import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * An Amazon Web Services Amazon Resource Name (ARN), including the Region and account ID.
   * For more information, refer to [Amazon Resource Names](https://docs.aws.amazon.com/general/latest/gr/aws-arns-and-namespaces.html).
   */
  ARN: string;
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: string;
  /**
   * A string containing a hexadecimal representation of a color.
   *
   * For example, "#6A8D48".
   *
   */
  Color: string;
  /**
   * Represents an [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601)-encoded date string.
   * For example, September 7, 2019 is represented as `"2019-07-16"`.
   *
   */
  Date: string;
  /**
   * Represents an [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601)-encoded date and time string.
   * For example, 3:50 pm on September 7, 2019 in the time zone of UTC (Coordinated Universal Time) is
   * represented as `"2019-09-07T15:50:00Z`".
   *
   */
  DateTime: string;
  /**
   * A signed decimal number, which supports arbitrary precision and is serialized as a string.
   *
   * Example values: `"29.99"`, `"29.999"`.
   *
   */
  Decimal: string;
  /**
   * A string containing a strict subset of HTML code. Non-allowed tags will be stripped out.
   * Allowed tags:
   * * `a` (allowed attributes: `href`, `target`)
   * * `b`
   * * `br`
   * * `em`
   * * `i`
   * * `strong`
   * * `u`
   * Use [HTML](https://shopify.dev/api/admin-graphql/latest/scalars/HTML) instead if you need to
   * include other HTML tags.
   *
   * Example value: `"Your current domain is <strong>example.myshopify.com</strong>."`
   *
   */
  FormattedString: string;
  /**
   * A string containing HTML code. Refer to the [HTML spec](https://html.spec.whatwg.org/#elements-3) for a
   * complete list of HTML elements.
   *
   * Example value: `"<p>Grey cotton knit sweater.</p>"`
   *
   */
  HTML: string;
  /**
   * A [JSON](https://www.json.org/json-en.html) object.
   *
   * Example value:
   * `{
   *   "product": {
   *     "id": "gid://shopify/Product/1346443542550",
   *     "title": "White T-shirt",
   *     "options": [{
   *       "name": "Size",
   *       "values": ["M", "L"]
   *     }]
   *   }
   * }`
   *
   */
  JSON: string;
  /** A monetary value string without a currency symbol or code. Example value: `"100.57"`. */
  Money: string;
  /**
   * Represents a unique identifier in the Storefront API. A `StorefrontID` value can be used wherever an ID is expected in the Storefront API.
   *
   * Example value: `"Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0LzEwMDc5Nzg1MTAw"`.
   *
   */
  StorefrontID: string;
  /**
   * Represents an [RFC 3986](https://datatracker.ietf.org/doc/html/rfc3986) and
   * [RFC 3987](https://datatracker.ietf.org/doc/html/rfc3987)-compliant URI string.
   *
   * For example, `"https://example.myshopify.com"` is a valid URL. It includes a scheme (`https`) and a host
   * (`example.myshopify.com`).
   *
   */
  URL: string;
  /**
   * An unsigned 64-bit integer. Represents whole numeric values between 0 and 2^64 - 1 encoded as a string of base-10 digits.
   *
   * Example value: `"50"`.
   *
   */
  UnsignedInt64: string;
  /**
   * Time between UTC time and a location's observed time, in the format `"+HH:MM"` or `"-HH:MM"`.
   *
   * Example value: `"-07:00"`.
   *
   */
  UtcOffset: string;
};

/** A checkout that was abandoned by the customer. */
export type AbandonedCheckout = Navigable & Node & {
  /** The URL for the buyer to recover their checkout. */
  readonly abandonedCheckoutUrl: Scalars['URL'];
  /**
   * The billing address provided by the buyer.
   * Null if the user did not provide a billing address.
   */
  readonly billingAddress?: Maybe<MailingAddress>;
  /**
   * The date and time when the buyer completed the checkout.
   * Null if the checkout has not been completed.
   */
  readonly completedAt?: Maybe<Scalars['DateTime']>;
  /** The date and time when the checkout was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A list of extra information that has been added to the checkout. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /**
   * The customer who created this checkout.
   * May be null if the checkout was created from a draft order or via an app.
   */
  readonly customer?: Maybe<Customer>;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** The discount codes entered by the buyer at checkout. */
  readonly discountCodes: ReadonlyArray<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** A list of the line items in this checkout. */
  readonly lineItems: AbandonedCheckoutLineItemConnection;
  /**
   * The number of products in the checkout.
   * @deprecated Use [AbandonedCheckoutLineItem.quantity](https://shopify.dev/api/admin-graphql/unstable/objects/AbandonedCheckoutLineItem#field-quantity) instead.
   */
  readonly lineItemsQuantity: Scalars['Int'];
  /** Unique merchant-facing identifier for the checkout. */
  readonly name: Scalars['String'];
  /** A merchant-facing note added to the checkout. Not visible to the buyer. */
  readonly note: Scalars['String'];
  /**
   * The shipping address to where the line items will be shipped.
   * Null if the user did not provide a shipping address.
   */
  readonly shippingAddress?: Maybe<MailingAddress>;
  /** The sum of all items in the checkout, including discounts but excluding shipping, taxes and tips. */
  readonly subtotalPriceSet: MoneyBag;
  /** Individual taxes charged on the checkout. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Whether taxes are included in line item and shipping line prices. */
  readonly taxesIncluded: Scalars['Boolean'];
  /** The total amount of discounts to be applied. */
  readonly totalDiscountSet: MoneyBag;
  /** The total duties applied to the checkout. */
  readonly totalDutiesSet?: Maybe<MoneyBag>;
  /** The sum of the prices of all line items in the checkout. */
  readonly totalLineItemsPriceSet: MoneyBag;
  /** The sum of all items in the checkout, including discounts, shipping, taxes, and tips. */
  readonly totalPriceSet: MoneyBag;
  /** The total tax applied to the checkout. */
  readonly totalTaxSet?: Maybe<MoneyBag>;
  /** The date and time when the checkout was most recently updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** A checkout that was abandoned by the customer. */
export type AbandonedCheckoutLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple AbandonedCheckouts. */
export type AbandonedCheckoutConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AbandonedCheckoutEdge>;
  /** A list of nodes that are contained in AbandonedCheckoutEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<AbandonedCheckout>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one AbandonedCheckout and a cursor during pagination. */
export type AbandonedCheckoutEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AbandonedCheckoutEdge. */
  readonly node: AbandonedCheckout;
};

/** A single line item in an abandoned checkout. */
export type AbandonedCheckoutLineItem = Node & {
  /** A list of extra information that has been added to the line item. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** Discount allocations that have been applied on the line item. */
  readonly discountAllocations: DiscountAllocationConnection;
  /** Final total price for the entire quantity of this line item, including discounts. */
  readonly discountedTotalPriceSet: MoneyBag;
  /** The total price for the entire quantity of this line item, after all discounts are applied, at both the line item and code-based line item level. */
  readonly discountedTotalPriceWithCodeDiscount: MoneyBag;
  /** The price of a single variant unit after discounts are applied at the line item level, in shop and presentment currencies. */
  readonly discountedUnitPriceSet: MoneyBag;
  /** The price of a single variant unit after all discounts are applied, at both the line item and code-based line item level. */
  readonly discountedUnitPriceWithCodeDiscount: MoneyBag;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The image associated with the line item's variant or product.
   * NULL if the line item has no product, or if neither the variant nor the product have an image.
   */
  readonly image?: Maybe<Image>;
  /** Original total price for the entire quantity of this line item, before discounts. */
  readonly originalTotalPriceSet: MoneyBag;
  /** Original price for a single unit of this line item, before discounts. */
  readonly originalUnitPriceSet: MoneyBag;
  /**
   * Product for this line item.
   * NULL for custom line items and products that were deleted after checkout began.
   */
  readonly product?: Maybe<Product>;
  /** The quantity of the line item. */
  readonly quantity: Scalars['Int'];
  /** SKU for the inventory item associated with the variant, if any. */
  readonly sku?: Maybe<Scalars['String']>;
  /** Title of the line item. Defaults to the product's title. */
  readonly title?: Maybe<Scalars['String']>;
  /**
   * Product variant for this line item.
   * NULL for custom line items and variants that were deleted after checkout began.
   */
  readonly variant?: Maybe<ProductVariant>;
  /**
   * Title of the variant for this line item.
   * NULL for custom line items and products that don't have distinct variants.
   */
  readonly variantTitle?: Maybe<Scalars['String']>;
};


/** A single line item in an abandoned checkout. */
export type AbandonedCheckoutLineItemDiscountAllocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple AbandonedCheckoutLineItems. */
export type AbandonedCheckoutLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AbandonedCheckoutLineItemEdge>;
  /** A list of nodes that are contained in AbandonedCheckoutLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<AbandonedCheckoutLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one AbandonedCheckoutLineItem and a cursor during pagination. */
export type AbandonedCheckoutLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AbandonedCheckoutLineItemEdge. */
  readonly node: AbandonedCheckoutLineItem;
};

/** The set of valid sort keys for the AbandonedCheckout query. */
export enum AbandonedCheckoutSortKeys {
  /** Sort by the `checkout_id` value. */
  CHECKOUT_ID = 'CHECKOUT_ID',
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `customer_name` value. */
  CUSTOMER_NAME = 'CUSTOMER_NAME',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `total_price` value. */
  TOTAL_PRICE = 'TOTAL_PRICE'
}

/** A browse, cart, or checkout that was abandoned by a customer. */
export type Abandonment = Node & {
  /** The abandonment payload for the abandoned checkout. */
  readonly abandonedCheckoutPayload?: Maybe<AbandonedCheckout>;
  /** The abandonment type. */
  readonly abandonmentType: AbandonmentAbandonmentType;
  /** The app associated with an abandoned checkout. */
  readonly app: App;
  /** Permalink to the cart page. */
  readonly cartUrl?: Maybe<Scalars['URL']>;
  /** The date and time when the abandonment was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The customer who abandoned this event. */
  readonly customer: Customer;
  /** Whether the customer has a draft order since this abandonment has been abandoned. */
  readonly customerHasNoDraftOrderSinceAbandonment: Scalars['Boolean'];
  /** Whether the customer has completed an order since this checkout has been abandoned. */
  readonly customerHasNoOrderSinceAbandonment: Scalars['Boolean'];
  /** The number of days since the last abandonment email was sent to the customer. */
  readonly daysSinceLastAbandonmentEmail: Scalars['Int'];
  /** When the email was sent, if that's the case. */
  readonly emailSentAt?: Maybe<Scalars['DateTime']>;
  /** The email state (e.g., sent or not sent). */
  readonly emailState?: Maybe<AbandonmentEmailState>;
  /** The number of hours since the customer has last abandoned a checkout. */
  readonly hoursSinceLastAbandonedCheckout?: Maybe<Scalars['Float']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether the products in abandonment are available. */
  readonly inventoryAvailable: Scalars['Boolean'];
  /** Whether the abandonment event comes from a custom storefront channel. */
  readonly isFromCustomStorefront: Scalars['Boolean'];
  /** Whether the abandonment event comes from the Online Store sales channel. */
  readonly isFromOnlineStore: Scalars['Boolean'];
  /** Whether the abandonment event comes from the Shop app sales channel. */
  readonly isFromShopApp: Scalars['Boolean'];
  /** Whether the abandonment event comes from Shop Pay. */
  readonly isFromShopPay: Scalars['Boolean'];
  /** Whether the customer didn't complete another most significant step since this abandonment. */
  readonly isMostSignificantAbandonment: Scalars['Boolean'];
  /** The date for the latest browse abandonment. */
  readonly lastBrowseAbandonmentDate: Scalars['DateTime'];
  /** The date for the latest cart abandonment. */
  readonly lastCartAbandonmentDate: Scalars['DateTime'];
  /** The date for the latest checkout abandonment. */
  readonly lastCheckoutAbandonmentDate: Scalars['DateTime'];
  /** The most recent step type. */
  readonly mostRecentStep: AbandonmentAbandonmentType;
  /** The products added to the cart during the customer abandoned visit. */
  readonly productsAddedToCart: CustomerVisitProductInfoConnection;
  /** The products viewed during the customer abandoned visit. */
  readonly productsViewed: CustomerVisitProductInfoConnection;
  /** The date and time when the visit started. */
  readonly visitStartedAt?: Maybe<Scalars['DateTime']>;
};


/** A browse, cart, or checkout that was abandoned by a customer. */
export type AbandonmentProductsAddedToCartArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A browse, cart, or checkout that was abandoned by a customer. */
export type AbandonmentProductsViewedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Specifies the abandonment type. */
export enum AbandonmentAbandonmentType {
  /** The abandonment event is an abandoned browse. */
  BROWSE = 'BROWSE',
  /** The abandonment event is an abandoned cart. */
  CART = 'CART',
  /** The abandonment event is an abandoned checkout. */
  CHECKOUT = 'CHECKOUT'
}

/** Specifies the delivery state of a marketing activity. */
export enum AbandonmentDeliveryState {
  /** The marketing activity action has not yet been sent. */
  NOT_SENT = 'NOT_SENT',
  /** The marketing activity action has been scheduled for later delivery. */
  SCHEDULED = 'SCHEDULED',
  /** The marketing activity action has been sent. */
  SENT = 'SENT'
}

/** Specifies the email state. */
export enum AbandonmentEmailState {
  /** The email has not yet been sent. */
  NOT_SENT = 'NOT_SENT',
  /** The email has been scheduled for later delivery. */
  SCHEDULED = 'SCHEDULED',
  /** The email has been sent. */
  SENT = 'SENT'
}

/** Return type for `abandonmentEmailStateUpdate` mutation. */
export type AbandonmentEmailStateUpdatePayload = {
  /** The updated abandonment. */
  readonly abandonment?: Maybe<Abandonment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<AbandonmentEmailStateUpdateUserError>;
};

/** An error that occurs during the execution of `AbandonmentEmailStateUpdate`. */
export type AbandonmentEmailStateUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<AbandonmentEmailStateUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `AbandonmentEmailStateUpdateUserError`. */
export enum AbandonmentEmailStateUpdateUserErrorCode {
  /** Unable to find an Abandonment for the provided ID. */
  ABANDONMENT_NOT_FOUND = 'ABANDONMENT_NOT_FOUND'
}

/** Return type for `abandonmentUpdateActivitiesDeliveryStatuses` mutation. */
export type AbandonmentUpdateActivitiesDeliveryStatusesPayload = {
  /** The updated abandonment. */
  readonly abandonment?: Maybe<Abandonment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<AbandonmentUpdateActivitiesDeliveryStatusesUserError>;
};

/** An error that occurs during the execution of `AbandonmentUpdateActivitiesDeliveryStatuses`. */
export type AbandonmentUpdateActivitiesDeliveryStatusesUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<AbandonmentUpdateActivitiesDeliveryStatusesUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `AbandonmentUpdateActivitiesDeliveryStatusesUserError`. */
export enum AbandonmentUpdateActivitiesDeliveryStatusesUserErrorCode {
  /** Unable to find an Abandonment for the provided ID. */
  ABANDONMENT_NOT_FOUND = 'ABANDONMENT_NOT_FOUND',
  /** Unable to find delivery status info for the provided ID. */
  DELIVERY_STATUS_INFO_NOT_FOUND = 'DELIVERY_STATUS_INFO_NOT_FOUND',
  /** Unable to find a marketing activity for the provided ID. */
  MARKETING_ACTIVITY_NOT_FOUND = 'MARKETING_ACTIVITY_NOT_FOUND'
}

/** The permission required to access a Shopify Admin API or Storefront API resource for a shop. Merchants grant access scopes that are requested by applications. */
export type AccessScope = {
  /** A description of the actions that the access scope allows an app to perform. */
  readonly description: Scalars['String'];
  /** A readable string that represents the access scope. The string usually follows the format `{action}_{resource}`. `{action}` is `read` or `write`, and `{resource}` is the resource that the action can be performed on. `{action}` and `{resource}` are separated by an underscore. For example, `read_orders` or `write_products`. */
  readonly handle: Scalars['String'];
};

/** Possible account types that a staff member can have. */
export enum AccountType {
  /** The account of a partner who collaborates with the merchant. */
  COLLABORATOR = 'COLLABORATOR',
  /** The account of a partner collaborator team member. */
  COLLABORATOR_TEAM_MEMBER = 'COLLABORATOR_TEAM_MEMBER',
  /** The user has not yet accepted the invitation to create an account. */
  INVITED = 'INVITED',
  /** The user has not yet accepted the invitation to become the store owner. */
  INVITED_STORE_OWNER = 'INVITED_STORE_OWNER',
  /** The account can access the Shopify admin. */
  REGULAR = 'REGULAR',
  /** The admin has not yet accepted the request to create a collaborator account. */
  REQUESTED = 'REQUESTED',
  /** The account cannot access the Shopify admin. */
  RESTRICTED = 'RESTRICTED',
  /** The account can be signed into via a SAML provider. */
  SAML = 'SAML'
}

/** Represents an operation publishing all products to a publication. */
export type AddAllProductsOperation = Node & ResourceOperation & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The count of processed rows, summing imported, failed, and skipped rows. */
  readonly processedRowCount?: Maybe<Scalars['Int']>;
  /** Represents a rows objects within this background operation. */
  readonly rowCount?: Maybe<RowCount>;
  /** The status of this operation. */
  readonly status: ResourceOperationStatus;
};

/** The additional fees that have been applied to the order. */
export type AdditionalFee = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the additional fee. */
  readonly name: Scalars['String'];
  /** The price of the additional fee. */
  readonly price: MoneyBag;
  /** A list of taxes charged on the additional fee. */
  readonly taxLines: ReadonlyArray<TaxLine>;
};

/** A sale associated with an additional fee charge. */
export type AdditionalFeeSale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The additional fees for the associated sale. */
  readonly additionalFee: SaleAdditionalFee;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** A sale associated with an order price adjustment. */
export type AdjustmentSale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** The set of valid sort keys for the Adjustments query. */
export enum AdjustmentsSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `time` value. */
  TIME = 'TIME'
}

/** Targets all items the cart for a specified discount. */
export type AllDiscountItems = {
  /** Whether all items are eligible for the discount. This value always returns `true`. */
  readonly allItems: Scalars['Boolean'];
};

/** The Android mobile platform application. */
export type AndroidApplication = {
  /** Whether Android App Links are supported by this app. */
  readonly appLinksEnabled: Scalars['Boolean'];
  /** The Android application ID. */
  readonly applicationId?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The SHA256 fingerprints of the app's signing certificate. */
  readonly sha256CertFingerprints: ReadonlyArray<Scalars['String']>;
};

/**
 * A version of the API, as defined by [Shopify API versioning](https://shopify.dev/api/usage/versioning).
 * Versions are commonly referred to by their handle (for example, `2021-10`).
 */
export type ApiVersion = {
  /** The human-readable name of the version. */
  readonly displayName: Scalars['String'];
  /** The unique identifier of an ApiVersion. All supported API versions have a date-based (YYYY-MM) or `unstable` handle. */
  readonly handle: Scalars['String'];
  /** Whether the version is actively supported by Shopify. Supported API versions are guaranteed to be stable. Unsupported API versions include unstable, release candidate, and end-of-life versions that are marked as unsupported. For more information, refer to [Versioning](https://shopify.dev/api/usage/versioning). */
  readonly supported: Scalars['Boolean'];
};

/** A Shopify application. */
export type App = Node & {
  /** A unique application API identifier. */
  readonly apiKey: Scalars['String'];
  /** App store page URL of the app. */
  readonly appStoreAppUrl?: Maybe<Scalars['URL']>;
  /** App store page URL of the developer who created the app. */
  readonly appStoreDeveloperUrl?: Maybe<Scalars['URL']>;
  /** All requestable access scopes available to the app. */
  readonly availableAccessScopes: ReadonlyArray<AccessScope>;
  /** Banner image for the app. */
  readonly banner: Image;
  /** Description of the app. */
  readonly description?: Maybe<Scalars['String']>;
  /** The name of the app developer. */
  readonly developerName?: Maybe<Scalars['String']>;
  /** The type of app developer. */
  readonly developerType: AppDeveloperType;
  /**
   * Website of the developer who created the app.
   * @deprecated Use `appStoreDeveloperUrl` instead.
   */
  readonly developerUrl: Scalars['URL'];
  /** Whether the app uses the Embedded App SDK. */
  readonly embedded: Scalars['Boolean'];
  /** Requirements that must be met before the app can be installed. */
  readonly failedRequirements: ReadonlyArray<FailedRequirement>;
  /** A list of app features that are shown in the Shopify App Store listing. */
  readonly features: ReadonlyArray<Scalars['String']>;
  /** Feedback from this app about the store. */
  readonly feedback?: Maybe<AppFeedback>;
  /** Handle of the app. */
  readonly handle?: Maybe<Scalars['String']>;
  /** Icon that represents the app. */
  readonly icon: Image;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Webpage where you can install the app. */
  readonly installUrl?: Maybe<Scalars['URL']>;
  /**
   * Corresponding AppInstallation for this shop and App.
   * Returns null if the App is not installed.
   */
  readonly installation?: Maybe<AppInstallation>;
  /** Whether the app is the [post purchase](https://shopify.dev/apps/checkout/post-purchase) app in use. */
  readonly isPostPurchaseAppInUse: Scalars['Boolean'];
  /**
   * Webpage that the app starts in.
   * @deprecated Use AppInstallation.launchUrl instead
   */
  readonly launchUrl: Scalars['URL'];
  /**
   * Menu items for the app, which also appear as submenu items in left navigation sidebar in the Shopify admin.
   * @deprecated Use AppInstallation.navigationItems instead
   */
  readonly navigationItems: ReadonlyArray<NavigationItem>;
  /** The optional scopes requested by the app. Lists the optional access scopes the app has declared in its configuration. These scopes are optionally requested by the app after installation. */
  readonly optionalAccessScopes: ReadonlyArray<AccessScope>;
  /** Whether the app was previously installed on the current shop. */
  readonly previouslyInstalled: Scalars['Boolean'];
  /** Detailed information about the app pricing. */
  readonly pricingDetails?: Maybe<Scalars['String']>;
  /** Summary of the app pricing details. */
  readonly pricingDetailsSummary: Scalars['String'];
  /** Link to app privacy policy. */
  readonly privacyPolicyUrl?: Maybe<Scalars['URL']>;
  /** The public category for the app. */
  readonly publicCategory: AppPublicCategory;
  /** Whether the app is published to the Shopify App Store. */
  readonly published: Scalars['Boolean'];
  /** The access scopes requested by the app. Lists the access scopes the app has declared in its configuration. Merchant must grant approval to these scopes for the app to be installed. */
  readonly requestedAccessScopes: ReadonlyArray<AccessScope>;
  /** Screenshots of the app. */
  readonly screenshots: ReadonlyArray<Image>;
  /** Whether the app was developed by Shopify. */
  readonly shopifyDeveloped: Scalars['Boolean'];
  /** Name of the app. */
  readonly title: Scalars['String'];
  /**
   * Message that appears when the app is uninstalled. For example:
   * By removing this app, you will no longer be able to publish products to MySocialSite or view this app in your Shopify admin. You can re-enable this channel at any time.
   */
  readonly uninstallMessage: Scalars['String'];
  /**
   * Webpage where you can uninstall the app.
   * @deprecated Use AppInstallation.uninstallUrl instead
   */
  readonly uninstallUrl?: Maybe<Scalars['URL']>;
  /** The webhook API version for the app. */
  readonly webhookApiVersion: Scalars['String'];
};

/** A catalog that defines the publication associated with an app. */
export type AppCatalog = Catalog & Node & {
  /** The apps associated with the catalog. */
  readonly apps: AppConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Most recent catalog operations. */
  readonly operations: ReadonlyArray<ResourceOperation>;
  /** The price list associated with the catalog. */
  readonly priceList?: Maybe<PriceList>;
  /** A group of products and collections that's published to a catalog. */
  readonly publication?: Maybe<Publication>;
  /** The status of the catalog. */
  readonly status: CatalogStatus;
  /** The name of the catalog. */
  readonly title: Scalars['String'];
};


/** A catalog that defines the publication associated with an app. */
export type AppCatalogAppsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple Apps. */
export type AppConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AppEdge>;
  /** A list of nodes that are contained in AppEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<App>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** App credits can be applied by the merchant towards future app purchases, subscriptions, or usage records in Shopify. */
export type AppCredit = Node & {
  /** The amount that can be used towards future app purchases in Shopify. */
  readonly amount: MoneyV2;
  /** The date and time when the app credit was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The description of the app credit. */
  readonly description: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether the app credit is a test transaction. */
  readonly test: Scalars['Boolean'];
};

/** An auto-generated type for paginating through multiple AppCredits. */
export type AppCreditConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AppCreditEdge>;
  /** A list of nodes that are contained in AppCreditEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<AppCredit>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one AppCredit and a cursor during pagination. */
export type AppCreditEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AppCreditEdge. */
  readonly node: AppCredit;
};

/** Possible types of app developer. */
export enum AppDeveloperType {
  /** Indicates the app developer works directly for a Merchant. */
  MERCHANT = 'MERCHANT',
  /** Indicates the app developer is a Partner. */
  PARTNER = 'PARTNER',
  /** Indicates the app developer is Shopify. */
  SHOPIFY = 'SHOPIFY',
  /** Indicates the app developer is unknown. It is not categorized as any of the other developer types. */
  UNKNOWN = 'UNKNOWN'
}

/**
 * The details about the app extension that's providing the
 * [discount type](https://help.shopify.com/manual/discounts/discount-types).
 * This information includes the app extension's name and
 * [client ID](https://shopify.dev/docs/apps/build/authentication-authorization/client-secrets),
 * [App Bridge configuration](https://shopify.dev/docs/api/app-bridge),
 * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations),
 * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries),
 * and other metadata about the discount type, including the discount type's name and description.
 */
export type AppDiscountType = {
  /**
   * The name of the app extension that's providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly app: App;
  /**
   * The [App Bridge configuration](https://shopify.dev/docs/api/app-bridge)
   * for the [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly appBridge: FunctionsAppBridge;
  /**
   * The [client ID](https://shopify.dev/docs/apps/build/authentication-authorization/client-secrets)
   * of the app extension that's providing the [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly appKey: Scalars['String'];
  /**
   * A description of the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types)
   * provided by the app extension.
   */
  readonly description?: Maybe<Scalars['String']>;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  readonly discountClass: DiscountClass;
  /**
   * The
   * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries)
   * associated with the app extension providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly functionId: Scalars['String'];
  /**
   * The type of line item on an order that the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types) applies to.
   * Valid values: `SHIPPING_LINE` and `LINE_ITEM`.
   * @deprecated Use `discountClasses` instead.
   */
  readonly targetType: DiscountApplicationTargetType;
  /**
   * The name of the [discount type](https://help.shopify.com/manual/discounts/discount-types)
   * that the app extension is providing.
   */
  readonly title: Scalars['String'];
};

/** An auto-generated type which holds one App and a cursor during pagination. */
export type AppEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AppEdge. */
  readonly node: App;
};

/**
 * Reports the status of shops and their resources and displays this information
 * within Shopify admin. AppFeedback is used to notify merchants about steps they need to take
 * to set up an app on their store.
 */
export type AppFeedback = {
  /** The application associated to the feedback. */
  readonly app: App;
  /** The date and time when the app feedback was generated. */
  readonly feedbackGeneratedAt: Scalars['DateTime'];
  /** A link to where merchants can resolve errors. */
  readonly link?: Maybe<Link>;
  /** The feedback message presented to the merchant. */
  readonly messages: ReadonlyArray<UserError>;
  /** Conveys the state of the feedback and whether it requires merchant action or not. */
  readonly state: ResourceFeedbackState;
};

/** Represents an installed application on a shop. */
export type AppInstallation = HasMetafields & Node & {
  /** The access scopes granted to the application by a merchant during installation. */
  readonly accessScopes: ReadonlyArray<AccessScope>;
  /** The active application subscriptions billed to the shop on a recurring basis. */
  readonly activeSubscriptions: ReadonlyArray<AppSubscription>;
  /** All subscriptions created for a shop. */
  readonly allSubscriptions: AppSubscriptionConnection;
  /** Application which is installed. */
  readonly app: App;
  /**
   * Channel associated with the installed application.
   * @deprecated Use `publication` instead.
   */
  readonly channel?: Maybe<Channel>;
  /** Credits that can be used towards future app purchases. */
  readonly credits: AppCreditConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The URL to launch the application. */
  readonly launchUrl: Scalars['URL'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** One-time purchases to a shop. */
  readonly oneTimePurchases: AppPurchaseOneTimeConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The publication associated with the installed application. */
  readonly publication?: Maybe<Publication>;
  /** The records that track the externally-captured revenue for the app. The records are used for revenue attribution purposes. */
  readonly revenueAttributionRecords: AppRevenueAttributionRecordConnection;
  /**
   * Subscriptions charge to a shop on a recurring basis.
   * @deprecated Use `activeSubscriptions` instead.
   */
  readonly subscriptions: ReadonlyArray<AppSubscription>;
  /** The URL to uninstall the application. */
  readonly uninstallUrl?: Maybe<Scalars['URL']>;
};


/** Represents an installed application on a shop. */
export type AppInstallationAllSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<AppSubscriptionSortKeys>;
};


/** Represents an installed application on a shop. */
export type AppInstallationCreditsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<AppTransactionSortKeys>;
};


/** Represents an installed application on a shop. */
export type AppInstallationMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** Represents an installed application on a shop. */
export type AppInstallationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an installed application on a shop. */
export type AppInstallationOneTimePurchasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<AppTransactionSortKeys>;
};


/** Represents an installed application on a shop. */
export type AppInstallationPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** Represents an installed application on a shop. */
export type AppInstallationPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an installed application on a shop. */
export type AppInstallationRevenueAttributionRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<AppRevenueAttributionRecordSortKeys>;
};

/**
 * The possible categories of an app installation, based on their purpose
 * or the environment they can run in.
 */
export enum AppInstallationCategory {
  /** Apps that serve as channels through which sales are made, such as the online store. */
  CHANNEL = 'CHANNEL',
  /** Apps that can be used in the POS mobile client. */
  POS_EMBEDDED = 'POS_EMBEDDED'
}

/** An auto-generated type for paginating through multiple AppInstallations. */
export type AppInstallationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AppInstallationEdge>;
  /** A list of nodes that are contained in AppInstallationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<AppInstallation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one AppInstallation and a cursor during pagination. */
export type AppInstallationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AppInstallationEdge. */
  readonly node: AppInstallation;
};

/** The levels of privacy of an app installation. */
export enum AppInstallationPrivacy {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

/** The set of valid sort keys for the AppInstallation query. */
export enum AppInstallationSortKeys {
  /** Sort by the `app_title` value. */
  APP_TITLE = 'APP_TITLE',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `installed_at` value. */
  INSTALLED_AT = 'INSTALLED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/**
 * The pricing model for the app subscription.
 * The pricing model input can be either `appRecurringPricingDetails` or `appUsagePricingDetails`.
 */
export type AppPlanInput = {
  /** The pricing details for recurring billing. */
  readonly appRecurringPricingDetails?: InputMaybe<AppRecurringPricingInput>;
  /** The pricing details for usage-based billing. */
  readonly appUsagePricingDetails?: InputMaybe<AppUsagePricingInput>;
};

/** The app plan that the merchant is subscribed to. */
export type AppPlanV2 = {
  /** The plan billed to a shop on a recurring basis. */
  readonly pricingDetails: AppPricingDetails;
};

/**
 * The information about the price that's charged to a shop every plan period.
 * The concrete type can be `AppRecurringPricing` for recurring billing or `AppUsagePricing` for usage-based billing.
 */
export type AppPricingDetails = AppRecurringPricing | AppUsagePricing;

/** The frequency at which the shop is billed for an app subscription. */
export enum AppPricingInterval {
  /** The app subscription bills the shop annually. */
  ANNUAL = 'ANNUAL',
  /** The app subscription bills the shop every 30 days. */
  EVERY_30_DAYS = 'EVERY_30_DAYS'
}

/** The public-facing category for an app. */
export enum AppPublicCategory {
  /** The app's public category is [custom](https://shopify.dev/apps/distribution#capabilities-and-requirements). */
  CUSTOM = 'CUSTOM',
  /** The app's public category is other. An app is in this category if it's not classified under any of the other app types (private, public, or custom). */
  OTHER = 'OTHER',
  /** The app's public category is [private](https://shopify.dev/apps/distribution#deprecated-app-types). */
  PRIVATE = 'PRIVATE',
  /** The app's public category is [public](https://shopify.dev/apps/distribution#capabilities-and-requirements). */
  PUBLIC = 'PUBLIC'
}

/** Services and features purchased once by the store. */
export type AppPurchase = {
  /** The date and time when the app purchase occurred. */
  readonly createdAt: Scalars['DateTime'];
  /** The name of the app purchase. */
  readonly name: Scalars['String'];
  /** The amount to be charged to the store for the app purchase. */
  readonly price: MoneyV2;
  /** The status of the app purchase. */
  readonly status: AppPurchaseStatus;
  /** Whether the app purchase is a test transaction. */
  readonly test: Scalars['Boolean'];
};

/** Services and features purchased once by a store. */
export type AppPurchaseOneTime = AppPurchase & Node & {
  /** The date and time when the app purchase occurred. */
  readonly createdAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the app purchase. */
  readonly name: Scalars['String'];
  /** The amount to be charged to the store for the app purchase. */
  readonly price: MoneyV2;
  /** The status of the app purchase. */
  readonly status: AppPurchaseStatus;
  /** Whether the app purchase is a test transaction. */
  readonly test: Scalars['Boolean'];
};

/** An auto-generated type for paginating through multiple AppPurchaseOneTimes. */
export type AppPurchaseOneTimeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AppPurchaseOneTimeEdge>;
  /** A list of nodes that are contained in AppPurchaseOneTimeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<AppPurchaseOneTime>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `appPurchaseOneTimeCreate` mutation. */
export type AppPurchaseOneTimeCreatePayload = {
  /** The newly created app one-time purchase. */
  readonly appPurchaseOneTime?: Maybe<AppPurchaseOneTime>;
  /**
   * The URL that the merchant can access to approve or decline the newly created app one-time purchase.
   *
   * If the merchant declines, then the merchant is redirected to the app and receives a notification message stating that the charge was declined.
   * If the merchant approves and they're successfully invoiced, then the state of the charge changes from `pending` to `active`.
   *
   * You get paid after the charge is activated.
   */
  readonly confirmationUrl?: Maybe<Scalars['URL']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one AppPurchaseOneTime and a cursor during pagination. */
export type AppPurchaseOneTimeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AppPurchaseOneTimeEdge. */
  readonly node: AppPurchaseOneTime;
};

/**
 * The approval status of the app purchase.
 *
 * The merchant is charged for the purchase immediately after approval, and the status changes to `active`.
 * If the payment fails, then the app purchase remains `pending`.
 *
 * Purchases start as `pending` and can change to: `active`, `declined`, `expired`. After a purchase changes, it
 * remains in that final state.
 */
export enum AppPurchaseStatus {
  /** The app purchase has been approved by the merchant and is ready to be activated by the app. App purchases created through the GraphQL Admin API are activated upon approval. */
  ACCEPTED = 'ACCEPTED',
  /** The app purchase was approved by the merchant and has been activated by the app. Active app purchases are charged to the merchant and are paid out to the partner. */
  ACTIVE = 'ACTIVE',
  /** The app purchase was declined by the merchant. */
  DECLINED = 'DECLINED',
  /** The app purchase was not accepted within two days of being created. */
  EXPIRED = 'EXPIRED',
  /** The app purchase is pending approval by the merchant. */
  PENDING = 'PENDING'
}

/**
 * The pricing information about a subscription app.
 * The object contains an interval (the frequency at which the shop is billed for an app subscription) and
 * a price (the amount to be charged to the subscribing shop at each interval).
 */
export type AppRecurringPricing = {
  /** The discount applied to the subscription for a given number of billing intervals. */
  readonly discount?: Maybe<AppSubscriptionDiscount>;
  /** The frequency at which the subscribing shop is billed for an app subscription. */
  readonly interval: AppPricingInterval;
  /** The amount and currency to be charged to the subscribing shop every billing interval. */
  readonly price: MoneyV2;
};

/** Instructs the app subscription to generate a fixed charge on a recurring basis. The frequency is specified by the billing interval. */
export type AppRecurringPricingInput = {
  /** The discount applied to the subscription for a given number of billing intervals. */
  readonly discount?: InputMaybe<AppSubscriptionDiscountInput>;
  /** How often the app subscription generates a charge. */
  readonly interval?: InputMaybe<AppPricingInterval>;
  /** The amount to be charged to the store every billing interval. */
  readonly price: MoneyInput;
};

/** Represents app revenue that was captured externally by the partner. */
export type AppRevenueAttributionRecord = Node & {
  /** The financial amount captured in this attribution. */
  readonly amount: MoneyV2;
  /** The timestamp when the financial amount was captured. */
  readonly capturedAt: Scalars['DateTime'];
  /** The timestamp at which this revenue attribution was issued. */
  readonly createdAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The unique value submitted during the creation of the app revenue attribution record.
   * For more information, refer to
   * [Idempotent requests](https://shopify.dev/api/usage/idempotent-requests).
   */
  readonly idempotencyKey: Scalars['String'];
  /** Indicates whether this is a test submission. */
  readonly test: Scalars['Boolean'];
  /** The type of revenue attribution. */
  readonly type: AppRevenueAttributionType;
};

/** An auto-generated type for paginating through multiple AppRevenueAttributionRecords. */
export type AppRevenueAttributionRecordConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AppRevenueAttributionRecordEdge>;
  /** A list of nodes that are contained in AppRevenueAttributionRecordEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<AppRevenueAttributionRecord>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one AppRevenueAttributionRecord and a cursor during pagination. */
export type AppRevenueAttributionRecordEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AppRevenueAttributionRecordEdge. */
  readonly node: AppRevenueAttributionRecord;
};

/** The set of valid sort keys for the AppRevenueAttributionRecord query. */
export enum AppRevenueAttributionRecordSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** Represents the billing types of revenue attribution. */
export enum AppRevenueAttributionType {
  /** App purchase related revenue collection. */
  APPLICATION_PURCHASE = 'APPLICATION_PURCHASE',
  /** App subscription revenue collection. */
  APPLICATION_SUBSCRIPTION = 'APPLICATION_SUBSCRIPTION',
  /** App usage-based revenue collection. */
  APPLICATION_USAGE = 'APPLICATION_USAGE',
  /** Other app revenue collection type. */
  OTHER = 'OTHER'
}

/** Represents an error that happens while revoking a granted scope. */
export type AppRevokeAccessScopesAppRevokeScopeError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<AppRevokeAccessScopesAppRevokeScopeErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `AppRevokeAccessScopesAppRevokeScopeError`. */
export enum AppRevokeAccessScopesAppRevokeScopeErrorCode {
  /** The application cannot be found. */
  APPLICATION_CANNOT_BE_FOUND = 'APPLICATION_CANNOT_BE_FOUND',
  /** App is not installed on shop. */
  APP_NOT_INSTALLED = 'APP_NOT_INSTALLED',
  /** Already granted implied scopes cannot be revoked. */
  CANNOT_REVOKE_IMPLIED_SCOPES = 'CANNOT_REVOKE_IMPLIED_SCOPES',
  /** Required scopes cannot be revoked. */
  CANNOT_REVOKE_REQUIRED_SCOPES = 'CANNOT_REVOKE_REQUIRED_SCOPES',
  /** Cannot revoke optional scopes that haven't been declared. */
  CANNOT_REVOKE_UNDECLARED_SCOPES = 'CANNOT_REVOKE_UNDECLARED_SCOPES',
  /** No app found on the access token. */
  MISSING_SOURCE_APP = 'MISSING_SOURCE_APP',
  /** The requested list of scopes to revoke includes invalid handles. */
  UNKNOWN_SCOPES = 'UNKNOWN_SCOPES'
}

/** Return type for `appRevokeAccessScopes` mutation. */
export type AppRevokeAccessScopesPayload = {
  /** The list of scope handles that have been revoked. */
  readonly revoked?: Maybe<ReadonlyArray<AccessScope>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<AppRevokeAccessScopesAppRevokeScopeError>;
};

/** Provides users access to services and/or features for a duration of time. */
export type AppSubscription = Node & {
  /** The date and time when the app subscription was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The date and time when the current app subscription period ends. Returns `null` if the subscription isn't active. */
  readonly currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The plans attached to the app subscription. */
  readonly lineItems: ReadonlyArray<AppSubscriptionLineItem>;
  /** The name of the app subscription. */
  readonly name: Scalars['String'];
  /** The URL that the merchant is redirected to after approving the app subscription. */
  readonly returnUrl: Scalars['URL'];
  /** The status of the app subscription. */
  readonly status: AppSubscriptionStatus;
  /** Specifies whether the app subscription is a test transaction. */
  readonly test: Scalars['Boolean'];
  /** The number of free trial days, starting at the subscription's creation date, by which billing is delayed. */
  readonly trialDays: Scalars['Int'];
};

/** Return type for `appSubscriptionCancel` mutation. */
export type AppSubscriptionCancelPayload = {
  /** The cancelled app subscription. */
  readonly appSubscription?: Maybe<AppSubscription>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type for paginating through multiple AppSubscriptions. */
export type AppSubscriptionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AppSubscriptionEdge>;
  /** A list of nodes that are contained in AppSubscriptionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<AppSubscription>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `appSubscriptionCreate` mutation. */
export type AppSubscriptionCreatePayload = {
  /** The newly-created app subscription. */
  readonly appSubscription?: Maybe<AppSubscription>;
  /** The URL pointing to the page where the merchant approves or declines the charges for an app subscription. */
  readonly confirmationUrl?: Maybe<Scalars['URL']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Discount applied to the recurring pricing portion of a subscription. */
export type AppSubscriptionDiscount = {
  /**
   * The total number of billing intervals to which the discount will be applied.
   * The discount will be applied to an indefinite number of billing intervals if this value is blank.
   */
  readonly durationLimitInIntervals?: Maybe<Scalars['Int']>;
  /** The price of the subscription after the discount is applied. */
  readonly priceAfterDiscount: MoneyV2;
  /** The remaining number of billing intervals to which the discount will be applied. */
  readonly remainingDurationInIntervals?: Maybe<Scalars['Int']>;
  /** The value of the discount applied every billing interval. */
  readonly value: AppSubscriptionDiscountValue;
};

/** The fixed amount value of a discount. */
export type AppSubscriptionDiscountAmount = {
  /** The fixed amount value of a discount. */
  readonly amount: MoneyV2;
};

/** The input fields to specify a discount to the recurring pricing portion of a subscription over a number of billing intervals. */
export type AppSubscriptionDiscountInput = {
  /**
   * The total number of billing intervals to which the discount will be applied. Must be greater than 0.
   * The discount will be applied to an indefinite number of billing intervals if this value is left blank.
   */
  readonly durationLimitInIntervals?: InputMaybe<Scalars['Int']>;
  /** The value to be discounted every billing interval. */
  readonly value?: InputMaybe<AppSubscriptionDiscountValueInput>;
};

/** The percentage value of a discount. */
export type AppSubscriptionDiscountPercentage = {
  /** The percentage value of a discount. */
  readonly percentage: Scalars['Float'];
};

/** The value of the discount. */
export type AppSubscriptionDiscountValue = AppSubscriptionDiscountAmount | AppSubscriptionDiscountPercentage;

/** The input fields to specify the value discounted every billing interval. */
export type AppSubscriptionDiscountValueInput = {
  /** The monetary value of a discount. */
  readonly amount?: InputMaybe<Scalars['Decimal']>;
  /** The percentage value of a discount. */
  readonly percentage?: InputMaybe<Scalars['Float']>;
};

/** An auto-generated type which holds one AppSubscription and a cursor during pagination. */
export type AppSubscriptionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AppSubscriptionEdge. */
  readonly node: AppSubscription;
};

/** The plan attached to an app subscription. */
export type AppSubscriptionLineItem = {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The pricing model for the app subscription. */
  readonly plan: AppPlanV2;
  /** A list of the store's usage records for a usage pricing plan. */
  readonly usageRecords: AppUsageRecordConnection;
};


/** The plan attached to an app subscription. */
export type AppSubscriptionLineItemUsageRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<AppUsageRecordSortKeys>;
};

/** The input fields to add more than one pricing plan to an app subscription. */
export type AppSubscriptionLineItemInput = {
  /** The pricing model for the app subscription. */
  readonly plan: AppPlanInput;
};

/** Return type for `appSubscriptionLineItemUpdate` mutation. */
export type AppSubscriptionLineItemUpdatePayload = {
  /** The updated app subscription. */
  readonly appSubscription?: Maybe<AppSubscription>;
  /** The URL where the merchant approves or declines the updated app subscription line item. */
  readonly confirmationUrl?: Maybe<Scalars['URL']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The replacement behavior when creating an app subscription for a merchant with an already existing app subscription. */
export enum AppSubscriptionReplacementBehavior {
  /** Cancels the merchant's current app subscription immediately and replaces it with the newly created app subscription. */
  APPLY_IMMEDIATELY = 'APPLY_IMMEDIATELY',
  /** Defers canceling the merchant's current app subscription and applying the newly created app subscription until the start of the next billing cycle. This value is ignored if the new app subscription is using a different currency than the current app subscription, in which case the new app subscription is applied immediately. */
  APPLY_ON_NEXT_BILLING_CYCLE = 'APPLY_ON_NEXT_BILLING_CYCLE',
  /**
   * Cancels the merchant's current app subscription immediately and replaces it with the newly created app subscription, with the exception of
   * the following scenarios where replacing the current app subscription will be deferred until the start of the next billing cycle.
   * 1) The current app subscription is annual and the newly created app subscription is annual, using the same currency, but is of a lesser value.
   * 2) The current app subscription is annual and the newly created app subscription is monthly and using the same currency.
   * 3) The current app subscription and the newly created app subscription are identical except for the `discount` value.
   */
  STANDARD = 'STANDARD'
}

/** The set of valid sort keys for the AppSubscription query. */
export enum AppSubscriptionSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The status of the app subscription. */
export enum AppSubscriptionStatus {
  /** The app subscription has been approved by the merchant and is ready to be activated by the app. */
  ACCEPTED = 'ACCEPTED',
  /** The app subscription has been approved by the merchant. Active app subscriptions are billed to the shop. After payment, partners receive payouts. */
  ACTIVE = 'ACTIVE',
  /** The app subscription was cancelled by the app. This could be caused by the app being uninstalled, a new app subscription being activated, or a direct cancellation by the app. This is a terminal state. */
  CANCELLED = 'CANCELLED',
  /** The app subscription was declined by the merchant. This is a terminal state. */
  DECLINED = 'DECLINED',
  /** The app subscription wasn't approved by the merchant within two days of being created. This is a terminal state. */
  EXPIRED = 'EXPIRED',
  /** The app subscription is on hold due to non-payment. The subscription re-activates after payments resume. */
  FROZEN = 'FROZEN',
  /** The app subscription is pending approval by the merchant. */
  PENDING = 'PENDING'
}

/** Return type for `appSubscriptionTrialExtend` mutation. */
export type AppSubscriptionTrialExtendPayload = {
  /** The app subscription that had its trial extended. */
  readonly appSubscription?: Maybe<AppSubscription>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<AppSubscriptionTrialExtendUserError>;
};

/** An error that occurs during the execution of `AppSubscriptionTrialExtend`. */
export type AppSubscriptionTrialExtendUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<AppSubscriptionTrialExtendUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `AppSubscriptionTrialExtendUserError`. */
export enum AppSubscriptionTrialExtendUserErrorCode {
  /** The app subscription isn't active. */
  SUBSCRIPTION_NOT_ACTIVE = 'SUBSCRIPTION_NOT_ACTIVE',
  /** The app subscription wasn't found. */
  SUBSCRIPTION_NOT_FOUND = 'SUBSCRIPTION_NOT_FOUND',
  /** The trial isn't active. */
  TRIAL_NOT_ACTIVE = 'TRIAL_NOT_ACTIVE'
}

/** The set of valid sort keys for the AppTransaction query. */
export enum AppTransactionSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/**
 * Defines a usage pricing model for the app subscription.
 * These charges are variable based on how much the merchant uses the app.
 */
export type AppUsagePricing = {
  /** The total usage records for interval. */
  readonly balanceUsed: MoneyV2;
  /**
   * The capped amount prevents the merchant from being charged for any usage over that amount during a billing period.
   * This prevents billing from exceeding a maximum threshold over the duration of the billing period.
   * For the merchant to continue using the app after exceeding a capped amount, they would need to agree to a new usage charge.
   */
  readonly cappedAmount: MoneyV2;
  /** The frequency with which the app usage records are billed. */
  readonly interval: AppPricingInterval;
  /**
   * The terms and conditions for app usage pricing.
   * Must be present in order to create usage charges.
   * The terms are presented to the merchant when they approve an app's usage charges.
   */
  readonly terms: Scalars['String'];
};

/** The input fields to issue arbitrary charges for app usage associated with a subscription. */
export type AppUsagePricingInput = {
  /** The maximum amount of usage charges that can be incurred within a subscription billing interval. */
  readonly cappedAmount: MoneyInput;
  /** The terms and conditions for app usage. These terms stipulate the pricing model for the charges that an app creates. */
  readonly terms: Scalars['String'];
};

/** Store usage for app subscriptions with usage pricing. */
export type AppUsageRecord = Node & {
  /** The date and time when the usage record was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The description of the app usage record. */
  readonly description: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** A unique key generated by the client to avoid duplicate charges. */
  readonly idempotencyKey?: Maybe<Scalars['String']>;
  /** The price of the usage record. */
  readonly price: MoneyV2;
  /** Defines the usage pricing plan the merchant is subscribed to. */
  readonly subscriptionLineItem: AppSubscriptionLineItem;
};

/** An auto-generated type for paginating through multiple AppUsageRecords. */
export type AppUsageRecordConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<AppUsageRecordEdge>;
  /** A list of nodes that are contained in AppUsageRecordEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<AppUsageRecord>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `appUsageRecordCreate` mutation. */
export type AppUsageRecordCreatePayload = {
  /** The newly created app usage record. */
  readonly appUsageRecord?: Maybe<AppUsageRecord>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one AppUsageRecord and a cursor during pagination. */
export type AppUsageRecordEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of AppUsageRecordEdge. */
  readonly node: AppUsageRecord;
};

/** The set of valid sort keys for the AppUsageRecord query. */
export enum AppUsageRecordSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The Apple mobile platform application. */
export type AppleApplication = {
  /** The iOS App Clip application ID. */
  readonly appClipApplicationId?: Maybe<Scalars['String']>;
  /** Whether iOS App Clips are enabled for this app. */
  readonly appClipsEnabled: Scalars['Boolean'];
  /** The iOS App ID. */
  readonly appId?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether iOS shared web credentials are enabled for this app. */
  readonly sharedWebCredentialsEnabled: Scalars['Boolean'];
  /** Whether iOS Universal Links are supported by this app. */
  readonly universalLinksEnabled: Scalars['Boolean'];
};

/** An article in the blogging system. */
export type Article = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Navigable & Node & {
  /** The name of the author of the article. */
  readonly author?: Maybe<ArticleAuthor>;
  /** The blog containing the article. */
  readonly blog: Blog;
  /** The text of the article's body, complete with HTML markup. */
  readonly body: Scalars['HTML'];
  /** List of the article's comments. */
  readonly comments: CommentConnection;
  /** Count of comments. */
  readonly commentsCount?: Maybe<Count>;
  /** The date and time (ISO 8601 format) when the article was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /**
   * A unique, human-friendly string for the article that's automatically generated from the article's title.
   * The handle is used in the article's URL.
   */
  readonly handle: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image associated with the article. */
  readonly image?: Maybe<Image>;
  /** Whether or not the article is visible. */
  readonly isPublished: Scalars['Boolean'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /**
   * The date and time (ISO 8601 format) when the article became or will become visible.
   * Returns null when the article isn't visible.
   */
  readonly publishedAt?: Maybe<Scalars['DateTime']>;
  /**
   * A summary of the article, which can include HTML markup.
   * The summary is used by the online store theme to display the article on other pages, such as the home page or the main blog page.
   */
  readonly summary?: Maybe<Scalars['HTML']>;
  /**
   * A comma-separated list of tags.
   * Tags are additional short descriptors formatted as a string of comma-separated values.
   */
  readonly tags: ReadonlyArray<Scalars['String']>;
  /**
   * The name of the template an article is using if it's using an alternate template.
   * If an article is using the default `article.liquid` template, then the value returned is `null`.
   */
  readonly templateSuffix?: Maybe<Scalars['String']>;
  /** The title of the article. */
  readonly title: Scalars['String'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The date and time (ISO 8601 format) when the article was last updated. */
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};


/** An article in the blogging system. */
export type ArticleCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** An article in the blogging system. */
export type ArticleCommentsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};


/** An article in the blogging system. */
export type ArticleEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/** An article in the blogging system. */
export type ArticleMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** An article in the blogging system. */
export type ArticleMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** An article in the blogging system. */
export type ArticleMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** An article in the blogging system. */
export type ArticlePrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** An article in the blogging system. */
export type ArticlePrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** An article in the blogging system. */
export type ArticleTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** Represents an article author in an Article. */
export type ArticleAuthor = {
  /** The author's full name. */
  readonly name: Scalars['String'];
};

/** The input fields of a blog when an article is created or updated. */
export type ArticleBlogInput = {
  /** The title of the blog. */
  readonly title: Scalars['String'];
};

/** An auto-generated type for paginating through multiple Articles. */
export type ArticleConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ArticleEdge>;
  /** A list of nodes that are contained in ArticleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Article>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields to create an article. */
export type ArticleCreateInput = {
  /** The name of the author of the article. */
  readonly author: AuthorInput;
  /** The ID of the blog containing the article. */
  readonly blogId?: InputMaybe<Scalars['ID']>;
  /** The text of the article's body, complete with HTML markup. */
  readonly body?: InputMaybe<Scalars['HTML']>;
  /**
   * A unique, human-friendly string for the article that's automatically generated from the article's title.
   * The handle is used in the article's URL.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** The image associated with the article. */
  readonly image?: InputMaybe<ArticleImageInput>;
  /** Whether or not the article should be visible. */
  readonly isPublished?: InputMaybe<Scalars['Boolean']>;
  /** The input fields to create or update a metafield. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The date and time (ISO 8601 format) when the article should become visible. */
  readonly publishDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * A summary of the article, which can include HTML markup.
   * The summary is used by the online store theme to display the article on other pages, such as the home page or the main blog page.
   */
  readonly summary?: InputMaybe<Scalars['HTML']>;
  /**
   * A comma-separated list of tags.
   * Tags are additional short descriptors formatted as a string of comma-separated values.
   */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /**
   * The suffix of the template that's used to render the page.
   * If the value is an empty string or `null`, then the default article template is used.
   */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /** The title of the article. */
  readonly title: Scalars['String'];
};

/** Return type for `articleCreate` mutation. */
export type ArticleCreatePayload = {
  /** The article that was created. */
  readonly article?: Maybe<Article>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ArticleCreateUserError>;
};

/** An error that occurs during the execution of `ArticleCreate`. */
export type ArticleCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ArticleCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ArticleCreateUserError`. */
export enum ArticleCreateUserErrorCode {
  /** Can't create an article author if both author name and user ID are supplied. */
  AMBIGUOUS_AUTHOR = 'AMBIGUOUS_AUTHOR',
  /** Can't create a blog from input if a blog ID is supplied. */
  AMBIGUOUS_BLOG = 'AMBIGUOUS_BLOG',
  /** Can't create an article if both author name and user ID are blank. */
  AUTHOR_FIELD_REQUIRED = 'AUTHOR_FIELD_REQUIRED',
  /** User must exist if a user ID is supplied. */
  AUTHOR_MUST_EXIST = 'AUTHOR_MUST_EXIST',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Must reference or create a blog when creating an article. */
  BLOG_REFERENCE_REQUIRED = 'BLOG_REFERENCE_REQUIRED',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Can’t set isPublished to true and also set a future publish date. */
  INVALID_PUBLISH_DATE = 'INVALID_PUBLISH_DATE',
  /** The metafield type is invalid. */
  INVALID_TYPE = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** Image upload failed. */
  UPLOAD_FAILED = 'UPLOAD_FAILED'
}

/** Return type for `articleDelete` mutation. */
export type ArticleDeletePayload = {
  /** The ID of the deleted article. */
  readonly deletedArticleId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ArticleDeleteUserError>;
};

/** An error that occurs during the execution of `ArticleDelete`. */
export type ArticleDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ArticleDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ArticleDeleteUserError`. */
export enum ArticleDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** An auto-generated type which holds one Article and a cursor during pagination. */
export type ArticleEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ArticleEdge. */
  readonly node: Article;
};

/** The input fields for an image associated with an article. */
export type ArticleImageInput = {
  /** A word or phrase to share the nature or contents of an image. */
  readonly altText?: InputMaybe<Scalars['String']>;
  /** The URL of the image. */
  readonly url?: InputMaybe<Scalars['String']>;
};

/** The set of valid sort keys for the Article query. */
export enum ArticleSortKeys {
  /** Sort by the `author` value. */
  AUTHOR = 'AUTHOR',
  /** Sort by the `blog_title` value. */
  BLOG_TITLE = 'BLOG_TITLE',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `published_at` value. */
  PUBLISHED_AT = 'PUBLISHED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Possible sort of tags. */
export enum ArticleTagSort {
  /** Sort alphabetically.. */
  ALPHABETICAL = 'ALPHABETICAL',
  /** Sort by popularity, starting with the most popular tag. */
  POPULAR = 'POPULAR'
}

/** The input fields to update an article. */
export type ArticleUpdateInput = {
  /** The name of the author of the article. */
  readonly author?: InputMaybe<AuthorInput>;
  /** The ID of the blog containing the article. */
  readonly blogId?: InputMaybe<Scalars['ID']>;
  /** The text of the article's body, complete with HTML markup. */
  readonly body?: InputMaybe<Scalars['HTML']>;
  /**
   * A unique, human-friendly string for the article that's automatically generated from the article's title.
   * The handle is used in the article's URL.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** The image associated with the article. */
  readonly image?: InputMaybe<ArticleImageInput>;
  /** Whether or not the article should be visible. */
  readonly isPublished?: InputMaybe<Scalars['Boolean']>;
  /** The input fields to create or update a metafield. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The date and time (ISO 8601 format) when the article should become visible. */
  readonly publishDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  readonly redirectNewHandle?: InputMaybe<Scalars['Boolean']>;
  /**
   * A summary of the article, which can include HTML markup.
   * The summary is used by the online store theme to display the article on other pages, such as the home page or the main blog page.
   */
  readonly summary?: InputMaybe<Scalars['HTML']>;
  /**
   * A comma-separated list of tags.
   * Tags are additional short descriptors formatted as a string of comma-separated values.
   */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /**
   * The suffix of the template that's used to render the page.
   * If the value is an empty string or `null`, then the default article template is used.
   */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /** The title of the article. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `articleUpdate` mutation. */
export type ArticleUpdatePayload = {
  /** The article that was updated. */
  readonly article?: Maybe<Article>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ArticleUpdateUserError>;
};

/** An error that occurs during the execution of `ArticleUpdate`. */
export type ArticleUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ArticleUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ArticleUpdateUserError`. */
export enum ArticleUpdateUserErrorCode {
  /** Can't update an article author if both author name and user ID are supplied. */
  AMBIGUOUS_AUTHOR = 'AMBIGUOUS_AUTHOR',
  /** Can't create a blog from input if a blog ID is supplied. */
  AMBIGUOUS_BLOG = 'AMBIGUOUS_BLOG',
  /** User must exist if a user ID is supplied. */
  AUTHOR_MUST_EXIST = 'AUTHOR_MUST_EXIST',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Can’t set isPublished to true and also set a future publish date. */
  INVALID_PUBLISH_DATE = 'INVALID_PUBLISH_DATE',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** Image upload failed. */
  UPLOAD_FAILED = 'UPLOAD_FAILED'
}

/**
 * A custom property. Attributes are used to store additional information about a Shopify resource, such as
 * products, customers, or orders. Attributes are stored as key-value pairs.
 *
 * For example, a list of attributes might include whether a customer is a first-time buyer (`"customer_first_order": "true"`),
 * whether an order is gift-wrapped (`"gift_wrapped": "true"`), a preferred delivery date
 * (`"preferred_delivery_date": "2025-10-01"`), the discount applied (`"loyalty_discount_applied": "10%"`), and any
 * notes provided by the customer (`"customer_notes": "Please leave at the front door"`).
 */
export type Attribute = {
  /** The key or name of the attribute. For example, `"customer_first_order"`. */
  readonly key: Scalars['String'];
  /** The value of the attribute. For example, `"true"`. */
  readonly value?: Maybe<Scalars['String']>;
};

/** The input fields for an attribute. */
export type AttributeInput = {
  /** Key or name of the attribute. */
  readonly key: Scalars['String'];
  /** Value of the attribute. */
  readonly value: Scalars['String'];
};

/** The input fields for an author. Either the `name` or `user_id` fields can be supplied, but never both. */
export type AuthorInput = {
  /** The author's full name. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The ID of a staff member's account. */
  readonly userId?: InputMaybe<Scalars['ID']>;
};

/** Automatic discount applications capture the intentions of a discount that was automatically applied. */
export type AutomaticDiscountApplication = DiscountApplication & {
  /** The method by which the discount's value is applied to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  readonly index: Scalars['Int'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The title of the discount application. */
  readonly title: Scalars['String'];
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/** The set of valid sort keys for the AutomaticDiscount query. */
export enum AutomaticDiscountSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** Represents an object containing all information for channels available to a shop. */
export type AvailableChannelDefinitionsByChannel = {
  /** The channel definitions for channels installed on a shop. */
  readonly channelDefinitions: ReadonlyArray<ChannelDefinition>;
  /** The name of the channel. */
  readonly channelName: Scalars['String'];
};

/** The possible types for a badge. */
export enum BadgeType {
  /** This badge has type `attention`. */
  ATTENTION = 'ATTENTION',
  /** This badge has type `critical`. */
  CRITICAL = 'CRITICAL',
  /** This badge has type `default`. */
  DEFAULT = 'DEFAULT',
  /** This badge has type `info`. */
  INFO = 'INFO',
  /** This badge has type `success`. */
  SUCCESS = 'SUCCESS',
  /** This badge has type `warning`. */
  WARNING = 'WARNING'
}

/** The set of valid sort keys for the BalanceTransaction query. */
export enum BalanceTransactionSortKeys {
  /** Sort by the `amount` value. */
  AMOUNT = 'AMOUNT',
  /** Sort by the `fee` value. */
  FEE = 'FEE',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `net` value. */
  NET = 'NET',
  /** Sort by the `order_name` value. */
  ORDER_NAME = 'ORDER_NAME',
  /** Sort by the `payment_method_name` value. */
  PAYMENT_METHOD_NAME = 'PAYMENT_METHOD_NAME',
  /** Sort by the `payout_date` value. */
  PAYOUT_DATE = 'PAYOUT_DATE',
  /** Sort by the `payout_status` value. */
  PAYOUT_STATUS = 'PAYOUT_STATUS',
  /** Sort by the `processed_at` value. */
  PROCESSED_AT = 'PROCESSED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `transaction_type` value. */
  TRANSACTION_TYPE = 'TRANSACTION_TYPE'
}

/** Generic payment details that are related to a transaction. */
export type BasePaymentDetails = {
  /** The name of payment method used by the buyer. */
  readonly paymentMethodName?: Maybe<Scalars['String']>;
};

/**
 * Basic events chronicle resource activities such as the creation of an article, the fulfillment of an order, or
 * the addition of a product.
 *
 * ### General events
 *
 * | Action | Description  |
 * |---|---|
 * | `create` | The item was created. |
 * | `destroy` | The item was destroyed. |
 * | `published` | The item was published. |
 * | `unpublished` | The item was unpublished. |
 * | `update` | The item was updated.  |
 *
 * ### Order events
 *
 * Order events can be divided into the following categories:
 *
 * - *Authorization*: Includes whether the authorization succeeded, failed, or is pending.
 * - *Capture*: Includes whether the capture succeeded, failed, or is pending.
 * - *Email*: Includes confirmation or cancellation of the order, as well as shipping.
 * - *Fulfillment*: Includes whether the fulfillment succeeded, failed, or is pending. Also includes cancellation, restocking, and fulfillment updates.
 * - *Order*: Includess the placement, confirmation, closing, re-opening, and cancellation of the order.
 * - *Refund*: Includes whether the refund succeeded, failed, or is pending.
 * - *Sale*: Includes whether the sale succeeded, failed, or is pending.
 * - *Void*: Includes whether the void succeeded, failed, or is pending.
 *
 * | Action  | Message  | Description  |
 * |---|---|---|
 * | `authorization_failure` | The customer, unsuccessfully, tried to authorize: `{money_amount}`. | Authorization failed. The funds cannot be captured. |
 * | `authorization_pending` | Authorization for `{money_amount}` is pending. | Authorization pending. |
 * | `authorization_success` | The customer successfully authorized us to capture: `{money_amount}`. | Authorization was successful and the funds are available for capture. |
 * | `cancelled` | Order was cancelled by `{shop_staff_name}`. | The order was cancelled. |
 * | `capture_failure` | We failed to capture: `{money_amount}`. | The capture failed. The funds cannot be transferred to the shop. |
 * | `capture_pending` | Capture for `{money_amount}` is pending. | The capture is in process. The funds are not yet available to the shop. |
 * | `capture_success` | We successfully captured: `{money_amount}` | The capture was successful and the funds are now available to the shop. |
 * | `closed` | Order was closed. | The order was closed. |
 * | `confirmed` | Received a new order: `{order_number}` by `{customer_name}`. | The order was confirmed. |
 * | `fulfillment_cancelled` | We cancelled `{number_of_line_items}` from being fulfilled by the third party fulfillment service. | Fulfillment for one or more of the line_items failed. |
 * | `fulfillment_pending` | We submitted `{number_of_line_items}` to the third party service. | One or more of the line_items has been assigned to a third party service for fulfillment. |
 * | `fulfillment_success` | We successfully fulfilled line_items. | Fulfillment was successful for one or more line_items. |
 * | `mail_sent` | `{message_type}` email was sent to the customer. | An email was sent to the customer. |
 * | `placed` | Order was placed. | An order was placed by the customer. |
 * | `re_opened` | Order was re-opened. | An order was re-opened. |
 * | `refund_failure` | We failed to refund `{money_amount}`. | The refund failed. The funds are still with the shop. |
 * | `refund_pending` | Refund of `{money_amount}` is still pending. | The refund is in process. The funds are still with shop. |
 * | `refund_success` | We successfully refunded `{money_amount}`. | The refund was successful. The funds have been transferred to the customer. |
 * | `restock_line_items` | We restocked `{number_of_line_items}`. |	One or more of the order's line items have been restocked. |
 * | `sale_failure` | The customer failed to pay `{money_amount}`. | The sale failed. The funds are not available to the shop. |
 * | `sale_pending` | The `{money_amount}` is pending. | The sale is in process. The funds are not yet available to the shop. |
 * | `sale_success` | We successfully captured `{money_amount}`. | The sale was successful. The funds are now with the shop. |
 * | `update` | `{order_number}` was updated. | The order was updated. |
 * | `void_failure` | We failed to void the authorization. | Voiding the authorization failed. The authorization is still valid. |
 * | `void_pending` | Authorization void is pending. | Voiding the authorization is in process. The authorization is still valid. |
 * | `void_success` | We successfully voided the authorization. | Voiding the authorization was successful. The authorization is no longer valid. |
 */
export type BasicEvent = Event & Node & {
  /** The action that occured. */
  readonly action: Scalars['String'];
  /** Provides additional content for collapsible timeline events. */
  readonly additionalContent?: Maybe<Scalars['JSON']>;
  /** Provides additional data for event consumers. */
  readonly additionalData?: Maybe<Scalars['JSON']>;
  /** The name of the app that created the event. */
  readonly appTitle?: Maybe<Scalars['String']>;
  /** Refers to a certain event and its resources. */
  readonly arguments?: Maybe<Scalars['JSON']>;
  /** Whether the event was created by an app. */
  readonly attributeToApp: Scalars['Boolean'];
  /** Whether the event was caused by an admin user. */
  readonly attributeToUser: Scalars['Boolean'];
  /** The date and time when the event was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Whether the event is critical. */
  readonly criticalAlert: Scalars['Boolean'];
  /** Whether this event has additional content. */
  readonly hasAdditionalContent: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Human readable text that describes the event. */
  readonly message: Scalars['FormattedString'];
  /** Human readable text that supports the event message. */
  readonly secondaryMessage?: Maybe<Scalars['FormattedString']>;
  /**
   * The resource that generated the event. To see a list of possible types,
   * refer to [HasEvents](https://shopify.dev/docs/api/admin-graphql/unstable/interfaces/HasEvents#implemented-in).
   */
  readonly subject?: Maybe<HasEvents>;
  /** The ID of the resource that generated the event. */
  readonly subjectId: Scalars['ID'];
  /** The type of the resource that generated the event. */
  readonly subjectType: EventSubjectType;
};

/** Represents an error that happens during the execution of a billing attempt mutation. */
export type BillingAttemptUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<BillingAttemptUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `BillingAttemptUserError`. */
export enum BillingAttemptUserErrorCode {
  /** Billing cycle charge attempt made more than 24 hours before the billing cycle `billingAttemptExpectedDate`. */
  BILLING_CYCLE_CHARGE_BEFORE_EXPECTED_DATE = 'BILLING_CYCLE_CHARGE_BEFORE_EXPECTED_DATE',
  /** Billing cycle must not be skipped. */
  BILLING_CYCLE_SKIPPED = 'BILLING_CYCLE_SKIPPED',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Subscription contract does not exist. */
  CONTRACT_NOT_FOUND = 'CONTRACT_NOT_FOUND',
  /** Subscription contract cannot be billed if paused. */
  CONTRACT_PAUSED = 'CONTRACT_PAUSED',
  /** Subscription contract cannot be billed once terminated. */
  CONTRACT_TERMINATED = 'CONTRACT_TERMINATED',
  /** Subscription contract is under review. */
  CONTRACT_UNDER_REVIEW = 'CONTRACT_UNDER_REVIEW',
  /** Billing cycle selector cannot select billing cycle outside of index range. */
  CYCLE_INDEX_OUT_OF_RANGE = 'CYCLE_INDEX_OUT_OF_RANGE',
  /** Billing cycle selector cannot select billing cycle outside of start date range. */
  CYCLE_START_DATE_OUT_OF_RANGE = 'CYCLE_START_DATE_OUT_OF_RANGE',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Origin time cannot be before the contract creation time. */
  ORIGIN_TIME_BEFORE_CONTRACT_CREATION = 'ORIGIN_TIME_BEFORE_CONTRACT_CREATION',
  /** Origin time needs to be within the selected billing cycle's start and end at date. */
  ORIGIN_TIME_OUT_OF_RANGE = 'ORIGIN_TIME_OUT_OF_RANGE',
  /** Billing cycle selector cannot select upcoming billing cycle past limit. */
  UPCOMING_CYCLE_LIMIT_EXCEEDED = 'UPCOMING_CYCLE_LIMIT_EXCEEDED'
}

/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type Blog = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Node & {
  /** List of the blog's articles. */
  readonly articles: ArticleConnection;
  /** Count of articles. */
  readonly articlesCount?: Maybe<Count>;
  /** Indicates whether readers can post comments to the blog and if comments are moderated or not. */
  readonly commentPolicy: CommentPolicy;
  /** The date and time when the blog was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** FeedBurner provider details. Any blogs that aren't already integrated with FeedBurner can't use the service. */
  readonly feed?: Maybe<BlogFeed>;
  /**
   * A unique, human-friendly string for the blog. If no handle is specified, a handle will be generated automatically from the blog title.
   * The handle is customizable and is used by the Liquid templating language to refer to the blog.
   */
  readonly handle: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** A list of tags associated with the 200 most recent blog articles. */
  readonly tags: ReadonlyArray<Scalars['String']>;
  /**
   * The name of the template a blog is using if it's using an alternate template.
   * Returns `null` if a blog is using the default blog.liquid template.
   */
  readonly templateSuffix?: Maybe<Scalars['String']>;
  /** The title of the blog. */
  readonly title: Scalars['String'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The date and time when the blog was update. */
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};


/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type BlogArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type BlogEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type BlogMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type BlogMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type BlogMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type BlogPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type BlogPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Shopify stores come with a built-in blogging engine, allowing a shop to have one or more blogs.  Blogs are meant
 * to be used as a type of magazine or newsletter for the shop, with content that changes over time.
 */
export type BlogTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** An auto-generated type for paginating through multiple Blogs. */
export type BlogConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<BlogEdge>;
  /** A list of nodes that are contained in BlogEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Blog>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields to create a blog. */
export type BlogCreateInput = {
  /** Indicates whether readers can post comments to the blog and whether comments are moderated. */
  readonly commentPolicy?: InputMaybe<CommentPolicy>;
  /**
   * A unique, human-friendly string for the blog. If no handle is specified, a handle will be generated automatically from the blog title.
   * The handle is customizable and is used by the Liquid templating language to refer to the blog.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** Attaches additional metadata to a store's resources. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /**
   * The name of the template a blog is using if it's using an alternate template.
   * Returns `null` if a blog is using the default blog.liquid template.
   */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /** The title of the blog. */
  readonly title: Scalars['String'];
};

/** Return type for `blogCreate` mutation. */
export type BlogCreatePayload = {
  /** The blog that was created. */
  readonly blog?: Maybe<Blog>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BlogCreateUserError>;
};

/** An error that occurs during the execution of `BlogCreate`. */
export type BlogCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<BlogCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `BlogCreateUserError`. */
export enum BlogCreateUserErrorCode {
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The metafield type is invalid. */
  INVALID_TYPE = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG'
}

/** Return type for `blogDelete` mutation. */
export type BlogDeletePayload = {
  /** The ID of the deleted blog. */
  readonly deletedBlogId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BlogDeleteUserError>;
};

/** An error that occurs during the execution of `BlogDelete`. */
export type BlogDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<BlogDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `BlogDeleteUserError`. */
export enum BlogDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** An auto-generated type which holds one Blog and a cursor during pagination. */
export type BlogEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of BlogEdge. */
  readonly node: Blog;
};

/** FeedBurner provider details. Any blogs that aren't already integrated with FeedBurner can't use the service. */
export type BlogFeed = {
  /** Blog feed provider url. */
  readonly location: Scalars['URL'];
  /** Blog feed provider path. */
  readonly path: Scalars['String'];
};

/** The set of valid sort keys for the Blog query. */
export enum BlogSortKeys {
  /** Sort by the `handle` value. */
  HANDLE = 'HANDLE',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE'
}

/** The input fields to update a blog. */
export type BlogUpdateInput = {
  /** Indicates whether readers can post comments to the blog and whether comments are moderated. */
  readonly commentPolicy?: InputMaybe<CommentPolicy>;
  /**
   * A unique, human-friendly string for the blog. If no handle is specified, a handle will be generated automatically from the blog title.
   * The handle is customizable and is used by the Liquid templating language to refer to the blog.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** Attaches additional metadata to a store's resources. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** Whether to redirect blog posts automatically. */
  readonly redirectArticles?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  readonly redirectNewHandle?: InputMaybe<Scalars['Boolean']>;
  /**
   * The name of the template a blog is using if it's using an alternate template.
   * Returns `null` if a blog is using the default blog.liquid template.
   */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /** The title of the blog. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `blogUpdate` mutation. */
export type BlogUpdatePayload = {
  /** The blog that was updated. */
  readonly blog?: Maybe<Blog>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BlogUpdateUserError>;
};

/** An error that occurs during the execution of `BlogUpdate`. */
export type BlogUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<BlogUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `BlogUpdateUserError`. */
export enum BlogUpdateUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG'
}

/** Possible error codes that can be returned by `BulkMutationUserError`. */
export enum BulkMutationErrorCode {
  /** There was a problem reading the JSONL file. This error might be intermittent, so you can try performing the same query again. */
  INTERNAL_FILE_SERVER_ERROR = 'INTERNAL_FILE_SERVER_ERROR',
  /** The operation did not run because the mutation is invalid. Check your mutation syntax and try again. */
  INVALID_MUTATION = 'INVALID_MUTATION',
  /** The JSONL file submitted via the `stagedUploadsCreate` mutation is invalid. Update the file and try again. */
  INVALID_STAGED_UPLOAD_FILE = 'INVALID_STAGED_UPLOAD_FILE',
  /** The JSONL file could not be found. Try [uploading the file](https://shopify.dev/api/usage/bulk-operations/imports#generate-the-uploaded-url-and-parameters) again, and check that you've entered the URL correctly for the `stagedUploadPath` mutation argument. */
  NO_SUCH_FILE = 'NO_SUCH_FILE',
  /** The operation did not run because another bulk mutation is already running. [Wait for the operation to finish](https://shopify.dev/api/usage/bulk-operations/imports#wait-for-the-operation-to-finish) before retrying this operation. */
  OPERATION_IN_PROGRESS = 'OPERATION_IN_PROGRESS'
}

/** Represents an error that happens during execution of a bulk mutation. */
export type BulkMutationUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<BulkMutationErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/**
 * An asynchronous long-running operation to fetch data in bulk or to bulk import data.
 *
 * Bulk operations are created using the `bulkOperationRunQuery` or `bulkOperationRunMutation` mutation. After
 * they are created, clients should poll the `status` field for updates. When `COMPLETED`, the `url` field contains
 * a link to the data in [JSONL](http://jsonlines.org/) format.
 *
 * Refer to the [bulk operations guide](https://shopify.dev/api/usage/bulk-operations/imports) for more details.
 */
export type BulkOperation = Node & {
  /** When the bulk operation was successfully completed. */
  readonly completedAt?: Maybe<Scalars['DateTime']>;
  /** When the bulk operation was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Error code for failed operations. */
  readonly errorCode?: Maybe<BulkOperationErrorCode>;
  /** File size in bytes of the file in the `url` field. */
  readonly fileSize?: Maybe<Scalars['UnsignedInt64']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A running count of all the objects processed.
   * For example, when fetching all the products and their variants, this field counts both products and variants.
   * This field can be used to track operation progress.
   */
  readonly objectCount: Scalars['UnsignedInt64'];
  /**
   * The URL that points to the partial or incomplete response data (in [JSONL](http://jsonlines.org/) format) that was returned by a failed operation.
   * The URL expires 7 days after the operation fails. Returns `null` when there's no data available.
   */
  readonly partialDataUrl?: Maybe<Scalars['URL']>;
  /** GraphQL query document specified in `bulkOperationRunQuery`. */
  readonly query: Scalars['String'];
  /**
   * A running count of all the objects that are processed at the root of the query.
   * For example, when fetching all the products and their variants, this field only counts products.
   * This field can be used to track operation progress.
   */
  readonly rootObjectCount: Scalars['UnsignedInt64'];
  /** Status of the bulk operation. */
  readonly status: BulkOperationStatus;
  /** The bulk operation's type. */
  readonly type: BulkOperationType;
  /**
   * The URL that points to the response data in [JSONL](http://jsonlines.org/) format.
   * The URL expires 7 days after the operation completes.
   */
  readonly url?: Maybe<Scalars['URL']>;
};

/** Return type for `bulkOperationCancel` mutation. */
export type BulkOperationCancelPayload = {
  /** The bulk operation to be canceled. */
  readonly bulkOperation?: Maybe<BulkOperation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Error codes for failed bulk operations. */
export enum BulkOperationErrorCode {
  /**
   * The provided operation `query` returned access denied due to missing
   * [access scopes](https://shopify.dev/api/usage/access-scopes).
   * Review the requested object permissions and execute the query as a normal non-bulk GraphQL request to see more details.
   */
  ACCESS_DENIED = 'ACCESS_DENIED',
  /**
   * The operation resulted in partial or incomplete data due to internal server errors during execution.
   * These errors might be intermittent, so you can try performing the same query again.
   */
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  /**
   * The operation resulted in partial or incomplete data due to query timeouts during execution.
   * In some cases, timeouts can be avoided by modifying your `query` to select fewer fields.
   */
  TIMEOUT = 'TIMEOUT'
}

/** Return type for `bulkOperationRunMutation` mutation. */
export type BulkOperationRunMutationPayload = {
  /** The newly created bulk operation. */
  readonly bulkOperation?: Maybe<BulkOperation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BulkMutationUserError>;
};

/** Return type for `bulkOperationRunQuery` mutation. */
export type BulkOperationRunQueryPayload = {
  /** The newly created bulk operation. */
  readonly bulkOperation?: Maybe<BulkOperation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The valid values for the status of a bulk operation. */
export enum BulkOperationStatus {
  /** The bulk operation has been canceled. */
  CANCELED = 'CANCELED',
  /**
   * Cancelation has been initiated on the bulk operation. There may be a short delay from when a cancelation
   * starts until the operation is actually canceled.
   */
  CANCELING = 'CANCELING',
  /** The bulk operation has successfully completed. */
  COMPLETED = 'COMPLETED',
  /** The bulk operation has been created. */
  CREATED = 'CREATED',
  /** The bulk operation URL has expired. */
  EXPIRED = 'EXPIRED',
  /**
   * The bulk operation has failed. For information on why the operation failed, use
   * [BulkOperation.errorCode](https://shopify.dev/api/admin-graphql/latest/enums/bulkoperationerrorcode).
   */
  FAILED = 'FAILED',
  /** The bulk operation is runnning. */
  RUNNING = 'RUNNING'
}

/** The valid values for the bulk operation's type. */
export enum BulkOperationType {
  /** The bulk operation is a mutation. */
  MUTATION = 'MUTATION',
  /** The bulk operation is a query. */
  QUERY = 'QUERY'
}

/** Return type for `bulkProductResourceFeedbackCreate` mutation. */
export type BulkProductResourceFeedbackCreatePayload = {
  /** The feedback that's created. */
  readonly feedback?: Maybe<ReadonlyArray<ProductResourceFeedback>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BulkProductResourceFeedbackCreateUserError>;
};

/** An error that occurs during the execution of `BulkProductResourceFeedbackCreate`. */
export type BulkProductResourceFeedbackCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<BulkProductResourceFeedbackCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `BulkProductResourceFeedbackCreateUserError`. */
export enum BulkProductResourceFeedbackCreateUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The input value should be less than or equal to the maximum value allowed. */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  /** The operation was attempted on too many feedback objects. The maximum number of feedback objects that you can operate on is 50. */
  MAXIMUM_FEEDBACK_LIMIT_EXCEEDED = 'MAXIMUM_FEEDBACK_LIMIT_EXCEEDED',
  /** The feedback for a later version of this resource was already accepted. */
  OUTDATED_FEEDBACK = 'OUTDATED_FEEDBACK',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The product wasn't found or isn't available to the channel. */
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND'
}

/** The input fields representing the components of a bundle line item. */
export type BundlesDraftOrderBundleLineItemComponentInput = {
  /** The quantity of the bundle component. */
  readonly quantity: Scalars['Int'];
  /**
   * The UUID of the bundle component. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with bundles.
   */
  readonly uuid?: InputMaybe<Scalars['String']>;
  /** The ID of the product variant corresponding to the bundle component. */
  readonly variantId?: InputMaybe<Scalars['ID']>;
};

/** Represents the Bundles feature configuration for the shop. */
export type BundlesFeature = {
  /** Whether a shop is configured properly to sell bundles. */
  readonly eligibleForBundles: Scalars['Boolean'];
  /** The reason why a shop is not eligible for bundles. */
  readonly ineligibilityReason?: Maybe<Scalars['String']>;
  /** Whether a shop has any fixed bundle products or has a cartTransform function installed. */
  readonly sellsBundles: Scalars['Boolean'];
};

/** Possible error codes that can be returned by `BusinessCustomerUserError`. */
export enum BusinessCustomerErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Deleting the resource failed. */
  FAILED_TO_DELETE = 'FAILED_TO_DELETE',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The input is invalid. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** The number of resources exceeded the limit. */
  LIMIT_REACHED = 'LIMIT_REACHED',
  /** The input is empty. */
  NO_INPUT = 'NO_INPUT',
  /** Missing a required field. */
  REQUIRED = 'REQUIRED',
  /** The resource wasn't found. */
  RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The field value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** Unexpected type. */
  UNEXPECTED_TYPE = 'UNEXPECTED_TYPE'
}

/** An error that happens during the execution of a business customer mutation. */
export type BusinessCustomerUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<BusinessCustomerErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Represents a merchant's Business Entity. */
export type BusinessEntity = Node & {
  /** The address of the merchant's Business Entity. */
  readonly address: BusinessEntityAddress;
  /** The name of the company associated with the merchant's Business Entity. */
  readonly companyName?: Maybe<Scalars['String']>;
  /** The display name of the merchant's Business Entity. */
  readonly displayName: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether it's the merchant's primary Business Entity. */
  readonly primary: Scalars['Boolean'];
  /** Shopify Payments account information, including balances and payouts. */
  readonly shopifyPaymentsAccount?: Maybe<ShopifyPaymentsAccount>;
};

/** Represents the address of a merchant's Business Entity. */
export type BusinessEntityAddress = {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: Maybe<Scalars['String']>;
  /** The country code of the merchant's Business Entity. */
  readonly countryCode: CountryCode;
  /** The region of the address, such as the province, state, or district. */
  readonly province?: Maybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** Settings describing the behavior of checkout for a B2B buyer. */
export type BuyerExperienceConfiguration = {
  /** Whether to checkout to draft order for merchant review. */
  readonly checkoutToDraft: Scalars['Boolean'];
  /** The portion required to be paid at checkout. */
  readonly deposit?: Maybe<DepositConfiguration>;
  /** Whether to allow customers to use editable shipping addresses. */
  readonly editableShippingAddress: Scalars['Boolean'];
  /**
   * Whether a buyer must pay at checkout or they can also choose to pay
   * later using net terms.
   * @deprecated Please use `checkoutToDraft`(must be false) and `paymentTermsTemplate`(must be nil) to derive this instead.
   */
  readonly payNowOnly: Scalars['Boolean'];
  /** Represents the merchant configured payment terms. */
  readonly paymentTermsTemplate?: Maybe<PaymentTermsTemplate>;
};

/** The input fields specifying the behavior of checkout for a B2B buyer. */
export type BuyerExperienceConfigurationInput = {
  /** Whether to checkout to draft order for merchant review. */
  readonly checkoutToDraft?: InputMaybe<Scalars['Boolean']>;
  /** The input fields configuring the deposit a B2B buyer. */
  readonly deposit?: InputMaybe<DepositInput>;
  /** Whether to allow customers to edit their shipping address at checkout. */
  readonly editableShippingAddress?: InputMaybe<Scalars['Boolean']>;
  /** Represents the merchant configured payment terms. */
  readonly paymentTermsTemplateId?: InputMaybe<Scalars['ID']>;
};

/** The input fields for exchange line items on a calculated return. */
export type CalculateExchangeLineItemInput = {
  /** The discount to be applied to the exchange line item. */
  readonly appliedDiscount?: InputMaybe<ExchangeLineItemAppliedDiscountInput>;
  /** The quantity of the item to be added. */
  readonly quantity: Scalars['Int'];
  /** The ID of the product variant to be added to the order as part of an exchange. */
  readonly variantId: Scalars['ID'];
};

/** The input fields to calculate return amounts associated with an order. */
export type CalculateReturnInput = {
  /** The exchange line items to add to the order. */
  readonly exchangeLineItems?: InputMaybe<ReadonlyArray<CalculateExchangeLineItemInput>>;
  /** The ID of the order that will be returned. */
  readonly orderId: Scalars['ID'];
  /** The line items from the order to include in the return. */
  readonly returnLineItems?: InputMaybe<ReadonlyArray<CalculateReturnLineItemInput>>;
  /** The return shipping fee associated with the return. */
  readonly returnShippingFee?: InputMaybe<ReturnShippingFeeInput>;
};

/** The input fields for return line items on a calculated return. */
export type CalculateReturnLineItemInput = {
  /** The ID of the fulfillment line item to be returned. */
  readonly fulfillmentLineItemId: Scalars['ID'];
  /** The quantity of the item to be returned. */
  readonly quantity: Scalars['Int'];
  /** The restocking fee for the return line item. */
  readonly restockingFee?: InputMaybe<RestockingFeeInput>;
};

/** A discount that is automatically applied to an order that is being edited. */
export type CalculatedAutomaticDiscountApplication = CalculatedDiscountApplication & {
  /** The method by which the discount's value is allocated to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  readonly appliedTo: DiscountApplicationLevel;
  /** The description of discount application. Indicates the reason why the discount was applied. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/** An amount discounting the line that has been allocated by an associated discount application. */
export type CalculatedDiscountAllocation = {
  /** The money amount that's allocated by the discount application in shop and presentment currencies. */
  readonly allocatedAmountSet: MoneyBag;
  /** The discount that the allocated amount originated from. */
  readonly discountApplication: CalculatedDiscountApplication;
};

/** A [discount application](https://shopify.dev/api/admin-graphql/latest/interfaces/discountapplication) involved in order editing that might be newly added or have new changes applied. */
export type CalculatedDiscountApplication = {
  /** The method by which the discount's value is allocated to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  readonly appliedTo: DiscountApplicationLevel;
  /** The description of discount application. Indicates the reason why the discount was applied. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/** An auto-generated type for paginating through multiple CalculatedDiscountApplications. */
export type CalculatedDiscountApplicationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CalculatedDiscountApplicationEdge>;
  /** A list of nodes that are contained in CalculatedDiscountApplicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CalculatedDiscountApplication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CalculatedDiscountApplication and a cursor during pagination. */
export type CalculatedDiscountApplicationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CalculatedDiscountApplicationEdge. */
  readonly node: CalculatedDiscountApplication;
};

/** A discount code that is applied to an order that is being edited. */
export type CalculatedDiscountCodeApplication = CalculatedDiscountApplication & {
  /** The method by which the discount's value is allocated to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  readonly appliedTo: DiscountApplicationLevel;
  /** The string identifying the discount code that was used at the time of application. */
  readonly code: Scalars['String'];
  /** The description of discount application. Indicates the reason why the discount was applied. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/** The calculated fields for a draft order. */
export type CalculatedDraftOrder = {
  /**
   * Whether or not to accept automatic discounts on the draft order during calculation.
   * If false, only discount codes and custom draft order discounts (see `appliedDiscount`) will be applied.
   * If true, eligible automatic discounts will be applied in addition to discount codes and custom draft order discounts.
   */
  readonly acceptAutomaticDiscounts?: Maybe<Scalars['Boolean']>;
  /** The list of alerts raised while calculating. */
  readonly alerts: ReadonlyArray<ResourceAlert>;
  /** The custom order-level discount applied. */
  readonly appliedDiscount?: Maybe<DraftOrderAppliedDiscount>;
  /**
   * The available shipping rates.
   * Requires a customer with a valid shipping address and at least one line item.
   */
  readonly availableShippingRates: ReadonlyArray<ShippingRate>;
  /** Whether the billing address matches the shipping address. */
  readonly billingAddressMatchesShippingAddress: Scalars['Boolean'];
  /** The shop currency used for calculation. */
  readonly currencyCode: CurrencyCode;
  /** The customer who will be sent an invoice. */
  readonly customer?: Maybe<Customer>;
  /** All discount codes applied. */
  readonly discountCodes: ReadonlyArray<Scalars['String']>;
  /** The list of the line items in the calculated draft order. */
  readonly lineItems: ReadonlyArray<CalculatedDraftOrderLineItem>;
  /**
   * A subtotal of the line items and corresponding discounts,
   * excluding include shipping charges, shipping discounts, taxes, or order discounts.
   */
  readonly lineItemsSubtotalPrice: MoneyBag;
  /**
   * The name of the selected market.
   * @deprecated This field is now incompatible with Markets.
   */
  readonly marketName: Scalars['String'];
  /**
   * The selected country code that determines the pricing.
   * @deprecated This field is now incompatible with Markets.
   */
  readonly marketRegionCountryCode: CountryCode;
  /** The assigned phone number. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The list of platform discounts applied. */
  readonly platformDiscounts: ReadonlyArray<DraftOrderPlatformDiscount>;
  /** The payment currency used for calculation. */
  readonly presentmentCurrencyCode: CurrencyCode;
  /** The purchasing entity. */
  readonly purchasingEntity?: Maybe<PurchasingEntity>;
  /** The line item containing the shipping information and costs. */
  readonly shippingLine?: Maybe<ShippingLine>;
  /**
   * The subtotal, in shop currency, of the line items and their discounts, excluding shipping charges, shipping discounts, and taxes.
   * @deprecated Use `subtotalPriceSet` instead.
   */
  readonly subtotalPrice: Scalars['Money'];
  /** The subtotal, of the line items and their discounts, excluding shipping charges, shipping discounts, and taxes. */
  readonly subtotalPriceSet: MoneyBag;
  /** The list of of taxes lines charged for each line item and shipping line. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Whether the line item prices include taxes. */
  readonly taxesIncluded: Scalars['Boolean'];
  /** Total discounts. */
  readonly totalDiscountsSet: MoneyBag;
  /** Total price of line items. */
  readonly totalLineItemsPriceSet: MoneyBag;
  /**
   * The total price, in shop currency, includes taxes, shipping charges, and discounts.
   * @deprecated Use `totalPriceSet` instead.
   */
  readonly totalPrice: Scalars['Money'];
  /** The total price, includes taxes, shipping charges, and discounts. */
  readonly totalPriceSet: MoneyBag;
  /**
   * The sum of individual line item quantities.
   * If the draft order has bundle items, this is the sum containing the quantities of individual items in the bundle.
   */
  readonly totalQuantityOfLineItems: Scalars['Int'];
  /**
   * The total shipping price in shop currency.
   * @deprecated Use `totalShippingPriceSet` instead.
   */
  readonly totalShippingPrice: Scalars['Money'];
  /** The total shipping price. */
  readonly totalShippingPriceSet: MoneyBag;
  /**
   * The total tax in shop currency.
   * @deprecated Use `totalTaxSet` instead.
   */
  readonly totalTax: Scalars['Money'];
  /** The total tax. */
  readonly totalTaxSet: MoneyBag;
  /**
   * Fingerprint of the current cart.
   * In order to have bundles work, the fingerprint must be passed to
   * each request as it was previously returned, unmodified.
   */
  readonly transformerFingerprint?: Maybe<Scalars['String']>;
  /** The list of warnings raised while calculating. */
  readonly warnings: ReadonlyArray<DraftOrderWarning>;
};

/** The calculated line item for a draft order. */
export type CalculatedDraftOrderLineItem = {
  /** The custom applied discount. */
  readonly appliedDiscount?: Maybe<DraftOrderAppliedDiscount>;
  /**
   * The `discountedTotal` divided by `quantity`,
   * equal to the average value of the line item price per unit after discounts are applied.
   * This value doesn't include discounts applied to the entire draft order.
   */
  readonly approximateDiscountedUnitPriceSet: MoneyBag;
  /** The bundle components of the draft order line item. */
  readonly bundleComponents: ReadonlyArray<CalculatedDraftOrderLineItem>;
  /** Whether the line item is custom (`true`) or contains a product variant (`false`). */
  readonly custom: Scalars['Boolean'];
  /** A list of attributes that represent custom features or special requests. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The list of additional information (metafields) with the associated types. */
  readonly customAttributesV2: ReadonlyArray<TypedAttribute>;
  /** The total price with discounts applied. */
  readonly discountedTotal: MoneyV2;
  /** The total price with discounts applied. */
  readonly discountedTotalSet: MoneyBag;
  /**
   * The unit price with discounts applied.
   * @deprecated Use `approximateDiscountedUnitPriceSet` instead.
   */
  readonly discountedUnitPrice: MoneyV2;
  /**
   * The unit price with discounts applied.
   * @deprecated Use `approximateDiscountedUnitPriceSet` instead.
   */
  readonly discountedUnitPriceSet: MoneyBag;
  /**
   * Name of the service provider who fulfilled the order.
   *
   * Valid values are either **manual** or the name of the provider.
   * For example, **amazon**, **shipwire**.
   *
   * Deleted fulfillment services will return null.
   */
  readonly fulfillmentService?: Maybe<FulfillmentService>;
  /** The image associated with the draft order line item. */
  readonly image?: Maybe<Image>;
  /** Whether the line item represents the purchase of a gift card. */
  readonly isGiftCard: Scalars['Boolean'];
  /** The name of the product. */
  readonly name: Scalars['String'];
  /** The total price, excluding discounts, equal to the original unit price multiplied by quantity. */
  readonly originalTotal: MoneyV2;
  /** The total price excluding discounts, equal to the original unit price multiplied by quantity. */
  readonly originalTotalSet: MoneyBag;
  /** The line item price without any discounts applied. */
  readonly originalUnitPrice: MoneyV2;
  /** The price without any discounts applied. */
  readonly originalUnitPriceSet: MoneyBag;
  /** The original custom line item input price. */
  readonly originalUnitPriceWithCurrency?: Maybe<MoneyV2>;
  /** The product for the line item. */
  readonly product?: Maybe<Product>;
  /**
   * The quantity of items. For a bundle item, this is the quantity of bundles,
   * not the quantity of items contained in the bundles themselves.
   */
  readonly quantity: Scalars['Int'];
  /** Whether physical shipping is required for the variant. */
  readonly requiresShipping: Scalars['Boolean'];
  /** The SKU number of the product variant. */
  readonly sku?: Maybe<Scalars['String']>;
  /** Whether the variant is taxable. */
  readonly taxable: Scalars['Boolean'];
  /** The title of the product or variant. This field only applies to custom line items. */
  readonly title: Scalars['String'];
  /** The total value of the discount. */
  readonly totalDiscount: MoneyV2;
  /** The total discount amount. */
  readonly totalDiscountSet: MoneyBag;
  /**
   * The UUID of the draft order line item. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with bundles.
   */
  readonly uuid: Scalars['String'];
  /** The product variant for the line item. */
  readonly variant?: Maybe<ProductVariant>;
  /** The name of the variant. */
  readonly variantTitle?: Maybe<Scalars['String']>;
  /** The name of the vendor who created the product variant. */
  readonly vendor?: Maybe<Scalars['String']>;
  /** The weight unit and value. */
  readonly weight?: Maybe<Weight>;
};

/** A calculated exchange line item. */
export type CalculatedExchangeLineItem = {
  /** The discounts that have been allocated onto the line item by discount applications. */
  readonly calculatedDiscountAllocations: ReadonlyArray<CalculatedDiscountAllocation>;
  /** The unit price of the exchange line item after discounts. */
  readonly discountedUnitPriceSet: MoneyBag;
  /** A globally-unique ID. */
  readonly id?: Maybe<Scalars['ID']>;
  /** The original unit price of the exchange line item before discounts. */
  readonly originalUnitPriceSet: MoneyBag;
  /** The quantity being exchanged. */
  readonly quantity: Scalars['Int'];
  /** The calculated subtotal set of the exchange line item, including discounts. */
  readonly subtotalSet: MoneyBag;
  /** The total tax of the exchange line item. */
  readonly totalTaxSet: MoneyBag;
  /** The variant being exchanged. */
  readonly variant: ProductVariant;
};

/** A line item involved in order editing that may be newly added or have new changes applied. */
export type CalculatedLineItem = {
  /** The discounts that have been allocated onto the line item by discount applications. */
  readonly calculatedDiscountAllocations: ReadonlyArray<CalculatedDiscountAllocation>;
  /** A list of attributes that represent custom features or special requests. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /**
   * The discounts that have been allocated onto the line item by discount applications.
   * @deprecated Use `calculatedDiscountAllocations` instead.
   */
  readonly discountAllocations: ReadonlyArray<DiscountAllocation>;
  /** The price of a single quantity of the line item with line item discounts applied, in shop and presentment currencies. Discounts applied to the entire order aren't included in this price. */
  readonly discountedUnitPriceSet: MoneyBag;
  /** The total number of items that can be edited. */
  readonly editableQuantity: Scalars['Int'];
  /** The editable quantity prior to any changes made in the current edit. */
  readonly editableQuantityBeforeChanges: Scalars['Int'];
  /** The total price of editable lines in shop and presentment currencies. */
  readonly editableSubtotalSet: MoneyBag;
  /** Whether the calculated line item has a staged discount. */
  readonly hasStagedLineItemDiscount: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image object associated to the line item's variant. */
  readonly image?: Maybe<Image>;
  /** The variant unit price in shop and presentment currencies, without any discounts applied. */
  readonly originalUnitPriceSet: MoneyBag;
  /** The total number of items. */
  readonly quantity: Scalars['Int'];
  /** Whether the line item can be restocked or not. */
  readonly restockable: Scalars['Boolean'];
  /** Whether the changes on the line item will result in a restock. */
  readonly restocking: Scalars['Boolean'];
  /** The variant SKU number. */
  readonly sku?: Maybe<Scalars['String']>;
  /** A list of changes that affect this line item. */
  readonly stagedChanges: ReadonlyArray<OrderStagedChange>;
  /** The title of the product. */
  readonly title: Scalars['String'];
  /** The total price of uneditable lines in shop and presentment currencies. */
  readonly uneditableSubtotalSet: MoneyBag;
  /**
   * The product variant associated with this line item. The value is null for custom line items and items where
   * the variant has been deleted.
   */
  readonly variant?: Maybe<ProductVariant>;
  /** The title of the variant. */
  readonly variantTitle?: Maybe<Scalars['String']>;
};

/** An auto-generated type for paginating through multiple CalculatedLineItems. */
export type CalculatedLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CalculatedLineItemEdge>;
  /** A list of nodes that are contained in CalculatedLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CalculatedLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CalculatedLineItem and a cursor during pagination. */
export type CalculatedLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CalculatedLineItemEdge. */
  readonly node: CalculatedLineItem;
};

/** Represents a discount that was manually created for an order that is being edited. */
export type CalculatedManualDiscountApplication = CalculatedDiscountApplication & {
  /** The method by which the discount's value is allocated to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  readonly appliedTo: DiscountApplicationLevel;
  /** The description of discount application. Indicates the reason why the discount was applied. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/** An order with edits applied but not saved. */
export type CalculatedOrder = Node & {
  /** Returns only the new discount applications being added to the order in the current edit. */
  readonly addedDiscountApplications: CalculatedDiscountApplicationConnection;
  /** Returns only the new line items being added to the order during the current edit. */
  readonly addedLineItems: CalculatedLineItemConnection;
  /** Amount of the order-level discount (doesn't contain any line item discounts) in shop and presentment currencies. */
  readonly cartDiscountAmountSet?: Maybe<MoneyBag>;
  /**
   * Whether the changes have been applied and saved to the order.
   * @deprecated CalculatedOrder for committed order edits is being deprecated, and this field will also be removed in a future version.  See [changelog](https://shopify.dev/changelog/deprecation-notice-calculatedorder-for-committed-order-edits) for more details.
   */
  readonly committed: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * Returns all items on the order that existed before starting the edit.
   * Will include any changes that have been made.
   * Will not include line items added during the current edit.
   */
  readonly lineItems: CalculatedLineItemConnection;
  /** The HTML of the customer notification for the order edit. */
  readonly notificationPreviewHtml?: Maybe<Scalars['HTML']>;
  /** The customer notification title. */
  readonly notificationPreviewTitle: Scalars['String'];
  /** The order without any changes applied. */
  readonly originalOrder: Order;
  /**
   * Returns the shipping lines on the order that existed before starting the edit.
   * Will include any changes that have been made as well as shipping lines added during the current edit.
   * Returns only the first 250 shipping lines.
   */
  readonly shippingLines: ReadonlyArray<CalculatedShippingLine>;
  /** List of changes made to the order during the current edit. */
  readonly stagedChanges: OrderStagedChangeConnection;
  /** The sum of the quantities for the line items that contribute to the order's subtotal. */
  readonly subtotalLineItemsQuantity: Scalars['Int'];
  /** The subtotal of the line items, in shop and presentment currencies, after all the discounts are applied.  The subtotal doesn't include shipping.  The subtotal includes taxes for taxes-included orders and excludes taxes for taxes-excluded orders. */
  readonly subtotalPriceSet?: Maybe<MoneyBag>;
  /** Taxes charged for the line item. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Total price of the order less the total amount received from the customer in shop and presentment currencies. */
  readonly totalOutstandingSet: MoneyBag;
  /** Total amount of the order (includes taxes and discounts) in shop and presentment currencies. */
  readonly totalPriceSet: MoneyBag;
};


/** An order with edits applied but not saved. */
export type CalculatedOrderAddedDiscountApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** An order with edits applied but not saved. */
export type CalculatedOrderAddedLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** An order with edits applied but not saved. */
export type CalculatedOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** An order with edits applied but not saved. */
export type CalculatedOrderStagedChangesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The calculated costs of handling a return line item.
 * Typically, this would cover the costs of inspecting, repackaging, and restocking the item.
 */
export type CalculatedRestockingFee = CalculatedReturnFee & {
  /** The calculated amount of the return fee, in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The value of the fee as a percentage. */
  readonly percentage: Scalars['Float'];
};

/** A calculated return. */
export type CalculatedReturn = {
  /** A list of calculated exchange line items. */
  readonly exchangeLineItems: ReadonlyArray<CalculatedExchangeLineItem>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** A list of calculated return line items. */
  readonly returnLineItems: ReadonlyArray<CalculatedReturnLineItem>;
  /** The calulated return shipping fee. */
  readonly returnShippingFee?: Maybe<CalculatedReturnShippingFee>;
};

/** A calculated return fee. */
export type CalculatedReturnFee = {
  /** The calculated amount of the return fee, in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
};

/** A calculated return line item. */
export type CalculatedReturnLineItem = {
  /** The fulfillment line item from which items are returned. */
  readonly fulfillmentLineItem: FulfillmentLineItem;
  /** A globally-unique ID. */
  readonly id?: Maybe<Scalars['ID']>;
  /** The quantity being returned. */
  readonly quantity: Scalars['Int'];
  /** The restocking fee of the return line item. */
  readonly restockingFee?: Maybe<CalculatedRestockingFee>;
  /** The subtotal of the return line item before order discounts. */
  readonly subtotalBeforeOrderDiscountsSet: MoneyBag;
  /** The subtotal of the return line item. */
  readonly subtotalSet: MoneyBag;
  /** The total tax of the return line item. */
  readonly totalTaxSet: MoneyBag;
};

/** The calculated cost of the return shipping. */
export type CalculatedReturnShippingFee = CalculatedReturnFee & {
  /** The calculated amount of the return fee, in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
};

/** A discount created by a Shopify script for an order that is being edited. */
export type CalculatedScriptDiscountApplication = CalculatedDiscountApplication & {
  /** The method by which the discount's value is allocated to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /** The level at which the discount was applied. */
  readonly appliedTo: DiscountApplicationLevel;
  /** The description of discount application. Indicates the reason why the discount was applied. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/** A shipping line item involved in order editing that may be newly added or have new changes applied. */
export type CalculatedShippingLine = {
  /** A globally-unique ID. */
  readonly id?: Maybe<Scalars['ID']>;
  /** The price of the shipping line when sold and before applying discounts. This field includes taxes if `Order.taxesIncluded` is true. Otherwise, this field doesn't include taxes for the shipping line. */
  readonly price: MoneyBag;
  /** The staged status of the shipping line. */
  readonly stagedStatus: CalculatedShippingLineStagedStatus;
  /** The title of the shipping line. */
  readonly title: Scalars['String'];
};

/** Represents the staged status of a CalculatedShippingLine on a CalculatedOrder. */
export enum CalculatedShippingLineStagedStatus {
  /** The shipping line was added as part of the current order edit. */
  ADDED = 'ADDED',
  /** The shipping line has no staged changes associated with it. */
  NONE = 'NONE',
  /** The shipping line was removed as part of the current order edit. */
  REMOVED = 'REMOVED'
}

/** Card payment details related to a transaction. */
export type CardPaymentDetails = BasePaymentDetails & {
  /** The response code from the address verification system (AVS). The code is always a single letter. */
  readonly avsResultCode?: Maybe<Scalars['String']>;
  /** The issuer identification number (IIN), formerly known as bank identification number (BIN) of the customer's credit card. This is made up of the first few digits of the credit card number. */
  readonly bin?: Maybe<Scalars['String']>;
  /** The name of the company that issued the customer's credit card. */
  readonly company?: Maybe<Scalars['String']>;
  /** The response code from the credit card company indicating whether the customer entered the card security code, or card verification value, correctly. The code is a single letter or empty string. */
  readonly cvvResultCode?: Maybe<Scalars['String']>;
  /** The month in which the used credit card expires. */
  readonly expirationMonth?: Maybe<Scalars['Int']>;
  /** The year in which the used credit card expires. */
  readonly expirationYear?: Maybe<Scalars['Int']>;
  /** The holder of the credit card. */
  readonly name?: Maybe<Scalars['String']>;
  /** The customer's credit card number, with most of the leading digits redacted. */
  readonly number?: Maybe<Scalars['String']>;
  /** The name of payment method used by the buyer. */
  readonly paymentMethodName?: Maybe<Scalars['String']>;
  /** Digital wallet used for the payment. */
  readonly wallet?: Maybe<DigitalWallet>;
};

/** Return type for `carrierServiceCreate` mutation. */
export type CarrierServiceCreatePayload = {
  /** The created carrier service. */
  readonly carrierService?: Maybe<DeliveryCarrierService>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CarrierServiceCreateUserError>;
};

/** An error that occurs during the execution of `CarrierServiceCreate`. */
export type CarrierServiceCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CarrierServiceCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CarrierServiceCreateUserError`. */
export enum CarrierServiceCreateUserErrorCode {
  /** Carrier service creation failed. */
  CARRIER_SERVICE_CREATE_FAILED = 'CARRIER_SERVICE_CREATE_FAILED'
}

/** Return type for `carrierServiceDelete` mutation. */
export type CarrierServiceDeletePayload = {
  /** The ID of the deleted carrier service. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CarrierServiceDeleteUserError>;
};

/** An error that occurs during the execution of `CarrierServiceDelete`. */
export type CarrierServiceDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CarrierServiceDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CarrierServiceDeleteUserError`. */
export enum CarrierServiceDeleteUserErrorCode {
  /** Carrier service deletion failed. */
  CARRIER_SERVICE_DELETE_FAILED = 'CARRIER_SERVICE_DELETE_FAILED'
}

/** The set of valid sort keys for the CarrierService query. */
export enum CarrierServiceSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Return type for `carrierServiceUpdate` mutation. */
export type CarrierServiceUpdatePayload = {
  /** The updated carrier service. */
  readonly carrierService?: Maybe<DeliveryCarrierService>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CarrierServiceUpdateUserError>;
};

/** An error that occurs during the execution of `CarrierServiceUpdate`. */
export type CarrierServiceUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CarrierServiceUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CarrierServiceUpdateUserError`. */
export enum CarrierServiceUpdateUserErrorCode {
  /** Carrier service update failed. */
  CARRIER_SERVICE_UPDATE_FAILED = 'CARRIER_SERVICE_UPDATE_FAILED'
}

/** A Cart Transform Function to create [Customized Bundles.](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle). */
export type CartTransform = HasMetafields & Node & {
  /** Whether a run failure will block cart and checkout operations. */
  readonly blockOnFailure: Scalars['Boolean'];
  /** The ID for the Cart Transform function. */
  readonly functionId: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
};


/** A Cart Transform Function to create [Customized Bundles.](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle). */
export type CartTransformMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A Cart Transform Function to create [Customized Bundles.](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle). */
export type CartTransformMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A Cart Transform Function to create [Customized Bundles.](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle). */
export type CartTransformPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A Cart Transform Function to create [Customized Bundles.](https://shopify.dev/docs/apps/selling-strategies/bundles/add-a-customized-bundle). */
export type CartTransformPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple CartTransforms. */
export type CartTransformConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CartTransformEdge>;
  /** A list of nodes that are contained in CartTransformEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CartTransform>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `cartTransformCreate` mutation. */
export type CartTransformCreatePayload = {
  /** The newly created cart transform function. */
  readonly cartTransform?: Maybe<CartTransform>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CartTransformCreateUserError>;
};

/** An error that occurs during the execution of `CartTransformCreate`. */
export type CartTransformCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CartTransformCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CartTransformCreateUserError`. */
export enum CartTransformCreateUserErrorCode {
  /** A cart transform function already exists for the provided function_id. */
  FUNCTION_ALREADY_REGISTERED = 'FUNCTION_ALREADY_REGISTERED',
  /** Function does not implement the required interface for this cart_transform function. */
  FUNCTION_DOES_NOT_IMPLEMENT = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** No Shopify Function found for provided function_id. */
  FUNCTION_NOT_FOUND = 'FUNCTION_NOT_FOUND',
  /** Failed to create cart transform due to invalid input. */
  INPUT_INVALID = 'INPUT_INVALID',
  /** Could not create or update metafields. */
  INVALID_METAFIELDS = 'INVALID_METAFIELDS'
}

/** Return type for `cartTransformDelete` mutation. */
export type CartTransformDeletePayload = {
  /** The globally-unique ID for the deleted cart transform. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CartTransformDeleteUserError>;
};

/** An error that occurs during the execution of `CartTransformDelete`. */
export type CartTransformDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CartTransformDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CartTransformDeleteUserError`. */
export enum CartTransformDeleteUserErrorCode {
  /** Could not find cart transform for provided id. */
  NOT_FOUND = 'NOT_FOUND',
  /** Unauthorized app scope. */
  UNAUTHORIZED_APP_SCOPE = 'UNAUTHORIZED_APP_SCOPE'
}

/** An auto-generated type which holds one CartTransform and a cursor during pagination. */
export type CartTransformEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CartTransformEdge. */
  readonly node: CartTransform;
};

/** Represents the cart transform feature configuration for the shop. */
export type CartTransformEligibleOperations = {
  /** The shop is eligible for expand operations. */
  readonly expandOperation: Scalars['Boolean'];
  /** The shop is eligible for merge operations. */
  readonly mergeOperation: Scalars['Boolean'];
  /** The shop is eligible for update operations. */
  readonly updateOperation: Scalars['Boolean'];
};

/** Represents the cart transform feature configuration for the shop. */
export type CartTransformFeature = {
  /** The cart transform operations eligible for the shop. */
  readonly eligibleOperations: CartTransformEligibleOperations;
};

/** The rounding adjustment applied to total payment or refund received for an Order involving cash payments. */
export type CashRoundingAdjustment = {
  /** The rounding adjustment that can be applied to totalReceived for an Order involving cash payments in shop and presentment currencies. Could be a positive or negative value. Value is 0 if there's no rounding, or for non-cash payments. */
  readonly paymentSet: MoneyBag;
  /** The rounding adjustment that can be applied to totalRefunded for an Order involving cash payments in shop and presentment currencies. Could be a positive or negative value. Value is 0 if there's no rounding, or for non-cash refunds. */
  readonly refundSet: MoneyBag;
};

/** Tracks an adjustment to the cash in a cash tracking session for a point of sale device over the course of a shift. */
export type CashTrackingAdjustment = Node & {
  /** The amount of cash being added or removed. */
  readonly cash: MoneyV2;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The note entered when the adjustment was made. */
  readonly note?: Maybe<Scalars['String']>;
  /** The staff member who made the adjustment. */
  readonly staffMember: StaffMember;
  /** The time when the adjustment was made. */
  readonly time: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple CashTrackingAdjustments. */
export type CashTrackingAdjustmentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CashTrackingAdjustmentEdge>;
  /** A list of nodes that are contained in CashTrackingAdjustmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CashTrackingAdjustment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CashTrackingAdjustment and a cursor during pagination. */
export type CashTrackingAdjustmentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CashTrackingAdjustmentEdge. */
  readonly node: CashTrackingAdjustment;
};

/** Tracks the balance in a cash drawer for a point of sale device over the course of a shift. */
export type CashTrackingSession = Node & {
  /** The adjustments made to the cash drawer during this session. */
  readonly adjustments: CashTrackingAdjustmentConnection;
  /** Whether this session is tracking cash payments. */
  readonly cashTrackingEnabled: Scalars['Boolean'];
  /** The cash transactions made during this session. */
  readonly cashTransactions: OrderTransactionConnection;
  /** The counted cash balance when the session was closed. */
  readonly closingBalance?: Maybe<MoneyV2>;
  /** The note entered when the session was closed. */
  readonly closingNote?: Maybe<Scalars['String']>;
  /** The user who closed the session. */
  readonly closingStaffMember?: Maybe<StaffMember>;
  /** When the session was closed. */
  readonly closingTime?: Maybe<Scalars['DateTime']>;
  /** The expected balance at the end of the session or the expected current balance for sessions that are still open. */
  readonly expectedBalance: MoneyV2;
  /** The amount that was expected to be in the cash drawer at the end of the session, calculated after the session was closed. */
  readonly expectedClosingBalance?: Maybe<MoneyV2>;
  /** The amount expected to be in the cash drawer based on the previous session. */
  readonly expectedOpeningBalance?: Maybe<MoneyV2>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The location of the point of sale device during this session. */
  readonly location?: Maybe<Location>;
  /** The net cash sales made for the duration of this cash tracking session. */
  readonly netCashSales: MoneyV2;
  /** The counted cash balance when the session was opened. */
  readonly openingBalance: MoneyV2;
  /** The note entered when the session was opened. */
  readonly openingNote?: Maybe<Scalars['String']>;
  /** The user who opened the session. */
  readonly openingStaffMember?: Maybe<StaffMember>;
  /** When the session was opened. */
  readonly openingTime: Scalars['DateTime'];
  /** The register name for the point of sale device that this session is tracking cash for. */
  readonly registerName: Scalars['String'];
  /** The sum of all adjustments made during the session, excluding the final adjustment. */
  readonly totalAdjustments?: Maybe<MoneyV2>;
  /** The sum of all cash refunds for the duration of this cash tracking session. */
  readonly totalCashRefunds: MoneyV2;
  /** The sum of all cash sales for the duration of this cash tracking session. */
  readonly totalCashSales: MoneyV2;
  /** The total discrepancy for the session including starting and ending. */
  readonly totalDiscrepancy?: Maybe<MoneyV2>;
};


/** Tracks the balance in a cash drawer for a point of sale device over the course of a shift. */
export type CashTrackingSessionAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<AdjustmentsSortKeys>;
};


/** Tracks the balance in a cash drawer for a point of sale device over the course of a shift. */
export type CashTrackingSessionCashTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CashTrackingSessionTransactionsSortKeys>;
};

/** An auto-generated type for paginating through multiple CashTrackingSessions. */
export type CashTrackingSessionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CashTrackingSessionEdge>;
  /** A list of nodes that are contained in CashTrackingSessionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CashTrackingSession>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CashTrackingSession and a cursor during pagination. */
export type CashTrackingSessionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CashTrackingSessionEdge. */
  readonly node: CashTrackingSession;
};

/** The set of valid sort keys for the CashTrackingSessionTransactions query. */
export enum CashTrackingSessionTransactionsSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `processed_at` value. */
  PROCESSED_AT = 'PROCESSED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The set of valid sort keys for the CashTrackingSessions query. */
export enum CashTrackingSessionsSortKeys {
  /** Sort by the `closing_time_asc` value. */
  CLOSING_TIME_ASC = 'CLOSING_TIME_ASC',
  /** Sort by the `closing_time_desc` value. */
  CLOSING_TIME_DESC = 'CLOSING_TIME_DESC',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `opening_time_asc` value. */
  OPENING_TIME_ASC = 'OPENING_TIME_ASC',
  /** Sort by the `opening_time_desc` value. */
  OPENING_TIME_DESC = 'OPENING_TIME_DESC',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `total_discrepancy_asc` value. */
  TOTAL_DISCREPANCY_ASC = 'TOTAL_DISCREPANCY_ASC',
  /** Sort by the `total_discrepancy_desc` value. */
  TOTAL_DISCREPANCY_DESC = 'TOTAL_DISCREPANCY_DESC'
}

/**
 * A list of products with publishing and pricing information.
 * A catalog can be associated with a specific context, such as a [`Market`](https://shopify.dev/api/admin-graphql/current/objects/market), [`CompanyLocation`](https://shopify.dev/api/admin-graphql/current/objects/companylocation), or [`App`](https://shopify.dev/api/admin-graphql/current/objects/app).
 */
export type Catalog = {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Most recent catalog operations. */
  readonly operations: ReadonlyArray<ResourceOperation>;
  /** The price list associated with the catalog. */
  readonly priceList?: Maybe<PriceList>;
  /** A group of products and collections that's published to a catalog. */
  readonly publication?: Maybe<Publication>;
  /** The status of the catalog. */
  readonly status: CatalogStatus;
  /** The name of the catalog. */
  readonly title: Scalars['String'];
};

/** An auto-generated type for paginating through multiple Catalogs. */
export type CatalogConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CatalogEdge>;
  /** A list of nodes that are contained in CatalogEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Catalog>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for the context in which the catalog's publishing and pricing rules apply. */
export type CatalogContextInput = {
  /** The IDs of the company locations to associate to the catalog. */
  readonly companyLocationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** Return type for `catalogContextUpdate` mutation. */
export type CatalogContextUpdatePayload = {
  /** The updated catalog. */
  readonly catalog?: Maybe<Catalog>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CatalogUserError>;
};

/** The input fields required to create a catalog. */
export type CatalogCreateInput = {
  /** The context associated with the catalog. */
  readonly context: CatalogContextInput;
  /** The ID of the price list to associate to the catalog. */
  readonly priceListId?: InputMaybe<Scalars['ID']>;
  /** The ID of the publication to associate to the catalog. */
  readonly publicationId?: InputMaybe<Scalars['ID']>;
  /** The status of the catalog. */
  readonly status: CatalogStatus;
  /** The name of the catalog. */
  readonly title: Scalars['String'];
};

/** Return type for `catalogCreate` mutation. */
export type CatalogCreatePayload = {
  /** The newly created catalog. */
  readonly catalog?: Maybe<Catalog>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CatalogUserError>;
};

/** A catalog csv operation represents a CSV file import. */
export type CatalogCsvOperation = Node & ResourceOperation & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The count of processed rows, summing imported, failed, and skipped rows. */
  readonly processedRowCount?: Maybe<Scalars['Int']>;
  /** Represents a rows objects within this background operation. */
  readonly rowCount?: Maybe<RowCount>;
  /** The status of this operation. */
  readonly status: ResourceOperationStatus;
};

/** Return type for `catalogDelete` mutation. */
export type CatalogDeletePayload = {
  /** The ID of the deleted catalog. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CatalogUserError>;
};

/** An auto-generated type which holds one Catalog and a cursor during pagination. */
export type CatalogEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CatalogEdge. */
  readonly node: Catalog;
};

/** The set of valid sort keys for the Catalog query. */
export enum CatalogSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE'
}

/** The state of a catalog. */
export enum CatalogStatus {
  /** The catalog is active. */
  ACTIVE = 'ACTIVE',
  /** The catalog is archived. */
  ARCHIVED = 'ARCHIVED',
  /** The catalog is in draft. */
  DRAFT = 'DRAFT'
}

/** The associated catalog's type. */
export enum CatalogType {
  /** Catalogs belonging to apps. */
  APP = 'APP',
  /** Catalogs belonging to company locations. */
  COMPANY_LOCATION = 'COMPANY_LOCATION',
  /** Catalogs belonging to markets. */
  MARKET = 'MARKET',
  /** Not associated to a catalog. */
  NONE = 'NONE'
}

/** The input fields used to update a catalog. */
export type CatalogUpdateInput = {
  /** The context associated with the catalog. */
  readonly context?: InputMaybe<CatalogContextInput>;
  /** The ID of the price list to associate to the catalog. */
  readonly priceListId?: InputMaybe<Scalars['ID']>;
  /** The ID of the publication to associate to the catalog. */
  readonly publicationId?: InputMaybe<Scalars['ID']>;
  /** The status of the catalog. */
  readonly status?: InputMaybe<CatalogStatus>;
  /** The name of the catalog. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `catalogUpdate` mutation. */
export type CatalogUpdatePayload = {
  /** The updated catalog. */
  readonly catalog?: Maybe<Catalog>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CatalogUserError>;
};

/** Defines errors encountered while managing a catalog. */
export type CatalogUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CatalogUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CatalogUserError`. */
export enum CatalogUserErrorCode {
  /** An app catalog cannot be assigned to a price list. */
  APP_CATALOG_PRICE_LIST_ASSIGNMENT = 'APP_CATALOG_PRICE_LIST_ASSIGNMENT',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The catalog can't be associated with more than one market. */
  CANNOT_ADD_MORE_THAN_ONE_MARKET = 'CANNOT_ADD_MORE_THAN_ONE_MARKET',
  /** Cannot create a catalog for an app. */
  CANNOT_CREATE_APP_CATALOG = 'CANNOT_CREATE_APP_CATALOG',
  /** Cannot create a catalog for a market. */
  CANNOT_CREATE_MARKET_CATALOG = 'CANNOT_CREATE_MARKET_CATALOG',
  /** Cannot delete a catalog for an app. */
  CANNOT_DELETE_APP_CATALOG = 'CANNOT_DELETE_APP_CATALOG',
  /** Cannot delete a catalog for a market. */
  CANNOT_DELETE_MARKET_CATALOG = 'CANNOT_DELETE_MARKET_CATALOG',
  /** Cannot modify a catalog for an app. */
  CANNOT_MODIFY_APP_CATALOG = 'CANNOT_MODIFY_APP_CATALOG',
  /** Cannot modify a catalog for a market. */
  CANNOT_MODIFY_MARKET_CATALOG = 'CANNOT_MODIFY_MARKET_CATALOG',
  /** Quantity price breaks can be associated only with company location catalogs or catalogs associated with compatible markets. */
  CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_PRICE_BREAKS = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_PRICE_BREAKS',
  /** Quantity rules can be associated only with company location catalogs or catalogs associated with compatible markets. */
  CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES',
  /** Catalog failed to save. */
  CATALOG_FAILED_TO_SAVE = 'CATALOG_FAILED_TO_SAVE',
  /** The catalog wasn't found. */
  CATALOG_NOT_FOUND = 'CATALOG_NOT_FOUND',
  /** A company location catalog outside of a supported plan can only have an archived status. */
  COMPANY_LOCATION_CATALOG_STATUS_PLAN = 'COMPANY_LOCATION_CATALOG_STATUS_PLAN',
  /** The company location could not be found. */
  COMPANY_LOCATION_NOT_FOUND = 'COMPANY_LOCATION_NOT_FOUND',
  /** Context driver already assigned to this catalog. */
  CONTEXT_ALREADY_ASSIGNED_TO_CATALOG = 'CONTEXT_ALREADY_ASSIGNED_TO_CATALOG',
  /** Cannot save the catalog because the catalog limit for the context was reached. */
  CONTEXT_CATALOG_LIMIT_REACHED = 'CONTEXT_CATALOG_LIMIT_REACHED',
  /** The arguments `contextsToAdd` and `contextsToRemove` must match existing catalog context type. */
  CONTEXT_DRIVER_MISMATCH = 'CONTEXT_DRIVER_MISMATCH',
  /** A country catalog cannot be assigned to a price list. */
  COUNTRY_CATALOG_PRICE_LIST_ASSIGNMENT = 'COUNTRY_CATALOG_PRICE_LIST_ASSIGNMENT',
  /** A country price list cannot be assigned to a catalog. */
  COUNTRY_PRICE_LIST_ASSIGNMENT = 'COUNTRY_PRICE_LIST_ASSIGNMENT',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The catalog context type is invalid. */
  INVALID_CATALOG_CONTEXT_TYPE = 'INVALID_CATALOG_CONTEXT_TYPE',
  /** Cannot change context to specified type. */
  INVALID_CONTEXT_CHANGE = 'INVALID_CONTEXT_CHANGE',
  /** The managed country belongs to another catalog. */
  MANAGED_COUNTRY_BELONGS_TO_ANOTHER_CATALOG = 'MANAGED_COUNTRY_BELONGS_TO_ANOTHER_CATALOG',
  /** The catalog's market and price list currencies do not match. */
  MARKET_AND_PRICE_LIST_CURRENCY_MISMATCH = 'MARKET_AND_PRICE_LIST_CURRENCY_MISMATCH',
  /** A market catalog must have an active status. */
  MARKET_CATALOG_STATUS = 'MARKET_CATALOG_STATUS',
  /** Market not found. */
  MARKET_NOT_FOUND = 'MARKET_NOT_FOUND',
  /** Market already belongs to another catalog. */
  MARKET_TAKEN = 'MARKET_TAKEN',
  /** Must provide exactly one context type. */
  MUST_PROVIDE_EXACTLY_ONE_CONTEXT_TYPE = 'MUST_PROVIDE_EXACTLY_ONE_CONTEXT_TYPE',
  /** Price list failed to save. */
  PRICE_LIST_FAILED_TO_SAVE = 'PRICE_LIST_FAILED_TO_SAVE',
  /** The price list is currently being modified. Please try again later. */
  PRICE_LIST_LOCKED = 'PRICE_LIST_LOCKED',
  /** A price list cannot be assigned to the primary market. */
  PRICE_LIST_NOT_ALLOWED_FOR_PRIMARY_MARKET = 'PRICE_LIST_NOT_ALLOWED_FOR_PRIMARY_MARKET',
  /** Price list not found. */
  PRICE_LIST_NOT_FOUND = 'PRICE_LIST_NOT_FOUND',
  /** Publication not found. */
  PUBLICATION_NOT_FOUND = 'PUBLICATION_NOT_FOUND',
  /** Must have `contexts_to_add` or `contexts_to_remove` argument. */
  REQUIRES_CONTEXTS_TO_ADD_OR_REMOVE = 'REQUIRES_CONTEXTS_TO_ADD_OR_REMOVE',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** Managing this catalog is not supported by your plan. */
  UNPERMITTED_ENTITLEMENTS_MARKET_CATALOGS = 'UNPERMITTED_ENTITLEMENTS_MARKET_CATALOGS',
  /** Can't perform this action on a catalog of this type. */
  UNSUPPORTED_CATALOG_ACTION = 'UNSUPPORTED_CATALOG_ACTION'
}

/**
 * A channel represents an app where you sell a group of products and collections.
 * A channel can be a platform or marketplace such as Facebook or Pinterest, an online store, or POS.
 */
export type Channel = Node & {
  /** The underlying app used by the channel. */
  readonly app: App;
  /** The collection publications for the list of collections published to the channel. */
  readonly collectionPublicationsV3: ResourcePublicationConnection;
  /** The list of collections published to the channel. */
  readonly collections: CollectionConnection;
  /**
   * The unique identifier for the channel.
   * @deprecated Use `id` instead.
   */
  readonly handle: Scalars['String'];
  /** Whether the collection is available to the channel. */
  readonly hasCollection: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the channel. */
  readonly name: Scalars['String'];
  /**
   * The menu items for the channel, which also appear as submenu items in the left navigation sidebar in the Shopify admin.
   * @deprecated Use [AppInstallation.navigationItems](
   *           https://shopify.dev/api/admin-graphql/current/objects/AppInstallation#field-appinstallation-navigationitems) instead.
   */
  readonly navigationItems: ReadonlyArray<NavigationItem>;
  /**
   * Home page for the channel.
   * @deprecated Use [AppInstallation.launchUrl](
   *           https://shopify.dev/api/admin-graphql/current/objects/AppInstallation#field-appinstallation-launchurl) instead.
   */
  readonly overviewPath?: Maybe<Scalars['URL']>;
  /**
   * The product publications for the products published to the channel.
   * @deprecated Use `productPublicationsV3` instead.
   */
  readonly productPublications: ProductPublicationConnection;
  /** The product publications for the list of products published to the channel. */
  readonly productPublicationsV3: ResourcePublicationConnection;
  /** The list of products published to the channel. */
  readonly products: ProductConnection;
  /** The count of products published to the channel. Limited to a maximum of 10000. */
  readonly productsCount?: Maybe<Count>;
  /** Whether the channel supports future publishing. */
  readonly supportsFuturePublishing: Scalars['Boolean'];
};


/**
 * A channel represents an app where you sell a group of products and collections.
 * A channel can be a platform or marketplace such as Facebook or Pinterest, an online store, or POS.
 */
export type ChannelCollectionPublicationsV3Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A channel represents an app where you sell a group of products and collections.
 * A channel can be a platform or marketplace such as Facebook or Pinterest, an online store, or POS.
 */
export type ChannelCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A channel represents an app where you sell a group of products and collections.
 * A channel can be a platform or marketplace such as Facebook or Pinterest, an online store, or POS.
 */
export type ChannelHasCollectionArgs = {
  id: Scalars['ID'];
};


/**
 * A channel represents an app where you sell a group of products and collections.
 * A channel can be a platform or marketplace such as Facebook or Pinterest, an online store, or POS.
 */
export type ChannelProductPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A channel represents an app where you sell a group of products and collections.
 * A channel can be a platform or marketplace such as Facebook or Pinterest, an online store, or POS.
 */
export type ChannelProductPublicationsV3Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A channel represents an app where you sell a group of products and collections.
 * A channel can be a platform or marketplace such as Facebook or Pinterest, an online store, or POS.
 */
export type ChannelProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A channel represents an app where you sell a group of products and collections.
 * A channel can be a platform or marketplace such as Facebook or Pinterest, an online store, or POS.
 */
export type ChannelProductsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};

/** An auto-generated type for paginating through multiple Channels. */
export type ChannelConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ChannelEdge>;
  /** A list of nodes that are contained in ChannelEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Channel>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/**
 * A channel definition represents channels surfaces on the platform.
 * A channel definition can be a platform or a subsegment of it such as Facebook Home, Instagram Live, Instagram Shops, or WhatsApp chat.
 */
export type ChannelDefinition = Node & {
  /** Name of the channel that this sub channel belongs to. */
  readonly channelName: Scalars['String'];
  /** Unique string used as a public identifier for the channel definition. */
  readonly handle: Scalars['String'];
  /** The unique ID for the channel definition. */
  readonly id: Scalars['ID'];
  /** Whether this channel definition represents a marketplace. */
  readonly isMarketplace: Scalars['Boolean'];
  /** Name of the sub channel (e.g. Online Store, Instagram Shopping, TikTok Live). */
  readonly subChannelName: Scalars['String'];
  /** Icon displayed when showing the channel in admin. */
  readonly svgIcon?: Maybe<Scalars['String']>;
};

/** An auto-generated type which holds one Channel and a cursor during pagination. */
export type ChannelEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ChannelEdge. */
  readonly node: Channel;
};

/** Contains the information for a given sales channel. */
export type ChannelInformation = Node & {
  /** The app associated with the channel. */
  readonly app: App;
  /** The channel definition associated with the channel. */
  readonly channelDefinition?: Maybe<ChannelDefinition>;
  /** The unique ID for the channel. */
  readonly channelId: Scalars['ID'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
};

/**
 * The settings of checkout visual customizations.
 *
 * To learn more about updating checkout branding settings, refer to the
 * [checkoutBrandingUpsert](https://shopify.dev/api/admin-graphql/unstable/mutations/checkoutBrandingUpsert) mutation.
 */
export type CheckoutBranding = {
  /** The customizations that apply to specific components or areas of the user interface. */
  readonly customizations?: Maybe<CheckoutBrandingCustomizations>;
  /**
   * The design system allows you to set values that represent specific attributes
   * of your brand like color and font. These attributes are used throughout the user
   * interface. This brings consistency and allows you to easily make broad design changes.
   */
  readonly designSystem?: Maybe<CheckoutBrandingDesignSystem>;
};

/** The container background style. */
export enum CheckoutBrandingBackground {
  /** The Base background style. */
  BASE = 'BASE',
  /** The Subdued background style. */
  SUBDUED = 'SUBDUED',
  /** The Transparent background style. */
  TRANSPARENT = 'TRANSPARENT'
}

/** Possible values for the background style. */
export enum CheckoutBrandingBackgroundStyle {
  /** The None background style. */
  NONE = 'NONE',
  /** The Solid background style. */
  SOLID = 'SOLID'
}

/** Possible values for the border. */
export enum CheckoutBrandingBorder {
  /** The Block End border. */
  BLOCK_END = 'BLOCK_END',
  /** The Full border. */
  FULL = 'FULL',
  /** The None border. */
  NONE = 'NONE'
}

/** The container border style. */
export enum CheckoutBrandingBorderStyle {
  /** The Base border style. */
  BASE = 'BASE',
  /** The Dashed border style. */
  DASHED = 'DASHED',
  /** The Dotted border style. */
  DOTTED = 'DOTTED'
}

/** The container border width. */
export enum CheckoutBrandingBorderWidth {
  /** The Base border width. */
  BASE = 'BASE',
  /** The Large border width. */
  LARGE = 'LARGE',
  /** The Large 100 border width. */
  LARGE_100 = 'LARGE_100',
  /** The Large 200 border width. */
  LARGE_200 = 'LARGE_200'
}

/** The buttons customizations. */
export type CheckoutBrandingButton = {
  /** The background style used for buttons. */
  readonly background?: Maybe<CheckoutBrandingBackgroundStyle>;
  /** The block padding used for buttons. */
  readonly blockPadding?: Maybe<CheckoutBrandingSpacing>;
  /** The border used for buttons. */
  readonly border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** The corner radius used for buttons. */
  readonly cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The inline padding used for buttons. */
  readonly inlinePadding?: Maybe<CheckoutBrandingSpacing>;
  /** The typography used for buttons. */
  readonly typography?: Maybe<CheckoutBrandingTypographyStyle>;
};

/** Colors for buttons. */
export type CheckoutBrandingButtonColorRoles = {
  /** The color of accented objects (links and focused state). */
  readonly accent?: Maybe<Scalars['String']>;
  /** The color of the background. */
  readonly background?: Maybe<Scalars['String']>;
  /** The color of borders. */
  readonly border?: Maybe<Scalars['String']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  readonly decorative?: Maybe<Scalars['String']>;
  /** The colors of the button on hover. */
  readonly hover?: Maybe<CheckoutBrandingColorRoles>;
  /** The color of icons. */
  readonly icon?: Maybe<Scalars['String']>;
  /** The color of text. */
  readonly text?: Maybe<Scalars['String']>;
};

/** The input fields to set colors for buttons. */
export type CheckoutBrandingButtonColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  readonly accent?: InputMaybe<Scalars['String']>;
  /** The color of the background. */
  readonly background?: InputMaybe<Scalars['String']>;
  /** The color of borders. */
  readonly border?: InputMaybe<Scalars['String']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  readonly decorative?: InputMaybe<Scalars['String']>;
  /** The colors of the button on hover. */
  readonly hover?: InputMaybe<CheckoutBrandingColorRolesInput>;
  /** The color of icons. */
  readonly icon?: InputMaybe<Scalars['String']>;
  /** The color of text. */
  readonly text?: InputMaybe<Scalars['String']>;
};

/** The input fields used to update the buttons customizations. */
export type CheckoutBrandingButtonInput = {
  /** The background style used for buttons. */
  readonly background?: InputMaybe<CheckoutBrandingBackgroundStyle>;
  /** The block padding used for buttons. */
  readonly blockPadding?: InputMaybe<CheckoutBrandingSpacing>;
  /** The border used for buttons. */
  readonly border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** The corner radius used for buttons. */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The inline padding used for buttons. */
  readonly inlinePadding?: InputMaybe<CheckoutBrandingSpacing>;
  /** The typography style used for buttons. */
  readonly typography?: InputMaybe<CheckoutBrandingTypographyStyleInput>;
};

/** The customizations for the breadcrumbs that represent a buyer's journey to the checkout. */
export type CheckoutBrandingBuyerJourney = {
  /** An option to display or hide the breadcrumbs that represent the buyer's journey on 3-page checkout. */
  readonly visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** The input fields for updating breadcrumb customizations, which represent the buyer's journey to checkout. */
export type CheckoutBrandingBuyerJourneyInput = {
  /** The visibility customizations for updating breadcrumbs, which represent the buyer's journey to checkout. */
  readonly visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/** The customizations that you can make to cart links at checkout. */
export type CheckoutBrandingCartLink = {
  /** Whether the cart link is visible at checkout. */
  readonly visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** Possible values for the cart link content type for the header. */
export enum CheckoutBrandingCartLinkContentType {
  /** The checkout header content type icon value. */
  ICON = 'ICON',
  /** The checkout header content type image value. */
  IMAGE = 'IMAGE',
  /** The checkout header content type text value. */
  TEXT = 'TEXT'
}

/** The input fields for updating the cart link customizations at checkout. */
export type CheckoutBrandingCartLinkInput = {
  /** The input to update the visibility of cart links in checkout. This hides the cart icon on one-page and the cart link in the breadcrumbs/buyer journey on three-page checkout. */
  readonly visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/** The checkboxes customizations. */
export type CheckoutBrandingCheckbox = {
  /** The corner radius used for checkboxes. */
  readonly cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
};

/** The input fields used to update the checkboxes customizations. */
export type CheckoutBrandingCheckboxInput = {
  /** The corner radius used for checkboxes. */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
};

/** The choice list customizations. */
export type CheckoutBrandingChoiceList = {
  /** The settings that apply to the 'group' variant of ChoiceList. */
  readonly group?: Maybe<CheckoutBrandingChoiceListGroup>;
};

/** The settings that apply to the 'group' variant of ChoiceList. */
export type CheckoutBrandingChoiceListGroup = {
  /** The spacing between UI elements in the list. */
  readonly spacing?: Maybe<CheckoutBrandingSpacingKeyword>;
};

/** The input fields to update the settings that apply to the 'group' variant of ChoiceList. */
export type CheckoutBrandingChoiceListGroupInput = {
  /** The spacing between UI elements in the list. */
  readonly spacing?: InputMaybe<CheckoutBrandingSpacingKeyword>;
};

/** The input fields to use to update the choice list customizations. */
export type CheckoutBrandingChoiceListInput = {
  /** The settings that apply to the 'group' variant of ChoiceList. */
  readonly group?: InputMaybe<CheckoutBrandingChoiceListGroupInput>;
};

/** A set of colors for customizing the overall look and feel of the checkout. */
export type CheckoutBrandingColorGlobal = {
  /** A color used for interaction, like links and focus states. */
  readonly accent?: Maybe<Scalars['String']>;
  /**
   * A color that's strongly associated with the merchant. Currently used for
   * primary buttons, for example **Pay now**, and secondary buttons, for example **Buy again**.
   */
  readonly brand?: Maybe<Scalars['String']>;
  /** A semantic color used for components that communicate critical content. For example, a blocking error such as the requirement to enter a valid credit card number. */
  readonly critical?: Maybe<Scalars['String']>;
  /** A color used to highlight certain areas of the user interface. For example, the [`Text`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/titles-and-text/text#textprops-propertydetail-appearance) component. */
  readonly decorative?: Maybe<Scalars['String']>;
  /** A semantic color used for components that communicate general, informative content. */
  readonly info?: Maybe<Scalars['String']>;
  /** A semantic color used for components that communicate successful actions or a positive state. */
  readonly success?: Maybe<Scalars['String']>;
  /** A semantic color used for components that display content that requires attention. For example, something that might be wrong, but not blocking. */
  readonly warning?: Maybe<Scalars['String']>;
};

/** The input fields to customize the overall look and feel of the checkout. */
export type CheckoutBrandingColorGlobalInput = {
  /** A color used for interaction, like links and focus states. */
  readonly accent?: InputMaybe<Scalars['String']>;
  /**
   * A color that's strongly associated with the merchant. Currently used for
   * primary buttons, such as **Pay now**, and secondary buttons, such as **Buy again**.
   */
  readonly brand?: InputMaybe<Scalars['String']>;
  /** A semantic color used for components that communicate critical content. For example, a blocking error such as the requirement to enter a valid credit card number. */
  readonly critical?: InputMaybe<Scalars['String']>;
  /** A color used to highlight certain areas of the user interface. For example, the [`Text`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/titles-and-text/text#textprops-propertydetail-appearance) component. */
  readonly decorative?: InputMaybe<Scalars['String']>;
  /** A semantic color used for components that communicate general, informative content. */
  readonly info?: InputMaybe<Scalars['String']>;
  /** A semantic color used for components that communicate successful actions or a positive state. */
  readonly success?: InputMaybe<Scalars['String']>;
  /** A semantic color used for components that display content that requires attention. For example, something that might be wrong, but not blocking. */
  readonly warning?: InputMaybe<Scalars['String']>;
};

/** A group of colors used together on a surface. */
export type CheckoutBrandingColorRoles = {
  /** The color of accented objects (links and focused state). */
  readonly accent?: Maybe<Scalars['String']>;
  /** The color of the background. */
  readonly background?: Maybe<Scalars['String']>;
  /** The color of borders. */
  readonly border?: Maybe<Scalars['String']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  readonly decorative?: Maybe<Scalars['String']>;
  /** The color of icons. */
  readonly icon?: Maybe<Scalars['String']>;
  /** The color of text. */
  readonly text?: Maybe<Scalars['String']>;
};

/** The input fields for a group of colors used together on a surface. */
export type CheckoutBrandingColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  readonly accent?: InputMaybe<Scalars['String']>;
  /** The color of the background. */
  readonly background?: InputMaybe<Scalars['String']>;
  /** The color of borders. */
  readonly border?: InputMaybe<Scalars['String']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  readonly decorative?: InputMaybe<Scalars['String']>;
  /** The color of icons. */
  readonly icon?: InputMaybe<Scalars['String']>;
  /** The color of text. */
  readonly text?: InputMaybe<Scalars['String']>;
};

/**
 * A base set of color customizations that's applied to an area of Checkout, from which every component
 * pulls its colors.
 */
export type CheckoutBrandingColorScheme = {
  /** The main colors of a scheme. Used for the surface background, text, links, and more. */
  readonly base?: Maybe<CheckoutBrandingColorRoles>;
  /** The colors of form controls, such as the [`TextField`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/textfield) and [`ChoiceList`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/choicelist) components. */
  readonly control?: Maybe<CheckoutBrandingControlColorRoles>;
  /** The colors of the primary button. For example, the main payment, or **Pay now** button. */
  readonly primaryButton?: Maybe<CheckoutBrandingButtonColorRoles>;
  /** The colors of the secondary button, which is used for secondary actions. For example, **Buy again**. */
  readonly secondaryButton?: Maybe<CheckoutBrandingButtonColorRoles>;
};

/**
 * The input fields for a base set of color customizations that's applied to an area of Checkout, from which
 * every component pulls its colors.
 */
export type CheckoutBrandingColorSchemeInput = {
  /** The main colors of a scheme. Used for the surface background, text, links, and more. */
  readonly base?: InputMaybe<CheckoutBrandingColorRolesInput>;
  /** The colors of form controls, such as the [`TextField`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/textfield) and [`ChoiceList`](https://shopify.dev/docs/api/checkout-ui-extensions/latest/components/forms/choicelist) components. */
  readonly control?: InputMaybe<CheckoutBrandingControlColorRolesInput>;
  /** The colors of the primary button. For example, the main payment, or **Pay now** button. */
  readonly primaryButton?: InputMaybe<CheckoutBrandingButtonColorRolesInput>;
  /** The colors of the secondary button, which is used for secondary actions. For example, **Buy again**. */
  readonly secondaryButton?: InputMaybe<CheckoutBrandingButtonColorRolesInput>;
};

/** The possible color schemes. */
export enum CheckoutBrandingColorSchemeSelection {
  /** The COLOR_SCHEME1 color scheme selection. */
  COLOR_SCHEME1 = 'COLOR_SCHEME1',
  /** The COLOR_SCHEME2 color scheme selection. */
  COLOR_SCHEME2 = 'COLOR_SCHEME2',
  /** The COLOR_SCHEME3 color scheme selection. */
  COLOR_SCHEME3 = 'COLOR_SCHEME3',
  /** The COLOR_SCHEME4 color scheme selection. */
  COLOR_SCHEME4 = 'COLOR_SCHEME4',
  /** The TRANSPARENT color scheme selection. */
  TRANSPARENT = 'TRANSPARENT'
}

/** The color schemes. */
export type CheckoutBrandingColorSchemes = {
  /** The primary scheme. By default, it’s used for the main area of the interface. */
  readonly scheme1?: Maybe<CheckoutBrandingColorScheme>;
  /** The secondary scheme. By default, it’s used for secondary areas, like Checkout’s Order Summary. */
  readonly scheme2?: Maybe<CheckoutBrandingColorScheme>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  readonly scheme3?: Maybe<CheckoutBrandingColorScheme>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  readonly scheme4?: Maybe<CheckoutBrandingColorScheme>;
};

/** The input fields for the color schemes. */
export type CheckoutBrandingColorSchemesInput = {
  /** The primary scheme. By default, it’s used for the main area of the interface. */
  readonly scheme1?: InputMaybe<CheckoutBrandingColorSchemeInput>;
  /** The secondary scheme. By default, it’s used for secondary areas, like Checkout’s Order Summary. */
  readonly scheme2?: InputMaybe<CheckoutBrandingColorSchemeInput>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  readonly scheme3?: InputMaybe<CheckoutBrandingColorSchemeInput>;
  /** An extra scheme available to customize more surfaces, components or specific states of the user interface. */
  readonly scheme4?: InputMaybe<CheckoutBrandingColorSchemeInput>;
};

/** The possible colors. */
export enum CheckoutBrandingColorSelection {
  /** Transparent color selection. */
  TRANSPARENT = 'TRANSPARENT'
}

/** The color settings for global colors and color schemes. */
export type CheckoutBrandingColors = {
  /** A group of global colors for customizing the overall look and feel of the user interface. */
  readonly global?: Maybe<CheckoutBrandingColorGlobal>;
  /** A set of color schemes which apply to different areas of the user interface. */
  readonly schemes?: Maybe<CheckoutBrandingColorSchemes>;
};

/** The input fields used to update the color settings for global colors and color schemes. */
export type CheckoutBrandingColorsInput = {
  /** The input to update global colors for customizing the overall look and feel of the user interface. */
  readonly global?: InputMaybe<CheckoutBrandingColorGlobalInput>;
  /** The input to define color schemes which apply to different areas of the user interface. */
  readonly schemes?: InputMaybe<CheckoutBrandingColorSchemesInput>;
};

/** The container's divider customizations. */
export type CheckoutBrandingContainerDivider = {
  /** The divider style. */
  readonly borderStyle?: Maybe<CheckoutBrandingBorderStyle>;
  /** The divider width. */
  readonly borderWidth?: Maybe<CheckoutBrandingBorderWidth>;
  /** The divider visibility. */
  readonly visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** The input fields used to update a container's divider customizations. */
export type CheckoutBrandingContainerDividerInput = {
  /** The divider style. */
  readonly borderStyle?: InputMaybe<CheckoutBrandingBorderStyle>;
  /** The divider width. */
  readonly borderWidth?: InputMaybe<CheckoutBrandingBorderWidth>;
  /** The divider visibility. */
  readonly visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/** The content container customizations. */
export type CheckoutBrandingContent = {
  /** The content container's divider style and visibility. */
  readonly divider?: Maybe<CheckoutBrandingContainerDivider>;
};

/** The input fields used to update the content container customizations. */
export type CheckoutBrandingContentInput = {
  /** Divider style and visibility on the content container. */
  readonly divider?: InputMaybe<CheckoutBrandingContainerDividerInput>;
};

/** The form controls customizations. */
export type CheckoutBrandingControl = {
  /** The border used for form controls. */
  readonly border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** Set to TRANSPARENT to define transparent form controls. If null, form controls inherit colors from their scheme settings (for example, the main section inherits from `design_system.colors.schemes.scheme1.control` by default). Note that usage of the `customizations.control.color` setting to customize the form control color is deprecated. */
  readonly color?: Maybe<CheckoutBrandingColorSelection>;
  /** The corner radius used for form controls. */
  readonly cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The label position used for form controls. */
  readonly labelPosition?: Maybe<CheckoutBrandingLabelPosition>;
};

/** Colors for form controls. */
export type CheckoutBrandingControlColorRoles = {
  /** The color of accented objects (links and focused state). */
  readonly accent?: Maybe<Scalars['String']>;
  /** The color of the background. */
  readonly background?: Maybe<Scalars['String']>;
  /** The color of borders. */
  readonly border?: Maybe<Scalars['String']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  readonly decorative?: Maybe<Scalars['String']>;
  /** The color of icons. */
  readonly icon?: Maybe<Scalars['String']>;
  /** The colors of selected controls. */
  readonly selected?: Maybe<CheckoutBrandingColorRoles>;
  /** The color of text. */
  readonly text?: Maybe<Scalars['String']>;
};

/** The input fields to define colors for form controls. */
export type CheckoutBrandingControlColorRolesInput = {
  /** The color of accented objects (links and focused state). */
  readonly accent?: InputMaybe<Scalars['String']>;
  /** The color of the background. */
  readonly background?: InputMaybe<Scalars['String']>;
  /** The color of borders. */
  readonly border?: InputMaybe<Scalars['String']>;
  /** The decorative color for highlighting specific parts of the user interface. */
  readonly decorative?: InputMaybe<Scalars['String']>;
  /** The color of icons. */
  readonly icon?: InputMaybe<Scalars['String']>;
  /** The colors of selected controls. */
  readonly selected?: InputMaybe<CheckoutBrandingColorRolesInput>;
  /** The color of text. */
  readonly text?: InputMaybe<Scalars['String']>;
};

/** The input fields used to update the form controls customizations. */
export type CheckoutBrandingControlInput = {
  /** The border used for form controls. */
  readonly border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** Set to TRANSPARENT to define transparent form controls. If null, form controls inherit colors from their scheme settings (for example, the main section inherits from `design_system.colors.schemes.scheme1.control` by default). Note that usage of the `customizations.control.color` setting to customize the form control color is deprecated. */
  readonly color?: InputMaybe<CheckoutBrandingColorSelection>;
  /** The corner radius used for form controls. */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The label position used for form controls. */
  readonly labelPosition?: InputMaybe<CheckoutBrandingLabelPosition>;
};

/**
 * The options for customizing the corner radius of checkout-related objects. Examples include the primary
 * button, the name text fields and the sections within the main area (if they have borders).
 * Refer to this complete [list](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutBrandingCornerRadius#fieldswith)
 * for objects with customizable corner radii.
 *
 * The design system defines the corner radius pixel size for each option. Modify the defaults by setting the
 * [designSystem.cornerRadius](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CheckoutBrandingDesignSystemInput#field-checkoutbrandingdesignsysteminput-cornerradius)
 * input fields.
 */
export enum CheckoutBrandingCornerRadius {
  /** The corner radius with a pixel value defined by designSystem.cornerRadius.base. */
  BASE = 'BASE',
  /** The corner radius with a pixel value defined by designSystem.cornerRadius.large. */
  LARGE = 'LARGE',
  /** The 0px corner radius (square corners). */
  NONE = 'NONE',
  /** The corner radius with a pixel value defined by designSystem.cornerRadius.small. */
  SMALL = 'SMALL'
}

/** Define the pixel size of corner radius options. */
export type CheckoutBrandingCornerRadiusVariables = {
  /** The value in pixels for base corner radii. Example: 5. */
  readonly base?: Maybe<Scalars['Int']>;
  /** The value in pixels for large corner radii. Example: 10. */
  readonly large?: Maybe<Scalars['Int']>;
  /** The value in pixels for small corner radii. Example: 3. */
  readonly small?: Maybe<Scalars['Int']>;
};

/** The input fields used to update the corner radius variables. */
export type CheckoutBrandingCornerRadiusVariablesInput = {
  /** The value in pixels for base corner radii. It should be greater than zero. Example: 5. */
  readonly base?: InputMaybe<Scalars['Int']>;
  /** The value in pixels for large corner radii. It should be greater than zero. Example: 10. */
  readonly large?: InputMaybe<Scalars['Int']>;
  /** The value in pixels for small corner radii. It should be greater than zero. Example: 3. */
  readonly small?: InputMaybe<Scalars['Int']>;
};

/** A custom font. */
export type CheckoutBrandingCustomFont = CheckoutBrandingFont & {
  /** Globally unique ID reference to the custom font file. */
  readonly genericFileId?: Maybe<Scalars['ID']>;
  /** The font sources. */
  readonly sources?: Maybe<Scalars['String']>;
  /** The font weight. */
  readonly weight?: Maybe<Scalars['Int']>;
};

/** The input fields required to update a custom font group. */
export type CheckoutBrandingCustomFontGroupInput = {
  /** The base font. */
  readonly base: CheckoutBrandingCustomFontInput;
  /** The bold font. */
  readonly bold: CheckoutBrandingCustomFontInput;
  /** The font loading strategy. */
  readonly loadingStrategy?: InputMaybe<CheckoutBrandingFontLoadingStrategy>;
};

/** The input fields required to update a font. */
export type CheckoutBrandingCustomFontInput = {
  /**
   * A globally-unique ID for a font file uploaded via the Files api.
   * Allowed font types are .woff and .woff2.
   */
  readonly genericFileId: Scalars['ID'];
  /** The font weight. Its value should be between 100 and 900. */
  readonly weight: Scalars['Int'];
};

/** The customizations that apply to specific components or areas of the user interface. */
export type CheckoutBrandingCustomizations = {
  /** The customizations for the breadcrumbs that represent a buyer's journey to the checkout. */
  readonly buyerJourney?: Maybe<CheckoutBrandingBuyerJourney>;
  /** The checkout cart link customizations. For example, by setting the visibility field to `HIDDEN`, you can hide the cart icon in the header for one-page checkout, and the cart link in breadcrumbs in three-page checkout. */
  readonly cartLink?: Maybe<CheckoutBrandingCartLink>;
  /** The checkboxes customizations. */
  readonly checkbox?: Maybe<CheckoutBrandingCheckbox>;
  /** The choice list customizations. */
  readonly choiceList?: Maybe<CheckoutBrandingChoiceList>;
  /** The content container customizations. */
  readonly content?: Maybe<CheckoutBrandingContent>;
  /** The form controls customizations. */
  readonly control?: Maybe<CheckoutBrandingControl>;
  /** The customizations for the page, content, main, and order summary dividers. For example, by setting the borderStyle to `DOTTED`, you can make these dividers render as dotted lines. */
  readonly divider?: Maybe<CheckoutBrandingDividerStyle>;
  /** The express checkout customizations. */
  readonly expressCheckout?: Maybe<CheckoutBrandingExpressCheckout>;
  /** The favicon image. */
  readonly favicon?: Maybe<CheckoutBrandingImage>;
  /** The footer customizations. */
  readonly footer?: Maybe<CheckoutBrandingFooter>;
  /** The global customizations. */
  readonly global?: Maybe<CheckoutBrandingGlobal>;
  /** The header customizations. */
  readonly header?: Maybe<CheckoutBrandingHeader>;
  /** The Heading Level 1 customizations. */
  readonly headingLevel1?: Maybe<CheckoutBrandingHeadingLevel>;
  /** The Heading Level 2 customizations. */
  readonly headingLevel2?: Maybe<CheckoutBrandingHeadingLevel>;
  /** The Heading Level 3 customizations. */
  readonly headingLevel3?: Maybe<CheckoutBrandingHeadingLevel>;
  /** The main area customizations. */
  readonly main?: Maybe<CheckoutBrandingMain>;
  /** The merchandise thumbnails customizations. */
  readonly merchandiseThumbnail?: Maybe<CheckoutBrandingMerchandiseThumbnail>;
  /** The order summary customizations. */
  readonly orderSummary?: Maybe<CheckoutBrandingOrderSummary>;
  /** The primary buttons customizations. */
  readonly primaryButton?: Maybe<CheckoutBrandingButton>;
  /** The secondary buttons customizations. */
  readonly secondaryButton?: Maybe<CheckoutBrandingButton>;
  /** The selects customizations. */
  readonly select?: Maybe<CheckoutBrandingSelect>;
  /** The text fields customizations. */
  readonly textField?: Maybe<CheckoutBrandingTextField>;
};

/** The input fields used to update the components customizations. */
export type CheckoutBrandingCustomizationsInput = {
  /** The customizations for the breadcrumbs that represent a buyer's journey to the checkout. */
  readonly buyerJourney?: InputMaybe<CheckoutBrandingBuyerJourneyInput>;
  /** The input for checkout cart link customizations. For example, by setting the visibility field to `HIDDEN`, you can hide the cart icon in the header for one-page checkout, and the cart link in breadcrumbs in three-page checkout. */
  readonly cartLink?: InputMaybe<CheckoutBrandingCartLinkInput>;
  /** The checkboxes customizations. */
  readonly checkbox?: InputMaybe<CheckoutBrandingCheckboxInput>;
  /** The choice list customizations. */
  readonly choiceList?: InputMaybe<CheckoutBrandingChoiceListInput>;
  /** The content container customizations. */
  readonly content?: InputMaybe<CheckoutBrandingContentInput>;
  /** The form controls customizations. */
  readonly control?: InputMaybe<CheckoutBrandingControlInput>;
  /** The input for the page, content, main, and order summary dividers customizations. For example, by setting the borderStyle to `DOTTED`, you can make these dividers render as dotted lines. */
  readonly divider?: InputMaybe<CheckoutBrandingDividerStyleInput>;
  /** The express checkout customizations. */
  readonly expressCheckout?: InputMaybe<CheckoutBrandingExpressCheckoutInput>;
  /** The favicon image (must be of PNG format). */
  readonly favicon?: InputMaybe<CheckoutBrandingImageInput>;
  /** The footer customizations. */
  readonly footer?: InputMaybe<CheckoutBrandingFooterInput>;
  /** The global customizations. */
  readonly global?: InputMaybe<CheckoutBrandingGlobalInput>;
  /** The header customizations. */
  readonly header?: InputMaybe<CheckoutBrandingHeaderInput>;
  /** The Heading Level 1 customizations. */
  readonly headingLevel1?: InputMaybe<CheckoutBrandingHeadingLevelInput>;
  /** The Heading Level 2 customizations. */
  readonly headingLevel2?: InputMaybe<CheckoutBrandingHeadingLevelInput>;
  /** The Heading Level 3 customizations. */
  readonly headingLevel3?: InputMaybe<CheckoutBrandingHeadingLevelInput>;
  /** The main area customizations. */
  readonly main?: InputMaybe<CheckoutBrandingMainInput>;
  /** The merchandise thumbnails customizations. */
  readonly merchandiseThumbnail?: InputMaybe<CheckoutBrandingMerchandiseThumbnailInput>;
  /** The order summary customizations. */
  readonly orderSummary?: InputMaybe<CheckoutBrandingOrderSummaryInput>;
  /** The primary buttons customizations. */
  readonly primaryButton?: InputMaybe<CheckoutBrandingButtonInput>;
  /** The secondary buttons customizations. */
  readonly secondaryButton?: InputMaybe<CheckoutBrandingButtonInput>;
  /** The selects customizations. */
  readonly select?: InputMaybe<CheckoutBrandingSelectInput>;
  /** The text fields customizations. */
  readonly textField?: InputMaybe<CheckoutBrandingTextFieldInput>;
};

/**
 * The design system allows you to set values that represent specific attributes
 * of your brand like color and font. These attributes are used throughout the user
 * interface. This brings consistency and allows you to easily make broad design changes.
 */
export type CheckoutBrandingDesignSystem = {
  /** The color settings for global colors and color schemes. */
  readonly colors?: Maybe<CheckoutBrandingColors>;
  /** The corner radius variables. */
  readonly cornerRadius?: Maybe<CheckoutBrandingCornerRadiusVariables>;
  /** The typography. */
  readonly typography?: Maybe<CheckoutBrandingTypography>;
};

/** The input fields used to update the design system. */
export type CheckoutBrandingDesignSystemInput = {
  /** The color settings for global colors and color schemes. */
  readonly colors?: InputMaybe<CheckoutBrandingColorsInput>;
  /** The corner radius variables. */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingCornerRadiusVariablesInput>;
  /** The typography. */
  readonly typography?: InputMaybe<CheckoutBrandingTypographyInput>;
};

/** The customizations for the page, content, main, and order summary dividers. */
export type CheckoutBrandingDividerStyle = {
  /** The border style for the divider. */
  readonly borderStyle?: Maybe<CheckoutBrandingBorderStyle>;
  /** The border width for the divider. */
  readonly borderWidth?: Maybe<CheckoutBrandingBorderWidth>;
};

/** The input fields used to update the page, content, main and order summary dividers customizations. */
export type CheckoutBrandingDividerStyleInput = {
  /** The border style for the divider. */
  readonly borderStyle?: InputMaybe<CheckoutBrandingBorderStyle>;
  /** The border width for the divider. */
  readonly borderWidth?: InputMaybe<CheckoutBrandingBorderWidth>;
};

/** The Express Checkout customizations. */
export type CheckoutBrandingExpressCheckout = {
  /** The Express Checkout buttons customizations. */
  readonly button?: Maybe<CheckoutBrandingExpressCheckoutButton>;
};

/** The Express Checkout button customizations. */
export type CheckoutBrandingExpressCheckoutButton = {
  /** The corner radius used for the Express Checkout buttons. */
  readonly cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
};

/** The input fields to use to update the express checkout customizations. */
export type CheckoutBrandingExpressCheckoutButtonInput = {
  /** The corner radius used for Express Checkout buttons. */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
};

/** The input fields to use to update the Express Checkout customizations. */
export type CheckoutBrandingExpressCheckoutInput = {
  /** The Express Checkout buttons customizations. */
  readonly button?: InputMaybe<CheckoutBrandingExpressCheckoutButtonInput>;
};

/** A font. */
export type CheckoutBrandingFont = {
  /** The font sources. */
  readonly sources?: Maybe<Scalars['String']>;
  /** The font weight. */
  readonly weight?: Maybe<Scalars['Int']>;
};

/**
 * A font group. To learn more about updating fonts, refer to the
 * [checkoutBrandingUpsert](https://shopify.dev/api/admin-graphql/unstable/mutations/checkoutBrandingUpsert)
 * mutation and the checkout branding [tutorial](https://shopify.dev/docs/apps/checkout/styling).
 */
export type CheckoutBrandingFontGroup = {
  /** The base font. */
  readonly base?: Maybe<CheckoutBrandingFont>;
  /** The bold font. */
  readonly bold?: Maybe<CheckoutBrandingFont>;
  /** The font loading strategy. */
  readonly loadingStrategy?: Maybe<CheckoutBrandingFontLoadingStrategy>;
  /** The font group name. */
  readonly name?: Maybe<Scalars['String']>;
};

/**
 * The input fields used to update a font group. To learn more about updating fonts, refer to the
 * [checkoutBrandingUpsert](https://shopify.dev/api/admin-graphql/unstable/mutations/checkoutBrandingUpsert)
 * mutation and the checkout branding [tutorial](https://shopify.dev/docs/apps/checkout/styling).
 */
export type CheckoutBrandingFontGroupInput = {
  /** A custom font group. */
  readonly customFontGroup?: InputMaybe<CheckoutBrandingCustomFontGroupInput>;
  /** A Shopify font group. */
  readonly shopifyFontGroup?: InputMaybe<CheckoutBrandingShopifyFontGroupInput>;
};

/**
 * The font loading strategy determines how a font face is displayed after it is loaded or failed to load.
 * For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display.
 */
export enum CheckoutBrandingFontLoadingStrategy {
  /** The font display strategy is defined by the browser user agent. */
  AUTO = 'AUTO',
  /** Gives the font face a short block period and an infinite swap period. */
  BLOCK = 'BLOCK',
  /** Gives the font face an extremely small block period and a short swap period. */
  FALLBACK = 'FALLBACK',
  /** Gives the font face an extremely small block period and no swap period. */
  OPTIONAL = 'OPTIONAL',
  /** Gives the font face an extremely small block period and an infinite swap period. */
  SWAP = 'SWAP'
}

/** The font size. */
export type CheckoutBrandingFontSize = {
  /** The base font size. */
  readonly base?: Maybe<Scalars['Float']>;
  /** The scale ratio used to derive all font sizes such as small and large. */
  readonly ratio?: Maybe<Scalars['Float']>;
};

/** The input fields used to update the font size. */
export type CheckoutBrandingFontSizeInput = {
  /** The base font size. Its value should be between 12.0 and 18.0. */
  readonly base?: InputMaybe<Scalars['Float']>;
  /** The scale ratio used to derive all font sizes such as small and large. Its value should be between 1.0 and 1.4. */
  readonly ratio?: InputMaybe<Scalars['Float']>;
};

/** A container for the footer section customizations. */
export type CheckoutBrandingFooter = {
  /** The footer alignment. */
  readonly alignment?: Maybe<CheckoutBrandingFooterAlignment>;
  /** The selected color scheme of the footer container. */
  readonly colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The footer content settings. */
  readonly content?: Maybe<CheckoutBrandingFooterContent>;
  /** The divided setting. */
  readonly divided?: Maybe<Scalars['Boolean']>;
  /** The padding of the footer container. */
  readonly padding?: Maybe<CheckoutBrandingSpacingKeyword>;
  /** The footer position. */
  readonly position?: Maybe<CheckoutBrandingFooterPosition>;
};

/** Possible values for the footer alignment. */
export enum CheckoutBrandingFooterAlignment {
  /** The checkout footer alignment Center value. */
  CENTER = 'CENTER',
  /** The checkout footer alignment End value. */
  END = 'END',
  /** The checkout footer alignment Start value. */
  START = 'START'
}

/** The footer content customizations. */
export type CheckoutBrandingFooterContent = {
  /** The visibility settings for footer content. */
  readonly visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** The input fields for footer content customizations. */
export type CheckoutBrandingFooterContentInput = {
  /** The visibility settings for footer content. */
  readonly visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/** The input fields when mutating the checkout footer settings. */
export type CheckoutBrandingFooterInput = {
  /** The footer alignment settings. You can set the footer native content alignment to the left, center, or right. */
  readonly alignment?: InputMaybe<CheckoutBrandingFooterAlignment>;
  /** The selected color scheme of the footer container. */
  readonly colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** The input field for setting the footer content customizations. */
  readonly content?: InputMaybe<CheckoutBrandingFooterContentInput>;
  /** The divided setting. */
  readonly divided?: InputMaybe<Scalars['Boolean']>;
  /** The padding of the footer container. */
  readonly padding?: InputMaybe<CheckoutBrandingSpacingKeyword>;
  /** The input field for setting the footer position customizations. */
  readonly position?: InputMaybe<CheckoutBrandingFooterPosition>;
};

/** Possible values for the footer position. */
export enum CheckoutBrandingFooterPosition {
  /** The End footer position. */
  END = 'END',
  /** The Inline footer position. */
  INLINE = 'INLINE'
}

/** The global customizations. */
export type CheckoutBrandingGlobal = {
  /**
   * The global corner radius setting that overrides all other [corner radius](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutBrandingCornerRadius)
   * customizations.
   */
  readonly cornerRadius?: Maybe<CheckoutBrandingGlobalCornerRadius>;
  /** The global typography customizations. */
  readonly typography?: Maybe<CheckoutBrandingTypographyStyleGlobal>;
};

/**
 * Possible choices to override corner radius customizations on all applicable objects. Note that this selection
 * can only be used to set the override to `NONE` (0px).
 *
 * For more customizations options, set the [corner radius](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutBrandingCornerRadius)
 * selection on specific objects while leaving the global corner radius unset.
 */
export enum CheckoutBrandingGlobalCornerRadius {
  /** Set the global corner radius override to 0px (square corners). */
  NONE = 'NONE'
}

/** The input fields used to update the global customizations. */
export type CheckoutBrandingGlobalInput = {
  /**
   * Select a global corner radius setting that overrides all other [corner radii](https://shopify.dev/docs/api/admin-graphql/latest/enums/CheckoutBrandingCornerRadius)
   * customizations.
   */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingGlobalCornerRadius>;
  /** The global typography customizations. */
  readonly typography?: InputMaybe<CheckoutBrandingTypographyStyleGlobalInput>;
};

/** The header customizations. */
export type CheckoutBrandingHeader = {
  /** The header alignment. */
  readonly alignment?: Maybe<CheckoutBrandingHeaderAlignment>;
  /** The background image of the header. */
  readonly banner?: Maybe<CheckoutBrandingImage>;
  /** The cart link customizations for 1-page checkout. This field allows to customize the cart icon that renders by default on 1-page checkout. */
  readonly cartLink?: Maybe<CheckoutBrandingHeaderCartLink>;
  /** The selected color scheme of the header container. */
  readonly colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The divided setting. */
  readonly divided?: Maybe<Scalars['Boolean']>;
  /** The store logo. */
  readonly logo?: Maybe<CheckoutBrandingLogo>;
  /** The padding of the header container. */
  readonly padding?: Maybe<CheckoutBrandingSpacingKeyword>;
  /** The header position. */
  readonly position?: Maybe<CheckoutBrandingHeaderPosition>;
};

/** The possible header alignments. */
export enum CheckoutBrandingHeaderAlignment {
  /** Center alignment. */
  CENTER = 'CENTER',
  /** End alignment. */
  END = 'END',
  /** Start alignment. */
  START = 'START'
}

/** The header cart link customizations. */
export type CheckoutBrandingHeaderCartLink = {
  /** The content type for the header back to cart link in 1-page checkout. Setting this to image will render the custom image provided using the image field on the header cart_link object. If no image is provided, the default cart icon will be used. */
  readonly contentType?: Maybe<CheckoutBrandingCartLinkContentType>;
  /** The image that's used for the header back to cart link in 1-page checkout when the content type is set to image. */
  readonly image?: Maybe<Image>;
};

/** The input fields for header cart link customizations. */
export type CheckoutBrandingHeaderCartLinkInput = {
  /** The input for the content type for the header back to cart link in 1-page checkout. Setting this to image will render the custom image provided using the image field on the header cart_link object. If no image is provided, the default cart icon will be used. */
  readonly contentType?: InputMaybe<CheckoutBrandingCartLinkContentType>;
  /** The input for the image that's used for the header back to cart link in 1-page checkout when the content type is set to image. */
  readonly image?: InputMaybe<CheckoutBrandingImageInput>;
};

/** The input fields used to update the header customizations. */
export type CheckoutBrandingHeaderInput = {
  /** The header alignment. */
  readonly alignment?: InputMaybe<CheckoutBrandingHeaderAlignment>;
  /** The background image of the header (must not be of SVG format). */
  readonly banner?: InputMaybe<CheckoutBrandingImageInput>;
  /** The input for cart link customizations for 1-page checkout. This field allows to customize the cart icon that renders by default on 1-page checkout. */
  readonly cartLink?: InputMaybe<CheckoutBrandingHeaderCartLinkInput>;
  /** The selected color scheme of the header container. */
  readonly colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** The divided setting. */
  readonly divided?: InputMaybe<Scalars['Boolean']>;
  /** The store logo. */
  readonly logo?: InputMaybe<CheckoutBrandingLogoInput>;
  /** The padding of the header container. */
  readonly padding?: InputMaybe<CheckoutBrandingSpacingKeyword>;
  /** The header position. */
  readonly position?: InputMaybe<CheckoutBrandingHeaderPosition>;
};

/** The possible header positions. */
export enum CheckoutBrandingHeaderPosition {
  /** Inline position. */
  INLINE = 'INLINE',
  /** Secondary inline position. */
  INLINE_SECONDARY = 'INLINE_SECONDARY',
  /** Start position. */
  START = 'START'
}

/** The heading level customizations. */
export type CheckoutBrandingHeadingLevel = {
  /** The typography customizations used for headings. */
  readonly typography?: Maybe<CheckoutBrandingTypographyStyle>;
};

/** The input fields for heading level customizations. */
export type CheckoutBrandingHeadingLevelInput = {
  /** The typography customizations used for headings. */
  readonly typography?: InputMaybe<CheckoutBrandingTypographyStyleInput>;
};

/** A checkout branding image. */
export type CheckoutBrandingImage = {
  /** The image details. */
  readonly image?: Maybe<Image>;
};

/** The input fields used to update a checkout branding image uploaded via the Files API. */
export type CheckoutBrandingImageInput = {
  /** A globally-unique ID. */
  readonly mediaImageId?: InputMaybe<Scalars['ID']>;
};

/** The input fields used to upsert the checkout branding settings. */
export type CheckoutBrandingInput = {
  /** The customizations that apply to specific components or areas of the user interface. */
  readonly customizations?: InputMaybe<CheckoutBrandingCustomizationsInput>;
  /**
   * The design system allows you to set values that represent specific attributes
   * of your brand like color and font. These attributes are used throughout the user
   * interface. This brings consistency and allows you to easily make broad design changes.
   */
  readonly designSystem?: InputMaybe<CheckoutBrandingDesignSystemInput>;
};

/** Possible values for the label position. */
export enum CheckoutBrandingLabelPosition {
  /** The Inside label position. */
  INSIDE = 'INSIDE',
  /** The Outside label position. */
  OUTSIDE = 'OUTSIDE'
}

/** The store logo customizations. */
export type CheckoutBrandingLogo = {
  /** The logo image. */
  readonly image?: Maybe<Image>;
  /** The maximum width of the logo. */
  readonly maxWidth?: Maybe<Scalars['Int']>;
  /** The visibility of the logo. */
  readonly visibility?: Maybe<CheckoutBrandingVisibility>;
};

/** The input fields used to update the logo customizations. */
export type CheckoutBrandingLogoInput = {
  /** The logo image (must not be of SVG format). */
  readonly image?: InputMaybe<CheckoutBrandingImageInput>;
  /** The maximum width of the logo. */
  readonly maxWidth?: InputMaybe<Scalars['Int']>;
  /** The visibility of the logo. */
  readonly visibility?: InputMaybe<CheckoutBrandingVisibility>;
};

/** The main container customizations. */
export type CheckoutBrandingMain = {
  /** The background image of the main container. */
  readonly backgroundImage?: Maybe<CheckoutBrandingImage>;
  /** The selected color scheme of the main container. */
  readonly colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The main container's divider style and visibility. */
  readonly divider?: Maybe<CheckoutBrandingContainerDivider>;
  /** The settings for the main sections. */
  readonly section?: Maybe<CheckoutBrandingMainSection>;
};

/** The input fields used to update the main container customizations. */
export type CheckoutBrandingMainInput = {
  /** The background image of the main container (must not be of SVG format). */
  readonly backgroundImage?: InputMaybe<CheckoutBrandingImageInput>;
  /** The selected color scheme for the main container of the checkout. */
  readonly colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** Divider style and visibility on the main container. */
  readonly divider?: InputMaybe<CheckoutBrandingContainerDividerInput>;
  /** The settings for the main sections. */
  readonly section?: InputMaybe<CheckoutBrandingMainSectionInput>;
};

/** The main sections customizations. */
export type CheckoutBrandingMainSection = {
  /** The background style of the main sections. */
  readonly background?: Maybe<CheckoutBrandingBackground>;
  /** The border for the main sections. */
  readonly border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** The border style of the main sections. */
  readonly borderStyle?: Maybe<CheckoutBrandingBorderStyle>;
  /** The border width of the main sections. */
  readonly borderWidth?: Maybe<CheckoutBrandingBorderWidth>;
  /** The selected color scheme of the main sections. */
  readonly colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The corner radius of the main sections. */
  readonly cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The padding of the main sections. */
  readonly padding?: Maybe<CheckoutBrandingSpacingKeyword>;
  /** The shadow of the main sections. */
  readonly shadow?: Maybe<CheckoutBrandingShadow>;
};

/** The input fields used to update the main sections customizations. */
export type CheckoutBrandingMainSectionInput = {
  /** The background style of the main sections. */
  readonly background?: InputMaybe<CheckoutBrandingBackground>;
  /** The border for the main sections. */
  readonly border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** The border style of the main sections. */
  readonly borderStyle?: InputMaybe<CheckoutBrandingBorderStyle>;
  /** The border width of the main sections. */
  readonly borderWidth?: InputMaybe<CheckoutBrandingBorderWidth>;
  /** The selected color scheme for the main sections. */
  readonly colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** The corner radius of the main sections. */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The padding of the main sections. */
  readonly padding?: InputMaybe<CheckoutBrandingSpacingKeyword>;
  /** The shadow of the main sections. */
  readonly shadow?: InputMaybe<CheckoutBrandingShadow>;
};

/** The merchandise thumbnails customizations. */
export type CheckoutBrandingMerchandiseThumbnail = {
  /** The border used for merchandise thumbnails. */
  readonly border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** The corner radius used for merchandise thumbnails. */
  readonly cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
};

/** The input fields used to update the merchandise thumbnails customizations. */
export type CheckoutBrandingMerchandiseThumbnailInput = {
  /** The border used for merchandise thumbnails. */
  readonly border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** The corner radius used for merchandise thumbnails. */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
};

/** The order summary customizations. */
export type CheckoutBrandingOrderSummary = {
  /** The background image of the order summary container. */
  readonly backgroundImage?: Maybe<CheckoutBrandingImage>;
  /** The selected color scheme of the order summary container. */
  readonly colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The order summary container's divider style and visibility. */
  readonly divider?: Maybe<CheckoutBrandingContainerDivider>;
  /** The settings for the order summary sections. */
  readonly section?: Maybe<CheckoutBrandingOrderSummarySection>;
};

/** The input fields used to update the order summary container customizations. */
export type CheckoutBrandingOrderSummaryInput = {
  /** The background image of the order summary container (must not be of SVG format). */
  readonly backgroundImage?: InputMaybe<CheckoutBrandingImageInput>;
  /** The selected color scheme for the order summary container of the checkout. */
  readonly colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** Divider style and visibility on the order summary container. */
  readonly divider?: InputMaybe<CheckoutBrandingContainerDividerInput>;
  /** The settings for the order summary sections. */
  readonly section?: InputMaybe<CheckoutBrandingOrderSummarySectionInput>;
};

/** The order summary sections customizations. */
export type CheckoutBrandingOrderSummarySection = {
  /** The background style of the order summary sections. */
  readonly background?: Maybe<CheckoutBrandingBackground>;
  /** The border for the order summary sections. */
  readonly border?: Maybe<CheckoutBrandingSimpleBorder>;
  /** The border style of the order summary sections. */
  readonly borderStyle?: Maybe<CheckoutBrandingBorderStyle>;
  /** The border width of the order summary sections. */
  readonly borderWidth?: Maybe<CheckoutBrandingBorderWidth>;
  /** The selected color scheme of the order summary sections. */
  readonly colorScheme?: Maybe<CheckoutBrandingColorSchemeSelection>;
  /** The corner radius of the order summary sections. */
  readonly cornerRadius?: Maybe<CheckoutBrandingCornerRadius>;
  /** The padding of the order summary sections. */
  readonly padding?: Maybe<CheckoutBrandingSpacingKeyword>;
  /** The shadow of the order summary sections. */
  readonly shadow?: Maybe<CheckoutBrandingShadow>;
};

/** The input fields used to update the order summary sections customizations. */
export type CheckoutBrandingOrderSummarySectionInput = {
  /** The background style of the order summary sections. */
  readonly background?: InputMaybe<CheckoutBrandingBackground>;
  /** The border for the order summary sections. */
  readonly border?: InputMaybe<CheckoutBrandingSimpleBorder>;
  /** The border style of the order summary sections. */
  readonly borderStyle?: InputMaybe<CheckoutBrandingBorderStyle>;
  /** The border width of the order summary sections. */
  readonly borderWidth?: InputMaybe<CheckoutBrandingBorderWidth>;
  /** The selected color scheme for the order summary sections. */
  readonly colorScheme?: InputMaybe<CheckoutBrandingColorSchemeSelection>;
  /** The corner radius of the order summary sections. */
  readonly cornerRadius?: InputMaybe<CheckoutBrandingCornerRadius>;
  /** The padding of the order summary sections. */
  readonly padding?: InputMaybe<CheckoutBrandingSpacingKeyword>;
  /** The shadow of the order summary sections. */
  readonly shadow?: InputMaybe<CheckoutBrandingShadow>;
};

/** The selects customizations. */
export type CheckoutBrandingSelect = {
  /** The border used for selects. */
  readonly border?: Maybe<CheckoutBrandingBorder>;
  /** The typography customizations used for selects. */
  readonly typography?: Maybe<CheckoutBrandingTypographyStyle>;
};

/** The input fields used to update the selects customizations. */
export type CheckoutBrandingSelectInput = {
  /** The border used for selects. */
  readonly border?: InputMaybe<CheckoutBrandingBorder>;
  /** The typography customizations used for selects. */
  readonly typography?: InputMaybe<CheckoutBrandingTypographyStyleInput>;
};

/** The container shadow. */
export enum CheckoutBrandingShadow {
  /** The Base shadow. */
  BASE = 'BASE',
  /** The Large 100 shadow. */
  LARGE_100 = 'LARGE_100',
  /** The Large 200 shadow. */
  LARGE_200 = 'LARGE_200',
  /** The Small 100 shadow. */
  SMALL_100 = 'SMALL_100',
  /** The Small 200 shadow. */
  SMALL_200 = 'SMALL_200'
}

/** A Shopify font. */
export type CheckoutBrandingShopifyFont = CheckoutBrandingFont & {
  /** The font sources. */
  readonly sources?: Maybe<Scalars['String']>;
  /** The font weight. */
  readonly weight?: Maybe<Scalars['Int']>;
};

/** The input fields used to update a Shopify font group. */
export type CheckoutBrandingShopifyFontGroupInput = {
  /** The base font weight. */
  readonly baseWeight?: InputMaybe<Scalars['Int']>;
  /** The bold font weight. */
  readonly boldWeight?: InputMaybe<Scalars['Int']>;
  /** The font loading strategy. */
  readonly loadingStrategy?: InputMaybe<CheckoutBrandingFontLoadingStrategy>;
  /** The Shopify font name from [the list of available fonts](https://shopify.dev/themes/architecture/settings/fonts#available-fonts), such as `Alegreya Sans` or `Anonymous Pro`. */
  readonly name: Scalars['String'];
};

/** Possible values for the simple border. */
export enum CheckoutBrandingSimpleBorder {
  /** The Full simple border. */
  FULL = 'FULL',
  /** The None simple border. */
  NONE = 'NONE'
}

/** Possible values for the spacing. */
export enum CheckoutBrandingSpacing {
  /** The Base spacing. */
  BASE = 'BASE',
  /** The Extra Loose spacing. */
  EXTRA_LOOSE = 'EXTRA_LOOSE',
  /** The Extra Tight spacing. */
  EXTRA_TIGHT = 'EXTRA_TIGHT',
  /** The Loose spacing. */
  LOOSE = 'LOOSE',
  /** The None spacing. */
  NONE = 'NONE',
  /** The Tight spacing. */
  TIGHT = 'TIGHT'
}

/** The spacing between UI elements. */
export enum CheckoutBrandingSpacingKeyword {
  /** The Base spacing. */
  BASE = 'BASE',
  /** The Large spacing. */
  LARGE = 'LARGE',
  /** The Large 100 spacing. */
  LARGE_100 = 'LARGE_100',
  /** The Large 200 spacing. */
  LARGE_200 = 'LARGE_200',
  /** The Large 300 spacing. */
  LARGE_300 = 'LARGE_300',
  /** The Large 400 spacing. */
  LARGE_400 = 'LARGE_400',
  /** The Large 500 spacing. */
  LARGE_500 = 'LARGE_500',
  /** The None spacing. */
  NONE = 'NONE',
  /** The Small spacing. */
  SMALL = 'SMALL',
  /** The Small 100 spacing. */
  SMALL_100 = 'SMALL_100',
  /** The Small 200 spacing. */
  SMALL_200 = 'SMALL_200',
  /** The Small 300 spacing. */
  SMALL_300 = 'SMALL_300',
  /** The Small 400 spacing. */
  SMALL_400 = 'SMALL_400',
  /** The Small 500 spacing. */
  SMALL_500 = 'SMALL_500'
}

/** The text fields customizations. */
export type CheckoutBrandingTextField = {
  /** The border used for text fields. */
  readonly border?: Maybe<CheckoutBrandingBorder>;
  /** The typography customizations used for text fields. */
  readonly typography?: Maybe<CheckoutBrandingTypographyStyle>;
};

/** The input fields used to update the text fields customizations. */
export type CheckoutBrandingTextFieldInput = {
  /** The border used for text fields. */
  readonly border?: InputMaybe<CheckoutBrandingBorder>;
  /** The typography customizations used for text fields. */
  readonly typography?: InputMaybe<CheckoutBrandingTypographyStyleInput>;
};

/**
 * The typography settings used for checkout-related text. Use these settings to customize the
 * font family and size for primary and secondary text elements.
 *
 * Refer to the [typography tutorial](https://shopify.dev/docs/apps/checkout/styling/customize-typography)
 * for further information on typography customization.
 */
export type CheckoutBrandingTypography = {
  /** A font group used for most components such as text, buttons and form controls. */
  readonly primary?: Maybe<CheckoutBrandingFontGroup>;
  /** A font group used for heading components by default. */
  readonly secondary?: Maybe<CheckoutBrandingFontGroup>;
  /** The font size design system (base size in pixels and scaling between different sizes). */
  readonly size?: Maybe<CheckoutBrandingFontSize>;
};

/** The font selection. */
export enum CheckoutBrandingTypographyFont {
  /** The primary font. */
  PRIMARY = 'PRIMARY',
  /** The secondary font. */
  SECONDARY = 'SECONDARY'
}

/**
 * The input fields used to update the typography. Refer to the [typography tutorial](https://shopify.dev/docs/apps/checkout/styling/customize-typography)
 * for more information on how to set these fields.
 */
export type CheckoutBrandingTypographyInput = {
  /** A font group used for most components such as text, buttons and form controls. */
  readonly primary?: InputMaybe<CheckoutBrandingFontGroupInput>;
  /** A font group used for heading components by default. */
  readonly secondary?: InputMaybe<CheckoutBrandingFontGroupInput>;
  /** The font size. */
  readonly size?: InputMaybe<CheckoutBrandingFontSizeInput>;
};

/** Possible values for the typography kerning. */
export enum CheckoutBrandingTypographyKerning {
  /** Base or default kerning. */
  BASE = 'BASE',
  /** Extra loose kerning, leaving even more space in between characters. */
  EXTRA_LOOSE = 'EXTRA_LOOSE',
  /** Loose kerning, leaving more space than the default in between characters. */
  LOOSE = 'LOOSE'
}

/** Possible values for the typography letter case. */
export enum CheckoutBrandingTypographyLetterCase {
  /** All letters are is lower case. */
  LOWER = 'LOWER',
  /** No letter casing applied. */
  NONE = 'NONE',
  /** Capitalize the first letter of each word. */
  TITLE = 'TITLE',
  /** All letters are uppercase. */
  UPPER = 'UPPER'
}

/**
 * Possible choices for the font size.
 *
 * Note that the value in pixels of these settings can be customized with the
 * [typography size](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/CheckoutBrandingFontSizeInput)
 * object. Refer to the [typography tutorial](https://shopify.dev/docs/apps/checkout/styling/customize-typography)
 * for more information.
 */
export enum CheckoutBrandingTypographySize {
  /** The base font size. Example: 14px. */
  BASE = 'BASE',
  /** The extra extra large font size. Example: 24px. */
  EXTRA_EXTRA_LARGE = 'EXTRA_EXTRA_LARGE',
  /** The extra large font size. Example: 21px. */
  EXTRA_LARGE = 'EXTRA_LARGE',
  /** The extra small font size. Example: 10px. */
  EXTRA_SMALL = 'EXTRA_SMALL',
  /** The large font size. Example: 19px. */
  LARGE = 'LARGE',
  /** The medium font size. Example: 16px. */
  MEDIUM = 'MEDIUM',
  /** The small font size. Example: 12px. */
  SMALL = 'SMALL'
}

/** The typography customizations. */
export type CheckoutBrandingTypographyStyle = {
  /** The font. */
  readonly font?: Maybe<CheckoutBrandingTypographyFont>;
  /** The kerning. */
  readonly kerning?: Maybe<CheckoutBrandingTypographyKerning>;
  /** The letter case. */
  readonly letterCase?: Maybe<CheckoutBrandingTypographyLetterCase>;
  /** The font size. */
  readonly size?: Maybe<CheckoutBrandingTypographySize>;
  /** The font weight. */
  readonly weight?: Maybe<CheckoutBrandingTypographyWeight>;
};

/** The global typography customizations. */
export type CheckoutBrandingTypographyStyleGlobal = {
  /** The kerning. */
  readonly kerning?: Maybe<CheckoutBrandingTypographyKerning>;
  /** The letter case. */
  readonly letterCase?: Maybe<CheckoutBrandingTypographyLetterCase>;
};

/** The input fields used to update the global typography customizations. */
export type CheckoutBrandingTypographyStyleGlobalInput = {
  /** The kerning. */
  readonly kerning?: InputMaybe<CheckoutBrandingTypographyKerning>;
  /** The letter case. */
  readonly letterCase?: InputMaybe<CheckoutBrandingTypographyLetterCase>;
};

/** The input fields used to update the typography customizations. */
export type CheckoutBrandingTypographyStyleInput = {
  /** The font. */
  readonly font?: InputMaybe<CheckoutBrandingTypographyFont>;
  /** The kerning. */
  readonly kerning?: InputMaybe<CheckoutBrandingTypographyKerning>;
  /** The letter case. */
  readonly letterCase?: InputMaybe<CheckoutBrandingTypographyLetterCase>;
  /** The font size. */
  readonly size?: InputMaybe<CheckoutBrandingTypographySize>;
  /** The font weight. */
  readonly weight?: InputMaybe<CheckoutBrandingTypographyWeight>;
};

/** Possible values for the font weight. */
export enum CheckoutBrandingTypographyWeight {
  /** The base weight. */
  BASE = 'BASE',
  /** The bold weight. */
  BOLD = 'BOLD'
}

/** Return type for `checkoutBrandingUpsert` mutation. */
export type CheckoutBrandingUpsertPayload = {
  /** Returns the new checkout branding settings. */
  readonly checkoutBranding?: Maybe<CheckoutBranding>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CheckoutBrandingUpsertUserError>;
};

/** An error that occurs during the execution of `CheckoutBrandingUpsert`. */
export type CheckoutBrandingUpsertUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CheckoutBrandingUpsertUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CheckoutBrandingUpsertUserError`. */
export enum CheckoutBrandingUpsertUserErrorCode {
  /** Unexpected internal error happened. */
  INTERNAL_ERROR = 'INTERNAL_ERROR'
}

/** Possible visibility states. */
export enum CheckoutBrandingVisibility {
  /** The Hidden visibility setting. */
  HIDDEN = 'HIDDEN',
  /** The Visible visibility setting. */
  VISIBLE = 'VISIBLE'
}

/** A checkout profile defines the branding settings and the UI extensions for a store's checkout. A checkout profile could be published or draft. A store might have at most one published checkout profile, which is used to render their live checkout. The store could also have multiple draft profiles that were created, previewed, and published using the admin checkout editor. */
export type CheckoutProfile = Node & {
  /** The date and time when the checkout profile was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The date and time when the checkout profile was last edited. */
  readonly editedAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether the checkout profile is published or not. */
  readonly isPublished: Scalars['Boolean'];
  /** The profile name. */
  readonly name: Scalars['String'];
  /** Whether the checkout profile Thank You Page and Order Status Page are actively using extensibility or not. */
  readonly typOspPagesActive: Scalars['Boolean'];
  /** The date and time when the checkout profile was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple CheckoutProfiles. */
export type CheckoutProfileConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CheckoutProfileEdge>;
  /** A list of nodes that are contained in CheckoutProfileEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CheckoutProfile>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CheckoutProfile and a cursor during pagination. */
export type CheckoutProfileEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CheckoutProfileEdge. */
  readonly node: CheckoutProfile;
};

/** The set of valid sort keys for the CheckoutProfile query. */
export enum CheckoutProfileSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `edited_at` value. */
  EDITED_AT = 'EDITED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `is_published` value. */
  IS_PUBLISHED = 'IS_PUBLISHED',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** The input fields for adding products to the Combined Listing. */
export type ChildProductRelationInput = {
  /** The ID of the child product. */
  readonly childProductId: Scalars['ID'];
  /** The parent option values. */
  readonly selectedParentOptionValues: ReadonlyArray<SelectedVariantOptionInput>;
};

/** The set of valid sort keys for the CodeDiscount query. */
export enum CodeDiscountSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `ends_at` value. */
  ENDS_AT = 'ENDS_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `starts_at` value. */
  STARTS_AT = 'STARTS_AT',
  /** Sort by the `title` value. */
  TITLE = 'TITLE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type Collection = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Node & Publishable & {
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  readonly availablePublicationsCount?: Maybe<Count>;
  /** A single-line, text-only description of the collection, stripped of any HTML tags and formatting that were included in the description. */
  readonly description: Scalars['String'];
  /** The description of the collection, including any HTML tags and formatting. This content is typically displayed to customers, such as on an online store, depending on the theme. */
  readonly descriptionHtml: Scalars['HTML'];
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** Information about the collection that's provided through resource feedback. */
  readonly feedback?: Maybe<ResourceFeedback>;
  /**
   * A unique string that identifies the collection. If a handle isn't specified when a collection is created, it's automatically generated from the collection's original title, and typically includes words from the title separated by hyphens. For example, a collection that was created with the title `Summer Catalog 2022` might have the handle `summer-catalog-2022`.
   *
   * If the title is changed, the handle doesn't automatically change.
   *
   * The handle can be used in themes by the Liquid templating language to refer to the collection, but using the ID is preferred because it never changes.
   */
  readonly handle: Scalars['String'];
  /** Whether the collection includes the specified product. */
  readonly hasProduct: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image associated with the collection. */
  readonly image?: Maybe<Image>;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The products that are included in the collection. */
  readonly products: ProductConnection;
  /** The number of products in the collection. */
  readonly productsCount?: Maybe<Count>;
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * @deprecated Use `resourcePublicationsCount` instead.
   */
  readonly publicationCount: Scalars['Int'];
  /**
   * The channels where the collection is published.
   * @deprecated Use `resourcePublications` instead.
   */
  readonly publications: CollectionPublicationConnection;
  /**
   * Whether the resource is published to a specific channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  readonly publishedOnChannel: Scalars['Boolean'];
  /**
   * Whether the resource is published to a
   * [channel](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel).
   * For example, the resource might be published to the online store channel.
   * @deprecated Use `publishedOnCurrentPublication` instead.
   */
  readonly publishedOnCurrentChannel: Scalars['Boolean'];
  /**
   * Whether the resource is published to the app's
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * For example, the resource might be published to the app's online store channel.
   */
  readonly publishedOnCurrentPublication: Scalars['Boolean'];
  /**
   * Whether the resource is published to a specified
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly publishedOnPublication: Scalars['Boolean'];
  /**
   * The list of resources that are published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly resourcePublications: ResourcePublicationConnection;
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  readonly resourcePublicationsCount?: Maybe<Count>;
  /**
   * The list of resources that are either published or staged to be published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly resourcePublicationsV2: ResourcePublicationV2Connection;
  /** For a smart (automated) collection, specifies the rules that determine whether a product is included. */
  readonly ruleSet?: Maybe<CollectionRuleSet>;
  /** If the default SEO fields for page title and description have been modified, contains the modified information. */
  readonly seo: Seo;
  /** The order in which the products in the collection are displayed by default in the Shopify admin and in sales channels, such as an online store. */
  readonly sortOrder: CollectionSortOrder;
  /**
   * The Storefront GraphQL API ID of the `Collection`.
   *
   * As of the `2022-04` version release, the Storefront GraphQL API will no longer return Base64 encoded IDs to match the behavior of the Admin GraphQL API. Therefore, you can safely use the `id` field's value instead.
   * @deprecated Use `id` instead.
   */
  readonly storefrontId: Scalars['StorefrontID'];
  /** The suffix of the Liquid template being used to show the collection in an online store. For example, if the value is `custom`, then the collection is using the `collection.custom.liquid` template. If the value is `null`, then the collection is using the default `collection.liquid` template. */
  readonly templateSuffix?: Maybe<Scalars['String']>;
  /** The name of the collection. It's displayed in the Shopify admin and is typically displayed in sales channels, such as an online store. */
  readonly title: Scalars['String'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /**
   * The list of channels that the resource is not published to.
   * @deprecated Use `unpublishedPublications` instead.
   */
  readonly unpublishedChannels: ChannelConnection;
  /**
   * The list of [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that the resource isn't published to.
   */
  readonly unpublishedPublications: PublicationConnection;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the collection was last modified. */
  readonly updatedAt: Scalars['DateTime'];
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionHasProductArgs = {
  id: Scalars['ID'];
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductCollectionSortKeys>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionPublicationCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionPublishedOnChannelArgs = {
  channelId: Scalars['ID'];
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionPublishedOnPublicationArgs = {
  publicationId: Scalars['ID'];
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionResourcePublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionResourcePublicationsCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionResourcePublicationsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionUnpublishedChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a group of products that can be displayed in online stores and other sales channels in categories, which makes it easy for customers to find them. For example, an athletics store might create different collections for running attire, shoes, and accessories.
 *
 * Collections can be defined by conditions, such as whether they match certain product tags. These are called smart or automated collections.
 *
 * Collections can also be created for a custom group of products. These are called custom or manual collections.
 */
export type CollectionUnpublishedPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `collectionAddProducts` mutation. */
export type CollectionAddProductsPayload = {
  /** The updated collection. Returns `null` if an error is raised. */
  readonly collection?: Maybe<Collection>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `collectionAddProductsV2` mutation. */
export type CollectionAddProductsV2Payload = {
  /** The asynchronous job adding the products. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CollectionAddProductsV2UserError>;
};

/** An error that occurs during the execution of `CollectionAddProductsV2`. */
export type CollectionAddProductsV2UserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CollectionAddProductsV2UserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CollectionAddProductsV2UserError`. */
export enum CollectionAddProductsV2UserErrorCode {
  /** Can't manually add products to a smart collection. */
  CANT_ADD_TO_SMART_COLLECTION = 'CANT_ADD_TO_SMART_COLLECTION',
  /** Collection doesn't exist. */
  COLLECTION_DOES_NOT_EXIST = 'COLLECTION_DOES_NOT_EXIST'
}

/** An auto-generated type for paginating through multiple Collections. */
export type CollectionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CollectionEdge>;
  /** A list of nodes that are contained in CollectionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Collection>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `collectionCreate` mutation. */
export type CollectionCreatePayload = {
  /** The collection that has been created. */
  readonly collection?: Maybe<Collection>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for specifying the collection to delete. */
export type CollectionDeleteInput = {
  /** The ID of the collection to be deleted. */
  readonly id: Scalars['ID'];
};

/** Return type for `collectionDelete` mutation. */
export type CollectionDeletePayload = {
  /** The ID of the collection that was deleted. Returns `null` if the collection doesn't exist. */
  readonly deletedCollectionId?: Maybe<Scalars['ID']>;
  /** The shop associated with the collection. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one Collection and a cursor during pagination. */
export type CollectionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CollectionEdge. */
  readonly node: Collection;
};

/** The input fields required to create a collection. */
export type CollectionInput = {
  /** The description of the collection, in HTML format. */
  readonly descriptionHtml?: InputMaybe<Scalars['String']>;
  /** A unique human-friendly string for the collection. Automatically generated from the collection's title. */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** Specifies the collection to update or create a new collection if absent. Required for updating a collection. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The image associated with the collection. */
  readonly image?: InputMaybe<ImageInput>;
  /** The metafields to associate with the collection. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** Initial list of collection products. Only valid with `collectionCreate` and without rules. */
  readonly products?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * Indicates whether a redirect is required after a new handle has been provided.
   * If true, then the old handle is redirected to the new one automatically.
   */
  readonly redirectNewHandle?: InputMaybe<Scalars['Boolean']>;
  /** The rules used to assign products to the collection. */
  readonly ruleSet?: InputMaybe<CollectionRuleSetInput>;
  /** SEO information for the collection. */
  readonly seo?: InputMaybe<SeoInput>;
  /** The order in which the collection's products are sorted. */
  readonly sortOrder?: InputMaybe<CollectionSortOrder>;
  /** The theme template used when viewing the collection in a store. */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /** The title of the collection. Required for creating a new collection. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Represents the publications where a collection is published. */
export type CollectionPublication = {
  /**
   * The channel where the collection will be published.
   * @deprecated Use `publication` instead.
   */
  readonly channel: Channel;
  /** The collection to be published on the publication. */
  readonly collection: Collection;
  /** Whether the publication is published or not. */
  readonly isPublished: Scalars['Boolean'];
  /** The publication where the collection will be published. */
  readonly publication: Publication;
  /** The date that the publication was or is going to be published. */
  readonly publishDate: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple CollectionPublications. */
export type CollectionPublicationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CollectionPublicationEdge>;
  /** A list of nodes that are contained in CollectionPublicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CollectionPublication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CollectionPublication and a cursor during pagination. */
export type CollectionPublicationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CollectionPublicationEdge. */
  readonly node: CollectionPublication;
};

/** The input fields for publications to which a collection will be published. */
export type CollectionPublicationInput = {
  /** The ID of the publication. */
  readonly publicationId?: InputMaybe<Scalars['ID']>;
};

/** The input fields for specifying a collection to publish and the sales channels to publish it to. */
export type CollectionPublishInput = {
  /** The channels where the collection will be published. */
  readonly collectionPublications: ReadonlyArray<CollectionPublicationInput>;
  /** The collection to create or update publications for. */
  readonly id: Scalars['ID'];
};

/** Return type for `collectionPublish` mutation. */
export type CollectionPublishPayload = {
  /** The published collection. */
  readonly collection?: Maybe<Collection>;
  /** The channels where the collection has been published. */
  readonly collectionPublications?: Maybe<ReadonlyArray<CollectionPublication>>;
  /** The shop associated with the collection. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `collectionRemoveProducts` mutation. */
export type CollectionRemoveProductsPayload = {
  /** The asynchronous job removing the products. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `collectionReorderProducts` mutation. */
export type CollectionReorderProductsPayload = {
  /** The asynchronous job reordering the products. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents at rule that's used to assign products to a collection. */
export type CollectionRule = {
  /** The attribute that the rule focuses on. For example, `title` or `product_type`. */
  readonly column: CollectionRuleColumn;
  /** The value that the operator is applied to. For example, `Hats`. */
  readonly condition: Scalars['String'];
  /** The value that the operator is applied to. */
  readonly conditionObject?: Maybe<CollectionRuleConditionObject>;
  /** The type of operator that the rule is based on. For example, `equals`, `contains`, or `not_equals`. */
  readonly relation: CollectionRuleRelation;
};

/** Specifies the taxonomy category to used for the condition. */
export type CollectionRuleCategoryCondition = {
  /** The taxonomy category used as condition. */
  readonly value: TaxonomyCategory;
};

/** Specifies the attribute of a product being used to populate the smart collection. */
export enum CollectionRuleColumn {
  /**
   * An attribute evaluated based on the `compare_at_price` attribute of the product's variants.
   * With `is_set` relation, the rule matches products with at least one variant with `compare_at_price` set.
   * With `is_not_set` relation, the rule matches matches products with at least one variant with `compare_at_price` not set.
   */
  IS_PRICE_REDUCED = 'IS_PRICE_REDUCED',
  /**
   * This rule type is designed to dynamically include products in a smart collection based on their category id.
   * When a specific product category is set as a condition, this rule will match products that are directly assigned to the specified category.
   */
  PRODUCT_CATEGORY_ID = 'PRODUCT_CATEGORY_ID',
  /**
   * This rule type is designed to dynamically include products in a smart collection based on their category id.
   * When a specific product category is set as a condition, this rule will not only match products that are
   * directly assigned to the specified category but also include any products categorized under any descendant of that category.
   */
  PRODUCT_CATEGORY_ID_WITH_DESCENDANTS = 'PRODUCT_CATEGORY_ID_WITH_DESCENDANTS',
  /** This category includes metafield definitions that have the `useAsCollectionCondition` flag set to true. */
  PRODUCT_METAFIELD_DEFINITION = 'PRODUCT_METAFIELD_DEFINITION',
  /** The [`product_taxonomy_node_id`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-product-productcategory) attribute. */
  PRODUCT_TAXONOMY_NODE_ID = 'PRODUCT_TAXONOMY_NODE_ID',
  /** The [`tag`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-product-producttype) attribute. */
  TAG = 'TAG',
  /** The [`title`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-product-title) attribute. */
  TITLE = 'TITLE',
  /** The [`type`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-product-producttype) attribute. */
  TYPE = 'TYPE',
  /** The [`variant_compare_at_price`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-productvariant-compareatprice) attribute. */
  VARIANT_COMPARE_AT_PRICE = 'VARIANT_COMPARE_AT_PRICE',
  /** The [`variant_inventory`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-productvariant-inventoryquantity) attribute. */
  VARIANT_INVENTORY = 'VARIANT_INVENTORY',
  /** This category includes metafield definitions that have the `useAsCollectionCondition` flag set to true. */
  VARIANT_METAFIELD_DEFINITION = 'VARIANT_METAFIELD_DEFINITION',
  /** The [`variant_price`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-productvariant-price) attribute. */
  VARIANT_PRICE = 'VARIANT_PRICE',
  /** The [`variant_title`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-productvariant-title) attribute. */
  VARIANT_TITLE = 'VARIANT_TITLE',
  /** The [`variant_weight`](https://shopify.dev/api/admin-graphql/latest/objects/ProductVariant#field-productvariant-weight) attribute. */
  VARIANT_WEIGHT = 'VARIANT_WEIGHT',
  /** The [`vendor`](https://shopify.dev/api/admin-graphql/latest/objects/Product#field-product-vendor) attribute. */
  VENDOR = 'VENDOR'
}

/** Specifies object for the condition of the rule. */
export type CollectionRuleConditionObject = CollectionRuleCategoryCondition | CollectionRuleMetafieldCondition | CollectionRuleProductCategoryCondition | CollectionRuleTextCondition;

/** This object defines all columns and allowed relations that can be used in rules for smart collections to automatically include the matching products. */
export type CollectionRuleConditions = {
  /** Allowed relations of the rule. */
  readonly allowedRelations: ReadonlyArray<CollectionRuleRelation>;
  /** Most commonly used relation for this rule. */
  readonly defaultRelation: CollectionRuleRelation;
  /** Additional attributes defining the rule. */
  readonly ruleObject?: Maybe<CollectionRuleConditionsRuleObject>;
  /** Type of the rule. */
  readonly ruleType: CollectionRuleColumn;
};

/** Specifies object with additional rule attributes. */
export type CollectionRuleConditionsRuleObject = CollectionRuleMetafieldCondition;

/** The input fields for a rule to associate with a collection. */
export type CollectionRuleInput = {
  /** The attribute that the rule focuses on. For example, `title` or `product_type`. */
  readonly column: CollectionRuleColumn;
  /** The value that the operator is applied to. For example, `Hats`. */
  readonly condition: Scalars['String'];
  /**
   * The object ID that points to additional attributes for the collection rule.
   * This is only required when using metafield definition rules.
   */
  readonly conditionObjectId?: InputMaybe<Scalars['ID']>;
  /** The type of operator that the rule is based on. For example, `equals`, `contains`, or `not_equals`. */
  readonly relation: CollectionRuleRelation;
};

/** Identifies a metafield definition used as a rule for the smart collection. */
export type CollectionRuleMetafieldCondition = {
  /** The metafield definition associated with the condition. */
  readonly metafieldDefinition: MetafieldDefinition;
};

/** Specifies the condition for a Product Category field. */
export type CollectionRuleProductCategoryCondition = {
  /** The value of the condition. */
  readonly value: ProductTaxonomyNode;
};

/** Specifies the relationship between the `column` and the `condition`. */
export enum CollectionRuleRelation {
  /** The attribute contains the condition. */
  CONTAINS = 'CONTAINS',
  /** The attribute ends with the condition. */
  ENDS_WITH = 'ENDS_WITH',
  /** The attribute is equal to the condition. */
  EQUALS = 'EQUALS',
  /** The attribute is greater than the condition. */
  GREATER_THAN = 'GREATER_THAN',
  /** The attribute is not set (equal to `null`). */
  IS_NOT_SET = 'IS_NOT_SET',
  /** The attribute is set (not equal to `null`). */
  IS_SET = 'IS_SET',
  /** The attribute is less than the condition. */
  LESS_THAN = 'LESS_THAN',
  /** The attribute does not contain the condition. */
  NOT_CONTAINS = 'NOT_CONTAINS',
  /** The attribute does not equal the condition. */
  NOT_EQUALS = 'NOT_EQUALS',
  /** The attribute starts with the condition. */
  STARTS_WITH = 'STARTS_WITH'
}

/** The set of rules that are used to determine which products are included in the collection. */
export type CollectionRuleSet = {
  /**
   * Whether products must match any or all of the rules to be included in the collection.
   * If true, then products must match at least one of the rules to be included in the collection.
   * If false, then products must match all of the rules to be included in the collection.
   */
  readonly appliedDisjunctively: Scalars['Boolean'];
  /** The rules used to assign products to the collection. */
  readonly rules: ReadonlyArray<CollectionRule>;
};

/** The input fields for a rule set of the collection. */
export type CollectionRuleSetInput = {
  /**
   * Whether products must match any or all of the rules to be included in the collection.
   * If true, then products must match at least one of the rules to be included in the collection.
   * If false, then products must match all of the rules to be included in the collection.
   */
  readonly appliedDisjunctively: Scalars['Boolean'];
  /** The rules used to assign products to the collection. */
  readonly rules?: InputMaybe<ReadonlyArray<CollectionRuleInput>>;
};

/** Specifies the condition for a text field. */
export type CollectionRuleTextCondition = {
  /** The value of the condition. */
  readonly value: Scalars['String'];
};

/** The set of valid sort keys for the Collection query. */
export enum CollectionSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Specifies the sort order for the products in the collection. */
export enum CollectionSortOrder {
  /** Alphabetically, in ascending order (A - Z). */
  ALPHA_ASC = 'ALPHA_ASC',
  /** Alphabetically, in descending order (Z - A). */
  ALPHA_DESC = 'ALPHA_DESC',
  /** By best-selling products. */
  BEST_SELLING = 'BEST_SELLING',
  /** By date created, in ascending order (oldest - newest). */
  CREATED = 'CREATED',
  /** By date created, in descending order (newest - oldest). */
  CREATED_DESC = 'CREATED_DESC',
  /** In the order set manually by the merchant. */
  MANUAL = 'MANUAL',
  /** By price, in ascending order (lowest - highest). */
  PRICE_ASC = 'PRICE_ASC',
  /** By price, in descending order (highest - lowest). */
  PRICE_DESC = 'PRICE_DESC'
}

/** The input fields for specifying the collection to unpublish and the sales channels to remove it from. */
export type CollectionUnpublishInput = {
  /** The channels where the collection is published. */
  readonly collectionPublications: ReadonlyArray<CollectionPublicationInput>;
  /** The collection to create or update publications for. */
  readonly id: Scalars['ID'];
};

/** Return type for `collectionUnpublish` mutation. */
export type CollectionUnpublishPayload = {
  /** The collection that has been unpublished. */
  readonly collection?: Maybe<Collection>;
  /** The shop associated with the collection. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `collectionUpdate` mutation. */
export type CollectionUpdatePayload = {
  /** The updated collection. */
  readonly collection?: Maybe<Collection>;
  /** The asynchronous job updating the products based on the new rule set. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A combined listing of products. */
export type CombinedListing = {
  /** A list of child products in the combined listing. */
  readonly combinedListingChildren: CombinedListingChildConnection;
  /** The parent product. */
  readonly parentProduct: Product;
};


/** A combined listing of products. */
export type CombinedListingCombinedListingChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** A child of a combined listing. */
export type CombinedListingChild = {
  /** The parent variant. */
  readonly parentVariant: ProductVariant;
  /** The child product. */
  readonly product: Product;
};

/** An auto-generated type for paginating through multiple CombinedListingChildren. */
export type CombinedListingChildConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CombinedListingChildEdge>;
  /** A list of nodes that are contained in CombinedListingChildEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CombinedListingChild>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CombinedListingChild and a cursor during pagination. */
export type CombinedListingChildEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CombinedListingChildEdge. */
  readonly node: CombinedListingChild;
};

/** Return type for `combinedListingUpdate` mutation. */
export type CombinedListingUpdatePayload = {
  /** The parent product. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CombinedListingUpdateUserError>;
};

/** An error that occurs during the execution of `CombinedListingUpdate`. */
export type CombinedListingUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CombinedListingUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CombinedListingUpdateUserError`. */
export enum CombinedListingUpdateUserErrorCode {
  /** Unable to add duplicated products. */
  CANNOT_HAVE_DUPLICATED_PRODUCTS = 'CANNOT_HAVE_DUPLICATED_PRODUCTS',
  /** Unable to add a product that is a parent. */
  CANNOT_HAVE_PARENT_AS_CHILD = 'CANNOT_HAVE_PARENT_AS_CHILD',
  /** Unable to add products with repeated options. */
  CANNOT_HAVE_REPEATED_OPTIONS = 'CANNOT_HAVE_REPEATED_OPTIONS',
  /** Option values cannot be repeated. */
  CANNOT_HAVE_REPEATED_OPTION_VALUES = 'CANNOT_HAVE_REPEATED_OPTION_VALUES',
  /** Unable to add options values that are already in use. */
  CANT_ADD_OPTIONS_VALUES_IF_ALREADY_EXISTS = 'CANT_ADD_OPTIONS_VALUES_IF_ALREADY_EXISTS',
  /** Combined listings feature is not enabled. */
  COMBINED_LISTINGS_NOT_ENABLED = 'COMBINED_LISTINGS_NOT_ENABLED',
  /** Cannot perform edit and remove on same products. */
  EDIT_AND_REMOVE_ON_SAME_PRODUCTS = 'EDIT_AND_REMOVE_ON_SAME_PRODUCTS',
  /** Unable to add products. */
  FAILED_TO_ADD_PRODUCTS = 'FAILED_TO_ADD_PRODUCTS',
  /** Unable to remove products. */
  FAILED_TO_REMOVE_PRODUCTS = 'FAILED_TO_REMOVE_PRODUCTS',
  /** Unable to update products. */
  FAILED_TO_UPDATE_PRODUCTS = 'FAILED_TO_UPDATE_PRODUCTS',
  /** The same metafield cannot be linked to multiple options. */
  LINKED_METAFIELDS_CANNOT_BE_REPEATED = 'LINKED_METAFIELDS_CANNOT_BE_REPEATED',
  /** An option linked to a metafield cannot be linked to a different metafield. */
  LINKED_METAFIELD_CANNOT_BE_CHANGED = 'LINKED_METAFIELD_CANNOT_BE_CHANGED',
  /** Linked metafield value missing from `optionsAndValues` field. */
  LINKED_METAFIELD_VALUE_MISSING = 'LINKED_METAFIELD_VALUE_MISSING',
  /** Linked options are currently not supported for this shop. */
  LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** The optionsAndValues field is required for this operation. */
  MISSING_OPTION_VALUES = 'MISSING_OPTION_VALUES',
  /** Selected option values cannot be empty. */
  MUST_HAVE_SELECTED_OPTION_VALUES = 'MUST_HAVE_SELECTED_OPTION_VALUES',
  /** All child products must include the same options. */
  OPTIONS_MUST_BE_EQUAL_TO_THE_OTHER_COMPONENTS = 'OPTIONS_MUST_BE_EQUAL_TO_THE_OTHER_COMPONENTS',
  /** Unable to add products with blank option names. */
  OPTION_NAME_CANNOT_BE_BLANK = 'OPTION_NAME_CANNOT_BE_BLANK',
  /** Option name contains invalid characters. */
  OPTION_NAME_CONTAINS_INVALID_CHARACTERS = 'OPTION_NAME_CONTAINS_INVALID_CHARACTERS',
  /** Option does not exist. */
  OPTION_NOT_FOUND = 'OPTION_NOT_FOUND',
  /** Unable to update options with blank option values. */
  OPTION_VALUES_CANNOT_BE_BLANK = 'OPTION_VALUES_CANNOT_BE_BLANK',
  /** Unable to update options with no option values. */
  OPTION_VALUES_CANNOT_BE_EMPTY = 'OPTION_VALUES_CANNOT_BE_EMPTY',
  /** Parent product cannot be a combined listing child. */
  PARENT_PRODUCT_CANNOT_BE_COMBINED_LISTING_CHILD = 'PARENT_PRODUCT_CANNOT_BE_COMBINED_LISTING_CHILD',
  /** Unable to update components for a product that isn't a combined listing. */
  PARENT_PRODUCT_MUST_BE_A_COMBINED_LISTING = 'PARENT_PRODUCT_MUST_BE_A_COMBINED_LISTING',
  /** Parent product not found. */
  PARENT_PRODUCT_NOT_FOUND = 'PARENT_PRODUCT_NOT_FOUND',
  /** Unable to add a product that is already a child. */
  PRODUCT_IS_ALREADY_A_CHILD = 'PRODUCT_IS_ALREADY_A_CHILD',
  /** Failed to remove mebmership due to invalid input. */
  PRODUCT_MEMBERSHIP_NOT_FOUND = 'PRODUCT_MEMBERSHIP_NOT_FOUND',
  /** Unable to add products that do not exist. */
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  /** The title cannot be longer than 255 characters. */
  TITLE_TOO_LONG = 'TITLE_TOO_LONG',
  /** You have reached the maximum number of products that can be added to an individual combined listing. */
  TOO_MANY_PRODUCTS = 'TOO_MANY_PRODUCTS',
  /** You have reached the maximum number of variants across all products for an individual combined listing. */
  TOO_MANY_VARIANTS = 'TOO_MANY_VARIANTS',
  /** An unexpected error occurred. */
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR'
}

/** The role of the combined listing. */
export enum CombinedListingsRole {
  /** The product is the child of a combined listing. */
  CHILD = 'CHILD',
  /** The product is the parent of a combined listing. */
  PARENT = 'PARENT'
}

/** A comment on an article. */
export type Comment = HasEvents & Node & {
  /** The article associated with the comment. */
  readonly article?: Maybe<Article>;
  /** The comment’s author. */
  readonly author: CommentAuthor;
  /** The content of the comment. */
  readonly body: Scalars['String'];
  /** The content of the comment, complete with HTML formatting. */
  readonly bodyHtml: Scalars['HTML'];
  /** The date and time when the comment was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The IP address of the commenter. */
  readonly ip?: Maybe<Scalars['String']>;
  /** Whether or not the comment is published. */
  readonly isPublished: Scalars['Boolean'];
  /** The date and time when the comment was published. */
  readonly publishedAt?: Maybe<Scalars['DateTime']>;
  /** The status of the comment. */
  readonly status: CommentStatus;
  /** The date and time when the comment was last updated. */
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user agent of the commenter. */
  readonly userAgent?: Maybe<Scalars['String']>;
};


/** A comment on an article. */
export type CommentEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** Return type for `commentApprove` mutation. */
export type CommentApprovePayload = {
  /** The comment that was approved. */
  readonly comment?: Maybe<Comment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CommentApproveUserError>;
};

/** An error that occurs during the execution of `CommentApprove`. */
export type CommentApproveUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CommentApproveUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CommentApproveUserError`. */
export enum CommentApproveUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** The author of a comment. */
export type CommentAuthor = {
  /** The author's email. */
  readonly email: Scalars['String'];
  /** The author’s name. */
  readonly name: Scalars['String'];
};

/** An auto-generated type for paginating through multiple Comments. */
export type CommentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CommentEdge>;
  /** A list of nodes that are contained in CommentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Comment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `commentDelete` mutation. */
export type CommentDeletePayload = {
  /** The ID of the comment that was deleted. */
  readonly deletedCommentId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CommentDeleteUserError>;
};

/** An error that occurs during the execution of `CommentDelete`. */
export type CommentDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CommentDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CommentDeleteUserError`. */
export enum CommentDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** An auto-generated type which holds one Comment and a cursor during pagination. */
export type CommentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CommentEdge. */
  readonly node: Comment;
};

/**
 * Comment events are generated by staff members of a shop.
 * They are created when a staff member adds a comment to the timeline of an order, draft order, customer, or transfer.
 */
export type CommentEvent = Event & Node & {
  /** The action that occured. */
  readonly action: Scalars['String'];
  /** The name of the app that created the event. */
  readonly appTitle?: Maybe<Scalars['String']>;
  /** The attachments associated with the comment event. */
  readonly attachments: ReadonlyArray<CommentEventAttachment>;
  /** Whether the event was created by an app. */
  readonly attributeToApp: Scalars['Boolean'];
  /** Whether the event was caused by an admin user. */
  readonly attributeToUser: Scalars['Boolean'];
  /** The name of the user that authored the comment event. */
  readonly author: StaffMember;
  /** Whether the comment event can be deleted. If true, then the comment event can be deleted. */
  readonly canDelete: Scalars['Boolean'];
  /** Whether the comment event can be edited. If true, then the comment event can be edited. */
  readonly canEdit: Scalars['Boolean'];
  /** The date and time when the event was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Whether the event is critical. */
  readonly criticalAlert: Scalars['Boolean'];
  /** Whether the comment event has been edited. If true, then the comment event has been edited. */
  readonly edited: Scalars['Boolean'];
  /** The object reference associated with the comment event. For example, a product or discount). */
  readonly embed?: Maybe<CommentEventEmbed>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Human readable text that describes the event. */
  readonly message: Scalars['FormattedString'];
  /** The raw body of the comment event. */
  readonly rawMessage: Scalars['String'];
  /** The parent subject to which the comment event belongs. */
  readonly subject?: Maybe<CommentEventSubject>;
};

/** A file attachment associated to a comment event. */
export type CommentEventAttachment = {
  /** The file extension of the comment event attachment, indicating the file format. */
  readonly fileExtension?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image attached to the comment event. */
  readonly image?: Maybe<Image>;
  /** The filename of the comment event attachment. */
  readonly name: Scalars['String'];
  /** The size of the attachment. */
  readonly size: Scalars['Int'];
  /** The URL of the attachment. */
  readonly url: Scalars['URL'];
};

/** The main embed of a comment event. */
export type CommentEventEmbed = Customer | DraftOrder | Order | Product | ProductVariant;

/** The subject line of a comment event. */
export type CommentEventSubject = {
  /** Whether the timeline subject has a timeline comment. If true, then a timeline comment exists. */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
};

/** Return type for `commentNotSpam` mutation. */
export type CommentNotSpamPayload = {
  /** The comment that was marked as not spam. */
  readonly comment?: Maybe<Comment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CommentNotSpamUserError>;
};

/** An error that occurs during the execution of `CommentNotSpam`. */
export type CommentNotSpamUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CommentNotSpamUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CommentNotSpamUserError`. */
export enum CommentNotSpamUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** Possible comment policies for a blog. */
export enum CommentPolicy {
  /** Readers can post comments to blog articles without moderation. */
  AUTO_PUBLISHED = 'AUTO_PUBLISHED',
  /** Readers cannot post comments to blog articles. */
  CLOSED = 'CLOSED',
  /** Readers can post comments to blog articles, but comments must be moderated before they appear. */
  MODERATED = 'MODERATED'
}

/** The set of valid sort keys for the Comment query. */
export enum CommentSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** Return type for `commentSpam` mutation. */
export type CommentSpamPayload = {
  /** The comment that was marked as spam. */
  readonly comment?: Maybe<Comment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CommentSpamUserError>;
};

/** An error that occurs during the execution of `CommentSpam`. */
export type CommentSpamUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CommentSpamUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CommentSpamUserError`. */
export enum CommentSpamUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** The status of a comment. */
export enum CommentStatus {
  /** The comment is pending approval. */
  PENDING = 'PENDING',
  /** The comment is published. */
  PUBLISHED = 'PUBLISHED',
  /** The comment has been removed. */
  REMOVED = 'REMOVED',
  /** The comment is marked as spam. */
  SPAM = 'SPAM',
  /** The comment is unapproved. */
  UNAPPROVED = 'UNAPPROVED'
}

/** Return type for `companiesDelete` mutation. */
export type CompaniesDeletePayload = {
  /** A list of IDs of the deleted companies. */
  readonly deletedCompanyIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Represents information about a company which is also a customer of the shop. */
export type Company = CommentEventSubject & HasEvents & HasMetafieldDefinitions & HasMetafields & Navigable & Node & {
  /**
   * The number of contacts that belong to the company.
   * @deprecated Use `contactsCount` instead.
   */
  readonly contactCount: Scalars['Int'];
  /** The list of roles for the company contacts. */
  readonly contactRoles: CompanyContactRoleConnection;
  /** The list of contacts in the company. */
  readonly contacts: CompanyContactConnection;
  /** The number of contacts that belong to the company. */
  readonly contactsCount?: Maybe<Count>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company was created in Shopify. */
  readonly createdAt: Scalars['DateTime'];
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company became the customer. */
  readonly customerSince: Scalars['DateTime'];
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** The role proposed by default for a contact at the company. */
  readonly defaultRole?: Maybe<CompanyContactRole>;
  /** The list of the company's draft orders. */
  readonly draftOrders: DraftOrderConnection;
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** A unique externally-supplied ID for the company. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** Whether the merchant added a timeline comment to the company. */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The lifetime duration of the company, since it became a customer of the shop. Examples: `2 days`, `3 months`, `1 year`. */
  readonly lifetimeDuration: Scalars['String'];
  /** The list of locations in the company. */
  readonly locations: CompanyLocationConnection;
  /** The number of locations that belong to the company. */
  readonly locationsCount?: Maybe<Count>;
  /** The main contact for the company. */
  readonly mainContact?: Maybe<CompanyContact>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** The name of the company. */
  readonly name: Scalars['String'];
  /** A note about the company. */
  readonly note?: Maybe<Scalars['String']>;
  /** The list of the company's orders. */
  readonly orders: OrderConnection;
  /** The total number of orders placed for this company, across all its locations. */
  readonly ordersCount?: Maybe<Count>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The total amount spent by this company, across all its locations. */
  readonly totalSpent: MoneyV2;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company was last modified. */
  readonly updatedAt: Scalars['DateTime'];
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyContactRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanyContactRoleSortKeys>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanyContactSortKeys>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanyLocationSortKeys>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** Represents information about a company which is also a customer of the shop. */
export type CompanyPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a billing or shipping address for a company location. */
export type CompanyAddress = Node & {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1: Scalars['String'];
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: Maybe<Scalars['String']>;
  /** The name of the company. */
  readonly companyName: Scalars['String'];
  /** The name of the country. */
  readonly country?: Maybe<Scalars['String']>;
  /**
   * The two-letter code for the country of the address.
   * For example, US.
   */
  readonly countryCode: CountryCode;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company address was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The first name of the recipient. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** The formatted version of the address. */
  readonly formattedAddress: ReadonlyArray<Scalars['String']>;
  /** A comma-separated list of the values for city, province, and country. */
  readonly formattedArea?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The last name of the recipient. */
  readonly lastName?: Maybe<Scalars['String']>;
  /**
   * A unique phone number for the customer.
   * Formatted using E.164 standard. For example, _+16135551111_.
   */
  readonly phone?: Maybe<Scalars['String']>;
  /** The region of the address, such as the province, state, or district. */
  readonly province?: Maybe<Scalars['String']>;
  /** The identity of the recipient e.g. 'Receiving Department'. */
  readonly recipient?: Maybe<Scalars['String']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company address was last updated. */
  readonly updatedAt: Scalars['DateTime'];
  /** The zip or postal code of the address. */
  readonly zip?: Maybe<Scalars['String']>;
  /**
   * The alphanumeric code for the region.
   * For example, ON.
   */
  readonly zoneCode?: Maybe<Scalars['String']>;
};


/** Represents a billing or shipping address for a company location. */
export type CompanyAddressFormattedAddressArgs = {
  withCompanyName?: InputMaybe<Scalars['Boolean']>;
  withName?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `companyAddressDelete` mutation. */
export type CompanyAddressDeletePayload = {
  /** The ID of the deleted address. */
  readonly deletedAddressId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** The input fields to create or update the address of a company location. */
export type CompanyAddressInput = {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1?: InputMaybe<Scalars['String']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: InputMaybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: InputMaybe<Scalars['String']>;
  /** The two-letter code ([ISO 3166-1 alpha-2]](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) format) for the country of the address. For example, `US`` for the United States. */
  readonly countryCode?: InputMaybe<CountryCode>;
  /** The first name of the recipient. */
  readonly firstName?: InputMaybe<Scalars['String']>;
  /** The last name of the recipient. */
  readonly lastName?: InputMaybe<Scalars['String']>;
  /** A phone number for the recipient. Formatted using E.164 standard. For example, _+16135551111_. */
  readonly phone?: InputMaybe<Scalars['String']>;
  /** The identity of the recipient e.g. 'Receiving Department'. */
  readonly recipient?: InputMaybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  readonly zip?: InputMaybe<Scalars['String']>;
  /** The alphanumeric code for the region of the address, such as the province, state, or district. For example, `ON` for Ontario, Canada. */
  readonly zoneCode?: InputMaybe<Scalars['String']>;
};

/** The valid values for the address type of a company. */
export enum CompanyAddressType {
  /** The address is a billing address. */
  BILLING = 'BILLING',
  /** The address is a shipping address. */
  SHIPPING = 'SHIPPING'
}

/** Return type for `companyAssignCustomerAsContact` mutation. */
export type CompanyAssignCustomerAsContactPayload = {
  /** The created company contact. */
  readonly companyContact?: Maybe<CompanyContact>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyAssignMainContact` mutation. */
export type CompanyAssignMainContactPayload = {
  /** The company for which the main contact is assigned. */
  readonly company?: Maybe<Company>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** An auto-generated type for paginating through multiple Companies. */
export type CompanyConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CompanyEdge>;
  /** A list of nodes that are contained in CompanyEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Company>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** A person that acts on behalf of company associated to [a customer](https://shopify.dev/api/admin-graphql/latest/objects/customer). */
export type CompanyContact = Node & {
  /** The company to which the contact belongs. */
  readonly company: Company;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company contact was created at Shopify. */
  readonly createdAt: Scalars['DateTime'];
  /** The customer associated to this contact. */
  readonly customer: Customer;
  /** The list of draft orders for the company contact. */
  readonly draftOrders: DraftOrderConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether the contact is the main contact of the company. */
  readonly isMainContact: Scalars['Boolean'];
  /** The lifetime duration of the company contact, since its creation date on Shopify. Examples: `1 year`, `2 months`, `3 days`. */
  readonly lifetimeDuration: Scalars['String'];
  /** The company contact's locale (language). */
  readonly locale?: Maybe<Scalars['String']>;
  /** The list of orders for the company contact. */
  readonly orders: OrderConnection;
  /** The list of roles assigned to this company contact. */
  readonly roleAssignments: CompanyContactRoleAssignmentConnection;
  /** The company contact's job title. */
  readonly title?: Maybe<Scalars['String']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company contact was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** A person that acts on behalf of company associated to [a customer](https://shopify.dev/api/admin-graphql/latest/objects/customer). */
export type CompanyContactDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** A person that acts on behalf of company associated to [a customer](https://shopify.dev/api/admin-graphql/latest/objects/customer). */
export type CompanyContactOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/** A person that acts on behalf of company associated to [a customer](https://shopify.dev/api/admin-graphql/latest/objects/customer). */
export type CompanyContactRoleAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanyContactRoleAssignmentSortKeys>;
};

/** Return type for `companyContactAssignRole` mutation. */
export type CompanyContactAssignRolePayload = {
  /** The company contact role assignment. */
  readonly companyContactRoleAssignment?: Maybe<CompanyContactRoleAssignment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyContactAssignRoles` mutation. */
export type CompanyContactAssignRolesPayload = {
  /** A list of newly created assignments of company contacts to a company location. */
  readonly roleAssignments?: Maybe<ReadonlyArray<CompanyContactRoleAssignment>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** An auto-generated type for paginating through multiple CompanyContacts. */
export type CompanyContactConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CompanyContactEdge>;
  /** A list of nodes that are contained in CompanyContactEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CompanyContact>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `companyContactCreate` mutation. */
export type CompanyContactCreatePayload = {
  /** The created company contact. */
  readonly companyContact?: Maybe<CompanyContact>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyContactDelete` mutation. */
export type CompanyContactDeletePayload = {
  /** The ID of the deleted company contact. */
  readonly deletedCompanyContactId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** An auto-generated type which holds one CompanyContact and a cursor during pagination. */
export type CompanyContactEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CompanyContactEdge. */
  readonly node: CompanyContact;
};

/** The input fields for company contact attributes when creating or updating a company contact. */
export type CompanyContactInput = {
  /** The unique email address of the company contact. */
  readonly email?: InputMaybe<Scalars['String']>;
  /** The company contact's first name. */
  readonly firstName?: InputMaybe<Scalars['String']>;
  /** The company contact's last name. */
  readonly lastName?: InputMaybe<Scalars['String']>;
  /** The contact's locale. */
  readonly locale?: InputMaybe<Scalars['String']>;
  /** The phone number of the company contact. */
  readonly phone?: InputMaybe<Scalars['String']>;
  /** The title of the company contact. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `companyContactRemoveFromCompany` mutation. */
export type CompanyContactRemoveFromCompanyPayload = {
  /** The ID of the removed company contact. */
  readonly removedCompanyContactId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyContactRevokeRole` mutation. */
export type CompanyContactRevokeRolePayload = {
  /** The role assignment that was revoked. */
  readonly revokedCompanyContactRoleAssignmentId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyContactRevokeRoles` mutation. */
export type CompanyContactRevokeRolesPayload = {
  /** A list of role assignment IDs that were removed from the company contact. */
  readonly revokedRoleAssignmentIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** The role for a [company contact](https://shopify.dev/api/admin-graphql/latest/objects/companycontact). */
export type CompanyContactRole = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The name of a role.
   * For example, `admin` or `buyer`.
   */
  readonly name: Scalars['String'];
  /** A note for the role. */
  readonly note?: Maybe<Scalars['String']>;
};

/** The input fields for the role and location to assign to a company contact. */
export type CompanyContactRoleAssign = {
  /** The role ID. */
  readonly companyContactRoleId: Scalars['ID'];
  /** The location. */
  readonly companyLocationId: Scalars['ID'];
};

/** The CompanyContactRoleAssignment describes the company and location associated to a company contact's role. */
export type CompanyContactRoleAssignment = Node & {
  /** The company this role assignment belongs to. */
  readonly company: Company;
  /** The company contact for whom this role is assigned. */
  readonly companyContact: CompanyContact;
  /** The company location to which the role is assigned. */
  readonly companyLocation: CompanyLocation;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the assignment record was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The role that's assigned to the company contact. */
  readonly role: CompanyContactRole;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the assignment record was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple CompanyContactRoleAssignments. */
export type CompanyContactRoleAssignmentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CompanyContactRoleAssignmentEdge>;
  /** A list of nodes that are contained in CompanyContactRoleAssignmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CompanyContactRoleAssignment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CompanyContactRoleAssignment and a cursor during pagination. */
export type CompanyContactRoleAssignmentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CompanyContactRoleAssignmentEdge. */
  readonly node: CompanyContactRoleAssignment;
};

/** The set of valid sort keys for the CompanyContactRoleAssignment query. */
export enum CompanyContactRoleAssignmentSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `location_name` value. */
  LOCATION_NAME = 'LOCATION_NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** An auto-generated type for paginating through multiple CompanyContactRoles. */
export type CompanyContactRoleConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CompanyContactRoleEdge>;
  /** A list of nodes that are contained in CompanyContactRoleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CompanyContactRole>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CompanyContactRole and a cursor during pagination. */
export type CompanyContactRoleEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CompanyContactRoleEdge. */
  readonly node: CompanyContactRole;
};

/** The set of valid sort keys for the CompanyContactRole query. */
export enum CompanyContactRoleSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Return type for `companyContactSendWelcomeEmail` mutation. */
export type CompanyContactSendWelcomeEmailPayload = {
  /** The company contact to whom a welcome email was sent. */
  readonly companyContact?: Maybe<CompanyContact>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** The set of valid sort keys for the CompanyContact query. */
export enum CompanyContactSortKeys {
  /** Sort by the `company_id` value. */
  COMPANY_ID = 'COMPANY_ID',
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `email` value. */
  EMAIL = 'EMAIL',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /** Sort by the `name_email` value. */
  NAME_EMAIL = 'NAME_EMAIL',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Return type for `companyContactUpdate` mutation. */
export type CompanyContactUpdatePayload = {
  /** The updated company contact. */
  readonly companyContact?: Maybe<CompanyContact>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyContactsDelete` mutation. */
export type CompanyContactsDeletePayload = {
  /** The list of IDs of the deleted company contacts. */
  readonly deletedCompanyContactIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** The input fields and values for creating a company and its associated resources. */
export type CompanyCreateInput = {
  /** The attributes for the company. */
  readonly company: CompanyInput;
  /** The attributes for the company contact. */
  readonly companyContact?: InputMaybe<CompanyContactInput>;
  /** The attributes for the company location. */
  readonly companyLocation?: InputMaybe<CompanyLocationInput>;
};

/** Return type for `companyCreate` mutation. */
export type CompanyCreatePayload = {
  /** The created company. */
  readonly company?: Maybe<Company>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyDelete` mutation. */
export type CompanyDeletePayload = {
  /** The ID of the deleted company. */
  readonly deletedCompanyId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** An auto-generated type which holds one Company and a cursor during pagination. */
export type CompanyEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CompanyEdge. */
  readonly node: Company;
};

/** The input fields for company attributes when creating or updating a company. */
export type CompanyInput = {
  /**
   * The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at
   *           which the company became the customer.
   */
  readonly customerSince?: InputMaybe<Scalars['DateTime']>;
  /** A unique externally-supplied ID for the company. */
  readonly externalId?: InputMaybe<Scalars['String']>;
  /** The name of the company. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** A note about the company. */
  readonly note?: InputMaybe<Scalars['String']>;
};

/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocation = CommentEventSubject & HasEvents & HasMetafieldDefinitions & HasMetafields & Navigable & Node & {
  /** The address used as billing address for the location. */
  readonly billingAddress?: Maybe<CompanyAddress>;
  /** The configuration for the buyer's B2B checkout. */
  readonly buyerExperienceConfiguration?: Maybe<BuyerExperienceConfiguration>;
  /** The list of catalogs associated with the company location. */
  readonly catalogs: CatalogConnection;
  /** The number of catalogs associated with the company location. Limited to a maximum of 10000. */
  readonly catalogsCount?: Maybe<Count>;
  /** The company that the company location belongs to. */
  readonly company: Company;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company location was created in Shopify. */
  readonly createdAt: Scalars['DateTime'];
  /** The location's currency based on the shipping address. If the shipping address is empty, then the value is the shop's primary market. */
  readonly currency: CurrencyCode;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** The list of draft orders for the company location. */
  readonly draftOrders: DraftOrderConnection;
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** A unique externally-supplied ID for the company location. */
  readonly externalId?: Maybe<Scalars['String']>;
  /** Whether the merchant added a timeline comment to the company location. */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether the company location is assigned a specific catalog. */
  readonly inCatalog: Scalars['Boolean'];
  /** The preferred locale of the company location. */
  readonly locale?: Maybe<Scalars['String']>;
  /** The market that includes the location's shipping address. If the shipping address is empty, then the value is the shop's primary market. */
  readonly market: Market;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** The name of the company location. */
  readonly name: Scalars['String'];
  /** A note about the company location. */
  readonly note?: Maybe<Scalars['String']>;
  /**
   * The total number of orders placed for the location.
   * @deprecated Use `ordersCount` instead.
   */
  readonly orderCount: Scalars['Int'];
  /** The list of orders for the company location. */
  readonly orders: OrderConnection;
  /** The total number of orders placed for the location. */
  readonly ordersCount?: Maybe<Count>;
  /** The phone number of the company location. */
  readonly phone?: Maybe<Scalars['String']>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The list of roles assigned to the company location. */
  readonly roleAssignments: CompanyContactRoleAssignmentConnection;
  /** The address used as shipping address for the location. */
  readonly shippingAddress?: Maybe<CompanyAddress>;
  /** The list of staff members assigned to the company location. */
  readonly staffMemberAssignments: CompanyLocationStaffMemberAssignmentConnection;
  /**
   * The list of tax exemptions applied to the location.
   * @deprecated Use `taxSettings` instead.
   */
  readonly taxExemptions: ReadonlyArray<TaxExemption>;
  /**
   * The tax registration ID for the company location.
   * @deprecated Use `taxSettings` instead.
   */
  readonly taxRegistrationId?: Maybe<Scalars['String']>;
  /** The total amount spent by the location. */
  readonly totalSpent: MoneyV2;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company location was last modified. */
  readonly updatedAt: Scalars['DateTime'];
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationInCatalogArgs = {
  catalogId: Scalars['ID'];
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationRoleAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanyContactRoleAssignmentSortKeys>;
};


/** A location or branch of a [company that's a customer](https://shopify.dev/api/admin-graphql/latest/objects/company) of the shop. Configuration of B2B relationship, for example prices lists and checkout settings, may be done for a location. */
export type CompanyLocationStaffMemberAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanyLocationStaffMemberAssignmentSortKeys>;
};

/** Return type for `companyLocationAssignAddress` mutation. */
export type CompanyLocationAssignAddressPayload = {
  /** The list of updated addresses on the company location. */
  readonly addresses?: Maybe<ReadonlyArray<CompanyAddress>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationAssignRoles` mutation. */
export type CompanyLocationAssignRolesPayload = {
  /** A list of newly created assignments of company contacts to a company location. */
  readonly roleAssignments?: Maybe<ReadonlyArray<CompanyContactRoleAssignment>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationAssignStaffMembers` mutation. */
export type CompanyLocationAssignStaffMembersPayload = {
  /** The list of created staff member assignments. */
  readonly companyLocationStaffMemberAssignments?: Maybe<ReadonlyArray<CompanyLocationStaffMemberAssignment>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationAssignTaxExemptions` mutation. */
export type CompanyLocationAssignTaxExemptionsPayload = {
  /** The updated company location. */
  readonly companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** A list of products with publishing and pricing information associated with company locations. */
export type CompanyLocationCatalog = Catalog & Node & {
  /** The company locations associated with the catalog. */
  readonly companyLocations: CompanyLocationConnection;
  /** The number of company locations associated with the catalog. */
  readonly companyLocationsCount?: Maybe<Count>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Most recent catalog operations. */
  readonly operations: ReadonlyArray<ResourceOperation>;
  /** The price list associated with the catalog. */
  readonly priceList?: Maybe<PriceList>;
  /** A group of products and collections that's published to a catalog. */
  readonly publication?: Maybe<Publication>;
  /** The status of the catalog. */
  readonly status: CatalogStatus;
  /** The name of the catalog. */
  readonly title: Scalars['String'];
};


/** A list of products with publishing and pricing information associated with company locations. */
export type CompanyLocationCatalogCompanyLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanyLocationSortKeys>;
};

/** An auto-generated type for paginating through multiple CompanyLocations. */
export type CompanyLocationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CompanyLocationEdge>;
  /** A list of nodes that are contained in CompanyLocationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CompanyLocation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `companyLocationCreate` mutation. */
export type CompanyLocationCreatePayload = {
  /** The created company location. */
  readonly companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationCreateTaxRegistration` mutation. */
export type CompanyLocationCreateTaxRegistrationPayload = {
  /** The company location with the created tax registration. */
  readonly companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationDelete` mutation. */
export type CompanyLocationDeletePayload = {
  /** The ID of the deleted company location. */
  readonly deletedCompanyLocationId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** An auto-generated type which holds one CompanyLocation and a cursor during pagination. */
export type CompanyLocationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CompanyLocationEdge. */
  readonly node: CompanyLocation;
};

/** The input fields for company location when creating or updating a company location. */
export type CompanyLocationInput = {
  /** The input fields to create or update the billing address for a company location. */
  readonly billingAddress?: InputMaybe<CompanyAddressInput>;
  /** Whether the billing address is the same as the shipping address. If the value is true, then the input for `billingAddress` is ignored. */
  readonly billingSameAsShipping?: InputMaybe<Scalars['Boolean']>;
  /** The configuration for the buyer's checkout at the company location. */
  readonly buyerExperienceConfiguration?: InputMaybe<BuyerExperienceConfigurationInput>;
  /** A unique externally-supplied ID for the company location. */
  readonly externalId?: InputMaybe<Scalars['String']>;
  /** The preferred locale of the company location. */
  readonly locale?: InputMaybe<Scalars['String']>;
  /** The name of the company location. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** A note about the company location. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The phone number of the company location. */
  readonly phone?: InputMaybe<Scalars['String']>;
  /** The input fields to create or update the shipping address for a company location. */
  readonly shippingAddress?: InputMaybe<CompanyAddressInput>;
  /** The list of tax exemptions to apply to the company location. */
  readonly taxExemptions?: InputMaybe<ReadonlyArray<TaxExemption>>;
  /** The tax registration ID of the company location. */
  readonly taxRegistrationId?: InputMaybe<Scalars['String']>;
};

/** Return type for `companyLocationRemoveStaffMembers` mutation. */
export type CompanyLocationRemoveStaffMembersPayload = {
  /** The list of IDs of the deleted staff member assignment. */
  readonly deletedCompanyLocationStaffMemberAssignmentIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationRevokeRoles` mutation. */
export type CompanyLocationRevokeRolesPayload = {
  /** A list of role assignment IDs that were removed from the company location. */
  readonly revokedRoleAssignmentIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationRevokeTaxExemptions` mutation. */
export type CompanyLocationRevokeTaxExemptionsPayload = {
  /** The updated company location. */
  readonly companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationRevokeTaxRegistration` mutation. */
export type CompanyLocationRevokeTaxRegistrationPayload = {
  /** The updated company location. */
  readonly companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** The input fields for the role and contact to assign on a location. */
export type CompanyLocationRoleAssign = {
  /** The company contact ID.. */
  readonly companyContactId: Scalars['ID'];
  /** The role ID. */
  readonly companyContactRoleId: Scalars['ID'];
};

/** The set of valid sort keys for the CompanyLocation query. */
export enum CompanyLocationSortKeys {
  /** Sort by the `company_and_location_name` value. */
  COMPANY_AND_LOCATION_NAME = 'COMPANY_AND_LOCATION_NAME',
  /** Sort by the `company_id` value. */
  COMPANY_ID = 'COMPANY_ID',
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** A representation of store's staff member who is assigned to a [company location](https://shopify.dev/api/admin-graphql/latest/objects/CompanyLocation) of the shop. The staff member's actions will be limited to objects associated with the assigned company location. */
export type CompanyLocationStaffMemberAssignment = Node & {
  /** The company location the staff member is assigned to. */
  readonly companyLocation: CompanyLocation;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Represents the data of a staff member who's assigned to a company location. */
  readonly staffMember: StaffMember;
};

/** An auto-generated type for paginating through multiple CompanyLocationStaffMemberAssignments. */
export type CompanyLocationStaffMemberAssignmentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CompanyLocationStaffMemberAssignmentEdge>;
  /** A list of nodes that are contained in CompanyLocationStaffMemberAssignmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CompanyLocationStaffMemberAssignment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CompanyLocationStaffMemberAssignment and a cursor during pagination. */
export type CompanyLocationStaffMemberAssignmentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CompanyLocationStaffMemberAssignmentEdge. */
  readonly node: CompanyLocationStaffMemberAssignment;
};

/** The set of valid sort keys for the CompanyLocationStaffMemberAssignment query. */
export enum CompanyLocationStaffMemberAssignmentSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** The input fields for company location when creating or updating a company location. */
export type CompanyLocationUpdateInput = {
  /** The configuration for the buyer's checkout at the company location. */
  readonly buyerExperienceConfiguration?: InputMaybe<BuyerExperienceConfigurationInput>;
  /** A unique externally-supplied ID for the company location. */
  readonly externalId?: InputMaybe<Scalars['String']>;
  /** The preferred locale of the company location. */
  readonly locale?: InputMaybe<Scalars['String']>;
  /** The name of the company location. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** A note about the company location. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The phone number of the company location. */
  readonly phone?: InputMaybe<Scalars['String']>;
};

/** Return type for `companyLocationUpdate` mutation. */
export type CompanyLocationUpdatePayload = {
  /** The updated company location. */
  readonly companyLocation?: Maybe<CompanyLocation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyLocationsDelete` mutation. */
export type CompanyLocationsDeletePayload = {
  /** A list of IDs of the deleted company locations. */
  readonly deletedCompanyLocationIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** Return type for `companyRevokeMainContact` mutation. */
export type CompanyRevokeMainContactPayload = {
  /** The company from which the main contact is revoked. */
  readonly company?: Maybe<Company>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** The set of valid sort keys for the Company query. */
export enum CompanySortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /** Sort by the `order_count` value. */
  ORDER_COUNT = 'ORDER_COUNT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `since_date` value. */
  SINCE_DATE = 'SINCE_DATE',
  /** Sort by the `total_spent` value. */
  TOTAL_SPENT = 'TOTAL_SPENT',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Return type for `companyUpdate` mutation. */
export type CompanyUpdatePayload = {
  /** The updated company. */
  readonly company?: Maybe<Company>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BusinessCustomerUserError>;
};

/** The input fields for the context data that determines the pricing of a variant. Refer to [Product](https://shopify.dev/docs/api/admin-graphql/latest/queries/product?example=Get+the+price+range+for+a+product+for+buyers+from+Canada)for more information on how to use this input object. */
export type ContextualPricingContext = {
  /** The CompanyLocation ID used to fetch company location specific prices. */
  readonly companyLocationId?: InputMaybe<Scalars['ID']>;
  /** The country code used to fetch country-specific prices. */
  readonly country?: InputMaybe<CountryCode>;
};

/** The context data that determines the publication status of a product. */
export type ContextualPublicationContext = {
  /** The company location ID used to fetch company-specific publication. */
  readonly companyLocationId?: InputMaybe<Scalars['ID']>;
  /** The country code used to fetch country-specific publication. */
  readonly country?: InputMaybe<CountryCode>;
};

/** Details for count of elements. */
export type Count = {
  /** The count of elements. */
  readonly count: Scalars['Int'];
  /** The count's precision, or the exactness of the value. */
  readonly precision: CountPrecision;
};

/** The precision of the value returned by a count field. */
export enum CountPrecision {
  /** The count is at least the value. A limit was imposed and reached. */
  AT_LEAST = 'AT_LEAST',
  /** The count is exactly the value. */
  EXACT = 'EXACT'
}

/** The list of all the countries from the combined shipping zones for the shop. */
export type CountriesInShippingZones = {
  /** The list of all the countries from all the combined shipping zones. */
  readonly countryCodes: ReadonlyArray<CountryCode>;
  /** Whether 'Rest of World' has been defined in any of the shipping zones. */
  readonly includeRestOfWorld: Scalars['Boolean'];
};

/**
 * The code designating a country/region, which generally follows ISO 3166-1 alpha-2 guidelines.
 * If a territory doesn't have a country code value in the `CountryCode` enum, then it might be considered a subdivision
 * of another country. For example, the territories associated with Spain are represented by the country code `ES`,
 * and the territories associated with the United States of America are represented by the country code `US`.
 */
export enum CountryCode {
  /** Ascension Island. */
  AC = 'AC',
  /** Andorra. */
  AD = 'AD',
  /** United Arab Emirates. */
  AE = 'AE',
  /** Afghanistan. */
  AF = 'AF',
  /** Antigua & Barbuda. */
  AG = 'AG',
  /** Anguilla. */
  AI = 'AI',
  /** Albania. */
  AL = 'AL',
  /** Armenia. */
  AM = 'AM',
  /** Netherlands Antilles. */
  AN = 'AN',
  /** Angola. */
  AO = 'AO',
  /** Argentina. */
  AR = 'AR',
  /** Austria. */
  AT = 'AT',
  /** Australia. */
  AU = 'AU',
  /** Aruba. */
  AW = 'AW',
  /** Åland Islands. */
  AX = 'AX',
  /** Azerbaijan. */
  AZ = 'AZ',
  /** Bosnia & Herzegovina. */
  BA = 'BA',
  /** Barbados. */
  BB = 'BB',
  /** Bangladesh. */
  BD = 'BD',
  /** Belgium. */
  BE = 'BE',
  /** Burkina Faso. */
  BF = 'BF',
  /** Bulgaria. */
  BG = 'BG',
  /** Bahrain. */
  BH = 'BH',
  /** Burundi. */
  BI = 'BI',
  /** Benin. */
  BJ = 'BJ',
  /** St. Barthélemy. */
  BL = 'BL',
  /** Bermuda. */
  BM = 'BM',
  /** Brunei. */
  BN = 'BN',
  /** Bolivia. */
  BO = 'BO',
  /** Caribbean Netherlands. */
  BQ = 'BQ',
  /** Brazil. */
  BR = 'BR',
  /** Bahamas. */
  BS = 'BS',
  /** Bhutan. */
  BT = 'BT',
  /** Bouvet Island. */
  BV = 'BV',
  /** Botswana. */
  BW = 'BW',
  /** Belarus. */
  BY = 'BY',
  /** Belize. */
  BZ = 'BZ',
  /** Canada. */
  CA = 'CA',
  /** Cocos (Keeling) Islands. */
  CC = 'CC',
  /** Congo - Kinshasa. */
  CD = 'CD',
  /** Central African Republic. */
  CF = 'CF',
  /** Congo - Brazzaville. */
  CG = 'CG',
  /** Switzerland. */
  CH = 'CH',
  /** Côte d’Ivoire. */
  CI = 'CI',
  /** Cook Islands. */
  CK = 'CK',
  /** Chile. */
  CL = 'CL',
  /** Cameroon. */
  CM = 'CM',
  /** China. */
  CN = 'CN',
  /** Colombia. */
  CO = 'CO',
  /** Costa Rica. */
  CR = 'CR',
  /** Cuba. */
  CU = 'CU',
  /** Cape Verde. */
  CV = 'CV',
  /** Curaçao. */
  CW = 'CW',
  /** Christmas Island. */
  CX = 'CX',
  /** Cyprus. */
  CY = 'CY',
  /** Czechia. */
  CZ = 'CZ',
  /** Germany. */
  DE = 'DE',
  /** Djibouti. */
  DJ = 'DJ',
  /** Denmark. */
  DK = 'DK',
  /** Dominica. */
  DM = 'DM',
  /** Dominican Republic. */
  DO = 'DO',
  /** Algeria. */
  DZ = 'DZ',
  /** Ecuador. */
  EC = 'EC',
  /** Estonia. */
  EE = 'EE',
  /** Egypt. */
  EG = 'EG',
  /** Western Sahara. */
  EH = 'EH',
  /** Eritrea. */
  ER = 'ER',
  /** Spain. */
  ES = 'ES',
  /** Ethiopia. */
  ET = 'ET',
  /** Finland. */
  FI = 'FI',
  /** Fiji. */
  FJ = 'FJ',
  /** Falkland Islands. */
  FK = 'FK',
  /** Faroe Islands. */
  FO = 'FO',
  /** France. */
  FR = 'FR',
  /** Gabon. */
  GA = 'GA',
  /** United Kingdom. */
  GB = 'GB',
  /** Grenada. */
  GD = 'GD',
  /** Georgia. */
  GE = 'GE',
  /** French Guiana. */
  GF = 'GF',
  /** Guernsey. */
  GG = 'GG',
  /** Ghana. */
  GH = 'GH',
  /** Gibraltar. */
  GI = 'GI',
  /** Greenland. */
  GL = 'GL',
  /** Gambia. */
  GM = 'GM',
  /** Guinea. */
  GN = 'GN',
  /** Guadeloupe. */
  GP = 'GP',
  /** Equatorial Guinea. */
  GQ = 'GQ',
  /** Greece. */
  GR = 'GR',
  /** South Georgia & South Sandwich Islands. */
  GS = 'GS',
  /** Guatemala. */
  GT = 'GT',
  /** Guinea-Bissau. */
  GW = 'GW',
  /** Guyana. */
  GY = 'GY',
  /** Hong Kong SAR. */
  HK = 'HK',
  /** Heard & McDonald Islands. */
  HM = 'HM',
  /** Honduras. */
  HN = 'HN',
  /** Croatia. */
  HR = 'HR',
  /** Haiti. */
  HT = 'HT',
  /** Hungary. */
  HU = 'HU',
  /** Indonesia. */
  ID = 'ID',
  /** Ireland. */
  IE = 'IE',
  /** Israel. */
  IL = 'IL',
  /** Isle of Man. */
  IM = 'IM',
  /** India. */
  IN = 'IN',
  /** British Indian Ocean Territory. */
  IO = 'IO',
  /** Iraq. */
  IQ = 'IQ',
  /** Iran. */
  IR = 'IR',
  /** Iceland. */
  IS = 'IS',
  /** Italy. */
  IT = 'IT',
  /** Jersey. */
  JE = 'JE',
  /** Jamaica. */
  JM = 'JM',
  /** Jordan. */
  JO = 'JO',
  /** Japan. */
  JP = 'JP',
  /** Kenya. */
  KE = 'KE',
  /** Kyrgyzstan. */
  KG = 'KG',
  /** Cambodia. */
  KH = 'KH',
  /** Kiribati. */
  KI = 'KI',
  /** Comoros. */
  KM = 'KM',
  /** St. Kitts & Nevis. */
  KN = 'KN',
  /** North Korea. */
  KP = 'KP',
  /** South Korea. */
  KR = 'KR',
  /** Kuwait. */
  KW = 'KW',
  /** Cayman Islands. */
  KY = 'KY',
  /** Kazakhstan. */
  KZ = 'KZ',
  /** Laos. */
  LA = 'LA',
  /** Lebanon. */
  LB = 'LB',
  /** St. Lucia. */
  LC = 'LC',
  /** Liechtenstein. */
  LI = 'LI',
  /** Sri Lanka. */
  LK = 'LK',
  /** Liberia. */
  LR = 'LR',
  /** Lesotho. */
  LS = 'LS',
  /** Lithuania. */
  LT = 'LT',
  /** Luxembourg. */
  LU = 'LU',
  /** Latvia. */
  LV = 'LV',
  /** Libya. */
  LY = 'LY',
  /** Morocco. */
  MA = 'MA',
  /** Monaco. */
  MC = 'MC',
  /** Moldova. */
  MD = 'MD',
  /** Montenegro. */
  ME = 'ME',
  /** St. Martin. */
  MF = 'MF',
  /** Madagascar. */
  MG = 'MG',
  /** North Macedonia. */
  MK = 'MK',
  /** Mali. */
  ML = 'ML',
  /** Myanmar (Burma). */
  MM = 'MM',
  /** Mongolia. */
  MN = 'MN',
  /** Macao SAR. */
  MO = 'MO',
  /** Martinique. */
  MQ = 'MQ',
  /** Mauritania. */
  MR = 'MR',
  /** Montserrat. */
  MS = 'MS',
  /** Malta. */
  MT = 'MT',
  /** Mauritius. */
  MU = 'MU',
  /** Maldives. */
  MV = 'MV',
  /** Malawi. */
  MW = 'MW',
  /** Mexico. */
  MX = 'MX',
  /** Malaysia. */
  MY = 'MY',
  /** Mozambique. */
  MZ = 'MZ',
  /** Namibia. */
  NA = 'NA',
  /** New Caledonia. */
  NC = 'NC',
  /** Niger. */
  NE = 'NE',
  /** Norfolk Island. */
  NF = 'NF',
  /** Nigeria. */
  NG = 'NG',
  /** Nicaragua. */
  NI = 'NI',
  /** Netherlands. */
  NL = 'NL',
  /** Norway. */
  NO = 'NO',
  /** Nepal. */
  NP = 'NP',
  /** Nauru. */
  NR = 'NR',
  /** Niue. */
  NU = 'NU',
  /** New Zealand. */
  NZ = 'NZ',
  /** Oman. */
  OM = 'OM',
  /** Panama. */
  PA = 'PA',
  /** Peru. */
  PE = 'PE',
  /** French Polynesia. */
  PF = 'PF',
  /** Papua New Guinea. */
  PG = 'PG',
  /** Philippines. */
  PH = 'PH',
  /** Pakistan. */
  PK = 'PK',
  /** Poland. */
  PL = 'PL',
  /** St. Pierre & Miquelon. */
  PM = 'PM',
  /** Pitcairn Islands. */
  PN = 'PN',
  /** Palestinian Territories. */
  PS = 'PS',
  /** Portugal. */
  PT = 'PT',
  /** Paraguay. */
  PY = 'PY',
  /** Qatar. */
  QA = 'QA',
  /** Réunion. */
  RE = 'RE',
  /** Romania. */
  RO = 'RO',
  /** Serbia. */
  RS = 'RS',
  /** Russia. */
  RU = 'RU',
  /** Rwanda. */
  RW = 'RW',
  /** Saudi Arabia. */
  SA = 'SA',
  /** Solomon Islands. */
  SB = 'SB',
  /** Seychelles. */
  SC = 'SC',
  /** Sudan. */
  SD = 'SD',
  /** Sweden. */
  SE = 'SE',
  /** Singapore. */
  SG = 'SG',
  /** St. Helena. */
  SH = 'SH',
  /** Slovenia. */
  SI = 'SI',
  /** Svalbard & Jan Mayen. */
  SJ = 'SJ',
  /** Slovakia. */
  SK = 'SK',
  /** Sierra Leone. */
  SL = 'SL',
  /** San Marino. */
  SM = 'SM',
  /** Senegal. */
  SN = 'SN',
  /** Somalia. */
  SO = 'SO',
  /** Suriname. */
  SR = 'SR',
  /** South Sudan. */
  SS = 'SS',
  /** São Tomé & Príncipe. */
  ST = 'ST',
  /** El Salvador. */
  SV = 'SV',
  /** Sint Maarten. */
  SX = 'SX',
  /** Syria. */
  SY = 'SY',
  /** Eswatini. */
  SZ = 'SZ',
  /** Tristan da Cunha. */
  TA = 'TA',
  /** Turks & Caicos Islands. */
  TC = 'TC',
  /** Chad. */
  TD = 'TD',
  /** French Southern Territories. */
  TF = 'TF',
  /** Togo. */
  TG = 'TG',
  /** Thailand. */
  TH = 'TH',
  /** Tajikistan. */
  TJ = 'TJ',
  /** Tokelau. */
  TK = 'TK',
  /** Timor-Leste. */
  TL = 'TL',
  /** Turkmenistan. */
  TM = 'TM',
  /** Tunisia. */
  TN = 'TN',
  /** Tonga. */
  TO = 'TO',
  /** Türkiye. */
  TR = 'TR',
  /** Trinidad & Tobago. */
  TT = 'TT',
  /** Tuvalu. */
  TV = 'TV',
  /** Taiwan. */
  TW = 'TW',
  /** Tanzania. */
  TZ = 'TZ',
  /** Ukraine. */
  UA = 'UA',
  /** Uganda. */
  UG = 'UG',
  /** U.S. Outlying Islands. */
  UM = 'UM',
  /** United States. */
  US = 'US',
  /** Uruguay. */
  UY = 'UY',
  /** Uzbekistan. */
  UZ = 'UZ',
  /** Vatican City. */
  VA = 'VA',
  /** St. Vincent & Grenadines. */
  VC = 'VC',
  /** Venezuela. */
  VE = 'VE',
  /** British Virgin Islands. */
  VG = 'VG',
  /** Vietnam. */
  VN = 'VN',
  /** Vanuatu. */
  VU = 'VU',
  /** Wallis & Futuna. */
  WF = 'WF',
  /** Samoa. */
  WS = 'WS',
  /** Kosovo. */
  XK = 'XK',
  /** Yemen. */
  YE = 'YE',
  /** Mayotte. */
  YT = 'YT',
  /** South Africa. */
  ZA = 'ZA',
  /** Zambia. */
  ZM = 'ZM',
  /** Zimbabwe. */
  ZW = 'ZW',
  /** Unknown Region. */
  ZZ = 'ZZ'
}

/** The country-specific harmonized system code and ISO country code for an inventory item. */
export type CountryHarmonizedSystemCode = {
  /** The ISO 3166-1 alpha-2 country code for the country that issued the specified harmonized system code. */
  readonly countryCode: CountryCode;
  /** The country-specific harmonized system code. These are usually longer than 6 digits. */
  readonly harmonizedSystemCode: Scalars['String'];
};

/** An auto-generated type for paginating through multiple CountryHarmonizedSystemCodes. */
export type CountryHarmonizedSystemCodeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CountryHarmonizedSystemCodeEdge>;
  /** A list of nodes that are contained in CountryHarmonizedSystemCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CountryHarmonizedSystemCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CountryHarmonizedSystemCode and a cursor during pagination. */
export type CountryHarmonizedSystemCodeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CountryHarmonizedSystemCodeEdge. */
  readonly node: CountryHarmonizedSystemCode;
};

/** The input fields required to specify a harmonized system code. */
export type CountryHarmonizedSystemCodeInput = {
  /** The ISO 3166-1 alpha-2 country code for the country that issued the specified harmonized system code. */
  readonly countryCode: CountryCode;
  /** Country specific harmonized system code. */
  readonly harmonizedSystemCode: Scalars['String'];
};

/** The input fields required to create a media object. */
export type CreateMediaInput = {
  /** The alt text associated with the media. */
  readonly alt?: InputMaybe<Scalars['String']>;
  /** The media content type. */
  readonly mediaContentType: MediaContentType;
  /** The original source of the media object. This might be an external URL or a staged upload URL. */
  readonly originalSource: Scalars['String'];
};

/** The part of the image that should remain after cropping. */
export enum CropRegion {
  /** Keep the bottom of the image. */
  BOTTOM = 'BOTTOM',
  /** Keep the center of the image. */
  CENTER = 'CENTER',
  /** Keep the left of the image. */
  LEFT = 'LEFT',
  /** Keep the right of the image. */
  RIGHT = 'RIGHT',
  /** Keep the top of the image. */
  TOP = 'TOP'
}

/**
 * The three-letter currency codes that represent the world currencies used in stores. Currency codes include
 * [standard ISO 4217 codes](https://en.wikipedia.org/wiki/ISO_4217), legacy codes, and non-standard codes.
 */
export enum CurrencyCode {
  /** United Arab Emirates Dirham (AED). */
  AED = 'AED',
  /** Afghan Afghani (AFN). */
  AFN = 'AFN',
  /** Albanian Lek (ALL). */
  ALL = 'ALL',
  /** Armenian Dram (AMD). */
  AMD = 'AMD',
  /** Netherlands Antillean Guilder. */
  ANG = 'ANG',
  /** Angolan Kwanza (AOA). */
  AOA = 'AOA',
  /** Argentine Pesos (ARS). */
  ARS = 'ARS',
  /** Australian Dollars (AUD). */
  AUD = 'AUD',
  /** Aruban Florin (AWG). */
  AWG = 'AWG',
  /** Azerbaijani Manat (AZN). */
  AZN = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark (BAM). */
  BAM = 'BAM',
  /** Barbadian Dollar (BBD). */
  BBD = 'BBD',
  /** Bangladesh Taka (BDT). */
  BDT = 'BDT',
  /** Bulgarian Lev (BGN). */
  BGN = 'BGN',
  /** Bahraini Dinar (BHD). */
  BHD = 'BHD',
  /** Burundian Franc (BIF). */
  BIF = 'BIF',
  /** Bermudian Dollar (BMD). */
  BMD = 'BMD',
  /** Brunei Dollar (BND). */
  BND = 'BND',
  /** Bolivian Boliviano (BOB). */
  BOB = 'BOB',
  /** Brazilian Real (BRL). */
  BRL = 'BRL',
  /** Bahamian Dollar (BSD). */
  BSD = 'BSD',
  /** Bhutanese Ngultrum (BTN). */
  BTN = 'BTN',
  /** Botswana Pula (BWP). */
  BWP = 'BWP',
  /** Belarusian Ruble (BYN). */
  BYN = 'BYN',
  /** Belarusian Ruble (BYR). */
  BYR = 'BYR',
  /** Belize Dollar (BZD). */
  BZD = 'BZD',
  /** Canadian Dollars (CAD). */
  CAD = 'CAD',
  /** Congolese franc (CDF). */
  CDF = 'CDF',
  /** Swiss Francs (CHF). */
  CHF = 'CHF',
  /** Chilean Peso (CLP). */
  CLP = 'CLP',
  /** Chinese Yuan Renminbi (CNY). */
  CNY = 'CNY',
  /** Colombian Peso (COP). */
  COP = 'COP',
  /** Costa Rican Colones (CRC). */
  CRC = 'CRC',
  /** Cape Verdean escudo (CVE). */
  CVE = 'CVE',
  /** Czech Koruny (CZK). */
  CZK = 'CZK',
  /** Djiboutian Franc (DJF). */
  DJF = 'DJF',
  /** Danish Kroner (DKK). */
  DKK = 'DKK',
  /** Dominican Peso (DOP). */
  DOP = 'DOP',
  /** Algerian Dinar (DZD). */
  DZD = 'DZD',
  /** Egyptian Pound (EGP). */
  EGP = 'EGP',
  /** Eritrean Nakfa (ERN). */
  ERN = 'ERN',
  /** Ethiopian Birr (ETB). */
  ETB = 'ETB',
  /** Euro (EUR). */
  EUR = 'EUR',
  /** Fijian Dollars (FJD). */
  FJD = 'FJD',
  /** Falkland Islands Pounds (FKP). */
  FKP = 'FKP',
  /** United Kingdom Pounds (GBP). */
  GBP = 'GBP',
  /** Georgian Lari (GEL). */
  GEL = 'GEL',
  /** Ghanaian Cedi (GHS). */
  GHS = 'GHS',
  /** Gibraltar Pounds (GIP). */
  GIP = 'GIP',
  /** Gambian Dalasi (GMD). */
  GMD = 'GMD',
  /** Guinean Franc (GNF). */
  GNF = 'GNF',
  /** Guatemalan Quetzal (GTQ). */
  GTQ = 'GTQ',
  /** Guyanese Dollar (GYD). */
  GYD = 'GYD',
  /** Hong Kong Dollars (HKD). */
  HKD = 'HKD',
  /** Honduran Lempira (HNL). */
  HNL = 'HNL',
  /** Croatian Kuna (HRK). */
  HRK = 'HRK',
  /** Haitian Gourde (HTG). */
  HTG = 'HTG',
  /** Hungarian Forint (HUF). */
  HUF = 'HUF',
  /** Indonesian Rupiah (IDR). */
  IDR = 'IDR',
  /** Israeli New Shekel (NIS). */
  ILS = 'ILS',
  /** Indian Rupees (INR). */
  INR = 'INR',
  /** Iraqi Dinar (IQD). */
  IQD = 'IQD',
  /** Iranian Rial (IRR). */
  IRR = 'IRR',
  /** Icelandic Kronur (ISK). */
  ISK = 'ISK',
  /** Jersey Pound. */
  JEP = 'JEP',
  /** Jamaican Dollars (JMD). */
  JMD = 'JMD',
  /** Jordanian Dinar (JOD). */
  JOD = 'JOD',
  /** Japanese Yen (JPY). */
  JPY = 'JPY',
  /** Kenyan Shilling (KES). */
  KES = 'KES',
  /** Kyrgyzstani Som (KGS). */
  KGS = 'KGS',
  /** Cambodian Riel. */
  KHR = 'KHR',
  /** Kiribati Dollar (KID). */
  KID = 'KID',
  /** Comorian Franc (KMF). */
  KMF = 'KMF',
  /** South Korean Won (KRW). */
  KRW = 'KRW',
  /** Kuwaiti Dinar (KWD). */
  KWD = 'KWD',
  /** Cayman Dollars (KYD). */
  KYD = 'KYD',
  /** Kazakhstani Tenge (KZT). */
  KZT = 'KZT',
  /** Laotian Kip (LAK). */
  LAK = 'LAK',
  /** Lebanese Pounds (LBP). */
  LBP = 'LBP',
  /** Sri Lankan Rupees (LKR). */
  LKR = 'LKR',
  /** Liberian Dollar (LRD). */
  LRD = 'LRD',
  /** Lesotho Loti (LSL). */
  LSL = 'LSL',
  /** Lithuanian Litai (LTL). */
  LTL = 'LTL',
  /** Latvian Lati (LVL). */
  LVL = 'LVL',
  /** Libyan Dinar (LYD). */
  LYD = 'LYD',
  /** Moroccan Dirham. */
  MAD = 'MAD',
  /** Moldovan Leu (MDL). */
  MDL = 'MDL',
  /** Malagasy Ariary (MGA). */
  MGA = 'MGA',
  /** Macedonia Denar (MKD). */
  MKD = 'MKD',
  /** Burmese Kyat (MMK). */
  MMK = 'MMK',
  /** Mongolian Tugrik. */
  MNT = 'MNT',
  /** Macanese Pataca (MOP). */
  MOP = 'MOP',
  /** Mauritanian Ouguiya (MRU). */
  MRU = 'MRU',
  /** Mauritian Rupee (MUR). */
  MUR = 'MUR',
  /** Maldivian Rufiyaa (MVR). */
  MVR = 'MVR',
  /** Malawian Kwacha (MWK). */
  MWK = 'MWK',
  /** Mexican Pesos (MXN). */
  MXN = 'MXN',
  /** Malaysian Ringgits (MYR). */
  MYR = 'MYR',
  /** Mozambican Metical. */
  MZN = 'MZN',
  /** Namibian Dollar. */
  NAD = 'NAD',
  /** Nigerian Naira (NGN). */
  NGN = 'NGN',
  /** Nicaraguan Córdoba (NIO). */
  NIO = 'NIO',
  /** Norwegian Kroner (NOK). */
  NOK = 'NOK',
  /** Nepalese Rupee (NPR). */
  NPR = 'NPR',
  /** New Zealand Dollars (NZD). */
  NZD = 'NZD',
  /** Omani Rial (OMR). */
  OMR = 'OMR',
  /** Panamian Balboa (PAB). */
  PAB = 'PAB',
  /** Peruvian Nuevo Sol (PEN). */
  PEN = 'PEN',
  /** Papua New Guinean Kina (PGK). */
  PGK = 'PGK',
  /** Philippine Peso (PHP). */
  PHP = 'PHP',
  /** Pakistani Rupee (PKR). */
  PKR = 'PKR',
  /** Polish Zlotych (PLN). */
  PLN = 'PLN',
  /** Paraguayan Guarani (PYG). */
  PYG = 'PYG',
  /** Qatari Rial (QAR). */
  QAR = 'QAR',
  /** Romanian Lei (RON). */
  RON = 'RON',
  /** Serbian dinar (RSD). */
  RSD = 'RSD',
  /** Russian Rubles (RUB). */
  RUB = 'RUB',
  /** Rwandan Franc (RWF). */
  RWF = 'RWF',
  /** Saudi Riyal (SAR). */
  SAR = 'SAR',
  /** Solomon Islands Dollar (SBD). */
  SBD = 'SBD',
  /** Seychellois Rupee (SCR). */
  SCR = 'SCR',
  /** Sudanese Pound (SDG). */
  SDG = 'SDG',
  /** Swedish Kronor (SEK). */
  SEK = 'SEK',
  /** Singapore Dollars (SGD). */
  SGD = 'SGD',
  /** Saint Helena Pounds (SHP). */
  SHP = 'SHP',
  /** Sierra Leonean Leone (SLL). */
  SLL = 'SLL',
  /** Somali Shilling (SOS). */
  SOS = 'SOS',
  /** Surinamese Dollar (SRD). */
  SRD = 'SRD',
  /** South Sudanese Pound (SSP). */
  SSP = 'SSP',
  /** Sao Tome And Principe Dobra (STD). */
  STD = 'STD',
  /** Sao Tome And Principe Dobra (STN). */
  STN = 'STN',
  /** Syrian Pound (SYP). */
  SYP = 'SYP',
  /** Swazi Lilangeni (SZL). */
  SZL = 'SZL',
  /** Thai baht (THB). */
  THB = 'THB',
  /** Tajikistani Somoni (TJS). */
  TJS = 'TJS',
  /** Turkmenistani Manat (TMT). */
  TMT = 'TMT',
  /** Tunisian Dinar (TND). */
  TND = 'TND',
  /** Tongan Pa'anga (TOP). */
  TOP = 'TOP',
  /** Turkish Lira (TRY). */
  TRY = 'TRY',
  /** Trinidad and Tobago Dollars (TTD). */
  TTD = 'TTD',
  /** Taiwan Dollars (TWD). */
  TWD = 'TWD',
  /** Tanzanian Shilling (TZS). */
  TZS = 'TZS',
  /** Ukrainian Hryvnia (UAH). */
  UAH = 'UAH',
  /** Ugandan Shilling (UGX). */
  UGX = 'UGX',
  /** United States Dollars (USD). */
  USD = 'USD',
  /** Uruguayan Pesos (UYU). */
  UYU = 'UYU',
  /** Uzbekistan som (UZS). */
  UZS = 'UZS',
  /** Venezuelan Bolivares (VED). */
  VED = 'VED',
  /** Venezuelan Bolivares (VEF). */
  VEF = 'VEF',
  /** Venezuelan Bolivares Soberanos (VES). */
  VES = 'VES',
  /** Vietnamese đồng (VND). */
  VND = 'VND',
  /** Vanuatu Vatu (VUV). */
  VUV = 'VUV',
  /** Samoan Tala (WST). */
  WST = 'WST',
  /** Central African CFA Franc (XAF). */
  XAF = 'XAF',
  /** East Caribbean Dollar (XCD). */
  XCD = 'XCD',
  /** West African CFA franc (XOF). */
  XOF = 'XOF',
  /** CFP Franc (XPF). */
  XPF = 'XPF',
  /** Unrecognized currency. */
  XXX = 'XXX',
  /** Yemeni Rial (YER). */
  YER = 'YER',
  /** South African Rand (ZAR). */
  ZAR = 'ZAR',
  /** Zambian Kwacha (ZMW). */
  ZMW = 'ZMW'
}

/** Currency formats configured for the merchant. These formats are available to use within Liquid. */
export type CurrencyFormats = {
  /** Money without currency in HTML. */
  readonly moneyFormat: Scalars['FormattedString'];
  /** Money without currency in emails. */
  readonly moneyInEmailsFormat: Scalars['String'];
  /** Money with currency in HTML. */
  readonly moneyWithCurrencyFormat: Scalars['FormattedString'];
  /** Money with currency in emails. */
  readonly moneyWithCurrencyInEmailsFormat: Scalars['String'];
};

/** A setting for a presentment currency. */
export type CurrencySetting = {
  /** The currency's ISO code. */
  readonly currencyCode: CurrencyCode;
  /** The full name of the currency. */
  readonly currencyName: Scalars['String'];
  /** Whether the currency is enabled or not. An enabled currency setting is visible to buyers and allows orders to be generated with that currency as presentment. */
  readonly enabled: Scalars['Boolean'];
  /** The date and time when the active exchange rate for the currency was last modified. It can be the automatic rate's creation date, or the manual rate's last updated at date if active. */
  readonly rateUpdatedAt?: Maybe<Scalars['DateTime']>;
};

/** An auto-generated type for paginating through multiple CurrencySettings. */
export type CurrencySettingConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CurrencySettingEdge>;
  /** A list of nodes that are contained in CurrencySettingEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CurrencySetting>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CurrencySetting and a cursor during pagination. */
export type CurrencySettingEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CurrencySettingEdge. */
  readonly node: CurrencySetting;
};

/** The input fields for a custom shipping package used to pack shipment. */
export type CustomShippingPackageInput = {
  /** The default package is the one used to calculate shipping costs on checkout. */
  readonly default?: InputMaybe<Scalars['Boolean']>;
  /** Outside dimensions of the empty shipping package. */
  readonly dimensions?: InputMaybe<ObjectDimensionsInput>;
  /** Descriptive name for the package. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Type of package. */
  readonly type?: InputMaybe<ShippingPackageType>;
  /** Weight of the empty shipping package. */
  readonly weight?: InputMaybe<WeightInput>;
};

/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type Customer = CommentEventSubject & HasEvents & HasMetafieldDefinitions & HasMetafields & HasStoreCreditAccounts & LegacyInteroperability & Node & {
  /** A list of addresses associated with the customer. */
  readonly addresses: ReadonlyArray<MailingAddress>;
  /** The addresses associated with the customer. */
  readonly addressesV2: MailingAddressConnection;
  /** The total amount that the customer has spent on orders in their lifetime. */
  readonly amountSpent: MoneyV2;
  /**
   * Whether the merchant can delete the customer from their store.
   *
   * A customer can be deleted from a store only if they haven't yet made an order. After a customer makes an
   * order, they can't be deleted from a store.
   */
  readonly canDelete: Scalars['Boolean'];
  /** A list of the customer's company contact profiles. */
  readonly companyContactProfiles: ReadonlyArray<CompanyContact>;
  /** The date and time when the customer was added to the store. */
  readonly createdAt: Scalars['DateTime'];
  /** Whether the customer has opted out of having their data sold. */
  readonly dataSaleOptOut: Scalars['Boolean'];
  /** The default address associated with the customer. */
  readonly defaultAddress?: Maybe<MailingAddress>;
  /**
   * The full name of the customer, based on the values for first_name and last_name. If the first_name and
   * last_name are not available, then this falls back to the customer's email address, and if that is not available, the customer's phone number.
   */
  readonly displayName: Scalars['String'];
  /**
   * The customer's email address.
   * @deprecated Use `defaultEmailAddress.emailAddress` instead.
   */
  readonly email?: Maybe<Scalars['String']>;
  /**
   * The current email marketing state for the customer.
   * If the customer doesn't have an email address, then this property is `null`.
   * @deprecated Use `defaultEmailAddress.marketingState`, `defaultEmailAddress.marketingOptInLevel`, `defaultEmailAddress.marketingUpdatedAt`, and `defaultEmailAddress.sourceLocation` instead.
   */
  readonly emailMarketingConsent?: Maybe<CustomerEmailMarketingConsentState>;
  /** A list of events associated with the customer. */
  readonly events: EventConnection;
  /** The customer's first name. */
  readonly firstName?: Maybe<Scalars['String']>;
  /**
   * Whether the merchant has added timeline comments about the customer on the customer's page.
   * @deprecated To query for comments on the timeline, use the events connection and a `query` argument containing `verb:comment`, or look for a `CommentEvent` in the `__typename` of events.
   */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image associated with the customer. */
  readonly image: Image;
  /** The customer's last name. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The customer's last order. */
  readonly lastOrder?: Maybe<Order>;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /**
   * The amount of time since the customer was first added to the store.
   *
   * Example: 'about 12 years'.
   */
  readonly lifetimeDuration: Scalars['String'];
  /** The customer's locale. */
  readonly locale: Scalars['String'];
  /** The market that includes the customer’s default address. */
  readonly market?: Maybe<Market>;
  /** Whether the customer can be merged with another customer. */
  readonly mergeable: CustomerMergeable;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** A unique identifier for the customer that's used with Multipass login. */
  readonly multipassIdentifier?: Maybe<Scalars['String']>;
  /** A note about the customer. */
  readonly note?: Maybe<Scalars['String']>;
  /** The number of orders that the customer has made at the store in their lifetime. */
  readonly numberOfOrders: Scalars['UnsignedInt64'];
  /** A list of the customer's orders. */
  readonly orders: OrderConnection;
  /** A list of the customer's payment methods. */
  readonly paymentMethods: CustomerPaymentMethodConnection;
  /**
   * The customer's phone number.
   * @deprecated Use `defaultPhoneNumber.phoneNumber` instead.
   */
  readonly phone?: Maybe<Scalars['String']>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** Possible subscriber states of a customer defined by their subscription contracts. */
  readonly productSubscriberStatus: CustomerProductSubscriberStatus;
  /**
   * The current SMS marketing state for the customer's phone number.
   *
   * If the customer does not have a phone number, then this property is `null`.
   * @deprecated Use `defaultPhoneNumber.marketingState`, `defaultPhoneNumber.marketingOptInLevel`, `defaultPhoneNumber.marketingUpdatedAt`, `defaultPhoneNumber.marketingCollectedFrom`, and `defaultPhoneNumber.sourceLocation` instead.
   */
  readonly smsMarketingConsent?: Maybe<CustomerSmsMarketingConsentState>;
  /**
   * The state of the customer's account with the shop.
   *
   * Please note that this only meaningful when Classic Customer Accounts is active.
   */
  readonly state: CustomerState;
  /** The statistics for a given customer. */
  readonly statistics: CustomerStatistics;
  /**
   * Returns a list of store credit accounts that belong to the owner resource.
   * A store credit account owner can hold multiple accounts each with a different currency.
   */
  readonly storeCreditAccounts: StoreCreditAccountConnection;
  /** A list of the customer's subscription contracts. */
  readonly subscriptionContracts: SubscriptionContractConnection;
  /** A comma separated list of tags that have been added to the customer. */
  readonly tags: ReadonlyArray<Scalars['String']>;
  /** Whether the customer is exempt from being charged taxes on their orders. */
  readonly taxExempt: Scalars['Boolean'];
  /** The list of tax exemptions applied to the customer. */
  readonly taxExemptions: ReadonlyArray<TaxExemption>;
  /**
   * The URL to unsubscribe the customer from the mailing list.
   * @deprecated Use `defaultEmailAddress.marketingUnsubscribeUrl` instead.
   */
  readonly unsubscribeUrl: Scalars['URL'];
  /** The date and time when the customer was last updated. */
  readonly updatedAt: Scalars['DateTime'];
  /**
   * Whether the email address is formatted correctly.
   *
   * Returns `true` when the email is formatted correctly and
   * belongs to an existing domain. This doesn't guarantee that
   * the email address actually exists.
   * @deprecated Use `defaultEmailAddress.validFormat` instead.
   */
  readonly validEmailAddress: Scalars['Boolean'];
  /** Whether the customer has verified their email address. Defaults to `true` if the customer is created through the Shopify admin or API. */
  readonly verifiedEmail: Scalars['Boolean'];
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerAddressesArgs = {
  first?: InputMaybe<Scalars['Int']>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerAddressesV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  showRevoked?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerStoreCreditAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


/**
 * Represents information about a customer of the shop, such as the customer's contact details, their order
 * history, and whether they've agreed to receive marketing material by email.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type CustomerSubscriptionContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An app extension page for the customer account navigation menu. */
export type CustomerAccountAppExtensionPage = CustomerAccountPage & Navigable & Node & {
  /** The UUID of the app extension. */
  readonly appExtensionUuid?: Maybe<Scalars['String']>;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** A unique, human-friendly string for the customer account page. */
  readonly handle: Scalars['String'];
  /** The unique ID for the customer account page. */
  readonly id: Scalars['ID'];
  /** The title of the customer account page. */
  readonly title: Scalars['String'];
};

/** A native page for the customer account navigation menu. */
export type CustomerAccountNativePage = CustomerAccountPage & Navigable & Node & {
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** A unique, human-friendly string for the customer account page. */
  readonly handle: Scalars['String'];
  /** The unique ID for the customer account page. */
  readonly id: Scalars['ID'];
  /** The type of customer account native page. */
  readonly pageType: CustomerAccountNativePagePageType;
  /** The title of the customer account page. */
  readonly title: Scalars['String'];
};

/** The type of customer account native page. */
export enum CustomerAccountNativePagePageType {
  /** An orders page type. */
  NATIVE_ORDERS = 'NATIVE_ORDERS',
  /** A profile page type. */
  NATIVE_PROFILE = 'NATIVE_PROFILE',
  /** A settings page type. */
  NATIVE_SETTINGS = 'NATIVE_SETTINGS',
  /** An unknown page type. Represents new page types that may be added in future versions. */
  UNKNOWN = 'UNKNOWN'
}

/** A customer account page. */
export type CustomerAccountPage = {
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** A unique, human-friendly string for the customer account page. */
  readonly handle: Scalars['String'];
  /** The unique ID for the customer account page. */
  readonly id: Scalars['ID'];
  /** The title of the customer account page. */
  readonly title: Scalars['String'];
};

/** An auto-generated type for paginating through multiple CustomerAccountPages. */
export type CustomerAccountPageConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CustomerAccountPageEdge>;
  /** A list of nodes that are contained in CustomerAccountPageEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CustomerAccountPage>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CustomerAccountPage and a cursor during pagination. */
export type CustomerAccountPageEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CustomerAccountPageEdge. */
  readonly node: CustomerAccountPage;
};

/** Information about the shop's customer accounts. */
export type CustomerAccountsV2 = {
  /** Indicates which version of customer accounts the merchant is using in online store and checkout. */
  readonly customerAccountsVersion: CustomerAccountsVersion;
  /** Login links are shown in online store and checkout. */
  readonly loginLinksVisibleOnStorefrontAndCheckout: Scalars['Boolean'];
  /** Customers are required to log in to their account before checkout. */
  readonly loginRequiredAtCheckout: Scalars['Boolean'];
  /** The root url for the customer accounts pages. */
  readonly url?: Maybe<Scalars['URL']>;
};

/** The login redirection target for customer accounts. */
export enum CustomerAccountsVersion {
  /** The customer is redirected to the classic customer accounts login page. */
  CLASSIC = 'CLASSIC',
  /** The customer is redirected to the new customer accounts login page. */
  NEW_CUSTOMER_ACCOUNTS = 'NEW_CUSTOMER_ACCOUNTS'
}

/** Return type for `customerAddTaxExemptions` mutation. */
export type CustomerAddTaxExemptionsPayload = {
  /** The updated customer. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Possible error codes that can be returned by `CustomerCancelDataErasureUserError`. */
export enum CustomerCancelDataErasureErrorCode {
  /** Customer does not exist. */
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  /** Failed to cancel customer data erasure. */
  FAILED_TO_CANCEL = 'FAILED_TO_CANCEL',
  /** Customer's data is not scheduled for erasure. */
  NOT_BEING_ERASED = 'NOT_BEING_ERASED'
}

/** Return type for `customerCancelDataErasure` mutation. */
export type CustomerCancelDataErasurePayload = {
  /** The ID of the customer whose pending data erasure has been cancelled. */
  readonly customerId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerCancelDataErasureUserError>;
};

/** An error that occurs when cancelling a customer data erasure request. */
export type CustomerCancelDataErasureUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerCancelDataErasureErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** An auto-generated type for paginating through multiple Customers. */
export type CustomerConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CustomerEdge>;
  /** A list of nodes that are contained in CustomerEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Customer>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The source that collected the customer's consent to receive marketing materials. */
export enum CustomerConsentCollectedFrom {
  /** The customer consent was collected outside of Shopify. */
  OTHER = 'OTHER',
  /** The customer consent was collected by Shopify. */
  SHOPIFY = 'SHOPIFY'
}

/** Return type for `customerCreate` mutation. */
export type CustomerCreatePayload = {
  /** The created customer. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents a card instrument for customer payment method. */
export type CustomerCreditCard = {
  /** The billing address of the card. */
  readonly billingAddress?: Maybe<CustomerCreditCardBillingAddress>;
  /** The brand of the card. */
  readonly brand: Scalars['String'];
  /** Whether the card is about to expire. */
  readonly expiresSoon: Scalars['Boolean'];
  /** The expiry month of the card. */
  readonly expiryMonth: Scalars['Int'];
  /** The expiry year of the card. */
  readonly expiryYear: Scalars['Int'];
  /** The card's BIN number. */
  readonly firstDigits?: Maybe<Scalars['String']>;
  /** The payment method can be revoked if there are no active subscription contracts. */
  readonly isRevocable: Scalars['Boolean'];
  /** The last 4 digits of the card. */
  readonly lastDigits: Scalars['String'];
  /** The masked card number with only the last 4 digits displayed. */
  readonly maskedNumber: Scalars['String'];
  /** The name of the card holder. */
  readonly name: Scalars['String'];
  /** The source of the card if coming from a wallet such as Apple Pay. */
  readonly source?: Maybe<Scalars['String']>;
  /** The last 4 digits of the Device Account Number. */
  readonly virtualLastDigits?: Maybe<Scalars['String']>;
};

/** The billing address of a credit card payment instrument. */
export type CustomerCreditCardBillingAddress = {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: Maybe<Scalars['String']>;
  /** The name of the country. */
  readonly country?: Maybe<Scalars['String']>;
  /**
   * The two-letter code for the country of the address.
   * For example, US.
   */
  readonly countryCode?: Maybe<CountryCode>;
  /** The first name in the billing address. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** The last name in the billing address. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The region of the address, such as the province, state, or district. */
  readonly province?: Maybe<Scalars['String']>;
  /**
   * The alphanumeric code for the region.
   * For example, ON.
   */
  readonly provinceCode?: Maybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** The input fields to delete a customer. */
export type CustomerDeleteInput = {
  /** The ID of the customer to delete. */
  readonly id: Scalars['ID'];
};

/** Return type for `customerDelete` mutation. */
export type CustomerDeletePayload = {
  /** The ID of the deleted customer. */
  readonly deletedCustomerId?: Maybe<Scalars['ID']>;
  /** The shop of the deleted customer. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one Customer and a cursor during pagination. */
export type CustomerEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CustomerEdge. */
  readonly node: Customer;
};

/** Represents an email address. */
export type CustomerEmailAddress = {
  /** The customer's default email address. */
  readonly emailAddress: Scalars['String'];
  /** Whether the customer has subscribed to email marketing. */
  readonly marketingState: CustomerEmailAddressMarketingState;
  /** The URL to unsubscribe a member from all mailing lists. */
  readonly marketingUnsubscribeUrl: Scalars['URL'];
  /** Whether the customer has opted in to having their opened emails tracked. */
  readonly openTrackingLevel: CustomerEmailAddressOpenTrackingLevel;
  /** The URL that can be used to opt a customer in or out of email open tracking. */
  readonly openTrackingUrl: Scalars['URL'];
};

/** Possible marketing states for the customer’s email address. */
export enum CustomerEmailAddressMarketingState {
  /** The customer’s email address marketing state is invalid. */
  INVALID = 'INVALID',
  /** The customer is not subscribed to email marketing. */
  NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
  /** The customer is in the process of subscribing to email marketing. */
  PENDING = 'PENDING',
  /** The customer is subscribed to email marketing. */
  SUBSCRIBED = 'SUBSCRIBED',
  /** The customer is not subscribed to email marketing but was previously subscribed. */
  UNSUBSCRIBED = 'UNSUBSCRIBED'
}

/** The different levels related to whether a customer has opted in to having their opened emails tracked. */
export enum CustomerEmailAddressOpenTrackingLevel {
  /** The customer has opted in to having their open emails tracked. */
  OPTED_IN = 'OPTED_IN',
  /** The customer has opted out of having their open emails tracked. */
  OPTED_OUT = 'OPTED_OUT',
  /** The customer has not specified whether they want to opt in or out of having their open emails tracked. */
  UNKNOWN = 'UNKNOWN'
}

/**
 * Information that describes when a customer consented to
 *         receiving marketing material by email.
 */
export type CustomerEmailMarketingConsentInput = {
  /**
   * The latest date and time when the customer consented or objected to
   *           receiving marketing material by email.
   */
  readonly consentUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The customer opt-in level at the time of subscribing to marketing material. */
  readonly marketingOptInLevel?: InputMaybe<CustomerMarketingOptInLevel>;
  /**
   * The current marketing state associated with the customer's email.
   *           If the customer doesn't have an email, then this field is `null`.
   */
  readonly marketingState: CustomerEmailMarketingState;
};

/** The record of when a customer consented to receive marketing material by email. */
export type CustomerEmailMarketingConsentState = {
  /**
   * The date and time at which the customer consented to receive marketing material by email.
   * The customer's consent state reflects the consent record with the most recent `consent_updated_at` date.
   * If no date is provided, then the date and time at which the consent information was sent is used.
   */
  readonly consentUpdatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The marketing subscription opt-in level, as described by the M3AAWG best practices guidelines,
   * that the customer gave when they consented to receive marketing material by email.
   */
  readonly marketingOptInLevel?: Maybe<CustomerMarketingOptInLevel>;
  /** The current email marketing state for the customer. */
  readonly marketingState: CustomerEmailMarketingState;
};

/** The input fields for the email consent information to update for a given customer ID. */
export type CustomerEmailMarketingConsentUpdateInput = {
  /** The ID of the customer for which to update the email marketing consent information. The customer must have a unique email address associated to the record. If not, add the email address using the `customerUpdate` mutation first. */
  readonly customerId: Scalars['ID'];
  /** The marketing consent information when the customer consented to receiving marketing material by email. */
  readonly emailMarketingConsent: CustomerEmailMarketingConsentInput;
};

/** Return type for `customerEmailMarketingConsentUpdate` mutation. */
export type CustomerEmailMarketingConsentUpdatePayload = {
  /** The updated customer. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerEmailMarketingConsentUpdateUserError>;
};

/** An error that occurs during the execution of `CustomerEmailMarketingConsentUpdate`. */
export type CustomerEmailMarketingConsentUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerEmailMarketingConsentUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerEmailMarketingConsentUpdateUserError`. */
export enum CustomerEmailMarketingConsentUpdateUserErrorCode {
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** Unexpected internal error happened. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Missing a required argument. */
  MISSING_ARGUMENT = 'MISSING_ARGUMENT'
}

/** The possible email marketing states for a customer. */
export enum CustomerEmailMarketingState {
  /** The customer’s email address marketing state is invalid. */
  INVALID = 'INVALID',
  /** The customer isn't subscribed to email marketing. */
  NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
  /** The customer is in the process of subscribing to email marketing. */
  PENDING = 'PENDING',
  /** The customer's personal data is erased. This value is internally-set and read-only. */
  REDACTED = 'REDACTED',
  /** The customer is subscribed to email marketing. */
  SUBSCRIBED = 'SUBSCRIBED',
  /** The customer isn't currently subscribed to email marketing but was previously subscribed. */
  UNSUBSCRIBED = 'UNSUBSCRIBED'
}

/** Return type for `customerGenerateAccountActivationUrl` mutation. */
export type CustomerGenerateAccountActivationUrlPayload = {
  /** The generated account activation URL. */
  readonly accountActivationUrl?: Maybe<Scalars['URL']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields and values to use when creating or updating a customer. */
export type CustomerInput = {
  /** The addresses for a customer. */
  readonly addresses?: InputMaybe<ReadonlyArray<MailingAddressInput>>;
  /** The unique email address of the customer. */
  readonly email?: InputMaybe<Scalars['String']>;
  /**
   * Information that describes when the customer consented to receiving marketing
   *         material by email. The `email` field is required when creating a customer with email marketing
   *         consent information.
   */
  readonly emailMarketingConsent?: InputMaybe<CustomerEmailMarketingConsentInput>;
  /** The customer's first name. */
  readonly firstName?: InputMaybe<Scalars['String']>;
  /** The ID of the customer to update. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The customer's last name. */
  readonly lastName?: InputMaybe<Scalars['String']>;
  /** The customer's locale. */
  readonly locale?: InputMaybe<Scalars['String']>;
  /** Additional metafields to associate to the customer. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** A note about the customer. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The unique phone number for the customer. */
  readonly phone?: InputMaybe<Scalars['String']>;
  /**
   * The marketing consent information when the customer consented to receiving marketing
   *         material by SMS. The `phone` field is required when creating a customer with SMS
   *         marketing consent information.
   */
  readonly smsMarketingConsent?: InputMaybe<CustomerSmsMarketingConsentInput>;
  /**
   * A list of tags to associate with the customer. Can be an array or a comma-separated list. Example values: `["tag1", "tag2", "tag3"]`, `"tag1, tag2, tag3"`
   *
   * Updating `tags` overwrites any existing tags that were previously added to the customer. To add new tags without overwriting
   * existing tags, use the [tagsAdd](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** Whether the customer is exempt from paying taxes on their order. */
  readonly taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** The list of tax exemptions to apply to the customer. */
  readonly taxExemptions?: InputMaybe<ReadonlyArray<TaxExemption>>;
};

/** Represents a customer's visiting activities on a shop's online store. */
export type CustomerJourney = {
  /** The position of the current order within the customer's order history. */
  readonly customerOrderIndex: Scalars['Int'];
  /** The amount of days between first session and order creation date. First session represents first session since the last order, or first session within the 30 day attribution window, if more than 30 days has passed since the last order. */
  readonly daysToConversion: Scalars['Int'];
  /** The customer's first session going into the shop. */
  readonly firstVisit: CustomerVisit;
  /** The last session before an order is made. */
  readonly lastVisit?: Maybe<CustomerVisit>;
  /** Events preceding a customer order, such as shop sessions. */
  readonly moments: ReadonlyArray<CustomerMoment>;
};

/** Represents a customer's visiting activities on a shop's online store. */
export type CustomerJourneySummary = {
  /** The position of the current order within the customer's order history. Test orders aren't included. */
  readonly customerOrderIndex?: Maybe<Scalars['Int']>;
  /** The number of days between the first session and the order creation date. The first session represents the first session since the last order, or the first session within the 30 day attribution window, if more than 30 days have passed since the last order. */
  readonly daysToConversion?: Maybe<Scalars['Int']>;
  /** The customer's first session going into the shop. */
  readonly firstVisit?: Maybe<CustomerVisit>;
  /** The last session before an order is made. */
  readonly lastVisit?: Maybe<CustomerVisit>;
  /** The events preceding a customer's order, such as shop sessions. */
  readonly moments?: Maybe<CustomerMomentConnection>;
  /** The total number of customer moments associated with this order. Returns null if the order is still in the process of being attributed. */
  readonly momentsCount?: Maybe<Count>;
  /** Whether the attributed sessions for the order have been created yet. */
  readonly ready: Scalars['Boolean'];
};


/** Represents a customer's visiting activities on a shop's online store. */
export type CustomerJourneySummaryMomentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The possible values for the marketing subscription opt-in level enabled at the time the customer consented to receive marketing information.
 *
 * The levels are defined by [the M3AAWG best practices guideline
 *   document](https://www.m3aawg.org/sites/maawg/files/news/M3AAWG_Senders_BCP_Ver3-2015-02.pdf).
 */
export enum CustomerMarketingOptInLevel {
  /**
   * After providing their information, the customer receives a confirmation and is required to
   * perform a intermediate step before receiving marketing information.
   */
  CONFIRMED_OPT_IN = 'CONFIRMED_OPT_IN',
  /**
   * After providing their information, the customer receives marketing information without any
   * intermediate steps.
   */
  SINGLE_OPT_IN = 'SINGLE_OPT_IN',
  /** The customer receives marketing information but how they were opted in is unknown. */
  UNKNOWN = 'UNKNOWN'
}

/** The error blocking a customer merge. */
export type CustomerMergeError = {
  /** The list of fields preventing the customer from being merged. */
  readonly errorFields: ReadonlyArray<CustomerMergeErrorFieldType>;
  /** The customer merge error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerMergeUserError`. */
export enum CustomerMergeErrorCode {
  /** The customer cannot be merged because it has associated gift cards. */
  CUSTOMER_HAS_GIFT_CARDS = 'CUSTOMER_HAS_GIFT_CARDS',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The customer cannot be merged. */
  INVALID_CUSTOMER = 'INVALID_CUSTOMER',
  /** The customer ID is invalid. */
  INVALID_CUSTOMER_ID = 'INVALID_CUSTOMER_ID',
  /** The customer is missing the attribute requested for override. */
  MISSING_OVERRIDE_ATTRIBUTE = 'MISSING_OVERRIDE_ATTRIBUTE',
  /** The override attribute is invalid. */
  OVERRIDE_ATTRIBUTE_INVALID = 'OVERRIDE_ATTRIBUTE_INVALID'
}

/** The types of the hard blockers preventing a customer from being merged to another customer. */
export enum CustomerMergeErrorFieldType {
  /** The customer is a company contact. */
  COMPANY_CONTACT = 'COMPANY_CONTACT',
  /** The customer has payment methods. */
  CUSTOMER_PAYMENT_METHODS = 'CUSTOMER_PAYMENT_METHODS',
  /** The customer does not exist. */
  DELETED_AT = 'DELETED_AT',
  /** The customer has gift cards. */
  GIFT_CARDS = 'GIFT_CARDS',
  /** The customer has a merge in progress. */
  MERGE_IN_PROGRESS = 'MERGE_IN_PROGRESS',
  /** The customer has a multipass identifier. */
  MULTIPASS_IDENTIFIER = 'MULTIPASS_IDENTIFIER',
  /** The override fields are invalid. */
  OVERRIDE_FIELDS = 'OVERRIDE_FIELDS',
  /** The customer has a pending data request. */
  PENDING_DATA_REQUEST = 'PENDING_DATA_REQUEST',
  /** The customer has a pending or completed redaction. */
  REDACTED_AT = 'REDACTED_AT',
  /** The customer has store credit. */
  STORE_CREDIT = 'STORE_CREDIT',
  /** The customer has a subscription history. */
  SUBSCRIPTIONS = 'SUBSCRIPTIONS'
}

/** The input fields to override default customer merge rules. */
export type CustomerMergeOverrideFields = {
  /** The ID of the customer whose default address will be kept. */
  readonly customerIdOfDefaultAddressToKeep?: InputMaybe<Scalars['ID']>;
  /** The ID of the customer whose email will be kept. */
  readonly customerIdOfEmailToKeep?: InputMaybe<Scalars['ID']>;
  /** The ID of the customer whose first name will be kept. */
  readonly customerIdOfFirstNameToKeep?: InputMaybe<Scalars['ID']>;
  /** The ID of the customer whose last name will be kept. */
  readonly customerIdOfLastNameToKeep?: InputMaybe<Scalars['ID']>;
  /** The ID of the customer whose phone number will be kept. */
  readonly customerIdOfPhoneNumberToKeep?: InputMaybe<Scalars['ID']>;
  /** The note to keep. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The tags to keep. */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

/** Return type for `customerMerge` mutation. */
export type CustomerMergePayload = {
  /** The asynchronous job for merging the customers. */
  readonly job?: Maybe<Job>;
  /** The ID of the customer resulting from the merge. */
  readonly resultingCustomerId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerMergeUserError>;
};

/** A preview of the results of a customer merge request. */
export type CustomerMergePreview = {
  /** The fields that can be used to override the default fields. */
  readonly alternateFields?: Maybe<CustomerMergePreviewAlternateFields>;
  /** The fields that will block the merge if the two customers are merged. */
  readonly blockingFields?: Maybe<CustomerMergePreviewBlockingFields>;
  /** The errors blocking the customer merge. */
  readonly customerMergeErrors?: Maybe<ReadonlyArray<CustomerMergeError>>;
  /** The fields that will be kept if the two customers are merged. */
  readonly defaultFields?: Maybe<CustomerMergePreviewDefaultFields>;
  /** The resulting customer ID if the two customers are merged. */
  readonly resultingCustomerId?: Maybe<Scalars['ID']>;
};

/** The fields that can be used to override the default fields. */
export type CustomerMergePreviewAlternateFields = {
  /** The default address of a customer. */
  readonly defaultAddress?: Maybe<MailingAddress>;
  /** The email state of a customer. */
  readonly email?: Maybe<CustomerEmailAddress>;
  /** The first name of a customer. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** The last name of a customer. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The phone number state of a customer. */
  readonly phoneNumber?: Maybe<CustomerPhoneNumber>;
};

/** The blocking fields of a customer merge preview. These fields will block customer merge unless edited. */
export type CustomerMergePreviewBlockingFields = {
  /** The merged note resulting from a customer merge. The merged note is over the 5000 character limit and will block customer merge. */
  readonly note?: Maybe<Scalars['String']>;
  /** The merged tags resulting from a customer merge. The merged tags are over the 250 limit and will block customer merge. */
  readonly tags: ReadonlyArray<Scalars['String']>;
};

/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFields = {
  /** The merged addresses resulting from a customer merge. */
  readonly addresses: MailingAddressConnection;
  /** The default address resulting from a customer merge. */
  readonly defaultAddress?: Maybe<MailingAddress>;
  /** The total number of customer-specific discounts resulting from a customer merge. */
  readonly discountNodeCount: Scalars['UnsignedInt64'];
  /** The merged customer-specific discounts resulting from a customer merge. */
  readonly discountNodes: DiscountNodeConnection;
  /** The full name of the customer, based on the values for `first_name` and `last_name`. If `first_name` and `last_name` aren't available, then this field falls back to the customer's email address. If the customer's email isn't available, then this field falls back to the customer's phone number. */
  readonly displayName: Scalars['String'];
  /** The total number of merged draft orders. */
  readonly draftOrderCount: Scalars['UnsignedInt64'];
  /** The merged draft orders resulting from a customer merge. */
  readonly draftOrders: DraftOrderConnection;
  /** The email state of a customer. */
  readonly email?: Maybe<CustomerEmailAddress>;
  /** The first name resulting from a customer merge. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** The total number of merged gift cards. */
  readonly giftCardCount: Scalars['UnsignedInt64'];
  /** The merged gift cards resulting from a customer merge. */
  readonly giftCards: GiftCardConnection;
  /** The last name resulting from a customer merge. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The total number of merged metafields. */
  readonly metafieldCount: Scalars['UnsignedInt64'];
  /** The merged note resulting from a customer merge. */
  readonly note?: Maybe<Scalars['String']>;
  /** The total number of merged orders. */
  readonly orderCount: Scalars['UnsignedInt64'];
  /** The merged orders resulting from a customer merge. */
  readonly orders: OrderConnection;
  /** The phone number state of a customer. */
  readonly phoneNumber?: Maybe<CustomerPhoneNumber>;
  /** The merged tags resulting from a customer merge. */
  readonly tags: ReadonlyArray<Scalars['String']>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsAddressesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsDiscountNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<DiscountSortKeys>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<GiftCardSortKeys>;
};


/** The fields that will be kept as part of a customer merge preview. */
export type CustomerMergePreviewDefaultFieldsOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};

/** A merge request for merging two customers. */
export type CustomerMergeRequest = {
  /** The merge errors that occurred during the customer merge request. */
  readonly customerMergeErrors: ReadonlyArray<CustomerMergeError>;
  /** The UUID of the merge job. */
  readonly jobId?: Maybe<Scalars['ID']>;
  /** The ID of the customer resulting from the merge. */
  readonly resultingCustomerId: Scalars['ID'];
  /** The status of the customer merge request. */
  readonly status: CustomerMergeRequestStatus;
};

/** The status of the customer merge request. */
export enum CustomerMergeRequestStatus {
  /** The customer merge request has been completed. */
  COMPLETED = 'COMPLETED',
  /** The customer merge request has failed. */
  FAILED = 'FAILED',
  /** The customer merge request is currently in progress. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The customer merge request has been requested. */
  REQUESTED = 'REQUESTED'
}

/** An error that occurs while merging two customers. */
export type CustomerMergeUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerMergeErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** An object that represents whether a customer can be merged with another customer. */
export type CustomerMergeable = {
  /** The list of fields preventing the customer from being merged. */
  readonly errorFields: ReadonlyArray<CustomerMergeErrorFieldType>;
  /** Whether the customer can be merged with another customer. */
  readonly isMergeable: Scalars['Boolean'];
  /** The merge request if one is currently in progress. */
  readonly mergeInProgress?: Maybe<CustomerMergeRequest>;
  /** The reason why the customer can't be merged with another customer. */
  readonly reason?: Maybe<Scalars['String']>;
};

/** Represents a session preceding an order, often used for building a timeline of events leading to an order. */
export type CustomerMoment = {
  /** The date and time when the customer's session occurred. */
  readonly occurredAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple CustomerMoments. */
export type CustomerMomentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CustomerMomentEdge>;
  /** A list of nodes that are contained in CustomerMomentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CustomerMoment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CustomerMoment and a cursor during pagination. */
export type CustomerMomentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CustomerMomentEdge. */
  readonly node: CustomerMoment;
};

/** All possible instruments for CustomerPaymentMethods. */
export type CustomerPaymentInstrument = CustomerCreditCard | CustomerPaypalBillingAgreement | CustomerShopPayAgreement;

/** The billing address of a payment instrument. */
export type CustomerPaymentInstrumentBillingAddress = {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: Maybe<Scalars['String']>;
  /** The name of the country. */
  readonly country?: Maybe<Scalars['String']>;
  /**
   * The two-letter code for the country of the address.
   * For example, US.
   */
  readonly countryCode?: Maybe<CountryCode>;
  /** The name of the buyer of the address. */
  readonly name?: Maybe<Scalars['String']>;
  /** The region of the address, such as the province, state, or district. */
  readonly province?: Maybe<Scalars['String']>;
  /**
   * The alphanumeric code for the region.
   * For example, ON.
   */
  readonly provinceCode?: Maybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** A customer's payment method. */
export type CustomerPaymentMethod = Node & {
  /** The customer to whom the payment method belongs. */
  readonly customer?: Maybe<Customer>;
  /** The ID of this payment method. */
  readonly id: Scalars['ID'];
  /** The instrument for this payment method. */
  readonly instrument?: Maybe<CustomerPaymentInstrument>;
  /** The time that the payment method was revoked. */
  readonly revokedAt?: Maybe<Scalars['DateTime']>;
  /** The revocation reason for this payment method. */
  readonly revokedReason?: Maybe<CustomerPaymentMethodRevocationReason>;
  /** List Subscription Contracts. */
  readonly subscriptionContracts: SubscriptionContractConnection;
};


/** A customer's payment method. */
export type CustomerPaymentMethodSubscriptionContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple CustomerPaymentMethods. */
export type CustomerPaymentMethodConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CustomerPaymentMethodEdge>;
  /** A list of nodes that are contained in CustomerPaymentMethodEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CustomerPaymentMethod>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `customerPaymentMethodCreateFromDuplicationData` mutation. */
export type CustomerPaymentMethodCreateFromDuplicationDataPayload = {
  /** The customer payment method. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerPaymentMethodCreateFromDuplicationDataUserError>;
};

/** An error that occurs during the execution of `CustomerPaymentMethodCreateFromDuplicationData`. */
export type CustomerPaymentMethodCreateFromDuplicationDataUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerPaymentMethodCreateFromDuplicationDataUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodCreateFromDuplicationDataUserError`. */
export enum CustomerPaymentMethodCreateFromDuplicationDataUserErrorCode {
  /** Customer doesn't exist. */
  CUSTOMER_DOES_NOT_EXIST = 'CUSTOMER_DOES_NOT_EXIST',
  /** Invalid encrypted duplication data. */
  INVALID_ENCRYPTED_DUPLICATION_DATA = 'INVALID_ENCRYPTED_DUPLICATION_DATA',
  /** Too many requests. */
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS'
}

/** Return type for `customerPaymentMethodCreditCardCreate` mutation. */
export type CustomerPaymentMethodCreditCardCreatePayload = {
  /** The customer payment method. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** If the card verification result is processing. When this is true, customer_payment_method will be null. */
  readonly processing?: Maybe<Scalars['Boolean']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `customerPaymentMethodCreditCardUpdate` mutation. */
export type CustomerPaymentMethodCreditCardUpdatePayload = {
  /** The customer payment method. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** If the card verification result is processing. When this is true, customer_payment_method will be null. */
  readonly processing?: Maybe<Scalars['Boolean']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one CustomerPaymentMethod and a cursor during pagination. */
export type CustomerPaymentMethodEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CustomerPaymentMethodEdge. */
  readonly node: CustomerPaymentMethod;
};

/** Return type for `customerPaymentMethodGetDuplicationData` mutation. */
export type CustomerPaymentMethodGetDuplicationDataPayload = {
  /** The encrypted data from the payment method to be duplicated. */
  readonly encryptedDuplicationData?: Maybe<Scalars['String']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerPaymentMethodGetDuplicationDataUserError>;
};

/** An error that occurs during the execution of `CustomerPaymentMethodGetDuplicationData`. */
export type CustomerPaymentMethodGetDuplicationDataUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerPaymentMethodGetDuplicationDataUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodGetDuplicationDataUserError`. */
export enum CustomerPaymentMethodGetDuplicationDataUserErrorCode {
  /** Customer doesn't exist. */
  CUSTOMER_DOES_NOT_EXIST = 'CUSTOMER_DOES_NOT_EXIST',
  /** Invalid payment instrument. */
  INVALID_INSTRUMENT = 'INVALID_INSTRUMENT',
  /** Must be targeted to another shop in the same organization. */
  INVALID_ORGANIZATION_SHOP = 'INVALID_ORGANIZATION_SHOP',
  /** Payment method doesn't exist. */
  PAYMENT_METHOD_DOES_NOT_EXIST = 'PAYMENT_METHOD_DOES_NOT_EXIST',
  /** Target shop cannot be the same as the source. */
  SAME_SHOP = 'SAME_SHOP',
  /** Too many requests. */
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS'
}

/** Return type for `customerPaymentMethodGetUpdateUrl` mutation. */
export type CustomerPaymentMethodGetUpdateUrlPayload = {
  /** The URL to redirect the customer to update the payment method. */
  readonly updatePaymentMethodUrl?: Maybe<Scalars['URL']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerPaymentMethodGetUpdateUrlUserError>;
};

/** An error that occurs during the execution of `CustomerPaymentMethodGetUpdateUrl`. */
export type CustomerPaymentMethodGetUpdateUrlUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerPaymentMethodGetUpdateUrlUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodGetUpdateUrlUserError`. */
export enum CustomerPaymentMethodGetUpdateUrlUserErrorCode {
  /** Customer doesn't exist. */
  CUSTOMER_DOES_NOT_EXIST = 'CUSTOMER_DOES_NOT_EXIST',
  /** Invalid payment instrument. */
  INVALID_INSTRUMENT = 'INVALID_INSTRUMENT',
  /** Payment method doesn't exist. */
  PAYMENT_METHOD_DOES_NOT_EXIST = 'PAYMENT_METHOD_DOES_NOT_EXIST',
  /** Too many requests. */
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS'
}

/** Return type for `customerPaymentMethodPaypalBillingAgreementCreate` mutation. */
export type CustomerPaymentMethodPaypalBillingAgreementCreatePayload = {
  /** The customer payment method. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerPaymentMethodUserError>;
};

/** Return type for `customerPaymentMethodPaypalBillingAgreementUpdate` mutation. */
export type CustomerPaymentMethodPaypalBillingAgreementUpdatePayload = {
  /** The customer payment method. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerPaymentMethodUserError>;
};

/** Return type for `customerPaymentMethodRemoteCreate` mutation. */
export type CustomerPaymentMethodRemoteCreatePayload = {
  /** The customer payment method. Note that the returned payment method may initially be in an incomplete state. Developers should poll this payment method using the customerPaymentMethod query until all required payment details have been processed. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerPaymentMethodRemoteUserError>;
};

/** Return type for `customerPaymentMethodRemoteCreditCardCreate` mutation. */
export type CustomerPaymentMethodRemoteCreditCardCreatePayload = {
  /** The customer payment method. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerPaymentMethodUserError>;
};

/** The input fields for a remote gateway payment method, only one remote reference permitted. */
export type CustomerPaymentMethodRemoteInput = {
  /** The input fields for a remote authorize net customer profile. */
  readonly authorizeNetCustomerPaymentProfile?: InputMaybe<RemoteAuthorizeNetCustomerPaymentProfileInput>;
  /** The input fields for a remote Braintree customer profile. */
  readonly braintreePaymentMethod?: InputMaybe<RemoteBraintreePaymentMethodInput>;
  /** Input containing the fields for a remote stripe credit card. */
  readonly stripePaymentMethod?: InputMaybe<RemoteStripePaymentMethodInput>;
};

/** Represents an error in the input of a mutation. */
export type CustomerPaymentMethodRemoteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerPaymentMethodRemoteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodRemoteUserError`. */
export enum CustomerPaymentMethodRemoteUserErrorCode {
  /** Authorize.net is not enabled for subscriptions. */
  AUTHORIZE_NET_NOT_ENABLED_FOR_SUBSCRIPTIONS = 'AUTHORIZE_NET_NOT_ENABLED_FOR_SUBSCRIPTIONS',
  /** Braintree is not enabled for subscriptions. */
  BRAINTREE_NOT_ENABLED_FOR_SUBSCRIPTIONS = 'BRAINTREE_NOT_ENABLED_FOR_SUBSCRIPTIONS',
  /** Exactly one remote reference is required. */
  EXACTLY_ONE_REMOTE_REFERENCE_REQUIRED = 'EXACTLY_ONE_REMOTE_REFERENCE_REQUIRED',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The input value is already taken. */
  TAKEN = 'TAKEN'
}

/** The revocation reason types for a customer payment method. */
export enum CustomerPaymentMethodRevocationReason {
  /** The Authorize.net payment gateway is not enabled. */
  AUTHORIZE_NET_GATEWAY_NOT_ENABLED = 'AUTHORIZE_NET_GATEWAY_NOT_ENABLED',
  /** Authorize.net did not return any payment methods. Make sure that the correct Authorize.net account is linked. */
  AUTHORIZE_NET_RETURNED_NO_PAYMENT_METHOD = 'AUTHORIZE_NET_RETURNED_NO_PAYMENT_METHOD',
  /** Failed to contact Braintree API. */
  BRAINTREE_API_AUTHENTICATION_ERROR = 'BRAINTREE_API_AUTHENTICATION_ERROR',
  /** The Braintree payment gateway is not enabled. */
  BRAINTREE_GATEWAY_NOT_ENABLED = 'BRAINTREE_GATEWAY_NOT_ENABLED',
  /** The Braintree payment method type should be a credit card or Apple Pay card. */
  BRAINTREE_PAYMENT_METHOD_NOT_CARD = 'BRAINTREE_PAYMENT_METHOD_NOT_CARD',
  /** Braintree returned no payment methods. Make sure the correct Braintree account is linked. */
  BRAINTREE_RETURNED_NO_PAYMENT_METHOD = 'BRAINTREE_RETURNED_NO_PAYMENT_METHOD',
  /** The billing address failed to retrieve. */
  FAILED_TO_RETRIEVE_BILLING_ADDRESS = 'FAILED_TO_RETRIEVE_BILLING_ADDRESS',
  /** The credit card failed to update. */
  FAILED_TO_UPDATE_CREDIT_CARD = 'FAILED_TO_UPDATE_CREDIT_CARD',
  /** The payment method was manually revoked. */
  MANUALLY_REVOKED = 'MANUALLY_REVOKED',
  /** The payment method was replaced with an existing payment method. The associated contracts have been migrated to the other payment method. */
  MERGED = 'MERGED',
  /** Failed to contact the Stripe API. */
  STRIPE_API_AUTHENTICATION_ERROR = 'STRIPE_API_AUTHENTICATION_ERROR',
  /** Invalid request. Failed to retrieve payment method from Stripe. */
  STRIPE_API_INVALID_REQUEST_ERROR = 'STRIPE_API_INVALID_REQUEST_ERROR',
  /** The Stripe payment gateway is not enabled. */
  STRIPE_GATEWAY_NOT_ENABLED = 'STRIPE_GATEWAY_NOT_ENABLED',
  /** The Stripe payment method type should be card. */
  STRIPE_PAYMENT_METHOD_NOT_CARD = 'STRIPE_PAYMENT_METHOD_NOT_CARD',
  /** Stripe did not return any payment methods. Make sure that the correct Stripe account is linked. */
  STRIPE_RETURNED_NO_PAYMENT_METHOD = 'STRIPE_RETURNED_NO_PAYMENT_METHOD'
}

/** Return type for `customerPaymentMethodRevoke` mutation. */
export type CustomerPaymentMethodRevokePayload = {
  /** The ID of the revoked customer payment method. */
  readonly revokedCustomerPaymentMethodId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `customerPaymentMethodSendUpdateEmail` mutation. */
export type CustomerPaymentMethodSendUpdateEmailPayload = {
  /** The customer to whom an update payment method email was sent. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents an error in the input of a mutation. */
export type CustomerPaymentMethodUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerPaymentMethodUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerPaymentMethodUserError`. */
export enum CustomerPaymentMethodUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The input value is already taken. */
  TAKEN = 'TAKEN'
}

/** Represents a PayPal instrument for customer payment method. */
export type CustomerPaypalBillingAgreement = {
  /** The billing address of this payment method. */
  readonly billingAddress?: Maybe<CustomerPaymentInstrumentBillingAddress>;
  /** Whether the PayPal billing agreement is inactive. */
  readonly inactive: Scalars['Boolean'];
  /** Whether the payment method can be revoked.The payment method can be revoked if there are no active subscription contracts. */
  readonly isRevocable: Scalars['Boolean'];
  /** The customers's PayPal account email address. */
  readonly paypalAccountEmail?: Maybe<Scalars['String']>;
};

/** A phone number. */
export type CustomerPhoneNumber = {
  /** Whether the customer has subscribed to SMS marketing material. */
  readonly marketingState: CustomerSmsMarketingState;
  /** A customer's phone number. */
  readonly phoneNumber: Scalars['String'];
};

/** The valid tiers for the predicted spend of a customer with a shop. */
export enum CustomerPredictedSpendTier {
  /** The customer's spending is predicted to be in the top spending range for the shop in the following year. */
  HIGH = 'HIGH',
  /** The customer's spending is predicted to be zero, or in the lowest spending range for the shop in the following year. */
  LOW = 'LOW',
  /** The customer's spending is predicted to be in the normal spending range for the shop in the following year. */
  MEDIUM = 'MEDIUM'
}

/** The possible product subscription states for a customer, as defined by the customer's subscription contracts. */
export enum CustomerProductSubscriberStatus {
  /** The customer has at least one active subscription contract. */
  ACTIVE = 'ACTIVE',
  /**
   * The customer's last subscription contract was cancelled and there are no other active or paused
   * subscription contracts.
   */
  CANCELLED = 'CANCELLED',
  /**
   * The customer's last subscription contract expired and there are no other active or paused
   * subscription contracts.
   */
  EXPIRED = 'EXPIRED',
  /**
   * The customer's last subscription contract failed and there are no other active or paused
   * subscription contracts.
   */
  FAILED = 'FAILED',
  /** The customer has never had a subscription contract. */
  NEVER_SUBSCRIBED = 'NEVER_SUBSCRIBED',
  /**
   * The customer has at least one paused subscription contract and there are no other active
   * subscription contracts.
   */
  PAUSED = 'PAUSED'
}

/** Return type for `customerRemoveTaxExemptions` mutation. */
export type CustomerRemoveTaxExemptionsPayload = {
  /** The updated customer. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `customerReplaceTaxExemptions` mutation. */
export type CustomerReplaceTaxExemptionsPayload = {
  /** The updated customer. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Possible error codes that can be returned by `CustomerRequestDataErasureUserError`. */
export enum CustomerRequestDataErasureErrorCode {
  /** Customer does not exist. */
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  /** Failed to request customer data erasure. */
  FAILED_TO_REQUEST = 'FAILED_TO_REQUEST'
}

/** Return type for `customerRequestDataErasure` mutation. */
export type CustomerRequestDataErasurePayload = {
  /** The ID of the customer that will be erased. */
  readonly customerId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerRequestDataErasureUserError>;
};

/** An error that occurs when requesting a customer data erasure. */
export type CustomerRequestDataErasureUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerRequestDataErasureErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** The set of valid sort keys for the CustomerSavedSearch query. */
export enum CustomerSavedSearchSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The member of a segment. */
export type CustomerSegmentMember = HasMetafields & {
  /** The total amount of money that the member has spent on orders. */
  readonly amountSpent?: Maybe<MoneyV2>;
  /** The member's default address. */
  readonly defaultAddress?: Maybe<MailingAddress>;
  /** The member's default email address. */
  readonly defaultEmailAddress?: Maybe<CustomerEmailAddress>;
  /** The member's default phone number. */
  readonly defaultPhoneNumber?: Maybe<CustomerPhoneNumber>;
  /** The full name of the member, which is based on the values of the `first_name` and `last_name` fields. If the member's first name and last name aren't available, then the customer's email address is used. If the customer's email address isn't available, then the customer's phone number is used. */
  readonly displayName: Scalars['String'];
  /** The member's first name. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** The member’s ID. */
  readonly id: Scalars['ID'];
  /** The member's last name. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The ID of the member's most recent order. */
  readonly lastOrderId?: Maybe<Scalars['ID']>;
  /** Whether the customer can be merged with another customer. */
  readonly mergeable: CustomerMergeable;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** A note about the member. */
  readonly note?: Maybe<Scalars['String']>;
  /** The total number of orders that the member has made. */
  readonly numberOfOrders?: Maybe<Scalars['UnsignedInt64']>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
};


/** The member of a segment. */
export type CustomerSegmentMemberMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** The member of a segment. */
export type CustomerSegmentMemberMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The member of a segment. */
export type CustomerSegmentMemberPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** The member of a segment. */
export type CustomerSegmentMemberPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for the `CustomerSegmentMembers` object. */
export type CustomerSegmentMemberConnection = {
  /** A list of edges. */
  readonly edges: ReadonlyArray<CustomerSegmentMemberEdge>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
  /** The statistics for a given segment. */
  readonly statistics: SegmentStatistics;
  /** The total number of members in a given segment. */
  readonly totalCount: Scalars['Int'];
};

/** An auto-generated type which holds one CustomerSegmentMember and a cursor during pagination. */
export type CustomerSegmentMemberEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CustomerSegmentMemberEdge. */
  readonly node: CustomerSegmentMember;
};

/** A job to determine a list of members, such as customers, that are associated with an individual segment. */
export type CustomerSegmentMembersQuery = JobResult & Node & {
  /** The current total number of members in a given segment. */
  readonly currentCount: Scalars['Int'];
  /** This indicates if the job is still queued or has been run. */
  readonly done: Scalars['Boolean'];
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  readonly id: Scalars['ID'];
};

/** Return type for `customerSegmentMembersQueryCreate` mutation. */
export type CustomerSegmentMembersQueryCreatePayload = {
  /** The newly created customer segment members query. */
  readonly customerSegmentMembersQuery?: Maybe<CustomerSegmentMembersQuery>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerSegmentMembersQueryUserError>;
};

/** The input fields and values for creating a customer segment members query. */
export type CustomerSegmentMembersQueryInput = {
  /** The query that's used to filter the members. The query is composed of a combination of conditions on facts about customers such as `email_subscription_status = 'SUBSCRIBED'` with [this syntax](https://shopify.dev/api/shopifyql/segment-query-language-reference). */
  readonly query?: InputMaybe<Scalars['String']>;
  /** Reverse the order of the list. The sorting behaviour defaults to ascending order. */
  readonly reverse?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the segment. */
  readonly segmentId?: InputMaybe<Scalars['ID']>;
  /** Sort the list by a given key. */
  readonly sortKey?: InputMaybe<Scalars['String']>;
};

/** Represents a customer segment members query custom error. */
export type CustomerSegmentMembersQueryUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerSegmentMembersQueryUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerSegmentMembersQueryUserError`. */
export enum CustomerSegmentMembersQueryUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Return type for `customerSendAccountInviteEmail` mutation. */
export type CustomerSendAccountInviteEmailPayload = {
  /** The customer to whom an account invite email was sent. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerSendAccountInviteEmailUserError>;
};

/** Defines errors for customerSendAccountInviteEmail mutation. */
export type CustomerSendAccountInviteEmailUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerSendAccountInviteEmailUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerSendAccountInviteEmailUserError`. */
export enum CustomerSendAccountInviteEmailUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Represents a Shop Pay card instrument for customer payment method. */
export type CustomerShopPayAgreement = {
  /** The billing address of the card. */
  readonly billingAddress?: Maybe<CustomerCreditCardBillingAddress>;
  /** Whether the card is about to expire. */
  readonly expiresSoon: Scalars['Boolean'];
  /** The expiry month of the card. */
  readonly expiryMonth: Scalars['Int'];
  /** The expiry year of the card. */
  readonly expiryYear: Scalars['Int'];
  /** Whether the Shop Pay billing agreement is inactive. */
  readonly inactive: Scalars['Boolean'];
  /** The payment method can be revoked if there are no active subscription contracts. */
  readonly isRevocable: Scalars['Boolean'];
  /** The last 4 digits of the card. */
  readonly lastDigits: Scalars['String'];
  /** The masked card number with only the last 4 digits displayed. */
  readonly maskedNumber: Scalars['String'];
  /** The name of the card holder. */
  readonly name: Scalars['String'];
};

/** An error that occurs during execution of an SMS marketing consent mutation. */
export type CustomerSmsMarketingConsentError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<CustomerSmsMarketingConsentErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `CustomerSmsMarketingConsentError`. */
export enum CustomerSmsMarketingConsentErrorCode {
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** Unexpected internal error happened. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Missing a required argument. */
  MISSING_ARGUMENT = 'MISSING_ARGUMENT'
}

/**
 * The marketing consent information when the customer consented to
 *         receiving marketing material by SMS.
 */
export type CustomerSmsMarketingConsentInput = {
  /**
   * The date and time when the customer consented to receive marketing material by SMS.
   * If no date is provided, then the date and time when the consent information was sent is used.
   */
  readonly consentUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The marketing subscription opt-in level that was set when the customer consented to receive marketing information. */
  readonly marketingOptInLevel?: InputMaybe<CustomerMarketingOptInLevel>;
  /** The current SMS marketing state for the customer. */
  readonly marketingState: CustomerSmsMarketingState;
};

/**
 * The record of when a customer consented to receive marketing material by SMS.
 *
 * The customer's consent state reflects the record with the most recent date when consent was updated.
 */
export type CustomerSmsMarketingConsentState = {
  /** The source from which the SMS marketing information for the customer was collected. */
  readonly consentCollectedFrom?: Maybe<CustomerConsentCollectedFrom>;
  /**
   * The date and time when the customer consented to receive marketing material by SMS.
   * If no date is provided, then the date and time when the consent information was sent is used.
   */
  readonly consentUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The marketing subscription opt-in level that was set when the customer consented to receive marketing information. */
  readonly marketingOptInLevel: CustomerMarketingOptInLevel;
  /** The current SMS marketing state for the customer. */
  readonly marketingState: CustomerSmsMarketingState;
};

/** The input fields for updating SMS marketing consent information for a given customer ID. */
export type CustomerSmsMarketingConsentUpdateInput = {
  /** The ID of the customer to update the SMS marketing consent information for. The customer must have a unique phone number associated to the record. If not, add the phone number using the `customerUpdate` mutation first. */
  readonly customerId: Scalars['ID'];
  /** The marketing consent information when the customer consented to receiving marketing material by SMS. */
  readonly smsMarketingConsent: CustomerSmsMarketingConsentInput;
};

/** Return type for `customerSmsMarketingConsentUpdate` mutation. */
export type CustomerSmsMarketingConsentUpdatePayload = {
  /** The updated customer. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<CustomerSmsMarketingConsentError>;
};

/** The valid SMS marketing states for a customer’s phone number. */
export enum CustomerSmsMarketingState {
  /** The customer hasn't subscribed to SMS marketing. */
  NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
  /** The customer is in the process of subscribing to SMS marketing. */
  PENDING = 'PENDING',
  /** The customer's personal data is erased. This value is internally-set and read-only. */
  REDACTED = 'REDACTED',
  /** The customer is subscribed to SMS marketing. */
  SUBSCRIBED = 'SUBSCRIBED',
  /** The customer isn't currently subscribed to SMS marketing but was previously subscribed. */
  UNSUBSCRIBED = 'UNSUBSCRIBED'
}

/** The set of valid sort keys for the Customer query. */
export enum CustomerSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `location` value. */
  LOCATION = 'LOCATION',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** The valid values for the state of a customer's account with a shop. */
export enum CustomerState {
  /** The customer declined the email invite to create an account. */
  DECLINED = 'DECLINED',
  /** The customer doesn't have an active account. Customer accounts can be disabled from the Shopify admin at any time. */
  DISABLED = 'DISABLED',
  /** The customer has created an account. */
  ENABLED = 'ENABLED',
  /** The customer has received an email invite to create an account. */
  INVITED = 'INVITED'
}

/** A customer's computed statistics. */
export type CustomerStatistics = {
  /** The predicted spend tier of a customer with a shop. */
  readonly predictedSpendTier?: Maybe<CustomerPredictedSpendTier>;
};

/** Return type for `customerUpdateDefaultAddress` mutation. */
export type CustomerUpdateDefaultAddressPayload = {
  /** The customer whose address was updated. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `customerUpdate` mutation. */
export type CustomerUpdatePayload = {
  /** The updated customer. */
  readonly customer?: Maybe<Customer>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents a customer's session visiting a shop's online store, including information about the marketing activity attributed to starting the session. */
export type CustomerVisit = CustomerMoment & Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** URL of the first page the customer landed on for the session. */
  readonly landingPage?: Maybe<Scalars['URL']>;
  /** Landing page information with URL linked in HTML. For example, the first page the customer visited was store.myshopify.com/products/1. */
  readonly landingPageHtml?: Maybe<Scalars['HTML']>;
  /**
   * Represent actions taken by an app, on behalf of a merchant,
   * to market Shopify resources such as products, collections, and discounts.
   */
  readonly marketingEvent?: Maybe<MarketingEvent>;
  /** The date and time when the customer's session occurred. */
  readonly occurredAt: Scalars['DateTime'];
  /**
   * Marketing referral code from the link that the customer clicked to visit the store.
   * Supports the following URL attributes: _ref_, _source_, or _r_.
   * For example, if the URL is myshopifystore.com/products/slide?ref=j2tj1tn2, then this value is j2tj1tn2.
   */
  readonly referralCode?: Maybe<Scalars['String']>;
  /** Referral information with URLs linked in HTML. */
  readonly referralInfoHtml: Scalars['FormattedString'];
  /**
   * Webpage where the customer clicked a link that sent them to the online store.
   * For example, _https://randomblog.com/page1_ or _android-app://com.google.android.gm_.
   */
  readonly referrerUrl?: Maybe<Scalars['URL']>;
  /**
   * Source from which the customer visited the store, such as a platform (Facebook, Google), email, direct,
   * a website domain, QR code, or unknown.
   */
  readonly source: Scalars['String'];
  /** Describes the source explicitly for first or last session. */
  readonly sourceDescription?: Maybe<Scalars['String']>;
  /** Type of marketing tactic. */
  readonly sourceType?: Maybe<MarketingTactic>;
  /** A set of UTM parameters gathered from the URL parameters of the referrer. */
  readonly utmParameters?: Maybe<UtmParameters>;
};

/** This type returns the information about the product and product variant from a customer visit. */
export type CustomerVisitProductInfo = {
  /** The product information. If `null`, then the product was deleted from the store. */
  readonly product?: Maybe<Product>;
  /** The quantity of the product that the customer requested. */
  readonly quantity: Scalars['Int'];
  /** The product variant information, if the product variant exists. */
  readonly variant?: Maybe<ProductVariant>;
};

/** An auto-generated type for paginating through multiple CustomerVisitProductInfos. */
export type CustomerVisitProductInfoConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<CustomerVisitProductInfoEdge>;
  /** A list of nodes that are contained in CustomerVisitProductInfoEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<CustomerVisitProductInfo>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one CustomerVisitProductInfo and a cursor during pagination. */
export type CustomerVisitProductInfoEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of CustomerVisitProductInfoEdge. */
  readonly node: CustomerVisitProductInfo;
};

/** Return type for `dataSaleOptOut` mutation. */
export type DataSaleOptOutPayload = {
  /** The ID of the customer whose email address has been opted out of data sale. */
  readonly customerId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DataSaleOptOutUserError>;
};

/** An error that occurs during the execution of `DataSaleOptOut`. */
export type DataSaleOptOutUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<DataSaleOptOutUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `DataSaleOptOutUserError`. */
export enum DataSaleOptOutUserErrorCode {
  /** Data sale opt out failed. */
  FAILED = 'FAILED'
}

/** Days of the week from Monday to Sunday. */
export enum DayOfTheWeek {
  /** Friday. */
  FRIDAY = 'FRIDAY',
  /** Monday. */
  MONDAY = 'MONDAY',
  /** Saturday. */
  SATURDAY = 'SATURDAY',
  /** Sunday. */
  SUNDAY = 'SUNDAY',
  /** Thursday. */
  THURSDAY = 'THURSDAY',
  /** Tuesday. */
  TUESDAY = 'TUESDAY',
  /** Wednesday. */
  WEDNESDAY = 'WEDNESDAY'
}

/**
 * A token that delegates a set of scopes from the original permission.
 *
 * To learn more about creating delegate access tokens, refer to
 * [Delegate OAuth access tokens to subsystems](https://shopify.dev/docs/apps/build/authentication-authorization/access-tokens/use-delegate-tokens).
 */
export type DelegateAccessToken = {
  /** The list of permissions associated with the token. */
  readonly accessScopes: ReadonlyArray<Scalars['String']>;
  /** The issued delegate access token. */
  readonly accessToken: Scalars['String'];
  /** The date and time when the delegate access token was created. */
  readonly createdAt: Scalars['DateTime'];
};

/** Return type for `delegateAccessTokenCreate` mutation. */
export type DelegateAccessTokenCreatePayload = {
  /** The delegate access token. */
  readonly delegateAccessToken?: Maybe<DelegateAccessToken>;
  /** The user's shop. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DelegateAccessTokenCreateUserError>;
};

/** An error that occurs during the execution of `DelegateAccessTokenCreate`. */
export type DelegateAccessTokenCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<DelegateAccessTokenCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `DelegateAccessTokenCreateUserError`. */
export enum DelegateAccessTokenCreateUserErrorCode {
  /** The parent access token can't be a delegate token. */
  DELEGATE_ACCESS_TOKEN = 'DELEGATE_ACCESS_TOKEN',
  /** The access scope can't be empty. */
  EMPTY_ACCESS_SCOPE = 'EMPTY_ACCESS_SCOPE',
  /** The delegate token can't expire after the parent token. */
  EXPIRES_AFTER_PARENT = 'EXPIRES_AFTER_PARENT',
  /** The expires_in value must be greater than 0. */
  NEGATIVE_EXPIRES_IN = 'NEGATIVE_EXPIRES_IN',
  /** Persistence failed. */
  PERSISTENCE_FAILED = 'PERSISTENCE_FAILED',
  /** The parent access token can't have a refresh token. */
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  /** Unknown scopes. */
  UNKNOWN_SCOPES = 'UNKNOWN_SCOPES'
}

/** Return type for `delegateAccessTokenDestroy` mutation. */
export type DelegateAccessTokenDestroyPayload = {
  /** The user's shop. */
  readonly shop: Shop;
  /** The status of the delegate access token destroy operation. Returns true if successful. */
  readonly status?: Maybe<Scalars['Boolean']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DelegateAccessTokenDestroyUserError>;
};

/** An error that occurs during the execution of `DelegateAccessTokenDestroy`. */
export type DelegateAccessTokenDestroyUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<DelegateAccessTokenDestroyUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `DelegateAccessTokenDestroyUserError`. */
export enum DelegateAccessTokenDestroyUserErrorCode {
  /** Access denied. */
  ACCESS_DENIED = 'ACCESS_DENIED',
  /** Access token not found. */
  ACCESS_TOKEN_NOT_FOUND = 'ACCESS_TOKEN_NOT_FOUND',
  /** Cannot delete parent access token. */
  CAN_ONLY_DELETE_DELEGATE_TOKENS = 'CAN_ONLY_DELETE_DELEGATE_TOKENS',
  /** Persistence failed. */
  PERSISTENCE_FAILED = 'PERSISTENCE_FAILED'
}

/** The input fields for a delegate access token. */
export type DelegateAccessTokenInput = {
  /** The list of scopes that will be delegated to the new access token. */
  readonly delegateAccessScope: ReadonlyArray<Scalars['String']>;
  /** The amount of time, in seconds, after which the delegate access token is no longer valid. */
  readonly expiresIn?: InputMaybe<Scalars['Int']>;
};

/**
 * Deletion events chronicle the destruction of resources (e.g. products and collections).
 * Once deleted, the deletion event is the only trace of the original's existence,
 * as the resource itself has been removed and can no longer be accessed.
 */
export type DeletionEvent = {
  /** The date and time when the deletion event for the related resource was generated. */
  readonly occurredAt: Scalars['DateTime'];
  /** The ID of the resource that was deleted. */
  readonly subjectId: Scalars['ID'];
  /** The type of resource that was deleted. */
  readonly subjectType: DeletionEventSubjectType;
};

/** An auto-generated type for paginating through multiple DeletionEvents. */
export type DeletionEventConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DeletionEventEdge>;
  /** A list of nodes that are contained in DeletionEventEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DeletionEvent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DeletionEvent and a cursor during pagination. */
export type DeletionEventEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DeletionEventEdge. */
  readonly node: DeletionEvent;
};

/** The set of valid sort keys for the DeletionEvent query. */
export enum DeletionEventSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The supported subject types of deletion events. */
export enum DeletionEventSubjectType {
  COLLECTION = 'COLLECTION',
  PRODUCT = 'PRODUCT'
}

/** A shipping service and a list of countries that the service is available for. */
export type DeliveryAvailableService = {
  /** The countries the service provider ships to. */
  readonly countries: DeliveryCountryCodesOrRestOfWorld;
  /** The name of the service. */
  readonly name: Scalars['String'];
};

/** Represents a branded promise presented to buyers. */
export type DeliveryBrandedPromise = {
  /** The handle of the branded promise.  For example: `shop_promise`. */
  readonly handle: Scalars['String'];
  /** The name of the branded promise.  For example: `Shop Promise`. */
  readonly name: Scalars['String'];
};

/**
 * A carrier service (also known as a carrier calculated service or shipping service) provides real-time shipping rates to Shopify. Some common carrier services include Canada Post, FedEx, UPS, and USPS. The term **carrier** is often used interchangeably with the terms **shipping company** and **rate provider**.
 *
 * Using the CarrierService resource, you can add a carrier service to a shop and then provide a list of applicable shipping rates at checkout. You can even use the cart data to adjust shipping rates and offer shipping discounts based on what is in the customer's cart.
 *
 * ## Requirements for accessing the CarrierService resource
 * To access the CarrierService resource, add the `write_shipping` permission to your app's requested scopes. For more information, see [API access scopes](https://shopify.dev/docs/admin-api/access-scopes).
 *
 * Your app's request to create a carrier service will fail unless the store installing your carrier service meets one of the following requirements:
 * * It's on the Advanced Shopify plan or higher.
 * * It's on the Shopify plan with yearly billing, or the carrier service feature has been added to the store for a monthly fee. For more information, contact [Shopify Support](https://help.shopify.com/questions).
 * * It's a development store.
 *
 * > Note:
 * > If a store changes its Shopify plan, then the store's association with a carrier service is deactivated if the store no long meets one of the requirements above.
 *
 * ## Providing shipping rates to Shopify
 * When adding a carrier service to a store, you need to provide a POST endpoint rooted in the `callbackUrl` property where Shopify can retrieve applicable shipping rates. The callback URL should be a public endpoint that expects these requests from Shopify.
 *
 * ### Example shipping rate request sent to a carrier service
 *
 * ```json
 * {
 *   "rate": {
 *     "origin": {
 *       "country": "CA",
 *       "postal_code": "K2P1L4",
 *       "province": "ON",
 *       "city": "Ottawa",
 *       "name": null,
 *       "address1": "150 Elgin St.",
 *       "address2": "",
 *       "address3": null,
 *       "phone": null,
 *       "fax": null,
 *       "email": null,
 *       "address_type": null,
 *       "company_name": "Jamie D's Emporium"
 *     },
 *     "destination": {
 *       "country": "CA",
 *       "postal_code": "K1M1M4",
 *       "province": "ON",
 *       "city": "Ottawa",
 *       "name": "Bob Norman",
 *       "address1": "24 Sussex Dr.",
 *       "address2": "",
 *       "address3": null,
 *       "phone": null,
 *       "fax": null,
 *       "email": null,
 *       "address_type": null,
 *       "company_name": null
 *     },
 *     "items": [{
 *       "name": "Short Sleeve T-Shirt",
 *       "sku": "",
 *       "quantity": 1,
 *       "grams": 1000,
 *       "price": 1999,
 *       "vendor": "Jamie D's Emporium",
 *       "requires_shipping": true,
 *       "taxable": true,
 *       "fulfillment_service": "manual",
 *       "properties": null,
 *       "product_id": 48447225880,
 *       "variant_id": 258644705304
 *     }],
 *     "currency": "USD",
 *     "locale": "en"
 *   }
 * }
 * ```
 *
 * ### Example response
 * ```json
 * {
 *    "rates": [
 *        {
 *            "service_name": "canadapost-overnight",
 *            "service_code": "ON",
 *            "total_price": "1295",
 *            "description": "This is the fastest option by far",
 *            "currency": "CAD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        },
 *        {
 *            "service_name": "fedex-2dayground",
 *            "service_code": "2D",
 *            "total_price": "2934",
 *            "currency": "USD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        },
 *        {
 *            "service_name": "fedex-priorityovernight",
 *            "service_code": "1D",
 *            "total_price": "3587",
 *            "currency": "USD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        }
 *    ]
 * }
 * ```
 *
 * The `address3`, `fax`, `address_type`, and `company_name` fields are returned by specific [ActiveShipping](https://github.com/Shopify/active_shipping) providers. For API-created carrier services, you should use only the following shipping address fields:
 * * `address1`
 * * `address2`
 * * `city`
 * * `zip`
 * * `province`
 * * `country`
 *
 * Other values remain as `null` and are not sent to the callback URL.
 *
 * ### Response fields
 *
 * When Shopify requests shipping rates using your callback URL, the response object `rates` must be a JSON array of objects with the following fields.  Required fields must be included in the response for the carrier service integration to work properly.
 *
 * | Field                   | Required | Description                                                                                                                                                                                                  |
 * | ----------------------- | -------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
 * | `service_name`          | Yes      | The name of the rate, which customers see at checkout. For example: `Expedited Mail`.                                                                                                                        |
 * | `description`           | Yes      | A description of the rate, which customers see at checkout. For example: `Includes tracking and insurance`.                                                                                                  |
 * | `service_code`          | Yes      | A unique code associated with the rate. For example: `expedited_mail`.                                                                                                                                       |
 * | `currency`              | Yes      | The currency of the shipping rate.                                                                                                                                                                           |
 * | `total_price`           | Yes      | The total price expressed in subunits. If the currency doesn't use subunits, then the value must be multiplied by 100. For example: `"total_price": 500` for 5.00 CAD, `"total_price": 100000` for 1000 JPY. |
 * | `phone_required`        | No       | Whether the customer must provide a phone number at checkout.                                                                                                                                                |
 * | `min_delivery_date`     | No       | The earliest delivery date for the displayed rate.                                                                                                                                                           |
 * | `max_delivery_date`     | No       | The latest delivery date for the displayed rate to still be valid.                                                                                                                                           |
 *
 * ### Special conditions
 *
 * * To indicate that this carrier service cannot handle this shipping request, return an empty array and any successful (20x) HTTP code.
 * * To force backup rates instead, return a 40x or 50x HTTP code with any content. A good choice is the regular 404 Not Found code.
 * * Redirects (30x codes) will only be followed for the same domain as the original callback URL. Attempting to redirect to a different domain will trigger backup rates.
 * * There is no retry mechanism. The response must be successful on the first try, within the time budget listed below. Timeouts or errors will trigger backup rates.
 *
 * ## Response Timeouts
 *
 * The read timeout for rate requests are dynamic, based on the number of requests per minute (RPM). These limits are applied to each shop-app pair. The timeout values are as follows.
 *
 * | RPM Range     | Timeout    |
 * | ------------- | ---------- |
 * | Under 1500    | 10s        |
 * | 1500 to 3000  | 5s         |
 * | Over 3000     | 3s         |
 *
 * > Note:
 * > These values are upper limits and should not be interpretted as a goal to develop towards. Shopify is constantly evaluating the performance of the platform and working towards improving resilience as well as app capabilities. As such, these numbers may be adjusted outside of our normal versioning timelines.
 *
 * ## Server-side caching of requests
 * Shopify provides server-side caching to reduce the number of requests it makes. Any shipping rate request that identically matches the following fields will be retrieved from Shopify's cache of the initial response:
 * * variant IDs
 * * default shipping box weight and dimensions
 * * variant quantities
 * * carrier service ID
 * * origin address
 * * destination address
 * * item weights and signatures
 *
 * If any of these fields differ, or if the cache has expired since the original request, then new shipping rates are requested. The cache expires 15 minutes after rates are successfully returned. If an error occurs, then the cache expires after 30 seconds.
 */
export type DeliveryCarrierService = Node & {
  /** Whether the carrier service is active. */
  readonly active: Scalars['Boolean'];
  /** The list of services offered for given destinations. */
  readonly availableServicesForCountries: ReadonlyArray<DeliveryAvailableService>;
  /** The URL endpoint that Shopify needs to retrieve shipping rates. */
  readonly callbackUrl?: Maybe<Scalars['URL']>;
  /** The properly formatted name of the shipping service provider, ready to display. */
  readonly formattedName?: Maybe<Scalars['String']>;
  /** The logo of the service provider. */
  readonly icon: Image;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the shipping service provider. */
  readonly name?: Maybe<Scalars['String']>;
  /** Whether merchants are able to send dummy data to your service through the Shopify admin to see shipping rate examples. */
  readonly supportsServiceDiscovery: Scalars['Boolean'];
};


/**
 * A carrier service (also known as a carrier calculated service or shipping service) provides real-time shipping rates to Shopify. Some common carrier services include Canada Post, FedEx, UPS, and USPS. The term **carrier** is often used interchangeably with the terms **shipping company** and **rate provider**.
 *
 * Using the CarrierService resource, you can add a carrier service to a shop and then provide a list of applicable shipping rates at checkout. You can even use the cart data to adjust shipping rates and offer shipping discounts based on what is in the customer's cart.
 *
 * ## Requirements for accessing the CarrierService resource
 * To access the CarrierService resource, add the `write_shipping` permission to your app's requested scopes. For more information, see [API access scopes](https://shopify.dev/docs/admin-api/access-scopes).
 *
 * Your app's request to create a carrier service will fail unless the store installing your carrier service meets one of the following requirements:
 * * It's on the Advanced Shopify plan or higher.
 * * It's on the Shopify plan with yearly billing, or the carrier service feature has been added to the store for a monthly fee. For more information, contact [Shopify Support](https://help.shopify.com/questions).
 * * It's a development store.
 *
 * > Note:
 * > If a store changes its Shopify plan, then the store's association with a carrier service is deactivated if the store no long meets one of the requirements above.
 *
 * ## Providing shipping rates to Shopify
 * When adding a carrier service to a store, you need to provide a POST endpoint rooted in the `callbackUrl` property where Shopify can retrieve applicable shipping rates. The callback URL should be a public endpoint that expects these requests from Shopify.
 *
 * ### Example shipping rate request sent to a carrier service
 *
 * ```json
 * {
 *   "rate": {
 *     "origin": {
 *       "country": "CA",
 *       "postal_code": "K2P1L4",
 *       "province": "ON",
 *       "city": "Ottawa",
 *       "name": null,
 *       "address1": "150 Elgin St.",
 *       "address2": "",
 *       "address3": null,
 *       "phone": null,
 *       "fax": null,
 *       "email": null,
 *       "address_type": null,
 *       "company_name": "Jamie D's Emporium"
 *     },
 *     "destination": {
 *       "country": "CA",
 *       "postal_code": "K1M1M4",
 *       "province": "ON",
 *       "city": "Ottawa",
 *       "name": "Bob Norman",
 *       "address1": "24 Sussex Dr.",
 *       "address2": "",
 *       "address3": null,
 *       "phone": null,
 *       "fax": null,
 *       "email": null,
 *       "address_type": null,
 *       "company_name": null
 *     },
 *     "items": [{
 *       "name": "Short Sleeve T-Shirt",
 *       "sku": "",
 *       "quantity": 1,
 *       "grams": 1000,
 *       "price": 1999,
 *       "vendor": "Jamie D's Emporium",
 *       "requires_shipping": true,
 *       "taxable": true,
 *       "fulfillment_service": "manual",
 *       "properties": null,
 *       "product_id": 48447225880,
 *       "variant_id": 258644705304
 *     }],
 *     "currency": "USD",
 *     "locale": "en"
 *   }
 * }
 * ```
 *
 * ### Example response
 * ```json
 * {
 *    "rates": [
 *        {
 *            "service_name": "canadapost-overnight",
 *            "service_code": "ON",
 *            "total_price": "1295",
 *            "description": "This is the fastest option by far",
 *            "currency": "CAD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        },
 *        {
 *            "service_name": "fedex-2dayground",
 *            "service_code": "2D",
 *            "total_price": "2934",
 *            "currency": "USD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        },
 *        {
 *            "service_name": "fedex-priorityovernight",
 *            "service_code": "1D",
 *            "total_price": "3587",
 *            "currency": "USD",
 *            "min_delivery_date": "2013-04-12 14:48:45 -0400",
 *            "max_delivery_date": "2013-04-12 14:48:45 -0400"
 *        }
 *    ]
 * }
 * ```
 *
 * The `address3`, `fax`, `address_type`, and `company_name` fields are returned by specific [ActiveShipping](https://github.com/Shopify/active_shipping) providers. For API-created carrier services, you should use only the following shipping address fields:
 * * `address1`
 * * `address2`
 * * `city`
 * * `zip`
 * * `province`
 * * `country`
 *
 * Other values remain as `null` and are not sent to the callback URL.
 *
 * ### Response fields
 *
 * When Shopify requests shipping rates using your callback URL, the response object `rates` must be a JSON array of objects with the following fields.  Required fields must be included in the response for the carrier service integration to work properly.
 *
 * | Field                   | Required | Description                                                                                                                                                                                                  |
 * | ----------------------- | -------- | ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------ |
 * | `service_name`          | Yes      | The name of the rate, which customers see at checkout. For example: `Expedited Mail`.                                                                                                                        |
 * | `description`           | Yes      | A description of the rate, which customers see at checkout. For example: `Includes tracking and insurance`.                                                                                                  |
 * | `service_code`          | Yes      | A unique code associated with the rate. For example: `expedited_mail`.                                                                                                                                       |
 * | `currency`              | Yes      | The currency of the shipping rate.                                                                                                                                                                           |
 * | `total_price`           | Yes      | The total price expressed in subunits. If the currency doesn't use subunits, then the value must be multiplied by 100. For example: `"total_price": 500` for 5.00 CAD, `"total_price": 100000` for 1000 JPY. |
 * | `phone_required`        | No       | Whether the customer must provide a phone number at checkout.                                                                                                                                                |
 * | `min_delivery_date`     | No       | The earliest delivery date for the displayed rate.                                                                                                                                                           |
 * | `max_delivery_date`     | No       | The latest delivery date for the displayed rate to still be valid.                                                                                                                                           |
 *
 * ### Special conditions
 *
 * * To indicate that this carrier service cannot handle this shipping request, return an empty array and any successful (20x) HTTP code.
 * * To force backup rates instead, return a 40x or 50x HTTP code with any content. A good choice is the regular 404 Not Found code.
 * * Redirects (30x codes) will only be followed for the same domain as the original callback URL. Attempting to redirect to a different domain will trigger backup rates.
 * * There is no retry mechanism. The response must be successful on the first try, within the time budget listed below. Timeouts or errors will trigger backup rates.
 *
 * ## Response Timeouts
 *
 * The read timeout for rate requests are dynamic, based on the number of requests per minute (RPM). These limits are applied to each shop-app pair. The timeout values are as follows.
 *
 * | RPM Range     | Timeout    |
 * | ------------- | ---------- |
 * | Under 1500    | 10s        |
 * | 1500 to 3000  | 5s         |
 * | Over 3000     | 3s         |
 *
 * > Note:
 * > These values are upper limits and should not be interpretted as a goal to develop towards. Shopify is constantly evaluating the performance of the platform and working towards improving resilience as well as app capabilities. As such, these numbers may be adjusted outside of our normal versioning timelines.
 *
 * ## Server-side caching of requests
 * Shopify provides server-side caching to reduce the number of requests it makes. Any shipping rate request that identically matches the following fields will be retrieved from Shopify's cache of the initial response:
 * * variant IDs
 * * default shipping box weight and dimensions
 * * variant quantities
 * * carrier service ID
 * * origin address
 * * destination address
 * * item weights and signatures
 *
 * If any of these fields differ, or if the cache has expired since the original request, then new shipping rates are requested. The cache expires 15 minutes after rates are successfully returned. If an error occurs, then the cache expires after 30 seconds.
 */
export type DeliveryCarrierServiceAvailableServicesForCountriesArgs = {
  countryCodes?: InputMaybe<ReadonlyArray<CountryCode>>;
  origins?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  restOfWorld: Scalars['Boolean'];
};

/** A carrier service and the associated list of shop locations. */
export type DeliveryCarrierServiceAndLocations = {
  /** The carrier service. */
  readonly carrierService: DeliveryCarrierService;
  /** The list of locations that support this carrier service. */
  readonly locations: ReadonlyArray<Location>;
};

/** An auto-generated type for paginating through multiple DeliveryCarrierServices. */
export type DeliveryCarrierServiceConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DeliveryCarrierServiceEdge>;
  /** A list of nodes that are contained in DeliveryCarrierServiceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DeliveryCarrierService>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields required to create a carrier service. */
export type DeliveryCarrierServiceCreateInput = {
  /** Whether this carrier service is active. If `true`, then the service will be available to serve rates in checkout. */
  readonly active: Scalars['Boolean'];
  /** The URL endpoint that Shopify needs to retrieve shipping rates. This must be a public URL. */
  readonly callbackUrl: Scalars['URL'];
  /** The name of the shipping service as seen by merchants and their customers. */
  readonly name: Scalars['String'];
  /** Whether merchants are able to send dummy data to your service through the Shopify admin to see shipping rate examples. */
  readonly supportsServiceDiscovery: Scalars['Boolean'];
};

/** An auto-generated type which holds one DeliveryCarrierService and a cursor during pagination. */
export type DeliveryCarrierServiceEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DeliveryCarrierServiceEdge. */
  readonly node: DeliveryCarrierService;
};

/** The input fields used to update a carrier service. */
export type DeliveryCarrierServiceUpdateInput = {
  /** Whether this carrier service is active. If `true`, then the service will be available to serve rates in checkout. */
  readonly active?: InputMaybe<Scalars['Boolean']>;
  /** The URL endpoint that Shopify needs to retrieve shipping rates. This must be a public URL. */
  readonly callbackUrl?: InputMaybe<Scalars['URL']>;
  /** The global ID of the carrier service to update. */
  readonly id: Scalars['ID'];
  /** The name of the shipping service as seen by merchants and their customers. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Whether merchants are able to send dummy data to your service through the Shopify admin to see shipping rate examples. */
  readonly supportsServiceDiscovery?: InputMaybe<Scalars['Boolean']>;
};

/** A condition that must pass for a delivery method definition to be applied to an order. */
export type DeliveryCondition = Node & {
  /** The value (weight or price) that the condition field is compared to. */
  readonly conditionCriteria: DeliveryConditionCriteria;
  /** The field to compare the criterion value against, using the operator. */
  readonly field: DeliveryConditionField;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The operator to compare the field and criterion value. */
  readonly operator: DeliveryConditionOperator;
};

/** The value (weight or price) that the condition field is compared to. */
export type DeliveryConditionCriteria = MoneyV2 | Weight;

/** The field type that the condition will be applied to. */
export enum DeliveryConditionField {
  /** The condition will check against the total price of the order. */
  TOTAL_PRICE = 'TOTAL_PRICE',
  /** The condition will check against the total weight of the order. */
  TOTAL_WEIGHT = 'TOTAL_WEIGHT'
}

/** The operator to use to determine if the condition passes. */
export enum DeliveryConditionOperator {
  /** The condition will check whether the field is greater than or equal to the criterion. */
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  /** The condition will check if the field is less than or equal to the criterion. */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO'
}

/** A country that is used to define a shipping zone. */
export type DeliveryCountry = Node & {
  /**
   * A two-letter country code in ISO 3166-1 alpha-2 standard.
   * It also includes a flag indicating whether the country should be
   * a part of the 'Rest Of World' shipping zone.
   */
  readonly code: DeliveryCountryCodeOrRestOfWorld;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The full name of the country. */
  readonly name: Scalars['String'];
  /** The list of regions associated with this country. */
  readonly provinces: ReadonlyArray<DeliveryProvince>;
  /** The translated name of the country. The translation returned is based on the system's locale. */
  readonly translatedName: Scalars['String'];
};

/** The country details and the associated shipping zone. */
export type DeliveryCountryAndZone = {
  /** The country details. */
  readonly country: DeliveryCountry;
  /** The name of the shipping zone. */
  readonly zone: Scalars['String'];
};

/** The country code and whether the country is a part of the 'Rest Of World' shipping zone. */
export type DeliveryCountryCodeOrRestOfWorld = {
  /** The country code in the ISO 3166-1 alpha-2 format. */
  readonly countryCode?: Maybe<CountryCode>;
  /** Whether the country is a part of the 'Rest of World' shipping zone. */
  readonly restOfWorld: Scalars['Boolean'];
};

/**
 * The list of country codes and information whether the countries
 * are a part of the 'Rest Of World' shipping zone.
 */
export type DeliveryCountryCodesOrRestOfWorld = {
  /** List of applicable country codes in the ISO 3166-1 alpha-2 format. */
  readonly countryCodes: ReadonlyArray<CountryCode>;
  /** Whether the countries are a part of the 'Rest of World' shipping zone. */
  readonly restOfWorld: Scalars['Boolean'];
};

/** The input fields to specify a country. */
export type DeliveryCountryInput = {
  /** The country code of the country in the ISO 3166-1 alpha-2 format. */
  readonly code?: InputMaybe<CountryCode>;
  /** Associate all available provinces with this country. */
  readonly includeAllProvinces?: InputMaybe<Scalars['Boolean']>;
  /** The regions associated with this country. */
  readonly provinces?: InputMaybe<ReadonlyArray<DeliveryProvinceInput>>;
  /** Whether the country is a part of the 'Rest of World' shipping zone. */
  readonly restOfWorld?: InputMaybe<Scalars['Boolean']>;
};

/** A delivery customization. */
export type DeliveryCustomization = HasMetafieldDefinitions & HasMetafields & Node & {
  /** The enabled status of the delivery customization. */
  readonly enabled: Scalars['Boolean'];
  /** The error history on the most recent version of the delivery customization. */
  readonly errorHistory?: Maybe<FunctionsErrorHistory>;
  /** The ID of the Shopify Function implementing the delivery customization. */
  readonly functionId: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The Shopify Function implementing the delivery customization. */
  readonly shopifyFunction: ShopifyFunction;
  /** The title of the delivery customization. */
  readonly title: Scalars['String'];
};


/** A delivery customization. */
export type DeliveryCustomizationMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A delivery customization. */
export type DeliveryCustomizationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** A delivery customization. */
export type DeliveryCustomizationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A delivery customization. */
export type DeliveryCustomizationPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A delivery customization. */
export type DeliveryCustomizationPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `deliveryCustomizationActivation` mutation. */
export type DeliveryCustomizationActivationPayload = {
  /** The IDs of the updated delivery customizations. */
  readonly ids?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DeliveryCustomizationError>;
};

/** An auto-generated type for paginating through multiple DeliveryCustomizations. */
export type DeliveryCustomizationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DeliveryCustomizationEdge>;
  /** A list of nodes that are contained in DeliveryCustomizationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DeliveryCustomization>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `deliveryCustomizationCreate` mutation. */
export type DeliveryCustomizationCreatePayload = {
  /** Returns the created delivery customization. */
  readonly deliveryCustomization?: Maybe<DeliveryCustomization>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DeliveryCustomizationError>;
};

/** Return type for `deliveryCustomizationDelete` mutation. */
export type DeliveryCustomizationDeletePayload = {
  /** Returns the deleted delivery customization ID. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DeliveryCustomizationError>;
};

/** An auto-generated type which holds one DeliveryCustomization and a cursor during pagination. */
export type DeliveryCustomizationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DeliveryCustomizationEdge. */
  readonly node: DeliveryCustomization;
};

/** An error that occurs during the execution of a delivery customization mutation. */
export type DeliveryCustomizationError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<DeliveryCustomizationErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `DeliveryCustomizationError`. */
export enum DeliveryCustomizationErrorCode {
  /** Shop must be on a Shopify Plus plan to activate functions from a custom app. */
  CUSTOM_APP_FUNCTION_NOT_ELIGIBLE = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** Shop must be on a Shopify Plus plan to activate delivery customizations from a custom app. */
  DELIVERY_CUSTOMIZATION_FUNCTION_NOT_ELIGIBLE = 'DELIVERY_CUSTOMIZATION_FUNCTION_NOT_ELIGIBLE',
  /** Delivery customization not found. */
  DELIVERY_CUSTOMIZATION_NOT_FOUND = 'DELIVERY_CUSTOMIZATION_NOT_FOUND',
  /** Function does not implement the required interface for this delivery customization. */
  FUNCTION_DOES_NOT_IMPLEMENT = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** Function ID cannot be changed. */
  FUNCTION_ID_CANNOT_BE_CHANGED = 'FUNCTION_ID_CANNOT_BE_CHANGED',
  /** Function not found. */
  FUNCTION_NOT_FOUND = 'FUNCTION_NOT_FOUND',
  /** Function is pending deletion. */
  FUNCTION_PENDING_DELETION = 'FUNCTION_PENDING_DELETION',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Could not create or update metafields. */
  INVALID_METAFIELDS = 'INVALID_METAFIELDS',
  /** Maximum delivery customizations are already enabled. */
  MAXIMUM_ACTIVE_DELIVERY_CUSTOMIZATIONS = 'MAXIMUM_ACTIVE_DELIVERY_CUSTOMIZATIONS',
  /** Required input field must be present. */
  REQUIRED_INPUT_FIELD = 'REQUIRED_INPUT_FIELD',
  /** Unauthorized app scope. */
  UNAUTHORIZED_APP_SCOPE = 'UNAUTHORIZED_APP_SCOPE'
}

/** The input fields to create and update a delivery customization. */
export type DeliveryCustomizationInput = {
  /** The enabled status of the delivery customization. */
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the function providing the delivery customization. */
  readonly functionId?: InputMaybe<Scalars['String']>;
  /** Additional metafields to associate to the delivery customization. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The title of the delivery customization. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `deliveryCustomizationUpdate` mutation. */
export type DeliveryCustomizationUpdatePayload = {
  /** Returns the updated delivery customization. */
  readonly deliveryCustomization?: Maybe<DeliveryCustomization>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DeliveryCustomizationError>;
};

/** Whether the shop is blocked from converting to full multi-location delivery profiles mode. If the shop is blocked, then the blocking reasons are also returned. */
export type DeliveryLegacyModeBlocked = {
  /** Whether the shop can convert to full multi-location delivery profiles mode. */
  readonly blocked: Scalars['Boolean'];
  /** The reasons why the shop is blocked from converting to full multi-location delivery profiles mode. */
  readonly reasons?: Maybe<ReadonlyArray<DeliveryLegacyModeBlockedReason>>;
};

/** Reasons the shop is blocked from converting to full multi-location delivery profiles mode. */
export enum DeliveryLegacyModeBlockedReason {
  /** Multi-Location mode is disabled. The shop can't convert to full multi-location delivery profiles mode. */
  MULTI_LOCATION_DISABLED = 'MULTI_LOCATION_DISABLED',
  /** There are no locations for this store that can fulfill online orders. */
  NO_LOCATIONS_FULFILLING_ONLINE_ORDERS = 'NO_LOCATIONS_FULFILLING_ONLINE_ORDERS'
}

/** Local pickup settings associated with a location. */
export type DeliveryLocalPickupSettings = {
  /** Additional instructions or information related to the local pickup. */
  readonly instructions: Scalars['String'];
  /** The estimated pickup time to show customers at checkout. */
  readonly pickupTime: DeliveryLocalPickupTime;
};

/** Possible pickup time values that a location enabled for local pickup can have. */
export enum DeliveryLocalPickupTime {
  /** Custom pickup time. Unrecognized pickup time enum value. */
  CUSTOM = 'CUSTOM',
  /** Usually ready in 5+ days. */
  FIVE_OR_MORE_DAYS = 'FIVE_OR_MORE_DAYS',
  /** Usually ready in 4 hours. */
  FOUR_HOURS = 'FOUR_HOURS',
  /** Usually ready in 1 hour. */
  ONE_HOUR = 'ONE_HOUR',
  /** Usually ready in 24 hours. */
  TWENTY_FOUR_HOURS = 'TWENTY_FOUR_HOURS',
  /** Usually ready in 2 hours. */
  TWO_HOURS = 'TWO_HOURS',
  /** Usually ready in 2-4 days. */
  TWO_TO_FOUR_DAYS = 'TWO_TO_FOUR_DAYS'
}

/**
 * A location group is a collection of locations. They share zones and delivery methods across delivery
 * profiles.
 */
export type DeliveryLocationGroup = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** A list of all locations that are part of this location group. */
  readonly locations: LocationConnection;
  /** A count of all locations that are part of this location group. */
  readonly locationsCount?: Maybe<Count>;
};


/**
 * A location group is a collection of locations. They share zones and delivery methods across delivery
 * profiles.
 */
export type DeliveryLocationGroupLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  includeLegacy?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<LocationSortKeys>;
};

/** Links a location group with a zone and the associated method definitions. */
export type DeliveryLocationGroupZone = {
  /** The number of method definitions for the zone. */
  readonly methodDefinitionCounts: DeliveryMethodDefinitionCounts;
  /** The method definitions associated to a zone and location group. */
  readonly methodDefinitions: DeliveryMethodDefinitionConnection;
  /** The zone associated to a location group. */
  readonly zone: DeliveryZone;
};


/** Links a location group with a zone and the associated method definitions. */
export type DeliveryLocationGroupZoneMethodDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  eligible?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MethodDefinitionSortKeys>;
  type?: InputMaybe<DeliveryMethodDefinitionType>;
};

/** An auto-generated type for paginating through multiple DeliveryLocationGroupZones. */
export type DeliveryLocationGroupZoneConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DeliveryLocationGroupZoneEdge>;
  /** A list of nodes that are contained in DeliveryLocationGroupZoneEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DeliveryLocationGroupZone>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DeliveryLocationGroupZone and a cursor during pagination. */
export type DeliveryLocationGroupZoneEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DeliveryLocationGroupZoneEdge. */
  readonly node: DeliveryLocationGroupZone;
};

/** The input fields for a delivery zone associated to a location group and profile. */
export type DeliveryLocationGroupZoneInput = {
  /** A list of countries to associate with the zone. */
  readonly countries?: InputMaybe<ReadonlyArray<DeliveryCountryInput>>;
  /** A globally-unique ID of the zone. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** A list of method definitions to create. */
  readonly methodDefinitionsToCreate?: InputMaybe<ReadonlyArray<DeliveryMethodDefinitionInput>>;
  /** A list of method definitions to update. */
  readonly methodDefinitionsToUpdate?: InputMaybe<ReadonlyArray<DeliveryMethodDefinitionInput>>;
  /** The name of the zone. */
  readonly name?: InputMaybe<Scalars['String']>;
};

/** The input fields for a local pickup setting associated with a location. */
export type DeliveryLocationLocalPickupEnableInput = {
  /** The instructions for the local pickup. */
  readonly instructions?: InputMaybe<Scalars['String']>;
  /** The ID of the location associated with the location setting. */
  readonly locationId: Scalars['ID'];
  /** The time of the local pickup. */
  readonly pickupTime: DeliveryLocalPickupTime;
};

/** Represents an error that happened when changing local pickup settings for a location. */
export type DeliveryLocationLocalPickupSettingsError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<DeliveryLocationLocalPickupSettingsErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `DeliveryLocationLocalPickupSettingsError`. */
export enum DeliveryLocationLocalPickupSettingsErrorCode {
  /** Provided locationId is not for an active location belonging to this store. */
  ACTIVE_LOCATION_NOT_FOUND = 'ACTIVE_LOCATION_NOT_FOUND',
  /** Custom pickup time is not allowed for local pickup settings. */
  CUSTOM_PICKUP_TIME_NOT_ALLOWED = 'CUSTOM_PICKUP_TIME_NOT_ALLOWED',
  /** An error occurred while changing the local pickup settings. */
  GENERIC_ERROR = 'GENERIC_ERROR'
}

/** The delivery method used by a fulfillment order. */
export type DeliveryMethod = Node & {
  /** The Additional information to consider when performing the delivery. */
  readonly additionalInformation?: Maybe<DeliveryMethodAdditionalInformation>;
  /** The branded promise that was presented to the buyer during checkout.  For example: Shop Promise. */
  readonly brandedPromise?: Maybe<DeliveryBrandedPromise>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The latest delivery date and time when the fulfillment is expected to arrive at the buyer's location. */
  readonly maxDeliveryDateTime?: Maybe<Scalars['DateTime']>;
  /** The type of the delivery method. */
  readonly methodType: DeliveryMethodType;
  /** The earliest delivery date and time when the fulfillment is expected to arrive at the buyer's location. */
  readonly minDeliveryDateTime?: Maybe<Scalars['DateTime']>;
  /** The name of the delivery option that was presented to the buyer during checkout. */
  readonly presentedName?: Maybe<Scalars['String']>;
  /** A reference to the shipping method. */
  readonly serviceCode?: Maybe<Scalars['String']>;
  /** Source reference is promise provider specific data associated with delivery promise. */
  readonly sourceReference?: Maybe<Scalars['String']>;
};

/** Additional information included on a delivery method that will help during the delivery process. */
export type DeliveryMethodAdditionalInformation = {
  /** The delivery instructions to follow when performing the delivery. */
  readonly instructions?: Maybe<Scalars['String']>;
  /** The phone number to contact when performing the delivery. */
  readonly phone?: Maybe<Scalars['String']>;
};

/**
 * A method definition contains the delivery rate and the conditions that must be met for the method to be
 * applied.
 */
export type DeliveryMethodDefinition = Node & {
  /** Whether this method definition is active. */
  readonly active: Scalars['Boolean'];
  /** The description of the method definition. Only available on shipping rates that are custom. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The method conditions that must pass for this method definition to be applied to an order. */
  readonly methodConditions: ReadonlyArray<DeliveryCondition>;
  /** The name of the method definition. */
  readonly name: Scalars['String'];
  /** The provided rate for this method definition, from a rate definition or participant. */
  readonly rateProvider: DeliveryRateProvider;
};

/** An auto-generated type for paginating through multiple DeliveryMethodDefinitions. */
export type DeliveryMethodDefinitionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DeliveryMethodDefinitionEdge>;
  /** A list of nodes that are contained in DeliveryMethodDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DeliveryMethodDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The number of method definitions for a zone, separated into merchant-owned and participant definitions. */
export type DeliveryMethodDefinitionCounts = {
  /** The number of participant method definitions for the specified zone. */
  readonly participantDefinitionsCount: Scalars['Int'];
  /** The number of merchant-defined method definitions for the specified zone. */
  readonly rateDefinitionsCount: Scalars['Int'];
};

/** An auto-generated type which holds one DeliveryMethodDefinition and a cursor during pagination. */
export type DeliveryMethodDefinitionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DeliveryMethodDefinitionEdge. */
  readonly node: DeliveryMethodDefinition;
};

/** The input fields for a method definition. */
export type DeliveryMethodDefinitionInput = {
  /** Whether to use this method definition during rate calculation. */
  readonly active?: InputMaybe<Scalars['Boolean']>;
  /** A list of conditions to update on the method definition. */
  readonly conditionsToUpdate?: InputMaybe<ReadonlyArray<DeliveryUpdateConditionInput>>;
  /** The description of the method definition. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** A globally-unique ID of the method definition. Use only when updating a method definiton. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The name of the method definition. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** A participant to apply to the method definition. */
  readonly participant?: InputMaybe<DeliveryParticipantInput>;
  /** A list of price conditions on the method definition. */
  readonly priceConditionsToCreate?: InputMaybe<ReadonlyArray<DeliveryPriceConditionInput>>;
  /** A rate definition to apply to the method definition. */
  readonly rateDefinition?: InputMaybe<DeliveryRateDefinitionInput>;
  /** A list of weight conditions on the method definition. */
  readonly weightConditionsToCreate?: InputMaybe<ReadonlyArray<DeliveryWeightConditionInput>>;
};

/** The different types of method definitions to filter by. */
export enum DeliveryMethodDefinitionType {
  /** A static merchant-defined rate. */
  MERCHANT = 'MERCHANT',
  /** A dynamic participant rate. */
  PARTICIPANT = 'PARTICIPANT'
}

/** Possible method types that a delivery method can have. */
export enum DeliveryMethodType {
  /** The order is delivered using a local delivery service. */
  LOCAL = 'LOCAL',
  /** Non-physical items, no delivery needed. */
  NONE = 'NONE',
  /** The order is delivered to a pickup point. */
  PICKUP_POINT = 'PICKUP_POINT',
  /** The order is picked up by the customer. */
  PICK_UP = 'PICK_UP',
  /** In-store sale, no delivery needed. */
  RETAIL = 'RETAIL',
  /** The order is shipped. */
  SHIPPING = 'SHIPPING'
}

/**
 * A participant defines carrier-calculated rates for shipping services
 * with a possible merchant-defined fixed fee or a percentage-of-rate fee.
 */
export type DeliveryParticipant = Node & {
  /** Whether to display new shipping services automatically to the customer when the service becomes available. */
  readonly adaptToNewServicesFlag: Scalars['Boolean'];
  /** The carrier used for this participant. */
  readonly carrierService: DeliveryCarrierService;
  /** The merchant-defined fixed fee for this participant. */
  readonly fixedFee?: Maybe<MoneyV2>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The carrier-specific services offered by the participant, and whether each service is active. */
  readonly participantServices: ReadonlyArray<DeliveryParticipantService>;
  /** The merchant-defined percentage-of-rate fee for this participant. */
  readonly percentageOfRateFee: Scalars['Float'];
};

/** The input fields for a participant. */
export type DeliveryParticipantInput = {
  /** Whether to automatically display new shipping services to the customer when a service becomes available. */
  readonly adaptToNewServices?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the carrier service for this participant. */
  readonly carrierServiceId?: InputMaybe<Scalars['ID']>;
  /** The fixed feed that's defined by the merchant for this participant. */
  readonly fixedFee?: InputMaybe<MoneyInput>;
  /** The ID of the participant. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The list of shipping services offered by the participant. */
  readonly participantServices?: InputMaybe<ReadonlyArray<DeliveryParticipantServiceInput>>;
  /** The merchant-defined percentage-of-rate fee for this participant. */
  readonly percentageOfRateFee?: InputMaybe<Scalars['Float']>;
};

/** A mail service provided by the participant. */
export type DeliveryParticipantService = {
  /** Whether the service is active. */
  readonly active: Scalars['Boolean'];
  /** The name of the service. */
  readonly name: Scalars['String'];
};

/** The input fields for a shipping service provided by a participant. */
export type DeliveryParticipantServiceInput = {
  /** Whether the service is active. */
  readonly active: Scalars['Boolean'];
  /** The name of the service. */
  readonly name: Scalars['String'];
};

/** The input fields for a price-based condition of a delivery method definition. */
export type DeliveryPriceConditionInput = {
  /** The monetary value to compare the price of an order to. */
  readonly criteria?: InputMaybe<MoneyInput>;
  /** The operator to use for comparison. */
  readonly operator?: InputMaybe<DeliveryConditionOperator>;
};

/** How many product variants are in a profile. This count is capped at 500. */
export type DeliveryProductVariantsCount = {
  /** Whether the count has reached the cap of 500. */
  readonly capped: Scalars['Boolean'];
  /** The product variant count. */
  readonly count: Scalars['Int'];
};

/** A shipping profile. In Shopify, a shipping profile is a set of shipping rates scoped to a set of products or variants that can be shipped from selected locations to zones. Learn more about [building with delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles). */
export type DeliveryProfile = Node & {
  /** The number of active shipping rates for the profile. */
  readonly activeMethodDefinitionsCount: Scalars['Int'];
  /** Whether this is the default profile. */
  readonly default: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether this shop has enabled legacy compatibility mode for delivery profiles. */
  readonly legacyMode: Scalars['Boolean'];
  /** The number of locations without rates defined. */
  readonly locationsWithoutRatesCount: Scalars['Int'];
  /** The name of the delivery profile. */
  readonly name: Scalars['String'];
  /** The number of active origin locations for the profile. */
  readonly originLocationCount: Scalars['Int'];
  /** How many product variants are in this profile. */
  readonly productVariantsCount?: Maybe<Count>;
  /**
   * How many product variants are in this profile.
   * @deprecated Use `productVariantsCount` instead.
   */
  readonly productVariantsCountV2: DeliveryProductVariantsCount;
  /** The products and variants associated with this profile. */
  readonly profileItems: DeliveryProfileItemConnection;
  /** The location groups and associated zones using this profile. */
  readonly profileLocationGroups: ReadonlyArray<DeliveryProfileLocationGroup>;
  /** Selling plan groups associated with the specified delivery profile. */
  readonly sellingPlanGroups: SellingPlanGroupConnection;
  /** List of locations that haven't been assigned to a location group for this profile. */
  readonly unassignedLocations: ReadonlyArray<Location>;
  /** List of locations that have not been assigned to a location group for this profile. */
  readonly unassignedLocationsPaginated: LocationConnection;
  /** The number of countries with active rates to deliver to. */
  readonly zoneCountryCount: Scalars['Int'];
};


/** A shipping profile. In Shopify, a shipping profile is a set of shipping rates scoped to a set of products or variants that can be shipped from selected locations to zones. Learn more about [building with delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles). */
export type DeliveryProfileProfileItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A shipping profile. In Shopify, a shipping profile is a set of shipping rates scoped to a set of products or variants that can be shipped from selected locations to zones. Learn more about [building with delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles). */
export type DeliveryProfileProfileLocationGroupsArgs = {
  locationGroupId?: InputMaybe<Scalars['ID']>;
};


/** A shipping profile. In Shopify, a shipping profile is a set of shipping rates scoped to a set of products or variants that can be shipped from selected locations to zones. Learn more about [building with delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles). */
export type DeliveryProfileSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A shipping profile. In Shopify, a shipping profile is a set of shipping rates scoped to a set of products or variants that can be shipped from selected locations to zones. Learn more about [building with delivery profiles](https://shopify.dev/apps/build/purchase-options/deferred/delivery-and-deferment/build-delivery-profiles). */
export type DeliveryProfileUnassignedLocationsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple DeliveryProfiles. */
export type DeliveryProfileConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DeliveryProfileEdge>;
  /** A list of nodes that are contained in DeliveryProfileEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DeliveryProfile>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `deliveryProfileCreate` mutation. */
export type DeliveryProfileCreatePayload = {
  /** The delivery profile that was created. */
  readonly profile?: Maybe<DeliveryProfile>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one DeliveryProfile and a cursor during pagination. */
export type DeliveryProfileEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DeliveryProfileEdge. */
  readonly node: DeliveryProfile;
};

/** The input fields for a delivery profile. */
export type DeliveryProfileInput = {
  /** The list of condition IDs to delete. */
  readonly conditionsToDelete?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * The list of location groups to be created in the delivery profile.
   *
   * **Note:** due to the potential complexity of the nested data, it is recommended to send no more than 5 location groups per each request.
   */
  readonly locationGroupsToCreate?: InputMaybe<ReadonlyArray<DeliveryProfileLocationGroupInput>>;
  /** The list of location groups to be deleted from the delivery profile. */
  readonly locationGroupsToDelete?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * The list of location groups to be updated in the delivery profile.
   *
   * **Note:** due to the potential complexity of the nested data, it is recommended to send no more than 5 location groups per each request.
   */
  readonly locationGroupsToUpdate?: InputMaybe<ReadonlyArray<DeliveryProfileLocationGroupInput>>;
  /** The list of method definition IDs to delete. */
  readonly methodDefinitionsToDelete?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The name of the delivery profile. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The list of location groups associated with the delivery profile. */
  readonly profileLocationGroups?: InputMaybe<ReadonlyArray<DeliveryProfileLocationGroupInput>>;
  /** The list of selling plan groups to be associated with the delivery profile. */
  readonly sellingPlanGroupsToAssociate?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of selling plan groups to be dissociated with the delivery profile. */
  readonly sellingPlanGroupsToDissociate?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of product variant IDs to be associated with the delivery profile. */
  readonly variantsToAssociate?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * The list of product variant IDs to be dissociated from the delivery profile.
   * The dissociated product variants are moved back to the default delivery profile.
   */
  readonly variantsToDissociate?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of zone IDs to delete. */
  readonly zonesToDelete?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** A product and the subset of associated variants that are part of this delivery profile. */
export type DeliveryProfileItem = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** A product associated with this profile. */
  readonly product: Product;
  /** The product variants associated with this delivery profile. */
  readonly variants: ProductVariantConnection;
};


/** A product and the subset of associated variants that are part of this delivery profile. */
export type DeliveryProfileItemVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple DeliveryProfileItems. */
export type DeliveryProfileItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DeliveryProfileItemEdge>;
  /** A list of nodes that are contained in DeliveryProfileItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DeliveryProfileItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DeliveryProfileItem and a cursor during pagination. */
export type DeliveryProfileItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DeliveryProfileItemEdge. */
  readonly node: DeliveryProfileItem;
};

/** Links a location group with zones. Both are associated to a delivery profile. */
export type DeliveryProfileLocationGroup = {
  /** The countries already selected in any zone for the specified location group. */
  readonly countriesInAnyZone: ReadonlyArray<DeliveryCountryAndZone>;
  /** The collection of locations that make up the specified location group. */
  readonly locationGroup: DeliveryLocationGroup;
  /** The applicable zones associated to the specified location group. */
  readonly locationGroupZones: DeliveryLocationGroupZoneConnection;
};


/** Links a location group with zones. Both are associated to a delivery profile. */
export type DeliveryProfileLocationGroupLocationGroupZonesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields for a location group associated to a delivery profile. */
export type DeliveryProfileLocationGroupInput = {
  /** The globally-unique ID of the delivery profile location group. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The list of location IDs to be moved to this location group. */
  readonly locations?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * The list of location IDs to be added to this location group.
   *
   * **Note:** due to API input array limits, a maximum of 250 items can be sent per each request.
   */
  readonly locationsToAdd?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * The list of location IDs to be removed from this location group.
   *
   * **Note:** due to API input array limits, a maximum of 250 items can be sent per each request.
   */
  readonly locationsToRemove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * The list of location group zones to create.
   *
   * **Note:** due to the potential complexity of the nested data, it is recommended to send no more than 5 zones per each request.
   */
  readonly zonesToCreate?: InputMaybe<ReadonlyArray<DeliveryLocationGroupZoneInput>>;
  /**
   * The list of location group zones to update.
   *
   * **Note:** due to the potential complexity of the nested data, it is recommended to send no more than 5 zones per each request.
   */
  readonly zonesToUpdate?: InputMaybe<ReadonlyArray<DeliveryLocationGroupZoneInput>>;
};

/** Return type for `deliveryProfileRemove` mutation. */
export type DeliveryProfileRemovePayload = {
  /** The delivery profile deletion job triggered by the mutation. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `deliveryProfileUpdate` mutation. */
export type DeliveryProfileUpdatePayload = {
  /** The delivery profile that was updated. */
  readonly profile?: Maybe<DeliveryProfile>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A delivery promise provider. Currently restricted to select approved delivery promise partners. */
export type DeliveryPromiseProvider = Node & {
  /** Whether the delivery promise provider is active. Defaults to `true` when creating a provider. */
  readonly active: Scalars['Boolean'];
  /** The number of seconds to add to the current time as a buffer when looking up delivery promises. Represents how long the shop requires before releasing an order to the fulfillment provider. */
  readonly fulfillmentDelay?: Maybe<Scalars['Int']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The location associated with this delivery promise provider. */
  readonly location: Location;
  /** The time zone to be used for interpreting day of week and cutoff times in delivery schedules when looking up delivery promises. */
  readonly timeZone: Scalars['String'];
};

/** Return type for `deliveryPromiseProviderUpsert` mutation. */
export type DeliveryPromiseProviderUpsertPayload = {
  /** The created or updated delivery promise provider. */
  readonly deliveryPromiseProvider?: Maybe<DeliveryPromiseProvider>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DeliveryPromiseProviderUpsertUserError>;
};

/** An error that occurs during the execution of `DeliveryPromiseProviderUpsert`. */
export type DeliveryPromiseProviderUpsertUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<DeliveryPromiseProviderUpsertUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `DeliveryPromiseProviderUpsertUserError`. */
export enum DeliveryPromiseProviderUpsertUserErrorCode {
  /** The time zone is invalid. */
  INVALID_TIME_ZONE = 'INVALID_TIME_ZONE',
  /** The location doesn't belong to the app. */
  MUST_BELONG_TO_APP = 'MUST_BELONG_TO_APP',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG'
}

/** A region that is used to define a shipping zone. */
export type DeliveryProvince = Node & {
  /** The code of the region. */
  readonly code: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The full name of the region. */
  readonly name: Scalars['String'];
  /** The translated name of the region. The translation returned is based on the system's locale. */
  readonly translatedName: Scalars['String'];
};

/** The input fields to specify a region. */
export type DeliveryProvinceInput = {
  /** The code of the region. */
  readonly code: Scalars['String'];
};

/** The merchant-defined rate of the [DeliveryMethodDefinition](https://shopify.dev/api/admin-graphql/latest/objects/DeliveryMethodDefinition). */
export type DeliveryRateDefinition = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The price of this rate. */
  readonly price: MoneyV2;
};

/** The input fields for a rate definition. */
export type DeliveryRateDefinitionInput = {
  /** A globally-unique ID of the rate definition. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The price of the rate definition. */
  readonly price: MoneyInput;
};

/** A rate provided by a merchant-defined rate or a participant. */
export type DeliveryRateProvider = DeliveryParticipant | DeliveryRateDefinition;

/**
 * The `DeliverySetting` object enables you to manage shop-wide shipping settings.
 * You can enable legacy compatibility mode for the multi-location delivery profiles feature
 * if the legacy mode isn't blocked.
 */
export type DeliverySetting = {
  /** Whether the shop is blocked from converting to full multi-location delivery profiles mode. If the shop is blocked, then the blocking reasons are also returned. */
  readonly legacyModeBlocked: DeliveryLegacyModeBlocked;
  /** Enables legacy compatability mode for the multi-location delivery profiles feature. */
  readonly legacyModeProfiles: Scalars['Boolean'];
};

/** The input fields for shop-level delivery settings. */
export type DeliverySettingInput = {
  /** Whether legacy compatability mode is enabled for the multi-location delivery profiles feature. */
  readonly legacyModeProfiles?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `deliverySettingUpdate` mutation. */
export type DeliverySettingUpdatePayload = {
  /** The updated delivery shop level settings. */
  readonly setting?: Maybe<DeliverySetting>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `deliveryShippingOriginAssign` mutation. */
export type DeliveryShippingOriginAssignPayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for updating the condition of a delivery method definition. */
export type DeliveryUpdateConditionInput = {
  /** The value that will be used in comparison. */
  readonly criteria?: InputMaybe<Scalars['Float']>;
  /** The unit associated with the value that will be used in comparison. */
  readonly criteriaUnit?: InputMaybe<Scalars['String']>;
  /** The property of an order that will be used in comparison. */
  readonly field?: InputMaybe<DeliveryConditionField>;
  /** A globally-unique ID of the condition. */
  readonly id: Scalars['ID'];
  /** The operator to use for comparison. */
  readonly operator?: InputMaybe<DeliveryConditionOperator>;
};

/** The input fields for a weight-based condition of a delivery method definition. */
export type DeliveryWeightConditionInput = {
  /** The weight value to compare the weight of an order to. */
  readonly criteria?: InputMaybe<WeightInput>;
  /** The operator to use for comparison. */
  readonly operator?: InputMaybe<DeliveryConditionOperator>;
};

/** A zone is a group of countries that have the same shipping rates. Customers can order products from a store only if they choose a shipping destination that's included in one of the store's zones. */
export type DeliveryZone = Node & {
  /** The list of countries within the zone. */
  readonly countries: ReadonlyArray<DeliveryCountry>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the zone. */
  readonly name: Scalars['String'];
};

/** Configuration of the deposit. */
export type DepositConfiguration = DepositPercentage;

/** The input fields configuring the deposit for a B2B buyer. */
export type DepositInput = {
  /** The percentage of the order total that should be paid as a deposit. */
  readonly percentage: Scalars['Float'];
};

/** A percentage deposit. */
export type DepositPercentage = {
  /** The percentage value of the deposit. */
  readonly percentage: Scalars['Float'];
};

/** Digital wallet, such as Apple Pay, which can be used for accelerated checkouts. */
export enum DigitalWallet {
  /** Amazon Pay. */
  AMAZON_PAY = 'AMAZON_PAY',
  /** Android Pay. */
  ANDROID_PAY = 'ANDROID_PAY',
  /** Apple Pay. */
  APPLE_PAY = 'APPLE_PAY',
  /** Facebook Pay. */
  FACEBOOK_PAY = 'FACEBOOK_PAY',
  /** Google Pay. */
  GOOGLE_PAY = 'GOOGLE_PAY',
  /** Shopify Pay. */
  SHOPIFY_PAY = 'SHOPIFY_PAY'
}

/** A discount. */
export type Discount = DiscountAutomaticApp | DiscountAutomaticBasic | DiscountAutomaticBxgy | DiscountAutomaticFreeShipping | DiscountCodeApp | DiscountCodeBasic | DiscountCodeBxgy | DiscountCodeFreeShipping;

/** An amount that's allocated to a line based on an associated discount application. */
export type DiscountAllocation = {
  /**
   * The money amount that's allocated to a line based on the associated discount application.
   * @deprecated Use `allocatedAmountSet` instead.
   */
  readonly allocatedAmount: MoneyV2;
  /** The money amount that's allocated to a line based on the associated discount application in shop and presentment currencies. */
  readonly allocatedAmountSet: MoneyBag;
  /** The discount application that the allocated amount originated from. */
  readonly discountApplication: DiscountApplication;
};

/** An auto-generated type for paginating through multiple DiscountAllocations. */
export type DiscountAllocationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DiscountAllocationEdge>;
  /** A list of nodes that are contained in DiscountAllocationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DiscountAllocation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountAllocation and a cursor during pagination. */
export type DiscountAllocationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DiscountAllocationEdge. */
  readonly node: DiscountAllocation;
};

/** The fixed amount value of a discount, and whether the amount is applied to each entitled item or spread evenly across the entitled items. */
export type DiscountAmount = {
  /** The value of the discount. */
  readonly amount: MoneyV2;
  /** If true, then the discount is applied to each of the entitled items. If false, then the amount is split across all of the entitled items. */
  readonly appliesOnEachItem: Scalars['Boolean'];
};

/** The input fields for the value of the discount and how it is applied. */
export type DiscountAmountInput = {
  /** The value of the discount. */
  readonly amount?: InputMaybe<Scalars['Decimal']>;
  /** If true, then the discount is applied to each of the entitled items. If false, then the amount is split across all of the entitled items. */
  readonly appliesOnEachItem?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Discount applications capture the intentions of a discount source at
 * the time of application on an order's line items or shipping lines.
 *
 * Discount applications don't represent the actual final amount discounted on a line (line item or shipping line). The actual amount discounted on a line is represented by the [DiscountAllocation](https://shopify.dev/api/admin-graphql/latest/objects/discountallocation) object.
 */
export type DiscountApplication = {
  /** The method by which the discount's value is applied to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  readonly index: Scalars['Int'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/** The method by which the discount's value is allocated onto its entitled lines. */
export enum DiscountApplicationAllocationMethod {
  /** The value is spread across all entitled lines. */
  ACROSS = 'ACROSS',
  /** The value is applied onto every entitled line. */
  EACH = 'EACH',
  /** The value is specifically applied onto a particular line. */
  ONE = 'ONE'
}

/** An auto-generated type for paginating through multiple DiscountApplications. */
export type DiscountApplicationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DiscountApplicationEdge>;
  /** A list of nodes that are contained in DiscountApplicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DiscountApplication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountApplication and a cursor during pagination. */
export type DiscountApplicationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DiscountApplicationEdge. */
  readonly node: DiscountApplication;
};

/** The level at which the discount's value is applied. */
export enum DiscountApplicationLevel {
  /**
   * The discount is applied at the line level.
   * Line level discounts are factored into the discountedUnitPriceSet on line items.
   */
  LINE = 'LINE',
  /**
   * The discount is applied at the order level.
   * Order level discounts are not factored into the discountedUnitPriceSet on line items.
   */
  ORDER = 'ORDER'
}

/**
 * The lines on the order to which the discount is applied, of the type defined by
 * the discount application's `targetType`. For example, the value `ENTITLED`, combined with a `targetType` of
 * `LINE_ITEM`, applies the discount on all line items that are entitled to the discount.
 * The value `ALL`, combined with a `targetType` of `SHIPPING_LINE`, applies the discount on all shipping lines.
 */
export enum DiscountApplicationTargetSelection {
  /** The discount is allocated onto all the lines. */
  ALL = 'ALL',
  /** The discount is allocated onto only the lines that it's entitled for. */
  ENTITLED = 'ENTITLED',
  /** The discount is allocated onto explicitly chosen lines. */
  EXPLICIT = 'EXPLICIT'
}

/** The type of line (i.e. line item or shipping line) on an order that the discount is applicable towards. */
export enum DiscountApplicationTargetType {
  /** The discount applies onto line items. */
  LINE_ITEM = 'LINE_ITEM',
  /** The discount applies onto shipping lines. */
  SHIPPING_LINE = 'SHIPPING_LINE'
}

/** The type of discount associated to the automatic discount. For example, the automatic discount might offer a basic discount using a fixed percentage, or a fixed amount, on specific products from the order. The automatic discount may also be a BXGY discount, which offers customer discounts on select products if they add a specific product to their order. */
export type DiscountAutomatic = DiscountAutomaticApp | DiscountAutomaticBasic | DiscountAutomaticBxgy | DiscountAutomaticFreeShipping;

/** Return type for `discountAutomaticActivate` mutation. */
export type DiscountAutomaticActivatePayload = {
  /** The activated automatic discount. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The `DiscountAutomaticApp` object stores information about automatic discounts
 * that are managed by an app using
 * [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
 * Use `DiscountAutomaticApp`when you need advanced, custom, or
 * dynamic discount capabilities that aren't supported by
 * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 *
 * Learn more about creating
 * [custom discount functionality](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
 *
 * > Note:
 * > The [`DiscountCodeApp`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeApp)
 * object has similar functionality to the `DiscountAutomaticApp` object, with the exception that `DiscountCodeApp`
 * stores information about discount codes that are managed by an app using Shopify Functions.
 */
export type DiscountAutomaticApp = {
  /**
   * The details about the app extension that's providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   * This information includes the app extension's name and
   * [client ID](https://shopify.dev/docs/apps/build/authentication-authorization/client-secrets),
   * [App Bridge configuration](https://shopify.dev/docs/api/app-bridge),
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations),
   * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries),
   * and other metadata about the discount type, including the discount type's name and description.
   */
  readonly appDiscountType: AppDiscountType;
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  readonly appliesOnSubscription: Scalars['Boolean'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  readonly asyncUsageCount: Scalars['Int'];
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the discount was created. */
  readonly createdAt: Scalars['DateTime'];
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   */
  readonly discountClass: DiscountClass;
  /**
   * The [globally-unique ID](https://shopify.dev/docs/api/usage/gids)
   * for the discount.
   */
  readonly discountId: Scalars['ID'];
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * The [error history](https://shopify.dev/docs/apps/build/functions/monitoring-and-errors)
   * for the latest version of the discount type that the app provides.
   */
  readonly errorHistory?: Maybe<FunctionsErrorHistory>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit: Scalars['Int'];
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt: Scalars['DateTime'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  readonly status: DiscountStatus;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title: Scalars['String'];
  /** The date and time when the discount was updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** Return type for `discountAutomaticAppCreate` mutation. */
export type DiscountAutomaticAppCreatePayload = {
  /** The automatic discount that the app manages. */
  readonly automaticAppDiscount?: Maybe<DiscountAutomaticApp>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The input fields for creating or updating an automatic discount
 * that's managed by an app.
 *
 * Use these input fields when you need advanced, custom, or
 * dynamic discount capabilities that aren't supported by
 * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 */
export type DiscountAutomaticAppInput = {
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  readonly appliesOnSubscription?: InputMaybe<Scalars['Boolean']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * The
   * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries)
   * associated with the app extension providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly functionId?: InputMaybe<Scalars['String']>;
  /**
   * Additional metafields to associate to the discount.
   * [Metafields](https://shopify.dev/docs/apps/build/custom-data)
   * provide dynamic function configuration with
   * different parameters, such as `percentage` for a percentage discount. Merchants can set metafield values
   * in the Shopify admin, which makes the discount function more flexible and customizable.
   */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit?: InputMaybe<Scalars['Int']>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt?: InputMaybe<Scalars['DateTime']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `discountAutomaticAppUpdate` mutation. */
export type DiscountAutomaticAppUpdatePayload = {
  /** The updated automatic discount that the app provides. */
  readonly automaticAppDiscount?: Maybe<DiscountAutomaticApp>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The `DiscountAutomaticBasic` object lets you manage
 * [amount off discounts](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
 * that are automatically applied on a cart and at checkout. Amount off discounts give customers a
 * fixed value or a percentage off the products in an order, but don't apply to shipping costs.
 *
 * The `DiscountAutomaticBasic` object stores information about automatic amount off discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountCodeBasic`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeBasic)
 * object has similar functionality to the `DiscountAutomaticBasic` object, but customers need to enter a code to
 * receive a discount.
 */
export type DiscountAutomaticBasic = {
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  readonly asyncUsageCount: Scalars['Int'];
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the discount was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  readonly customerGets: DiscountCustomerGets;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  readonly discountClass: MerchandiseDiscountClass;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  readonly minimumRequirement: DiscountMinimumRequirement;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit: Scalars['Int'];
  /**
   * An abbreviated version of the discount
   * [`summary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBasic#field-summary)
   * field.
   */
  readonly shortSummary: Scalars['String'];
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt: Scalars['DateTime'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  readonly status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  readonly summary: Scalars['String'];
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title: Scalars['String'];
  /** The date and time when the discount was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /**
   * The number of times that the discount has been used.
   * @deprecated Use `asyncUsageCount` instead.
   */
  readonly usageCount: Scalars['Int'];
};

/** Return type for `discountAutomaticBasicCreate` mutation. */
export type DiscountAutomaticBasicCreatePayload = {
  /** The automatic discount that was created. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The input fields for creating or updating an
 * [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
 * that's automatically applied on a cart and at checkout.
 */
export type DiscountAutomaticBasicInput = {
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /** Information about the qualifying items and their discount. */
  readonly customerGets?: InputMaybe<DiscountCustomerGetsInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: InputMaybe<Scalars['DateTime']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  readonly minimumRequirement?: InputMaybe<DiscountMinimumRequirementInput>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit?: InputMaybe<Scalars['Int']>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt?: InputMaybe<Scalars['DateTime']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `discountAutomaticBasicUpdate` mutation. */
export type DiscountAutomaticBasicUpdatePayload = {
  /** The automatic discount that was updated. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** Return type for `discountAutomaticBulkDelete` mutation. */
export type DiscountAutomaticBulkDeletePayload = {
  /** The asynchronous job removing the automatic discounts. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The `DiscountAutomaticBxgy` object lets you manage
 * [buy X get Y discounts (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that are automatically applied on a cart and at checkout. BXGY discounts incentivize customers by offering
 * them additional items at a discounted price or for free when they purchase a specified quantity of items.
 *
 * The `DiscountAutomaticBxgy` object stores information about automatic BXGY discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountCodeBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeBxgy)
 * object has similar functionality to the `DiscountAutomaticBxgy` object, but customers need to enter a code to
 * receive a discount.
 */
export type DiscountAutomaticBxgy = HasEvents & Node & {
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  readonly asyncUsageCount: Scalars['Int'];
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the discount was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The items eligible for the discount and the required quantity of each to receive the discount. */
  readonly customerBuys: DiscountCustomerBuys;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  readonly customerGets: DiscountCustomerGets;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  readonly discountClass: MerchandiseDiscountClass;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /**
   * A legacy unique ID for the discount.
   * @deprecated Use DiscountAutomaticNode.id instead.
   */
  readonly id: Scalars['ID'];
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt: Scalars['DateTime'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  readonly status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  readonly summary: Scalars['String'];
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title: Scalars['String'];
  /** The date and time when the discount was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /**
   * The number of times that the discount has been used.
   * @deprecated Use `asyncUsageCount` instead.
   */
  readonly usageCount: Scalars['Int'];
  /** The maximum number of times that the discount can be applied to an order. */
  readonly usesPerOrderLimit?: Maybe<Scalars['Int']>;
};


/**
 * The `DiscountAutomaticBxgy` object lets you manage
 * [buy X get Y discounts (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that are automatically applied on a cart and at checkout. BXGY discounts incentivize customers by offering
 * them additional items at a discounted price or for free when they purchase a specified quantity of items.
 *
 * The `DiscountAutomaticBxgy` object stores information about automatic BXGY discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountCodeBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeBxgy)
 * object has similar functionality to the `DiscountAutomaticBxgy` object, but customers need to enter a code to
 * receive a discount.
 */
export type DiscountAutomaticBxgyEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** Return type for `discountAutomaticBxgyCreate` mutation. */
export type DiscountAutomaticBxgyCreatePayload = {
  /** The automatic discount that was created. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The input fields for creating or updating a
 * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that's automatically applied on a cart and at checkout.
 */
export type DiscountAutomaticBxgyInput = {
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /** The items eligible for the discount and the required quantity of each to receive the discount. */
  readonly customerBuys?: InputMaybe<DiscountCustomerBuysInput>;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  readonly customerGets?: InputMaybe<DiscountCustomerGetsInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: InputMaybe<Scalars['DateTime']>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt?: InputMaybe<Scalars['DateTime']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title?: InputMaybe<Scalars['String']>;
  /** The maximum number of times that the discount can be applied to an order. */
  readonly usesPerOrderLimit?: InputMaybe<Scalars['UnsignedInt64']>;
};

/** Return type for `discountAutomaticBxgyUpdate` mutation. */
export type DiscountAutomaticBxgyUpdatePayload = {
  /** The automatic discount that was updated. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** An auto-generated type for paginating through multiple DiscountAutomatics. */
export type DiscountAutomaticConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DiscountAutomaticEdge>;
  /** A list of nodes that are contained in DiscountAutomaticEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DiscountAutomatic>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `discountAutomaticDeactivate` mutation. */
export type DiscountAutomaticDeactivatePayload = {
  /** The deactivated automatic discount. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** Return type for `discountAutomaticDelete` mutation. */
export type DiscountAutomaticDeletePayload = {
  /** The ID of the automatic discount that was deleted. */
  readonly deletedAutomaticDiscountId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** An auto-generated type which holds one DiscountAutomatic and a cursor during pagination. */
export type DiscountAutomaticEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DiscountAutomaticEdge. */
  readonly node: DiscountAutomatic;
};

/**
 * The `DiscountAutomaticFreeShipping` object lets you manage
 * [free shipping discounts](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
 * that are automatically applied on a cart and at checkout. Free shipping discounts are promotional deals that
 * merchants offer to customers to waive shipping costs and encourage online purchases.
 *
 * The `DiscountAutomaticFreeShipping` object stores information about automatic free shipping discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountCodeFreeShipping`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeFreeShipping)
 * object has similar functionality to the `DiscountAutomaticFreeShipping` object, but customers need to enter a code to
 * receive a discount.
 */
export type DiscountAutomaticFreeShipping = {
  /**
   * Whether the discount applies on one-time purchases.
   * A one-time purchase is a transaction where you pay a
   * single time for a product, without any ongoing
   * commitments or recurring charges.
   */
  readonly appliesOnOneTimePurchase: Scalars['Boolean'];
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  readonly appliesOnSubscription: Scalars['Boolean'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  readonly asyncUsageCount: Scalars['Int'];
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the discount was created. */
  readonly createdAt: Scalars['DateTime'];
  /**
   * The countries that qualify for the discount.
   * You can define
   * [a list of countries](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCountries)
   * or specify [all countries](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCountryAll)
   * to be eligible for the discount.
   */
  readonly destinationSelection: DiscountShippingDestinationSelection;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  readonly discountClass: ShippingDiscountClass;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** The maximum shipping price amount accepted to qualify for the discount. */
  readonly maximumShippingPrice?: Maybe<MoneyV2>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  readonly minimumRequirement: DiscountMinimumRequirement;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit: Scalars['Int'];
  /**
   * An abbreviated version of the discount
   * [`summary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticFreeShipping#field-summary)
   * field.
   */
  readonly shortSummary: Scalars['String'];
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt: Scalars['DateTime'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  readonly status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  readonly summary: Scalars['String'];
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title: Scalars['String'];
  /** The total sales from orders where the discount was used. */
  readonly totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** Return type for `discountAutomaticFreeShippingCreate` mutation. */
export type DiscountAutomaticFreeShippingCreatePayload = {
  /** The automatic free shipping discount that was created. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The input fields for creating or updating a
 * [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
 * that's automatically applied on a cart and at checkout.
 */
export type DiscountAutomaticFreeShippingInput = {
  /** Whether the discount applies on regular one-time-purchase items. */
  readonly appliesOnOneTimePurchase?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  readonly appliesOnSubscription?: InputMaybe<Scalars['Boolean']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with the shipping discount.
   */
  readonly combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /** A list of destinations where the discount will apply. */
  readonly destination?: InputMaybe<DiscountShippingDestinationSelectionInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: InputMaybe<Scalars['DateTime']>;
  /** The maximum shipping price that qualifies for the discount. */
  readonly maximumShippingPrice?: InputMaybe<Scalars['Decimal']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  readonly minimumRequirement?: InputMaybe<DiscountMinimumRequirementInput>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit?: InputMaybe<Scalars['Int']>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt?: InputMaybe<Scalars['DateTime']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `discountAutomaticFreeShippingUpdate` mutation. */
export type DiscountAutomaticFreeShippingUpdatePayload = {
  /** The automatic discount that was updated. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNode = HasEvents & HasMetafieldDefinitions & HasMetafields & Node & {
  /** A discount that's applied automatically when an order meets specific criteria. Learn more about [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts). */
  readonly automaticDiscount: DiscountAutomatic;
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodeMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodeMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodeMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodePrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * The `DiscountAutomaticNode` object enables you to manage [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts) that are applied when an order meets specific criteria. You can create amount off, free shipping, or buy X get Y automatic discounts. For example, you can offer customers a free shipping discount that applies when conditions are met. Or you can offer customers a buy X get Y discount that's automatically applied when customers spend a specified amount of money, or a specified quantity of products.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountAutomaticNodePrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple DiscountAutomaticNodes. */
export type DiscountAutomaticNodeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DiscountAutomaticNodeEdge>;
  /** A list of nodes that are contained in DiscountAutomaticNodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DiscountAutomaticNode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountAutomaticNode and a cursor during pagination. */
export type DiscountAutomaticNodeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DiscountAutomaticNodeEdge. */
  readonly node: DiscountAutomaticNode;
};

/**
 * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
 * that's used to control how discounts can be combined.
 */
export enum DiscountClass {
  /**
   * The discount is combined with an
   * [order discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  ORDER = 'ORDER',
  /**
   * The discount is combined with a
   * [product discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  PRODUCT = 'PRODUCT',
  /**
   * The discount is combined with a
   * [shipping discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  SHIPPING = 'SHIPPING'
}

/** The type of discount associated with the discount code. For example, the discount code might offer a basic discount of a fixed percentage, or a fixed amount, on specific products or the order. Alternatively, the discount might offer the customer free shipping on their order. A third option is a Buy X, Get Y (BXGY) discount, which offers a customer discounts on select products if they add a specific product to their order. */
export type DiscountCode = DiscountCodeApp | DiscountCodeBasic | DiscountCodeBxgy | DiscountCodeFreeShipping;

/** Return type for `discountCodeActivate` mutation. */
export type DiscountCodeActivatePayload = {
  /** The activated code discount. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The `DiscountCodeApp` object stores information about code discounts
 * that are managed by an app using
 * [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
 * Use `DiscountCodeApp` when you need advanced, custom, or
 * dynamic discount capabilities that aren't supported by
 * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 *
 * Learn more about creating
 * [custom discount functionality](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
 *
 * > Note:
 * > The [`DiscountAutomaticApp`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticApp)
 * object has similar functionality to the `DiscountCodeApp` object, with the exception that `DiscountAutomaticApp`
 * stores information about automatic discounts that are managed by an app using Shopify Functions.
 */
export type DiscountCodeApp = {
  /**
   * The details about the app extension that's providing the
   * [discount type](https://help.shopify.com/manual/discounts/discount-types).
   * This information includes the app extension's name and
   * [client ID](https://shopify.dev/docs/apps/build/authentication-authorization/client-secrets),
   * [App Bridge configuration](https://shopify.dev/docs/api/app-bridge),
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations),
   * [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries),
   * and other metadata about the discount type, including the discount type's name and description.
   */
  readonly appDiscountType: AppDiscountType;
  /** Whether a customer can only use the discount once. */
  readonly appliesOncePerCustomer: Scalars['Boolean'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  readonly asyncUsageCount: Scalars['Int'];
  /** A list codes that customers can use to redeem the discount. */
  readonly codes: DiscountRedeemCodeConnection;
  /** The number of codes that a customer can use to redeem the discount. */
  readonly codesCount?: Maybe<Count>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the discount was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The customers that can use the discount. */
  readonly customerSelection: DiscountCustomerSelection;
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   */
  readonly discountClass: DiscountClass;
  /**
   * The [globally-unique ID](https://shopify.dev/docs/api/usage/gids)
   * for the discount.
   */
  readonly discountId: Scalars['ID'];
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * The [error history](https://shopify.dev/docs/apps/build/functions/monitoring-and-errors)
   * for the latest version of the discount type that the app provides.
   */
  readonly errorHistory?: Maybe<FunctionsErrorHistory>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  readonly hasTimelineComment: Scalars['Boolean'];
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit?: Maybe<Scalars['Int']>;
  /** A list of URLs that the app can use to share the discount. */
  readonly shareableUrls: ReadonlyArray<DiscountShareableUrl>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt: Scalars['DateTime'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  readonly status: DiscountStatus;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title: Scalars['String'];
  /** The total sales from orders where the discount was used. */
  readonly totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /**
   * The maximum number of times that a customer can use the discount.
   * For discounts with unlimited usage, specify `null`.
   */
  readonly usageLimit?: Maybe<Scalars['Int']>;
};


/**
 * The `DiscountCodeApp` object stores information about code discounts
 * that are managed by an app using
 * [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
 * Use `DiscountCodeApp` when you need advanced, custom, or
 * dynamic discount capabilities that aren't supported by
 * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 *
 * Learn more about creating
 * [custom discount functionality](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
 *
 * > Note:
 * > The [`DiscountAutomaticApp`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticApp)
 * object has similar functionality to the `DiscountCodeApp` object, with the exception that `DiscountAutomaticApp`
 * stores information about automatic discounts that are managed by an app using Shopify Functions.
 */
export type DiscountCodeAppCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};

/** Return type for `discountCodeAppCreate` mutation. */
export type DiscountCodeAppCreatePayload = {
  /** The discount that the app provides. */
  readonly codeAppDiscount?: Maybe<DiscountCodeApp>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The input fields for creating or updating a code discount, where the discount type is provided by an app extension that uses [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
 *
 *
 * Use these input fields when you need advanced or custom discount capabilities that aren't supported by [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
 */
export type DiscountCodeAppInput = {
  /** Whether a customer can only use the discount once. */
  readonly appliesOncePerCustomer?: InputMaybe<Scalars['Boolean']>;
  /** The code that customers use to apply the discount. */
  readonly code?: InputMaybe<Scalars['String']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /** The customers that can use the discount. */
  readonly customerSelection?: InputMaybe<DiscountCustomerSelectionInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: InputMaybe<Scalars['DateTime']>;
  /** The [function ID](https://shopify.dev/docs/apps/build/functions/input-output/metafields-for-input-queries) associated with the app extension that's providing the [discount type](https://help.shopify.com/manual/discounts/discount-types). */
  readonly functionId?: InputMaybe<Scalars['String']>;
  /** Additional metafields to associate to the discount. [Metafields](https://shopify.dev/docs/apps/build/custom-data) provide dynamic function configuration with different parameters, such as `percentage` for a percentage discount. Merchants can set metafield values in the Shopify admin, which makes the discount function more flexible and customizable. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt?: InputMaybe<Scalars['DateTime']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title?: InputMaybe<Scalars['String']>;
  /**
   * The maximum number of times that a customer can use the discount.
   * For discounts with unlimited usage, specify `null`.
   */
  readonly usageLimit?: InputMaybe<Scalars['Int']>;
};

/** Return type for `discountCodeAppUpdate` mutation. */
export type DiscountCodeAppUpdatePayload = {
  /** The updated discount that the app provides. */
  readonly codeAppDiscount?: Maybe<DiscountCodeApp>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * Discount code applications capture the intentions of a discount code at
 * the time that it is applied onto an order.
 *
 * Discount applications don't represent the actual final amount discounted on a line (line item or shipping line). The actual amount discounted on a line is represented by the [DiscountAllocation](https://shopify.dev/api/admin-graphql/latest/objects/discountallocation) object.
 */
export type DiscountCodeApplication = DiscountApplication & {
  /** The method by which the discount's value is applied to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /** The string identifying the discount code that was used at the time of application. */
  readonly code: Scalars['String'];
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  readonly index: Scalars['Int'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/**
 * The `DiscountCodeBasic` object lets you manage
 * [amount off discounts](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
 * that are applied on a cart and at checkout when a customer enters a code. Amount off discounts give customers a
 * fixed value or a percentage off the products in an order, but don't apply to shipping costs.
 *
 * The `DiscountCodeBasic` object stores information about amount off code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountAutomaticBasic`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBasic)
 * object has similar functionality to the `DiscountCodeBasic` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeBasic = {
  /** Whether a customer can only use the discount once. */
  readonly appliesOncePerCustomer: Scalars['Boolean'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  readonly asyncUsageCount: Scalars['Int'];
  /** A list codes that customers can use to redeem the discount. */
  readonly codes: DiscountRedeemCodeConnection;
  /** The number of codes that a customer can use to redeem the discount. */
  readonly codesCount?: Maybe<Count>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the discount was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  readonly customerGets: DiscountCustomerGets;
  /** The customers that can use the discount. */
  readonly customerSelection: DiscountCustomerSelection;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  readonly discountClass: MerchandiseDiscountClass;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  readonly minimumRequirement?: Maybe<DiscountMinimumRequirement>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit?: Maybe<Scalars['Int']>;
  /** A list of URLs that the app can use to share the discount. */
  readonly shareableUrls: ReadonlyArray<DiscountShareableUrl>;
  /**
   * An abbreviated version of the discount
   * [`summary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeBasic#field-summary)
   * field.
   */
  readonly shortSummary: Scalars['String'];
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt: Scalars['DateTime'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  readonly status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  readonly summary: Scalars['String'];
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title: Scalars['String'];
  /** The total sales from orders where the discount was used. */
  readonly totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /**
   * The maximum number of times that a customer can use the discount.
   * For discounts with unlimited usage, specify `null`.
   */
  readonly usageLimit?: Maybe<Scalars['Int']>;
};


/**
 * The `DiscountCodeBasic` object lets you manage
 * [amount off discounts](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
 * that are applied on a cart and at checkout when a customer enters a code. Amount off discounts give customers a
 * fixed value or a percentage off the products in an order, but don't apply to shipping costs.
 *
 * The `DiscountCodeBasic` object stores information about amount off code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountAutomaticBasic`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBasic)
 * object has similar functionality to the `DiscountCodeBasic` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeBasicCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};

/** Return type for `discountCodeBasicCreate` mutation. */
export type DiscountCodeBasicCreatePayload = {
  /** The discount code that was created. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** The input fields for creating or updating an [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount) that's applied on a cart and at checkout when a customer enters a code. Amount off discounts can be a percentage off or a fixed amount off. */
export type DiscountCodeBasicInput = {
  /** Whether a customer can only use the discount once. */
  readonly appliesOncePerCustomer?: InputMaybe<Scalars['Boolean']>;
  /** The code that customers use to apply the discount. */
  readonly code?: InputMaybe<Scalars['String']>;
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  readonly customerGets?: InputMaybe<DiscountCustomerGetsInput>;
  /** The customers that can use the discount. */
  readonly customerSelection?: InputMaybe<DiscountCustomerSelectionInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: InputMaybe<Scalars['DateTime']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  readonly minimumRequirement?: InputMaybe<DiscountMinimumRequirementInput>;
  /** The number of billing cycles for which the discount can be applied, which is useful for subscription-based discounts. For example, if you set this field to `3`, then the discount only applies to the first three billing cycles of a subscription. If you specify `0`, then the discount applies indefinitely. */
  readonly recurringCycleLimit?: InputMaybe<Scalars['Int']>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt?: InputMaybe<Scalars['DateTime']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title?: InputMaybe<Scalars['String']>;
  /**
   * The maximum number of times that a customer can use the discount.
   * For discounts with unlimited usage, specify `null`.
   */
  readonly usageLimit?: InputMaybe<Scalars['Int']>;
};

/** Return type for `discountCodeBasicUpdate` mutation. */
export type DiscountCodeBasicUpdatePayload = {
  /** The discount code that was updated. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** Return type for `discountCodeBulkActivate` mutation. */
export type DiscountCodeBulkActivatePayload = {
  /** The asynchronous job that activates the discounts. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** Return type for `discountCodeBulkDeactivate` mutation. */
export type DiscountCodeBulkDeactivatePayload = {
  /** The asynchronous job that deactivates the discounts. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** Return type for `discountCodeBulkDelete` mutation. */
export type DiscountCodeBulkDeletePayload = {
  /** The asynchronous job that deletes the discounts. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The `DiscountCodeBxgy` object lets you manage
 * [buy X get Y discounts (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that are applied on a cart and at checkout when a customer enters a code. BXGY discounts incentivize customers
 * by offering them additional items at a discounted price or for free when they purchase a specified quantity
 * of items.
 *
 * The `DiscountCodeBxgy` object stores information about BXGY code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountAutomaticBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBxgy)
 * object has similar functionality to the `DiscountCodeBxgy` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeBxgy = {
  /** Whether a customer can only use the discount once. */
  readonly appliesOncePerCustomer: Scalars['Boolean'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  readonly asyncUsageCount: Scalars['Int'];
  /** A list codes that customers can use to redeem the discount. */
  readonly codes: DiscountRedeemCodeConnection;
  /** The number of codes that a customer can use to redeem the discount. */
  readonly codesCount?: Maybe<Count>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the discount was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The items eligible for the discount and the required quantity of each to receive the discount. */
  readonly customerBuys: DiscountCustomerBuys;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  readonly customerGets: DiscountCustomerGets;
  /** The customers that can use the discount. */
  readonly customerSelection: DiscountCustomerSelection;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  readonly discountClass: MerchandiseDiscountClass;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** A list of URLs that the app can use to share the discount. */
  readonly shareableUrls: ReadonlyArray<DiscountShareableUrl>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt: Scalars['DateTime'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  readonly status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  readonly summary: Scalars['String'];
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title: Scalars['String'];
  /** The total sales from orders where the discount was used. */
  readonly totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /**
   * The maximum number of times that a customer can use the discount.
   * For discounts with unlimited usage, specify `null`.
   */
  readonly usageLimit?: Maybe<Scalars['Int']>;
  /** The maximum number of times that the discount can be applied to an order. */
  readonly usesPerOrderLimit?: Maybe<Scalars['Int']>;
};


/**
 * The `DiscountCodeBxgy` object lets you manage
 * [buy X get Y discounts (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that are applied on a cart and at checkout when a customer enters a code. BXGY discounts incentivize customers
 * by offering them additional items at a discounted price or for free when they purchase a specified quantity
 * of items.
 *
 * The `DiscountCodeBxgy` object stores information about BXGY code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The [`DiscountAutomaticBxgy`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticBxgy)
 * object has similar functionality to the `DiscountCodeBxgy` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeBxgyCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};

/** Return type for `discountCodeBxgyCreate` mutation. */
export type DiscountCodeBxgyCreatePayload = {
  /** The code discount that was created. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The input fields for creating or updating a
 * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
 * that's applied on a cart and at checkout when a customer enters a code.
 */
export type DiscountCodeBxgyInput = {
  /** Whether a customer can only use the discount once. */
  readonly appliesOncePerCustomer?: InputMaybe<Scalars['Boolean']>;
  /** The code that customers use to apply the discount. */
  readonly code?: InputMaybe<Scalars['String']>;
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /** The items eligible for the discount and the required quantity of each to receive the discount. */
  readonly customerBuys?: InputMaybe<DiscountCustomerBuysInput>;
  /** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
  readonly customerGets?: InputMaybe<DiscountCustomerGetsInput>;
  /** The customers that can use the discount. */
  readonly customerSelection?: InputMaybe<DiscountCustomerSelectionInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: InputMaybe<Scalars['DateTime']>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt?: InputMaybe<Scalars['DateTime']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title?: InputMaybe<Scalars['String']>;
  /**
   * The maximum number of times that a customer can use the discount.
   * For discounts with unlimited usage, specify `null`.
   */
  readonly usageLimit?: InputMaybe<Scalars['Int']>;
  /** The maximum number of times that the discount can be applied to an order. */
  readonly usesPerOrderLimit?: InputMaybe<Scalars['Int']>;
};

/** Return type for `discountCodeBxgyUpdate` mutation. */
export type DiscountCodeBxgyUpdatePayload = {
  /** The code discount that was updated. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** Return type for `discountCodeDeactivate` mutation. */
export type DiscountCodeDeactivatePayload = {
  /** The deactivated code discount. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** Return type for `discountCodeDelete` mutation. */
export type DiscountCodeDeletePayload = {
  /** The ID of the code discount that was deleted. */
  readonly deletedCodeDiscountId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The `DiscountCodeFreeShipping` object lets you manage
 * [free shipping discounts](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
 * that are applied on a cart and at checkout when a customer enters a code. Free shipping discounts are
 * promotional deals that merchants offer to customers to waive shipping costs and encourage online purchases.
 *
 * The `DiscountCodeFreeShipping` object stores information about free shipping code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The
 * [`DiscountAutomaticFreeShipping`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticFreeShipping)
 * object has similar functionality to the `DiscountCodeFreeShipping` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeFreeShipping = {
  /**
   * Whether the discount applies on one-time purchases.
   * A one-time purchase is a transaction where you pay a
   * single time for a product, without any ongoing
   * commitments or recurring charges.
   */
  readonly appliesOnOneTimePurchase: Scalars['Boolean'];
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  readonly appliesOnSubscription: Scalars['Boolean'];
  /** Whether a customer can only use the discount once. */
  readonly appliesOncePerCustomer: Scalars['Boolean'];
  /**
   * The number of times that the discount has been used.
   * For example, if a "Buy 3, Get 1 Free" t-shirt discount
   * is automatically applied in 200 transactions, then the
   * discount has been used 200 times.
   * This value is updated asynchronously. As a result,
   * it might be lower than the actual usage count until the
   * asynchronous process is completed.
   */
  readonly asyncUsageCount: Scalars['Int'];
  /** A list codes that customers can use to redeem the discount. */
  readonly codes: DiscountRedeemCodeConnection;
  /** The number of codes that a customer can use to redeem the discount. */
  readonly codesCount?: Maybe<Count>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the discount was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The customers that can use the discount. */
  readonly customerSelection: DiscountCustomerSelection;
  /**
   * The countries that qualify for the discount.
   * You can define
   * [a list of countries](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCountries)
   * or specify [all countries](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCountryAll)
   * to be eligible for the discount.
   */
  readonly destinationSelection: DiscountShippingDestinationSelection;
  /**
   * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   * @deprecated Use `discountClasses` instead.
   */
  readonly discountClass: ShippingDiscountClass;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Whether there are
   * [timeline comments](https://help.shopify.com/manual/discounts/managing-discount-codes#use-the-discount-timeline)
   * associated with the discount.
   */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** The maximum shipping price amount accepted to qualify for the discount. */
  readonly maximumShippingPrice?: Maybe<MoneyV2>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  readonly minimumRequirement?: Maybe<DiscountMinimumRequirement>;
  /**
   * The number of billing cycles for which the discount can be applied,
   * which is useful for subscription-based discounts. For example, if you set this field
   * to `3`, then the discount only applies to the first three billing cycles of a
   * subscription. If you specify `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit?: Maybe<Scalars['Int']>;
  /** A list of URLs that the app can use to share the discount. */
  readonly shareableUrls: ReadonlyArray<DiscountShareableUrl>;
  /**
   * An abbreviated version of the discount
   * [`summary`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCodeFreeShipping#field-summary)
   * field.
   */
  readonly shortSummary: Scalars['String'];
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt: Scalars['DateTime'];
  /**
   * The status of the discount that describes its availability,
   * expiration, or pending activation.
   */
  readonly status: DiscountStatus;
  /**
   * A detailed explanation of what the discount is,
   * who can use it, when and where it applies, and any associated
   * rules or limitations.
   */
  readonly summary: Scalars['String'];
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title: Scalars['String'];
  /** The total sales from orders where the discount was used. */
  readonly totalSales?: Maybe<MoneyV2>;
  /** The date and time when the discount was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /**
   * The maximum number of times that a customer can use the discount.
   * For discounts with unlimited usage, specify `null`.
   */
  readonly usageLimit?: Maybe<Scalars['Int']>;
};


/**
 * The `DiscountCodeFreeShipping` object lets you manage
 * [free shipping discounts](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
 * that are applied on a cart and at checkout when a customer enters a code. Free shipping discounts are
 * promotional deals that merchants offer to customers to waive shipping costs and encourage online purchases.
 *
 * The `DiscountCodeFreeShipping` object stores information about free shipping code discounts that apply to
 * specific [products and variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountProducts),
 * [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountCollections),
 * or [all items in a cart](https://shopify.dev/docs/api/admin-graphql/latest/objects/AllDiscountItems).
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including limitations and considerations.
 *
 * > Note:
 * > The
 * [`DiscountAutomaticFreeShipping`](https://shopify.dev/docs/api/admin-graphql/latest/objects/DiscountAutomaticFreeShipping)
 * object has similar functionality to the `DiscountCodeFreeShipping` object, but discounts are automatically applied,
 * without the need for customers to enter a code.
 */
export type DiscountCodeFreeShippingCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};

/** Return type for `discountCodeFreeShippingCreate` mutation. */
export type DiscountCodeFreeShippingCreatePayload = {
  /** The discount code that was created. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** The input fields for creating or updating a [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping) that's applied on a cart and at checkout when a customer enters a code. */
export type DiscountCodeFreeShippingInput = {
  /** Whether the discount applies on one-time purchases. A one-time purchase is a transaction where you pay a single time for a product, without any ongoing commitments or recurring charges. */
  readonly appliesOnOneTimePurchase?: InputMaybe<Scalars['Boolean']>;
  /** Whether the discount applies on subscription items. [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts) enable customers to purchase products on a recurring basis. */
  readonly appliesOnSubscription?: InputMaybe<Scalars['Boolean']>;
  /** Whether a customer can only use the discount once. */
  readonly appliesOncePerCustomer?: InputMaybe<Scalars['Boolean']>;
  /** The code that customers use to apply the discount. */
  readonly code?: InputMaybe<Scalars['String']>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with the shipping discount.
   */
  readonly combinesWith?: InputMaybe<DiscountCombinesWithInput>;
  /** The customers that can use the discount. */
  readonly customerSelection?: InputMaybe<DiscountCustomerSelectionInput>;
  /** The shipping destinations where the free shipping discount can be applied. You can specify whether the discount applies to all countries, or specify individual countries. */
  readonly destination?: InputMaybe<DiscountShippingDestinationSelectionInput>;
  /**
   * The date and time when the discount expires and is no longer available to customers.
   * For discounts without a fixed expiration date, specify `null`.
   */
  readonly endsAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * The maximum shipping price, in the shop's currency, that qualifies for free shipping.
   * <br/><br/>
   * For example, if set to 20.00, then only shipping rates that cost $20.00 or less will be made free. To apply the discount to all shipping rates, specify `null`.
   */
  readonly maximumShippingPrice?: InputMaybe<Scalars['Decimal']>;
  /** The minimum subtotal or quantity of items that are required for the discount to be applied. */
  readonly minimumRequirement?: InputMaybe<DiscountMinimumRequirementInput>;
  /**
   * The number of billing cycles for which the discount can be applied, which is useful for subscription-based discounts.
   * <br/><br/>
   * For example, if set to `3`, then the discount only applies to the first three billing cycles of a subscription. If set to `0`, then the discount applies indefinitely.
   */
  readonly recurringCycleLimit?: InputMaybe<Scalars['Int']>;
  /** The date and time when the discount becomes active and is available to customers. */
  readonly startsAt?: InputMaybe<Scalars['DateTime']>;
  /** The discount's name that displays to merchants in the Shopify admin and to customers. */
  readonly title?: InputMaybe<Scalars['String']>;
  /**
   * The maximum number of times that a customer can use the discount.
   * For discounts with unlimited usage, specify `null`.
   */
  readonly usageLimit?: InputMaybe<Scalars['Int']>;
};

/** Return type for `discountCodeFreeShippingUpdate` mutation. */
export type DiscountCodeFreeShippingUpdatePayload = {
  /** The discount code that was updated. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNode = HasEvents & HasMetafieldDefinitions & HasMetafields & Node & {
  /** The underlying code discount object. */
  readonly codeDiscount: DiscountCode;
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodeMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodeMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodeMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodePrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * The `DiscountCodeNode` object enables you to manage [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) that are applied when customers enter a code at checkout. For example, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store. Or, you can offer discounts where customers have to enter a code to get free shipping. Merchants can create and share discount codes individually with customers.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related queries, mutations, limitations, and considerations.
 */
export type DiscountCodeNodePrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple DiscountCodeNodes. */
export type DiscountCodeNodeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DiscountCodeNodeEdge>;
  /** A list of nodes that are contained in DiscountCodeNodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DiscountCodeNode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountCodeNode and a cursor during pagination. */
export type DiscountCodeNodeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DiscountCodeNodeEdge. */
  readonly node: DiscountCodeNode;
};

/** Return type for `discountCodeRedeemCodeBulkDelete` mutation. */
export type DiscountCodeRedeemCodeBulkDeletePayload = {
  /** The asynchronous job that deletes the discount codes. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** The set of valid sort keys for the DiscountCode query. */
export enum DiscountCodeSortKeys {
  /** Sort by the `code` value. */
  CODE = 'CODE',
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** A list of collections that the discount can have as a prerequisite or a list of collections to which the discount can be applied. */
export type DiscountCollections = {
  /** The list of collections that the discount can have as a prerequisite or the list of collections to which the discount can be applied. */
  readonly collections: CollectionConnection;
};


/** A list of collections that the discount can have as a prerequisite or a list of collections to which the discount can be applied. */
export type DiscountCollectionsCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields for collections attached to a discount. */
export type DiscountCollectionsInput = {
  /** Specifies list of collection ids to add. */
  readonly add?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** Specifies list of collection ids to remove. */
  readonly remove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/**
 * The [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
 * that you can use in combination with
 * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
 */
export type DiscountCombinesWith = {
  /**
   * Whether the discount combines with the
   * [order discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  readonly orderDiscounts: Scalars['Boolean'];
  /**
   * Whether the discount combines with the
   * [product discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  readonly productDiscounts: Scalars['Boolean'];
  /**
   * Whether the discount combines with the
   * [shipping discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  readonly shippingDiscounts: Scalars['Boolean'];
};

/** The input fields to determine which discount classes the discount can combine with. */
export type DiscountCombinesWithInput = {
  /**
   * Whether the discount combines with the
   * [order discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  readonly orderDiscounts?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the discount combines with the
   * [product discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  readonly productDiscounts?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the discount combines
   * with the
   * [shipping discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  readonly shippingDiscounts?: InputMaybe<Scalars['Boolean']>;
};

/** The shipping destinations where the discount can be applied. */
export type DiscountCountries = {
  /** The codes for the countries where the discount can be applied. */
  readonly countries: ReadonlyArray<CountryCode>;
  /** Whether the discount is applicable to countries that haven't been defined in the shop's shipping zones. */
  readonly includeRestOfWorld: Scalars['Boolean'];
};

/** The input fields for a list of countries to add or remove from the free shipping discount. */
export type DiscountCountriesInput = {
  /** The country codes to add to the list of countries where the discount applies. */
  readonly add?: InputMaybe<ReadonlyArray<CountryCode>>;
  /** Whether the discount code is applicable to countries that haven't been defined in the shop's shipping zones. */
  readonly includeRestOfWorld?: InputMaybe<Scalars['Boolean']>;
  /** The country codes to remove from the list of countries where the discount applies. */
  readonly remove?: InputMaybe<ReadonlyArray<CountryCode>>;
};

/** The `DiscountCountryAll` object lets you target all countries as shipping destination for discount eligibility. */
export type DiscountCountryAll = {
  /** Whether the discount can be applied to all countries as shipping destination. This value is always `true`. */
  readonly allCountries: Scalars['Boolean'];
};

/** The `DiscountCustomerAll` object lets you target all customers for discount eligibility. */
export type DiscountCustomerAll = {
  /** Whether the discount can be applied by all customers. This value is always `true`. */
  readonly allCustomers: Scalars['Boolean'];
};

/** The prerequisite items and prerequisite value that a customer must have on the order for the discount to be applicable. */
export type DiscountCustomerBuys = {
  /** The items required for the discount to be applicable. */
  readonly items: DiscountItems;
  /** The prerequisite value. */
  readonly value: DiscountCustomerBuysValue;
};

/** The input fields for prerequisite items and quantity for the discount. */
export type DiscountCustomerBuysInput = {
  /** The IDs of items that the customer buys. The items can be either collections or products. */
  readonly items?: InputMaybe<DiscountItemsInput>;
  /** The quantity of prerequisite items. */
  readonly value?: InputMaybe<DiscountCustomerBuysValueInput>;
};

/** The prerequisite for the discount to be applicable. For example, the discount might require a customer to buy a minimum quantity of select items. Alternatively, the discount might require a customer to spend a minimum amount on select items. */
export type DiscountCustomerBuysValue = DiscountPurchaseAmount | DiscountQuantity;

/** The input fields for prerequisite quantity or minimum purchase amount required for the discount. */
export type DiscountCustomerBuysValueInput = {
  /** The prerequisite minimum purchase amount required for the discount to be applicable. */
  readonly amount?: InputMaybe<Scalars['Decimal']>;
  /** The quantity of prerequisite items. */
  readonly quantity?: InputMaybe<Scalars['UnsignedInt64']>;
};

/** The items in the order that qualify for the discount, their quantities, and the total value of the discount. */
export type DiscountCustomerGets = {
  /** Whether the discount applies on regular one-time-purchase items. */
  readonly appliesOnOneTimePurchase: Scalars['Boolean'];
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  readonly appliesOnSubscription: Scalars['Boolean'];
  /** The items to which the discount applies. */
  readonly items: DiscountItems;
  /** Entitled quantity and the discount value. */
  readonly value: DiscountCustomerGetsValue;
};

/** Specifies the items that will be discounted, the quantity of items that will be discounted, and the value of discount. */
export type DiscountCustomerGetsInput = {
  /** Whether the discount applies on regular one-time-purchase items. */
  readonly appliesOnOneTimePurchase?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the discount applies on subscription items.
   * [Subscriptions](https://shopify.dev/docs/apps/launch/billing/subscription-billing/offer-subscription-discounts)
   * enable customers to purchase products
   * on a recurring basis.
   */
  readonly appliesOnSubscription?: InputMaybe<Scalars['Boolean']>;
  /** The IDs of the items that the customer gets. The items can be either collections or products. */
  readonly items?: InputMaybe<DiscountItemsInput>;
  /** The quantity of items discounted and the discount value. */
  readonly value?: InputMaybe<DiscountCustomerGetsValueInput>;
};

/** The type of the discount value and how it will be applied. For example, it might be a percentage discount on a fixed number of items. Alternatively, it might be a fixed amount evenly distributed across all items or on each individual item. A third example is a percentage discount on all items. */
export type DiscountCustomerGetsValue = DiscountAmount | DiscountOnQuantity | DiscountPercentage;

/** The input fields for the quantity of items discounted and the discount value. */
export type DiscountCustomerGetsValueInput = {
  /** The value of the discount. */
  readonly discountAmount?: InputMaybe<DiscountAmountInput>;
  /** The quantity of the items that are discounted and the discount value. */
  readonly discountOnQuantity?: InputMaybe<DiscountOnQuantityInput>;
  /** The percentage value of the discount. Value must be between 0.00 - 1.00. */
  readonly percentage?: InputMaybe<Scalars['Float']>;
};

/** A list of customer segments who are eligible for the discount. */
export type DiscountCustomerSegments = {
  /** The list of customer segments who are eligible for the discount. */
  readonly segments: ReadonlyArray<Segment>;
};

/** The input fields for which customer segments to add to or remove from the discount. */
export type DiscountCustomerSegmentsInput = {
  /** A list of customer segments to add to the current list of customer segments. */
  readonly add?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** A list of customer segments to remove from the current list of customer segments. */
  readonly remove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** The type used for targeting a set of customers who are eligible for the discount. For example, the discount might be available to all customers or it might only be available to a specific set of customers. You can define the set of customers by targeting a list of customer segments, or by targeting a list of specific customers. */
export type DiscountCustomerSelection = DiscountCustomerAll | DiscountCustomerSegments | DiscountCustomers;

/** The input fields for the customers who can use this discount. */
export type DiscountCustomerSelectionInput = {
  /** Whether all customers can use this discount. */
  readonly all?: InputMaybe<Scalars['Boolean']>;
  /** The list of customer segment IDs to add or remove from the list of customer segments. */
  readonly customerSegments?: InputMaybe<DiscountCustomerSegmentsInput>;
  /** The list of customer IDs to add or remove from the list of customers. */
  readonly customers?: InputMaybe<DiscountCustomersInput>;
};

/** A list of individual customers eligible for the discount. */
export type DiscountCustomers = {
  /** The list of individual customers eligible for the discount. */
  readonly customers: ReadonlyArray<Customer>;
};

/** The input fields for which customers to add to or remove from the discount. */
export type DiscountCustomersInput = {
  /** A list of customers to add to the current list of customers who can use the discount. */
  readonly add?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** A list of customers to remove from the current list of customers who can use the discount. */
  readonly remove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** The type of discount that will be applied. Currently, only a percentage discount is supported. */
export type DiscountEffect = DiscountAmount | DiscountPercentage;

/** The input fields for how the discount will be applied. Currently, only percentage off is supported. */
export type DiscountEffectInput = {
  /** The value of the discount. */
  readonly amount?: InputMaybe<Scalars['Decimal']>;
  /** The percentage value of the discount. Value must be between 0.00 - 1.00. */
  readonly percentage?: InputMaybe<Scalars['Float']>;
};

/** Possible error codes that can be returned by `DiscountUserError`. */
export enum DiscountErrorCode {
  /** The active period overlaps with other automatic discounts. At any given time, only 25 automatic discounts can be active. */
  ACTIVE_PERIOD_OVERLAP = 'ACTIVE_PERIOD_OVERLAP',
  /** A discount cannot have both appliesOnOneTimePurchase and appliesOnSubscription set to false. */
  APPLIES_ON_NOTHING = 'APPLIES_ON_NOTHING',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The attribute selection contains conflicting settings. */
  CONFLICT = 'CONFLICT',
  /** The input value is already present. */
  DUPLICATE = 'DUPLICATE',
  /** The end date should be after the start date. */
  END_DATE_BEFORE_START_DATE = 'END_DATE_BEFORE_START_DATE',
  /** The input value should be equal to the value allowed. */
  EQUAL_TO = 'EQUAL_TO',
  /** The value exceeded the maximum allowed value. */
  EXCEEDED_MAX = 'EXCEEDED_MAX',
  /** The input value should be greater than the minimum allowed value. */
  GREATER_THAN = 'GREATER_THAN',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  /** The value is already present through another selection. */
  IMPLICIT_DUPLICATE = 'IMPLICIT_DUPLICATE',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** Unexpected internal error happened. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The `combinesWith` settings are invalid for the discount class. */
  INVALID_COMBINES_WITH_FOR_DISCOUNT_CLASS = 'INVALID_COMBINES_WITH_FOR_DISCOUNT_CLASS',
  /** The discountClass is invalid for the price rule. */
  INVALID_DISCOUNT_CLASS_FOR_PRICE_RULE = 'INVALID_DISCOUNT_CLASS_FOR_PRICE_RULE',
  /** The input value should be less than the maximum value allowed. */
  LESS_THAN = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  /** The active period overlaps with too many other app-provided discounts. There's a limit on the number of app discounts that can be active at any given time. */
  MAX_APP_DISCOUNTS = 'MAX_APP_DISCOUNTS',
  /** Specify a minimum subtotal or a quantity, but not both. */
  MINIMUM_SUBTOTAL_AND_QUANTITY_RANGE_BOTH_PRESENT = 'MINIMUM_SUBTOTAL_AND_QUANTITY_RANGE_BOTH_PRESENT',
  /** Missing a required argument. */
  MISSING_ARGUMENT = 'MISSING_ARGUMENT',
  /** Recurring cycle limit must be 1 when discount does not apply to subscription items. */
  MULTIPLE_RECURRING_CYCLE_LIMIT_FOR_NON_SUBSCRIPTION_ITEMS = 'MULTIPLE_RECURRING_CYCLE_LIMIT_FOR_NON_SUBSCRIPTION_ITEMS',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** Recurring cycle limit must be a valid integer greater than or equal to 0. */
  RECURRING_CYCLE_LIMIT_NOT_A_VALID_INTEGER = 'RECURRING_CYCLE_LIMIT_NOT_A_VALID_INTEGER',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** Too many arguments provided. */
  TOO_MANY_ARGUMENTS = 'TOO_MANY_ARGUMENTS',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** The value is outside of the allowed range. */
  VALUE_OUTSIDE_RANGE = 'VALUE_OUTSIDE_RANGE'
}

/** The type used to target the items required for discount eligibility, or the items to which the application of a discount might apply. For example, for a customer to be eligible for a discount, they're required to add an item from a specified collection to their order. Alternatively, a customer might be required to add a specific product or product variant. When using this type to target which items the discount will apply to, the discount might apply to all items on the order, or to specific products and product variants, or items in a given collection. */
export type DiscountItems = AllDiscountItems | DiscountCollections | DiscountProducts;

/** The input fields for the items attached to a discount. You can specify the discount items by product ID or collection ID. */
export type DiscountItemsInput = {
  /** Whether all items should be selected. */
  readonly all?: InputMaybe<Scalars['Boolean']>;
  /** The collections that are attached to a discount. */
  readonly collections?: InputMaybe<DiscountCollectionsInput>;
  /**
   * The
   * [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and
   * [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant)
   * that the discount applies to.
   */
  readonly products?: InputMaybe<DiscountProductsInput>;
};

/** The minimum quantity of items required for the discount to apply. */
export type DiscountMinimumQuantity = {
  /** The minimum quantity of items that's required for the discount to be applied. */
  readonly greaterThanOrEqualToQuantity: Scalars['UnsignedInt64'];
};

/** The input fields for the minimum quantity required for the discount. */
export type DiscountMinimumQuantityInput = {
  /** The minimum quantity of items that's required for the discount to be applied. */
  readonly greaterThanOrEqualToQuantity?: InputMaybe<Scalars['UnsignedInt64']>;
};

/** The type of minimum requirement that must be met for the discount to be applied. For example, a customer must spend a minimum subtotal to be eligible for the discount. Alternatively, a customer must purchase a minimum quantity of items to be eligible for the discount. */
export type DiscountMinimumRequirement = DiscountMinimumQuantity | DiscountMinimumSubtotal;

/** The input fields for the minimum quantity or subtotal required for a discount. */
export type DiscountMinimumRequirementInput = {
  /** The minimum required quantity. */
  readonly quantity?: InputMaybe<DiscountMinimumQuantityInput>;
  /** The minimum required subtotal. */
  readonly subtotal?: InputMaybe<DiscountMinimumSubtotalInput>;
};

/** The minimum subtotal required for the discount to apply. */
export type DiscountMinimumSubtotal = {
  /** The minimum subtotal that's required for the discount to be applied. */
  readonly greaterThanOrEqualToSubtotal: MoneyV2;
};

/** The input fields for the minimum subtotal required for a discount. */
export type DiscountMinimumSubtotalInput = {
  /** The minimum subtotal that's required for the discount to be applied. */
  readonly greaterThanOrEqualToSubtotal?: InputMaybe<Scalars['Decimal']>;
};

/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNode = HasEvents & HasMetafieldDefinitions & HasMetafields & Node & {
  /**
   * A discount that's applied at checkout or on cart.
   *
   *
   * Discounts can be [automatic or code-based](https://shopify.dev/docs/apps/build/discounts#discount-methods).
   */
  readonly discount: Discount;
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodeMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodeMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodeMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodePrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * The `DiscountNode` object enables you to manage [discounts](https://help.shopify.com/manual/discounts), which are applied at checkout or on a cart.
 *
 *
 * Discounts are a way for merchants to promote sales and special offers, or as customer loyalty rewards. Discounts can apply to [orders, products, or shipping](https://shopify.dev/docs/apps/build/discounts#discount-classes), and can be either automatic or code-based. For example, you can offer customers a buy X get Y discount that's automatically applied when purchases meet specific criteria. Or, you can offer discounts where customers have to enter a code to redeem an amount off discount on products, variants, or collections in a store.
 *
 * Learn more about working with [Shopify's discount model](https://shopify.dev/docs/apps/build/discounts),
 * including related mutations, limitations, and considerations.
 */
export type DiscountNodePrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple DiscountNodes. */
export type DiscountNodeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DiscountNodeEdge>;
  /** A list of nodes that are contained in DiscountNodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DiscountNode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountNode and a cursor during pagination. */
export type DiscountNodeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DiscountNodeEdge. */
  readonly node: DiscountNode;
};

/** The quantity of items discounted, the discount value, and how the discount will be applied. */
export type DiscountOnQuantity = {
  /** The discount's effect on qualifying items. */
  readonly effect: DiscountEffect;
  /** The number of items being discounted. The customer must have at least this many items of specified products or product variants in their order to be eligible for the discount. */
  readonly quantity: DiscountQuantity;
};

/** The input fields for the quantity of items discounted and the discount value. */
export type DiscountOnQuantityInput = {
  /** The percentage value of the discount. */
  readonly effect?: InputMaybe<DiscountEffectInput>;
  /** The quantity of items that are discounted. */
  readonly quantity?: InputMaybe<Scalars['UnsignedInt64']>;
};

/** A discount effect that gives customers a percentage off of specified items on their order. */
export type DiscountPercentage = {
  /** The percentage value of the discount. */
  readonly percentage: Scalars['Float'];
};

/** A list of products and product variants that the discount can have as a prerequisite or a list of products and product variants to which the discount can be applied. */
export type DiscountProducts = {
  /** The list of product variants that the discount can have as a prerequisite or the list of product variants to which the discount can be applied. */
  readonly productVariants: ProductVariantConnection;
  /** The list of products that the discount can have as a prerequisite or the list of products to which the discount can be applied. */
  readonly products: ProductConnection;
};


/** A list of products and product variants that the discount can have as a prerequisite or a list of products and product variants to which the discount can be applied. */
export type DiscountProductsProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A list of products and product variants that the discount can have as a prerequisite or a list of products and product variants to which the discount can be applied. */
export type DiscountProductsProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The input fields for adding and removing
 * [products](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product) and
 * [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant)
 * as prerequisites or as eligible items for a discount.
 */
export type DiscountProductsInput = {
  /** The IDs of the product variants to add as prerequisites or as eligible items for a discount. */
  readonly productVariantsToAdd?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The IDs of the product variants to remove as prerequisites or as eligible items for a discount. */
  readonly productVariantsToRemove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The IDs of the products to add as prerequisites or as eligible items for a discount. */
  readonly productsToAdd?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The IDs of the products to remove as prerequisites or as eligible items for a discount. */
  readonly productsToRemove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** A purchase amount in the context of a discount. This object can be used to define the minimum purchase amount required for a discount to be applicable. */
export type DiscountPurchaseAmount = {
  /** The purchase amount in decimal format. */
  readonly amount: Scalars['Decimal'];
};

/** A quantity of items in the context of a discount. This object can be used to define the minimum quantity of items required to apply a discount. Alternatively, it can be used to define the quantity of items that can be discounted. */
export type DiscountQuantity = {
  /** The quantity of items. */
  readonly quantity: Scalars['UnsignedInt64'];
};

/** A code that a customer can use at checkout to receive a discount. For example, a customer can use the redeem code 'SUMMER20' at checkout to receive a 20% discount on their entire order. */
export type DiscountRedeemCode = {
  /** The number of times that the discount redeem code has been used. This value is updated asynchronously and can be different than the actual usage count. */
  readonly asyncUsageCount: Scalars['Int'];
  /** The code that a customer can use at checkout to receive a discount. */
  readonly code: Scalars['String'];
  /** The application that created the discount redeem code. */
  readonly createdBy?: Maybe<App>;
  /** A globally-unique ID of the discount redeem code. */
  readonly id: Scalars['ID'];
};

/** Return type for `discountRedeemCodeBulkAdd` mutation. */
export type DiscountRedeemCodeBulkAddPayload = {
  /**
   * The ID of bulk operation that creates multiple unique discount codes.
   * You can use the
   * [`discountRedeemCodeBulkCreation` query](https://shopify.dev/api/admin-graphql/latest/queries/discountRedeemCodeBulkCreation)
   * to track the status of the bulk operation.
   */
  readonly bulkCreation?: Maybe<DiscountRedeemCodeBulkCreation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DiscountUserError>;
};

/** The properties and status of a bulk discount redeem code creation operation. */
export type DiscountRedeemCodeBulkCreation = Node & {
  /** The result of each code creation operation associated with the bulk creation operation including any errors that might have occurred during the operation. */
  readonly codes: DiscountRedeemCodeBulkCreationCodeConnection;
  /** The number of codes to create. */
  readonly codesCount: Scalars['Int'];
  /** The date and time when the bulk creation was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The code discount associated with the created codes. */
  readonly discountCode?: Maybe<DiscountCodeNode>;
  /** Whether the bulk creation is still queued (`false`) or has been run (`true`). */
  readonly done: Scalars['Boolean'];
  /** The number of codes that weren't created successfully. */
  readonly failedCount: Scalars['Int'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The number of codes created successfully. */
  readonly importedCount: Scalars['Int'];
};


/** The properties and status of a bulk discount redeem code creation operation. */
export type DiscountRedeemCodeBulkCreationCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** A result of a discount redeem code creation operation created by a bulk creation. */
export type DiscountRedeemCodeBulkCreationCode = {
  /** The code to use in the discount redeem code creation operation. */
  readonly code: Scalars['String'];
  /**
   * The successfully created discount redeem code.
   *
   * If the discount redeem code couldn't be created, then this field is `null``.
   */
  readonly discountRedeemCode?: Maybe<DiscountRedeemCode>;
  /** A list of errors that occurred during the creation operation of the discount redeem code. */
  readonly errors: ReadonlyArray<DiscountUserError>;
};

/** An auto-generated type for paginating through multiple DiscountRedeemCodeBulkCreationCodes. */
export type DiscountRedeemCodeBulkCreationCodeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DiscountRedeemCodeBulkCreationCodeEdge>;
  /** A list of nodes that are contained in DiscountRedeemCodeBulkCreationCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DiscountRedeemCodeBulkCreationCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountRedeemCodeBulkCreationCode and a cursor during pagination. */
export type DiscountRedeemCodeBulkCreationCodeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DiscountRedeemCodeBulkCreationCodeEdge. */
  readonly node: DiscountRedeemCodeBulkCreationCode;
};

/** An auto-generated type for paginating through multiple DiscountRedeemCodes. */
export type DiscountRedeemCodeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DiscountRedeemCodeEdge>;
  /** A list of nodes that are contained in DiscountRedeemCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DiscountRedeemCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DiscountRedeemCode and a cursor during pagination. */
export type DiscountRedeemCodeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DiscountRedeemCodeEdge. */
  readonly node: DiscountRedeemCode;
};

/** The input fields for the redeem code to attach to a discount. */
export type DiscountRedeemCodeInput = {
  /** The code that a customer can use at checkout to receive the associated discount. */
  readonly code: Scalars['String'];
};

/** A shareable URL for a discount code. */
export type DiscountShareableUrl = {
  /** The image URL of the item (product or collection) to which the discount applies. */
  readonly targetItemImage?: Maybe<Image>;
  /** The type of page that's associated with the URL. */
  readonly targetType: DiscountShareableUrlTargetType;
  /** The title of the page that's associated with the URL. */
  readonly title: Scalars['String'];
  /** The URL for the discount code. */
  readonly url: Scalars['URL'];
};

/** The type of page where a shareable discount URL lands. */
export enum DiscountShareableUrlTargetType {
  /** The URL lands on a collection page. */
  COLLECTION = 'COLLECTION',
  /** The URL lands on a home page. */
  HOME = 'HOME',
  /** The URL lands on a product page. */
  PRODUCT = 'PRODUCT'
}

/** The type used to target the eligible countries of an order's shipping destination for which the discount applies. For example, the discount might be applicable when shipping to all countries, or only to a set of countries. */
export type DiscountShippingDestinationSelection = DiscountCountries | DiscountCountryAll;

/** The input fields for the destinations where the free shipping discount will be applied. */
export type DiscountShippingDestinationSelectionInput = {
  /** Whether the discount code applies to all countries. */
  readonly all?: InputMaybe<Scalars['Boolean']>;
  /** A list of countries where the discount code will apply. */
  readonly countries?: InputMaybe<DiscountCountriesInput>;
};

/** The set of valid sort keys for the Discount query. */
export enum DiscountSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `ends_at` value. */
  ENDS_AT = 'ENDS_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `starts_at` value. */
  STARTS_AT = 'STARTS_AT',
  /** Sort by the `title` value. */
  TITLE = 'TITLE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/**
 * The status of the discount that describes its availability,
 * expiration, or pending activation.
 */
export enum DiscountStatus {
  /** The discount is currently available for use. */
  ACTIVE = 'ACTIVE',
  /** The discount has reached its end date and is no longer valid. */
  EXPIRED = 'EXPIRED',
  /** The discount is set to become active at a future date. */
  SCHEDULED = 'SCHEDULED'
}

/** The type of line (line item or shipping line) on an order that the subscription discount is applicable towards. */
export enum DiscountTargetType {
  /** The discount applies onto line items. */
  LINE_ITEM = 'LINE_ITEM',
  /** The discount applies onto shipping lines. */
  SHIPPING_LINE = 'SHIPPING_LINE'
}

/** The type of the subscription discount. */
export enum DiscountType {
  /** Automatic discount type. */
  AUTOMATIC_DISCOUNT = 'AUTOMATIC_DISCOUNT',
  /** Code discount type. */
  CODE_DISCOUNT = 'CODE_DISCOUNT',
  /** Manual discount type. */
  MANUAL = 'MANUAL'
}

/** An error that occurs during the execution of a discount mutation. */
export type DiscountUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<DiscountErrorCode>;
  /** Extra information about this error. */
  readonly extraInfo?: Maybe<Scalars['String']>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Represents an error in the input of a mutation. */
export type DisplayableError = {
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Return type for `disputeEvidenceUpdate` mutation. */
export type DisputeEvidenceUpdatePayload = {
  /** The updated dispute evidence. */
  readonly disputeEvidence?: Maybe<ShopifyPaymentsDisputeEvidence>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DisputeEvidenceUpdateUserError>;
};

/** An error that occurs during the execution of `DisputeEvidenceUpdate`. */
export type DisputeEvidenceUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<DisputeEvidenceUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `DisputeEvidenceUpdateUserError`. */
export enum DisputeEvidenceUpdateUserErrorCode {
  /** Dispute evidence could not be found. */
  DISPUTE_EVIDENCE_NOT_FOUND = 'DISPUTE_EVIDENCE_NOT_FOUND',
  /** Evidence already accepted. */
  EVIDENCE_ALREADY_ACCEPTED = 'EVIDENCE_ALREADY_ACCEPTED',
  /** Evidence past due date. */
  EVIDENCE_PAST_DUE_DATE = 'EVIDENCE_PAST_DUE_DATE',
  /** Combined files size is too large. */
  FILES_SIZE_EXCEEDED_LIMIT = 'FILES_SIZE_EXCEEDED_LIMIT',
  /** File upload failed. Please try again. */
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Individual file size is too large. */
  TOO_LARGE = 'TOO_LARGE'
}

/** The possible statuses of a dispute. */
export enum DisputeStatus {
  ACCEPTED = 'ACCEPTED',
  /** Status previously used by Stripe to indicate that a dispute led to a refund. */
  CHARGE_REFUNDED = 'CHARGE_REFUNDED',
  LOST = 'LOST',
  NEEDS_RESPONSE = 'NEEDS_RESPONSE',
  UNDER_REVIEW = 'UNDER_REVIEW',
  WON = 'WON'
}

/** The possible types for a dispute. */
export enum DisputeType {
  /** The dispute has turned into a chargeback. */
  CHARGEBACK = 'CHARGEBACK',
  /** The dispute is in the inquiry phase. */
  INQUIRY = 'INQUIRY'
}

/** A unique string that represents the address of a Shopify store on the Internet. */
export type Domain = Node & {
  /** The host name of the domain. For example, `example.com`. */
  readonly host: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The localization of the domain, if the domain doesn't redirect. */
  readonly localization?: Maybe<DomainLocalization>;
  /** The web presence of the domain. */
  readonly marketWebPresence?: Maybe<MarketWebPresence>;
  /** Whether SSL is enabled. */
  readonly sslEnabled: Scalars['Boolean'];
  /** The URL of the domain (for example, `https://example.com`). */
  readonly url: Scalars['URL'];
};

/** The country and language settings assigned to a domain. */
export type DomainLocalization = {
  /** The ISO codes for the domain’s alternate locales. For example, `["en"]`. */
  readonly alternateLocales: ReadonlyArray<Scalars['String']>;
  /** The ISO code for the country assigned to the domain. For example, `"CA"` or "*" for a domain set to "Rest of world". */
  readonly country?: Maybe<Scalars['String']>;
  /** The ISO code for the domain’s default locale. For example, `"en"`. */
  readonly defaultLocale: Scalars['String'];
};

/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 * - Save an order as a draft and resume working on it later.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrder = CommentEventSubject & HasEvents & HasLocalizationExtensions & HasMetafields & LegacyInteroperability & Navigable & Node & {
  /**
   * Whether or not to accept automatic discounts on the draft order during calculation.
   * If false, only discount codes and custom draft order discounts (see `appliedDiscount`) will be applied.
   * If true, eligible automatic discounts will be applied in addition to discount codes and custom draft order discounts.
   */
  readonly acceptAutomaticDiscounts?: Maybe<Scalars['Boolean']>;
  /** Whether discount codes are allowed during checkout of this draft order. */
  readonly allowDiscountCodesInCheckout: Scalars['Boolean'];
  /** The custom order-level discount applied. */
  readonly appliedDiscount?: Maybe<DraftOrderAppliedDiscount>;
  /** The billing address of the customer. */
  readonly billingAddress?: Maybe<MailingAddress>;
  /** Whether the billing address matches the shipping address. */
  readonly billingAddressMatchesShippingAddress: Scalars['Boolean'];
  /**
   * The date and time when the draft order was converted to a new order,
   * and had it's status changed to **Completed**.
   */
  readonly completedAt?: Maybe<Scalars['DateTime']>;
  /** The date and time when the draft order was created in Shopify. */
  readonly createdAt: Scalars['DateTime'];
  /** The shop currency used for calculation. */
  readonly currencyCode: CurrencyCode;
  /** The custom information added to the draft order on behalf of the customer. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The customer who will be sent an invoice. */
  readonly customer?: Maybe<Customer>;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** All discount codes applied. */
  readonly discountCodes: ReadonlyArray<Scalars['String']>;
  /** The email address of the customer, which is used to send notifications. */
  readonly email?: Maybe<Scalars['String']>;
  /** The list of events associated with the draft order. */
  readonly events: EventConnection;
  /** Whether the merchant has added timeline comments to the draft order. */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The subject defined for the draft invoice email template. */
  readonly invoiceEmailTemplateSubject: Scalars['String'];
  /** The date and time when the invoice was last emailed to the customer. */
  readonly invoiceSentAt?: Maybe<Scalars['DateTime']>;
  /** The link to the checkout, which is sent to the customer in the invoice email. */
  readonly invoiceUrl?: Maybe<Scalars['URL']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The list of the line items in the draft order. */
  readonly lineItems: DraftOrderLineItemConnection;
  /**
   * A subtotal of the line items and corresponding discounts,
   * excluding include shipping charges, shipping discounts, taxes, or order discounts.
   */
  readonly lineItemsSubtotalPrice: MoneyBag;
  /**
   * List of localization extensions for the resource.
   * @deprecated This connection will be removed in a future version. Use `localizedFields` instead.
   */
  readonly localizationExtensions: LocalizationExtensionConnection;
  /**
   * The name of the selected market.
   * @deprecated This field is now incompatible with Markets.
   */
  readonly marketName: Scalars['String'];
  /**
   * The selected country code that determines the pricing.
   * @deprecated This field is now incompatible with Markets.
   */
  readonly marketRegionCountryCode: CountryCode;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** The identifier for the draft order, which is unique within the store. For example, _#D1223_. */
  readonly name: Scalars['String'];
  /** The text from an optional note attached to the draft order. */
  readonly note2?: Maybe<Scalars['String']>;
  /** The order that was created from the draft order. */
  readonly order?: Maybe<Order>;
  /** The associated payment terms for this draft order. */
  readonly paymentTerms?: Maybe<PaymentTerms>;
  /** The assigned phone number. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The list of platform discounts applied. */
  readonly platformDiscounts: ReadonlyArray<DraftOrderPlatformDiscount>;
  /** The purchase order number. */
  readonly poNumber?: Maybe<Scalars['String']>;
  /** The payment currency used for calculation. */
  readonly presentmentCurrencyCode: CurrencyCode;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The purchasing entity. */
  readonly purchasingEntity?: Maybe<PurchasingEntity>;
  /**
   * Whether the draft order is ready and can be completed.
   * Draft orders might have asynchronous operations that can take time to finish.
   */
  readonly ready: Scalars['Boolean'];
  /** The time after which inventory will automatically be restocked. */
  readonly reserveInventoryUntil?: Maybe<Scalars['DateTime']>;
  /** The shipping address of the customer. */
  readonly shippingAddress?: Maybe<MailingAddress>;
  /** The line item containing the shipping information and costs. */
  readonly shippingLine?: Maybe<ShippingLine>;
  /** The status of the draft order. */
  readonly status: DraftOrderStatus;
  /**
   * The subtotal, in shop currency, of the line items and their discounts, excluding shipping charges, shipping discounts, and taxes.
   * @deprecated Use `subtotalPriceSet` instead.
   */
  readonly subtotalPrice: Scalars['Money'];
  /** The subtotal, of the line items and their discounts, excluding shipping charges, shipping discounts, and taxes. */
  readonly subtotalPriceSet: MoneyBag;
  /**
   * The comma separated list of tags associated with the draft order.
   * Updating `tags` overwrites any existing tags that were previously added to the draft order.
   * To add new tags without overwriting existing tags, use the [tagsAdd](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd) mutation.
   */
  readonly tags: ReadonlyArray<Scalars['String']>;
  /** Whether the draft order is tax exempt. */
  readonly taxExempt: Scalars['Boolean'];
  /** The list of of taxes lines charged for each line item and shipping line. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Whether the line item prices include taxes. */
  readonly taxesIncluded: Scalars['Boolean'];
  /** Total discounts. */
  readonly totalDiscountsSet: MoneyBag;
  /** Total price of line items. */
  readonly totalLineItemsPriceSet: MoneyBag;
  /**
   * The total price, in shop currency, includes taxes, shipping charges, and discounts.
   * @deprecated Use `totalPriceSet` instead.
   */
  readonly totalPrice: Scalars['Money'];
  /** The total price, includes taxes, shipping charges, and discounts. */
  readonly totalPriceSet: MoneyBag;
  /**
   * The sum of individual line item quantities.
   * If the draft order has bundle items, this is the sum containing the quantities of individual items in the bundle.
   */
  readonly totalQuantityOfLineItems: Scalars['Int'];
  /**
   * The total shipping price in shop currency.
   * @deprecated Use `totalShippingPriceSet` instead.
   */
  readonly totalShippingPrice: Scalars['Money'];
  /** The total shipping price. */
  readonly totalShippingPriceSet: MoneyBag;
  /**
   * The total tax in shop currency.
   * @deprecated Use `totalTaxSet` instead.
   */
  readonly totalTax: Scalars['Money'];
  /** The total tax. */
  readonly totalTaxSet: MoneyBag;
  /** The total weight in grams of the draft order. */
  readonly totalWeight: Scalars['UnsignedInt64'];
  /**
   * Fingerprint of the current cart.
   * In order to have bundles work, the fingerprint must be passed to
   * each request as it was previously returned, unmodified.
   */
  readonly transformerFingerprint?: Maybe<Scalars['String']>;
  /**
   * The date and time when the draft order was last changed.
   * The format is YYYY-MM-DD HH:mm:ss. For example, 2016-02-05 17:04:01.
   */
  readonly updatedAt: Scalars['DateTime'];
  /** Whether the draft order will be visible to the customer on the self-serve portal. */
  readonly visibleToCustomer: Scalars['Boolean'];
  /** The list of warnings raised while calculating. */
  readonly warnings: ReadonlyArray<DraftOrderWarning>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 * - Save an order as a draft and resume working on it later.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 * - Save an order as a draft and resume working on it later.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 * - Save an order as a draft and resume working on it later.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderLocalizationExtensionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countryCodes?: InputMaybe<ReadonlyArray<CountryCode>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  purposes?: InputMaybe<ReadonlyArray<LocalizationExtensionPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 * - Save an order as a draft and resume working on it later.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 * - Save an order as a draft and resume working on it later.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 * - Save an order as a draft and resume working on it later.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * An order that a merchant creates on behalf of a customer. Draft orders are useful for merchants that need to do the following tasks:
 *
 * - Create new orders for sales made by phone, in person, by chat, or elsewhere. When a merchant accepts payment for a draft order, an order is created.
 * - Send invoices to customers to pay with a secure checkout link.
 * - Use custom items to represent additional costs or products that aren't displayed in a shop's inventory.
 * - Re-create orders manually from active sales channels.
 * - Sell products at discount or wholesale rates.
 * - Take pre-orders.
 * - Save an order as a draft and resume working on it later.
 *
 * For draft orders in multiple currencies `presentment_money` is the source of truth for what a customer is going to be charged and `shop_money` is an estimate of what the merchant might receive in their shop currency.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 *
 * Draft orders created on or after April 1, 2025 will be automatically purged after one year of inactivity.
 */
export type DraftOrderPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The order-level discount applied to a draft order. */
export type DraftOrderAppliedDiscount = {
  /**
   * Amount of the order-level discount that's applied to the draft order in shop currency.
   * @deprecated Use `amountSet` instead.
   */
  readonly amount: Scalars['Money'];
  /** The amount of money discounted, with values shown in both shop currency and presentment currency. */
  readonly amountSet: MoneyBag;
  /**
   * Amount of money discounted.
   * @deprecated Use `amountSet` instead.
   */
  readonly amountV2: MoneyV2;
  /** Description of the order-level discount. */
  readonly description: Scalars['String'];
  /** Name of the order-level discount. */
  readonly title?: Maybe<Scalars['String']>;
  /**
   * The order level discount amount. If `valueType` is `"percentage"`,
   * then `value` is the percentage discount.
   */
  readonly value: Scalars['Float'];
  /** Type of the order-level discount. */
  readonly valueType: DraftOrderAppliedDiscountType;
};

/** The input fields for applying an order-level discount to a draft order. */
export type DraftOrderAppliedDiscountInput = {
  /** The applied amount of the discount in the specified currency. */
  readonly amountWithCurrency?: InputMaybe<MoneyInput>;
  /** Reason for the discount. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** Title of the discount. */
  readonly title?: InputMaybe<Scalars['String']>;
  /**
   * The value of the discount.
   * If the type of the discount is fixed amount, then this is a fixed amount in your shop currency.
   * If the type is percentage, then this is the percentage.
   */
  readonly value: Scalars['Float'];
  /** The type of discount. */
  readonly valueType: DraftOrderAppliedDiscountType;
};

/** The valid discount types that can be applied to a draft order. */
export enum DraftOrderAppliedDiscountType {
  /** A fixed amount in the store's currency. */
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  /** A percentage of the order subtotal. */
  PERCENTAGE = 'PERCENTAGE'
}

/** Return type for `draftOrderBulkAddTags` mutation. */
export type DraftOrderBulkAddTagsPayload = {
  /** The asynchronous job for adding tags to the draft orders. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `draftOrderBulkDelete` mutation. */
export type DraftOrderBulkDeletePayload = {
  /** The asynchronous job for deleting the draft orders. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `draftOrderBulkRemoveTags` mutation. */
export type DraftOrderBulkRemoveTagsPayload = {
  /** The asynchronous job for removing tags from the draft orders. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A warning indicating that a bundle was added to a draft order. */
export type DraftOrderBundleAddedWarning = DraftOrderWarning & {
  /** The error code. */
  readonly errorCode: Scalars['String'];
  /** The input field that the warning applies to. */
  readonly field: Scalars['String'];
  /** The warning message. */
  readonly message: Scalars['String'];
};

/** Return type for `draftOrderCalculate` mutation. */
export type DraftOrderCalculatePayload = {
  /** The calculated properties for a draft order. */
  readonly calculatedDraftOrder?: Maybe<CalculatedDraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `draftOrderComplete` mutation. */
export type DraftOrderCompletePayload = {
  /** The completed draft order. */
  readonly draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type for paginating through multiple DraftOrders. */
export type DraftOrderConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DraftOrderEdge>;
  /** A list of nodes that are contained in DraftOrderEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DraftOrder>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `draftOrderCreateFromOrder` mutation. */
export type DraftOrderCreateFromOrderPayload = {
  /** The created draft order. */
  readonly draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `draftOrderCreateMerchantCheckout` mutation. */
export type DraftOrderCreateMerchantCheckoutPayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `draftOrderCreate` mutation. */
export type DraftOrderCreatePayload = {
  /** The created draft order. */
  readonly draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields to specify the draft order to delete by its ID. */
export type DraftOrderDeleteInput = {
  /** The ID of the draft order to delete. */
  readonly id: Scalars['ID'];
};

/** Return type for `draftOrderDelete` mutation. */
export type DraftOrderDeletePayload = {
  /** The ID of the deleted draft order. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A warning indicating that a discount cannot be applied to a draft order. */
export type DraftOrderDiscountNotAppliedWarning = DraftOrderWarning & {
  /** The code of the discount that can't be applied. */
  readonly discountCode?: Maybe<Scalars['String']>;
  /** The title of the discount that can't be applied. */
  readonly discountTitle?: Maybe<Scalars['String']>;
  /** The error code. */
  readonly errorCode: Scalars['String'];
  /** The input field that the warning applies to. */
  readonly field: Scalars['String'];
  /** The warning message. */
  readonly message: Scalars['String'];
  /** The price rule that can't be applied. */
  readonly priceRule?: Maybe<PriceRule>;
};

/** Return type for `draftOrderDuplicate` mutation. */
export type DraftOrderDuplicatePayload = {
  /** The newly duplicated draft order. */
  readonly draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one DraftOrder and a cursor during pagination. */
export type DraftOrderEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DraftOrderEdge. */
  readonly node: DraftOrder;
};

/** The input fields used to create or update a draft order. */
export type DraftOrderInput = {
  /**
   * Whether or not to accept automatic discounts on the draft order during calculation.
   * If false, only discount codes and custom draft order discounts (see `appliedDiscount`) will be applied.
   * If true, eligible automatic discounts will be applied in addition to discount codes and custom draft order discounts.
   */
  readonly acceptAutomaticDiscounts?: InputMaybe<Scalars['Boolean']>;
  /** Whether discount codes are allowed during checkout of this draft order. */
  readonly allowDiscountCodesInCheckout?: InputMaybe<Scalars['Boolean']>;
  /**
   * The discount that will be applied to the draft order.
   * A draft order line item can have one discount. A draft order can also have one order-level discount.
   */
  readonly appliedDiscount?: InputMaybe<DraftOrderAppliedDiscountInput>;
  /** The mailing address associated with the payment method. */
  readonly billingAddress?: InputMaybe<MailingAddressInput>;
  /** The extra information added to the draft order on behalf of the customer. */
  readonly customAttributes?: InputMaybe<ReadonlyArray<AttributeInput>>;
  /**
   * The list of discount codes that will be attempted to be applied to the draft order.
   * If the draft isn't eligible for any given discount code it will be skipped during calculation.
   */
  readonly discountCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The customer's email address. */
  readonly email?: InputMaybe<Scalars['String']>;
  /**
   * The list of product variant or custom line item.
   * Each draft order must include at least one line item.
   *
   * NOTE: Draft orders don't currently support subscriptions.
   */
  readonly lineItems?: InputMaybe<ReadonlyArray<DraftOrderLineItemInput>>;
  /** The list of metafields attached to the draft order. An existing metafield can not be used when creating a draft order. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The text of an optional note that a shop owner can attach to the draft order. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The fields used to create payment terms. */
  readonly paymentTerms?: InputMaybe<PaymentTermsInput>;
  /** The customer's phone number. */
  readonly phone?: InputMaybe<Scalars['String']>;
  /** The purchase order number. */
  readonly poNumber?: InputMaybe<Scalars['String']>;
  /** The payment currency of the customer for this draft order. */
  readonly presentmentCurrencyCode?: InputMaybe<CurrencyCode>;
  /** The purchasing entity for the draft order. */
  readonly purchasingEntity?: InputMaybe<PurchasingEntityInput>;
  /** The time after which inventory reservation will expire. */
  readonly reserveInventoryUntil?: InputMaybe<Scalars['DateTime']>;
  /** The unique token identifying the draft order. */
  readonly sessionToken?: InputMaybe<Scalars['String']>;
  /** The mailing address to where the order will be shipped. */
  readonly shippingAddress?: InputMaybe<MailingAddressInput>;
  /** The shipping line object, which details the shipping method used. */
  readonly shippingLine?: InputMaybe<ShippingLineInput>;
  /**
   * The source of the checkout.
   * To use this field for sales attribution, you must register the channels that your app is managing.
   * You can register the channels that your app is managing by completing
   * [this Google Form](https://docs.google.com/forms/d/e/1FAIpQLScmVTZRQNjOJ7RD738mL1lGeFjqKVe_FM2tO9xsm21QEo5Ozg/viewform?usp=sf_link).
   * After you've submitted your request, you need to wait for your request to be processed by Shopify.
   * You can find a list of your channels in the Partner Dashboard, in your app's Marketplace extension.
   * You need to specify the handle as the `source_name` value in your request.
   * The handle is the channel that the order was placed from.
   */
  readonly sourceName?: InputMaybe<Scalars['String']>;
  /** A comma separated list of tags that have been added to the draft order. */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /**
   * Whether or not taxes are exempt for the draft order.
   * If false, then Shopify will refer to the taxable field for each line item.
   * If a customer is applied to the draft order, then Shopify will use the customer's tax exempt field instead.
   */
  readonly taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Fingerprint to guarantee bundles are handled correctly. */
  readonly transformerFingerprint?: InputMaybe<Scalars['String']>;
  /** Whether to use the customer's default address. */
  readonly useCustomerDefaultAddress?: InputMaybe<Scalars['Boolean']>;
  /** Whether the draft order will be visible to the customer on the self-serve portal. */
  readonly visibleToCustomer?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `draftOrderInvoicePreview` mutation. */
export type DraftOrderInvoicePreviewPayload = {
  /** The draft order invoice email rendered as HTML to allow previewing. */
  readonly previewHtml?: Maybe<Scalars['HTML']>;
  /** The subject preview for the draft order invoice email. */
  readonly previewSubject?: Maybe<Scalars['HTML']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `draftOrderInvoiceSend` mutation. */
export type DraftOrderInvoiceSendPayload = {
  /** The draft order an invoice email is sent for. */
  readonly draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The line item for a draft order. */
export type DraftOrderLineItem = Node & {
  /** The custom applied discount. */
  readonly appliedDiscount?: Maybe<DraftOrderAppliedDiscount>;
  /**
   * The `discountedTotal` divided by `quantity`,
   * equal to the average value of the line item price per unit after discounts are applied.
   * This value doesn't include discounts applied to the entire draft order.
   */
  readonly approximateDiscountedUnitPriceSet: MoneyBag;
  /** The list of bundle components if applicable. */
  readonly bundleComponents: ReadonlyArray<DraftOrderLineItem>;
  /** Whether the line item is custom (`true`) or contains a product variant (`false`). */
  readonly custom: Scalars['Boolean'];
  /** A list of attributes that represent custom features or special requests. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The list of additional information (metafields) with the associated types. */
  readonly customAttributesV2: ReadonlyArray<TypedAttribute>;
  /**
   * The line item price, in shop currency, after discounts are applied.
   * @deprecated Use `discountedTotalSet` instead.
   */
  readonly discountedTotal: Scalars['Money'];
  /** The total price with discounts applied. */
  readonly discountedTotalSet: MoneyBag;
  /**
   * The `discountedTotal` divided by `quantity`, equal to the value of the discount per unit in the shop currency.
   * @deprecated Use `approximateDiscountedUnitPriceSet` instead.
   */
  readonly discountedUnitPrice: Scalars['Money'];
  /**
   * The unit price with discounts applied.
   * @deprecated Use `approximateDiscountedUnitPriceSet` instead.
   */
  readonly discountedUnitPriceSet: MoneyBag;
  /**
   * Name of the service provider who fulfilled the order.
   *
   * Valid values are either **manual** or the name of the provider.
   * For example, **amazon**, **shipwire**.
   *
   * Deleted fulfillment services will return null.
   */
  readonly fulfillmentService?: Maybe<FulfillmentService>;
  /**
   * The weight of the line item in grams.
   * @deprecated Use `weight` instead.
   */
  readonly grams?: Maybe<Scalars['Int']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image of the product variant. */
  readonly image?: Maybe<Image>;
  /** Whether the line item represents the purchase of a gift card. */
  readonly isGiftCard: Scalars['Boolean'];
  /** The name of the product. */
  readonly name: Scalars['String'];
  /**
   * The total price, in shop currency, excluding discounts, equal to the original unit price multiplied by quantity.
   * @deprecated Use `originalTotalSet` instead.
   */
  readonly originalTotal: Scalars['Money'];
  /** The total price excluding discounts, equal to the original unit price multiplied by quantity. */
  readonly originalTotalSet: MoneyBag;
  /**
   * The price, in shop currency, without any discounts applied.
   * @deprecated Use `originalUnitPriceWithCurrency` instead.
   */
  readonly originalUnitPrice: Scalars['Money'];
  /** The price without any discounts applied. */
  readonly originalUnitPriceSet: MoneyBag;
  /** The original custom line item input price. */
  readonly originalUnitPriceWithCurrency?: Maybe<MoneyV2>;
  /** The product for the line item. */
  readonly product?: Maybe<Product>;
  /**
   * The quantity of items. For a bundle item, this is the quantity of bundles,
   * not the quantity of items contained in the bundles themselves.
   */
  readonly quantity: Scalars['Int'];
  /** Whether physical shipping is required for the variant. */
  readonly requiresShipping: Scalars['Boolean'];
  /** The SKU number of the product variant. */
  readonly sku?: Maybe<Scalars['String']>;
  /** A list of tax lines. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Whether the variant is taxable. */
  readonly taxable: Scalars['Boolean'];
  /** The title of the product or variant. This field only applies to custom line items. */
  readonly title: Scalars['String'];
  /**
   * The total discount applied in shop currency.
   * @deprecated Use `totalDiscountSet` instead.
   */
  readonly totalDiscount: Scalars['Money'];
  /** The total discount amount. */
  readonly totalDiscountSet: MoneyBag;
  /**
   * The UUID of the draft order line item. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with bundles.
   */
  readonly uuid: Scalars['String'];
  /** The product variant for the line item. */
  readonly variant?: Maybe<ProductVariant>;
  /** The name of the variant. */
  readonly variantTitle?: Maybe<Scalars['String']>;
  /** The name of the vendor who created the product variant. */
  readonly vendor?: Maybe<Scalars['String']>;
  /** The weight unit and value. */
  readonly weight?: Maybe<Weight>;
};

/** An auto-generated type for paginating through multiple DraftOrderLineItems. */
export type DraftOrderLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<DraftOrderLineItemEdge>;
  /** A list of nodes that are contained in DraftOrderLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<DraftOrderLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one DraftOrderLineItem and a cursor during pagination. */
export type DraftOrderLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of DraftOrderLineItemEdge. */
  readonly node: DraftOrderLineItem;
};

/** The input fields for a line item included in a draft order. */
export type DraftOrderLineItemInput = {
  /** The custom discount to be applied. */
  readonly appliedDiscount?: InputMaybe<DraftOrderAppliedDiscountInput>;
  /** The bundle components when the line item is a bundle. */
  readonly bundleComponents?: InputMaybe<ReadonlyArray<BundlesDraftOrderBundleLineItemComponentInput>>;
  /** A generic custom attribute using a key value pair. */
  readonly customAttributes?: InputMaybe<ReadonlyArray<AttributeInput>>;
  /**
   * The price in presentment currency, without any discounts applied, for a custom line item.
   * If this value is provided, `original_unit_price` will be ignored. This field is ignored when `variantId` is provided.
   * Note: All presentment currencies for a single draft should be the same and match the
   * presentment currency of the draft order.
   */
  readonly originalUnitPriceWithCurrency?: InputMaybe<MoneyInput>;
  /** The line item quantity. */
  readonly quantity: Scalars['Int'];
  /** Whether physical shipping is required for a custom line item. This field is ignored when `variantId` is provided. */
  readonly requiresShipping?: InputMaybe<Scalars['Boolean']>;
  /** The SKU number for custom line items only. This field is ignored when `variantId` is provided. */
  readonly sku?: InputMaybe<Scalars['String']>;
  /** Whether the custom line item is taxable. This field is ignored when `variantId` is provided. */
  readonly taxable?: InputMaybe<Scalars['Boolean']>;
  /** Title of the line item. This field is ignored when `variantId` is provided. */
  readonly title?: InputMaybe<Scalars['String']>;
  /**
   * The UUID of the draft order line item. Must be unique and consistent across requests.
   * This field is mandatory in order to manipulate drafts with bundles.
   */
  readonly uuid?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the product variant corresponding to the line item.
   * Must be null for custom line items, otherwise required.
   */
  readonly variantId?: InputMaybe<Scalars['ID']>;
  /**
   * The weight unit and value inputs for custom line items only.
   * This field is ignored when `variantId` is provided.
   */
  readonly weight?: InputMaybe<WeightInput>;
};

/** The platform discounts applied to the draft order. */
export type DraftOrderPlatformDiscount = {
  /** Price reduction allocations across the draft order's lines. */
  readonly allocations: ReadonlyArray<DraftOrderPlatformDiscountAllocation>;
  /** Whether the discount is an automatic discount. */
  readonly automaticDiscount: Scalars['Boolean'];
  /** Whether the discount is a buy x get y discount. */
  readonly bxgyDiscount: Scalars['Boolean'];
  /** If a code-based discount, the code used to add the discount. */
  readonly code?: Maybe<Scalars['String']>;
  /**
   * The discount class.
   * @deprecated Use `discountClasses` instead.
   */
  readonly discountClass: DiscountClass;
  /** The discount node for the platform discount. */
  readonly discountNode?: Maybe<DiscountNode>;
  /** The ID of the discount. */
  readonly id?: Maybe<Scalars['ID']>;
  /** Whether the discount is line, order or shipping level. */
  readonly presentationLevel: Scalars['String'];
  /** The short summary of the discount. */
  readonly shortSummary: Scalars['String'];
  /** The summary of the discount. */
  readonly summary: Scalars['String'];
  /** The name of the discount. */
  readonly title: Scalars['String'];
  /** The discount total amount in shop currency. */
  readonly totalAmount: MoneyV2;
  /** The amount of money discounted, with values shown in both shop currency and presentment currency. */
  readonly totalAmountPriceSet: MoneyBag;
};

/** Price reduction allocations across the draft order's lines. */
export type DraftOrderPlatformDiscountAllocation = {
  /** The ID of the allocation. */
  readonly id?: Maybe<Scalars['ID']>;
  /** The quantity of the target being discounted. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** Amount of the discount allocated to the target. */
  readonly reductionAmount: MoneyV2;
  /** Amount of the discount allocated to the target in both shop currency and presentment currency. */
  readonly reductionAmountSet: MoneyBag;
  /** The element of the draft being discounted. */
  readonly target?: Maybe<DraftOrderPlatformDiscountAllocationTarget>;
};

/** The element of the draft being discounted. */
export type DraftOrderPlatformDiscountAllocationTarget = CalculatedDraftOrderLineItem | DraftOrderLineItem | ShippingLine;

/** The set of valid sort keys for the DraftOrder query. */
export enum DraftOrderSortKeys {
  /** Sort by the `customer_name` value. */
  CUSTOMER_NAME = 'CUSTOMER_NAME',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `number` value. */
  NUMBER = 'NUMBER',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `status` value. */
  STATUS = 'STATUS',
  /** Sort by the `total_price` value. */
  TOTAL_PRICE = 'TOTAL_PRICE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** The valid statuses for a draft order. */
export enum DraftOrderStatus {
  /** The draft order has been paid. */
  COMPLETED = 'COMPLETED',
  /** An invoice for the draft order has been sent to the customer. */
  INVOICE_SENT = 'INVOICE_SENT',
  /** The draft order is open. It has not been paid, and an invoice hasn't been sent. */
  OPEN = 'OPEN'
}

/** Represents a draft order tag. */
export type DraftOrderTag = Node & {
  /** Handle of draft order tag. */
  readonly handle: Scalars['String'];
  /** ID of draft order tag. */
  readonly id: Scalars['ID'];
  /** Title of draft order tag. */
  readonly title: Scalars['String'];
};

/** Return type for `draftOrderUpdate` mutation. */
export type DraftOrderUpdatePayload = {
  /** The updated draft order. */
  readonly draftOrder?: Maybe<DraftOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A warning that is displayed to the merchant when a change is made to a draft order. */
export type DraftOrderWarning = {
  /** The error code. */
  readonly errorCode: Scalars['String'];
  /** The input field that the warning applies to. */
  readonly field: Scalars['String'];
  /** The warning message. */
  readonly message: Scalars['String'];
};

/** The duty details for a line item. */
export type Duty = Node & {
  /** The ISO 3166-1 alpha-2 country code of the country of origin used in calculating the duty. */
  readonly countryCodeOfOrigin?: Maybe<CountryCode>;
  /** The harmonized system code of the item used in calculating the duty. */
  readonly harmonizedSystemCode?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The amount of the duty. */
  readonly price: MoneyBag;
  /** A list of taxes charged on the duty. */
  readonly taxLines: ReadonlyArray<TaxLine>;
};

/** A sale associated with a duty charge. */
export type DutySale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The duty for the associated sale. */
  readonly duty: Duty;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** The attribute editable information. */
export type EditableProperty = {
  /** Whether the attribute is locked for editing. */
  readonly locked: Scalars['Boolean'];
  /** The reason the attribute is locked for editing. */
  readonly reason?: Maybe<Scalars['FormattedString']>;
};

/** The input fields for an email. */
export type EmailInput = {
  /** Specifies any bcc recipients for the email. */
  readonly bcc?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** Specifies the email body. */
  readonly body?: InputMaybe<Scalars['String']>;
  /** Specifies a custom message to include in the email. */
  readonly customMessage?: InputMaybe<Scalars['String']>;
  /** Specifies the email sender. */
  readonly from?: InputMaybe<Scalars['String']>;
  /** Specifies the email subject. */
  readonly subject?: InputMaybe<Scalars['String']>;
  /** Specifies the email recipient. */
  readonly to?: InputMaybe<Scalars['String']>;
};

/** An error that occurs during the execution of a server pixel mutation. */
export type ErrorsServerPixelUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ErrorsServerPixelUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ErrorsServerPixelUserError`. */
export enum ErrorsServerPixelUserErrorCode {
  /** A server pixel already exists for this app and shop. Only one server pixel can exist for any app and shop combination. */
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  /** Server Pixel must be configured with a valid AWS Event Bridge or GCP pub/sub endpoint address to be connected. */
  NEEDS_CONFIGURATION_TO_CONNECT = 'NEEDS_CONFIGURATION_TO_CONNECT',
  /** A server pixel doesn't exist for this app and shop. */
  NOT_FOUND = 'NOT_FOUND',
  /** PubSubProject and PubSubTopic values resulted in an address that is not a valid GCP pub/sub format.Address format should be pubsub://project:topic. */
  PUB_SUB_ERROR = 'PUB_SUB_ERROR'
}

/** An error that occurs during the execution of a web pixel mutation. */
export type ErrorsWebPixelUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ErrorsWebPixelUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ErrorsWebPixelUserError`. */
export enum ErrorsWebPixelUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The provided settings is not a valid JSON. */
  INVALID_CONFIGURATION_JSON = 'INVALID_CONFIGURATION_JSON',
  /** The provided runtime context is invalid. */
  INVALID_RUNTIME_CONTEXT = 'INVALID_RUNTIME_CONTEXT',
  /** The provided settings does not match the expected settings definition on the app. */
  INVALID_SETTINGS = 'INVALID_SETTINGS',
  /** The settings definition of the web pixel extension is in an invalid state on the app. */
  INVALID_SETTINGS_DEFINITION = 'INVALID_SETTINGS_DEFINITION',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** No extension found. */
  NO_EXTENSION = 'NO_EXTENSION',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** An error occurred and the web pixel couldnt be deleted. */
  UNABLE_TO_DELETE = 'UNABLE_TO_DELETE',
  /** An unexpected error occurred. */
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR'
}

/**
 * Events chronicle resource activities such as the creation of an article, the fulfillment of an order, or the
 * addition of a product.
 */
export type Event = {
  /** The action that occured. */
  readonly action: Scalars['String'];
  /** The name of the app that created the event. */
  readonly appTitle?: Maybe<Scalars['String']>;
  /** Whether the event was created by an app. */
  readonly attributeToApp: Scalars['Boolean'];
  /** Whether the event was caused by an admin user. */
  readonly attributeToUser: Scalars['Boolean'];
  /** The date and time when the event was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Whether the event is critical. */
  readonly criticalAlert: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Human readable text that describes the event. */
  readonly message: Scalars['FormattedString'];
};

/** Return type for `eventBridgeServerPixelUpdate` mutation. */
export type EventBridgeServerPixelUpdatePayload = {
  /** The server pixel as configured by the mutation. */
  readonly serverPixel?: Maybe<ServerPixel>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ErrorsServerPixelUserError>;
};

/** Return type for `eventBridgeWebhookSubscriptionCreate` mutation. */
export type EventBridgeWebhookSubscriptionCreatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
  /** The webhook subscription that was created. */
  readonly webhookSubscription?: Maybe<WebhookSubscription>;
};

/** The input fields for an EventBridge webhook subscription. */
export type EventBridgeWebhookSubscriptionInput = {
  /** The ARN of the EventBridge partner event source. */
  readonly arn?: InputMaybe<Scalars['ARN']>;
  /** A constraint specified using search syntax that ensures only webhooks that match the specified filter are emitted. See our [guide on filters](https://shopify.dev/docs/apps/build/webhooks/customize/filters) for more details. */
  readonly filter?: InputMaybe<Scalars['String']>;
  /** The format in which the webhook subscription should send the data. */
  readonly format?: InputMaybe<WebhookSubscriptionFormat>;
  /** The list of fields to be included in the webhook subscription. */
  readonly includeFields?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The list of namespaces for any metafields that should be included in the webhook subscription. */
  readonly metafieldNamespaces?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

/** Return type for `eventBridgeWebhookSubscriptionUpdate` mutation. */
export type EventBridgeWebhookSubscriptionUpdatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
  /** The webhook subscription that was updated. */
  readonly webhookSubscription?: Maybe<WebhookSubscription>;
};

/** An auto-generated type for paginating through multiple Events. */
export type EventConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<EventEdge>;
  /** A list of nodes that are contained in EventEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Event>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one Event and a cursor during pagination. */
export type EventEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of EventEdge. */
  readonly node: Event;
};

/** The set of valid sort keys for the Event query. */
export enum EventSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The type of the resource that generated the event. */
export enum EventSubjectType {
  /** A Article resource generated the event. */
  ARTICLE = 'ARTICLE',
  /** A Blog resource generated the event. */
  BLOG = 'BLOG',
  /** A Collection resource generated the event. */
  COLLECTION = 'COLLECTION',
  /** A Comment resource generated the event. */
  COMMENT = 'COMMENT',
  /** A Company resource generated the event. */
  COMPANY = 'COMPANY',
  /** A CompanyLocation resource generated the event. */
  COMPANY_LOCATION = 'COMPANY_LOCATION',
  /** A Customer resource generated the event. */
  CUSTOMER = 'CUSTOMER',
  /** A DiscountAutomaticBxgy resource generated the event. */
  DISCOUNT_AUTOMATIC_BXGY = 'DISCOUNT_AUTOMATIC_BXGY',
  /** A DiscountAutomaticNode resource generated the event. */
  DISCOUNT_AUTOMATIC_NODE = 'DISCOUNT_AUTOMATIC_NODE',
  /** A DiscountCodeNode resource generated the event. */
  DISCOUNT_CODE_NODE = 'DISCOUNT_CODE_NODE',
  /** A DiscountNode resource generated the event. */
  DISCOUNT_NODE = 'DISCOUNT_NODE',
  /** A DraftOrder resource generated the event. */
  DRAFT_ORDER = 'DRAFT_ORDER',
  /** A Order resource generated the event. */
  ORDER = 'ORDER',
  /** A Page resource generated the event. */
  PAGE = 'PAGE',
  /** A PriceRule resource generated the event. */
  PRICE_RULE = 'PRICE_RULE',
  /** A Product resource generated the event. */
  PRODUCT = 'PRODUCT',
  /** A ProductVariant resource generated the event. */
  PRODUCT_VARIANT = 'PRODUCT_VARIANT',
  /**
   * Subject type is not available. This usually means that the subject isn't available in the current
   *         version of the API, using a newer API version may resolve this.
   */
  UNKNOWN = 'UNKNOWN'
}

/** An item for exchange. */
export type ExchangeLineItem = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The order line item for the exchange. */
  readonly lineItem?: Maybe<LineItem>;
};

/** The input fields for an applied discount on a calculated exchange line item. */
export type ExchangeLineItemAppliedDiscountInput = {
  /** The description of the discount. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** The value of the discount as a fixed amount or a percentage. */
  readonly value: ExchangeLineItemAppliedDiscountValueInput;
};

/**
 * The input value for an applied discount on a calculated exchange line item.
 * Can either specify the value as a fixed amount or a percentage.
 */
export type ExchangeLineItemAppliedDiscountValueInput = {
  /** The value of the discount as a fixed amount. */
  readonly amount?: InputMaybe<MoneyInput>;
  /** The value of the discount as a percentage. */
  readonly percentage?: InputMaybe<Scalars['Float']>;
};

/** An auto-generated type for paginating through multiple ExchangeLineItems. */
export type ExchangeLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ExchangeLineItemEdge>;
  /** A list of nodes that are contained in ExchangeLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ExchangeLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ExchangeLineItem and a cursor during pagination. */
export type ExchangeLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ExchangeLineItemEdge. */
  readonly node: ExchangeLineItem;
};

/** The input fields for new line items to be added to the order as part of an exchange. */
export type ExchangeLineItemInput = {
  /** The discount to be applied to the exchange line item. */
  readonly appliedDiscount?: InputMaybe<ExchangeLineItemAppliedDiscountInput>;
  /** The gift card codes associated with the physical gift cards. */
  readonly giftCardCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The quantity of the item to be added. */
  readonly quantity: Scalars['Int'];
  /** The ID of the product variant to be added to the order as part of an exchange. */
  readonly variantId?: InputMaybe<Scalars['ID']>;
};

/** An exchange where existing items on an order are returned and new items are added to the order. */
export type ExchangeV2 = Node & {
  /** The details of the new items in the exchange. */
  readonly additions: ExchangeV2Additions;
  /** The date and time when the exchange was completed. */
  readonly completedAt?: Maybe<Scalars['DateTime']>;
  /** The date and time when the exchange was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The location where the exchange happened. */
  readonly location?: Maybe<Location>;
  /** The text of an optional note that a shop owner can attach to the exchange. */
  readonly note?: Maybe<Scalars['String']>;
  /** The refunds processed during the exchange. */
  readonly refunds: ReadonlyArray<Refund>;
  /** The details of the returned items in the exchange. */
  readonly returns: ExchangeV2Returns;
  /** The staff member associated with the exchange. */
  readonly staffMember?: Maybe<StaffMember>;
  /** The amount of money that was paid or refunded as part of the exchange. */
  readonly totalAmountProcessedSet: MoneyBag;
  /** The difference in values of the items that were exchanged. */
  readonly totalPriceSet: MoneyBag;
  /** The order transactions related to the exchange. */
  readonly transactions: ReadonlyArray<OrderTransaction>;
};

/** New items associated to the exchange. */
export type ExchangeV2Additions = {
  /** The list of new items for the exchange. */
  readonly lineItems: ReadonlyArray<ExchangeV2LineItem>;
  /** The subtotal of the items being added, including discounts. */
  readonly subtotalPriceSet: MoneyBag;
  /** The summary of all taxes of the items being added. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** The total price of the items being added, including discounts and taxes. */
  readonly totalPriceSet: MoneyBag;
};

/** An auto-generated type for paginating through multiple ExchangeV2s. */
export type ExchangeV2Connection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ExchangeV2Edge>;
  /** A list of nodes that are contained in ExchangeV2Edge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ExchangeV2>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ExchangeV2 and a cursor during pagination. */
export type ExchangeV2Edge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ExchangeV2Edge. */
  readonly node: ExchangeV2;
};

/** Contains information about an item in the exchange. */
export type ExchangeV2LineItem = {
  /** A list of attributes that represent custom features or special requests. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The total line price, in shop and presentment currencies, after discounts are applied. */
  readonly discountedTotalSet: MoneyBag;
  /**
   * The price, in shop and presentment currencies,
   * of a single variant unit after line item discounts are applied.
   */
  readonly discountedUnitPriceSet: MoneyBag;
  /**
   * Name of the service provider who fulfilled the order.
   *
   * Valid values are either **manual** or the name of the provider.
   * For example, **amazon**, **shipwire**.
   *
   * Deleted fulfillment services will return null.
   */
  readonly fulfillmentService?: Maybe<FulfillmentService>;
  /** Indiciates if this line item is a gift card. */
  readonly giftCard: Scalars['Boolean'];
  /** The gift cards associated with the line item. */
  readonly giftCards: ReadonlyArray<GiftCard>;
  /** Whether the line item represents the purchase of a gift card. */
  readonly isGiftCard: Scalars['Boolean'];
  /** The line item associated with this object. */
  readonly lineItem?: Maybe<LineItem>;
  /** The name of the product. */
  readonly name: Scalars['String'];
  /** The total price, in shop and presentment currencies, before discounts are applied. */
  readonly originalTotalSet: MoneyBag;
  /**
   * The price, in shop and presentment currencies,
   * of a single variant unit before line item discounts are applied.
   */
  readonly originalUnitPriceSet: MoneyBag;
  /** The number of products that were purchased. */
  readonly quantity: Scalars['Int'];
  /** Whether physical shipping is required for the variant. */
  readonly requiresShipping: Scalars['Boolean'];
  /** The SKU number of the product variant. */
  readonly sku?: Maybe<Scalars['String']>;
  /** The TaxLine object connected to this line item. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Whether the variant is taxable. */
  readonly taxable: Scalars['Boolean'];
  /** The title of the product or variant. This field only applies to custom line items. */
  readonly title: Scalars['String'];
  /** The product variant of the line item. */
  readonly variant?: Maybe<ProductVariant>;
  /** The name of the variant. */
  readonly variantTitle?: Maybe<Scalars['String']>;
  /** The name of the vendor who created the product variant. */
  readonly vendor?: Maybe<Scalars['String']>;
};

/** Return items associated to the exchange. */
export type ExchangeV2Returns = {
  /** The list of return items for the exchange. */
  readonly lineItems: ReadonlyArray<ExchangeV2LineItem>;
  /** The amount of the order-level discount for the items and shipping being returned, which doesn't contain any line item discounts. */
  readonly orderDiscountAmountSet: MoneyBag;
  /** The amount of money to be refunded for shipping. */
  readonly shippingRefundAmountSet: MoneyBag;
  /** The subtotal of the items being returned. */
  readonly subtotalPriceSet: MoneyBag;
  /** The summary of all taxes of the items being returned. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** The amount of money to be refunded for tip. */
  readonly tipRefundAmountSet: MoneyBag;
  /** The total value of the items being returned. */
  readonly totalPriceSet: MoneyBag;
};

/** Represents a video hosted outside of Shopify. */
export type ExternalVideo = File & Media & Node & {
  /** A word or phrase to describe the contents or the function of a file. */
  readonly alt?: Maybe<Scalars['String']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The embed URL of the video for the respective host. */
  readonly embedUrl: Scalars['URL'];
  /**
   * The URL.
   * @deprecated Use `originUrl` instead.
   */
  readonly embeddedUrl: Scalars['URL'];
  /** Any errors that have occurred on the file. */
  readonly fileErrors: ReadonlyArray<FileError>;
  /** The status of the file. */
  readonly fileStatus: FileStatus;
  /** The host of the external video. */
  readonly host: MediaHost;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The media content type. */
  readonly mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  readonly mediaErrors: ReadonlyArray<MediaError>;
  /** The warnings attached to the media. */
  readonly mediaWarnings: ReadonlyArray<MediaWarning>;
  /** The origin URL of the video on the respective host. */
  readonly originUrl: Scalars['URL'];
  /** The preview image for the media. */
  readonly preview?: Maybe<MediaPreviewImage>;
  /** Current status of the media. */
  readonly status: MediaStatus;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** Requirements that must be met before an app can be installed. */
export type FailedRequirement = {
  /** Action to be taken to resolve a failed requirement, including URL link. */
  readonly action?: Maybe<NavigationItem>;
  /**
   * A concise set of copy strings to be displayed to merchants, to guide them in resolving problems your app
   * encounters when trying to make use of their Shop and its resources.
   */
  readonly message: Scalars['String'];
};

/** A additional cost, charged by the merchant, on an order. Examples include return shipping fees and restocking fees. */
export type Fee = {
  /** The unique ID for the Fee. */
  readonly id: Scalars['ID'];
};

/** A sale associated with a fee. */
export type FeeSale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The fee associated with the sale. */
  readonly fee: Fee;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** A file interface. */
export type File = {
  /** A word or phrase to describe the contents or the function of a file. */
  readonly alt?: Maybe<Scalars['String']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Any errors that have occurred on the file. */
  readonly fileErrors: ReadonlyArray<FileError>;
  /** The status of the file. */
  readonly fileStatus: FileStatus;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The preview image for the media. */
  readonly preview?: Maybe<MediaPreviewImage>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** Return type for `fileAcknowledgeUpdateFailed` mutation. */
export type FileAcknowledgeUpdateFailedPayload = {
  /** The updated file(s). */
  readonly files?: Maybe<ReadonlyArray<File>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FilesUserError>;
};

/** An auto-generated type for paginating through multiple Files. */
export type FileConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<FileEdge>;
  /** A list of nodes that are contained in FileEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<File>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The possible content types for a file object. */
export enum FileContentType {
  /** An externally hosted video. */
  EXTERNAL_VIDEO = 'EXTERNAL_VIDEO',
  /** A Shopify-hosted generic file. */
  FILE = 'FILE',
  /** A Shopify-hosted image. */
  IMAGE = 'IMAGE',
  /** A Shopify-hosted 3D model. */
  MODEL_3D = 'MODEL_3D',
  /** A Shopify-hosted video file. It's recommended to use this type for all video files. */
  VIDEO = 'VIDEO'
}

/** The input fields that are required to create a file object. */
export type FileCreateInput = {
  /** The alternative text description of the file. */
  readonly alt?: InputMaybe<Scalars['String']>;
  /** The file content type. If omitted, then Shopify will attempt to determine the content type during file processing. */
  readonly contentType?: InputMaybe<FileContentType>;
  /** How to handle if filename is already in use. */
  readonly duplicateResolutionMode?: InputMaybe<FileCreateInputDuplicateResolutionMode>;
  /**
   * When provided, the file will be created with the given filename,
   * otherwise the filename in the originalSource will be used.
   */
  readonly filename?: InputMaybe<Scalars['String']>;
  /**
   * An external URL (for images only) or a
   * [staged upload URL](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   */
  readonly originalSource: Scalars['String'];
};

/** The input fields for handling if filename is already in use. */
export enum FileCreateInputDuplicateResolutionMode {
  /** Append a UUID if filename is already in use. */
  APPEND_UUID = 'APPEND_UUID',
  /** Raise an error if filename is already in use. */
  RAISE_ERROR = 'RAISE_ERROR',
  /** Replace the existing file if filename is already in use. */
  REPLACE = 'REPLACE'
}

/** Return type for `fileCreate` mutation. */
export type FileCreatePayload = {
  /** The newly created files. */
  readonly files?: Maybe<ReadonlyArray<File>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FilesUserError>;
};

/** Return type for `fileDelete` mutation. */
export type FileDeletePayload = {
  /** The IDs of the deleted files. */
  readonly deletedFileIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FilesUserError>;
};

/** An auto-generated type which holds one File and a cursor during pagination. */
export type FileEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of FileEdge. */
  readonly node: File;
};

/**
 * A file error. This typically occurs when there is an issue with the file itself causing it to fail validation.
 * Check the file before attempting to upload again.
 */
export type FileError = {
  /** Code representing the type of error. */
  readonly code: FileErrorCode;
  /** Additional details regarding the error. */
  readonly details?: Maybe<Scalars['String']>;
  /** Translated error message. */
  readonly message: Scalars['String'];
};

/** The error types for a file. */
export enum FileErrorCode {
  /** File could not be created because a file with the same name already exists. */
  DUPLICATE_FILENAME_ERROR = 'DUPLICATE_FILENAME_ERROR',
  /** File could not be created because embed permissions are disabled for this video. */
  EXTERNAL_VIDEO_EMBED_DISABLED = 'EXTERNAL_VIDEO_EMBED_DISABLED',
  /** File could not be created because video is either not found or still transcoding. */
  EXTERNAL_VIDEO_EMBED_NOT_FOUND_OR_TRANSCODING = 'EXTERNAL_VIDEO_EMBED_NOT_FOUND_OR_TRANSCODING',
  /** File could not be created because the external video has an invalid aspect ratio. */
  EXTERNAL_VIDEO_INVALID_ASPECT_RATIO = 'EXTERNAL_VIDEO_INVALID_ASPECT_RATIO',
  /** File could not be created because the external video could not be found. */
  EXTERNAL_VIDEO_NOT_FOUND = 'EXTERNAL_VIDEO_NOT_FOUND',
  /** File could not be created because the external video is not listed or is private. */
  EXTERNAL_VIDEO_UNLISTED = 'EXTERNAL_VIDEO_UNLISTED',
  /** File could not be created because the cumulative file storage limit would be exceeded. */
  FILE_STORAGE_LIMIT_EXCEEDED = 'FILE_STORAGE_LIMIT_EXCEEDED',
  /** File could not be processed because the source could not be downloaded. */
  GENERIC_FILE_DOWNLOAD_FAILURE = 'GENERIC_FILE_DOWNLOAD_FAILURE',
  /** File could not be created because the size is too large. */
  GENERIC_FILE_INVALID_SIZE = 'GENERIC_FILE_INVALID_SIZE',
  /** File could not be processed because the image could not be downloaded. */
  IMAGE_DOWNLOAD_FAILURE = 'IMAGE_DOWNLOAD_FAILURE',
  /** File could not be processed because the image could not be processed. */
  IMAGE_PROCESSING_FAILURE = 'IMAGE_PROCESSING_FAILURE',
  /** File could not be created because the image has an invalid aspect ratio. */
  INVALID_IMAGE_ASPECT_RATIO = 'INVALID_IMAGE_ASPECT_RATIO',
  /** File could not be created because the image size is too large. */
  INVALID_IMAGE_FILE_SIZE = 'INVALID_IMAGE_FILE_SIZE',
  /** File could not be created because the image's resolution exceeds the max limit. */
  INVALID_IMAGE_RESOLUTION = 'INVALID_IMAGE_RESOLUTION',
  /** File could not be processed because the signed URL was invalid. */
  INVALID_SIGNED_URL = 'INVALID_SIGNED_URL',
  /** File timed out because it is currently being modified by another operation. */
  MEDIA_TIMEOUT_ERROR = 'MEDIA_TIMEOUT_ERROR',
  /** File could not be created because the model file failed processing. */
  MODEL3D_GLB_OUTPUT_CREATION_ERROR = 'MODEL3D_GLB_OUTPUT_CREATION_ERROR',
  /** File could not be created because the model can't be converted to USDZ format. */
  MODEL3D_GLB_TO_USDZ_CONVERSION_ERROR = 'MODEL3D_GLB_TO_USDZ_CONVERSION_ERROR',
  /** File could not be created because the model file failed processing. */
  MODEL3D_PROCESSING_FAILURE = 'MODEL3D_PROCESSING_FAILURE',
  /** File could not be created because the model's thumbnail generation failed. */
  MODEL3D_THUMBNAIL_GENERATION_ERROR = 'MODEL3D_THUMBNAIL_GENERATION_ERROR',
  /** There was an issue while trying to generate a new thumbnail. */
  MODEL3D_THUMBNAIL_REGENERATION_ERROR = 'MODEL3D_THUMBNAIL_REGENERATION_ERROR',
  /** Model failed validation. */
  MODEL3D_VALIDATION_ERROR = 'MODEL3D_VALIDATION_ERROR',
  /** File error has occurred for an unknown reason. */
  UNKNOWN = 'UNKNOWN',
  /** File could not be created because the image is an unsupported file type. */
  UNSUPPORTED_IMAGE_FILE_TYPE = 'UNSUPPORTED_IMAGE_FILE_TYPE',
  /** File could not be created because it has an invalid file type. */
  VIDEO_INVALID_FILETYPE_ERROR = 'VIDEO_INVALID_FILETYPE_ERROR',
  /** File could not be created because it does not meet the maximum duration requirement. */
  VIDEO_MAX_DURATION_ERROR = 'VIDEO_MAX_DURATION_ERROR',
  /** File could not be created because it does not meet the maximum height requirement. */
  VIDEO_MAX_HEIGHT_ERROR = 'VIDEO_MAX_HEIGHT_ERROR',
  /** File could not be created because it does not meet the maximum width requirement. */
  VIDEO_MAX_WIDTH_ERROR = 'VIDEO_MAX_WIDTH_ERROR',
  /** File could not be created because the metadata could not be read. */
  VIDEO_METADATA_READ_ERROR = 'VIDEO_METADATA_READ_ERROR',
  /** File could not be created because it does not meet the minimum duration requirement. */
  VIDEO_MIN_DURATION_ERROR = 'VIDEO_MIN_DURATION_ERROR',
  /** File could not be created because it does not meet the minimum height requirement. */
  VIDEO_MIN_HEIGHT_ERROR = 'VIDEO_MIN_HEIGHT_ERROR',
  /** File could not be created because it does not meet the minimum width requirement. */
  VIDEO_MIN_WIDTH_ERROR = 'VIDEO_MIN_WIDTH_ERROR',
  /** Video failed validation. */
  VIDEO_VALIDATION_ERROR = 'VIDEO_VALIDATION_ERROR'
}

/** The input fields required to create or update a file object. */
export type FileSetInput = {
  /** The alternative text description of the file. */
  readonly alt?: InputMaybe<Scalars['String']>;
  /** The file content type. If omitted, then Shopify will attempt to determine the content type during file processing. */
  readonly contentType?: InputMaybe<FileContentType>;
  /** How to handle if filename is already in use. */
  readonly duplicateResolutionMode?: InputMaybe<FileCreateInputDuplicateResolutionMode>;
  /**
   * When provided, the file will be created with the given filename,
   * otherwise the filename in the originalSource will be used.
   */
  readonly filename?: InputMaybe<Scalars['String']>;
  /** The ID of an existing file. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /**
   * An external URL (for images only) or a
   * [staged upload URL](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   */
  readonly originalSource?: InputMaybe<Scalars['String']>;
};

/** The set of valid sort keys for the File query. */
export enum FileSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `filename` value. */
  FILENAME = 'FILENAME',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `original_upload_size` value. */
  ORIGINAL_UPLOAD_SIZE = 'ORIGINAL_UPLOAD_SIZE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** The possible statuses for a file object. */
export enum FileStatus {
  /** File processing has failed. */
  FAILED = 'FAILED',
  /** File is being processed. */
  PROCESSING = 'PROCESSING',
  /** File is ready to be displayed. */
  READY = 'READY',
  /** File has been uploaded but hasn't been processed. */
  UPLOADED = 'UPLOADED'
}

/** The input fields that are required to update a file object. */
export type FileUpdateInput = {
  /** The alternative text description of the file. */
  readonly alt?: InputMaybe<Scalars['String']>;
  /** The name of the file including its extension. */
  readonly filename?: InputMaybe<Scalars['String']>;
  /** The ID of the file to be updated. */
  readonly id: Scalars['ID'];
  /**
   * The source from which to update a media image or generic file.
   * An external URL (for images only) or a
   * [staged upload URL](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   */
  readonly originalSource?: InputMaybe<Scalars['String']>;
  /**
   * The source from which to update the media preview image.
   * May be an external URL or a
   * [staged upload URL](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   */
  readonly previewImageSource?: InputMaybe<Scalars['String']>;
  /** The IDs of the references to add to the file. Currently only accepts product IDs. */
  readonly referencesToAdd?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The IDs of the references to remove from the file. Currently only accepts product IDs. */
  readonly referencesToRemove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** Return type for `fileUpdate` mutation. */
export type FileUpdatePayload = {
  /** The list of updated files. */
  readonly files?: Maybe<ReadonlyArray<File>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FilesUserError>;
};

/** Possible error codes that can be returned by `FilesUserError`. */
export enum FilesErrorCode {
  /** The alt value exceeds the maximum limit of 512 characters. */
  ALT_VALUE_LIMIT_EXCEEDED = 'ALT_VALUE_LIMIT_EXCEEDED',
  /** The search term must not be blank. */
  BLANK_SEARCH = 'BLANK_SEARCH',
  /** The provided filename already exists. */
  FILENAME_ALREADY_EXISTS = 'FILENAME_ALREADY_EXISTS',
  /** File does not exist. */
  FILE_DOES_NOT_EXIST = 'FILE_DOES_NOT_EXIST',
  /** File has a pending operation. */
  FILE_LOCKED = 'FILE_LOCKED',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Duplicate resolution mode is not supported for this file type. */
  INVALID_DUPLICATE_MODE_FOR_TYPE = 'INVALID_DUPLICATE_MODE_FOR_TYPE',
  /** The provided filename is invalid. */
  INVALID_FILENAME = 'INVALID_FILENAME',
  /** Invalid filename extension. */
  INVALID_FILENAME_EXTENSION = 'INVALID_FILENAME_EXTENSION',
  /** Invalid image source url value provided. */
  INVALID_IMAGE_SOURCE_URL = 'INVALID_IMAGE_SOURCE_URL',
  /** Search query isn't supported. */
  INVALID_QUERY = 'INVALID_QUERY',
  /** Cannot create file with custom filename which does not match original source extension. */
  MISMATCHED_FILENAME_AND_ORIGINAL_SOURCE = 'MISMATCHED_FILENAME_AND_ORIGINAL_SOURCE',
  /** At least one argument is required. */
  MISSING_ARGUMENTS = 'MISSING_ARGUMENTS',
  /** Duplicate resolution mode REPLACE cannot be used without specifying filename. */
  MISSING_FILENAME_FOR_DUPLICATE_MODE_REPLACE = 'MISSING_FILENAME_FOR_DUPLICATE_MODE_REPLACE',
  /** Exceeded the limit of non-image media per shop. */
  NON_IMAGE_MEDIA_PER_SHOP_LIMIT_EXCEEDED = 'NON_IMAGE_MEDIA_PER_SHOP_LIMIT_EXCEEDED',
  /** The file is not in the READY state. */
  NON_READY_STATE = 'NON_READY_STATE',
  /** Exceeded the limit of media per product. */
  PRODUCT_MEDIA_LIMIT_EXCEEDED = 'PRODUCT_MEDIA_LIMIT_EXCEEDED',
  /** One or more associated products are suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** The target resource does not exist. */
  REFERENCE_TARGET_DOES_NOT_EXIST = 'REFERENCE_TARGET_DOES_NOT_EXIST',
  /** Specify one argument: search, IDs, or deleteAll. */
  TOO_MANY_ARGUMENTS = 'TOO_MANY_ARGUMENTS',
  /** Cannot add more than 10000 references to a file. */
  TOO_MANY_FILE_REFERENCE = 'TOO_MANY_FILE_REFERENCE',
  /** The file type is not supported. */
  UNACCEPTABLE_ASSET = 'UNACCEPTABLE_ASSET',
  /** The file is not supported on trial accounts. Select a plan to upload this file. */
  UNACCEPTABLE_TRIAL_ASSET = 'UNACCEPTABLE_TRIAL_ASSET',
  /** The file is not supported on trial accounts that have not validated their email. Either select a plan or verify the shop owner email to upload this file. */
  UNACCEPTABLE_UNVERIFIED_TRIAL_ASSET = 'UNACCEPTABLE_UNVERIFIED_TRIAL_ASSET',
  /** The file type is not supported for referencing. */
  UNSUPPORTED_FILE_REFERENCE = 'UNSUPPORTED_FILE_REFERENCE',
  /** Filename update is only supported on Image and GenericFile. */
  UNSUPPORTED_MEDIA_TYPE_FOR_FILENAME_UPDATE = 'UNSUPPORTED_MEDIA_TYPE_FOR_FILENAME_UPDATE'
}

/** An error that happens during the execution of a Files API query or mutation. */
export type FilesUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FilesErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** A filter option is one possible value in a search filter. */
export type FilterOption = {
  /** The filter option's label for display purposes. */
  readonly label: Scalars['String'];
  /** The filter option's value. */
  readonly value: Scalars['String'];
};

/** An amount that's allocated to a line item based on an associated discount application. */
export type FinancialSummaryDiscountAllocation = {
  /** The money amount that's allocated per unit on the associated line based on the discount application in shop and presentment currencies. If the allocated amount for the line cannot be evenly divided by the quantity, then this amount will be an approximate amount, avoiding fractional pennies. For example, if the associated line had a quantity of 3 with a discount of 4 cents, then the discount distribution would be [0.01, 0.01, 0.02]. This field returns the highest number of the distribution. In this example, this would be 0.02. */
  readonly approximateAllocatedAmountPerItem: MoneyBag;
  /** The discount application that the allocated amount originated from. */
  readonly discountApplication: FinancialSummaryDiscountApplication;
};

/**
 * Discount applications capture the intentions of a discount source at
 * the time of application on an order's line items or shipping lines.
 */
export type FinancialSummaryDiscountApplication = {
  /** The method by which the discount's value is applied to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
};

/** Return type for `flowGenerateSignature` mutation. */
export type FlowGenerateSignaturePayload = {
  /** The payload used to generate the signature. */
  readonly payload?: Maybe<Scalars['String']>;
  /** The generated signature. */
  readonly signature?: Maybe<Scalars['String']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `flowTriggerReceive` mutation. */
export type FlowTriggerReceivePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/**
 * Represents a fulfillment.
 * In Shopify, a fulfillment represents a shipment of one or more items in an order.
 * When an order has been completely fulfilled, it means that all the items that are included
 * in the order have been sent to the customer.
 * There can be more than one fulfillment for an order.
 */
export type Fulfillment = LegacyInteroperability & Node & {
  /** The date and time when the fulfillment was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The date that this fulfillment was delivered. */
  readonly deliveredAt?: Maybe<Scalars['DateTime']>;
  /** Human readable display status for this fulfillment. */
  readonly displayStatus?: Maybe<FulfillmentDisplayStatus>;
  /** The estimated date that this fulfillment will arrive. */
  readonly estimatedDeliveryAt?: Maybe<Scalars['DateTime']>;
  /** The history of events associated with this fulfillment. */
  readonly events: FulfillmentEventConnection;
  /** List of the fulfillment's line items. */
  readonly fulfillmentLineItems: FulfillmentLineItemConnection;
  /** A paginated list of fulfillment orders for the fulfillment. */
  readonly fulfillmentOrders: FulfillmentOrderConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The date and time when the fulfillment went into transit. */
  readonly inTransitAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The location that the fulfillment was processed at. */
  readonly location?: Maybe<Location>;
  /** Human readable reference identifier for this fulfillment. */
  readonly name: Scalars['String'];
  /** The order for which the fulfillment was created. */
  readonly order: Order;
  /** The address at which the fulfillment occurred. This field is intended for tax purposes, as a full address is required for tax providers to accurately calculate taxes. Typically this is the address of the warehouse or fulfillment center. To retrieve a fulfillment location's address, use the `assignedLocation` field on the [`FulfillmentOrder`](/docs/api/admin-graphql/latest/objects/FulfillmentOrder) object instead. */
  readonly originAddress?: Maybe<FulfillmentOriginAddress>;
  /** Whether any of the line items in the fulfillment require shipping. */
  readonly requiresShipping: Scalars['Boolean'];
  /** Fulfillment service associated with the fulfillment. */
  readonly service?: Maybe<FulfillmentService>;
  /** The status of the fulfillment. */
  readonly status: FulfillmentStatus;
  /** Sum of all line item quantities for the fulfillment. */
  readonly totalQuantity: Scalars['Int'];
  /**
   * Tracking information associated with the fulfillment,
   * such as the tracking company, tracking number, and tracking URL.
   */
  readonly trackingInfo: ReadonlyArray<FulfillmentTrackingInfo>;
  /** The date and time when the fulfillment was last modified. */
  readonly updatedAt: Scalars['DateTime'];
};


/**
 * Represents a fulfillment.
 * In Shopify, a fulfillment represents a shipment of one or more items in an order.
 * When an order has been completely fulfilled, it means that all the items that are included
 * in the order have been sent to the customer.
 * There can be more than one fulfillment for an order.
 */
export type FulfillmentEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<FulfillmentEventSortKeys>;
};


/**
 * Represents a fulfillment.
 * In Shopify, a fulfillment represents a shipment of one or more items in an order.
 * When an order has been completely fulfilled, it means that all the items that are included
 * in the order have been sent to the customer.
 * There can be more than one fulfillment for an order.
 */
export type FulfillmentFulfillmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a fulfillment.
 * In Shopify, a fulfillment represents a shipment of one or more items in an order.
 * When an order has been completely fulfilled, it means that all the items that are included
 * in the order have been sent to the customer.
 * There can be more than one fulfillment for an order.
 */
export type FulfillmentFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a fulfillment.
 * In Shopify, a fulfillment represents a shipment of one or more items in an order.
 * When an order has been completely fulfilled, it means that all the items that are included
 * in the order have been sent to the customer.
 * There can be more than one fulfillment for an order.
 */
export type FulfillmentTrackingInfoArgs = {
  first?: InputMaybe<Scalars['Int']>;
};

/** Return type for `fulfillmentCancel` mutation. */
export type FulfillmentCancelPayload = {
  /** The canceled fulfillment. */
  readonly fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type for paginating through multiple Fulfillments. */
export type FulfillmentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<FulfillmentEdge>;
  /** A list of nodes that are contained in FulfillmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Fulfillment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** A fulfillment constraint rule. */
export type FulfillmentConstraintRule = HasMetafields & Node & {
  /** Delivery method types that the function is associated with. */
  readonly deliveryMethodTypes: ReadonlyArray<DeliveryMethodType>;
  /** The ID for the fulfillment constraint function. */
  readonly function: ShopifyFunction;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
};


/** A fulfillment constraint rule. */
export type FulfillmentConstraintRuleMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A fulfillment constraint rule. */
export type FulfillmentConstraintRuleMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A fulfillment constraint rule. */
export type FulfillmentConstraintRulePrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A fulfillment constraint rule. */
export type FulfillmentConstraintRulePrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `fulfillmentConstraintRuleCreate` mutation. */
export type FulfillmentConstraintRuleCreatePayload = {
  /** The newly created fulfillment constraint rule. */
  readonly fulfillmentConstraintRule?: Maybe<FulfillmentConstraintRule>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentConstraintRuleCreateUserError>;
};

/** An error that occurs during the execution of `FulfillmentConstraintRuleCreate`. */
export type FulfillmentConstraintRuleCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentConstraintRuleCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentConstraintRuleCreateUserError`. */
export enum FulfillmentConstraintRuleCreateUserErrorCode {
  /** Shop must be on a Shopify Plus plan to activate functions from a custom app. */
  CUSTOM_APP_FUNCTION_NOT_ELIGIBLE = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** A fulfillment constraint rule already exists for the provided function_id. */
  FUNCTION_ALREADY_REGISTERED = 'FUNCTION_ALREADY_REGISTERED',
  /** Function does not implement the required interface for this fulfillment constraint rule. */
  FUNCTION_DOES_NOT_IMPLEMENT = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** No Shopify Function found for provided function_id. */
  FUNCTION_NOT_FOUND = 'FUNCTION_NOT_FOUND',
  /** Function is pending deletion and cannot have new rules created against it. */
  FUNCTION_PENDING_DELETION = 'FUNCTION_PENDING_DELETION',
  /** Failed to create fulfillment constraint rule due to invalid input. */
  INPUT_INVALID = 'INPUT_INVALID',
  /** Maximum number of fulfillment constraint rules reached. Limit is 10. */
  MAXIMUM_FULFILLMENT_CONSTRAINT_RULES_REACHED = 'MAXIMUM_FULFILLMENT_CONSTRAINT_RULES_REACHED'
}

/** Return type for `fulfillmentConstraintRuleDelete` mutation. */
export type FulfillmentConstraintRuleDeletePayload = {
  /** Whether or not the fulfillment constraint rule was successfully deleted. */
  readonly success?: Maybe<Scalars['Boolean']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentConstraintRuleDeleteUserError>;
};

/** An error that occurs during the execution of `FulfillmentConstraintRuleDelete`. */
export type FulfillmentConstraintRuleDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentConstraintRuleDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentConstraintRuleDeleteUserError`. */
export enum FulfillmentConstraintRuleDeleteUserErrorCode {
  /** Could not find fulfillment constraint rule for provided id. */
  NOT_FOUND = 'NOT_FOUND',
  /** Unauthorized app scope. */
  UNAUTHORIZED_APP_SCOPE = 'UNAUTHORIZED_APP_SCOPE'
}

/** Return type for `fulfillmentConstraintRuleUpdate` mutation. */
export type FulfillmentConstraintRuleUpdatePayload = {
  /** The updated fulfillment constraint rule. */
  readonly fulfillmentConstraintRule?: Maybe<FulfillmentConstraintRule>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentConstraintRuleUpdateUserError>;
};

/** An error that occurs during the execution of `FulfillmentConstraintRuleUpdate`. */
export type FulfillmentConstraintRuleUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentConstraintRuleUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentConstraintRuleUpdateUserError`. */
export enum FulfillmentConstraintRuleUpdateUserErrorCode {
  /** Could not find fulfillment constraint rule for provided id. */
  NOT_FOUND = 'NOT_FOUND',
  /** Unauthorized app scope. */
  UNAUTHORIZED_APP_SCOPE = 'UNAUTHORIZED_APP_SCOPE'
}

/** Return type for `fulfillmentCreate` mutation. */
export type FulfillmentCreatePayload = {
  /** The created fulfillment. */
  readonly fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `fulfillmentCreateV2` mutation. */
export type FulfillmentCreateV2Payload = {
  /** The created fulfillment. */
  readonly fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The display status of a fulfillment. */
export enum FulfillmentDisplayStatus {
  /** Displayed as **Attempted delivery**. */
  ATTEMPTED_DELIVERY = 'ATTEMPTED_DELIVERY',
  /** Displayed as **Canceled**. */
  CANCELED = 'CANCELED',
  /** Displayed as **Confirmed**. */
  CONFIRMED = 'CONFIRMED',
  /** Displayed as **Delivered**. */
  DELIVERED = 'DELIVERED',
  /** Displayed as **Failure**. */
  FAILURE = 'FAILURE',
  /** Displayed as **Fulfilled**. */
  FULFILLED = 'FULFILLED',
  /** Displayed as **In transit**. */
  IN_TRANSIT = 'IN_TRANSIT',
  /** Displayed as **Label printed**. */
  LABEL_PRINTED = 'LABEL_PRINTED',
  /** Displayed as **Label purchased**. */
  LABEL_PURCHASED = 'LABEL_PURCHASED',
  /** Displayed as **Label voided**. */
  LABEL_VOIDED = 'LABEL_VOIDED',
  /** Displayed as **Marked as fulfilled**. */
  MARKED_AS_FULFILLED = 'MARKED_AS_FULFILLED',
  /** Displayed as **Not delivered**. */
  NOT_DELIVERED = 'NOT_DELIVERED',
  /** Displayed as **Out for delivery**. */
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  /** Displayed as **Picked up**. */
  PICKED_UP = 'PICKED_UP',
  /** Displayed as **Ready for pickup**. */
  READY_FOR_PICKUP = 'READY_FOR_PICKUP',
  /** Displayed as **Submitted**. */
  SUBMITTED = 'SUBMITTED'
}

/** An auto-generated type which holds one Fulfillment and a cursor during pagination. */
export type FulfillmentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of FulfillmentEdge. */
  readonly node: Fulfillment;
};

/** The fulfillment event that describes the fulfilllment status at a particular time. */
export type FulfillmentEvent = Node & {
  /** The street address where this fulfillment event occurred. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The city where this fulfillment event occurred. */
  readonly city?: Maybe<Scalars['String']>;
  /** The country where this fulfillment event occurred. */
  readonly country?: Maybe<Scalars['String']>;
  /** The date and time when the fulfillment event was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The estimated delivery date and time of the fulfillment. */
  readonly estimatedDeliveryAt?: Maybe<Scalars['DateTime']>;
  /** The time at which this fulfillment event happened. */
  readonly happenedAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The latitude where this fulfillment event occurred. */
  readonly latitude?: Maybe<Scalars['Float']>;
  /** The longitude where this fulfillment event occurred. */
  readonly longitude?: Maybe<Scalars['Float']>;
  /** A message associated with this fulfillment event. */
  readonly message?: Maybe<Scalars['String']>;
  /** The province where this fulfillment event occurred. */
  readonly province?: Maybe<Scalars['String']>;
  /** The status of this fulfillment event. */
  readonly status: FulfillmentEventStatus;
  /** The zip code of the location where this fulfillment event occurred. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** An auto-generated type for paginating through multiple FulfillmentEvents. */
export type FulfillmentEventConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<FulfillmentEventEdge>;
  /** A list of nodes that are contained in FulfillmentEventEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<FulfillmentEvent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `fulfillmentEventCreate` mutation. */
export type FulfillmentEventCreatePayload = {
  /** The created fulfillment event. */
  readonly fulfillmentEvent?: Maybe<FulfillmentEvent>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one FulfillmentEvent and a cursor during pagination. */
export type FulfillmentEventEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of FulfillmentEventEdge. */
  readonly node: FulfillmentEvent;
};

/** The input fields used to create a fulfillment event. */
export type FulfillmentEventInput = {
  /** The street address where this fulfillment event occurred. */
  readonly address1?: InputMaybe<Scalars['String']>;
  /** The city where this fulfillment event occurred. */
  readonly city?: InputMaybe<Scalars['String']>;
  /** The country where this fulfillment event occurred. */
  readonly country?: InputMaybe<Scalars['String']>;
  /** The estimated delivery date and time of the fulfillment. */
  readonly estimatedDeliveryAt?: InputMaybe<Scalars['DateTime']>;
  /** The ID for the fulfillment that's associated with this fulfillment event. */
  readonly fulfillmentId: Scalars['ID'];
  /** The time at which this fulfillment event happened. */
  readonly happenedAt?: InputMaybe<Scalars['DateTime']>;
  /** The latitude where this fulfillment event occurred. */
  readonly latitude?: InputMaybe<Scalars['Float']>;
  /** The longitude where this fulfillment event occurred. */
  readonly longitude?: InputMaybe<Scalars['Float']>;
  /** A message associated with this fulfillment event. */
  readonly message?: InputMaybe<Scalars['String']>;
  /** The province where this fulfillment event occurred. */
  readonly province?: InputMaybe<Scalars['String']>;
  /** The status of this fulfillment event. */
  readonly status: FulfillmentEventStatus;
  /** The zip code of the location where this fulfillment event occurred. */
  readonly zip?: InputMaybe<Scalars['String']>;
};

/** The set of valid sort keys for the FulfillmentEvent query. */
export enum FulfillmentEventSortKeys {
  /** Sort by the `happened_at` value. */
  HAPPENED_AT = 'HAPPENED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The status that describes a fulfillment or delivery event. */
export enum FulfillmentEventStatus {
  /** A delivery was attempted. */
  ATTEMPTED_DELIVERY = 'ATTEMPTED_DELIVERY',
  /** The fulfillment is confirmed. This is the default value when no other information is available. */
  CONFIRMED = 'CONFIRMED',
  /** The fulfillment was successfully delivered. */
  DELIVERED = 'DELIVERED',
  /** The fulfillment request failed. */
  FAILURE = 'FAILURE',
  /** The fulfillment is in transit. */
  IN_TRANSIT = 'IN_TRANSIT',
  /** A purchased shipping label has been printed. */
  LABEL_PRINTED = 'LABEL_PRINTED',
  /** A shipping label has been purchased. */
  LABEL_PURCHASED = 'LABEL_PURCHASED',
  /** The fulfillment is out for delivery. */
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  /** The fulfillment is ready to be picked up. */
  READY_FOR_PICKUP = 'READY_FOR_PICKUP'
}

/** A fulfillment hold currently applied on a fulfillment order. */
export type FulfillmentHold = Node & {
  /** The localized reason for the fulfillment hold for display purposes. */
  readonly displayReason: Scalars['String'];
  /**
   * The name of the app or service that applied the fulfillment hold.
   * @deprecated Use `heldByApp.title` instead.
   * For more information, see the following [changelog post](https://shopify.dev/changelog/update-to-fulfillmenthold-heldbyapp-field-from-fulfillmenthold-heldby-field).
   *
   */
  readonly heldBy?: Maybe<Scalars['String']>;
  /** A boolean value that indicates whether the requesting app created the fulfillment hold. */
  readonly heldByRequestingApp: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The reason for the fulfillment hold. */
  readonly reason: FulfillmentHoldReason;
  /** Additional information about the fulfillment hold reason. */
  readonly reasonNotes?: Maybe<Scalars['String']>;
};

/** The reason for a fulfillment hold. */
export enum FulfillmentHoldReason {
  /** The fulfillment hold is applied because payment is pending. */
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  /** The fulfillment hold is applied because of return items not yet received during an exchange. */
  AWAITING_RETURN_ITEMS = 'AWAITING_RETURN_ITEMS',
  /** The fulfillment hold is applied because of a high risk of fraud. */
  HIGH_RISK_OF_FRAUD = 'HIGH_RISK_OF_FRAUD',
  /** The fulfillment hold is applied because of an incorrect address. */
  INCORRECT_ADDRESS = 'INCORRECT_ADDRESS',
  /** The fulfillment hold is applied because inventory is out of stock. */
  INVENTORY_OUT_OF_STOCK = 'INVENTORY_OUT_OF_STOCK',
  /** The fulfillment hold is applied because of a post purchase upsell offer. */
  ONLINE_STORE_POST_PURCHASE_CROSS_SELL = 'ONLINE_STORE_POST_PURCHASE_CROSS_SELL',
  /** The fulfillment hold is applied for another reason. */
  OTHER = 'OTHER',
  /** The fulfillment hold is applied because of an unknown delivery date. */
  UNKNOWN_DELIVERY_DATE = 'UNKNOWN_DELIVERY_DATE'
}

/** The input fields used to create a fulfillment from fulfillment orders. */
export type FulfillmentInput = {
  /**
   * Pairs of `fulfillment_order_id` and `fulfillment_order_line_items` that represent the fulfillment
   * order line items that have to be fulfilled for each fulfillment order.  For any given pair, if the
   * fulfillment order line items are left blank then all the fulfillment order line items of the
   * associated fulfillment order ID will be fulfilled.
   */
  readonly lineItemsByFulfillmentOrder: ReadonlyArray<FulfillmentOrderLineItemsInput>;
  /**
   * Whether the customer is notified.
   * If `true`, then a notification is sent when the fulfillment is created. The default value is `false`.
   */
  readonly notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  /** Address information about the location from which the order was fulfilled. */
  readonly originAddress?: InputMaybe<FulfillmentOriginAddressInput>;
  /**
   * The fulfillment's tracking information, including a tracking URL, a tracking number,
   * and the company associated with the fulfillment.
   */
  readonly trackingInfo?: InputMaybe<FulfillmentTrackingInput>;
};

/** Represents a line item from an order that's included in a fulfillment. */
export type FulfillmentLineItem = Node & {
  /**
   * The total price after discounts are applied.
   * @deprecated Use `discountedTotalSet` instead.
   */
  readonly discountedTotal: Scalars['Money'];
  /** The total price after discounts are applied in shop and presentment currencies. This value doesn't include order-level discounts. */
  readonly discountedTotalSet: MoneyBag;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The associated order's line item. */
  readonly lineItem: LineItem;
  /**
   * The total price before discounts are applied.
   * @deprecated Use `originalTotalSet` instead.
   */
  readonly originalTotal: Scalars['Money'];
  /** The total price before discounts are applied in shop and presentment currencies. */
  readonly originalTotalSet: MoneyBag;
  /** Number of line items in the fulfillment. */
  readonly quantity?: Maybe<Scalars['Int']>;
};

/** An auto-generated type for paginating through multiple FulfillmentLineItems. */
export type FulfillmentLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<FulfillmentLineItemEdge>;
  /** A list of nodes that are contained in FulfillmentLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<FulfillmentLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one FulfillmentLineItem and a cursor during pagination. */
export type FulfillmentLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of FulfillmentLineItemEdge. */
  readonly node: FulfillmentLineItem;
};

/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrder = Node & {
  /**
   * The fulfillment order's assigned location. This is the location where the fulfillment is expected to happen.
   *
   * The fulfillment order's assigned location might change in the following cases:
   *
   * - The fulfillment order has been entirely moved to a new location. For example, the [fulfillmentOrderMove](
   *   https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove
   *   ) mutation has been called, and you see the original fulfillment order in the [movedFulfillmentOrder](
   *   https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove#field-fulfillmentordermovepayload-movedfulfillmentorder
   *   ) field within the mutation's response.
   * - Work on the fulfillment order hasn't yet begun, which means that the fulfillment order has the
   *     [OPEN](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-open),
   *     [SCHEDULED](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-scheduled), or
   *     [ON_HOLD](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-onhold)
   *     status, and the shop's location properties might be undergoing edits (for example, in the Shopify admin).
   */
  readonly assignedLocation: FulfillmentOrderAssignedLocation;
  /** ID of the channel that created the order. */
  readonly channelId?: Maybe<Scalars['ID']>;
  /** Date and time when the fulfillment order was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Delivery method of this fulfillment order. */
  readonly deliveryMethod?: Maybe<DeliveryMethod>;
  /** The destination where the items should be sent. */
  readonly destination?: Maybe<FulfillmentOrderDestination>;
  /** The date and time at which the fulfillment order will be fulfillable. When this date and time is reached, the scheduled fulfillment order is automatically transitioned to open. For example, the `fulfill_at` date for a subscription order might be the 1st of each month, a pre-order `fulfill_at` date would be `nil`, and a standard order `fulfill_at` date would be the order creation date. */
  readonly fulfillAt?: Maybe<Scalars['DateTime']>;
  /** The latest date and time by which all items in the fulfillment order need to be fulfilled. */
  readonly fulfillBy?: Maybe<Scalars['DateTime']>;
  /** The fulfillment holds applied on the fulfillment order. */
  readonly fulfillmentHolds: ReadonlyArray<FulfillmentHold>;
  /** Fulfillment orders eligible for merging with the given fulfillment order. */
  readonly fulfillmentOrdersForMerge: FulfillmentOrderConnection;
  /** A list of fulfillments for the fulfillment order. */
  readonly fulfillments: FulfillmentConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The duties delivery method of this fulfillment order. */
  readonly internationalDuties?: Maybe<FulfillmentOrderInternationalDuties>;
  /** A list of the fulfillment order's line items. */
  readonly lineItems: FulfillmentOrderLineItemConnection;
  /** A list of locations that the fulfillment order can potentially move to. */
  readonly locationsForMove: FulfillmentOrderLocationForMoveConnection;
  /** A list of requests sent by the merchant or an order management app to the fulfillment service for the fulfillment order. */
  readonly merchantRequests: FulfillmentOrderMerchantRequestConnection;
  /** The order that's associated with the fulfillment order. */
  readonly order: Order;
  /** ID of the order that's associated with the fulfillment order. */
  readonly orderId: Scalars['ID'];
  /**
   * The unique identifier for the order that appears on the order page in the Shopify admin and the <b>Order status</b> page.
   * For example, "#1001", "EN1001", or "1001-A".
   * This value isn't unique across multiple stores.
   */
  readonly orderName: Scalars['String'];
  /**
   * The date and time when the order was processed.
   * This date and time might not match the date and time when the order was created.
   */
  readonly orderProcessedAt: Scalars['DateTime'];
  /** The request status of the fulfillment order. */
  readonly requestStatus: FulfillmentOrderRequestStatus;
  /** The status of the fulfillment order. */
  readonly status: FulfillmentOrderStatus;
  /** The actions that can be performed on this fulfillment order. */
  readonly supportedActions: ReadonlyArray<FulfillmentOrderSupportedAction>;
  /** The date and time when the fulfillment order was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderFulfillmentOrdersForMergeArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderFulfillmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderLocationsForMoveArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lineItemIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  locationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The FulfillmentOrder object represents either an item or a group of items in an
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * that are expected to be fulfilled from the same location.
 * There can be more than one fulfillment order for an
 * [order](https://shopify.dev/api/admin-graphql/latest/objects/Order)
 * at a given location.
 *
 * {{ '/api/reference/fulfillment_order_relationships.png' | image }}
 *
 * Fulfillment orders represent the work which is intended to be done in relation to an order.
 * When fulfillment has started for one or more line items, a
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment)
 * is created by a merchant or third party to represent the ongoing or completed work of fulfillment.
 *
 * [See below for more details on creating fulfillments](#the-lifecycle-of-a-fulfillment-order-at-a-location-which-is-managed-by-a-fulfillment-service).
 *
 * > Note:
 * > Shopify creates fulfillment orders automatically when an order is created.
 * > It is not possible to manually create fulfillment orders.
 * >
 * > [See below for more details on the lifecycle of a fulfillment order](#the-lifecycle-of-a-fulfillment-order).
 *
 * ## Retrieving fulfillment orders
 *
 * ### Fulfillment orders from an order
 *
 * All fulfillment orders related to a given order can be retrieved with the
 * [Order.fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/objects/Order#connection-order-fulfillmentorders)
 * connection.
 *
 * [API access scopes](#api-access-scopes)
 * govern which fulfillments orders are returned to clients.
 * An API client will only receive a subset of the fulfillment orders which belong to an order
 * if they don't have the necessary access scopes to view all of the fulfillment orders.
 *
 * ### Fulfillment orders assigned to the app for fulfillment
 *
 * Fulfillment service apps can retrieve the fulfillment orders which have been assigned to their locations with the
 * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
 * connection.
 * Use the `assignmentStatus` argument to control whether all assigned fulfillment orders
 * should be returned or only those where a merchant has sent a
 * [fulfillment request](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderMerchantRequest)
 * and it has yet to be responded to.
 *
 * The API client must be granted the `read_assigned_fulfillment_orders` access scope to access
 * the assigned fulfillment orders.
 *
 * ### All fulfillment orders
 *
 * Apps can retrieve all fulfillment orders with the
 * [fulfillmentOrders](https://shopify.dev/api/admin-graphql/latest/queries/fulfillmentOrders)
 * query. This query returns all assigned, merchant-managed, and third-party fulfillment orders on the shop,
 * which are accessible to the app according to the
 * [fulfillment order access scopes](#api-access-scopes) it was granted with.
 *
 * ## The lifecycle of a fulfillment order
 *
 * ### Fulfillment Order Creation
 *
 * After an order is created, a background worker performs the order routing process which determines
 * which locations will be responsible for fulfilling the purchased items.
 * Once the order routing process is complete, one or more fulfillment orders will be created
 * and assigned to these locations. It is not possible to manually create fulfillment orders.
 *
 * Once a fulfillment order has been created, it will have one of two different lifecycles depending on
 * the type of location which the fulfillment order is assigned to.
 *
 * ### The lifecycle of a fulfillment order at a merchant managed location
 *
 * Fulfillment orders are completed by creating
 * [fulfillments](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment).
 * Fulfillments represents the work done.
 *
 * For digital products a merchant or an order management app would create a fulfilment once the digital asset
 * has been provisioned.
 * For example, in the case of a digital gift card, a merchant would to do this once
 * the gift card has been activated - before the email has been shipped.
 *
 * On the other hand, for a traditional shipped order,
 * a merchant or an order management app would create a fulfillment after picking and packing the items relating
 * to a fulfillment order, but before the courier has collected the goods.
 *
 * [Learn about managing fulfillment orders as an order management app](https://shopify.dev/apps/fulfillment/order-management-apps/manage-fulfillments).
 *
 * ### The lifecycle of a fulfillment order at a location which is managed by a fulfillment service
 *
 * For fulfillment orders which are assigned to a location that is managed by a fulfillment service,
 * a merchant or an Order Management App can
 * [send a fulfillment request](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitFulfillmentRequest)
 * to the fulfillment service which operates the location to request that they fulfill the associated items.
 * A fulfillment service has the option to
 * [accept](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderAcceptFulfillmentRequest)
 * or [reject](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderRejectFulfillmentRequest)
 * this fulfillment request.
 *
 * Once the fulfillment service has accepted the request, the request can no longer be cancelled by the merchant
 * or order management app and instead a
 * [cancellation request must be submitted](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderSubmitCancellationRequest)
 * to the fulfillment service.
 *
 * Once a fulfillment service accepts a fulfillment request,
 * then after they are ready to pack items and send them for delivery, they create fulfillments with the
 * [fulfillmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentCreate)
 * mutation.
 * They can provide tracking information right away or create fulfillments without it and then
 * update the tracking information for fulfillments with the
 * [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/unstable/mutations/fulfillmentTrackingInfoUpdate)
 * mutation.
 *
 * [Learn about managing fulfillment orders as a fulfillment service](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments).
 *
 * ## API access scopes
 *
 * Fulfillment orders are governed by the following API access scopes:
 *
 * * The `read_merchant_managed_fulfillment_orders` and
 *   `write_merchant_managed_fulfillment_orders` access scopes
 *   grant access to fulfillment orders assigned to merchant-managed locations.
 * * The `read_assigned_fulfillment_orders` and `write_assigned_fulfillment_orders`
 *   access scopes are intended for fulfillment services.
 *   These scopes grant access to fulfillment orders assigned to locations that are being managed
 *   by fulfillment services.
 * * The `read_third_party_fulfillment_orders` and `write_third_party_fulfillment_orders`
 *   access scopes grant access to fulfillment orders
 *   assigned to locations managed by other fulfillment services.
 *
 * ### Fulfillment service app access scopes
 *
 * Usually, **fulfillment services** have the `write_assigned_fulfillment_orders` access scope
 * and don't have the `*_third_party_fulfillment_orders`
 * or `*_merchant_managed_fulfillment_orders` access scopes.
 * The app will only have access to the fulfillment orders assigned to their location
 * (or multiple locations if the app registers multiple fulfillment services on the shop).
 * The app will not have access to fulfillment orders assigned to merchant-managed locations
 * or locations owned by other fulfillment service apps.
 *
 * ### Order management app access scopes
 *
 * **Order management apps** will usually request `write_merchant_managed_fulfillment_orders` and
 * `write_third_party_fulfillment_orders` access scopes. This will allow them to manage all fulfillment orders
 * on behalf of a merchant.
 *
 * If an app combines the functions of an order management app and a fulfillment service,
 * then the app should request all
 * access scopes to manage all assigned and all unassigned fulfillment orders.
 *
 * ## Notifications about fulfillment orders
 *
 * Fulfillment services are required to
 * [register](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
 * a self-hosted callback URL which has a number of uses. One of these uses is that this callback URL will be notified
 * whenever a merchant submits a fulfillment or cancellation request.
 *
 * Both merchants and apps can
 * [subscribe](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * to the
 * [fulfillment order webhooks](https://shopify.dev/api/admin-graphql/latest/enums/WebhookSubscriptionTopic#value-fulfillmentorderscancellationrequestaccepted)
 * to be notified whenever fulfillment order related domain events occur.
 *
 * [Learn about fulfillment workflows](https://shopify.dev/apps/fulfillment).
 */
export type FulfillmentOrderMerchantRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  kind?: InputMaybe<FulfillmentOrderMerchantRequestKind>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `fulfillmentOrderAcceptCancellationRequest` mutation. */
export type FulfillmentOrderAcceptCancellationRequestPayload = {
  /** The fulfillment order whose cancellation request was accepted. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `fulfillmentOrderAcceptFulfillmentRequest` mutation. */
export type FulfillmentOrderAcceptFulfillmentRequestPayload = {
  /** The fulfillment order whose fulfillment request was accepted. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The actions that can be taken on a fulfillment order. */
export enum FulfillmentOrderAction {
  /** Cancels a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderCancel`. */
  CANCEL_FULFILLMENT_ORDER = 'CANCEL_FULFILLMENT_ORDER',
  /** Creates a fulfillment for selected line items in the fulfillment order. The corresponding mutation for this action is `fulfillmentCreateV2`. */
  CREATE_FULFILLMENT = 'CREATE_FULFILLMENT',
  /** Opens an external URL to initiate the fulfillment process outside Shopify. This action should be paired with `FulfillmentOrderSupportedAction.externalUrl`. */
  EXTERNAL = 'EXTERNAL',
  /** Applies a fulfillment hold on the fulfillment order. The corresponding mutation for this action is `fulfillmentOrderHold`. */
  HOLD = 'HOLD',
  /** Marks the fulfillment order as open. The corresponding mutation for this action is `fulfillmentOrderOpen`. */
  MARK_AS_OPEN = 'MARK_AS_OPEN',
  /** Merges a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderMerge`. */
  MERGE = 'MERGE',
  /** Moves a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderMove`. */
  MOVE = 'MOVE',
  /** Releases the fulfillment hold on the fulfillment order. The corresponding mutation for this action is `fulfillmentOrderReleaseHold`. */
  RELEASE_HOLD = 'RELEASE_HOLD',
  /** Sends a cancellation request to the fulfillment service of a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderSubmitCancellationRequest`. */
  REQUEST_CANCELLATION = 'REQUEST_CANCELLATION',
  /** Sends a request for fulfilling selected line items in a fulfillment order to a fulfillment service. The corresponding mutation for this action is `fulfillmentOrderSubmitFulfillmentRequest`. */
  REQUEST_FULFILLMENT = 'REQUEST_FULFILLMENT',
  /** Splits a fulfillment order. The corresponding mutation for this action is `fulfillmentOrderSplit`. */
  SPLIT = 'SPLIT'
}

/**
 * The fulfillment order's assigned location. This is the location where the fulfillment is expected to happen.
 *
 *  The fulfillment order's assigned location might change in the following cases:
 *
 *   - The fulfillment order has been entirely moved to a new location. For example, the [fulfillmentOrderMove](
 *     https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove
 *     ) mutation has been called, and you see the original fulfillment order in the [movedFulfillmentOrder](
 *     https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove#field-fulfillmentordermovepayload-movedfulfillmentorder
 *     ) field within the mutation's response.
 *
 *   - Work on the fulfillment order has not yet begun, which means that the fulfillment order has the
 *       [OPEN](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-open),
 *       [SCHEDULED](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-scheduled), or
 *       [ON_HOLD](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-onhold)
 *       status, and the shop's location properties might be undergoing edits (for example, in the Shopify admin).
 *
 * If the [fulfillmentOrderMove](
 * https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentOrderMove
 * ) mutation has moved the fulfillment order's line items to a new location,
 * but hasn't moved the fulfillment order instance itself, then the original fulfillment order's assigned location
 * doesn't change.
 * This happens if the fulfillment order is being split during the move, or if all line items can be moved
 * to an existing fulfillment order at a new location.
 *
 * Once the fulfillment order has been taken into work or canceled,
 * which means that the fulfillment order has the
 * [IN_PROGRESS](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-inprogress),
 * [CLOSED](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-closed),
 * [CANCELLED](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-cancelled), or
 * [INCOMPLETE](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderStatus#value-incomplete)
 * status, `FulfillmentOrderAssignedLocation` acts as a snapshot of the shop's location content.
 * Up-to-date shop's location data may be queried through [location](
 *   https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderAssignedLocation#field-fulfillmentorderassignedlocation-location
 * ) connection.
 */
export type FulfillmentOrderAssignedLocation = {
  /** The first line of the address for the location. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the address for the location. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The city of the location. */
  readonly city?: Maybe<Scalars['String']>;
  /** The two-letter country code of the location. */
  readonly countryCode: CountryCode;
  /**
   * The location where the fulfillment is expected to happen. This value might be different from
   * `FulfillmentOrderAssignedLocation` if the location's attributes were updated
   * after the fulfillment order was taken into work of canceled.
   */
  readonly location?: Maybe<Location>;
  /** The name of the location. */
  readonly name: Scalars['String'];
  /** The phone number of the location. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The province of the location. */
  readonly province?: Maybe<Scalars['String']>;
  /** The ZIP code of the location. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** The assigment status to be used to filter fulfillment orders. */
export enum FulfillmentOrderAssignmentStatus {
  /**
   * Fulfillment orders for which the merchant has requested cancellation of
   * the previously accepted fulfillment request.
   */
  CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
  /**
   * Fulfillment orders for which the merchant's fulfillment request has been accepted.
   * Any number of fulfillments can be created on these fulfillment orders
   * to completely fulfill the requested items.
   */
  FULFILLMENT_ACCEPTED = 'FULFILLMENT_ACCEPTED',
  /** Fulfillment orders for which the merchant has requested fulfillment. */
  FULFILLMENT_REQUESTED = 'FULFILLMENT_REQUESTED',
  /** Fulfillment orders for which the merchant hasn't yet requested fulfillment. */
  FULFILLMENT_UNSUBMITTED = 'FULFILLMENT_UNSUBMITTED'
}

/** Return type for `fulfillmentOrderCancel` mutation. */
export type FulfillmentOrderCancelPayload = {
  /** The fulfillment order that was marked as canceled. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The fulfillment order that was created to replace the canceled fulfillment order. */
  readonly replacementFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `fulfillmentOrderClose` mutation. */
export type FulfillmentOrderClosePayload = {
  /** The fulfillment order that was marked as incomplete. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type for paginating through multiple FulfillmentOrders. */
export type FulfillmentOrderConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<FulfillmentOrderEdge>;
  /** A list of nodes that are contained in FulfillmentOrderEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<FulfillmentOrder>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Represents the destination where the items should be sent upon fulfillment. */
export type FulfillmentOrderDestination = Node & {
  /** The first line of the address of the destination. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the address of the destination. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The city of the destination. */
  readonly city?: Maybe<Scalars['String']>;
  /** The company of the destination. */
  readonly company?: Maybe<Scalars['String']>;
  /** The two-letter country code of the destination. */
  readonly countryCode?: Maybe<CountryCode>;
  /** The email of the customer at the destination. */
  readonly email?: Maybe<Scalars['String']>;
  /** The first name of the customer at the destination. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The last name of the customer at the destination. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The location designated for the pick-up of the fulfillment order. */
  readonly location?: Maybe<Location>;
  /** The phone number of the customer at the destination. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The province of the destination. */
  readonly province?: Maybe<Scalars['String']>;
  /** The ZIP code of the destination. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** An auto-generated type which holds one FulfillmentOrder and a cursor during pagination. */
export type FulfillmentOrderEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of FulfillmentOrderEdge. */
  readonly node: FulfillmentOrder;
};

/** The input fields for the fulfillment hold applied on the fulfillment order. */
export type FulfillmentOrderHoldInput = {
  /** A configurable ID used to track the automation system releasing these holds. */
  readonly externalId?: InputMaybe<Scalars['String']>;
  /**
   * The fulfillment order line items to be placed on hold.
   *
   * If left blank, all line items of the fulfillment order are placed on hold.
   */
  readonly fulfillmentOrderLineItems?: InputMaybe<ReadonlyArray<FulfillmentOrderLineItemInput>>;
  /** Whether the merchant receives a notification about the fulfillment hold. The default value is `false`. */
  readonly notifyMerchant?: InputMaybe<Scalars['Boolean']>;
  /** The reason for the fulfillment hold. */
  readonly reason: FulfillmentHoldReason;
  /** Additional information about the fulfillment hold reason. */
  readonly reasonNotes?: InputMaybe<Scalars['String']>;
};

/** Return type for `fulfillmentOrderHold` mutation. */
export type FulfillmentOrderHoldPayload = {
  /** The fulfillment hold created for the fulfillment order. Null if no hold was created. */
  readonly fulfillmentHold?: Maybe<FulfillmentHold>;
  /** The fulfillment order on which a fulfillment hold was applied. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * The remaining fulfillment order containing the line items to which the hold wasn't applied,
   * if specific line items were specified to be placed on hold.
   */
  readonly remainingFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentOrderHoldUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderHold`. */
export type FulfillmentOrderHoldUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentOrderHoldUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentOrderHoldUserError`. */
export enum FulfillmentOrderHoldUserErrorCode {
  /** The fulfillment order line items are not unique. */
  DUPLICATED_FULFILLMENT_ORDER_LINE_ITEMS = 'DUPLICATED_FULFILLMENT_ORDER_LINE_ITEMS',
  /** The handle provided for the fulfillment hold is already in use by this app for another hold on this fulfillment order. */
  DUPLICATE_FULFILLMENT_HOLD_HANDLE = 'DUPLICATE_FULFILLMENT_HOLD_HANDLE',
  /** The maximum number of fulfillment holds for this fulfillment order has been reached for this app. An app can only have up to 10 holds on a single fulfillment order at any one time. */
  FULFILLMENT_ORDER_HOLD_LIMIT_REACHED = 'FULFILLMENT_ORDER_HOLD_LIMIT_REACHED',
  /** The fulfillment order could not be found. */
  FULFILLMENT_ORDER_NOT_FOUND = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The fulfillment order is not in a splittable state. */
  FULFILLMENT_ORDER_NOT_SPLITTABLE = 'FULFILLMENT_ORDER_NOT_SPLITTABLE',
  /** The fulfillment order line item quantity must be greater than 0. */
  GREATER_THAN_ZERO = 'GREATER_THAN_ZERO',
  /** The fulfillment order line item quantity is invalid. */
  INVALID_LINE_ITEM_QUANTITY = 'INVALID_LINE_ITEM_QUANTITY',
  /** The input value is already taken. */
  TAKEN = 'TAKEN'
}

/** The international duties relevant to a fulfillment order. */
export type FulfillmentOrderInternationalDuties = {
  /** The method of duties payment. Example values: `DDP`, `DAP`. */
  readonly incoterm: Scalars['String'];
};

/** Associates an order line item with quantities requiring fulfillment from the respective fulfillment order. */
export type FulfillmentOrderLineItem = Node & {
  /** The financial summary for the Fulfillment Order's Line Items. */
  readonly financialSummaries: ReadonlyArray<FulfillmentOrderLineItemFinancialSummary>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image associated to the line item's variant. */
  readonly image?: Maybe<Image>;
  /** The ID of the inventory item. */
  readonly inventoryItemId?: Maybe<Scalars['ID']>;
  /** The associated order line item. */
  readonly lineItem: LineItem;
  /**
   * The variant unit price without discounts applied, in shop and presentment currencies.
   * @deprecated Use `financialSummaries` instead.
   */
  readonly originalUnitPriceSet: MoneyBag;
  /** The title of the product. */
  readonly productTitle: Scalars['String'];
  /** The number of units remaining to be fulfilled. */
  readonly remainingQuantity: Scalars['Int'];
  /** Whether physical shipping is required for the variant. */
  readonly requiresShipping: Scalars['Boolean'];
  /** The variant SKU number. */
  readonly sku?: Maybe<Scalars['String']>;
  /** The total number of units to be fulfilled. */
  readonly totalQuantity: Scalars['Int'];
  /** The product variant associated to the fulfillment order line item. */
  readonly variant?: Maybe<ProductVariant>;
  /** The name of the variant. */
  readonly variantTitle?: Maybe<Scalars['String']>;
  /** The name of the vendor who made the variant. */
  readonly vendor?: Maybe<Scalars['String']>;
  /** Warning messages for a fulfillment order line item. */
  readonly warnings: ReadonlyArray<FulfillmentOrderLineItemWarning>;
  /** The weight of a line item unit. */
  readonly weight?: Maybe<Weight>;
};

/** An auto-generated type for paginating through multiple FulfillmentOrderLineItems. */
export type FulfillmentOrderLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<FulfillmentOrderLineItemEdge>;
  /** A list of nodes that are contained in FulfillmentOrderLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<FulfillmentOrderLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one FulfillmentOrderLineItem and a cursor during pagination. */
export type FulfillmentOrderLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of FulfillmentOrderLineItemEdge. */
  readonly node: FulfillmentOrderLineItem;
};

/** The financial details of a fulfillment order line item. */
export type FulfillmentOrderLineItemFinancialSummary = {
  /** The approximate split price of a line item unit, in shop and presentment currencies. This value doesn't include discounts applied to the entire order.For the full picture of applied discounts, see discountAllocations. */
  readonly approximateDiscountedUnitPriceSet: MoneyBag;
  /** The discounts that have been allocated onto the line item by discount applications, not including order edits and refunds. */
  readonly discountAllocations: ReadonlyArray<FinancialSummaryDiscountAllocation>;
  /** The variant unit price without discounts applied, in shop and presentment currencies. */
  readonly originalUnitPriceSet: MoneyBag;
  /** Number of line items that this financial summary applies to. */
  readonly quantity: Scalars['Int'];
};

/** The input fields used to include the quantity of the fulfillment order line item that should be fulfilled. */
export type FulfillmentOrderLineItemInput = {
  /** The ID of the fulfillment order line item. */
  readonly id: Scalars['ID'];
  /** The quantity of the fulfillment order line item. */
  readonly quantity: Scalars['Int'];
};

/** A fulfillment order line item warning. For example, a warning about why a fulfillment request was rejected. */
export type FulfillmentOrderLineItemWarning = {
  /** The description of warning. */
  readonly description?: Maybe<Scalars['String']>;
  /** The title of warning. */
  readonly title?: Maybe<Scalars['String']>;
};

/** The input fields used to include the line items of a specified fulfillment order that should be fulfilled. */
export type FulfillmentOrderLineItemsInput = {
  /** The ID of the fulfillment order. */
  readonly fulfillmentOrderId: Scalars['ID'];
  /**
   * The fulfillment order line items to be fulfilled.
   * If left blank, all line items of the fulfillment order will be fulfilled.
   */
  readonly fulfillmentOrderLineItems?: InputMaybe<ReadonlyArray<FulfillmentOrderLineItemInput>>;
};

/** The input fields for marking fulfillment order line items as ready for pickup. */
export type FulfillmentOrderLineItemsPreparedForPickupInput = {
  /** The fulfillment orders associated with the line items which are ready to be picked up by a customer. */
  readonly lineItemsByFulfillmentOrder: ReadonlyArray<PreparedFulfillmentOrderLineItemsInput>;
};

/** Return type for `fulfillmentOrderLineItemsPreparedForPickup` mutation. */
export type FulfillmentOrderLineItemsPreparedForPickupPayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentOrderLineItemsPreparedForPickupUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderLineItemsPreparedForPickup`. */
export type FulfillmentOrderLineItemsPreparedForPickupUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentOrderLineItemsPreparedForPickupUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentOrderLineItemsPreparedForPickupUserError`. */
export enum FulfillmentOrderLineItemsPreparedForPickupUserErrorCode {
  /** Invalid fulfillment order ID provided. */
  FULFILLMENT_ORDER_INVALID = 'FULFILLMENT_ORDER_INVALID',
  /** The fulfillment order does not have any line items that can be prepared. */
  NO_LINE_ITEMS_TO_PREPARE_FOR_FULFILLMENT_ORDER = 'NO_LINE_ITEMS_TO_PREPARE_FOR_FULFILLMENT_ORDER',
  /** Unable to prepare quantity. */
  UNABLE_TO_PREPARE_QUANTITY = 'UNABLE_TO_PREPARE_QUANTITY'
}

/** A location that a fulfillment order can potentially move to. */
export type FulfillmentOrderLocationForMove = {
  /** Fulfillment order line items that can be moved from their current location to the given location. */
  readonly availableLineItems: FulfillmentOrderLineItemConnection;
  /**
   * Total number of fulfillment order line items that can be moved from their current assigned location to the
   * given location.
   */
  readonly availableLineItemsCount?: Maybe<Count>;
  /** The location being considered as the fulfillment order's new assigned location. */
  readonly location: Location;
  /**
   * A human-readable string with the reason why the fulfillment order, or some of its line items, can't be
   * moved to the location.
   */
  readonly message?: Maybe<Scalars['String']>;
  /** Whether the fulfillment order can be moved to the location. */
  readonly movable: Scalars['Boolean'];
  /** Fulfillment order line items that cannot be moved from their current location to the given location. */
  readonly unavailableLineItems: FulfillmentOrderLineItemConnection;
  /**
   * Total number of fulfillment order line items that can't be moved from their current assigned location to the
   * given location.
   */
  readonly unavailableLineItemsCount?: Maybe<Count>;
};


/** A location that a fulfillment order can potentially move to. */
export type FulfillmentOrderLocationForMoveAvailableLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A location that a fulfillment order can potentially move to. */
export type FulfillmentOrderLocationForMoveUnavailableLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple FulfillmentOrderLocationForMoves. */
export type FulfillmentOrderLocationForMoveConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<FulfillmentOrderLocationForMoveEdge>;
  /** A list of nodes that are contained in FulfillmentOrderLocationForMoveEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<FulfillmentOrderLocationForMove>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one FulfillmentOrderLocationForMove and a cursor during pagination. */
export type FulfillmentOrderLocationForMoveEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of FulfillmentOrderLocationForMoveEdge. */
  readonly node: FulfillmentOrderLocationForMove;
};

/**
 * A request made by the merchant or an order management app to a fulfillment service
 * for a fulfillment order.
 */
export type FulfillmentOrderMerchantRequest = Node & {
  /** The fulfillment order associated with the merchant request. */
  readonly fulfillmentOrder: FulfillmentOrder;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The kind of request made. */
  readonly kind: FulfillmentOrderMerchantRequestKind;
  /** The optional message that the merchant included in the request. */
  readonly message?: Maybe<Scalars['String']>;
  /**
   * Additional options requested by the merchant. These depend on the `kind` of the request.
   * For example, for a `FULFILLMENT_REQUEST`, one option is `notify_customer`, which indicates whether the
   * merchant intends to notify the customer upon fulfillment. The fulfillment service can then set
   * `notifyCustomer` when making calls to `FulfillmentCreate`.
   */
  readonly requestOptions?: Maybe<Scalars['JSON']>;
  /** The response from the fulfillment service. */
  readonly responseData?: Maybe<Scalars['JSON']>;
  /** The timestamp when the request was made. */
  readonly sentAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple FulfillmentOrderMerchantRequests. */
export type FulfillmentOrderMerchantRequestConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<FulfillmentOrderMerchantRequestEdge>;
  /** A list of nodes that are contained in FulfillmentOrderMerchantRequestEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<FulfillmentOrderMerchantRequest>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one FulfillmentOrderMerchantRequest and a cursor during pagination. */
export type FulfillmentOrderMerchantRequestEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of FulfillmentOrderMerchantRequestEdge. */
  readonly node: FulfillmentOrderMerchantRequest;
};

/** The kinds of request merchants can make to a fulfillment service. */
export enum FulfillmentOrderMerchantRequestKind {
  /** The merchant requests cancellation of an `IN_PROGRESS` fulfillment order. */
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  /** The merchant requests fulfillment for an `OPEN` fulfillment order. */
  FULFILLMENT_REQUEST = 'FULFILLMENT_REQUEST'
}

/** The input fields for merging fulfillment orders. */
export type FulfillmentOrderMergeInput = {
  /** The details of the fulfillment orders to be merged. */
  readonly mergeIntents: ReadonlyArray<FulfillmentOrderMergeInputMergeIntent>;
};

/** The input fields for merging fulfillment orders into a single merged fulfillment order. */
export type FulfillmentOrderMergeInputMergeIntent = {
  /** The ID of the fulfillment order to be merged. */
  readonly fulfillmentOrderId: Scalars['ID'];
  /** The fulfillment order line items to be merged. */
  readonly fulfillmentOrderLineItems?: InputMaybe<ReadonlyArray<FulfillmentOrderLineItemInput>>;
};

/** Return type for `fulfillmentOrderMerge` mutation. */
export type FulfillmentOrderMergePayload = {
  /** The result of the fulfillment order merges. */
  readonly fulfillmentOrderMerges?: Maybe<ReadonlyArray<FulfillmentOrderMergeResult>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentOrderMergeUserError>;
};

/** The result of merging a set of fulfillment orders. */
export type FulfillmentOrderMergeResult = {
  /** The new fulfillment order as a result of the merge. */
  readonly fulfillmentOrder: FulfillmentOrder;
};

/** An error that occurs during the execution of `FulfillmentOrderMerge`. */
export type FulfillmentOrderMergeUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentOrderMergeUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentOrderMergeUserError`. */
export enum FulfillmentOrderMergeUserErrorCode {
  /** The fulfillment order could not be found. */
  FULFILLMENT_ORDER_NOT_FOUND = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The fulfillment order line item quantity must be greater than 0. */
  GREATER_THAN = 'GREATER_THAN',
  /** The fulfillment order line item quantity is invalid. */
  INVALID_LINE_ITEM_QUANTITY = 'INVALID_LINE_ITEM_QUANTITY'
}

/** Return type for `fulfillmentOrderMove` mutation. */
export type FulfillmentOrderMovePayload = {
  /**
   * The fulfillment order which now contains the moved line items and is assigned to the destination location.
   *
   * If the original fulfillment order doesn't have any line items which are fully or partially fulfilled, the original fulfillment order will be moved to the new location.
   * However if this isn't the case, the moved fulfillment order will differ from the original one.
   */
  readonly movedFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * The final state of the original fulfillment order.
   *
   * As a result of the move operation, the original fulfillment order might be moved to the new location
   * or remain in the original location. The original fulfillment order might have the same status or be closed.
   */
  readonly originalFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** This field is deprecated. */
  readonly remainingFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `fulfillmentOrderOpen` mutation. */
export type FulfillmentOrderOpenPayload = {
  /** The fulfillment order that was transitioned to open and is fulfillable. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `fulfillmentOrderRejectCancellationRequest` mutation. */
export type FulfillmentOrderRejectCancellationRequestPayload = {
  /** The fulfillment order whose cancellation request was rejected. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `fulfillmentOrderRejectFulfillmentRequest` mutation. */
export type FulfillmentOrderRejectFulfillmentRequestPayload = {
  /** The fulfillment order whose fulfillment request was rejected. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The reason for a fulfillment order rejection. */
export enum FulfillmentOrderRejectionReason {
  /** The fulfillment order was rejected because of an incorrect address. */
  INCORRECT_ADDRESS = 'INCORRECT_ADDRESS',
  /** The fulfillment order was rejected because of an ineligible product. */
  INELIGIBLE_PRODUCT = 'INELIGIBLE_PRODUCT',
  /** The fulfillment order was rejected because inventory is out of stock. */
  INVENTORY_OUT_OF_STOCK = 'INVENTORY_OUT_OF_STOCK',
  /** The fulfillment order was rejected for another reason. */
  OTHER = 'OTHER',
  /** The fulfillment order was rejected because of an undeliverable destination. */
  UNDELIVERABLE_DESTINATION = 'UNDELIVERABLE_DESTINATION'
}

/** Return type for `fulfillmentOrderReleaseHold` mutation. */
export type FulfillmentOrderReleaseHoldPayload = {
  /** The fulfillment order on which the hold was released. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentOrderReleaseHoldUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderReleaseHold`. */
export type FulfillmentOrderReleaseHoldUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentOrderReleaseHoldUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentOrderReleaseHoldUserError`. */
export enum FulfillmentOrderReleaseHoldUserErrorCode {
  /** The fulfillment order wasn't found. */
  FULFILLMENT_ORDER_NOT_FOUND = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The app doesn't have access to release the fulfillment hold. */
  INVALID_ACCESS = 'INVALID_ACCESS'
}

/** The request status of a fulfillment order. */
export enum FulfillmentOrderRequestStatus {
  /** The fulfillment service accepted the merchant's fulfillment request. */
  ACCEPTED = 'ACCEPTED',
  /** The fulfillment service accepted the merchant's fulfillment cancellation request. */
  CANCELLATION_ACCEPTED = 'CANCELLATION_ACCEPTED',
  /** The fulfillment service rejected the merchant's fulfillment cancellation request. */
  CANCELLATION_REJECTED = 'CANCELLATION_REJECTED',
  /** The merchant requested a cancellation of the fulfillment request for this fulfillment order. */
  CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
  /** The fulfillment service closed the fulfillment order without completing it. */
  CLOSED = 'CLOSED',
  /** The fulfillment service rejected the merchant's fulfillment request. */
  REJECTED = 'REJECTED',
  /** The merchant requested fulfillment for this fulfillment order. */
  SUBMITTED = 'SUBMITTED',
  /**
   * The initial request status for the newly-created fulfillment orders. This is the only valid
   * request status for fulfillment orders that aren't assigned to a fulfillment service.
   */
  UNSUBMITTED = 'UNSUBMITTED'
}

/** Return type for `fulfillmentOrderReschedule` mutation. */
export type FulfillmentOrderReschedulePayload = {
  /**
   * A fulfillment order with the rescheduled line items.
   *
   * Fulfillment orders may be merged if they have the same `fulfillAt` datetime.
   *
   * If the fulfillment order is merged then the resulting fulfillment order will be returned.
   * Otherwise the original fulfillment order will be returned with an updated `fulfillAt` datetime.
   */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentOrderRescheduleUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrderReschedule`. */
export type FulfillmentOrderRescheduleUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentOrderRescheduleUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentOrderRescheduleUserError`. */
export enum FulfillmentOrderRescheduleUserErrorCode {
  /** Fulfillment order could not be found. */
  FULFILLMENT_ORDER_NOT_FOUND = 'FULFILLMENT_ORDER_NOT_FOUND'
}

/** The set of valid sort keys for the FulfillmentOrder query. */
export enum FulfillmentOrderSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** The input fields for the split applied to the fulfillment order. */
export type FulfillmentOrderSplitInput = {
  /** The ID of the fulfillment order to be split. */
  readonly fulfillmentOrderId: Scalars['ID'];
  /** The fulfillment order line items to be split out. */
  readonly fulfillmentOrderLineItems: ReadonlyArray<FulfillmentOrderLineItemInput>;
};

/** Return type for `fulfillmentOrderSplit` mutation. */
export type FulfillmentOrderSplitPayload = {
  /** The result of the fulfillment order splits. */
  readonly fulfillmentOrderSplits?: Maybe<ReadonlyArray<FulfillmentOrderSplitResult>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentOrderSplitUserError>;
};

/** The result of splitting a fulfillment order. */
export type FulfillmentOrderSplitResult = {
  /** The original fulfillment order as a result of the split. */
  readonly fulfillmentOrder: FulfillmentOrder;
  /** The remaining fulfillment order as a result of the split. */
  readonly remainingFulfillmentOrder: FulfillmentOrder;
  /** The replacement fulfillment order if the original fulfillment order wasn't in a state to be split. */
  readonly replacementFulfillmentOrder?: Maybe<FulfillmentOrder>;
};

/** An error that occurs during the execution of `FulfillmentOrderSplit`. */
export type FulfillmentOrderSplitUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentOrderSplitUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentOrderSplitUserError`. */
export enum FulfillmentOrderSplitUserErrorCode {
  /** The fulfillment order could not be found. */
  FULFILLMENT_ORDER_NOT_FOUND = 'FULFILLMENT_ORDER_NOT_FOUND',
  /** The fulfillment order line item quantity must be greater than 0. */
  GREATER_THAN = 'GREATER_THAN',
  /** The fulfillment order line item quantity is invalid. */
  INVALID_LINE_ITEM_QUANTITY = 'INVALID_LINE_ITEM_QUANTITY',
  /** The fulfillment order must have at least one line item input to split. */
  NO_LINE_ITEMS_PROVIDED_TO_SPLIT = 'NO_LINE_ITEMS_PROVIDED_TO_SPLIT'
}

/** The status of a fulfillment order. */
export enum FulfillmentOrderStatus {
  /** The fulfillment order has been cancelled by the merchant. */
  CANCELLED = 'CANCELLED',
  /** The fulfillment order has been completed and closed. */
  CLOSED = 'CLOSED',
  /** The fulfillment order cannot be completed as requested. */
  INCOMPLETE = 'INCOMPLETE',
  /** The fulfillment order is being processed. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The fulfillment order is on hold. The fulfillment process can't be initiated until the hold on the fulfillment order is released. */
  ON_HOLD = 'ON_HOLD',
  /** The fulfillment order is ready for fulfillment. */
  OPEN = 'OPEN',
  /** The fulfillment order is deferred and will be ready for fulfillment after the date and time specified in `fulfill_at`. */
  SCHEDULED = 'SCHEDULED'
}

/** Return type for `fulfillmentOrderSubmitCancellationRequest` mutation. */
export type FulfillmentOrderSubmitCancellationRequestPayload = {
  /** The fulfillment order specified in the cancelation request. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `fulfillmentOrderSubmitFulfillmentRequest` mutation. */
export type FulfillmentOrderSubmitFulfillmentRequestPayload = {
  /** The original fulfillment order intended to request fulfillment for. */
  readonly originalFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * The fulfillment order that was submitted to the fulfillment service. This will be the same as
   * the original fulfillment order field. The exception to this is partial fulfillment requests or
   * fulfillment request for cancelled or incomplete fulfillment orders.
   */
  readonly submittedFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * This field will only be present for partial fulfillment requests. This will represent the new
   * fulfillment order with the remaining line items not submitted to the fulfillment service.
   */
  readonly unsubmittedFulfillmentOrder?: Maybe<FulfillmentOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** One of the actions that the fulfillment order supports in its current state. */
export type FulfillmentOrderSupportedAction = {
  /** The action value. */
  readonly action: FulfillmentOrderAction;
  /**
   * The external URL to be used to initiate the fulfillment process outside Shopify.
   * Applicable only when the `action` value is `EXTERNAL`.
   */
  readonly externalUrl?: Maybe<Scalars['URL']>;
};

/** Return type for `fulfillmentOrdersSetFulfillmentDeadline` mutation. */
export type FulfillmentOrdersSetFulfillmentDeadlinePayload = {
  /** Whether the fulfillment deadline was successfully set. */
  readonly success?: Maybe<Scalars['Boolean']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<FulfillmentOrdersSetFulfillmentDeadlineUserError>;
};

/** An error that occurs during the execution of `FulfillmentOrdersSetFulfillmentDeadline`. */
export type FulfillmentOrdersSetFulfillmentDeadlineUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<FulfillmentOrdersSetFulfillmentDeadlineUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `FulfillmentOrdersSetFulfillmentDeadlineUserError`. */
export enum FulfillmentOrdersSetFulfillmentDeadlineUserErrorCode {
  /** The fulfillment orders could not be found. */
  FULFILLMENT_ORDERS_NOT_FOUND = 'FULFILLMENT_ORDERS_NOT_FOUND'
}

/** The address at which the fulfillment occurred. This object is intended for tax purposes, as a full address is required for tax providers to accurately calculate taxes. Typically this is the address of the warehouse or fulfillment center. To retrieve a fulfillment location's address, use the `assignedLocation` field on the [`FulfillmentOrder`](/docs/api/admin-graphql/latest/objects/FulfillmentOrder) object instead. */
export type FulfillmentOriginAddress = {
  /** The street address of the fulfillment location. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The city in which the fulfillment location is located. */
  readonly city?: Maybe<Scalars['String']>;
  /** The country code of the fulfillment location. */
  readonly countryCode: Scalars['String'];
  /** The province code of the fulfillment location. */
  readonly provinceCode?: Maybe<Scalars['String']>;
  /** The zip code of the fulfillment location. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** The input fields used to include the address at which the fulfillment occurred. This input object is intended for tax purposes, as a full address is required for tax providers to accurately calculate taxes. Typically this is the address of the warehouse or fulfillment center. To retrieve a fulfillment location's address, use the `assignedLocation` field on the [`FulfillmentOrder`](/docs/api/admin-graphql/latest/objects/FulfillmentOrder) object instead. */
export type FulfillmentOriginAddressInput = {
  /** The street address of the fulfillment location. */
  readonly address1?: InputMaybe<Scalars['String']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: InputMaybe<Scalars['String']>;
  /** The city in which the fulfillment location is located. */
  readonly city?: InputMaybe<Scalars['String']>;
  /** The country of the fulfillment location. */
  readonly countryCode: Scalars['String'];
  /** The province of the fulfillment location. */
  readonly provinceCode?: InputMaybe<Scalars['String']>;
  /** The zip code of the fulfillment location. */
  readonly zip?: InputMaybe<Scalars['String']>;
};

/**
 * A **Fulfillment Service** is a third party warehouse that prepares and ships orders
 * on behalf of the store owner. Fulfillment services charge a fee to package and ship items
 * and update product inventory levels. Some well known fulfillment services with Shopify integrations
 * include: Amazon, Shipwire, and Rakuten. When an app registers a new `FulfillmentService` on a store,
 * Shopify automatically creates a `Location` that's associated to the fulfillment service.
 * To learn more about fulfillment services, refer to
 * [Manage fulfillments as a fulfillment service app](https://shopify.dev/apps/fulfillment/fulfillment-service-apps)
 * guide.
 *
 * ## Mutations
 *
 * You can work with the `FulfillmentService` object with the
 * [fulfillmentServiceCreate](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentServiceCreate),
 * [fulfillmentServiceUpdate](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentServiceUpdate),
 * and [fulfillmentServiceDelete](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentServiceDelete)
 * mutations.
 *
 * ## Hosted endpoints
 *
 * Fulfillment service providers integrate with Shopify by providing Shopify with a set of hosted endpoints that
 * Shopify can query on certain conditions.
 * These endpoints must have a common prefix, and this prefix should be supplied in the `callbackUrl` parameter
 * in the
 * [fulfillmentServiceCreate](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentServiceCreate)
 * mutation.
 *
 * - Shopify sends POST requests to the `<callbackUrl>/fulfillment_order_notification` endpoint
 *   to notify the fulfillment service about fulfillment requests and fulfillment cancellation requests.
 *
 *   For more information, refer to
 *   [Receive fulfillment requests and cancellations](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#step-2-receive-fulfillment-requests-and-cancellations).
 * - Shopify sends GET requests to the `<callbackUrl>/fetch_tracking_numbers` endpoint to retrieve tracking numbers for orders
 *   if `trackingSupport` is set to `true`.
 *
 *   For more information, refer to
 *   [Enable tracking support](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#step-8-enable-tracking-support-optional).
 *
 *   Fulfillment services can also update tracking information using the
 *   [fulfillmentTrackingInfoUpdate](https://shopify.dev/api/admin-graphql/latest/mutations/fulfillmentTrackingInfoUpdate) mutation,
 *   rather than waiting for Shopify to ask for tracking numbers.
 * - Shopify sends GET requests to the `<callbackUrl>/fetch_stock` endpoint to retrieve
 *   on hand inventory levels for the fulfillment service location if `inventoryManagement` is set to `true`.
 *
 *   For more information, refer to
 *   [Sharing inventory levels with Shopify](https://shopify.dev/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-10-optional-share-inventory-levels-with-shopify).
 *
 * To make sure you have everything set up correctly, you can test the `callbackUrl`-prefixed endpoints
 * in your development store.
 *
 * ## Resources and webhooks
 *
 * There are a variety of objects and webhooks that enable a fulfillment service to work.
 * To exchange fulfillment information with Shopify, fulfillment services use the
 * [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder),
 * [Fulfillment](https://shopify.dev/api/admin-graphql/latest/objects/Fulfillment) and
 * [Order](https://shopify.dev/api/admin-graphql/latest/objects/Order) objects and related mutations.
 * To act on fulfillment process events that happen on the Shopify side,
 * besides awaiting calls to `callbackUrl`-prefixed endpoints,
 * fulfillment services can subscribe to the
 * [fulfillment order](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments#webhooks)
 * and [order](https://shopify.dev/api/admin-rest/latest/resources/webhook)
 * webhooks.
 */
export type FulfillmentService = {
  /**
   * The callback URL that the fulfillment service has registered for requests. The following considerations apply:
   *
   * - Shopify queries the `<callbackUrl>/fetch_tracking_numbers` endpoint to retrieve tracking numbers
   *     for orders, if `trackingSupport` is set to `true`.
   * - Shopify queries the `<callbackUrl>/fetch_stock` endpoint to retrieve inventory levels,
   *     if `inventoryManagement` is set to `true`.
   * - Shopify uses the `<callbackUrl>/fulfillment_order_notification` endpoint to send
   *     [fulfillment and cancellation requests](https://shopify.dev/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-9-optional-enable-tracking-support).
   */
  readonly callbackUrl?: Maybe<Scalars['URL']>;
  /**
   * Whether the fulfillment service uses the [fulfillment order based workflow](https://shopify.dev/apps/fulfillment/fulfillment-service-apps/manage-fulfillments) for managing fulfillments.
   *
   * As the migration is now finished, the `fulfillmentOrdersOptIn` property is [deprecated](
   * https://shopify.dev/changelog/deprecation-of-the-fulfillmentservice-fulfillmentordersoptin-field)
   * and is always set to `true` on correctly functioning fulfillment services.
   * @deprecated Migration period ended. All correctly functioning fulfillment services have `fulfillmentOrdersOptIn` set to `true`.
   */
  readonly fulfillmentOrdersOptIn: Scalars['Boolean'];
  /** Human-readable unique identifier for this fulfillment service. */
  readonly handle: Scalars['String'];
  /** The ID of the fulfillment service. */
  readonly id: Scalars['ID'];
  /** Whether the fulfillment service tracks product inventory and provides updates to Shopify. */
  readonly inventoryManagement: Scalars['Boolean'];
  /** Location associated with the fulfillment service. */
  readonly location?: Maybe<Location>;
  /** Whether the fulfillment service can stock inventory alongside other locations. */
  readonly permitsSkuSharing: Scalars['Boolean'];
  /** The name of the fulfillment service as seen by merchants. */
  readonly serviceName: Scalars['String'];
  /** Whether the fulfillment service implemented the /fetch_tracking_numbers endpoint. */
  readonly trackingSupport: Scalars['Boolean'];
  /** Type associated with the fulfillment service. */
  readonly type: FulfillmentServiceType;
};

/** Return type for `fulfillmentServiceCreate` mutation. */
export type FulfillmentServiceCreatePayload = {
  /** The created fulfillment service. */
  readonly fulfillmentService?: Maybe<FulfillmentService>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Actions that can be taken at the location when a client requests the deletion of the fulfillment service. */
export enum FulfillmentServiceDeleteInventoryAction {
  /** Deactivate and delete the inventory and location. */
  DELETE = 'DELETE',
  /** Keep the inventory in place and convert the Fulfillment Service's location to be merchant managed. */
  KEEP = 'KEEP',
  /** Transfer the inventory and other dependencies to the provided location. */
  TRANSFER = 'TRANSFER'
}

/** Return type for `fulfillmentServiceDelete` mutation. */
export type FulfillmentServiceDeletePayload = {
  /** The ID of the deleted fulfillment service. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The type of a fulfillment service. */
export enum FulfillmentServiceType {
  /** Fulfillment by gift card. */
  GIFT_CARD = 'GIFT_CARD',
  /** Manual fulfillment by the merchant. */
  MANUAL = 'MANUAL',
  /** Fullfillment by a third-party fulfillment service. */
  THIRD_PARTY = 'THIRD_PARTY'
}

/** Return type for `fulfillmentServiceUpdate` mutation. */
export type FulfillmentServiceUpdatePayload = {
  /** The updated fulfillment service. */
  readonly fulfillmentService?: Maybe<FulfillmentService>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The status of a fulfillment. */
export enum FulfillmentStatus {
  /** The fulfillment was canceled. */
  CANCELLED = 'CANCELLED',
  /** There was an error with the fulfillment request. */
  ERROR = 'ERROR',
  /** The fulfillment request failed. */
  FAILURE = 'FAILURE',
  /** The third-party fulfillment service has acknowledged the fulfillment and is processing it. */
  OPEN = 'OPEN',
  /** Shopify has created the fulfillment and is waiting for the third-party fulfillment service to transition it to `open` or `success`. */
  PENDING = 'PENDING',
  /** The fulfillment was completed successfully. */
  SUCCESS = 'SUCCESS'
}

/** Represents the tracking information for a fulfillment. */
export type FulfillmentTrackingInfo = {
  /**
   * The name of the tracking company.
   *
   * For tracking company names from the list below
   * Shopify will automatically build tracking URLs for all provided tracking numbers,
   * which will make the tracking numbers clickable in the interface.
   *
   * Additionally, for the tracking companies listed on the
   * [Shipping Carriers help page](https://help.shopify.com/manual/shipping/understanding-shipping/shipping-carriers#integrated-shipping-carriers)
   * Shopify will automatically update the fulfillment's `shipment_status` field during the fulfillment process.
   *
   * ### Supported tracking companies
   *
   * The following tracking companies display for shops located in any country:
   *
   *   * 4PX
   *   * AGS
   *   * Amazon
   *   * Amazon Logistics UK
   *   * An Post
   *   * Anjun Logistics
   *   * APC
   *   * Asendia USA
   *   * Australia Post
   *   * Bonshaw
   *   * BPost
   *   * BPost International
   *   * Canada Post
   *   * Canpar
   *   * CDL Last Mile
   *   * China Post
   *   * Chronopost
   *   * Chukou1
   *   * Colissimo
   *   * Comingle
   *   * Coordinadora
   *   * Correios
   *   * Correos
   *   * CTT
   *   * CTT Express
   *   * Cyprus Post
   *   * Delnext
   *   * Deutsche Post
   *   * DHL eCommerce
   *   * DHL eCommerce Asia
   *   * DHL Express
   *   * DPD
   *   * DPD Local
   *   * DPD UK
   *   * DTD Express
   *   * DX
   *   * Eagle
   *   * Estes
   *   * Evri
   *   * FedEx
   *   * First Global Logistics
   *   * First Line
   *   * FSC
   *   * Fulfilla
   *   * GLS
   *   * Guangdong Weisuyi Information Technology (WSE)
   *   * Heppner Internationale Spedition GmbH & Co.
   *   * Iceland Post
   *   * IDEX
   *   * Israel Post
   *   * Japan Post (EN)
   *   * Japan Post (JA)
   *   * La Poste
   *   * Lasership
   *   * Latvia Post
   *   * Lietuvos Paštas
   *   * Logisters
   *   * Lone Star Overnight
   *   * M3 Logistics
   *   * Meteor Space
   *   * Mondial Relay
   *   * New Zealand Post
   *   * NinjaVan
   *   * North Russia Supply Chain (Shenzhen) Co.
   *   * OnTrac
   *   * Packeta
   *   * Pago Logistics
   *   * Ping An Da Tengfei Express
   *   * Pitney Bowes
   *   * Portal PostNord
   *   * Poste Italiane
   *   * PostNL
   *   * PostNord DK
   *   * PostNord NO
   *   * PostNord SE
   *   * Purolator
   *   * Qxpress
   *   * Qyun Express
   *   * Royal Mail
   *   * Royal Shipments
   *   * Sagawa (EN)
   *   * Sagawa (JA)
   *   * Sendle
   *   * SF Express
   *   * SFC Fulfillment
   *   * SHREE NANDAN COURIER
   *   * Singapore Post
   *   * Southwest Air Cargo
   *   * StarTrack
   *   * Step Forward Freight
   *   * Swiss Post
   *   * TForce Final Mile
   *   * Tinghao
   *   * TNT
   *   * Toll IPEC
   *   * United Delivery Service
   *   * UPS
   *   * USPS
   *   * Venipak
   *   * We Post
   *   * Whistl
   *   * Wizmo
   *   * WMYC
   *   * Xpedigo
   *   * XPO Logistics
   *   * Yamato (EN)
   *   * Yamato (JA)
   *   * YiFan Express
   *   * YunExpress
   *
   * The following tracking companies are displayed for shops located in specific countries:
   *
   *   * **Australia**: Australia Post, Sendle, Aramex Australia, TNT Australia, Hunter Express, Couriers Please, Bonds, Allied Express, Direct Couriers, Northline, GO Logistics
   *   * **Austria**: Österreichische Post
   *   * **Bulgaria**: Speedy
   *   * **Canada**: Intelcom, BoxKnight, Loomis, GLS
   *   * **China**: China Post, DHL eCommerce Asia, WanbExpress, YunExpress, Anjun Logistics, SFC Fulfillment, FSC
   *   * **Czechia**: Zásilkovna
   *   * **Germany**: Deutsche Post (DE), Deutsche Post (EN), DHL, DHL Express, Swiship, Hermes, GLS
   *   * **Spain**: SEUR
   *   * **France**: Colissimo, Mondial Relay, Colis Privé, GLS
   *   * **United Kingdom**: Evri, DPD UK, Parcelforce, Yodel, DHL Parcel, Tuffnells
   *   * **Greece**: ACS Courier
   *   * **Hong Kong SAR**: SF Express
   *   * **Ireland**: Fastway, DPD Ireland
   *   * **India**: DTDC, India Post, Delhivery, Gati KWE, Professional Couriers, XpressBees, Ecom Express, Ekart, Shadowfax, Bluedart
   *   * **Italy**: BRT, GLS Italy
   *   * **Japan**: エコ配, 西濃運輸, 西濃スーパーエキスプレス, 福山通運, 日本通運, 名鉄運輸, 第一貨物
   *   * **Netherlands**: DHL Parcel, DPD
   *   * **Norway**: Bring
   *   * **Poland**: Inpost
   *   * **Turkey**: PTT, Yurtiçi Kargo, Aras Kargo, Sürat Kargo
   *   * **United States**: GLS, Alliance Air Freight, Pilot Freight, LSO, Old Dominion, Pandion, R+L Carriers, Southwest Air Cargo
   *   * **South Africa**: Fastway, Skynet.
   */
  readonly company?: Maybe<Scalars['String']>;
  /**
   * The tracking number of the fulfillment.
   *
   * The tracking number is clickable in the interface if one of the following applies
   * (the highest in the list has the highest priority):
   *
   * * Tracking url provided in the `url` field.
   * * [Shopify-known tracking company name](#supported-tracking-companies) specified in the `company` field.
   *   Shopify will build the tracking URL automatically based on the tracking number specified.
   * * The tracking number has a Shopify-known format.
   *   Shopify will guess the tracking provider and build the tracking url based on the tracking number format.
   *   Not all tracking carriers are supported, and multiple tracking carriers may use similarly formatted tracking numbers.
   *   This can result in an invalid tracking URL.
   *   It is highly recommended that you send the tracking company and the tracking URL.
   */
  readonly number?: Maybe<Scalars['String']>;
  /**
   * The URLs to track the fulfillment.
   *
   * The tracking URL is displayed in the merchant's admin on the order page.
   * The tracking URL is displayed in the shipping confirmation email, which can optionally be sent to the customer.
   * When accounts are enabled, it's also displayed in the customer's order history.
   */
  readonly url?: Maybe<Scalars['URL']>;
};

/** Return type for `fulfillmentTrackingInfoUpdate` mutation. */
export type FulfillmentTrackingInfoUpdatePayload = {
  /** The updated fulfillment with tracking information. */
  readonly fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `fulfillmentTrackingInfoUpdateV2` mutation. */
export type FulfillmentTrackingInfoUpdateV2Payload = {
  /** The updated fulfillment with tracking information. */
  readonly fulfillment?: Maybe<Fulfillment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/**
 * The input fields that specify all possible fields for tracking information.
 *
 * > Note:
 * > If you provide the `url` field, you should not provide the `urls` field.
 * >
 * > If you provide the `number` field, you should not provide the `numbers` field.
 * >
 * > If you provide the `url` field, you should provide the `number` field.
 * >
 * > If you provide the `urls` field, you should provide the `numbers` field.
 */
export type FulfillmentTrackingInput = {
  /**
   * The name of the tracking company.
   *
   * If you specify a tracking company name from
   * [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies),
   * Shopify will automatically build tracking URLs for all provided tracking numbers,
   * which will make the tracking numbers clickable in the interface.
   * The same tracking company will be applied to all tracking numbers specified.
   *
   * Additionally, for the tracking companies listed on the
   * [Shipping Carriers help page](https://help.shopify.com/manual/shipping/understanding-shipping/shipping-carriers#integrated-shipping-carriers)
   * Shopify will automatically update the fulfillment's `shipment_status` field during the fulfillment process.
   *
   * > Note:
   * > Send the tracking company name exactly as written in
   * > [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   * > (capitalization matters).
   */
  readonly company?: InputMaybe<Scalars['String']>;
  /**
   * The tracking number of the fulfillment.
   *
   * The tracking number will be clickable in the interface if one of the following applies
   * (the highest in the list has the highest priority):
   *
   * * Tracking url provided in the `url` field.
   * * [Shopify-known tracking company name](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   *   specified in the `company` field.
   *   Shopify will build the tracking URL automatically based on the tracking number specified.
   * * The tracking number has a Shopify-known format.
   *   Shopify will guess the tracking provider and build the tracking url based on the tracking number format.
   *   Not all tracking carriers are supported, and multiple tracking carriers may use similarly formatted tracking numbers.
   *   This can result in an invalid tracking URL.
   *   It is highly recommended that you send the tracking company and the tracking URL.
   */
  readonly number?: InputMaybe<Scalars['String']>;
  /**
   * The tracking numbers of the fulfillment, one or many.
   *
   * With multiple tracking numbers, you can provide tracking information
   * for all shipments associated with the fulfillment, if there are more than one.
   * For example, if you're shipping assembly parts of one furniture item in several boxes.
   *
   * Tracking numbers will be clickable in the interface if one of the following applies
   * (the highest in the list has the highest priority):
   *
   * * Tracking URLs provided in the `urls` field.
   *   The tracking URLs will be matched to the tracking numbers based on their positions in the arrays.
   * * [Shopify-known tracking company name](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   *   specified in the `company` field.
   *   Shopify will build tracking URLs automatically for all tracking numbers specified.
   *   The same tracking company will be applied to all tracking numbers.
   * * Tracking numbers have a Shopify-known format.
   *   Shopify will guess tracking providers and build tracking URLs based on the tracking number formats.
   *   Not all tracking carriers are supported, and multiple tracking carriers may use similarly formatted tracking numbers.
   *   This can result in an invalid tracking URL.
   *   It is highly recommended that you send the tracking company and the tracking URLs.
   */
  readonly numbers?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /**
   * The URL to track the fulfillment.
   *
   * The tracking URL is displayed in the merchant's admin on the order page.
   * The tracking URL is displayed in the shipping confirmation email, which can optionally be sent to the customer.
   * When accounts are enabled, it's also displayed in the customer's order history.
   *
   * The URL must be an [RFC 3986](https://datatracker.ietf.org/doc/html/rfc3986) and
   * [RFC 3987](https://datatracker.ietf.org/doc/html/rfc3987)-compliant URI string.
   * For example, `"https://www.myshipping.com/track/?tracknumbers=TRACKING_NUMBER"` is a valid URL.
   * It includes a scheme (`https`) and a host (`myshipping.com`).
   */
  readonly url?: InputMaybe<Scalars['URL']>;
  /**
   * The URLs to track the fulfillment, one or many.
   *
   * The tracking URLs are displayed in the merchant's admin on the order page.
   * The tracking URLs are displayed in the shipping confirmation email, which can optionally be sent to the customer.
   * When accounts are enabled, the tracking URLs are also displayed in the customer's order history.
   *
   * If you're not specifying a
   * [Shopify-known](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   * tracking company name in the `company` field,
   * then provide tracking URLs for all tracking numbers from the `numbers` field.
   *
   * Tracking URLs from the `urls` array field are being matched with the tracking numbers from the `numbers` array
   * field correspondingly their positions in the arrays.
   *
   * Each URL must be an [RFC 3986](https://datatracker.ietf.org/doc/html/rfc3986) and
   * [RFC 3987](https://datatracker.ietf.org/doc/html/rfc3987)-compliant URI string.
   * For example, `"https://www.myshipping.com/track/?tracknumbers=TRACKING_NUMBER"` is a valid URL.
   * It includes a scheme (`https`) and a host (`myshipping.com`).
   */
  readonly urls?: InputMaybe<ReadonlyArray<Scalars['URL']>>;
};

/** The input fields used to create a fulfillment from fulfillment orders. */
export type FulfillmentV2Input = {
  /**
   * Pairs of `fulfillment_order_id` and `fulfillment_order_line_items` that represent the fulfillment
   * order line items that have to be fulfilled for each fulfillment order.  For any given pair, if the
   * fulfillment order line items are left blank then all the fulfillment order line items of the
   * associated fulfillment order ID will be fulfilled.
   */
  readonly lineItemsByFulfillmentOrder: ReadonlyArray<FulfillmentOrderLineItemsInput>;
  /**
   * Whether the customer is notified.
   * If `true`, then a notification is sent when the fulfillment is created. The default value is `false`.
   */
  readonly notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  /** Address information about the location from which the order was fulfilled. */
  readonly originAddress?: InputMaybe<FulfillmentOriginAddressInput>;
  /**
   * The fulfillment's tracking information, including a tracking URL, a tracking number,
   * and the company associated with the fulfillment.
   */
  readonly trackingInfo?: InputMaybe<FulfillmentTrackingInput>;
};

/** The App Bridge information for a Shopify Function. */
export type FunctionsAppBridge = {
  /** The relative path for creating a customization. */
  readonly createPath: Scalars['String'];
  /** The relative path for viewing a customization. */
  readonly detailsPath: Scalars['String'];
};

/** The error history from running a Shopify Function. */
export type FunctionsErrorHistory = {
  /** The date and time that the first error occurred. */
  readonly errorsFirstOccurredAt: Scalars['DateTime'];
  /** The date and time that the first error occurred. */
  readonly firstOccurredAt: Scalars['DateTime'];
  /** Whether the merchant has shared all the recent errors with the developer. */
  readonly hasBeenSharedSinceLastError: Scalars['Boolean'];
  /** Whether the merchant has shared all the recent errors with the developer. */
  readonly hasSharedRecentErrors: Scalars['Boolean'];
};

/** Represents any file other than HTML. */
export type GenericFile = File & Node & {
  /** A word or phrase to describe the contents or the function of a file. */
  readonly alt?: Maybe<Scalars['String']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Any errors that have occurred on the file. */
  readonly fileErrors: ReadonlyArray<FileError>;
  /** The status of the file. */
  readonly fileStatus: FileStatus;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The generic file's MIME type. */
  readonly mimeType?: Maybe<Scalars['String']>;
  /** The generic file's size in bytes. */
  readonly originalFileSize?: Maybe<Scalars['Int']>;
  /** The preview image for the media. */
  readonly preview?: Maybe<MediaPreviewImage>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  readonly updatedAt: Scalars['DateTime'];
  /** The generic file's URL. */
  readonly url?: Maybe<Scalars['URL']>;
};

/** Represents an issued gift card. */
export type GiftCard = Node & {
  /** The gift card's remaining balance. */
  readonly balance: MoneyV2;
  /** The date and time at which the gift card was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The customer who will receive the gift card. */
  readonly customer?: Maybe<Customer>;
  /** The date and time at which the gift card was deactivated. */
  readonly deactivatedAt?: Maybe<Scalars['DateTime']>;
  /** Whether the gift card is enabled. */
  readonly enabled: Scalars['Boolean'];
  /** The date at which the gift card will expire. */
  readonly expiresOn?: Maybe<Scalars['Date']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The initial value of the gift card. */
  readonly initialValue: MoneyV2;
  /** The final four characters of the gift card code. */
  readonly lastCharacters: Scalars['String'];
  /** The gift card code. Everything but the final four characters is masked. */
  readonly maskedCode: Scalars['String'];
  /** The note associated with the gift card, which isn't visible to the customer. */
  readonly note?: Maybe<Scalars['String']>;
  /** The order associated with the gift card. This value is `null` if the gift card was issued manually. */
  readonly order?: Maybe<Order>;
  /** The recipient who will receive the gift card. */
  readonly recipientAttributes?: Maybe<GiftCardRecipient>;
  /** The theme template used to render the gift card online. */
  readonly templateSuffix?: Maybe<Scalars['String']>;
  /** The transaction history of the gift card. */
  readonly transactions?: Maybe<GiftCardTransactionConnection>;
  /** The date and time at which the gift card was updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** Represents an issued gift card. */
export type GiftCardTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple GiftCards. */
export type GiftCardConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<GiftCardEdge>;
  /** A list of nodes that are contained in GiftCardEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<GiftCard>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields to issue a gift card. */
export type GiftCardCreateInput = {
  /**
   * The gift card's code. It must be 8-20 characters long and contain only letters(a-z) and numbers(0-9).
   * It isn't case sensitive. If not provided, then a random code will be generated.
   */
  readonly code?: InputMaybe<Scalars['String']>;
  /** The ID of the customer who will receive the gift card. Requires `write_customers` access_scope. */
  readonly customerId?: InputMaybe<Scalars['ID']>;
  /** The date at which the gift card will expire. If not provided, then the gift card will never expire. */
  readonly expiresOn?: InputMaybe<Scalars['Date']>;
  /** The initial value of the gift card. */
  readonly initialValue: Scalars['Decimal'];
  /** The note associated with the gift card, which isn't visible to the customer. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The recipient attributes of the gift card. */
  readonly recipientAttributes?: InputMaybe<GiftCardRecipientInput>;
  /**
   * The suffix of the Liquid template that's used to render the gift card online.
   * For example, if the value is `birthday`, then the gift card is rendered using the template `gift_card.birthday.liquid`.
   * If not provided, then the default `gift_card.liquid` template is used.
   */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
};

/** Return type for `giftCardCreate` mutation. */
export type GiftCardCreatePayload = {
  /** The created gift card. */
  readonly giftCard?: Maybe<GiftCard>;
  /** The created gift card's code. */
  readonly giftCardCode?: Maybe<Scalars['String']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<GiftCardUserError>;
};

/** The input fields for a gift card credit transaction. */
export type GiftCardCreditInput = {
  /** The amount to credit the gift card. */
  readonly creditAmount: MoneyInput;
  /** A note about the credit. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The date and time the credit was processed. Defaults to current date and time. */
  readonly processedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Return type for `giftCardCredit` mutation. */
export type GiftCardCreditPayload = {
  /** The gift card credit transaction that was created. */
  readonly giftCardCreditTransaction?: Maybe<GiftCardCreditTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<GiftCardTransactionUserError>;
};

/** A credit transaction which increases the gift card balance. */
export type GiftCardCreditTransaction = GiftCardTransaction & HasMetafields & Node & {
  /** The amount of the transaction. */
  readonly amount: MoneyV2;
  /** The gift card that the transaction belongs to. */
  readonly giftCard: GiftCard;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** A note about the transaction. */
  readonly note?: Maybe<Scalars['String']>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The date and time when the transaction was processed. */
  readonly processedAt: Scalars['DateTime'];
};


/** A credit transaction which increases the gift card balance. */
export type GiftCardCreditTransactionMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A credit transaction which increases the gift card balance. */
export type GiftCardCreditTransactionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A credit transaction which increases the gift card balance. */
export type GiftCardCreditTransactionPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A credit transaction which increases the gift card balance. */
export type GiftCardCreditTransactionPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `giftCardDeactivate` mutation. */
export type GiftCardDeactivatePayload = {
  /** The deactivated gift card. */
  readonly giftCard?: Maybe<GiftCard>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<GiftCardDeactivateUserError>;
};

/** An error that occurs during the execution of `GiftCardDeactivate`. */
export type GiftCardDeactivateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<GiftCardDeactivateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `GiftCardDeactivateUserError`. */
export enum GiftCardDeactivateUserErrorCode {
  /** The gift card could not be found. */
  GIFT_CARD_NOT_FOUND = 'GIFT_CARD_NOT_FOUND'
}

/** The input fields for a gift card debit transaction. */
export type GiftCardDebitInput = {
  /** The amount to debit the gift card. */
  readonly debitAmount: MoneyInput;
  /** A note about the debit. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The date and time the debit was processed. Defaults to current date and time. */
  readonly processedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Return type for `giftCardDebit` mutation. */
export type GiftCardDebitPayload = {
  /** The gift card debit transaction that was created. */
  readonly giftCardDebitTransaction?: Maybe<GiftCardDebitTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<GiftCardTransactionUserError>;
};

/** A debit transaction which decreases the gift card balance. */
export type GiftCardDebitTransaction = GiftCardTransaction & HasMetafields & Node & {
  /** The amount of the transaction. */
  readonly amount: MoneyV2;
  /** The gift card that the transaction belongs to. */
  readonly giftCard: GiftCard;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** A note about the transaction. */
  readonly note?: Maybe<Scalars['String']>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The date and time when the transaction was processed. */
  readonly processedAt: Scalars['DateTime'];
};


/** A debit transaction which decreases the gift card balance. */
export type GiftCardDebitTransactionMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A debit transaction which decreases the gift card balance. */
export type GiftCardDebitTransactionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A debit transaction which decreases the gift card balance. */
export type GiftCardDebitTransactionPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A debit transaction which decreases the gift card balance. */
export type GiftCardDebitTransactionPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type which holds one GiftCard and a cursor during pagination. */
export type GiftCardEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of GiftCardEdge. */
  readonly node: GiftCard;
};

/** Possible error codes that can be returned by `GiftCardUserError`. */
export enum GiftCardErrorCode {
  /** The customer could not be found. */
  CUSTOMER_NOT_FOUND = 'CUSTOMER_NOT_FOUND',
  /** The gift card's value exceeds the allowed limits. */
  GIFT_CARD_LIMIT_EXCEEDED = 'GIFT_CARD_LIMIT_EXCEEDED',
  /** The input value should be greater than the minimum allowed value. */
  GREATER_THAN = 'GREATER_THAN',
  /** Unexpected internal error happened. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Missing a required argument. */
  MISSING_ARGUMENT = 'MISSING_ARGUMENT',
  /** The recipient could not be found. */
  RECIPIENT_NOT_FOUND = 'RECIPIENT_NOT_FOUND',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT'
}

/** Represents a recipient who will receive the issued gift card. */
export type GiftCardRecipient = {
  /** The message sent with the gift card. */
  readonly message?: Maybe<Scalars['String']>;
  /** The preferred name of the recipient who will receive the gift card. */
  readonly preferredName?: Maybe<Scalars['String']>;
  /** The recipient who will receive the gift card. */
  readonly recipient: Customer;
  /** The scheduled datetime on which the gift card will be sent to the recipient. The gift card will be sent within an hour of the specified datetime. */
  readonly sendNotificationAt?: Maybe<Scalars['DateTime']>;
};

/** The input fields to add a recipient to a gift card. */
export type GiftCardRecipientInput = {
  /** The ID of the customer who will be the recipient of the gift card. Requires `write_customers` access_scope. */
  readonly id: Scalars['ID'];
  /** The personalized message intended for the recipient. */
  readonly message?: InputMaybe<Scalars['String']>;
  /** The preferred name of the recipient. */
  readonly preferredName?: InputMaybe<Scalars['String']>;
  /** The scheduled datetime on which the gift card will be sent to the recipient. The gift card will be sent within an hour of the specified datetime. */
  readonly sendNotificationAt?: InputMaybe<Scalars['DateTime']>;
};

/** A sale associated with a gift card. */
export type GiftCardSale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line item for the associated sale. */
  readonly lineItem: LineItem;
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** Return type for `giftCardSendNotificationToCustomer` mutation. */
export type GiftCardSendNotificationToCustomerPayload = {
  /** The gift card that was sent. */
  readonly giftCard?: Maybe<GiftCard>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<GiftCardSendNotificationToCustomerUserError>;
};

/** An error that occurs during the execution of `GiftCardSendNotificationToCustomer`. */
export type GiftCardSendNotificationToCustomerUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<GiftCardSendNotificationToCustomerUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `GiftCardSendNotificationToCustomerUserError`. */
export enum GiftCardSendNotificationToCustomerUserErrorCode {
  /** The customer could not be found. */
  CUSTOMER_NOT_FOUND = 'CUSTOMER_NOT_FOUND',
  /** The gift card could not be found. */
  GIFT_CARD_NOT_FOUND = 'GIFT_CARD_NOT_FOUND',
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Return type for `giftCardSendNotificationToRecipient` mutation. */
export type GiftCardSendNotificationToRecipientPayload = {
  /** The gift card that was sent. */
  readonly giftCard?: Maybe<GiftCard>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<GiftCardSendNotificationToRecipientUserError>;
};

/** An error that occurs during the execution of `GiftCardSendNotificationToRecipient`. */
export type GiftCardSendNotificationToRecipientUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<GiftCardSendNotificationToRecipientUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `GiftCardSendNotificationToRecipientUserError`. */
export enum GiftCardSendNotificationToRecipientUserErrorCode {
  /** The gift card could not be found. */
  GIFT_CARD_NOT_FOUND = 'GIFT_CARD_NOT_FOUND',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The recipient could not be found. */
  RECIPIENT_NOT_FOUND = 'RECIPIENT_NOT_FOUND'
}

/** The set of valid sort keys for the GiftCard query. */
export enum GiftCardSortKeys {
  /** Sort by the `amount_spent` value. */
  AMOUNT_SPENT = 'AMOUNT_SPENT',
  /** Sort by the `balance` value. */
  BALANCE = 'BALANCE',
  /** Sort by the `code` value. */
  CODE = 'CODE',
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `customer_name` value. */
  CUSTOMER_NAME = 'CUSTOMER_NAME',
  /** Sort by the `disabled_at` value. */
  DISABLED_AT = 'DISABLED_AT',
  /** Sort by the `expires_on` value. */
  EXPIRES_ON = 'EXPIRES_ON',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `initial_value` value. */
  INITIAL_VALUE = 'INITIAL_VALUE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Interface for a gift card transaction. */
export type GiftCardTransaction = {
  /** The amount of the transaction. */
  readonly amount: MoneyV2;
  /** The gift card that the transaction belongs to. */
  readonly giftCard: GiftCard;
  /** The unique ID for the transaction. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** A note about the transaction. */
  readonly note?: Maybe<Scalars['String']>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The date and time when the transaction was processed. */
  readonly processedAt: Scalars['DateTime'];
};


/** Interface for a gift card transaction. */
export type GiftCardTransactionMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** Interface for a gift card transaction. */
export type GiftCardTransactionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Interface for a gift card transaction. */
export type GiftCardTransactionPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** Interface for a gift card transaction. */
export type GiftCardTransactionPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple GiftCardTransactions. */
export type GiftCardTransactionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<GiftCardTransactionEdge>;
  /** A list of nodes that are contained in GiftCardTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<GiftCardTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one GiftCardTransaction and a cursor during pagination. */
export type GiftCardTransactionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of GiftCardTransactionEdge. */
  readonly node: GiftCardTransaction;
};

/** Represents an error that happens during the execution of a gift card transaction mutation. */
export type GiftCardTransactionUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<GiftCardTransactionUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `GiftCardTransactionUserError`. */
export enum GiftCardTransactionUserErrorCode {
  /** The gift card's value exceeds the allowed limits. */
  GIFT_CARD_LIMIT_EXCEEDED = 'GIFT_CARD_LIMIT_EXCEEDED',
  /** The gift card could not be found. */
  GIFT_CARD_NOT_FOUND = 'GIFT_CARD_NOT_FOUND',
  /** The gift card does not have sufficient funds to satisfy the request. */
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  /** Unexpected internal error happened. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The currency provided does not match the currency of the gift card. */
  MISMATCHING_CURRENCY = 'MISMATCHING_CURRENCY',
  /** A positive amount must be used. */
  NEGATIVE_OR_ZERO_AMOUNT = 'NEGATIVE_OR_ZERO_AMOUNT'
}

/** The input fields to update a gift card. */
export type GiftCardUpdateInput = {
  /** The ID of the customer who will receive the gift card. The ID can't be changed if the gift card already has an assigned customer ID. */
  readonly customerId?: InputMaybe<Scalars['ID']>;
  /** The date at which the gift card will expire. If set to `null`, then the gift card will never expire. */
  readonly expiresOn?: InputMaybe<Scalars['Date']>;
  /** The note associated with the gift card, which isn't visible to the customer. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The recipient attributes of the gift card. */
  readonly recipientAttributes?: InputMaybe<GiftCardRecipientInput>;
  /**
   * The suffix of the Liquid template that's used to render the gift card online.
   * For example, if the value is `birthday`, then the gift card is rendered using the template `gift_card.birthday.liquid`.
   */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
};

/** Return type for `giftCardUpdate` mutation. */
export type GiftCardUpdatePayload = {
  /** The updated gift card. */
  readonly giftCard?: Maybe<GiftCard>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents an error that happens during the execution of a gift card mutation. */
export type GiftCardUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<GiftCardErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/**
 * Represents a summary of the current version of data in a resource.
 *
 * The `compare_digest` field can be used as input for mutations that implement a compare-and-swap mechanism.
 */
export type HasCompareDigest = {
  /** The data stored in the resource, represented as a digest. */
  readonly compareDigest: Scalars['String'];
};

/** Represents an object that has a list of events. */
export type HasEvents = {
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
};


/** Represents an object that has a list of events. */
export type HasEventsEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** Localization extensions associated with the specified resource. For example, the tax id for government invoice. */
export type HasLocalizationExtensions = {
  /**
   * List of localization extensions for the resource.
   * @deprecated This connection will be removed in a future version. Use `localizedFields` instead.
   */
  readonly localizationExtensions: LocalizationExtensionConnection;
};


/** Localization extensions associated with the specified resource. For example, the tax id for government invoice. */
export type HasLocalizationExtensionsLocalizationExtensionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countryCodes?: InputMaybe<ReadonlyArray<CountryCode>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  purposes?: InputMaybe<ReadonlyArray<LocalizationExtensionPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Resources that metafield definitions can be applied to. */
export type HasMetafieldDefinitions = {
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
};


/** Resources that metafield definitions can be applied to. */
export type HasMetafieldDefinitionsMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};

/** Represents information about the metafields associated to the specified resource. */
export type HasMetafields = {
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
};


/** Represents information about the metafields associated to the specified resource. */
export type HasMetafieldsMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** Represents information about the metafields associated to the specified resource. */
export type HasMetafieldsMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents information about the metafields associated to the specified resource. */
export type HasMetafieldsPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** Represents information about the metafields associated to the specified resource. */
export type HasMetafieldsPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Published translations associated with the resource. */
export type HasPublishedTranslations = {
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
};


/** Published translations associated with the resource. */
export type HasPublishedTranslationsTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** Represents information about the store credit accounts associated to the specified owner. */
export type HasStoreCreditAccounts = {
  /**
   * Returns a list of store credit accounts that belong to the owner resource.
   * A store credit account owner can hold multiple accounts each with a different currency.
   */
  readonly storeCreditAccounts: StoreCreditAccountConnection;
};


/** Represents information about the store credit accounts associated to the specified owner. */
export type HasStoreCreditAccountsStoreCreditAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

/** Represents an image resource. */
export type Image = HasMetafields & {
  /** A word or phrase to share the nature or contents of an image. */
  readonly altText?: Maybe<Scalars['String']>;
  /** The original height of the image in pixels. Returns `null` if the image isn't hosted by Shopify. */
  readonly height?: Maybe<Scalars['Int']>;
  /** A unique ID for the image. */
  readonly id?: Maybe<Scalars['ID']>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * The location of the original image as a URL.
   *
   * If there are any existing transformations in the original source URL, they will remain and not be stripped.
   * @deprecated Use `url` instead.
   */
  readonly originalSrc: Scalars['URL'];
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /**
   * The location of the image as a URL.
   * @deprecated Use `url` instead.
   */
  readonly src: Scalars['URL'];
  /**
   * The location of the transformed image as a URL.
   *
   * All transformation arguments are considered "best-effort". If they can be applied to an image, they will be.
   * Otherwise any transformations which an image type doesn't support will be ignored.
   * @deprecated Use `url(transform:)` instead
   */
  readonly transformedSrc: Scalars['URL'];
  /**
   * The location of the image as a URL.
   *
   * If no transform options are specified, then the original image will be preserved including any pre-applied transforms.
   *
   * All transformation options are considered "best-effort". Any transformation that the original image type doesn't support will be ignored.
   *
   * If you need multiple variations of the same image, then you can use [GraphQL aliases](https://graphql.org/learn/queries/#aliases).
   */
  readonly url: Scalars['URL'];
  /** The original width of the image in pixels. Returns `null` if the image isn't hosted by Shopify. */
  readonly width?: Maybe<Scalars['Int']>;
};


/** Represents an image resource. */
export type ImageMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** Represents an image resource. */
export type ImageMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an image resource. */
export type ImagePrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** Represents an image resource. */
export type ImagePrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents an image resource. */
export type ImageTransformedSrcArgs = {
  crop?: InputMaybe<CropRegion>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  preferredContentType?: InputMaybe<ImageContentType>;
  scale?: InputMaybe<Scalars['Int']>;
};


/** Represents an image resource. */
export type ImageUrlArgs = {
  transform?: InputMaybe<ImageTransformInput>;
};

/** An auto-generated type for paginating through multiple Images. */
export type ImageConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ImageEdge>;
  /** A list of nodes that are contained in ImageEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Image>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** List of supported image content types. */
export enum ImageContentType {
  /** A JPG image. */
  JPG = 'JPG',
  /** A PNG image. */
  PNG = 'PNG',
  /** A WEBP image. */
  WEBP = 'WEBP'
}

/** An auto-generated type which holds one Image and a cursor during pagination. */
export type ImageEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ImageEdge. */
  readonly node: Image;
};

/** The input fields for an image. */
export type ImageInput = {
  /** A word or phrase to share the nature or contents of an image. */
  readonly altText?: InputMaybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The URL of the image. May be a staged upload URL. */
  readonly src?: InputMaybe<Scalars['String']>;
};

/**
 * The available options for transforming an image.
 *
 * All transformation options are considered best effort. Any transformation that the original image type doesn't support will be ignored.
 */
export type ImageTransformInput = {
  /**
   * The region of the image to remain after cropping.
   * Must be used in conjunction with the `maxWidth` and/or `maxHeight` fields, where the `maxWidth` and `maxHeight` aren't equal.
   * The `crop` argument should coincide with the smaller value. A smaller `maxWidth` indicates a `LEFT` or `RIGHT` crop, while
   * a smaller `maxHeight` indicates a `TOP` or `BOTTOM` crop. For example, `{ maxWidth: 5, maxHeight: 10, crop: LEFT }` will result
   * in an image with a width of 5 and height of 10, where the right side of the image is removed.
   */
  readonly crop?: InputMaybe<CropRegion>;
  /** Image height in pixels between 1 and 5760. */
  readonly maxHeight?: InputMaybe<Scalars['Int']>;
  /** Image width in pixels between 1 and 5760. */
  readonly maxWidth?: InputMaybe<Scalars['Int']>;
  /**
   * Convert the source image into the preferred content type.
   * Supported conversions: `.svg` to `.png`, any file type to `.jpg`, and any file type to `.webp`.
   */
  readonly preferredContentType?: InputMaybe<ImageContentType>;
  /** Image size multiplier for high-resolution retina displays. Must be within 1..3. */
  readonly scale?: InputMaybe<Scalars['Int']>;
};

/**
 * A parameter to upload an image.
 *
 * Deprecated in favor of
 * [StagedUploadParameter](https://shopify.dev/api/admin-graphql/latest/objects/StagedUploadParameter),
 * which is used in
 * [StagedMediaUploadTarget](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget)
 * and returned by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type ImageUploadParameter = {
  /** The parameter name. */
  readonly name: Scalars['String'];
  /** The parameter value. */
  readonly value: Scalars['String'];
};

/** The input fields for the incoming line item. */
export type IncomingRequestLineItemInput = {
  /** The ID of the rejected line item. */
  readonly fulfillmentOrderLineItemId: Scalars['ID'];
  /** The rejection message of the line item. */
  readonly message?: InputMaybe<Scalars['String']>;
};

/** Return type for `inventoryActivate` mutation. */
export type InventoryActivatePayload = {
  /** The inventory level that was activated. */
  readonly inventoryLevel?: Maybe<InventoryLevel>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields required to adjust inventory quantities. */
export type InventoryAdjustQuantitiesInput = {
  /** The quantity changes of items at locations to be made. */
  readonly changes: ReadonlyArray<InventoryChangeInput>;
  /**
   * The quantity [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states)
   * to be adjusted.
   */
  readonly name: Scalars['String'];
  /**
   * The reason for the quantity changes. The value must be one of the [possible
   * reasons](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#set-inventory-quantities-on-hand).
   */
  readonly reason: Scalars['String'];
  /**
   * A freeform URI that represents why the inventory change happened. This can be the entity adjusting inventory
   * quantities or the Shopify resource that's associated with the inventory adjustment. For example, a unit in a
   * draft order might have been previously reserved, and a merchant later creates an order from the draft order.
   * In this case, the `referenceDocumentUri` for the inventory adjustment is a URI referencing the order ID.
   */
  readonly referenceDocumentUri?: InputMaybe<Scalars['String']>;
};

/** Return type for `inventoryAdjustQuantities` mutation. */
export type InventoryAdjustQuantitiesPayload = {
  /** The group of changes made by the operation. */
  readonly inventoryAdjustmentGroup?: Maybe<InventoryAdjustmentGroup>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<InventoryAdjustQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventoryAdjustQuantities`. */
export type InventoryAdjustQuantitiesUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<InventoryAdjustQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `InventoryAdjustQuantitiesUserError`. */
export enum InventoryAdjustQuantitiesUserErrorCode {
  /** The quantities couldn't be adjusted. Try again. */
  ADJUST_QUANTITIES_FAILED = 'ADJUST_QUANTITIES_FAILED',
  /** Internal (gid://shopify/) ledger documents are not allowed to be adjusted via API. */
  INTERNAL_LEDGER_DOCUMENT = 'INTERNAL_LEDGER_DOCUMENT',
  /** A ledger document URI is not allowed when adjusting available. */
  INVALID_AVAILABLE_DOCUMENT = 'INVALID_AVAILABLE_DOCUMENT',
  /** The specified inventory item could not be found. */
  INVALID_INVENTORY_ITEM = 'INVALID_INVENTORY_ITEM',
  /** The specified ledger document is invalid. */
  INVALID_LEDGER_DOCUMENT = 'INVALID_LEDGER_DOCUMENT',
  /** The specified location could not be found. */
  INVALID_LOCATION = 'INVALID_LOCATION',
  /** A ledger document URI is required except when adjusting available. */
  INVALID_QUANTITY_DOCUMENT = 'INVALID_QUANTITY_DOCUMENT',
  /** The specified quantity name is invalid. */
  INVALID_QUANTITY_NAME = 'INVALID_QUANTITY_NAME',
  /** The quantity can't be higher than 2,000,000,000. */
  INVALID_QUANTITY_TOO_HIGH = 'INVALID_QUANTITY_TOO_HIGH',
  /** The quantity can't be lower than -2,000,000,000. */
  INVALID_QUANTITY_TOO_LOW = 'INVALID_QUANTITY_TOO_LOW',
  /** The specified reason is invalid. */
  INVALID_REASON = 'INVALID_REASON',
  /** The specified reference document is invalid. */
  INVALID_REFERENCE_DOCUMENT = 'INVALID_REFERENCE_DOCUMENT',
  /** The inventory item is not stocked at the location. */
  ITEM_NOT_STOCKED_AT_LOCATION = 'ITEM_NOT_STOCKED_AT_LOCATION',
  /** All changes must have the same ledger document URI or, in the case of adjusting available, no ledger document URI. */
  MAX_ONE_LEDGER_DOCUMENT = 'MAX_ONE_LEDGER_DOCUMENT',
  /** The specified inventory item is not allowed to be adjusted via API. Example: if the inventory item is a parent bundle. */
  NON_MUTABLE_INVENTORY_ITEM = 'NON_MUTABLE_INVENTORY_ITEM'
}

/** Represents a group of adjustments made as part of the same operation. */
export type InventoryAdjustmentGroup = Node & {
  /** The app that triggered the inventory event, if one exists. */
  readonly app?: Maybe<App>;
  /** The set of inventory quantity changes that occurred in the inventory event. */
  readonly changes: ReadonlyArray<InventoryChange>;
  /** The date and time the inventory adjustment group was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The reason for the group of adjustments. */
  readonly reason: Scalars['String'];
  /**
   * A freeform URI that represents why the inventory change happened. This can be the entity adjusting inventory
   * quantities or the Shopify resource that's associated with the inventory adjustment. For example, a unit in a
   * draft order might have been previously reserved, and a merchant later creates an order from the draft order.
   * In this case, the `referenceDocumentUri` for the inventory adjustment is a URI referencing the order ID.
   */
  readonly referenceDocumentUri?: Maybe<Scalars['String']>;
  /** The staff member associated with the inventory event. */
  readonly staffMember?: Maybe<StaffMember>;
};


/** Represents a group of adjustments made as part of the same operation. */
export type InventoryAdjustmentGroupChangesArgs = {
  inventoryItemIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  locationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  quantityNames?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

/** The input fields to specify whether the inventory item should be activated or not at the specified location. */
export type InventoryBulkToggleActivationInput = {
  /** Whether the inventory item can be stocked at the specified location. To deactivate, set the value to false which removes an inventory item's quantities from that location, and turns off inventory at that location. */
  readonly activate: Scalars['Boolean'];
  /** The ID of the location to modify the inventory item's stocked status. */
  readonly locationId: Scalars['ID'];
};

/** Return type for `inventoryBulkToggleActivation` mutation. */
export type InventoryBulkToggleActivationPayload = {
  /** The inventory item that was updated. */
  readonly inventoryItem?: Maybe<InventoryItem>;
  /** The activated inventory levels. */
  readonly inventoryLevels?: Maybe<ReadonlyArray<InventoryLevel>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<InventoryBulkToggleActivationUserError>;
};

/** An error that occurred while setting the activation status of an inventory item. */
export type InventoryBulkToggleActivationUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<InventoryBulkToggleActivationUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `InventoryBulkToggleActivationUserError`. */
export enum InventoryBulkToggleActivationUserErrorCode {
  /** Cannot unstock an inventory item from the only location at which it is stocked. */
  CANNOT_DEACTIVATE_FROM_ONLY_LOCATION = 'CANNOT_DEACTIVATE_FROM_ONLY_LOCATION',
  /** Cannot unstock this inventory item from this location because it has committed and incoming quantities. */
  COMMITTED_AND_INCOMING_INVENTORY_AT_LOCATION = 'COMMITTED_AND_INCOMING_INVENTORY_AT_LOCATION',
  /** Cannot unstock this inventory item from this location because it has committed quantities. */
  COMMITTED_INVENTORY_AT_LOCATION = 'COMMITTED_INVENTORY_AT_LOCATION',
  /** Failed to stock this inventory item at this location. */
  FAILED_TO_STOCK_AT_LOCATION = 'FAILED_TO_STOCK_AT_LOCATION',
  /** Failed to unstock this inventory item from this location. */
  FAILED_TO_UNSTOCK_FROM_LOCATION = 'FAILED_TO_UNSTOCK_FROM_LOCATION',
  /** An error occurred while setting the activation status. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** Cannot unstock this inventory item from this location because it has incoming quantities. */
  INCOMING_INVENTORY_AT_LOCATION = 'INCOMING_INVENTORY_AT_LOCATION',
  /** The inventory item was not found. */
  INVENTORY_ITEM_NOT_FOUND = 'INVENTORY_ITEM_NOT_FOUND',
  /** Cannot stock this inventory item at this location because it is managed by a third-party fulfillment service. */
  INVENTORY_MANAGED_BY_3RD_PARTY = 'INVENTORY_MANAGED_BY_3RD_PARTY',
  /** Cannot stock this inventory item at this location because it is managed by Shopify. */
  INVENTORY_MANAGED_BY_SHOPIFY = 'INVENTORY_MANAGED_BY_SHOPIFY',
  /** The location was not found. */
  LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND',
  /** Cannot stock this inventory item at this location because the variant is missing a SKU. */
  MISSING_SKU = 'MISSING_SKU',
  /** Cannot unstock this inventory item from this location because it has unavailable quantities. */
  RESERVED_INVENTORY_AT_LOCATION = 'RESERVED_INVENTORY_AT_LOCATION'
}

/** Represents a change in an inventory quantity of an inventory item at a location. */
export type InventoryChange = {
  /** The amount by which the inventory quantity was changed. */
  readonly delta: Scalars['Int'];
  /** The inventory item associated with this inventory change. */
  readonly item?: Maybe<InventoryItem>;
  /** A URI that represents what the inventory quantity change was applied to. */
  readonly ledgerDocumentUri?: Maybe<Scalars['String']>;
  /** The location associated with this inventory change. */
  readonly location?: Maybe<Location>;
  /**
   * The [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states)
   * of the inventory quantity that was changed.
   */
  readonly name: Scalars['String'];
  /** The quantity of named inventory after the change. */
  readonly quantityAfterChange?: Maybe<Scalars['Int']>;
};

/** The input fields for the change to be made to an inventory item at a location. */
export type InventoryChangeInput = {
  /** The amount by which the inventory quantity will be changed. */
  readonly delta: Scalars['Int'];
  /** Specifies the inventory item to which the change will be applied. */
  readonly inventoryItemId: Scalars['ID'];
  /**
   * A freeform URI that represents what changed the inventory quantities. A Shopify global ID isn't an accepted
   * value. For example, specifying "gid://shopify/Order/123" would return an error. This field is required for all
   * quantity names except `available`. The field `ledgerDocumentUri` isn't supported for use with an `available`
   * quantity name.
   */
  readonly ledgerDocumentUri?: InputMaybe<Scalars['String']>;
  /** Specifies the location at which the change will be applied. */
  readonly locationId: Scalars['ID'];
};

/** Return type for `inventoryDeactivate` mutation. */
export type InventoryDeactivatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/**
 * Represents the goods available to be shipped to a customer.
 * It holds essential information about the goods, including SKU and whether it is tracked.
 * Learn [more about the relationships between inventory objects](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItem = LegacyInteroperability & Node & {
  /** The ISO 3166-1 alpha-2 country code of where the item originated from. */
  readonly countryCodeOfOrigin?: Maybe<CountryCode>;
  /** A list of country specific harmonized system codes. */
  readonly countryHarmonizedSystemCodes: CountryHarmonizedSystemCodeConnection;
  /** The date and time when the inventory item was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The number of inventory items that share the same SKU with this item. */
  readonly duplicateSkuCount: Scalars['Int'];
  /** The harmonized system code of the item. This must be a number between 6 and 13 digits. */
  readonly harmonizedSystemCode?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The URL that points to the inventory history for the item. */
  readonly inventoryHistoryUrl?: Maybe<Scalars['URL']>;
  /** The inventory item's quantities at the specified location. */
  readonly inventoryLevel?: Maybe<InventoryLevel>;
  /** A list of the inventory item's quantities for each location that the inventory item can be stocked at. */
  readonly inventoryLevels: InventoryLevelConnection;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The number of locations where this inventory item is stocked. */
  readonly locationsCount?: Maybe<Count>;
  /** The packaging dimensions of the inventory item. */
  readonly measurement: InventoryItemMeasurement;
  /** The ISO 3166-2 alpha-2 province code of where the item originated from. */
  readonly provinceCodeOfOrigin?: Maybe<Scalars['String']>;
  /** Whether the inventory item requires shipping. */
  readonly requiresShipping: Scalars['Boolean'];
  /** Inventory item SKU. Case-sensitive string. */
  readonly sku?: Maybe<Scalars['String']>;
  /** Whether inventory levels are tracked for the item. */
  readonly tracked: Scalars['Boolean'];
  /** Whether the value of the `tracked` field for the inventory item can be changed. */
  readonly trackedEditable: EditableProperty;
  /** Unit cost associated with the inventory item. Note: the user must have "View product costs" permission granted in order to access this field once product granular permissions are enabled. */
  readonly unitCost?: Maybe<MoneyV2>;
  /** The date and time when the inventory item was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /** The variant that owns this inventory item. */
  readonly variant: ProductVariant;
};


/**
 * Represents the goods available to be shipped to a customer.
 * It holds essential information about the goods, including SKU and whether it is tracked.
 * Learn [more about the relationships between inventory objects](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItemCountryHarmonizedSystemCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents the goods available to be shipped to a customer.
 * It holds essential information about the goods, including SKU and whether it is tracked.
 * Learn [more about the relationships between inventory objects](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItemInventoryLevelArgs = {
  locationId: Scalars['ID'];
};


/**
 * Represents the goods available to be shipped to a customer.
 * It holds essential information about the goods, including SKU and whether it is tracked.
 * Learn [more about the relationships between inventory objects](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryItemInventoryLevelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple InventoryItems. */
export type InventoryItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<InventoryItemEdge>;
  /** A list of nodes that are contained in InventoryItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<InventoryItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one InventoryItem and a cursor during pagination. */
export type InventoryItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of InventoryItemEdge. */
  readonly node: InventoryItem;
};

/** The input fields for an inventory item. */
export type InventoryItemInput = {
  /** Unit cost associated with the inventory item, the currency is the shop's default currency. */
  readonly cost?: InputMaybe<Scalars['Decimal']>;
  /** The ISO 3166-1 alpha-2 country code of where the item originated from. */
  readonly countryCodeOfOrigin?: InputMaybe<CountryCode>;
  /** List of country-specific harmonized system codes. */
  readonly countryHarmonizedSystemCodes?: InputMaybe<ReadonlyArray<CountryHarmonizedSystemCodeInput>>;
  /** The harmonized system code of the inventory item. This must be a number between 6 and 13 digits. */
  readonly harmonizedSystemCode?: InputMaybe<Scalars['String']>;
  /** The measurements of an inventory item. */
  readonly measurement?: InputMaybe<InventoryItemMeasurementInput>;
  /** The ISO 3166-2 alpha-2 province code of where the item originated from. */
  readonly provinceCodeOfOrigin?: InputMaybe<Scalars['String']>;
  readonly requiresShipping?: InputMaybe<Scalars['Boolean']>;
  /** The SKU (stock keeping unit) of the inventory item. */
  readonly sku?: InputMaybe<Scalars['String']>;
  /** Whether the inventory item is tracked. */
  readonly tracked?: InputMaybe<Scalars['Boolean']>;
};

/** Represents the packaged dimension for an inventory item. */
export type InventoryItemMeasurement = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The weight of the inventory item. */
  readonly weight?: Maybe<Weight>;
};

/** The input fields for an inventory item measurement. */
export type InventoryItemMeasurementInput = {
  /** The weight of the inventory item. */
  readonly weight?: InputMaybe<WeightInput>;
};

/** Return type for `inventoryItemUpdate` mutation. */
export type InventoryItemUpdatePayload = {
  /** The inventory item that was updated. */
  readonly inventoryItem?: Maybe<InventoryItem>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/**
 * The quantities of an inventory item that are related to a specific location.
 * Learn [more about the relationships between inventory objects](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryLevel = Node & {
  /** Whether the inventory items associated with the inventory level can be deactivated. */
  readonly canDeactivate: Scalars['Boolean'];
  /** The date and time when the inventory level was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Describes either the impact of deactivating the inventory level, or why the inventory level can't be deactivated. */
  readonly deactivationAlert?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Inventory item associated with the inventory level. */
  readonly item: InventoryItem;
  /** The location associated with the inventory level. */
  readonly location: Location;
  /** Quantities for the requested names. */
  readonly quantities: ReadonlyArray<InventoryQuantity>;
  /** Scheduled changes for the requested quantity names. */
  readonly scheduledChanges: InventoryScheduledChangeConnection;
  /** The date and time when the inventory level was updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/**
 * The quantities of an inventory item that are related to a specific location.
 * Learn [more about the relationships between inventory objects](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryLevelQuantitiesArgs = {
  names: ReadonlyArray<Scalars['String']>;
};


/**
 * The quantities of an inventory item that are related to a specific location.
 * Learn [more about the relationships between inventory objects](https://shopify.dev/docs/apps/build/orders-fulfillment/inventory-management-apps/manage-quantities-states#inventory-object-relationships).
 */
export type InventoryLevelScheduledChangesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ScheduledChangeSortKeys>;
};

/** An auto-generated type for paginating through multiple InventoryLevels. */
export type InventoryLevelConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<InventoryLevelEdge>;
  /** A list of nodes that are contained in InventoryLevelEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<InventoryLevel>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one InventoryLevel and a cursor during pagination. */
export type InventoryLevelEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of InventoryLevelEdge. */
  readonly node: InventoryLevel;
};

/** The input fields for an inventory level. */
export type InventoryLevelInput = {
  /** The available quantity of an inventory item at a location. */
  readonly availableQuantity: Scalars['Int'];
  /** The ID of a location associated with the inventory level. */
  readonly locationId: Scalars['ID'];
};

/** The input fields required to move inventory quantities. */
export type InventoryMoveQuantitiesInput = {
  /** The quantity changes of items at locations to be made. */
  readonly changes: ReadonlyArray<InventoryMoveQuantityChange>;
  /**
   * The reason for the quantity changes. The value must be one of the [possible
   * reasons](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#set-inventory-quantities-on-hand).
   */
  readonly reason: Scalars['String'];
  /**
   * A freeform URI that represents why the inventory change happened. This can be the entity adjusting inventory
   * quantities or the Shopify resource that's associated with the inventory adjustment. For example, a unit in a
   * draft order might have been previously reserved, and a merchant later creates an order from the draft order.
   * In this case, the `referenceDocumentUri` for the inventory adjustment is a URI referencing the order ID.
   */
  readonly referenceDocumentUri: Scalars['String'];
};

/** Return type for `inventoryMoveQuantities` mutation. */
export type InventoryMoveQuantitiesPayload = {
  /** The group of changes made by the operation. */
  readonly inventoryAdjustmentGroup?: Maybe<InventoryAdjustmentGroup>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<InventoryMoveQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventoryMoveQuantities`. */
export type InventoryMoveQuantitiesUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<InventoryMoveQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `InventoryMoveQuantitiesUserError`. */
export enum InventoryMoveQuantitiesUserErrorCode {
  /** The quantities can't be moved between different locations. */
  DIFFERENT_LOCATIONS = 'DIFFERENT_LOCATIONS',
  /** Internal (gid://shopify/) ledger documents are not allowed to be adjusted via API. */
  INTERNAL_LEDGER_DOCUMENT = 'INTERNAL_LEDGER_DOCUMENT',
  /** A ledger document URI is not allowed when adjusting available. */
  INVALID_AVAILABLE_DOCUMENT = 'INVALID_AVAILABLE_DOCUMENT',
  /** The specified inventory item could not be found. */
  INVALID_INVENTORY_ITEM = 'INVALID_INVENTORY_ITEM',
  /** The specified ledger document is invalid. */
  INVALID_LEDGER_DOCUMENT = 'INVALID_LEDGER_DOCUMENT',
  /** The specified location could not be found. */
  INVALID_LOCATION = 'INVALID_LOCATION',
  /** A ledger document URI is required except when adjusting available. */
  INVALID_QUANTITY_DOCUMENT = 'INVALID_QUANTITY_DOCUMENT',
  /** The specified quantity name is invalid. */
  INVALID_QUANTITY_NAME = 'INVALID_QUANTITY_NAME',
  /** The quantity can't be negative. */
  INVALID_QUANTITY_NEGATIVE = 'INVALID_QUANTITY_NEGATIVE',
  /** The quantity can't be higher than 2,000,000,000. */
  INVALID_QUANTITY_TOO_HIGH = 'INVALID_QUANTITY_TOO_HIGH',
  /** The specified reason is invalid. */
  INVALID_REASON = 'INVALID_REASON',
  /** The specified reference document is invalid. */
  INVALID_REFERENCE_DOCUMENT = 'INVALID_REFERENCE_DOCUMENT',
  /** The inventory item is not stocked at the location. */
  ITEM_NOT_STOCKED_AT_LOCATION = 'ITEM_NOT_STOCKED_AT_LOCATION',
  /** Only a maximum of 2 ledger document URIs across all changes is allowed. */
  MAXIMUM_LEDGER_DOCUMENT_URIS = 'MAXIMUM_LEDGER_DOCUMENT_URIS',
  /** The quantities couldn't be moved. Try again. */
  MOVE_QUANTITIES_FAILED = 'MOVE_QUANTITIES_FAILED',
  /** The specified inventory item is not allowed to be adjusted via API. Example: if the inventory item is a parent bundle. */
  NON_MUTABLE_INVENTORY_ITEM = 'NON_MUTABLE_INVENTORY_ITEM',
  /** The quantity names for each change can't be the same. */
  SAME_QUANTITY_NAME = 'SAME_QUANTITY_NAME'
}

/**
 * Represents the change to be made to an inventory item at a location.
 * The change can either involve the same quantity name between different locations,
 * or involve different quantity names between the same location.
 */
export type InventoryMoveQuantityChange = {
  /** Details about where the move will be made from. */
  readonly from: InventoryMoveQuantityTerminalInput;
  /** Specifies the inventory item to which the change will be applied. */
  readonly inventoryItemId: Scalars['ID'];
  /** The amount by which the inventory quantity will be changed. */
  readonly quantity: Scalars['Int'];
  /** Details about where the move will be made to. */
  readonly to: InventoryMoveQuantityTerminalInput;
};

/** The input fields representing the change to be made to an inventory item at a location. */
export type InventoryMoveQuantityTerminalInput = {
  /**
   * A freeform URI that represents what changed the inventory quantities. A Shopify global ID isn't an accepted
   * value. For example, specifying "gid://shopify/Order/123" would return an error. This field is required for a move of
   * all quantity names except `available`. The field `ledgerDocumentUri` isn't supported for use with an
   * `available` quantity name.
   */
  readonly ledgerDocumentUri?: InputMaybe<Scalars['String']>;
  /** Specifies the location at which the change will be applied. */
  readonly locationId: Scalars['ID'];
  /**
   * The quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states) to be
   * moved.
   */
  readonly name: Scalars['String'];
};

/** General inventory properties for the shop. */
export type InventoryProperties = {
  /** All the quantity names. */
  readonly quantityNames: ReadonlyArray<InventoryQuantityName>;
};

/** Represents a quantity of an inventory item at a specific location, for a specific name. */
export type InventoryQuantity = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states)
   * that identifies the inventory quantity.
   */
  readonly name: Scalars['String'];
  /** The quantity for the quantity name. */
  readonly quantity: Scalars['Int'];
  /** When the quantity was last updated. */
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

/** The input fields for the quantity to be set for an inventory item at a location. */
export type InventoryQuantityInput = {
  /** The current quantity to be compared against the persisted quantity. */
  readonly compareQuantity?: InputMaybe<Scalars['Int']>;
  /** Specifies the inventory item to which the quantity will be set. */
  readonly inventoryItemId: Scalars['ID'];
  /** Specifies the location at which the quantity will be set. */
  readonly locationId: Scalars['ID'];
  /** The quantity to which the inventory quantity will be set. */
  readonly quantity: Scalars['Int'];
};

/** Details about an individual quantity name. */
export type InventoryQuantityName = {
  /** List of quantity names that this quantity name belongs to. */
  readonly belongsTo: ReadonlyArray<Scalars['String']>;
  /** List of quantity names that comprise this quantity name. */
  readonly comprises: ReadonlyArray<Scalars['String']>;
  /** The display name for quantity names translated into applicable language. */
  readonly displayName?: Maybe<Scalars['String']>;
  /** Whether the quantity name has been used by the merchant. */
  readonly isInUse: Scalars['Boolean'];
  /**
   * The [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#inventory-states) of
   * the inventory quantity. Used by
   * [inventory queries and mutations](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps#graphql-queries-and-mutations).
   */
  readonly name: Scalars['String'];
};

/** Returns the scheduled changes to inventory states related to the ledger document. */
export type InventoryScheduledChange = {
  /** The date and time that the scheduled change is expected to happen. */
  readonly expectedAt: Scalars['DateTime'];
  /**
   * The quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#move-inventory-quantities-between-states)
   * to transition from.
   */
  readonly fromName: Scalars['String'];
  /** The quantities of an inventory item that are related to a specific location. */
  readonly inventoryLevel: InventoryLevel;
  /** A freeform URI that represents what changed the inventory quantities. */
  readonly ledgerDocumentUri: Scalars['URL'];
  /** The quantity of the scheduled change associated with the ledger document in the `fromName` state. */
  readonly quantity: Scalars['Int'];
  /**
   * The quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#move-inventory-quantities-between-states)
   * to transition to.
   */
  readonly toName: Scalars['String'];
};

/** An auto-generated type for paginating through multiple InventoryScheduledChanges. */
export type InventoryScheduledChangeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<InventoryScheduledChangeEdge>;
  /** A list of nodes that are contained in InventoryScheduledChangeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<InventoryScheduledChange>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one InventoryScheduledChange and a cursor during pagination. */
export type InventoryScheduledChangeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of InventoryScheduledChangeEdge. */
  readonly node: InventoryScheduledChange;
};

/** The input fields for a scheduled change of an inventory item. */
export type InventoryScheduledChangeInput = {
  /** The date and time that the scheduled change is expected to happen. */
  readonly expectedAt: Scalars['DateTime'];
  /**
   * The quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#move-inventory-quantities-between-states)
   * to transition from.
   */
  readonly fromName: Scalars['String'];
  /**
   * The quantity
   * [name](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#move-inventory-quantities-between-states)
   * to transition to.
   */
  readonly toName: Scalars['String'];
};

/** The input fields for the inventory item associated with the scheduled changes that need to be applied. */
export type InventoryScheduledChangeItemInput = {
  /** The ID of the inventory item. */
  readonly inventoryItemId: Scalars['ID'];
  /** A freeform URI that represents what changed the inventory quantities. */
  readonly ledgerDocumentUri: Scalars['URL'];
  /** The ID of the location. */
  readonly locationId: Scalars['ID'];
  /** An array of all the scheduled changes for the item. */
  readonly scheduledChanges: ReadonlyArray<InventoryScheduledChangeInput>;
};

/** The input fields required to set inventory on hand quantities. */
export type InventorySetOnHandQuantitiesInput = {
  /**
   * The reason for the quantity changes. The value must be one of the [possible
   * reasons](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#set-inventory-quantities-on-hand).
   */
  readonly reason: Scalars['String'];
  /**
   * A freeform URI that represents why the inventory change happened. This can be the entity adjusting inventory
   * quantities or the Shopify resource that's associated with the inventory adjustment. For example, a unit in a
   * draft order might have been previously reserved, and a merchant later creates an order from the draft order.
   * In this case, the `referenceDocumentUri` for the inventory adjustment is a URI referencing the order ID.
   */
  readonly referenceDocumentUri?: InputMaybe<Scalars['String']>;
  /** The value to which the on hand quantity will be set. */
  readonly setQuantities: ReadonlyArray<InventorySetQuantityInput>;
};

/** Return type for `inventorySetOnHandQuantities` mutation. */
export type InventorySetOnHandQuantitiesPayload = {
  /** The group of changes made by the operation. */
  readonly inventoryAdjustmentGroup?: Maybe<InventoryAdjustmentGroup>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<InventorySetOnHandQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventorySetOnHandQuantities`. */
export type InventorySetOnHandQuantitiesUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<InventorySetOnHandQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `InventorySetOnHandQuantitiesUserError`. */
export enum InventorySetOnHandQuantitiesUserErrorCode {
  /** The specified inventory item could not be found. */
  INVALID_INVENTORY_ITEM = 'INVALID_INVENTORY_ITEM',
  /** The specified location could not be found. */
  INVALID_LOCATION = 'INVALID_LOCATION',
  /** The quantity can't be negative. */
  INVALID_QUANTITY_NEGATIVE = 'INVALID_QUANTITY_NEGATIVE',
  /** The total quantity can't be higher than 1,000,000,000. */
  INVALID_QUANTITY_TOO_HIGH = 'INVALID_QUANTITY_TOO_HIGH',
  /** The specified reason is invalid. */
  INVALID_REASON = 'INVALID_REASON',
  /** The specified reference document is invalid. */
  INVALID_REFERENCE_DOCUMENT = 'INVALID_REFERENCE_DOCUMENT',
  /** The inventory item is not stocked at the location. */
  ITEM_NOT_STOCKED_AT_LOCATION = 'ITEM_NOT_STOCKED_AT_LOCATION',
  /** The specified inventory item is not allowed to be adjusted via API. Example: if the inventory item is a parent bundle. */
  NON_MUTABLE_INVENTORY_ITEM = 'NON_MUTABLE_INVENTORY_ITEM',
  /** The on-hand quantities couldn't be set. Try again. */
  SET_ON_HAND_QUANTITIES_FAILED = 'SET_ON_HAND_QUANTITIES_FAILED'
}

/** The input fields required to set inventory quantities. */
export type InventorySetQuantitiesInput = {
  /** Skip the compare quantity check in the quantities field. */
  readonly ignoreCompareQuantity?: InputMaybe<Scalars['Boolean']>;
  /** The name of quantities to be changed. The only accepted values are: `available` or `on_hand`. */
  readonly name: Scalars['String'];
  /** The values to which each quantities will be set. */
  readonly quantities: ReadonlyArray<InventoryQuantityInput>;
  /**
   * The reason for the quantity changes. The value must be one of the [possible
   * reasons](https://shopify.dev/docs/apps/fulfillment/inventory-management-apps/quantities-states#set-inventory-quantities-on-hand).
   */
  readonly reason: Scalars['String'];
  /**
   * A freeform URI that represents why the inventory change happened. This can be the entity adjusting inventory
   * quantities or the Shopify resource that's associated with the inventory adjustment. For example, a unit in a
   * draft order might have been previously reserved, and a merchant later creates an order from the draft order.
   * In this case, the `referenceDocumentUri` for the inventory adjustment is a URI referencing the order ID.
   */
  readonly referenceDocumentUri?: InputMaybe<Scalars['String']>;
};

/** Return type for `inventorySetQuantities` mutation. */
export type InventorySetQuantitiesPayload = {
  /** The group of changes made by the operation. */
  readonly inventoryAdjustmentGroup?: Maybe<InventoryAdjustmentGroup>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<InventorySetQuantitiesUserError>;
};

/** An error that occurs during the execution of `InventorySetQuantities`. */
export type InventorySetQuantitiesUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<InventorySetQuantitiesUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `InventorySetQuantitiesUserError`. */
export enum InventorySetQuantitiesUserErrorCode {
  /** The compareQuantity argument must be given to each quantity or ignored using ignoreCompareQuantity. */
  COMPARE_QUANTITY_REQUIRED = 'COMPARE_QUANTITY_REQUIRED',
  /** The compareQuantity value does not match persisted value. */
  COMPARE_QUANTITY_STALE = 'COMPARE_QUANTITY_STALE',
  /** The specified inventory item could not be found. */
  INVALID_INVENTORY_ITEM = 'INVALID_INVENTORY_ITEM',
  /** The specified location could not be found. */
  INVALID_LOCATION = 'INVALID_LOCATION',
  /** The quantity name must be either 'available' or 'on_hand'. */
  INVALID_NAME = 'INVALID_NAME',
  /** The quantity can't be negative. */
  INVALID_QUANTITY_NEGATIVE = 'INVALID_QUANTITY_NEGATIVE',
  /** The total quantity can't be higher than 1,000,000,000. */
  INVALID_QUANTITY_TOO_HIGH = 'INVALID_QUANTITY_TOO_HIGH',
  /** The total quantity can't be lower than -1,000,000,000. */
  INVALID_QUANTITY_TOO_LOW = 'INVALID_QUANTITY_TOO_LOW',
  /** The specified reason is invalid. */
  INVALID_REASON = 'INVALID_REASON',
  /** The specified reference document is invalid. */
  INVALID_REFERENCE_DOCUMENT = 'INVALID_REFERENCE_DOCUMENT',
  /** The specified inventory item is not stocked at the location. */
  ITEM_NOT_STOCKED_AT_LOCATION = 'ITEM_NOT_STOCKED_AT_LOCATION',
  /** The specified inventory item is not allowed to be adjusted via API. Example: if the inventory item is a parent bundle. */
  NON_MUTABLE_INVENTORY_ITEM = 'NON_MUTABLE_INVENTORY_ITEM',
  /** The combination of inventoryItemId and locationId must be unique. */
  NO_DUPLICATE_INVENTORY_ITEM_ID_GROUP_ID_PAIR = 'NO_DUPLICATE_INVENTORY_ITEM_ID_GROUP_ID_PAIR'
}

/** The input fields for the quantity to be set for an inventory item at a location. */
export type InventorySetQuantityInput = {
  /** Specifies the inventory item to which the quantity will be set. */
  readonly inventoryItemId: Scalars['ID'];
  /** Specifies the location at which the quantity will be set. */
  readonly locationId: Scalars['ID'];
  /** The quantity to which the inventory quantity will be set. */
  readonly quantity: Scalars['Int'];
};

/** The input fields for setting up scheduled changes of inventory items. */
export type InventorySetScheduledChangesInput = {
  /** The list of all the items on which the scheduled changes need to be applied. */
  readonly items: ReadonlyArray<InventoryScheduledChangeItemInput>;
  /** The reason for setting up the scheduled changes. */
  readonly reason: Scalars['String'];
  /**
   * A freeform URI that represents why the inventory change happened. This can be the entity adjusting inventory
   * quantities or the Shopify resource that's associated with the inventory adjustment. For example, a unit in a
   * draft order might have been previously reserved, and a merchant later creates an order from the draft order.
   * In this case, the `referenceDocumentUri` for the inventory adjustment is a URI referencing the order ID.
   */
  readonly referenceDocumentUri: Scalars['URL'];
};

/** Return type for `inventorySetScheduledChanges` mutation. */
export type InventorySetScheduledChangesPayload = {
  /** The scheduled changes that were created. */
  readonly scheduledChanges?: Maybe<ReadonlyArray<InventoryScheduledChange>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<InventorySetScheduledChangesUserError>;
};

/** An error that occurs during the execution of `InventorySetScheduledChanges`. */
export type InventorySetScheduledChangesUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<InventorySetScheduledChangesUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `InventorySetScheduledChangesUserError`. */
export enum InventorySetScheduledChangesUserErrorCode {
  /** The item can only have one scheduled change for quantity name as the fromName. */
  DUPLICATE_FROM_NAME = 'DUPLICATE_FROM_NAME',
  /** The item can only have one scheduled change for quantity name as the toName. */
  DUPLICATE_TO_NAME = 'DUPLICATE_TO_NAME',
  /** There was an error updating the scheduled changes. */
  ERROR_UPDATING_SCHEDULED = 'ERROR_UPDATING_SCHEDULED',
  /** The specified field is invalid. */
  INCLUSION = 'INCLUSION',
  /** The specified fromName is invalid. */
  INVALID_FROM_NAME = 'INVALID_FROM_NAME',
  /** The specified reason is invalid. */
  INVALID_REASON = 'INVALID_REASON',
  /** The specified toName is invalid. */
  INVALID_TO_NAME = 'INVALID_TO_NAME',
  /** The inventory item was not found. */
  INVENTORY_ITEM_NOT_FOUND = 'INVENTORY_ITEM_NOT_FOUND',
  /** The inventory item was not found at the location specified. */
  INVENTORY_STATE_NOT_FOUND = 'INVENTORY_STATE_NOT_FOUND',
  /** At least 1 item must be provided. */
  ITEMS_EMPTY = 'ITEMS_EMPTY',
  /** The ledger document URI is invalid. */
  LEDGER_DOCUMENT_INVALID = 'LEDGER_DOCUMENT_INVALID',
  /** The location couldn't be found. */
  LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND',
  /** The from_name and to_name can't be the same. */
  SAME_FROM_TO_NAMES = 'SAME_FROM_TO_NAMES'
}

/** A job corresponds to some long running task that the client should poll for status. */
export type Job = {
  /** This indicates if the job is still queued or has been run. */
  readonly done: Scalars['Boolean'];
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  readonly id: Scalars['ID'];
  /** This field will only resolve once the job is done. Can be used to ask for object(s) that have been changed by the job. */
  readonly query?: Maybe<QueryRoot>;
};

/** A job corresponds to some long running task that the client should poll for status. */
export type JobResult = {
  /** This indicates if the job is still queued or has been run. */
  readonly done: Scalars['Boolean'];
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  readonly id: Scalars['ID'];
};

/** Language codes supported by Shopify. */
export enum LanguageCode {
  /** Afrikaans. */
  AF = 'AF',
  /** Akan. */
  AK = 'AK',
  /** Amharic. */
  AM = 'AM',
  /** Arabic. */
  AR = 'AR',
  /** Assamese. */
  AS = 'AS',
  /** Azerbaijani. */
  AZ = 'AZ',
  /** Belarusian. */
  BE = 'BE',
  /** Bulgarian. */
  BG = 'BG',
  /** Bambara. */
  BM = 'BM',
  /** Bangla. */
  BN = 'BN',
  /** Tibetan. */
  BO = 'BO',
  /** Breton. */
  BR = 'BR',
  /** Bosnian. */
  BS = 'BS',
  /** Catalan. */
  CA = 'CA',
  /** Chechen. */
  CE = 'CE',
  /** Central Kurdish. */
  CKB = 'CKB',
  /** Czech. */
  CS = 'CS',
  /** Church Slavic. */
  CU = 'CU',
  /** Welsh. */
  CY = 'CY',
  /** Danish. */
  DA = 'DA',
  /** German. */
  DE = 'DE',
  /** Dzongkha. */
  DZ = 'DZ',
  /** Ewe. */
  EE = 'EE',
  /** Greek. */
  EL = 'EL',
  /** English. */
  EN = 'EN',
  /** Esperanto. */
  EO = 'EO',
  /** Spanish. */
  ES = 'ES',
  /** Estonian. */
  ET = 'ET',
  /** Basque. */
  EU = 'EU',
  /** Persian. */
  FA = 'FA',
  /** Fulah. */
  FF = 'FF',
  /** Finnish. */
  FI = 'FI',
  /** Filipino. */
  FIL = 'FIL',
  /** Faroese. */
  FO = 'FO',
  /** French. */
  FR = 'FR',
  /** Western Frisian. */
  FY = 'FY',
  /** Irish. */
  GA = 'GA',
  /** Scottish Gaelic. */
  GD = 'GD',
  /** Galician. */
  GL = 'GL',
  /** Gujarati. */
  GU = 'GU',
  /** Manx. */
  GV = 'GV',
  /** Hausa. */
  HA = 'HA',
  /** Hebrew. */
  HE = 'HE',
  /** Hindi. */
  HI = 'HI',
  /** Croatian. */
  HR = 'HR',
  /** Hungarian. */
  HU = 'HU',
  /** Armenian. */
  HY = 'HY',
  /** Interlingua. */
  IA = 'IA',
  /** Indonesian. */
  ID = 'ID',
  /** Igbo. */
  IG = 'IG',
  /** Sichuan Yi. */
  II = 'II',
  /** Icelandic. */
  IS = 'IS',
  /** Italian. */
  IT = 'IT',
  /** Japanese. */
  JA = 'JA',
  /** Javanese. */
  JV = 'JV',
  /** Georgian. */
  KA = 'KA',
  /** Kikuyu. */
  KI = 'KI',
  /** Kazakh. */
  KK = 'KK',
  /** Kalaallisut. */
  KL = 'KL',
  /** Khmer. */
  KM = 'KM',
  /** Kannada. */
  KN = 'KN',
  /** Korean. */
  KO = 'KO',
  /** Kashmiri. */
  KS = 'KS',
  /** Kurdish. */
  KU = 'KU',
  /** Cornish. */
  KW = 'KW',
  /** Kyrgyz. */
  KY = 'KY',
  /** Luxembourgish. */
  LB = 'LB',
  /** Ganda. */
  LG = 'LG',
  /** Lingala. */
  LN = 'LN',
  /** Lao. */
  LO = 'LO',
  /** Lithuanian. */
  LT = 'LT',
  /** Luba-Katanga. */
  LU = 'LU',
  /** Latvian. */
  LV = 'LV',
  /** Malagasy. */
  MG = 'MG',
  /** Māori. */
  MI = 'MI',
  /** Macedonian. */
  MK = 'MK',
  /** Malayalam. */
  ML = 'ML',
  /** Mongolian. */
  MN = 'MN',
  /** Marathi. */
  MR = 'MR',
  /** Malay. */
  MS = 'MS',
  /** Maltese. */
  MT = 'MT',
  /** Burmese. */
  MY = 'MY',
  /** Norwegian (Bokmål). */
  NB = 'NB',
  /** North Ndebele. */
  ND = 'ND',
  /** Nepali. */
  NE = 'NE',
  /** Dutch. */
  NL = 'NL',
  /** Norwegian Nynorsk. */
  NN = 'NN',
  /** Norwegian. */
  NO = 'NO',
  /** Oromo. */
  OM = 'OM',
  /** Odia. */
  OR = 'OR',
  /** Ossetic. */
  OS = 'OS',
  /** Punjabi. */
  PA = 'PA',
  /** Polish. */
  PL = 'PL',
  /** Pashto. */
  PS = 'PS',
  /** Portuguese. */
  PT = 'PT',
  /** Portuguese (Brazil). */
  PT_BR = 'PT_BR',
  /** Portuguese (Portugal). */
  PT_PT = 'PT_PT',
  /** Quechua. */
  QU = 'QU',
  /** Romansh. */
  RM = 'RM',
  /** Rundi. */
  RN = 'RN',
  /** Romanian. */
  RO = 'RO',
  /** Russian. */
  RU = 'RU',
  /** Kinyarwanda. */
  RW = 'RW',
  /** Sanskrit. */
  SA = 'SA',
  /** Sardinian. */
  SC = 'SC',
  /** Sindhi. */
  SD = 'SD',
  /** Northern Sami. */
  SE = 'SE',
  /** Sango. */
  SG = 'SG',
  /** Sinhala. */
  SI = 'SI',
  /** Slovak. */
  SK = 'SK',
  /** Slovenian. */
  SL = 'SL',
  /** Shona. */
  SN = 'SN',
  /** Somali. */
  SO = 'SO',
  /** Albanian. */
  SQ = 'SQ',
  /** Serbian. */
  SR = 'SR',
  /** Sundanese. */
  SU = 'SU',
  /** Swedish. */
  SV = 'SV',
  /** Swahili. */
  SW = 'SW',
  /** Tamil. */
  TA = 'TA',
  /** Telugu. */
  TE = 'TE',
  /** Tajik. */
  TG = 'TG',
  /** Thai. */
  TH = 'TH',
  /** Tigrinya. */
  TI = 'TI',
  /** Turkmen. */
  TK = 'TK',
  /** Tongan. */
  TO = 'TO',
  /** Turkish. */
  TR = 'TR',
  /** Tatar. */
  TT = 'TT',
  /** Uyghur. */
  UG = 'UG',
  /** Ukrainian. */
  UK = 'UK',
  /** Urdu. */
  UR = 'UR',
  /** Uzbek. */
  UZ = 'UZ',
  /** Vietnamese. */
  VI = 'VI',
  /** Volapük. */
  VO = 'VO',
  /** Wolof. */
  WO = 'WO',
  /** Xhosa. */
  XH = 'XH',
  /** Yiddish. */
  YI = 'YI',
  /** Yoruba. */
  YO = 'YO',
  /** Chinese. */
  ZH = 'ZH',
  /** Chinese (Simplified). */
  ZH_CN = 'ZH_CN',
  /** Chinese (Traditional). */
  ZH_TW = 'ZH_TW',
  /** Zulu. */
  ZU = 'ZU'
}

/**
 * Interoperability metadata for types that directly correspond to a REST Admin API resource.
 * For example, on the Product type, LegacyInteroperability returns metadata for the corresponding [Product object](https://shopify.dev/api/admin-graphql/latest/objects/product) in the REST Admin API.
 */
export type LegacyInteroperability = {
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
};

/** Units of measurement for length. */
export enum LengthUnit {
  /** 100 centimeters equals 1 meter. */
  CENTIMETERS = 'CENTIMETERS',
  /** Imperial system unit of length. */
  FEET = 'FEET',
  /** 12 inches equals 1 foot. */
  INCHES = 'INCHES',
  /** Metric system unit of length. */
  METERS = 'METERS',
  /** 1000 millimeters equals 1 meter. */
  MILLIMETERS = 'MILLIMETERS',
  /** 1 yard equals 3 feet. */
  YARDS = 'YARDS'
}

/**
 * The total number of pending orders on a shop if less then a maximum, or that maximum.
 * The atMax field indicates when this maximum has been reached.
 */
export type LimitedPendingOrderCount = {
  /** This is set when the number of pending orders has reached the maximum. */
  readonly atMax: Scalars['Boolean'];
  /**
   * The number of pendings orders on the shop.
   * Limited to a maximum of 10000.
   */
  readonly count: Scalars['Int'];
};

/** Represents individual products and quantities purchased in the associated order. */
export type LineItem = Node & {
  /**
   * Whether the line item can be restocked.
   * @deprecated Use `restockable` instead.
   */
  readonly canRestock: Scalars['Boolean'];
  /** The subscription contract associated with this line item. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The number of units ordered, excluding refunded and removed units. */
  readonly currentQuantity: Scalars['Int'];
  /** A list of attributes that represent custom features or special requests. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The discounts that have been allocated to the line item by discount applications, including discounts allocated to refunded and removed quantities. */
  readonly discountAllocations: ReadonlyArray<DiscountAllocation>;
  /**
   * The total discounted price of the line item in shop currency, including refunded and removed quantities. This value doesn't include order-level discounts.
   * @deprecated Use `discountedTotalSet` instead.
   */
  readonly discountedTotal: Scalars['Money'];
  /** The total discounted price of the line item in shop and presentment currencies, including refunded and removed quantities. This value doesn't include order-level discounts. Code-based discounts aren't included by default. */
  readonly discountedTotalSet: MoneyBag;
  /**
   * The approximate unit price of the line item in shop currency. This value includes line-level discounts and discounts applied to refunded and removed quantities. It doesn't include order-level or code-based discounts.
   * @deprecated Use `discountedUnitPriceSet` instead.
   */
  readonly discountedUnitPrice: Scalars['Money'];
  /** The approximate unit price of the line item in shop and presentment currencies. This value includes discounts applied to refunded and removed quantities. */
  readonly discountedUnitPriceAfterAllDiscountsSet: MoneyBag;
  /** The approximate unit price of the line item in shop and presentment currencies. This value includes line-level discounts and discounts applied to refunded and removed quantities. It doesn't include order-level or code-based discounts. */
  readonly discountedUnitPriceSet: MoneyBag;
  /** The duties associated with the line item. */
  readonly duties: ReadonlyArray<Duty>;
  /**
   * The total number of units to fulfill.
   * @deprecated Use [FulfillmentOrderLineItem#remainingQuantity](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderLineItem#field-fulfillmentorderlineitem-remainingquantity) instead.
   */
  readonly fulfillableQuantity: Scalars['Int'];
  /**
   * The fulfillment service that stocks the product variant belonging to a line item.
   *
   * This is a third-party fulfillment service in the following scenarios:
   *
   * **Scenario 1**
   * - The product variant is stocked by a single fulfillment service.
   * - The [FulfillmentService](/api/admin-graphql/latest/objects/FulfillmentService) is a third-party fulfillment service. Third-party fulfillment services don't have a handle with the value `manual`.
   *
   * **Scenario 2**
   * - Multiple fulfillment services stock the product variant.
   * - The last time that the line item was unfulfilled, it was awaiting fulfillment by a third-party fulfillment service. Third-party fulfillment services don't have a handle with the value `manual`.
   *
   * If none of the above conditions are met, then the fulfillment service has the `manual` handle.
   * @deprecated
   * The [relationship between a product variant and a fulfillment service was changed in the `2022-07` API version](/changelog/fulfillment-service-sku-sharing). A [ProductVariant](/api/admin-graphql/latest/objects/ProductVariant) can be stocked by multiple fulfillment services. As a result, we recommend that you use the [inventoryItem field](/api/admin-graphql/latest/objects/ProductVariant#field-productvariant-inventoryitem) if you need to determine where a product variant is stocked.
   *
   * If you need to determine whether a product is a gift card, then you should continue to use this field until an alternative is available.
   *
   * Altering the locations which stock a product variant won't change the value of this field for existing orders.
   *
   * Learn about [managing inventory quantities and states](/apps/fulfillment/inventory-management-apps/quantities-states).
   *
   */
  readonly fulfillmentService?: Maybe<FulfillmentService>;
  /**
   * The line item's fulfillment status. Returns 'fulfilled' if fulfillableQuantity >= quantity,
   * 'partial' if  fulfillableQuantity > 0, and 'unfulfilled' otherwise.
   * @deprecated Use [FulfillmentOrderLineItem#remainingQuantity](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrderLineItem#field-fulfillmentorderlineitem-remainingquantity) instead
   */
  readonly fulfillmentStatus: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image associated to the line item's variant. */
  readonly image?: Maybe<Image>;
  /** Whether the line item represents the purchase of a gift card. */
  readonly isGiftCard: Scalars['Boolean'];
  /** The line item group associated to the line item. */
  readonly lineItemGroup?: Maybe<LineItemGroup>;
  /** Whether the line item can be edited or not. */
  readonly merchantEditable: Scalars['Boolean'];
  /** The title of the product, optionally appended with the title of the variant (if applicable). */
  readonly name: Scalars['String'];
  /** The total number of units that can't be fulfilled. For example, if items have been refunded, or the item is not something that can be fulfilled, like a tip. Please see the [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder) object for more fulfillment details. */
  readonly nonFulfillableQuantity: Scalars['Int'];
  /**
   * In shop currency, the total price of the line item when the order was created.
   * This value doesn't include discounts.
   * @deprecated Use `originalTotalSet` instead.
   */
  readonly originalTotal: Scalars['Money'];
  /**
   * In shop and presentment currencies, the total price of the line item when the order was created.
   * This value doesn't include discounts.
   */
  readonly originalTotalSet: MoneyBag;
  /**
   * In shop currency, the unit price of the line item when the order was created. This value doesn't include discounts.
   * @deprecated Use `originalUnitPriceSet` instead.
   */
  readonly originalUnitPrice: Scalars['Money'];
  /** In shop and presentment currencies, the unit price of the line item when the order was created. This value doesn't include discounts. */
  readonly originalUnitPriceSet: MoneyBag;
  /** The Product object associated with this line item's variant. */
  readonly product?: Maybe<Product>;
  /** The number of units ordered, including refunded and removed units. */
  readonly quantity: Scalars['Int'];
  /** The number of units ordered, excluding refunded units. */
  readonly refundableQuantity: Scalars['Int'];
  /** Whether physical shipping is required for the variant. */
  readonly requiresShipping: Scalars['Boolean'];
  /** Whether the line item can be restocked. */
  readonly restockable: Scalars['Boolean'];
  /** The selling plan details associated with the line item. */
  readonly sellingPlan?: Maybe<LineItemSellingPlan>;
  /** The variant SKU number. */
  readonly sku?: Maybe<Scalars['String']>;
  /** Staff attributed to the line item. */
  readonly staffMember?: Maybe<StaffMember>;
  /** The taxes charged for the line item, including taxes charged for refunded and removed quantities. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Whether the variant is taxable. */
  readonly taxable: Scalars['Boolean'];
  /** The title of the product at time of order creation. */
  readonly title: Scalars['String'];
  /**
   * The total discount allocated to the line item in shop currency, including the total allocated to refunded and removed quantities. This value doesn't include order-level discounts.
   * @deprecated Use `totalDiscountSet` instead.
   */
  readonly totalDiscount: Scalars['Money'];
  /** The total discount allocated to the line item in shop and presentment currencies, including the total allocated to refunded and removed quantities. This value doesn't include order-level discounts. */
  readonly totalDiscountSet: MoneyBag;
  /**
   * In shop currency, the total discounted price of the unfulfilled quantity for the line item.
   * @deprecated Use `unfulfilledDiscountedTotalSet` instead.
   */
  readonly unfulfilledDiscountedTotal: Scalars['Money'];
  /** In shop and presentment currencies, the total discounted price of the unfulfilled quantity for the line item. */
  readonly unfulfilledDiscountedTotalSet: MoneyBag;
  /**
   * In shop currency, the total price of the unfulfilled quantity for the line item. This value doesn't include discounts.
   * @deprecated Use `unfulfilledOriginalTotalSet` instead.
   */
  readonly unfulfilledOriginalTotal: Scalars['Money'];
  /** In shop and presentment currencies, the total price of the unfulfilled quantity for the line item. This value doesn't include discounts. */
  readonly unfulfilledOriginalTotalSet: MoneyBag;
  /** The number of units not yet fulfilled. */
  readonly unfulfilledQuantity: Scalars['Int'];
  /** The Variant object associated with this line item. */
  readonly variant?: Maybe<ProductVariant>;
  /** The title of the variant at time of order creation. */
  readonly variantTitle?: Maybe<Scalars['String']>;
  /** The name of the vendor who made the variant. */
  readonly vendor?: Maybe<Scalars['String']>;
};


/** Represents individual products and quantities purchased in the associated order. */
export type LineItemDiscountedTotalSetArgs = {
  withCodeDiscounts?: InputMaybe<Scalars['Boolean']>;
};


/** Represents individual products and quantities purchased in the associated order. */
export type LineItemTaxLinesArgs = {
  first?: InputMaybe<Scalars['Int']>;
};

/** An auto-generated type for paginating through multiple LineItems. */
export type LineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<LineItemEdge>;
  /** A list of nodes that are contained in LineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<LineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one LineItem and a cursor during pagination. */
export type LineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of LineItemEdge. */
  readonly node: LineItem;
};

/** A line item group (bundle) to which a line item belongs to. */
export type LineItemGroup = Node & {
  /** A list of attributes that represent custom features or special requests. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Quantity of the line item group on the order. */
  readonly quantity: Scalars['Int'];
  /** Title of the line item group. */
  readonly title: Scalars['String'];
  /** ID of the variant of the line item group. */
  readonly variantId?: Maybe<Scalars['ID']>;
  /** SKU of the variant of the line item group. */
  readonly variantSku?: Maybe<Scalars['String']>;
};

/** Represents the selling plan for a line item. */
export type LineItemSellingPlan = {
  /** The name of the selling plan for display purposes. */
  readonly name: Scalars['String'];
  /** The ID of the selling plan associated with the line item. */
  readonly sellingPlanId?: Maybe<Scalars['ID']>;
};

/** A link to direct users to. */
export type Link = HasPublishedTranslations & {
  /** A context-sensitive label for the link. */
  readonly label: Scalars['String'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The URL that the link visits. */
  readonly url: Scalars['URL'];
};


/** A link to direct users to. */
export type LinkTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/**
 * The identifier for the metafield linked to this option.
 *
 * This API is currently in early access. See [Metafield-linked product options](https://shopify.dev/docs/api/admin/migrate/new-product-model/metafield-linked) for more details.
 */
export type LinkedMetafield = {
  /** Key of the metafield the option is linked to. */
  readonly key?: Maybe<Scalars['String']>;
  /** Namespace of the metafield the option is linked to. */
  readonly namespace?: Maybe<Scalars['String']>;
};

/** The input fields required to link a product option to a metafield. */
export type LinkedMetafieldCreateInput = {
  /** The key of the metafield this option is linked to. */
  readonly key: Scalars['String'];
  /** The namespace of the metafield this option is linked to. */
  readonly namespace: Scalars['String'];
  /** Values associated with the option. */
  readonly values?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

/** The input fields for linking a combined listing option to a metafield. */
export type LinkedMetafieldInput = {
  /** The key of the linked metafield. */
  readonly key: Scalars['String'];
  /** The namespace of the linked metafield. */
  readonly namespace: Scalars['String'];
  /** The values of the linked metafield. */
  readonly values: ReadonlyArray<Scalars['String']>;
};

/**
 * The input fields required to link a product option to a metafield.
 *
 * This API is currently in early access. See [Metafield-linked product options](https://shopify.dev/docs/api/admin/migrate/new-product-model/metafield-linked) for more details.
 */
export type LinkedMetafieldUpdateInput = {
  /** The key of the metafield this option is linked to. */
  readonly key: Scalars['String'];
  /** The namespace of the metafield this option is linked to. */
  readonly namespace: Scalars['String'];
};

/** Local payment methods payment details related to a transaction. */
export type LocalPaymentMethodsPaymentDetails = BasePaymentDetails & {
  /** The descriptor by the payment provider. Only available for Amazon Pay and Buy with Prime. */
  readonly paymentDescriptor?: Maybe<Scalars['String']>;
  /** The name of payment method used by the buyer. */
  readonly paymentMethodName?: Maybe<Scalars['String']>;
};

/** A locale. */
export type Locale = {
  /** Locale ISO code. */
  readonly isoCode: Scalars['String'];
  /** Human-readable locale name. */
  readonly name: Scalars['String'];
};

/** Specifies the type of the underlying localizable content. This can be used to conditionally render different UI elements such as input fields. */
export enum LocalizableContentType {
  /** A file reference. */
  FILE_REFERENCE = 'FILE_REFERENCE',
  /** An HTML. */
  HTML = 'HTML',
  /** An inline rich text. */
  INLINE_RICH_TEXT = 'INLINE_RICH_TEXT',
  /** A JSON. */
  JSON = 'JSON',
  /** A JSON string. */
  JSON_STRING = 'JSON_STRING',
  /** A link. */
  LINK = 'LINK',
  /** A list of file references. */
  LIST_FILE_REFERENCE = 'LIST_FILE_REFERENCE',
  /** A list of links. */
  LIST_LINK = 'LIST_LINK',
  /** A list of multi-line texts. */
  LIST_MULTI_LINE_TEXT_FIELD = 'LIST_MULTI_LINE_TEXT_FIELD',
  /** A list of single-line texts. */
  LIST_SINGLE_LINE_TEXT_FIELD = 'LIST_SINGLE_LINE_TEXT_FIELD',
  /** A list of URLs. */
  LIST_URL = 'LIST_URL',
  /** A multi-line text. */
  MULTI_LINE_TEXT_FIELD = 'MULTI_LINE_TEXT_FIELD',
  /** A rich text. */
  RICH_TEXT_FIELD = 'RICH_TEXT_FIELD',
  /** A single-line text. */
  SINGLE_LINE_TEXT_FIELD = 'SINGLE_LINE_TEXT_FIELD',
  /** A string. */
  STRING = 'STRING',
  /** A URI. */
  URI = 'URI',
  /** A URL. */
  URL = 'URL'
}

/** Represents the value captured by a localization extension. Localization extensions are additional fields required by certain countries on international orders. For example, some countries require additional fields for customs information or tax identification numbers. */
export type LocalizationExtension = {
  /** Country ISO 3166-1 alpha-2 code. */
  readonly countryCode: CountryCode;
  /** The localized extension keys that are allowed. */
  readonly key: LocalizationExtensionKey;
  /** The purpose of this localization extension. */
  readonly purpose: LocalizationExtensionPurpose;
  /** The localized extension title. */
  readonly title: Scalars['String'];
  /** The value of the field. */
  readonly value: Scalars['String'];
};

/** An auto-generated type for paginating through multiple LocalizationExtensions. */
export type LocalizationExtensionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<LocalizationExtensionEdge>;
  /** A list of nodes that are contained in LocalizationExtensionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<LocalizationExtension>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one LocalizationExtension and a cursor during pagination. */
export type LocalizationExtensionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of LocalizationExtensionEdge. */
  readonly node: LocalizationExtension;
};

/** The input fields for a LocalizationExtensionInput. */
export type LocalizationExtensionInput = {
  /** The key for the localization extension. */
  readonly key: LocalizationExtensionKey;
  /** The localization extension value. */
  readonly value: Scalars['String'];
};

/** The key of a localization extension. */
export enum LocalizationExtensionKey {
  /** Extension key 'shipping_credential_br' for country BR. */
  SHIPPING_CREDENTIAL_BR = 'SHIPPING_CREDENTIAL_BR',
  /** Extension key 'shipping_credential_cl' for country CL. */
  SHIPPING_CREDENTIAL_CL = 'SHIPPING_CREDENTIAL_CL',
  /** Extension key 'shipping_credential_cn' for country CN. */
  SHIPPING_CREDENTIAL_CN = 'SHIPPING_CREDENTIAL_CN',
  /** Extension key 'shipping_credential_co' for country CO. */
  SHIPPING_CREDENTIAL_CO = 'SHIPPING_CREDENTIAL_CO',
  /** Extension key 'shipping_credential_cr' for country CR. */
  SHIPPING_CREDENTIAL_CR = 'SHIPPING_CREDENTIAL_CR',
  /** Extension key 'shipping_credential_ec' for country EC. */
  SHIPPING_CREDENTIAL_EC = 'SHIPPING_CREDENTIAL_EC',
  /** Extension key 'shipping_credential_es' for country ES. */
  SHIPPING_CREDENTIAL_ES = 'SHIPPING_CREDENTIAL_ES',
  /** Extension key 'shipping_credential_gt' for country GT. */
  SHIPPING_CREDENTIAL_GT = 'SHIPPING_CREDENTIAL_GT',
  /** Extension key 'shipping_credential_id' for country ID. */
  SHIPPING_CREDENTIAL_ID = 'SHIPPING_CREDENTIAL_ID',
  /** Extension key 'shipping_credential_kr' for country KR. */
  SHIPPING_CREDENTIAL_KR = 'SHIPPING_CREDENTIAL_KR',
  /** Extension key 'shipping_credential_my' for country MY. */
  SHIPPING_CREDENTIAL_MY = 'SHIPPING_CREDENTIAL_MY',
  /** Extension key 'shipping_credential_pe' for country PE. */
  SHIPPING_CREDENTIAL_PE = 'SHIPPING_CREDENTIAL_PE',
  /** Extension key 'shipping_credential_pt' for country PT. */
  SHIPPING_CREDENTIAL_PT = 'SHIPPING_CREDENTIAL_PT',
  /** Extension key 'shipping_credential_py' for country PY. */
  SHIPPING_CREDENTIAL_PY = 'SHIPPING_CREDENTIAL_PY',
  /** Extension key 'shipping_credential_tr' for country TR. */
  SHIPPING_CREDENTIAL_TR = 'SHIPPING_CREDENTIAL_TR',
  /** Extension key 'shipping_credential_tw' for country TW. */
  SHIPPING_CREDENTIAL_TW = 'SHIPPING_CREDENTIAL_TW',
  /** Extension key 'shipping_credential_type_co' for country CO. */
  SHIPPING_CREDENTIAL_TYPE_CO = 'SHIPPING_CREDENTIAL_TYPE_CO',
  /** Extension key 'tax_credential_br' for country BR. */
  TAX_CREDENTIAL_BR = 'TAX_CREDENTIAL_BR',
  /** Extension key 'tax_credential_cl' for country CL. */
  TAX_CREDENTIAL_CL = 'TAX_CREDENTIAL_CL',
  /** Extension key 'tax_credential_co' for country CO. */
  TAX_CREDENTIAL_CO = 'TAX_CREDENTIAL_CO',
  /** Extension key 'tax_credential_cr' for country CR. */
  TAX_CREDENTIAL_CR = 'TAX_CREDENTIAL_CR',
  /** Extension key 'tax_credential_ec' for country EC. */
  TAX_CREDENTIAL_EC = 'TAX_CREDENTIAL_EC',
  /** Extension key 'tax_credential_es' for country ES. */
  TAX_CREDENTIAL_ES = 'TAX_CREDENTIAL_ES',
  /** Extension key 'tax_credential_gt' for country GT. */
  TAX_CREDENTIAL_GT = 'TAX_CREDENTIAL_GT',
  /** Extension key 'tax_credential_id' for country ID. */
  TAX_CREDENTIAL_ID = 'TAX_CREDENTIAL_ID',
  /** Extension key 'tax_credential_it' for country IT. */
  TAX_CREDENTIAL_IT = 'TAX_CREDENTIAL_IT',
  /** Extension key 'tax_credential_mx' for country MX. */
  TAX_CREDENTIAL_MX = 'TAX_CREDENTIAL_MX',
  /** Extension key 'tax_credential_my' for country MY. */
  TAX_CREDENTIAL_MY = 'TAX_CREDENTIAL_MY',
  /** Extension key 'tax_credential_pe' for country PE. */
  TAX_CREDENTIAL_PE = 'TAX_CREDENTIAL_PE',
  /** Extension key 'tax_credential_pt' for country PT. */
  TAX_CREDENTIAL_PT = 'TAX_CREDENTIAL_PT',
  /** Extension key 'tax_credential_py' for country PY. */
  TAX_CREDENTIAL_PY = 'TAX_CREDENTIAL_PY',
  /** Extension key 'tax_credential_tr' for country TR. */
  TAX_CREDENTIAL_TR = 'TAX_CREDENTIAL_TR',
  /** Extension key 'tax_credential_type_co' for country CO. */
  TAX_CREDENTIAL_TYPE_CO = 'TAX_CREDENTIAL_TYPE_CO',
  /** Extension key 'tax_credential_type_mx' for country MX. */
  TAX_CREDENTIAL_TYPE_MX = 'TAX_CREDENTIAL_TYPE_MX',
  /** Extension key 'tax_credential_use_mx' for country MX. */
  TAX_CREDENTIAL_USE_MX = 'TAX_CREDENTIAL_USE_MX',
  /** Extension key 'tax_email_it' for country IT. */
  TAX_EMAIL_IT = 'TAX_EMAIL_IT'
}

/** The purpose of a localization extension. */
export enum LocalizationExtensionPurpose {
  /** Extensions that are used for shipping purposes, for example, customs clearance. */
  SHIPPING = 'SHIPPING',
  /** Extensions that are used for taxes purposes, for example, invoicing. */
  TAX = 'TAX'
}

/**
 * Represents the location where the physical good resides. You can stock inventory at active locations. Active
 * locations that have `fulfills_online_orders: true` and are configured with a shipping rate, pickup enabled or
 * local delivery will be able to sell from their storefront.
 */
export type Location = HasMetafieldDefinitions & HasMetafields & LegacyInteroperability & Node & {
  /**
   * Whether the location can be reactivated. If `false`, then trying to activate the location with the
   * [`LocationActivate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/locationActivate)
   * mutation will return an error that describes why the location can't be activated.
   */
  readonly activatable: Scalars['Boolean'];
  /** The address of this location. */
  readonly address: LocationAddress;
  /** Whether the location address has been verified. */
  readonly addressVerified: Scalars['Boolean'];
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) that the location was added to a shop. */
  readonly createdAt: Scalars['DateTime'];
  /**
   * Whether this location can be deactivated. If `true`, then the location can be deactivated by calling the
   * [`LocationDeactivate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/locationDeactivate)
   * mutation. If `false`, then calling the mutation to deactivate it will return an error that describes why the
   * location can't be deactivated.
   */
  readonly deactivatable: Scalars['Boolean'];
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) that the location was deactivated at. For example, 3:30 pm on September 7, 2019 in the time zone of UTC (Universal Time Coordinated) is represented as `"2019-09-07T15:50:00Z`". */
  readonly deactivatedAt?: Maybe<Scalars['String']>;
  /** Whether this location can be deleted. */
  readonly deletable: Scalars['Boolean'];
  /** Name of the service provider that fulfills from this location. */
  readonly fulfillmentService?: Maybe<FulfillmentService>;
  /** Whether this location can fulfill online orders. */
  readonly fulfillsOnlineOrders: Scalars['Boolean'];
  /** Whether this location has active inventory. */
  readonly hasActiveInventory: Scalars['Boolean'];
  /** Whether this location has orders that need to be fulfilled. */
  readonly hasUnfulfilledOrders: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The quantities of an inventory item at this location. */
  readonly inventoryLevel?: Maybe<InventoryLevel>;
  /** A list of the quantities of the inventory items that can be stocked at this location. */
  readonly inventoryLevels: InventoryLevelConnection;
  /**
   * Whether the location is active. A deactivated location can be activated (change `isActive: true`) if it has
   * `activatable` set to `true` by calling the
   * [`locationActivate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/locationActivate)
   * mutation.
   */
  readonly isActive: Scalars['Boolean'];
  /** Whether this location is a fulfillment service. */
  readonly isFulfillmentService: Scalars['Boolean'];
  /**
   * Whether the location is your primary location for shipping inventory.
   * @deprecated The concept of a primary location is deprecated, shipsInventory can be used to get a fallback location
   */
  readonly isPrimary: Scalars['Boolean'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** Local pickup settings for the location. */
  readonly localPickupSettingsV2?: Maybe<DeliveryLocalPickupSettings>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** The name of the location. */
  readonly name: Scalars['String'];
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** Whether this location is used for calculating shipping rates. In multi-origin shipping mode, this flag is ignored. */
  readonly shipsInventory: Scalars['Boolean'];
  /** List of suggested addresses for this location (empty if none). */
  readonly suggestedAddresses: ReadonlyArray<LocationSuggestedAddress>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the location was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/**
 * Represents the location where the physical good resides. You can stock inventory at active locations. Active
 * locations that have `fulfills_online_orders: true` and are configured with a shipping rate, pickup enabled or
 * local delivery will be able to sell from their storefront.
 */
export type LocationInventoryLevelArgs = {
  inventoryItemId: Scalars['ID'];
};


/**
 * Represents the location where the physical good resides. You can stock inventory at active locations. Active
 * locations that have `fulfills_online_orders: true` and are configured with a shipping rate, pickup enabled or
 * local delivery will be able to sell from their storefront.
 */
export type LocationInventoryLevelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents the location where the physical good resides. You can stock inventory at active locations. Active
 * locations that have `fulfills_online_orders: true` and are configured with a shipping rate, pickup enabled or
 * local delivery will be able to sell from their storefront.
 */
export type LocationMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * Represents the location where the physical good resides. You can stock inventory at active locations. Active
 * locations that have `fulfills_online_orders: true` and are configured with a shipping rate, pickup enabled or
 * local delivery will be able to sell from their storefront.
 */
export type LocationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * Represents the location where the physical good resides. You can stock inventory at active locations. Active
 * locations that have `fulfills_online_orders: true` and are configured with a shipping rate, pickup enabled or
 * local delivery will be able to sell from their storefront.
 */
export type LocationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents the location where the physical good resides. You can stock inventory at active locations. Active
 * locations that have `fulfills_online_orders: true` and are configured with a shipping rate, pickup enabled or
 * local delivery will be able to sell from their storefront.
 */
export type LocationPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * Represents the location where the physical good resides. You can stock inventory at active locations. Active
 * locations that have `fulfills_online_orders: true` and are configured with a shipping rate, pickup enabled or
 * local delivery will be able to sell from their storefront.
 */
export type LocationPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `locationActivate` mutation. */
export type LocationActivatePayload = {
  /** The location that was activated. */
  readonly location?: Maybe<Location>;
  /** The list of errors that occurred from executing the mutation. */
  readonly locationActivateUserErrors: ReadonlyArray<LocationActivateUserError>;
};

/** An error that occurs while activating a location. */
export type LocationActivateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<LocationActivateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `LocationActivateUserError`. */
export enum LocationActivateUserErrorCode {
  /** An error occurred while activating the location. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** There is already an active location with this name. */
  HAS_NON_UNIQUE_NAME = 'HAS_NON_UNIQUE_NAME',
  /** This location currently cannot be activated as inventory, pending orders or transfers are being relocated from this location. */
  HAS_ONGOING_RELOCATION = 'HAS_ONGOING_RELOCATION',
  /** Shop has reached its location limit. */
  LOCATION_LIMIT = 'LOCATION_LIMIT',
  /** Location not found. */
  LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND'
}

/** The input fields to use to specify the address while adding a location. */
export type LocationAddAddressInput = {
  /** The first line of the address. */
  readonly address1?: InputMaybe<Scalars['String']>;
  /** The second line of the address. */
  readonly address2?: InputMaybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: InputMaybe<Scalars['String']>;
  /** The two-letter code of country for the address. */
  readonly countryCode: CountryCode;
  /** The phone number of the location. */
  readonly phone?: InputMaybe<Scalars['String']>;
  /**
   * The code for the region of the address, such as the state, province, or district.
   * For example CA for California, United States.
   */
  readonly provinceCode?: InputMaybe<Scalars['String']>;
  /** The ZIP code or postal code of the address. */
  readonly zip?: InputMaybe<Scalars['String']>;
};

/** The input fields to use to add a location. */
export type LocationAddInput = {
  /** The address of the location. */
  readonly address: LocationAddAddressInput;
  /** Whether inventory at this location is available for sale online. */
  readonly fulfillsOnlineOrders?: InputMaybe<Scalars['Boolean']>;
  /** Additional customizable information to associate with the location. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The name of the location. */
  readonly name: Scalars['String'];
};

/** Return type for `locationAdd` mutation. */
export type LocationAddPayload = {
  /** The location that was added. */
  readonly location?: Maybe<Location>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<LocationAddUserError>;
};

/** An error that occurs while adding a location. */
export type LocationAddUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<LocationAddUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `LocationAddUserError`. */
export enum LocationAddUserErrorCode {
  /** ApiPermission metafields can only be created or updated by the app owner. */
  APP_NOT_AUTHORIZED = 'APP_NOT_AUTHORIZED',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The metafield violates a capability restriction. */
  CAPABILITY_VIOLATION = 'CAPABILITY_VIOLATION',
  /** Owner type can't be used in this mutation. */
  DISALLOWED_OWNER_TYPE = 'DISALLOWED_OWNER_TYPE',
  /** An error occurred while adding the location. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The type is invalid. */
  INVALID_TYPE = 'INVALID_TYPE',
  /** The ZIP code is not a valid US ZIP code. */
  INVALID_US_ZIPCODE = 'INVALID_US_ZIPCODE',
  /** The value is invalid for the metafield type or for the definition options. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** Unstructured reserved namespace. */
  UNSTRUCTURED_RESERVED_NAMESPACE = 'UNSTRUCTURED_RESERVED_NAMESPACE'
}

/** Represents the address of a location. */
export type LocationAddress = {
  /** The first line of the address for the location. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the address for the location. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The city of the location. */
  readonly city?: Maybe<Scalars['String']>;
  /** The country of the location. */
  readonly country?: Maybe<Scalars['String']>;
  /** The country code of the location. */
  readonly countryCode?: Maybe<Scalars['String']>;
  /** A formatted version of the address for the location. */
  readonly formatted: ReadonlyArray<Scalars['String']>;
  /** The approximate latitude coordinates of the location. */
  readonly latitude?: Maybe<Scalars['Float']>;
  /** The approximate longitude coordinates of the location. */
  readonly longitude?: Maybe<Scalars['Float']>;
  /** The phone number of the location. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The province of the location. */
  readonly province?: Maybe<Scalars['String']>;
  /** The code for the province, state, or district of the address of the location. */
  readonly provinceCode?: Maybe<Scalars['String']>;
  /** The ZIP code of the location. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** An auto-generated type for paginating through multiple Locations. */
export type LocationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<LocationEdge>;
  /** A list of nodes that are contained in LocationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Location>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `locationDeactivate` mutation. */
export type LocationDeactivatePayload = {
  /** The location that was deactivated. */
  readonly location?: Maybe<Location>;
  /** The list of errors that occurred from executing the mutation. */
  readonly locationDeactivateUserErrors: ReadonlyArray<LocationDeactivateUserError>;
};

/** The possible errors that can be returned when executing the `locationDeactivate` mutation. */
export type LocationDeactivateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<LocationDeactivateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `LocationDeactivateUserError`. */
export enum LocationDeactivateUserErrorCode {
  /** At least one location must fulfill online orders. */
  CANNOT_DISABLE_ONLINE_ORDER_FULFILLMENT = 'CANNOT_DISABLE_ONLINE_ORDER_FULFILLMENT',
  /** Destination location is the same as the location to be deactivated. */
  DESTINATION_LOCATION_IS_THE_SAME_LOCATION = 'DESTINATION_LOCATION_IS_THE_SAME_LOCATION',
  /** Destination location is not found or inactive. */
  DESTINATION_LOCATION_NOT_FOUND_OR_INACTIVE = 'DESTINATION_LOCATION_NOT_FOUND_OR_INACTIVE',
  /** Failed to relocate active inventories to the destination location. */
  FAILED_TO_RELOCATE_ACTIVE_INVENTORIES = 'FAILED_TO_RELOCATE_ACTIVE_INVENTORIES',
  /** Failed to relocate incoming movements to the destination location. */
  FAILED_TO_RELOCATE_INCOMING_MOVEMENTS = 'FAILED_TO_RELOCATE_INCOMING_MOVEMENTS',
  /** Failed to relocate open purchase orders to the destination location. */
  FAILED_TO_RELOCATE_OPEN_PURCHASE_ORDERS = 'FAILED_TO_RELOCATE_OPEN_PURCHASE_ORDERS',
  /** Location could not be deactivated without specifying where to relocate inventory at the location. */
  HAS_ACTIVE_INVENTORY_ERROR = 'HAS_ACTIVE_INVENTORY_ERROR',
  /** Location needs to be removed from Shopify POS for Retail subscription in Point of Sale channel. */
  HAS_ACTIVE_RETAIL_SUBSCRIPTIONS = 'HAS_ACTIVE_RETAIL_SUBSCRIPTIONS',
  /** Location could not be deactivated because it has pending orders. */
  HAS_FULFILLMENT_ORDERS_ERROR = 'HAS_FULFILLMENT_ORDERS_ERROR',
  /** Location could not be deactivated because it has open Shopify Fulfillment Network transfers. */
  HAS_INCOMING_MOVEMENTS_ERROR = 'HAS_INCOMING_MOVEMENTS_ERROR',
  /** Location could not be deactivated because it has open purchase orders. */
  HAS_OPEN_PURCHASE_ORDERS_ERROR = 'HAS_OPEN_PURCHASE_ORDERS_ERROR',
  /** Location not found. */
  LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND',
  /** Location either has a fulfillment service or is the only location with a shipping address. */
  PERMANENTLY_BLOCKED_FROM_DEACTIVATION_ERROR = 'PERMANENTLY_BLOCKED_FROM_DEACTIVATION_ERROR',
  /** Location has incoming inventory. The location can be deactivated after the inventory has been received. */
  TEMPORARILY_BLOCKED_FROM_DEACTIVATION_ERROR = 'TEMPORARILY_BLOCKED_FROM_DEACTIVATION_ERROR'
}

/** Return type for `locationDelete` mutation. */
export type LocationDeletePayload = {
  /** The ID of the location that was deleted. */
  readonly deletedLocationId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly locationDeleteUserErrors: ReadonlyArray<LocationDeleteUserError>;
};

/** An error that occurs while deleting a location. */
export type LocationDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<LocationDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `LocationDeleteUserError`. */
export enum LocationDeleteUserErrorCode {
  /** An error occurred while deleting the location. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** The location cannot be deleted while it has any active Retail subscriptions in the Point of Sale channel. */
  LOCATION_HAS_ACTIVE_RETAIL_SUBSCRIPTION = 'LOCATION_HAS_ACTIVE_RETAIL_SUBSCRIPTION',
  /** The location cannot be deleted while it has inventory. */
  LOCATION_HAS_INVENTORY = 'LOCATION_HAS_INVENTORY',
  /** The location cannot be deleted while it has pending orders. */
  LOCATION_HAS_PENDING_ORDERS = 'LOCATION_HAS_PENDING_ORDERS',
  /** The location cannot be deleted while it is active. */
  LOCATION_IS_ACTIVE = 'LOCATION_IS_ACTIVE',
  /** Location not found. */
  LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND'
}

/** An auto-generated type which holds one Location and a cursor during pagination. */
export type LocationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of LocationEdge. */
  readonly node: Location;
};

/** The input fields to use to edit the address of a location. */
export type LocationEditAddressInput = {
  /** The first line of the address. */
  readonly address1?: InputMaybe<Scalars['String']>;
  /** The second line of the address. */
  readonly address2?: InputMaybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: InputMaybe<Scalars['String']>;
  /** The two-letter code of country for the address. */
  readonly countryCode?: InputMaybe<CountryCode>;
  /** The phone number of the location. */
  readonly phone?: InputMaybe<Scalars['String']>;
  /**
   * The code for the region of the address, such as the state, province, or district.
   * For example CA for California, United States.
   */
  readonly provinceCode?: InputMaybe<Scalars['String']>;
  /** The ZIP code or postal code of the location. */
  readonly zip?: InputMaybe<Scalars['String']>;
};

/** The input fields to use to edit a location. */
export type LocationEditInput = {
  /** The address of the location. */
  readonly address?: InputMaybe<LocationEditAddressInput>;
  /**
   * Whether inventory at this location is available for sale online.
   *
   * **Note:** This can't be disabled for fulfillment service locations.
   */
  readonly fulfillsOnlineOrders?: InputMaybe<Scalars['Boolean']>;
  /** Additional customizable information to associate with the location. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The name of the location. */
  readonly name?: InputMaybe<Scalars['String']>;
};

/** Return type for `locationEdit` mutation. */
export type LocationEditPayload = {
  /** The location that was edited. */
  readonly location?: Maybe<Location>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<LocationEditUserError>;
};

/** An error that occurs while editing a location. */
export type LocationEditUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<LocationEditUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `LocationEditUserError`. */
export enum LocationEditUserErrorCode {
  /** ApiPermission metafields can only be created or updated by the app owner. */
  APP_NOT_AUTHORIZED = 'APP_NOT_AUTHORIZED',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** At least one location must fulfill online orders. */
  CANNOT_DISABLE_ONLINE_ORDER_FULFILLMENT = 'CANNOT_DISABLE_ONLINE_ORDER_FULFILLMENT',
  /** Cannot modify the online order fulfillment preference for fulfillment service locations. */
  CANNOT_MODIFY_ONLINE_ORDER_FULFILLMENT_FOR_FS_LOCATION = 'CANNOT_MODIFY_ONLINE_ORDER_FULFILLMENT_FOR_FS_LOCATION',
  /** The metafield violates a capability restriction. */
  CAPABILITY_VIOLATION = 'CAPABILITY_VIOLATION',
  /** Owner type can't be used in this mutation. */
  DISALLOWED_OWNER_TYPE = 'DISALLOWED_OWNER_TYPE',
  /** An error occurred while editing the location. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The type is invalid. */
  INVALID_TYPE = 'INVALID_TYPE',
  /** The ZIP code is not a valid US ZIP code. */
  INVALID_US_ZIPCODE = 'INVALID_US_ZIPCODE',
  /** The value is invalid for the metafield type or for the definition options. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** Unstructured reserved namespace. */
  UNSTRUCTURED_RESERVED_NAMESPACE = 'UNSTRUCTURED_RESERVED_NAMESPACE'
}

/** Return type for `locationLocalPickupDisable` mutation. */
export type LocationLocalPickupDisablePayload = {
  /** The ID of the location for which local pickup was disabled. */
  readonly locationId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DeliveryLocationLocalPickupSettingsError>;
};

/** Return type for `locationLocalPickupEnable` mutation. */
export type LocationLocalPickupEnablePayload = {
  /** The local pickup settings that were enabled. */
  readonly localPickupSettings?: Maybe<DeliveryLocalPickupSettings>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<DeliveryLocationLocalPickupSettingsError>;
};

/** The set of valid sort keys for the Location query. */
export enum LocationSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** Represents a suggested address for a location. */
export type LocationSuggestedAddress = {
  /** The first line of the suggested address. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the suggested address. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The city of the suggested address. */
  readonly city?: Maybe<Scalars['String']>;
  /** The country of the suggested address. */
  readonly country?: Maybe<Scalars['String']>;
  /** The country code of the suggested address. */
  readonly countryCode?: Maybe<CountryCode>;
  /** A formatted version of the suggested address. */
  readonly formatted: ReadonlyArray<Scalars['String']>;
  /** The province of the suggested address. */
  readonly province?: Maybe<Scalars['String']>;
  /** The code for the province, state, or district of the suggested address. */
  readonly provinceCode?: Maybe<Scalars['String']>;
  /** The ZIP code of the suggested address. */
  readonly zip?: Maybe<Scalars['String']>;
};

/**
 * Represents a customer mailing address.
 *
 * For example, a customer's default address and an order's billing address are both mailling addresses.
 */
export type MailingAddress = Node & {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: Maybe<Scalars['String']>;
  /** The name of the customer's company or organization. */
  readonly company?: Maybe<Scalars['String']>;
  /** Whether the address corresponds to recognized latitude and longitude values. */
  readonly coordinatesValidated: Scalars['Boolean'];
  /** The name of the country. */
  readonly country?: Maybe<Scalars['String']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   * @deprecated Use `countryCodeV2` instead.
   */
  readonly countryCode?: Maybe<Scalars['String']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   */
  readonly countryCodeV2?: Maybe<CountryCode>;
  /** The first name of the customer. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** A formatted version of the address, customized by the provided arguments. */
  readonly formatted: ReadonlyArray<Scalars['String']>;
  /** A comma-separated list of the values for city, province, and country. */
  readonly formattedArea?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The last name of the customer. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The latitude coordinate of the customer address. */
  readonly latitude?: Maybe<Scalars['Float']>;
  /** The longitude coordinate of the customer address. */
  readonly longitude?: Maybe<Scalars['Float']>;
  /** The full name of the customer, based on firstName and lastName. */
  readonly name?: Maybe<Scalars['String']>;
  /** A unique phone number for the customer. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The region of the address, such as the province, state, or district. */
  readonly province?: Maybe<Scalars['String']>;
  /**
   * The alphanumeric code for the region.
   *
   * For example, ON.
   */
  readonly provinceCode?: Maybe<Scalars['String']>;
  /** The time zone of the address. */
  readonly timeZone?: Maybe<Scalars['String']>;
  /**
   * The validation status that is leveraged by the address validation feature in the Shopify Admin.
   * See ["Validating addresses in your Shopify admin"](https://help.shopify.com/manual/fulfillment/managing-orders/validating-order-address) for more details.
   */
  readonly validationResultSummary?: Maybe<MailingAddressValidationResult>;
  /** The zip or postal code of the address. */
  readonly zip?: Maybe<Scalars['String']>;
};


/**
 * Represents a customer mailing address.
 *
 * For example, a customer's default address and an order's billing address are both mailling addresses.
 */
export type MailingAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']>;
  withName?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple MailingAddresses. */
export type MailingAddressConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MailingAddressEdge>;
  /** A list of nodes that are contained in MailingAddressEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MailingAddress>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one MailingAddress and a cursor during pagination. */
export type MailingAddressEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MailingAddressEdge. */
  readonly node: MailingAddress;
};

/** The input fields to create or update a mailing address. */
export type MailingAddressInput = {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1?: InputMaybe<Scalars['String']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: InputMaybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: InputMaybe<Scalars['String']>;
  /** The name of the customer's company or organization. */
  readonly company?: InputMaybe<Scalars['String']>;
  /** The two-letter code for the country of the address. */
  readonly countryCode?: InputMaybe<CountryCode>;
  /** The first name of the customer. */
  readonly firstName?: InputMaybe<Scalars['String']>;
  /** The last name of the customer. */
  readonly lastName?: InputMaybe<Scalars['String']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   */
  readonly phone?: InputMaybe<Scalars['String']>;
  /**
   * The code for the region of the address, such as the province, state, or district.
   * For example QC for Quebec, Canada.
   */
  readonly provinceCode?: InputMaybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  readonly zip?: InputMaybe<Scalars['String']>;
};

/** Highest level of validation concerns identified for the address. */
export enum MailingAddressValidationResult {
  /** Indicates that the address has been validated and is very likely to contain invalid information. */
  ERROR = 'ERROR',
  /** Indicates that the address has been validated and no issues were found. */
  NO_ISSUES = 'NO_ISSUES',
  /** Indicates that the address has been validated and might contain invalid information. */
  WARNING = 'WARNING'
}

/**
 * Manual discount applications capture the intentions of a discount that was manually created for an order.
 *
 * Discount applications don't represent the actual final amount discounted on a line (line item or shipping line). The actual amount discounted on a line is represented by the [DiscountAllocation](https://shopify.dev/api/admin-graphql/latest/objects/discountallocation) object.
 */
export type ManualDiscountApplication = DiscountApplication & {
  /** The method by which the discount's value is applied to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /** The description of the discount application. */
  readonly description?: Maybe<Scalars['String']>;
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  readonly index: Scalars['Int'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The title of the discount application. */
  readonly title: Scalars['String'];
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type Market = HasMetafieldDefinitions & HasMetafields & Node & {
  /** The catalogs that belong to the market. */
  readonly catalogs: MarketCatalogConnection;
  /** The number of catalogs that belong to the market. */
  readonly catalogsCount?: Maybe<Count>;
  /** The market’s currency settings. */
  readonly currencySettings: MarketCurrencySettings;
  /**
   * Whether the market is enabled to receive visitors and sales. **Note**: Regions in inactive
   * markets can't be selected on the storefront or in checkout.
   * @deprecated Use `status` instead.
   */
  readonly enabled: Scalars['Boolean'];
  /** A short, human-readable unique identifier for the market. This is changeable by the merchant. */
  readonly handle: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** The name of the market. Not shown to customers. */
  readonly name: Scalars['String'];
  /**
   * The market’s price list, which specifies a percentage-based price adjustment as well as
   * fixed price overrides for specific variants.
   *
   * Markets with multiple catalogs can have multiple price lists. To query which price lists are connected to
   * a market, please query for price lists through the catalogs connection.
   * @deprecated Use `catalogs` instead.
   */
  readonly priceList?: Maybe<PriceList>;
  /**
   * Whether the market is the shop’s primary market.
   * @deprecated This field is deprecated and will be removed in the future.
   */
  readonly primary: Scalars['Boolean'];
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /**
   * The regions that comprise the market.
   * @deprecated This field is deprecated and will be removed in the future. Use `conditions.regionConditions` instead.
   */
  readonly regions: MarketRegionConnection;
  /**
   * The market’s web presence, which defines its SEO strategy. This can be a different domain,
   * subdomain, or subfolders of the primary domain. Each web presence comprises one or more
   * language variants. If a market doesn't have its own web presence, then the market is accessible on the
   * primary market's domains using [country
   * selectors](https://shopify.dev/themes/internationalization/multiple-currencies-languages#the-country-selector).
   * If it's the primary market and it has multiple web presences, then this field will return the primary domain web presence.
   * @deprecated Use `webPresences` instead.
   */
  readonly webPresence?: Maybe<MarketWebPresence>;
  /**
   * The market’s web presences, which defines its SEO strategy. This can be a different domain,
   * subdomain, or subfolders of the primary domain. Each web presence comprises one or more
   * language variants. If a market doesn't have any web presences, then the market is accessible on the
   * primary market's domains using [country
   * selectors](https://shopify.dev/themes/internationalization/multiple-currencies-languages#the-country-selector).
   */
  readonly webPresences: MarketWebPresenceConnection;
};


/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type MarketCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type MarketMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type MarketMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type MarketMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type MarketPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type MarketPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type MarketRegionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A market is a group of one or more regions that you want to target for international sales.
 * By creating a market, you can configure a distinct, localized shopping experience for
 * customers from a specific area of the world. For example, you can
 * [change currency](https://shopify.dev/api/admin-graphql/current/mutations/marketCurrencySettingsUpdate),
 * [configure international pricing](https://shopify.dev/apps/internationalization/product-price-lists),
 * or [add market-specific domains or subfolders](https://shopify.dev/api/admin-graphql/current/objects/MarketWebPresence).
 */
export type MarketWebPresencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** A list of products with publishing and pricing information associated with markets. */
export type MarketCatalog = Catalog & Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The markets associated with the catalog. */
  readonly markets: MarketConnection;
  /** Most recent catalog operations. */
  readonly operations: ReadonlyArray<ResourceOperation>;
  /** The price list associated with the catalog. */
  readonly priceList?: Maybe<PriceList>;
  /** A group of products and collections that's published to a catalog. */
  readonly publication?: Maybe<Publication>;
  /** The status of the catalog. */
  readonly status: CatalogStatus;
  /** The name of the catalog. */
  readonly title: Scalars['String'];
};


/** A list of products with publishing and pricing information associated with markets. */
export type MarketCatalogMarketsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple MarketCatalogs. */
export type MarketCatalogConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MarketCatalogEdge>;
  /** A list of nodes that are contained in MarketCatalogEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MarketCatalog>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one MarketCatalog and a cursor during pagination. */
export type MarketCatalogEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MarketCatalogEdge. */
  readonly node: MarketCatalog;
};

/** An auto-generated type for paginating through multiple Markets. */
export type MarketConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MarketEdge>;
  /** A list of nodes that are contained in MarketEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Market>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields required to create a market. */
export type MarketCreateInput = {
  /**
   * Whether the market is enabled to receive visitors and sales. If a
   * value isn't provided, then the market is enabled by default if all
   * included regions have shipping rates, and disabled if any regions don't
   * have shipping rates.
   *
   * **Note**: Regions in inactive markets can't be selected on the
   * storefront or in checkout.
   */
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * A unique identifier for the market. For example `"ca"`.
   * If the handle isn't provided, then the handle is auto-generated based on the country or name.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** The name of the market. Not shown to customers. */
  readonly name: Scalars['String'];
  /**
   * The regions to be included in the market. Each region can only be included in one market at
   * a time.
   */
  readonly regions: ReadonlyArray<MarketRegionCreateInput>;
};

/** Return type for `marketCreate` mutation. */
export type MarketCreatePayload = {
  /** The market object. */
  readonly market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** A market's currency settings. */
export type MarketCurrencySettings = {
  /**
   * The currency which this market's prices are defined in, and the
   * currency which its customers must use if local currencies are disabled.
   */
  readonly baseCurrency: CurrencySetting;
  /**
   * Whether or not local currencies are enabled. If enabled, then prices will
   * be converted to give each customer the best experience based on their
   * region. If disabled, then all customers in this market will see prices
   * in the market's base currency. For single country markets this will be true when
   * the market's base currency is the same as the default currency for the region.
   */
  readonly localCurrencies: Scalars['Boolean'];
};

/** The input fields used to update the currency settings of a market. */
export type MarketCurrencySettingsUpdateInput = {
  /**
   * The currency which this market’s prices are defined in, and the
   * currency which its customers must use if local currencies are disabled.
   */
  readonly baseCurrency?: InputMaybe<CurrencyCode>;
  /**
   * Whether or not local currencies are enabled. If enabled, then prices will
   * be converted to give each customer the best experience based on their
   * region. If disabled, then all customers in this market will see prices
   * in the market's base currency.
   */
  readonly localCurrencies?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `marketCurrencySettingsUpdate` mutation. */
export type MarketCurrencySettingsUpdatePayload = {
  /** The market object. */
  readonly market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketCurrencySettingsUserError>;
};

/** Error codes for failed market multi-currency operations. */
export type MarketCurrencySettingsUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MarketCurrencySettingsUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MarketCurrencySettingsUserError`. */
export enum MarketCurrencySettingsUserErrorCode {
  /** The currency settings of the given market cannot be changed because the market manager has exclusive control of pricing. */
  MANAGED_MARKET = 'MANAGED_MARKET',
  /** The specified market wasn't found. */
  MARKET_NOT_FOUND = 'MARKET_NOT_FOUND',
  /** The shop's payment gateway does not support enabling more than one currency. */
  MULTIPLE_CURRENCIES_NOT_SUPPORTED = 'MULTIPLE_CURRENCIES_NOT_SUPPORTED',
  /** Can't enable or disable local currencies on a single country market. */
  NO_LOCAL_CURRENCIES_ON_SINGLE_COUNTRY_MARKET = 'NO_LOCAL_CURRENCIES_ON_SINGLE_COUNTRY_MARKET',
  /** The primary market must use the shop currency. */
  PRIMARY_MARKET_USES_SHOP_CURRENCY = 'PRIMARY_MARKET_USES_SHOP_CURRENCY',
  /** The specified currency is not supported. */
  UNSUPPORTED_CURRENCY = 'UNSUPPORTED_CURRENCY'
}

/** Return type for `marketDelete` mutation. */
export type MarketDeletePayload = {
  /** The ID of the deleted market. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** An auto-generated type which holds one Market and a cursor during pagination. */
export type MarketEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MarketEdge. */
  readonly node: Market;
};

/** The market localizable content of a resource's field. */
export type MarketLocalizableContent = {
  /** The hash digest representation of the content value. */
  readonly digest?: Maybe<Scalars['String']>;
  /** The resource field that's being localized. */
  readonly key: Scalars['String'];
  /** The content value. */
  readonly value?: Maybe<Scalars['String']>;
};

/** A resource that has market localizable fields. */
export type MarketLocalizableResource = {
  /** The market localizable content. */
  readonly marketLocalizableContent: ReadonlyArray<MarketLocalizableContent>;
  /** Market localizations for the market localizable content. */
  readonly marketLocalizations: ReadonlyArray<MarketLocalization>;
  /** The GID of the resource. */
  readonly resourceId: Scalars['ID'];
};


/** A resource that has market localizable fields. */
export type MarketLocalizableResourceMarketLocalizationsArgs = {
  marketId: Scalars['ID'];
};

/** An auto-generated type for paginating through multiple MarketLocalizableResources. */
export type MarketLocalizableResourceConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MarketLocalizableResourceEdge>;
  /** A list of nodes that are contained in MarketLocalizableResourceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MarketLocalizableResource>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one MarketLocalizableResource and a cursor during pagination. */
export type MarketLocalizableResourceEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MarketLocalizableResourceEdge. */
  readonly node: MarketLocalizableResource;
};

/** The type of resources that are market localizable. */
export enum MarketLocalizableResourceType {
  /** A metafield. Market localizable fields: `value`. */
  METAFIELD = 'METAFIELD',
  /** A Metaobject. Market Localizable fields are determined by the Metaobject type. */
  METAOBJECT = 'METAOBJECT'
}

/** The market localization of a field within a resource, which is determined by the market ID. */
export type MarketLocalization = {
  /** A reference to the value being localized on the resource that this market localization belongs to. */
  readonly key: Scalars['String'];
  /** The market that the localization is specific to. */
  readonly market: Market;
  /** Whether the original content has changed since this market localization was updated. */
  readonly outdated: Scalars['Boolean'];
  /** The date and time when the market localization was updated. */
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  /** The value of the market localization. */
  readonly value?: Maybe<Scalars['String']>;
};

/** The input fields and values for creating or updating a market localization. */
export type MarketLocalizationRegisterInput = {
  /** A reference to the value being localized on the resource that this market localization belongs to. */
  readonly key: Scalars['String'];
  /** The ID of the market that the localization is specific to. */
  readonly marketId: Scalars['ID'];
  /** A hash digest representation of the content being localized. */
  readonly marketLocalizableContentDigest: Scalars['String'];
  /** The value of the market localization. */
  readonly value: Scalars['String'];
};

/** Return type for `marketLocalizationsRegister` mutation. */
export type MarketLocalizationsRegisterPayload = {
  /** The market localizations that were created or updated. */
  readonly marketLocalizations?: Maybe<ReadonlyArray<MarketLocalization>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<TranslationUserError>;
};

/** Return type for `marketLocalizationsRemove` mutation. */
export type MarketLocalizationsRemovePayload = {
  /** The market localizations that were deleted. */
  readonly marketLocalizations?: Maybe<ReadonlyArray<MarketLocalization>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<TranslationUserError>;
};

/** A geographic region which comprises a market. */
export type MarketRegion = {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the region. */
  readonly name: Scalars['String'];
};

/** An auto-generated type for paginating through multiple MarketRegions. */
export type MarketRegionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MarketRegionEdge>;
  /** A list of nodes that are contained in MarketRegionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MarketRegion>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** A country which comprises a market. */
export type MarketRegionCountry = MarketRegion & Node & {
  /** The ISO code identifying the country. */
  readonly code: CountryCode;
  /** The currency which this country uses given its market settings. */
  readonly currency: CurrencySetting;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the region. */
  readonly name: Scalars['String'];
};

/** The input fields for creating a market region with exactly one required option. */
export type MarketRegionCreateInput = {
  /** A country code for the region. */
  readonly countryCode: CountryCode;
};

/** Return type for `marketRegionDelete` mutation. */
export type MarketRegionDeletePayload = {
  /** The ID of the deleted market region. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The parent market object of the deleted region. */
  readonly market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** An auto-generated type which holds one MarketRegion and a cursor during pagination. */
export type MarketRegionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MarketRegionEdge. */
  readonly node: MarketRegion;
};

/** Return type for `marketRegionsCreate` mutation. */
export type MarketRegionsCreatePayload = {
  /** The market object. */
  readonly market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** Return type for `marketRegionsDelete` mutation. */
export type MarketRegionsDeletePayload = {
  /** The ID of the deleted market region. */
  readonly deletedIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** The input fields used to update a market. */
export type MarketUpdateInput = {
  /**
   * Whether the market is enabled to receive visitors and sales. **Note**: Regions in
   * inactive markets cannot be selected on the storefront or in checkout.
   */
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the market. For example `"ca"`. */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** The name of the market. Not shown to customers. */
  readonly name?: InputMaybe<Scalars['String']>;
};

/** Return type for `marketUpdate` mutation. */
export type MarketUpdatePayload = {
  /** The market object. */
  readonly market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** Defines errors encountered while managing a Market. */
export type MarketUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MarketUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MarketUserError`. */
export enum MarketUserErrorCode {
  /** B2B markets must be merchant managed. */
  B2B_MARKET_MUST_BE_MERCHANT_MANAGED = 'B2B_MARKET_MUST_BE_MERCHANT_MANAGED',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Can't add customer account domain to a market. */
  CANNOT_ADD_CUSTOMER_DOMAIN = 'CANNOT_ADD_CUSTOMER_DOMAIN',
  /** Can't add regions to the primary market. */
  CANNOT_ADD_REGIONS_TO_PRIMARY_MARKET = 'CANNOT_ADD_REGIONS_TO_PRIMARY_MARKET',
  /** Can't add the web presence to the primary market. */
  CANNOT_ADD_WEB_PRESENCE_TO_PRIMARY_MARKET = 'CANNOT_ADD_WEB_PRESENCE_TO_PRIMARY_MARKET',
  /** Can't delete the only region in a market. */
  CANNOT_DELETE_ONLY_REGION = 'CANNOT_DELETE_ONLY_REGION',
  /** Can't delete the primary market. */
  CANNOT_DELETE_PRIMARY_MARKET = 'CANNOT_DELETE_PRIMARY_MARKET',
  /** Can't delete the primary market's web presence. */
  CANNOT_DELETE_PRIMARY_MARKET_WEB_PRESENCE = 'CANNOT_DELETE_PRIMARY_MARKET_WEB_PRESENCE',
  /** Can't disable the primary market. */
  CANNOT_DISABLE_PRIMARY_MARKET = 'CANNOT_DISABLE_PRIMARY_MARKET',
  /** Can't have both subfolder and domain web presences. */
  CANNOT_HAVE_BOTH_SUBFOLDER_AND_DOMAIN_WEB_PRESENCES = 'CANNOT_HAVE_BOTH_SUBFOLDER_AND_DOMAIN_WEB_PRESENCES',
  /** Can't have multiple subfolder web presences per market. */
  CANNOT_HAVE_MULTIPLE_SUBFOLDERS_PER_MARKET = 'CANNOT_HAVE_MULTIPLE_SUBFOLDERS_PER_MARKET',
  /** Can't pass both `subfolderSuffix` and `domainId`. */
  CANNOT_HAVE_SUBFOLDER_AND_DOMAIN = 'CANNOT_HAVE_SUBFOLDER_AND_DOMAIN',
  /** Can't set default locale to null. */
  CANNOT_SET_DEFAULT_LOCALE_TO_NULL = 'CANNOT_SET_DEFAULT_LOCALE_TO_NULL',
  /** Catalogs with volume pricing or quantity rules are not supported for the specified condition types. */
  CATALOGS_WITH_VOLUME_PRICING_OR_QUANTITY_RULES_NOT_SUPPORTED = 'CATALOGS_WITH_VOLUME_PRICING_OR_QUANTITY_RULES_NOT_SUPPORTED',
  /** Catalog condition types must be the same for all conditions on a catalog. */
  CATALOG_CONDITION_TYPES_MUST_BE_THE_SAME = 'CATALOG_CONDITION_TYPES_MUST_BE_THE_SAME',
  /** Catalogs and condition types are not compatible with each other. */
  CATALOG_NOT_COMPATIBLE_WITH_CONDITION_TYPES = 'CATALOG_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** A market can only have market catalogs. */
  CATALOG_TYPE_NOT_SUPPORTED = 'CATALOG_TYPE_NOT_SUPPORTED',
  /** One or more condition IDs were not found. */
  CONDITIONS_NOT_FOUND = 'CONDITIONS_NOT_FOUND',
  /** Contains regions that cannot be managed. */
  CONTAINS_REGIONS_THAT_CANNOT_BE_MANAGED = 'CONTAINS_REGIONS_THAT_CANNOT_BE_MANAGED',
  /** One or more customizations were not found. */
  CUSTOMIZATIONS_NOT_FOUND = 'CUSTOMIZATIONS_NOT_FOUND',
  /** The language isn't enabled on the store. */
  DISABLED_LANGUAGE = 'DISABLED_LANGUAGE',
  /** Domain was not found. */
  DOMAIN_NOT_FOUND = 'DOMAIN_NOT_FOUND',
  /** Duplicates found in languages. */
  DUPLICATE_LANGUAGES = 'DUPLICATE_LANGUAGES',
  /** Duplicate region market. */
  DUPLICATE_REGION_MARKET = 'DUPLICATE_REGION_MARKET',
  /** Duplicate unique market. */
  DUPLICATE_UNIQUE_MARKET = 'DUPLICATE_UNIQUE_MARKET',
  /** Exceeds max multi-context markets. */
  EXCEEDS_MAX_MULTI_CONTEXT_MARKETS = 'EXCEEDS_MAX_MULTI_CONTEXT_MARKETS',
  /** An error occurred. See the message for details. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** Inclusive pricing cannot be added to a market with the specified condition types. */
  INCLUSIVE_PRICING_NOT_COMPATIBLE_WITH_CONDITION_TYPES = 'INCLUSIVE_PRICING_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** The specified conditions are not compatible with each other. */
  INCOMPATIBLE_CONDITIONS = 'INCOMPATIBLE_CONDITIONS',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Invalid combination of status and enabled. */
  INVALID_STATUS_AND_ENABLED_COMBINATION = 'INVALID_STATUS_AND_ENABLED_COMBINATION',
  /** Location match all is only valid with one non-match all region. */
  LOCATION_MATCH_ALL_REQUIRES_ONE_SPECIFIC_REGION = 'LOCATION_MATCH_ALL_REQUIRES_ONE_SPECIFIC_REGION',
  /** A location's country does not match the region's country. */
  LOCATION_REGION_COUNTRY_MISMATCH = 'LOCATION_REGION_COUNTRY_MISMATCH',
  /** The currency settings of the given market cannot be changed because the market manager has exclusive control of pricing. */
  MANAGED_MARKET = 'MANAGED_MARKET',
  /** Catalogs created by Managed Markets cannot be added to a market. */
  MANAGED_MARKETS_CATALOG_NOT_ALLOWED = 'MANAGED_MARKETS_CATALOG_NOT_ALLOWED',
  /** A direct connection catalog can't be attached to a market. */
  MARKET_CANT_HAVE_DIRECT_CONNECTION_CATALOG = 'MARKET_CANT_HAVE_DIRECT_CONNECTION_CATALOG',
  /** The market wasn't found. */
  MARKET_NOT_FOUND = 'MARKET_NOT_FOUND',
  /** Can't add another web presence to the market. */
  MARKET_REACHED_WEB_PRESENCE_LIMIT = 'MARKET_REACHED_WEB_PRESENCE_LIMIT',
  /** All retail locations in a market must be in the same country. */
  MIXED_COUNTRY_LOCATIONS_NOT_ALLOWED = 'MIXED_COUNTRY_LOCATIONS_NOT_ALLOWED',
  /** The shop's payment gateway does not support enabling more than one currency. */
  MULTIPLE_CURRENCIES_NOT_SUPPORTED = 'MULTIPLE_CURRENCIES_NOT_SUPPORTED',
  /** Can’t delete, disable, or change the type of the last region market. */
  MUST_HAVE_AT_LEAST_ONE_ACTIVE_REGION_MARKET = 'MUST_HAVE_AT_LEAST_ONE_ACTIVE_REGION_MARKET',
  /** No languages selected. */
  NO_LANGUAGES = 'NO_LANGUAGES',
  /** Can't enable or disable local currencies on a single country market. */
  NO_LOCAL_CURRENCIES_ON_SINGLE_COUNTRY_MARKET = 'NO_LOCAL_CURRENCIES_ON_SINGLE_COUNTRY_MARKET',
  /** Rounding is not supported if unified markets are not enabled. */
  NO_ROUNDING_ON_LEGACY_MARKET = 'NO_ROUNDING_ON_LEGACY_MARKET',
  /** POS location markets must be merchant managed. */
  POS_LOCATION_MARKET_MUST_BE_MERCHANT_MANAGED = 'POS_LOCATION_MARKET_MUST_BE_MERCHANT_MANAGED',
  /** The primary market must use the primary domain. */
  PRIMARY_MARKET_MUST_USE_PRIMARY_DOMAIN = 'PRIMARY_MARKET_MUST_USE_PRIMARY_DOMAIN',
  /** The market region wasn't found. */
  REGION_NOT_FOUND = 'REGION_NOT_FOUND',
  /** Cannot add region-specific language. */
  REGION_SPECIFIC_LANGUAGE = 'REGION_SPECIFIC_LANGUAGE',
  /** One of `subfolderSuffix` or `domainId` is required. */
  REQUIRES_DOMAIN_OR_SUBFOLDER = 'REQUIRES_DOMAIN_OR_SUBFOLDER',
  /** Exactly one input option is required. */
  REQUIRES_EXACTLY_ONE_OPTION = 'REQUIRES_EXACTLY_ONE_OPTION',
  /** Retail location currency must be local. */
  RETAIL_LOCATION_CURRENCY_MUST_BE_LOCAL = 'RETAIL_LOCATION_CURRENCY_MUST_BE_LOCAL',
  /** The shop must have a web presence that uses the primary domain. */
  SHOP_MUST_HAVE_PRIMARY_DOMAIN_WEB_PRESENCE = 'SHOP_MUST_HAVE_PRIMARY_DOMAIN_WEB_PRESENCE',
  /** Can't have more than 50 markets. */
  SHOP_REACHED_MARKETS_LIMIT = 'SHOP_REACHED_MARKETS_LIMIT',
  /** Specified conditions cannot be empty. */
  SPECIFIED_CONDITIONS_CANNOT_BE_EMPTY = 'SPECIFIED_CONDITIONS_CANNOT_BE_EMPTY',
  /** With an ID list in input, SPECIFIED is not needed. */
  SPECIFIED_NOT_VALID_FOR_INPUT = 'SPECIFIED_NOT_VALID_FOR_INPUT',
  /** The subfolder suffix is invalid, please provide a different value. */
  SUBFOLDER_SUFFIX_CANNOT_BE_SCRIPT_CODE = 'SUBFOLDER_SUFFIX_CANNOT_BE_SCRIPT_CODE',
  /** The subfolder suffix must contain only letters. */
  SUBFOLDER_SUFFIX_MUST_CONTAIN_ONLY_LETTERS = 'SUBFOLDER_SUFFIX_MUST_CONTAIN_ONLY_LETTERS',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** Unified markets are not enabled. */
  UNIFIED_MARKETS_NOT_ENABLED = 'UNIFIED_MARKETS_NOT_ENABLED',
  /** The language isn't published to the store. */
  UNPUBLISHED_LANGUAGE = 'UNPUBLISHED_LANGUAGE',
  /** Can't add unsupported country or region. */
  UNSUPPORTED_COUNTRY_REGION = 'UNSUPPORTED_COUNTRY_REGION',
  /** The specified currency is not supported. */
  UNSUPPORTED_CURRENCY = 'UNSUPPORTED_CURRENCY',
  /** The user doesn't have permission access to create or edit markets. */
  USER_LACKS_PERMISSION = 'USER_LACKS_PERMISSION',
  /** Web presences and condition types are not compatible with each other. */
  WEB_PRESENCE_NOT_COMPATIBLE_WITH_CONDITION_TYPES = 'WEB_PRESENCE_NOT_COMPATIBLE_WITH_CONDITION_TYPES',
  /** The market web presence wasn't found. */
  WEB_PRESENCE_NOT_FOUND = 'WEB_PRESENCE_NOT_FOUND',
  /** Can't add web presence to the another market. */
  WEB_PRESENCE_REACHED_MARKETS_LIMIT = 'WEB_PRESENCE_REACHED_MARKETS_LIMIT',
  /** Matching ALL or NONE isn't supported for this driver type. */
  WILDCARD_NOT_SUPPORTED = 'WILDCARD_NOT_SUPPORTED'
}

/**
 * The market’s web presence, which defines its SEO strategy. This can be a different domain
 * (e.g. `example.ca`), subdomain (e.g. `ca.example.com`), or subfolders of the primary
 * domain (e.g. `example.com/en-ca`). Each web presence comprises one or more language
 * variants. If a market does not have its own web presence, it is accessible on the shop’s
 * primary domain via [country
 * selectors](https://shopify.dev/themes/internationalization/multiple-currencies-languages#the-country-selector).
 *
 * Note: while the domain/subfolders defined by a market’s web presence are not applicable to
 * custom storefronts, which must manage their own domains and routing, the languages chosen
 * here do govern [the languages available on the Storefront
 * API](https://shopify.dev/custom-storefronts/internationalization/multiple-languages) for the countries in
 * this market.
 */
export type MarketWebPresence = Node & {
  /**
   * The ShopLocale object for the alternate locales. When a domain is used, these locales will be
   * available as language-specific subfolders. For example, if English is an
   * alternate locale, and `example.ca` is the market’s domain, then
   * `example.ca/en` will load in English.
   */
  readonly alternateLocales: ReadonlyArray<ShopLocale>;
  /**
   * The ShopLocale object for the default locale. When a domain is used, this is the locale that will
   * be used when the domain root is accessed. For example, if French is the default locale,
   * and `example.ca` is the market’s domain, then `example.ca` will load in French.
   */
  readonly defaultLocale: ShopLocale;
  /**
   * The web presence’s domain.
   * This field will be null if `subfolderSuffix` isn't null.
   */
  readonly domain?: Maybe<Domain>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The associated market. */
  readonly market: Market;
  /** The list of root URLs for each of the web presence’s locales. As of version `2024-04` this value will no longer have a trailing slash. */
  readonly rootUrls: ReadonlyArray<MarketWebPresenceRootUrl>;
  /** The market-specific suffix of the subfolders defined by the web presence. Example: in `/en-us` the subfolder suffix is `us`. This field will be null if `domain` isn't null. */
  readonly subfolderSuffix?: Maybe<Scalars['String']>;
};

/** An auto-generated type for paginating through multiple MarketWebPresences. */
export type MarketWebPresenceConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MarketWebPresenceEdge>;
  /** A list of nodes that are contained in MarketWebPresenceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MarketWebPresence>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields used to create a web presence for a market. */
export type MarketWebPresenceCreateInput = {
  /** The alternate locales for the market’s web presence. */
  readonly alternateLocales?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The default locale for the market’s web presence. */
  readonly defaultLocale: Scalars['String'];
  /** The web presence's domain ID. This field must be `null` if the `subfolderSuffix` isn't `null`. */
  readonly domainId?: InputMaybe<Scalars['ID']>;
  /**
   * The market-specific suffix of the subfolders defined by the web presence.
   * For example: in `/en-us`, the subfolder suffix is `us`.
   * Only ASCII characters are allowed. This field must be `null` if the `domainId` isn't `null`.
   */
  readonly subfolderSuffix?: InputMaybe<Scalars['String']>;
};

/** Return type for `marketWebPresenceCreate` mutation. */
export type MarketWebPresenceCreatePayload = {
  /** The market object. */
  readonly market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** Return type for `marketWebPresenceDelete` mutation. */
export type MarketWebPresenceDeletePayload = {
  /** The ID of the deleted web presence. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The market for which the web presence was deleted. */
  readonly market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** An auto-generated type which holds one MarketWebPresence and a cursor during pagination. */
export type MarketWebPresenceEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MarketWebPresenceEdge. */
  readonly node: MarketWebPresence;
};

/**
 * The URL for the homepage of the online store in the context of a particular market and a
 * particular locale.
 */
export type MarketWebPresenceRootUrl = {
  /** The locale that the storefront loads in. */
  readonly locale: Scalars['String'];
  /** The URL. */
  readonly url: Scalars['URL'];
};

/** The input fields used to update a web presence for a market. */
export type MarketWebPresenceUpdateInput = {
  /** The alternate locales for the market’s web presence. */
  readonly alternateLocales?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The default locale for the market’s web presence. */
  readonly defaultLocale?: InputMaybe<Scalars['String']>;
  /** The web presence's domain ID. This field must be null if `subfolderSuffix` is not null. */
  readonly domainId?: InputMaybe<Scalars['ID']>;
  /**
   * The market-specific suffix of the subfolders defined by the web presence.
   * Example: in `/en-us` the subfolder suffix is `us`.
   * Only ASCII characters are allowed. This field must be null if `domainId` is not null.
   */
  readonly subfolderSuffix?: InputMaybe<Scalars['String']>;
};

/** Return type for `marketWebPresenceUpdate` mutation. */
export type MarketWebPresenceUpdatePayload = {
  /** The market object. */
  readonly market?: Maybe<Market>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketUserError>;
};

/** Return type for `marketingActivitiesDeleteAllExternal` mutation. */
export type MarketingActivitiesDeleteAllExternalPayload = {
  /** The asynchronous job that performs the deletion. The status of the job may be used to determine when it's safe again to create new activities. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketingActivityUserError>;
};

/**
 * The marketing activity resource represents marketing that a
 *         merchant created through an app.
 */
export type MarketingActivity = Node & {
  /** The URL of the marketing activity listing page in the marketing section. */
  readonly activityListUrl?: Maybe<Scalars['URL']>;
  /** The amount spent on the marketing activity. */
  readonly adSpend?: Maybe<MoneyV2>;
  /** The app which created this marketing activity. */
  readonly app: App;
  /** The errors generated when an app publishes the marketing activity. */
  readonly appErrors?: Maybe<MarketingActivityExtensionAppErrors>;
  /** The allocated budget for the marketing activity. */
  readonly budget?: Maybe<MarketingBudget>;
  /** The date and time when the marketing activity was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The completed content in the marketing activity creation form. */
  readonly formData?: Maybe<Scalars['String']>;
  /** The hierarchy level of the marketing activity. */
  readonly hierarchyLevel?: Maybe<MarketingActivityHierarchyLevel>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether the marketing activity is in the main workflow version of the marketing automation. */
  readonly inMainWorkflowVersion: Scalars['Boolean'];
  /** The marketing activity represents an external marketing activity. */
  readonly isExternal: Scalars['Boolean'];
  /**
   * The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation.
   * @deprecated Use `marketingChannelType` instead.
   */
  readonly marketingChannel: MarketingChannel;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  readonly marketingChannelType: MarketingChannel;
  /** Associated marketing event of this marketing activity. */
  readonly marketingEvent?: Maybe<MarketingEvent>;
  /** ID of the parent activity of this marketing activity. */
  readonly parentActivityId?: Maybe<Scalars['ID']>;
  /** ID of the parent activity of this marketing activity. */
  readonly parentRemoteId?: Maybe<Scalars['String']>;
  /** A contextual description of the marketing activity based on the platform and tactic used. */
  readonly sourceAndMedium: Scalars['String'];
  /** The current state of the marketing activity. */
  readonly status: MarketingActivityStatus;
  /**
   * The severity of the marketing activity's status.
   * @deprecated Use `statusBadgeTypeV2` instead.
   */
  readonly statusBadgeType?: Maybe<MarketingActivityStatusBadgeType>;
  /** The severity of the marketing activity's status. */
  readonly statusBadgeTypeV2?: Maybe<BadgeType>;
  /** The rendered status of the marketing activity. */
  readonly statusLabel: Scalars['String'];
  /**
   * The [date and time](
   *           https://help.shopify.com/https://en.wikipedia.org/wiki/ISO_8601
   *           ) when the activity's status last changed.
   */
  readonly statusTransitionedAt?: Maybe<Scalars['DateTime']>;
  /** The method of marketing used for this marketing activity. */
  readonly tactic: MarketingTactic;
  /** The status to which the marketing activity is currently transitioning. */
  readonly targetStatus?: Maybe<MarketingActivityStatus>;
  /** The marketing activity's title, which is rendered on the marketing listing page. */
  readonly title: Scalars['String'];
  /** The date and time when the marketing activity was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /** The value portion of the URL query parameter used in attributing sessions to this activity. */
  readonly urlParameterValue?: Maybe<Scalars['String']>;
  /**
   * The set of [Urchin Tracking Module](
   *           https://help.shopify.com/https://en.wikipedia.org/wiki/UTM_parameters
   *           ) used in the URL for tracking this marketing activity.
   */
  readonly utmParameters?: Maybe<UtmParameters>;
};

/** The input fields combining budget amount and its marketing budget type. */
export type MarketingActivityBudgetInput = {
  /** Budget type for marketing activity. */
  readonly budgetType?: InputMaybe<MarketingBudgetBudgetType>;
  /** Amount of budget for the marketing activity. */
  readonly total?: InputMaybe<MoneyInput>;
};

/** An auto-generated type for paginating through multiple MarketingActivities. */
export type MarketingActivityConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MarketingActivityEdge>;
  /** A list of nodes that are contained in MarketingActivityEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MarketingActivity>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for creating an externally-managed marketing activity. */
export type MarketingActivityCreateExternalInput = {
  /** The amount spent on the marketing activity. */
  readonly adSpend?: InputMaybe<MoneyInput>;
  /** The budget for this marketing activity. */
  readonly budget?: InputMaybe<MarketingActivityBudgetInput>;
  /** The unique string identifier of the channel to which this activity belongs. For the correct handle for your channel, contact your partner manager. */
  readonly channelHandle?: InputMaybe<Scalars['String']>;
  /** The date and time at which the activity ended. If omitted or set to `null`, the current time will be used if the status is set to `INACTIVE` or `DELETED_EXTERNALLY`. */
  readonly end?: InputMaybe<Scalars['DateTime']>;
  /** The hierarchy level of the activity within a campaign. The hierarchy level can't be updated. */
  readonly hierarchyLevel?: InputMaybe<MarketingActivityHierarchyLevel>;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  readonly marketingChannelType: MarketingChannel;
  /** The ID for the parent marketing activity, if creating hierarchical activities. */
  readonly parentActivityId?: InputMaybe<Scalars['ID']>;
  /** The remote ID for the parent marketing activity, if creating hierarchical activities. */
  readonly parentRemoteId?: InputMaybe<Scalars['String']>;
  /** The domain from which ad clicks are forwarded to the shop. */
  readonly referringDomain?: InputMaybe<Scalars['String']>;
  /** A custom unique identifier for the marketing activity, which can be used to manage the activity and send engagement metrics without having to store our marketing activity ID in your systems. */
  readonly remoteId?: InputMaybe<Scalars['String']>;
  /** The URL for a preview image that's used for the marketing activity. */
  readonly remotePreviewImageUrl?: InputMaybe<Scalars['URL']>;
  /** The URL for viewing and/or managing the activity outside of Shopify. */
  readonly remoteUrl: Scalars['URL'];
  /** The date and time at which the activity is scheduled to end. */
  readonly scheduledEnd?: InputMaybe<Scalars['DateTime']>;
  /** The date and time at which the activity is scheduled to start. */
  readonly scheduledStart?: InputMaybe<Scalars['DateTime']>;
  /** The date and time at which the activity started. If omitted or set to `null`, the current time will be used. */
  readonly start?: InputMaybe<Scalars['DateTime']>;
  /** The status of the marketing activity. If status isn't set it will default to UNDEFINED. */
  readonly status?: InputMaybe<MarketingActivityExternalStatus>;
  /** The method of marketing used for this marketing activity. The marketing tactic determines which default fields are included in the marketing activity. */
  readonly tactic: MarketingTactic;
  /** The title of the marketing activity. */
  readonly title: Scalars['String'];
  /** Value for a query parameter that gets inserted into storefront URLs for matching storefront traffic to this activity. This feature is currently available on a limited basis to some partners only. UTMs should continue to be used for most partners. Both the URL parameter value and UTM parameters can be set. */
  readonly urlParameterValue?: InputMaybe<Scalars['String']>;
  /** Specifies the [Urchin Traffic Module (UTM) parameters](https://en.wikipedia.org/wiki/UTM_parameters) that are associated with a related marketing campaign. Either the URL parameter value or UTM can be set, but not both. */
  readonly utm?: InputMaybe<UtmInput>;
};

/** Return type for `marketingActivityCreateExternal` mutation. */
export type MarketingActivityCreateExternalPayload = {
  /** The external marketing activity that was created. */
  readonly marketingActivity?: Maybe<MarketingActivity>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketingActivityUserError>;
};

/** The input fields required to create a marketing activity. */
export type MarketingActivityCreateInput = {
  /** The budget for this marketing activity. */
  readonly budget?: InputMaybe<MarketingActivityBudgetInput>;
  /** Encoded context containing marketing campaign id. */
  readonly context?: InputMaybe<Scalars['String']>;
  /** The form data in JSON serialized as a string. */
  readonly formData?: InputMaybe<Scalars['String']>;
  /** The ID of the marketing activity extension. */
  readonly marketingActivityExtensionId: Scalars['ID'];
  /** The title of the marketing activity. */
  readonly marketingActivityTitle?: InputMaybe<Scalars['String']>;
  /** The current state of the marketing activity. */
  readonly status: MarketingActivityStatus;
  /** Value for a query parameter that gets inserted into storefront URLs for matching storefront traffic to this activity. This feature is currently available on a limited basis to some partners only. UTMs should continue to be used for most partners. Both the URL parameter value and UTM parameters can be set. */
  readonly urlParameterValue?: InputMaybe<Scalars['String']>;
  /**
   * Specifies the
   * [Urchin Traffic Module (UTM) parameters](https://en.wikipedia.org/wiki/UTM_parameters)
   * that are associated with a related marketing campaign. UTMInput is required for all Marketing
   * tactics except Storefront App.
   */
  readonly utm?: InputMaybe<UtmInput>;
};

/** Return type for `marketingActivityCreate` mutation. */
export type MarketingActivityCreatePayload = {
  /** The created marketing activity. */
  readonly marketingActivity?: Maybe<MarketingActivity>;
  /** The path to return back to shopify admin from embedded editor. */
  readonly redirectPath?: Maybe<Scalars['String']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `marketingActivityDeleteExternal` mutation. */
export type MarketingActivityDeleteExternalPayload = {
  /** The ID of the marketing activity that was deleted, if one was deleted. */
  readonly deletedMarketingActivityId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketingActivityUserError>;
};

/** An auto-generated type which holds one MarketingActivity and a cursor during pagination. */
export type MarketingActivityEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MarketingActivityEdge. */
  readonly node: MarketingActivity;
};

/** The error code resulted from the marketing activity extension integration. */
export enum MarketingActivityExtensionAppErrorCode {
  /** The app is either not responding or returning unexpected data. */
  API_ERROR = 'API_ERROR',
  /** The app needs to be installed. */
  INSTALL_REQUIRED_ERROR = 'INSTALL_REQUIRED_ERROR',
  /** The shop/user must be onboarded to use the app. */
  NOT_ONBOARDED_ERROR = 'NOT_ONBOARDED_ERROR',
  /** The app has returned an error when invoking the platform. */
  PLATFORM_ERROR = 'PLATFORM_ERROR',
  /** The app has returned validation errors. */
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

/** Represents errors returned from apps when using the marketing activity extension. */
export type MarketingActivityExtensionAppErrors = {
  /** The app error type. */
  readonly code: MarketingActivityExtensionAppErrorCode;
  /** The list of errors returned by the app. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Set of possible statuses for an external marketing activity. */
export enum MarketingActivityExternalStatus {
  /** This marketing activity is currently running. */
  ACTIVE = 'ACTIVE',
  /** This marketing activity was deleted and it was triggered from outside of Shopify. */
  DELETED_EXTERNALLY = 'DELETED_EXTERNALLY',
  /** This marketing activity has completed running. */
  INACTIVE = 'INACTIVE',
  /** This marketing activity is currently not running. */
  PAUSED = 'PAUSED',
  /** This marketing activity is scheduled to run. */
  SCHEDULED = 'SCHEDULED',
  /** The marketing activity's status is unknown. */
  UNDEFINED = 'UNDEFINED'
}

/** Hierarchy levels for external marketing activities. */
export enum MarketingActivityHierarchyLevel {
  /** An advertisement activity. Must be parented by an ad group or a campaign activity, and must be assigned tracking parameters (URL or UTM). */
  AD = 'AD',
  /** A group of advertisement activities. Must be parented by a campaign activity. */
  AD_GROUP = 'AD_GROUP',
  /** A campaign activity. May contain either ad groups or ads as child activities. If childless, then the campaign activity should have tracking parameters assigned (URL or UTM) otherwise it won't appear in marketing reports. */
  CAMPAIGN = 'CAMPAIGN'
}

/** The set of valid sort keys for the MarketingActivity query. */
export enum MarketingActivitySortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE'
}

/** Status helps to identify if this marketing activity has been completed, queued, failed etc. */
export enum MarketingActivityStatus {
  /** This marketing activity is currently running. */
  ACTIVE = 'ACTIVE',
  /** This marketing activity is permanently unavailable. */
  DELETED = 'DELETED',
  /** This marketing activity was deleted and it was triggered from outside of Shopify. */
  DELETED_EXTERNALLY = 'DELETED_EXTERNALLY',
  /** This marketing activity is disconnected and no longer editable. */
  DISCONNECTED = 'DISCONNECTED',
  /** This marketing activity has been edited, but it is not yet created. */
  DRAFT = 'DRAFT',
  /** This marketing activity is unable to run. */
  FAILED = 'FAILED',
  /** This marketing activity has completed running. */
  INACTIVE = 'INACTIVE',
  /** This marketing activity is currently not running. */
  PAUSED = 'PAUSED',
  /** This marketing activity is pending creation on the app's marketing platform. */
  PENDING = 'PENDING',
  /** This marketing activity is scheduled to run. */
  SCHEDULED = 'SCHEDULED',
  /** The marketing activity's status is unknown. */
  UNDEFINED = 'UNDEFINED'
}

/** StatusBadgeType helps to identify the color of the status badge. */
export enum MarketingActivityStatusBadgeType {
  /** This status badge has type attention. */
  ATTENTION = 'ATTENTION',
  /** This status badge has type critical. */
  CRITICAL = 'CRITICAL',
  /** This status badge has type default. */
  DEFAULT = 'DEFAULT',
  /** This status badge has type info. */
  INFO = 'INFO',
  /** This status badge has type success. */
  SUCCESS = 'SUCCESS',
  /** This status badge has type warning. */
  WARNING = 'WARNING'
}

/** The input fields required to update an externally managed marketing activity. */
export type MarketingActivityUpdateExternalInput = {
  /** The amount spent on the marketing activity. */
  readonly adSpend?: InputMaybe<MoneyInput>;
  /** The budget for this marketing activity. */
  readonly budget?: InputMaybe<MarketingActivityBudgetInput>;
  /** The date and time at which the activity ended. */
  readonly end?: InputMaybe<Scalars['DateTime']>;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  readonly marketingChannelType?: InputMaybe<MarketingChannel>;
  /** The domain from which ad clicks are forwarded to the shop. */
  readonly referringDomain?: InputMaybe<Scalars['String']>;
  /** The URL for a preview image that's used for the marketing activity. */
  readonly remotePreviewImageUrl?: InputMaybe<Scalars['URL']>;
  /** The URL for viewing and/or managing the activity outside of Shopify. */
  readonly remoteUrl?: InputMaybe<Scalars['URL']>;
  /** The date and time at which the activity is scheduled to end. */
  readonly scheduledEnd?: InputMaybe<Scalars['DateTime']>;
  /** The date and time at which the activity is scheduled to start. */
  readonly scheduledStart?: InputMaybe<Scalars['DateTime']>;
  /** The date and time at which the activity started. */
  readonly start?: InputMaybe<Scalars['DateTime']>;
  /** The status of the marketing activity. */
  readonly status?: InputMaybe<MarketingActivityExternalStatus>;
  /** The method of marketing used for this marketing activity. The marketing tactic determines which default fields are included in the marketing activity. */
  readonly tactic?: InputMaybe<MarketingTactic>;
  /** The title of the marketing activity. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `marketingActivityUpdateExternal` mutation. */
export type MarketingActivityUpdateExternalPayload = {
  /** The updated marketing activity. */
  readonly marketingActivity?: Maybe<MarketingActivity>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketingActivityUserError>;
};

/** The input fields required to update a marketing activity. */
export type MarketingActivityUpdateInput = {
  /** The budget for the marketing activity. */
  readonly budget?: InputMaybe<MarketingActivityBudgetInput>;
  /**
   * The error messages that were generated when the app was trying to complete the activity.
   * Learn more about the
   * [JSON format expected for error messages](/api/marketing-activities/statuses#failed-status).
   */
  readonly errors?: InputMaybe<Scalars['JSON']>;
  /**
   * The form data of the marketing activity. This is only used if the marketing activity is
   *               integrated with the external editor.
   */
  readonly formData?: InputMaybe<Scalars['String']>;
  /** The ID of the marketing activity. */
  readonly id: Scalars['ID'];
  /**
   * A list of the item IDs that were marketed in this marketing activity. Valid types for these items are:
   * * `Product`
   * * `Shop`
   */
  readonly marketedResources?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The ID of the recommendation that the marketing activity was created from, if one exists. */
  readonly marketingRecommendationId?: InputMaybe<Scalars['ID']>;
  /**
   * The current state of the marketing activity. Learn more about
   * [marketing activities statuses](/api/marketing-activities/statuses).
   */
  readonly status?: InputMaybe<MarketingActivityStatus>;
  /** The target state that the marketing activity is transitioning to. Learn more about [marketing activities statuses](/api/marketing-activities/statuses). */
  readonly targetStatus?: InputMaybe<MarketingActivityStatus>;
  /** The title of the marketing activity. */
  readonly title?: InputMaybe<Scalars['String']>;
  /** Value for a query parameter that gets inserted into storefront URLs for matching storefront traffic to this activity. This feature is currently available on a limited basis to some partners only. UTMs should continue to be used for most partners. Both the URL parameter value and UTM parameters can be set. */
  readonly urlParameterValue?: InputMaybe<Scalars['String']>;
  /**
   * Specifies the
   * [Urchin Traffic Module (UTM) parameters](https://en.wikipedia.org/wiki/UTM_parameters)
   * that are associated with a related marketing campaign. UTMInput is required for all Marketing
   * tactics except Storefront App. The utm field can only be set once and never modified.
   */
  readonly utm?: InputMaybe<UtmInput>;
};

/** Return type for `marketingActivityUpdate` mutation. */
export type MarketingActivityUpdatePayload = {
  /** The updated marketing activity. */
  readonly marketingActivity?: Maybe<MarketingActivity>;
  /** The redirect path from the embedded editor to the Shopify admin. */
  readonly redirectPath?: Maybe<Scalars['String']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for creating or updating an externally-managed marketing activity. */
export type MarketingActivityUpsertExternalInput = {
  /** The amount spent on the marketing activity. */
  readonly adSpend?: InputMaybe<MoneyInput>;
  /** The budget for this marketing activity. */
  readonly budget?: InputMaybe<MarketingActivityBudgetInput>;
  /** The unique string identifier of the channel to which this activity belongs. For the correct handle for your channel, contact your partner manager. */
  readonly channelHandle?: InputMaybe<Scalars['String']>;
  /** The date and time at which the activity started. On creation, if this field is omitted or set to `null`, the current time will be used if the status is set to `INACTIVE` or `DELETED_EXTERNALLY` . */
  readonly end?: InputMaybe<Scalars['DateTime']>;
  /** The hierarchy level of the activity within a campaign. The hierarchy level can't be updated. */
  readonly hierarchyLevel?: InputMaybe<MarketingActivityHierarchyLevel>;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  readonly marketingChannelType: MarketingChannel;
  /** The remote ID for the parent marketing activity, if creating hierarchical activities. */
  readonly parentRemoteId?: InputMaybe<Scalars['String']>;
  /** The domain from which ad clicks are forwarded to the shop. */
  readonly referringDomain?: InputMaybe<Scalars['String']>;
  /** A custom unique identifier for the marketing activity, which can be used to manage the activity and send engagement metrics without having to store our marketing activity ID in your systems. */
  readonly remoteId: Scalars['String'];
  /** The URL for a preview image that's used for the marketing activity. */
  readonly remotePreviewImageUrl?: InputMaybe<Scalars['URL']>;
  /** The URL for viewing and/or managing the activity outside of Shopify. */
  readonly remoteUrl: Scalars['URL'];
  /** The date and time at which the activity is scheduled to end. */
  readonly scheduledEnd?: InputMaybe<Scalars['DateTime']>;
  /** The date and time at which the activity is scheduled to start. */
  readonly scheduledStart?: InputMaybe<Scalars['DateTime']>;
  /** The date and time at which the activity started. On creation, if this field is omitted or set to `null`, the current time will be used. */
  readonly start?: InputMaybe<Scalars['DateTime']>;
  /** The status of the marketing activity. */
  readonly status: MarketingActivityExternalStatus;
  /** The method of marketing used for this marketing activity. The marketing tactic determines which default fields are included in the marketing activity. */
  readonly tactic: MarketingTactic;
  /** The title of the marketing activity. */
  readonly title: Scalars['String'];
  /** Value for a query parameter that gets inserted into storefront URLs for matching storefront traffic to this activity. This feature is currently available on a limited basis to some partners only. UTMs should continue to be used for most partners. Both the URL parameter value and UTM parameters can be set. */
  readonly urlParameterValue?: InputMaybe<Scalars['String']>;
  /** Specifies the [Urchin Traffic Module (UTM) parameters](https://en.wikipedia.org/wiki/UTM_parameters) that are associated with a related marketing campaign. Either the URL parameter value or UTM can be set, but not both. */
  readonly utm?: InputMaybe<UtmInput>;
};

/** Return type for `marketingActivityUpsertExternal` mutation. */
export type MarketingActivityUpsertExternalPayload = {
  /** The external marketing activity that was created or updated. */
  readonly marketingActivity?: Maybe<MarketingActivity>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketingActivityUserError>;
};

/** An error that occurs during the execution of marketing activity and engagement mutations. */
export type MarketingActivityUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MarketingActivityUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MarketingActivityUserError`. */
export enum MarketingActivityUserErrorCode {
  /** The marketing activity must be an external activity. */
  ACTIVITY_NOT_EXTERNAL = 'ACTIVITY_NOT_EXTERNAL',
  /** This activity has child activities and thus cannot be deleted. Child activities must be deleted before a parent activity. */
  CANNOT_DELETE_ACTIVITY_WITH_CHILD_EVENTS = 'CANNOT_DELETE_ACTIVITY_WITH_CHILD_EVENTS',
  /** The activity's tactic can not be updated from STOREFRONT_APP. */
  CANNOT_UPDATE_TACTIC_IF_ORIGINALLY_STOREFRONT_APP = 'CANNOT_UPDATE_TACTIC_IF_ORIGINALLY_STOREFRONT_APP',
  /** The activity's tactic can not be updated to STOREFRONT_APP. This type of tactic can only be specified when creating a new activity. */
  CANNOT_UPDATE_TACTIC_TO_STOREFRONT_APP = 'CANNOT_UPDATE_TACTIC_TO_STOREFRONT_APP',
  /** All currency codes provided in the input need to match. */
  CURRENCY_CODE_MISMATCH_INPUT = 'CURRENCY_CODE_MISMATCH_INPUT',
  /** A mutation can not be ran because a job to delete all external activities has been enqueued, which happens either from calling the marketingActivitiesDeleteAllExternal mutation or as a result of an app uninstall. */
  DELETE_JOB_ENQUEUED = 'DELETE_JOB_ENQUEUED',
  /** The job to delete all external activities failed to enqueue. */
  DELETE_JOB_FAILED_TO_ENQUEUE = 'DELETE_JOB_FAILED_TO_ENQUEUE',
  /** The channel handle value cannot be modified. */
  IMMUTABLE_CHANNEL_HANDLE = 'IMMUTABLE_CHANNEL_HANDLE',
  /** The hierarchy level cannot be modified. */
  IMMUTABLE_HIERARCHY_LEVEL = 'IMMUTABLE_HIERARCHY_LEVEL',
  /** The parent activity cannot be modified. */
  IMMUTABLE_PARENT_ID = 'IMMUTABLE_PARENT_ID',
  /** The URL parameter value cannot be modified. */
  IMMUTABLE_URL_PARAMETER = 'IMMUTABLE_URL_PARAMETER',
  /** The UTM parameters cannot be modified. */
  IMMUTABLE_UTM_PARAMETERS = 'IMMUTABLE_UTM_PARAMETERS',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The channel handle is not recognized. */
  INVALID_CHANNEL_HANDLE = 'INVALID_CHANNEL_HANDLE',
  /** Either the marketing activity ID or remote ID must be provided for the activity to be deleted. */
  INVALID_DELETE_ACTIVITY_EXTERNAL_ARGUMENTS = 'INVALID_DELETE_ACTIVITY_EXTERNAL_ARGUMENTS',
  /** Either the channel_handle or delete_engagements_for_all_channels must be provided when deleting a marketing engagement. */
  INVALID_DELETE_ENGAGEMENTS_ARGUMENTS = 'INVALID_DELETE_ENGAGEMENTS_ARGUMENTS',
  /** Either the marketing activity ID, remote ID, or UTM must be provided. */
  INVALID_MARKETING_ACTIVITY_EXTERNAL_ARGUMENTS = 'INVALID_MARKETING_ACTIVITY_EXTERNAL_ARGUMENTS',
  /** For activity level engagement, either the marketing activity ID or remote ID must be provided. For channel level engagement, the channel handle must be provided. */
  INVALID_MARKETING_ENGAGEMENT_ARGUMENTS = 'INVALID_MARKETING_ENGAGEMENT_ARGUMENTS',
  /** No identifier found. For activity level engagement, either the marketing activity ID or remote ID must be provided. For channel level engagement, the channel handle must be provided. */
  INVALID_MARKETING_ENGAGEMENT_ARGUMENT_MISSING = 'INVALID_MARKETING_ENGAGEMENT_ARGUMENT_MISSING',
  /** The remote ID does not correspond to an existing activity. */
  INVALID_REMOTE_ID = 'INVALID_REMOTE_ID',
  /** The currency codes provided need to match the referenced marketing activity's currency code. */
  MARKETING_ACTIVITY_CURRENCY_CODE_MISMATCH = 'MARKETING_ACTIVITY_CURRENCY_CODE_MISMATCH',
  /** Marketing activity does not exist. */
  MARKETING_ACTIVITY_DOES_NOT_EXIST = 'MARKETING_ACTIVITY_DOES_NOT_EXIST',
  /** A marketing activity with the same remote ID already exists. */
  MARKETING_ACTIVITY_WITH_REMOTE_ID_ALREADY_EXISTS = 'MARKETING_ACTIVITY_WITH_REMOTE_ID_ALREADY_EXISTS',
  /** A marketing activity with the same URL parameter value already exists. */
  MARKETING_ACTIVITY_WITH_URL_PARAMETER_VALUE_ALREADY_EXISTS = 'MARKETING_ACTIVITY_WITH_URL_PARAMETER_VALUE_ALREADY_EXISTS',
  /** A marketing activity with the same UTM campaign, medium, and source already exists. */
  MARKETING_ACTIVITY_WITH_UTM_CAMPAIGN_ALREADY_EXISTS = 'MARKETING_ACTIVITY_WITH_UTM_CAMPAIGN_ALREADY_EXISTS',
  /** Marketing activity is not valid, the associated marketing event does not exist. */
  MARKETING_EVENT_DOES_NOT_EXIST = 'MARKETING_EVENT_DOES_NOT_EXIST',
  /** Non-hierarchical marketing activities must have UTM parameters or a URL parameter value. */
  NON_HIERARCHIAL_REQUIRES_UTM_URL_PARAMETER = 'NON_HIERARCHIAL_REQUIRES_UTM_URL_PARAMETER',
  /** The input value is already taken. */
  TAKEN = 'TAKEN'
}

/** This type combines budget amount and its marketing budget type. */
export type MarketingBudget = {
  /** The budget type for a marketing activity. */
  readonly budgetType: MarketingBudgetBudgetType;
  /** The amount of budget for marketing activity. */
  readonly total: MoneyV2;
};

/** The budget type for a marketing activity. */
export enum MarketingBudgetBudgetType {
  /** A daily budget. */
  DAILY = 'DAILY',
  /** A budget for the lifetime of a marketing activity. */
  LIFETIME = 'LIFETIME'
}

/** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
export enum MarketingChannel {
  /** Displayed ads. */
  DISPLAY = 'DISPLAY',
  /** Email. */
  EMAIL = 'EMAIL',
  /** Referral links. */
  REFERRAL = 'REFERRAL',
  /** Paid search. */
  SEARCH = 'SEARCH',
  /** Social media. */
  SOCIAL = 'SOCIAL'
}

/** Marketing engagement represents customer activity taken on a marketing activity or a marketing channel. */
export type MarketingEngagement = {
  /** The total ad spend for the marketing content. Recurring weekly, monthly, or yearly spend needs to be divided into daily amounts. */
  readonly adSpend?: Maybe<MoneyV2>;
  /** The unique string identifier of the channel to which the engagement metrics are being provided. This should be set when and only when providing channel-level engagements. This should be nil when providing activity-level engagements. For the correct handle for your channel, contact your partner manager. */
  readonly channelHandle?: Maybe<Scalars['String']>;
  /** The total number of interactions, such as a button press or a screen touch, that occurred on the marketing content. */
  readonly clicksCount?: Maybe<Scalars['Int']>;
  /** The total number of comments on the marketing content. */
  readonly commentsCount?: Maybe<Scalars['Int']>;
  /** The total number of complaints on the marketing content. For message-based platforms such as email or SMS, this represents the number of marketing emails or messages that were marked as spam. For social media platforms, this represents the number of dislikes or the number of times marketing content was reported. */
  readonly complaintsCount?: Maybe<Scalars['Int']>;
  /** The total number of fails for the marketing content. For message-based platforms such as email or SMS, this represents the number of bounced marketing emails or messages. */
  readonly failsCount?: Maybe<Scalars['Int']>;
  /** The total number of favorites, likes, saves, or bookmarks on the marketing content. */
  readonly favoritesCount?: Maybe<Scalars['Int']>;
  /** The number of customers that have placed their first order. Doesn't include adjustments such as edits, exchanges, or returns. */
  readonly firstTimeCustomers?: Maybe<Scalars['Decimal']>;
  /** The total number of times marketing content was displayed to users, whether or not an interaction occurred. For message-based platforms such as email or SMS, this represents the number of marketing emails or messages that were delivered. */
  readonly impressionsCount?: Maybe<Scalars['Int']>;
  /** Specifies how the provided metrics have been aggregated. Cumulative metrics are aggregated from the first day of reporting up to and including `occuredOn`. Non-cumulative metrics are aggregated over the single day indicated in `occuredOn`. Cumulative metrics will monotonically increase in time as each record includes the previous day's values, and so on. Non-cumulative is strongly preferred, and support for cumulative metrics may be deprecated in the future. */
  readonly isCumulative: Scalars['Boolean'];
  /** The marketing activity object related to this engagement. This corresponds to the marketingActivityId passed in on creation of the engagement. */
  readonly marketingActivity?: Maybe<MarketingActivity>;
  /** The calendar date (in the time zone offset specified by the utcOffset field) for which the metrics are being reported. For example, a shop in UTC-5 would set utcOffset="-05:00" and aggregate all engagements from 05:00:00Z up to 29:00:00Z (5am UTC next day) for each call. */
  readonly occurredOn: Scalars['Date'];
  /** The number of orders generated from the marketing content. */
  readonly orders?: Maybe<Scalars['Decimal']>;
  /** The number of returning customers that have placed an order. Doesn't include adjustments such as edits, exchanges, or returns. */
  readonly returningCustomers?: Maybe<Scalars['Decimal']>;
  /** The amount of sales generated from the marketing content. */
  readonly sales?: Maybe<MoneyV2>;
  /** The total number of marketing emails or messages that were sent. */
  readonly sendsCount?: Maybe<Scalars['Int']>;
  /** The number of online store sessions generated from the marketing content. */
  readonly sessionsCount?: Maybe<Scalars['Int']>;
  /** The total number of times marketing content was distributed or reposted to either one's own network of followers through a social media platform or other digital channels. For message-based platforms such as email or SMS, this represents the number of times marketing emails or messages were forwarded. */
  readonly sharesCount?: Maybe<Scalars['Int']>;
  /** The total number of unique clicks on the marketing content. */
  readonly uniqueClicksCount?: Maybe<Scalars['Int']>;
  /** The total number of all users who saw marketing content since it was published. For  message-based platforms such as email or SMS, this represents the number of unique users that opened a  marketing email or message. For video-based content, this represents the number of unique users that  played video content. */
  readonly uniqueViewsCount?: Maybe<Scalars['Int']>;
  /** The total number of unsubscribes on the marketing content. For social media platforms, this represents the number of unfollows. */
  readonly unsubscribesCount?: Maybe<Scalars['Int']>;
  /** The UTC offset for the time zone in which the metrics are being reported, in the format `"+HH:MM"` or `"-HH:MM"`. Used in combination with occurredOn when aggregating daily metrics. Must match the account settings for the shop to minimize eventual discrepancies in reporting. */
  readonly utcOffset: Scalars['UtcOffset'];
  /** The total number of views on the marketing content. For message-based platforms such as email or SMS, this represents the number of times marketing emails or messages were opened. For video-based content, this represents the number of times videos were played. */
  readonly viewsCount?: Maybe<Scalars['Int']>;
};

/** Return type for `marketingEngagementCreate` mutation. */
export type MarketingEngagementCreatePayload = {
  /** The marketing engagement that was created. This represents customer activity taken on a marketing activity or a marketing channel. */
  readonly marketingEngagement?: Maybe<MarketingEngagement>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketingActivityUserError>;
};

/** The input fields for a marketing engagement. */
export type MarketingEngagementInput = {
  /** The total ad spend for the marketing content. Recurring weekly, monthly, or yearly spend needs to be divided into daily amounts. */
  readonly adSpend?: InputMaybe<MoneyInput>;
  /** The total number of interactions, such as a button press or a screen touch, that occurred on the marketing content. */
  readonly clicksCount?: InputMaybe<Scalars['Int']>;
  /** The total number of comments on the marketing content. */
  readonly commentsCount?: InputMaybe<Scalars['Int']>;
  /** The total number of complaints on the marketing content. For message-based platforms such as email or SMS, this represents the number of marketing emails or messages that were marked as spam. For social media platforms, this represents the number of dislikes or the number of times marketing content was reported. */
  readonly complaintsCount?: InputMaybe<Scalars['Int']>;
  /** The total number of fails for the marketing content. For message-based platforms such as email or SMS, this represents the number of bounced marketing emails or messages. */
  readonly failsCount?: InputMaybe<Scalars['Int']>;
  /** The total number of favorites, likes, saves, or bookmarks on the marketing content. */
  readonly favoritesCount?: InputMaybe<Scalars['Int']>;
  /** The number of customers that have placed their first order. Doesn't include adjustments such as edits, exchanges, or returns. */
  readonly firstTimeCustomers?: InputMaybe<Scalars['Decimal']>;
  /** The total number of times marketing content was displayed to users, whether or not an interaction occurred. For message-based platforms such as email or SMS, this represents the number of marketing emails or messages that were delivered. */
  readonly impressionsCount?: InputMaybe<Scalars['Int']>;
  /** Specifies how the provided metrics have been aggregated. Cumulative metrics are aggregated from the first day of reporting up to and including `occuredOn`. Non-cumulative metrics are aggregated over the single day indicated in `occuredOn`. Cumulative metrics will monotonically increase in time as each record includes the previous day's values, and so on. Non-cumulative is strongly preferred, and support for cumulative metrics may be deprecated in the future. */
  readonly isCumulative: Scalars['Boolean'];
  /** The calendar date (in the time zone offset specified by the utcOffset field) for which the metrics are being reported. For example, a shop in UTC-5 would set utcOffset="-05:00" and aggregate all engagements from 05:00:00Z up to 29:00:00Z (5am UTC next day) for each call. */
  readonly occurredOn: Scalars['Date'];
  /** The number of orders generated from the marketing content. */
  readonly orders?: InputMaybe<Scalars['Decimal']>;
  /** The number of returning customers that have placed an order. Doesn't include adjustments such as edits, exchanges, or returns. */
  readonly returningCustomers?: InputMaybe<Scalars['Decimal']>;
  /** The amount of sales generated from the marketing content. */
  readonly sales?: InputMaybe<MoneyInput>;
  /** The total number of marketing emails or messages that were sent. */
  readonly sendsCount?: InputMaybe<Scalars['Int']>;
  /** The number of online store sessions generated from the marketing content. */
  readonly sessionsCount?: InputMaybe<Scalars['Int']>;
  /** The total number of times marketing content was distributed or reposted to either one's own network of followers through a social media platform or other digital channels. For message-based platforms such as email or SMS, this represents the number of times marketing emails or messages were forwarded. */
  readonly sharesCount?: InputMaybe<Scalars['Int']>;
  /** The total number of unique clicks on the marketing content. */
  readonly uniqueClicksCount?: InputMaybe<Scalars['Int']>;
  /** The total number of all users who saw marketing content since it was published. For  message-based platforms such as email or SMS, this represents the number of unique users that opened a  marketing email or message. For video-based content, this represents the number of unique users that  played video content. */
  readonly uniqueViewsCount?: InputMaybe<Scalars['Int']>;
  /** The total number of unsubscribes on the marketing content. For social media platforms, this represents the number of unfollows. */
  readonly unsubscribesCount?: InputMaybe<Scalars['Int']>;
  /** The UTC offset for the time zone in which the metrics are being reported, in the format `"+HH:MM"` or `"-HH:MM"`. Used in combination with occurredOn when aggregating daily metrics. Must match the account settings for the shop to minimize eventual discrepancies in reporting. */
  readonly utcOffset: Scalars['UtcOffset'];
  /** The total number of views on the marketing content. For message-based platforms such as email or SMS, this represents the number of times marketing emails or messages were opened. For video-based content, this represents the number of times videos were played. */
  readonly viewsCount?: InputMaybe<Scalars['Int']>;
};

/** Return type for `marketingEngagementsDelete` mutation. */
export type MarketingEngagementsDeletePayload = {
  /** Informational message about the engagement data that has been marked for deletion. */
  readonly result?: Maybe<Scalars['String']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MarketingActivityUserError>;
};

/** Represents actions that market a merchant's store or products. */
export type MarketingEvent = LegacyInteroperability & Node & {
  /** The app that the marketing event is attributed to. */
  readonly app: App;
  /**
   * The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation.
   * @deprecated Use `marketingChannelType` instead.
   */
  readonly channel?: Maybe<MarketingChannel>;
  /** The unique string identifier of the channel to which this activity belongs. For the correct handle for your channel, contact your partner manager. */
  readonly channelHandle?: Maybe<Scalars['String']>;
  /** A human-readable description of the marketing event. */
  readonly description?: Maybe<Scalars['String']>;
  /** The date and time when the marketing event ended. */
  readonly endedAt?: Maybe<Scalars['DateTime']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The URL where the marketing event can be managed. */
  readonly manageUrl?: Maybe<Scalars['URL']>;
  /** The medium through which the marketing activity and event reached consumers. This is used for reporting aggregation. */
  readonly marketingChannelType?: Maybe<MarketingChannel>;
  /** The URL where the marketing event can be previewed. */
  readonly previewUrl?: Maybe<Scalars['URL']>;
  /** An optional ID that helps Shopify validate engagement data. */
  readonly remoteId?: Maybe<Scalars['String']>;
  /** The date and time when the marketing event is scheduled to end. */
  readonly scheduledToEndAt?: Maybe<Scalars['DateTime']>;
  /**
   * Where the `MarketingEvent` occurred and what kind of content was used.
   * Because `utmSource` and `utmMedium` are often used interchangeably, this is
   * based on a combination of `marketingChannel`, `referringDomain`, and `type` to
   * provide a consistent representation for any given piece of marketing
   * regardless of the app that created it.
   */
  readonly sourceAndMedium: Scalars['String'];
  /** The date and time when the marketing event started. */
  readonly startedAt: Scalars['DateTime'];
  /**
   * The display text for the marketing event type.
   * @deprecated Use `sourceAndMedium` instead.
   */
  readonly targetTypeDisplayText: Scalars['String'];
  /** The marketing event type. */
  readonly type: MarketingTactic;
  /** The name of the marketing campaign. */
  readonly utmCampaign?: Maybe<Scalars['String']>;
  /** The medium that the marketing campaign is using. Example values: `cpc`, `banner`. */
  readonly utmMedium?: Maybe<Scalars['String']>;
  /** The referrer of the marketing event. Example values: `google`, `newsletter`. */
  readonly utmSource?: Maybe<Scalars['String']>;
};

/** An auto-generated type for paginating through multiple MarketingEvents. */
export type MarketingEventConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MarketingEventEdge>;
  /** A list of nodes that are contained in MarketingEventEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MarketingEvent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one MarketingEvent and a cursor during pagination. */
export type MarketingEventEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MarketingEventEdge. */
  readonly node: MarketingEvent;
};

/** The set of valid sort keys for the MarketingEvent query. */
export enum MarketingEventSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `started_at` value. */
  STARTED_AT = 'STARTED_AT'
}

/** The available types of tactics for a marketing activity. */
export enum MarketingTactic {
  /** An abandoned cart recovery email. */
  ABANDONED_CART = 'ABANDONED_CART',
  /** An ad, such as a Facebook ad. */
  AD = 'AD',
  /** An affiliate link. */
  AFFILIATE = 'AFFILIATE',
  /** A link. */
  LINK = 'LINK',
  /** A loyalty program. */
  LOYALTY = 'LOYALTY',
  /** A messaging app, such as Facebook Messenger. */
  MESSAGE = 'MESSAGE',
  /** A newsletter. */
  NEWSLETTER = 'NEWSLETTER',
  /** A notification in the Shopify admin. */
  NOTIFICATION = 'NOTIFICATION',
  /** A blog post. */
  POST = 'POST',
  /** A retargeting ad. */
  RETARGETING = 'RETARGETING',
  /** Search engine optimization. */
  SEO = 'SEO',
  /** A popup on the online store. */
  STOREFRONT_APP = 'STOREFRONT_APP',
  /** A transactional email. */
  TRANSACTIONAL = 'TRANSACTIONAL'
}

/** Represents a media interface. */
export type Media = {
  /** A word or phrase to share the nature or contents of a media. */
  readonly alt?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The media content type. */
  readonly mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  readonly mediaErrors: ReadonlyArray<MediaError>;
  /** The warnings attached to the media. */
  readonly mediaWarnings: ReadonlyArray<MediaWarning>;
  /** The preview image for the media. */
  readonly preview?: Maybe<MediaPreviewImage>;
  /** Current status of the media. */
  readonly status: MediaStatus;
};

/** An auto-generated type for paginating through multiple Media. */
export type MediaConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MediaEdge>;
  /** A list of nodes that are contained in MediaEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Media>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The possible content types for a media object. */
export enum MediaContentType {
  /** An externally hosted video. */
  EXTERNAL_VIDEO = 'EXTERNAL_VIDEO',
  /** A Shopify-hosted image. */
  IMAGE = 'IMAGE',
  /** A 3d model. */
  MODEL_3D = 'MODEL_3D',
  /** A Shopify-hosted video. */
  VIDEO = 'VIDEO'
}

/** An auto-generated type which holds one Media and a cursor during pagination. */
export type MediaEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MediaEdge. */
  readonly node: Media;
};

/**
 * Represents a media error. This typically occurs when there is an issue with the media itself causing it to fail validation.
 * Check the media before attempting to upload again.
 */
export type MediaError = {
  /** Code representing the type of error. */
  readonly code: MediaErrorCode;
  /** Additional details regarding the error. */
  readonly details?: Maybe<Scalars['String']>;
  /** Translated error message. */
  readonly message: Scalars['String'];
};

/** Error types for media. */
export enum MediaErrorCode {
  /** Media could not be created because a file with the same name already exists. */
  DUPLICATE_FILENAME_ERROR = 'DUPLICATE_FILENAME_ERROR',
  /** Media could not be created because embed permissions are disabled for this video. */
  EXTERNAL_VIDEO_EMBED_DISABLED = 'EXTERNAL_VIDEO_EMBED_DISABLED',
  /** Media could not be created because video is either not found or still transcoding. */
  EXTERNAL_VIDEO_EMBED_NOT_FOUND_OR_TRANSCODING = 'EXTERNAL_VIDEO_EMBED_NOT_FOUND_OR_TRANSCODING',
  /** Media could not be created because the external video has an invalid aspect ratio. */
  EXTERNAL_VIDEO_INVALID_ASPECT_RATIO = 'EXTERNAL_VIDEO_INVALID_ASPECT_RATIO',
  /** Media could not be created because the external video could not be found. */
  EXTERNAL_VIDEO_NOT_FOUND = 'EXTERNAL_VIDEO_NOT_FOUND',
  /** Media could not be created because the external video is not listed or is private. */
  EXTERNAL_VIDEO_UNLISTED = 'EXTERNAL_VIDEO_UNLISTED',
  /** Media could not be created because the cumulative file storage limit would be exceeded. */
  FILE_STORAGE_LIMIT_EXCEEDED = 'FILE_STORAGE_LIMIT_EXCEEDED',
  /** File could not be processed because the source could not be downloaded. */
  GENERIC_FILE_DOWNLOAD_FAILURE = 'GENERIC_FILE_DOWNLOAD_FAILURE',
  /** File could not be created because the size is too large. */
  GENERIC_FILE_INVALID_SIZE = 'GENERIC_FILE_INVALID_SIZE',
  /** Media could not be processed because the image could not be downloaded. */
  IMAGE_DOWNLOAD_FAILURE = 'IMAGE_DOWNLOAD_FAILURE',
  /** Media could not be processed because the image could not be processed. */
  IMAGE_PROCESSING_FAILURE = 'IMAGE_PROCESSING_FAILURE',
  /** Media could not be created because the image has an invalid aspect ratio. */
  INVALID_IMAGE_ASPECT_RATIO = 'INVALID_IMAGE_ASPECT_RATIO',
  /** Media could not be created because the image size is too large. */
  INVALID_IMAGE_FILE_SIZE = 'INVALID_IMAGE_FILE_SIZE',
  /** Media could not be created because the image's resolution exceeds the max limit. */
  INVALID_IMAGE_RESOLUTION = 'INVALID_IMAGE_RESOLUTION',
  /** Media could not be processed because the signed URL was invalid. */
  INVALID_SIGNED_URL = 'INVALID_SIGNED_URL',
  /** Media timed out because it is currently being modified by another operation. */
  MEDIA_TIMEOUT_ERROR = 'MEDIA_TIMEOUT_ERROR',
  /** Media could not be created because the model file failed processing. */
  MODEL3D_GLB_OUTPUT_CREATION_ERROR = 'MODEL3D_GLB_OUTPUT_CREATION_ERROR',
  /** Media could not be created because the model can't be converted to USDZ format. */
  MODEL3D_GLB_TO_USDZ_CONVERSION_ERROR = 'MODEL3D_GLB_TO_USDZ_CONVERSION_ERROR',
  /** Media could not be created because the model file failed processing. */
  MODEL3D_PROCESSING_FAILURE = 'MODEL3D_PROCESSING_FAILURE',
  /** Media could not be created because the model's thumbnail generation failed. */
  MODEL3D_THUMBNAIL_GENERATION_ERROR = 'MODEL3D_THUMBNAIL_GENERATION_ERROR',
  /** There was an issue while trying to generate a new thumbnail. */
  MODEL3D_THUMBNAIL_REGENERATION_ERROR = 'MODEL3D_THUMBNAIL_REGENERATION_ERROR',
  /** Model failed validation. */
  MODEL3D_VALIDATION_ERROR = 'MODEL3D_VALIDATION_ERROR',
  /** Media error has occured for unknown reason. */
  UNKNOWN = 'UNKNOWN',
  /** Media could not be created because the image is an unsupported file type. */
  UNSUPPORTED_IMAGE_FILE_TYPE = 'UNSUPPORTED_IMAGE_FILE_TYPE',
  /** Media could not be created because it has an invalid file type. */
  VIDEO_INVALID_FILETYPE_ERROR = 'VIDEO_INVALID_FILETYPE_ERROR',
  /** Media could not be created because it does not meet the maximum duration requirement. */
  VIDEO_MAX_DURATION_ERROR = 'VIDEO_MAX_DURATION_ERROR',
  /** Media could not be created because it does not meet the maximum height requirement. */
  VIDEO_MAX_HEIGHT_ERROR = 'VIDEO_MAX_HEIGHT_ERROR',
  /** Media could not be created because it does not meet the maximum width requirement. */
  VIDEO_MAX_WIDTH_ERROR = 'VIDEO_MAX_WIDTH_ERROR',
  /** Media could not be created because the metadata could not be read. */
  VIDEO_METADATA_READ_ERROR = 'VIDEO_METADATA_READ_ERROR',
  /** Media could not be created because it does not meet the minimum duration requirement. */
  VIDEO_MIN_DURATION_ERROR = 'VIDEO_MIN_DURATION_ERROR',
  /** Media could not be created because it does not meet the minimum height requirement. */
  VIDEO_MIN_HEIGHT_ERROR = 'VIDEO_MIN_HEIGHT_ERROR',
  /** Media could not be created because it does not meet the minimum width requirement. */
  VIDEO_MIN_WIDTH_ERROR = 'VIDEO_MIN_WIDTH_ERROR',
  /** Video failed validation. */
  VIDEO_VALIDATION_ERROR = 'VIDEO_VALIDATION_ERROR'
}

/** Host for a Media Resource. */
export enum MediaHost {
  /** Host for Vimeo embedded videos. */
  VIMEO = 'VIMEO',
  /** Host for YouTube embedded videos. */
  YOUTUBE = 'YOUTUBE'
}

/** An image hosted on Shopify. */
export type MediaImage = File & HasMetafields & Media & Node & {
  /** A word or phrase to share the nature or contents of a media. */
  readonly alt?: Maybe<Scalars['String']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Any errors that have occurred on the file. */
  readonly fileErrors: ReadonlyArray<FileError>;
  /** The status of the file. */
  readonly fileStatus: FileStatus;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The image for the media. Returns `null` until `status` is `READY`. */
  readonly image?: Maybe<Image>;
  /** The media content type. */
  readonly mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  readonly mediaErrors: ReadonlyArray<MediaError>;
  /** The warnings attached to the media. */
  readonly mediaWarnings: ReadonlyArray<MediaWarning>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   * @deprecated No longer supported. Use metaobjects instead.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   * @deprecated No longer supported. Use metaobjects instead.
   */
  readonly metafields: MetafieldConnection;
  /** The MIME type of the image. */
  readonly mimeType?: Maybe<Scalars['String']>;
  /** The original source of the image. */
  readonly originalSource?: Maybe<MediaImageOriginalSource>;
  /** The preview image for the media. */
  readonly preview?: Maybe<MediaPreviewImage>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** Current status of the media. */
  readonly status: MediaStatus;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** An image hosted on Shopify. */
export type MediaImageMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** An image hosted on Shopify. */
export type MediaImageMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** An image hosted on Shopify. */
export type MediaImagePrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** An image hosted on Shopify. */
export type MediaImagePrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The original source for an image. */
export type MediaImageOriginalSource = {
  /** The size of the original file in bytes. */
  readonly fileSize?: Maybe<Scalars['Int']>;
  /** The URL of the original image, valid only for a short period. */
  readonly url?: Maybe<Scalars['URL']>;
};

/** Represents the preview image for a media. */
export type MediaPreviewImage = {
  /** The preview image for the media. Returns `null` until `status` is `READY`. */
  readonly image?: Maybe<Image>;
  /** Current status of the preview image. */
  readonly status: MediaPreviewImageStatus;
};

/** The possible statuses for a media preview image. */
export enum MediaPreviewImageStatus {
  /** Preview image processing has failed. */
  FAILED = 'FAILED',
  /** Preview image is being processed. */
  PROCESSING = 'PROCESSING',
  /** Preview image is ready to be displayed. */
  READY = 'READY',
  /** Preview image is uploaded but not yet processed. */
  UPLOADED = 'UPLOADED'
}

/** The possible statuses for a media object. */
export enum MediaStatus {
  /** Media processing has failed. */
  FAILED = 'FAILED',
  /** Media is being processed. */
  PROCESSING = 'PROCESSING',
  /** Media is ready to be displayed. */
  READY = 'READY',
  /** Media has been uploaded but not yet processed. */
  UPLOADED = 'UPLOADED'
}

/** Represents an error that happens during execution of a Media query or mutation. */
export type MediaUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MediaUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MediaUserError`. */
export enum MediaUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Invalid media type. */
  INVALID_MEDIA_TYPE = 'INVALID_MEDIA_TYPE',
  /** Exceeded the maximum number of 100 variant-media pairs per mutation call. */
  MAXIMUM_VARIANT_MEDIA_PAIRS_EXCEEDED = 'MAXIMUM_VARIANT_MEDIA_PAIRS_EXCEEDED',
  /** Media cannot be modified. It is currently being modified by another operation. */
  MEDIA_CANNOT_BE_MODIFIED = 'MEDIA_CANNOT_BE_MODIFIED',
  /** Media does not exist. */
  MEDIA_DOES_NOT_EXIST = 'MEDIA_DOES_NOT_EXIST',
  /** Media does not exist on the given product. */
  MEDIA_DOES_NOT_EXIST_ON_PRODUCT = 'MEDIA_DOES_NOT_EXIST_ON_PRODUCT',
  /** The specified media is not attached to the specified variant. */
  MEDIA_IS_NOT_ATTACHED_TO_VARIANT = 'MEDIA_IS_NOT_ATTACHED_TO_VARIANT',
  /** Missing arguments. */
  MISSING_ARGUMENTS = 'MISSING_ARGUMENTS',
  /** Model3d creation throttle was exceeded. */
  MODEL3D_THROTTLE_EXCEEDED = 'MODEL3D_THROTTLE_EXCEEDED',
  /** Model validation failed. */
  MODEL3D_VALIDATION_ERROR = 'MODEL3D_VALIDATION_ERROR',
  /** Non-ready media are not supported. */
  NON_READY_MEDIA = 'NON_READY_MEDIA',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Exceeded the limit of media per product. */
  PRODUCT_MEDIA_LIMIT_EXCEEDED = 'PRODUCT_MEDIA_LIMIT_EXCEEDED',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** Product variant already has attached media. */
  PRODUCT_VARIANT_ALREADY_HAS_MEDIA = 'PRODUCT_VARIANT_ALREADY_HAS_MEDIA',
  /** Variant does not exist on the given product. */
  PRODUCT_VARIANT_DOES_NOT_EXIST_ON_PRODUCT = 'PRODUCT_VARIANT_DOES_NOT_EXIST_ON_PRODUCT',
  /** Variant specified in more than one pair. */
  PRODUCT_VARIANT_SPECIFIED_MULTIPLE_TIMES = 'PRODUCT_VARIANT_SPECIFIED_MULTIPLE_TIMES',
  /** Exceeded the limit of media per shop. */
  SHOP_MEDIA_LIMIT_EXCEEDED = 'SHOP_MEDIA_LIMIT_EXCEEDED',
  /** Only one mediaId is allowed per variant-media input pair. */
  TOO_MANY_MEDIA_PER_INPUT_PAIR = 'TOO_MANY_MEDIA_PER_INPUT_PAIR',
  /** Video creation throttle was exceeded. */
  VIDEO_THROTTLE_EXCEEDED = 'VIDEO_THROTTLE_EXCEEDED',
  /** Video validation failed. */
  VIDEO_VALIDATION_ERROR = 'VIDEO_VALIDATION_ERROR'
}

/**
 * Represents a media warning. This occurs when there is a non-blocking concern regarding your media.
 * Consider reviewing your media to ensure it is correct and its parameters are as expected.
 */
export type MediaWarning = {
  /** The code representing the type of warning. */
  readonly code: MediaWarningCode;
  /** Translated warning message. */
  readonly message?: Maybe<Scalars['String']>;
};

/** Warning types for media. */
export enum MediaWarningCode {
  /** 3D model physical size might be invalid. The dimensions of your model are very large. Consider reviewing your model to ensure they are correct. */
  MODEL_LARGE_PHYSICAL_SIZE = 'MODEL_LARGE_PHYSICAL_SIZE',
  /** The thumbnail failed to regenerate.Try applying the changes again to regenerate the thumbnail. */
  MODEL_PREVIEW_IMAGE_FAIL = 'MODEL_PREVIEW_IMAGE_FAIL',
  /** 3D model physical size might be invalid. The dimensions of your model are very small. Consider reviewing your model to ensure they are correct. */
  MODEL_SMALL_PHYSICAL_SIZE = 'MODEL_SMALL_PHYSICAL_SIZE'
}

/** A menu for display on the storefront. */
export type Menu = HasPublishedTranslations & Node & {
  /** The menu's handle. */
  readonly handle: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether the menu is a default. The handle for default menus can't be updated and default menus can't be deleted. */
  readonly isDefault: Scalars['Boolean'];
  /** A list of items on the menu sorted by position. */
  readonly items: ReadonlyArray<MenuItem>;
  /** The menu's title. */
  readonly title: Scalars['String'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
};


/** A menu for display on the storefront. */
export type MenuItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** A menu for display on the storefront. */
export type MenuTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** An auto-generated type for paginating through multiple Menus. */
export type MenuConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MenuEdge>;
  /** A list of nodes that are contained in MenuEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Menu>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `menuCreate` mutation. */
export type MenuCreatePayload = {
  /** The created menu. */
  readonly menu?: Maybe<Menu>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MenuCreateUserError>;
};

/** An error that occurs during the execution of `MenuCreate`. */
export type MenuCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MenuCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MenuCreateUserError`. */
export enum MenuCreateUserErrorCode {
  /** The menu cannot be nested more than 3 level deep. */
  NESTING_TOO_DEEP = 'NESTING_TOO_DEEP',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** Return type for `menuDelete` mutation. */
export type MenuDeletePayload = {
  /** The ID of the deleted menu. */
  readonly deletedMenuId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MenuDeleteUserError>;
};

/** An error that occurs during the execution of `MenuDelete`. */
export type MenuDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MenuDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MenuDeleteUserError`. */
export enum MenuDeleteUserErrorCode {
  /** Menu does not exist. */
  MENU_DOES_NOT_EXIST = 'MENU_DOES_NOT_EXIST',
  /** Default menu cannot be deleted. */
  UNABLE_TO_DELETE_DEFAULT_MENU = 'UNABLE_TO_DELETE_DEFAULT_MENU'
}

/** An auto-generated type which holds one Menu and a cursor during pagination. */
export type MenuEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MenuEdge. */
  readonly node: Menu;
};

/** A menu item for display on the storefront. */
export type MenuItem = {
  /** A globally-unique ID of the navigation menu item. */
  readonly id: Scalars['ID'];
  /** List of the menu items nested under this item sorted by position. */
  readonly items: ReadonlyArray<MenuItem>;
  /** The ID of the resource to link to. */
  readonly resourceId?: Maybe<Scalars['ID']>;
  /** The menu item's tags to filter a collection. */
  readonly tags: ReadonlyArray<Scalars['String']>;
  /** The menu item's title. */
  readonly title: Scalars['String'];
  /** The menu item's type. */
  readonly type: MenuItemType;
  /** The menu item's url. */
  readonly url?: Maybe<Scalars['String']>;
};

/** The input fields required to create a valid menu item. */
export type MenuItemCreateInput = {
  /** List of the menu items nested under this item sorted by position. */
  readonly items?: InputMaybe<ReadonlyArray<MenuItemCreateInput>>;
  /** The menu item's association with an existing resource. */
  readonly resourceId?: InputMaybe<Scalars['ID']>;
  /** The menu item's tags to filter a collection. */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The menu item's title. */
  readonly title: Scalars['String'];
  /** The menu item's type. */
  readonly type: MenuItemType;
  /** The menu item's url to be used when the item doesn't point to a resource. */
  readonly url?: InputMaybe<Scalars['String']>;
};

/** A menu item type. */
export enum MenuItemType {
  /** The article menu item type. */
  ARTICLE = 'ARTICLE',
  /** The blog menu item type. */
  BLOG = 'BLOG',
  /** The catalog menu item type. */
  CATALOG = 'CATALOG',
  /** The collection menu item type. */
  COLLECTION = 'COLLECTION',
  /** The collections menu item type. */
  COLLECTIONS = 'COLLECTIONS',
  /** The customer_account_page menu item type. */
  CUSTOMER_ACCOUNT_PAGE = 'CUSTOMER_ACCOUNT_PAGE',
  /** The frontpage menu item type. */
  FRONTPAGE = 'FRONTPAGE',
  /** The http menu item type. */
  HTTP = 'HTTP',
  /** The metaobject menu item type. */
  METAOBJECT = 'METAOBJECT',
  /** The page menu item type. */
  PAGE = 'PAGE',
  /** The product menu item type. */
  PRODUCT = 'PRODUCT',
  /** The search menu item type. */
  SEARCH = 'SEARCH',
  /** The shop_policy menu item type. */
  SHOP_POLICY = 'SHOP_POLICY'
}

/** The input fields required to update a valid menu item. */
export type MenuItemUpdateInput = {
  /** A globally-unique ID of the online store navigation menu item. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** List of the menu items nested under this item sorted by position. */
  readonly items?: InputMaybe<ReadonlyArray<MenuItemUpdateInput>>;
  /** The menu item's association with an existing resource. */
  readonly resourceId?: InputMaybe<Scalars['ID']>;
  /** The menu item's tags to filter a collection. */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The menu item's title. */
  readonly title: Scalars['String'];
  /** The menu item's type. */
  readonly type: MenuItemType;
  /** The menu item's url to be used when the item doesn't point to a resource. */
  readonly url?: InputMaybe<Scalars['String']>;
};

/** The set of valid sort keys for the Menu query. */
export enum MenuSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Return type for `menuUpdate` mutation. */
export type MenuUpdatePayload = {
  /** The updated menu. */
  readonly menu?: Maybe<Menu>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MenuUpdateUserError>;
};

/** An error that occurs during the execution of `MenuUpdate`. */
export type MenuUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MenuUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MenuUpdateUserError`. */
export enum MenuUpdateUserErrorCode {
  /** The menu cannot be nested more than 3 level deep. */
  NESTING_TOO_DEEP = 'NESTING_TOO_DEEP',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/**
 * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
 * that's used to control how discounts can be combined.
 */
export enum MerchandiseDiscountClass {
  /**
   * The discount is combined with an
   * [order discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  ORDER = 'ORDER',
  /**
   * The discount is combined with a
   * [product discount](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * class.
   */
  PRODUCT = 'PRODUCT'
}

/** Merchant approval for accelerated onboarding to channel integration apps. */
export type MerchantApprovalSignals = {
  /** Whether the shop's Shopify Payments account identity is verified. Returns `false` if the identity is unverified or if the shop doesn't have a Shopify Payments account. */
  readonly identityVerified: Scalars['Boolean'];
  /** Whether Shopify has pre-verified the merchant's business for onboarding to channel integration apps. Returns `false` if the shop isn't marked for verification. */
  readonly verifiedByShopify: Scalars['Boolean'];
  /** Which tier of the Shopify verification was determined for the merchant's business for onboarding to channel integration apps. */
  readonly verifiedByShopifyTier: Scalars['String'];
};

/**
 * Metafields enable you to attach additional information to a Shopify resource, such as a [Product](https://shopify.dev/api/admin-graphql/latest/objects/product) or a [Collection](https://shopify.dev/api/admin-graphql/latest/objects/collection).
 * For more information about where you can attach metafields refer to [HasMetafields](https://shopify.dev/api/admin/graphql/reference/common-objects/HasMetafields).
 * Some examples of the data that metafields enable you to store are specifications, size charts, downloadable documents, release dates, images, or part numbers.
 * Metafields are identified by an owner resource, namespace, and key. and store a value along with type information for that value.
 */
export type Metafield = HasCompareDigest & LegacyInteroperability & Node & {
  /** The data stored in the resource, represented as a digest. */
  readonly compareDigest: Scalars['String'];
  /** The date and time when the metafield was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The metafield definition that the metafield belongs to, if any. */
  readonly definition?: Maybe<MetafieldDefinition>;
  /**
   * The description of the metafield.
   * @deprecated This field will be removed in a future release. Use the `description` on the metafield definition instead.
   *
   */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The data stored in the metafield in JSON format. */
  readonly jsonValue: Scalars['JSON'];
  /** The unique identifier for the metafield within its namespace. */
  readonly key: Scalars['String'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The container for a group of metafields that the metafield is associated with. */
  readonly namespace: Scalars['String'];
  /** The resource that the metafield is attached to. */
  readonly owner: HasMetafields;
  /** The type of resource that the metafield is attached to. */
  readonly ownerType: MetafieldOwnerType;
  /** Returns a reference object if the metafield definition's type is a resource reference. */
  readonly reference?: Maybe<MetafieldReference>;
  /** A list of reference objects if the metafield's type is a resource reference list. */
  readonly references?: Maybe<MetafieldReferenceConnection>;
  /**
   * The type of data that is stored in the metafield.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/types).
   */
  readonly type: Scalars['String'];
  /** The date and time when the metafield was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /** The data stored in the metafield. Always stored as a string, regardless of the metafield's type. */
  readonly value: Scalars['String'];
};


/**
 * Metafields enable you to attach additional information to a Shopify resource, such as a [Product](https://shopify.dev/api/admin-graphql/latest/objects/product) or a [Collection](https://shopify.dev/api/admin-graphql/latest/objects/collection).
 * For more information about where you can attach metafields refer to [HasMetafields](https://shopify.dev/api/admin/graphql/reference/common-objects/HasMetafields).
 * Some examples of the data that metafields enable you to store are specifications, size charts, downloadable documents, release dates, images, or part numbers.
 * Metafields are identified by an owner resource, namespace, and key. and store a value along with type information for that value.
 */
export type MetafieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Access permissions for the definition's metafields. */
export type MetafieldAccess = {
  /** The access permitted on the Admin API. */
  readonly admin?: Maybe<MetafieldAdminAccess>;
  /** The access permitted on the Customer Account API. */
  readonly customerAccount: MetafieldCustomerAccountAccess;
  /**
   * The explicit grants for this metafield definition, superseding the default admin access
   * for the specified grantees.
   * @deprecated Explicit grants are [deprecated](https://shopify.dev/changelog/deprecating-explicit-access-grants-for-app-owned-metafields).
   *
   */
  readonly grants: ReadonlyArray<MetafieldAccessGrant>;
  /** The access permitted on the Storefront API. */
  readonly storefront?: Maybe<MetafieldStorefrontAccess>;
};

/**
 * An explicit access grant for the metafields under this definition.
 *
 * Explicit grants are [deprecated](https://shopify.dev/changelog/deprecating-explicit-access-grants-for-app-owned-metafields).
 */
export type MetafieldAccessGrant = {
  /** The level of access the grantee has. */
  readonly access: MetafieldGrantAccessLevel;
  /** The grantee being granted access. */
  readonly grantee: Scalars['String'];
};

/** The input fields for an explicit access grant to be deleted for the metafields under this definition. */
export type MetafieldAccessGrantDeleteInput = {
  /** The grantee whose grant should be deleted. */
  readonly grantee: Scalars['String'];
};

/**
 * The input fields for an explicit access grant to be created or updated for the metafields under this definition.
 *
 * Explicit grants are [deprecated](https://shopify.dev/changelog/deprecating-explicit-access-grants-for-app-owned-metafields).
 */
export type MetafieldAccessGrantInput = {
  /** The level of access being granted. */
  readonly access: MetafieldGrantAccessLevel;
  /** The grantee being granted access. */
  readonly grantee: Scalars['String'];
};

/**
 * The input fields for possible operations for modifying access grants. Exactly one option is required.
 *
 * Explicit grants are [deprecated](https://shopify.dev/changelog/deprecating-explicit-access-grants-for-app-owned-metafields).
 */
export type MetafieldAccessGrantOperationInput = {
  /**
   * The input fields for an explicit access grant to be created or updated for the metafields under this definition.
   *
   * Explicit grants are [deprecated](https://shopify.dev/changelog/deprecating-explicit-access-grants-for-app-owned-metafields).
   */
  readonly create?: InputMaybe<MetafieldAccessGrantInput>;
  /** The input fields for an explicit access grant to be deleted for the metafields under this definition. */
  readonly delete?: InputMaybe<MetafieldAccessGrantDeleteInput>;
  /**
   * The input fields for an explicit access grant to be created or updated for the metafields under this definition.
   *
   * Explicit grants are [deprecated](https://shopify.dev/changelog/deprecating-explicit-access-grants-for-app-owned-metafields).
   */
  readonly update?: InputMaybe<MetafieldAccessGrantInput>;
};

/** The input fields that set access permissions for the definition's metafields. */
export type MetafieldAccessInput = {
  /** The access permitted on the Admin API. */
  readonly admin: MetafieldAdminAccessInput;
  /** The access permitted on the Customer Account API. */
  readonly customerAccount?: InputMaybe<MetafieldCustomerAccountAccessInput>;
  /** The access permitted on the Storefront API. */
  readonly storefront?: InputMaybe<MetafieldStorefrontAccessInput>;
};

/** The input fields for the access settings for the metafields under the definition. */
export type MetafieldAccessUpdateInput = {
  /** The admin access setting to use for the metafields under this definition. */
  readonly admin: MetafieldAdminAccessInput;
  /** The Customer Account API access setting to use for the metafields under this definition. */
  readonly customerAccount?: InputMaybe<MetafieldCustomerAccountAccessInput>;
  /** The storefront access setting to use for the metafields under this definition. */
  readonly storefront?: InputMaybe<MetafieldStorefrontAccessInput>;
};

/** Metafield access permissions for the Admin API. */
export enum MetafieldAdminAccess {
  /** The merchant has read-only access. No other apps have access. */
  MERCHANT_READ = 'MERCHANT_READ',
  /** The merchant has read and write access. No other apps have access. */
  MERCHANT_READ_WRITE = 'MERCHANT_READ_WRITE',
  /** The merchant and other apps have no access. */
  PRIVATE = 'PRIVATE',
  /** The merchant and other apps have read-only access. */
  PUBLIC_READ = 'PUBLIC_READ',
  /** The merchant and other apps have read and write access. */
  PUBLIC_READ_WRITE = 'PUBLIC_READ_WRITE'
}

/** Metafield access permissions for the Admin API. */
export enum MetafieldAdminAccessInput {
  /** The merchant has read-only access. No other apps have access. */
  MERCHANT_READ = 'MERCHANT_READ',
  /** The merchant has read and write access. No other apps have access. */
  MERCHANT_READ_WRITE = 'MERCHANT_READ_WRITE',
  /** The merchant and other apps have no access. */
  PRIVATE = 'PRIVATE',
  /** The merchant and other apps have read-only access. */
  PUBLIC_READ = 'PUBLIC_READ',
  /** The merchant and other apps have read and write access. */
  PUBLIC_READ_WRITE = 'PUBLIC_READ_WRITE'
}

/** Provides the capabilities of a metafield definition. */
export type MetafieldCapabilities = {
  /** Indicate whether a metafield definition is configured for filtering. */
  readonly adminFilterable: MetafieldCapabilityAdminFilterable;
  /** Indicate whether a metafield definition can be used as a smart collection condition. */
  readonly smartCollectionCondition: MetafieldCapabilitySmartCollectionCondition;
};

/** Information about the admin filterable capability on a metafield definition. */
export type MetafieldCapabilityAdminFilterable = {
  /** Indicates if the definition is eligible to have the capability. */
  readonly eligible: Scalars['Boolean'];
  /** Indicates if the capability is enabled. */
  readonly enabled: Scalars['Boolean'];
  /** Determines the metafield definition's filter status for use in admin filtering. */
  readonly status: MetafieldDefinitionAdminFilterStatus;
};

/** The input fields for enabling and disabling the admin filterable capability. */
export type MetafieldCapabilityAdminFilterableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The input fields for creating a metafield capability. */
export type MetafieldCapabilityCreateInput = {
  /** The input for updating the admin filterable capability. */
  readonly adminFilterable?: InputMaybe<MetafieldCapabilityAdminFilterableInput>;
  /** The input for updating the smart collection condition capability. */
  readonly smartCollectionCondition?: InputMaybe<MetafieldCapabilitySmartCollectionConditionInput>;
};

/** Information about the smart collection condition capability on a metafield definition. */
export type MetafieldCapabilitySmartCollectionCondition = {
  /** Indicates if the definition is eligible to have the capability. */
  readonly eligible: Scalars['Boolean'];
  /** Indicates if the capability is enabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The input fields for enabling and disabling the smart collection condition capability. */
export type MetafieldCapabilitySmartCollectionConditionInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The input fields for updating a metafield capability. */
export type MetafieldCapabilityUpdateInput = {
  /** The input for updating the admin filterable capability. */
  readonly adminFilterable?: InputMaybe<MetafieldCapabilityAdminFilterableInput>;
  /** The input for updating the smart collection condition capability. */
  readonly smartCollectionCondition?: InputMaybe<MetafieldCapabilitySmartCollectionConditionInput>;
};

/** An auto-generated type for paginating through multiple Metafields. */
export type MetafieldConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MetafieldEdge>;
  /** A list of nodes that are contained in MetafieldEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Metafield>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Metafield access permissions for the Customer Account API. */
export enum MetafieldCustomerAccountAccess {
  /** No access. */
  NONE = 'NONE',
  /** Read-only access. */
  READ = 'READ',
  /** Read and write access. */
  READ_WRITE = 'READ_WRITE'
}

/** Metafield access permissions for the Customer Account API. */
export enum MetafieldCustomerAccountAccessInput {
  /** No access. */
  NONE = 'NONE',
  /** Read-only access. */
  READ = 'READ',
  /** Read and write access. */
  READ_WRITE = 'READ_WRITE'
}

/**
 * Metafield definitions enable you to define additional validation constraints for metafields, and enable the
 * merchant to edit metafield values in context.
 */
export type MetafieldDefinition = Node & {
  /** The access settings associated with the metafield definition. */
  readonly access: MetafieldAccess;
  /** The capabilities of the metafield definition. */
  readonly capabilities: MetafieldCapabilities;
  /**
   * The [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions)
   * that determine what subtypes of resources a metafield definition applies to.
   */
  readonly constraints?: Maybe<MetafieldDefinitionConstraints>;
  /** The description of the metafield definition. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The unique identifier for the metafield definition within its namespace. */
  readonly key: Scalars['String'];
  /** The metafields that belong to the metafield definition. */
  readonly metafields: MetafieldConnection;
  /** The count of the metafields that belong to the metafield definition. */
  readonly metafieldsCount: Scalars['Int'];
  /** The human-readable name of the metafield definition. */
  readonly name: Scalars['String'];
  /** The container for a group of metafields that the metafield definition is associated with. */
  readonly namespace: Scalars['String'];
  /** The resource type that the metafield definition is attached to. */
  readonly ownerType: MetafieldOwnerType;
  /** The position of the metafield definition in the pinned list. */
  readonly pinnedPosition?: Maybe<Scalars['Int']>;
  /** The standard metafield definition template associated with the metafield definition. */
  readonly standardTemplate?: Maybe<StandardMetafieldDefinitionTemplate>;
  /**
   * The type of data that each of the metafields that belong to the metafield definition will store.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/types).
   */
  readonly type: MetafieldDefinitionType;
  /** Whether the metafield definition can be used as a collection condition. */
  readonly useAsCollectionCondition: Scalars['Boolean'];
  /** The validation status for the metafields that belong to the metafield definition. */
  readonly validationStatus: MetafieldDefinitionValidationStatus;
  /**
   * A list of [validation options](https://shopify.dev/apps/metafields/definitions/validation) for
   * the metafields that belong to the metafield definition. For example, for a metafield definition with the
   * type `date`, you can set a minimum date validation so that each of the metafields that belong to it can only
   * store dates after the specified minimum.
   */
  readonly validations: ReadonlyArray<MetafieldDefinitionValidation>;
  /**
   * Whether each of the metafields that belong to the metafield definition are visible from the Storefront API.
   * @deprecated Use `access.storefront` instead.
   */
  readonly visibleToStorefrontApi: Scalars['Boolean'];
};


/**
 * Metafield definitions enable you to define additional validation constraints for metafields, and enable the
 * merchant to edit metafield values in context.
 */
export type MetafieldDefinitionMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  validationStatus?: InputMaybe<MetafieldValidationStatus>;
};


/**
 * Metafield definitions enable you to define additional validation constraints for metafields, and enable the
 * merchant to edit metafield values in context.
 */
export type MetafieldDefinitionMetafieldsCountArgs = {
  validationStatus?: InputMaybe<MetafieldValidationStatus>;
};

/** Possible filter statuses associated with a metafield definition for use in admin filtering. */
export enum MetafieldDefinitionAdminFilterStatus {
  /** The metafield definition has failed to be enabled for admin filtering. */
  FAILED = 'FAILED',
  /** The metafield definition allows admin filtering by matching metafield values. */
  FILTERABLE = 'FILTERABLE',
  /** The metafield definition's metafields are currently being processed for admin filtering. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The metafield definition cannot be used for admin filtering. */
  NOT_FILTERABLE = 'NOT_FILTERABLE'
}

/** An auto-generated type for paginating through multiple MetafieldDefinitions. */
export type MetafieldDefinitionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MetafieldDefinitionEdge>;
  /** A list of nodes that are contained in MetafieldDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MetafieldDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Metafield definition constraint criteria to filter metafield definitions by. */
export enum MetafieldDefinitionConstraintStatus {
  /** Returns both constrained and unconstrained metafield definitions. */
  CONSTRAINED_AND_UNCONSTRAINED = 'CONSTRAINED_AND_UNCONSTRAINED',
  /** Only returns metafield definitions that are constrained to a resource subtype. */
  CONSTRAINED_ONLY = 'CONSTRAINED_ONLY',
  /** Only returns metafield definitions that are not constrained to a resource subtype. */
  UNCONSTRAINED_ONLY = 'UNCONSTRAINED_ONLY'
}

/** The input fields used to identify a subtype of a resource for the purposes of metafield definition constraints. */
export type MetafieldDefinitionConstraintSubtypeIdentifier = {
  /** The category of the resource subtype. */
  readonly key: Scalars['String'];
  /** The specific subtype value within the identified subtype category. */
  readonly value: Scalars['String'];
};

/** A constraint subtype value that the metafield definition applies to. */
export type MetafieldDefinitionConstraintValue = {
  /** The subtype value of the constraint. */
  readonly value: Scalars['String'];
};

/** An auto-generated type for paginating through multiple MetafieldDefinitionConstraintValues. */
export type MetafieldDefinitionConstraintValueConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MetafieldDefinitionConstraintValueEdge>;
  /** A list of nodes that are contained in MetafieldDefinitionConstraintValueEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MetafieldDefinitionConstraintValue>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one MetafieldDefinitionConstraintValue and a cursor during pagination. */
export type MetafieldDefinitionConstraintValueEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MetafieldDefinitionConstraintValueEdge. */
  readonly node: MetafieldDefinitionConstraintValue;
};

/**
 * The [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions)
 * that determine what subtypes of resources a metafield definition applies to.
 */
export type MetafieldDefinitionConstraints = {
  /** The category of resource subtypes that the definition applies to. */
  readonly key?: Maybe<Scalars['String']>;
  /** The specific constraint subtype values that the definition applies to. */
  readonly values: MetafieldDefinitionConstraintValueConnection;
};


/**
 * The [constraints](https://shopify.dev/apps/build/custom-data/metafields/conditional-metafield-definitions)
 * that determine what subtypes of resources a metafield definition applies to.
 */
export type MetafieldDefinitionConstraintsValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `metafieldDefinitionCreate` mutation. */
export type MetafieldDefinitionCreatePayload = {
  /** The metafield definition that was created. */
  readonly createdDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetafieldDefinitionCreateUserError>;
};

/** An error that occurs during the execution of `MetafieldDefinitionCreate`. */
export type MetafieldDefinitionCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MetafieldDefinitionCreateUserErrorCode>;
  /** The index of the array element that's causing the error. */
  readonly elementIndex?: Maybe<Scalars['Int']>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionCreateUserError`. */
export enum MetafieldDefinitionCreateUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** A duplicate option. */
  DUPLICATE_OPTION = 'DUPLICATE_OPTION',
  /** The maximum limit of grants per definition type has been exceeded. */
  GRANT_LIMIT_EXCEEDED = 'GRANT_LIMIT_EXCEEDED',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The metafield definition capability is invalid. */
  INVALID_CAPABILITY = 'INVALID_CAPABILITY',
  /** A field contains an invalid character. */
  INVALID_CHARACTER = 'INVALID_CHARACTER',
  /** The input combination is invalid. */
  INVALID_INPUT_COMBINATION = 'INVALID_INPUT_COMBINATION',
  /** An invalid option. */
  INVALID_OPTION = 'INVALID_OPTION',
  /** The maximum limit of definitions per owner type has exceeded. */
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  /** You have reached the maximum allowed definitions for automated collections. */
  OWNER_TYPE_LIMIT_EXCEEDED_FOR_AUTOMATED_COLLECTIONS = 'OWNER_TYPE_LIMIT_EXCEEDED_FOR_AUTOMATED_COLLECTIONS',
  /** The pinned limit has been reached for the owner type. */
  PINNED_LIMIT_REACHED = 'PINNED_LIMIT_REACHED',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** This namespace and key combination is reserved for standard definitions. */
  RESERVED_NAMESPACE_KEY = 'RESERVED_NAMESPACE_KEY',
  /** The definition limit per owner type has exceeded. */
  RESOURCE_TYPE_LIMIT_EXCEEDED = 'RESOURCE_TYPE_LIMIT_EXCEEDED',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** The definition type is not eligible to be used as collection condition. */
  TYPE_NOT_ALLOWED_FOR_CONDITIONS = 'TYPE_NOT_ALLOWED_FOR_CONDITIONS',
  /** This namespace and key combination is already in use for a set of your metafields. */
  UNSTRUCTURED_ALREADY_EXISTS = 'UNSTRUCTURED_ALREADY_EXISTS'
}

/** Return type for `metafieldDefinitionDelete` mutation. */
export type MetafieldDefinitionDeletePayload = {
  /** The ID of the deleted metafield definition. */
  readonly deletedDefinitionId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetafieldDefinitionDeleteUserError>;
};

/** An error that occurs during the execution of `MetafieldDefinitionDelete`. */
export type MetafieldDefinitionDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MetafieldDefinitionDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionDeleteUserError`. */
export enum MetafieldDefinitionDeleteUserErrorCode {
  /** Definition is managed by app configuration and cannot be modified through the API. */
  APP_CONFIG_MANAGED = 'APP_CONFIG_MANAGED',
  /** Owner type can't be used in this mutation. */
  DISALLOWED_OWNER_TYPE = 'DISALLOWED_OWNER_TYPE',
  /** Deleting an id type metafield definition requires deletion of its associated metafields. */
  ID_TYPE_DELETION_ERROR = 'ID_TYPE_DELETION_ERROR',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** Action cannot proceed. Definition is currently in use. */
  METAFIELD_DEFINITION_IN_USE = 'METAFIELD_DEFINITION_IN_USE',
  /** Definition not found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** Deleting a reference type metafield definition requires deletion of its associated metafields. */
  REFERENCE_TYPE_DELETION_ERROR = 'REFERENCE_TYPE_DELETION_ERROR',
  /** Deleting a definition in a reserved namespace requires deletion of its associated metafields. */
  RESERVED_NAMESPACE_ORPHANED_METAFIELDS = 'RESERVED_NAMESPACE_ORPHANED_METAFIELDS'
}

/** An auto-generated type which holds one MetafieldDefinition and a cursor during pagination. */
export type MetafieldDefinitionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MetafieldDefinitionEdge. */
  readonly node: MetafieldDefinition;
};

/** The input fields required to create a metafield definition. */
export type MetafieldDefinitionInput = {
  /** The access settings that apply to each of the metafields that belong to the metafield definition. */
  readonly access?: InputMaybe<MetafieldAccessInput>;
  /** The capabilities of the metafield definition. */
  readonly capabilities?: InputMaybe<MetafieldCapabilityCreateInput>;
  /** The description for the metafield definition. */
  readonly description?: InputMaybe<Scalars['String']>;
  /**
   * The unique identifier for the metafield definition within its namespace.
   *
   * Must be 2-64 characters long and only contain alphanumeric, hyphen, and underscore characters.
   */
  readonly key: Scalars['String'];
  /** The human-readable name for the metafield definition. */
  readonly name: Scalars['String'];
  /**
   * The container for a group of metafields that the metafield definition will be associated with. If omitted, the
   * app-reserved namespace will be used.
   *
   * Must be 3-255 characters long and only contain alphanumeric, hyphen, and underscore characters.
   */
  readonly namespace?: InputMaybe<Scalars['String']>;
  /** The resource type that the metafield definition is attached to. */
  readonly ownerType: MetafieldOwnerType;
  /**
   * Whether to [pin](https://help.shopify.com/manual/custom-data/metafields/pinning-metafield-definitions)
   * the metafield definition.
   */
  readonly pin?: InputMaybe<Scalars['Boolean']>;
  /**
   * The type of data that each of the metafields that belong to the metafield definition will store.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/types).
   */
  readonly type: Scalars['String'];
  /**
   * A list of [validation options](https://shopify.dev/apps/metafields/definitions/validation) for
   * the metafields that belong to the metafield definition. For example, for a metafield definition with the
   * type `date`, you can set a minimum date validation so that each of the metafields that belong to it can only
   * store dates after the specified minimum.
   */
  readonly validations?: InputMaybe<ReadonlyArray<MetafieldDefinitionValidationInput>>;
};

/** Return type for `metafieldDefinitionPin` mutation. */
export type MetafieldDefinitionPinPayload = {
  /** The metafield definition that was pinned. */
  readonly pinnedDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetafieldDefinitionPinUserError>;
};

/** An error that occurs during the execution of `MetafieldDefinitionPin`. */
export type MetafieldDefinitionPinUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MetafieldDefinitionPinUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionPinUserError`. */
export enum MetafieldDefinitionPinUserErrorCode {
  /** The metafield definition is already pinned. */
  ALREADY_PINNED = 'ALREADY_PINNED',
  /** Owner type can't be used in this mutation. */
  DISALLOWED_OWNER_TYPE = 'DISALLOWED_OWNER_TYPE',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The metafield definition was not found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The pinned limit has been reached for owner type. */
  PINNED_LIMIT_REACHED = 'PINNED_LIMIT_REACHED'
}

/** Possible metafield definition pinned statuses. */
export enum MetafieldDefinitionPinnedStatus {
  /** All metafield definitions. */
  ANY = 'ANY',
  /** Only metafield definitions that are pinned. */
  PINNED = 'PINNED',
  /** Only metafield definitions that are not pinned. */
  UNPINNED = 'UNPINNED'
}

/** The set of valid sort keys for the MetafieldDefinition query. */
export enum MetafieldDefinitionSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /** Sort by the `pinned_position` value. */
  PINNED_POSITION = 'PINNED_POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/**
 * The type and name for the optional validation configuration of a metafield.
 *
 * For example, a supported validation might consist of a `max` name and a `number_integer` type.
 * This validation can then be used to enforce a maximum character length for a `single_line_text_field` metafield.
 */
export type MetafieldDefinitionSupportedValidation = {
  /** The name of the metafield definition validation. */
  readonly name: Scalars['String'];
  /** The type of input for the validation. */
  readonly type: Scalars['String'];
};

/** A metafield definition type provides basic foundation and validation for a metafield. */
export type MetafieldDefinitionType = {
  /** The category associated with the metafield definition type. */
  readonly category: Scalars['String'];
  /**
   * The name of the type for the metafield definition.
   * See the list of [supported types](https://shopify.dev/apps/metafields/types).
   */
  readonly name: Scalars['String'];
  /** The supported validations for a metafield definition type. */
  readonly supportedValidations: ReadonlyArray<MetafieldDefinitionSupportedValidation>;
  /** Whether metafields without a definition can be migrated to a definition of this type. */
  readonly supportsDefinitionMigrations: Scalars['Boolean'];
  /**
   * The value type for a metafield created with this definition type.
   * @deprecated `valueType` is deprecated and `name` should be used for type information.
   */
  readonly valueType: MetafieldValueType;
};

/** Return type for `metafieldDefinitionUnpin` mutation. */
export type MetafieldDefinitionUnpinPayload = {
  /** The metafield definition that was unpinned. */
  readonly unpinnedDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetafieldDefinitionUnpinUserError>;
};

/** An error that occurs during the execution of `MetafieldDefinitionUnpin`. */
export type MetafieldDefinitionUnpinUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MetafieldDefinitionUnpinUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionUnpinUserError`. */
export enum MetafieldDefinitionUnpinUserErrorCode {
  /** Definition is managed by app configuration and cannot be modified through the API. */
  APP_CONFIG_MANAGED = 'APP_CONFIG_MANAGED',
  /** Owner type can't be used in this mutation. */
  DISALLOWED_OWNER_TYPE = 'DISALLOWED_OWNER_TYPE',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The metafield definition was not found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The metafield definition isn't pinned. */
  NOT_PINNED = 'NOT_PINNED'
}

/** The input fields required to update a metafield definition. */
export type MetafieldDefinitionUpdateInput = {
  /** The access settings that apply to each of the metafields that belong to the metafield definition. */
  readonly access?: InputMaybe<MetafieldAccessUpdateInput>;
  /** The capabilities of the metafield definition. */
  readonly capabilities?: InputMaybe<MetafieldCapabilityUpdateInput>;
  /** The description for the metafield definition. */
  readonly description?: InputMaybe<Scalars['String']>;
  /**
   * The unique identifier for the metafield definition within its namespace. Used to help identify the metafield
   * definition, but can't be updated itself.
   */
  readonly key: Scalars['String'];
  /** The human-readable name for the metafield definition. */
  readonly name?: InputMaybe<Scalars['String']>;
  /**
   * The container for a group of metafields that the metafield definition is associated with. Used to help identify
   * the metafield definition, but cannot be updated itself. If omitted, the app-reserved namespace will be used.
   */
  readonly namespace?: InputMaybe<Scalars['String']>;
  /**
   * The resource type that the metafield definition is attached to. Used to help identify the metafield definition,
   * but can't be updated itself.
   */
  readonly ownerType: MetafieldOwnerType;
  /** Whether to pin the metafield definition. */
  readonly pin?: InputMaybe<Scalars['Boolean']>;
  /**
   * A list of [validation options](https://shopify.dev/apps/metafields/definitions/validation) for
   * the metafields that belong to the metafield definition. For example, for a metafield definition with the
   * type `date`, you can set a minimum date validation so that each of the metafields that belong to it can only
   * store dates after the specified minimum.
   */
  readonly validations?: InputMaybe<ReadonlyArray<MetafieldDefinitionValidationInput>>;
};

/** Return type for `metafieldDefinitionUpdate` mutation. */
export type MetafieldDefinitionUpdatePayload = {
  /** The metafield definition that was updated. */
  readonly updatedDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetafieldDefinitionUpdateUserError>;
  /** The asynchronous job updating the metafield definition's validation_status. */
  readonly validationJob?: Maybe<Job>;
};

/** An error that occurs during the execution of `MetafieldDefinitionUpdate`. */
export type MetafieldDefinitionUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MetafieldDefinitionUpdateUserErrorCode>;
  /** The index of the array element that's causing the error. */
  readonly elementIndex?: Maybe<Scalars['Int']>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MetafieldDefinitionUpdateUserError`. */
export enum MetafieldDefinitionUpdateUserErrorCode {
  /** Admin access can only be specified for app-owned metafield definitions. */
  ADMIN_ACCESS_INPUT_NOT_ALLOWED = 'ADMIN_ACCESS_INPUT_NOT_ALLOWED',
  /** Definition is managed by app configuration and cannot be modified through the API. */
  APP_CONFIG_MANAGED = 'APP_CONFIG_MANAGED',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The metafield definition capability cannot be disabled. */
  CAPABILITY_CANNOT_BE_DISABLED = 'CAPABILITY_CANNOT_BE_DISABLED',
  /** A capability is required for the definition type but is disabled. */
  CAPABILITY_REQUIRED_BUT_DISABLED = 'CAPABILITY_REQUIRED_BUT_DISABLED',
  /** Owner type can't be used in this mutation. */
  DISALLOWED_OWNER_TYPE = 'DISALLOWED_OWNER_TYPE',
  /** A duplicate option. */
  DUPLICATE_OPTION = 'DUPLICATE_OPTION',
  /** The maximum limit of grants per definition type has been exceeded. */
  GRANT_LIMIT_EXCEEDED = 'GRANT_LIMIT_EXCEEDED',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The metafield definition capability is invalid. */
  INVALID_CAPABILITY = 'INVALID_CAPABILITY',
  /** The metafield definition constraints are invalid. */
  INVALID_CONSTRAINTS = 'INVALID_CONSTRAINTS',
  /** An invalid input. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** The input combination is invalid. */
  INVALID_INPUT_COMBINATION = 'INVALID_INPUT_COMBINATION',
  /** An invalid option. */
  INVALID_OPTION = 'INVALID_OPTION',
  /** Action cannot proceed. Definition is currently in use. */
  METAFIELD_DEFINITION_IN_USE = 'METAFIELD_DEFINITION_IN_USE',
  /** You cannot change the metaobject definition pointed to by a metaobject reference metafield definition. */
  METAOBJECT_DEFINITION_CHANGED = 'METAOBJECT_DEFINITION_CHANGED',
  /** The metafield definition wasn't found. */
  NOT_FOUND = 'NOT_FOUND',
  /** You have reached the maximum allowed definitions for automated collections. */
  OWNER_TYPE_LIMIT_EXCEEDED_FOR_AUTOMATED_COLLECTIONS = 'OWNER_TYPE_LIMIT_EXCEEDED_FOR_AUTOMATED_COLLECTIONS',
  /** The pinned limit has been reached for the owner type. */
  PINNED_LIMIT_REACHED = 'PINNED_LIMIT_REACHED',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The definition type is not eligible to be used as collection condition. */
  TYPE_NOT_ALLOWED_FOR_CONDITIONS = 'TYPE_NOT_ALLOWED_FOR_CONDITIONS',
  /** The metafield definition does not support pinning. */
  UNSUPPORTED_PINNING = 'UNSUPPORTED_PINNING'
}

/**
 * A configured metafield definition validation.
 *
 * For example, for a metafield definition of `number_integer` type, you can set a validation with the name `max`
 * and a value of `15`. This validation will ensure that the value of the metafield is a number less than or equal to 15.
 *
 * Refer to the [list of supported validations](https://shopify.dev/api/admin/graphql/reference/common-objects/metafieldDefinitionTypes#examples-Fetch_all_metafield_definition_types).
 */
export type MetafieldDefinitionValidation = {
  /** The validation name. */
  readonly name: Scalars['String'];
  /** The name for the metafield type of this validation. */
  readonly type: Scalars['String'];
  /** The validation value. */
  readonly value?: Maybe<Scalars['String']>;
};

/**
 * The name and value for a metafield definition validation.
 *
 * For example, for a metafield definition of `single_line_text_field` type, you can set a validation with the name `min` and a value of `10`.
 * This validation will ensure that the value of the metafield is at least 10 characters.
 *
 * Refer to the [list of supported validations](https://shopify.dev/api/admin/graphql/reference/common-objects/metafieldDefinitionTypes#examples-Fetch_all_metafield_definition_types).
 */
export type MetafieldDefinitionValidationInput = {
  /** The name for the metafield definition validation. */
  readonly name: Scalars['String'];
  /** The value for the metafield definition validation. */
  readonly value: Scalars['String'];
};

/** Possible metafield definition validation statuses. */
export enum MetafieldDefinitionValidationStatus {
  /** All of this definition's metafields are valid. */
  ALL_VALID = 'ALL_VALID',
  /** Asynchronous validation of this definition's metafields is in progress. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Some of this definition's metafields are invalid. */
  SOME_INVALID = 'SOME_INVALID'
}

/** The input fields to delete a metafield. */
export type MetafieldDeleteInput = {
  /** The ID of the metafield to delete. */
  readonly id: Scalars['ID'];
};

/** Return type for `metafieldDelete` mutation. */
export type MetafieldDeletePayload = {
  /** The ID of the deleted metafield. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one Metafield and a cursor during pagination. */
export type MetafieldEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MetafieldEdge. */
  readonly node: Metafield;
};

/** Possible access levels for explicit metafield access grants. */
export enum MetafieldGrantAccessLevel {
  /** Read metafield access. */
  READ = 'READ',
  /** Read and write metafield access. */
  READ_WRITE = 'READ_WRITE'
}

/** Identifies a metafield by its owner resource, namespace, and key. */
export type MetafieldIdentifier = {
  /** The key of the metafield. */
  readonly key: Scalars['String'];
  /** The namespace of the metafield. */
  readonly namespace: Scalars['String'];
  /** GID of the owner resource that the metafield belongs to. */
  readonly ownerId: Scalars['ID'];
};

/** The input fields that identify metafields. */
export type MetafieldIdentifierInput = {
  /** The key of the metafield. */
  readonly key: Scalars['String'];
  /** The namespace of the metafield. */
  readonly namespace: Scalars['String'];
  /** The unique ID of the resource that the metafield is attached to. */
  readonly ownerId: Scalars['ID'];
};

/**
 * The input fields to use to create or update a metafield through a mutation on the owning resource.
 * An alternative way to create or update a metafield is by using the
 * [metafieldsSet](https://shopify.dev/api/admin-graphql/latest/mutations/metafieldsSet) mutation.
 */
export type MetafieldInput = {
  /** The unique ID of the metafield. Using `owner_id`, `namespace`, and `key` is preferred for creating and updating. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /**
   * The unique identifier for a metafield within its namespace.
   *
   * Required when creating a metafield, but optional when updating. Used to help identify the metafield when
   * updating, but can't be updated itself.
   *
   * Must be 2-64 characters long and can contain alphanumeric, hyphen, and underscore characters.
   */
  readonly key?: InputMaybe<Scalars['String']>;
  /**
   * The container for a group of metafields that the metafield is or will be associated with. Used in tandem with
   * `key` to lookup a metafield on a resource, preventing conflicts with other metafields with the same `key`.
   *
   * Required when creating a metafield, but optional when updating. Used to help identify the metafield when
   * updating, but can't be updated itself.
   *
   * Must be 3-255 characters long and can contain alphanumeric, hyphen, and underscore characters.
   */
  readonly namespace?: InputMaybe<Scalars['String']>;
  /**
   * The type of data that is stored in the metafield.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/types).
   *
   * Required when creating or updating a metafield without a definition.
   */
  readonly type?: InputMaybe<Scalars['String']>;
  /** The data stored in the metafield. Always stored as a string, regardless of the metafield's type. */
  readonly value?: InputMaybe<Scalars['String']>;
};

/** Possible types of a metafield's owner resource. */
export enum MetafieldOwnerType {
  /** The Api Permission metafield owner type. */
  API_PERMISSION = 'API_PERMISSION',
  /** The Article metafield owner type. */
  ARTICLE = 'ARTICLE',
  /** The Blog metafield owner type. */
  BLOG = 'BLOG',
  /** The Cart Transform metafield owner type. */
  CARTTRANSFORM = 'CARTTRANSFORM',
  /** The Collection metafield owner type. */
  COLLECTION = 'COLLECTION',
  /** The Company metafield owner type. */
  COMPANY = 'COMPANY',
  /** The Company Location metafield owner type. */
  COMPANY_LOCATION = 'COMPANY_LOCATION',
  /** The Customer metafield owner type. */
  CUSTOMER = 'CUSTOMER',
  /** The Delivery Customization metafield owner type. */
  DELIVERY_CUSTOMIZATION = 'DELIVERY_CUSTOMIZATION',
  /** The Discount metafield owner type. */
  DISCOUNT = 'DISCOUNT',
  /** The draft order metafield owner type. */
  DRAFTORDER = 'DRAFTORDER',
  /** The Fulfillment Constraint Rule metafield owner type. */
  FULFILLMENT_CONSTRAINT_RULE = 'FULFILLMENT_CONSTRAINT_RULE',
  /** The GiftCardTransaction metafield owner type. */
  GIFT_CARD_TRANSACTION = 'GIFT_CARD_TRANSACTION',
  /** The Location metafield owner type. */
  LOCATION = 'LOCATION',
  /** The Market metafield owner type. */
  MARKET = 'MARKET',
  /** The Media Image metafield owner type. */
  MEDIA_IMAGE = 'MEDIA_IMAGE',
  /** The Order metafield owner type. */
  ORDER = 'ORDER',
  /** The Order Routing Location Rule metafield owner type. */
  ORDER_ROUTING_LOCATION_RULE = 'ORDER_ROUTING_LOCATION_RULE',
  /** The Page metafield owner type. */
  PAGE = 'PAGE',
  /** The Payment Customization metafield owner type. */
  PAYMENT_CUSTOMIZATION = 'PAYMENT_CUSTOMIZATION',
  /** The Product metafield owner type. */
  PRODUCT = 'PRODUCT',
  /** The Product Variant metafield owner type. */
  PRODUCTVARIANT = 'PRODUCTVARIANT',
  /** The Selling Plan metafield owner type. */
  SELLING_PLAN = 'SELLING_PLAN',
  /** The Shop metafield owner type. */
  SHOP = 'SHOP',
  /** The Validation metafield owner type. */
  VALIDATION = 'VALIDATION'
}

/** The resource referenced by the metafield value. */
export type MetafieldReference = Collection | Company | Customer | GenericFile | MediaImage | Metaobject | Model3d | Order | Page | Product | ProductVariant | TaxonomyValue | Video;

/** An auto-generated type for paginating through multiple MetafieldReferences. */
export type MetafieldReferenceConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MetafieldReferenceEdge>;
  /** A list of nodes that are contained in MetafieldReferenceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Maybe<MetafieldReference>>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one MetafieldReference and a cursor during pagination. */
export type MetafieldReferenceEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MetafieldReferenceEdge. */
  readonly node?: Maybe<MetafieldReference>;
};

/** Types of resources that may use metafields to reference other resources. */
export type MetafieldReferencer = AppInstallation | Article | Blog | Collection | Company | CompanyLocation | Customer | DeliveryCustomization | DiscountAutomaticNode | DiscountCodeNode | DiscountNode | DraftOrder | FulfillmentOrder | Location | Market | Metaobject | Order | Page | PaymentCustomization | Product | ProductVariant | Shop;

/**
 * Defines a relation between two resources via a reference metafield.
 * The referencer owns the joining field with a given namespace and key,
 * while the target is referenced by the field.
 */
export type MetafieldRelation = {
  /** The key of the field making the reference. */
  readonly key: Scalars['String'];
  /** The name of the field making the reference. */
  readonly name: Scalars['String'];
  /** The namespace of the metafield making the reference, or type of the metaobject. */
  readonly namespace: Scalars['String'];
  /** The resource making the reference. */
  readonly referencer: MetafieldReferencer;
  /**
   * The referenced resource.
   * @deprecated No longer supported. Access the object directly instead.
   */
  readonly target: MetafieldReference;
};

/** An auto-generated type for paginating through multiple MetafieldRelations. */
export type MetafieldRelationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MetafieldRelationEdge>;
  /** A list of nodes that are contained in MetafieldRelationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MetafieldRelation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one MetafieldRelation and a cursor during pagination. */
export type MetafieldRelationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MetafieldRelationEdge. */
  readonly node: MetafieldRelation;
};

/** Metafield access permissions for the Storefront API. */
export enum MetafieldStorefrontAccess {
  /** Liquid-only access. This access permission is deprecated and can not be set. */
  LEGACY_LIQUID_ONLY = 'LEGACY_LIQUID_ONLY',
  /** No access. */
  NONE = 'NONE',
  /** Read-only access. */
  PUBLIC_READ = 'PUBLIC_READ'
}

/** Metafield access permissions for the Storefront API. */
export enum MetafieldStorefrontAccessInput {
  /** No access. */
  NONE = 'NONE',
  /** Read-only access. */
  PUBLIC_READ = 'PUBLIC_READ'
}

/**
 * By default, the Storefront API can't read metafields. To make specific metafields visible in the Storefront API,
 * you need to create a `MetafieldStorefrontVisibility` record. A `MetafieldStorefrontVisibility` record is a list
 * of the metafields, defined by the `owner_type`, `namespace`, and `key`, to make visible in the Storefront API.
 *
 * Learn about [exposing metafields in the Storefront API]
 * (https://shopify.dev/custom-storefronts/products-collections/metafields)
 * for more details.
 */
export type MetafieldStorefrontVisibility = LegacyInteroperability & Node & {
  /** The date and time when the metafield was set to visible in the Storefront API. */
  readonly createdAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The key of a metafield to make visible in the Storefront API. */
  readonly key: Scalars['String'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The namespace of a metafield to make visible in the Storefront API. */
  readonly namespace: Scalars['String'];
  /** The owner type of a metafield to make visible in the Storefront API. */
  readonly ownerType: MetafieldOwnerType;
  /** The date and time when the `MetafieldStorefrontVisilibty` record was updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple MetafieldStorefrontVisibilities. */
export type MetafieldStorefrontVisibilityConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MetafieldStorefrontVisibilityEdge>;
  /** A list of nodes that are contained in MetafieldStorefrontVisibilityEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MetafieldStorefrontVisibility>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `metafieldStorefrontVisibilityCreate` mutation. */
export type MetafieldStorefrontVisibilityCreatePayload = {
  /** The `MetafieldStorefrontVisibility` that was created. */
  readonly metafieldStorefrontVisibility?: Maybe<MetafieldStorefrontVisibility>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `metafieldStorefrontVisibilityDelete` mutation. */
export type MetafieldStorefrontVisibilityDeletePayload = {
  /** The ID of the deleted `MetafieldStorefrontVisibility` record. */
  readonly deletedMetafieldStorefrontVisibilityId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one MetafieldStorefrontVisibility and a cursor during pagination. */
export type MetafieldStorefrontVisibilityEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MetafieldStorefrontVisibilityEdge. */
  readonly node: MetafieldStorefrontVisibility;
};

/** The input fields to create a MetafieldStorefrontVisibility record. */
export type MetafieldStorefrontVisibilityInput = {
  /** The key of a metafield to make visible in the Storefront API. */
  readonly key: Scalars['String'];
  /** The namespace of a metafield to make visible in the Storefront API. If omitted the app reserved namespace will be used. */
  readonly namespace?: InputMaybe<Scalars['String']>;
  /** The owner type of a metafield to make visible in the Storefront API. */
  readonly ownerType: MetafieldOwnerType;
};

/** Possible metafield validation statuses. */
export enum MetafieldValidationStatus {
  /** Any validation status (valid or invalid). */
  ANY = 'ANY',
  /** Invalid (according to definition). */
  INVALID = 'INVALID',
  /** Valid (according to definition). */
  VALID = 'VALID'
}

/**
 * Legacy type information for the stored value.
 * Replaced by `type`.
 */
export enum MetafieldValueType {
  /** A `true` or `false` value. */
  BOOLEAN = 'BOOLEAN',
  /** A whole number. */
  INTEGER = 'INTEGER',
  /** A JSON string. */
  JSON_STRING = 'JSON_STRING',
  /** A text field. */
  STRING = 'STRING'
}

/** Return type for `metafieldsDelete` mutation. */
export type MetafieldsDeletePayload = {
  /** List of metafield identifiers that were deleted, null if the corresponding metafield isn't found. */
  readonly deletedMetafields?: Maybe<ReadonlyArray<Maybe<MetafieldIdentifier>>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for a metafield value to set. */
export type MetafieldsSetInput = {
  /** The `compareDigest` value obtained from a previous query. Provide this with updates to ensure the metafield is modified safely. */
  readonly compareDigest?: InputMaybe<Scalars['String']>;
  /**
   * The unique identifier for a metafield within its namespace.
   *
   * Must be 2-64 characters long and can contain alphanumeric, hyphen, and underscore characters.
   */
  readonly key: Scalars['String'];
  /**
   * The container for a group of metafields that the metafield is or will be associated with. Used in tandem
   * with `key` to lookup a metafield on a resource, preventing conflicts with other metafields with the
   * same `key`. If omitted the app-reserved namespace will be used.
   *
   * Must be 3-255 characters long and can contain alphanumeric, hyphen, and underscore characters.
   */
  readonly namespace?: InputMaybe<Scalars['String']>;
  /** The unique ID of the resource that the metafield is attached to. */
  readonly ownerId: Scalars['ID'];
  /**
   * The type of data that is stored in the metafield.
   * The type must be one of the [supported types](https://shopify.dev/apps/metafields/types).
   *
   * Required when there is no corresponding definition for the given `namespace`, `key`, and
   * owner resource type (derived from `ownerId`).
   */
  readonly type?: InputMaybe<Scalars['String']>;
  /** The data stored in the metafield. Always stored as a string, regardless of the metafield's type. */
  readonly value: Scalars['String'];
};

/** Return type for `metafieldsSet` mutation. */
export type MetafieldsSetPayload = {
  /** The list of metafields that were set. */
  readonly metafields?: Maybe<ReadonlyArray<Metafield>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetafieldsSetUserError>;
};

/** An error that occurs during the execution of `MetafieldsSet`. */
export type MetafieldsSetUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MetafieldsSetUserErrorCode>;
  /** The index of the array element that's causing the error. */
  readonly elementIndex?: Maybe<Scalars['Int']>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MetafieldsSetUserError`. */
export enum MetafieldsSetUserErrorCode {
  /** ApiPermission metafields can only be created or updated by the app owner. */
  APP_NOT_AUTHORIZED = 'APP_NOT_AUTHORIZED',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The metafield violates a capability restriction. */
  CAPABILITY_VIOLATION = 'CAPABILITY_VIOLATION',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The compareDigest is invalid. */
  INVALID_COMPARE_DIGEST = 'INVALID_COMPARE_DIGEST',
  /** The type is invalid. */
  INVALID_TYPE = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** The input value should be less than or equal to the maximum value allowed. */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The metafield has been modified since it was loaded. */
  STALE_OBJECT = 'STALE_OBJECT',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT'
}

/** Provides an object instance represented by a MetaobjectDefinition. */
export type Metaobject = Node & {
  /** Metaobject capabilities for this Metaobject. */
  readonly capabilities: MetaobjectCapabilityData;
  /** The app used to create the object. */
  readonly createdBy: App;
  /** The app used to create the object. */
  readonly createdByApp: App;
  /** The staff member who created the metaobject. */
  readonly createdByStaff?: Maybe<StaffMember>;
  /** The MetaobjectDefinition that models this object type. */
  readonly definition: MetaobjectDefinition;
  /** The preferred display name field value of the metaobject. */
  readonly displayName: Scalars['String'];
  /** The field for an object key, or null if the key has no field definition. */
  readonly field?: Maybe<MetaobjectField>;
  /** All ordered fields of the metaobject with their definitions and values. */
  readonly fields: ReadonlyArray<MetaobjectField>;
  /** The unique handle of the object, useful as a custom ID. */
  readonly handle: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** List of back references metafields that belong to the resource. */
  readonly referencedBy: MetafieldRelationConnection;
  /**
   * The staff member who created the metaobject.
   * @deprecated Use `createdByStaff` instead.
   */
  readonly staffMember?: Maybe<StaffMember>;
  /** The recommended field to visually represent this metaobject. May be a file reference or color         field. */
  readonly thumbnailField?: Maybe<MetaobjectField>;
  /** The type of the metaobject. */
  readonly type: Scalars['String'];
  /** When the object was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** Provides an object instance represented by a MetaobjectDefinition. */
export type MetaobjectFieldArgs = {
  key: Scalars['String'];
};


/** Provides an object instance represented by a MetaobjectDefinition. */
export type MetaobjectReferencedByArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Access permissions for the definition's metaobjects. */
export type MetaobjectAccess = {
  /** The access permitted on the Admin API. */
  readonly admin: MetaobjectAdminAccess;
  /** The access permitted on the Storefront API. */
  readonly storefront: MetaobjectStorefrontAccess;
};

/** The input fields that set access permissions for the definition's metaobjects. */
export type MetaobjectAccessInput = {
  /** The access permitted on the Admin API. */
  readonly admin?: InputMaybe<MetaobjectAdminAccess>;
  /** The access permitted on the Storefront API. */
  readonly storefront?: InputMaybe<MetaobjectStorefrontAccess>;
};

/**
 * Metaobject access permissions for the Admin API. When the metaobject is app-owned, the owning app always has
 * full access.
 */
export enum MetaobjectAdminAccess {
  /** The merchant has read-only access. No other apps have access. */
  MERCHANT_READ = 'MERCHANT_READ',
  /** The merchant has read and write access. No other apps have access. */
  MERCHANT_READ_WRITE = 'MERCHANT_READ_WRITE',
  /** The merchant and other apps have no access. */
  PRIVATE = 'PRIVATE',
  /** The merchant and other apps have read-only access. */
  PUBLIC_READ = 'PUBLIC_READ',
  /** The merchant and other apps have read and write access. */
  PUBLIC_READ_WRITE = 'PUBLIC_READ_WRITE'
}

/** Return type for `metaobjectBulkDelete` mutation. */
export type MetaobjectBulkDeletePayload = {
  /** The asynchronous job that deletes the metaobjects. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/**
 * Specifies the condition by which metaobjects are deleted.
 * Exactly one field of input is required.
 */
export type MetaobjectBulkDeleteWhereCondition = {
  /** A list of metaobjects IDs to delete. */
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** Deletes all metaobjects with the specified `type`. */
  readonly type?: InputMaybe<Scalars['String']>;
};

/** Provides the capabilities of a metaobject definition. */
export type MetaobjectCapabilities = {
  /** Indicates whether a metaobject definition can be displayed as a page on the Online Store. */
  readonly onlineStore?: Maybe<MetaobjectCapabilitiesOnlineStore>;
  /** Indicate whether a metaobject definition is publishable. */
  readonly publishable: MetaobjectCapabilitiesPublishable;
  /** Indicate whether a metaobject definition is renderable and exposes SEO data. */
  readonly renderable?: Maybe<MetaobjectCapabilitiesRenderable>;
  /** Indicate whether a metaobject definition is translatable. */
  readonly translatable: MetaobjectCapabilitiesTranslatable;
};

/** The Online Store capability of a metaobject definition. */
export type MetaobjectCapabilitiesOnlineStore = {
  /** The data associated with the Online Store capability. */
  readonly data?: Maybe<MetaobjectCapabilityDefinitionDataOnlineStore>;
  /** Indicates if the capability is enabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The publishable capability of a metaobject definition. */
export type MetaobjectCapabilitiesPublishable = {
  /** Indicates if the capability is enabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The renderable capability of a metaobject definition. */
export type MetaobjectCapabilitiesRenderable = {
  /** The data associated with the renderable capability. */
  readonly data?: Maybe<MetaobjectCapabilityDefinitionDataRenderable>;
  /** Indicates if the capability is enabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The translatable capability of a metaobject definition. */
export type MetaobjectCapabilitiesTranslatable = {
  /** Indicates if the capability is enabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The input fields for creating a metaobject capability. */
export type MetaobjectCapabilityCreateInput = {
  /** The input for enabling the Online Store capability. */
  readonly onlineStore?: InputMaybe<MetaobjectCapabilityOnlineStoreInput>;
  /** The input for enabling the publishable capability. */
  readonly publishable?: InputMaybe<MetaobjectCapabilityPublishableInput>;
  /** The input for enabling the renderable capability. */
  readonly renderable?: InputMaybe<MetaobjectCapabilityRenderableInput>;
  /** The input for enabling the translatable capability. */
  readonly translatable?: InputMaybe<MetaobjectCapabilityTranslatableInput>;
};

/** Provides the capabilities of a metaobject. */
export type MetaobjectCapabilityData = {
  /** The Online Store capability for this metaobject. */
  readonly onlineStore?: Maybe<MetaobjectCapabilityDataOnlineStore>;
  /** The publishable capability for this metaobject. */
  readonly publishable?: Maybe<MetaobjectCapabilityDataPublishable>;
};

/** The input fields for metaobject capabilities. */
export type MetaobjectCapabilityDataInput = {
  /** Online Store capability input. */
  readonly onlineStore?: InputMaybe<MetaobjectCapabilityDataOnlineStoreInput>;
  /** Publishable capability input. */
  readonly publishable?: InputMaybe<MetaobjectCapabilityDataPublishableInput>;
};

/** The Online Store capability for the parent metaobject. */
export type MetaobjectCapabilityDataOnlineStore = {
  /** The theme template used when viewing the metaobject in a store. */
  readonly templateSuffix?: Maybe<Scalars['String']>;
};

/** The input fields for the Online Store capability to control renderability on the Online Store. */
export type MetaobjectCapabilityDataOnlineStoreInput = {
  /** The theme template used when viewing the metaobject in a store. */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
};

/** The publishable capability for the parent metaobject. */
export type MetaobjectCapabilityDataPublishable = {
  /** The visibility status of this metaobject across all channels. */
  readonly status: MetaobjectStatus;
};

/** The input fields for publishable capability to adjust visibility on channels. */
export type MetaobjectCapabilityDataPublishableInput = {
  /** The visibility status of this metaobject across all channels. */
  readonly status: MetaobjectStatus;
};

/** The Online Store capability data for the metaobject definition. */
export type MetaobjectCapabilityDefinitionDataOnlineStore = {
  /** Flag indicating if a sufficient number of redirects are available to redirect all published entries. */
  readonly canCreateRedirects: Scalars['Boolean'];
  /** The URL handle for accessing pages of this metaobject type in the Online Store. */
  readonly urlHandle: Scalars['String'];
};

/** The input fields of the Online Store capability. */
export type MetaobjectCapabilityDefinitionDataOnlineStoreInput = {
  /** Whether to redirect published metaobjects automatically when the URL handle changes. */
  readonly createRedirects?: InputMaybe<Scalars['Boolean']>;
  /** The URL handle for accessing pages of this metaobject type in the Online Store. */
  readonly urlHandle: Scalars['String'];
};

/** The renderable capability data for the metaobject definition. */
export type MetaobjectCapabilityDefinitionDataRenderable = {
  /** The metaobject field used as an alias for the SEO page description. */
  readonly metaDescriptionKey?: Maybe<Scalars['String']>;
  /** The metaobject field used as an alias for the SEO page title. */
  readonly metaTitleKey?: Maybe<Scalars['String']>;
};

/** The input fields of the renderable capability for SEO aliases. */
export type MetaobjectCapabilityDefinitionDataRenderableInput = {
  /** The metaobject field used as an alias for the SEO page description. */
  readonly metaDescriptionKey?: InputMaybe<Scalars['String']>;
  /** The metaobject field used as an alias for the SEO page title. */
  readonly metaTitleKey?: InputMaybe<Scalars['String']>;
};

/** The input fields for enabling and disabling the Online Store capability. */
export type MetaobjectCapabilityOnlineStoreInput = {
  /** The data associated with the Online Store capability. */
  readonly data?: InputMaybe<MetaobjectCapabilityDefinitionDataOnlineStoreInput>;
  /** Indicates whether the capability should be enabled or disabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The input fields for enabling and disabling the publishable capability. */
export type MetaobjectCapabilityPublishableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The input fields for enabling and disabling the renderable capability. */
export type MetaobjectCapabilityRenderableInput = {
  /** The data associated with the renderable capability. */
  readonly data?: InputMaybe<MetaobjectCapabilityDefinitionDataRenderableInput>;
  /** Indicates whether the capability should be enabled or disabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The input fields for enabling and disabling the translatable capability. */
export type MetaobjectCapabilityTranslatableInput = {
  /** Indicates whether the capability should be enabled or disabled. */
  readonly enabled: Scalars['Boolean'];
};

/** The input fields for updating a metaobject capability. */
export type MetaobjectCapabilityUpdateInput = {
  /** The input for enabling the Online Store capability. */
  readonly onlineStore?: InputMaybe<MetaobjectCapabilityOnlineStoreInput>;
  /** The input for updating the publishable capability. */
  readonly publishable?: InputMaybe<MetaobjectCapabilityPublishableInput>;
  /** The input for enabling the renderable capability. */
  readonly renderable?: InputMaybe<MetaobjectCapabilityRenderableInput>;
  /** The input for updating the translatable capability. */
  readonly translatable?: InputMaybe<MetaobjectCapabilityTranslatableInput>;
};

/** An auto-generated type for paginating through multiple Metaobjects. */
export type MetaobjectConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MetaobjectEdge>;
  /** A list of nodes that are contained in MetaobjectEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Metaobject>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for creating a metaobject. */
export type MetaobjectCreateInput = {
  /** Capabilities for the metaobject. */
  readonly capabilities?: InputMaybe<MetaobjectCapabilityDataInput>;
  /** Values for fields. These are mapped by key to fields of the metaobject definition. */
  readonly fields?: InputMaybe<ReadonlyArray<MetaobjectFieldInput>>;
  /** A unique handle for the metaobject. This value is auto-generated when omitted. */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** The type of the metaobject. Must match an existing metaobject definition type. */
  readonly type: Scalars['String'];
};

/** Return type for `metaobjectCreate` mutation. */
export type MetaobjectCreatePayload = {
  /** The created metaobject. */
  readonly metaobject?: Maybe<Metaobject>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/** Provides the definition of a generic object structure composed of metafields. */
export type MetaobjectDefinition = Node & {
  /** Access configuration for the metaobject definition. */
  readonly access: MetaobjectAccess;
  /** The capabilities of the metaobject definition. */
  readonly capabilities: MetaobjectCapabilities;
  /** The app used to create the metaobject definition. */
  readonly createdByApp: App;
  /** The staff member who created the metaobject definition. */
  readonly createdByStaff?: Maybe<StaffMember>;
  /** The administrative description. */
  readonly description?: Maybe<Scalars['String']>;
  /** The key of a field to reference as the display name for each object. */
  readonly displayNameKey?: Maybe<Scalars['String']>;
  /** The fields defined for this object type. */
  readonly fieldDefinitions: ReadonlyArray<MetaobjectFieldDefinition>;
  /** Whether this metaobject definition has field whose type can visually represent a metaobject with        the `thumbnailField`. */
  readonly hasThumbnailField: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** A paginated connection to the metaobjects associated with the definition. */
  readonly metaobjects: MetaobjectConnection;
  /** The count of metaobjects created for the definition. */
  readonly metaobjectsCount: Scalars['Int'];
  /** The human-readable name. */
  readonly name: Scalars['String'];
  /** The type of the object definition. Defines the namespace of associated metafields. */
  readonly type: Scalars['String'];
};


/** Provides the definition of a generic object structure composed of metafields. */
export type MetaobjectDefinitionMetaobjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple MetaobjectDefinitions. */
export type MetaobjectDefinitionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MetaobjectDefinitionEdge>;
  /** A list of nodes that are contained in MetaobjectDefinitionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MetaobjectDefinition>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for creating a metaobject definition. */
export type MetaobjectDefinitionCreateInput = {
  /** Access configuration for the metaobjects created with this definition. */
  readonly access?: InputMaybe<MetaobjectAccessInput>;
  /** The capabilities of the metaobject definition. */
  readonly capabilities?: InputMaybe<MetaobjectCapabilityCreateInput>;
  /** An administrative description of the definition. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** The key of a field to reference as the display name for metaobjects of this type. */
  readonly displayNameKey?: InputMaybe<Scalars['String']>;
  /** A set of field definitions to create on this metaobject definition. */
  readonly fieldDefinitions: ReadonlyArray<MetaobjectFieldDefinitionCreateInput>;
  /** A human-readable name for the definition. This can be changed at any time. */
  readonly name?: InputMaybe<Scalars['String']>;
  /**
   * The type of the metaobject definition. This can't be changed.
   *
   * Must be 3-255 characters long and only contain alphanumeric, hyphen, and underscore characters.
   */
  readonly type: Scalars['String'];
};

/** Return type for `metaobjectDefinitionCreate` mutation. */
export type MetaobjectDefinitionCreatePayload = {
  /** The created metaobject definition. */
  readonly metaobjectDefinition?: Maybe<MetaobjectDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/** Return type for `metaobjectDefinitionDelete` mutation. */
export type MetaobjectDefinitionDeletePayload = {
  /** The ID of the deleted metaobjects definition. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/** An auto-generated type which holds one MetaobjectDefinition and a cursor during pagination. */
export type MetaobjectDefinitionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MetaobjectDefinitionEdge. */
  readonly node: MetaobjectDefinition;
};

/** The input fields for updating a metaobject definition. */
export type MetaobjectDefinitionUpdateInput = {
  /** Access configuration for the metaobjects created with this definition. */
  readonly access?: InputMaybe<MetaobjectAccessInput>;
  /** The capabilities of the metaobject definition. */
  readonly capabilities?: InputMaybe<MetaobjectCapabilityUpdateInput>;
  /** An administrative description of the definition. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** The key of a metafield to reference as the display name for objects of this type. */
  readonly displayNameKey?: InputMaybe<Scalars['String']>;
  /** A set of operations for modifying field definitions. */
  readonly fieldDefinitions?: InputMaybe<ReadonlyArray<MetaobjectFieldDefinitionOperationInput>>;
  /** A human-readable name for the definition. */
  readonly name?: InputMaybe<Scalars['String']>;
  /**
   * Whether the field order should be reset while updating.
   * If `true`, then the order is assigned based on submitted fields followed by alphabetized field omissions.
   * If `false`, then no changes are made to the existing field order and new fields are appended at the end.
   */
  readonly resetFieldOrder?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `metaobjectDefinitionUpdate` mutation. */
export type MetaobjectDefinitionUpdatePayload = {
  /** The updated metaobject definition. */
  readonly metaobjectDefinition?: Maybe<MetaobjectDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/** Return type for `metaobjectDelete` mutation. */
export type MetaobjectDeletePayload = {
  /** The ID of the deleted metaobject. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/** An auto-generated type which holds one Metaobject and a cursor during pagination. */
export type MetaobjectEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MetaobjectEdge. */
  readonly node: Metaobject;
};

/** Provides a field definition and the data value assigned to it. */
export type MetaobjectField = {
  /** The field definition for this object key. */
  readonly definition: MetaobjectFieldDefinition;
  /** The assigned field value in JSON format. */
  readonly jsonValue?: Maybe<Scalars['JSON']>;
  /** The object key of this field. */
  readonly key: Scalars['String'];
  /** For resource reference fields, provides the referenced object. */
  readonly reference?: Maybe<MetafieldReference>;
  /** For resource reference list fields, provides the list of referenced objects. */
  readonly references?: Maybe<MetafieldReferenceConnection>;
  /** For file reference or color fields, provides visual attributes for this field. */
  readonly thumbnail?: Maybe<MetaobjectThumbnail>;
  /** The type of the field. */
  readonly type: Scalars['String'];
  /** The assigned field value, always stored as a string regardless of the field type. */
  readonly value?: Maybe<Scalars['String']>;
};


/** Provides a field definition and the data value assigned to it. */
export type MetaobjectFieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * Defines a field for a MetaobjectDefinition with properties
 * such as the field's data type and validations.
 */
export type MetaobjectFieldDefinition = {
  /** The administrative description. */
  readonly description?: Maybe<Scalars['String']>;
  /** A key name used to identify the field within the metaobject composition. */
  readonly key: Scalars['String'];
  /** The human-readable name. */
  readonly name: Scalars['String'];
  /** Required status of the field within the metaobject composition. */
  readonly required: Scalars['Boolean'];
  /** The type of data that the field stores. */
  readonly type: MetafieldDefinitionType;
  /**
   * A list of [validation options](https://shopify.dev/apps/metafields/definitions/validation) for
   * the field. For example, a field with the type `date` can set a minimum date requirement.
   */
  readonly validations: ReadonlyArray<MetafieldDefinitionValidation>;
};

/** The input fields for creating a metaobject field definition. */
export type MetaobjectFieldDefinitionCreateInput = {
  /** An administrative description of the field. */
  readonly description?: InputMaybe<Scalars['String']>;
  /**
   * The key of the new field definition. This can't be changed.
   *
   * Must be 2-64 characters long and only contain alphanumeric, hyphen, and underscore characters.
   */
  readonly key: Scalars['String'];
  /** A human-readable name for the field. This can be changed at any time. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Whether metaobjects require a saved value for the field. */
  readonly required?: InputMaybe<Scalars['Boolean']>;
  /** The metafield type applied to values of the field. */
  readonly type: Scalars['String'];
  /** Custom validations that apply to values assigned to the field. */
  readonly validations?: InputMaybe<ReadonlyArray<MetafieldDefinitionValidationInput>>;
};

/** The input fields for deleting a metaobject field definition. */
export type MetaobjectFieldDefinitionDeleteInput = {
  /** The key of the field definition to delete. */
  readonly key: Scalars['String'];
};

/** The input fields for possible operations for modifying field definitions. Exactly one option is required. */
export type MetaobjectFieldDefinitionOperationInput = {
  /** The input fields for creating a metaobject field definition. */
  readonly create?: InputMaybe<MetaobjectFieldDefinitionCreateInput>;
  /** The input fields for deleting a metaobject field definition. */
  readonly delete?: InputMaybe<MetaobjectFieldDefinitionDeleteInput>;
  /** The input fields for updating a metaobject field definition. */
  readonly update?: InputMaybe<MetaobjectFieldDefinitionUpdateInput>;
};

/** The input fields for updating a metaobject field definition. */
export type MetaobjectFieldDefinitionUpdateInput = {
  /** An administrative description of the field. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** The key of the field definition to update. */
  readonly key: Scalars['String'];
  /** A human-readable name for the field. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Whether metaobjects require a saved value for the field. */
  readonly required?: InputMaybe<Scalars['Boolean']>;
  /** Custom validations that apply to values assigned to the field. */
  readonly validations?: InputMaybe<ReadonlyArray<MetafieldDefinitionValidationInput>>;
};

/** The input fields for a metaobject field value. */
export type MetaobjectFieldInput = {
  /** The key of the field. */
  readonly key: Scalars['String'];
  /** The value of the field. */
  readonly value: Scalars['String'];
};

/** The input fields for retrieving a metaobject by handle. */
export type MetaobjectHandleInput = {
  /** The handle of the metaobject to create or update. */
  readonly handle: Scalars['String'];
  /** The type of the metaobject. Must match an existing metaobject definition type. */
  readonly type: Scalars['String'];
};

/** Defines visibility status for metaobjects. */
export enum MetaobjectStatus {
  /** The metaobjects is active for public use. */
  ACTIVE = 'ACTIVE',
  /** The metaobjects is an internal record. */
  DRAFT = 'DRAFT'
}

/** Metaobject access permissions for the Storefront API. */
export enum MetaobjectStorefrontAccess {
  /** No access. */
  NONE = 'NONE',
  /** Read-only access. */
  PUBLIC_READ = 'PUBLIC_READ'
}

/** Provides attributes for visual representation. */
export type MetaobjectThumbnail = {
  /** The file to be used for visual representation of this metaobject. */
  readonly file?: Maybe<File>;
  /** The hexadecimal color code to be used for respresenting this metaobject. */
  readonly hex?: Maybe<Scalars['String']>;
};

/** The input fields for updating a metaobject. */
export type MetaobjectUpdateInput = {
  /** Capabilities for the metaobject. */
  readonly capabilities?: InputMaybe<MetaobjectCapabilityDataInput>;
  /** Values for fields. These are mapped by key to fields of the metaobject definition. */
  readonly fields?: InputMaybe<ReadonlyArray<MetaobjectFieldInput>>;
  /** A unique handle for the metaobject. */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** Whether to create a redirect for the metaobject. */
  readonly redirectNewHandle?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `metaobjectUpdate` mutation. */
export type MetaobjectUpdatePayload = {
  /** The updated metaobject. */
  readonly metaobject?: Maybe<Metaobject>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/** The input fields for upserting a metaobject. */
export type MetaobjectUpsertInput = {
  /** Capabilities for the metaobject. */
  readonly capabilities?: InputMaybe<MetaobjectCapabilityDataInput>;
  /** Values for fields. These are mapped by key to fields of the metaobject definition. */
  readonly fields?: InputMaybe<ReadonlyArray<MetaobjectFieldInput>>;
  /** The handle of the metaobject. */
  readonly handle?: InputMaybe<Scalars['String']>;
};

/** Return type for `metaobjectUpsert` mutation. */
export type MetaobjectUpsertPayload = {
  /** The created or updated metaobject. */
  readonly metaobject?: Maybe<Metaobject>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/** Defines errors encountered while managing metaobject resources. */
export type MetaobjectUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MetaobjectUserErrorCode>;
  /** The index of the failing list element in an array. */
  readonly elementIndex?: Maybe<Scalars['Int']>;
  /** The key of the failing object element. */
  readonly elementKey?: Maybe<Scalars['String']>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MetaobjectUserError`. */
export enum MetaobjectUserErrorCode {
  /** Admin access can only be specified on metaobject definitions that have an app-reserved type. */
  ADMIN_ACCESS_INPUT_NOT_ALLOWED = 'ADMIN_ACCESS_INPUT_NOT_ALLOWED',
  /** Definition is managed by app configuration and cannot be modified through the API. */
  APP_CONFIG_MANAGED = 'APP_CONFIG_MANAGED',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The capability you are using is not enabled. */
  CAPABILITY_NOT_ENABLED = 'CAPABILITY_NOT_ENABLED',
  /** The display name cannot be the same when using the metaobject as a product option. */
  DISPLAY_NAME_CONFLICT = 'DISPLAY_NAME_CONFLICT',
  /** Duplicate inputs were provided for this field key. */
  DUPLICATE_FIELD_INPUT = 'DUPLICATE_FIELD_INPUT',
  /** Renderable data input is referencing an invalid field. */
  FIELD_TYPE_INVALID = 'FIELD_TYPE_INVALID',
  /** The targeted object cannot be modified. */
  IMMUTABLE = 'IMMUTABLE',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** The maximum number of input metaobjects has been exceeded. */
  INPUT_LIMIT_EXCEEDED = 'INPUT_LIMIT_EXCEEDED',
  /** An unexpected error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The value for the metafield definition option was invalid. */
  INVALID_OPTION = 'INVALID_OPTION',
  /** The metafield type is invalid. */
  INVALID_TYPE = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or the definition options. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** The maximum number of metaobjects definitions has been exceeded. */
  MAX_DEFINITIONS_EXCEEDED = 'MAX_DEFINITIONS_EXCEEDED',
  /** The maximum number of metaobjects per shop has been exceeded. */
  MAX_OBJECTS_EXCEEDED = 'MAX_OBJECTS_EXCEEDED',
  /** The input is missing required keys. */
  MISSING_REQUIRED_KEYS = 'MISSING_REQUIRED_KEYS',
  /** Not authorized. */
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  /** Missing required fields were found for this object. */
  OBJECT_FIELD_REQUIRED = 'OBJECT_FIELD_REQUIRED',
  /** The specified field key is already in use. */
  OBJECT_FIELD_TAKEN = 'OBJECT_FIELD_TAKEN',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The requested record couldn't be found. */
  RECORD_NOT_FOUND = 'RECORD_NOT_FOUND',
  /** The action cannot be completed because associated metaobjects are referenced by another resource. */
  REFERENCE_EXISTS_ERROR = 'REFERENCE_EXISTS_ERROR',
  /** The provided name is reserved for system use. */
  RESERVED_NAME = 'RESERVED_NAME',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** No field definition found for this key. */
  UNDEFINED_OBJECT_FIELD = 'UNDEFINED_OBJECT_FIELD',
  /** No metaobject definition found for this type. */
  UNDEFINED_OBJECT_TYPE = 'UNDEFINED_OBJECT_TYPE',
  /** The Online Store URL handle cannot be blank. */
  URL_HANDLE_BLANK = 'URL_HANDLE_BLANK',
  /** The Online Store URL handle is invalid. */
  URL_HANDLE_INVALID = 'URL_HANDLE_INVALID',
  /** The Online Store URL handle is already taken. */
  URL_HANDLE_TAKEN = 'URL_HANDLE_TAKEN'
}

/** The set of valid sort keys for the MethodDefinition query. */
export enum MethodDefinitionSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `rate_provider_type` value. */
  RATE_PROVIDER_TYPE = 'RATE_PROVIDER_TYPE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/**
 * You can use the `MobilePlatformApplication` resource to enable
 * [shared web credentials](https://developer.apple.com/documentation/security/shared_web_credentials) for Shopify iOS apps,
 * as well as to create [iOS universal link](https://developer.apple.com/ios/universal-links/)
 * or [Android app link](https://developer.android.com/training/app-links/) verification endpoints for merchant Shopify iOS or Android apps.
 * Shared web credentials let iOS users access a native app after logging into the respective website in Safari without re-entering
 * their username and password. If a user changes their credentials in the app, then those changes are reflected in Safari.
 * You must use a custom domain to integrate shared web credentials with Shopify. With each platform's link system,
 * users can tap a link to a shop's website and get seamlessly redirected to a merchant's installed app without going
 * through a browser or manually selecting an app.
 *
 * For full configuration instructions on iOS shared web credentials,
 * see the [associated domains setup](https://developer.apple.com/documentation/security/password_autofill/setting_up_an_app_s_associated_domains) technical documentation.
 *
 * For full configuration instructions on iOS universal links or Android App Links,
 * see the respective [iOS universal link](https://developer.apple.com/documentation/uikit/core_app/allowing_apps_and_websites_to_link_to_your_content)
 * or [Android app link](https://developer.android.com/training/app-links) technical documentation.
 */
export type MobilePlatformApplication = AndroidApplication | AppleApplication;

/** An auto-generated type for paginating through multiple MobilePlatformApplications. */
export type MobilePlatformApplicationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<MobilePlatformApplicationEdge>;
  /** A list of nodes that are contained in MobilePlatformApplicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<MobilePlatformApplication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for an Android based mobile platform application. */
export type MobilePlatformApplicationCreateAndroidInput = {
  /** Whether Android App Links are supported by this app. */
  readonly appLinksEnabled: Scalars['Boolean'];
  /** Android application ID. */
  readonly applicationId?: InputMaybe<Scalars['String']>;
  /** The SHA256 fingerprints of the app’s signing certificate. */
  readonly sha256CertFingerprints: ReadonlyArray<Scalars['String']>;
};

/** The input fields for an Apple based mobile platform application. */
export type MobilePlatformApplicationCreateAppleInput = {
  /** The Apple app clip application ID. */
  readonly appClipApplicationId?: InputMaybe<Scalars['String']>;
  /** Whether Apple app clips are enabled for this app. */
  readonly appClipsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Apple application ID. */
  readonly appId?: InputMaybe<Scalars['String']>;
  /** Whether Apple shared web credentials are enabled for this app. */
  readonly sharedWebCredentialsEnabled: Scalars['Boolean'];
  /** Whether Apple Universal Links are supported by this app. */
  readonly universalLinksEnabled: Scalars['Boolean'];
};

/** The input fields for a mobile application platform type. */
export type MobilePlatformApplicationCreateInput = {
  /** Android based mobile platform application. */
  readonly android?: InputMaybe<MobilePlatformApplicationCreateAndroidInput>;
  /** Apple based mobile platform application. */
  readonly apple?: InputMaybe<MobilePlatformApplicationCreateAppleInput>;
};

/** Return type for `mobilePlatformApplicationCreate` mutation. */
export type MobilePlatformApplicationCreatePayload = {
  /** Created mobile platform application. */
  readonly mobilePlatformApplication?: Maybe<MobilePlatformApplication>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MobilePlatformApplicationUserError>;
};

/** Return type for `mobilePlatformApplicationDelete` mutation. */
export type MobilePlatformApplicationDeletePayload = {
  /** The ID of the mobile platform application that was just deleted. */
  readonly deletedMobilePlatformApplicationId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MobilePlatformApplicationUserError>;
};

/** An auto-generated type which holds one MobilePlatformApplication and a cursor during pagination. */
export type MobilePlatformApplicationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of MobilePlatformApplicationEdge. */
  readonly node: MobilePlatformApplication;
};

/** The input fields for an Android based mobile platform application. */
export type MobilePlatformApplicationUpdateAndroidInput = {
  /** Whether Android App Links are supported by this app. */
  readonly appLinksEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Android application ID. */
  readonly applicationId?: InputMaybe<Scalars['String']>;
  /** The SHA256 fingerprints of the app’s signing certificate. */
  readonly sha256CertFingerprints?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

/** The input fields for an Apple based mobile platform application. */
export type MobilePlatformApplicationUpdateAppleInput = {
  /** The Apple App Clip application ID. */
  readonly appClipApplicationId?: InputMaybe<Scalars['String']>;
  /** Whether Apple App Clips are enabled for this app. */
  readonly appClipsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Apple application ID. */
  readonly appId?: InputMaybe<Scalars['String']>;
  /** Whether Apple shared web credentials are enabled for this app. */
  readonly sharedWebCredentialsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether Apple Universal Links are supported by this app. */
  readonly universalLinksEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields for the mobile platform application platform type. */
export type MobilePlatformApplicationUpdateInput = {
  /** Android based Mobile Platform Application. */
  readonly android?: InputMaybe<MobilePlatformApplicationUpdateAndroidInput>;
  /** Apple based Mobile Platform Application. */
  readonly apple?: InputMaybe<MobilePlatformApplicationUpdateAppleInput>;
};

/** Return type for `mobilePlatformApplicationUpdate` mutation. */
export type MobilePlatformApplicationUpdatePayload = {
  /** Created mobile platform application. */
  readonly mobilePlatformApplication?: Maybe<MobilePlatformApplication>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MobilePlatformApplicationUserError>;
};

/** Represents an error in the input of a mutation. */
export type MobilePlatformApplicationUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<MobilePlatformApplicationUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `MobilePlatformApplicationUserError`. */
export enum MobilePlatformApplicationUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG'
}

/** Represents a Shopify hosted 3D model. */
export type Model3d = File & Media & Node & {
  /** A word or phrase to describe the contents or the function of a file. */
  readonly alt?: Maybe<Scalars['String']>;
  /** The 3d model's bounding box information. */
  readonly boundingBox?: Maybe<Model3dBoundingBox>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Any errors that have occurred on the file. */
  readonly fileErrors: ReadonlyArray<FileError>;
  /** The status of the file. */
  readonly fileStatus: FileStatus;
  /** The 3d model's filename. */
  readonly filename: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The media content type. */
  readonly mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  readonly mediaErrors: ReadonlyArray<MediaError>;
  /** The warnings attached to the media. */
  readonly mediaWarnings: ReadonlyArray<MediaWarning>;
  /** The 3d model's original source. */
  readonly originalSource?: Maybe<Model3dSource>;
  /** The preview image for the media. */
  readonly preview?: Maybe<MediaPreviewImage>;
  /** The 3d model's sources. */
  readonly sources: ReadonlyArray<Model3dSource>;
  /** Current status of the media. */
  readonly status: MediaStatus;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** Bounding box information of a 3d model. */
export type Model3dBoundingBox = {
  /** Size in meters of the smallest volume which contains the 3d model. */
  readonly size: Vector3;
};

/**
 * A source for a Shopify-hosted 3d model.
 *
 * Types of sources include GLB and USDZ formatted 3d models, where the former
 * is an original 3d model and the latter has been converted from the original.
 *
 * If the original source is in GLB format and over 15 MBs in size, then both the
 * original and the USDZ formatted source are optimized to reduce the file size.
 */
export type Model3dSource = {
  /** The 3d model source's filesize. */
  readonly filesize: Scalars['Int'];
  /** The 3d model source's format. */
  readonly format: Scalars['String'];
  /** The 3d model source's MIME type. */
  readonly mimeType: Scalars['String'];
  /** The 3d model source's URL. */
  readonly url: Scalars['String'];
};

/**
 * A collection of monetary values in their respective currencies. Typically used in the context of multi-currency pricing and transactions,
 * when an amount in the shop's currency is converted to the customer's currency of choice (the presentment currency).
 */
export type MoneyBag = {
  /** Amount in presentment currency. */
  readonly presentmentMoney: MoneyV2;
  /** Amount in shop currency. */
  readonly shopMoney: MoneyV2;
};

/**
 * An input collection of monetary values in their respective currencies.
 * Represents an amount in the shop's currency and the amount as converted to the customer's currency of choice (the presentment currency).
 */
export type MoneyBagInput = {
  /** Amount in presentment currency. If this isn't given then we assume that the presentment currency is the same as the shop's currency. */
  readonly presentmentMoney?: InputMaybe<MoneyInput>;
  /** Amount in shop currency. */
  readonly shopMoney: MoneyInput;
};

/** The input fields for a monetary value with currency. */
export type MoneyInput = {
  /** Decimal money amount. */
  readonly amount: Scalars['Decimal'];
  /** Currency of the money. */
  readonly currencyCode: CurrencyCode;
};

/** A precise monetary value and its associated currency. For example, 12.99 USD. */
export type MoneyV2 = {
  /**
   * A monetary value in decimal format, allowing for precise representation of cents or fractional
   * currency. For example, 12.99.
   */
  readonly amount: Scalars['Decimal'];
  /**
   * The three-letter currency code that represents a world currency used in a store. Currency codes
   * include standard [standard ISO 4217 codes](https://en.wikipedia.org/wiki/ISO_4217), legacy codes,
   * and non-standard codes. For example, USD.
   */
  readonly currencyCode: CurrencyCode;
};

/** The input fields for a single move of an object to a specific position in a set, using a zero-based index. */
export type MoveInput = {
  /** The ID of the object to be moved. */
  readonly id: Scalars['ID'];
  /** The new position of the object in the set. */
  readonly newPosition: Scalars['UnsignedInt64'];
};

/** The schema's entry point for all mutation operations. */
export type Mutation = {
  /**
   * Updates the email state value for an abandonment.
   * @deprecated Use `abandonmentUpdateActivitiesDeliveryStatuses` instead.
   */
  readonly abandonmentEmailStateUpdate?: Maybe<AbandonmentEmailStateUpdatePayload>;
  /** Updates the marketing activities delivery statuses for an abandonment. */
  readonly abandonmentUpdateActivitiesDeliveryStatuses?: Maybe<AbandonmentUpdateActivitiesDeliveryStatusesPayload>;
  /**
   * Charges a shop for features or services one time.
   * This type of charge is recommended for apps that aren't billed on a recurring basis.
   * Test and demo shops aren't charged.
   */
  readonly appPurchaseOneTimeCreate?: Maybe<AppPurchaseOneTimeCreatePayload>;
  /** Revokes access scopes previously granted for an app installation. */
  readonly appRevokeAccessScopes?: Maybe<AppRevokeAccessScopesPayload>;
  /** Cancels an app subscription on a store. */
  readonly appSubscriptionCancel?: Maybe<AppSubscriptionCancelPayload>;
  /** Allows an app to charge a store for features or services on a recurring basis. */
  readonly appSubscriptionCreate?: Maybe<AppSubscriptionCreatePayload>;
  /** Updates the capped amount on the usage pricing plan of an app subscription line item. */
  readonly appSubscriptionLineItemUpdate?: Maybe<AppSubscriptionLineItemUpdatePayload>;
  /** Extends the trial of an app subscription. */
  readonly appSubscriptionTrialExtend?: Maybe<AppSubscriptionTrialExtendPayload>;
  /**
   * Enables an app to charge a store for features or services on a per-use basis.
   * The usage charge value is counted towards the `cappedAmount` limit that was specified in the `appUsagePricingDetails` field when the app subscription was created.
   * If you create an app usage charge that causes the total usage charges in a billing interval to exceed the capped amount, then a `Total price exceeds balance remaining` error is returned.
   */
  readonly appUsageRecordCreate?: Maybe<AppUsageRecordCreatePayload>;
  /** Creates an article. */
  readonly articleCreate?: Maybe<ArticleCreatePayload>;
  /** Deletes an article. */
  readonly articleDelete?: Maybe<ArticleDeletePayload>;
  /** Updates an article. */
  readonly articleUpdate?: Maybe<ArticleUpdatePayload>;
  /** Creates a blog. */
  readonly blogCreate?: Maybe<BlogCreatePayload>;
  /** Deletes a blog. */
  readonly blogDelete?: Maybe<BlogDeletePayload>;
  /** Updates a blog. */
  readonly blogUpdate?: Maybe<BlogUpdatePayload>;
  /**
   * Starts the cancelation process of a running bulk operation.
   *
   * There may be a short delay from when a cancelation starts until the operation is actually canceled.
   */
  readonly bulkOperationCancel?: Maybe<BulkOperationCancelPayload>;
  /**
   * Creates and runs a bulk operation mutation.
   *
   * To learn how to bulk import large volumes of data asynchronously, refer to the
   * [bulk import data guide](https://shopify.dev/api/usage/bulk-operations/imports).
   */
  readonly bulkOperationRunMutation?: Maybe<BulkOperationRunMutationPayload>;
  /**
   * Creates and runs a bulk operation query.
   *
   * See the [bulk operations guide](https://shopify.dev/api/usage/bulk-operations/queries) for more details.
   */
  readonly bulkOperationRunQuery?: Maybe<BulkOperationRunQueryPayload>;
  /** Creates product feedback for multiple products. */
  readonly bulkProductResourceFeedbackCreate?: Maybe<BulkProductResourceFeedbackCreatePayload>;
  /** Creates a new carrier service. */
  readonly carrierServiceCreate?: Maybe<CarrierServiceCreatePayload>;
  /** Removes an existing carrier service. */
  readonly carrierServiceDelete?: Maybe<CarrierServiceDeletePayload>;
  /** Updates a carrier service. Only the app that creates a carrier service can update it. */
  readonly carrierServiceUpdate?: Maybe<CarrierServiceUpdatePayload>;
  /** Create a CartTransform function to the Shop. */
  readonly cartTransformCreate?: Maybe<CartTransformCreatePayload>;
  /** Destroy a cart transform function from the Shop. */
  readonly cartTransformDelete?: Maybe<CartTransformDeletePayload>;
  /** Updates the context of a catalog. */
  readonly catalogContextUpdate?: Maybe<CatalogContextUpdatePayload>;
  /** Creates a new catalog. */
  readonly catalogCreate?: Maybe<CatalogCreatePayload>;
  /** Delete a catalog. */
  readonly catalogDelete?: Maybe<CatalogDeletePayload>;
  /** Updates an existing catalog. */
  readonly catalogUpdate?: Maybe<CatalogUpdatePayload>;
  /**
   * Updates the checkout branding settings for a
   * [checkout profile](https://shopify.dev/api/admin-graphql/unstable/queries/checkoutProfile).
   *
   * If the settings don't exist, then new settings are created. The checkout branding settings applied to a
   * published checkout profile will be immediately visible within the store's checkout. The checkout branding
   * settings applied to a draft checkout profile could be previewed within the admin checkout editor.
   *
   * To learn more about updating checkout branding settings, refer to the checkout branding
   * [tutorial](https://shopify.dev/docs/apps/checkout/styling).
   */
  readonly checkoutBrandingUpsert?: Maybe<CheckoutBrandingUpsertPayload>;
  /** Adds products to a collection. */
  readonly collectionAddProducts?: Maybe<CollectionAddProductsPayload>;
  /** Asynchronously adds a set of products to a given collection. It can take a long time to run. Instead of returning a collection, it returns a job which should be polled. */
  readonly collectionAddProductsV2?: Maybe<CollectionAddProductsV2Payload>;
  /** Creates a collection. */
  readonly collectionCreate?: Maybe<CollectionCreatePayload>;
  /** Deletes a collection. */
  readonly collectionDelete?: Maybe<CollectionDeletePayload>;
  /**
   * Publishes a collection to a channel.
   * @deprecated Use `publishablePublish` instead.
   */
  readonly collectionPublish?: Maybe<CollectionPublishPayload>;
  /** Removes a set of products from a given collection. The mutation can take a long time to run. Instead of returning an updated collection the mutation returns a job, which should be [polled](https://shopify.dev/api/admin-graphql/latest/queries/job). For use with manual collections only. */
  readonly collectionRemoveProducts?: Maybe<CollectionRemoveProductsPayload>;
  /** Asynchronously reorders a set of products within a specified collection. Instead of returning an updated collection, this mutation returns a job, which should be [polled](https://shopify.dev/api/admin-graphql/latest/queries/job). The [`Collection.sortOrder`](https://shopify.dev/api/admin-graphql/latest/objects/Collection#field-collection-sortorder) must be `MANUAL`. Displaced products will have their position altered in a consistent manner, with no gaps. */
  readonly collectionReorderProducts?: Maybe<CollectionReorderProductsPayload>;
  /**
   * Unpublishes a collection.
   * @deprecated Use `publishableUnpublish` instead.
   */
  readonly collectionUnpublish?: Maybe<CollectionUnpublishPayload>;
  /** Updates a collection. */
  readonly collectionUpdate?: Maybe<CollectionUpdatePayload>;
  /**
   * Add, remove and update `CombinedListing`s of a given Product.
   *
   * `CombinedListing`s are comprised of multiple products to create a single listing. There are two kinds of products used in a `CombinedListing`:
   *
   * 1. Parent products
   * 2. Child products
   *
   * The parent product is created with a `productCreate` with a `CombinedListingRole` of `PARENT`. Once created, you can associate child products with the parent product using this mutation. Parent products represent the idea of a product (e.g. Shoe).
   *
   * Child products represent a particular option value (or combination of option values) of a parent product. For instance, with your Shoe parent product, you may have several child products representing specific colors of the shoe (e.g. Shoe - Blue). You could also have child products representing more than a single option (e.g. Shoe - Blue/Canvas, Shoe - Blue/Leather, etc...).
   *
   * The combined listing is the association of parent product to one or more child products.
   *
   * Learn more about [Combined Listings](https://shopify.dev/apps/selling-strategies/combined-listings).
   */
  readonly combinedListingUpdate?: Maybe<CombinedListingUpdatePayload>;
  /** Approves a comment. */
  readonly commentApprove?: Maybe<CommentApprovePayload>;
  /** Deletes a comment. */
  readonly commentDelete?: Maybe<CommentDeletePayload>;
  /** Marks a comment as not spam. */
  readonly commentNotSpam?: Maybe<CommentNotSpamPayload>;
  /** Marks a comment as spam. */
  readonly commentSpam?: Maybe<CommentSpamPayload>;
  /** Deletes a list of companies. */
  readonly companiesDelete?: Maybe<CompaniesDeletePayload>;
  /** Deletes a company address. */
  readonly companyAddressDelete?: Maybe<CompanyAddressDeletePayload>;
  /** Assigns the customer as a company contact. */
  readonly companyAssignCustomerAsContact?: Maybe<CompanyAssignCustomerAsContactPayload>;
  /** Assigns the main contact for the company. */
  readonly companyAssignMainContact?: Maybe<CompanyAssignMainContactPayload>;
  /** Assigns a role to a contact for a location. */
  readonly companyContactAssignRole?: Maybe<CompanyContactAssignRolePayload>;
  /** Assigns roles on a company contact. */
  readonly companyContactAssignRoles?: Maybe<CompanyContactAssignRolesPayload>;
  /** Creates a company contact and the associated customer. */
  readonly companyContactCreate?: Maybe<CompanyContactCreatePayload>;
  /** Deletes a company contact. */
  readonly companyContactDelete?: Maybe<CompanyContactDeletePayload>;
  /** Removes a company contact from a Company. */
  readonly companyContactRemoveFromCompany?: Maybe<CompanyContactRemoveFromCompanyPayload>;
  /** Revokes a role on a company contact. */
  readonly companyContactRevokeRole?: Maybe<CompanyContactRevokeRolePayload>;
  /** Revokes roles on a company contact. */
  readonly companyContactRevokeRoles?: Maybe<CompanyContactRevokeRolesPayload>;
  /** Sends the company contact a welcome email. */
  readonly companyContactSendWelcomeEmail?: Maybe<CompanyContactSendWelcomeEmailPayload>;
  /** Updates a company contact. */
  readonly companyContactUpdate?: Maybe<CompanyContactUpdatePayload>;
  /** Deletes one or more company contacts. */
  readonly companyContactsDelete?: Maybe<CompanyContactsDeletePayload>;
  /** Creates a company. */
  readonly companyCreate?: Maybe<CompanyCreatePayload>;
  /** Deletes a company. */
  readonly companyDelete?: Maybe<CompanyDeletePayload>;
  /** Updates an address on a company location. */
  readonly companyLocationAssignAddress?: Maybe<CompanyLocationAssignAddressPayload>;
  /** Assigns roles on a company location. */
  readonly companyLocationAssignRoles?: Maybe<CompanyLocationAssignRolesPayload>;
  /** Creates one or more mappings between a staff member at a shop and a company location. */
  readonly companyLocationAssignStaffMembers?: Maybe<CompanyLocationAssignStaffMembersPayload>;
  /**
   * Assigns tax exemptions to the company location.
   * @deprecated Use `companyLocationTaxSettingsUpdate` instead.
   */
  readonly companyLocationAssignTaxExemptions?: Maybe<CompanyLocationAssignTaxExemptionsPayload>;
  /** Creates a company location. */
  readonly companyLocationCreate?: Maybe<CompanyLocationCreatePayload>;
  /**
   * Creates a tax registration for a company location.
   * @deprecated Use `companyLocationTaxSettingsUpdate` instead.
   */
  readonly companyLocationCreateTaxRegistration?: Maybe<CompanyLocationCreateTaxRegistrationPayload>;
  /** Deletes a company location. */
  readonly companyLocationDelete?: Maybe<CompanyLocationDeletePayload>;
  /** Deletes one or more existing mappings between a staff member at a shop and a company location. */
  readonly companyLocationRemoveStaffMembers?: Maybe<CompanyLocationRemoveStaffMembersPayload>;
  /** Revokes roles on a company location. */
  readonly companyLocationRevokeRoles?: Maybe<CompanyLocationRevokeRolesPayload>;
  /**
   * Revokes tax exemptions from the company location.
   * @deprecated Use `companyLocationTaxSettingsUpdate` instead.
   */
  readonly companyLocationRevokeTaxExemptions?: Maybe<CompanyLocationRevokeTaxExemptionsPayload>;
  /**
   * Revokes tax registration on a company location.
   * @deprecated Use `companyLocationTaxSettingsUpdate` instead.
   */
  readonly companyLocationRevokeTaxRegistration?: Maybe<CompanyLocationRevokeTaxRegistrationPayload>;
  /** Updates a company location. */
  readonly companyLocationUpdate?: Maybe<CompanyLocationUpdatePayload>;
  /** Deletes a list of company locations. */
  readonly companyLocationsDelete?: Maybe<CompanyLocationsDeletePayload>;
  /** Revokes the main contact from the company. */
  readonly companyRevokeMainContact?: Maybe<CompanyRevokeMainContactPayload>;
  /** Updates a company. */
  readonly companyUpdate?: Maybe<CompanyUpdatePayload>;
  /** Add tax exemptions for the customer. */
  readonly customerAddTaxExemptions?: Maybe<CustomerAddTaxExemptionsPayload>;
  /**
   * Cancels a pending erasure of a customer's data.
   *
   * To request an erasure of a customer's data use the [customerRequestDataErasure mutation](https://shopify.dev/api/admin-graphql/unstable/mutations/customerRequestDataErasure).
   */
  readonly customerCancelDataErasure?: Maybe<CustomerCancelDataErasurePayload>;
  /** Create a new customer. As of API version 2022-10, apps using protected customer data must meet the protected customer data [requirements](https://shopify.dev/apps/store/data-protection/protected-customer-data). */
  readonly customerCreate?: Maybe<CustomerCreatePayload>;
  /** Delete a customer. As of API version 2022-10, apps using protected customer data must meet the protected customer data [requirements](https://shopify.dev/apps/store/data-protection/protected-customer-data). */
  readonly customerDelete?: Maybe<CustomerDeletePayload>;
  /** Update a customer's email marketing information information. */
  readonly customerEmailMarketingConsentUpdate?: Maybe<CustomerEmailMarketingConsentUpdatePayload>;
  /** Generate an account activation URL for a customer. */
  readonly customerGenerateAccountActivationUrl?: Maybe<CustomerGenerateAccountActivationUrlPayload>;
  /** Merges two customers. */
  readonly customerMerge?: Maybe<CustomerMergePayload>;
  /**
   * Creates a vaulted payment method for a customer from duplication data.
   *
   * This data must be obtained from another shop within the same organization.
   *
   * Currently, this only supports Shop Pay payment methods. This is only available for selected partner apps.
   */
  readonly customerPaymentMethodCreateFromDuplicationData?: Maybe<CustomerPaymentMethodCreateFromDuplicationDataPayload>;
  /**
   * Creates a credit card payment method for a customer using a session id.
   * These values are only obtained through card imports happening from a PCI compliant environment.
   * Please use customerPaymentMethodRemoteCreate if you are not managing credit cards directly.
   */
  readonly customerPaymentMethodCreditCardCreate?: Maybe<CustomerPaymentMethodCreditCardCreatePayload>;
  /** Updates the credit card payment method for a customer. */
  readonly customerPaymentMethodCreditCardUpdate?: Maybe<CustomerPaymentMethodCreditCardUpdatePayload>;
  /**
   * Returns encrypted data that can be used to duplicate the payment method in another shop within the same organization.
   *
   * Currently, this only supports Shop Pay payment methods. This is only available for selected partner apps.
   */
  readonly customerPaymentMethodGetDuplicationData?: Maybe<CustomerPaymentMethodGetDuplicationDataPayload>;
  /**
   * Returns a URL that allows the customer to update a specific payment method.
   *
   * Currently, `customerPaymentMethodGetUpdateUrl` only supports Shop Pay.
   */
  readonly customerPaymentMethodGetUpdateUrl?: Maybe<CustomerPaymentMethodGetUpdateUrlPayload>;
  /** Creates a PayPal billing agreement for a customer. */
  readonly customerPaymentMethodPaypalBillingAgreementCreate?: Maybe<CustomerPaymentMethodPaypalBillingAgreementCreatePayload>;
  /** Updates a PayPal billing agreement for a customer. */
  readonly customerPaymentMethodPaypalBillingAgreementUpdate?: Maybe<CustomerPaymentMethodPaypalBillingAgreementUpdatePayload>;
  /** Create a payment method from remote gateway identifiers. NOTE: This operation processes payment methods asynchronously. The returned payment method will initially have incomplete details. Developers must poll this payment method using customerPaymentMethod query until all payment method details are available, or the payment method is revoked (usually within seconds). */
  readonly customerPaymentMethodRemoteCreate?: Maybe<CustomerPaymentMethodRemoteCreatePayload>;
  /**
   * Create a payment method from a credit card stored by Stripe.
   * @deprecated Use `customerPaymentMethodRemoteCreate` instead.
   */
  readonly customerPaymentMethodRemoteCreditCardCreate?: Maybe<CustomerPaymentMethodRemoteCreditCardCreatePayload>;
  /** Revokes a customer's payment method. */
  readonly customerPaymentMethodRevoke?: Maybe<CustomerPaymentMethodRevokePayload>;
  /** Sends a link to the customer so they can update a specific payment method. */
  readonly customerPaymentMethodSendUpdateEmail?: Maybe<CustomerPaymentMethodSendUpdateEmailPayload>;
  /** Remove tax exemptions from a customer. */
  readonly customerRemoveTaxExemptions?: Maybe<CustomerRemoveTaxExemptionsPayload>;
  /** Replace tax exemptions for a customer. */
  readonly customerReplaceTaxExemptions?: Maybe<CustomerReplaceTaxExemptionsPayload>;
  /**
   * Enqueues a request to erase customer's data. Read more [here](https://help.shopify.com/manual/privacy-and-security/privacy/processing-customer-data-requests#erase-customer-personal-data).
   *
   * To cancel the data erasure request use the [customerCancelDataErasure mutation](https://shopify.dev/api/admin-graphql/unstable/mutations/customerCancelDataErasure).
   */
  readonly customerRequestDataErasure?: Maybe<CustomerRequestDataErasurePayload>;
  /** Creates a customer segment members query. */
  readonly customerSegmentMembersQueryCreate?: Maybe<CustomerSegmentMembersQueryCreatePayload>;
  /** Sends the customer an account invite email. */
  readonly customerSendAccountInviteEmail?: Maybe<CustomerSendAccountInviteEmailPayload>;
  /** Update a customer's SMS marketing consent information. */
  readonly customerSmsMarketingConsentUpdate?: Maybe<CustomerSmsMarketingConsentUpdatePayload>;
  /** Update a customer's attributes. As of API version 2022-10, apps using protected customer data must meet the protected customer data [requirements](https://shopify.dev/apps/store/data-protection/protected-customer-data). */
  readonly customerUpdate?: Maybe<CustomerUpdatePayload>;
  /** Updates a customer's default address. */
  readonly customerUpdateDefaultAddress?: Maybe<CustomerUpdateDefaultAddressPayload>;
  /** Opt out a customer from data sale. */
  readonly dataSaleOptOut?: Maybe<DataSaleOptOutPayload>;
  /**
   * Creates a delegate access token.
   *
   * To learn more about creating delegate access tokens, refer to
   * [Delegate OAuth access tokens to subsystems](https://shopify.dev/docs/apps/build/authentication-authorization/access-tokens/use-delegate-tokens).
   */
  readonly delegateAccessTokenCreate?: Maybe<DelegateAccessTokenCreatePayload>;
  /** Destroys a delegate access token. */
  readonly delegateAccessTokenDestroy?: Maybe<DelegateAccessTokenDestroyPayload>;
  /** Activates and deactivates delivery customizations. */
  readonly deliveryCustomizationActivation?: Maybe<DeliveryCustomizationActivationPayload>;
  /** Creates a delivery customization. */
  readonly deliveryCustomizationCreate?: Maybe<DeliveryCustomizationCreatePayload>;
  /** Creates a delivery customization. */
  readonly deliveryCustomizationDelete?: Maybe<DeliveryCustomizationDeletePayload>;
  /** Updates a delivery customization. */
  readonly deliveryCustomizationUpdate?: Maybe<DeliveryCustomizationUpdatePayload>;
  /** Create a delivery profile. */
  readonly deliveryProfileCreate?: Maybe<DeliveryProfileCreatePayload>;
  /** Enqueue the removal of a delivery profile. */
  readonly deliveryProfileRemove?: Maybe<DeliveryProfileRemovePayload>;
  /** Update a delivery profile. */
  readonly deliveryProfileUpdate?: Maybe<DeliveryProfileUpdatePayload>;
  /** Creates or updates a delivery promise provider. Currently restricted to select approved delivery promise partners. */
  readonly deliveryPromiseProviderUpsert?: Maybe<DeliveryPromiseProviderUpsertPayload>;
  /** Set the delivery settings for a shop. */
  readonly deliverySettingUpdate?: Maybe<DeliverySettingUpdatePayload>;
  /** Assigns a location as the shipping origin while using legacy compatibility mode for multi-location delivery profiles. */
  readonly deliveryShippingOriginAssign?: Maybe<DeliveryShippingOriginAssignPayload>;
  /** Activates an automatic discount. */
  readonly discountAutomaticActivate?: Maybe<DiscountAutomaticActivatePayload>;
  /**
   * Creates an automatic discount that's managed by an app.
   * Use this mutation with [Shopify Functions](https://shopify.dev/docs/apps/build/functions)
   * when you need advanced, custom, or dynamic discount capabilities that aren't supported by
   * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
   *
   * For example, use this mutation to create an automatic discount using an app's
   * "Volume" discount type that applies a percentage
   * off when customers purchase more than the minimum quantity of a product. For an example implementation,
   * refer to [our tutorial](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
   *
   * > Note:
   * > To create code discounts with custom logic, use the
   * [`discountCodeAppCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeAppCreate)
   * mutation.
   */
  readonly discountAutomaticAppCreate?: Maybe<DiscountAutomaticAppCreatePayload>;
  /**
   * Updates an existing automatic discount that's managed by an app using
   * [Shopify Functions](https://shopify.dev/docs/apps/build/functions).
   * Use this mutation when you need advanced, custom, or
   * dynamic discount capabilities that aren't supported by
   * [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
   *
   * For example, use this mutation to update a new "Volume" discount type that applies a percentage
   * off when customers purchase more than the minimum quantity of a product. For an example implementation,
   * refer to [our tutorial](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
   *
   * > Note:
   * > To update code discounts with custom logic, use the
   * [`discountCodeAppUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeAppUpdate)
   * mutation instead.
   */
  readonly discountAutomaticAppUpdate?: Maybe<DiscountAutomaticAppUpdatePayload>;
  /**
   * Creates an
   * [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To create code discounts, use the
   * [`discountCodeBasicCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBasicCreate)
   * mutation.
   */
  readonly discountAutomaticBasicCreate?: Maybe<DiscountAutomaticBasicCreatePayload>;
  /**
   * Updates an existing
   * [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To update code discounts, use the
   * [`discountCodeBasicUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBasicUpdate)
   * mutation instead.
   */
  readonly discountAutomaticBasicUpdate?: Maybe<DiscountAutomaticBasicUpdatePayload>;
  /**
   * Asynchronously delete automatic discounts in bulk if a `search` or `saved_search_id` argument is provided or if a
   * maximum discount threshold is reached (1,000). Otherwise, deletions will occur inline.
   * **Warning:** All automatic discounts will be deleted if a blank `search` argument is provided.
   */
  readonly discountAutomaticBulkDelete?: Maybe<DiscountAutomaticBulkDeletePayload>;
  /**
   * Creates a
   * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To create code discounts, use the
   * [`discountCodeBxgyCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBxgyCreate)
   * mutation.
   */
  readonly discountAutomaticBxgyCreate?: Maybe<DiscountAutomaticBxgyCreatePayload>;
  /**
   * Updates an existing
   * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To update code discounts, use the
   * [`discountCodeBxgyUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeBxgyUpdate)
   * mutation instead.
   */
  readonly discountAutomaticBxgyUpdate?: Maybe<DiscountAutomaticBxgyUpdatePayload>;
  /** Deactivates an automatic discount. */
  readonly discountAutomaticDeactivate?: Maybe<DiscountAutomaticDeactivatePayload>;
  /**
   * Deletes an
   * [automatic discount](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts).
   */
  readonly discountAutomaticDelete?: Maybe<DiscountAutomaticDeletePayload>;
  /**
   * Creates a
   * [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To create code discounts, use the
   * [`discountCodeFreeShippingCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeFreeShippingCreate)
   * mutation.
   */
  readonly discountAutomaticFreeShippingCreate?: Maybe<DiscountAutomaticFreeShippingCreatePayload>;
  /**
   * Updates an existing
   * [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping)
   * that's automatically applied on a cart and at checkout.
   *
   * > Note:
   * > To update code discounts, use the
   * [`discountCodeFreeShippingUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountCodeFreeShippingUpdate)
   * mutation instead.
   */
  readonly discountAutomaticFreeShippingUpdate?: Maybe<DiscountAutomaticFreeShippingUpdatePayload>;
  /** Activates a code discount. */
  readonly discountCodeActivate?: Maybe<DiscountCodeActivatePayload>;
  /**
   * Creates a code discount. The discount type must be provided by an app extension that uses [Shopify Functions](https://shopify.dev/docs/apps/build/functions). Functions can implement [order](https://shopify.dev/docs/api/functions/reference/order-discounts), [product](https://shopify.dev/docs/api/functions/reference/product-discounts), or [shipping](https://shopify.dev/docs/api/functions/reference/shipping-discounts) discount functions. Use this mutation with Shopify Functions when you need custom logic beyond [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
   *
   * For example, use this mutation to create a code discount using an app's "Volume" discount type that applies a percentage off when customers purchase more than the minimum quantity
   * of a product. For an example implementation, refer to [our tutorial](https://shopify.dev/docs/apps/build/discounts/build-discount-function).
   *
   * > Note:
   * > To create automatic discounts with custom logic, use [`discountAutomaticAppCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticAppCreate).
   */
  readonly discountCodeAppCreate?: Maybe<DiscountCodeAppCreatePayload>;
  /**
   * Updates a code discount, where the discount type is provided by an app extension that uses [Shopify Functions](https://shopify.dev/docs/apps/build/functions). Use this mutation when you need advanced, custom, or dynamic discount capabilities that aren't supported by [Shopify's native discount types](https://help.shopify.com/manual/discounts/discount-types).
   *
   * > Note:
   * > To update automatic discounts, use [`discountAutomaticAppUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticAppUpdate).
   */
  readonly discountCodeAppUpdate?: Maybe<DiscountCodeAppUpdatePayload>;
  /**
   * Creates an [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount) that's applied on a cart and at checkout when a customer enters a code. Amount off discounts can be a percentage off or a fixed amount off.
   *
   * > Note:
   * > To create discounts that are automatically applied on a cart and at checkout, use the [`discountAutomaticBasicCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticBasicCreate) mutation.
   */
  readonly discountCodeBasicCreate?: Maybe<DiscountCodeBasicCreatePayload>;
  /**
   * Updates an [amount off discount](https://help.shopify.com/manual/discounts/discount-types/percentage-fixed-amount) that's applied on a cart and at checkout when a customer enters a code. Amount off discounts can be a percentage off or a fixed amount off.
   *
   * > Note:
   * > To update discounts that are automatically applied on a cart and at checkout, use the [`discountAutomaticBasicUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticBasicUpdate) mutation.
   */
  readonly discountCodeBasicUpdate?: Maybe<DiscountCodeBasicUpdatePayload>;
  /**
   * Activates multiple [code discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) asynchronously using one of the following:
   * - A search query
   * - A saved search ID
   * - A list of discount code IDs
   *
   * For example, you can activate discounts for all codes that match a search criteria, or activate a predefined set of discount codes.
   */
  readonly discountCodeBulkActivate?: Maybe<DiscountCodeBulkActivatePayload>;
  /**
   * Deactivates multiple [code-based discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) asynchronously using one of the following:
   * - A search query
   * - A saved search ID
   * - A list of discount code IDs
   *
   * For example, you can deactivate discounts for all codes that match a search criteria, or deactivate a predefined set of discount codes.
   */
  readonly discountCodeBulkDeactivate?: Maybe<DiscountCodeBulkDeactivatePayload>;
  /**
   * Deletes multiple [code-based discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes) asynchronously using one of the following:
   * - A search query
   * - A saved search ID
   * - A list of discount code IDs
   *
   * For example, you can delete discounts for all codes that match a search criteria, or delete a predefined set of discount codes.
   */
  readonly discountCodeBulkDelete?: Maybe<DiscountCodeBulkDeletePayload>;
  /**
   * Creates a
   * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
   * that's applied on a cart and at checkout when a customer enters a code.
   *
   * > Note:
   * > To create discounts that are automatically applied on a cart and at checkout, use the
   * [`discountAutomaticBxgyCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticBxgyCreate)
   * mutation.
   */
  readonly discountCodeBxgyCreate?: Maybe<DiscountCodeBxgyCreatePayload>;
  /**
   * Updates a
   * [buy X get Y discount (BXGY)](https://help.shopify.com/manual/discounts/discount-types/buy-x-get-y)
   * that's applied on a cart and at checkout when a customer enters a code.
   *
   * > Note:
   * > To update discounts that are automatically applied on a cart and at checkout, use the
   * [`discountAutomaticBxgyUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticBxgyUpdate)
   * mutation.
   */
  readonly discountCodeBxgyUpdate?: Maybe<DiscountCodeBxgyUpdatePayload>;
  /** Deactivates a code discount. */
  readonly discountCodeDeactivate?: Maybe<DiscountCodeDeactivatePayload>;
  /**
   * Deletes a
   * [code discount](https://help.shopify.com/manual/discounts/discount-types#discount-codes).
   */
  readonly discountCodeDelete?: Maybe<DiscountCodeDeletePayload>;
  /**
   * Creates an [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping) that's applied on a cart and at checkout when a customer enters a code.
   *
   * > Note:
   * > To create discounts that are automatically applied on a cart and at checkout, use the [`discountAutomaticFreeShippingCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticFreeShippingCreate) mutation.
   */
  readonly discountCodeFreeShippingCreate?: Maybe<DiscountCodeFreeShippingCreatePayload>;
  /**
   * Updates a [free shipping discount](https://help.shopify.com/manual/discounts/discount-types/free-shipping) that's applied on a cart and at checkout when a customer enters a code.
   *
   * > Note:
   * > To update a free shipping discount that's automatically applied on a cart and at checkout, use the [`discountAutomaticFreeShippingUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/discountAutomaticFreeShippingUpdate) mutation.
   */
  readonly discountCodeFreeShippingUpdate?: Maybe<DiscountCodeFreeShippingUpdatePayload>;
  /**
   * Asynchronously delete
   * [discount codes](https://help.shopify.com/manual/discounts/discount-types#discount-codes)
   * in bulk that customers can use to redeem a discount.
   */
  readonly discountCodeRedeemCodeBulkDelete?: Maybe<DiscountCodeRedeemCodeBulkDeletePayload>;
  /**
   * Asynchronously add
   * [discount codes](https://help.shopify.com/manual/discounts/discount-types#discount-codes)
   * in bulk that customers can use to redeem a discount. You can use the `discountRedeemCodeBulkAdd` mutation
   * to automate the distribution of discount codes through emails or other
   * marketing channels.
   */
  readonly discountRedeemCodeBulkAdd?: Maybe<DiscountRedeemCodeBulkAddPayload>;
  /** Updates a dispute evidence. */
  readonly disputeEvidenceUpdate?: Maybe<DisputeEvidenceUpdatePayload>;
  /** Adds tags to multiple draft orders. */
  readonly draftOrderBulkAddTags?: Maybe<DraftOrderBulkAddTagsPayload>;
  /** Deletes multiple draft orders. */
  readonly draftOrderBulkDelete?: Maybe<DraftOrderBulkDeletePayload>;
  /** Removes tags from multiple draft orders. */
  readonly draftOrderBulkRemoveTags?: Maybe<DraftOrderBulkRemoveTagsPayload>;
  /**
   * Calculates the properties of a draft order. Useful for determining information
   * such as total taxes or price without actually creating a draft order.
   */
  readonly draftOrderCalculate?: Maybe<DraftOrderCalculatePayload>;
  /** Completes a draft order and creates an order. */
  readonly draftOrderComplete?: Maybe<DraftOrderCompletePayload>;
  /** Creates a draft order. */
  readonly draftOrderCreate?: Maybe<DraftOrderCreatePayload>;
  /** Creates a draft order from order. */
  readonly draftOrderCreateFromOrder?: Maybe<DraftOrderCreateFromOrderPayload>;
  /**
   * Creates a merchant checkout for the given draft order.
   * @deprecated This mutation is no longer supported.
   */
  readonly draftOrderCreateMerchantCheckout?: Maybe<DraftOrderCreateMerchantCheckoutPayload>;
  /** Deletes a draft order. */
  readonly draftOrderDelete?: Maybe<DraftOrderDeletePayload>;
  /** Duplicates a draft order. */
  readonly draftOrderDuplicate?: Maybe<DraftOrderDuplicatePayload>;
  /** Previews a draft order invoice email. */
  readonly draftOrderInvoicePreview?: Maybe<DraftOrderInvoicePreviewPayload>;
  /** Sends an email invoice for a draft order. */
  readonly draftOrderInvoiceSend?: Maybe<DraftOrderInvoiceSendPayload>;
  /**
   * Updates a draft order.
   *
   * If a checkout has been started for a draft order, any update to the draft will unlink the checkout. Checkouts
   * are created but not immediately completed when opening the merchant credit card modal in the admin, and when a
   * buyer opens the invoice URL. This is usually fine, but there is an edge case where a checkout is in progress
   * and the draft is updated before the checkout completes. This will not interfere with the checkout and order
   * creation, but if the link from draft to checkout is broken the draft will remain open even after the order is
   * created.
   */
  readonly draftOrderUpdate?: Maybe<DraftOrderUpdatePayload>;
  /**
   * Updates the server pixel to connect to an EventBridge endpoint.
   * Running this mutation deletes any previous subscriptions for the server pixel.
   */
  readonly eventBridgeServerPixelUpdate?: Maybe<EventBridgeServerPixelUpdatePayload>;
  /**
   * Creates a new Amazon EventBridge webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly eventBridgeWebhookSubscriptionCreate?: Maybe<EventBridgeWebhookSubscriptionCreatePayload>;
  /**
   * Updates an Amazon EventBridge webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly eventBridgeWebhookSubscriptionUpdate?: Maybe<EventBridgeWebhookSubscriptionUpdatePayload>;
  /** Acknowledges file update failure by resetting FAILED status to READY and clearing any media errors. */
  readonly fileAcknowledgeUpdateFailed?: Maybe<FileAcknowledgeUpdateFailedPayload>;
  /**
   * Creates file assets using an external URL or for files that were previously uploaded using the
   * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   * These files are added to the [Files page](https://shopify.com/admin/settings/files) in Shopify admin.
   *
   * Files are processed asynchronously. Some data is not available until processing is completed.
   * Check [fileStatus](https://shopify.dev/api/admin-graphql/latest/interfaces/File#field-file-filestatus)
   * to know when the files are READY or FAILED. See the [FileStatus](https://shopify.dev/api/admin-graphql/latest/enums/filestatus)
   * for the complete set of possible fileStatus values.
   *
   * To get a list of all files, use the [files query](https://shopify.dev/api/admin-graphql/latest/queries/files).
   */
  readonly fileCreate?: Maybe<FileCreatePayload>;
  /** Deletes existing file assets that were uploaded to Shopify. */
  readonly fileDelete?: Maybe<FileDeletePayload>;
  /** Updates an existing file asset that was uploaded to Shopify. */
  readonly fileUpdate?: Maybe<FileUpdatePayload>;
  /** Generates a signature for a Flow action payload. */
  readonly flowGenerateSignature?: Maybe<FlowGenerateSignaturePayload>;
  /** Triggers any workflows that begin with the trigger specified in the request body. To learn more, refer to [_Create Shopify Flow triggers_](https://shopify.dev/apps/flow/triggers). */
  readonly flowTriggerReceive?: Maybe<FlowTriggerReceivePayload>;
  /** Cancels a fulfillment. */
  readonly fulfillmentCancel?: Maybe<FulfillmentCancelPayload>;
  /** Creates a fulfillment constraint rule and its metafield. */
  readonly fulfillmentConstraintRuleCreate?: Maybe<FulfillmentConstraintRuleCreatePayload>;
  /** Deletes a fulfillment constraint rule and its metafields. */
  readonly fulfillmentConstraintRuleDelete?: Maybe<FulfillmentConstraintRuleDeletePayload>;
  /** Update a fulfillment constraint rule. */
  readonly fulfillmentConstraintRuleUpdate?: Maybe<FulfillmentConstraintRuleUpdatePayload>;
  /**
   * Creates a fulfillment for one or many fulfillment orders.
   * The fulfillment orders are associated with the same order and are assigned to the same location.
   */
  readonly fulfillmentCreate?: Maybe<FulfillmentCreatePayload>;
  /**
   * Creates a fulfillment for one or many fulfillment orders.
   * The fulfillment orders are associated with the same order and are assigned to the same location.
   * @deprecated Use `fulfillmentCreate` instead.
   */
  readonly fulfillmentCreateV2?: Maybe<FulfillmentCreateV2Payload>;
  /** Creates a fulfillment event for a specified fulfillment. */
  readonly fulfillmentEventCreate?: Maybe<FulfillmentEventCreatePayload>;
  /** Accept a cancellation request sent to a fulfillment service for a fulfillment order. */
  readonly fulfillmentOrderAcceptCancellationRequest?: Maybe<FulfillmentOrderAcceptCancellationRequestPayload>;
  /** Accepts a fulfillment request sent to a fulfillment service for a fulfillment order. */
  readonly fulfillmentOrderAcceptFulfillmentRequest?: Maybe<FulfillmentOrderAcceptFulfillmentRequestPayload>;
  /** Marks a fulfillment order as canceled. */
  readonly fulfillmentOrderCancel?: Maybe<FulfillmentOrderCancelPayload>;
  /**
   * Marks an in-progress fulfillment order as incomplete,
   * indicating the fulfillment service is unable to ship any remaining items,
   * and closes the fulfillment request.
   *
   * This mutation can only be called for fulfillment orders that meet the following criteria:
   *   - Assigned to a fulfillment service location,
   *   - The fulfillment request has been accepted,
   *   - The fulfillment order status is `IN_PROGRESS`.
   *
   * This mutation can only be called by the fulfillment service app that accepted the fulfillment request.
   * Calling this mutation returns the control of the fulfillment order to the merchant, allowing them to
   * move the fulfillment order line items to another location and fulfill from there,
   * remove and refund the line items, or to request fulfillment from the same fulfillment service again.
   *
   * Closing a fulfillment order is explained in
   * [the fulfillment service guide](https://shopify.dev/apps/build/orders-fulfillment/fulfillment-service-apps/build-for-fulfillment-services#step-7-optional-close-a-fulfillment-order).
   */
  readonly fulfillmentOrderClose?: Maybe<FulfillmentOrderClosePayload>;
  /**
   * Applies a fulfillment hold on a fulfillment order.
   *
   * As of the
   * [2025-01 API version](https://shopify.dev/changelog/apply-multiple-holds-to-a-single-fulfillment-order),
   * the mutation can be successfully executed on fulfillment orders that are already on hold.
   * To place multiple holds on a fulfillment order, apps need to supply the
   * [handle](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentHold#field-handle)
   * field. Each app can place up to
   * 10 active holds
   * per fulfillment order. If an app attempts to place more than this, the mutation will return
   * [a user error indicating that the limit has been reached](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderHoldUserErrorCode#value-fulfillmentorderholdlimitreached).
   * The app would need to release one of its existing holds before being able to apply a new one.
   */
  readonly fulfillmentOrderHold?: Maybe<FulfillmentOrderHoldPayload>;
  /**
   * Mark line items associated with a fulfillment order as being ready for pickup by a customer.
   *
   * Sends a Ready For Pickup notification to the customer to let them know that their order is ready
   * to be picked up.
   */
  readonly fulfillmentOrderLineItemsPreparedForPickup?: Maybe<FulfillmentOrderLineItemsPreparedForPickupPayload>;
  /**
   * Merges a set or multiple sets of fulfillment orders together into one based on
   * line item inputs and quantities.
   */
  readonly fulfillmentOrderMerge?: Maybe<FulfillmentOrderMergePayload>;
  /**
   * Changes the location which is assigned to fulfill a number of unfulfilled fulfillment order line items.
   *
   * Moving a fulfillment order will fail in the following circumstances:
   *
   * * The fulfillment order is closed.
   * * The destination location has never stocked the requested inventory item.
   * * The API client doesn't have the correct permissions.
   *
   * Line items which have already been fulfilled can't be re-assigned
   * and will always remain assigned to the original location.
   *
   * You can't change the assigned location while a fulfillment order has a
   * [request status](https://shopify.dev/docs/api/admin-graphql/latest/enums/FulfillmentOrderRequestStatus)
   * of `SUBMITTED`, `ACCEPTED`, `CANCELLATION_REQUESTED`, or `CANCELLATION_REJECTED`.
   * These request statuses mean that a fulfillment order is awaiting action by a fulfillment service
   * and can't be re-assigned without first having the fulfillment service accept a cancellation request.
   * This behavior is intended to prevent items from being fulfilled by multiple locations or fulfillment services.
   *
   * ### How re-assigning line items affects fulfillment orders
   *
   * **First scenario:** Re-assign all line items belonging to a fulfillment order to a new location.
   *
   * In this case, the
   * [assignedLocation](https://shopify.dev/docs/api/admin-graphql/latest/objects/fulfillmentorder#field-fulfillmentorder-assignedlocation)
   * of the original fulfillment order will be updated to the new location.
   *
   * **Second scenario:** Re-assign a subset of the line items belonging to a fulfillment order to a new location.
   * You can specify a subset of line items using the `fulfillmentOrderLineItems` parameter
   * (available as of the `2023-04` API version),
   * or specify that the original fulfillment order contains line items which have already been fulfilled.
   *
   * If the new location is already assigned to another active fulfillment order, on the same order, then
   * a new fulfillment order is created. The existing fulfillment order is closed and line items are recreated
   * in a new fulfillment order.
   */
  readonly fulfillmentOrderMove?: Maybe<FulfillmentOrderMovePayload>;
  /** Marks a scheduled fulfillment order as open. */
  readonly fulfillmentOrderOpen?: Maybe<FulfillmentOrderOpenPayload>;
  /** Rejects a cancellation request sent to a fulfillment service for a fulfillment order. */
  readonly fulfillmentOrderRejectCancellationRequest?: Maybe<FulfillmentOrderRejectCancellationRequestPayload>;
  /** Rejects a fulfillment request sent to a fulfillment service for a fulfillment order. */
  readonly fulfillmentOrderRejectFulfillmentRequest?: Maybe<FulfillmentOrderRejectFulfillmentRequestPayload>;
  /** Releases the fulfillment hold on a fulfillment order. */
  readonly fulfillmentOrderReleaseHold?: Maybe<FulfillmentOrderReleaseHoldPayload>;
  /**
   * Reschedules a scheduled fulfillment order.
   *
   * Updates the value of the `fulfillAt` field on a scheduled fulfillment order.
   *
   * The fulfillment order will be marked as ready for fulfillment at this date and time.
   */
  readonly fulfillmentOrderReschedule?: Maybe<FulfillmentOrderReschedulePayload>;
  /** Splits a fulfillment order or orders based on line item inputs and quantities. */
  readonly fulfillmentOrderSplit?: Maybe<FulfillmentOrderSplitPayload>;
  /** Sends a cancellation request to the fulfillment service of a fulfillment order. */
  readonly fulfillmentOrderSubmitCancellationRequest?: Maybe<FulfillmentOrderSubmitCancellationRequestPayload>;
  /** Sends a fulfillment request to the fulfillment service of a fulfillment order. */
  readonly fulfillmentOrderSubmitFulfillmentRequest?: Maybe<FulfillmentOrderSubmitFulfillmentRequestPayload>;
  /** Sets the latest date and time by which the fulfillment orders need to be fulfilled. */
  readonly fulfillmentOrdersSetFulfillmentDeadline?: Maybe<FulfillmentOrdersSetFulfillmentDeadlinePayload>;
  /**
   * Creates a fulfillment service.
   *
   * ## Fulfillment service location
   *
   * When creating a fulfillment service, a new location will be automatically created on the shop
   * and will be associated with this fulfillment service.
   * This location will be named after the fulfillment service and inherit the shop's address.
   *
   * If you are using API version `2023-10` or later, and you need to specify custom attributes for the fulfillment service location
   * (for example, to change its address to a country different from the shop's country),
   * use the
   * [LocationEdit](https://shopify.dev/api/admin-graphql/latest/mutations/locationEdit)
   * mutation after creating the fulfillment service.
   */
  readonly fulfillmentServiceCreate?: Maybe<FulfillmentServiceCreatePayload>;
  /** Deletes a fulfillment service. */
  readonly fulfillmentServiceDelete?: Maybe<FulfillmentServiceDeletePayload>;
  /**
   * Updates a fulfillment service.
   *
   * If you are using API version `2023-10` or later,
   * and you need to update the location managed by the fulfillment service
   * (for example, to change the address of a fulfillment service),
   * use the
   * [LocationEdit](https://shopify.dev/api/admin-graphql/latest/mutations/locationEdit)
   * mutation.
   */
  readonly fulfillmentServiceUpdate?: Maybe<FulfillmentServiceUpdatePayload>;
  /** Updates tracking information for a fulfillment. */
  readonly fulfillmentTrackingInfoUpdate?: Maybe<FulfillmentTrackingInfoUpdatePayload>;
  /**
   * Updates tracking information for a fulfillment.
   * @deprecated Use `fulfillmentTrackingInfoUpdate` instead.
   */
  readonly fulfillmentTrackingInfoUpdateV2?: Maybe<FulfillmentTrackingInfoUpdateV2Payload>;
  /** Create a gift card. */
  readonly giftCardCreate?: Maybe<GiftCardCreatePayload>;
  /** Credit a gift card. */
  readonly giftCardCredit?: Maybe<GiftCardCreditPayload>;
  /**
   * Deactivate a gift card. A deactivated gift card cannot be used by a customer.
   * A deactivated gift card cannot be re-enabled.
   */
  readonly giftCardDeactivate?: Maybe<GiftCardDeactivatePayload>;
  /** Debit a gift card. */
  readonly giftCardDebit?: Maybe<GiftCardDebitPayload>;
  /** Send notification to the customer of a gift card. */
  readonly giftCardSendNotificationToCustomer?: Maybe<GiftCardSendNotificationToCustomerPayload>;
  /** Send notification to the recipient of a gift card. */
  readonly giftCardSendNotificationToRecipient?: Maybe<GiftCardSendNotificationToRecipientPayload>;
  /** Update a gift card. */
  readonly giftCardUpdate?: Maybe<GiftCardUpdatePayload>;
  /** Activate an inventory item at a location. */
  readonly inventoryActivate?: Maybe<InventoryActivatePayload>;
  /** Apply changes to inventory quantities. */
  readonly inventoryAdjustQuantities?: Maybe<InventoryAdjustQuantitiesPayload>;
  /** Modify the activation status of an inventory item at locations. Activating an inventory item at a particular location allows that location to stock that inventory item. Deactivating an inventory item at a location removes the inventory item's quantities and turns off the inventory item from that location. */
  readonly inventoryBulkToggleActivation?: Maybe<InventoryBulkToggleActivationPayload>;
  /** Removes an inventory item's quantities from a location, and turns off inventory at the location. */
  readonly inventoryDeactivate?: Maybe<InventoryDeactivatePayload>;
  /** Updates an inventory item. */
  readonly inventoryItemUpdate?: Maybe<InventoryItemUpdatePayload>;
  /** Moves inventory between inventory quantity names at a single location. */
  readonly inventoryMoveQuantities?: Maybe<InventoryMoveQuantitiesPayload>;
  /**
   * Set inventory on-hand quantities using absolute values.
   * @deprecated Use `inventorySetQuantities` to set on_hand or available quantites instead.
   */
  readonly inventorySetOnHandQuantities?: Maybe<InventorySetOnHandQuantitiesPayload>;
  /**
   * Set quantities of specified name using absolute values. This mutation supports compare-and-set functionality to handle
   * concurrent requests properly. If `ignoreCompareQuantity` is not set to true,
   * the mutation will only update the quantity if the persisted quantity matches the `compareQuantity` value.
   * If the `compareQuantity` value does not match the persisted value, the mutation will return an error. In order to opt out
   * of the `compareQuantity` check, the `ignoreCompareQuantity` argument can be set to true.
   *
   * > Note:
   * > Only use this mutation if calling on behalf of a system that acts as the source of truth for inventory quantities,
   * > otherwise please consider using the [inventoryAdjustQuantities](https://shopify.dev/api/admin-graphql/latest/mutations/inventoryAdjustQuantities) mutation.
   * >
   * >
   * > Opting out of the `compareQuantity` check can lead to inaccurate inventory quantities if multiple requests are made concurrently.
   * > It is recommended to always include the `compareQuantity` value to ensure the accuracy of the inventory quantities and to opt out
   * > of the check using `ignoreCompareQuantity` only when necessary.
   */
  readonly inventorySetQuantities?: Maybe<InventorySetQuantitiesPayload>;
  /** Set up scheduled changes of inventory items. */
  readonly inventorySetScheduledChanges?: Maybe<InventorySetScheduledChangesPayload>;
  /**
   * Activates a location so that you can stock inventory at the location. Refer to the
   * [`isActive`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location#field-isactive) and
   * [`activatable`](https://shopify.dev/docs/api/admin-graphql/latest/objects/Location#field-activatable)
   * fields on the `Location` object.
   */
  readonly locationActivate?: Maybe<LocationActivatePayload>;
  /** Adds a new location. */
  readonly locationAdd?: Maybe<LocationAddPayload>;
  /** Deactivates a location and moves inventory, pending orders, and moving transfers to a destination location. */
  readonly locationDeactivate?: Maybe<LocationDeactivatePayload>;
  /** Deletes a location. */
  readonly locationDelete?: Maybe<LocationDeletePayload>;
  /**
   * Edits an existing location.
   *
   * [As of the 2023-10 API version](https://shopify.dev/changelog/apps-can-now-change-the-name-and-address-of-their-fulfillment-service-locations), apps can change the name and address of their fulfillment service locations.
   */
  readonly locationEdit?: Maybe<LocationEditPayload>;
  /** Disables local pickup for a location. */
  readonly locationLocalPickupDisable?: Maybe<LocationLocalPickupDisablePayload>;
  /** Enables local pickup for a location. */
  readonly locationLocalPickupEnable?: Maybe<LocationLocalPickupEnablePayload>;
  /** Creates a new market. */
  readonly marketCreate?: Maybe<MarketCreatePayload>;
  /** Updates currency settings of a market. */
  readonly marketCurrencySettingsUpdate?: Maybe<MarketCurrencySettingsUpdatePayload>;
  /** Deletes a market definition. */
  readonly marketDelete?: Maybe<MarketDeletePayload>;
  /** Creates or updates market localizations. */
  readonly marketLocalizationsRegister?: Maybe<MarketLocalizationsRegisterPayload>;
  /** Deletes market localizations. */
  readonly marketLocalizationsRemove?: Maybe<MarketLocalizationsRemovePayload>;
  /**
   * Deletes a market region.
   * @deprecated Use `marketUpdate` instead.
   */
  readonly marketRegionDelete?: Maybe<MarketRegionDeletePayload>;
  /**
   * Creates regions that belong to an existing market.
   * @deprecated This mutation is deprecated and will be removed in the future. Use `marketCreate` or `marketUpdate` instead.
   */
  readonly marketRegionsCreate?: Maybe<MarketRegionsCreatePayload>;
  /**
   * Deletes a list of market regions.
   * @deprecated Use `marketUpdate` instead.
   */
  readonly marketRegionsDelete?: Maybe<MarketRegionsDeletePayload>;
  /** Updates the properties of a market. */
  readonly marketUpdate?: Maybe<MarketUpdatePayload>;
  /**
   * Creates a web presence for a market.
   * @deprecated Use `webPresenceCreate` instead.
   */
  readonly marketWebPresenceCreate?: Maybe<MarketWebPresenceCreatePayload>;
  /**
   * Deletes a market web presence.
   * @deprecated Use `webPresenceDelete` instead.
   */
  readonly marketWebPresenceDelete?: Maybe<MarketWebPresenceDeletePayload>;
  /**
   * Updates a market web presence.
   * @deprecated Use `webPresenceUpdate` instead.
   */
  readonly marketWebPresenceUpdate?: Maybe<MarketWebPresenceUpdatePayload>;
  /** Deletes all external marketing activities. Deletion is performed by a background job, as it may take a bit of time to complete if a large number of activities are to be deleted. Attempting to create or modify external activities before the job has completed will result in the create/update/upsert mutation returning an error. */
  readonly marketingActivitiesDeleteAllExternal?: Maybe<MarketingActivitiesDeleteAllExternalPayload>;
  /** Create new marketing activity. */
  readonly marketingActivityCreate?: Maybe<MarketingActivityCreatePayload>;
  /** Creates a new external marketing activity. */
  readonly marketingActivityCreateExternal?: Maybe<MarketingActivityCreateExternalPayload>;
  /** Deletes an external marketing activity. */
  readonly marketingActivityDeleteExternal?: Maybe<MarketingActivityDeleteExternalPayload>;
  /** Updates a marketing activity with the latest information. */
  readonly marketingActivityUpdate?: Maybe<MarketingActivityUpdatePayload>;
  /** Update an external marketing activity. */
  readonly marketingActivityUpdateExternal?: Maybe<MarketingActivityUpdateExternalPayload>;
  /** Creates a new external marketing activity or updates an existing one. When optional fields are absent or null, associated information will be removed from an existing marketing activity. */
  readonly marketingActivityUpsertExternal?: Maybe<MarketingActivityUpsertExternalPayload>;
  /** Creates a new marketing engagement for a marketing activity or a marketing channel. */
  readonly marketingEngagementCreate?: Maybe<MarketingEngagementCreatePayload>;
  /**
   * Marks channel-level engagement data such that it no longer appears in reports.
   *           Activity-level data cannot be deleted directly, instead the MarketingActivity itself should be deleted to
   *           hide it from reports.
   */
  readonly marketingEngagementsDelete?: Maybe<MarketingEngagementsDeletePayload>;
  /** Creates a menu. */
  readonly menuCreate?: Maybe<MenuCreatePayload>;
  /** Deletes a menu. */
  readonly menuDelete?: Maybe<MenuDeletePayload>;
  /** Updates a menu. */
  readonly menuUpdate?: Maybe<MenuUpdatePayload>;
  /**
   * Creates a metafield definition. Any metafields existing under the same owner type, namespace, and key will be
   * checked against this definition and will have their type updated accordingly. For metafields that are not
   * valid, they will remain unchanged but any attempts to update them must align with this definition.
   */
  readonly metafieldDefinitionCreate?: Maybe<MetafieldDefinitionCreatePayload>;
  /**
   * Delete a metafield definition.
   * Optionally deletes all associated metafields asynchronously when specified.
   */
  readonly metafieldDefinitionDelete?: Maybe<MetafieldDefinitionDeletePayload>;
  /**
   * You can organize your metafields in your Shopify admin by pinning/unpinning metafield definitions.
   * The order of your pinned metafield definitions determines the order in which your metafields are displayed
   * on the corresponding pages in your Shopify admin. By default, only pinned metafields are automatically displayed.
   */
  readonly metafieldDefinitionPin?: Maybe<MetafieldDefinitionPinPayload>;
  /**
   * You can organize your metafields in your Shopify admin by pinning/unpinning metafield definitions.
   * The order of your pinned metafield definitions determines the order in which your metafields are displayed
   * on the corresponding pages in your Shopify admin. By default, only pinned metafields are automatically displayed.
   */
  readonly metafieldDefinitionUnpin?: Maybe<MetafieldDefinitionUnpinPayload>;
  /** Updates a metafield definition. */
  readonly metafieldDefinitionUpdate?: Maybe<MetafieldDefinitionUpdatePayload>;
  /**
   * Deletes a metafield.
   * @deprecated This mutation will be removed in a future version. Use `metafieldsDelete` instead.
   */
  readonly metafieldDelete?: Maybe<MetafieldDeletePayload>;
  /**
   * Creates a `MetafieldStorefrontVisibility` record to make all metafields that belong to the specified resource
   * and have the established `namespace` and `key` combination visible in the Storefront API.
   * @deprecated This mutation will be removed in a future version. Use the `metafieldDefinitionCreate` or `metafieldDefinitionUpdate` mutations with `access.storefront` set instead.
   *
   */
  readonly metafieldStorefrontVisibilityCreate?: Maybe<MetafieldStorefrontVisibilityCreatePayload>;
  /**
   * Deletes a `MetafieldStorefrontVisibility` record. All metafields that belongs to the specified record will no
   * longer be visible in the Storefront API.
   * @deprecated This mutation will be removed in a future version. Use the `metafieldDefinitionUpdate` mutation with `access.storefront` set instead.
   *
   */
  readonly metafieldStorefrontVisibilityDelete?: Maybe<MetafieldStorefrontVisibilityDeletePayload>;
  /** Deletes multiple metafields in bulk. */
  readonly metafieldsDelete?: Maybe<MetafieldsDeletePayload>;
  /**
   * Sets metafield values. Metafield values will be set regardless if they were previously created or not.
   *
   * Allows a maximum of 25 metafields to be set at a time.
   *
   * This operation is atomic, meaning no changes are persisted if an error is encountered.
   *
   * As of `2024-07`, this operation supports compare-and-set functionality to better handle concurrent requests.
   * If `compareDigest` is set for any metafield, the mutation will only set that metafield if the persisted metafield value matches the digest used on `compareDigest`.
   * If the metafield doesn't exist yet, but you want to guarantee that the operation will run in a safe manner, set `compareDigest` to `null`.
   * The `compareDigest` value can be acquired by querying the metafield object and selecting `compareDigest` as a field.
   * If the `compareDigest` value does not match the digest for the persisted value, the mutation will return an error.
   * You can opt out of write guarantees by not sending `compareDigest` in the request.
   */
  readonly metafieldsSet?: Maybe<MetafieldsSetPayload>;
  /** Asynchronously delete metaobjects and their associated metafields in bulk. */
  readonly metaobjectBulkDelete?: Maybe<MetaobjectBulkDeletePayload>;
  /** Creates a new metaobject. */
  readonly metaobjectCreate?: Maybe<MetaobjectCreatePayload>;
  /** Creates a new metaobject definition. */
  readonly metaobjectDefinitionCreate?: Maybe<MetaobjectDefinitionCreatePayload>;
  /**
   * Deletes the specified metaobject definition.
   * Also deletes all related metafield definitions, metaobjects, and metafields asynchronously.
   */
  readonly metaobjectDefinitionDelete?: Maybe<MetaobjectDefinitionDeletePayload>;
  /** Updates a metaobject definition with new settings and metafield definitions. */
  readonly metaobjectDefinitionUpdate?: Maybe<MetaobjectDefinitionUpdatePayload>;
  /** Deletes the specified metaobject and its associated metafields. */
  readonly metaobjectDelete?: Maybe<MetaobjectDeletePayload>;
  /** Updates an existing metaobject. */
  readonly metaobjectUpdate?: Maybe<MetaobjectUpdatePayload>;
  /**
   * Retrieves a metaobject by handle, then updates it with the provided input values.
   * If no matching metaobject is found, a new metaobject is created with the provided input values.
   */
  readonly metaobjectUpsert?: Maybe<MetaobjectUpsertPayload>;
  /** Create a mobile platform application. */
  readonly mobilePlatformApplicationCreate?: Maybe<MobilePlatformApplicationCreatePayload>;
  /** Delete a mobile platform application. */
  readonly mobilePlatformApplicationDelete?: Maybe<MobilePlatformApplicationDeletePayload>;
  /** Update a mobile platform application. */
  readonly mobilePlatformApplicationUpdate?: Maybe<MobilePlatformApplicationUpdatePayload>;
  /** Cancels an order. */
  readonly orderCancel?: Maybe<OrderCancelPayload>;
  /** Captures payment for an authorized transaction on an order. An order can only be captured if it has a successful authorization transaction. Capturing an order will claim the money reserved by the authorization. orderCapture can be used to capture multiple times as long as the OrderTransaction is multi-capturable. To capture a partial payment, the included `amount` value should be less than the total order amount. Multi-capture is available only to stores on a Shopify Plus plan. */
  readonly orderCapture?: Maybe<OrderCapturePayload>;
  /** Closes an open order. */
  readonly orderClose?: Maybe<OrderClosePayload>;
  /**
   * Creates an order with attributes such as customer information, line items, and shipping and billing addresses.
   *
   * Use the `orderCreate` mutation to programmatically generate orders in scenarios where
   * orders aren't created through the standard checkout process, such as when importing orders from an external
   * system or creating orders for wholesale customers.
   *
   * The `orderCreate` mutation doesn't support applying multiple discounts, such as discounts on line items.
   * Automatic discounts won't be applied unless you replicate the logic of those discounts in your custom
   * implementation. You can [apply a discount code](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/OrderCreateDiscountCodeInput),
   * but only one discount code can be set for each order.
   *
   * > Note:
   * > If you're using the `orderCreate` mutation with a
   * > [trial](https://help.shopify.com/manual/intro-to-shopify/pricing-plans/free-trial) or
   * > [development store](https://shopify.dev/docs/api/development-stores), then you can create a
   * > maximum of five new orders per minute.
   *
   * After you create an order, you can make subsequent edits to the order using one of the following mutations:
   * * [`orderUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderUpdate):
   * Used for simple updates to an order, such as changing the order's note, tags, or customer information.
   * * [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin):
   * Used when you need to make significant updates to an order, such as adding or removing line items, changing
   * quantities, or modifying discounts. The `orderEditBegin` mutation initiates an order editing session,
   * allowing you to make multiple changes before finalizing them. Learn more about using the `orderEditBegin`
   * mutation to [edit existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   *
   * Learn how to build apps that integrate with
   * [order management and fulfillment processes](https://shopify.dev/docs/apps/build/orders-fulfillment).
   */
  readonly orderCreate?: Maybe<OrderCreatePayload>;
  /** Creates a payment for an order by mandate. */
  readonly orderCreateMandatePayment?: Maybe<OrderCreateMandatePaymentPayload>;
  /** Deletes an order. For more information on which orders can be deleted, refer to [Delete an order](https://help.shopify.com/manual/orders/cancel-delete-order#delete-an-order). */
  readonly orderDelete?: Maybe<OrderDeletePayload>;
  /** Adds a custom line item to an existing order. For example, you could add a gift wrapping service as a [custom line item](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing#add-a-custom-line-item). To learn how to edit existing orders, refer to [Edit an existing order with Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  readonly orderEditAddCustomItem?: Maybe<OrderEditAddCustomItemPayload>;
  /** Adds a discount to a line item on the current order edit. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  readonly orderEditAddLineItemDiscount?: Maybe<OrderEditAddLineItemDiscountPayload>;
  /** Adds a shipping line to an existing order. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  readonly orderEditAddShippingLine?: Maybe<OrderEditAddShippingLinePayload>;
  /** Adds a line item from an existing product variant. As of API version 2025-04, the [orderEditAddVariant](https://shopify.dev/api/admin-graphql/latest/mutations/ordereditaddvariant) API will respect the contextual pricing of the variant. */
  readonly orderEditAddVariant?: Maybe<OrderEditAddVariantPayload>;
  /**
   * Starts editing an order. Mutations are operating on `OrderEdit`.
   * All order edits start with `orderEditBegin`, have any number of `orderEdit`* mutations made, and end with `orderEditCommit`.
   */
  readonly orderEditBegin?: Maybe<OrderEditBeginPayload>;
  /**
   * Applies and saves staged changes to an order. Mutations are operating on `OrderEdit`.
   * All order edits start with `orderEditBegin`, have any number of `orderEdit`* mutations made, and end with `orderEditCommit`.
   */
  readonly orderEditCommit?: Maybe<OrderEditCommitPayload>;
  /** Removes a discount on the current order edit. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  readonly orderEditRemoveDiscount?: Maybe<OrderEditRemoveDiscountPayload>;
  /**
   * Removes a line item discount that was applied as part of an order edit.
   * @deprecated Use `orderEditRemoveDiscount` instead.
   */
  readonly orderEditRemoveLineItemDiscount?: Maybe<OrderEditRemoveLineItemDiscountPayload>;
  /** Removes a shipping line from an existing order. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  readonly orderEditRemoveShippingLine?: Maybe<OrderEditRemoveShippingLinePayload>;
  /** Sets the quantity of a line item on an order that is being edited. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  readonly orderEditSetQuantity?: Maybe<OrderEditSetQuantityPayload>;
  /** Updates a manual line level discount on the current order edit. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  readonly orderEditUpdateDiscount?: Maybe<OrderEditUpdateDiscountPayload>;
  /** Updates a shipping line on the current order edit. For more information on how to use the GraphQL Admin API to edit an existing order, refer to [Edit existing orders](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing). */
  readonly orderEditUpdateShippingLine?: Maybe<OrderEditUpdateShippingLinePayload>;
  /** Sends an email invoice for an order. */
  readonly orderInvoiceSend?: Maybe<OrderInvoiceSendPayload>;
  /** Marks an order as paid. You can only mark an order as paid if it isn't already fully paid. */
  readonly orderMarkAsPaid?: Maybe<OrderMarkAsPaidPayload>;
  /** Opens a closed order. */
  readonly orderOpen?: Maybe<OrderOpenPayload>;
  /** Create a risk assessment for an order. */
  readonly orderRiskAssessmentCreate?: Maybe<OrderRiskAssessmentCreatePayload>;
  /**
   * Updates the attributes of an order, such as the customer's email, the shipping address for the order,
   * tags, and [metafields](https://shopify.dev/docs/apps/build/custom-data) associated with the order.
   *
   * If you need to make significant updates to an order, such as adding or removing line items, changing
   * quantities, or modifying discounts, then use
   * the [`orderEditBegin`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/orderEditBegin)
   * mutation instead. The `orderEditBegin` mutation initiates an order editing session,
   * allowing you to make multiple changes before finalizing them. Learn more about using the `orderEditBegin`
   * mutation to [edit existing orders](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders).
   *
   * Learn how to build apps that integrate with
   * [order management and fulfillment processes](https://shopify.dev/docs/apps/build/orders-fulfillment).
   */
  readonly orderUpdate?: Maybe<OrderUpdatePayload>;
  /** Creates a page. */
  readonly pageCreate?: Maybe<PageCreatePayload>;
  /** Deletes a page. */
  readonly pageDelete?: Maybe<PageDeletePayload>;
  /** Updates a page. */
  readonly pageUpdate?: Maybe<PageUpdatePayload>;
  /** Activates and deactivates payment customizations. */
  readonly paymentCustomizationActivation?: Maybe<PaymentCustomizationActivationPayload>;
  /** Creates a payment customization. */
  readonly paymentCustomizationCreate?: Maybe<PaymentCustomizationCreatePayload>;
  /** Deletes a payment customization. */
  readonly paymentCustomizationDelete?: Maybe<PaymentCustomizationDeletePayload>;
  /** Updates a payment customization. */
  readonly paymentCustomizationUpdate?: Maybe<PaymentCustomizationUpdatePayload>;
  /** Sends an email payment reminder for a payment schedule. */
  readonly paymentReminderSend?: Maybe<PaymentReminderSendPayload>;
  /** Create payment terms on an order. To create payment terms on a draft order, use a draft order mutation and include the request with the `DraftOrderInput`. */
  readonly paymentTermsCreate?: Maybe<PaymentTermsCreatePayload>;
  /** Delete payment terms for an order. To delete payment terms on a draft order, use a draft order mutation and include the request with the `DraftOrderInput`. */
  readonly paymentTermsDelete?: Maybe<PaymentTermsDeletePayload>;
  /** Update payment terms on an order. To update payment terms on a draft order, use a draft order mutation and include the request with the `DraftOrderInput`. */
  readonly paymentTermsUpdate?: Maybe<PaymentTermsUpdatePayload>;
  /** Creates a price list. You can use the `priceListCreate` mutation to create a new price list and associate it with a catalog. This enables you to sell your products with contextual pricing. */
  readonly priceListCreate?: Maybe<PriceListCreatePayload>;
  /** Deletes a price list. For example, you can delete a price list so that it no longer applies for products in the associated market. */
  readonly priceListDelete?: Maybe<PriceListDeletePayload>;
  /** Creates or updates fixed prices on a price list. You can use the `priceListFixedPricesAdd` mutation to set a fixed price for specific product variants. This lets you change product variant pricing on a per country basis. Any existing fixed price list prices for these variants will be overwritten. */
  readonly priceListFixedPricesAdd?: Maybe<PriceListFixedPricesAddPayload>;
  /** Updates the fixed prices for all variants for a product on a price list. You can use the `priceListFixedPricesByProductUpdate` mutation to set or remove a fixed price for all variants of a product associated with the price list. */
  readonly priceListFixedPricesByProductUpdate?: Maybe<PriceListFixedPricesByProductUpdatePayload>;
  /** Deletes specific fixed prices from a price list using a product variant ID. You can use the `priceListFixedPricesDelete` mutation to delete a set of fixed prices from a price list. After deleting the set of fixed prices from the price list, the price of each product variant reverts to the original price that was determined by the price list adjustment. */
  readonly priceListFixedPricesDelete?: Maybe<PriceListFixedPricesDeletePayload>;
  /** Updates fixed prices on a price list. You can use the `priceListFixedPricesUpdate` mutation to set a fixed price for specific product variants or to delete prices for variants associated with the price list. */
  readonly priceListFixedPricesUpdate?: Maybe<PriceListFixedPricesUpdatePayload>;
  /**
   * Updates a price list.
   * If you modify the currency, then any fixed prices set on the price list will be deleted.
   */
  readonly priceListUpdate?: Maybe<PriceListUpdatePayload>;
  /**
   * Deletes a private metafield.
   * Private metafields are automatically deleted when the app that created them is uninstalled.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafieldDelete?: Maybe<PrivateMetafieldDeletePayload>;
  /**
   * Creates or updates a private metafield. Use private metafields when you don't want the metafield data to be accessible by merchants or other apps.
   * Private metafields are accessible only by the application that created them and only from the GraphQL Admin API.
   *
   * An application can create a maximum of 10 private metafields per shop resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafieldUpsert?: Maybe<PrivateMetafieldUpsertPayload>;
  /** Creates a new componentized product. */
  readonly productBundleCreate?: Maybe<ProductBundleCreatePayload>;
  /** Updates a componentized product. */
  readonly productBundleUpdate?: Maybe<ProductBundleUpdatePayload>;
  /**
   * Changes the status of a product. This allows you to set the availability of the product across all channels.
   * @deprecated Use `productUpdate` instead.
   */
  readonly productChangeStatus?: Maybe<ProductChangeStatusPayload>;
  /**
   * Creates a [product](https://shopify.dev/docs/api/admin-graphql/latest/objects/Product)
   * with attributes such as title, description, and vendor.
   * You can use the `productCreate` mutation to define
   * [options](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOption) and
   * [values](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductOptionValue)
   * for products with
   * [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant),
   * such as different sizes or colors.
   *
   * To create multiple product variants for a single product and manage prices, use the
   * [`productVariantsBulkCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productVariantsBulkCreate)
   * mutation.
   *
   * To create or update a product in a single request, use the
   * [`productSet`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productSet) mutation.
   *
   * Learn more about the [product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model)
   * and [adding product data](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/add-data).
   */
  readonly productCreate?: Maybe<ProductCreatePayload>;
  /**
   * Creates media for a product.
   * @deprecated Use `productUpdate` or `productSet` instead.
   */
  readonly productCreateMedia?: Maybe<ProductCreateMediaPayload>;
  /**
   * Deletes a product, including all associated variants and media.
   *
   * As of API version `2023-01`, if you need to delete a large product, such as one that has many
   * [variants](https://shopify.dev/api/admin-graphql/latest/input-objects/ProductVariantInput)
   * that are active at several
   * [locations](https://shopify.dev/api/admin-graphql/latest/input-objects/InventoryLevelInput),
   * you may encounter timeout errors. To avoid these timeout errors, you can instead use the asynchronous
   * [ProductDeleteAsync](https://shopify.dev/api/admin-graphql/latest/mutations/productDeleteAsync)
   * mutation.
   */
  readonly productDelete?: Maybe<ProductDeletePayload>;
  /**
   * Deletes media for a product.
   * @deprecated Use `fileUpdate` instead.
   */
  readonly productDeleteMedia?: Maybe<ProductDeleteMediaPayload>;
  /**
   * Duplicates a product.
   *
   * If you need to duplicate a large product, such as one that has many
   * [variants](https://shopify.dev/api/admin-graphql/latest/input-objects/ProductVariantInput)
   * that are active at several
   * [locations](https://shopify.dev/api/admin-graphql/latest/input-objects/InventoryLevelInput),
   * you might encounter timeout errors.
   *
   * To avoid these timeout errors, you can instead duplicate the product asynchronously.
   *
   * In API version 2024-10 and higher, include `synchronous: false` argument in this mutation to perform the duplication asynchronously.
   *
   * In API version 2024-07 and lower, use the asynchronous [`ProductDuplicateAsyncV2`](https://shopify.dev/api/admin-graphql/2024-07/mutations/productDuplicateAsyncV2).
   *
   * Metafield values are not duplicated if the unique values capability is enabled.
   */
  readonly productDuplicate?: Maybe<ProductDuplicatePayload>;
  /** Creates a product feed for a specific publication. */
  readonly productFeedCreate?: Maybe<ProductFeedCreatePayload>;
  /** Deletes a product feed for a specific publication. */
  readonly productFeedDelete?: Maybe<ProductFeedDeletePayload>;
  /** Runs the full product sync for a given shop. */
  readonly productFullSync?: Maybe<ProductFullSyncPayload>;
  /** Adds multiple selling plan groups to a product. */
  readonly productJoinSellingPlanGroups?: Maybe<ProductJoinSellingPlanGroupsPayload>;
  /** Removes multiple groups from a product. */
  readonly productLeaveSellingPlanGroups?: Maybe<ProductLeaveSellingPlanGroupsPayload>;
  /** Updates a product option. */
  readonly productOptionUpdate?: Maybe<ProductOptionUpdatePayload>;
  /** Creates options on a product. */
  readonly productOptionsCreate?: Maybe<ProductOptionsCreatePayload>;
  /** Deletes the specified options. */
  readonly productOptionsDelete?: Maybe<ProductOptionsDeletePayload>;
  /**
   * Reorders options and option values on a product, causing product variants to alter their position.
   *
   * Options order take precedence over option values order. Depending on the existing product variants,
   * some input orders might not be achieved.
   *
   * Example:
   *   Existing product variants:
   *     ["Red / Small", "Green / Medium", "Blue / Small"].
   *
   *   New order:
   *     [
   *       {
   *         name: "Size", values: [{ name: "Small" }, { name: "Medium" }],
   *         name: "Color", values: [{ name: "Green" }, { name: "Red" }, { name: "Blue" }]
   *       }
   *     ].
   *
   *   Description:
   *     Variants with "Green" value are expected to appear before variants with "Red" and "Blue" values.
   *     However, "Size" option appears before "Color".
   *
   *   Therefore, output will be:
   *     ["Small / "Red", "Small / Blue", "Medium / Green"].
   */
  readonly productOptionsReorder?: Maybe<ProductOptionsReorderPayload>;
  /**
   * Publishes a product. Products that are sold exclusively on subscription (`requiresSellingPlan: true`) can only be published on online stores.
   * @deprecated Use `publishablePublish` instead.
   */
  readonly productPublish?: Maybe<ProductPublishPayload>;
  /** Asynchronously reorders the media attached to a product. */
  readonly productReorderMedia?: Maybe<ProductReorderMediaPayload>;
  /**
   * Creates or updates a product in a single request.
   *
   * Use this mutation when syncing information from an external data source into Shopify.
   *
   * When using this mutation to update a product, specify that product's `id` in the input.
   *
   * Any list field (e.g.
   * [collections](https://shopify.dev/api/admin-graphql/current/input-objects/ProductSetInput#field-productsetinput-collections),
   * [metafields](https://shopify.dev/api/admin-graphql/current/input-objects/ProductSetInput#field-productsetinput-metafields),
   * [variants](https://shopify.dev/api/admin-graphql/current/input-objects/ProductSetInput#field-productsetinput-variants))
   * will be updated so that all included entries are either created or updated, and all existing entries not
   * included will be deleted.
   *
   * All other fields will be updated to the value passed. Omitted fields will not be updated.
   *
   * When run in synchronous mode, you will get the product back in the response.
   * For versions `2024-04` and earlier, the synchronous mode has an input limit of 100 variants.
   * This limit has been removed for versions `2024-07` and later.
   *
   * In asynchronous mode, you will instead get a
   * [ProductSetOperation](https://shopify.dev/api/admin-graphql/current/objects/ProductSetOperation)
   * object back. You can then use the
   * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query to
   * retrieve the updated product data. This query uses the `ProductSetOperation` object to
   * check the status of the operation and to retrieve the details of the updated product and its variants.
   *
   * If you need to update a subset of variants, use one of the bulk variant mutations:
   * - [productVariantsBulkCreate](https://shopify.dev/api/admin-graphql/current/mutations/productVariantsBulkCreate)
   * - [productVariantsBulkUpdate](https://shopify.dev/api/admin-graphql/current/mutations/productVariantsBulkUpdate)
   * - [productVariantsBulkDelete](https://shopify.dev/api/admin-graphql/current/mutations/productVariantsBulkDelete)
   *
   * If you need to update options, use one of the product option mutations:
   * - [productOptionsCreate](https://shopify.dev/api/admin-graphql/current/mutations/productOptionsCreate)
   * - [productOptionUpdate](https://shopify.dev/api/admin-graphql/current/mutations/productOptionUpdate)
   * - [productOptionsDelete](https://shopify.dev/api/admin-graphql/current/mutations/productOptionsDelete)
   * - [productOptionsReorder](https://shopify.dev/api/admin-graphql/current/mutations/productOptionsReorder)
   *
   * See our guide to
   * [sync product data from an external source](https://shopify.dev/api/admin/migrate/new-product-model/sync-data)
   * for more.
   */
  readonly productSet?: Maybe<ProductSetPayload>;
  /**
   * Unpublishes a product.
   * @deprecated Use `publishableUnpublish` instead.
   */
  readonly productUnpublish?: Maybe<ProductUnpublishPayload>;
  /**
   * Updates a product.
   *
   * For versions `2024-01` and older:
   * If you update a product and only include some variants in the update,
   * then any variants not included will be deleted.
   *
   * To safely manage variants without the risk of
   * deleting excluded variants, use
   * [productVariantsBulkUpdate](https://shopify.dev/api/admin-graphql/latest/mutations/productvariantsbulkupdate).
   *
   * If you want to update a single variant, then use
   * [productVariantUpdate](https://shopify.dev/api/admin-graphql/latest/mutations/productvariantupdate).
   */
  readonly productUpdate?: Maybe<ProductUpdatePayload>;
  /**
   * Updates media for a product.
   * @deprecated Use `fileUpdate` instead.
   */
  readonly productUpdateMedia?: Maybe<ProductUpdateMediaPayload>;
  /** Appends media from a product to variants of the product. */
  readonly productVariantAppendMedia?: Maybe<ProductVariantAppendMediaPayload>;
  /** Detaches media from product variants. */
  readonly productVariantDetachMedia?: Maybe<ProductVariantDetachMediaPayload>;
  /** Adds multiple selling plan groups to a product variant. */
  readonly productVariantJoinSellingPlanGroups?: Maybe<ProductVariantJoinSellingPlanGroupsPayload>;
  /** Remove multiple groups from a product variant. */
  readonly productVariantLeaveSellingPlanGroups?: Maybe<ProductVariantLeaveSellingPlanGroupsPayload>;
  /** Creates new bundles, updates existing bundles, and removes bundle components for one or multiple bundles. */
  readonly productVariantRelationshipBulkUpdate?: Maybe<ProductVariantRelationshipBulkUpdatePayload>;
  /** Creates multiple variants in a single product. This mutation can be called directly or via the bulkOperation. */
  readonly productVariantsBulkCreate?: Maybe<ProductVariantsBulkCreatePayload>;
  /** Deletes multiple variants in a single product. This mutation can be called directly or via the bulkOperation. */
  readonly productVariantsBulkDelete?: Maybe<ProductVariantsBulkDeletePayload>;
  /** Reorders multiple variants in a single product. This mutation can be called directly or via the bulkOperation. */
  readonly productVariantsBulkReorder?: Maybe<ProductVariantsBulkReorderPayload>;
  /** Updates multiple variants in a single product. This mutation can be called directly or via the bulkOperation. */
  readonly productVariantsBulkUpdate?: Maybe<ProductVariantsBulkUpdatePayload>;
  /**
   * Updates the server pixel to connect to a Google PubSub endpoint.
   * Running this mutation deletes any previous subscriptions for the server pixel.
   */
  readonly pubSubServerPixelUpdate?: Maybe<PubSubServerPixelUpdatePayload>;
  /**
   * Creates a new Google Cloud Pub/Sub webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly pubSubWebhookSubscriptionCreate?: Maybe<PubSubWebhookSubscriptionCreatePayload>;
  /**
   * Updates a Google Cloud Pub/Sub webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly pubSubWebhookSubscriptionUpdate?: Maybe<PubSubWebhookSubscriptionUpdatePayload>;
  /** Creates a publication. */
  readonly publicationCreate?: Maybe<PublicationCreatePayload>;
  /** Deletes a publication. */
  readonly publicationDelete?: Maybe<PublicationDeletePayload>;
  /** Updates a publication. */
  readonly publicationUpdate?: Maybe<PublicationUpdatePayload>;
  /** Publishes a resource to a channel. If the resource is a product, then it's visible in the channel only if the product status is `active`. Products that are sold exclusively on subscription (`requiresSellingPlan: true`) can be published only on online stores. */
  readonly publishablePublish?: Maybe<PublishablePublishPayload>;
  /** Publishes a resource to current channel. If the resource is a product, then it's visible in the channel only if the product status is `active`. Products that are sold exclusively on subscription (`requiresSellingPlan: true`) can be published only on online stores. */
  readonly publishablePublishToCurrentChannel?: Maybe<PublishablePublishToCurrentChannelPayload>;
  /** Unpublishes a resource from a channel. If the resource is a product, then it's visible in the channel only if the product status is `active`. */
  readonly publishableUnpublish?: Maybe<PublishableUnpublishPayload>;
  /** Unpublishes a resource from the current channel. If the resource is a product, then it's visible in the channel only if the product status is `active`. */
  readonly publishableUnpublishToCurrentChannel?: Maybe<PublishableUnpublishToCurrentChannelPayload>;
  /** Updates quantity pricing on a price list. You can use the `quantityPricingByVariantUpdate` mutation to set fixed prices, quantity rules, and quantity price breaks. This mutation does not allow partial successes. If any of the requested resources fail to update, none of the requested resources will be updated. Delete operations are executed before create operations. */
  readonly quantityPricingByVariantUpdate?: Maybe<QuantityPricingByVariantUpdatePayload>;
  /**
   * Creates or updates existing quantity rules on a price list.
   * You can use the `quantityRulesAdd` mutation to set order level minimums, maximumums and increments for specific product variants.
   */
  readonly quantityRulesAdd?: Maybe<QuantityRulesAddPayload>;
  /**
   * Deletes specific quantity rules from a price list using a product variant ID.
   * You can use the `quantityRulesDelete` mutation to delete a set of quantity rules from a price list.
   */
  readonly quantityRulesDelete?: Maybe<QuantityRulesDeletePayload>;
  /** Creates a refund. */
  readonly refundCreate?: Maybe<RefundCreatePayload>;
  /**
   * Approves a customer's return request.
   * If this mutation is successful, then the `Return.status` field of the
   * approved return is set to `OPEN`.
   */
  readonly returnApproveRequest?: Maybe<ReturnApproveRequestPayload>;
  /**
   * Cancels a return and restores the items back to being fulfilled.
   * Canceling a return is only available before any work has been done
   * on the return (such as an inspection or refund).
   */
  readonly returnCancel?: Maybe<ReturnCancelPayload>;
  /**
   * Indicates a return is complete, either when a refund has been made and items restocked,
   * or simply when it has been marked as returned in the system.
   */
  readonly returnClose?: Maybe<ReturnClosePayload>;
  /** Creates a return. */
  readonly returnCreate?: Maybe<ReturnCreatePayload>;
  /**
   * Declines a return on an order.
   * When a return is declined, each `ReturnLineItem.fulfillmentLineItem` can be associated to a new return.
   * Use the `ReturnCreate` or `ReturnRequest` mutation to initiate a new return.
   */
  readonly returnDeclineRequest?: Maybe<ReturnDeclineRequestPayload>;
  /** Removes return lines from a return. */
  readonly returnLineItemRemoveFromReturn?: Maybe<ReturnLineItemRemoveFromReturnPayload>;
  /** Refunds a return when its status is `OPEN` or `CLOSED` and associates it with the related return request. */
  readonly returnRefund?: Maybe<ReturnRefundPayload>;
  /** Reopens a closed return. */
  readonly returnReopen?: Maybe<ReturnReopenPayload>;
  /**
   * A customer's return request that hasn't been approved or declined.
   * This mutation sets the value of the `Return.status` field to `REQUESTED`.
   * To create a return that has the `Return.status` field set to `OPEN`, use the `returnCreate` mutation.
   */
  readonly returnRequest?: Maybe<ReturnRequestPayload>;
  /** Creates a new reverse delivery with associated external shipping information. */
  readonly reverseDeliveryCreateWithShipping?: Maybe<ReverseDeliveryCreateWithShippingPayload>;
  /** Updates a reverse delivery with associated external shipping information. */
  readonly reverseDeliveryShippingUpdate?: Maybe<ReverseDeliveryShippingUpdatePayload>;
  /** Disposes reverse fulfillment order line items. */
  readonly reverseFulfillmentOrderDispose?: Maybe<ReverseFulfillmentOrderDisposePayload>;
  /** Creates a saved search. */
  readonly savedSearchCreate?: Maybe<SavedSearchCreatePayload>;
  /** Delete a saved search. */
  readonly savedSearchDelete?: Maybe<SavedSearchDeletePayload>;
  /** Updates a saved search. */
  readonly savedSearchUpdate?: Maybe<SavedSearchUpdatePayload>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>Your app might not pass App Store review if it uses script tags instead of theme app extensions. All new apps, and apps that integrate with Online Store 2.0 themes, should use theme app extensions, such as app blocks or app embed blocks. Script tags are an alternative you can use with only vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   * <div class="note"><h4>Script tag deprecation</h4>
   *   <p>Script tags will be sunset for the <b>Order status</b> page on August 28, 2025. <a href="https://www.shopify.com/plus/upgrading-to-checkout-extensibility">Upgrade to Checkout Extensibility</a> before this date. <a href="/docs/api/liquid/objects#script">Shopify Scripts</a> will continue to work alongside Checkout Extensibility until August 28, 2025.</p></div>
   *
   *
   * Creates a new script tag.
   */
  readonly scriptTagCreate?: Maybe<ScriptTagCreatePayload>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>Your app might not pass App Store review if it uses script tags instead of theme app extensions. All new apps, and apps that integrate with Online Store 2.0 themes, should use theme app extensions, such as app blocks or app embed blocks. Script tags are an alternative you can use with only vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   * <div class="note"><h4>Script tag deprecation</h4>
   *   <p>Script tags will be sunset for the <b>Order status</b> page on August 28, 2025. <a href="https://www.shopify.com/plus/upgrading-to-checkout-extensibility">Upgrade to Checkout Extensibility</a> before this date. <a href="/docs/api/liquid/objects#script">Shopify Scripts</a> will continue to work alongside Checkout Extensibility until August 28, 2025.</p></div>
   *
   *
   * Deletes a script tag.
   */
  readonly scriptTagDelete?: Maybe<ScriptTagDeletePayload>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>Your app might not pass App Store review if it uses script tags instead of theme app extensions. All new apps, and apps that integrate with Online Store 2.0 themes, should use theme app extensions, such as app blocks or app embed blocks. Script tags are an alternative you can use with only vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   * <div class="note"><h4>Script tag deprecation</h4>
   *   <p>Script tags will be sunset for the <b>Order status</b> page on August 28, 2025. <a href="https://www.shopify.com/plus/upgrading-to-checkout-extensibility">Upgrade to Checkout Extensibility</a> before this date. <a href="/docs/api/liquid/objects#script">Shopify Scripts</a> will continue to work alongside Checkout Extensibility until August 28, 2025.</p></div>
   *
   *
   * Updates a script tag.
   */
  readonly scriptTagUpdate?: Maybe<ScriptTagUpdatePayload>;
  /** Creates a segment. */
  readonly segmentCreate?: Maybe<SegmentCreatePayload>;
  /** Deletes a segment. */
  readonly segmentDelete?: Maybe<SegmentDeletePayload>;
  /** Updates a segment. */
  readonly segmentUpdate?: Maybe<SegmentUpdatePayload>;
  /** Adds multiple product variants to a selling plan group. */
  readonly sellingPlanGroupAddProductVariants?: Maybe<SellingPlanGroupAddProductVariantsPayload>;
  /** Adds multiple products to a selling plan group. */
  readonly sellingPlanGroupAddProducts?: Maybe<SellingPlanGroupAddProductsPayload>;
  /** Creates a Selling Plan Group. */
  readonly sellingPlanGroupCreate?: Maybe<SellingPlanGroupCreatePayload>;
  /** Delete a Selling Plan Group. This does not affect subscription contracts. */
  readonly sellingPlanGroupDelete?: Maybe<SellingPlanGroupDeletePayload>;
  /** Removes multiple product variants from a selling plan group. */
  readonly sellingPlanGroupRemoveProductVariants?: Maybe<SellingPlanGroupRemoveProductVariantsPayload>;
  /** Removes multiple products from a selling plan group. */
  readonly sellingPlanGroupRemoveProducts?: Maybe<SellingPlanGroupRemoveProductsPayload>;
  /** Update a Selling Plan Group. */
  readonly sellingPlanGroupUpdate?: Maybe<SellingPlanGroupUpdatePayload>;
  /** Creates a new unconfigured server pixel. A single server pixel can exist for an app and shop combination. If you call this mutation when a server pixel already exists, then an error will return. */
  readonly serverPixelCreate?: Maybe<ServerPixelCreatePayload>;
  /** Deletes the Server Pixel associated with the current app & shop. */
  readonly serverPixelDelete?: Maybe<ServerPixelDeletePayload>;
  /** Deletes a shipping package. */
  readonly shippingPackageDelete?: Maybe<ShippingPackageDeletePayload>;
  /**
   * Set a shipping package as the default.
   * The default shipping package is the one used to calculate shipping costs on checkout.
   */
  readonly shippingPackageMakeDefault?: Maybe<ShippingPackageMakeDefaultPayload>;
  /** Updates a shipping package. */
  readonly shippingPackageUpdate?: Maybe<ShippingPackageUpdatePayload>;
  /** Deletes a locale for a shop. This also deletes all translations of this locale. */
  readonly shopLocaleDisable?: Maybe<ShopLocaleDisablePayload>;
  /** Adds a locale for a shop. The newly added locale is in the unpublished state. */
  readonly shopLocaleEnable?: Maybe<ShopLocaleEnablePayload>;
  /** Updates a locale for a shop. */
  readonly shopLocaleUpdate?: Maybe<ShopLocaleUpdatePayload>;
  /** Updates a shop policy. */
  readonly shopPolicyUpdate?: Maybe<ShopPolicyUpdatePayload>;
  /**
   * The `ResourceFeedback` object lets your app report the status of shops and their resources. For example, if
   * your app is a marketplace channel, then you can use resource feedback to alert merchants that they need to connect their marketplace account by signing in.
   *
   * Resource feedback notifications are displayed to the merchant on the home screen of their Shopify admin, and in the product details view for any products that are published to your app.
   *
   * This resource should be used only in cases where you're describing steps that a merchant is required to complete. If your app offers optional or promotional set-up steps, or if it makes recommendations, then don't use resource feedback to let merchants know about them.
   *
   * ## Sending feedback on a shop
   *
   * You can send resource feedback on a shop to let the merchant know what steps they need to take to make sure that your app is set up correctly. Feedback can have one of two states: `requires_action` or `success`. You need to send a `requires_action` feedback request for each step that the merchant is required to complete.
   *
   * If there are multiple set-up steps that require merchant action, then send feedback with a state of `requires_action` as merchants complete prior steps. And to remove the feedback message from the Shopify admin, send a `success` feedback request.
   *
   * #### Important
   * Sending feedback replaces previously sent feedback for the shop. Send a new `shopResourceFeedbackCreate` mutation to push the latest state of a shop or its resources to Shopify.
   */
  readonly shopResourceFeedbackCreate?: Maybe<ShopResourceFeedbackCreatePayload>;
  /** Creates an alternate currency payout for a Shopify Payments account. */
  readonly shopifyPaymentsPayoutAlternateCurrencyCreate?: Maybe<ShopifyPaymentsPayoutAlternateCurrencyCreatePayload>;
  /**
   * Generates the URL and signed paramaters needed to upload an asset to Shopify.
   * @deprecated Use `stagedUploadsCreate` instead.
   */
  readonly stagedUploadTargetGenerate?: Maybe<StagedUploadTargetGeneratePayload>;
  /**
   * Uploads multiple images.
   * @deprecated Use `stagedUploadsCreate` instead.
   */
  readonly stagedUploadTargetsGenerate?: Maybe<StagedUploadTargetsGeneratePayload>;
  /**
   * Creates staged upload targets for each input. This is the first step in the upload process.
   * The returned staged upload targets' URL and parameter fields can be used to send a request
   * to upload the file described in the corresponding input.
   *
   * For more information on the upload process, refer to
   * [Upload media to Shopify](https://shopify.dev/apps/online-store/media/products#step-1-upload-media-to-shopify).
   */
  readonly stagedUploadsCreate?: Maybe<StagedUploadsCreatePayload>;
  /**
   * Activates the specified standard metafield definition from its template.
   *
   * Refer to the [list of standard metafield definition templates](https://shopify.dev/apps/metafields/definitions/standard-definitions).
   */
  readonly standardMetafieldDefinitionEnable?: Maybe<StandardMetafieldDefinitionEnablePayload>;
  /** Enables the specified standard metaobject definition from its template. */
  readonly standardMetaobjectDefinitionEnable?: Maybe<StandardMetaobjectDefinitionEnablePayload>;
  /**
   * Creates a credit transaction that increases the store credit account balance by the given amount.
   * This operation will create an account if one does not already exist.
   * A store credit account owner can hold multiple accounts each with a different currency.
   * Use the most appropriate currency for the given store credit account owner.
   */
  readonly storeCreditAccountCredit?: Maybe<StoreCreditAccountCreditPayload>;
  /** Creates a debit transaction that decreases the store credit account balance by the given amount. */
  readonly storeCreditAccountDebit?: Maybe<StoreCreditAccountDebitPayload>;
  /**
   * Creates a storefront access token for use with the [Storefront API](https://shopify.dev/docs/api/storefront).
   *
   * An app can have a maximum of 100 active storefront access tokens for each shop.
   *
   * [Get started with the Storefront API](https://shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/getting-started).
   */
  readonly storefrontAccessTokenCreate?: Maybe<StorefrontAccessTokenCreatePayload>;
  /** Deletes a storefront access token. */
  readonly storefrontAccessTokenDelete?: Maybe<StorefrontAccessTokenDeletePayload>;
  /** Creates a new subscription billing attempt. For more information, refer to [Create a subscription contract](https://shopify.dev/docs/apps/selling-strategies/subscriptions/contracts/create#step-4-create-a-billing-attempt). */
  readonly subscriptionBillingAttemptCreate?: Maybe<SubscriptionBillingAttemptCreatePayload>;
  /** Asynchronously queries and charges all subscription billing cycles whose [billingAttemptExpectedDate](https://shopify.dev/api/admin-graphql/latest/objects/SubscriptionBillingCycle#field-billingattemptexpecteddate) values fall within a specified date range and meet additional filtering criteria. The results of this action can be retrieved using the [subscriptionBillingCycleBulkResults](https://shopify.dev/api/admin-graphql/latest/queries/subscriptionBillingCycleBulkResults) query. */
  readonly subscriptionBillingCycleBulkCharge?: Maybe<SubscriptionBillingCycleBulkChargePayload>;
  /** Asynchronously queries all subscription billing cycles whose [billingAttemptExpectedDate](https://shopify.dev/api/admin-graphql/latest/objects/SubscriptionBillingCycle#field-billingattemptexpecteddate) values fall within a specified date range and meet additional filtering criteria. The results of this action can be retrieved using the [subscriptionBillingCycleBulkResults](https://shopify.dev/api/admin-graphql/latest/queries/subscriptionBillingCycleBulkResults) query. */
  readonly subscriptionBillingCycleBulkSearch?: Maybe<SubscriptionBillingCycleBulkSearchPayload>;
  /** Creates a new subscription billing attempt for a specified billing cycle. This is the alternative mutation for [subscriptionBillingAttemptCreate](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionBillingAttemptCreate). For more information, refer to [Create a subscription contract](https://shopify.dev/docs/apps/selling-strategies/subscriptions/contracts/create#step-4-create-a-billing-attempt). */
  readonly subscriptionBillingCycleCharge?: Maybe<SubscriptionBillingCycleChargePayload>;
  /** Commits the updates of a Subscription Billing Cycle Contract draft. */
  readonly subscriptionBillingCycleContractDraftCommit?: Maybe<SubscriptionBillingCycleContractDraftCommitPayload>;
  /** Concatenates a contract to a Subscription Draft. */
  readonly subscriptionBillingCycleContractDraftConcatenate?: Maybe<SubscriptionBillingCycleContractDraftConcatenatePayload>;
  /** Edit the contents of a subscription contract for the specified billing cycle. */
  readonly subscriptionBillingCycleContractEdit?: Maybe<SubscriptionBillingCycleContractEditPayload>;
  /** Delete the schedule and contract edits of the selected subscription billing cycle. */
  readonly subscriptionBillingCycleEditDelete?: Maybe<SubscriptionBillingCycleEditDeletePayload>;
  /** Delete the current and future schedule and contract edits of a list of subscription billing cycles. */
  readonly subscriptionBillingCycleEditsDelete?: Maybe<SubscriptionBillingCycleEditsDeletePayload>;
  /** Modify the schedule of a specific billing cycle. */
  readonly subscriptionBillingCycleScheduleEdit?: Maybe<SubscriptionBillingCycleScheduleEditPayload>;
  /** Skips a Subscription Billing Cycle. */
  readonly subscriptionBillingCycleSkip?: Maybe<SubscriptionBillingCycleSkipPayload>;
  /** Unskips a Subscription Billing Cycle. */
  readonly subscriptionBillingCycleUnskip?: Maybe<SubscriptionBillingCycleUnskipPayload>;
  /** Activates a Subscription Contract. Contract status must be either active, paused, or failed. */
  readonly subscriptionContractActivate?: Maybe<SubscriptionContractActivatePayload>;
  /** Creates a Subscription Contract. */
  readonly subscriptionContractAtomicCreate?: Maybe<SubscriptionContractAtomicCreatePayload>;
  /** Cancels a Subscription Contract. */
  readonly subscriptionContractCancel?: Maybe<SubscriptionContractCancelPayload>;
  /**
   * Creates a Subscription Contract Draft.
   * You can submit all the desired information for the draft using [Subscription Draft Input object](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/SubscriptionDraftInput).
   * You can also update the draft using the [Subscription Contract Update](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionContractUpdate) mutation.
   * The draft is not saved until you call the [Subscription Draft Commit](https://shopify.dev/docs/api/admin-graphql/latest/mutations/subscriptionDraftCommit) mutation.
   */
  readonly subscriptionContractCreate?: Maybe<SubscriptionContractCreatePayload>;
  /** Expires a Subscription Contract. */
  readonly subscriptionContractExpire?: Maybe<SubscriptionContractExpirePayload>;
  /** Fails a Subscription Contract. */
  readonly subscriptionContractFail?: Maybe<SubscriptionContractFailPayload>;
  /** Pauses a Subscription Contract. */
  readonly subscriptionContractPause?: Maybe<SubscriptionContractPausePayload>;
  /** Allows for the easy change of a Product in a Contract or a Product price change. */
  readonly subscriptionContractProductChange?: Maybe<SubscriptionContractProductChangePayload>;
  /**
   * Sets the next billing date of a Subscription Contract. This field is managed by the apps.
   *         Alternatively you can utilize our
   *         [Billing Cycles APIs](https://shopify.dev/docs/apps/selling-strategies/subscriptions/billing-cycles),
   *         which provide auto-computed billing dates and additional functionalities.
   */
  readonly subscriptionContractSetNextBillingDate?: Maybe<SubscriptionContractSetNextBillingDatePayload>;
  /** The subscriptionContractUpdate mutation allows you to create a draft of an existing subscription contract. This [draft](https://shopify.dev/api/admin-graphql/latest/objects/SubscriptionDraft) can be reviewed and modified as needed. Once the draft is committed with [subscriptionDraftCommit](https://shopify.dev/api/admin-graphql/latest/mutations/subscriptionDraftCommit), the changes are applied to the original subscription contract. */
  readonly subscriptionContractUpdate?: Maybe<SubscriptionContractUpdatePayload>;
  /** Commits the updates of a Subscription Contract draft. */
  readonly subscriptionDraftCommit?: Maybe<SubscriptionDraftCommitPayload>;
  /** Adds a subscription discount to a subscription draft. */
  readonly subscriptionDraftDiscountAdd?: Maybe<SubscriptionDraftDiscountAddPayload>;
  /** Applies a code discount on the subscription draft. */
  readonly subscriptionDraftDiscountCodeApply?: Maybe<SubscriptionDraftDiscountCodeApplyPayload>;
  /** Removes a subscription discount from a subscription draft. */
  readonly subscriptionDraftDiscountRemove?: Maybe<SubscriptionDraftDiscountRemovePayload>;
  /** Updates a subscription discount on a subscription draft. */
  readonly subscriptionDraftDiscountUpdate?: Maybe<SubscriptionDraftDiscountUpdatePayload>;
  /** Adds a subscription free shipping discount to a subscription draft. */
  readonly subscriptionDraftFreeShippingDiscountAdd?: Maybe<SubscriptionDraftFreeShippingDiscountAddPayload>;
  /** Updates a subscription free shipping discount on a subscription draft. */
  readonly subscriptionDraftFreeShippingDiscountUpdate?: Maybe<SubscriptionDraftFreeShippingDiscountUpdatePayload>;
  /** Adds a subscription line to a subscription draft. */
  readonly subscriptionDraftLineAdd?: Maybe<SubscriptionDraftLineAddPayload>;
  /** Removes a subscription line from a subscription draft. */
  readonly subscriptionDraftLineRemove?: Maybe<SubscriptionDraftLineRemovePayload>;
  /** Updates a subscription line on a subscription draft. */
  readonly subscriptionDraftLineUpdate?: Maybe<SubscriptionDraftLineUpdatePayload>;
  /** Updates a Subscription Draft. */
  readonly subscriptionDraftUpdate?: Maybe<SubscriptionDraftUpdatePayload>;
  /** Add tags to an order, a draft order, a customer, a product, or an online store article. */
  readonly tagsAdd?: Maybe<TagsAddPayload>;
  /** Remove tags from an order, a draft order, a customer, a product, or an online store article. */
  readonly tagsRemove?: Maybe<TagsRemovePayload>;
  /** Allows tax app configurations for tax partners. */
  readonly taxAppConfigure?: Maybe<TaxAppConfigurePayload>;
  /**
   * Creates a theme using an external URL or for files that were previously uploaded using the
   * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stageduploadscreate).
   * These themes are added to the [Themes page](https://admin.shopify.com/themes) in Shopify admin.
   */
  readonly themeCreate?: Maybe<ThemeCreatePayload>;
  /** Deletes a theme. */
  readonly themeDelete?: Maybe<ThemeDeletePayload>;
  /** Copy theme files. Copying to existing theme files will overwrite them. */
  readonly themeFilesCopy?: Maybe<ThemeFilesCopyPayload>;
  /** Deletes a theme's files. */
  readonly themeFilesDelete?: Maybe<ThemeFilesDeletePayload>;
  /** Create or update theme files. */
  readonly themeFilesUpsert?: Maybe<ThemeFilesUpsertPayload>;
  /** Publishes a theme. */
  readonly themePublish?: Maybe<ThemePublishPayload>;
  /** Updates a theme. */
  readonly themeUpdate?: Maybe<ThemeUpdatePayload>;
  /** Trigger the voiding of an uncaptured authorization transaction. */
  readonly transactionVoid?: Maybe<TransactionVoidPayload>;
  /** Creates or updates translations. */
  readonly translationsRegister?: Maybe<TranslationsRegisterPayload>;
  /** Deletes translations. */
  readonly translationsRemove?: Maybe<TranslationsRemovePayload>;
  /** Asynchronously delete [URL redirects](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect) in bulk. */
  readonly urlRedirectBulkDeleteAll?: Maybe<UrlRedirectBulkDeleteAllPayload>;
  /**
   * Asynchronously delete [URLRedirect](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect)
   * objects in bulk by IDs.
   * Learn more about [URLRedirect](https://help.shopify.com/en/manual/online-store/menus-and-links/url-redirect)
   * objects.
   */
  readonly urlRedirectBulkDeleteByIds?: Maybe<UrlRedirectBulkDeleteByIdsPayload>;
  /** Asynchronously delete redirects in bulk. */
  readonly urlRedirectBulkDeleteBySavedSearch?: Maybe<UrlRedirectBulkDeleteBySavedSearchPayload>;
  /** Asynchronously delete redirects in bulk. */
  readonly urlRedirectBulkDeleteBySearch?: Maybe<UrlRedirectBulkDeleteBySearchPayload>;
  /** Creates a [`UrlRedirect`](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect) object. */
  readonly urlRedirectCreate?: Maybe<UrlRedirectCreatePayload>;
  /** Deletes a [`UrlRedirect`](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect) object. */
  readonly urlRedirectDelete?: Maybe<UrlRedirectDeletePayload>;
  /**
   * Creates a [`UrlRedirectImport`](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirectImport) object.
   *
   * After creating the `UrlRedirectImport` object, the `UrlRedirectImport` request can be performed using the [`urlRedirectImportSubmit`](https://shopify.dev/api/admin-graphql/latest/mutations/urlRedirectImportSubmit) mutation.
   */
  readonly urlRedirectImportCreate?: Maybe<UrlRedirectImportCreatePayload>;
  /**
   * Submits a `UrlRedirectImport` request to be processed.
   *
   * The `UrlRedirectImport` request is first created with the [`urlRedirectImportCreate`](https://shopify.dev/api/admin-graphql/latest/mutations/urlRedirectImportCreate) mutation.
   */
  readonly urlRedirectImportSubmit?: Maybe<UrlRedirectImportSubmitPayload>;
  /** Updates a URL redirect. */
  readonly urlRedirectUpdate?: Maybe<UrlRedirectUpdatePayload>;
  /** Creates a validation. */
  readonly validationCreate?: Maybe<ValidationCreatePayload>;
  /** Deletes a validation. */
  readonly validationDelete?: Maybe<ValidationDeletePayload>;
  /** Update a validation. */
  readonly validationUpdate?: Maybe<ValidationUpdatePayload>;
  /**
   * Activate a [web pixel extension](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels)
   * by creating a web pixel record on the store where you installed your app.
   *
   * When you run the `webPixelCreate` mutation, Shopify validates it
   * against the settings definition in `shopify.extension.toml`. If the `settings` input field doesn't match
   * the schema that you defined, then the mutation fails. Learn how to
   * define [web pixel settings](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels#step-2-define-your-web-pixel-settings).
   */
  readonly webPixelCreate?: Maybe<WebPixelCreatePayload>;
  /** Deletes the web pixel shop settings. */
  readonly webPixelDelete?: Maybe<WebPixelDeletePayload>;
  /**
   * Activate a [web pixel extension](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels)
   * by updating a web pixel record on the store where you installed your app.
   *
   * When you run the `webPixelUpdate` mutation, Shopify validates it
   * against the settings definition in `shopify.extension.toml`. If the `settings` input field doesn't match
   * the schema that you defined, then the mutation fails. Learn how to
   * define [web pixel settings](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels#step-2-define-your-web-pixel-settings).
   */
  readonly webPixelUpdate?: Maybe<WebPixelUpdatePayload>;
  /**
   * Creates a new webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly webhookSubscriptionCreate?: Maybe<WebhookSubscriptionCreatePayload>;
  /**
   * Deletes a webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly webhookSubscriptionDelete?: Maybe<WebhookSubscriptionDeletePayload>;
  /**
   * Updates a webhook subscription.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly webhookSubscriptionUpdate?: Maybe<WebhookSubscriptionUpdatePayload>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAbandonmentEmailStateUpdateArgs = {
  emailSentAt?: InputMaybe<Scalars['DateTime']>;
  emailState: AbandonmentEmailState;
  emailStateChangeReason?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationAbandonmentUpdateActivitiesDeliveryStatusesArgs = {
  abandonmentId: Scalars['ID'];
  deliveredAt?: InputMaybe<Scalars['DateTime']>;
  deliveryStatus: AbandonmentDeliveryState;
  deliveryStatusChangeReason?: InputMaybe<Scalars['String']>;
  marketingActivityId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationAppPurchaseOneTimeCreateArgs = {
  name: Scalars['String'];
  price: MoneyInput;
  returnUrl: Scalars['URL'];
  test?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAppRevokeAccessScopesArgs = {
  scopes: ReadonlyArray<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAppSubscriptionCancelArgs = {
  id: Scalars['ID'];
  prorate?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAppSubscriptionCreateArgs = {
  lineItems: ReadonlyArray<AppSubscriptionLineItemInput>;
  name: Scalars['String'];
  replacementBehavior?: InputMaybe<AppSubscriptionReplacementBehavior>;
  returnUrl: Scalars['URL'];
  test?: InputMaybe<Scalars['Boolean']>;
  trialDays?: InputMaybe<Scalars['Int']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationAppSubscriptionLineItemUpdateArgs = {
  cappedAmount: MoneyInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationAppSubscriptionTrialExtendArgs = {
  days: Scalars['Int'];
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationAppUsageRecordCreateArgs = {
  description: Scalars['String'];
  idempotencyKey?: InputMaybe<Scalars['String']>;
  price: MoneyInput;
  subscriptionLineItemId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationArticleCreateArgs = {
  article: ArticleCreateInput;
  blog?: InputMaybe<ArticleBlogInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationArticleDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationArticleUpdateArgs = {
  article: ArticleUpdateInput;
  blog?: InputMaybe<ArticleBlogInput>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBlogCreateArgs = {
  blog: BlogCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationBlogDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBlogUpdateArgs = {
  blog: BlogUpdateInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBulkOperationCancelArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBulkOperationRunMutationArgs = {
  clientIdentifier?: InputMaybe<Scalars['String']>;
  mutation: Scalars['String'];
  stagedUploadPath: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBulkOperationRunQueryArgs = {
  query: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationBulkProductResourceFeedbackCreateArgs = {
  feedbackInput: ReadonlyArray<ProductResourceFeedbackInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCarrierServiceCreateArgs = {
  input: DeliveryCarrierServiceCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCarrierServiceDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCarrierServiceUpdateArgs = {
  input: DeliveryCarrierServiceUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCartTransformCreateArgs = {
  blockOnFailure?: InputMaybe<Scalars['Boolean']>;
  functionId: Scalars['String'];
  metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCartTransformDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCatalogContextUpdateArgs = {
  catalogId: Scalars['ID'];
  contextsToAdd?: InputMaybe<CatalogContextInput>;
  contextsToRemove?: InputMaybe<CatalogContextInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCatalogCreateArgs = {
  input: CatalogCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCatalogDeleteArgs = {
  deleteDependentResources?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCatalogUpdateArgs = {
  id: Scalars['ID'];
  input: CatalogUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCheckoutBrandingUpsertArgs = {
  checkoutBrandingInput?: InputMaybe<CheckoutBrandingInput>;
  checkoutProfileId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionAddProductsArgs = {
  id: Scalars['ID'];
  productIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionAddProductsV2Args = {
  id: Scalars['ID'];
  productIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionCreateArgs = {
  input: CollectionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionDeleteArgs = {
  input: CollectionDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionPublishArgs = {
  input: CollectionPublishInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionRemoveProductsArgs = {
  id: Scalars['ID'];
  productIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionReorderProductsArgs = {
  id: Scalars['ID'];
  moves: ReadonlyArray<MoveInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionUnpublishArgs = {
  input: CollectionUnpublishInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCollectionUpdateArgs = {
  input: CollectionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCombinedListingUpdateArgs = {
  optionsAndValues?: InputMaybe<ReadonlyArray<OptionAndValueInput>>;
  parentProductId: Scalars['ID'];
  productsAdded?: InputMaybe<ReadonlyArray<ChildProductRelationInput>>;
  productsEdited?: InputMaybe<ReadonlyArray<ChildProductRelationInput>>;
  productsRemovedIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  title?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCommentApproveArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCommentDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCommentNotSpamArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCommentSpamArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompaniesDeleteArgs = {
  companyIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyAddressDeleteArgs = {
  addressId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyAssignCustomerAsContactArgs = {
  companyId: Scalars['ID'];
  customerId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyAssignMainContactArgs = {
  companyContactId: Scalars['ID'];
  companyId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactAssignRoleArgs = {
  companyContactId: Scalars['ID'];
  companyContactRoleId: Scalars['ID'];
  companyLocationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactAssignRolesArgs = {
  companyContactId: Scalars['ID'];
  rolesToAssign: ReadonlyArray<CompanyContactRoleAssign>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactCreateArgs = {
  companyId: Scalars['ID'];
  input: CompanyContactInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactDeleteArgs = {
  companyContactId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactRemoveFromCompanyArgs = {
  companyContactId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactRevokeRoleArgs = {
  companyContactId: Scalars['ID'];
  companyContactRoleAssignmentId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactRevokeRolesArgs = {
  companyContactId: Scalars['ID'];
  revokeAll?: InputMaybe<Scalars['Boolean']>;
  roleAssignmentIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactSendWelcomeEmailArgs = {
  companyContactId: Scalars['ID'];
  email?: InputMaybe<EmailInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactUpdateArgs = {
  companyContactId: Scalars['ID'];
  input: CompanyContactInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyContactsDeleteArgs = {
  companyContactIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyCreateArgs = {
  input: CompanyCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationAssignAddressArgs = {
  address: CompanyAddressInput;
  addressTypes: ReadonlyArray<CompanyAddressType>;
  locationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationAssignRolesArgs = {
  companyLocationId: Scalars['ID'];
  rolesToAssign: ReadonlyArray<CompanyLocationRoleAssign>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationAssignStaffMembersArgs = {
  companyLocationId: Scalars['ID'];
  staffMemberIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationAssignTaxExemptionsArgs = {
  companyLocationId: Scalars['ID'];
  taxExemptions: ReadonlyArray<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationCreateArgs = {
  companyId: Scalars['ID'];
  input: CompanyLocationInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationCreateTaxRegistrationArgs = {
  locationId: Scalars['ID'];
  taxId: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationDeleteArgs = {
  companyLocationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationRemoveStaffMembersArgs = {
  companyLocationStaffMemberAssignmentIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationRevokeRolesArgs = {
  companyLocationId: Scalars['ID'];
  rolesToRevoke: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationRevokeTaxExemptionsArgs = {
  companyLocationId: Scalars['ID'];
  taxExemptions: ReadonlyArray<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationRevokeTaxRegistrationArgs = {
  companyLocationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationUpdateArgs = {
  companyLocationId: Scalars['ID'];
  input: CompanyLocationUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyLocationsDeleteArgs = {
  companyLocationIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyRevokeMainContactArgs = {
  companyId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCompanyUpdateArgs = {
  companyId: Scalars['ID'];
  input: CompanyInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerAddTaxExemptionsArgs = {
  customerId: Scalars['ID'];
  taxExemptions: ReadonlyArray<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerCancelDataErasureArgs = {
  customerId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerCreateArgs = {
  input: CustomerInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerDeleteArgs = {
  input: CustomerDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerEmailMarketingConsentUpdateArgs = {
  input: CustomerEmailMarketingConsentUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerGenerateAccountActivationUrlArgs = {
  customerId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerMergeArgs = {
  customerOneId: Scalars['ID'];
  customerTwoId: Scalars['ID'];
  overrideFields?: InputMaybe<CustomerMergeOverrideFields>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodCreateFromDuplicationDataArgs = {
  billingAddress: MailingAddressInput;
  customerId: Scalars['ID'];
  encryptedDuplicationData: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodCreditCardCreateArgs = {
  billingAddress: MailingAddressInput;
  customerId: Scalars['ID'];
  sessionId: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodCreditCardUpdateArgs = {
  billingAddress: MailingAddressInput;
  id: Scalars['ID'];
  sessionId: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodGetDuplicationDataArgs = {
  customerPaymentMethodId: Scalars['ID'];
  targetCustomerId: Scalars['ID'];
  targetShopId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodGetUpdateUrlArgs = {
  customerPaymentMethodId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodPaypalBillingAgreementCreateArgs = {
  billingAddress?: InputMaybe<MailingAddressInput>;
  billingAgreementId: Scalars['String'];
  customerId: Scalars['ID'];
  inactive?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodPaypalBillingAgreementUpdateArgs = {
  billingAddress: MailingAddressInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodRemoteCreateArgs = {
  customerId: Scalars['ID'];
  remoteReference: CustomerPaymentMethodRemoteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodRemoteCreditCardCreateArgs = {
  customerId: Scalars['ID'];
  stripeCustomerId: Scalars['String'];
  stripePaymentMethodId?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodRevokeArgs = {
  customerPaymentMethodId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerPaymentMethodSendUpdateEmailArgs = {
  customerPaymentMethodId: Scalars['ID'];
  email?: InputMaybe<EmailInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerRemoveTaxExemptionsArgs = {
  customerId: Scalars['ID'];
  taxExemptions: ReadonlyArray<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerReplaceTaxExemptionsArgs = {
  customerId: Scalars['ID'];
  taxExemptions: ReadonlyArray<TaxExemption>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerRequestDataErasureArgs = {
  customerId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerSegmentMembersQueryCreateArgs = {
  input: CustomerSegmentMembersQueryInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerSendAccountInviteEmailArgs = {
  customerId: Scalars['ID'];
  email?: InputMaybe<EmailInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerSmsMarketingConsentUpdateArgs = {
  input: CustomerSmsMarketingConsentUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerUpdateArgs = {
  input: CustomerInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationCustomerUpdateDefaultAddressArgs = {
  addressId: Scalars['ID'];
  customerId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDataSaleOptOutArgs = {
  email: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDelegateAccessTokenCreateArgs = {
  input: DelegateAccessTokenInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDelegateAccessTokenDestroyArgs = {
  accessToken: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryCustomizationActivationArgs = {
  enabled: Scalars['Boolean'];
  ids: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryCustomizationCreateArgs = {
  deliveryCustomization: DeliveryCustomizationInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryCustomizationDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryCustomizationUpdateArgs = {
  deliveryCustomization: DeliveryCustomizationInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryProfileCreateArgs = {
  profile: DeliveryProfileInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryProfileRemoveArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryProfileUpdateArgs = {
  id: Scalars['ID'];
  leaveLegacyModeProfiles?: InputMaybe<Scalars['Boolean']>;
  profile: DeliveryProfileInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryPromiseProviderUpsertArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  fulfillmentDelay?: InputMaybe<Scalars['Int']>;
  locationId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliverySettingUpdateArgs = {
  setting: DeliverySettingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDeliveryShippingOriginAssignArgs = {
  locationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticActivateArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticAppCreateArgs = {
  automaticAppDiscount: DiscountAutomaticAppInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticAppUpdateArgs = {
  automaticAppDiscount: DiscountAutomaticAppInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBasicCreateArgs = {
  automaticBasicDiscount: DiscountAutomaticBasicInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBasicUpdateArgs = {
  automaticBasicDiscount: DiscountAutomaticBasicInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBulkDeleteArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBxgyCreateArgs = {
  automaticBxgyDiscount: DiscountAutomaticBxgyInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticBxgyUpdateArgs = {
  automaticBxgyDiscount: DiscountAutomaticBxgyInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticDeactivateArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticFreeShippingCreateArgs = {
  freeShippingAutomaticDiscount: DiscountAutomaticFreeShippingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountAutomaticFreeShippingUpdateArgs = {
  freeShippingAutomaticDiscount: DiscountAutomaticFreeShippingInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeActivateArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeAppCreateArgs = {
  codeAppDiscount: DiscountCodeAppInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeAppUpdateArgs = {
  codeAppDiscount: DiscountCodeAppInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBasicCreateArgs = {
  basicCodeDiscount: DiscountCodeBasicInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBasicUpdateArgs = {
  basicCodeDiscount: DiscountCodeBasicInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBulkActivateArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBulkDeactivateArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBulkDeleteArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBxgyCreateArgs = {
  bxgyCodeDiscount: DiscountCodeBxgyInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeBxgyUpdateArgs = {
  bxgyCodeDiscount: DiscountCodeBxgyInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeDeactivateArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeFreeShippingCreateArgs = {
  freeShippingCodeDiscount: DiscountCodeFreeShippingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeFreeShippingUpdateArgs = {
  freeShippingCodeDiscount: DiscountCodeFreeShippingInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountCodeRedeemCodeBulkDeleteArgs = {
  discountId: Scalars['ID'];
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDiscountRedeemCodeBulkAddArgs = {
  codes: ReadonlyArray<DiscountRedeemCodeInput>;
  discountId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDisputeEvidenceUpdateArgs = {
  id: Scalars['ID'];
  input: ShopifyPaymentsDisputeEvidenceUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderBulkAddTagsArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  tags: ReadonlyArray<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderBulkDeleteArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderBulkRemoveTagsArgs = {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  tags: ReadonlyArray<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCalculateArgs = {
  input: DraftOrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCompleteArgs = {
  id: Scalars['ID'];
  paymentGatewayId?: InputMaybe<Scalars['ID']>;
  sourceName?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCreateArgs = {
  input: DraftOrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCreateFromOrderArgs = {
  orderId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderCreateMerchantCheckoutArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderDeleteArgs = {
  input: DraftOrderDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderDuplicateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderInvoicePreviewArgs = {
  email?: InputMaybe<EmailInput>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderInvoiceSendArgs = {
  email?: InputMaybe<EmailInput>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationDraftOrderUpdateArgs = {
  id: Scalars['ID'];
  input: DraftOrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationEventBridgeServerPixelUpdateArgs = {
  arn: Scalars['ARN'];
};


/** The schema's entry point for all mutation operations. */
export type MutationEventBridgeWebhookSubscriptionCreateArgs = {
  topic: WebhookSubscriptionTopic;
  webhookSubscription: EventBridgeWebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationEventBridgeWebhookSubscriptionUpdateArgs = {
  id: Scalars['ID'];
  webhookSubscription: EventBridgeWebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationFileAcknowledgeUpdateFailedArgs = {
  fileIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFileCreateArgs = {
  files: ReadonlyArray<FileCreateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFileDeleteArgs = {
  fileIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFileUpdateArgs = {
  files: ReadonlyArray<FileUpdateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFlowGenerateSignatureArgs = {
  id: Scalars['ID'];
  payload: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFlowTriggerReceiveArgs = {
  handle?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentCancelArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentConstraintRuleCreateArgs = {
  deliveryMethodTypes: ReadonlyArray<DeliveryMethodType>;
  functionId: Scalars['String'];
  metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentConstraintRuleDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentConstraintRuleUpdateArgs = {
  deliveryMethodTypes: ReadonlyArray<DeliveryMethodType>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentCreateArgs = {
  fulfillment: FulfillmentInput;
  message?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentCreateV2Args = {
  fulfillment: FulfillmentV2Input;
  message?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentEventCreateArgs = {
  fulfillmentEvent: FulfillmentEventInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderAcceptCancellationRequestArgs = {
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderAcceptFulfillmentRequestArgs = {
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderCancelArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderCloseArgs = {
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderHoldArgs = {
  fulfillmentHold: FulfillmentOrderHoldInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderLineItemsPreparedForPickupArgs = {
  input: FulfillmentOrderLineItemsPreparedForPickupInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderMergeArgs = {
  fulfillmentOrderMergeInputs: ReadonlyArray<FulfillmentOrderMergeInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderMoveArgs = {
  fulfillmentOrderLineItems?: InputMaybe<ReadonlyArray<FulfillmentOrderLineItemInput>>;
  id: Scalars['ID'];
  newLocationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderOpenArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderRejectCancellationRequestArgs = {
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderRejectFulfillmentRequestArgs = {
  id: Scalars['ID'];
  lineItems?: InputMaybe<ReadonlyArray<IncomingRequestLineItemInput>>;
  message?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<FulfillmentOrderRejectionReason>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderReleaseHoldArgs = {
  externalId?: InputMaybe<Scalars['String']>;
  holdIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderRescheduleArgs = {
  fulfillAt: Scalars['DateTime'];
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderSplitArgs = {
  fulfillmentOrderSplits: ReadonlyArray<FulfillmentOrderSplitInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderSubmitCancellationRequestArgs = {
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrderSubmitFulfillmentRequestArgs = {
  fulfillmentOrderLineItems?: InputMaybe<ReadonlyArray<FulfillmentOrderLineItemInput>>;
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentOrdersSetFulfillmentDeadlineArgs = {
  fulfillmentDeadline: Scalars['DateTime'];
  fulfillmentOrderIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentServiceCreateArgs = {
  callbackUrl: Scalars['URL'];
  inventoryManagement?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  trackingSupport?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentServiceDeleteArgs = {
  destinationLocationId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  inventoryAction?: InputMaybe<FulfillmentServiceDeleteInventoryAction>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentServiceUpdateArgs = {
  callbackUrl?: InputMaybe<Scalars['URL']>;
  id: Scalars['ID'];
  inventoryManagement?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  trackingSupport?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentTrackingInfoUpdateArgs = {
  fulfillmentId: Scalars['ID'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  trackingInfoInput: FulfillmentTrackingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationFulfillmentTrackingInfoUpdateV2Args = {
  fulfillmentId: Scalars['ID'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  trackingInfoInput: FulfillmentTrackingInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardCreateArgs = {
  input: GiftCardCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardCreditArgs = {
  creditInput: GiftCardCreditInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardDeactivateArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardDebitArgs = {
  debitInput: GiftCardDebitInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardSendNotificationToCustomerArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardSendNotificationToRecipientArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationGiftCardUpdateArgs = {
  id: Scalars['ID'];
  input: GiftCardUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryActivateArgs = {
  available?: InputMaybe<Scalars['Int']>;
  inventoryItemId: Scalars['ID'];
  locationId: Scalars['ID'];
  onHand?: InputMaybe<Scalars['Int']>;
  stockAtLegacyLocation?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryAdjustQuantitiesArgs = {
  input: InventoryAdjustQuantitiesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryBulkToggleActivationArgs = {
  inventoryItemId: Scalars['ID'];
  inventoryItemUpdates: ReadonlyArray<InventoryBulkToggleActivationInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryDeactivateArgs = {
  inventoryLevelId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryItemUpdateArgs = {
  id: Scalars['ID'];
  input: InventoryItemInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventoryMoveQuantitiesArgs = {
  input: InventoryMoveQuantitiesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventorySetOnHandQuantitiesArgs = {
  input: InventorySetOnHandQuantitiesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventorySetQuantitiesArgs = {
  input: InventorySetQuantitiesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationInventorySetScheduledChangesArgs = {
  input: InventorySetScheduledChangesInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationActivateArgs = {
  locationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationAddArgs = {
  input: LocationAddInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationDeactivateArgs = {
  destinationLocationId?: InputMaybe<Scalars['ID']>;
  locationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationDeleteArgs = {
  locationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationEditArgs = {
  id: Scalars['ID'];
  input: LocationEditInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationLocalPickupDisableArgs = {
  locationId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationLocationLocalPickupEnableArgs = {
  localPickupSettings: DeliveryLocationLocalPickupEnableInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketCreateArgs = {
  input: MarketCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketCurrencySettingsUpdateArgs = {
  input: MarketCurrencySettingsUpdateInput;
  marketId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketLocalizationsRegisterArgs = {
  marketLocalizations: ReadonlyArray<MarketLocalizationRegisterInput>;
  resourceId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketLocalizationsRemoveArgs = {
  marketIds: ReadonlyArray<Scalars['ID']>;
  marketLocalizationKeys: ReadonlyArray<Scalars['String']>;
  resourceId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketRegionDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketRegionsCreateArgs = {
  marketId: Scalars['ID'];
  regions: ReadonlyArray<MarketRegionCreateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketRegionsDeleteArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketUpdateArgs = {
  id: Scalars['ID'];
  input: MarketUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketWebPresenceCreateArgs = {
  marketId: Scalars['ID'];
  webPresence: MarketWebPresenceCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketWebPresenceDeleteArgs = {
  webPresenceId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketWebPresenceUpdateArgs = {
  webPresence: MarketWebPresenceUpdateInput;
  webPresenceId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityCreateArgs = {
  input: MarketingActivityCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityCreateExternalArgs = {
  input: MarketingActivityCreateExternalInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityDeleteExternalArgs = {
  marketingActivityId?: InputMaybe<Scalars['ID']>;
  remoteId?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityUpdateArgs = {
  input: MarketingActivityUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityUpdateExternalArgs = {
  input: MarketingActivityUpdateExternalInput;
  marketingActivityId?: InputMaybe<Scalars['ID']>;
  remoteId?: InputMaybe<Scalars['String']>;
  utm?: InputMaybe<UtmInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingActivityUpsertExternalArgs = {
  input: MarketingActivityUpsertExternalInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingEngagementCreateArgs = {
  channelHandle?: InputMaybe<Scalars['String']>;
  marketingActivityId?: InputMaybe<Scalars['ID']>;
  marketingEngagement: MarketingEngagementInput;
  remoteId?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMarketingEngagementsDeleteArgs = {
  channelHandle?: InputMaybe<Scalars['String']>;
  deleteEngagementsForAllChannels?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMenuCreateArgs = {
  handle: Scalars['String'];
  items: ReadonlyArray<MenuItemCreateInput>;
  title: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMenuDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMenuUpdateArgs = {
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  items: ReadonlyArray<MenuItemUpdateInput>;
  title: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionCreateArgs = {
  definition: MetafieldDefinitionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionDeleteArgs = {
  deleteAllAssociatedMetafields?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionPinArgs = {
  definitionId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionUnpinArgs = {
  definitionId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDefinitionUpdateArgs = {
  definition: MetafieldDefinitionUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldDeleteArgs = {
  input: MetafieldDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldStorefrontVisibilityCreateArgs = {
  input: MetafieldStorefrontVisibilityInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldStorefrontVisibilityDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldsDeleteArgs = {
  metafields: ReadonlyArray<MetafieldIdentifierInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetafieldsSetArgs = {
  metafields: ReadonlyArray<MetafieldsSetInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectBulkDeleteArgs = {
  where: MetaobjectBulkDeleteWhereCondition;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectCreateArgs = {
  metaobject: MetaobjectCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectDefinitionCreateArgs = {
  definition: MetaobjectDefinitionCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectDefinitionDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectDefinitionUpdateArgs = {
  definition: MetaobjectDefinitionUpdateInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectUpdateArgs = {
  id: Scalars['ID'];
  metaobject: MetaobjectUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMetaobjectUpsertArgs = {
  handle: MetaobjectHandleInput;
  metaobject: MetaobjectUpsertInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMobilePlatformApplicationCreateArgs = {
  input: MobilePlatformApplicationCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationMobilePlatformApplicationDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationMobilePlatformApplicationUpdateArgs = {
  id: Scalars['ID'];
  input: MobilePlatformApplicationUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCancelArgs = {
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  reason: OrderCancelReason;
  refund: Scalars['Boolean'];
  restock: Scalars['Boolean'];
  staffNote?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCaptureArgs = {
  input: OrderCaptureInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCloseArgs = {
  input: OrderCloseInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCreateArgs = {
  options?: InputMaybe<OrderCreateOptionsInput>;
  order: OrderCreateOrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderCreateMandatePaymentArgs = {
  amount?: InputMaybe<MoneyInput>;
  autoCapture?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idempotencyKey: Scalars['String'];
  mandateId: Scalars['ID'];
  paymentScheduleId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderDeleteArgs = {
  orderId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditAddCustomItemArgs = {
  id: Scalars['ID'];
  locationId?: InputMaybe<Scalars['ID']>;
  price: MoneyInput;
  quantity: Scalars['Int'];
  requiresShipping?: InputMaybe<Scalars['Boolean']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditAddLineItemDiscountArgs = {
  discount: OrderEditAppliedDiscountInput;
  id: Scalars['ID'];
  lineItemId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditAddShippingLineArgs = {
  id: Scalars['ID'];
  shippingLine: OrderEditAddShippingLineInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditAddVariantArgs = {
  allowDuplicates?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  locationId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  variantId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditBeginArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditCommitArgs = {
  id: Scalars['ID'];
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  staffNote?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditRemoveDiscountArgs = {
  discountApplicationId: Scalars['ID'];
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditRemoveLineItemDiscountArgs = {
  discountApplicationId: Scalars['ID'];
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditRemoveShippingLineArgs = {
  id: Scalars['ID'];
  shippingLineId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditSetQuantityArgs = {
  id: Scalars['ID'];
  lineItemId: Scalars['ID'];
  quantity: Scalars['Int'];
  restock?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditUpdateDiscountArgs = {
  discount: OrderEditAppliedDiscountInput;
  discountApplicationId: Scalars['ID'];
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderEditUpdateShippingLineArgs = {
  id: Scalars['ID'];
  shippingLine: OrderEditUpdateShippingLineInput;
  shippingLineId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderInvoiceSendArgs = {
  email?: InputMaybe<EmailInput>;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderMarkAsPaidArgs = {
  input: OrderMarkAsPaidInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderOpenArgs = {
  input: OrderOpenInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderRiskAssessmentCreateArgs = {
  orderRiskAssessmentInput: OrderRiskAssessmentCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationOrderUpdateArgs = {
  input: OrderInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPageCreateArgs = {
  page: PageCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPageDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPageUpdateArgs = {
  id: Scalars['ID'];
  page: PageUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentCustomizationActivationArgs = {
  enabled: Scalars['Boolean'];
  ids: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentCustomizationCreateArgs = {
  paymentCustomization: PaymentCustomizationInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentCustomizationDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentCustomizationUpdateArgs = {
  id: Scalars['ID'];
  paymentCustomization: PaymentCustomizationInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentReminderSendArgs = {
  paymentScheduleId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentTermsCreateArgs = {
  paymentTermsAttributes: PaymentTermsCreateInput;
  referenceId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentTermsDeleteArgs = {
  input: PaymentTermsDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPaymentTermsUpdateArgs = {
  input: PaymentTermsUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListCreateArgs = {
  input: PriceListCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListFixedPricesAddArgs = {
  priceListId: Scalars['ID'];
  prices: ReadonlyArray<PriceListPriceInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListFixedPricesByProductUpdateArgs = {
  priceListId: Scalars['ID'];
  pricesToAdd?: InputMaybe<ReadonlyArray<PriceListProductPriceInput>>;
  pricesToDeleteByProductIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListFixedPricesDeleteArgs = {
  priceListId: Scalars['ID'];
  variantIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListFixedPricesUpdateArgs = {
  priceListId: Scalars['ID'];
  pricesToAdd: ReadonlyArray<PriceListPriceInput>;
  variantIdsToDelete: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPriceListUpdateArgs = {
  id: Scalars['ID'];
  input: PriceListUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPrivateMetafieldDeleteArgs = {
  input: PrivateMetafieldDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPrivateMetafieldUpsertArgs = {
  input: PrivateMetafieldInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductBundleCreateArgs = {
  input: ProductBundleCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductBundleUpdateArgs = {
  input: ProductBundleUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductChangeStatusArgs = {
  productId: Scalars['ID'];
  status: ProductStatus;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductCreateArgs = {
  media?: InputMaybe<ReadonlyArray<CreateMediaInput>>;
  product?: InputMaybe<ProductCreateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductCreateMediaArgs = {
  media: ReadonlyArray<CreateMediaInput>;
  productId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductDeleteArgs = {
  input: ProductDeleteInput;
  synchronous?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductDeleteMediaArgs = {
  mediaIds: ReadonlyArray<Scalars['ID']>;
  productId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductDuplicateArgs = {
  includeImages?: InputMaybe<Scalars['Boolean']>;
  includeTranslations?: InputMaybe<Scalars['Boolean']>;
  newStatus?: InputMaybe<ProductStatus>;
  newTitle: Scalars['String'];
  productId: Scalars['ID'];
  synchronous?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductFeedCreateArgs = {
  input?: InputMaybe<ProductFeedInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductFeedDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductFullSyncArgs = {
  beforeUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updatedAtSince?: InputMaybe<Scalars['DateTime']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductJoinSellingPlanGroupsArgs = {
  id: Scalars['ID'];
  sellingPlanGroupIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductLeaveSellingPlanGroupsArgs = {
  id: Scalars['ID'];
  sellingPlanGroupIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductOptionUpdateArgs = {
  option: OptionUpdateInput;
  optionValuesToAdd?: InputMaybe<ReadonlyArray<OptionValueCreateInput>>;
  optionValuesToDelete?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  optionValuesToUpdate?: InputMaybe<ReadonlyArray<OptionValueUpdateInput>>;
  productId: Scalars['ID'];
  variantStrategy?: InputMaybe<ProductOptionUpdateVariantStrategy>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductOptionsCreateArgs = {
  options: ReadonlyArray<OptionCreateInput>;
  productId: Scalars['ID'];
  variantStrategy?: InputMaybe<ProductOptionCreateVariantStrategy>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductOptionsDeleteArgs = {
  options: ReadonlyArray<Scalars['ID']>;
  productId: Scalars['ID'];
  strategy?: InputMaybe<ProductOptionDeleteStrategy>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductOptionsReorderArgs = {
  options: ReadonlyArray<OptionReorderInput>;
  productId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductPublishArgs = {
  input: ProductPublishInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductReorderMediaArgs = {
  id: Scalars['ID'];
  moves: ReadonlyArray<MoveInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductSetArgs = {
  input: ProductSetInput;
  synchronous?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductUnpublishArgs = {
  input: ProductUnpublishInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductUpdateArgs = {
  media?: InputMaybe<ReadonlyArray<CreateMediaInput>>;
  product?: InputMaybe<ProductUpdateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductUpdateMediaArgs = {
  media: ReadonlyArray<UpdateMediaInput>;
  productId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantAppendMediaArgs = {
  productId: Scalars['ID'];
  variantMedia: ReadonlyArray<ProductVariantAppendMediaInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantDetachMediaArgs = {
  productId: Scalars['ID'];
  variantMedia: ReadonlyArray<ProductVariantDetachMediaInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantJoinSellingPlanGroupsArgs = {
  id: Scalars['ID'];
  sellingPlanGroupIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantLeaveSellingPlanGroupsArgs = {
  id: Scalars['ID'];
  sellingPlanGroupIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantRelationshipBulkUpdateArgs = {
  input: ReadonlyArray<ProductVariantRelationshipUpdateInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantsBulkCreateArgs = {
  media?: InputMaybe<ReadonlyArray<CreateMediaInput>>;
  productId: Scalars['ID'];
  strategy?: InputMaybe<ProductVariantsBulkCreateStrategy>;
  variants: ReadonlyArray<ProductVariantsBulkInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantsBulkDeleteArgs = {
  productId: Scalars['ID'];
  variantsIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantsBulkReorderArgs = {
  positions: ReadonlyArray<ProductVariantPositionInput>;
  productId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationProductVariantsBulkUpdateArgs = {
  allowPartialUpdates?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<ReadonlyArray<CreateMediaInput>>;
  productId: Scalars['ID'];
  variants: ReadonlyArray<ProductVariantsBulkInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPubSubServerPixelUpdateArgs = {
  pubSubProject: Scalars['String'];
  pubSubTopic: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPubSubWebhookSubscriptionCreateArgs = {
  topic: WebhookSubscriptionTopic;
  webhookSubscription: PubSubWebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPubSubWebhookSubscriptionUpdateArgs = {
  id: Scalars['ID'];
  webhookSubscription?: InputMaybe<PubSubWebhookSubscriptionInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublicationCreateArgs = {
  input: PublicationCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublicationDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPublicationUpdateArgs = {
  id: Scalars['ID'];
  input: PublicationUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublishablePublishArgs = {
  id: Scalars['ID'];
  input: ReadonlyArray<PublicationInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublishablePublishToCurrentChannelArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationPublishableUnpublishArgs = {
  id: Scalars['ID'];
  input: ReadonlyArray<PublicationInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationPublishableUnpublishToCurrentChannelArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationQuantityPricingByVariantUpdateArgs = {
  input: QuantityPricingByVariantUpdateInput;
  priceListId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationQuantityRulesAddArgs = {
  priceListId: Scalars['ID'];
  quantityRules: ReadonlyArray<QuantityRuleInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationQuantityRulesDeleteArgs = {
  priceListId: Scalars['ID'];
  variantIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationRefundCreateArgs = {
  input: RefundInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnApproveRequestArgs = {
  input: ReturnApproveRequestInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnCancelArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnCloseArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnCreateArgs = {
  returnInput: ReturnInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnDeclineRequestArgs = {
  input: ReturnDeclineRequestInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnLineItemRemoveFromReturnArgs = {
  returnId: Scalars['ID'];
  returnLineItems: ReadonlyArray<ReturnLineItemRemoveFromReturnInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnRefundArgs = {
  returnRefundInput: ReturnRefundInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnReopenArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationReturnRequestArgs = {
  input: ReturnRequestInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationReverseDeliveryCreateWithShippingArgs = {
  labelInput?: InputMaybe<ReverseDeliveryLabelInput>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  reverseDeliveryLineItems: ReadonlyArray<ReverseDeliveryLineItemInput>;
  reverseFulfillmentOrderId: Scalars['ID'];
  trackingInput?: InputMaybe<ReverseDeliveryTrackingInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationReverseDeliveryShippingUpdateArgs = {
  labelInput?: InputMaybe<ReverseDeliveryLabelInput>;
  notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  reverseDeliveryId: Scalars['ID'];
  trackingInput?: InputMaybe<ReverseDeliveryTrackingInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationReverseFulfillmentOrderDisposeArgs = {
  dispositionInputs: ReadonlyArray<ReverseFulfillmentOrderDisposeInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSavedSearchCreateArgs = {
  input: SavedSearchCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSavedSearchDeleteArgs = {
  input: SavedSearchDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSavedSearchUpdateArgs = {
  input: SavedSearchUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationScriptTagCreateArgs = {
  input: ScriptTagInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationScriptTagDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationScriptTagUpdateArgs = {
  id: Scalars['ID'];
  input: ScriptTagInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSegmentCreateArgs = {
  name: Scalars['String'];
  query: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSegmentDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSegmentUpdateArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupAddProductVariantsArgs = {
  id: Scalars['ID'];
  productVariantIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupAddProductsArgs = {
  id: Scalars['ID'];
  productIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupCreateArgs = {
  input: SellingPlanGroupInput;
  resources?: InputMaybe<SellingPlanGroupResourceInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupRemoveProductVariantsArgs = {
  id: Scalars['ID'];
  productVariantIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupRemoveProductsArgs = {
  id: Scalars['ID'];
  productIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSellingPlanGroupUpdateArgs = {
  id: Scalars['ID'];
  input: SellingPlanGroupInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShippingPackageDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationShippingPackageMakeDefaultArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationShippingPackageUpdateArgs = {
  id: Scalars['ID'];
  shippingPackage: CustomShippingPackageInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopLocaleDisableArgs = {
  locale: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationShopLocaleEnableArgs = {
  locale: Scalars['String'];
  marketWebPresenceIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopLocaleUpdateArgs = {
  locale: Scalars['String'];
  shopLocale: ShopLocaleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopPolicyUpdateArgs = {
  shopPolicy: ShopPolicyInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopResourceFeedbackCreateArgs = {
  input: ResourceFeedbackCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationShopifyPaymentsPayoutAlternateCurrencyCreateArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  currency: CurrencyCode;
};


/** The schema's entry point for all mutation operations. */
export type MutationStagedUploadTargetGenerateArgs = {
  input: StagedUploadTargetGenerateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationStagedUploadTargetsGenerateArgs = {
  input: ReadonlyArray<StageImageInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationStagedUploadsCreateArgs = {
  input: ReadonlyArray<StagedUploadInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationStandardMetafieldDefinitionEnableArgs = {
  access?: InputMaybe<StandardMetafieldDefinitionAccessInput>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  namespace?: InputMaybe<Scalars['String']>;
  ownerType: MetafieldOwnerType;
  pin?: Scalars['Boolean'];
};


/** The schema's entry point for all mutation operations. */
export type MutationStandardMetaobjectDefinitionEnableArgs = {
  type: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationStoreCreditAccountCreditArgs = {
  creditInput: StoreCreditAccountCreditInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationStoreCreditAccountDebitArgs = {
  debitInput: StoreCreditAccountDebitInput;
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationStorefrontAccessTokenCreateArgs = {
  input: StorefrontAccessTokenInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationStorefrontAccessTokenDeleteArgs = {
  input: StorefrontAccessTokenDeleteInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingAttemptCreateArgs = {
  subscriptionBillingAttemptInput: SubscriptionBillingAttemptInput;
  subscriptionContractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleBulkChargeArgs = {
  billingAttemptExpectedDateRange: SubscriptionBillingCyclesDateRangeSelector;
  filters?: InputMaybe<SubscriptionBillingCycleBulkFilters>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleBulkSearchArgs = {
  billingAttemptExpectedDateRange: SubscriptionBillingCyclesDateRangeSelector;
  filters?: InputMaybe<SubscriptionBillingCycleBulkFilters>;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleChargeArgs = {
  billingCycleSelector: SubscriptionBillingCycleSelector;
  subscriptionContractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleContractDraftCommitArgs = {
  draftId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleContractDraftConcatenateArgs = {
  concatenatedBillingCycleContracts: ReadonlyArray<SubscriptionBillingCycleInput>;
  draftId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleContractEditArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleEditDeleteArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleEditsDeleteArgs = {
  contractId: Scalars['ID'];
  targetSelection: SubscriptionBillingCyclesTargetSelection;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleScheduleEditArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
  input: SubscriptionBillingCycleScheduleEditInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleSkipArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionBillingCycleUnskipArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractActivateArgs = {
  subscriptionContractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractAtomicCreateArgs = {
  input: SubscriptionContractAtomicCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractCancelArgs = {
  subscriptionContractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractCreateArgs = {
  input: SubscriptionContractCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractExpireArgs = {
  subscriptionContractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractFailArgs = {
  subscriptionContractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractPauseArgs = {
  subscriptionContractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractProductChangeArgs = {
  input: SubscriptionContractProductChangeInput;
  lineId: Scalars['ID'];
  subscriptionContractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractSetNextBillingDateArgs = {
  contractId: Scalars['ID'];
  date: Scalars['DateTime'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionContractUpdateArgs = {
  contractId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftCommitArgs = {
  draftId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftDiscountAddArgs = {
  draftId: Scalars['ID'];
  input: SubscriptionManualDiscountInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftDiscountCodeApplyArgs = {
  draftId: Scalars['ID'];
  redeemCode: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftDiscountRemoveArgs = {
  discountId: Scalars['ID'];
  draftId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftDiscountUpdateArgs = {
  discountId: Scalars['ID'];
  draftId: Scalars['ID'];
  input: SubscriptionManualDiscountInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftFreeShippingDiscountAddArgs = {
  draftId: Scalars['ID'];
  input: SubscriptionFreeShippingDiscountInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftFreeShippingDiscountUpdateArgs = {
  discountId: Scalars['ID'];
  draftId: Scalars['ID'];
  input: SubscriptionFreeShippingDiscountInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftLineAddArgs = {
  draftId: Scalars['ID'];
  input: SubscriptionLineInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftLineRemoveArgs = {
  draftId: Scalars['ID'];
  lineId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftLineUpdateArgs = {
  draftId: Scalars['ID'];
  input: SubscriptionLineUpdateInput;
  lineId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationSubscriptionDraftUpdateArgs = {
  draftId: Scalars['ID'];
  input: SubscriptionDraftInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationTagsAddArgs = {
  id: Scalars['ID'];
  tags: ReadonlyArray<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationTagsRemoveArgs = {
  id: Scalars['ID'];
  tags: ReadonlyArray<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationTaxAppConfigureArgs = {
  ready: Scalars['Boolean'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeCreateArgs = {
  name?: InputMaybe<Scalars['String']>;
  source: Scalars['URL'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeFilesCopyArgs = {
  files: ReadonlyArray<ThemeFilesCopyFileInput>;
  themeId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeFilesDeleteArgs = {
  files: ReadonlyArray<Scalars['String']>;
  themeId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeFilesUpsertArgs = {
  files: ReadonlyArray<OnlineStoreThemeFilesUpsertFileInput>;
  themeId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemePublishArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationThemeUpdateArgs = {
  id: Scalars['ID'];
  input: OnlineStoreThemeInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationTransactionVoidArgs = {
  parentTransactionId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationTranslationsRegisterArgs = {
  resourceId: Scalars['ID'];
  translations: ReadonlyArray<TranslationInput>;
};


/** The schema's entry point for all mutation operations. */
export type MutationTranslationsRemoveArgs = {
  locales: ReadonlyArray<Scalars['String']>;
  marketIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  resourceId: Scalars['ID'];
  translationKeys: ReadonlyArray<Scalars['String']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectBulkDeleteByIdsArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectBulkDeleteBySavedSearchArgs = {
  savedSearchId: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectBulkDeleteBySearchArgs = {
  search: Scalars['String'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectCreateArgs = {
  urlRedirect: UrlRedirectInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectImportCreateArgs = {
  url: Scalars['URL'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectImportSubmitArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationUrlRedirectUpdateArgs = {
  id: Scalars['ID'];
  urlRedirect: UrlRedirectInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationValidationCreateArgs = {
  validation: ValidationCreateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationValidationDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationValidationUpdateArgs = {
  id: Scalars['ID'];
  validation: ValidationUpdateInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPixelCreateArgs = {
  webPixel: WebPixelInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPixelDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationWebPixelUpdateArgs = {
  id: Scalars['ID'];
  webPixel: WebPixelInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebhookSubscriptionCreateArgs = {
  topic: WebhookSubscriptionTopic;
  webhookSubscription: WebhookSubscriptionInput;
};


/** The schema's entry point for all mutation operations. */
export type MutationWebhookSubscriptionDeleteArgs = {
  id: Scalars['ID'];
};


/** The schema's entry point for all mutation operations. */
export type MutationWebhookSubscriptionUpdateArgs = {
  id: Scalars['ID'];
  webhookSubscription: WebhookSubscriptionInput;
};

/**
 * A signed upload parameter for uploading an asset to Shopify.
 *
 * Deprecated in favor of
 * [StagedUploadParameter](https://shopify.dev/api/admin-graphql/latest/objects/StagedUploadParameter),
 * which is used in
 * [StagedMediaUploadTarget](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget)
 * and returned by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type MutationsStagedUploadTargetGenerateUploadParameter = {
  /** The upload parameter name. */
  readonly name: Scalars['String'];
  /** The upload parameter value. */
  readonly value: Scalars['String'];
};

/**
 * A default cursor that you can use in queries to paginate your results. Each edge in a connection can
 * return a cursor, which is a reference to the edge's position in the connection. You can use an edge's cursor as
 * the starting point to retrieve the nodes before or after it in a connection.
 *
 * To learn more about using cursor-based pagination, refer to
 * [Paginating results with GraphQL](https://shopify.dev/api/usage/pagination-graphql).
 */
export type Navigable = {
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
};

/** A navigation item, holding basic link attributes. */
export type NavigationItem = {
  /** The unique identifier of the navigation item. */
  readonly id: Scalars['String'];
  /** The name of the navigation item. */
  readonly title: Scalars['String'];
  /** The URL of the page that the navigation item links to. */
  readonly url: Scalars['URL'];
};

/**
 * An object with an ID field to support global identification, in accordance with the
 * [Relay specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface).
 * This interface is used by the [node](https://shopify.dev/api/admin-graphql/unstable/queries/node)
 * and [nodes](https://shopify.dev/api/admin-graphql/unstable/queries/nodes) queries.
 */
export type Node = {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
};

/** The input fields for dimensions of an object. */
export type ObjectDimensionsInput = {
  /** The height in `unit`s. */
  readonly height: Scalars['Float'];
  /** The length in `unit`s. */
  readonly length: Scalars['Float'];
  /** Unit of measurement for `length`, `width`, and `height`. */
  readonly unit: LengthUnit;
  /** The width in `unit`s. */
  readonly width: Scalars['Float'];
};

/** The shop's online store channel. */
export type OnlineStore = {
  /** Storefront password information. */
  readonly passwordProtection: OnlineStorePasswordProtection;
};

/** Storefront password information. */
export type OnlineStorePasswordProtection = {
  /** Whether the storefront password is enabled. */
  readonly enabled: Scalars['Boolean'];
};

/** Online Store preview URL of the object. */
export type OnlineStorePreviewable = {
  /** The [preview URL](https://help.shopify.com/manual/online-store/setting-up#preview-your-store) for the online store. */
  readonly onlineStorePreviewUrl?: Maybe<Scalars['URL']>;
};

/** A theme for display on the storefront. */
export type OnlineStoreTheme = HasPublishedTranslations & Node & {
  /** The date and time when the theme was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The files in the theme. */
  readonly files?: Maybe<OnlineStoreThemeFileConnection>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the theme, set by the merchant. */
  readonly name: Scalars['String'];
  /** The prefix of the theme. */
  readonly prefix: Scalars['String'];
  /** Whether the theme is processing. */
  readonly processing: Scalars['Boolean'];
  /** Whether the theme processing failed. */
  readonly processingFailed: Scalars['Boolean'];
  /** The role of the theme. */
  readonly role: ThemeRole;
  /** The theme store ID. */
  readonly themeStoreId?: Maybe<Scalars['Int']>;
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The date and time when the theme was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** A theme for display on the storefront. */
export type OnlineStoreThemeFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filenames?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
};


/** A theme for display on the storefront. */
export type OnlineStoreThemeTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** An auto-generated type for paginating through multiple OnlineStoreThemes. */
export type OnlineStoreThemeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<OnlineStoreThemeEdge>;
  /** A list of nodes that are contained in OnlineStoreThemeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<OnlineStoreTheme>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one OnlineStoreTheme and a cursor during pagination. */
export type OnlineStoreThemeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of OnlineStoreThemeEdge. */
  readonly node: OnlineStoreTheme;
};

/** Represents a theme file. */
export type OnlineStoreThemeFile = {
  /** The body of the theme file. */
  readonly body: OnlineStoreThemeFileBody;
  /** The md5 digest of the theme file for data integrity. */
  readonly checksumMd5?: Maybe<Scalars['String']>;
  /** The content type of the theme file. */
  readonly contentType: Scalars['String'];
  /** The date and time when the theme file was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The unique identifier of the theme file. */
  readonly filename: Scalars['String'];
  /** The size of the theme file in bytes. */
  readonly size: Scalars['UnsignedInt64'];
  /** The date and time when the theme file was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** Represents the body of a theme file. */
export type OnlineStoreThemeFileBody = OnlineStoreThemeFileBodyBase64 | OnlineStoreThemeFileBodyText | OnlineStoreThemeFileBodyUrl;

/** Represents the base64 encoded body of a theme file. */
export type OnlineStoreThemeFileBodyBase64 = {
  /** The body of the theme file, base64 encoded. */
  readonly contentBase64: Scalars['String'];
};

/** The input fields for the theme file body. */
export type OnlineStoreThemeFileBodyInput = {
  /** The input type of the theme file body. */
  readonly type: OnlineStoreThemeFileBodyInputType;
  /** The body of the theme file. */
  readonly value: Scalars['String'];
};

/** The input type for a theme file body. */
export enum OnlineStoreThemeFileBodyInputType {
  /** The base64 encoded body of a theme file. */
  BASE64 = 'BASE64',
  /** The text body of the theme file. */
  TEXT = 'TEXT',
  /** The url of the body of a theme file. */
  URL = 'URL'
}

/** Represents the body of a theme file. */
export type OnlineStoreThemeFileBodyText = {
  /** The body of the theme file. */
  readonly content: Scalars['String'];
};

/** Represents the url of the body of a theme file. */
export type OnlineStoreThemeFileBodyUrl = {
  /** The short lived url for the body of the theme file. */
  readonly url: Scalars['URL'];
};

/** An auto-generated type for paginating through multiple OnlineStoreThemeFiles. */
export type OnlineStoreThemeFileConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<OnlineStoreThemeFileEdge>;
  /** A list of nodes that are contained in OnlineStoreThemeFileEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<OnlineStoreThemeFile>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
  /** List of errors that occurred during the request. */
  readonly userErrors: ReadonlyArray<OnlineStoreThemeFileReadResult>;
};

/** An auto-generated type which holds one OnlineStoreThemeFile and a cursor during pagination. */
export type OnlineStoreThemeFileEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of OnlineStoreThemeFileEdge. */
  readonly node: OnlineStoreThemeFile;
};

/** Represents the result of a copy, delete, or write operation performed on a theme file. */
export type OnlineStoreThemeFileOperationResult = {
  /** Unique identifier of the theme file. */
  readonly filename: Scalars['String'];
};

/** Represents the result of a read operation performed on a theme asset. */
export type OnlineStoreThemeFileReadResult = {
  /** Type that indicates the result of the operation. */
  readonly code: OnlineStoreThemeFileResultType;
  /** Unique identifier associated with the operation and the theme file. */
  readonly filename: Scalars['String'];
};

/** Type of a theme file operation result. */
export enum OnlineStoreThemeFileResultType {
  /** Operation was malformed or invalid. */
  BAD_REQUEST = 'BAD_REQUEST',
  /** Operation faced a conflict with the current state of the file. */
  CONFLICT = 'CONFLICT',
  /** Operation encountered an error. */
  ERROR = 'ERROR',
  /** Operation file could not be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** Operation was successful. */
  SUCCESS = 'SUCCESS',
  /** Operation timed out. */
  TIMEOUT = 'TIMEOUT',
  /** Operation could not be processed due to issues with input data. */
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY'
}

/** The input fields for the file to create or update. */
export type OnlineStoreThemeFilesUpsertFileInput = {
  /** The body of the theme file. */
  readonly body: OnlineStoreThemeFileBodyInput;
  /** The filename of the theme file. */
  readonly filename: Scalars['String'];
};

/** User errors for theme file operations. */
export type OnlineStoreThemeFilesUserErrors = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OnlineStoreThemeFilesUserErrorsCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The filename of the theme file. */
  readonly filename?: Maybe<Scalars['String']>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OnlineStoreThemeFilesUserErrors`. */
export enum OnlineStoreThemeFilesUserErrorsCode {
  /** Access denied. */
  ACCESS_DENIED = 'ACCESS_DENIED',
  /** There are files with the same filename. */
  DUPLICATE_FILE_INPUT = 'DUPLICATE_FILE_INPUT',
  /** Error. */
  ERROR = 'ERROR',
  /** The file is invalid. */
  FILE_VALIDATION_ERROR = 'FILE_VALIDATION_ERROR',
  /** The input value should be less than or equal to the maximum value allowed. */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** There are theme files with conflicts. */
  THEME_FILES_CONFLICT = 'THEME_FILES_CONFLICT',
  /** This action is not available on your current plan. Please upgrade to access theme editing features. */
  THEME_LIMITED_PLAN = 'THEME_LIMITED_PLAN',
  /** Too many updates in a short period. Please try again later. */
  THROTTLED = 'THROTTLED'
}

/** The input fields for Theme attributes to update. */
export type OnlineStoreThemeInput = {
  /** The new name of the theme. */
  readonly name?: InputMaybe<Scalars['String']>;
};

/** The input fields for the options and values of the combined listing. */
export type OptionAndValueInput = {
  /** The linked metafield for the product's option. */
  readonly linkedMetafield?: InputMaybe<LinkedMetafieldInput>;
  /** The name of the Product's Option. */
  readonly name: Scalars['String'];
  /** The ID of the option to update. If not present, the option will be created. */
  readonly optionId?: InputMaybe<Scalars['ID']>;
  /** The ordered values of the Product's Option. */
  readonly values: ReadonlyArray<Scalars['String']>;
};

/** The input fields for creating a product option. */
export type OptionCreateInput = {
  /** Specifies the metafield the option is linked to. */
  readonly linkedMetafield?: InputMaybe<LinkedMetafieldCreateInput>;
  /** Name of the option. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Position of the option. */
  readonly position?: InputMaybe<Scalars['Int']>;
  /** Values associated with the option. */
  readonly values?: InputMaybe<ReadonlyArray<OptionValueCreateInput>>;
};

/** The input fields for reordering a product option and/or its values. */
export type OptionReorderInput = {
  /** Specifies the product option to reorder by ID. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** Specifies the product option to reorder by name. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Values associated with the option. */
  readonly values?: InputMaybe<ReadonlyArray<OptionValueReorderInput>>;
};

/** The input fields for creating or updating a product option. */
export type OptionSetInput = {
  /** Specifies the product option to update. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** Specifies the metafield the option is linked to. */
  readonly linkedMetafield?: InputMaybe<LinkedMetafieldCreateInput>;
  /** Name of the option. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Position of the option. */
  readonly position?: InputMaybe<Scalars['Int']>;
  /** Value associated with an option. */
  readonly values?: InputMaybe<ReadonlyArray<OptionValueSetInput>>;
};

/** The input fields for updating a product option. */
export type OptionUpdateInput = {
  /** Specifies the product option to update. */
  readonly id: Scalars['ID'];
  /** Specifies the metafield the option is linked to. */
  readonly linkedMetafield?: InputMaybe<LinkedMetafieldUpdateInput>;
  /** Name of the option. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Position of the option. */
  readonly position?: InputMaybe<Scalars['Int']>;
};

/** The input fields required to create a product option value. */
export type OptionValueCreateInput = {
  /** Metafield value associated with an option. */
  readonly linkedMetafieldValue?: InputMaybe<Scalars['String']>;
  /** Value associated with an option. */
  readonly name?: InputMaybe<Scalars['String']>;
};

/** The input fields for reordering a product option value. */
export type OptionValueReorderInput = {
  /** Specifies the product option value by ID. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** Specifies the product option value by name. */
  readonly name?: InputMaybe<Scalars['String']>;
};

/** The input fields for creating or updating a product option value. */
export type OptionValueSetInput = {
  /** Specifies the product option value. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** Value associated with an option. */
  readonly name?: InputMaybe<Scalars['String']>;
};

/** The input fields for updating a product option value. */
export type OptionValueUpdateInput = {
  /** Specifies the product option value. */
  readonly id: Scalars['ID'];
  /** Metafield value associated with an option. */
  readonly linkedMetafieldValue?: InputMaybe<Scalars['String']>;
  /** Value associated with an option. */
  readonly name?: InputMaybe<Scalars['String']>;
};

/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type Order = CommentEventSubject & HasEvents & HasLocalizationExtensions & HasMetafieldDefinitions & HasMetafields & LegacyInteroperability & Node & {
  /** A list of additional fees applied to the order. */
  readonly additionalFees: ReadonlyArray<AdditionalFee>;
  /** A list of sales agreements associated with the order. */
  readonly agreements: SalesAgreementConnection;
  /** A list of messages that appear on the order page in the Shopify admin. */
  readonly alerts: ReadonlyArray<ResourceAlert>;
  /** The application that created the order. */
  readonly app?: Maybe<OrderApp>;
  /** The billing address of the customer. */
  readonly billingAddress?: Maybe<MailingAddress>;
  /** Whether the billing address matches the shipping address. */
  readonly billingAddressMatchesShippingAddress: Scalars['Boolean'];
  /** Whether the order can be manually marked as paid. */
  readonly canMarkAsPaid: Scalars['Boolean'];
  /** Whether a customer email exists for the order. */
  readonly canNotifyCustomer: Scalars['Boolean'];
  /**
   * The reason provided when the order was canceled.
   * Returns `null` if the order wasn't canceled.
   */
  readonly cancelReason?: Maybe<OrderCancelReason>;
  /** Cancellation details for the order. */
  readonly cancellation?: Maybe<OrderCancellation>;
  /**
   * The date and time when the order was canceled.
   * Returns `null` if the order wasn't canceled.
   */
  readonly cancelledAt?: Maybe<Scalars['DateTime']>;
  /** Whether payment for the order can be captured. */
  readonly capturable: Scalars['Boolean'];
  /**
   * The total order-level discount amount, before returns, in shop currency.
   * @deprecated Use `cartDiscountAmountSet` instead.
   */
  readonly cartDiscountAmount?: Maybe<Scalars['Money']>;
  /** The total order-level discount amount, before returns, in shop and presentment currencies. */
  readonly cartDiscountAmountSet?: Maybe<MoneyBag>;
  /**
   * The channel that created the order.
   * @deprecated Use `publication` instead.
   */
  readonly channel?: Maybe<Channel>;
  /** Details about the channel that created the order. */
  readonly channelInformation?: Maybe<ChannelInformation>;
  /** The IP address of the API client that created the order. */
  readonly clientIp?: Maybe<Scalars['String']>;
  /** Whether the order is closed. */
  readonly closed: Scalars['Boolean'];
  /**
   * The date and time when the order was closed.
   * Returns `null` if the order isn't closed.
   */
  readonly closedAt?: Maybe<Scalars['DateTime']>;
  /**
   * A randomly generated alpha-numeric identifier for the order that may be shown to the customer
   * instead of the sequential order name. For example, "XPAV284CT", "R50KELTJP" or "35PKUN0UJ".
   * This value isn't guaranteed to be unique.
   */
  readonly confirmationNumber?: Maybe<Scalars['String']>;
  /** Whether inventory has been reserved for the order. */
  readonly confirmed: Scalars['Boolean'];
  /** Date and time when the order was created in Shopify. */
  readonly createdAt: Scalars['DateTime'];
  /** The shop currency when the order was placed. */
  readonly currencyCode: CurrencyCode;
  /** The current order-level discount amount after all order updates, in shop and presentment currencies. */
  readonly currentCartDiscountAmountSet: MoneyBag;
  /** The current shipping price after applying refunds and discounts. If the parent `order.taxesIncluded` field is true, then this price includes taxes. Otherwise, this field is the pre-tax price. */
  readonly currentShippingPriceSet: MoneyBag;
  /** The sum of the quantities for all line items that contribute to the order's current subtotal price. */
  readonly currentSubtotalLineItemsQuantity: Scalars['Int'];
  /**
   * The sum of the prices for all line items after discounts and returns, in shop and presentment currencies.
   * If `taxesIncluded` is `true`, then the subtotal also includes tax.
   */
  readonly currentSubtotalPriceSet: MoneyBag;
  /**
   * A list of all tax lines applied to line items on the order, after returns.
   * Tax line prices represent the total price for all tax lines with the same `rate` and `title`.
   */
  readonly currentTaxLines: ReadonlyArray<TaxLine>;
  /**
   * The total amount of additional fees after returns, in shop and presentment currencies.
   * Returns `null` if there are no additional fees for the order.
   */
  readonly currentTotalAdditionalFeesSet?: Maybe<MoneyBag>;
  /**
   * The total amount discounted on the order after returns, in shop and presentment currencies.
   * This includes both order and line level discounts.
   */
  readonly currentTotalDiscountsSet: MoneyBag;
  /**
   * The total amount of duties after returns, in shop and presentment currencies.
   * Returns `null` if duties aren't applicable.
   */
  readonly currentTotalDutiesSet?: Maybe<MoneyBag>;
  /**
   * The total price of the order, after returns, in shop and presentment currencies.
   * This includes taxes and discounts.
   */
  readonly currentTotalPriceSet: MoneyBag;
  /** The sum of the prices of all tax lines applied to line items on the order, after returns, in shop and presentment currencies. */
  readonly currentTotalTaxSet: MoneyBag;
  /** The total weight of the order after returns, in grams. */
  readonly currentTotalWeight: Scalars['UnsignedInt64'];
  /** A list of additional merchant-facing details that have been added to the order. For example, whether an order is a customer's first. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The customer that placed the order. */
  readonly customer?: Maybe<Customer>;
  /** Whether the customer agreed to receive marketing materials. */
  readonly customerAcceptsMarketing: Scalars['Boolean'];
  /**
   * The customer's visits and interactions with the online store before placing the order.
   * @deprecated Use `customerJourneySummary` instead.
   */
  readonly customerJourney?: Maybe<CustomerJourney>;
  /** The customer's visits and interactions with the online store before placing the order. */
  readonly customerJourneySummary?: Maybe<CustomerJourneySummary>;
  /** A two-letter or three-letter language code, optionally followed by a region modifier. */
  readonly customerLocale?: Maybe<Scalars['String']>;
  /** A list of discounts that are applied to the order, not including order edits and refunds. */
  readonly discountApplications: DiscountApplicationConnection;
  /** The discount code used for the order. */
  readonly discountCode?: Maybe<Scalars['String']>;
  /** The discount codes used for the order. */
  readonly discountCodes: ReadonlyArray<Scalars['String']>;
  /**
   * The primary address of the customer.
   * Returns `null` if neither the shipping address nor the billing address was provided.
   */
  readonly displayAddress?: Maybe<MailingAddress>;
  /**
   * The financial status of the order that can be shown to the merchant.
   * This field doesn't capture all the details of an order's financial state. It should only be used for display summary purposes.
   */
  readonly displayFinancialStatus?: Maybe<OrderDisplayFinancialStatus>;
  /**
   * The fulfillment status for the order that can be shown to the merchant.
   * This field does not capture all the details of an order's fulfillment state. It should only be used for display summary purposes.
   * For a more granular view of the fulfillment status, refer to the [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder) object.
   */
  readonly displayFulfillmentStatus: OrderDisplayFulfillmentStatus;
  /** A list of the disputes associated with the order. */
  readonly disputes: ReadonlyArray<OrderDisputeSummary>;
  /** Whether duties are included in the subtotal price of the order. */
  readonly dutiesIncluded: Scalars['Boolean'];
  /** Whether the order has had any edits applied. */
  readonly edited: Scalars['Boolean'];
  /** The email address associated with the customer. */
  readonly email?: Maybe<Scalars['String']>;
  /**
   * Whether taxes on the order are estimated.
   * This field returns `false` when taxes on the order are finalized and aren't subject to any changes.
   */
  readonly estimatedTaxes: Scalars['Boolean'];
  /** A list of events associated with the order. */
  readonly events: EventConnection;
  /**
   * A list of ExchangeV2s for the order.
   * @deprecated Use `returns` instead.
   */
  readonly exchangeV2s: ExchangeV2Connection;
  /**
   * Whether there are line items that can be fulfilled.
   * This field returns `false` when the order has no fulfillable line items.
   * For a more granular view of the fulfillment status, refer to the [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder) object.
   */
  readonly fulfillable: Scalars['Boolean'];
  /**
   * A list of fulfillment orders for a specific order.
   *
   * [FulfillmentOrder API access scopes](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder#api-access-scopes)
   * govern which fulfillments orders are returned.
   * An API client will only receive a subset of the fulfillment orders which belong to an order
   * if they don't have the necessary access scopes to view all of the fulfillment orders.
   * In the case that an API client does not have the access scopes necessary to view
   * any of the fulfillment orders that belong to an order, an empty array will be returned.
   */
  readonly fulfillmentOrders: FulfillmentOrderConnection;
  /** List of shipments for the order. */
  readonly fulfillments: ReadonlyArray<Fulfillment>;
  /** The count of fulfillments including the cancelled fulfillments. */
  readonly fulfillmentsCount?: Maybe<Count>;
  /** Whether the order has been paid in full. */
  readonly fullyPaid: Scalars['Boolean'];
  /** Whether the merchant added a timeline comment to the order. */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The URL of the first page of the online store that the customer visited before they submitted the order.
   * @deprecated Use `customerJourneySummary.lastVisit.landingPageHtml` instead
   */
  readonly landingPageDisplayText?: Maybe<Scalars['String']>;
  /**
   * The first page of the online store that the customer visited before they submitted the order.
   * @deprecated Use `customerJourneySummary.lastVisit.landingPage` instead
   */
  readonly landingPageUrl?: Maybe<Scalars['URL']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** A list of the order's line items. */
  readonly lineItems: LineItemConnection;
  /**
   * List of localization extensions for the resource.
   * @deprecated This connection will be removed in a future version. Use `localizedFields` instead.
   */
  readonly localizationExtensions: LocalizationExtensionConnection;
  /** The merchant's business entity associated with the order. */
  readonly merchantBusinessEntity: BusinessEntity;
  /** Whether the order can be edited by the merchant. For example, canceled orders can’t be edited. */
  readonly merchantEditable: Scalars['Boolean'];
  /** A list of reasons why the order can't be edited. For example, "Canceled orders can't be edited". */
  readonly merchantEditableErrors: ReadonlyArray<Scalars['String']>;
  /** The application acting as the Merchant of Record for the order. */
  readonly merchantOfRecordApp?: Maybe<OrderApp>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * The unique identifier for the order that appears on the order page in the Shopify admin and the <b>Order status</b> page.
   * For example, "#1001", "EN1001", or "1001-A".
   * This value isn't unique across multiple stores.
   */
  readonly name: Scalars['String'];
  /**
   * The net payment for the order, based on the total amount received minus the total amount refunded, in shop currency.
   * @deprecated Use `netPaymentSet` instead.
   */
  readonly netPayment: Scalars['Money'];
  /** The net payment for the order, based on the total amount received minus the total amount refunded, in shop and presentment currencies. */
  readonly netPaymentSet: MoneyBag;
  /**
   * A list of line items that can't be fulfilled.
   * For example, tips and fully refunded line items can't be fulfilled.
   * For a more granular view of the fulfillment status, refer to the [FulfillmentOrder](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentOrder) object.
   */
  readonly nonFulfillableLineItems: LineItemConnection;
  /** The contents of the note associated with the order. */
  readonly note?: Maybe<Scalars['String']>;
  /**
   * The total amount of additional fees at the time of order creation, in shop and presentment currencies.
   * Returns `null` if additional fees aren't applicable.
   */
  readonly originalTotalAdditionalFeesSet?: Maybe<MoneyBag>;
  /**
   * The total amount of duties at the time of order creation, in shop and presentment currencies.
   * Returns `null` if duties aren't applicable.
   */
  readonly originalTotalDutiesSet?: Maybe<MoneyBag>;
  /** The total price of the order at the time of order creation, in shop and presentment currencies. */
  readonly originalTotalPriceSet: MoneyBag;
  /** The payment collection details for the order. */
  readonly paymentCollectionDetails: OrderPaymentCollectionDetails;
  /**
   * A list of the names of all payment gateways used for the order.
   * For example, "Shopify Payments" and "Cash on Delivery (COD)".
   */
  readonly paymentGatewayNames: ReadonlyArray<Scalars['String']>;
  /** The payment terms associated with the order. */
  readonly paymentTerms?: Maybe<PaymentTerms>;
  /** The phone number associated with the customer. */
  readonly phone?: Maybe<Scalars['String']>;
  /**
   * The fulfillment location that was assigned when the order was created.
   * Orders can have multiple fulfillment orders. These fulfillment orders can each be assigned to a different location which is responsible for fulfilling a subset of the items in an order. The `Order.physicalLocation` field will only point to one of these locations.
   * Use the [`FulfillmentOrder`](https://shopify.dev/api/admin-graphql/latest/objects/fulfillmentorder)
   * object for up to date fulfillment location information.
   * @deprecated Use `fulfillmentOrders` to get the fulfillment location for the order
   */
  readonly physicalLocation?: Maybe<Location>;
  /** The PO number associated with the order. */
  readonly poNumber?: Maybe<Scalars['String']>;
  /** The payment `CurrencyCode` of the customer for the order. */
  readonly presentmentCurrencyCode: CurrencyCode;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /**
   * The date and time when the order was processed.
   * This date and time might not match the date and time when the order was created.
   */
  readonly processedAt: Scalars['DateTime'];
  /** The publication that the order was created from. */
  readonly publication?: Maybe<Publication>;
  /** The purchasing entity for the order. */
  readonly purchasingEntity?: Maybe<PurchasingEntity>;
  /**
   * The marketing referral code from the link that the customer clicked to visit the store.
   * Supports the following URL attributes: "ref", "source", or "r".
   * For example, if the URL is `{shop}.myshopify.com/products/slide?ref=j2tj1tn2`, then this value is `j2tj1tn2`.
   * @deprecated Use `customerJourneySummary.lastVisit.referralCode` instead
   */
  readonly referralCode?: Maybe<Scalars['String']>;
  /**
   * A web domain or short description of the source that sent the customer to your online store. For example, "shopify.com" or "email".
   * @deprecated Use `customerJourneySummary.lastVisit.referralInfoHtml` instead
   */
  readonly referrerDisplayText?: Maybe<Scalars['String']>;
  /**
   * The URL of the webpage where the customer clicked a link that sent them to your online store.
   * @deprecated Use `customerJourneySummary.lastVisit.referrerUrl` instead
   */
  readonly referrerUrl?: Maybe<Scalars['URL']>;
  /** The difference between the suggested and actual refund amount of all refunds that have been applied to the order. A positive value indicates a difference in the merchant's favor, and a negative value indicates a difference in the customer's favor. */
  readonly refundDiscrepancySet: MoneyBag;
  /** Whether the order can be refunded. */
  readonly refundable: Scalars['Boolean'];
  /** A list of refunds that have been applied to the order. */
  readonly refunds: ReadonlyArray<Refund>;
  /** The URL of the source that the order originated from, if found in the domain registry. */
  readonly registeredSourceUrl?: Maybe<Scalars['URL']>;
  /** Whether the order has shipping lines or at least one line item on the order that requires shipping. */
  readonly requiresShipping: Scalars['Boolean'];
  /** Whether any line item on the order can be restocked. */
  readonly restockable: Scalars['Boolean'];
  /** The physical location where a retail order is created or completed, except for draft POS orders completed via the “mark as paid” flow in Admin, which return null. Transactions associated with the order might have been processed at a different location. */
  readonly retailLocation?: Maybe<Location>;
  /** The order's aggregated return status for display purposes. */
  readonly returnStatus: OrderReturnStatus;
  /** A list of returns for the order. */
  readonly returns: ReturnConnection;
  /** The risk characteristics for the order. */
  readonly risk: OrderRiskSummary;
  /**
   * The fraud risk level of the order.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment.riskLevel which allows for more granular risk levels, including PENDING and NONE.
   */
  readonly riskLevel: OrderRiskLevel;
  /**
   * A list of risks associated with the order.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment, which provides enhanced capabilities such as distinguishing risks from their provider.
   */
  readonly risks: ReadonlyArray<OrderRisk>;
  /** The mailing address of the customer. */
  readonly shippingAddress?: Maybe<MailingAddress>;
  /** A summary of all shipping costs on the order. */
  readonly shippingLine?: Maybe<ShippingLine>;
  /** A list of the order's shipping lines. */
  readonly shippingLines: ShippingLineConnection;
  /** The Shopify Protect details for the order. If Shopify Protect is disabled for the shop, then this will be null. */
  readonly shopifyProtect?: Maybe<ShopifyProtectOrderSummary>;
  /**
   * A unique POS or third party order identifier.
   * For example, "1234-12-1000" or "111-98567-54". The `receipt_number` field is derived from this value for POS orders.
   */
  readonly sourceIdentifier?: Maybe<Scalars['String']>;
  /** The name of the source associated with the order. */
  readonly sourceName?: Maybe<Scalars['String']>;
  /** The staff member associated with the order. */
  readonly staffMember?: Maybe<StaffMember>;
  /** The URL where the customer can check the order's current status. */
  readonly statusPageUrl: Scalars['URL'];
  /** The sum of the quantities for all line items that contribute to the order's subtotal price. */
  readonly subtotalLineItemsQuantity: Scalars['Int'];
  /**
   * The sum of the prices for all line items after discounts and before returns, in shop currency.
   * If `taxesIncluded` is `true`, then the subtotal also includes tax.
   * @deprecated Use `subtotalPriceSet` instead.
   */
  readonly subtotalPrice?: Maybe<Scalars['Money']>;
  /**
   * The sum of the prices for all line items after discounts and before returns, in shop and presentment currencies.
   * If `taxesIncluded` is `true`, then the subtotal also includes tax.
   */
  readonly subtotalPriceSet?: Maybe<MoneyBag>;
  /** A suggested refund for the order. */
  readonly suggestedRefund?: Maybe<SuggestedRefund>;
  /**
   * A comma separated list of tags associated with the order. Updating `tags` overwrites
   * any existing tags that were previously added to the order. To add new tags without overwriting
   * existing tags, use the [tagsAdd](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  readonly tags: ReadonlyArray<Scalars['String']>;
  /** Whether taxes are exempt on the order. */
  readonly taxExempt: Scalars['Boolean'];
  /**
   * A list of all tax lines applied to line items on the order, before returns.
   * Tax line prices represent the total price for all tax lines with the same `rate` and `title`.
   */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Whether taxes are included in the subtotal price of the order. */
  readonly taxesIncluded: Scalars['Boolean'];
  /**
   * Whether the order is a test.
   * Test orders are made using the Shopify Bogus Gateway or a payment provider with test mode enabled.
   * A test order can't be converted into a real order and vice versa.
   */
  readonly test: Scalars['Boolean'];
  /**
   * The authorized amount that's uncaptured or undercaptured, in shop currency.
   * This amount isn't adjusted for returns.
   * @deprecated Use `totalCapturableSet` instead.
   */
  readonly totalCapturable: Scalars['Money'];
  /**
   * The authorized amount that's uncaptured or undercaptured, in shop and presentment currencies.
   * This amount isn't adjusted for returns.
   */
  readonly totalCapturableSet: MoneyBag;
  /** The total rounding adjustment applied to payments or refunds for an Order involving cash payments. Applies to some countries where cash transactions are rounded to the nearest currency denomination. */
  readonly totalCashRoundingAdjustment: CashRoundingAdjustment;
  /**
   * The total amount discounted on the order before returns, in shop currency.
   * This includes both order and line level discounts.
   * @deprecated Use `totalDiscountsSet` instead.
   */
  readonly totalDiscounts?: Maybe<Scalars['Money']>;
  /**
   * The total amount discounted on the order before returns, in shop and presentment currencies.
   * This includes both order and line level discounts.
   */
  readonly totalDiscountsSet?: Maybe<MoneyBag>;
  /**
   * The total amount not yet transacted for the order, in shop and presentment currencies.
   * A positive value indicates a difference in the merchant's favor (payment from customer to merchant) and a negative value indicates a difference in the customer's favor (refund from merchant to customer).
   */
  readonly totalOutstandingSet: MoneyBag;
  /**
   * The total price of the order, before returns, in shop currency.
   * This includes taxes and discounts.
   * @deprecated Use `totalPriceSet` instead.
   */
  readonly totalPrice: Scalars['Money'];
  /**
   * The total price of the order, before returns, in shop and presentment currencies.
   * This includes taxes and discounts.
   */
  readonly totalPriceSet: MoneyBag;
  /**
   * The total amount received from the customer before returns, in shop currency.
   * @deprecated Use `totalReceivedSet` instead.
   */
  readonly totalReceived: Scalars['Money'];
  /** The total amount received from the customer before returns, in shop and presentment currencies. */
  readonly totalReceivedSet: MoneyBag;
  /**
   * The total amount that was refunded, in shop currency.
   * @deprecated Use `totalRefundedSet` instead.
   */
  readonly totalRefunded: Scalars['Money'];
  /** The total amount that was refunded, in shop and presentment currencies. */
  readonly totalRefundedSet: MoneyBag;
  /** The total amount of shipping that was refunded, in shop and presentment currencies. */
  readonly totalRefundedShippingSet: MoneyBag;
  /**
   * The total shipping amount before discounts and returns, in shop currency.
   * @deprecated Use `totalShippingPriceSet` instead.
   */
  readonly totalShippingPrice: Scalars['Money'];
  /** The total shipping amount before discounts and returns, in shop and presentment currencies. */
  readonly totalShippingPriceSet: MoneyBag;
  /**
   * The total tax amount before returns, in shop currency.
   * @deprecated Use `totalTaxSet` instead.
   */
  readonly totalTax?: Maybe<Scalars['Money']>;
  /** The total tax amount before returns, in shop and presentment currencies. */
  readonly totalTaxSet?: Maybe<MoneyBag>;
  /**
   * The sum of all tip amounts for the order, in shop currency.
   * @deprecated Use `totalTipReceivedSet` instead.
   */
  readonly totalTipReceived: MoneyV2;
  /** The sum of all tip amounts for the order, in shop and presentment currencies. */
  readonly totalTipReceivedSet: MoneyBag;
  /** The total weight of the order before returns, in grams. */
  readonly totalWeight?: Maybe<Scalars['UnsignedInt64']>;
  /** A list of transactions associated with the order. */
  readonly transactions: ReadonlyArray<OrderTransaction>;
  /** The number of transactions associated with the order. */
  readonly transactionsCount?: Maybe<Count>;
  /** Whether no payments have been made for the order. */
  readonly unpaid: Scalars['Boolean'];
  /** The date and time when the order was modified last. */
  readonly updatedAt: Scalars['DateTime'];
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderAgreementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderDiscountApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderExchangeV2sArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  displayable?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderFulfillmentsArgs = {
  first?: InputMaybe<Scalars['Int']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderLocalizationExtensionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  countryCodes?: InputMaybe<ReadonlyArray<CountryCode>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  purposes?: InputMaybe<ReadonlyArray<LocalizationExtensionPurpose>>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderNonFulfillableLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderRefundsArgs = {
  first?: InputMaybe<Scalars['Int']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderReturnsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderRisksArgs = {
  first?: InputMaybe<Scalars['Int']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderShippingLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeRemovals?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderSuggestedRefundArgs = {
  refundDuties?: InputMaybe<ReadonlyArray<RefundDutyInput>>;
  refundLineItems?: InputMaybe<ReadonlyArray<RefundLineItemInput>>;
  refundShipping?: InputMaybe<Scalars['Boolean']>;
  shippingAmount?: InputMaybe<Scalars['Money']>;
  suggestFullRefund?: InputMaybe<Scalars['Boolean']>;
};


/**
 * An order is a customer's request to purchase one or more products from a shop. You can retrieve and update orders using the `Order` object.
 * Learn more about
 * [editing an existing order with the GraphQL Admin API](https://shopify.dev/apps/fulfillment/order-management-apps/order-editing).
 *
 * Only the last 60 days' worth of orders from a store are accessible from the `Order` object by default. If you want to access older orders,
 * then you need to [request access to all orders](https://shopify.dev/api/usage/access-scopes#orders-permissions). If your app is granted
 * access, then you can add the `read_all_orders` scope to your app along with `read_orders` or `write_orders`.
 * [Private apps](https://shopify.dev/apps/auth/basic-http) are not affected by this change and are automatically granted the scope.
 *
 * **Caution:** Only use this data if it's required for your app's functionality. Shopify will restrict [access to scopes](https://shopify.dev/api/usage/access-scopes) for apps that don't have a legitimate use for the associated data.
 */
export type OrderTransactionsArgs = {
  capturable?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  manuallyResolvable?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The possible order action types for a
 * [sales agreement](https://shopify.dev/api/admin-graphql/latest/interfaces/salesagreement).
 */
export enum OrderActionType {
  /** An order with a purchase or charge. */
  ORDER = 'ORDER',
  /** An edit to the order. */
  ORDER_EDIT = 'ORDER_EDIT',
  /** A refund on the order. */
  REFUND = 'REFUND',
  /** A return on the order. */
  RETURN = 'RETURN',
  /** An unknown agreement action. Represents new actions that may be added in future versions. */
  UNKNOWN = 'UNKNOWN'
}

/** An order adjustment accounts for the difference between a calculated and actual refund amount. */
export type OrderAdjustment = Node & {
  /** The amount of the order adjustment in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** An optional reason that explains a discrepancy between calculated and actual refund amounts. */
  readonly reason?: Maybe<OrderAdjustmentDiscrepancyReason>;
  /** The tax amount of the order adjustment in shop and presentment currencies. */
  readonly taxAmountSet: MoneyBag;
};

/** An auto-generated type for paginating through multiple OrderAdjustments. */
export type OrderAdjustmentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<OrderAdjustmentEdge>;
  /** A list of nodes that are contained in OrderAdjustmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<OrderAdjustment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Discrepancy reasons for order adjustments. */
export enum OrderAdjustmentDiscrepancyReason {
  /** The discrepancy reason is customer. */
  CUSTOMER = 'CUSTOMER',
  /** The discrepancy reason is damage. */
  DAMAGE = 'DAMAGE',
  /** The discrepancy reason is balance adjustment. */
  FULL_RETURN_BALANCING_ADJUSTMENT = 'FULL_RETURN_BALANCING_ADJUSTMENT',
  /** The discrepancy reason is pending refund. */
  PENDING_REFUND_DISCREPANCY = 'PENDING_REFUND_DISCREPANCY',
  /** The discrepancy reason is not one of the predefined reasons. */
  REFUND_DISCREPANCY = 'REFUND_DISCREPANCY',
  /** The discrepancy reason is restocking. */
  RESTOCK = 'RESTOCK'
}

/** An auto-generated type which holds one OrderAdjustment and a cursor during pagination. */
export type OrderAdjustmentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of OrderAdjustmentEdge. */
  readonly node: OrderAdjustment;
};

/** Discrepancy reasons for order adjustments. */
export enum OrderAdjustmentInputDiscrepancyReason {
  /** The discrepancy reason is customer. */
  CUSTOMER = 'CUSTOMER',
  /** The discrepancy reason is damage. */
  DAMAGE = 'DAMAGE',
  /** The discrepancy reason is not one of the predefined reasons. */
  OTHER = 'OTHER',
  /** The discrepancy reason is restocking. */
  RESTOCK = 'RESTOCK'
}

/** An agreement associated with an order placement. */
export type OrderAgreement = SalesAgreement & {
  /** The application that created the agreement. */
  readonly app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  readonly happenedAt: Scalars['DateTime'];
  /** The unique ID for the agreement. */
  readonly id: Scalars['ID'];
  /** The order associated with the agreement. */
  readonly order: Order;
  /** The reason the agremeent was created. */
  readonly reason: OrderActionType;
  /** The sales associated with the agreement. */
  readonly sales: SaleConnection;
  /** The staff member associated with the agreement. */
  readonly user?: Maybe<StaffMember>;
};


/** An agreement associated with an order placement. */
export type OrderAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The [application](https://shopify.dev/apps) that created the order. */
export type OrderApp = {
  /** The application icon. */
  readonly icon: Image;
  /** The application ID. */
  readonly id: Scalars['ID'];
  /** The name of the application. */
  readonly name: Scalars['String'];
};

/** Return type for `orderCancel` mutation. */
export type OrderCancelPayload = {
  /** The job that asynchronously cancels the order. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly orderCancelUserErrors: ReadonlyArray<OrderCancelUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `orderCancelUserErrors` instead.
   */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents the reason for the order's cancellation. */
export enum OrderCancelReason {
  /** The customer wanted to cancel the order. */
  CUSTOMER = 'CUSTOMER',
  /** Payment was declined. */
  DECLINED = 'DECLINED',
  /** The order was fraudulent. */
  FRAUD = 'FRAUD',
  /** There was insufficient inventory. */
  INVENTORY = 'INVENTORY',
  /** The order was canceled for an unlisted reason. */
  OTHER = 'OTHER',
  /** Staff made an error. */
  STAFF = 'STAFF'
}

/** Errors related to order cancellation. */
export type OrderCancelUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderCancelUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderCancelUserError`. */
export enum OrderCancelUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** An order refund was requested but the user does not have the refund_orders permission. */
  NO_REFUND_PERMISSION = 'NO_REFUND_PERMISSION'
}

/** Details about the order cancellation. */
export type OrderCancellation = {
  /** Staff provided note for the order cancellation. */
  readonly staffNote?: Maybe<Scalars['String']>;
};

/** The input fields for the authorized transaction to capture and the total amount to capture from it. */
export type OrderCaptureInput = {
  /** The amount to capture. The capture amount can't be greater than the amount of the authorized transaction. */
  readonly amount: Scalars['Money'];
  /** The currency (in ISO format) that's used to capture the order. This must be the presentment currency (the currency used by the customer) and is a required field for orders where the currency and presentment currency differ. */
  readonly currency?: InputMaybe<CurrencyCode>;
  /**
   * Indicates whether this is to be the final capture for the order transaction. Only applies to
   * Shopify Payments authorizations which are multi-capturable. If true, any uncaptured amount from the
   * authorization will be voided after the capture is completed. If false, the authorization will remain open
   * for future captures.
   *
   * For multi-capturable authorizations, this defaults to false if not provided. This field has no effect on
   * authorizations which aren't multi-capturable (can only be captured once), or on other types of
   * transactions.
   */
  readonly finalCapture?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the order to capture. */
  readonly id: Scalars['ID'];
  /** The ID of the authorized transaction to capture. */
  readonly parentTransactionId: Scalars['ID'];
};

/** Return type for `orderCapture` mutation. */
export type OrderCapturePayload = {
  /** The created capture transaction. */
  readonly transaction?: Maybe<OrderTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for specifying an open order to close. */
export type OrderCloseInput = {
  /** The ID of the order to close. */
  readonly id: Scalars['ID'];
};

/** Return type for `orderClose` mutation. */
export type OrderClosePayload = {
  /** The closed order. */
  readonly order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type for paginating through multiple Orders. */
export type OrderConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<OrderEdge>;
  /** A list of nodes that are contained in OrderEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Order>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for a note attribute for an order. */
export type OrderCreateCustomAttributeInput = {
  /** The key or name of the custom attribute. */
  readonly key: Scalars['String'];
  /** The value of the custom attribute. */
  readonly value: Scalars['String'];
};

/** The input fields for a discount code to apply to an order. Only one type of discount can be applied to an order. */
export type OrderCreateDiscountCodeInput = {
  /** A free shipping discount code applied to the shipping on an order. */
  readonly freeShippingDiscountCode?: InputMaybe<OrderCreateFreeShippingDiscountCodeAttributesInput>;
  /** A fixed amount discount code applied to the line items on the order. */
  readonly itemFixedDiscountCode?: InputMaybe<OrderCreateFixedDiscountCodeAttributesInput>;
  /** A percentage discount code applied to the line items on the order. */
  readonly itemPercentageDiscountCode?: InputMaybe<OrderCreatePercentageDiscountCodeAttributesInput>;
};

/** The status of payments associated with the order. Can only be set when the order is created. */
export enum OrderCreateFinancialStatus {
  /** The payments have been authorized. */
  AUTHORIZED = 'AUTHORIZED',
  /** The payments have been expired. */
  EXPIRED = 'EXPIRED',
  /** The payments have been paid. */
  PAID = 'PAID',
  /** The order has been partially paid. */
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  /** The payments have been partially refunded. */
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  /** The payments are pending. Payment might fail in this state. Check again to confirm whether the payments have been paid successfully. */
  PENDING = 'PENDING',
  /** The payments have been refunded. */
  REFUNDED = 'REFUNDED',
  /** The payments have been voided. */
  VOIDED = 'VOIDED'
}

/** The input fields for a fixed amount discount code to apply to an order. */
export type OrderCreateFixedDiscountCodeAttributesInput = {
  /** The amount that's deducted from the order total. When you create an order, this value is the monetary amount to deduct. */
  readonly amountSet?: InputMaybe<MoneyBagInput>;
  /** The discount code that was entered at checkout. */
  readonly code: Scalars['String'];
};

/** The input fields for a free shipping discount code to apply to an order. */
export type OrderCreateFreeShippingDiscountCodeAttributesInput = {
  /** The discount code that was entered at checkout. */
  readonly code: Scalars['String'];
};

/** The input fields for a fulfillment to create for an order. */
export type OrderCreateFulfillmentInput = {
  /** The ID of the location to fulfill the order from. */
  readonly locationId: Scalars['ID'];
  /** Whether the customer should be notified of changes with the fulfillment. */
  readonly notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  /** The address at which the fulfillment occurred. */
  readonly originAddress?: InputMaybe<FulfillmentOriginAddressInput>;
  /** The status of the shipment. */
  readonly shipmentStatus?: InputMaybe<FulfillmentEventStatus>;
  /**
   * The name of the tracking company.
   *
   * If you specify a tracking company name from
   * [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies),
   * Shopify will automatically build tracking URLs for all provided tracking numbers,
   * which will make the tracking numbers clickable in the interface.
   * The same tracking company will be applied to all tracking numbers specified.
   *
   * Additionally, for the tracking companies listed on the
   * [Shipping Carriers help page](https://help.shopify.com/manual/shipping/understanding-shipping/shipping-carriers#integrated-shipping-carriers)
   * Shopify will automatically update the fulfillment's `shipment_status` field during the fulfillment process.
   *
   * > Note:
   * > Send the tracking company name exactly as written in
   * > [the list](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   * > (capitalization matters).
   */
  readonly trackingCompany?: InputMaybe<Scalars['String']>;
  /**
   * The tracking number of the fulfillment.
   *
   * The tracking number will be clickable in the interface if one of the following applies
   * (the highest in the list has the highest priority):
   *
   * * [Shopify-known tracking company name](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentTrackingInfo#supported-tracking-companies)
   *   specified in the `company` field.
   *   Shopify will build the tracking URL automatically based on the tracking number specified.
   * * The tracking number has a Shopify-known format.
   *   Shopify will guess the tracking provider and build the tracking url based on the tracking number format.
   *   Not all tracking carriers are supported, and multiple tracking carriers may use similarly formatted tracking numbers.
   *   This can result in an invalid tracking URL.
   */
  readonly trackingNumber?: InputMaybe<Scalars['String']>;
};

/** The order's status in terms of fulfilled line items. */
export enum OrderCreateFulfillmentStatus {
  /** Every line item in the order has been fulfilled. */
  FULFILLED = 'FULFILLED',
  /** At least one line item in the order has been fulfilled. */
  PARTIAL = 'PARTIAL',
  /** Every line item in the order has been restocked and the order canceled. */
  RESTOCKED = 'RESTOCKED'
}

/** The types of behavior to use when updating inventory. */
export enum OrderCreateInputsInventoryBehavior {
  /** Do not claim inventory. */
  BYPASS = 'BYPASS',
  /** Ignore the product's inventory policy and claim inventory. */
  DECREMENT_IGNORING_POLICY = 'DECREMENT_IGNORING_POLICY',
  /** Follow the product's inventory policy and claim inventory, if possible. */
  DECREMENT_OBEYING_POLICY = 'DECREMENT_OBEYING_POLICY'
}

/** The input fields for a line item to create for an order. */
export type OrderCreateLineItemInput = {
  /**
   * The handle of a fulfillment service that stocks the product variant belonging to a line item.
   *
   *               This is a third-party fulfillment service in the following scenarios:
   *
   *               **Scenario 1**
   *               - The product variant is stocked by a single fulfillment service.
   *               - The [FulfillmentService](/api/admin-graphql/latest/objects/FulfillmentService) is a third-party fulfillment service. Third-party fulfillment services don't have a handle with the value `manual`.
   *
   *               **Scenario 2**
   *               - Multiple fulfillment services stock the product variant.
   *               - The last time that the line item was unfulfilled, it was awaiting fulfillment by a third-party fulfillment service. Third-party fulfillment services don't have a handle with the value `manual`.
   *
   *               If none of the above conditions are met, then the fulfillment service has the `manual` handle.
   */
  readonly fulfillmentService?: InputMaybe<Scalars['String']>;
  /** Whether the item is a gift card. If true, then the item is not taxed or considered for shipping charges. */
  readonly giftCard?: InputMaybe<Scalars['Boolean']>;
  /** The price of the item before discounts have been applied in the shop currency. */
  readonly priceSet?: InputMaybe<MoneyBagInput>;
  /** The ID of the product that the line item belongs to. Can be `null` if the original product associated with the order is deleted at a later date. */
  readonly productId?: InputMaybe<Scalars['ID']>;
  /** An array of custom information for the item that has been added to the cart. Often used to provide product customization options. */
  readonly properties?: InputMaybe<ReadonlyArray<OrderCreateLineItemPropertyInput>>;
  /** The number of items that were purchased. */
  readonly quantity: Scalars['Int'];
  /** Whether the item requires shipping. */
  readonly requiresShipping?: InputMaybe<Scalars['Boolean']>;
  /** The item's SKU (stock keeping unit). */
  readonly sku?: InputMaybe<Scalars['String']>;
  /** A list of tax line objects, each of which details a tax applied to the item. */
  readonly taxLines?: InputMaybe<ReadonlyArray<OrderCreateTaxLineInput>>;
  /** Whether the item was taxable. */
  readonly taxable?: InputMaybe<Scalars['Boolean']>;
  /** The title of the product. */
  readonly title?: InputMaybe<Scalars['String']>;
  /** The ID of the product variant. If both `productId` and `variantId` are provided, then the product ID that corresponds to the `variantId` is used. */
  readonly variantId?: InputMaybe<Scalars['ID']>;
  /** The title of the product variant. */
  readonly variantTitle?: InputMaybe<Scalars['String']>;
  /** The name of the item's supplier. */
  readonly vendor?: InputMaybe<Scalars['String']>;
};

/** The input fields for a line item property for an order. */
export type OrderCreateLineItemPropertyInput = {
  /** The name of the line item property. */
  readonly name: Scalars['String'];
  /** The value of the line item property. */
  readonly value: Scalars['String'];
};

/** Return type for `orderCreateMandatePayment` mutation. */
export type OrderCreateMandatePaymentPayload = {
  /** The async job used for charging the payment. */
  readonly job?: Maybe<Job>;
  /** The Unique ID for the created payment. */
  readonly paymentReferenceId?: Maybe<Scalars['String']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderCreateMandatePaymentUserError>;
};

/** An error that occurs during the execution of `OrderCreateMandatePayment`. */
export type OrderCreateMandatePaymentUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderCreateMandatePaymentUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderCreateMandatePaymentUserError`. */
export enum OrderCreateMandatePaymentUserErrorCode {
  /** Errors for mandate payment on order. */
  ORDER_MANDATE_PAYMENT_ERROR_CODE = 'ORDER_MANDATE_PAYMENT_ERROR_CODE'
}

/**
 * The input fields that define the strategies for updating inventory and
 * whether to send shipping and order confirmations to customers.
 */
export type OrderCreateOptionsInput = {
  /**
   * The strategy for handling updates to inventory: not claiming inventory, ignoring inventory policies,
   * or following policies when claiming inventory.
   */
  readonly inventoryBehaviour?: InputMaybe<OrderCreateInputsInventoryBehavior>;
  /** Whether to send a shipping confirmation to the customer. */
  readonly sendFulfillmentReceipt?: InputMaybe<Scalars['Boolean']>;
  /** Whether to send an order confirmation to the customer. */
  readonly sendReceipt?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields for creating an order. */
export type OrderCreateOrderInput = {
  /**
   * The mailing address associated with the payment method. This address is an optional field that won't be
   *                available on orders that don't require a payment method.
   *
   *               > Note:
   *               > If a customer is provided, this field or `shipping_address` (which has precedence) will be set as the
   *               > customer's default address. Additionally, if the provided customer is new or hasn't created an order yet
   *               > then their name will be set to the first/last name from this address (if provided).
   */
  readonly billingAddress?: InputMaybe<MailingAddressInput>;
  /** Whether the customer consented to receive email updates from the shop. */
  readonly buyerAcceptsMarketing?: InputMaybe<Scalars['Boolean']>;
  /** The date and time ([ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format) when the order was closed. Returns null if the order isn't closed. */
  readonly closedAt?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the purchasing company's location for the order. */
  readonly companyLocationId?: InputMaybe<Scalars['ID']>;
  /** The shop-facing currency for the order. If not specified, then the shop's default currency is used. */
  readonly currency?: InputMaybe<CurrencyCode>;
  /** A list of extra information that's added to the order. Appears in the **Additional details** section of an order details page. */
  readonly customAttributes?: InputMaybe<ReadonlyArray<OrderCreateCustomAttributeInput>>;
  /** A discount code applied to the order. */
  readonly discountCode?: InputMaybe<OrderCreateDiscountCodeInput>;
  /**
   * A new customer email address for the order.
   *
   *               > Note:
   *               > If a customer is provided, and no email is provided, the customer's email will be set to this field.
   */
  readonly email?: InputMaybe<Scalars['String']>;
  /** The financial status of the order. If not specified, then this will be derived through the given transactions. Note that it's possible to specify a status that doesn't match the given transactions and it will persist, but if an operation later occurs on the order, the status may then be recalculated to match the current state of transactions. */
  readonly financialStatus?: InputMaybe<OrderCreateFinancialStatus>;
  /** The fulfillment to create for the order. This will apply to all line items. */
  readonly fulfillment?: InputMaybe<OrderCreateFulfillmentInput>;
  /** The fulfillment status of the order. Will default to `unfulfilled` if not included. */
  readonly fulfillmentStatus?: InputMaybe<OrderCreateFulfillmentStatus>;
  /** The line items to create for the order. */
  readonly lineItems?: InputMaybe<ReadonlyArray<OrderCreateLineItemInput>>;
  /** A list of metafields to add to the order. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The order name, generated by combining the `order_number` property with the order prefix and suffix that are set in the merchant's [general settings](https://www.shopify.com/admin/settings/general). This is different from the `id` property, which is the ID of the order used by the API. This field can also be set by the API to be any string value. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The new contents for the note associated with the order. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** A new customer phone number for the order. */
  readonly phone?: InputMaybe<Scalars['String']>;
  /** The purchase order number associated to this order. */
  readonly poNumber?: InputMaybe<Scalars['String']>;
  /** The presentment currency that was used to display prices to the customer. This must be specified if any presentment currencies are used in the order. */
  readonly presentmentCurrency?: InputMaybe<CurrencyCode>;
  /** The date and time ([ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format) when an order was processed. This value is the date that appears on your orders and that's used in the analytic reports. If you're importing orders from an app or another platform, then you can set processed_at to a date and time in the past to match when the original order was created. */
  readonly processedAt?: InputMaybe<Scalars['DateTime']>;
  /** The website where the customer clicked a link to the shop. */
  readonly referringSite?: InputMaybe<Scalars['URL']>;
  /**
   * The mailing address to where the order will be shipped.
   *
   *               > Note:
   *               > If a customer is provided, this field (which has precedence) or `billing_address` will be set as the
   *               > customer's default address. Additionally, if the provided customer doesn't have a first or last name
   *               > then it will be set to the first/last name from this address (if provided).
   */
  readonly shippingAddress?: InputMaybe<MailingAddressInput>;
  /** An array of objects, each of which details a shipping method used. */
  readonly shippingLines?: InputMaybe<ReadonlyArray<OrderCreateShippingLineInput>>;
  /** The ID of the order placed on the originating platform. This value doesn't correspond to the Shopify ID that's generated from a completed draft. */
  readonly sourceIdentifier?: InputMaybe<Scalars['String']>;
  /** The source of the checkout. To use this field for sales attribution, you must register the channels that your app is managing. You can register the channels that your app is managing by completing [this Google Form](https://docs.google.com/forms/d/e/1FAIpQLScmVTZRQNjOJ7RD738mL1lGeFjqKVe_FM2tO9xsm21QEo5Ozg/viewform?usp=sf_link). After you've submited your request, you need to wait for your request to be processed by Shopify. You can find a list of your channels in the Partner Dashboard, in your app's Marketplace extension. You can specify a handle as the source_name value in your request. */
  readonly sourceName?: InputMaybe<Scalars['String']>;
  /** A valid URL to the original order on the originating surface. This URL is displayed to merchants on the Order Details page. If the URL is invalid, then it won't be displayed. */
  readonly sourceUrl?: InputMaybe<Scalars['URL']>;
  /** A comma separated list of tags that have been added to the draft order. */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** An array of tax line objects, each of which details a tax applicable to the order. When creating an order through the API, tax lines can be specified on the order or the line items but not both. Tax lines specified on the order are split across the _taxable_ line items in the created order. */
  readonly taxLines?: InputMaybe<ReadonlyArray<OrderCreateTaxLineInput>>;
  /** Whether taxes are included in the order subtotal. */
  readonly taxesIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Whether this is a test order. */
  readonly test?: InputMaybe<Scalars['Boolean']>;
  /** The payment transactions to create for the order. */
  readonly transactions?: InputMaybe<ReadonlyArray<OrderCreateOrderTransactionInput>>;
  /** The ID of the user logged into Shopify POS who processed the order, if applicable. */
  readonly userId?: InputMaybe<Scalars['ID']>;
};

/** The input fields for a transaction to create for an order. */
export type OrderCreateOrderTransactionInput = {
  /** The amount of the transaction. */
  readonly amountSet: MoneyBagInput;
  /** The authorization code associated with the transaction. */
  readonly authorizationCode?: InputMaybe<Scalars['String']>;
  /** The ID of the device used to process the transaction. */
  readonly deviceId?: InputMaybe<Scalars['ID']>;
  /** The name of the gateway the transaction was issued through. */
  readonly gateway?: InputMaybe<Scalars['String']>;
  /** The ID of the gift card used for this transaction. */
  readonly giftCardId?: InputMaybe<Scalars['ID']>;
  /** The kind of transaction. */
  readonly kind?: InputMaybe<OrderTransactionKind>;
  /** The ID of the location where the transaction was processed. */
  readonly locationId?: InputMaybe<Scalars['ID']>;
  /** The date and time when the transaction was processed. */
  readonly processedAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * The transaction receipt that the payment gateway attaches to the transaction.
   * The value of this field depends on which payment gateway processed the transaction.
   */
  readonly receiptJson?: InputMaybe<Scalars['JSON']>;
  /** The status of the transaction. */
  readonly status?: InputMaybe<OrderTransactionStatus>;
  /** Whether the transaction is a test transaction. */
  readonly test?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the user who processed the transaction. */
  readonly userId?: InputMaybe<Scalars['ID']>;
};

/** Return type for `orderCreate` mutation. */
export type OrderCreatePayload = {
  /** The order that was created. */
  readonly order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderCreateUserError>;
};

/** The input fields for a percentage discount code to apply to an order. */
export type OrderCreatePercentageDiscountCodeAttributesInput = {
  /** The discount code that was entered at checkout. */
  readonly code: Scalars['String'];
  /** The amount that's deducted from the order total. When you create an order, this value is the percentage to deduct. */
  readonly percentage?: InputMaybe<Scalars['Float']>;
};

/** The input fields for a shipping line to create for an order. */
export type OrderCreateShippingLineInput = {
  /** A reference to the shipping method. */
  readonly code?: InputMaybe<Scalars['String']>;
  /** The price of this shipping method in the shop currency. Can't be negative. */
  readonly priceSet: MoneyBagInput;
  /** The source of the shipping method. */
  readonly source?: InputMaybe<Scalars['String']>;
  /** A list of tax line objects, each of which details a tax applicable to this shipping line. */
  readonly taxLines?: InputMaybe<ReadonlyArray<OrderCreateTaxLineInput>>;
  /** The title of the shipping method. */
  readonly title: Scalars['String'];
};

/** The input fields for a tax line to create for an order. */
export type OrderCreateTaxLineInput = {
  /** Whether the channel that submitted the tax line is liable for remitting. A value of `null` indicates unknown liability for the tax line. */
  readonly channelLiable?: InputMaybe<Scalars['Boolean']>;
  /** The amount of tax to be charged on the item. */
  readonly priceSet?: InputMaybe<MoneyBagInput>;
  /** The proportion of the item price that the tax represents as a decimal. */
  readonly rate: Scalars['Decimal'];
  /** The name of the tax line to create. */
  readonly title: Scalars['String'];
};

/** An error that occurs during the execution of `OrderCreate`. */
export type OrderCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderCreateUserError`. */
export enum OrderCreateUserErrorCode {
  /** Indicates that the line item fulfillment service handle is invalid. */
  FULFILLMENT_SERVICE_INVALID = 'FULFILLMENT_SERVICE_INVALID',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Indicates that the inventory claim failed during order creation. */
  INVENTORY_CLAIM_FAILED = 'INVENTORY_CLAIM_FAILED',
  /** Indicates that the processed_at field is invalid, such as when it references a future date. */
  PROCESSED_AT_INVALID = 'PROCESSED_AT_INVALID',
  /** Indicates that both customer_id and customer were provided - only one is permitted. */
  REDUNDANT_CUSTOMER_FIELDS = 'REDUNDANT_CUSTOMER_FIELDS',
  /** Indicates that the shop is dormant and cannot create orders. */
  SHOP_DORMANT = 'SHOP_DORMANT',
  /** Indicates that the tax line rate is missing - only enforced for LineItem or ShippingLine-level tax lines. */
  TAX_LINE_RATE_MISSING = 'TAX_LINE_RATE_MISSING'
}

/** Return type for `orderDelete` mutation. */
export type OrderDeletePayload = {
  /** Deleted order ID. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderDeleteUserError>;
};

/** Errors related to deleting an order. */
export type OrderDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderDeleteUserError`. */
export enum OrderDeleteUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** Represents the order's current financial status. */
export enum OrderDisplayFinancialStatus {
  /** Displayed as **Authorized**. The payment provider has validated the customer's payment information. This status appears only for manual payment capture and indicates payments should be captured before the authorization period expires. */
  AUTHORIZED = 'AUTHORIZED',
  /** Displayed as **Expired**. Payment wasn't captured before the payment provider's deadline on an authorized order. Some payment providers use this status to indicate failed payment processing. */
  EXPIRED = 'EXPIRED',
  /** Displayed as **Paid**. Payment was automatically or manually captured, or the order was marked as paid. */
  PAID = 'PAID',
  /** Displayed as **Partially paid**. A payment was manually captured for the order with an amount less than the full order value. */
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  /** Displayed as **Partially refunded**. The amount refunded to a customer is less than the full amount paid for an order. */
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  /** Displayed as **Pending**. Orders have this status when the payment provider needs time to complete the payment, or when manual payment methods are being used. */
  PENDING = 'PENDING',
  /** Displayed as **Refunded**. The full amount paid for an order was refunded to the customer. */
  REFUNDED = 'REFUNDED',
  /**
   * Displayed as **Voided**. An unpaid (payment authorized but not captured) order was manually
   *          canceled.
   */
  VOIDED = 'VOIDED'
}

/** Represents the order's aggregated fulfillment status for display purposes. */
export enum OrderDisplayFulfillmentStatus {
  /** Displayed as **Fulfilled**. All the items in the order have been fulfilled. */
  FULFILLED = 'FULFILLED',
  /** Displayed as **In progress**. Some of the items in the order have been fulfilled, or a request for fulfillment has been sent to the fulfillment service. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Displayed as **On hold**. All of the unfulfilled items in this order are on hold. */
  ON_HOLD = 'ON_HOLD',
  /** Displayed as **Open**. None of the items in the order have been fulfilled. Replaced by "UNFULFILLED" status. */
  OPEN = 'OPEN',
  /** Displayed as **Partially fulfilled**. Some of the items in the order have been fulfilled. */
  PARTIALLY_FULFILLED = 'PARTIALLY_FULFILLED',
  /** Displayed as **Pending fulfillment**. A request for fulfillment of some items awaits a response from the fulfillment service. Replaced by the "IN_PROGRESS" status. */
  PENDING_FULFILLMENT = 'PENDING_FULFILLMENT',
  /** Displayed as **Request declined**. Some of the items in the order have been rejected for fulfillment by the fulfillment service. */
  REQUEST_DECLINED = 'REQUEST_DECLINED',
  /** Displayed as **Restocked**. All the items in the order have been restocked. Replaced by the "UNFULFILLED" status. */
  RESTOCKED = 'RESTOCKED',
  /** Displayed as **Scheduled**. All of the unfulfilled items in this order are scheduled for fulfillment at later time. */
  SCHEDULED = 'SCHEDULED',
  /** Displayed as **Unfulfilled**. None of the items in the order have been fulfilled. */
  UNFULFILLED = 'UNFULFILLED'
}

/** A summary of the important details for a dispute on an order. */
export type OrderDisputeSummary = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The type that the dispute was initiated as. */
  readonly initiatedAs: DisputeType;
  /** The current status of the dispute. */
  readonly status: DisputeStatus;
};

/** An auto-generated type which holds one Order and a cursor during pagination. */
export type OrderEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of OrderEdge. */
  readonly node: Order;
};

/** Return type for `orderEditAddCustomItem` mutation. */
export type OrderEditAddCustomItemPayload = {
  /** The custom line item that will be added to the order based on the current edits. */
  readonly calculatedLineItem?: Maybe<CalculatedLineItem>;
  /** An order with the edits applied but not saved. */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `orderEditAddLineItemDiscount` mutation. */
export type OrderEditAddLineItemDiscountPayload = {
  /** The discount applied to a line item during this order edit. */
  readonly addedDiscountStagedChange?: Maybe<OrderStagedChangeAddLineItemDiscount>;
  /** The line item with the edits applied but not saved. */
  readonly calculatedLineItem?: Maybe<CalculatedLineItem>;
  /** An order with the edits applied but not saved. */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields used to add a shipping line. */
export type OrderEditAddShippingLineInput = {
  /** The price of the shipping line. */
  readonly price: MoneyInput;
  /** The title of the shipping line. */
  readonly title: Scalars['String'];
};

/** Return type for `orderEditAddShippingLine` mutation. */
export type OrderEditAddShippingLinePayload = {
  /**
   * The [calculated order](https://shopify.dev/api/admin-graphql/latest/objects/calculatedorder)
   * with the edits applied but not saved.
   */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /**
   * The [calculated shipping line](https://shopify.dev/api/admin-graphql/latest/objects/calculatedshippingline)
   * that's added during this order edit.
   */
  readonly calculatedShippingLine?: Maybe<CalculatedShippingLine>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderEditAddShippingLineUserError>;
};

/** An error that occurs during the execution of `OrderEditAddShippingLine`. */
export type OrderEditAddShippingLineUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderEditAddShippingLineUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderEditAddShippingLineUserError`. */
export enum OrderEditAddShippingLineUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Return type for `orderEditAddVariant` mutation. */
export type OrderEditAddVariantPayload = {
  /**
   * The [calculated line item](https://shopify.dev/api/admin-graphql/latest/objects/calculatedlineitem)
   * that's added during this order edit.
   */
  readonly calculatedLineItem?: Maybe<CalculatedLineItem>;
  /**
   * The [calculated order](https://shopify.dev/api/admin-graphql/latest/objects/calculatedorder)
   * with the edits applied but not saved.
   */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An agreement associated with an edit to the order. */
export type OrderEditAgreement = SalesAgreement & {
  /** The application that created the agreement. */
  readonly app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  readonly happenedAt: Scalars['DateTime'];
  /** The unique ID for the agreement. */
  readonly id: Scalars['ID'];
  /** The reason the agremeent was created. */
  readonly reason: OrderActionType;
  /** The sales associated with the agreement. */
  readonly sales: SaleConnection;
  /** The staff member associated with the agreement. */
  readonly user?: Maybe<StaffMember>;
};


/** An agreement associated with an edit to the order. */
export type OrderEditAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields used to add a discount during an order edit. */
export type OrderEditAppliedDiscountInput = {
  /** The description of the discount. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** The value of the discount as a fixed amount. */
  readonly fixedValue?: InputMaybe<MoneyInput>;
  /** The value of the discount as a percentage. */
  readonly percentValue?: InputMaybe<Scalars['Float']>;
};

/** Return type for `orderEditBegin` mutation. */
export type OrderEditBeginPayload = {
  /** The order that will be edited. */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `orderEditCommit` mutation. */
export type OrderEditCommitPayload = {
  /** The order with changes applied. */
  readonly order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `orderEditRemoveDiscount` mutation. */
export type OrderEditRemoveDiscountPayload = {
  /** An order with the edits applied but not saved. */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderEditRemoveDiscountUserError>;
};

/** An error that occurs during the execution of `OrderEditRemoveDiscount`. */
export type OrderEditRemoveDiscountUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderEditRemoveDiscountUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderEditRemoveDiscountUserError`. */
export enum OrderEditRemoveDiscountUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Return type for `orderEditRemoveLineItemDiscount` mutation. */
export type OrderEditRemoveLineItemDiscountPayload = {
  /** The calculated line item after removal of the discount. */
  readonly calculatedLineItem?: Maybe<CalculatedLineItem>;
  /** An order with the edits applied but not saved. */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `orderEditRemoveShippingLine` mutation. */
export type OrderEditRemoveShippingLinePayload = {
  /**
   * The [calculated order](https://shopify.dev/api/admin-graphql/latest/objects/calculatedorder)
   * with the edits applied but not saved.
   */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderEditRemoveShippingLineUserError>;
};

/** An error that occurs during the execution of `OrderEditRemoveShippingLine`. */
export type OrderEditRemoveShippingLineUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderEditRemoveShippingLineUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderEditRemoveShippingLineUserError`. */
export enum OrderEditRemoveShippingLineUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Return type for `orderEditSetQuantity` mutation. */
export type OrderEditSetQuantityPayload = {
  /** The calculated line item with the edits applied but not saved. */
  readonly calculatedLineItem?: Maybe<CalculatedLineItem>;
  /** The calculated order with the edits applied but not saved. */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `orderEditUpdateDiscount` mutation. */
export type OrderEditUpdateDiscountPayload = {
  /** An order with the edits applied but not saved. */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderEditUpdateDiscountUserError>;
};

/** An error that occurs during the execution of `OrderEditUpdateDiscount`. */
export type OrderEditUpdateDiscountUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderEditUpdateDiscountUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderEditUpdateDiscountUserError`. */
export enum OrderEditUpdateDiscountUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** The input fields used to update a shipping line. */
export type OrderEditUpdateShippingLineInput = {
  /** The price of the shipping line. */
  readonly price?: InputMaybe<MoneyInput>;
  /** The title of the shipping line. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `orderEditUpdateShippingLine` mutation. */
export type OrderEditUpdateShippingLinePayload = {
  /** An order with the edits applied but not saved. */
  readonly calculatedOrder?: Maybe<CalculatedOrder>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderEditUpdateShippingLineUserError>;
};

/** An error that occurs during the execution of `OrderEditUpdateShippingLine`. */
export type OrderEditUpdateShippingLineUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderEditUpdateShippingLineUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderEditUpdateShippingLineUserError`. */
export enum OrderEditUpdateShippingLineUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** The input fields for specifying the information to be updated on an order when using the orderUpdate mutation. */
export type OrderInput = {
  /** A new list of custom attributes for the order. Overwrites the existing custom attributes. */
  readonly customAttributes?: InputMaybe<ReadonlyArray<AttributeInput>>;
  /** A new customer email address for the order. Overwrites the existing email address. */
  readonly email?: InputMaybe<Scalars['String']>;
  /** The ID of the order to update. */
  readonly id: Scalars['ID'];
  /** A list of new metafields to add to the existing metafields for the order. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The new contents for the note associated with the order. Overwrites the existing note. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The new purchase order number for the order. */
  readonly poNumber?: InputMaybe<Scalars['String']>;
  /** The new shipping address for the order. Overwrites the existing shipping address. */
  readonly shippingAddress?: InputMaybe<MailingAddressInput>;
  /** A new list of tags for the order. Overwrites the existing tags. */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

/** Return type for `orderInvoiceSend` mutation. */
export type OrderInvoiceSendPayload = {
  /** The order associated with the invoice email. */
  readonly order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderInvoiceSendUserError>;
};

/** An error that occurs during the execution of `OrderInvoiceSend`. */
export type OrderInvoiceSendUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderInvoiceSendUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderInvoiceSendUserError`. */
export enum OrderInvoiceSendUserErrorCode {
  /** An error occurred while sending the invoice. */
  ORDER_INVOICE_SEND_UNSUCCESSFUL = 'ORDER_INVOICE_SEND_UNSUCCESSFUL'
}

/** The input fields for specifying the order to mark as paid. */
export type OrderMarkAsPaidInput = {
  /** The ID of the order to mark as paid. */
  readonly id: Scalars['ID'];
};

/** Return type for `orderMarkAsPaid` mutation. */
export type OrderMarkAsPaidPayload = {
  /** The order marked as paid. */
  readonly order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for specifying a closed order to open. */
export type OrderOpenInput = {
  /** The ID of the order to open. */
  readonly id: Scalars['ID'];
};

/** Return type for `orderOpen` mutation. */
export type OrderOpenPayload = {
  /** The opened order. */
  readonly order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The payment collection details for an order that requires additional payment following an edit to the order. */
export type OrderPaymentCollectionDetails = {
  /** The URL to use for collecting an additional payment on the order. */
  readonly additionalPaymentCollectionUrl?: Maybe<Scalars['URL']>;
  /** The list of vaulted payment methods for the order with their permissions. */
  readonly vaultedPaymentMethods?: Maybe<ReadonlyArray<PaymentMandate>>;
};

/** The status of a customer's payment for an order. */
export type OrderPaymentStatus = {
  /** A message describing an error during the asynchronous processing of a payment. */
  readonly errorMessage?: Maybe<Scalars['String']>;
  /** The ID of the payment, initially returned by an `orderCreateMandatePayment` or `orderCreatePayment` mutation. */
  readonly paymentReferenceId: Scalars['String'];
  /** The status of the payment. */
  readonly status: OrderPaymentStatusResult;
  /** The transaction associated with the payment. */
  readonly transactions: ReadonlyArray<OrderTransaction>;
  /** A translated message describing an error during the asynchronous processing of a payment. */
  readonly translatedErrorMessage?: Maybe<Scalars['String']>;
};

/** The type of a payment status. */
export enum OrderPaymentStatusResult {
  /** The payment is authorized. */
  AUTHORIZED = 'AUTHORIZED',
  /** The payment is captured. */
  CAPTURED = 'CAPTURED',
  /** There was an error initiating the payment. */
  ERROR = 'ERROR',
  /** The payment is awaiting processing. */
  INITIATED = 'INITIATED',
  /** The payment is pending with the provider, and may take a while. */
  PENDING = 'PENDING',
  /** The payment is still being processed. */
  PROCESSING = 'PROCESSING',
  /** The payment is in purchased status. */
  PURCHASED = 'PURCHASED',
  /** Redirect required. */
  REDIRECT_REQUIRED = 'REDIRECT_REQUIRED',
  /** The payment is refunded. */
  REFUNDED = 'REFUNDED',
  /** Payment can be retried. */
  RETRYABLE = 'RETRYABLE',
  /** The payment succeeded. */
  SUCCESS = 'SUCCESS',
  /** Status is unknown. */
  UNKNOWN = 'UNKNOWN',
  /** The payment is voided. */
  VOIDED = 'VOIDED'
}

/**
 * The order's aggregated return status that's used for display purposes.
 * An order might have multiple returns, so this field communicates the prioritized return status.
 * The `OrderReturnStatus` enum is a supported filter parameter in the [`orders` query](https://shopify.dev/api/admin-graphql/latest/queries/orders#:~:text=reference_location_id-,return_status,-risk_level).
 */
export enum OrderReturnStatus {
  /** All return shipments from a return in this order were inspected. */
  INSPECTION_COMPLETE = 'INSPECTION_COMPLETE',
  /** Some items in the order are being returned. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** No items in the order were returned. */
  NO_RETURN = 'NO_RETURN',
  /** Some items in the order were returned. */
  RETURNED = 'RETURNED',
  /** Some returns in the order were not completed successfully. */
  RETURN_FAILED = 'RETURN_FAILED',
  /** A return was requested for some items in the order. */
  RETURN_REQUESTED = 'RETURN_REQUESTED'
}

/** Represents a fraud check on an order. This object is deprecated in favor of [OrderRiskAssessment](https://shopify.dev/api/admin-graphql/latest/objects/OrderRiskAssessment) and its enhanced capabilities. */
export type OrderRisk = {
  /**
   * Whether the risk level is shown in the Shopify admin. If false, then this order risk is ignored when Shopify determines the overall risk level for the order.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment.facts.
   */
  readonly display: Scalars['Boolean'];
  /**
   * The likelihood that an order is fraudulent, based on this order risk. The level can be set by Shopify risk analysis or by an app.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment.riskLevel which allows for more granular risk levels, including PENDING and NONE.
   */
  readonly level?: Maybe<OrderRiskLevel>;
  /**
   * The risk message that's shown to the merchant in the Shopify admin.
   * @deprecated This field is deprecated in favor of OrderRiskAssessment.facts.
   */
  readonly message?: Maybe<Scalars['String']>;
};

/**
 * The risk assessments for an order.
 *
 * See the [example query "Retrieves a list of all order risks for an order"](https://shopify.dev/docs/api/admin-graphql/unstable/queries/order?example=Retrieves+a+list+of+all+order+risks+for+an+order).
 */
export type OrderRiskAssessment = {
  /**
   * Optional facts used to describe the risk assessment. The values in here are specific to the provider.
   * See the [examples for the mutation orderRiskAssessmentCreate](https://shopify.dev/api/admin-graphql/unstable/mutations/orderRiskAssessmentCreate#section-examples).
   */
  readonly facts: ReadonlyArray<RiskFact>;
  /** The app that provided the assessment, `null` if the assessment was provided by Shopify. */
  readonly provider?: Maybe<App>;
  /** The likelihood that the order is fraudulent, based on this risk assessment. */
  readonly riskLevel: RiskAssessmentResult;
};

/** The input fields for an order risk assessment. */
export type OrderRiskAssessmentCreateInput = {
  /** The list of facts used to determine the fraud assessment. */
  readonly facts: ReadonlyArray<OrderRiskAssessmentFactInput>;
  /** The ID of the order receiving the fraud assessment. */
  readonly orderId: Scalars['ID'];
  /** The risk level of the fraud assessment. */
  readonly riskLevel: RiskAssessmentResult;
};

/** Return type for `orderRiskAssessmentCreate` mutation. */
export type OrderRiskAssessmentCreatePayload = {
  /** The order risk assessment created. */
  readonly orderRiskAssessment?: Maybe<OrderRiskAssessment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OrderRiskAssessmentCreateUserError>;
};

/** An error that occurs during the execution of `OrderRiskAssessmentCreate`. */
export type OrderRiskAssessmentCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<OrderRiskAssessmentCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `OrderRiskAssessmentCreateUserError`. */
export enum OrderRiskAssessmentCreateUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The order is marked as fulfilled and can no longer accept new risk assessments. */
  ORDER_ALREADY_FULFILLED = 'ORDER_ALREADY_FULFILLED',
  /** Too many facts were provided for the risk assessment. */
  TOO_MANY_FACTS = 'TOO_MANY_FACTS'
}

/** The input fields to create a fact on an order risk assessment. */
export type OrderRiskAssessmentFactInput = {
  /** A description of the fact. Large values are truncated to 256 characters. */
  readonly description: Scalars['String'];
  /** Indicates whether the fact is a negative, neutral or positive contributor with regards to risk. */
  readonly sentiment: RiskFactSentiment;
};

/**
 * The likelihood that an order is fraudulent.
 * This enum is deprecated in favor of
 * [RiskAssessmentResult](https://shopify.dev/api/admin-graphql/latest/enums/RiskAssessmentResult)
 * which allows for more granular risk levels, including PENDING and NONE.
 */
export enum OrderRiskLevel {
  /** There is a high level of risk that this order is fraudulent. */
  HIGH = 'HIGH',
  /** There is a low level of risk that this order is fraudulent. */
  LOW = 'LOW',
  /** There is a medium level of risk that this order is fraudulent. */
  MEDIUM = 'MEDIUM'
}

/** List of possible values for an OrderRiskRecommendation recommendation. */
export enum OrderRiskRecommendationResult {
  /** Recommends fulfilling the order. */
  ACCEPT = 'ACCEPT',
  /** Recommends cancelling the order. */
  CANCEL = 'CANCEL',
  /** Recommends investigating the order by contacting buyers. */
  INVESTIGATE = 'INVESTIGATE',
  /** There is no recommended action for the order. */
  NONE = 'NONE'
}

/**
 * Summary of risk characteristics for an order.
 *
 * See the [example query "Retrieves a list of all order risks for an order"](https://shopify.dev/docs/api/admin-graphql/unstable/queries/order?example=Retrieves+a+list+of+all+order+risks+for+an+order).
 */
export type OrderRiskSummary = {
  /** The list of risk assessments for the order. */
  readonly assessments: ReadonlyArray<OrderRiskAssessment>;
  /** The recommendation for the order based on the results of the risk assessments. This suggests the action the merchant should take with regards to its risk of fraud. */
  readonly recommendation: OrderRiskRecommendationResult;
};

/** The set of valid sort keys for the Order query. */
export enum OrderSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `customer_name` value. */
  CUSTOMER_NAME = 'CUSTOMER_NAME',
  /** Sort by shipping address to analyze regional sales patterns or plan logistics. */
  DESTINATION = 'DESTINATION',
  /** Sort by the `financial_status` value. */
  FINANCIAL_STATUS = 'FINANCIAL_STATUS',
  /** Sort by the `fulfillment_status` value. */
  FULFILLMENT_STATUS = 'FULFILLMENT_STATUS',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `order_number` value. */
  ORDER_NUMBER = 'ORDER_NUMBER',
  /** Sort by the purchase order number to match external procurement systems or track recent orders. */
  PO_NUMBER = 'PO_NUMBER',
  /** Sort by the `processed_at` value. */
  PROCESSED_AT = 'PROCESSED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the total quantity of all line items to identify large purchases or analyze inventory demand patterns. */
  TOTAL_ITEMS_QUANTITY = 'TOTAL_ITEMS_QUANTITY',
  /** Sort by the `total_price` value. */
  TOTAL_PRICE = 'TOTAL_PRICE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** A change that has been applied to an order. */
export type OrderStagedChange = OrderStagedChangeAddCustomItem | OrderStagedChangeAddLineItemDiscount | OrderStagedChangeAddShippingLine | OrderStagedChangeAddVariant | OrderStagedChangeDecrementItem | OrderStagedChangeIncrementItem | OrderStagedChangeRemoveShippingLine;

/**
 * A change to the order representing the addition of a
 * custom line item. For example, you might want to add gift wrapping service
 * as a custom line item.
 */
export type OrderStagedChangeAddCustomItem = {
  /** The price of an individual item without any discounts applied. This value can't be negative. */
  readonly originalUnitPrice: MoneyV2;
  /** The quantity of the custom item to add to the order. This value must be greater than zero. */
  readonly quantity: Scalars['Int'];
  /** The title of the custom item. */
  readonly title: Scalars['String'];
};

/** The discount applied to an item that was added during the current order edit. */
export type OrderStagedChangeAddLineItemDiscount = {
  /** The description of the discount. */
  readonly description: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The pricing value of the discount. */
  readonly value: PricingValue;
};

/**
 * A new [shipping line](https://shopify.dev/api/admin-graphql/latest/objects/shippingline)
 * added as part of an order edit.
 */
export type OrderStagedChangeAddShippingLine = {
  /** The phone number at the shipping address. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The shipping line's title that's shown to the buyer. */
  readonly presentmentTitle?: Maybe<Scalars['String']>;
  /** The price that applies to the shipping line. */
  readonly price: MoneyV2;
  /** The title of the shipping line. */
  readonly title?: Maybe<Scalars['String']>;
};

/** A change to the order representing the addition of an existing product variant. */
export type OrderStagedChangeAddVariant = {
  /** The quantity of the product variant that was added. */
  readonly quantity: Scalars['Int'];
  /** The product variant that was added. */
  readonly variant: ProductVariant;
};

/** An auto-generated type for paginating through multiple OrderStagedChanges. */
export type OrderStagedChangeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<OrderStagedChangeEdge>;
  /** A list of nodes that are contained in OrderStagedChangeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<OrderStagedChange>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An removal of items from an existing line item on the order. */
export type OrderStagedChangeDecrementItem = {
  /** The number of items removed. */
  readonly delta: Scalars['Int'];
  /** The original line item. */
  readonly lineItem: LineItem;
  /** The intention to restock the removed items. */
  readonly restock: Scalars['Boolean'];
};

/** An auto-generated type which holds one OrderStagedChange and a cursor during pagination. */
export type OrderStagedChangeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of OrderStagedChangeEdge. */
  readonly node: OrderStagedChange;
};

/** An addition of items to an existing line item on the order. */
export type OrderStagedChangeIncrementItem = {
  /** The number of items added. */
  readonly delta: Scalars['Int'];
  /** The original line item. */
  readonly lineItem: LineItem;
};

/** A shipping line removed during an order edit. */
export type OrderStagedChangeRemoveShippingLine = {
  /** The removed shipping line. */
  readonly shippingLine: ShippingLine;
};

/** A payment transaction in the context of an order. */
export type OrderTransaction = Node & {
  /** The masked account number associated with the payment method. */
  readonly accountNumber?: Maybe<Scalars['String']>;
  /**
   * The amount of money.
   * @deprecated Use `amountSet` instead.
   */
  readonly amount: Scalars['Money'];
  /** The rounding adjustment applied on the cash amount in shop and presentment currencies. */
  readonly amountRoundingSet?: Maybe<MoneyBag>;
  /** The amount and currency of the transaction in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /**
   * The amount and currency of the transaction.
   * @deprecated Use `amountSet` instead.
   */
  readonly amountV2: MoneyV2;
  /** Authorization code associated with the transaction. */
  readonly authorizationCode?: Maybe<Scalars['String']>;
  /** The time when the authorization expires. This field is available only to stores on a Shopify Plus plan. */
  readonly authorizationExpiresAt?: Maybe<Scalars['DateTime']>;
  /** Date and time when the transaction was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A standardized error code, independent of the payment provider. */
  readonly errorCode?: Maybe<OrderTransactionErrorCode>;
  /** The transaction fees charged on the order transaction. Only present for Shopify Payments transactions. */
  readonly fees: ReadonlyArray<TransactionFee>;
  /** The human-readable payment gateway name used to process the transaction. */
  readonly formattedGateway?: Maybe<Scalars['String']>;
  /** The payment gateway used to process the transaction. */
  readonly gateway?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The kind of transaction. */
  readonly kind: OrderTransactionKind;
  /** Whether the transaction can be manually captured. */
  readonly manuallyCapturable: Scalars['Boolean'];
  /**
   * Specifies the available amount to refund on the gateway.
   * This value is only available for transactions of type `SuggestedRefund`.
   * @deprecated Use `maximumRefundableV2` instead.
   */
  readonly maximumRefundable?: Maybe<Scalars['Money']>;
  /**
   * Specifies the available amount with currency to refund on the gateway.
   * This value is only available for transactions of type `SuggestedRefund`.
   */
  readonly maximumRefundableV2?: Maybe<MoneyV2>;
  /** Whether the transaction can be captured multiple times. */
  readonly multiCapturable: Scalars['Boolean'];
  /** The associated order. */
  readonly order?: Maybe<Order>;
  /** The associated parent transaction, for example the authorization of a capture. */
  readonly parentTransaction?: Maybe<OrderTransaction>;
  /** The payment details for the transaction. */
  readonly paymentDetails?: Maybe<PaymentDetails>;
  /** The payment icon to display for the transaction. */
  readonly paymentIcon?: Maybe<Image>;
  /** The payment ID associated with the transaction. */
  readonly paymentId?: Maybe<Scalars['String']>;
  /**
   * The payment method used for the transaction. This value is `null` if the payment method is unknown.
   * @deprecated Use `paymentIcon` instead.
   */
  readonly paymentMethod?: Maybe<PaymentMethods>;
  /** Date and time when the transaction was processed. */
  readonly processedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The transaction receipt that the payment gateway attaches to the transaction.
   * The value of this field depends on which payment gateway processed the transaction.
   */
  readonly receiptJson?: Maybe<Scalars['JSON']>;
  /** The settlement currency. */
  readonly settlementCurrency?: Maybe<CurrencyCode>;
  /** The rate used when converting the transaction amount to settlement currency. */
  readonly settlementCurrencyRate?: Maybe<Scalars['Decimal']>;
  /** Contains all Shopify Payments information related to an order transaction. This field is available only to stores on a Shopify Plus plan. */
  readonly shopifyPaymentsSet?: Maybe<ShopifyPaymentsTransactionSet>;
  /** The status of this transaction. */
  readonly status: OrderTransactionStatus;
  /** Whether the transaction is a test transaction. */
  readonly test: Scalars['Boolean'];
  /**
   * Specifies the available amount to capture on the gateway.
   * Only available when an amount is capturable or manually mark as paid.
   * @deprecated Use `totalUnsettledSet` instead.
   */
  readonly totalUnsettled?: Maybe<Scalars['Money']>;
  /**
   * Specifies the available amount with currency to capture on the gateway in shop and presentment currencies.
   * Only available when an amount is capturable or manually mark as paid.
   */
  readonly totalUnsettledSet?: Maybe<MoneyBag>;
  /**
   * Specifies the available amount with currency to capture on the gateway.
   * Only available when an amount is capturable or manually mark as paid.
   * @deprecated Use `totalUnsettledSet` instead.
   */
  readonly totalUnsettledV2?: Maybe<MoneyV2>;
  /** Staff member who was logged into the Shopify POS device when the transaction was processed. */
  readonly user?: Maybe<StaffMember>;
};

/** An auto-generated type for paginating through multiple OrderTransactions. */
export type OrderTransactionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<OrderTransactionEdge>;
  /** A list of nodes that are contained in OrderTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<OrderTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one OrderTransaction and a cursor during pagination. */
export type OrderTransactionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of OrderTransactionEdge. */
  readonly node: OrderTransaction;
};

/** A standardized error code, independent of the payment provider. */
export enum OrderTransactionErrorCode {
  /** The payment method was invalid. */
  AMAZON_PAYMENTS_INVALID_PAYMENT_METHOD = 'AMAZON_PAYMENTS_INVALID_PAYMENT_METHOD',
  /** The maximum amount has been captured. */
  AMAZON_PAYMENTS_MAX_AMOUNT_CHARGED = 'AMAZON_PAYMENTS_MAX_AMOUNT_CHARGED',
  /** The maximum amount has been refunded. */
  AMAZON_PAYMENTS_MAX_AMOUNT_REFUNDED = 'AMAZON_PAYMENTS_MAX_AMOUNT_REFUNDED',
  /** The maximum of 10 authorizations has been captured for an order. */
  AMAZON_PAYMENTS_MAX_AUTHORIZATIONS_CAPTURED = 'AMAZON_PAYMENTS_MAX_AUTHORIZATIONS_CAPTURED',
  /** The maximum of 10 refunds has been processed for an order. */
  AMAZON_PAYMENTS_MAX_REFUNDS_PROCESSED = 'AMAZON_PAYMENTS_MAX_REFUNDS_PROCESSED',
  /** The order was canceled, which canceled all open authorizations. */
  AMAZON_PAYMENTS_ORDER_REFERENCE_CANCELED = 'AMAZON_PAYMENTS_ORDER_REFERENCE_CANCELED',
  /** The order was not confirmed within three hours. */
  AMAZON_PAYMENTS_STALE = 'AMAZON_PAYMENTS_STALE',
  /** Call the card issuer. */
  CALL_ISSUER = 'CALL_ISSUER',
  /** The card was declined. */
  CARD_DECLINED = 'CARD_DECLINED',
  /** There is an error in the gateway or merchant configuration. */
  CONFIG_ERROR = 'CONFIG_ERROR',
  /** The card is expired. */
  EXPIRED_CARD = 'EXPIRED_CARD',
  /** There was an unknown error with processing the payment. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** The address does not match the card number. */
  INCORRECT_ADDRESS = 'INCORRECT_ADDRESS',
  /** The CVC does not match the card number. */
  INCORRECT_CVC = 'INCORRECT_CVC',
  /** The card number is incorrect. */
  INCORRECT_NUMBER = 'INCORRECT_NUMBER',
  /** The entered PIN is incorrect. */
  INCORRECT_PIN = 'INCORRECT_PIN',
  /** The ZIP or postal code does not match the card number. */
  INCORRECT_ZIP = 'INCORRECT_ZIP',
  /** The amount is either too high or too low for the provider. */
  INVALID_AMOUNT = 'INVALID_AMOUNT',
  /** The payment method is not available in the customer's country. */
  INVALID_COUNTRY = 'INVALID_COUNTRY',
  /** The format of the CVC is incorrect. */
  INVALID_CVC = 'INVALID_CVC',
  /** The format of the expiry date is incorrect. */
  INVALID_EXPIRY_DATE = 'INVALID_EXPIRY_DATE',
  /** The format of the card number is incorrect. */
  INVALID_NUMBER = 'INVALID_NUMBER',
  /** The payment method is momentarily unavailable. */
  PAYMENT_METHOD_UNAVAILABLE = 'PAYMENT_METHOD_UNAVAILABLE',
  /** The card has been reported as lost or stolen, and the card issuer has requested that the merchant keep the card and call the number on the back. */
  PICK_UP_CARD = 'PICK_UP_CARD',
  /** There was an error while processing the payment. */
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  /** A real card was used but the gateway was in test mode. */
  TEST_MODE_LIVE_CARD = 'TEST_MODE_LIVE_CARD',
  /** The gateway or merchant configuration doesn't support a feature, such as network tokenization. */
  UNSUPPORTED_FEATURE = 'UNSUPPORTED_FEATURE'
}

/** The input fields for the information needed to create an order transaction. */
export type OrderTransactionInput = {
  /** The amount of money for this transaction. */
  readonly amount: Scalars['Money'];
  /** The payment gateway to use for this transaction. */
  readonly gateway: Scalars['String'];
  /** The kind of transaction. */
  readonly kind: OrderTransactionKind;
  /** The ID of the order associated with the transaction. */
  readonly orderId: Scalars['ID'];
  /** The ID of the optional parent transaction, for example the authorization of a capture. */
  readonly parentId?: InputMaybe<Scalars['ID']>;
};

/** The different kinds of order transactions. */
export enum OrderTransactionKind {
  /**
   * An amount reserved against the cardholder's funding source.
   * Money does not change hands until the authorization is captured.
   */
  AUTHORIZATION = 'AUTHORIZATION',
  /** A transfer of the money that was reserved by an authorization. */
  CAPTURE = 'CAPTURE',
  /** The money returned to the customer when they've paid too much during a cash transaction. */
  CHANGE = 'CHANGE',
  /** An authorization for a payment taken with an EMV credit card reader. */
  EMV_AUTHORIZATION = 'EMV_AUTHORIZATION',
  /**
   * A partial or full return of captured funds to the cardholder.
   * A refund can happen only after a capture is processed.
   */
  REFUND = 'REFUND',
  /** An authorization and capture performed together in a single step. */
  SALE = 'SALE',
  /** A suggested refund transaction that can be used to create a refund. */
  SUGGESTED_REFUND = 'SUGGESTED_REFUND',
  /** A cancelation of an authorization transaction. */
  VOID = 'VOID'
}

/** The different states that an `OrderTransaction` can have. */
export enum OrderTransactionStatus {
  /** Awaiting a response. */
  AWAITING_RESPONSE = 'AWAITING_RESPONSE',
  /** There was an error while processing the transaction. */
  ERROR = 'ERROR',
  /** The transaction failed. */
  FAILURE = 'FAILURE',
  /** The transaction is pending. */
  PENDING = 'PENDING',
  /** The transaction succeeded. */
  SUCCESS = 'SUCCESS',
  /** The transaction status is unknown. */
  UNKNOWN = 'UNKNOWN'
}

/** Return type for `orderUpdate` mutation. */
export type OrderUpdatePayload = {
  /** The updated order. */
  readonly order?: Maybe<Order>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A page on the Online Store. */
export type Page = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Navigable & Node & {
  /** The text content of the page, complete with HTML markup. */
  readonly body: Scalars['HTML'];
  /** The first 150 characters of the page body. If the page body contains more than 150 characters, additional characters are truncated by ellipses. */
  readonly bodySummary: Scalars['String'];
  /** The date and time (ISO 8601 format) of the page creation. */
  readonly createdAt: Scalars['DateTime'];
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /**
   * A unique, human-friendly string for the page.
   * In themes, the Liquid templating language refers to a page by its handle.
   */
  readonly handle: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether or not the page is visible. */
  readonly isPublished: Scalars['Boolean'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /**
   * The date and time (ISO 8601 format) when the page became or will become visible.
   * Returns null when the page isn't visible.
   */
  readonly publishedAt?: Maybe<Scalars['DateTime']>;
  /** The suffix of the template that's used to render the page. */
  readonly templateSuffix?: Maybe<Scalars['String']>;
  /** Title of the page. */
  readonly title: Scalars['String'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The date and time (ISO 8601 format) of the latest page update. */
  readonly updatedAt: Scalars['DateTime'];
};


/** A page on the Online Store. */
export type PageEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/** A page on the Online Store. */
export type PageMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A page on the Online Store. */
export type PageMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** A page on the Online Store. */
export type PageMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A page on the Online Store. */
export type PagePrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A page on the Online Store. */
export type PagePrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A page on the Online Store. */
export type PageTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** An auto-generated type for paginating through multiple Pages. */
export type PageConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<PageEdge>;
  /** A list of nodes that are contained in PageEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Page>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields to create a page. */
export type PageCreateInput = {
  /** The text content of the page, complete with HTML markup. */
  readonly body?: InputMaybe<Scalars['String']>;
  /**
   * A unique, human-friendly string for the page. If no handle is specified, a handle will be generated automatically from the page title.
   * In themes, the Liquid templating language refers to a page by its handle.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** Whether or not the page should be visible. Defaults to `true` if no publish date is specified. */
  readonly isPublished?: InputMaybe<Scalars['Boolean']>;
  /** The input fields to create or update a metafield. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The date and time (ISO 8601 format) when the page should become visible. */
  readonly publishDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * The suffix of the template that's used to render the page.
   * If the value is an empty string or `null`, then the default page template is used.
   */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /** The title of the page. */
  readonly title: Scalars['String'];
};

/** Return type for `pageCreate` mutation. */
export type PageCreatePayload = {
  /** The page that was created. */
  readonly page?: Maybe<Page>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PageCreateUserError>;
};

/** An error that occurs during the execution of `PageCreate`. */
export type PageCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PageCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PageCreateUserError`. */
export enum PageCreateUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Can’t set isPublished to true and also set a future publish date. */
  INVALID_PUBLISH_DATE = 'INVALID_PUBLISH_DATE',
  /** The metafield type is invalid. */
  INVALID_TYPE = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG'
}

/** Return type for `pageDelete` mutation. */
export type PageDeletePayload = {
  /** The ID of the deleted page. */
  readonly deletedPageId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PageDeleteUserError>;
};

/** An error that occurs during the execution of `PageDelete`. */
export type PageDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PageDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PageDeleteUserError`. */
export enum PageDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** An auto-generated type which holds one Page and a cursor during pagination. */
export type PageEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of PageEdge. */
  readonly node: Page;
};

/**
 * Returns information about pagination in a connection, in accordance with the
 * [Relay specification](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo).
 * For more information, please read our [GraphQL Pagination Usage Guide](https://shopify.dev/api/usage/pagination-graphql).
 */
export type PageInfo = {
  /** The cursor corresponding to the last node in edges. */
  readonly endCursor?: Maybe<Scalars['String']>;
  /** Whether there are more pages to fetch following the current page. */
  readonly hasNextPage: Scalars['Boolean'];
  /** Whether there are any pages prior to the current page. */
  readonly hasPreviousPage: Scalars['Boolean'];
  /** The cursor corresponding to the first node in edges. */
  readonly startCursor?: Maybe<Scalars['String']>;
};

/** The input fields to update a page. */
export type PageUpdateInput = {
  /** The text content of the page, complete with HTML markup. */
  readonly body?: InputMaybe<Scalars['String']>;
  /**
   * A unique, human-friendly string for the page. If no handle is specified, a handle will be generated automatically from the page title.
   * In themes, the Liquid templating language refers to a page by its handle.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** Whether or not the page should be visible. Defaults to `true` if no publish date is specified. */
  readonly isPublished?: InputMaybe<Scalars['Boolean']>;
  /** The input fields to create or update a metafield. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The date and time (ISO 8601 format) when the page should become visible. */
  readonly publishDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  readonly redirectNewHandle?: InputMaybe<Scalars['Boolean']>;
  /**
   * The suffix of the template that's used to render the page.
   * If the value is an empty string or `null`, then the default page template is used.
   */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /** The title of the page. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `pageUpdate` mutation. */
export type PageUpdatePayload = {
  /** The page that was updated. */
  readonly page?: Maybe<Page>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PageUpdateUserError>;
};

/** An error that occurs during the execution of `PageUpdate`. */
export type PageUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PageUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PageUpdateUserError`. */
export enum PageUpdateUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Can’t set isPublished to true and also set a future publish date. */
  INVALID_PUBLISH_DATE = 'INVALID_PUBLISH_DATE',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG'
}

/** A payment customization. */
export type PaymentCustomization = HasMetafieldDefinitions & HasMetafields & Node & {
  /** The enabled status of the payment customization. */
  readonly enabled: Scalars['Boolean'];
  /** The error history on the most recent version of the payment customization. */
  readonly errorHistory?: Maybe<FunctionsErrorHistory>;
  /** The ID of the Shopify Function implementing the payment customization. */
  readonly functionId: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The Shopify Function implementing the payment customization. */
  readonly shopifyFunction: ShopifyFunction;
  /** The title of the payment customization. */
  readonly title: Scalars['String'];
};


/** A payment customization. */
export type PaymentCustomizationMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A payment customization. */
export type PaymentCustomizationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** A payment customization. */
export type PaymentCustomizationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A payment customization. */
export type PaymentCustomizationPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A payment customization. */
export type PaymentCustomizationPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `paymentCustomizationActivation` mutation. */
export type PaymentCustomizationActivationPayload = {
  /** The IDs of the updated payment customizations. */
  readonly ids?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentCustomizationError>;
};

/** An auto-generated type for paginating through multiple PaymentCustomizations. */
export type PaymentCustomizationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<PaymentCustomizationEdge>;
  /** A list of nodes that are contained in PaymentCustomizationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<PaymentCustomization>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `paymentCustomizationCreate` mutation. */
export type PaymentCustomizationCreatePayload = {
  /** Returns the created payment customization. */
  readonly paymentCustomization?: Maybe<PaymentCustomization>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentCustomizationError>;
};

/** Return type for `paymentCustomizationDelete` mutation. */
export type PaymentCustomizationDeletePayload = {
  /** Returns the deleted payment customization ID. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentCustomizationError>;
};

/** An auto-generated type which holds one PaymentCustomization and a cursor during pagination. */
export type PaymentCustomizationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of PaymentCustomizationEdge. */
  readonly node: PaymentCustomization;
};

/** An error that occurs during the execution of a payment customization mutation. */
export type PaymentCustomizationError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PaymentCustomizationErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PaymentCustomizationError`. */
export enum PaymentCustomizationErrorCode {
  /** Shop plan not eligible to use Functions from a custom app. */
  CUSTOM_APP_FUNCTION_NOT_ELIGIBLE = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** Function does not implement the required interface. */
  FUNCTION_DOES_NOT_IMPLEMENT = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** Function ID cannot be changed. */
  FUNCTION_ID_CANNOT_BE_CHANGED = 'FUNCTION_ID_CANNOT_BE_CHANGED',
  /** Function not found. */
  FUNCTION_NOT_FOUND = 'FUNCTION_NOT_FOUND',
  /** Function is pending deletion. */
  FUNCTION_PENDING_DELETION = 'FUNCTION_PENDING_DELETION',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Could not create or update metafields. */
  INVALID_METAFIELDS = 'INVALID_METAFIELDS',
  /** Maximum payment customizations are already enabled. */
  MAXIMUM_ACTIVE_PAYMENT_CUSTOMIZATIONS = 'MAXIMUM_ACTIVE_PAYMENT_CUSTOMIZATIONS',
  /** Shop must be on a Shopify Plus plan to activate payment customizations from a custom app. */
  PAYMENT_CUSTOMIZATION_FUNCTION_NOT_ELIGIBLE = 'PAYMENT_CUSTOMIZATION_FUNCTION_NOT_ELIGIBLE',
  /** Payment customization not found. */
  PAYMENT_CUSTOMIZATION_NOT_FOUND = 'PAYMENT_CUSTOMIZATION_NOT_FOUND',
  /** Required input field must be present. */
  REQUIRED_INPUT_FIELD = 'REQUIRED_INPUT_FIELD'
}

/** The input fields to create and update a payment customization. */
export type PaymentCustomizationInput = {
  /** The enabled status of the payment customization. */
  readonly enabled?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the function providing the payment customization. */
  readonly functionId?: InputMaybe<Scalars['String']>;
  /** Additional metafields to associate to the payment customization. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The title of the payment customization. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `paymentCustomizationUpdate` mutation. */
export type PaymentCustomizationUpdatePayload = {
  /** Returns the updated payment customization. */
  readonly paymentCustomization?: Maybe<PaymentCustomization>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentCustomizationError>;
};

/** Payment details related to a transaction. */
export type PaymentDetails = CardPaymentDetails | LocalPaymentMethodsPaymentDetails | ShopPayInstallmentsPaymentDetails;

/** All possible instrument outputs for Payment Mandates. */
export type PaymentInstrument = VaultCreditCard | VaultPaypalBillingAgreement;

/**
 * A payment instrument and the permission
 * the owner of the instrument gives to the merchant to debit it.
 */
export type PaymentMandate = Node & {
  /** The unique ID of a payment mandate. */
  readonly id: Scalars['ID'];
  /** The outputs details of the payment instrument. */
  readonly paymentInstrument: PaymentInstrument;
};

/** Some of the payment methods used in Shopify. */
export enum PaymentMethods {
  AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
  BITCOIN = 'BITCOIN',
  BOGUS = 'BOGUS',
  DANKORT = 'DANKORT',
  DINERS_CLUB = 'DINERS_CLUB',
  DISCOVER = 'DISCOVER',
  DOGECOIN = 'DOGECOIN',
  /** The payment method for eftpos_au payment. */
  EFTPOS = 'EFTPOS',
  /** The payment method for Elo payment. */
  ELO = 'ELO',
  FORBRUGSFORENINGEN = 'FORBRUGSFORENINGEN',
  /** The payment method for Interac payment. */
  INTERAC = 'INTERAC',
  JCB = 'JCB',
  LITECOIN = 'LITECOIN',
  MAESTRO = 'MAESTRO',
  MASTERCARD = 'MASTERCARD',
  PAYPAL = 'PAYPAL',
  /** The payment method for UnionPay payment. */
  UNIONPAY = 'UNIONPAY',
  VISA = 'VISA'
}

/** Return type for `paymentReminderSend` mutation. */
export type PaymentReminderSendPayload = {
  /** Whether the payment reminder email was successfully sent. */
  readonly success?: Maybe<Scalars['Boolean']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentReminderSendUserError>;
};

/** An error that occurs during the execution of `PaymentReminderSend`. */
export type PaymentReminderSendUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PaymentReminderSendUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PaymentReminderSendUserError`. */
export enum PaymentReminderSendUserErrorCode {
  /** An error occurred while sending the payment reminder. */
  PAYMENT_REMINDER_SEND_UNSUCCESSFUL = 'PAYMENT_REMINDER_SEND_UNSUCCESSFUL'
}

/** Represents the payment schedule for a single payment defined in the payment terms. */
export type PaymentSchedule = Node & {
  /**
   * Amount owed for this payment schedule.
   * @deprecated Use `balanceDue`, `totalBalance`, or `Order.totalOutstandingSet` instead.
   */
  readonly amount: MoneyV2;
  /** Date and time when the payment schedule is paid or fulfilled. */
  readonly completedAt?: Maybe<Scalars['DateTime']>;
  /** Date and time when the payment schedule is due. */
  readonly dueAt?: Maybe<Scalars['DateTime']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Date and time when the invoice is sent. */
  readonly issuedAt?: Maybe<Scalars['DateTime']>;
  /** The payment terms the payment schedule belongs to. */
  readonly paymentTerms: PaymentTerms;
};

/** An auto-generated type for paginating through multiple PaymentSchedules. */
export type PaymentScheduleConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<PaymentScheduleEdge>;
  /** A list of nodes that are contained in PaymentScheduleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<PaymentSchedule>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one PaymentSchedule and a cursor during pagination. */
export type PaymentScheduleEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of PaymentScheduleEdge. */
  readonly node: PaymentSchedule;
};

/** The input fields used to create a payment schedule for payment terms. */
export type PaymentScheduleInput = {
  /** Specifies the date and time when the payment schedule is due. This field must be provided for fixed type payment terms. */
  readonly dueAt?: InputMaybe<Scalars['DateTime']>;
  /** Specifies the date and time that the payment schedule was issued. This field must be provided for net type payment terms. */
  readonly issuedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Settings related to payments. */
export type PaymentSettings = {
  /** List of the digital wallets which the shop supports. */
  readonly supportedDigitalWallets: ReadonlyArray<DigitalWallet>;
};

/** Represents the payment terms for an order or draft order. */
export type PaymentTerms = Node & {
  /** The draft order associated with the payment terms. */
  readonly draftOrder?: Maybe<DraftOrder>;
  /** Duration of payment terms in days based on the payment terms template used to create the payment terms. */
  readonly dueInDays?: Maybe<Scalars['Int']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The order associated with the payment terms. */
  readonly order?: Maybe<Order>;
  /** Whether the payment terms have overdue payment schedules. */
  readonly overdue: Scalars['Boolean'];
  /** List of schedules for the payment terms. */
  readonly paymentSchedules: PaymentScheduleConnection;
  /** The name of the payment terms template used to create the payment terms. */
  readonly paymentTermsName: Scalars['String'];
  /** The payment terms template type used to create the payment terms. */
  readonly paymentTermsType: PaymentTermsType;
  /** The payment terms name, translated into the shop admin's preferred language. */
  readonly translatedName: Scalars['String'];
};


/** Represents the payment terms for an order or draft order. */
export type PaymentTermsPaymentSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields used to create a payment terms. */
export type PaymentTermsCreateInput = {
  /** Specifies the payment schedules for the payment terms. */
  readonly paymentSchedules?: InputMaybe<ReadonlyArray<PaymentScheduleInput>>;
  /** Specifies the payment terms template ID used to generate payment terms. */
  readonly paymentTermsTemplateId: Scalars['ID'];
};

/** Return type for `paymentTermsCreate` mutation. */
export type PaymentTermsCreatePayload = {
  /** The created payment terms. */
  readonly paymentTerms?: Maybe<PaymentTerms>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentTermsCreateUserError>;
};

/** An error that occurs during the execution of `PaymentTermsCreate`. */
export type PaymentTermsCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PaymentTermsCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PaymentTermsCreateUserError`. */
export enum PaymentTermsCreateUserErrorCode {
  /** An error occurred while creating payment terms. */
  PAYMENT_TERMS_CREATION_UNSUCCESSFUL = 'PAYMENT_TERMS_CREATION_UNSUCCESSFUL'
}

/** The input fields used to delete the payment terms. */
export type PaymentTermsDeleteInput = {
  /** The ID of the payment terms being deleted. */
  readonly paymentTermsId: Scalars['ID'];
};

/** Return type for `paymentTermsDelete` mutation. */
export type PaymentTermsDeletePayload = {
  /** The deleted payment terms ID. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentTermsDeleteUserError>;
};

/** An error that occurs during the execution of `PaymentTermsDelete`. */
export type PaymentTermsDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PaymentTermsDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PaymentTermsDeleteUserError`. */
export enum PaymentTermsDeleteUserErrorCode {
  /** An error occurred while deleting payment terms. */
  PAYMENT_TERMS_DELETE_UNSUCCESSFUL = 'PAYMENT_TERMS_DELETE_UNSUCCESSFUL'
}

/** The input fields to create payment terms. Payment terms set the date that payment is due. */
export type PaymentTermsInput = {
  /** Specifies the payment schedules for the payment terms. */
  readonly paymentSchedules?: InputMaybe<ReadonlyArray<PaymentScheduleInput>>;
  /**
   * Specifies the ID of the payment terms template.
   *         Payment terms templates provide preset configurations to create common payment terms.
   *         Refer to the
   *         [PaymentTermsTemplate](https://shopify.dev/api/admin-graphql/latest/objects/paymenttermstemplate)
   *         object for more details.
   */
  readonly paymentTermsTemplateId?: InputMaybe<Scalars['ID']>;
};

/** Represents the payment terms template object. */
export type PaymentTermsTemplate = Node & {
  /** The description of the payment terms template. */
  readonly description: Scalars['String'];
  /** The number of days between the issued date and due date if this is the net type of payment terms. */
  readonly dueInDays?: Maybe<Scalars['Int']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the payment terms template. */
  readonly name: Scalars['String'];
  /** The type of the payment terms template. */
  readonly paymentTermsType: PaymentTermsType;
  /** The translated payment terms template name. */
  readonly translatedName: Scalars['String'];
};

/** The type of a payment terms or a payment terms template. */
export enum PaymentTermsType {
  /** The payment terms or payment terms template is a fixed type. It's due on a specified date. */
  FIXED = 'FIXED',
  /** The payment terms or payment terms template is due on fulfillment. */
  FULFILLMENT = 'FULFILLMENT',
  /** The payment terms or payment terms template is a net type. It's due a number of days after issue. */
  NET = 'NET',
  /** The payment terms or payment terms template is due on receipt. */
  RECEIPT = 'RECEIPT',
  /** The type of the payment terms or payment terms template is unknown. */
  UNKNOWN = 'UNKNOWN'
}

/** The input fields used to update the payment terms. */
export type PaymentTermsUpdateInput = {
  /** The attributes used to update the payment terms. */
  readonly paymentTermsAttributes: PaymentTermsInput;
  /** The ID of the payment terms being updated. */
  readonly paymentTermsId: Scalars['ID'];
};

/** Return type for `paymentTermsUpdate` mutation. */
export type PaymentTermsUpdatePayload = {
  /** The updated payment terms. */
  readonly paymentTerms?: Maybe<PaymentTerms>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PaymentTermsUpdateUserError>;
};

/** An error that occurs during the execution of `PaymentTermsUpdate`. */
export type PaymentTermsUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PaymentTermsUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PaymentTermsUpdateUserError`. */
export enum PaymentTermsUpdateUserErrorCode {
  /** An error occurred while updating payment terms. */
  PAYMENT_TERMS_UPDATE_UNSUCCESSFUL = 'PAYMENT_TERMS_UPDATE_UNSUCCESSFUL'
}

/** The set of valid sort keys for the Payout query. */
export enum PayoutSortKeys {
  /** Sort by the `adjustment_gross` value. */
  ADJUSTMENT_GROSS = 'ADJUSTMENT_GROSS',
  /** Sort by the `advance_gross` value. */
  ADVANCE_GROSS = 'ADVANCE_GROSS',
  /** Sort by the `amount` value. */
  AMOUNT = 'AMOUNT',
  /** Sort by the `charge_gross` value. */
  CHARGE_GROSS = 'CHARGE_GROSS',
  /** Sort by the `duties_gross` value. */
  DUTIES_GROSS = 'DUTIES_GROSS',
  /** Sort by the `fee_amount` value. */
  FEE_AMOUNT = 'FEE_AMOUNT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `issued_at` value. */
  ISSUED_AT = 'ISSUED_AT',
  /** Sort by the `refund_gross` value. */
  REFUND_GROSS = 'REFUND_GROSS',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `shipping_label_gross` value. */
  SHIPPING_LABEL_GROSS = 'SHIPPING_LABEL_GROSS',
  /** Sort by the `status` value. */
  STATUS = 'STATUS'
}

/** Represents a valid PayPal Express subscriptions gateway status. */
export enum PaypalExpressSubscriptionsGatewayStatus {
  /** The status is disabled. */
  DISABLED = 'DISABLED',
  /** The status is enabled. */
  ENABLED = 'ENABLED',
  /** The status is pending. */
  PENDING = 'PENDING'
}

/** The input fields used to include the line items of a specified fulfillment order that should be marked as prepared for pickup by a customer. */
export type PreparedFulfillmentOrderLineItemsInput = {
  /** The ID of the fulfillment order. */
  readonly fulfillmentOrderId: Scalars['ID'];
};

/** How to caluclate the parent product variant's price while bulk updating variant relationships. */
export enum PriceCalculationType {
  /** The price of the parent will be the sum of the components price times their quantity. */
  COMPONENTS_SUM = 'COMPONENTS_SUM',
  /** The price of the parent will be set to the price provided. */
  FIXED = 'FIXED',
  /** The price of the parent will not be adjusted. */
  NONE = 'NONE'
}

/** The input fields for updating the price of a parent product variant. */
export type PriceInput = {
  /**
   * The specific type of calculation done to determine the price of the parent variant.
   * The price is calculated during Bundle creation. Updating a component variant won't recalculate the price.
   */
  readonly calculation?: InputMaybe<PriceCalculationType>;
  /** The price of the parent product variant. This will be be used if calcualtion is set to 'FIXED'. */
  readonly price?: InputMaybe<Scalars['Money']>;
};

/**
 * Represents a price list, including information about related prices and eligibility rules.
 * You can use price lists to specify either fixed prices or adjusted relative prices that
 * override initial product variant prices. Price lists are applied to customers
 * using context rules, which determine price list eligibility.
 *
 *   For more information on price lists, refer to
 *   [Support different pricing models](https://shopify.dev/apps/internationalization/product-price-lists).
 */
export type PriceList = Node & {
  /** The catalog that the price list is associated with. */
  readonly catalog?: Maybe<Catalog>;
  /** The currency for fixed prices associated with this price list. */
  readonly currency: CurrencyCode;
  /** The number of fixed prices on the price list. */
  readonly fixedPricesCount: Scalars['Int'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The unique name of the price list, used as a human-readable identifier. */
  readonly name: Scalars['String'];
  /** Relative adjustments to other prices. */
  readonly parent?: Maybe<PriceListParent>;
  /** A list of prices associated with the price list. */
  readonly prices: PriceListPriceConnection;
  /** A list of quantity rules associated with the price list, ordered by product variants. */
  readonly quantityRules: QuantityRuleConnection;
};


/**
 * Represents a price list, including information about related prices and eligibility rules.
 * You can use price lists to specify either fixed prices or adjusted relative prices that
 * override initial product variant prices. Price lists are applied to customers
 * using context rules, which determine price list eligibility.
 *
 *   For more information on price lists, refer to
 *   [Support different pricing models](https://shopify.dev/apps/internationalization/product-price-lists).
 */
export type PriceListPricesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  originType?: InputMaybe<PriceListPriceOriginType>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a price list, including information about related prices and eligibility rules.
 * You can use price lists to specify either fixed prices or adjusted relative prices that
 * override initial product variant prices. Price lists are applied to customers
 * using context rules, which determine price list eligibility.
 *
 *   For more information on price lists, refer to
 *   [Support different pricing models](https://shopify.dev/apps/internationalization/product-price-lists).
 */
export type PriceListQuantityRulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  originType?: InputMaybe<QuantityRuleOriginType>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The type and value of a price list adjustment.
 *
 * For more information on price lists, refer to
 * [Support different pricing models](https://shopify.dev/apps/internationalization/product-price-lists).
 */
export type PriceListAdjustment = {
  /** The type of price adjustment, such as percentage increase or decrease. */
  readonly type: PriceListAdjustmentType;
  /**
   * The value of price adjustment, where positive numbers reduce the prices and negative numbers
   * increase them.
   */
  readonly value: Scalars['Float'];
};

/** The input fields to set a price list adjustment. */
export type PriceListAdjustmentInput = {
  /** The type of price adjustment, such as percentage increase or decrease. */
  readonly type: PriceListAdjustmentType;
  /** The value of the price adjustment as specified by the `type`. */
  readonly value: Scalars['Float'];
};

/** Represents the settings of price list adjustments. */
export type PriceListAdjustmentSettings = {
  /** The type of price list adjustment setting for compare at price. */
  readonly compareAtMode: PriceListCompareAtMode;
};

/** The input fields to set a price list's adjustment settings. */
export type PriceListAdjustmentSettingsInput = {
  /** Determines how adjustments are applied to compare at prices. */
  readonly compareAtMode?: PriceListCompareAtMode;
};

/** Represents a percentage price adjustment type. */
export enum PriceListAdjustmentType {
  /** Percentage decrease type. Prices will have a lower value. */
  PERCENTAGE_DECREASE = 'PERCENTAGE_DECREASE',
  /** Percentage increase type. Prices will have a higher value. */
  PERCENTAGE_INCREASE = 'PERCENTAGE_INCREASE'
}

/** Represents how the compare at price will be determined for a price list. */
export enum PriceListCompareAtMode {
  /** The compare at price is adjusted based on percentage specified in price list. */
  ADJUSTED = 'ADJUSTED',
  /** The compare at prices are set to `null` unless explicitly defined by a fixed price value. */
  NULLIFY = 'NULLIFY'
}

/** An auto-generated type for paginating through multiple PriceLists. */
export type PriceListConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<PriceListEdge>;
  /** A list of nodes that are contained in PriceListEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<PriceList>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields to create a price list. */
export type PriceListCreateInput = {
  /** The ID of the catalog to associate with this price list.If the catalog was already associated with another price list then it will be unlinked. */
  readonly catalogId?: InputMaybe<Scalars['ID']>;
  /** Three letter currency code for fixed prices associated with this price list. */
  readonly currency: CurrencyCode;
  /** The unique name of the price list, used as a human-readable identifier. */
  readonly name: Scalars['String'];
  /** Relative adjustments to other prices. */
  readonly parent: PriceListParentCreateInput;
};

/** Return type for `priceListCreate` mutation. */
export type PriceListCreatePayload = {
  /** The newly created price list. */
  readonly priceList?: Maybe<PriceList>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PriceListUserError>;
};

/** Return type for `priceListDelete` mutation. */
export type PriceListDeletePayload = {
  /** The ID of the deleted price list. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PriceListUserError>;
};

/** An auto-generated type which holds one PriceList and a cursor during pagination. */
export type PriceListEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of PriceListEdge. */
  readonly node: PriceList;
};

/** Return type for `priceListFixedPricesAdd` mutation. */
export type PriceListFixedPricesAddPayload = {
  /** The list of fixed prices that were added to or updated in the price list. */
  readonly prices?: Maybe<ReadonlyArray<PriceListPrice>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PriceListPriceUserError>;
};

/** Error codes for failed price list fixed prices by product bulk update operations. */
export type PriceListFixedPricesByProductBulkUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PriceListFixedPricesByProductBulkUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PriceListFixedPricesByProductBulkUpdateUserError`. */
export enum PriceListFixedPricesByProductBulkUpdateUserErrorCode {
  /** Duplicate ID in input. */
  DUPLICATE_ID_IN_INPUT = 'DUPLICATE_ID_IN_INPUT',
  /** IDs must be mutually exclusive across add or delete operations. */
  ID_MUST_BE_MUTUALLY_EXCLUSIVE = 'ID_MUST_BE_MUTUALLY_EXCLUSIVE',
  /** No update operations specified. */
  NO_UPDATE_OPERATIONS_SPECIFIED = 'NO_UPDATE_OPERATIONS_SPECIFIED',
  /** The currency specified does not match the price list's currency. */
  PRICES_TO_ADD_CURRENCY_MISMATCH = 'PRICES_TO_ADD_CURRENCY_MISMATCH',
  /** Exceeded the 10000 prices to add limit. */
  PRICE_LIMIT_EXCEEDED = 'PRICE_LIMIT_EXCEEDED',
  /** Price list does not exist. */
  PRICE_LIST_DOES_NOT_EXIST = 'PRICE_LIST_DOES_NOT_EXIST',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST'
}

/** Return type for `priceListFixedPricesByProductUpdate` mutation. */
export type PriceListFixedPricesByProductUpdatePayload = {
  /** The price list for which the fixed prices were modified. */
  readonly priceList?: Maybe<PriceList>;
  /** The product for which the fixed prices were added. */
  readonly pricesToAddProducts?: Maybe<ReadonlyArray<Product>>;
  /** The product for which the fixed prices were deleted. */
  readonly pricesToDeleteProducts?: Maybe<ReadonlyArray<Product>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PriceListFixedPricesByProductBulkUpdateUserError>;
};

/** Return type for `priceListFixedPricesDelete` mutation. */
export type PriceListFixedPricesDeletePayload = {
  /** A list of product variant IDs whose fixed prices were removed from the price list. */
  readonly deletedFixedPriceVariantIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PriceListPriceUserError>;
};

/** Return type for `priceListFixedPricesUpdate` mutation. */
export type PriceListFixedPricesUpdatePayload = {
  /** A list of deleted variant IDs for prices. */
  readonly deletedFixedPriceVariantIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The price list for which the fixed prices were modified. */
  readonly priceList?: Maybe<PriceList>;
  /** The prices that were added to the price list. */
  readonly pricesAdded?: Maybe<ReadonlyArray<PriceListPrice>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PriceListPriceUserError>;
};

/**
 * Represents relative adjustments from one price list to other prices.
 *   You can use a `PriceListParent` to specify an adjusted relative price using a percentage-based
 *   adjustment. Adjusted prices work in conjunction with exchange rules and rounding.
 *
 *   [Adjustment types](https://shopify.dev/api/admin-graphql/latest/enums/pricelistadjustmenttype)
 *   support both percentage increases and decreases.
 */
export type PriceListParent = {
  /** A price list adjustment. */
  readonly adjustment: PriceListAdjustment;
  /** A price list's settings for adjustment. */
  readonly settings: PriceListAdjustmentSettings;
};

/** The input fields to create a price list adjustment. */
export type PriceListParentCreateInput = {
  /** The relative adjustments to other prices. */
  readonly adjustment: PriceListAdjustmentInput;
  /** The price list adjustment settings. */
  readonly settings?: InputMaybe<PriceListAdjustmentSettingsInput>;
};

/** The input fields used to update a price list's adjustment. */
export type PriceListParentUpdateInput = {
  /** The relative adjustments to other prices.. */
  readonly adjustment: PriceListAdjustmentInput;
  /** The price list adjustment settings. */
  readonly settings?: InputMaybe<PriceListAdjustmentSettingsInput>;
};

/**
 * Represents information about pricing for a product variant
 *         as defined on a price list, such as the price, compare at price, and origin type. You can use a `PriceListPrice` to specify a fixed price for a specific product variant. For examples, refer to [PriceListFixedPricesAdd](https://shopify.dev/api/admin-graphql/latest/mutations/priceListFixedPricesAdd) and [PriceList](https://shopify.dev/api/admin-graphql/latest/queries/priceList#section-examples).
 */
export type PriceListPrice = {
  /** The compare-at price of the product variant on this price list. */
  readonly compareAtPrice?: Maybe<MoneyV2>;
  /** The origin of a price, either fixed (defined on the price list) or relative (calculated using a price list adjustment configuration). */
  readonly originType: PriceListPriceOriginType;
  /** The price of the product variant on this price list. */
  readonly price: MoneyV2;
  /** A list of quantity breaks for the product variant. */
  readonly quantityPriceBreaks: QuantityPriceBreakConnection;
  /** The product variant associated with this price. */
  readonly variant: ProductVariant;
};


/**
 * Represents information about pricing for a product variant
 *         as defined on a price list, such as the price, compare at price, and origin type. You can use a `PriceListPrice` to specify a fixed price for a specific product variant. For examples, refer to [PriceListFixedPricesAdd](https://shopify.dev/api/admin-graphql/latest/mutations/priceListFixedPricesAdd) and [PriceList](https://shopify.dev/api/admin-graphql/latest/queries/priceList#section-examples).
 */
export type PriceListPriceQuantityPriceBreaksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<QuantityPriceBreakSortKeys>;
};

/** An auto-generated type for paginating through multiple PriceListPrices. */
export type PriceListPriceConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<PriceListPriceEdge>;
  /** A list of nodes that are contained in PriceListPriceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<PriceListPrice>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one PriceListPrice and a cursor during pagination. */
export type PriceListPriceEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of PriceListPriceEdge. */
  readonly node: PriceListPrice;
};

/** The input fields for providing the fields and values to use when creating or updating a fixed price list price. */
export type PriceListPriceInput = {
  /** The compare-at price of the product variant on this price list. */
  readonly compareAtPrice?: InputMaybe<MoneyInput>;
  /** The price of the product variant on this price list. */
  readonly price: MoneyInput;
  /** The product variant ID associated with the price list price. */
  readonly variantId: Scalars['ID'];
};

/** Represents the origin of a price, either fixed (defined on the price list) or relative (calculated using a price list adjustment configuration). For examples, refer to [PriceList](https://shopify.dev/api/admin-graphql/latest/queries/priceList#section-examples). */
export enum PriceListPriceOriginType {
  /** The price is defined on the price list. */
  FIXED = 'FIXED',
  /** The price is relative to the adjustment type and value. */
  RELATIVE = 'RELATIVE'
}

/** An error for a failed price list price operation. */
export type PriceListPriceUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PriceListPriceUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PriceListPriceUserError`. */
export enum PriceListPriceUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The specified currency doesn't match the price list's currency. */
  PRICE_LIST_CURRENCY_MISMATCH = 'PRICE_LIST_CURRENCY_MISMATCH',
  /** The price list doesn't exist. */
  PRICE_LIST_NOT_FOUND = 'PRICE_LIST_NOT_FOUND',
  /** Only fixed prices can be deleted. */
  PRICE_NOT_FIXED = 'PRICE_NOT_FIXED',
  /** A fixed price for the specified product variant doesn't exist. */
  VARIANT_NOT_FOUND = 'VARIANT_NOT_FOUND'
}

/** The input fields representing the price for all variants of a product. */
export type PriceListProductPriceInput = {
  /** The price of the product to use for all variants with its currency. */
  readonly price: MoneyInput;
  /** Specifies the ID of the product to update its variants for. */
  readonly productId: Scalars['ID'];
};

/** The set of valid sort keys for the PriceList query. */
export enum PriceListSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The input fields used to update a price list. */
export type PriceListUpdateInput = {
  /** The ID of the catalog to associate with this price list. */
  readonly catalogId?: InputMaybe<Scalars['ID']>;
  /** The three-letter currency code for fixed prices associated with this price list. */
  readonly currency?: InputMaybe<CurrencyCode>;
  /** The unique name of the price list, used as a human-readable identifier. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Relative adjustments to other prices. */
  readonly parent?: InputMaybe<PriceListParentUpdateInput>;
};

/** Return type for `priceListUpdate` mutation. */
export type PriceListUpdatePayload = {
  /** The updated price list. */
  readonly priceList?: Maybe<PriceList>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PriceListUserError>;
};

/** Error codes for failed contextual pricing operations. */
export type PriceListUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PriceListUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PriceListUserError`. */
export enum PriceListUserErrorCode {
  /** An app catalog cannot be assigned to a price list. */
  APP_CATALOG_PRICE_LIST_ASSIGNMENT = 'APP_CATALOG_PRICE_LIST_ASSIGNMENT',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Cannot assign a catalog to a price list that also has context rules. */
  CATALOG_ASSIGNMENT_NOT_ALLOWED = 'CATALOG_ASSIGNMENT_NOT_ALLOWED',
  /** The context type of a catalog cannot be changed. */
  CATALOG_CANNOT_CHANGE_CONTEXT_TYPE = 'CATALOG_CANNOT_CHANGE_CONTEXT_TYPE',
  /** Quantity price breaks can be associated only with company location catalogs. */
  CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_PRICE_BREAKS = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_PRICE_BREAKS',
  /** Quantity rules can be associated only with company location catalogs. */
  CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES',
  /** The specified catalog does not exist. */
  CATALOG_DOES_NOT_EXIST = 'CATALOG_DOES_NOT_EXIST',
  /** The price list currency must match the market catalog currency. */
  CATALOG_MARKET_AND_PRICE_LIST_CURRENCY_MISMATCH = 'CATALOG_MARKET_AND_PRICE_LIST_CURRENCY_MISMATCH',
  /** Catalog has a price list already assigned. */
  CATALOG_TAKEN = 'CATALOG_TAKEN',
  /** A price list context rule cannot have more than one country. */
  CONTEXT_RULE_COUNTRIES_LIMIT = 'CONTEXT_RULE_COUNTRIES_LIMIT',
  /** A price list for this country is already taken. */
  CONTEXT_RULE_COUNTRY_TAKEN = 'CONTEXT_RULE_COUNTRY_TAKEN',
  /** Only one context rule option may be specified. */
  CONTEXT_RULE_LIMIT_ONE_OPTION = 'CONTEXT_RULE_LIMIT_ONE_OPTION',
  /** Cannot save the price list with context rule because the limit of context rules per shop was reached. */
  CONTEXT_RULE_LIMIT_REACHED = 'CONTEXT_RULE_LIMIT_REACHED',
  /** The specified market wasn't found. */
  CONTEXT_RULE_MARKET_NOT_FOUND = 'CONTEXT_RULE_MARKET_NOT_FOUND',
  /** A price list for this market is already taken. */
  CONTEXT_RULE_MARKET_TAKEN = 'CONTEXT_RULE_MARKET_TAKEN',
  /** A country in a context rule must use a valid currency. */
  COUNTRY_CURRENCY_MISMATCH = 'COUNTRY_CURRENCY_MISMATCH',
  /** A country catalog cannot be assigned to a price list. */
  COUNTRY_PRICE_LIST_ASSIGNMENT = 'COUNTRY_PRICE_LIST_ASSIGNMENT',
  /** A price list’s currency must be of the pricing rule’s country. */
  CURRENCY_COUNTRY_MISMATCH = 'CURRENCY_COUNTRY_MISMATCH',
  /** A price list’s currency must be the market currency. */
  CURRENCY_MARKET_MISMATCH = 'CURRENCY_MARKET_MISMATCH',
  /** The price list currency is not supported by the shop's payment gateway. */
  CURRENCY_NOT_SUPPORTED = 'CURRENCY_NOT_SUPPORTED',
  /** Something went wrong when trying to save the price list. Please try again. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** The adjustment value must not be greater than 1000% for `type` `PERCENTAGE_INCREASE`. */
  INVALID_ADJUSTMENT_MAX_VALUE = 'INVALID_ADJUSTMENT_MAX_VALUE',
  /** The adjustment value must not be greater than 100% for `type` `PERCENTAGE_DECREASE`. */
  INVALID_ADJUSTMENT_MIN_VALUE = 'INVALID_ADJUSTMENT_MIN_VALUE',
  /** The adjustment value must be a positive value and not be greater than 100% for `type` `PERCENTAGE_DECREASE` and not be greater than 1000% for `type` `PERCENTAGE_INCREASE`. */
  INVALID_ADJUSTMENT_VALUE = 'INVALID_ADJUSTMENT_VALUE',
  /** The context rule's market does not use the price list currency. */
  MARKET_CURRENCY_MISMATCH = 'MARKET_CURRENCY_MISMATCH',
  /** The price list is currently being modified. Please try again later. */
  PRICE_LIST_LOCKED = 'PRICE_LIST_LOCKED',
  /** Cannot create price list for a primary market. */
  PRICE_LIST_NOT_ALLOWED_FOR_PRIMARY_MARKET = 'PRICE_LIST_NOT_ALLOWED_FOR_PRIMARY_MARKET',
  /** The specified price list doesn't exist. */
  PRICE_LIST_NOT_FOUND = 'PRICE_LIST_NOT_FOUND',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG'
}

/**
 * Price rules are a set of conditions, including entitlements and prerequisites, that must be met in order for a discount code to apply.
 *
 * We recommend using the types and queries detailed at [Getting started with discounts](https://shopify.dev/docs/apps/selling-strategies/discounts/getting-started) instead. These will replace the GraphQL `PriceRule` object and REST Admin `PriceRule` and `DiscountCode` resources.
 */
export type PriceRule = CommentEventSubject & HasEvents & LegacyInteroperability & Node & {
  /** The maximum number of times that the price rule can be allocated onto an order. */
  readonly allocationLimit?: Maybe<Scalars['Int']>;
  /** The method by which the price rule's value is allocated to its entitled items. */
  readonly allocationMethod: PriceRuleAllocationMethod;
  /** The application that created the price rule. */
  readonly app?: Maybe<App>;
  /**
   * The
   * [discount classes](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that you can use in combination with
   * [Shopify discount types](https://help.shopify.com/manual/discounts/discount-types).
   */
  readonly combinesWith: DiscountCombinesWith;
  /** The date and time when the price rule was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The customers that can use this price rule. */
  readonly customerSelection: PriceRuleCustomerSelection;
  /**
   * The
   * [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
   * that's used to control how discounts can be combined.
   */
  readonly discountClass: DiscountClass;
  /** List of the price rule's discount codes. */
  readonly discountCodes: PriceRuleDiscountCodeConnection;
  /** How many discount codes associated with the price rule. */
  readonly discountCodesCount?: Maybe<Count>;
  /** The date and time when the price rule ends. For open-ended price rules, use `null`. */
  readonly endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Quantity of prerequisite items required for the price rule to be applicable,  compared to quantity of entitled items.
   * @deprecated Use `prerequisiteToEntitlementQuantityRatio` instead.
   */
  readonly entitlementToPrerequisiteQuantityRatio?: Maybe<PriceRuleEntitlementToPrerequisiteQuantityRatio>;
  /** The paginated list of events associated with the price rule. */
  readonly events: EventConnection;
  /** A list of the price rule's features. */
  readonly features: ReadonlyArray<PriceRuleFeature>;
  /** Indicates whether there are any timeline comments on the price rule. */
  readonly hasTimelineComment: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The items to which the price rule applies. */
  readonly itemEntitlements: PriceRuleItemEntitlements;
  /** The items required for the price rule to be applicable. */
  readonly itemPrerequisites: PriceRuleLineItemPrerequisites;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** Whether the price rule can be applied only once per customer. */
  readonly oncePerCustomer: Scalars['Boolean'];
  /** The number of the entitled items must fall within this range for the price rule to be applicable. */
  readonly prerequisiteQuantityRange?: Maybe<PriceRuleQuantityRange>;
  /** The shipping cost must fall within this range for the price rule to be applicable. */
  readonly prerequisiteShippingPriceRange?: Maybe<PriceRuleMoneyRange>;
  /** The sum of the entitled items subtotal prices must fall within this range for the price rule to be applicable. */
  readonly prerequisiteSubtotalRange?: Maybe<PriceRuleMoneyRange>;
  /** Quantity of prerequisite items required for the price rule to be applicable,  compared to quantity of entitled items. */
  readonly prerequisiteToEntitlementQuantityRatio?: Maybe<PriceRulePrerequisiteToEntitlementQuantityRatio>;
  /** URLs that can be used to share the discount. */
  readonly shareableUrls: ReadonlyArray<PriceRuleShareableUrl>;
  /** The shipping lines to which the price rule applies. */
  readonly shippingEntitlements: PriceRuleShippingLineEntitlements;
  /** The date and time when the price rule starts. */
  readonly startsAt: Scalars['DateTime'];
  /** The status of the price rule. */
  readonly status: PriceRuleStatus;
  /** A detailed summary of the price rule. */
  readonly summary?: Maybe<Scalars['String']>;
  /** The type of lines (line_item or shipping_line) to which the price rule applies. */
  readonly target: PriceRuleTarget;
  /** The title of the price rule. */
  readonly title: Scalars['String'];
  /** The total sales from orders where the price rule was used. */
  readonly totalSales?: Maybe<MoneyV2>;
  /**
   * A list of the price rule's features.
   * @deprecated Use `features` instead.
   */
  readonly traits: ReadonlyArray<PriceRuleTrait>;
  /** The number of times that the price rule has been used. This value is updated asynchronously and can be different than the actual usage count. */
  readonly usageCount: Scalars['Int'];
  /** The maximum number of times that the price rule can be used in total. */
  readonly usageLimit?: Maybe<Scalars['Int']>;
  /** A time period during which a price rule is applicable. */
  readonly validityPeriod: PriceRuleValidityPeriod;
  /**
   * The value of the price rule.
   * @deprecated Use `valueV2` instead.
   */
  readonly value: PriceRuleValue;
  /** The value of the price rule. */
  readonly valueV2: PricingValue;
};


/**
 * Price rules are a set of conditions, including entitlements and prerequisites, that must be met in order for a discount code to apply.
 *
 * We recommend using the types and queries detailed at [Getting started with discounts](https://shopify.dev/docs/apps/selling-strategies/discounts/getting-started) instead. These will replace the GraphQL `PriceRule` object and REST Admin `PriceRule` and `DiscountCode` resources.
 */
export type PriceRuleDiscountCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};


/**
 * Price rules are a set of conditions, including entitlements and prerequisites, that must be met in order for a discount code to apply.
 *
 * We recommend using the types and queries detailed at [Getting started with discounts](https://shopify.dev/docs/apps/selling-strategies/discounts/getting-started) instead. These will replace the GraphQL `PriceRule` object and REST Admin `PriceRule` and `DiscountCode` resources.
 */
export type PriceRuleEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};

/** The method by which the price rule's value is allocated to its entitled items. */
export enum PriceRuleAllocationMethod {
  /** The value will be applied once across the entitled items. */
  ACROSS = 'ACROSS',
  /** The value will be applied to each of the entitled items. */
  EACH = 'EACH'
}

/** A selection of customers for whom the price rule applies. */
export type PriceRuleCustomerSelection = {
  /** List of customers to whom the price rule applies. */
  readonly customers: CustomerConnection;
  /** Whether the price rule applies to all customers. */
  readonly forAllCustomers: Scalars['Boolean'];
  /** A list of customer segments that contain the customers who can use the price rule. */
  readonly segments: ReadonlyArray<Segment>;
};


/** A selection of customers for whom the price rule applies. */
export type PriceRuleCustomerSelectionCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<CustomerSortKeys>;
};

/** A discount code of a price rule. */
export type PriceRuleDiscountCode = Node & {
  /** The application that created the discount code. */
  readonly app?: Maybe<App>;
  /** The code to apply the discount. */
  readonly code: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The number of times that the price rule has been used. This value is updated asynchronously and can be different than the actual usage count. */
  readonly usageCount: Scalars['Int'];
};

/** An auto-generated type for paginating through multiple PriceRuleDiscountCodes. */
export type PriceRuleDiscountCodeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<PriceRuleDiscountCodeEdge>;
  /** A list of nodes that are contained in PriceRuleDiscountCodeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<PriceRuleDiscountCode>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one PriceRuleDiscountCode and a cursor during pagination. */
export type PriceRuleDiscountCodeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of PriceRuleDiscountCodeEdge. */
  readonly node: PriceRuleDiscountCode;
};

/** Quantity of prerequisite items required for the price rule to be applicable, compared to quantity of entitled items. */
export type PriceRuleEntitlementToPrerequisiteQuantityRatio = {
  /** The quantity of entitled items in the ratio. */
  readonly entitlementQuantity: Scalars['Int'];
  /** The quantity of prerequisite items in the ratio. */
  readonly prerequisiteQuantity: Scalars['Int'];
};

/** The list of features that can be supported by a price rule. */
export enum PriceRuleFeature {
  /** The price rule supports bulk discounts. */
  BULK = 'BULK',
  /** The price rule supports Buy X, Get Y (BXGY) discounts. */
  BUY_ONE_GET_ONE = 'BUY_ONE_GET_ONE',
  /** The price rule supports Buy X, Get Y (BXGY) discounts that specify a custom allocation limit. */
  BUY_ONE_GET_ONE_WITH_ALLOCATION_LIMIT = 'BUY_ONE_GET_ONE_WITH_ALLOCATION_LIMIT',
  /** The price rule supports discounts that require a quantity. */
  QUANTITY_DISCOUNTS = 'QUANTITY_DISCOUNTS',
  /** The price rule targets specific customers. */
  SPECIFIC_CUSTOMERS = 'SPECIFIC_CUSTOMERS'
}

/** The value of a fixed amount price rule. */
export type PriceRuleFixedAmountValue = {
  /** The monetary value of the price rule. */
  readonly amount: Scalars['Money'];
};

/** The items to which this price rule applies. This may be multiple products, product variants, collections or combinations of the aforementioned. */
export type PriceRuleItemEntitlements = {
  /** The collections to which the price rule applies. */
  readonly collections: CollectionConnection;
  /** The product variants to which the price rule applies. */
  readonly productVariants: ProductVariantConnection;
  /** The products to which the price rule applies. */
  readonly products: ProductConnection;
  /** Whether the price rule applies to all line items. */
  readonly targetAllLineItems: Scalars['Boolean'];
};


/** The items to which this price rule applies. This may be multiple products, product variants, collections or combinations of the aforementioned. */
export type PriceRuleItemEntitlementsCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The items to which this price rule applies. This may be multiple products, product variants, collections or combinations of the aforementioned. */
export type PriceRuleItemEntitlementsProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The items to which this price rule applies. This may be multiple products, product variants, collections or combinations of the aforementioned. */
export type PriceRuleItemEntitlementsProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Single or multiple line item products, product variants or collections required for the price rule to be applicable, can also be provided in combination. */
export type PriceRuleLineItemPrerequisites = {
  /** The collections required for the price rule to be applicable. */
  readonly collections: CollectionConnection;
  /** The product variants required for the price rule to be applicable. */
  readonly productVariants: ProductVariantConnection;
  /** The products required for the price rule to be applicable. */
  readonly products: ProductConnection;
};


/** Single or multiple line item products, product variants or collections required for the price rule to be applicable, can also be provided in combination. */
export type PriceRuleLineItemPrerequisitesCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Single or multiple line item products, product variants or collections required for the price rule to be applicable, can also be provided in combination. */
export type PriceRuleLineItemPrerequisitesProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Single or multiple line item products, product variants or collections required for the price rule to be applicable, can also be provided in combination. */
export type PriceRuleLineItemPrerequisitesProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** A money range within which the price rule is applicable. */
export type PriceRuleMoneyRange = {
  /** The lower bound of the money range. */
  readonly greaterThan?: Maybe<Scalars['Money']>;
  /** The lower bound or equal of the money range. */
  readonly greaterThanOrEqualTo?: Maybe<Scalars['Money']>;
  /** The upper bound of the money range. */
  readonly lessThan?: Maybe<Scalars['Money']>;
  /** The upper bound or equal of the money range. */
  readonly lessThanOrEqualTo?: Maybe<Scalars['Money']>;
};

/** The value of a percent price rule. */
export type PriceRulePercentValue = {
  /** The percent value of the price rule. */
  readonly percentage: Scalars['Float'];
};

/** Quantity of prerequisite items required for the price rule to be applicable, compared to quantity of entitled items. */
export type PriceRulePrerequisiteToEntitlementQuantityRatio = {
  /** The quantity of entitled items in the ratio. */
  readonly entitlementQuantity: Scalars['Int'];
  /** The quantity of prerequisite items in the ratio. */
  readonly prerequisiteQuantity: Scalars['Int'];
};

/** A quantity range within which the price rule is applicable. */
export type PriceRuleQuantityRange = {
  /** The lower bound of the quantity range. */
  readonly greaterThan?: Maybe<Scalars['Int']>;
  /** The lower bound or equal of the quantity range. */
  readonly greaterThanOrEqualTo?: Maybe<Scalars['Int']>;
  /** The upper bound of the quantity range. */
  readonly lessThan?: Maybe<Scalars['Int']>;
  /** The upper bound or equal of the quantity range. */
  readonly lessThanOrEqualTo?: Maybe<Scalars['Int']>;
};

/** Shareable URL for the discount code associated with the price rule. */
export type PriceRuleShareableUrl = {
  /** The image URL of the item (product or collection) to which the discount applies. */
  readonly targetItemImage?: Maybe<Image>;
  /** The type of page that's associated with the URL. */
  readonly targetType: PriceRuleShareableUrlTargetType;
  /** The title of the page that's associated with the URL. */
  readonly title: Scalars['String'];
  /** The URL for the discount code. */
  readonly url: Scalars['URL'];
};

/** The type of page where a shareable price rule URL lands. */
export enum PriceRuleShareableUrlTargetType {
  /** The URL lands on a collection page. */
  COLLECTION = 'COLLECTION',
  /** The URL lands on a home page. */
  HOME = 'HOME',
  /** The URL lands on a product page. */
  PRODUCT = 'PRODUCT'
}

/** The shipping lines to which the price rule applies to. */
export type PriceRuleShippingLineEntitlements = {
  /** The codes for the countries to which the price rule applies to. */
  readonly countryCodes: ReadonlyArray<CountryCode>;
  /** Whether the price rule is applicable to countries that haven't been defined in the shop's shipping zones. */
  readonly includeRestOfWorld: Scalars['Boolean'];
  /** Whether the price rule applies to all shipping lines. */
  readonly targetAllShippingLines: Scalars['Boolean'];
};

/** The status of the price rule. */
export enum PriceRuleStatus {
  /** The price rule is active. */
  ACTIVE = 'ACTIVE',
  /** The price rule is expired. */
  EXPIRED = 'EXPIRED',
  /** The price rule is scheduled. */
  SCHEDULED = 'SCHEDULED'
}

/** The type of lines (line_item or shipping_line) to which the price rule applies. */
export enum PriceRuleTarget {
  /** The price rule applies to line items. */
  LINE_ITEM = 'LINE_ITEM',
  /** The price rule applies to shipping lines. */
  SHIPPING_LINE = 'SHIPPING_LINE'
}

/** The list of features that can be supported by a price rule. */
export enum PriceRuleTrait {
  /** The price rule supports bulk discounts. */
  BULK = 'BULK',
  /** The price rule supports Buy X, Get Y (BXGY) discounts. */
  BUY_ONE_GET_ONE = 'BUY_ONE_GET_ONE',
  /** The price rule supports Buy X, Get Y (BXGY) discounts that specify a custom allocation limit. */
  BUY_ONE_GET_ONE_WITH_ALLOCATION_LIMIT = 'BUY_ONE_GET_ONE_WITH_ALLOCATION_LIMIT',
  /** The price rule supports discounts that require a quantity. */
  QUANTITY_DISCOUNTS = 'QUANTITY_DISCOUNTS',
  /** The price rule targets specific customers. */
  SPECIFIC_CUSTOMERS = 'SPECIFIC_CUSTOMERS'
}

/** A time period during which a price rule is applicable. */
export type PriceRuleValidityPeriod = {
  /** The time after which the price rule becomes invalid. */
  readonly end?: Maybe<Scalars['DateTime']>;
  /** The time after which the price rule is valid. */
  readonly start: Scalars['DateTime'];
};

/** The type of the price rule value. The price rule value might be a percentage value, or a fixed amount. */
export type PriceRuleValue = PriceRuleFixedAmountValue | PriceRulePercentValue;

/**
 * One type of value given to a customer when a discount is applied to an order.
 * The application of a discount with this value gives the customer the specified percentage off a specified item.
 */
export type PricingPercentageValue = {
  /** The percentage value of the object. This is a number between -100 (free) and 0 (no discount). */
  readonly percentage: Scalars['Float'];
};

/** The type of value given to a customer when a discount is applied to an order. For example, the application of the discount might give the customer a percentage off a specified item. Alternatively, the application of the discount might give the customer a monetary value in a given currency off an order. */
export type PricingValue = MoneyV2 | PricingPercentageValue;

/**
 * Private metafields represent custom metadata that is attached to a resource.
 * Private metafields are accessible only by the application that created them and only from the GraphQL Admin API.
 *
 * An application can create a maximum of 10 private metafields per shop resource.
 *
 * Private metafields are deprecated. Metafields created using a reserved namespace are private by default. See our guide for
 * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
 */
export type PrivateMetafield = Node & {
  /** The date and time when the private metafield was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The ID of the private metafield. */
  readonly id: Scalars['ID'];
  /** The key name of the private metafield. */
  readonly key: Scalars['String'];
  /** The namespace of the private metafield. */
  readonly namespace: Scalars['String'];
  /** The date and time when the private metafield was updated. */
  readonly updatedAt: Scalars['DateTime'];
  /** The value of a private metafield. */
  readonly value: Scalars['String'];
  /** Represents the private metafield value type. */
  readonly valueType: PrivateMetafieldValueType;
};

/** An auto-generated type for paginating through multiple PrivateMetafields. */
export type PrivateMetafieldConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<PrivateMetafieldEdge>;
  /** A list of nodes that are contained in PrivateMetafieldEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<PrivateMetafield>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for the private metafield to delete. */
export type PrivateMetafieldDeleteInput = {
  /** The key of the private metafield. */
  readonly key: Scalars['String'];
  /** The namespace of the private metafield. */
  readonly namespace: Scalars['String'];
  /** The ID of the resource that owns the metafield. If the field is blank, then the `Shop` resource owns the metafield. */
  readonly owner?: InputMaybe<Scalars['ID']>;
};

/** Return type for `privateMetafieldDelete` mutation. */
export type PrivateMetafieldDeletePayload = {
  /** The ID of private metafield that was deleted. */
  readonly deletedPrivateMetafieldId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one PrivateMetafield and a cursor during pagination. */
export type PrivateMetafieldEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of PrivateMetafieldEdge. */
  readonly node: PrivateMetafield;
};

/** The input fields for a private metafield. */
export type PrivateMetafieldInput = {
  /** The key of the private metafield. */
  readonly key: Scalars['String'];
  /** The namespace of the private metafield. */
  readonly namespace: Scalars['String'];
  /** The resource that owns the metafield. If the field is blank, then the `Shop` resource owns the metafield. */
  readonly owner?: InputMaybe<Scalars['ID']>;
  /** The `value` and `valueType` of the private metafield, wrapped in a `ValueInput` object. */
  readonly valueInput: PrivateMetafieldValueInput;
};

/** Return type for `privateMetafieldUpsert` mutation. */
export type PrivateMetafieldUpsertPayload = {
  /** The private metafield that was created or updated. */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for the value and value type of the private metafield. */
export type PrivateMetafieldValueInput = {
  /** The value of a private metafield. */
  readonly value: Scalars['String'];
  /** Represents the private metafield value type. */
  readonly valueType: PrivateMetafieldValueType;
};

/** Supported private metafield value types. */
export enum PrivateMetafieldValueType {
  /** An integer metafield. */
  INTEGER = 'INTEGER',
  /** A JSON string metafield. */
  JSON_STRING = 'JSON_STRING',
  /** A string metafield. */
  STRING = 'STRING'
}

/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type Product = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & LegacyInteroperability & Navigable & Node & OnlineStorePreviewable & Publishable & {
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  readonly availablePublicationsCount?: Maybe<Count>;
  /**
   * The description of the product, with
   * HTML tags. For example, the description might include
   * bold `<strong></strong>` and italic `<i></i>` text.
   * @deprecated Use `descriptionHtml` instead.
   */
  readonly bodyHtml?: Maybe<Scalars['String']>;
  /**
   * A list of [components](https://shopify.dev/docs/apps/build/product-merchandising/bundles/add-product-fixed-bundle)
   * that are associated with a product in a bundle.
   */
  readonly bundleComponents: ProductBundleComponentConnection;
  /**
   * The category of a product
   * from [Shopify's Standard Product Taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17).
   */
  readonly category?: Maybe<TaxonomyCategory>;
  /**
   * A list of [collections](https://shopify.dev/docs/api/admin-graphql/latest/objects/Collection)
   * that include the product.
   */
  readonly collections: CollectionConnection;
  /**
   * A special product type that combines separate products from a store into a single product listing.
   * [Combined listings](https://shopify.dev/apps/build/product-merchandising/combined-listings) are connected
   * by a shared option, such as color, model, or dimension.
   */
  readonly combinedListing?: Maybe<CombinedListing>;
  /**
   * The [role of the product](https://shopify.dev/docs/apps/build/product-merchandising/combined-listings/build-for-combined-listings)
   * in a combined listing.
   *
   * If `null`, then the product isn't part of any combined listing.
   */
  readonly combinedListingRole?: Maybe<CombinedListingsRole>;
  /**
   * The [compare-at price range](https://help.shopify.com/manual/products/details/product-pricing/sale-pricing)
   * of the product in the shop's default currency.
   */
  readonly compareAtPriceRange?: Maybe<ProductCompareAtPriceRange>;
  /** The pricing that applies to a customer in a specific context. For example, a price might vary depending on the customer's location. As of API version 2025-04, only active markets are considered in the price resolution. */
  readonly contextualPricing: ProductContextualPricing;
  /** The date and time when the product was created. */
  readonly createdAt: Scalars['DateTime'];
  /**
   * The custom product type specified by the merchant.
   * @deprecated Deprecated in API version 2022-10. Use `productType` instead.
   */
  readonly customProductType?: Maybe<Scalars['String']>;
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /**
   * A single-line description of the product,
   * with [HTML tags](https://developer.mozilla.org/en-US/docs/Web/HTML) removed.
   */
  readonly description: Scalars['String'];
  /**
   * The description of the product, with
   * HTML tags. For example, the description might include
   * bold `<strong></strong>` and italic `<i></i>` text.
   */
  readonly descriptionHtml: Scalars['HTML'];
  /**
   * Stripped description of the product, single line with HTML tags removed.
   * Truncated to 60 characters.
   * @deprecated Use `description` instead.
   */
  readonly descriptionPlainSummary: Scalars['String'];
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /**
   * The featured image for the product.
   * @deprecated Use `featuredMedia` instead.
   */
  readonly featuredImage?: Maybe<Image>;
  /**
   * The featured [media](https://shopify.dev/docs/apps/build/online-store/product-media)
   * associated with the product.
   */
  readonly featuredMedia?: Maybe<Media>;
  /**
   * The information that lets merchants know what steps they need to take
   * to make sure that the app is set up correctly.
   *
   * For example, if a merchant hasn't set up a product correctly in the app,
   * then the feedback might include a message that says "You need to add a price
   * to this product".
   */
  readonly feedback?: Maybe<ResourceFeedback>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view the gift card in a store. */
  readonly giftCardTemplateSuffix?: Maybe<Scalars['String']>;
  /**
   * A unique, human-readable string of the product's title. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * The handle is used in the online store URL for the product.
   */
  readonly handle: Scalars['String'];
  /** Whether the product has only a single variant with the default option and value. */
  readonly hasOnlyDefaultVariant: Scalars['Boolean'];
  /** Whether the product has variants that are out of stock. */
  readonly hasOutOfStockVariants: Scalars['Boolean'];
  /**
   * Whether at least one of the product variants requires
   * [bundle components](https://shopify.dev/docs/apps/build/product-merchandising/bundles/add-product-fixed-bundle).
   *
   * Learn more about
   * [store eligibility for bundles](https://shopify.dev/docs/apps/build/product-merchandising/bundles#store-eligibility).
   */
  readonly hasVariantsThatRequiresComponents: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The images associated with the product.
   * @deprecated Use `media` instead.
   */
  readonly images: ImageConnection;
  /**
   * Whether the product
   * is in a specified
   * [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
   */
  readonly inCollection: Scalars['Boolean'];
  /** Whether the product is a gift card. */
  readonly isGiftCard: Scalars['Boolean'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The [media](https://shopify.dev/docs/apps/build/online-store/product-media) associated with the product. Valid media are images, 3D models, videos. */
  readonly media: MediaConnection;
  /**
   * The total count of [media](https://shopify.dev/docs/apps/build/online-store/product-media)
   * that's associated with a product.
   */
  readonly mediaCount?: Maybe<Count>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** The [preview URL](https://help.shopify.com/manual/online-store/setting-up#preview-your-store) for the online store. */
  readonly onlineStorePreviewUrl?: Maybe<Scalars['URL']>;
  /**
   * The product's URL on the online store.
   * If `null`, then the product isn't published to the online store sales channel.
   */
  readonly onlineStoreUrl?: Maybe<Scalars['URL']>;
  /**
   * A list of product options. The limit is defined by the
   * [shop's resource limits for product options](https://shopify.dev/docs/api/admin-graphql/latest/objects/Shop#field-resourcelimits) (`Shop.resourceLimits.maxProductOptions`).
   */
  readonly options: ReadonlyArray<ProductOption>;
  /**
   * The price range of the product.
   * @deprecated Deprecated in API version 2020-10. Use `priceRangeV2` instead.
   */
  readonly priceRange: ProductPriceRange;
  /**
   * The minimum and maximum prices of a product, expressed in decimal numbers.
   * For example, if the product is priced between $10.00 and $50.00,
   * then the price range is $10.00 - $50.00.
   */
  readonly priceRangeV2: ProductPriceRangeV2;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /**
   * The product category specified by the merchant.
   * @deprecated Deprecated in API version 2024-04. Use `category` instead.
   */
  readonly productCategory?: Maybe<ProductCategory>;
  /**
   * A list of the channels where the product is published.
   * @deprecated Use `resourcePublications` instead.
   */
  readonly productPublications: ProductPublicationConnection;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  readonly productType: Scalars['String'];
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * @deprecated Use `resourcePublicationsCount` instead.
   */
  readonly publicationCount: Scalars['Int'];
  /**
   * A list of the channels where the product is published.
   * @deprecated Use `resourcePublications` instead.
   */
  readonly publications: ProductPublicationConnection;
  /** The date and time when the product was published to the online store. */
  readonly publishedAt?: Maybe<Scalars['DateTime']>;
  /** Whether the product is published for a customer only in a specified context. For example, a product might be published for a customer only in a specific location. */
  readonly publishedInContext: Scalars['Boolean'];
  /**
   * Whether the resource is published to a specific channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  readonly publishedOnChannel: Scalars['Boolean'];
  /**
   * Whether the resource is published to a
   * [channel](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel).
   * For example, the resource might be published to the online store channel.
   * @deprecated Use `publishedOnCurrentPublication` instead.
   */
  readonly publishedOnCurrentChannel: Scalars['Boolean'];
  /**
   * Whether the resource is published to the app's
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * For example, the resource might be published to the app's online store channel.
   */
  readonly publishedOnCurrentPublication: Scalars['Boolean'];
  /**
   * Whether the resource is published to a specified
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly publishedOnPublication: Scalars['Boolean'];
  /**
   * Whether the product can only be purchased with
   * a [selling plan](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   * Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores.
   * If you update a product to be subscription-only (`requiresSellingPlan:false`), then the product is unpublished from all channels, except the online store.
   */
  readonly requiresSellingPlan: Scalars['Boolean'];
  /**
   * The resource that's either published or staged to be published to
   * the [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly resourcePublicationOnCurrentPublication?: Maybe<ResourcePublicationV2>;
  /**
   * The list of resources that are published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly resourcePublications: ResourcePublicationConnection;
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  readonly resourcePublicationsCount?: Maybe<Count>;
  /**
   * The list of resources that are either published or staged to be published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly resourcePublicationsV2: ResourcePublicationV2Connection;
  /**
   * Whether the merchant can make changes to the product when they
   * [edit the order](https://shopify.dev/docs/apps/build/orders-fulfillment/order-management-apps/edit-orders)
   * associated with the product. For example, a merchant might be restricted from changing product details when they
   * edit an order.
   */
  readonly restrictedForResource?: Maybe<RestrictedForResource>;
  /**
   * A count of [selling plan groups](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan)
   * that are associated with the product.
   * @deprecated Use `sellingPlanGroupsCount` instead.
   */
  readonly sellingPlanGroupCount: Scalars['Int'];
  /**
   * A list of all [selling plan groups](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan)
   * that are associated with the product either directly, or through the product's variants.
   */
  readonly sellingPlanGroups: SellingPlanGroupConnection;
  /**
   * A count of [selling plan groups](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans/build-a-selling-plan)
   * that are associated with the product.
   */
  readonly sellingPlanGroupsCount?: Maybe<Count>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  readonly seo: Seo;
  /**
   * The standardized product type in the Shopify product taxonomy.
   * @deprecated Deprecated in API version 2022-10. Use `productCategory` instead.
   */
  readonly standardizedProductType?: Maybe<StandardizedProductType>;
  /**
   * The [product status](https://help.shopify.com/manual/products/details/product-details-page#product-status),
   * which controls visibility across all sales channels.
   */
  readonly status: ProductStatus;
  /**
   * The Storefront GraphQL API ID of the `Product`.
   *
   * As of the `2022-04` version release, the Storefront GraphQL API will no longer return Base64 encoded IDs to match the behavior of the Admin GraphQL API. Therefore, you can safely use the `id` field's value instead.
   * @deprecated Use `id` instead.
   */
  readonly storefrontId: Scalars['StorefrontID'];
  /**
   * A comma-separated list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites
   * any existing tags that were previously added to the product. To add new tags without overwriting
   * existing tags, use the [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  readonly tags: ReadonlyArray<Scalars['String']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view the product in a store. */
  readonly templateSuffix?: Maybe<Scalars['String']>;
  /**
   * The name for the product that displays to customers. The title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly title: Scalars['String'];
  /** The quantity of inventory that's in stock. */
  readonly totalInventory: Scalars['Int'];
  /**
   * The number of [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * that are associated with the product.
   * @deprecated Use `variantsCount` instead.
   */
  readonly totalVariants: Scalars['Int'];
  /**
   * Whether [inventory tracking](https://help.shopify.com/manual/products/inventory/getting-started-with-inventory/set-up-inventory-tracking)
   * has been enabled for the product.
   */
  readonly tracksInventory: Scalars['Boolean'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /**
   * The list of channels that the resource is not published to.
   * @deprecated Use `unpublishedPublications` instead.
   */
  readonly unpublishedChannels: ChannelConnection;
  /**
   * The list of [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that the resource isn't published to.
   */
  readonly unpublishedPublications: PublicationConnection;
  /**
   * The date and time when the product was last modified.
   * A product's `updatedAt` value can change for different reasons. For example, if an order
   * is placed for a product that has inventory tracking set up, then the inventory adjustment
   * is counted as an update.
   */
  readonly updatedAt: Scalars['DateTime'];
  /** A list of [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant) associated with the product. */
  readonly variants: ProductVariantConnection;
  /**
   * The number of [variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/ProductVariant)
   * that are associated with the product.
   */
  readonly variantsCount?: Maybe<Count>;
  /** The name of the product's vendor. */
  readonly vendor: Scalars['String'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductBundleComponentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CollectionSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductContextualPricingArgs = {
  context: ContextualPricingContext;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductImageSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductInCollectionArgs = {
  id: Scalars['ID'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductMediaArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductMediaSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductOptionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductProductPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublicationCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublishedInContextArgs = {
  context: ContextualPublicationContext;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublishedOnChannelArgs = {
  channelId: Scalars['ID'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductPublishedOnPublicationArgs = {
  publicationId: Scalars['ID'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductResourcePublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductResourcePublicationsCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductResourcePublicationsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductRestrictedForResourceArgs = {
  calculatedOrderId: Scalars['ID'];
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductUnpublishedChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductUnpublishedPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * The `Product` object lets you manage products in a merchant’s store.
 *
 * Products are the goods and services that merchants offer to customers. They can include various details such as title, description, price, images, and options such as size or color.
 * You can use [product variants](https://shopify.dev/docs/api/admin-graphql/latest/objects/productvariant) to create or update different versions of the same product.
 * You can also add or update product [media](https://shopify.dev/docs/api/admin-graphql/latest/interfaces/media).
 * Products can be organized by grouping them into a [collection](https://shopify.dev/docs/api/admin-graphql/latest/objects/collection).
 *
 * Learn more about working with [Shopify's product model](https://shopify.dev/docs/apps/build/graphql/migrate/new-product-model/product-model-components),
 * including limitations and considerations.
 */
export type ProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductVariantSortKeys>;
};

/** The product's component information. */
export type ProductBundleComponent = {
  /** The product that's related as a component. */
  readonly componentProduct: Product;
  /** The list of products' variants that are components. */
  readonly componentVariants: ProductVariantConnection;
  /** The number of component variants for the product component. */
  readonly componentVariantsCount?: Maybe<Count>;
  /**
   * The options in the parent and the component options they're connected to, along with the chosen option values
   * that appear in the bundle.
   */
  readonly optionSelections: ReadonlyArray<ProductBundleComponentOptionSelection>;
  /**
   * The quantity of the component product set for this bundle line.
   * It will be null if there's a quantityOption present.
   */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** The quantity as option of the component product. It will be null if there's a quantity set. */
  readonly quantityOption?: Maybe<ProductBundleComponentQuantityOption>;
};


/** The product's component information. */
export type ProductBundleComponentComponentVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple ProductBundleComponents. */
export type ProductBundleComponentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ProductBundleComponentEdge>;
  /** A list of nodes that are contained in ProductBundleComponentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ProductBundleComponent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductBundleComponent and a cursor during pagination. */
export type ProductBundleComponentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ProductBundleComponentEdge. */
  readonly node: ProductBundleComponent;
};

/** The input fields for a single component related to a componentized product. */
export type ProductBundleComponentInput = {
  /** The options to use in the component product, and the values for the option. */
  readonly optionSelections: ReadonlyArray<ProductBundleComponentOptionSelectionInput>;
  /** The ID of the component product to add to the bundle product. */
  readonly productId: Scalars['ID'];
  /** The quantity of the component product to add to the bundle product. This field can't exceed 2000. */
  readonly quantity?: InputMaybe<Scalars['Int']>;
  /**
   * New option to be created on the bundle parent that enables the buyer to select different quantities for
   * this component (e.g. two-pack, three-pack). Can only be used if quantity isn't set.
   */
  readonly quantityOption?: InputMaybe<ProductBundleComponentQuantityOptionInput>;
};

/** A relationship between a component option and a parent option. */
export type ProductBundleComponentOptionSelection = {
  /** The option that existed on the component product prior to the fixed bundle creation. */
  readonly componentOption: ProductOption;
  /** The option that was created on the parent product. */
  readonly parentOption?: Maybe<ProductOption>;
  /** The component option values that are actively selected for this relationship. */
  readonly values: ReadonlyArray<ProductBundleComponentOptionSelectionValue>;
};

/** The input fields for a single option related to a component product. */
export type ProductBundleComponentOptionSelectionInput = {
  /** The ID of the option present on the component product. */
  readonly componentOptionId: Scalars['ID'];
  /** The name to create for this option on the parent product. */
  readonly name: Scalars['String'];
  /** Array of selected option values. */
  readonly values: ReadonlyArray<Scalars['String']>;
};

/** The status of a component option value related to a bundle. */
export enum ProductBundleComponentOptionSelectionStatus {
  /** The component option value is not selected as sellable in the bundle. */
  DESELECTED = 'DESELECTED',
  /** The component option value was not initially selected, but is now available for the bundle. */
  NEW = 'NEW',
  /** The component option value is selected as sellable in the bundle. */
  SELECTED = 'SELECTED',
  /** The component option value was selected, is no longer available for the bundle. */
  UNAVAILABLE = 'UNAVAILABLE'
}

/** A component option value related to a bundle line. */
export type ProductBundleComponentOptionSelectionValue = {
  /** Selection status of the option. */
  readonly selectionStatus: ProductBundleComponentOptionSelectionStatus;
  /** The value of the option. */
  readonly value: Scalars['String'];
};

/** A quantity option related to a bundle. */
export type ProductBundleComponentQuantityOption = {
  /** The name of the option value. */
  readonly name: Scalars['String'];
  /** The option that was created on the parent product. */
  readonly parentOption?: Maybe<ProductOption>;
  /** The quantity values of the option. */
  readonly values: ReadonlyArray<ProductBundleComponentQuantityOptionValue>;
};

/** Input for the quantity option related to a component product. This will become a new option on the parent bundle product that doesn't have a corresponding option on the component. */
export type ProductBundleComponentQuantityOptionInput = {
  /** The option name to create on the parent product. */
  readonly name: Scalars['String'];
  /** Array of option values. */
  readonly values: ReadonlyArray<ProductBundleComponentQuantityOptionValueInput>;
};

/** A quantity option value related to a componentized product. */
export type ProductBundleComponentQuantityOptionValue = {
  /** The name of the option value. */
  readonly name: Scalars['String'];
  /** The quantity of the option value. */
  readonly quantity: Scalars['Int'];
};

/** The input fields for a single quantity option value related to a component product. */
export type ProductBundleComponentQuantityOptionValueInput = {
  /** The name associated with the option, e.g. one-pack, two-pack. */
  readonly name: Scalars['String'];
  /** How many of the variant will be included for the option value (e.g. two-pack has quantity 2). */
  readonly quantity: Scalars['Int'];
};

/** The input fields for creating a componentized product. */
export type ProductBundleCreateInput = {
  /** The component products to bundle with the bundle product. */
  readonly components: ReadonlyArray<ProductBundleComponentInput>;
  /** The title of the product to create. */
  readonly title: Scalars['String'];
};

/** Return type for `productBundleCreate` mutation. */
export type ProductBundleCreatePayload = {
  /** The asynchronous ProductBundleOperation creating the componentized product. */
  readonly productBundleOperation?: Maybe<ProductBundleOperation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Defines errors encountered while managing a product bundle. */
export type ProductBundleMutationUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductBundleMutationUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductBundleMutationUserError`. */
export enum ProductBundleMutationUserErrorCode {
  /** Something went wrong, please try again. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** Input is not valid. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** Error processing request in the background job. */
  JOB_ERROR = 'JOB_ERROR',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST'
}

/**
 * An entity that represents details of an asynchronous
 * [ProductBundleCreate](https://shopify.dev/api/admin-graphql/current/mutations/productBundleCreate) or
 * [ProductBundleUpdate](https://shopify.dev/api/admin-graphql/current/mutations/productBundleUpdate) mutation.
 *
 * By querying this entity with the
 * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query
 * using the ID that was returned when the bundle was created or updated, this can be used to check the status of an operation.
 *
 * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
 *
 * The `product` field provides the details of the created or updated product.
 *
 * The `userErrors` field provides mutation errors that occurred during the operation.
 */
export type ProductBundleOperation = Node & ProductOperation & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The product on which the operation is being performed. */
  readonly product?: Maybe<Product>;
  /** The status of this operation. */
  readonly status: ProductOperationStatus;
  /** Returns mutation errors occurred during background mutation processing. */
  readonly userErrors: ReadonlyArray<ProductBundleMutationUserError>;
};

/** The input fields for updating a componentized product. */
export type ProductBundleUpdateInput = {
  /** The components to update existing ones. If none provided, no changes occur. Note: This replaces, not adds to, current components. */
  readonly components?: InputMaybe<ReadonlyArray<ProductBundleComponentInput>>;
  /** The ID of the componentized product to update. */
  readonly productId: Scalars['ID'];
  /** The title to rename the componentized product to, if provided. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `productBundleUpdate` mutation. */
export type ProductBundleUpdatePayload = {
  /** The asynchronous ProductBundleOperation updating the componentized product. */
  readonly productBundleOperation?: Maybe<ProductBundleOperation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The details of a specific product category within the [Shopify product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). */
export type ProductCategory = {
  /** The product taxonomy node associated with the product category. */
  readonly productTaxonomyNode?: Maybe<ProductTaxonomyNode>;
};

/** Return type for `productChangeStatus` mutation. */
export type ProductChangeStatusPayload = {
  /** The product object. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductChangeStatusUserError>;
};

/** An error that occurs during the execution of `ProductChangeStatus`. */
export type ProductChangeStatusUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductChangeStatusUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductChangeStatusUserError`. */
export enum ProductChangeStatusUserErrorCode {
  /** Cannot be unarchived because combined listings are not compatible with this store. */
  COMBINED_LISTINGS_NOT_COMPATIBLE_WITH_SHOP = 'COMBINED_LISTINGS_NOT_COMPATIBLE_WITH_SHOP',
  /** Product could not be found. */
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND'
}

/** The input fields to claim ownership for Product features such as Bundles. */
export type ProductClaimOwnershipInput = {
  /**
   * Claiming ownership of bundles lets the app render a custom UI for the bundles' card on the
   * products details page in the Shopify admin.
   *
   * Bundle ownership can only be claimed when creating the product. If you create `ProductVariantComponents`
   * in any of its product variants, then the bundle ownership is automatically assigned to the app making the call.
   *
   * [Learn more](https://shopify.dev/docs/apps/selling-strategies/bundles/product-config).
   */
  readonly bundles?: InputMaybe<Scalars['Boolean']>;
};

/** The set of valid sort keys for products belonging to a collection. */
export enum ProductCollectionSortKeys {
  /** Sort by best selling. */
  BEST_SELLING = 'BEST_SELLING',
  /** Sort by collection default order. */
  COLLECTION_DEFAULT = 'COLLECTION_DEFAULT',
  /** Sort by creation time. */
  CREATED = 'CREATED',
  /** Sort by id. */
  ID = 'ID',
  /** Sort by manual order. */
  MANUAL = 'MANUAL',
  /** Sort by price. */
  PRICE = 'PRICE',
  /** Sort by relevance. */
  RELEVANCE = 'RELEVANCE',
  /** Sort by title. */
  TITLE = 'TITLE'
}

/** The compare-at price range of the product. */
export type ProductCompareAtPriceRange = {
  /** The highest variant's compare-at price. */
  readonly maxVariantCompareAtPrice: MoneyV2;
  /** The lowest variant's compare-at price. */
  readonly minVariantCompareAtPrice: MoneyV2;
};

/** An auto-generated type for paginating through multiple Products. */
export type ProductConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ProductEdge>;
  /** A list of nodes that are contained in ProductEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Product>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/**
 * The price of a product in a specific country.
 * Prices vary between countries.
 * Refer to [Product](https://shopify.dev/docs/api/admin-graphql/latest/queries/product?example=Get+the+price+range+for+a+product+for+buyers+from+Canada)
 * for more information on how to use this object.
 */
export type ProductContextualPricing = {
  /** The number of fixed quantity rules for the product's variants on the price list. */
  readonly fixedQuantityRulesCount: Scalars['Int'];
  /** The pricing of the variant with the highest price in the given context. */
  readonly maxVariantPricing?: Maybe<ProductVariantContextualPricing>;
  /** The pricing of the variant with the lowest price in the given context. */
  readonly minVariantPricing?: Maybe<ProductVariantContextualPricing>;
  /**
   * The minimum and maximum prices of a product, expressed in decimal numbers.
   * For example, if the product is priced between $10.00 and $50.00,
   * then the price range is $10.00 - $50.00.
   */
  readonly priceRange: ProductPriceRangeV2;
};

/** The input fields required to create a product. */
export type ProductCreateInput = {
  /**
   * The ID of the [category](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17)
   * that's associated with the product.
   */
  readonly category?: InputMaybe<Scalars['ID']>;
  /**
   * The input field to enable an app to provide additional product features.
   * For example, you can specify
   * [`bundles: true`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/ProductClaimOwnershipInput#field-bundles)
   * in the `claimOwnership` field to let an app add a
   * [product configuration extension](https://shopify.dev/docs/apps/build/product-merchandising/bundles/product-configuration-extension/add-merchant-config-ui).
   */
  readonly claimOwnership?: InputMaybe<ProductClaimOwnershipInput>;
  /** A list of collection IDs to associate with the product. */
  readonly collectionsToJoin?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The role of the product in a [combined listing](https://shopify.dev/apps/build/product-merchandising/combined-listings). */
  readonly combinedListingRole?: InputMaybe<CombinedListingsRole>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  readonly descriptionHtml?: InputMaybe<Scalars['String']>;
  /** Whether the product is a gift card. */
  readonly giftCard?: InputMaybe<Scalars['Boolean']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  readonly giftCardTemplateSuffix?: InputMaybe<Scalars['String']>;
  /**
   * A unique, human-readable string of the product's title. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * The handle is used in the online store URL for the product.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /**
   * The [custom fields](https://shopify.dev/docs/apps/build/custom-data) to associate with the product
   * for the purposes of adding and storing additional information.
   */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** A list of product options and option values. Maximum product options: three. There's no limit on the number of option values. */
  readonly productOptions?: InputMaybe<ReadonlyArray<OptionCreateInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  readonly productType?: InputMaybe<Scalars['String']>;
  /**
   * Whether the product can only be purchased with
   * a [selling plan](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   * Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores.
   * If you update a product to be subscription-only (`requiresSellingPlan:false`), then the product is unpublished from all channels except the online store.
   */
  readonly requiresSellingPlan?: InputMaybe<Scalars['Boolean']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  readonly seo?: InputMaybe<SeoInput>;
  /**
   * The [product status](https://help.shopify.com/manual/products/details/product-details-page#product-status),
   * which controls visibility across all sales channels.
   */
  readonly status?: InputMaybe<ProductStatus>;
  /**
   * A comma-separated list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /**
   * The name for the product that displays to customers. The title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly title?: InputMaybe<Scalars['String']>;
  /** The name of the product's vendor. */
  readonly vendor?: InputMaybe<Scalars['String']>;
};

/** Return type for `productCreateMedia` mutation. */
export type ProductCreateMediaPayload = {
  /** The newly created media. */
  readonly media?: Maybe<ReadonlyArray<Media>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly mediaUserErrors: ReadonlyArray<MediaUserError>;
  /** The product associated with the media. */
  readonly product?: Maybe<Product>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `mediaUserErrors` instead.
   */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `productCreate` mutation. */
export type ProductCreatePayload = {
  /** The product object. */
  readonly product?: Maybe<Product>;
  /** The shop associated with the product. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for specifying the product to delete. */
export type ProductDeleteInput = {
  /** The ID of the product. */
  readonly id: Scalars['ID'];
};

/** Return type for `productDeleteMedia` mutation. */
export type ProductDeleteMediaPayload = {
  /** List of media IDs which were deleted. */
  readonly deletedMediaIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** List of product image IDs which were deleted. */
  readonly deletedProductImageIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly mediaUserErrors: ReadonlyArray<MediaUserError>;
  /** The product associated with the deleted media. */
  readonly product?: Maybe<Product>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `mediaUserErrors` instead.
   */
  readonly userErrors: ReadonlyArray<UserError>;
};

/**
 * An entity that represents details of an asynchronous
 * [ProductDelete](https://shopify.dev/api/admin-graphql/current/mutations/productDelete) mutation.
 *
 * By querying this entity with the
 * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query
 * using the ID that was returned when the product was deleted, this can be used to check the status of an operation.
 *
 * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
 *
 * The `deletedProductId` field provides the ID of the deleted product.
 *
 * The `userErrors` field provides mutation errors that occurred during the operation.
 */
export type ProductDeleteOperation = Node & ProductOperation & {
  /** The ID of the deleted product. */
  readonly deletedProductId?: Maybe<Scalars['ID']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The product on which the operation is being performed. */
  readonly product?: Maybe<Product>;
  /** The status of this operation. */
  readonly status: ProductOperationStatus;
  /** Returns mutation errors occurred during background mutation processing. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `productDelete` mutation. */
export type ProductDeletePayload = {
  /** The ID of the deleted product. */
  readonly deletedProductId?: Maybe<Scalars['ID']>;
  /** The product delete operation, returned when run in asynchronous mode. */
  readonly productDeleteOperation?: Maybe<ProductDeleteOperation>;
  /** The shop associated with the product. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents a product duplication job. */
export type ProductDuplicateJob = {
  /** This indicates if the job is still queued or has been run. */
  readonly done: Scalars['Boolean'];
  /** A globally-unique ID that's returned when running an asynchronous mutation. */
  readonly id: Scalars['ID'];
};

/**
 * An entity that represents details of an asynchronous
 * [ProductDuplicate](https://shopify.dev/api/admin-graphql/current/mutations/productDuplicate) mutation.
 *
 * By querying this entity with the
 * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query
 * using the ID that was returned
 * [when the product was duplicated](https://shopify.dev/api/admin/migrate/new-product-model/sync-data#create-a-product-with-variants-and-options-asynchronously),
 * this can be used to check the status of an operation.
 *
 * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
 *
 * The `product` field provides the details of the original product.
 *
 * The `newProduct` field provides the details of the new duplicate of the product.
 *
 * The `userErrors` field provides mutation errors that occurred during the operation.
 */
export type ProductDuplicateOperation = Node & ProductOperation & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The newly created duplicate of the original product. */
  readonly newProduct?: Maybe<Product>;
  /** The product on which the operation is being performed. */
  readonly product?: Maybe<Product>;
  /** The status of this operation. */
  readonly status: ProductOperationStatus;
  /** Returns mutation errors occurred during background mutation processing. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `productDuplicate` mutation. */
export type ProductDuplicatePayload = {
  /** The asynchronous job that duplicates the product images. */
  readonly imageJob?: Maybe<Job>;
  /** The duplicated product. */
  readonly newProduct?: Maybe<Product>;
  /** The product duplicate operation, returned when run in asynchronous mode. */
  readonly productDuplicateOperation?: Maybe<ProductDuplicateOperation>;
  /** The user's shop. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one Product and a cursor during pagination. */
export type ProductEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ProductEdge. */
  readonly node: Product;
};

/** A product feed. */
export type ProductFeed = Node & {
  /** The country of the product feed. */
  readonly country?: Maybe<CountryCode>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The language of the product feed. */
  readonly language?: Maybe<LanguageCode>;
  /** The status of the product feed. */
  readonly status: ProductFeedStatus;
};

/** An auto-generated type for paginating through multiple ProductFeeds. */
export type ProductFeedConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ProductFeedEdge>;
  /** A list of nodes that are contained in ProductFeedEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ProductFeed>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `productFeedCreate` mutation. */
export type ProductFeedCreatePayload = {
  /** The newly created product feed. */
  readonly productFeed?: Maybe<ProductFeed>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductFeedCreateUserError>;
};

/** An error that occurs during the execution of `ProductFeedCreate`. */
export type ProductFeedCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductFeedCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductFeedCreateUserError`. */
export enum ProductFeedCreateUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The input value is already taken. */
  TAKEN = 'TAKEN'
}

/** Return type for `productFeedDelete` mutation. */
export type ProductFeedDeletePayload = {
  /** The ID of the product feed that was deleted. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductFeedDeleteUserError>;
};

/** An error that occurs during the execution of `ProductFeedDelete`. */
export type ProductFeedDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductFeedDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductFeedDeleteUserError`. */
export enum ProductFeedDeleteUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** An auto-generated type which holds one ProductFeed and a cursor during pagination. */
export type ProductFeedEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ProductFeedEdge. */
  readonly node: ProductFeed;
};

/** The input fields required to create a product feed. */
export type ProductFeedInput = {
  /** The country of the product feed. */
  readonly country: CountryCode;
  /** The language of the product feed. */
  readonly language: LanguageCode;
};

/** The valid values for the status of product feed. */
export enum ProductFeedStatus {
  /** The product feed is active. */
  ACTIVE = 'ACTIVE',
  /** The product feed is inactive. */
  INACTIVE = 'INACTIVE'
}

/** Return type for `productFullSync` mutation. */
export type ProductFullSyncPayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductFullSyncUserError>;
};

/** An error that occurs during the execution of `ProductFullSync`. */
export type ProductFullSyncUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductFullSyncUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductFullSyncUserError`. */
export enum ProductFullSyncUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** The set of valid sort keys for the ProductImage query. */
export enum ProductImageSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `position` value. */
  POSITION = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The input fields for creating or updating a product. */
export type ProductInput = {
  /**
   * The ID of the [category](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17)
   * that's associated with the product.
   */
  readonly category?: InputMaybe<Scalars['ID']>;
  /**
   * The input field to enable an app to provide additional product features.
   * For example, you can specify
   * [`bundles: true`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/ProductClaimOwnershipInput#field-bundles)
   * in the `claimOwnership` field to let an app add a
   * [product configuration extension](https://shopify.dev/docs/apps/build/product-merchandising/bundles/product-configuration-extension/add-merchant-config-ui).
   */
  readonly claimOwnership?: InputMaybe<ProductClaimOwnershipInput>;
  /** A list of collection IDs to associate with the product. */
  readonly collectionsToJoin?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The collection IDs to disassociate from the product. */
  readonly collectionsToLeave?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * The role of the product in a [combined listing](https://shopify.dev/apps/build/product-merchandising/combined-listings).
   * You can specify this field only when you create a product.
   */
  readonly combinedListingRole?: InputMaybe<CombinedListingsRole>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  readonly descriptionHtml?: InputMaybe<Scalars['String']>;
  /** Whether the product is a gift card. */
  readonly giftCard?: InputMaybe<Scalars['Boolean']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  readonly giftCardTemplateSuffix?: InputMaybe<Scalars['String']>;
  /**
   * A unique, human-readable string of the product's title. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * The handle is used in the online store URL for the product.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /**
   * The product's ID.
   *
   * If you're creating a product, then you don't need to pass the `id` as input to the
   * [`productCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productCreate) mutation.
   * If you're updating a product, then you do need to pass the `id` as input to the
   * [`productUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productUpdate) mutation
   * to identify which product you want to update.
   */
  readonly id?: InputMaybe<Scalars['ID']>;
  /**
   * The [custom fields](https://shopify.dev/docs/apps/build/custom-data) to associate with the product
   * for the purposes of adding and storing additional information.
   */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /**
   * A list of product options and option values. Maximum product options: three. There's no limit on the number of option values.
   * This input is supported only with the [`productCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productCreate)
   * mutation.
   */
  readonly productOptions?: InputMaybe<ReadonlyArray<OptionCreateInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  readonly productType?: InputMaybe<Scalars['String']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  readonly redirectNewHandle?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the product can only be purchased with
   * a [selling plan](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   * Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores.
   * If you update a product to be subscription-only (`requiresSellingPlan:false`), then the product is unpublished from all channels except the online store.
   */
  readonly requiresSellingPlan?: InputMaybe<Scalars['Boolean']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  readonly seo?: InputMaybe<SeoInput>;
  /**
   * The [product status](https://help.shopify.com/manual/products/details/product-details-page#product-status),
   * which controls visibility across all sales channels.
   */
  readonly status?: InputMaybe<ProductStatus>;
  /**
   * A comma-separated list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /**
   * The name for the product that displays to customers. The title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly title?: InputMaybe<Scalars['String']>;
  /** The name of the product's vendor. */
  readonly vendor?: InputMaybe<Scalars['String']>;
};

/** Return type for `productJoinSellingPlanGroups` mutation. */
export type ProductJoinSellingPlanGroupsPayload = {
  /** The product object. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** Return type for `productLeaveSellingPlanGroups` mutation. */
export type ProductLeaveSellingPlanGroupsPayload = {
  /** The product object. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** The set of valid sort keys for the ProductMedia query. */
export enum ProductMediaSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `position` value. */
  POSITION = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** An entity that represents details of an asynchronous operation on a product. */
export type ProductOperation = {
  /** The product on which the operation is being performed. */
  readonly product?: Maybe<Product>;
  /** The status of this operation. */
  readonly status: ProductOperationStatus;
};

/** Represents the state of this product operation. */
export enum ProductOperationStatus {
  /** Operation is currently running. */
  ACTIVE = 'ACTIVE',
  /** Operation is complete. */
  COMPLETE = 'COMPLETE',
  /** Operation has been created. */
  CREATED = 'CREATED'
}

/**
 * The product property names. For example, "Size", "Color", and "Material".
 * Variants are selected based on permutations of these options.
 * The limit for each product property name is 255 characters.
 */
export type ProductOption = HasPublishedTranslations & Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The metafield identifier linked to this option. */
  readonly linkedMetafield?: Maybe<LinkedMetafield>;
  /** The product option’s name. */
  readonly name: Scalars['String'];
  /** Similar to values, option_values returns all the corresponding option value objects to the product option, including values not assigned to any variants. */
  readonly optionValues: ReadonlyArray<ProductOptionValue>;
  /** The product option's position. */
  readonly position: Scalars['Int'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The corresponding value to the product option name. */
  readonly values: ReadonlyArray<Scalars['String']>;
};


/**
 * The product property names. For example, "Size", "Color", and "Material".
 * Variants are selected based on permutations of these options.
 * The limit for each product property name is 255 characters.
 */
export type ProductOptionTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** The set of variant strategies available for use in the `productOptionsCreate` mutation. */
export enum ProductOptionCreateVariantStrategy {
  /**
   * Existing variants are updated with the first option value of each added option. New variants are
   * created for each combination of existing variant option values and new option values.
   */
  CREATE = 'CREATE',
  /**
   * No additional variants are created in response to the added options. Existing variants are updated with the
   * first option value of each option added.
   */
  LEAVE_AS_IS = 'LEAVE_AS_IS'
}

/** The set of strategies available for use on the `productOptionDelete` mutation. */
export enum ProductOptionDeleteStrategy {
  /** The default strategy, the specified `Option` may only have one corresponding `value`. */
  DEFAULT = 'DEFAULT',
  /** An `Option` with multiple `values` can be deleted, but the operation only succeeds if no product variants get deleted. */
  NON_DESTRUCTIVE = 'NON_DESTRUCTIVE',
  /** An `Option` with multiple `values` can be deleted. Remaining variants will be deleted, highest `position` first, in the event of duplicates being detected. */
  POSITION = 'POSITION'
}

/** Return type for `productOptionUpdate` mutation. */
export type ProductOptionUpdatePayload = {
  /** The product with which the option being updated is associated. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductOptionUpdateUserError>;
};

/** Error codes for failed `ProductOptionUpdate` mutation. */
export type ProductOptionUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductOptionUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductOptionUpdateUserError`. */
export enum ProductOptionUpdateUserErrorCode {
  /** An option cannot have both metafield linked and nonlinked option values. */
  CANNOT_COMBINE_LINKED_AND_NONLINKED_OPTION_VALUES = 'CANNOT_COMBINE_LINKED_AND_NONLINKED_OPTION_VALUES',
  /** The number of variants will be above the limit after this operation. */
  CANNOT_CREATE_VARIANTS_ABOVE_LIMIT = 'CANNOT_CREATE_VARIANTS_ABOVE_LIMIT',
  /** Deleting all option values of an option is not allowed. */
  CANNOT_DELETE_ALL_OPTION_VALUES_IN_OPTION = 'CANNOT_DELETE_ALL_OPTION_VALUES_IN_OPTION',
  /** Cannot update the option because it would result in deleting variants, and you don't have the required permissions. */
  CANNOT_DELETE_VARIANT_WITHOUT_PERMISSION = 'CANNOT_DELETE_VARIANT_WITHOUT_PERMISSION',
  /** An option cannot be left only with option values that are not linked to any variant. */
  CANNOT_LEAVE_OPTIONS_WITHOUT_VARIANTS = 'CANNOT_LEAVE_OPTIONS_WITHOUT_VARIANTS',
  /** At least one of the product variants has invalid SKUs. */
  CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU = 'CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU',
  /** Duplicated option value. */
  DUPLICATED_OPTION_VALUE = 'DUPLICATED_OPTION_VALUE',
  /** Cannot link multiple options to the same metafield. */
  DUPLICATE_LINKED_OPTION = 'DUPLICATE_LINKED_OPTION',
  /** Invalid metafield value for linked option. */
  INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION = 'INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION',
  /** The name provided is not valid. */
  INVALID_NAME = 'INVALID_NAME',
  /** The option position provided is not valid. */
  INVALID_POSITION = 'INVALID_POSITION',
  /** A key is missing in the input. */
  KEY_MISSING_IN_INPUT = 'KEY_MISSING_IN_INPUT',
  /** No valid metafield definition found for linked option. */
  LINKED_METAFIELD_DEFINITION_NOT_FOUND = 'LINKED_METAFIELD_DEFINITION_NOT_FOUND',
  /** Linked options are currently not supported for this shop. */
  LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** Updating the linked_metafield of an option requires a linked_metafield_value for each option value. */
  LINKED_OPTION_UPDATE_MISSING_VALUES = 'LINKED_OPTION_UPDATE_MISSING_VALUES',
  /** On create, this key cannot be used. */
  NO_KEY_ON_CREATE = 'NO_KEY_ON_CREATE',
  /** Option already exists. */
  OPTION_ALREADY_EXISTS = 'OPTION_ALREADY_EXISTS',
  /** Option does not exist. */
  OPTION_DOES_NOT_EXIST = 'OPTION_DOES_NOT_EXIST',
  /** An option linked to the provided metafield already exists. */
  OPTION_LINKED_METAFIELD_ALREADY_TAKEN = 'OPTION_LINKED_METAFIELD_ALREADY_TAKEN',
  /** Option name is too long. */
  OPTION_NAME_TOO_LONG = 'OPTION_NAME_TOO_LONG',
  /** Option values count is over the allowed limit. */
  OPTION_VALUES_OVER_LIMIT = 'OPTION_VALUES_OVER_LIMIT',
  /** Option value already exists. */
  OPTION_VALUE_ALREADY_EXISTS = 'OPTION_VALUE_ALREADY_EXISTS',
  /** Performing conflicting actions on an option value. */
  OPTION_VALUE_CONFLICTING_OPERATION = 'OPTION_VALUE_CONFLICTING_OPERATION',
  /** Option value does not exist. */
  OPTION_VALUE_DOES_NOT_EXIST = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Option value with variants linked cannot be deleted. */
  OPTION_VALUE_HAS_VARIANTS = 'OPTION_VALUE_HAS_VARIANTS',
  /** Option value name is too long. */
  OPTION_VALUE_NAME_TOO_LONG = 'OPTION_VALUE_NAME_TOO_LONG',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** The number of option values created with the MANAGE strategy would exceed the variant limit. */
  TOO_MANY_VARIANTS_CREATED = 'TOO_MANY_VARIANTS_CREATED',
  /** Operation is not supported for a combined listing parent product. */
  UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION'
}

/** The set of variant strategies available for use in the `productOptionUpdate` mutation. */
export enum ProductOptionUpdateVariantStrategy {
  /**
   * Variants are not created nor deleted in response to option values to add or delete.
   * In cases where deleting a variant would be necessary to complete the operation, an error will be returned.
   */
  LEAVE_AS_IS = 'LEAVE_AS_IS',
  /**
   * Variants are created and deleted according to the option values to add and to delete.
   *
   * If an option value is added, a new variant will be added for each existing option combination
   * available on the product. For example, if the existing options are `Size` and `Color`, with
   * values `S`/`XL` and `Red`/`Blue`, adding a new option value `Green` for the option `Color` will create
   * variants with the option value combinations `S`/`Green` and `XL`/`Green`.
   *
   * If an option value is deleted, all variants referencing that option value will be deleted.
   */
  MANAGE = 'MANAGE'
}

/** The product option value names. For example, "Red", "Blue", and "Green" for a "Color" option. */
export type ProductOptionValue = HasPublishedTranslations & Node & {
  /** Whether the product option value has any linked variants. */
  readonly hasVariants: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The value of the linked metafield. */
  readonly linkedMetafieldValue?: Maybe<Scalars['String']>;
  /** The name of the product option value. */
  readonly name: Scalars['String'];
  /** The swatch associated with the product option value. */
  readonly swatch?: Maybe<ProductOptionValueSwatch>;
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
};


/** The product option value names. For example, "Red", "Blue", and "Green" for a "Color" option. */
export type ProductOptionValueTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** A swatch associated with a product option value. */
export type ProductOptionValueSwatch = {
  /** The color representation of the swatch. */
  readonly color?: Maybe<Scalars['Color']>;
  /** An image representation of the swatch. */
  readonly image?: Maybe<MediaImage>;
};

/** Return type for `productOptionsCreate` mutation. */
export type ProductOptionsCreatePayload = {
  /** The updated product object. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductOptionsCreateUserError>;
};

/** Error codes for failed `ProductOptionsCreate` mutation. */
export type ProductOptionsCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductOptionsCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductOptionsCreateUserError`. */
export enum ProductOptionsCreateUserErrorCode {
  /** Cannot combine linked metafield and option values. */
  CANNOT_COMBINE_LINKED_METAFIELD_AND_OPTION_VALUES = 'CANNOT_COMBINE_LINKED_METAFIELD_AND_OPTION_VALUES',
  /** At least one of the product variants has invalid SKUs. */
  CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU = 'CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU',
  /** Duplicated option name. */
  DUPLICATED_OPTION_NAME = 'DUPLICATED_OPTION_NAME',
  /** Duplicated option value. */
  DUPLICATED_OPTION_VALUE = 'DUPLICATED_OPTION_VALUE',
  /** Cannot link multiple options to the same metafield. */
  DUPLICATE_LINKED_OPTION = 'DUPLICATE_LINKED_OPTION',
  /** Invalid metafield value for linked option. */
  INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION = 'INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION',
  /** The name provided is not valid. */
  INVALID_NAME = 'INVALID_NAME',
  /** No valid metafield definition found for linked option. */
  LINKED_METAFIELD_DEFINITION_NOT_FOUND = 'LINKED_METAFIELD_DEFINITION_NOT_FOUND',
  /** Cannot specify 'linkedMetafieldValue' for an option that is not linked to a metafield. */
  LINKED_METAFIELD_VALUE_WITHOUT_LINKED_OPTION = 'LINKED_METAFIELD_VALUE_WITHOUT_LINKED_OPTION',
  /** Linked options are currently not supported for this shop. */
  LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** Missing metafield values for linked option. */
  MISSING_METAFIELD_VALUES_FOR_LINKED_OPTION = 'MISSING_METAFIELD_VALUES_FOR_LINKED_OPTION',
  /** Cannot create new options without values for all existing variants. */
  NEW_OPTION_WITHOUT_VALUE_FOR_EXISTING_VARIANTS = 'NEW_OPTION_WITHOUT_VALUE_FOR_EXISTING_VARIANTS',
  /** Options count is over the allowed limit. */
  OPTIONS_OVER_LIMIT = 'OPTIONS_OVER_LIMIT',
  /** Option already exists. */
  OPTION_ALREADY_EXISTS = 'OPTION_ALREADY_EXISTS',
  /** An option linked to the provided metafield already exists. */
  OPTION_LINKED_METAFIELD_ALREADY_TAKEN = 'OPTION_LINKED_METAFIELD_ALREADY_TAKEN',
  /** Each option must have a name specified. */
  OPTION_NAME_MISSING = 'OPTION_NAME_MISSING',
  /** Option name is too long. */
  OPTION_NAME_TOO_LONG = 'OPTION_NAME_TOO_LONG',
  /** If specified, position field must be present in all option inputs. */
  OPTION_POSITION_MISSING = 'OPTION_POSITION_MISSING',
  /** Each option must have at least one option value specified. */
  OPTION_VALUES_MISSING = 'OPTION_VALUES_MISSING',
  /** Option values count is over the allowed limit. */
  OPTION_VALUES_OVER_LIMIT = 'OPTION_VALUES_OVER_LIMIT',
  /** Option value name is too long. */
  OPTION_VALUE_NAME_TOO_LONG = 'OPTION_VALUE_NAME_TOO_LONG',
  /** Position must be between 1 and the maximum number of options per product. */
  POSITION_OUT_OF_BOUNDS = 'POSITION_OUT_OF_BOUNDS',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** The number of option values created with the CREATE strategy would exceed the variant limit. */
  TOO_MANY_VARIANTS_CREATED = 'TOO_MANY_VARIANTS_CREATED',
  /** Operation is not supported for a combined listing parent product. */
  UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION'
}

/** Return type for `productOptionsDelete` mutation. */
export type ProductOptionsDeletePayload = {
  /** IDs of the options deleted. */
  readonly deletedOptionsIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The updated product object. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductOptionsDeleteUserError>;
};

/** Error codes for failed `ProductOptionsDelete` mutation. */
export type ProductOptionsDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductOptionsDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductOptionsDeleteUserError`. */
export enum ProductOptionsDeleteUserErrorCode {
  /** Can't delete option with multiple values. */
  CANNOT_DELETE_OPTION_WITH_MULTIPLE_VALUES = 'CANNOT_DELETE_OPTION_WITH_MULTIPLE_VALUES',
  /** Cannot perform option deletion because it would result in deleting variants, and you don't have the required permissions. */
  CANNOT_DELETE_VARIANT_WITHOUT_PERMISSION = 'CANNOT_DELETE_VARIANT_WITHOUT_PERMISSION',
  /** At least one of the product variants has invalid SKUs. */
  CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU = 'CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU',
  /** Cannot delete options without deleting variants. */
  CANNOT_USE_NON_DESTRUCTIVE_STRATEGY = 'CANNOT_USE_NON_DESTRUCTIVE_STRATEGY',
  /** Options do not belong to the same product. */
  OPTIONS_DO_NOT_BELONG_TO_THE_SAME_PRODUCT = 'OPTIONS_DO_NOT_BELONG_TO_THE_SAME_PRODUCT',
  /** Option does not exist. */
  OPTION_DOES_NOT_EXIST = 'OPTION_DOES_NOT_EXIST',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** Operation is not supported for a combined listing parent product. */
  UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION'
}

/** Return type for `productOptionsReorder` mutation. */
export type ProductOptionsReorderPayload = {
  /** The updated product object. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductOptionsReorderUserError>;
};

/** Error codes for failed `ProductOptionsReorder` mutation. */
export type ProductOptionsReorderUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductOptionsReorderUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductOptionsReorderUserError`. */
export enum ProductOptionsReorderUserErrorCode {
  /** At least one of the product variants has invalid SKUs. */
  CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU = 'CANNOT_MAKE_CHANGES_IF_VARIANT_IS_MISSING_REQUIRED_SKU',
  /** Duplicated option name. */
  DUPLICATED_OPTION_NAME = 'DUPLICATED_OPTION_NAME',
  /** Duplicated option value. */
  DUPLICATED_OPTION_VALUE = 'DUPLICATED_OPTION_VALUE',
  /** Missing option name. */
  MISSING_OPTION_NAME = 'MISSING_OPTION_NAME',
  /** Missing option value. */
  MISSING_OPTION_VALUE = 'MISSING_OPTION_VALUE',
  /** Cannot specify different options or option values using mixed id and name reference key. */
  MIXING_ID_AND_NAME_KEYS_IS_NOT_ALLOWED = 'MIXING_ID_AND_NAME_KEYS_IS_NOT_ALLOWED',
  /** On reorder, this key cannot be used. */
  NO_KEY_ON_REORDER = 'NO_KEY_ON_REORDER',
  /** Option id does not exist. */
  OPTION_ID_DOES_NOT_EXIST = 'OPTION_ID_DOES_NOT_EXIST',
  /** Option name does not exist. */
  OPTION_NAME_DOES_NOT_EXIST = 'OPTION_NAME_DOES_NOT_EXIST',
  /** Option value does not exist. */
  OPTION_VALUE_DOES_NOT_EXIST = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Option value id does not exist. */
  OPTION_VALUE_ID_DOES_NOT_EXIST = 'OPTION_VALUE_ID_DOES_NOT_EXIST',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED'
}

/** The price range of the product. */
export type ProductPriceRange = {
  /** The highest variant's price. */
  readonly maxVariantPrice: MoneyV2;
  /** The lowest variant's price. */
  readonly minVariantPrice: MoneyV2;
};

/** The price range of the product. */
export type ProductPriceRangeV2 = {
  /** The highest variant's price. */
  readonly maxVariantPrice: MoneyV2;
  /** The lowest variant's price. */
  readonly minVariantPrice: MoneyV2;
};

/** Represents the channels where a product is published. */
export type ProductPublication = {
  /** The channel where the product was or is published. */
  readonly channel: Channel;
  /** Whether the publication is published or not. */
  readonly isPublished: Scalars['Boolean'];
  /** The product that was or is going to be published on the channel. */
  readonly product: Product;
  /** The date that the product was or is going to be published on the channel. */
  readonly publishDate?: Maybe<Scalars['DateTime']>;
};

/** An auto-generated type for paginating through multiple ProductPublications. */
export type ProductPublicationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ProductPublicationEdge>;
  /** A list of nodes that are contained in ProductPublicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ProductPublication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductPublication and a cursor during pagination. */
export type ProductPublicationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ProductPublicationEdge. */
  readonly node: ProductPublication;
};

/** The input fields for specifying a publication to which a product will be published. */
export type ProductPublicationInput = {
  /** ID of the publication. */
  readonly publicationId?: InputMaybe<Scalars['ID']>;
  /** The date and time that the product was (or will be) published. */
  readonly publishDate?: InputMaybe<Scalars['DateTime']>;
};

/** The input fields for specifying a product to publish and the channels to publish it to. */
export type ProductPublishInput = {
  /** The product to create or update publications for. */
  readonly id: Scalars['ID'];
  /** The publication that the product is published to. */
  readonly productPublications: ReadonlyArray<ProductPublicationInput>;
};

/** Return type for `productPublish` mutation. */
export type ProductPublishPayload = {
  /** The product that has been published. */
  readonly product?: Maybe<Product>;
  /**
   * The channels where the product is published.
   * @deprecated Use Product.publications instead.
   */
  readonly productPublications?: Maybe<ReadonlyArray<ProductPublication>>;
  /** The user's shop. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `productReorderMedia` mutation. */
export type ProductReorderMediaPayload = {
  /** The asynchronous job which reorders the media. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly mediaUserErrors: ReadonlyArray<MediaUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `mediaUserErrors` instead.
   */
  readonly userErrors: ReadonlyArray<UserError>;
};

/**
 * Reports the status of product for a Sales Channel or Storefront API.
 * This might include why a product is not available in a Sales Channel
 * and how a merchant might fix this.
 */
export type ProductResourceFeedback = {
  /**
   * The time when the feedback was generated. Used to help determine whether
   * incoming feedback is outdated compared to existing feedback.
   */
  readonly feedbackGeneratedAt: Scalars['DateTime'];
  /** The feedback messages presented to the merchant. */
  readonly messages: ReadonlyArray<Scalars['String']>;
  /** The ID of the product associated with the feedback. */
  readonly productId: Scalars['ID'];
  /** The timestamp of the product associated with the feedback. */
  readonly productUpdatedAt: Scalars['DateTime'];
  /** Conveys the state of the feedback and whether it requires merchant action or not. */
  readonly state: ResourceFeedbackState;
};

/** The input fields used to create a product feedback. */
export type ProductResourceFeedbackInput = {
  /**
   * The date and time when the payload is constructed.
   * Used to help determine whether incoming feedback is outdated compared to feedback already received, and if it should be ignored upon arrival.
   */
  readonly feedbackGeneratedAt: Scalars['DateTime'];
  /**
   * A concise set of copy strings to be displayed to merchants. Used to guide merchants in resolving problems that your app encounters when trying to make use of their products.
   * You can specify up to four messages. Each message is limited to 100 characters.
   */
  readonly messages?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The ID of the product that the feedback was created on. */
  readonly productId: Scalars['ID'];
  /** The timestamp of the product associated with the feedback. */
  readonly productUpdatedAt: Scalars['DateTime'];
  /** Whether the merchant needs to take action on the product. */
  readonly state: ResourceFeedbackState;
};

/** A sale associated with a product. */
export type ProductSale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line item for the associated sale. */
  readonly lineItem: LineItem;
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** The input fields required to create or update a product via ProductSet mutation. */
export type ProductSetInput = {
  /**
   * The ID of the [category](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17)
   * that's associated with the product.
   */
  readonly category?: InputMaybe<Scalars['ID']>;
  /**
   * The input field to enable an app to provide additional product features.
   * For example, you can specify
   * [`bundles: true`](https://shopify.dev/docs/api/admin-graphql/latest/input-objects/ProductClaimOwnershipInput#field-bundles)
   * in the `claimOwnership` field to let an app add a
   * [product configuration extension](https://shopify.dev/docs/apps/build/product-merchandising/bundles/product-configuration-extension/add-merchant-config-ui).
   */
  readonly claimOwnership?: InputMaybe<ProductClaimOwnershipInput>;
  /** The IDs of collections that this product will be a member of. */
  readonly collections?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The role of the product in a product grouping. It can only be set during creation. */
  readonly combinedListingRole?: InputMaybe<CombinedListingsRole>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  readonly descriptionHtml?: InputMaybe<Scalars['String']>;
  /** The files to associate with the product. */
  readonly files?: InputMaybe<ReadonlyArray<FileSetInput>>;
  /** Whether the product is a gift card. */
  readonly giftCard?: InputMaybe<Scalars['Boolean']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  readonly giftCardTemplateSuffix?: InputMaybe<Scalars['String']>;
  /**
   * A unique, human-readable string of the product's title. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * The handle is used in the online store URL for the product.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /**
   * The product's ID.
   *
   * If you're creating a product, then you don't need to pass the `id` as input to the
   * [`productCreate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productCreate) mutation.
   * If you're updating a product, then you do need to pass the `id` as input to the
   * [`productUpdate`](https://shopify.dev/docs/api/admin-graphql/latest/mutations/productUpdate) mutation
   * to identify which product you want to update.
   */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The metafields to associate with this product. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** List of custom product options and option values (maximum of 3 per product). */
  readonly productOptions?: InputMaybe<ReadonlyArray<OptionSetInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  readonly productType?: InputMaybe<Scalars['String']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  readonly redirectNewHandle?: InputMaybe<Scalars['Boolean']>;
  /** Whether the product can only be purchased with a selling plan (subscription). Products that are sold exclusively on subscription can only be created on online stores. If set to `true` on an already existing product, then the product will be marked unavailable on channels that don't support subscriptions. */
  readonly requiresSellingPlan?: InputMaybe<Scalars['Boolean']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  readonly seo?: InputMaybe<SeoInput>;
  /** The status of the product. */
  readonly status?: InputMaybe<ProductStatus>;
  /**
   * A comma-separated list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /**
   * The name for the product that displays to customers. The title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly title?: InputMaybe<Scalars['String']>;
  /** A list of variants associated with the product. */
  readonly variants?: InputMaybe<ReadonlyArray<ProductVariantSetInput>>;
  /** The name of the product's vendor. */
  readonly vendor?: InputMaybe<Scalars['String']>;
};

/** The input fields required to set inventory quantities using `productSet` mutation. */
export type ProductSetInventoryInput = {
  /** The ID of the location of the inventory quantity being set. */
  readonly locationId: Scalars['ID'];
  /** The name of the inventory quantity being set. Must be one of `available` or `on_hand`. */
  readonly name: Scalars['String'];
  /** The values to which each quantities will be set. */
  readonly quantity: Scalars['Int'];
};

/**
 * An entity that represents details of an asynchronous
 * [ProductSet](https://shopify.dev/api/admin-graphql/current/mutations/productSet) mutation.
 *
 * By querying this entity with the
 * [productOperation](https://shopify.dev/api/admin-graphql/current/queries/productOperation) query
 * using the ID that was returned
 * [when the product was created or updated](https://shopify.dev/api/admin/migrate/new-product-model/sync-data#create-a-product-with-variants-and-options-asynchronously),
 * this can be used to check the status of an operation.
 *
 * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
 *
 * The `product` field provides the details of the created or updated product.
 *
 * The `userErrors` field provides mutation errors that occurred during the operation.
 */
export type ProductSetOperation = Node & ProductOperation & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The product on which the operation is being performed. */
  readonly product?: Maybe<Product>;
  /** The status of this operation. */
  readonly status: ProductOperationStatus;
  /** Returns mutation errors occurred during background mutation processing. */
  readonly userErrors: ReadonlyArray<ProductSetUserError>;
};

/** Return type for `productSet` mutation. */
export type ProductSetPayload = {
  /** The product object. */
  readonly product?: Maybe<Product>;
  /** The product set operation, returned when run in asynchronous mode. */
  readonly productSetOperation?: Maybe<ProductSetOperation>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductSetUserError>;
};

/** Defines errors for ProductSet mutation. */
export type ProductSetUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductSetUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductSetUserError`. */
export enum ProductSetUserErrorCode {
  /** An option cannot have both metafield linked and nonlinked option values. */
  CANNOT_COMBINE_LINKED_AND_NONLINKED_OPTION_VALUES = 'CANNOT_COMBINE_LINKED_AND_NONLINKED_OPTION_VALUES',
  /** The metafield violates a capability restriction. */
  CAPABILITY_VIOLATION = 'CAPABILITY_VIOLATION',
  /** Duplicated option name. */
  DUPLICATED_OPTION_NAME = 'DUPLICATED_OPTION_NAME',
  /** Duplicated option value. */
  DUPLICATED_OPTION_VALUE = 'DUPLICATED_OPTION_VALUE',
  /** Duplicated value. */
  DUPLICATED_VALUE = 'DUPLICATED_VALUE',
  /** Cannot link multiple options to the same metafield. */
  DUPLICATE_LINKED_OPTION = 'DUPLICATE_LINKED_OPTION',
  /** Something went wrong, please try again. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** Gift card products can only be created after they have been activated. */
  GIFT_CARDS_NOT_ACTIVATED = 'GIFT_CARDS_NOT_ACTIVATED',
  /** The product gift_card attribute cannot be changed after creation. */
  GIFT_CARD_ATTRIBUTE_CANNOT_BE_CHANGED = 'GIFT_CARD_ATTRIBUTE_CANNOT_BE_CHANGED',
  /** Handle already in use. Please provide a new handle. */
  HANDLE_NOT_UNIQUE = 'HANDLE_NOT_UNIQUE',
  /** The id field is not allowed if identifier is provided. */
  ID_NOT_ALLOWED = 'ID_NOT_ALLOWED',
  /** The identifier value does not match the value of the corresponding field in the input. */
  INPUT_MISMATCH = 'INPUT_MISMATCH',
  /** Input is not valid. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** Metafield is not valid. */
  INVALID_METAFIELD = 'INVALID_METAFIELD',
  /** Invalid metafield value for linked option. */
  INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION = 'INVALID_METAFIELD_VALUE_FOR_LINKED_OPTION',
  /** Product is not valid. */
  INVALID_PRODUCT = 'INVALID_PRODUCT',
  /** Product variant is not valid. */
  INVALID_VARIANT = 'INVALID_VARIANT',
  /** Error processing request in the background job. */
  JOB_ERROR = 'JOB_ERROR',
  /** No valid metafield definition found for linked option. */
  LINKED_METAFIELD_DEFINITION_NOT_FOUND = 'LINKED_METAFIELD_DEFINITION_NOT_FOUND',
  /** Linked options are currently not supported for this shop. */
  LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP = 'LINKED_OPTIONS_NOT_SUPPORTED_FOR_SHOP',
  /** The input field corresponding to the identifier is required. */
  MISSING_FIELD_REQUIRED = 'MISSING_FIELD_REQUIRED',
  /** Resource matching the identifier was not found. */
  NOT_FOUND = 'NOT_FOUND',
  /** Options over limit. */
  OPTIONS_OVER_LIMIT = 'OPTIONS_OVER_LIMIT',
  /** Option does not exist. */
  OPTION_DOES_NOT_EXIST = 'OPTION_DOES_NOT_EXIST',
  /** Each option must have at least one option value specified. */
  OPTION_VALUES_MISSING = 'OPTION_VALUES_MISSING',
  /** Option values over limit. */
  OPTION_VALUES_OVER_LIMIT = 'OPTION_VALUES_OVER_LIMIT',
  /** Option value does not exist. */
  OPTION_VALUE_DOES_NOT_EXIST = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Must specify product options when updating variants. */
  PRODUCT_OPTIONS_INPUT_MISSING = 'PRODUCT_OPTIONS_INPUT_MISSING',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** Product variant does not exist. */
  PRODUCT_VARIANT_DOES_NOT_EXIST = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** Must specify variants when updating options. */
  VARIANTS_INPUT_MISSING = 'VARIANTS_INPUT_MISSING',
  /** Number of product variants exceeds shop limit. */
  VARIANTS_OVER_LIMIT = 'VARIANTS_OVER_LIMIT'
}

/** The set of valid sort keys for the Product query. */
export enum ProductSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `inventory_total` value. */
  INVENTORY_TOTAL = 'INVENTORY_TOTAL',
  /** Sort by the `product_type` value. */
  PRODUCT_TYPE = 'PRODUCT_TYPE',
  /** Sort by the `published_at` value. */
  PUBLISHED_AT = 'PUBLISHED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT',
  /** Sort by the `vendor` value. */
  VENDOR = 'VENDOR'
}

/** The possible product statuses. */
export enum ProductStatus {
  /** The product is ready to sell and can be published to sales channels and apps. Products with an active status aren't automatically published to sales channels, such as the online store, or apps. By default, existing products are set to active. */
  ACTIVE = 'ACTIVE',
  /** The product is no longer being sold and isn't available to customers on sales channels and apps. */
  ARCHIVED = 'ARCHIVED',
  /** The product isn't ready to sell and is unavailable to customers on sales channels and apps. By default, duplicated and unarchived products are set to draft. */
  DRAFT = 'DRAFT'
}

/** Represents a [Shopify product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17) node. */
export type ProductTaxonomyNode = Node & {
  /** The full name of the product taxonomy node. For example,  Animals & Pet Supplies > Pet Supplies > Dog Supplies > Dog Beds. */
  readonly fullName: Scalars['String'];
  /** The ID of the product taxonomy node. */
  readonly id: Scalars['ID'];
  /** Whether the node is a leaf node. */
  readonly isLeaf: Scalars['Boolean'];
  /** Whether the node is a root node. */
  readonly isRoot: Scalars['Boolean'];
  /** The name of the product taxonomy node. For example, Dog Beds. */
  readonly name: Scalars['String'];
};

/** The input fields for specifying a product to unpublish from a channel and the sales channels to unpublish it from. */
export type ProductUnpublishInput = {
  /** The ID of the product to create or update publications for. */
  readonly id: Scalars['ID'];
  /** The channels to unpublish the product from. */
  readonly productPublications: ReadonlyArray<ProductPublicationInput>;
};

/** Return type for `productUnpublish` mutation. */
export type ProductUnpublishPayload = {
  /** The product that has been unpublished. */
  readonly product?: Maybe<Product>;
  /** The user's shop. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for updating a product. */
export type ProductUpdateInput = {
  /**
   * The ID of the [category](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17)
   * that's associated with the product.
   */
  readonly category?: InputMaybe<Scalars['ID']>;
  /** A list of collection IDs to associate with the product. */
  readonly collectionsToJoin?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The collection IDs to disassociate from the product. */
  readonly collectionsToLeave?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * The description of the product, with HTML tags.
   * For example, the description might include bold `<strong></strong>` and italic `<i></i>` text.
   */
  readonly descriptionHtml?: InputMaybe<Scalars['String']>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a gift card in a store. */
  readonly giftCardTemplateSuffix?: InputMaybe<Scalars['String']>;
  /**
   * A unique, human-readable string of the product's title. A handle can contain letters, hyphens (`-`), and numbers, but no spaces.
   * The handle is used in the online store URL for the product.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly handle?: InputMaybe<Scalars['String']>;
  /** The product's ID. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /**
   * The [custom fields](https://shopify.dev/docs/apps/build/custom-data) to associate with the product
   * for the purposes of adding and storing additional information.
   */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /**
   * The [product type](https://help.shopify.com/manual/products/details/product-type)
   * that merchants define.
   */
  readonly productType?: InputMaybe<Scalars['String']>;
  /**
   * Whether a redirect is required after a new handle has been provided.
   * If `true`, then the old handle is redirected to the new one automatically.
   */
  readonly redirectNewHandle?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the product can only be purchased with
   * a [selling plan](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans).
   * Products that are sold on subscription (`requiresSellingPlan: true`) can be updated only for online stores.
   * If you update a product to be subscription-only (`requiresSellingPlan:false`), then the product is unpublished from all channels except the online store.
   */
  readonly requiresSellingPlan?: InputMaybe<Scalars['Boolean']>;
  /**
   * The [SEO title and description](https://help.shopify.com/manual/promoting-marketing/seo/adding-keywords)
   * that are associated with a product.
   */
  readonly seo?: InputMaybe<SeoInput>;
  /**
   * The [product status](https://help.shopify.com/manual/products/details/product-details-page#product-status),
   * which controls visibility across all sales channels.
   */
  readonly status?: InputMaybe<ProductStatus>;
  /**
   * A comma-separated list of searchable keywords that are
   * associated with the product. For example, a merchant might apply the `sports`
   * and `summer` tags to products that are associated with sportwear for summer.
   *
   * Updating `tags` overwrites any existing tags that were previously added to the product.
   * To add new tags without overwriting existing tags, use the
   * [`tagsAdd`](https://shopify.dev/api/admin-graphql/latest/mutations/tagsadd)
   * mutation.
   */
  readonly tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The [theme template](https://shopify.dev/docs/storefronts/themes/architecture/templates) that's used when customers view a product in a store. */
  readonly templateSuffix?: InputMaybe<Scalars['String']>;
  /**
   * The name for the product that displays to customers. The title is used to construct the product's handle.
   * For example, if a product is titled "Black Sunglasses", then the handle is `black-sunglasses`.
   */
  readonly title?: InputMaybe<Scalars['String']>;
  /** The name of the product's vendor. */
  readonly vendor?: InputMaybe<Scalars['String']>;
};

/** Return type for `productUpdateMedia` mutation. */
export type ProductUpdateMediaPayload = {
  /** The updated media object. */
  readonly media?: Maybe<ReadonlyArray<Media>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly mediaUserErrors: ReadonlyArray<MediaUserError>;
  /** The product on which media was updated. */
  readonly product?: Maybe<Product>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `mediaUserErrors` instead.
   */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `productUpdate` mutation. */
export type ProductUpdatePayload = {
  /** The updated product object. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents a product variant. */
export type ProductVariant = HasEvents & HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & LegacyInteroperability & Navigable & Node & {
  /** Whether the product variant is available for sale. */
  readonly availableForSale: Scalars['Boolean'];
  /** The value of the barcode associated with the product. */
  readonly barcode?: Maybe<Scalars['String']>;
  /** The compare-at price of the variant in the default shop currency. */
  readonly compareAtPrice?: Maybe<Scalars['Money']>;
  /** The pricing that applies for a customer in a given context. As of API version 2025-04, only active markets are considered in the price resolution. */
  readonly contextualPricing: ProductVariantContextualPricing;
  /** The date and time when the variant was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A default [cursor](https://shopify.dev/api/usage/pagination-graphql) that returns the single next record, sorted ascending by ID. */
  readonly defaultCursor: Scalars['String'];
  /** The [delivery profile](https://shopify.dev/api/admin-graphql/latest/objects/DeliveryProfile) for the variant. */
  readonly deliveryProfile?: Maybe<DeliveryProfile>;
  /** Display name of the variant, based on product's title + variant's title. */
  readonly displayName: Scalars['String'];
  /** The paginated list of events associated with the host subject. */
  readonly events: EventConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The featured image for the variant. */
  readonly image?: Maybe<Image>;
  /** The inventory item, which is used to query for inventory information. */
  readonly inventoryItem: InventoryItem;
  /** Whether customers are allowed to place an order for the product variant when it's out of stock. */
  readonly inventoryPolicy: ProductVariantInventoryPolicy;
  /** The total sellable quantity of the variant. */
  readonly inventoryQuantity?: Maybe<Scalars['Int']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The media associated with the product variant. */
  readonly media: MediaConnection;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  readonly position: Scalars['Int'];
  /**
   * List of prices and compare-at prices in the presentment currencies for this shop.
   * @deprecated Use `contextualPricing` instead.
   */
  readonly presentmentPrices: ProductVariantPricePairConnection;
  /** The price of the product variant in the default shop currency. */
  readonly price: Scalars['Money'];
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The product that this variant belongs to. */
  readonly product: Product;
  /** A list of the product variant components. */
  readonly productVariantComponents: ProductVariantComponentConnection;
  /**
   * Whether a product variant requires components. The default value is `false`.
   * If `true`, then the product variant can only be purchased as a parent bundle with components and it will be omitted
   * from channels that don't support bundles.
   */
  readonly requiresComponents: Scalars['Boolean'];
  /** List of product options applied to the variant. */
  readonly selectedOptions: ReadonlyArray<SelectedOption>;
  /**
   * The total sellable quantity of the variant for online channels.
   * This doesn't represent the total available inventory or capture
   * [limitations based on customer location](https://help.shopify.com/manual/markets/inventory_and_fulfillment).
   */
  readonly sellableOnlineQuantity: Scalars['Int'];
  /**
   * Count of selling plan groups associated with the product variant.
   * @deprecated Use `sellingPlanGroupsCount` instead.
   */
  readonly sellingPlanGroupCount: Scalars['Int'];
  /** A list of all selling plan groups defined in the current shop associated with the product variant. */
  readonly sellingPlanGroups: SellingPlanGroupConnection;
  /** Count of selling plan groups associated with the product variant. */
  readonly sellingPlanGroupsCount?: Maybe<Count>;
  /**
   * A case-sensitive identifier for the product variant in the shop.
   * Required in order to connect to a fulfillment service.
   */
  readonly sku?: Maybe<Scalars['String']>;
  /**
   * The Storefront GraphQL API ID of the `ProductVariant`.
   *
   * As of the `2022-04` version release, the Storefront GraphQL API will no longer return Base64 encoded IDs to match the behavior of the Admin GraphQL API. Therefore, you can safely use the `id` field's value instead.
   * @deprecated Use `id` instead.
   */
  readonly storefrontId: Scalars['StorefrontID'];
  /** The tax code for the product variant. */
  readonly taxCode?: Maybe<Scalars['String']>;
  /** Whether a tax is charged when the product variant is sold. */
  readonly taxable: Scalars['Boolean'];
  /** The title of the product variant. */
  readonly title: Scalars['String'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The unit price measurement for the variant. */
  readonly unitPriceMeasurement?: Maybe<UnitPriceMeasurement>;
  /** The date and time (ISO 8601 format) when the product variant was last modified. */
  readonly updatedAt: Scalars['DateTime'];
};


/** Represents a product variant. */
export type ProductVariantContextualPricingArgs = {
  context: ContextualPricingContext;
};


/** Represents a product variant. */
export type ProductVariantEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/** Represents a product variant. */
export type ProductVariantMediaArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a product variant. */
export type ProductVariantMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** Represents a product variant. */
export type ProductVariantMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** Represents a product variant. */
export type ProductVariantMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a product variant. */
export type ProductVariantPresentmentPricesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  presentmentCurrencies?: InputMaybe<ReadonlyArray<CurrencyCode>>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a product variant. */
export type ProductVariantPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** Represents a product variant. */
export type ProductVariantPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a product variant. */
export type ProductVariantProductVariantComponentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a product variant. */
export type ProductVariantSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a product variant. */
export type ProductVariantTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** The input fields required to append media to a single variant. */
export type ProductVariantAppendMediaInput = {
  /** Specifies the media to append to the variant. */
  readonly mediaIds: ReadonlyArray<Scalars['ID']>;
  /** Specifies the variant to which media will be appended. */
  readonly variantId: Scalars['ID'];
};

/** Return type for `productVariantAppendMedia` mutation. */
export type ProductVariantAppendMediaPayload = {
  /** The product associated with the variants and media. */
  readonly product?: Maybe<Product>;
  /** The product variants that were updated. */
  readonly productVariants?: Maybe<ReadonlyArray<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MediaUserError>;
};

/** A product variant component associated with a product variant. */
export type ProductVariantComponent = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The product variant associated with the component. */
  readonly productVariant: ProductVariant;
  /** The required quantity of the component. */
  readonly quantity: Scalars['Int'];
};

/** An auto-generated type for paginating through multiple ProductVariantComponents. */
export type ProductVariantComponentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ProductVariantComponentEdge>;
  /** A list of nodes that are contained in ProductVariantComponentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ProductVariantComponent>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductVariantComponent and a cursor during pagination. */
export type ProductVariantComponentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ProductVariantComponentEdge. */
  readonly node: ProductVariantComponent;
};

/** An auto-generated type for paginating through multiple ProductVariants. */
export type ProductVariantConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ProductVariantEdge>;
  /** A list of nodes that are contained in ProductVariantEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ProductVariant>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/**
 * The price of a product variant in a specific country.
 * Prices vary between countries.
 */
export type ProductVariantContextualPricing = {
  /** The final compare-at price after all adjustments are applied. */
  readonly compareAtPrice?: Maybe<MoneyV2>;
  /** The final price after all adjustments are applied. */
  readonly price: MoneyV2;
  /** A list of quantity breaks for the product variant. */
  readonly quantityPriceBreaks: QuantityPriceBreakConnection;
  /** The quantity rule applied for a given context. */
  readonly quantityRule: QuantityRule;
};


/**
 * The price of a product variant in a specific country.
 * Prices vary between countries.
 */
export type ProductVariantContextualPricingQuantityPriceBreaksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<QuantityPriceBreakSortKeys>;
};

/** The input fields required to detach media from a single variant. */
export type ProductVariantDetachMediaInput = {
  /** Specifies the media to detach from the variant. */
  readonly mediaIds: ReadonlyArray<Scalars['ID']>;
  /** Specifies the variant from which media will be detached. */
  readonly variantId: Scalars['ID'];
};

/** Return type for `productVariantDetachMedia` mutation. */
export type ProductVariantDetachMediaPayload = {
  /** The product associated with the variants and media. */
  readonly product?: Maybe<Product>;
  /** The product variants that were updated. */
  readonly productVariants?: Maybe<ReadonlyArray<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MediaUserError>;
};

/** An auto-generated type which holds one ProductVariant and a cursor during pagination. */
export type ProductVariantEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ProductVariantEdge. */
  readonly node: ProductVariant;
};

/** The input fields for the bundle components for core. */
export type ProductVariantGroupRelationshipInput = {
  /** The ID of the product variant that's a component of the bundle. */
  readonly id: Scalars['ID'];
  /** The number of units of the product variant required to construct one unit of the bundle. */
  readonly quantity: Scalars['Int'];
};

/** The valid values for the inventory policy of a product variant once it is out of stock. */
export enum ProductVariantInventoryPolicy {
  /** Customers can buy this product variant after it's out of stock. */
  CONTINUE = 'CONTINUE',
  /** Customers can't buy this product variant after it's out of stock. */
  DENY = 'DENY'
}

/** Return type for `productVariantJoinSellingPlanGroups` mutation. */
export type ProductVariantJoinSellingPlanGroupsPayload = {
  /** The product variant object. */
  readonly productVariant?: Maybe<ProductVariant>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** Return type for `productVariantLeaveSellingPlanGroups` mutation. */
export type ProductVariantLeaveSellingPlanGroupsPayload = {
  /** The product variant object. */
  readonly productVariant?: Maybe<ProductVariant>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** The input fields representing a product variant position. */
export type ProductVariantPositionInput = {
  /** Specifies the ID of the product variant to update. */
  readonly id: Scalars['ID'];
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  readonly position: Scalars['Int'];
};

/** The compare-at price and price of a variant sharing a currency. */
export type ProductVariantPricePair = {
  /** The compare-at price of the variant with associated currency. */
  readonly compareAtPrice?: Maybe<MoneyV2>;
  /** The price of the variant with associated currency. */
  readonly price: MoneyV2;
};

/** An auto-generated type for paginating through multiple ProductVariantPricePairs. */
export type ProductVariantPricePairConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ProductVariantPricePairEdge>;
  /** A list of nodes that are contained in ProductVariantPricePairEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ProductVariantPricePair>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ProductVariantPricePair and a cursor during pagination. */
export type ProductVariantPricePairEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ProductVariantPricePairEdge. */
  readonly node: ProductVariantPricePair;
};

/** Return type for `productVariantRelationshipBulkUpdate` mutation. */
export type ProductVariantRelationshipBulkUpdatePayload = {
  /** The product variants with successfully updated product variant relationships. */
  readonly parentProductVariants?: Maybe<ReadonlyArray<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductVariantRelationshipBulkUpdateUserError>;
};

/** An error that occurs during the execution of `ProductVariantRelationshipBulkUpdate`. */
export type ProductVariantRelationshipBulkUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductVariantRelationshipBulkUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductVariantRelationshipBulkUpdateUserError`. */
export enum ProductVariantRelationshipBulkUpdateUserErrorCode {
  /** Combined listing cannot be child product variants. */
  CHILD_PRODUCT_VARIANT_CANNOT_BE_COMBINED_LISTING = 'CHILD_PRODUCT_VARIANT_CANNOT_BE_COMBINED_LISTING',
  /** A parent product variant cannot contain itself as a component. */
  CIRCULAR_REFERENCE = 'CIRCULAR_REFERENCE',
  /** A parent product variant must not contain duplicate product variant relationships. */
  DUPLICATE_PRODUCT_VARIANT_RELATIONSHIP = 'DUPLICATE_PRODUCT_VARIANT_RELATIONSHIP',
  /** Exceeded the maximum allowable product variant relationships in a parent product variant. */
  EXCEEDED_PRODUCT_VARIANT_RELATIONSHIP_LIMIT = 'EXCEEDED_PRODUCT_VARIANT_RELATIONSHIP_LIMIT',
  /** Unable to create parent product variant. */
  FAILED_TO_CREATE = 'FAILED_TO_CREATE',
  /** Unable to remove product variant relationships. */
  FAILED_TO_REMOVE = 'FAILED_TO_REMOVE',
  /** Unable to update product variant relationships. */
  FAILED_TO_UPDATE = 'FAILED_TO_UPDATE',
  /** Unable to update parent product variant price. */
  FAILED_TO_UPDATE_PARENT_PRODUCT_VARIANT_PRICE = 'FAILED_TO_UPDATE_PARENT_PRODUCT_VARIANT_PRICE',
  /** Product variant relationships must have a quantity greater than 0. */
  INVALID_QUANTITY = 'INVALID_QUANTITY',
  /** The product variant relationships to remove must be specified if all the parent product variant's components aren't being removed. */
  MUST_SPECIFY_COMPONENTS = 'MUST_SPECIFY_COMPONENTS',
  /** Nested parent product variants aren't supported. */
  NESTED_PARENT_PRODUCT_VARIANT = 'NESTED_PARENT_PRODUCT_VARIANT',
  /** Combined listing cannot be parent product variants. */
  PARENT_PRODUCT_VARIANT_CANNOT_BE_COMBINED_LISTING = 'PARENT_PRODUCT_VARIANT_CANNOT_BE_COMBINED_LISTING',
  /** Gift cards cannot be parent product variants. */
  PARENT_PRODUCT_VARIANT_CANNOT_BE_GIFT_CARD = 'PARENT_PRODUCT_VARIANT_CANNOT_BE_GIFT_CARD',
  /** Parent product variants cannot require a selling plan. */
  PARENT_PRODUCT_VARIANT_CANNOT_REQUIRE_SELLING_PLAN = 'PARENT_PRODUCT_VARIANT_CANNOT_REQUIRE_SELLING_PLAN',
  /** A parent product variant ID or product ID must be provided. */
  PARENT_REQUIRED = 'PARENT_REQUIRED',
  /** The products for these product variants are already owned by another App. */
  PRODUCT_EXPANDER_APP_OWNERSHIP_ALREADY_EXISTS = 'PRODUCT_EXPANDER_APP_OWNERSHIP_ALREADY_EXISTS',
  /** Some of the provided product variants are not components of the specified parent product variant. */
  PRODUCT_VARIANTS_NOT_COMPONENTS = 'PRODUCT_VARIANTS_NOT_COMPONENTS',
  /** The product variants were not found. */
  PRODUCT_VARIANTS_NOT_FOUND = 'PRODUCT_VARIANTS_NOT_FOUND',
  /** A Core type relationship cannot be added to a composite product variant with SFN type relationships. */
  PRODUCT_VARIANT_RELATIONSHIP_TYPE_CONFLICT = 'PRODUCT_VARIANT_RELATIONSHIP_TYPE_CONFLICT',
  /** Unexpected error. */
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  /** Multipack bundles are not supported. */
  UNSUPPORTED_MULTIPACK_RELATIONSHIP = 'UNSUPPORTED_MULTIPACK_RELATIONSHIP',
  /** A price must be provided for a parent product variant if the price calucation is set to fixed. */
  UPDATE_PARENT_VARIANT_PRICE_REQUIRED = 'UPDATE_PARENT_VARIANT_PRICE_REQUIRED'
}

/** The input fields for updating a composite product variant. */
export type ProductVariantRelationshipUpdateInput = {
  /** A product ID which contains product variants that have relationships with other variants. */
  readonly parentProductId?: InputMaybe<Scalars['ID']>;
  /** The product variant ID representing that which contains the relationships with other variants. */
  readonly parentProductVariantId?: InputMaybe<Scalars['ID']>;
  /** Method in which to update the price of the parent product variant. */
  readonly priceInput?: InputMaybe<PriceInput>;
  /** The product variants and associated quantitites to add to the product variant. */
  readonly productVariantRelationshipsToCreate?: InputMaybe<ReadonlyArray<ProductVariantGroupRelationshipInput>>;
  /** The bundle component product variants to be removed from the product variant. */
  readonly productVariantRelationshipsToRemove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The product variants and associated quantitites to update in specified product variant. */
  readonly productVariantRelationshipsToUpdate?: InputMaybe<ReadonlyArray<ProductVariantGroupRelationshipInput>>;
  /** Whether to remove all components from the product variant. The default value is `false`. */
  readonly removeAllProductVariantRelationships?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields for specifying a product variant to create or update. */
export type ProductVariantSetInput = {
  /** The value of the barcode associated with the product. */
  readonly barcode?: InputMaybe<Scalars['String']>;
  /** The compare-at price of the variant. */
  readonly compareAtPrice?: InputMaybe<Scalars['Money']>;
  /**
   * The file to associate with the variant.
   * Any file specified here must also be specified in the `files` input for the product.
   */
  readonly file?: InputMaybe<FileSetInput>;
  /** Specifies the product variant to update or create a new variant if absent. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The inventory item associated with the variant, used for unit cost. */
  readonly inventoryItem?: InputMaybe<InventoryItemInput>;
  /** Whether customers are allowed to place an order for the product variant when it's out of stock. Defaults to `DENY`. */
  readonly inventoryPolicy?: InputMaybe<ProductVariantInventoryPolicy>;
  /**
   * The inventory quantities at each location where the variant is stocked.
   * If you're updating an existing variant, then you can only update the
   * quantities at locations where the variant is already stocked.
   */
  readonly inventoryQuantities?: InputMaybe<ReadonlyArray<ProductSetInventoryInput>>;
  /** Additional customizable information about the product variant. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The custom properties that a shop owner uses to define product variants. */
  readonly optionValues: ReadonlyArray<VariantOptionValueInput>;
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  readonly position?: InputMaybe<Scalars['Int']>;
  /** The price of the variant. */
  readonly price?: InputMaybe<Scalars['Money']>;
  /**
   * Whether a product variant requires components. The default value is `false`.
   * If `true`, then the product variant can only be purchased as a parent bundle with components and it will be omitted
   * from channels that don't support bundles.
   */
  readonly requiresComponents?: InputMaybe<Scalars['Boolean']>;
  /** The SKU for the variant. Case-sensitive string. */
  readonly sku?: InputMaybe<Scalars['String']>;
  /** The tax code associated with the variant. */
  readonly taxCode?: InputMaybe<Scalars['String']>;
  /** Whether the variant is taxable. */
  readonly taxable?: InputMaybe<Scalars['Boolean']>;
};

/** The set of valid sort keys for the ProductVariant query. */
export enum ProductVariantSortKeys {
  /** Sort by the `full_title` value. */
  FULL_TITLE = 'FULL_TITLE',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by available inventory quantity in the location specified by the `query:"location_id:"` argument.
   * Don't use this sort key when no `location_id` in query is specified.
   */
  INVENTORY_LEVELS_AVAILABLE = 'INVENTORY_LEVELS_AVAILABLE',
  /** Sort by the `inventory_management` value. */
  INVENTORY_MANAGEMENT = 'INVENTORY_MANAGEMENT',
  /** Sort by the `inventory_policy` value. */
  INVENTORY_POLICY = 'INVENTORY_POLICY',
  /** Sort by the `inventory_quantity` value. */
  INVENTORY_QUANTITY = 'INVENTORY_QUANTITY',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /** Sort by the `popular` value. */
  POPULAR = 'POPULAR',
  /** Sort by the `position` value. */
  POSITION = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `sku` value. */
  SKU = 'SKU',
  /** Sort by the `title` value. */
  TITLE = 'TITLE'
}

/** Return type for `productVariantsBulkCreate` mutation. */
export type ProductVariantsBulkCreatePayload = {
  /** The updated product object. */
  readonly product?: Maybe<Product>;
  /** The newly created variants. */
  readonly productVariants?: Maybe<ReadonlyArray<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductVariantsBulkCreateUserError>;
};

/** The set of strategies available for use on the `productVariantsBulkCreate` mutation. */
export enum ProductVariantsBulkCreateStrategy {
  /** The default strategy; keep the standalone variant (when product has only a single or default variant) when creating variants in bulk. */
  DEFAULT = 'DEFAULT',
  /** Delete the standalone variant (when product has only a single or default variant) when creating new variants in bulk. */
  REMOVE_STANDALONE_VARIANT = 'REMOVE_STANDALONE_VARIANT'
}

/** Error codes for failed product variant bulk create mutations. */
export type ProductVariantsBulkCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductVariantsBulkCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductVariantsBulkCreateUserError`. */
export enum ProductVariantsBulkCreateUserErrorCode {
  /** Cannot set name for an option value linked to a metafield. */
  CANNOT_SET_NAME_FOR_LINKED_OPTION_VALUE = 'CANNOT_SET_NAME_FOR_LINKED_OPTION_VALUE',
  /** Variant price must be greater than or equal to zero. */
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  /** Invalid input detected. */
  INVALID = 'INVALID',
  /** Input is invalid. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** Input must be for this product. */
  MUST_BE_FOR_THIS_PRODUCT = 'MUST_BE_FOR_THIS_PRODUCT',
  /** Variant options are not enough. */
  NEED_TO_ADD_OPTION_VALUES = 'NEED_TO_ADD_OPTION_VALUES',
  /** Price cannot take a negative value. */
  NEGATIVE_PRICE_VALUE = 'NEGATIVE_PRICE_VALUE',
  /** Input is not defined for this shop. */
  NOT_DEFINED_FOR_SHOP = 'NOT_DEFINED_FOR_SHOP',
  /** On create, this key cannot be used. */
  NO_KEY_ON_CREATE = 'NO_KEY_ON_CREATE',
  /** Variant options are more than the product options. */
  OPTION_VALUES_FOR_NUMBER_OF_UNKNOWN_OPTIONS = 'OPTION_VALUES_FOR_NUMBER_OF_UNKNOWN_OPTIONS',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** You reached the limit of available SKUs in your current plan. */
  SUBSCRIPTION_VIOLATION = 'SUBSCRIPTION_VIOLATION',
  /** Inventory locations cannot exceed the allowed resource limit or 10. */
  TOO_MANY_INVENTORY_LOCATIONS = 'TOO_MANY_INVENTORY_LOCATIONS',
  /** Quantity could not be set. The location was not found. */
  TRACKED_VARIANT_LOCATION_NOT_FOUND = 'TRACKED_VARIANT_LOCATION_NOT_FOUND',
  /** Operation is not supported for a combined listing parent product. */
  UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION',
  /** Variant already exists. */
  VARIANT_ALREADY_EXISTS = 'VARIANT_ALREADY_EXISTS',
  /** Variant options already exist. Please change the variant option(s). */
  VARIANT_ALREADY_EXISTS_CHANGE_OPTION_VALUE = 'VARIANT_ALREADY_EXISTS_CHANGE_OPTION_VALUE'
}

/** Return type for `productVariantsBulkDelete` mutation. */
export type ProductVariantsBulkDeletePayload = {
  /** The updated product object. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductVariantsBulkDeleteUserError>;
};

/** Error codes for failed bulk variant delete mutations. */
export type ProductVariantsBulkDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductVariantsBulkDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductVariantsBulkDeleteUserError`. */
export enum ProductVariantsBulkDeleteUserErrorCode {
  /** The variant does not exist. */
  AT_LEAST_ONE_VARIANT_DOES_NOT_BELONG_TO_THE_PRODUCT = 'AT_LEAST_ONE_VARIANT_DOES_NOT_BELONG_TO_THE_PRODUCT',
  /** Cannot delete default variant. */
  CANNOT_DELETE_LAST_VARIANT = 'CANNOT_DELETE_LAST_VARIANT',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** Operation is not supported for a combined listing parent product. */
  UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION'
}

/** The input fields for specifying a product variant to create as part of a variant bulk mutation. */
export type ProductVariantsBulkInput = {
  /** The value of the barcode associated with the product variant. */
  readonly barcode?: InputMaybe<Scalars['String']>;
  /** The compare-at price of the variant. */
  readonly compareAtPrice?: InputMaybe<Scalars['Money']>;
  /** Specifies the product variant to update or delete. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** The inventory item associated with the variant, used for unit cost. */
  readonly inventoryItem?: InputMaybe<InventoryItemInput>;
  /** Whether customers are allowed to place an order for the variant when it's out of stock. Defaults to `DENY`. */
  readonly inventoryPolicy?: InputMaybe<ProductVariantInventoryPolicy>;
  /**
   * The inventory quantities at each location where the variant is stocked. The number of elements
   * in the array of inventory quantities can't exceed the amount specified for the plan.
   * Supported as input with the `productVariantsBulkCreate` mutation only.
   */
  readonly inventoryQuantities?: InputMaybe<ReadonlyArray<InventoryLevelInput>>;
  /** The ID of the media that's associated with the variant. */
  readonly mediaId?: InputMaybe<Scalars['ID']>;
  /** The URL of the media to associate with the variant. */
  readonly mediaSrc?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The additional customizable information about the product variant. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The custom properties that a shop owner uses to define product variants. */
  readonly optionValues?: InputMaybe<ReadonlyArray<VariantOptionValueInput>>;
  /** The price of the variant. */
  readonly price?: InputMaybe<Scalars['Money']>;
  /**
   * Whether a product variant requires components. The default value is `false`.
   * If `true`, then the product variant can only be purchased as a parent bundle with components and it will be
   * omitted from channels that don't support bundles.
   */
  readonly requiresComponents?: InputMaybe<Scalars['Boolean']>;
  /** The tax code associated with the variant. */
  readonly taxCode?: InputMaybe<Scalars['String']>;
  /** Whether the variant is taxable. */
  readonly taxable?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `productVariantsBulkReorder` mutation. */
export type ProductVariantsBulkReorderPayload = {
  /** The updated product. */
  readonly product?: Maybe<Product>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductVariantsBulkReorderUserError>;
};

/** Error codes for failed bulk product variants reorder operation. */
export type ProductVariantsBulkReorderUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductVariantsBulkReorderUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductVariantsBulkReorderUserError`. */
export enum ProductVariantsBulkReorderUserErrorCode {
  /** Product variant IDs must be unique. */
  DUPLICATED_VARIANT_ID = 'DUPLICATED_VARIANT_ID',
  /** Something went wrong, please try again. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** Product variant position cannot be zero or negative number. */
  INVALID_POSITION = 'INVALID_POSITION',
  /** Product variant does not exist. */
  MISSING_VARIANT = 'MISSING_VARIANT',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST'
}

/** Return type for `productVariantsBulkUpdate` mutation. */
export type ProductVariantsBulkUpdatePayload = {
  /** The updated product object. */
  readonly product?: Maybe<Product>;
  /** The updated variants. */
  readonly productVariants?: Maybe<ReadonlyArray<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ProductVariantsBulkUpdateUserError>;
};

/** Error codes for failed variant bulk update mutations. */
export type ProductVariantsBulkUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ProductVariantsBulkUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ProductVariantsBulkUpdateUserError`. */
export enum ProductVariantsBulkUpdateUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Cannot set name for an option value linked to a metafield. */
  CANNOT_SET_NAME_FOR_LINKED_OPTION_VALUE = 'CANNOT_SET_NAME_FOR_LINKED_OPTION_VALUE',
  /** Mutually exclusive input fields provided. */
  CANNOT_SPECIFY_BOTH = 'CANNOT_SPECIFY_BOTH',
  /** The price of the variant must be greater than or equal to zero. */
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  /** Input is invalid. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** Metafield value is invalid. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** Input must be for this product. */
  MUST_BE_FOR_THIS_PRODUCT = 'MUST_BE_FOR_THIS_PRODUCT',
  /** Mandatory field input field missing. */
  MUST_SPECIFY_ONE_OF_PAIR = 'MUST_SPECIFY_ONE_OF_PAIR',
  /** Variant options are not enough. */
  NEED_TO_ADD_OPTION_VALUES = 'NEED_TO_ADD_OPTION_VALUES',
  /** Price cannot take a negative value. */
  NEGATIVE_PRICE_VALUE = 'NEGATIVE_PRICE_VALUE',
  /** Input is not defined for this shop. */
  NOT_DEFINED_FOR_SHOP = 'NOT_DEFINED_FOR_SHOP',
  /** Inventory quantities cannot be provided during update. */
  NO_INVENTORY_QUANTITES_DURING_UPDATE = 'NO_INVENTORY_QUANTITES_DURING_UPDATE',
  /** Inventory quantities can only be provided during create. To update inventory for existing variants, use inventoryAdjustQuantities. */
  NO_INVENTORY_QUANTITIES_ON_VARIANTS_UPDATE = 'NO_INVENTORY_QUANTITIES_ON_VARIANTS_UPDATE',
  /** Option does not exist. */
  OPTION_DOES_NOT_EXIST = 'OPTION_DOES_NOT_EXIST',
  /** Variant options are more than the product options. */
  OPTION_VALUES_FOR_NUMBER_OF_UNKNOWN_OPTIONS = 'OPTION_VALUES_FOR_NUMBER_OF_UNKNOWN_OPTIONS',
  /** Option value does not exist. */
  OPTION_VALUE_DOES_NOT_EXIST = 'OPTION_VALUE_DOES_NOT_EXIST',
  /** Option value name is too long. */
  OPTION_VALUE_NAME_TOO_LONG = 'OPTION_VALUE_NAME_TOO_LONG',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Product is suspended. */
  PRODUCT_SUSPENDED = 'PRODUCT_SUSPENDED',
  /** Product variant does not exist. */
  PRODUCT_VARIANT_DOES_NOT_EXIST = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** Product variant is missing ID attribute. */
  PRODUCT_VARIANT_ID_MISSING = 'PRODUCT_VARIANT_ID_MISSING',
  /** You reached the limit of available SKUs in your current plan. */
  SUBSCRIPTION_VIOLATION = 'SUBSCRIPTION_VIOLATION',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** Operation is not supported for a combined listing parent product. */
  UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION = 'UNSUPPORTED_COMBINED_LISTING_PARENT_OPERATION',
  /** The variant already exists. */
  VARIANT_ALREADY_EXISTS = 'VARIANT_ALREADY_EXISTS'
}

/** The set of valid sort keys for the ProfileItem query. */
export enum ProfileItemSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `inventory_total` value. */
  INVENTORY_TOTAL = 'INVENTORY_TOTAL',
  /** Sort by the `product_type` value. */
  PRODUCT_TYPE = 'PRODUCT_TYPE',
  /** Sort by the `published_at` value. */
  PUBLISHED_AT = 'PUBLISHED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `title` value. */
  TITLE = 'TITLE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT',
  /** Sort by the `vendor` value. */
  VENDOR = 'VENDOR'
}

/** Return type for `pubSubServerPixelUpdate` mutation. */
export type PubSubServerPixelUpdatePayload = {
  /** The server pixel as configured by the mutation. */
  readonly serverPixel?: Maybe<ServerPixel>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ErrorsServerPixelUserError>;
};

/** Return type for `pubSubWebhookSubscriptionCreate` mutation. */
export type PubSubWebhookSubscriptionCreatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PubSubWebhookSubscriptionCreateUserError>;
  /** The webhook subscription that was created. */
  readonly webhookSubscription?: Maybe<WebhookSubscription>;
};

/** An error that occurs during the execution of `PubSubWebhookSubscriptionCreate`. */
export type PubSubWebhookSubscriptionCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PubSubWebhookSubscriptionCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PubSubWebhookSubscriptionCreateUserError`. */
export enum PubSubWebhookSubscriptionCreateUserErrorCode {
  /** Invalid parameters provided. */
  INVALID_PARAMETERS = 'INVALID_PARAMETERS',
  /** Address for this topic has already been taken. */
  TAKEN = 'TAKEN'
}

/** The input fields for a PubSub webhook subscription. */
export type PubSubWebhookSubscriptionInput = {
  /** A constraint specified using search syntax that ensures only webhooks that match the specified filter are emitted. See our [guide on filters](https://shopify.dev/docs/apps/build/webhooks/customize/filters) for more details. */
  readonly filter?: InputMaybe<Scalars['String']>;
  /** The format in which the webhook subscription should send the data. */
  readonly format?: InputMaybe<WebhookSubscriptionFormat>;
  /** The list of fields to be included in the webhook subscription. */
  readonly includeFields?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The list of namespaces for any metafields that should be included in the webhook subscription. */
  readonly metafieldNamespaces?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The Pub/Sub project ID. */
  readonly pubSubProject: Scalars['String'];
  /** The Pub/Sub topic ID. */
  readonly pubSubTopic: Scalars['String'];
};

/** Return type for `pubSubWebhookSubscriptionUpdate` mutation. */
export type PubSubWebhookSubscriptionUpdatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PubSubWebhookSubscriptionUpdateUserError>;
  /** The webhook subscription that was updated. */
  readonly webhookSubscription?: Maybe<WebhookSubscription>;
};

/** An error that occurs during the execution of `PubSubWebhookSubscriptionUpdate`. */
export type PubSubWebhookSubscriptionUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PubSubWebhookSubscriptionUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PubSubWebhookSubscriptionUpdateUserError`. */
export enum PubSubWebhookSubscriptionUpdateUserErrorCode {
  /** Invalid parameters provided. */
  INVALID_PARAMETERS = 'INVALID_PARAMETERS'
}

/** A publication is a group of products and collections that is published to an app. */
export type Publication = Node & {
  /**
   * The app associated with the publication.
   * @deprecated Use [AppCatalog.apps](https://shopify.dev/api/admin-graphql/unstable/objects/AppCatalog#connection-appcatalog-apps) instead.
   */
  readonly app: App;
  /** Whether new products are automatically published to this publication. */
  readonly autoPublish: Scalars['Boolean'];
  /** The catalog associated with the publication. */
  readonly catalog?: Maybe<Catalog>;
  /** The collection publications for the list of collections published to the publication. */
  readonly collectionPublicationsV3: ResourcePublicationConnection;
  /** The list of collections published to the publication. */
  readonly collections: CollectionConnection;
  /** Whether the collection is available to the publication. */
  readonly hasCollection: Scalars['Boolean'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * Name of the publication.
   * @deprecated Use [Catalog.title](https://shopify.dev/api/admin-graphql/unstable/interfaces/Catalog#field-catalog-title) instead.
   */
  readonly name: Scalars['String'];
  /** A background operation associated with this publication. */
  readonly operation?: Maybe<PublicationOperation>;
  /** The product publications for the list of products published to the publication. */
  readonly productPublicationsV3: ResourcePublicationConnection;
  /** The list of products published to the publication. */
  readonly products: ProductConnection;
  /** Whether the publication supports future publishing. */
  readonly supportsFuturePublishing: Scalars['Boolean'];
};


/** A publication is a group of products and collections that is published to an app. */
export type PublicationCollectionPublicationsV3Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A publication is a group of products and collections that is published to an app. */
export type PublicationCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A publication is a group of products and collections that is published to an app. */
export type PublicationHasCollectionArgs = {
  id: Scalars['ID'];
};


/** A publication is a group of products and collections that is published to an app. */
export type PublicationProductPublicationsV3Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A publication is a group of products and collections that is published to an app. */
export type PublicationProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple Publications. */
export type PublicationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<PublicationEdge>;
  /** A list of nodes that are contained in PublicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Publication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for creating a publication. */
export type PublicationCreateInput = {
  /** Whether to automatically add newly created products to this publication. */
  readonly autoPublish?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the catalog. */
  readonly catalogId?: InputMaybe<Scalars['ID']>;
  /** Whether to create an empty publication or prepopulate it with all products. */
  readonly defaultState?: InputMaybe<PublicationCreateInputPublicationDefaultState>;
};

/** The input fields for the possible values for the default state of a publication. */
export enum PublicationCreateInputPublicationDefaultState {
  /** The publication is populated with all products. */
  ALL_PRODUCTS = 'ALL_PRODUCTS',
  /** The publication is empty. */
  EMPTY = 'EMPTY'
}

/** Return type for `publicationCreate` mutation. */
export type PublicationCreatePayload = {
  /** The publication that's been created. */
  readonly publication?: Maybe<Publication>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PublicationUserError>;
};

/** Return type for `publicationDelete` mutation. */
export type PublicationDeletePayload = {
  /** The ID of the publication that was deleted. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PublicationUserError>;
};

/** An auto-generated type which holds one Publication and a cursor during pagination. */
export type PublicationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of PublicationEdge. */
  readonly node: Publication;
};

/** The input fields required to publish a resource. */
export type PublicationInput = {
  /** ID of the publication. */
  readonly publicationId?: InputMaybe<Scalars['ID']>;
  /** The date and time that the resource was published. Setting this to a date in the future will schedule the resource to be published. Only online store channels support future publishing. This field has no effect if you include it in the `publishableUnpublish` mutation. */
  readonly publishDate?: InputMaybe<Scalars['DateTime']>;
};

/** The possible types of publication operations. */
export type PublicationOperation = AddAllProductsOperation | CatalogCsvOperation | PublicationResourceOperation;

/** A bulk update operation on a publication. */
export type PublicationResourceOperation = Node & ResourceOperation & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The count of processed rows, summing imported, failed, and skipped rows. */
  readonly processedRowCount?: Maybe<Scalars['Int']>;
  /** Represents a rows objects within this background operation. */
  readonly rowCount?: Maybe<RowCount>;
  /** The status of this operation. */
  readonly status: ResourceOperationStatus;
};

/** The input fields for updating a publication. */
export type PublicationUpdateInput = {
  /** Whether new products should be automatically published to the publication. */
  readonly autoPublish?: InputMaybe<Scalars['Boolean']>;
  /** A list of publishable IDs to add. The maximum number of publishables to update simultaneously is 50. */
  readonly publishablesToAdd?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** A list of publishable IDs to remove. The maximum number of publishables to update simultaneously is 50. */
  readonly publishablesToRemove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** Return type for `publicationUpdate` mutation. */
export type PublicationUpdatePayload = {
  /** The publication that's been updated. */
  readonly publication?: Maybe<Publication>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<PublicationUserError>;
};

/** Defines errors encountered while managing a publication. */
export type PublicationUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<PublicationUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `PublicationUserError`. */
export enum PublicationUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Cannot modify a catalog for an app. */
  CANNOT_MODIFY_APP_CATALOG = 'CANNOT_MODIFY_APP_CATALOG',
  /** Can't modify a publication that belongs to an app catalog. */
  CANNOT_MODIFY_APP_CATALOG_PUBLICATION = 'CANNOT_MODIFY_APP_CATALOG_PUBLICATION',
  /** Cannot modify a catalog for a market. */
  CANNOT_MODIFY_MARKET_CATALOG = 'CANNOT_MODIFY_MARKET_CATALOG',
  /** Can't modify a publication that belongs to a market catalog. */
  CANNOT_MODIFY_MARKET_CATALOG_PUBLICATION = 'CANNOT_MODIFY_MARKET_CATALOG_PUBLICATION',
  /** Catalog does not exist. */
  CATALOG_NOT_FOUND = 'CATALOG_NOT_FOUND',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Publishable ID not found. */
  INVALID_PUBLISHABLE_ID = 'INVALID_PUBLISHABLE_ID',
  /** Market does not exist. */
  MARKET_NOT_FOUND = 'MARKET_NOT_FOUND',
  /** A product publication cannot be created because the catalog type associated with this publication does not permit publications of this product type. */
  PRODUCT_TYPE_INCOMPATIBLE_WITH_CATALOG_TYPE = 'PRODUCT_TYPE_INCOMPATIBLE_WITH_CATALOG_TYPE',
  /** The publication is currently being modified. Please try again later. */
  PUBLICATION_LOCKED = 'PUBLICATION_LOCKED',
  /** Publication not found. */
  PUBLICATION_NOT_FOUND = 'PUBLICATION_NOT_FOUND',
  /** The limit for simultaneous publication updates has been exceeded. */
  PUBLICATION_UPDATE_LIMIT_EXCEEDED = 'PUBLICATION_UPDATE_LIMIT_EXCEEDED',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** Can't perform this action on a publication. */
  UNSUPPORTED_PUBLICATION_ACTION = 'UNSUPPORTED_PUBLICATION_ACTION',
  /** A catalog publication can only contain products. */
  UNSUPPORTED_PUBLISHABLE_TYPE = 'UNSUPPORTED_PUBLISHABLE_TYPE'
}

/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type Publishable = {
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  readonly availablePublicationsCount?: Maybe<Count>;
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   * @deprecated Use `resourcePublicationsCount` instead.
   */
  readonly publicationCount: Scalars['Int'];
  /**
   * Whether the resource is published to a specific channel.
   * @deprecated Use `publishedOnPublication` instead.
   */
  readonly publishedOnChannel: Scalars['Boolean'];
  /**
   * Whether the resource is published to a
   * [channel](https://shopify.dev/docs/api/admin-graphql/latest/objects/Channel).
   * For example, the resource might be published to the online store channel.
   * @deprecated Use `publishedOnCurrentPublication` instead.
   */
  readonly publishedOnCurrentChannel: Scalars['Boolean'];
  /**
   * Whether the resource is published to the app's
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   * For example, the resource might be published to the app's online store channel.
   */
  readonly publishedOnCurrentPublication: Scalars['Boolean'];
  /**
   * Whether the resource is published to a specified
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly publishedOnPublication: Scalars['Boolean'];
  /**
   * The list of resources that are published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly resourcePublications: ResourcePublicationConnection;
  /**
   * The number of
   * [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that a resource is published to, without
   * [feedback errors](https://shopify.dev/docs/api/admin-graphql/latest/objects/ResourceFeedback).
   */
  readonly resourcePublicationsCount?: Maybe<Count>;
  /**
   * The list of resources that are either published or staged to be published to a
   * [publication](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication).
   */
  readonly resourcePublicationsV2: ResourcePublicationV2Connection;
  /**
   * The list of channels that the resource is not published to.
   * @deprecated Use `unpublishedPublications` instead.
   */
  readonly unpublishedChannels: ChannelConnection;
  /**
   * The list of [publications](https://shopify.dev/docs/api/admin-graphql/latest/objects/Publication)
   * that the resource isn't published to.
   */
  readonly unpublishedPublications: PublicationConnection;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishablePublicationCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishablePublishedOnChannelArgs = {
  channelId: Scalars['ID'];
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishablePublishedOnPublicationArgs = {
  publicationId: Scalars['ID'];
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableResourcePublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableResourcePublicationsCountArgs = {
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableResourcePublicationsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableUnpublishedChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a resource that can be published to a channel.
 * A publishable resource can be either a Product or Collection.
 */
export type PublishableUnpublishedPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `publishablePublish` mutation. */
export type PublishablePublishPayload = {
  /** Resource that has been published. */
  readonly publishable?: Maybe<Publishable>;
  /** The user's shop. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `publishablePublishToCurrentChannel` mutation. */
export type PublishablePublishToCurrentChannelPayload = {
  /** Resource that has been published. */
  readonly publishable?: Maybe<Publishable>;
  /** The user's shop. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `publishableUnpublish` mutation. */
export type PublishableUnpublishPayload = {
  /** Resource that has been unpublished. */
  readonly publishable?: Maybe<Publishable>;
  /** The user's shop. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `publishableUnpublishToCurrentChannel` mutation. */
export type PublishableUnpublishToCurrentChannelPayload = {
  /** Resource that has been unpublished. */
  readonly publishable?: Maybe<Publishable>;
  /** The user's shop. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents information about the purchasing company for the order or draft order. */
export type PurchasingCompany = {
  /** The company associated to the order or draft order. */
  readonly company: Company;
  /** The company contact associated to the order or draft order. */
  readonly contact?: Maybe<CompanyContact>;
  /** The company location associated to the order or draft order. */
  readonly location: CompanyLocation;
};

/** The input fields for a purchasing company, which is a combination of company, company contact, and company location. */
export type PurchasingCompanyInput = {
  /** ID of the company contact. */
  readonly companyContactId: Scalars['ID'];
  /** ID of the company. */
  readonly companyId: Scalars['ID'];
  /** ID of the company location. */
  readonly companyLocationId: Scalars['ID'];
};

/** Represents information about the purchasing entity for the order or draft order. */
export type PurchasingEntity = Customer | PurchasingCompany;

/** The input fields for a purchasing entity. Can either be a customer or a purchasing company. */
export type PurchasingEntityInput = {
  /** Represents a customer. Null if there's a purchasing company. */
  readonly customerId?: InputMaybe<Scalars['ID']>;
  /** Represents a purchasing company. Null if there's a customer. */
  readonly purchasingCompany?: InputMaybe<PurchasingCompanyInput>;
};

/**
 * Quantity price breaks lets you offer different rates that are based on the
 * amount of a specific variant being ordered.
 */
export type QuantityPriceBreak = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Minimum quantity required to reach new quantity break price. */
  readonly minimumQuantity: Scalars['Int'];
  /** The price of variant after reaching the minimum quanity. */
  readonly price: MoneyV2;
  /** The price list associated with this quantity break. */
  readonly priceList: PriceList;
  /** The product variant associated with this quantity break. */
  readonly variant: ProductVariant;
};

/** An auto-generated type for paginating through multiple QuantityPriceBreaks. */
export type QuantityPriceBreakConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<QuantityPriceBreakEdge>;
  /** A list of nodes that are contained in QuantityPriceBreakEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<QuantityPriceBreak>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one QuantityPriceBreak and a cursor during pagination. */
export type QuantityPriceBreakEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of QuantityPriceBreakEdge. */
  readonly node: QuantityPriceBreak;
};

/** The input fields and values to use when creating quantity price breaks. */
export type QuantityPriceBreakInput = {
  /** The minimum required quantity for a variant to qualify for this price. */
  readonly minimumQuantity: Scalars['Int'];
  /** The price of the product variant when its quantity meets the break's minimum quantity. */
  readonly price: MoneyInput;
  /** The product variant ID associated with the quantity break. */
  readonly variantId: Scalars['ID'];
};

/** The set of valid sort keys for the QuantityPriceBreak query. */
export enum QuantityPriceBreakSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `minimum_quantity` value. */
  MINIMUM_QUANTITY = 'MINIMUM_QUANTITY',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The input fields used to update quantity pricing. */
export type QuantityPricingByVariantUpdateInput = {
  /** A list of fixed prices to add. */
  readonly pricesToAdd: ReadonlyArray<PriceListPriceInput>;
  /** A list of variant IDs that identify which fixed prices to remove. */
  readonly pricesToDeleteByVariantId: ReadonlyArray<Scalars['ID']>;
  /** A list of quantity price breaks to add. */
  readonly quantityPriceBreaksToAdd: ReadonlyArray<QuantityPriceBreakInput>;
  /** A list of quantity price break IDs that identify which quantity breaks to remove. */
  readonly quantityPriceBreaksToDelete: ReadonlyArray<Scalars['ID']>;
  /** A list of quantity rules to add. */
  readonly quantityRulesToAdd: ReadonlyArray<QuantityRuleInput>;
  /** A list of variant IDs that identify which quantity rules to remove. */
  readonly quantityRulesToDeleteByVariantId: ReadonlyArray<Scalars['ID']>;
};

/** Return type for `quantityPricingByVariantUpdate` mutation. */
export type QuantityPricingByVariantUpdatePayload = {
  /** The variants for which quantity pricing was created successfully in the price list. */
  readonly productVariants?: Maybe<ReadonlyArray<ProductVariant>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<QuantityPricingByVariantUserError>;
};

/** Error codes for failed volume pricing operations. */
export type QuantityPricingByVariantUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<QuantityPricingByVariantUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `QuantityPricingByVariantUserError`. */
export enum QuantityPricingByVariantUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Something went wrong when trying to update quantity pricing. Please try again later. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** Price list and fixed price currency mismatch. */
  PRICE_ADD_CURRENCY_MISMATCH = 'PRICE_ADD_CURRENCY_MISMATCH',
  /** Prices to add inputs must be unique by variant id. */
  PRICE_ADD_DUPLICATE_INPUT_FOR_VARIANT = 'PRICE_ADD_DUPLICATE_INPUT_FOR_VARIANT',
  /** Fixed price's variant not found. */
  PRICE_ADD_VARIANT_NOT_FOUND = 'PRICE_ADD_VARIANT_NOT_FOUND',
  /** Price is not fixed. */
  PRICE_DELETE_PRICE_NOT_FIXED = 'PRICE_DELETE_PRICE_NOT_FIXED',
  /** Fixed price's variant not found. */
  PRICE_DELETE_VARIANT_NOT_FOUND = 'PRICE_DELETE_VARIANT_NOT_FOUND',
  /** Price List does not exist. */
  PRICE_LIST_NOT_FOUND = 'PRICE_LIST_NOT_FOUND',
  /** Price list and quantity price break currency mismatch. */
  QUANTITY_PRICE_BREAK_ADD_CURRENCY_MISMATCH = 'QUANTITY_PRICE_BREAK_ADD_CURRENCY_MISMATCH',
  /** Quantity price breaks to add inputs must be unique by variant id and minimum quantity. */
  QUANTITY_PRICE_BREAK_ADD_DUPLICATE_INPUT_FOR_VARIANT_AND_MIN = 'QUANTITY_PRICE_BREAK_ADD_DUPLICATE_INPUT_FOR_VARIANT_AND_MIN',
  /** Failed to save quantity price break. */
  QUANTITY_PRICE_BREAK_ADD_FAILED_TO_SAVE = 'QUANTITY_PRICE_BREAK_ADD_FAILED_TO_SAVE',
  /** Invalid quantity price break. */
  QUANTITY_PRICE_BREAK_ADD_INVALID = 'QUANTITY_PRICE_BREAK_ADD_INVALID',
  /** Exceeded the allowed number of quantity price breaks per variant. */
  QUANTITY_PRICE_BREAK_ADD_LIMIT_EXCEEDED = 'QUANTITY_PRICE_BREAK_ADD_LIMIT_EXCEEDED',
  /** Quantity price break miniumum is higher than the quantity rule maximum. */
  QUANTITY_PRICE_BREAK_ADD_MIN_HIGHER_THAN_QUANTITY_RULES_MAX = 'QUANTITY_PRICE_BREAK_ADD_MIN_HIGHER_THAN_QUANTITY_RULES_MAX',
  /** Quantity price break miniumum is less than the quantity rule minimum. */
  QUANTITY_PRICE_BREAK_ADD_MIN_LOWER_THAN_QUANTITY_RULES_MIN = 'QUANTITY_PRICE_BREAK_ADD_MIN_LOWER_THAN_QUANTITY_RULES_MIN',
  /** Quantity price break miniumum is not multiple of the quantity rule increment. */
  QUANTITY_PRICE_BREAK_ADD_MIN_NOT_A_MULTIPLE_OF_QUANTITY_RULES_INCREMENT = 'QUANTITY_PRICE_BREAK_ADD_MIN_NOT_A_MULTIPLE_OF_QUANTITY_RULES_INCREMENT',
  /** Quantity price break's fixed price not found. */
  QUANTITY_PRICE_BREAK_ADD_PRICE_LIST_PRICE_NOT_FOUND = 'QUANTITY_PRICE_BREAK_ADD_PRICE_LIST_PRICE_NOT_FOUND',
  /** Quantity price break variant not found. */
  QUANTITY_PRICE_BREAK_ADD_VARIANT_NOT_FOUND = 'QUANTITY_PRICE_BREAK_ADD_VARIANT_NOT_FOUND',
  /** Variant to delete by is not found. */
  QUANTITY_PRICE_BREAK_DELETE_BY_VARIANT_ID_VARIANT_NOT_FOUND = 'QUANTITY_PRICE_BREAK_DELETE_BY_VARIANT_ID_VARIANT_NOT_FOUND',
  /** Failed to delete quantity price break. */
  QUANTITY_PRICE_BREAK_DELETE_FAILED = 'QUANTITY_PRICE_BREAK_DELETE_FAILED',
  /** Quantity price break not found. */
  QUANTITY_PRICE_BREAK_DELETE_NOT_FOUND = 'QUANTITY_PRICE_BREAK_DELETE_NOT_FOUND',
  /** Quantity rule catalog context not supported. */
  QUANTITY_RULE_ADD_CATALOG_CONTEXT_NOT_SUPPORTED = 'QUANTITY_RULE_ADD_CATALOG_CONTEXT_NOT_SUPPORTED',
  /** Quantity rules to add inputs must be unique by variant id. */
  QUANTITY_RULE_ADD_DUPLICATE_INPUT_FOR_VARIANT = 'QUANTITY_RULE_ADD_DUPLICATE_INPUT_FOR_VARIANT',
  /** Quantity rule increment is greater than minimum. */
  QUANTITY_RULE_ADD_INCREMENT_IS_GREATER_THAN_MINIMUM = 'QUANTITY_RULE_ADD_INCREMENT_IS_GREATER_THAN_MINIMUM',
  /** Quantity rule increment is less than one. */
  QUANTITY_RULE_ADD_INCREMENT_IS_LESS_THAN_ONE = 'QUANTITY_RULE_ADD_INCREMENT_IS_LESS_THAN_ONE',
  /** Quantity rule increment must be a multiple of the quantity price break minimum. */
  QUANTITY_RULE_ADD_INCREMENT_NOT_A_MULTIPLE_OF_QUANTITY_PRICE_BREAK_MIN = 'QUANTITY_RULE_ADD_INCREMENT_NOT_A_MULTIPLE_OF_QUANTITY_PRICE_BREAK_MIN',
  /** Quantity rule maximum is less than one. */
  QUANTITY_RULE_ADD_MAXIMUM_IS_LESS_THAN_ONE = 'QUANTITY_RULE_ADD_MAXIMUM_IS_LESS_THAN_ONE',
  /** Quantity rule maximum is not a multiple of increment. */
  QUANTITY_RULE_ADD_MAXIMUM_NOT_A_MULTIPLE_OF_INCREMENT = 'QUANTITY_RULE_ADD_MAXIMUM_NOT_A_MULTIPLE_OF_INCREMENT',
  /** Quantity rule maximum is less than the quantity price break minimum. */
  QUANTITY_RULE_ADD_MAX_LOWER_THAN_QUANTITY_PRICE_BREAK_MIN = 'QUANTITY_RULE_ADD_MAX_LOWER_THAN_QUANTITY_PRICE_BREAK_MIN',
  /** Quantity rule minimum is greater than maximum. */
  QUANTITY_RULE_ADD_MINIMUM_GREATER_THAN_MAXIMUM = 'QUANTITY_RULE_ADD_MINIMUM_GREATER_THAN_MAXIMUM',
  /** Quantity rule minimum is less than one. */
  QUANTITY_RULE_ADD_MINIMUM_IS_LESS_THAN_ONE = 'QUANTITY_RULE_ADD_MINIMUM_IS_LESS_THAN_ONE',
  /** Quantity rule minimum is not a multiple of increment. */
  QUANTITY_RULE_ADD_MINIMUM_NOT_A_MULTIPLE_OF_INCREMENT = 'QUANTITY_RULE_ADD_MINIMUM_NOT_A_MULTIPLE_OF_INCREMENT',
  /** Quantity rule minimum is higher than the quantity price break minimum. */
  QUANTITY_RULE_ADD_MIN_HIGHER_THAN_QUANTITY_PRICE_BREAK_MIN = 'QUANTITY_RULE_ADD_MIN_HIGHER_THAN_QUANTITY_PRICE_BREAK_MIN',
  /** Quantity rule variant not found. */
  QUANTITY_RULE_ADD_VARIANT_NOT_FOUND = 'QUANTITY_RULE_ADD_VARIANT_NOT_FOUND',
  /** Quantity rule not found. */
  QUANTITY_RULE_DELETE_RULE_NOT_FOUND = 'QUANTITY_RULE_DELETE_RULE_NOT_FOUND',
  /** Quantity rule variant not found. */
  QUANTITY_RULE_DELETE_VARIANT_NOT_FOUND = 'QUANTITY_RULE_DELETE_VARIANT_NOT_FOUND'
}

/** The quantity rule for the product variant in a given context. */
export type QuantityRule = {
  /**
   * The value that specifies the quantity increment between minimum and maximum of the rule.
   * Only quantities divisible by this value will be considered valid.
   *
   * The increment must be lower than or equal to the minimum and the maximum, and both minimum and maximum
   * must be divisible by this value.
   */
  readonly increment: Scalars['Int'];
  /** Whether the quantity rule fields match one increment, one minimum and no maximum. */
  readonly isDefault: Scalars['Boolean'];
  /**
   * An optional value that defines the highest allowed quantity purchased by the customer.
   * If defined, maximum must be lower than or equal to the minimum and must be a multiple of the increment.
   */
  readonly maximum?: Maybe<Scalars['Int']>;
  /**
   * The value that defines the lowest allowed quantity purchased by the customer.
   * The minimum must be a multiple of the quantity rule's increment.
   */
  readonly minimum: Scalars['Int'];
  /** Whether the values of the quantity rule were explicitly set. */
  readonly originType: QuantityRuleOriginType;
  /** The product variant for which the quantity rule is applied. */
  readonly productVariant: ProductVariant;
};

/** An auto-generated type for paginating through multiple QuantityRules. */
export type QuantityRuleConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<QuantityRuleEdge>;
  /** A list of nodes that are contained in QuantityRuleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<QuantityRule>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one QuantityRule and a cursor during pagination. */
export type QuantityRuleEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of QuantityRuleEdge. */
  readonly node: QuantityRule;
};

/** The input fields for the per-order quantity rule to be applied on the product variant. */
export type QuantityRuleInput = {
  /** The quantity increment. */
  readonly increment: Scalars['Int'];
  /** The maximum quantity. */
  readonly maximum?: InputMaybe<Scalars['Int']>;
  /** The minimum quantity. */
  readonly minimum: Scalars['Int'];
  /** Product variant on which to apply the quantity rule. */
  readonly variantId: Scalars['ID'];
};

/** The origin of quantity rule on a price list. */
export enum QuantityRuleOriginType {
  /** Quantity rule is explicitly defined. */
  FIXED = 'FIXED',
  /** Quantity rule falls back to the relative rule. */
  RELATIVE = 'RELATIVE'
}

/** An error for a failed quantity rule operation. */
export type QuantityRuleUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<QuantityRuleUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `QuantityRuleUserError`. */
export enum QuantityRuleUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Quantity rules can be associated only with company location catalogs. */
  CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES = 'CATALOG_CONTEXT_DOES_NOT_SUPPORT_QUANTITY_RULES',
  /** Quantity rule inputs must be unique by variant id. */
  DUPLICATE_INPUT_FOR_VARIANT = 'DUPLICATE_INPUT_FOR_VARIANT',
  /** Something went wrong when trying to save the quantity rule. Please try again later. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** Value must be greater than or equal to 1. */
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  /** Increment must be lower than or equal to the minimum. */
  INCREMENT_IS_GREATER_THAN_MINIMUM = 'INCREMENT_IS_GREATER_THAN_MINIMUM',
  /** Increment must be a multiple of all quantity price break minimums associated with this variant in the specified price list. */
  INCREMENT_NOT_A_MULTIPLE_OF_QUANTITY_PRICE_BREAK_MINIMUM = 'INCREMENT_NOT_A_MULTIPLE_OF_QUANTITY_PRICE_BREAK_MINIMUM',
  /** Maximum must be greater than or equal to all quantity price break minimums associated with this variant in the specified price list. */
  MAXIMUM_IS_LOWER_THAN_QUANTITY_PRICE_BREAK_MINIMUM = 'MAXIMUM_IS_LOWER_THAN_QUANTITY_PRICE_BREAK_MINIMUM',
  /** The maximum must be a multiple of the increment. */
  MAXIMUM_NOT_MULTIPLE_OF_INCREMENT = 'MAXIMUM_NOT_MULTIPLE_OF_INCREMENT',
  /** Minimum must be lower than or equal to the maximum. */
  MINIMUM_IS_GREATER_THAN_MAXIMUM = 'MINIMUM_IS_GREATER_THAN_MAXIMUM',
  /** Minimum must be less than or equal to all quantity price break minimums associated with this variant in the specified price list. */
  MINIMUM_IS_HIGHER_THAN_QUANTITY_PRICE_BREAK_MINIMUM = 'MINIMUM_IS_HIGHER_THAN_QUANTITY_PRICE_BREAK_MINIMUM',
  /** The minimum must be a multiple of the increment. */
  MINIMUM_NOT_MULTIPLE_OF_INCREMENT = 'MINIMUM_NOT_MULTIPLE_OF_INCREMENT',
  /** Price list does not exist. */
  PRICE_LIST_DOES_NOT_EXIST = 'PRICE_LIST_DOES_NOT_EXIST',
  /** Product variant ID does not exist. */
  PRODUCT_VARIANT_DOES_NOT_EXIST = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** Quantity rule for variant associated with the price list provided does not exist. */
  VARIANT_QUANTITY_RULE_DOES_NOT_EXIST = 'VARIANT_QUANTITY_RULE_DOES_NOT_EXIST'
}

/** Return type for `quantityRulesAdd` mutation. */
export type QuantityRulesAddPayload = {
  /** The list of quantity rules that were added to or updated in the price list. */
  readonly quantityRules?: Maybe<ReadonlyArray<QuantityRule>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<QuantityRuleUserError>;
};

/** Return type for `quantityRulesDelete` mutation. */
export type QuantityRulesDeletePayload = {
  /** A list of product variant IDs whose quantity rules were removed from the price list. */
  readonly deletedQuantityRulesVariantIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<QuantityRuleUserError>;
};

/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRoot = {
  /** List of abandoned checkouts. Includes checkouts that were recovered after being abandoned. */
  readonly abandonedCheckouts: AbandonedCheckoutConnection;
  /** Returns the count of abandoned checkouts for the given shop. Limited to a maximum of 10000. */
  readonly abandonedCheckoutsCount?: Maybe<Count>;
  /** Returns an abandonment by ID. */
  readonly abandonment?: Maybe<Abandonment>;
  /** Returns an Abandonment by the Abandoned Checkout ID. */
  readonly abandonmentByAbandonedCheckoutId?: Maybe<Abandonment>;
  /** Lookup an App by ID or return the currently authenticated App. */
  readonly app?: Maybe<App>;
  /**
   * Fetches app by handle.
   * Returns null if the app doesn't exist.
   */
  readonly appByHandle?: Maybe<App>;
  /**
   * Fetches an app by its client ID.
   * Returns null if the app doesn't exist.
   */
  readonly appByKey?: Maybe<App>;
  /** An app discount type. */
  readonly appDiscountType?: Maybe<AppDiscountType>;
  /** A list of app discount types installed by apps. */
  readonly appDiscountTypes: ReadonlyArray<AppDiscountType>;
  /** Lookup an AppInstallation by ID or return the AppInstallation for the currently authenticated App. */
  readonly appInstallation?: Maybe<AppInstallation>;
  /** A list of app installations. To use this query, you need to contact [Shopify Support](https://partners.shopify.com/current/support/) to grant your custom app the `read_apps` access scope. Public apps can't be granted this access scope. */
  readonly appInstallations: AppInstallationConnection;
  /** Returns an Article resource by ID. */
  readonly article?: Maybe<Article>;
  /** List of all article tags. */
  readonly articleTags: ReadonlyArray<Scalars['String']>;
  /** List of the shop's articles. */
  readonly articles: ArticleConnection;
  /**
   * The paginated list of fulfillment orders assigned to the shop locations owned by the app.
   *
   * Assigned fulfillment orders are fulfillment orders that are set to be fulfilled from locations
   * managed by
   * [fulfillment services](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
   * that are registered by the app.
   * One app (api_client) can host multiple fulfillment services on a shop.
   * Each fulfillment service manages a dedicated location on a shop.
   * Assigned fulfillment orders can have associated
   * [fulfillment requests](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderRequestStatus),
   * or might currently not be requested to be fulfilled.
   *
   * The app must have the `read_assigned_fulfillment_orders`
   * [access scope](https://shopify.dev/docs/api/usage/access-scopes)
   * to be able to retrieve the fulfillment orders assigned to its locations.
   *
   * All assigned fulfillment orders (except those with the `CLOSED` status) will be returned by default.
   * Perform filtering with the `assignmentStatus` argument
   * to receive only fulfillment orders that have been requested to be fulfilled.
   */
  readonly assignedFulfillmentOrders: FulfillmentOrderConnection;
  /**
   * Returns an automatic discount resource by ID.
   * @deprecated Use `automaticDiscountNode` instead.
   */
  readonly automaticDiscount?: Maybe<DiscountAutomatic>;
  /** Returns an automatic discount resource by ID. */
  readonly automaticDiscountNode?: Maybe<DiscountAutomaticNode>;
  /** Returns a list of [automatic discounts](https://help.shopify.com/manual/discounts/discount-types#automatic-discounts). */
  readonly automaticDiscountNodes: DiscountAutomaticNodeConnection;
  /** List of the shop's automatic discount saved searches. */
  readonly automaticDiscountSavedSearches: SavedSearchConnection;
  /**
   * List of automatic discounts.
   * @deprecated Use `automaticDiscountNodes` instead.
   */
  readonly automaticDiscounts: DiscountAutomaticConnection;
  /** Returns a list of activated carrier services and associated shop locations that support them. */
  readonly availableCarrierServices: ReadonlyArray<DeliveryCarrierServiceAndLocations>;
  /** A list of available locales. */
  readonly availableLocales: ReadonlyArray<Locale>;
  /** Returns a Blog resource by ID. */
  readonly blog?: Maybe<Blog>;
  /** List of the shop's blogs. */
  readonly blogs: BlogConnection;
  /** Count of blogs. */
  readonly blogsCount?: Maybe<Count>;
  /** Returns a list of Business Entities associated with the shop. */
  readonly businessEntities: ReadonlyArray<BusinessEntity>;
  /** Returns a Business Entity by ID. */
  readonly businessEntity?: Maybe<BusinessEntity>;
  /** Returns a `DeliveryCarrierService` object by ID. */
  readonly carrierService?: Maybe<DeliveryCarrierService>;
  /** Retrieve a list of CarrierServices. */
  readonly carrierServices: DeliveryCarrierServiceConnection;
  /** List of Cart transform objects owned by the current API client. */
  readonly cartTransforms: CartTransformConnection;
  /** Lookup a cash tracking session by ID. */
  readonly cashTrackingSession?: Maybe<CashTrackingSession>;
  /**
   * Returns a shop's cash tracking sessions for locations with a POS Pro subscription.
   *
   * Tip: To query for cash tracking sessions in bulk, you can
   * [perform a bulk operation](https://shopify.dev/docs/api/usage/bulk-operations/queries).
   */
  readonly cashTrackingSessions: CashTrackingSessionConnection;
  /** Returns a Catalog resource by ID. */
  readonly catalog?: Maybe<Catalog>;
  /** Returns the most recent catalog operations for the shop. */
  readonly catalogOperations: ReadonlyArray<ResourceOperation>;
  /** The catalogs belonging to the shop. */
  readonly catalogs: CatalogConnection;
  /** The count of catalogs belonging to the shop. Limited to a maximum of 10000. */
  readonly catalogsCount?: Maybe<Count>;
  /**
   * Lookup a channel by ID.
   * @deprecated Use `publication` instead.
   */
  readonly channel?: Maybe<Channel>;
  /**
   * List of the active sales channels.
   * @deprecated Use `publications` instead.
   */
  readonly channels: ChannelConnection;
  /**
   * Returns the visual customizations for checkout for a given checkout profile.
   *
   * To learn more about updating checkout branding settings, refer to the
   * [checkoutBrandingUpsert](https://shopify.dev/api/admin-graphql/unstable/mutations/checkoutBrandingUpsert)
   * mutation and the checkout branding [tutorial](https://shopify.dev/docs/apps/checkout/styling).
   */
  readonly checkoutBranding?: Maybe<CheckoutBranding>;
  /** A checkout profile on a shop. */
  readonly checkoutProfile?: Maybe<CheckoutProfile>;
  /** List of checkout profiles on a shop. */
  readonly checkoutProfiles: CheckoutProfileConnection;
  /** Returns a [code discount](https://help.shopify.com/manual/discounts/discount-types#discount-codes) resource by ID. */
  readonly codeDiscountNode?: Maybe<DiscountCodeNode>;
  /** Returns a code discount identified by its discount code. */
  readonly codeDiscountNodeByCode?: Maybe<DiscountCodeNode>;
  /** Returns a list of [code-based discounts](https://help.shopify.com/manual/discounts/discount-types#discount-codes). */
  readonly codeDiscountNodes: DiscountCodeNodeConnection;
  /** List of the shop's code discount saved searches. */
  readonly codeDiscountSavedSearches: SavedSearchConnection;
  /** Returns a Collection resource by ID. */
  readonly collection?: Maybe<Collection>;
  /**
   * Return a collection by its handle.
   * @deprecated Use `collectionByIdentifier` instead.
   */
  readonly collectionByHandle?: Maybe<Collection>;
  /** Lists all rules that can be used to create smart collections. */
  readonly collectionRulesConditions: ReadonlyArray<CollectionRuleConditions>;
  /** Returns a list of the shop's collection saved searches. */
  readonly collectionSavedSearches: SavedSearchConnection;
  /** Returns a list of collections. */
  readonly collections: CollectionConnection;
  /** Count of collections. Limited to a maximum of 10000. */
  readonly collectionsCount?: Maybe<Count>;
  /** Returns a Comment resource by ID. */
  readonly comment?: Maybe<Comment>;
  /** List of the shop's comments. */
  readonly comments: CommentConnection;
  /** Returns the list of companies in the shop. */
  readonly companies: CompanyConnection;
  /** The number of companies for a shop. */
  readonly companiesCount?: Maybe<Count>;
  /** Returns a `Company` object by ID. */
  readonly company?: Maybe<Company>;
  /** Returns a `CompanyContact` object by ID. */
  readonly companyContact?: Maybe<CompanyContact>;
  /** Returns a `CompanyContactRole` object by ID. */
  readonly companyContactRole?: Maybe<CompanyContactRole>;
  /** Returns a `CompanyLocation` object by ID. */
  readonly companyLocation?: Maybe<CompanyLocation>;
  /** Returns the list of company locations in the shop. */
  readonly companyLocations: CompanyLocationConnection;
  /** Return the AppInstallation for the currently authenticated App. */
  readonly currentAppInstallation: AppInstallation;
  /** Returns the current app's most recent BulkOperation. Apps can run one bulk query and one bulk mutation operation at a time, by shop. */
  readonly currentBulkOperation?: Maybe<BulkOperation>;
  /** The staff member making the API request. */
  readonly currentStaffMember?: Maybe<StaffMember>;
  /** Returns a Customer resource by ID. */
  readonly customer?: Maybe<Customer>;
  /** Returns a customer account page. */
  readonly customerAccountPage?: Maybe<CustomerAccountPage>;
  /** List of the shop's customer account pages. */
  readonly customerAccountPages?: Maybe<CustomerAccountPageConnection>;
  /** Returns the status of a customer merge request job. */
  readonly customerMergeJobStatus?: Maybe<CustomerMergeRequest>;
  /** Returns a preview of a customer merge request. */
  readonly customerMergePreview: CustomerMergePreview;
  /** Returns a CustomerPaymentMethod resource by its ID. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /**
   * The list of members, such as customers, that's associated with an individual segment.
   * The maximum page size is 1000.
   */
  readonly customerSegmentMembers: CustomerSegmentMemberConnection;
  /** Returns a segment members query resource by ID. */
  readonly customerSegmentMembersQuery?: Maybe<CustomerSegmentMembersQuery>;
  /** Whether a member, which is a customer, belongs to a segment. */
  readonly customerSegmentMembership: SegmentMembershipResponse;
  /**
   * Returns a list of [customers](https://shopify.dev/api/admin-graphql/latest/objects/Customer) in your Shopify store, including key information such as name, email, location, and purchase history.
   * Use this query to segment your audience, personalize marketing campaigns, or analyze customer behavior by applying filters based on location, order history, marketing preferences and tags.
   * The `customers` query supports [pagination](https://shopify.dev/api/usage/pagination-graphql) and [sorting](https://shopify.dev/api/admin-graphql/latest/enums/CustomerSortKeys).
   */
  readonly customers: CustomerConnection;
  /** The number of customers. */
  readonly customersCount?: Maybe<Count>;
  /**
   * The paginated list of deletion events.
   * @deprecated Use `events` instead.
   */
  readonly deletionEvents: DeletionEventConnection;
  /** The delivery customization. */
  readonly deliveryCustomization?: Maybe<DeliveryCustomization>;
  /** The delivery customizations. */
  readonly deliveryCustomizations: DeliveryCustomizationConnection;
  /** Returns a Delivery Profile resource by ID. */
  readonly deliveryProfile?: Maybe<DeliveryProfile>;
  /** Returns a list of saved delivery profiles. */
  readonly deliveryProfiles: DeliveryProfileConnection;
  /** Lookup a delivery promise provider. */
  readonly deliveryPromiseProvider?: Maybe<DeliveryPromiseProvider>;
  /** Returns the shop-wide shipping settings. */
  readonly deliverySettings?: Maybe<DeliverySetting>;
  /** The total number of discount codes for the shop. */
  readonly discountCodesCount?: Maybe<Count>;
  /** Returns a discount resource by ID. */
  readonly discountNode?: Maybe<DiscountNode>;
  /** Returns a list of discounts. */
  readonly discountNodes: DiscountNodeConnection;
  /** The total number of discounts for the shop. Limited to a maximum of 10000. */
  readonly discountNodesCount?: Maybe<Count>;
  /** Returns a bulk code creation resource by ID. */
  readonly discountRedeemCodeBulkCreation?: Maybe<DiscountRedeemCodeBulkCreation>;
  /** List of the shop's redeemed discount code saved searches. */
  readonly discountRedeemCodeSavedSearches: SavedSearchConnection;
  /** Returns dispute details based on ID. */
  readonly dispute?: Maybe<ShopifyPaymentsDispute>;
  /** Returns dispute evidence details based on ID. */
  readonly disputeEvidence?: Maybe<ShopifyPaymentsDisputeEvidence>;
  /** All disputes related to the Shop. */
  readonly disputes: ShopifyPaymentsDisputeConnection;
  /** Lookup a Domain by ID. */
  readonly domain?: Maybe<Domain>;
  /** Returns a DraftOrder resource by ID. */
  readonly draftOrder?: Maybe<DraftOrder>;
  /** List of the shop's draft order saved searches. */
  readonly draftOrderSavedSearches: SavedSearchConnection;
  /** Returns a DraftOrderTag resource by ID. */
  readonly draftOrderTag?: Maybe<DraftOrderTag>;
  /** List of saved draft orders. */
  readonly draftOrders: DraftOrderConnection;
  /** Get a single event by its id. */
  readonly event?: Maybe<Event>;
  /** The paginated list of events associated with the store. */
  readonly events?: Maybe<EventConnection>;
  /** Count of events. Limited to a maximum of 10000. */
  readonly eventsCount?: Maybe<Count>;
  /** A list of the shop's file saved searches. */
  readonly fileSavedSearches: SavedSearchConnection;
  /** Returns a paginated list of files that have been uploaded to Shopify. */
  readonly files: FileConnection;
  /** Returns a Fulfillment resource by ID. */
  readonly fulfillment?: Maybe<Fulfillment>;
  /** The fulfillment constraint rules that belong to a shop. */
  readonly fulfillmentConstraintRules: ReadonlyArray<FulfillmentConstraintRule>;
  /** Returns a Fulfillment order resource by ID. */
  readonly fulfillmentOrder?: Maybe<FulfillmentOrder>;
  /**
   * The paginated list of all fulfillment orders.
   * The returned fulfillment orders are filtered according to the
   * [fulfillment order access scopes](https://shopify.dev/api/admin-graphql/latest/objects/fulfillmentorder#api-access-scopes)
   * granted to the app.
   *
   * Use this query to retrieve fulfillment orders assigned to merchant-managed locations,
   * third-party fulfillment service locations, or all kinds of locations together.
   *
   * For fetching only the fulfillment orders assigned to the app's locations, use the
   * [assignedFulfillmentOrders](https://shopify.dev/api/admin-graphql/2024-07/objects/queryroot#connection-assignedfulfillmentorders)
   * connection.
   */
  readonly fulfillmentOrders: FulfillmentOrderConnection;
  /** Returns a FulfillmentService resource by ID. */
  readonly fulfillmentService?: Maybe<FulfillmentService>;
  /** Returns a gift card resource by ID. */
  readonly giftCard?: Maybe<GiftCard>;
  /** Returns a list of gift cards. */
  readonly giftCards: GiftCardConnection;
  /** The total number of gift cards issued for the shop. Limited to a maximum of 10000. */
  readonly giftCardsCount?: Maybe<Count>;
  /**
   * Returns an
   * [InventoryItem](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryItem)
   * object by ID.
   */
  readonly inventoryItem?: Maybe<InventoryItem>;
  /** Returns a list of inventory items. */
  readonly inventoryItems: InventoryItemConnection;
  /**
   * Returns an
   * [InventoryLevel](https://shopify.dev/docs/api/admin-graphql/latest/objects/InventoryLevel)
   * object by ID.
   */
  readonly inventoryLevel?: Maybe<InventoryLevel>;
  /** General inventory properties for the shop. */
  readonly inventoryProperties: InventoryProperties;
  /** Returns a Job resource by ID. Used to check the status of internal jobs and any applicable changes. */
  readonly job?: Maybe<Job>;
  /** Returns an inventory Location resource by ID. */
  readonly location?: Maybe<Location>;
  /** Returns a list of active inventory locations. */
  readonly locations: LocationConnection;
  /**
   * Returns a list of all origin locations available for a delivery profile.
   * @deprecated Use `locationsAvailableForDeliveryProfilesConnection` instead.
   */
  readonly locationsAvailableForDeliveryProfiles?: Maybe<ReadonlyArray<Location>>;
  /** Returns a list of all origin locations available for a delivery profile. */
  readonly locationsAvailableForDeliveryProfilesConnection: LocationConnection;
  /** Returns the count of locations for the given shop. Limited to a maximum of 10000. */
  readonly locationsCount?: Maybe<Count>;
  /** Returns a list of fulfillment orders that are on hold. */
  readonly manualHoldsFulfillmentOrders: FulfillmentOrderConnection;
  /** Returns a market resource by ID. */
  readonly market?: Maybe<Market>;
  /** Returns the applicable market for a customer based on where they are in the world. */
  readonly marketByGeography?: Maybe<Market>;
  /** A resource that can have localized values for different markets. */
  readonly marketLocalizableResource?: Maybe<MarketLocalizableResource>;
  /** Resources that can have localized values for different markets. */
  readonly marketLocalizableResources: MarketLocalizableResourceConnection;
  /** Resources that can have localized values for different markets. */
  readonly marketLocalizableResourcesByIds: MarketLocalizableResourceConnection;
  /** A list of marketing activities associated with the marketing app. */
  readonly marketingActivities: MarketingActivityConnection;
  /** Returns a MarketingActivity resource by ID. */
  readonly marketingActivity?: Maybe<MarketingActivity>;
  /** Returns a MarketingEvent resource by ID. */
  readonly marketingEvent?: Maybe<MarketingEvent>;
  /** A list of marketing events associated with the marketing app. */
  readonly marketingEvents: MarketingEventConnection;
  /** The markets configured for the shop. */
  readonly markets: MarketConnection;
  /** Returns a Menu resource by ID. */
  readonly menu?: Maybe<Menu>;
  /** The shop's menus. */
  readonly menus: MenuConnection;
  /** Returns a metafield definition by identifier. */
  readonly metafieldDefinition?: Maybe<MetafieldDefinition>;
  /**
   * Each metafield definition has a type, which defines the type of information that it can store.
   * This type is enforced across every instance of the resource that owns the metafield definition.
   *
   * Refer to the [list of supported metafield types](https://shopify.dev/apps/metafields/types).
   */
  readonly metafieldDefinitionTypes: ReadonlyArray<MetafieldDefinitionType>;
  /** Returns a list of metafield definitions. */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * List of the `MetafieldStorefrontVisibility` records.
   * @deprecated This query will be removed in a future version. Use the `access.storefront` field for nodes inside the `metafieldDefinitions` query instead.
   *
   */
  readonly metafieldStorefrontVisibilities: MetafieldStorefrontVisibilityConnection;
  /**
   * Returns a `MetafieldStorefrontVisibility` record by ID. A `MetafieldStorefrontVisibility` record lists the
   * metafields to make visible in the Storefront API.
   * @deprecated This query will be removed in a future version. Use the `access.storefront` field inside the `metafieldDefinition` query instead.
   *
   */
  readonly metafieldStorefrontVisibility?: Maybe<MetafieldStorefrontVisibility>;
  /** Retrieves a metaobject by ID. */
  readonly metaobject?: Maybe<Metaobject>;
  /** Retrieves a metaobject by handle. */
  readonly metaobjectByHandle?: Maybe<Metaobject>;
  /** Retrieves a metaobject definition by ID. */
  readonly metaobjectDefinition?: Maybe<MetaobjectDefinition>;
  /** Finds a metaobject definition by type. */
  readonly metaobjectDefinitionByType?: Maybe<MetaobjectDefinition>;
  /** All metaobject definitions. */
  readonly metaobjectDefinitions: MetaobjectDefinitionConnection;
  /** All metaobjects for the shop. */
  readonly metaobjects: MetaobjectConnection;
  /** Return a mobile platform application by its ID. */
  readonly mobilePlatformApplication?: Maybe<MobilePlatformApplication>;
  /** List the mobile platform applications. */
  readonly mobilePlatformApplications: MobilePlatformApplicationConnection;
  /**
   * Returns a specific node (any object that implements the
   * [Node](https://shopify.dev/api/admin-graphql/latest/interfaces/Node)
   * interface) by ID, in accordance with the
   * [Relay specification](https://relay.dev/docs/guides/graphql-server-specification/#object-identification).
   * This field is commonly used for refetching an object.
   */
  readonly node?: Maybe<Node>;
  /**
   * Returns the list of nodes (any objects that implement the
   * [Node](https://shopify.dev/api/admin-graphql/latest/interfaces/Node)
   * interface) with the given IDs, in accordance with the
   * [Relay specification](https://relay.dev/docs/guides/graphql-server-specification/#object-identification).
   */
  readonly nodes: ReadonlyArray<Maybe<Node>>;
  /** The shop's online store channel. */
  readonly onlineStore: OnlineStore;
  /** Returns an Order resource by ID. */
  readonly order?: Maybe<Order>;
  /** Returns a payment status by payment reference ID. Used to check the status of a deferred payment. */
  readonly orderPaymentStatus?: Maybe<OrderPaymentStatus>;
  /** List of the shop's order saved searches. */
  readonly orderSavedSearches: SavedSearchConnection;
  /**
   * Returns a list of [orders](https://shopify.dev/api/admin-graphql/latest/objects/Order) placed in the store, including data such as order status, customer, and line item details.
   * Use the `orders` query to build reports, analyze sales performance, or automate fulfillment workflows. The `orders` query supports [pagination](https://shopify.dev/docs/api/usage/pagination-graphql),
   * [sorting](https://shopify.dev/docs/api/admin-graphql/latest/queries/orders#argument-sortkey), and [filtering](https://shopify.dev/docs/api/admin-graphql/latest/queries/orders#argument-query).
   */
  readonly orders: OrderConnection;
  /** Returns the count of orders for the given shop. Limited to a maximum of 10000. */
  readonly ordersCount?: Maybe<Count>;
  /** Returns a Page resource by ID. */
  readonly page?: Maybe<Page>;
  /** List of the shop's pages. */
  readonly pages: PageConnection;
  /** Count of pages. */
  readonly pagesCount?: Maybe<Count>;
  /** The payment customization. */
  readonly paymentCustomization?: Maybe<PaymentCustomization>;
  /** The payment customizations. */
  readonly paymentCustomizations: PaymentCustomizationConnection;
  /** The list of payment terms templates eligible for all shops and users. */
  readonly paymentTermsTemplates: ReadonlyArray<PaymentTermsTemplate>;
  /** The number of pendings orders. Limited to a maximum of 10000. */
  readonly pendingOrdersCount?: Maybe<Count>;
  /** Returns a price list resource by ID. */
  readonly priceList?: Maybe<PriceList>;
  /** All price lists for a shop. */
  readonly priceLists: PriceListConnection;
  /**
   * The primary market of the shop.
   * @deprecated Use `backupRegion` instead.
   */
  readonly primaryMarket: Market;
  /**
   * Returns a private metafield by ID.
   * Private metafields are accessible only by the application that created them.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * Returns a list of private metafields associated to a resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** Returns a Product resource by ID. */
  readonly product?: Maybe<Product>;
  /**
   * Return a product by its handle.
   * @deprecated Use `productByIdentifier` instead.
   */
  readonly productByHandle?: Maybe<Product>;
  /** Returns the product duplicate job. */
  readonly productDuplicateJob: ProductDuplicateJob;
  /** Returns a ProductFeed resource by ID. */
  readonly productFeed?: Maybe<ProductFeed>;
  /** The product feeds for the shop. */
  readonly productFeeds: ProductFeedConnection;
  /**
   * Returns a ProductOperation resource by ID.
   *
   * This can be used to query the
   * [ProductSetOperation](https://shopify.dev/api/admin-graphql/current/objects/ProductSetOperation), using
   * the ID that was returned
   * [when the product was created or updated](https://shopify.dev/api/admin/migrate/new-product-model/sync-data#create-a-product-with-variants-and-options-asynchronously)
   * by the
   * [ProductSet](https://shopify.dev/api/admin-graphql/current/mutations/productSet) mutation.
   *
   * The `status` field indicates whether the operation is `CREATED`, `ACTIVE`, or `COMPLETE`.
   *
   * The `product` field provides the details of the created or updated product.
   *
   * For the
   * [ProductSetOperation](https://shopify.dev/api/admin-graphql/current/objects/ProductSetOperation), the
   * `userErrors` field provides mutation errors that occurred during the operation.
   */
  readonly productOperation?: Maybe<ProductOperation>;
  /** Returns the product resource feedback for the currently authenticated app. */
  readonly productResourceFeedback?: Maybe<ProductResourceFeedback>;
  /** Returns a list of the shop's product saved searches. */
  readonly productSavedSearches: SavedSearchConnection;
  /** Returns a ProductVariant resource by ID. */
  readonly productVariant?: Maybe<ProductVariant>;
  /** Returns a list of product variants. */
  readonly productVariants: ProductVariantConnection;
  /** Count of product variants. */
  readonly productVariantsCount?: Maybe<Count>;
  /** Returns a list of products. */
  readonly products: ProductConnection;
  /** Count of products. */
  readonly productsCount?: Maybe<Count>;
  /** The list of publicly-accessible Admin API versions, including supported versions, the release candidate, and unstable versions. */
  readonly publicApiVersions: ReadonlyArray<ApiVersion>;
  /** Lookup a publication by ID. */
  readonly publication?: Maybe<Publication>;
  /** List of publications. */
  readonly publications: PublicationConnection;
  /** Count of publications. */
  readonly publicationsCount?: Maybe<Count>;
  /** Returns a count of published products by publication ID. */
  readonly publishedProductsCount?: Maybe<Count>;
  /** Returns a Refund resource by ID. */
  readonly refund?: Maybe<Refund>;
  /** Returns a Return resource by ID. */
  readonly return?: Maybe<Return>;
  /** The calculated monetary value to be exchanged due to the return. */
  readonly returnCalculate?: Maybe<CalculatedReturn>;
  /** Lookup a returnable fulfillment by ID. */
  readonly returnableFulfillment?: Maybe<ReturnableFulfillment>;
  /** List of returnable fulfillments. */
  readonly returnableFulfillments: ReturnableFulfillmentConnection;
  /** Lookup a reverse delivery by ID. */
  readonly reverseDelivery?: Maybe<ReverseDelivery>;
  /** Lookup a reverse fulfillment order by ID. */
  readonly reverseFulfillmentOrder?: Maybe<ReverseFulfillmentOrder>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>Your app might not pass App Store review if it uses script tags instead of theme app extensions. All new apps, and apps that integrate with Online Store 2.0 themes, should use theme app extensions, such as app blocks or app embed blocks. Script tags are an alternative you can use with only vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   * <div class="note"><h4>Script tag deprecation</h4>
   *   <p>Script tags will be sunset for the <b>Order status</b> page on August 28, 2025. <a href="https://www.shopify.com/plus/upgrading-to-checkout-extensibility">Upgrade to Checkout Extensibility</a> before this date. <a href="/docs/api/liquid/objects#script">Shopify Scripts</a> will continue to work alongside Checkout Extensibility until August 28, 2025.</p></div>
   *
   *
   * Lookup a script tag resource by ID.
   */
  readonly scriptTag?: Maybe<ScriptTag>;
  /**
   * <div class="note"><h4>Theme app extensions</h4>
   *   <p>Your app might not pass App Store review if it uses script tags instead of theme app extensions. All new apps, and apps that integrate with Online Store 2.0 themes, should use theme app extensions, such as app blocks or app embed blocks. Script tags are an alternative you can use with only vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
   *
   * <div class="note"><h4>Script tag deprecation</h4>
   *   <p>Script tags will be sunset for the <b>Order status</b> page on August 28, 2025. <a href="https://www.shopify.com/plus/upgrading-to-checkout-extensibility">Upgrade to Checkout Extensibility</a> before this date. <a href="/docs/api/liquid/objects#script">Shopify Scripts</a> will continue to work alongside Checkout Extensibility until August 28, 2025.</p></div>
   *
   *
   * A list of script tags.
   */
  readonly scriptTags: ScriptTagConnection;
  /** The Customer Segment. */
  readonly segment?: Maybe<Segment>;
  /** A list of filter suggestions associated with a segment. A segment is a group of members (commonly customers) that meet specific criteria. */
  readonly segmentFilterSuggestions: SegmentFilterConnection;
  /** A list of filters. */
  readonly segmentFilters: SegmentFilterConnection;
  /** A list of a shop's segment migrations. */
  readonly segmentMigrations: SegmentMigrationConnection;
  /** The list of suggested values corresponding to a particular filter for a segment. A segment is a group of members, such as customers, that meet specific criteria. */
  readonly segmentValueSuggestions: SegmentValueConnection;
  /** A list of a shop's segments. */
  readonly segments: SegmentConnection;
  /** The number of segments for a shop. */
  readonly segmentsCount?: Maybe<Count>;
  /** Returns a Selling Plan Group resource by ID. */
  readonly sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** List Selling Plan Groups. */
  readonly sellingPlanGroups: SellingPlanGroupConnection;
  /** The server pixel configured by the app. */
  readonly serverPixel?: Maybe<ServerPixel>;
  /**
   * Returns the Shop resource corresponding to the access token used in the request. The Shop resource contains
   * business and store management settings for the shop.
   */
  readonly shop: Shop;
  /** The shop's billing preferences. */
  readonly shopBillingPreferences: ShopBillingPreferences;
  /** A list of locales available on a shop. */
  readonly shopLocales: ReadonlyArray<ShopLocale>;
  /**
   * Returns a Shopify Function by its ID.
   * [Functions](https://shopify.dev/apps/build/functions)
   * enable you to customize Shopify's backend logic at defined parts of the commerce loop.
   */
  readonly shopifyFunction?: Maybe<ShopifyFunction>;
  /** Returns the Shopify Functions owned by the querying API client installed on the shop. */
  readonly shopifyFunctions: ShopifyFunctionConnection;
  /** Shopify Payments account information, including balances and payouts. */
  readonly shopifyPaymentsAccount?: Maybe<ShopifyPaymentsAccount>;
  /** The StaffMember resource, by ID. */
  readonly staffMember?: Maybe<StaffMember>;
  /** The shop staff members. */
  readonly staffMembers?: Maybe<StaffMemberConnection>;
  /**
   * Standard metafield definitions are intended for specific, common use cases. Their namespace and keys reflect these use cases and are reserved.
   *
   * Refer to all available [`Standard Metafield Definition Templates`](https://shopify.dev/api/admin-graphql/latest/objects/StandardMetafieldDefinitionTemplate).
   */
  readonly standardMetafieldDefinitionTemplates: StandardMetafieldDefinitionTemplateConnection;
  /** Returns a store credit account resource by ID. */
  readonly storeCreditAccount?: Maybe<StoreCreditAccount>;
  /** Returns a SubscriptionBillingAttempt by ID. */
  readonly subscriptionBillingAttempt?: Maybe<SubscriptionBillingAttempt>;
  /** Returns subscription billing attempts on a store. */
  readonly subscriptionBillingAttempts: SubscriptionBillingAttemptConnection;
  /** Returns a subscription billing cycle found either by cycle index or date. */
  readonly subscriptionBillingCycle?: Maybe<SubscriptionBillingCycle>;
  /**
   * Retrieves the results of the asynchronous job for the subscription billing cycle bulk action based on the specified job ID.
   * This query can be used to obtain the billing cycles that match the criteria defined in the subscriptionBillingCycleBulkSearch and subscriptionBillingCycleBulkCharge mutations.
   */
  readonly subscriptionBillingCycleBulkResults: SubscriptionBillingCycleConnection;
  /** Returns subscription billing cycles for a contract ID. */
  readonly subscriptionBillingCycles: SubscriptionBillingCycleConnection;
  /** Returns a Subscription Contract resource by ID. */
  readonly subscriptionContract?: Maybe<SubscriptionContract>;
  /** List Subscription Contracts. */
  readonly subscriptionContracts: SubscriptionContractConnection;
  /** Returns a Subscription Draft resource by ID. */
  readonly subscriptionDraft?: Maybe<SubscriptionDraft>;
  /** The Taxonomy resource lets you access the categories, attributes and values of the loaded taxonomy tree. */
  readonly taxonomy?: Maybe<Taxonomy>;
  /** Returns a list of TenderTransactions associated with the shop. */
  readonly tenderTransactions: TenderTransactionConnection;
  /** Returns a particular theme for the shop. */
  readonly theme?: Maybe<OnlineStoreTheme>;
  /** Returns a paginated list of themes for the shop. */
  readonly themes?: Maybe<OnlineStoreThemeConnection>;
  /** A resource that can have localized values for different languages. */
  readonly translatableResource?: Maybe<TranslatableResource>;
  /** Resources that can have localized values for different languages. */
  readonly translatableResources: TranslatableResourceConnection;
  /** Resources that can have localized values for different languages. */
  readonly translatableResourcesByIds: TranslatableResourceConnection;
  /** Returns a redirect resource by ID. */
  readonly urlRedirect?: Maybe<UrlRedirect>;
  /** Returns a redirect import resource by ID. */
  readonly urlRedirectImport?: Maybe<UrlRedirectImport>;
  /** A list of the shop's URL redirect saved searches. */
  readonly urlRedirectSavedSearches: SavedSearchConnection;
  /** A list of redirects for a shop. */
  readonly urlRedirects: UrlRedirectConnection;
  /** Count of redirects. Limited to a maximum of 10000. */
  readonly urlRedirectsCount?: Maybe<Count>;
  /** Validation available on the shop. */
  readonly validation?: Maybe<Validation>;
  /** Validations available on the shop. */
  readonly validations: ValidationConnection;
  /**
   * Returns a
   * [web pixel](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels)
   * by ID.
   */
  readonly webPixel?: Maybe<WebPixel>;
  /**
   * Returns a webhook subscription by ID.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly webhookSubscription?: Maybe<WebhookSubscription>;
  /**
   * Returns a list of webhook subscriptions.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe).
   */
  readonly webhookSubscriptions: WebhookSubscriptionConnection;
  /**
   * The count of webhook subscriptions.
   *
   * Building an app? If you only use app-specific webhooks, you won't need this. App-specific webhook subscriptions specified in your `shopify.app.toml` may be easier. They are automatically kept up to date by Shopify & require less maintenance. Please read [About managing webhook subscriptions](https://shopify.dev/docs/apps/build/webhooks/subscribe). Limited to a maximum of 10000.
   */
  readonly webhookSubscriptionsCount?: Maybe<Count>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAbandonedCheckoutsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<AbandonedCheckoutSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAbandonedCheckoutsCountArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAbandonmentArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAbandonmentByAbandonedCheckoutIdArgs = {
  abandonedCheckoutId: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppByHandleArgs = {
  handle: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppByKeyArgs = {
  apiKey: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppDiscountTypeArgs = {
  functionId: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppInstallationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAppInstallationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<AppInstallationCategory>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  privacy?: InputMaybe<AppInstallationPrivacy>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<AppInstallationSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootArticleArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootArticleTagsArgs = {
  limit: Scalars['Int'];
  sort?: InputMaybe<ArticleTagSort>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ArticleSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAssignedFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignmentStatus?: InputMaybe<FulfillmentOrderAssignmentStatus>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<FulfillmentOrderSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountNodeArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<AutomaticDiscountSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootAutomaticDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<AutomaticDiscountSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBlogArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBlogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<BlogSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBlogsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootBusinessEntityArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCarrierServiceArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCarrierServicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CarrierServiceSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCartTransformsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashTrackingSessionArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCashTrackingSessionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CashTrackingSessionsSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCatalogArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CatalogSortKeys>;
  type?: InputMaybe<CatalogType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCatalogsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CatalogType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootChannelArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCheckoutBrandingArgs = {
  checkoutProfileId: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCheckoutProfileArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCheckoutProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CheckoutProfileSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCodeDiscountNodeArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCodeDiscountNodeByCodeArgs = {
  code: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCodeDiscountNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<CodeDiscountSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCodeDiscountSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionByHandleArgs = {
  handle: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<CollectionSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCollectionsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCommentArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CommentSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanySortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyContactArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyContactRoleArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyLocationArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCompanyLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CompanyLocationSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCurrentBulkOperationArgs = {
  type?: InputMaybe<BulkOperationType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerAccountPageArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerAccountPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerMergeJobStatusArgs = {
  jobId: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerMergePreviewArgs = {
  customerOneId: Scalars['ID'];
  customerTwoId: Scalars['ID'];
  overrideFields?: InputMaybe<CustomerMergeOverrideFields>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerPaymentMethodArgs = {
  id: Scalars['ID'];
  showRevoked?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerSegmentMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  queryId?: InputMaybe<Scalars['ID']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  segmentId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerSegmentMembersQueryArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomerSegmentMembershipArgs = {
  customerId: Scalars['ID'];
  segmentIds: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CustomerSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootCustomersCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeletionEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<DeletionEventSortKeys>;
  subjectTypes?: InputMaybe<ReadonlyArray<DeletionEventSubjectType>>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryCustomizationArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryCustomizationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryProfileArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  merchantOwnedOnly?: InputMaybe<Scalars['Boolean']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDeliveryPromiseProviderArgs = {
  locationId: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountCodesCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountNodeArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<DiscountSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountNodesCountArgs = {
  query?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountRedeemCodeBulkCreationArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDiscountRedeemCodeSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<DiscountCodeSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDisputeArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDisputeEvidenceArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDisputesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDomainArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrderArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrderSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrderTagArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootEventArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<EventSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootEventsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFileSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<FileSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFulfillmentArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFulfillmentOrderArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeClosed?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<FulfillmentOrderSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootFulfillmentServiceArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootGiftCardArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<GiftCardSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootGiftCardsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryItemArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootInventoryLevelArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootJobArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  includeLegacy?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<LocationSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationsAvailableForDeliveryProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootLocationsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootManualHoldsFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketByGeographyArgs = {
  countryCode: CountryCode;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketLocalizableResourceArgs = {
  resourceId: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketLocalizableResourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  resourceType: MarketLocalizableResourceType;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketLocalizableResourcesByIdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  resourceIds: ReadonlyArray<Scalars['ID']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketingActivitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  marketingActivityIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  remoteIds?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<MarketingActivitySortKeys>;
  utm?: InputMaybe<UtmInput>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketingActivityArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketingEventArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketingEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MarketingEventSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMarketsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMenuArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMenusArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MenuSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetafieldDefinitionArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  constraintStatus?: InputMaybe<MetafieldDefinitionConstraintStatus>;
  constraintSubtype?: InputMaybe<MetafieldDefinitionConstraintSubtypeIdentifier>;
  first?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  ownerType: MetafieldOwnerType;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetafieldStorefrontVisibilitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetafieldStorefrontVisibilityArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectByHandleArgs = {
  handle: MetaobjectHandleInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectDefinitionArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectDefinitionByTypeArgs = {
  type: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMetaobjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMobilePlatformApplicationArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootMobilePlatformApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootNodeArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootNodesArgs = {
  ids: ReadonlyArray<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderPaymentStatusArgs = {
  orderId: Scalars['ID'];
  paymentReferenceId: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrderSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootOrdersCountArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPageArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPaymentCustomizationArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPaymentCustomizationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPaymentTermsTemplatesArgs = {
  paymentTermsType?: InputMaybe<PaymentTermsType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPriceListArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPriceListsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<PriceListSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPrivateMetafieldArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  owner: Scalars['ID'];
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductByHandleArgs = {
  handle: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductDuplicateJobArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductFeedArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductFeedsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductOperationArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductResourceFeedbackArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductVariantArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<ProductVariantSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductVariantsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootProductsCountArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPublicationArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalogType?: InputMaybe<CatalogType>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPublicationsCountArgs = {
  catalogType?: InputMaybe<CatalogType>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootPublishedProductsCountArgs = {
  publicationId: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootRefundArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnCalculateArgs = {
  input: CalculateReturnInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnableFulfillmentArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReturnableFulfillmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderId: Scalars['ID'];
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReverseDeliveryArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootReverseFulfillmentOrderArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootScriptTagArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootScriptTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  src?: InputMaybe<Scalars['URL']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentFilterSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  search: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentFiltersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentMigrationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentValueSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterQueryName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  functionParameterQueryName?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSegmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<SegmentSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSellingPlanGroupArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<SellingPlanGroupSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopLocalesArgs = {
  published?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopifyFunctionArgs = {
  id: Scalars['String'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootShopifyFunctionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  apiType?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  useCreationUi?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootStaffMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootStaffMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<StaffMembersSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootStandardMetafieldDefinitionTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  constraintStatus?: InputMaybe<MetafieldDefinitionConstraintStatus>;
  constraintSubtype?: InputMaybe<MetafieldDefinitionConstraintSubtypeIdentifier>;
  excludeActivated?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootStoreCreditAccountArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingAttemptArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingAttemptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<SubscriptionBillingAttemptsSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingCycleArgs = {
  billingCycleInput: SubscriptionBillingCycleInput;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingCycleBulkResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobId: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionBillingCyclesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  billingCyclesDateRangeSelector?: InputMaybe<SubscriptionBillingCyclesDateRangeSelector>;
  billingCyclesIndexRangeSelector?: InputMaybe<SubscriptionBillingCyclesIndexRangeSelector>;
  contractId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<SubscriptionBillingCyclesSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionContractArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootSubscriptionDraftArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootTenderTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootThemeArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootThemesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  names?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  roles?: InputMaybe<ReadonlyArray<ThemeRole>>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootTranslatableResourceArgs = {
  resourceId: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootTranslatableResourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  resourceType: TranslatableResourceType;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootTranslatableResourcesByIdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  resourceIds: ReadonlyArray<Scalars['ID']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectImportArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<UrlRedirectSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootUrlRedirectsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootValidationArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootValidationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ValidationSortKeys>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebPixelArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebhookSubscriptionArgs = {
  id: Scalars['ID'];
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebhookSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['URL']>;
  first?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<WebhookSubscriptionFormat>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<WebhookSubscriptionSortKeys>;
  topics?: InputMaybe<ReadonlyArray<WebhookSubscriptionTopic>>;
};


/** The schema's entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryRootWebhookSubscriptionsCountArgs = {
  query?: InputMaybe<Scalars['String']>;
};

/** The record of the line items and transactions that were refunded to a customer, along with restocking instructions for refunded line items. */
export type Refund = LegacyInteroperability & Node & {
  /** The date and time when the refund was created. */
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  /** A list of the refunded duties as part of this refund. */
  readonly duties?: Maybe<ReadonlyArray<RefundDuty>>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The optional note associated with the refund. */
  readonly note?: Maybe<Scalars['String']>;
  /** The order associated with the refund. */
  readonly order: Order;
  /** The order adjustments that are attached with the refund. */
  readonly orderAdjustments: OrderAdjustmentConnection;
  /** The `RefundLineItem` resources attached to the refund. */
  readonly refundLineItems: RefundLineItemConnection;
  /** The `RefundShippingLine` resources attached to the refund. */
  readonly refundShippingLines: RefundShippingLineConnection;
  /** The return associated with the refund. */
  readonly return?: Maybe<Return>;
  /** The staff member who created the refund. */
  readonly staffMember?: Maybe<StaffMember>;
  /**
   * The total amount across all transactions for the refund.
   * @deprecated Use `totalRefundedSet` instead.
   */
  readonly totalRefunded: MoneyV2;
  /** The total amount across all transactions for the refund, in shop and presentment currencies. */
  readonly totalRefundedSet: MoneyBag;
  /** The transactions associated with the refund. */
  readonly transactions: OrderTransactionConnection;
  /** The date and time when the refund was updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** The record of the line items and transactions that were refunded to a customer, along with restocking instructions for refunded line items. */
export type RefundOrderAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The record of the line items and transactions that were refunded to a customer, along with restocking instructions for refunded line items. */
export type RefundRefundLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The record of the line items and transactions that were refunded to a customer, along with restocking instructions for refunded line items. */
export type RefundRefundShippingLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** The record of the line items and transactions that were refunded to a customer, along with restocking instructions for refunded line items. */
export type RefundTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An agreement between the merchant and customer to refund all or a portion of the order. */
export type RefundAgreement = SalesAgreement & {
  /** The application that created the agreement. */
  readonly app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  readonly happenedAt: Scalars['DateTime'];
  /** The unique ID for the agreement. */
  readonly id: Scalars['ID'];
  /** The reason the agremeent was created. */
  readonly reason: OrderActionType;
  /** The refund associated with the agreement. */
  readonly refund: Refund;
  /** The sales associated with the agreement. */
  readonly sales: SaleConnection;
  /** The staff member associated with the agreement. */
  readonly user?: Maybe<StaffMember>;
};


/** An agreement between the merchant and customer to refund all or a portion of the order. */
export type RefundAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple Refunds. */
export type RefundConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<RefundEdge>;
  /** A list of nodes that are contained in RefundEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Refund>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `refundCreate` mutation. */
export type RefundCreatePayload = {
  /** The order associated with the created refund. */
  readonly order?: Maybe<Order>;
  /** The created refund. */
  readonly refund?: Maybe<Refund>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Represents a refunded duty. */
export type RefundDuty = {
  /** The amount of a refunded duty in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** The duty associated with this refunded duty. */
  readonly originalDuty?: Maybe<Duty>;
};

/** The input fields required to reimburse duties on a refund. */
export type RefundDutyInput = {
  /** The ID of the duty in the refund. */
  readonly dutyId: Scalars['ID'];
  /** The type of refund for this duty. */
  readonly refundType?: InputMaybe<RefundDutyRefundType>;
};

/** The type of refund to perform for a particular refund duty. */
export enum RefundDutyRefundType {
  /** The duty is fully refunded. */
  FULL = 'FULL',
  /** The duty is proportionally refunded based on the quantity of the refunded line item. */
  PROPORTIONAL = 'PROPORTIONAL'
}

/** An auto-generated type which holds one Refund and a cursor during pagination. */
export type RefundEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of RefundEdge. */
  readonly node: Refund;
};

/** The input fields to create a refund. */
export type RefundInput = {
  /** The currency that is used to refund the order. This must be the presentment currency, which is the currency used by the customer. This is a required field for orders where the currency and presentment currency differ. */
  readonly currency?: InputMaybe<CurrencyCode>;
  /** An optional reason for a discrepancy between calculated and actual refund amounts. */
  readonly discrepancyReason?: InputMaybe<OrderAdjustmentInputDiscrepancyReason>;
  /** An optional note that's attached to the refund. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** Whether to send a refund notification to the customer. */
  readonly notify?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the order that's being refunded. */
  readonly orderId: Scalars['ID'];
  /** A list of duties to refund. */
  readonly refundDuties?: InputMaybe<ReadonlyArray<RefundDutyInput>>;
  /** A list of line items to refund. */
  readonly refundLineItems?: InputMaybe<ReadonlyArray<RefundLineItemInput>>;
  /** The input fields that are required to reimburse shipping costs. */
  readonly shipping?: InputMaybe<ShippingRefundInput>;
  /** A list of transactions involved in the refund. */
  readonly transactions?: InputMaybe<ReadonlyArray<OrderTransactionInput>>;
};

/** A line item that's included in a refund. */
export type RefundLineItem = {
  /** A globally-unique ID. */
  readonly id?: Maybe<Scalars['ID']>;
  /** The `LineItem` resource associated to the refunded line item. */
  readonly lineItem: LineItem;
  /** The inventory restock location. */
  readonly location?: Maybe<Location>;
  /**
   * The price of a refunded line item.
   * @deprecated Use `priceSet` instead.
   */
  readonly price: Scalars['Money'];
  /** The price of a refunded line item in shop and presentment currencies. */
  readonly priceSet: MoneyBag;
  /** The quantity of a refunded line item. */
  readonly quantity: Scalars['Int'];
  /** The type of restock for the refunded line item. */
  readonly restockType: RefundLineItemRestockType;
  /** Whether the refunded line item was restocked. Not applicable in the context of a SuggestedRefund. */
  readonly restocked: Scalars['Boolean'];
  /**
   * The subtotal price of a refunded line item.
   * @deprecated Use `subtotalSet` instead.
   */
  readonly subtotal: Scalars['Money'];
  /** The subtotal price of a refunded line item in shop and presentment currencies. */
  readonly subtotalSet: MoneyBag;
  /**
   * The total tax charged on a refunded line item.
   * @deprecated Use `totalTaxSet` instead.
   */
  readonly totalTax: Scalars['Money'];
  /** The total tax charged on a refunded line item in shop and presentment currencies. */
  readonly totalTaxSet: MoneyBag;
};

/** An auto-generated type for paginating through multiple RefundLineItems. */
export type RefundLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<RefundLineItemEdge>;
  /** A list of nodes that are contained in RefundLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<RefundLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one RefundLineItem and a cursor during pagination. */
export type RefundLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of RefundLineItemEdge. */
  readonly node: RefundLineItem;
};

/** The input fields required to reimburse line items on a refund. */
export type RefundLineItemInput = {
  /** The ID of the line item in the refund. */
  readonly lineItemId: Scalars['ID'];
  /** The intended location for restocking. If the `restockType` is set to `NO_RESTOCK`, then this value is empty. */
  readonly locationId?: InputMaybe<Scalars['ID']>;
  /** The quantity of the associated line item to be refunded. */
  readonly quantity: Scalars['Int'];
  /** The type of restock for this line item. */
  readonly restockType?: InputMaybe<RefundLineItemRestockType>;
};

/** The type of restock performed for a particular refund line item. */
export enum RefundLineItemRestockType {
  /** The refund line item was canceled. Use this when restocking unfulfilled line items. */
  CANCEL = 'CANCEL',
  /** Deprecated. The refund line item was restocked, without specifically beingidentified as a return or cancelation. This value is not accepted when creating new refunds. */
  LEGACY_RESTOCK = 'LEGACY_RESTOCK',
  /** Refund line item was not restocked. */
  NO_RESTOCK = 'NO_RESTOCK',
  /** The refund line item was returned. Use this when restocking line items that were fulfilled. */
  RETURN = 'RETURN'
}

/** The input fields for the shipping cost to refund. */
export type RefundShippingInput = {
  /** Whether to refund the full shipping amount. */
  readonly fullRefund?: InputMaybe<Scalars['Boolean']>;
  /**
   * The input fields required to refund shipping cost, in the presentment currency of the order.
   * This overrides the `fullRefund` argument.
   * This field defaults to 0.00 when not provided and when the `fullRefund` argument is false.
   */
  readonly shippingRefundAmount?: InputMaybe<MoneyInput>;
};

/** A shipping line item that's included in a refund. */
export type RefundShippingLine = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The `ShippingLine` resource associated to the refunded shipping line item. */
  readonly shippingLine: ShippingLine;
  /** The subtotal amount of the refund shipping line in shop and presentment currencies. */
  readonly subtotalAmountSet: MoneyBag;
  /** The tax amount of the refund shipping line in shop and presentment currencies. */
  readonly taxAmountSet: MoneyBag;
};

/** An auto-generated type for paginating through multiple RefundShippingLines. */
export type RefundShippingLineConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<RefundShippingLineEdge>;
  /** A list of nodes that are contained in RefundShippingLineEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<RefundShippingLine>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one RefundShippingLine and a cursor during pagination. */
export type RefundShippingLineEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of RefundShippingLineEdge. */
  readonly node: RefundShippingLine;
};

/** The input fields for a remote Authorize.net customer payment profile. */
export type RemoteAuthorizeNetCustomerPaymentProfileInput = {
  /**
   * The customerPaymentProfileId value from the Authorize.net API. Starting on 2025,
   * customer_payment_profile_id will become mandatory for all API versions.
   */
  readonly customerPaymentProfileId?: InputMaybe<Scalars['String']>;
  /** The customerProfileId value from the Authorize.net API. */
  readonly customerProfileId: Scalars['String'];
};

/** The input fields for a remote Braintree customer payment profile. */
export type RemoteBraintreePaymentMethodInput = {
  /** The `customer_id` value from the Braintree API. */
  readonly customerId: Scalars['String'];
  /**
   * The `payment_method_token` value from the Braintree API. Starting on 2025,
   * payment_method_token will become mandatory for all API versions.
   */
  readonly paymentMethodToken?: InputMaybe<Scalars['String']>;
};

/** The input fields for a remote stripe payment method. */
export type RemoteStripePaymentMethodInput = {
  /** The customer_id value from the Stripe API. */
  readonly customerId: Scalars['String'];
  /**
   * The payment_method_id value from the Stripe API. Starting on 2025,
   * payment_method_id will become mandatory for all API versions.
   */
  readonly paymentMethodId?: InputMaybe<Scalars['String']>;
};

/**
 * An alert message that appears in the Shopify admin about a problem with a store resource, with 1 or more actions to take. For example, you could use an alert to indicate that you're not charging taxes on some product variants.
 * They can optionally have a specific icon and be dismissed by merchants.
 */
export type ResourceAlert = {
  /**
   * Buttons in the alert that link to related information.
   * For example, _Edit variants_.
   */
  readonly actions: ReadonlyArray<ResourceAlertAction>;
  /** The secondary text in the alert that includes further information or instructions about how to solve a problem. */
  readonly content: Scalars['HTML'];
  /**
   * Unique identifier that appears when an alert is manually closed by the merchant.
   * Most alerts can't be manually closed.
   */
  readonly dismissibleHandle?: Maybe<Scalars['String']>;
  /** An icon that's optionally displayed with the alert. */
  readonly icon?: Maybe<ResourceAlertIcon>;
  /** Indication of how important the alert is. */
  readonly severity: ResourceAlertSeverity;
  /** The primary text in the alert that includes information or describes the problem. */
  readonly title: Scalars['String'];
};

/** An action associated to a resource alert, such as editing variants. */
export type ResourceAlertAction = {
  /** Whether the action appears as a button or as a link. */
  readonly primary: Scalars['Boolean'];
  /** Resource for the action to show. */
  readonly show?: Maybe<Scalars['String']>;
  /** The text for the button in the alert. For example, _Edit variants_. */
  readonly title: Scalars['String'];
  /** The target URL that the button links to. */
  readonly url: Scalars['URL'];
};

/** The available icons for resource alerts. */
export enum ResourceAlertIcon {
  /** A checkmark inside a circle. */
  CHECKMARK_CIRCLE = 'CHECKMARK_CIRCLE',
  /** A lowercase `i` inside a circle. */
  INFORMATION_CIRCLE = 'INFORMATION_CIRCLE'
}

/** The possible severity levels for a resource alert. */
export enum ResourceAlertSeverity {
  /** Indicates a critical alert. For example, a blocked app. */
  CRITICAL = 'CRITICAL',
  /** Indicates a neutral alert. For example, an accepted dispute. */
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR',
  /** Indicates an informative alert. For example, an escalated dispute. */
  INFO = 'INFO',
  /** Indicates a success alert. For example, a winning a dispute. */
  SUCCESS = 'SUCCESS',
  /** Indicates an informative alert. For example, a new dispute. */
  WARNING = 'WARNING'
}

/** Represents feedback from apps about a resource, and the steps required to set up the apps on the shop. */
export type ResourceFeedback = {
  /**
   * Feedback from an app about the steps a merchant needs to take to set up the app on their store.
   * @deprecated Use `details` instead.
   */
  readonly appFeedback: ReadonlyArray<AppFeedback>;
  /** List of AppFeedback detailing issues regarding a resource. */
  readonly details: ReadonlyArray<AppFeedback>;
  /** Summary of resource feedback pertaining to the resource. */
  readonly summary: Scalars['String'];
};

/** The input fields for a resource feedback object. */
export type ResourceFeedbackCreateInput = {
  /**
   * The date and time when the feedback was generated. Used to help determine whether
   * incoming feedback is outdated compared to existing feedback.
   */
  readonly feedbackGeneratedAt: Scalars['DateTime'];
  /**
   * If the feedback state is `requires_action`, then you can send a string message that communicates the action to be taken by the merchant.
   * The string must be a single message up to 100 characters long and must end with a period.
   * You need to adhere to the message formatting rules or your requests will fail:
   * - `[Explanation of the problem]. [Suggested action].`
   *
   * **Examples:**
   * - `[Your app name]` isn't connected. Connect your account to use this sales channel. `[Learn more]`
   * - `[Your app name]` isn't configured. Agree to the terms and conditions to use this app. `[Learn more]`
   * Both `Your app name` and `Learn more` (a button which directs merchants to your app) are automatically populated in the Shopify admin.
   */
  readonly messages?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The state of the feedback and whether it requires merchant action. */
  readonly state: ResourceFeedbackState;
};

/** The state of the resource feedback. */
export enum ResourceFeedbackState {
  /** No action required from merchant. */
  ACCEPTED = 'ACCEPTED',
  /** The merchant needs to resolve an issue with the resource. */
  REQUIRES_ACTION = 'REQUIRES_ACTION'
}

/** Represents a merchandising background operation interface. */
export type ResourceOperation = {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The count of processed rows, summing imported, failed, and skipped rows. */
  readonly processedRowCount?: Maybe<Scalars['Int']>;
  /** Represents a rows objects within this background operation. */
  readonly rowCount?: Maybe<RowCount>;
  /** The status of this operation. */
  readonly status: ResourceOperationStatus;
};

/** Represents the state of this catalog operation. */
export enum ResourceOperationStatus {
  /** Operation is currently running. */
  ACTIVE = 'ACTIVE',
  /** Operation is complete. */
  COMPLETE = 'COMPLETE',
  /** Operation has been created. */
  CREATED = 'CREATED'
}

/**
 * A resource publication represents information about the publication of a resource.
 * An instance of `ResourcePublication`, unlike `ResourcePublicationV2`, can be neither published or scheduled to be published.
 *
 * See [ResourcePublicationV2](/api/admin-graphql/latest/objects/ResourcePublicationV2) for more context.
 */
export type ResourcePublication = {
  /**
   * The channel the resource publication is published to.
   * @deprecated Use `publication` instead.
   */
  readonly channel: Channel;
  /**
   * Whether the resource publication is published. Also returns true if the resource publication is scheduled to be published.
   * If false, then the resource publication is neither published nor scheduled to be published.
   */
  readonly isPublished: Scalars['Boolean'];
  /** The publication the resource publication is published to. */
  readonly publication: Publication;
  /**
   * The date that the resource publication was or is going to be published to the publication.
   * If the product isn't published, then this field returns an epoch timestamp.
   */
  readonly publishDate: Scalars['DateTime'];
  /** The resource published to the publication. */
  readonly publishable: Publishable;
};

/** An auto-generated type for paginating through multiple ResourcePublications. */
export type ResourcePublicationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ResourcePublicationEdge>;
  /** A list of nodes that are contained in ResourcePublicationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ResourcePublication>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ResourcePublication and a cursor during pagination. */
export type ResourcePublicationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ResourcePublicationEdge. */
  readonly node: ResourcePublication;
};

/**
 * A resource publication represents information about the publication of a resource.
 * Unlike `ResourcePublication`, an instance of `ResourcePublicationV2` can't be unpublished. It must either be published or scheduled to be published.
 *
 * See [ResourcePublication](/api/admin-graphql/latest/objects/ResourcePublication) for more context.
 */
export type ResourcePublicationV2 = {
  /**
   * Whether the resource publication is published. If true, then the resource publication is published to the publication.
   * If false, then the resource publication is staged to be published to the publication.
   */
  readonly isPublished: Scalars['Boolean'];
  /** The publication the resource publication is published to. */
  readonly publication: Publication;
  /** The date that the resource publication was or is going to be published to the publication. */
  readonly publishDate?: Maybe<Scalars['DateTime']>;
  /** The resource published to the publication. */
  readonly publishable: Publishable;
};

/** An auto-generated type for paginating through multiple ResourcePublicationV2s. */
export type ResourcePublicationV2Connection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ResourcePublicationV2Edge>;
  /** A list of nodes that are contained in ResourcePublicationV2Edge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ResourcePublicationV2>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ResourcePublicationV2 and a cursor during pagination. */
export type ResourcePublicationV2Edge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ResourcePublicationV2Edge. */
  readonly node: ResourcePublicationV2;
};

/**
 * A restocking fee is a fee captured as part of a return to cover the costs of handling a return line item.
 * Typically, this would cover the costs of inspecting, repackaging, and restocking the item.
 */
export type RestockingFee = Fee & {
  /** The amount of the restocking fee, in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** The unique ID for the Fee. */
  readonly id: Scalars['ID'];
  /** The value of the fee as a percentage. */
  readonly percentage: Scalars['Float'];
};

/** The input fields for a restocking fee. */
export type RestockingFeeInput = {
  /** The value of the fee as a percentage. */
  readonly percentage: Scalars['Float'];
};

/** Information about product is restricted for a given resource. */
export type RestrictedForResource = {
  /** Returns true when the product is restricted for the given resource. */
  readonly restricted: Scalars['Boolean'];
  /** Restriction reason for the given resource. */
  readonly restrictedReason: Scalars['String'];
};

/** Represents a return. */
export type Return = Node & {
  /** Additional information about the declined return. */
  readonly decline?: Maybe<ReturnDecline>;
  /** The exchange line items attached to the return. */
  readonly exchangeLineItems: ExchangeLineItemConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the return. */
  readonly name: Scalars['String'];
  /** The order that the return belongs to. */
  readonly order: Order;
  /** The list of refunds associated with the return. */
  readonly refunds: RefundConnection;
  /** The return line items attached to the return. */
  readonly returnLineItems: ReturnLineItemTypeConnection;
  /** The return shipping fees for the return. */
  readonly returnShippingFees: ReadonlyArray<ReturnShippingFee>;
  /** The list of reverse fulfillment orders for the return. */
  readonly reverseFulfillmentOrders: ReverseFulfillmentOrderConnection;
  /** The status of the return. */
  readonly status: ReturnStatus;
  /** A suggested refund for the return. */
  readonly suggestedRefund?: Maybe<SuggestedReturnRefund>;
  /** The sum of all return line item quantities for the return. */
  readonly totalQuantity: Scalars['Int'];
};


/** Represents a return. */
export type ReturnExchangeLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeRemovedItems?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a return. */
export type ReturnRefundsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a return. */
export type ReturnReturnLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a return. */
export type ReturnReverseFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a return. */
export type ReturnSuggestedRefundArgs = {
  refundDuties?: InputMaybe<ReadonlyArray<RefundDutyInput>>;
  refundShipping?: InputMaybe<RefundShippingInput>;
  returnRefundLineItems: ReadonlyArray<ReturnRefundLineItemInput>;
};

/** An agreement between the merchant and customer for a return. */
export type ReturnAgreement = SalesAgreement & {
  /** The application that created the agreement. */
  readonly app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  readonly happenedAt: Scalars['DateTime'];
  /** The unique ID for the agreement. */
  readonly id: Scalars['ID'];
  /** The reason the agremeent was created. */
  readonly reason: OrderActionType;
  /** The return associated with the agreement. */
  readonly return: Return;
  /** The sales associated with the agreement. */
  readonly sales: SaleConnection;
  /** The staff member associated with the agreement. */
  readonly user?: Maybe<StaffMember>;
};


/** An agreement between the merchant and customer for a return. */
export type ReturnAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields for approving a customer's return request. */
export type ReturnApproveRequestInput = {
  /** The ID of the return that's being approved. */
  readonly id: Scalars['ID'];
  /**
   * Notify the customer when a return request is approved.
   * The customer will only receive a notification if `Order.email` is present.
   */
  readonly notifyCustomer?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `returnApproveRequest` mutation. */
export type ReturnApproveRequestPayload = {
  /** The approved return. */
  readonly return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** Return type for `returnCancel` mutation. */
export type ReturnCancelPayload = {
  /** The canceled return. */
  readonly return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** Return type for `returnClose` mutation. */
export type ReturnClosePayload = {
  /** The closed return. */
  readonly return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** An auto-generated type for paginating through multiple Returns. */
export type ReturnConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ReturnEdge>;
  /** A list of nodes that are contained in ReturnEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Return>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `returnCreate` mutation. */
export type ReturnCreatePayload = {
  /** The created return. */
  readonly return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** Additional information about why a merchant declined the customer's return request. */
export type ReturnDecline = {
  /**
   * The notification message sent to the customer about their declined return request.
   * Maximum length: 500 characters.
   */
  readonly note?: Maybe<Scalars['String']>;
  /** The reason the customer's return request was declined. */
  readonly reason: ReturnDeclineReason;
};

/** The reason why the merchant declined a customer's return request. */
export enum ReturnDeclineReason {
  /** The return contains final sale items. */
  FINAL_SALE = 'FINAL_SALE',
  /** The return is declined for another reason. */
  OTHER = 'OTHER',
  /** The return period has ended. */
  RETURN_PERIOD_ENDED = 'RETURN_PERIOD_ENDED'
}

/** The input fields for declining a customer's return request. */
export type ReturnDeclineRequestInput = {
  /**
   * The notification message that's sent to a customer about their declined return request.
   * Maximum length: 500 characters.
   */
  readonly declineNote?: InputMaybe<Scalars['String']>;
  /** The reason why the merchant declined the customer's return request. */
  readonly declineReason: ReturnDeclineReason;
  /** The ID of the return that's being declined. */
  readonly id: Scalars['ID'];
  /**
   * Notify the customer when a return request is declined.
   * The customer will only receive a notification if `Order.email` is present.
   */
  readonly notifyCustomer?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `returnDeclineRequest` mutation. */
export type ReturnDeclineRequestPayload = {
  /** The declined return. */
  readonly return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** An auto-generated type which holds one Return and a cursor during pagination. */
export type ReturnEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ReturnEdge. */
  readonly node: Return;
};

/** Possible error codes that can be returned by `ReturnUserError`. */
export enum ReturnErrorCode {
  /** The requested resource already exists. */
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** A requested resource could not be created. */
  CREATION_FAILED = 'CREATION_FAILED',
  /** The input value should be equal to the value allowed. */
  EQUAL_TO = 'EQUAL_TO',
  /** A required feature is not enabled. */
  FEATURE_NOT_ENABLED = 'FEATURE_NOT_ENABLED',
  /** The input value should be greater than the minimum allowed value. */
  GREATER_THAN = 'GREATER_THAN',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** Unexpected internal error happened. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** A resource was not in the correct state for the operation to succeed. */
  INVALID_STATE = 'INVALID_STATE',
  /** The input value should be less than the maximum value allowed. */
  LESS_THAN = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  /** A requested notification could not be sent. */
  NOTIFICATION_FAILED = 'NOTIFICATION_FAILED',
  /** The input value is not a number. */
  NOT_A_NUMBER = 'NOT_A_NUMBER',
  /** A requested item is not editable. */
  NOT_EDITABLE = 'NOT_EDITABLE',
  /** A requested item could not be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too big. */
  TOO_BIG = 'TOO_BIG',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** Too many arguments provided. */
  TOO_MANY_ARGUMENTS = 'TOO_MANY_ARGUMENTS',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** The input value is the wrong length. */
  WRONG_LENGTH = 'WRONG_LENGTH'
}

/** The input fields for a return. */
export type ReturnInput = {
  /** The new line items to be added to the order. */
  readonly exchangeLineItems?: InputMaybe<ReadonlyArray<ExchangeLineItemInput>>;
  /** The ID of the order to be returned. */
  readonly orderId: Scalars['ID'];
  /** The UTC date and time when the return was first solicited by the customer. */
  readonly requestedAt?: InputMaybe<Scalars['DateTime']>;
  /** The return line items list to be handled. */
  readonly returnLineItems: ReadonlyArray<ReturnLineItemInput>;
  /** The return shipping fee to capture. */
  readonly returnShippingFee?: InputMaybe<ReturnShippingFeeInput>;
};

/** A return line item. */
export type ReturnLineItem = Node & ReturnLineItemType & {
  /** A note from the customer that describes the item to be returned. Maximum length: 300 characters. */
  readonly customerNote?: Maybe<Scalars['String']>;
  /** The fulfillment line item from which items are returned. */
  readonly fulfillmentLineItem: FulfillmentLineItem;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The quantity being returned. */
  readonly quantity: Scalars['Int'];
  /** The quantity that can be refunded. */
  readonly refundableQuantity: Scalars['Int'];
  /** The quantity that was refunded. */
  readonly refundedQuantity: Scalars['Int'];
  /** The restocking fee for the return line item. */
  readonly restockingFee?: Maybe<RestockingFee>;
  /** The reason for returning the item. */
  readonly returnReason: ReturnReason;
  /** Additional information about the reason for the return. Maximum length: 255 characters. */
  readonly returnReasonNote: Scalars['String'];
  /** The total weight of the item. */
  readonly totalWeight?: Maybe<Weight>;
  /** The total line price after all discounts on the line item, including both line item level discounts and code-based line item discounts, are applied. */
  readonly withCodeDiscountedTotalPriceSet: MoneyBag;
};

/** The input fields for a return line item. */
export type ReturnLineItemInput = {
  /**
   * The ID of the fulfillment line item to be returned.
   * Specifically, this field expects a `FulfillmentLineItem.id`.
   */
  readonly fulfillmentLineItemId: Scalars['ID'];
  /** The quantity of the item to be returned. */
  readonly quantity: Scalars['Int'];
  /** The restocking fee to capture. */
  readonly restockingFee?: InputMaybe<RestockingFeeInput>;
  /** The reason for the item to be returned. */
  readonly returnReason: ReturnReason;
  /**
   * A note about the reason that the item is being returned.
   * Maximum length: 255 characters.
   */
  readonly returnReasonNote?: InputMaybe<Scalars['String']>;
};

/** The input fields for a removing a return line item from a return. */
export type ReturnLineItemRemoveFromReturnInput = {
  /** The quantity of the associated return line item to be removed. */
  readonly quantity: Scalars['Int'];
  /** The ID of the return line item to remove. */
  readonly returnLineItemId: Scalars['ID'];
};

/** Return type for `returnLineItemRemoveFromReturn` mutation. */
export type ReturnLineItemRemoveFromReturnPayload = {
  /** The modified return. */
  readonly return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** A return line item of any type. */
export type ReturnLineItemType = {
  /** A note from the customer that describes the item to be returned. Maximum length: 300 characters. */
  readonly customerNote?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The quantity being returned. */
  readonly quantity: Scalars['Int'];
  /** The quantity that can be refunded. */
  readonly refundableQuantity: Scalars['Int'];
  /** The quantity that was refunded. */
  readonly refundedQuantity: Scalars['Int'];
  /** The reason for returning the item. */
  readonly returnReason: ReturnReason;
  /** Additional information about the reason for the return. Maximum length: 255 characters. */
  readonly returnReasonNote: Scalars['String'];
};

/** An auto-generated type for paginating through multiple ReturnLineItemTypes. */
export type ReturnLineItemTypeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ReturnLineItemTypeEdge>;
  /** A list of nodes that are contained in ReturnLineItemTypeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ReturnLineItemType>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReturnLineItemType and a cursor during pagination. */
export type ReturnLineItemTypeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ReturnLineItemTypeEdge. */
  readonly node: ReturnLineItemType;
};

/** The reason for returning the return line item. */
export enum ReturnReason {
  /** The item is returned because the buyer did not like the color. Displays as **Color**. */
  COLOR = 'COLOR',
  /** The item is returned because it is damaged or defective. Displays as **Damaged or defective**. */
  DEFECTIVE = 'DEFECTIVE',
  /** The item is returned because it was not as described. Displays as **Item not as described**. */
  NOT_AS_DESCRIBED = 'NOT_AS_DESCRIBED',
  /** The item is returned for another reason. For this value, a return reason note is also provided. Displays as **Other**. */
  OTHER = 'OTHER',
  /** The item is returned because the size was too large. Displays as **Size was too large**. */
  SIZE_TOO_LARGE = 'SIZE_TOO_LARGE',
  /** The item is returned because the size was too small. Displays as **Size was too small**. */
  SIZE_TOO_SMALL = 'SIZE_TOO_SMALL',
  /** The item is returned because the buyer did not like the style. Displays as **Style**. */
  STYLE = 'STYLE',
  /** The item is returned because of an unknown reason. Displays as **Unknown**. */
  UNKNOWN = 'UNKNOWN',
  /** The item is returned because the customer changed their mind. Displays as **Customer changed their mind**. */
  UNWANTED = 'UNWANTED',
  /** The item is returned because the customer received the wrong one. Displays as **Received the wrong item**. */
  WRONG_ITEM = 'WRONG_ITEM'
}

/** The input fields to refund a return. */
export type ReturnRefundInput = {
  /** Whether to send a refund notification to the customer. */
  readonly notifyCustomer?: InputMaybe<Scalars['Boolean']>;
  /** A list of transactions involved in refunding the return. */
  readonly orderTransactions?: InputMaybe<ReadonlyArray<ReturnRefundOrderTransactionInput>>;
  /** A list of duties to refund. */
  readonly refundDuties?: InputMaybe<ReadonlyArray<RefundDutyInput>>;
  /** The shipping amount to refund. */
  readonly refundShipping?: InputMaybe<RefundShippingInput>;
  /** The ID of the return. */
  readonly returnId: Scalars['ID'];
  /** A list of return line items to refund. */
  readonly returnRefundLineItems: ReadonlyArray<ReturnRefundLineItemInput>;
};

/** The input fields for a return refund line item. */
export type ReturnRefundLineItemInput = {
  /** The quantity of the return line item to be refunded. */
  readonly quantity: Scalars['Int'];
  /** The ID of the return line item to be refunded. */
  readonly returnLineItemId: Scalars['ID'];
};

/** The input fields to create order transactions when refunding a return. */
export type ReturnRefundOrderTransactionInput = {
  /** The ID of the parent order transaction. The transaction must be of kind `CAPTURE` or a `SALE`. */
  readonly parentId: Scalars['ID'];
  /** The amount of money for the transaction in the presentment currency of the order. */
  readonly transactionAmount: MoneyInput;
};

/** Return type for `returnRefund` mutation. */
export type ReturnRefundPayload = {
  /** The created refund. */
  readonly refund?: Maybe<Refund>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** Return type for `returnReopen` mutation. */
export type ReturnReopenPayload = {
  /** The reopened return. */
  readonly return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** The input fields for requesting a return. */
export type ReturnRequestInput = {
  /** The ID of the order that's being returned. */
  readonly orderId: Scalars['ID'];
  /** The line items that are being handled in the return. */
  readonly returnLineItems: ReadonlyArray<ReturnRequestLineItemInput>;
  /** The return shipping fee to capture. */
  readonly returnShippingFee?: InputMaybe<ReturnShippingFeeInput>;
};

/** The input fields for a return line item. */
export type ReturnRequestLineItemInput = {
  /**
   * A note from the customer that describes the item to be returned.
   * For example, the note can communicate issues with the item to the merchant.
   * Maximum length: 300 characters.
   */
  readonly customerNote?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the fulfillment line item to be returned.
   * Specifically, this field expects a `FulfillmentLineItem.id`.
   */
  readonly fulfillmentLineItemId: Scalars['ID'];
  /** The quantity of the item that's being returned. */
  readonly quantity: Scalars['Int'];
  /** The restocking fee to capture. */
  readonly restockingFee?: InputMaybe<RestockingFeeInput>;
  /** The reason why the line item is being returned. */
  readonly returnReason: ReturnReason;
};

/** Return type for `returnRequest` mutation. */
export type ReturnRequestPayload = {
  /** The requested return. */
  readonly return?: Maybe<Return>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** A return shipping fee is a fee captured as part of a return to cover the costs of shipping the return. */
export type ReturnShippingFee = Fee & {
  /** The amount of the return shipping fee, in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** The unique ID for the Fee. */
  readonly id: Scalars['ID'];
};

/** The input fields for a return shipping fee. */
export type ReturnShippingFeeInput = {
  /** The value of the fee as a fixed amount in the presentment currency of the order. */
  readonly amount: MoneyInput;
};

/** The status of a return. */
export enum ReturnStatus {
  /** The return has been canceled. */
  CANCELED = 'CANCELED',
  /** The return has been completed. */
  CLOSED = 'CLOSED',
  /** The return was declined. */
  DECLINED = 'DECLINED',
  /** The return is in progress. */
  OPEN = 'OPEN',
  /** The return was requested. */
  REQUESTED = 'REQUESTED'
}

/** An error that occurs during the execution of a return mutation. */
export type ReturnUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ReturnErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/**
 * A returnable fulfillment, which is an order that has been delivered
 * and is eligible to be returned to the merchant.
 */
export type ReturnableFulfillment = Node & {
  /** The fulfillment that the returnable fulfillment refers to. */
  readonly fulfillment: Fulfillment;
  /** The unique ID of the Returnable Fulfillment. */
  readonly id: Scalars['ID'];
  /** The list of returnable fulfillment line items. */
  readonly returnableFulfillmentLineItems: ReturnableFulfillmentLineItemConnection;
};


/**
 * A returnable fulfillment, which is an order that has been delivered
 * and is eligible to be returned to the merchant.
 */
export type ReturnableFulfillmentReturnableFulfillmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple ReturnableFulfillments. */
export type ReturnableFulfillmentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ReturnableFulfillmentEdge>;
  /** A list of nodes that are contained in ReturnableFulfillmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ReturnableFulfillment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReturnableFulfillment and a cursor during pagination. */
export type ReturnableFulfillmentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ReturnableFulfillmentEdge. */
  readonly node: ReturnableFulfillment;
};

/** A returnable fulfillment line item. */
export type ReturnableFulfillmentLineItem = {
  /** The fulfillment line item that can be returned. */
  readonly fulfillmentLineItem: FulfillmentLineItem;
  /** The quantity available to be returned. */
  readonly quantity: Scalars['Int'];
};

/** An auto-generated type for paginating through multiple ReturnableFulfillmentLineItems. */
export type ReturnableFulfillmentLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ReturnableFulfillmentLineItemEdge>;
  /** A list of nodes that are contained in ReturnableFulfillmentLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ReturnableFulfillmentLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReturnableFulfillmentLineItem and a cursor during pagination. */
export type ReturnableFulfillmentLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ReturnableFulfillmentLineItemEdge. */
  readonly node: ReturnableFulfillmentLineItem;
};

/**
 * A reverse delivery is a post-fulfillment object that represents a buyer sending a package to a merchant.
 * For example, a buyer requests a return, and a merchant sends the buyer a shipping label.
 * The reverse delivery contains the context of the items sent back, how they're being sent back
 * (for example, a shipping label), and the current state of the delivery (tracking information).
 */
export type ReverseDelivery = Node & {
  /** The deliverable associated with the reverse delivery. */
  readonly deliverable?: Maybe<ReverseDeliveryDeliverable>;
  /** The ID of the reverse delivery. */
  readonly id: Scalars['ID'];
  /** The reverse delivery line items attached to the reverse delivery. */
  readonly reverseDeliveryLineItems: ReverseDeliveryLineItemConnection;
  /** The `ReverseFulfillmentOrder` associated with the reverse delivery. */
  readonly reverseFulfillmentOrder: ReverseFulfillmentOrder;
};


/**
 * A reverse delivery is a post-fulfillment object that represents a buyer sending a package to a merchant.
 * For example, a buyer requests a return, and a merchant sends the buyer a shipping label.
 * The reverse delivery contains the context of the items sent back, how they're being sent back
 * (for example, a shipping label), and the current state of the delivery (tracking information).
 */
export type ReverseDeliveryReverseDeliveryLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple ReverseDeliveries. */
export type ReverseDeliveryConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ReverseDeliveryEdge>;
  /** A list of nodes that are contained in ReverseDeliveryEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ReverseDelivery>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `reverseDeliveryCreateWithShipping` mutation. */
export type ReverseDeliveryCreateWithShippingPayload = {
  /** The created reverse delivery. */
  readonly reverseDelivery?: Maybe<ReverseDelivery>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** The delivery method and artifacts associated with a reverse delivery. */
export type ReverseDeliveryDeliverable = ReverseDeliveryShippingDeliverable;

/** An auto-generated type which holds one ReverseDelivery and a cursor during pagination. */
export type ReverseDeliveryEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ReverseDeliveryEdge. */
  readonly node: ReverseDelivery;
};

/** The input fields for a reverse label. */
export type ReverseDeliveryLabelInput = {
  /** The URL of the label file. If a label file was uploaded to be attached to the delivery, then provide the temporary staged URL. */
  readonly fileUrl: Scalars['URL'];
};

/** The return label file information for a reverse delivery. */
export type ReverseDeliveryLabelV2 = {
  /** The date and time when the reverse delivery label was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A public link that can be used to download the label image. */
  readonly publicFileUrl?: Maybe<Scalars['URL']>;
  /** The date and time when the reverse delivery label was updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** The details about a reverse delivery line item. */
export type ReverseDeliveryLineItem = Node & {
  /** The dispositions of the item. */
  readonly dispositions: ReadonlyArray<ReverseFulfillmentOrderDisposition>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The expected number of units. */
  readonly quantity: Scalars['Int'];
  /** The corresponding reverse fulfillment order line item. */
  readonly reverseFulfillmentOrderLineItem: ReverseFulfillmentOrderLineItem;
};

/** An auto-generated type for paginating through multiple ReverseDeliveryLineItems. */
export type ReverseDeliveryLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ReverseDeliveryLineItemEdge>;
  /** A list of nodes that are contained in ReverseDeliveryLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ReverseDeliveryLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReverseDeliveryLineItem and a cursor during pagination. */
export type ReverseDeliveryLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ReverseDeliveryLineItemEdge. */
  readonly node: ReverseDeliveryLineItem;
};

/** The input fields for a reverse delivery line item. */
export type ReverseDeliveryLineItemInput = {
  /** The quantity of the item to be included in the delivery. */
  readonly quantity: Scalars['Int'];
  /** The ID of the related reverse fulfillment order line item. */
  readonly reverseFulfillmentOrderLineItemId: Scalars['ID'];
};

/** A reverse shipping deliverable that may include a label and tracking information. */
export type ReverseDeliveryShippingDeliverable = {
  /** The return label attached to the reverse delivery. */
  readonly label?: Maybe<ReverseDeliveryLabelV2>;
  /** The information to track the reverse delivery. */
  readonly tracking?: Maybe<ReverseDeliveryTrackingV2>;
};

/** Return type for `reverseDeliveryShippingUpdate` mutation. */
export type ReverseDeliveryShippingUpdatePayload = {
  /** The updated reverse delivery. */
  readonly reverseDelivery?: Maybe<ReverseDelivery>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** The input fields for tracking information about a return delivery. */
export type ReverseDeliveryTrackingInput = {
  /** The tracking number for the label. */
  readonly number?: InputMaybe<Scalars['String']>;
  /** The tracking URL for the carrier. If the carrier isn't supported by Shopify, then provide the tracking URL of the delivery. */
  readonly url?: InputMaybe<Scalars['URL']>;
};

/** Represents the information used to track a reverse delivery. */
export type ReverseDeliveryTrackingV2 = {
  /** The provider of the tracking information, in a human-readable format for display purposes. */
  readonly carrierName?: Maybe<Scalars['String']>;
  /** The identifier used by the courier to identify the shipment. */
  readonly number?: Maybe<Scalars['String']>;
  /** The URL to track a shipment. */
  readonly url?: Maybe<Scalars['URL']>;
};

/**
 * A group of one or more items in a return that will be processed at a fulfillment service.
 * There can be more than one reverse fulfillment order for a return at a given location.
 */
export type ReverseFulfillmentOrder = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The list of reverse fulfillment order line items for the reverse fulfillment order. */
  readonly lineItems: ReverseFulfillmentOrderLineItemConnection;
  /**
   * The order associated with the reverse fulfillment order.
   * @deprecated Order will be nullable as of API version 2025-01. Older versions will return an error when order is null.
   */
  readonly order: Order;
  /** The list of reverse deliveries for the reverse fulfillment order. */
  readonly reverseDeliveries: ReverseDeliveryConnection;
  /** The status of the reverse fulfillment order. */
  readonly status: ReverseFulfillmentOrderStatus;
  /**
   * The current confirmation for the reverse fulfillment order from a third-party logistics service.
   * If no third-party service is involved, then this value is `nil`.
   */
  readonly thirdPartyConfirmation?: Maybe<ReverseFulfillmentOrderThirdPartyConfirmation>;
};


/**
 * A group of one or more items in a return that will be processed at a fulfillment service.
 * There can be more than one reverse fulfillment order for a return at a given location.
 */
export type ReverseFulfillmentOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * A group of one or more items in a return that will be processed at a fulfillment service.
 * There can be more than one reverse fulfillment order for a return at a given location.
 */
export type ReverseFulfillmentOrderReverseDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple ReverseFulfillmentOrders. */
export type ReverseFulfillmentOrderConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ReverseFulfillmentOrderEdge>;
  /** A list of nodes that are contained in ReverseFulfillmentOrderEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ReverseFulfillmentOrder>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields to dispose a reverse fulfillment order line item. */
export type ReverseFulfillmentOrderDisposeInput = {
  /** The final arrangement for the reverse fulfillment order line item. */
  readonly dispositionType: ReverseFulfillmentOrderDispositionType;
  /**
   * The ID of the location where the reverse fulfillment order line item is to be disposed.
   *         This is required when the disposition type is RESTOCKED.
   */
  readonly locationId?: InputMaybe<Scalars['ID']>;
  /** The quantity of the reverse fulfillment order line item to dispose. */
  readonly quantity: Scalars['Int'];
  /** The ID of the reverse fulfillment order line item. */
  readonly reverseFulfillmentOrderLineItemId: Scalars['ID'];
};

/** Return type for `reverseFulfillmentOrderDispose` mutation. */
export type ReverseFulfillmentOrderDisposePayload = {
  /** The disposed reverse fulfillment order line items. */
  readonly reverseFulfillmentOrderLineItems?: Maybe<ReadonlyArray<ReverseFulfillmentOrderLineItem>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ReturnUserError>;
};

/** The details of the arrangement of an item. */
export type ReverseFulfillmentOrderDisposition = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The location where the disposition occurred. */
  readonly location?: Maybe<Location>;
  /** The number of disposed units. */
  readonly quantity: Scalars['Int'];
  /** The final arrangement of an item. */
  readonly type: ReverseFulfillmentOrderDispositionType;
};

/** The final arrangement of an item from a reverse fulfillment order. */
export enum ReverseFulfillmentOrderDispositionType {
  /** An item that was expected but absent. */
  MISSING = 'MISSING',
  /** An item that wasn't restocked. */
  NOT_RESTOCKED = 'NOT_RESTOCKED',
  /** An item that requires further processing before being restocked or discarded. */
  PROCESSING_REQUIRED = 'PROCESSING_REQUIRED',
  /** An item that was restocked. */
  RESTOCKED = 'RESTOCKED'
}

/** An auto-generated type which holds one ReverseFulfillmentOrder and a cursor during pagination. */
export type ReverseFulfillmentOrderEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ReverseFulfillmentOrderEdge. */
  readonly node: ReverseFulfillmentOrder;
};

/** The details about a reverse fulfillment order line item. */
export type ReverseFulfillmentOrderLineItem = Node & {
  /** The dispositions of the item. */
  readonly dispositions: ReadonlyArray<ReverseFulfillmentOrderDisposition>;
  /** The corresponding fulfillment line item for a reverse fulfillment order line item. */
  readonly fulfillmentLineItem?: Maybe<FulfillmentLineItem>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The total number of units to be processed. */
  readonly totalQuantity: Scalars['Int'];
};

/** An auto-generated type for paginating through multiple ReverseFulfillmentOrderLineItems. */
export type ReverseFulfillmentOrderLineItemConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ReverseFulfillmentOrderLineItemEdge>;
  /** A list of nodes that are contained in ReverseFulfillmentOrderLineItemEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ReverseFulfillmentOrderLineItem>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ReverseFulfillmentOrderLineItem and a cursor during pagination. */
export type ReverseFulfillmentOrderLineItemEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ReverseFulfillmentOrderLineItemEdge. */
  readonly node: ReverseFulfillmentOrderLineItem;
};

/** The status of a reverse fulfillment order. */
export enum ReverseFulfillmentOrderStatus {
  /** The reverse fulfillment order has been canceled. */
  CANCELED = 'CANCELED',
  /** The reverse fulfillment order has been completed. */
  CLOSED = 'CLOSED',
  /** The reverse fulfillment order is in progress. */
  OPEN = 'OPEN'
}

/** The third-party confirmation of a reverse fulfillment order. */
export type ReverseFulfillmentOrderThirdPartyConfirmation = {
  /** The status of the reverse fulfillment order third-party confirmation. */
  readonly status: ReverseFulfillmentOrderThirdPartyConfirmationStatus;
};

/** The status of a reverse fulfillment order third-party confirmation. */
export enum ReverseFulfillmentOrderThirdPartyConfirmationStatus {
  /** The reverse fulfillment order was accepted by the fulfillment service. */
  ACCEPTED = 'ACCEPTED',
  /** The reverse fulfillment order cancelation was accepted by the fulfillment service. */
  CANCEL_ACCEPTED = 'CANCEL_ACCEPTED',
  /** The reverse fulfillment order cancelation was rejected by the fulfillment service. */
  CANCEL_REJECTED = 'CANCEL_REJECTED',
  /** The reverse fulfillment order is awaiting acceptance by the fulfillment service. */
  PENDING_ACCEPTANCE = 'PENDING_ACCEPTANCE',
  /** The reverse fulfillment order is awaiting cancelation by the fulfillment service. */
  PENDING_CANCELATION = 'PENDING_CANCELATION',
  /** The reverse fulfillment order was rejected by the fulfillment service. */
  REJECTED = 'REJECTED'
}

/** List of possible values for a RiskAssessment result. */
export enum RiskAssessmentResult {
  /** Indicates a high likelihood that the order is fraudulent. */
  HIGH = 'HIGH',
  /** Indicates a low likelihood that the order is fraudulent. */
  LOW = 'LOW',
  /** Indicates a medium likelihood that the order is fraudulent. */
  MEDIUM = 'MEDIUM',
  /** Indicates that the risk assessment will not provide a recommendation for the order. */
  NONE = 'NONE',
  /** Indicates that the risk assessment is still pending. */
  PENDING = 'PENDING'
}

/** A risk fact belongs to a single risk assessment and serves to provide additional context for an assessment. Risk facts are not necessarily tied to the result of the recommendation. */
export type RiskFact = {
  /** A description of the fact. */
  readonly description: Scalars['String'];
  /** Indicates whether the fact is a negative, neutral or positive contributor with regards to risk. */
  readonly sentiment: RiskFactSentiment;
};

/** List of possible values for a RiskFact sentiment. */
export enum RiskFactSentiment {
  /** A negative contributor that increases the risk. */
  NEGATIVE = 'NEGATIVE',
  /** A neutral contributor with regards to risk. */
  NEUTRAL = 'NEUTRAL',
  /** A positive contributor that lowers the risk. */
  POSITIVE = 'POSITIVE'
}

/** A row count represents rows on background operation. */
export type RowCount = {
  /** Estimated number of rows contained within this background operation. */
  readonly count: Scalars['Int'];
  /** Whether the operation exceeds max number of reportable rows. */
  readonly exceedsMax: Scalars['Boolean'];
};

/** SEO information. */
export type Seo = {
  /** SEO Description. */
  readonly description?: Maybe<Scalars['String']>;
  /** SEO Title. */
  readonly title?: Maybe<Scalars['String']>;
};

/** The input fields for SEO information. */
export type SeoInput = {
  /** SEO description of the product. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** SEO title of the product. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** An individual sale record associated with a sales agreement. Every money value in an order's sales data is represented in the currency's smallest unit. When amounts are divided across multiple line items, such as taxes or order discounts, the amounts might not divide evenly across all of the line items on the order. To address this, the remaining currency units that couldn't be divided evenly are allocated one at a time, starting with the first line item, until they are all accounted for. In aggregate, the values sum up correctly. In isolation, one line item might have a different tax or discount amount than another line item of the same price, before taxes and discounts. This is because the amount could not be divided evenly across the items. The allocation of currency units across line items is immutable. After they are allocated, currency units are never reallocated or redistributed among the line items. */
export type Sale = {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** The possible order action types for a sale. */
export enum SaleActionType {
  /** A purchase or charge. */
  ORDER = 'ORDER',
  /** A removal or return. */
  RETURN = 'RETURN',
  /** An unknown order action. Represents new actions that may be added in future versions. */
  UNKNOWN = 'UNKNOWN',
  /** A change to the price, taxes, or discounts for a prior purchase. */
  UPDATE = 'UPDATE'
}

/** The additional fee details for a line item. */
export type SaleAdditionalFee = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the additional fee. */
  readonly name: Scalars['String'];
  /** The price of the additional fee. */
  readonly price: MoneyBag;
  /** A list of taxes charged on the additional fee. */
  readonly taxLines: ReadonlyArray<TaxLine>;
};

/** An auto-generated type for paginating through multiple Sales. */
export type SaleConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SaleEdge>;
  /** A list of nodes that are contained in SaleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Sale>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one Sale and a cursor during pagination. */
export type SaleEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SaleEdge. */
  readonly node: Sale;
};

/** The possible line types for a sale record. One of the possible order line types for a sale is an adjustment. Sales adjustments occur when a refund is issued for a line item that is either more or less than the total value of the line item. Examples are restocking fees and goodwill payments. When this happens, Shopify produces a sales agreement with sale records for each line item that is returned or refunded and an additional sale record for the adjustment (for example, a restocking fee). The sales records for the returned or refunded items represent the reversal of the original line item sale value. The additional adjustment sale record represents the difference between the original total value of all line items that were refunded, and the actual amount refunded. */
export enum SaleLineType {
  /** An additional fee. */
  ADDITIONAL_FEE = 'ADDITIONAL_FEE',
  /** A sale adjustment. */
  ADJUSTMENT = 'ADJUSTMENT',
  /** A duty charge. */
  DUTY = 'DUTY',
  /** A fee charge. */
  FEE = 'FEE',
  /** A gift card. */
  GIFT_CARD = 'GIFT_CARD',
  /** A product purchased, returned or exchanged. */
  PRODUCT = 'PRODUCT',
  /** A shipping cost. */
  SHIPPING = 'SHIPPING',
  /** A tip added by the customer. */
  TIP = 'TIP',
  /** An unknown sale line. Represents new types that may be added in future versions. */
  UNKNOWN = 'UNKNOWN'
}

/** The tax allocated to a sale from a single tax line. */
export type SaleTax = {
  /** The portion of the total tax amount on the related sale that comes from the associated tax line. */
  readonly amount: MoneyBag;
  /** The unique ID for the sale tax. */
  readonly id: Scalars['ID'];
  /** The tax line associated with the sale. */
  readonly taxLine: TaxLine;
};

/** A contract between a merchant and a customer to do business. Shopify creates a sales agreement whenever an order is placed, edited, or refunded. A sales agreement has one or more sales records, which provide itemized details about the initial agreement or subsequent changes made to the order. For example, when a customer places an order, Shopify creates the order, generates a sales agreement, and records a sale for each line item purchased in the order. A sale record is specific to a type of order line. Order lines can represent different things such as a purchased product, a tip added by a customer, shipping costs collected at checkout, and more. */
export type SalesAgreement = {
  /** The application that created the agreement. */
  readonly app?: Maybe<App>;
  /** The date and time at which the agreement occured. */
  readonly happenedAt: Scalars['DateTime'];
  /** The unique ID for the agreement. */
  readonly id: Scalars['ID'];
  /** The reason the agremeent was created. */
  readonly reason: OrderActionType;
  /** The sales associated with the agreement. */
  readonly sales: SaleConnection;
  /** The staff member associated with the agreement. */
  readonly user?: Maybe<StaffMember>;
};


/** A contract between a merchant and a customer to do business. Shopify creates a sales agreement whenever an order is placed, edited, or refunded. A sales agreement has one or more sales records, which provide itemized details about the initial agreement or subsequent changes made to the order. For example, when a customer places an order, Shopify creates the order, generates a sales agreement, and records a sale for each line item purchased in the order. A sale record is specific to a type of order line. Order lines can represent different things such as a purchased product, a tip added by a customer, shipping costs collected at checkout, and more. */
export type SalesAgreementSalesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple SalesAgreements. */
export type SalesAgreementConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SalesAgreementEdge>;
  /** A list of nodes that are contained in SalesAgreementEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SalesAgreement>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one SalesAgreement and a cursor during pagination. */
export type SalesAgreementEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SalesAgreementEdge. */
  readonly node: SalesAgreement;
};

/** A saved search is a representation of a search query saved in the admin. */
export type SavedSearch = LegacyInteroperability & Node & {
  /** The filters of a saved search. */
  readonly filters: ReadonlyArray<SearchFilter>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The name of a saved search. */
  readonly name: Scalars['String'];
  /** The query string of a saved search. This includes search terms and filters. */
  readonly query: Scalars['String'];
  /** The type of resource this saved search is searching in. */
  readonly resourceType: SearchResultType;
  /** The search terms of a saved search. */
  readonly searchTerms: Scalars['String'];
};

/** An auto-generated type for paginating through multiple SavedSearches. */
export type SavedSearchConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SavedSearchEdge>;
  /** A list of nodes that are contained in SavedSearchEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SavedSearch>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields to create a saved search. */
export type SavedSearchCreateInput = {
  /** A descriptive name of the saved search. */
  readonly name: Scalars['String'];
  /** The query string of a saved search. This includes search terms and filters. */
  readonly query: Scalars['String'];
  /** The type of resource this saved search is searching in. */
  readonly resourceType: SearchResultType;
};

/** Return type for `savedSearchCreate` mutation. */
export type SavedSearchCreatePayload = {
  /** The saved search that was created. */
  readonly savedSearch?: Maybe<SavedSearch>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields to delete a saved search. */
export type SavedSearchDeleteInput = {
  /** ID of the saved search to delete. */
  readonly id: Scalars['ID'];
};

/** Return type for `savedSearchDelete` mutation. */
export type SavedSearchDeletePayload = {
  /** The ID of the saved search that was deleted. */
  readonly deletedSavedSearchId?: Maybe<Scalars['ID']>;
  /** The shop of the saved search that was deleted. */
  readonly shop: Shop;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one SavedSearch and a cursor during pagination. */
export type SavedSearchEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SavedSearchEdge. */
  readonly node: SavedSearch;
};

/** The input fields to update a saved search. */
export type SavedSearchUpdateInput = {
  /** ID of the saved search to update. */
  readonly id: Scalars['ID'];
  /** A descriptive name of the saved search. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The query string of a saved search. This included search terms and filters. */
  readonly query?: InputMaybe<Scalars['String']>;
};

/** Return type for `savedSearchUpdate` mutation. */
export type SavedSearchUpdatePayload = {
  /** The saved search that was updated. */
  readonly savedSearch?: Maybe<SavedSearch>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The set of valid sort keys for the ScheduledChange query. */
export enum ScheduledChangeSortKeys {
  /** Sort by the `expected_at` value. */
  EXPECTED_AT = 'EXPECTED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/**
 * Script discount applications capture the intentions of a discount that
 * was created by a Shopify Script for an order's line item or shipping line.
 *
 * Discount applications don't represent the actual final amount discounted on a line (line item or shipping line). The actual amount discounted on a line is represented by the [DiscountAllocation](https://shopify.dev/api/admin-graphql/latest/objects/discountallocation) object.
 */
export type ScriptDiscountApplication = DiscountApplication & {
  /** The method by which the discount's value is applied to its entitled items. */
  readonly allocationMethod: DiscountApplicationAllocationMethod;
  /**
   * The description of the application as defined by the Script.
   * @deprecated Use `title` instead.
   */
  readonly description: Scalars['String'];
  /**
   * An ordered index that can be used to identify the discount application and indicate the precedence
   * of the discount application for calculations.
   */
  readonly index: Scalars['Int'];
  /** How the discount amount is distributed on the discounted lines. */
  readonly targetSelection: DiscountApplicationTargetSelection;
  /** Whether the discount is applied on line items or shipping lines. */
  readonly targetType: DiscountApplicationTargetType;
  /** The title of the application as defined by the Script. */
  readonly title: Scalars['String'];
  /** The value of the discount application. */
  readonly value: PricingValue;
};

/**
 * <div class="note"><h4>Theme app extensions</h4>
 *   <p>Your app might not pass App Store review if it uses script tags instead of theme app extensions. All new apps, and apps that integrate with Online Store 2.0 themes, should use theme app extensions, such as app blocks or app embed blocks. Script tags are an alternative you can use with only vintage themes. <a href="/apps/online-store#what-integration-method-should-i-use" target="_blank">Learn more</a>.</p></div>
 *
 * <div class="note"><h4>Script tag deprecation</h4>
 *   <p>Script tags will be sunset for the <b>Order status</b> page on August 28, 2025. <a href="https://www.shopify.com/plus/upgrading-to-checkout-extensibility">Upgrade to Checkout Extensibility</a> before this date. <a href="/docs/api/liquid/objects#script">Shopify Scripts</a> will continue to work alongside Checkout Extensibility until August 28, 2025.</p></div>
 *
 *
 * A script tag represents remote JavaScript code that is loaded into the pages of a shop's storefront or the **Order status** page of checkout.
 */
export type ScriptTag = LegacyInteroperability & Node & {
  /**
   * Whether the Shopify CDN can cache and serve the script tag.
   * If `true`, then the script will be cached and served by the CDN.
   * The cache expires 15 minutes after the script tag is successfully returned.
   * If `false`, then the script will be served as is.
   */
  readonly cache: Scalars['Boolean'];
  /** The date and time when the script tag was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The page or pages on the online store that the script should be included. */
  readonly displayScope: ScriptTagDisplayScope;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The URL to the remote script. */
  readonly src: Scalars['URL'];
  /** The date and time when the script tag was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple ScriptTags. */
export type ScriptTagConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ScriptTagEdge>;
  /** A list of nodes that are contained in ScriptTagEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ScriptTag>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `scriptTagCreate` mutation. */
export type ScriptTagCreatePayload = {
  /** The script tag that was created. */
  readonly scriptTag?: Maybe<ScriptTag>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `scriptTagDelete` mutation. */
export type ScriptTagDeletePayload = {
  /** The ID of the deleted script tag. */
  readonly deletedScriptTagId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The page or pages on the online store where the script should be included. */
export enum ScriptTagDisplayScope {
  /** Include the script on both the web storefront and the <b>Order status</b> page. */
  ALL = 'ALL',
  /** Include the script only on the web storefront. */
  ONLINE_STORE = 'ONLINE_STORE',
  /** Include the script only on the <b>Order status</b> page. */
  ORDER_STATUS = 'ORDER_STATUS'
}

/** An auto-generated type which holds one ScriptTag and a cursor during pagination. */
export type ScriptTagEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ScriptTagEdge. */
  readonly node: ScriptTag;
};

/**
 * The input fields for a script tag. This input object is used when creating or updating
 * a script tag to specify its URL, where it should be included, and how it will be cached.
 */
export type ScriptTagInput = {
  /**
   * Whether the Shopify CDN can cache and serve the script tag.
   * If `true`, then the script will be cached and served by the CDN.
   * The cache expires 15 minutes after the script tag is successfully returned.
   * If `false`, then the script is served as is.
   * The default value is `false`.
   */
  readonly cache?: InputMaybe<Scalars['Boolean']>;
  /** The page or pages on the online store where the script should be included. */
  readonly displayScope?: InputMaybe<ScriptTagDisplayScope>;
  /** The URL of the remote script. For example: `https://example.com/path/to/script.js`. */
  readonly src?: InputMaybe<Scalars['URL']>;
};

/** Return type for `scriptTagUpdate` mutation. */
export type ScriptTagUpdatePayload = {
  /** The script tag that was updated. */
  readonly scriptTag?: Maybe<ScriptTag>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A filter in a search query represented by a key value pair. */
export type SearchFilter = {
  /** The key of the search filter. */
  readonly key: Scalars['String'];
  /** The value of the search filter. */
  readonly value: Scalars['String'];
};

/** A list of search filters along with their specific options in value and label pair for filtering. */
export type SearchFilterOptions = {
  /** A list of options that can be use to filter product availability. */
  readonly productAvailability: ReadonlyArray<FilterOption>;
};

/** Represents an individual result returned from a search. */
export type SearchResult = {
  /** Returns the search result description text. */
  readonly description?: Maybe<Scalars['String']>;
  /** Returns the Image resource presented to accompany a search result. */
  readonly image?: Maybe<Image>;
  /** Returns the ID of the resource returned in the search result. */
  readonly reference: Node;
  /** Returns the resource title. */
  readonly title: Scalars['String'];
  /** Returns the absolute URL to the resource in the search result. */
  readonly url: Scalars['URL'];
};

/** The connection type for SearchResult. */
export type SearchResultConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SearchResultEdge>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
  /**
   * An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page.
   * @deprecated The provided information is not accurate.
   */
  readonly resultsAfterCount: Scalars['Int'];
};

/** An auto-generated type which holds one SearchResult and a cursor during pagination. */
export type SearchResultEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SearchResultEdge. */
  readonly node: SearchResult;
};

/** Specifies the type of resources to be returned from a search. */
export enum SearchResultType {
  /** An article. */
  ARTICLE = 'ARTICLE',
  /** A balance transaction. */
  BALANCE_TRANSACTION = 'BALANCE_TRANSACTION',
  /** A blog. */
  BLOG = 'BLOG',
  COLLECTION = 'COLLECTION',
  CUSTOMER = 'CUSTOMER',
  /** A code discount redeem code. */
  DISCOUNT_REDEEM_CODE = 'DISCOUNT_REDEEM_CODE',
  DRAFT_ORDER = 'DRAFT_ORDER',
  /** A file. */
  FILE = 'FILE',
  ORDER = 'ORDER',
  /** A page. */
  PAGE = 'PAGE',
  PRICE_RULE = 'PRICE_RULE',
  PRODUCT = 'PRODUCT',
  /** A URL redirect. */
  URL_REDIRECT = 'URL_REDIRECT'
}

/** A dynamic collection of customers based on specific criteria. */
export type Segment = Node & {
  /** The date and time when the segment was added to the store. */
  readonly creationDate: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The date and time when the segment was last updated. */
  readonly lastEditDate: Scalars['DateTime'];
  /** The name of the segment. */
  readonly name: Scalars['String'];
  /** A precise definition of the segment. The definition is composed of a combination of conditions on facts about customers. */
  readonly query: Scalars['String'];
};

/** A filter that takes a value that's associated with an object. For example, the `tags` field is associated with the [`Customer`](/api/admin-graphql/latest/objects/Customer) object. */
export type SegmentAssociationFilter = SegmentFilter & {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
};

/** The statistics of a given attribute. */
export type SegmentAttributeStatistics = {
  /** The average of a given attribute. */
  readonly average: Scalars['Float'];
  /** The sum of a given attribute. */
  readonly sum: Scalars['Float'];
};

/** A filter with a Boolean value that's been added to a segment query. */
export type SegmentBooleanFilter = SegmentFilter & {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
};

/** An auto-generated type for paginating through multiple Segments. */
export type SegmentConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SegmentEdge>;
  /** A list of nodes that are contained in SegmentEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Segment>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `segmentCreate` mutation. */
export type SegmentCreatePayload = {
  /** The newly created segment. */
  readonly segment?: Maybe<Segment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A filter with a date value that's been added to a segment query. */
export type SegmentDateFilter = SegmentFilter & {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
};

/** Return type for `segmentDelete` mutation. */
export type SegmentDeletePayload = {
  /** ID of the deleted segment. */
  readonly deletedSegmentId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one Segment and a cursor during pagination. */
export type SegmentEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SegmentEdge. */
  readonly node: Segment;
};

/** A filter with a set of possible values that's been added to a segment query. */
export type SegmentEnumFilter = SegmentFilter & {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
};

/** A filter that's used to segment customers based on the date that an event occured. For example, the `product_bought` event filter allows you to segment customers based on what products they've bought. */
export type SegmentEventFilter = SegmentFilter & {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The parameters for an event segment filter. */
  readonly parameters: ReadonlyArray<SegmentEventFilterParameter>;
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
  /** The return value type for an event segment filter. */
  readonly returnValueType: Scalars['String'];
};

/** The parameters for an event segment filter. */
export type SegmentEventFilterParameter = {
  /** Whether the parameter accepts a list of values. */
  readonly acceptsMultipleValues: Scalars['Boolean'];
  /** The localized description of the parameter. */
  readonly localizedDescription: Scalars['String'];
  /** The localized name of the parameter. */
  readonly localizedName: Scalars['String'];
  /** Whether the parameter is optional. */
  readonly optional: Scalars['Boolean'];
  /** The type of the parameter. */
  readonly parameterType: Scalars['String'];
  /** The query name of the parameter. */
  readonly queryName: Scalars['String'];
};

/** The filters used in segment queries associated with a shop. */
export type SegmentFilter = {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
};

/** An auto-generated type for paginating through multiple SegmentFilters. */
export type SegmentFilterConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SegmentFilterEdge>;
  /** A list of nodes that are contained in SegmentFilterEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SegmentFilter>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one SegmentFilter and a cursor during pagination. */
export type SegmentFilterEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SegmentFilterEdge. */
  readonly node: SegmentFilter;
};

/** A filter with a double-precision, floating-point value that's been added to a segment query. */
export type SegmentFloatFilter = SegmentFilter & {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
};

/** A filter with an integer that's been added to a segment query. */
export type SegmentIntegerFilter = SegmentFilter & {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
};

/** The response type for the `segmentMembership` object. */
export type SegmentMembership = {
  /** A Boolean that indicates whether or not the customer in the query is a member of the segment, which is identified using the `segmentId`. */
  readonly isMember: Scalars['Boolean'];
  /** A `segmentId` that's used for testing membership. */
  readonly segmentId: Scalars['ID'];
};

/** A list of maps that contain `segmentId` IDs and `isMember` Booleans. The maps represent segment memberships. */
export type SegmentMembershipResponse = {
  /** The membership status for the given list of segments. */
  readonly memberships: ReadonlyArray<SegmentMembership>;
};

/**
 * A segment and its corresponding saved search.
 * For example, you can use `SegmentMigration` to retrieve the segment ID that corresponds to a saved search ID.
 */
export type SegmentMigration = {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The ID of the saved search. */
  readonly savedSearchId: Scalars['ID'];
  /** The ID of the segment. */
  readonly segmentId?: Maybe<Scalars['ID']>;
};

/** An auto-generated type for paginating through multiple SegmentMigrations. */
export type SegmentMigrationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SegmentMigrationEdge>;
  /** A list of nodes that are contained in SegmentMigrationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SegmentMigration>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one SegmentMigration and a cursor during pagination. */
export type SegmentMigrationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SegmentMigrationEdge. */
  readonly node: SegmentMigration;
};

/** The set of valid sort keys for the Segment query. */
export enum SegmentSortKeys {
  /** Sort by the `creation_date` value. */
  CREATION_DATE = 'CREATION_DATE',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `last_edit_date` value. */
  LAST_EDIT_DATE = 'LAST_EDIT_DATE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The statistics of a given segment. */
export type SegmentStatistics = {
  /** The statistics of a given attribute. */
  readonly attributeStatistics: SegmentAttributeStatistics;
};


/** The statistics of a given segment. */
export type SegmentStatisticsAttributeStatisticsArgs = {
  attributeName: Scalars['String'];
};

/** A filter with a string that's been added to a segment query. */
export type SegmentStringFilter = SegmentFilter & {
  /** The localized name of the filter. */
  readonly localizedName: Scalars['String'];
  /** Whether a file can have multiple values for a single customer. */
  readonly multiValue: Scalars['Boolean'];
  /** The query name of the filter. */
  readonly queryName: Scalars['String'];
};

/** Return type for `segmentUpdate` mutation. */
export type SegmentUpdatePayload = {
  /** The updated segment. */
  readonly segment?: Maybe<Segment>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/**
 * A list of suggested values associated with an individual segment. A
 * segment is a group of members, such as customers, that meet specific
 * criteria.
 */
export type SegmentValue = {
  /** The localized version of the value's name. This name is displayed to the merchant. */
  readonly localizedValue: Scalars['String'];
  /** The name of the query associated with the suggestion. */
  readonly queryName: Scalars['String'];
};

/** An auto-generated type for paginating through multiple SegmentValues. */
export type SegmentValueConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SegmentValueEdge>;
  /** A list of nodes that are contained in SegmentValueEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SegmentValue>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one SegmentValue and a cursor during pagination. */
export type SegmentValueEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SegmentValueEdge. */
  readonly node: SegmentValue;
};

/**
 * Properties used by customers to select a product variant.
 * Products can have multiple options, like different sizes or colors.
 */
export type SelectedOption = {
  /** The product option’s name. */
  readonly name: Scalars['String'];
  /** The product option’s value object. */
  readonly optionValue: ProductOptionValue;
  /** The product option’s value. */
  readonly value: Scalars['String'];
};

/** The input fields for the selected variant option of the combined listing. */
export type SelectedVariantOptionInput = {
  /** The metaobject value of the linked metafield. */
  readonly linkedMetafieldValue?: InputMaybe<Scalars['String']>;
  /** The name of the parent product's option. */
  readonly name: Scalars['String'];
  /** The selected option value of the parent product's option. */
  readonly value: Scalars['String'];
};

/**
 * Represents how a product can be sold and purchased. Selling plans and associated records (selling plan groups
 * and policies) are deleted 48 hours after a merchant uninstalls their subscriptions app. We recommend backing
 * up these records if you need to restore them later.
 *
 * For more information on selling plans, refer to
 * [*Creating and managing selling plans*](https://shopify.dev/docs/apps/selling-strategies/subscriptions/selling-plans).
 */
export type SellingPlan = HasMetafieldDefinitions & HasMetafields & HasPublishedTranslations & Node & {
  /** A selling plan policy which describes the recurring billing details. */
  readonly billingPolicy: SellingPlanBillingPolicy;
  /** The category used to classify the selling plan for reporting purposes. */
  readonly category?: Maybe<SellingPlanCategory>;
  /** The date and time when the selling plan was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A selling plan policy which describes the delivery details. */
  readonly deliveryPolicy: SellingPlanDeliveryPolicy;
  /** Buyer facing string which describes the selling plan commitment. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** When to reserve inventory for a selling plan. */
  readonly inventoryPolicy?: Maybe<SellingPlanInventoryPolicy>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * A customer-facing description of the selling plan.
   *
   * If your store supports multiple currencies, then don't include country-specific pricing content, such as "Buy monthly, get 10$ CAD off". This field won't be converted to reflect different currencies.
   */
  readonly name: Scalars['String'];
  /** The values of all options available on the selling plan. Selling plans are grouped together in Liquid when they're created by the same app, and have the same `selling_plan_group.name` and `selling_plan_group.options` values. */
  readonly options: ReadonlyArray<Scalars['String']>;
  /** Relative position of the selling plan for display. A lower position will be displayed before a higher position. */
  readonly position?: Maybe<Scalars['Int']>;
  /** Selling plan pricing details. */
  readonly pricingPolicies: ReadonlyArray<SellingPlanPricingPolicy>;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
};


/**
 * Represents how a product can be sold and purchased. Selling plans and associated records (selling plan groups
 * and policies) are deleted 48 hours after a merchant uninstalls their subscriptions app. We recommend backing
 * up these records if you need to restore them later.
 *
 * For more information on selling plans, refer to
 * [*Creating and managing selling plans*](https://shopify.dev/docs/apps/selling-strategies/subscriptions/selling-plans).
 */
export type SellingPlanMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/**
 * Represents how a product can be sold and purchased. Selling plans and associated records (selling plan groups
 * and policies) are deleted 48 hours after a merchant uninstalls their subscriptions app. We recommend backing
 * up these records if you need to restore them later.
 *
 * For more information on selling plans, refer to
 * [*Creating and managing selling plans*](https://shopify.dev/docs/apps/selling-strategies/subscriptions/selling-plans).
 */
export type SellingPlanMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/**
 * Represents how a product can be sold and purchased. Selling plans and associated records (selling plan groups
 * and policies) are deleted 48 hours after a merchant uninstalls their subscriptions app. We recommend backing
 * up these records if you need to restore them later.
 *
 * For more information on selling plans, refer to
 * [*Creating and managing selling plans*](https://shopify.dev/docs/apps/selling-strategies/subscriptions/selling-plans).
 */
export type SellingPlanMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents how a product can be sold and purchased. Selling plans and associated records (selling plan groups
 * and policies) are deleted 48 hours after a merchant uninstalls their subscriptions app. We recommend backing
 * up these records if you need to restore them later.
 *
 * For more information on selling plans, refer to
 * [*Creating and managing selling plans*](https://shopify.dev/docs/apps/selling-strategies/subscriptions/selling-plans).
 */
export type SellingPlanPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/**
 * Represents how a product can be sold and purchased. Selling plans and associated records (selling plan groups
 * and policies) are deleted 48 hours after a merchant uninstalls their subscriptions app. We recommend backing
 * up these records if you need to restore them later.
 *
 * For more information on selling plans, refer to
 * [*Creating and managing selling plans*](https://shopify.dev/docs/apps/selling-strategies/subscriptions/selling-plans).
 */
export type SellingPlanPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents how a product can be sold and purchased. Selling plans and associated records (selling plan groups
 * and policies) are deleted 48 hours after a merchant uninstalls their subscriptions app. We recommend backing
 * up these records if you need to restore them later.
 *
 * For more information on selling plans, refer to
 * [*Creating and managing selling plans*](https://shopify.dev/docs/apps/selling-strategies/subscriptions/selling-plans).
 */
export type SellingPlanTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/**
 * Specifies the date when delivery or fulfillment is completed by a merchant for a given time cycle. You can also
 * define a cutoff for which customers are eligible to enter this cycle and the desired behavior for customers who
 * start their subscription inside the cutoff period.
 *
 * Some example scenarios where anchors can be useful to implement advanced delivery behavior:
 * - A merchant starts fulfillment on a specific date every month.
 * - A merchant wants to bill the 1st of every quarter.
 * - A customer expects their delivery every Tuesday.
 *
 * For more details, see [About Selling Plans](https://shopify.dev/docs/apps/build/purchase-options/subscriptions/selling-plans#anchors).
 */
export type SellingPlanAnchor = {
  /**
   * The cutoff day for the anchor. Specifies a buffer period before the anchor date for orders to be included in a
   * delivery or fulfillment cycle.
   *
   * If `type` is WEEKDAY, then the value must be between 1-7. Shopify interprets
   * the days of the week according to ISO 8601, where 1 is Monday.
   *
   * If `type` is MONTHDAY, then the value must be between 1-31.
   *
   * If `type` is YEARDAY, then the value must be `null`.
   */
  readonly cutoffDay?: Maybe<Scalars['Int']>;
  /**
   * The day of the anchor.
   *
   * If `type` is WEEKDAY, then the value must be between 1-7. Shopify interprets
   * the days of the week according to ISO 8601, where 1 is Monday.
   *
   * If `type` isn't WEEKDAY, then the value must be between 1-31.
   */
  readonly day: Scalars['Int'];
  /**
   * The month of the anchor. If type is different than YEARDAY, then the value must
   * be `null` or between 1-12.
   */
  readonly month?: Maybe<Scalars['Int']>;
  /** Represents the anchor type, it can be one one of WEEKDAY, MONTHDAY, YEARDAY. */
  readonly type: SellingPlanAnchorType;
};

/** The input fields required to create or update a selling plan anchor. */
export type SellingPlanAnchorInput = {
  /**
   * The cutoff day of the anchor.
   *
   * If `type` is WEEKDAY, then the value must be between 1-7. Shopify interprets
   * the days of the week according to ISO 8601, where 1 is Monday.
   *
   * If `type` is MONTHDAY, then the value must be between 1-31.
   *
   * If `type` is YEARDAY, then the value must be `null`.
   *
   * This field should only be set if the cutoff field for the delivery policy is `null`.
   */
  readonly cutoffDay?: InputMaybe<Scalars['Int']>;
  /**
   * The day of the anchor.
   *
   * If `type` is WEEKDAY, then the value must be between 1-7. Shopify interprets
   * the days of the week according to ISO 8601, where 1 is Monday.
   *
   * If `type` isn't WEEKDAY, then the value must be between 1-31.
   */
  readonly day?: InputMaybe<Scalars['Int']>;
  /**
   * The month of the anchor. If type is different than YEARDAY, then the value must
   * be `null` or between 1-12.
   */
  readonly month?: InputMaybe<Scalars['Int']>;
  /** Represents the anchor type, must be one of WEEKDAY, MONTHDAY, YEARDAY. */
  readonly type?: InputMaybe<SellingPlanAnchorType>;
};

/** Represents the anchor type. */
export enum SellingPlanAnchorType {
  /** Which day of the month, between 1-31. */
  MONTHDAY = 'MONTHDAY',
  /** Which day of the week, between 1-7. */
  WEEKDAY = 'WEEKDAY',
  /** Which days of the month and year, month between 1-12, and day between 1-31. */
  YEARDAY = 'YEARDAY'
}

/**
 * Represents the billing frequency associated to the selling plan (for example, bill every week, or bill every
 * three months). The selling plan billing policy and associated records (selling plan groups, selling plans, pricing
 * policies, and delivery policy) are deleted 48 hours after a merchant uninstalls their subscriptions app.
 * We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanBillingPolicy = SellingPlanFixedBillingPolicy | SellingPlanRecurringBillingPolicy;

/** The input fields that are required to create or update a billing policy type. */
export type SellingPlanBillingPolicyInput = {
  /** The fixed billing policy details. */
  readonly fixed?: InputMaybe<SellingPlanFixedBillingPolicyInput>;
  /** The recurring billing policy details. */
  readonly recurring?: InputMaybe<SellingPlanRecurringBillingPolicyInput>;
};

/**
 * The category of the selling plan. For the `OTHER` category,
 *          you must fill out our [request form](https://docs.google.com/forms/d/e/1FAIpQLSeU18Xmw0Q61V8wdH-dfGafFqIBfRchQKUO8WAF3yJTvgyyZQ/viewform),
 *          where we'll review your request for a new purchase option.
 */
export enum SellingPlanCategory {
  /** The selling plan is for anything not in one of the other categories. */
  OTHER = 'OTHER',
  /** The selling plan is for pre-orders. */
  PRE_ORDER = 'PRE_ORDER',
  /** The selling plan is for subscriptions. */
  SUBSCRIPTION = 'SUBSCRIPTION',
  /** The selling plan is for try before you buy purchases. */
  TRY_BEFORE_YOU_BUY = 'TRY_BEFORE_YOU_BUY'
}

/** The amount charged at checkout when the full amount isn't charged at checkout. */
export type SellingPlanCheckoutCharge = {
  /** The charge type for the checkout charge. */
  readonly type: SellingPlanCheckoutChargeType;
  /** The charge value for the checkout charge. */
  readonly value: SellingPlanCheckoutChargeValue;
};

/** The input fields that are required to create or update a checkout charge. */
export type SellingPlanCheckoutChargeInput = {
  /** The checkout charge type defined by the policy. */
  readonly type?: InputMaybe<SellingPlanCheckoutChargeType>;
  /** The checkout charge value defined by the policy. */
  readonly value?: InputMaybe<SellingPlanCheckoutChargeValueInput>;
};

/** The percentage value of the price used for checkout charge. */
export type SellingPlanCheckoutChargePercentageValue = {
  /** The percentage value of the price used for checkout charge. */
  readonly percentage: Scalars['Float'];
};

/** The checkout charge when the full amount isn't charged at checkout. */
export enum SellingPlanCheckoutChargeType {
  /** The checkout charge is a percentage of the product or variant price. */
  PERCENTAGE = 'PERCENTAGE',
  /** The checkout charge is a fixed price amount. */
  PRICE = 'PRICE'
}

/** The portion of the price to be charged at checkout. */
export type SellingPlanCheckoutChargeValue = MoneyV2 | SellingPlanCheckoutChargePercentageValue;

/** The input fields required to create or update an checkout charge value. */
export type SellingPlanCheckoutChargeValueInput = {
  /** The fixed value for an checkout charge. */
  readonly fixedValue?: InputMaybe<Scalars['Decimal']>;
  /** The percentage value. */
  readonly percentage?: InputMaybe<Scalars['Float']>;
};

/** An auto-generated type for paginating through multiple SellingPlans. */
export type SellingPlanConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SellingPlanEdge>;
  /** A list of nodes that are contained in SellingPlanEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SellingPlan>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/**
 * Represents the delivery frequency associated to the selling plan (for example, deliver every month, or deliver
 * every other week). The selling plan delivery policy and associated records (selling plan groups, selling plans,
 * pricing policies, and billing policy) are deleted 48 hours after a merchant uninstalls their subscriptions app.
 * We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanDeliveryPolicy = SellingPlanFixedDeliveryPolicy | SellingPlanRecurringDeliveryPolicy;

/** The input fields that are required to create or update a delivery policy. */
export type SellingPlanDeliveryPolicyInput = {
  /** The fixed delivery policy details. */
  readonly fixed?: InputMaybe<SellingPlanFixedDeliveryPolicyInput>;
  /** The recurring delivery policy details. */
  readonly recurring?: InputMaybe<SellingPlanRecurringDeliveryPolicyInput>;
};

/** An auto-generated type which holds one SellingPlan and a cursor during pagination. */
export type SellingPlanEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SellingPlanEdge. */
  readonly node: SellingPlan;
};

/**
 * The fixed selling plan billing policy defines how much of the price of the product will be billed to customer
 * at checkout. If there is an outstanding balance, it determines when it will be paid.
 */
export type SellingPlanFixedBillingPolicy = {
  /** The checkout charge when the full amount isn't charged at checkout. */
  readonly checkoutCharge: SellingPlanCheckoutCharge;
  /** The exact time when to capture the full payment. */
  readonly remainingBalanceChargeExactTime?: Maybe<Scalars['DateTime']>;
  /** The period after remaining_balance_charge_trigger, before capturing the full payment. Expressed as an ISO8601 duration. */
  readonly remainingBalanceChargeTimeAfterCheckout?: Maybe<Scalars['String']>;
  /** When to capture payment for amount due. */
  readonly remainingBalanceChargeTrigger: SellingPlanRemainingBalanceChargeTrigger;
};

/** The input fields required to create or update a fixed billing policy. */
export type SellingPlanFixedBillingPolicyInput = {
  /** The checkout charge policy for the selling plan. */
  readonly checkoutCharge?: InputMaybe<SellingPlanCheckoutChargeInput>;
  /** The date and time to capture the full payment. */
  readonly remainingBalanceChargeExactTime?: InputMaybe<Scalars['DateTime']>;
  /** The period after capturing the payment for the amount due (`remainingBalanceChargeTrigger`), and before capturing the full payment. Expressed as an ISO8601 duration. */
  readonly remainingBalanceChargeTimeAfterCheckout?: InputMaybe<Scalars['String']>;
  /** When to capture the payment for the amount due. */
  readonly remainingBalanceChargeTrigger?: InputMaybe<SellingPlanRemainingBalanceChargeTrigger>;
};

/** Represents a fixed selling plan delivery policy. */
export type SellingPlanFixedDeliveryPolicy = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  readonly anchors: ReadonlyArray<SellingPlanAnchor>;
  /** A buffer period for orders to be included in next fulfillment anchor. */
  readonly cutoff?: Maybe<Scalars['Int']>;
  /** The date and time when the fulfillment should trigger. */
  readonly fulfillmentExactTime?: Maybe<Scalars['DateTime']>;
  /** What triggers the fulfillment. The value must be one of ANCHOR, ASAP, EXACT_TIME, or UNKNOWN. */
  readonly fulfillmentTrigger: SellingPlanFulfillmentTrigger;
  /**
   * Whether the delivery policy is merchant or buyer-centric.
   * Buyer-centric delivery policies state the time when the buyer will receive the goods.
   * Merchant-centric delivery policies state the time when the fulfillment should be started.
   * Currently, only merchant-centric delivery policies are supported.
   */
  readonly intent: SellingPlanFixedDeliveryPolicyIntent;
  /** The fulfillment or delivery behavior of the first fulfillment when the order is placed before the anchor. The default value for this field is `ASAP`. */
  readonly preAnchorBehavior: SellingPlanFixedDeliveryPolicyPreAnchorBehavior;
};

/** The input fields required to create or update a fixed delivery policy. */
export type SellingPlanFixedDeliveryPolicyInput = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  readonly anchors?: InputMaybe<ReadonlyArray<SellingPlanAnchorInput>>;
  /** A buffer period for orders to be included in a cycle. */
  readonly cutoff?: InputMaybe<Scalars['Int']>;
  /** The date and time when the fulfillment should trigger. */
  readonly fulfillmentExactTime?: InputMaybe<Scalars['DateTime']>;
  /** What triggers the fulfillment. */
  readonly fulfillmentTrigger?: InputMaybe<SellingPlanFulfillmentTrigger>;
  /** Whether the delivery policy is merchant or buyer-centric. */
  readonly intent?: InputMaybe<SellingPlanFixedDeliveryPolicyIntent>;
  /** The pre-anchor behavior. */
  readonly preAnchorBehavior?: InputMaybe<SellingPlanFixedDeliveryPolicyPreAnchorBehavior>;
};

/** Possible intentions of a Delivery Policy. */
export enum SellingPlanFixedDeliveryPolicyIntent {
  /** A merchant-centric delivery policy. Mark this delivery policy to define when the merchant should start fulfillment. */
  FULFILLMENT_BEGIN = 'FULFILLMENT_BEGIN'
}

/** The fulfillment or delivery behavior of the first fulfillment when the orderis placed before the anchor. */
export enum SellingPlanFixedDeliveryPolicyPreAnchorBehavior {
  /** Orders placed can be fulfilled / delivered immediately. Orders placed inside a cutoff can be fulfilled / delivered at the next anchor. */
  ASAP = 'ASAP',
  /**
   * Orders placed can be fulfilled / delivered at the next anchor date.
   * Orders placed inside a cutoff will skip the next anchor and can be fulfilled /
   * delivered at the following anchor.
   */
  NEXT = 'NEXT'
}

/**
 * Represents the pricing policy of a subscription or deferred purchase option selling plan.
 * The selling plan fixed pricing policy works with the billing and delivery policy
 * to determine the final price. Discounts are divided among fulfillments.
 * For example, a subscription with a $10 discount and two deliveries will have a $5
 * discount applied to each delivery.
 */
export type SellingPlanFixedPricingPolicy = SellingPlanPricingPolicyBase & {
  /** The price adjustment type. */
  readonly adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** The price adjustment value. */
  readonly adjustmentValue: SellingPlanPricingPolicyAdjustmentValue;
  /** The date and time when the fixed selling plan pricing policy was created. */
  readonly createdAt: Scalars['DateTime'];
};

/** The input fields required to create or update a fixed selling plan pricing policy. */
export type SellingPlanFixedPricingPolicyInput = {
  /** Price adjustment type defined by the policy. */
  readonly adjustmentType?: InputMaybe<SellingPlanPricingPolicyAdjustmentType>;
  /** Price adjustment value defined by the policy. */
  readonly adjustmentValue?: InputMaybe<SellingPlanPricingPolicyValueInput>;
  /** ID of the pricing policy. */
  readonly id?: InputMaybe<Scalars['ID']>;
};

/** Describes what triggers fulfillment. */
export enum SellingPlanFulfillmentTrigger {
  /** Use the anchor values to calculate fulfillment date. */
  ANCHOR = 'ANCHOR',
  /** As soon as possible. */
  ASAP = 'ASAP',
  /** At an exact time defined by the fulfillment_exact_time field. */
  EXACT_TIME = 'EXACT_TIME',
  /** Unknown. Usually to be determined in the future. */
  UNKNOWN = 'UNKNOWN'
}

/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroup = HasPublishedTranslations & Node & {
  /** The ID for app, exposed in Liquid and product JSON. */
  readonly appId?: Maybe<Scalars['String']>;
  /** Whether the given product is directly associated to the selling plan group. */
  readonly appliesToProduct: Scalars['Boolean'];
  /** Whether the given product variant is directly associated to the selling plan group. */
  readonly appliesToProductVariant: Scalars['Boolean'];
  /** Whether any of the product variants of the given product are associated to the selling plan group. */
  readonly appliesToProductVariants: Scalars['Boolean'];
  /** The date and time when the selling plan group was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The merchant-facing description of the selling plan group. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The merchant-facing label of the selling plan group. */
  readonly merchantCode: Scalars['String'];
  /** The buyer-facing label of the selling plan group. */
  readonly name: Scalars['String'];
  /** The values of all options available on the selling plan group. Selling plans are grouped together in Liquid when they're created by the same app, and have the same `selling_plan_group.name` and `selling_plan_group.options` values. */
  readonly options: ReadonlyArray<Scalars['String']>;
  /** The relative position of the selling plan group for display. */
  readonly position?: Maybe<Scalars['Int']>;
  /** Product variants associated to the selling plan group. */
  readonly productVariants: ProductVariantConnection;
  /** A count of product variants associated to the selling plan group. */
  readonly productVariantsCount?: Maybe<Count>;
  /** Products associated to the selling plan group. */
  readonly products: ProductConnection;
  /** A count of products associated to the selling plan group. */
  readonly productsCount?: Maybe<Count>;
  /** Selling plans associated to the selling plan group. */
  readonly sellingPlans: SellingPlanConnection;
  /** A summary of the policies associated to the selling plan group. */
  readonly summary?: Maybe<Scalars['String']>;
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
};


/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroupAppliesToProductArgs = {
  productId: Scalars['ID'];
};


/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroupAppliesToProductVariantArgs = {
  productVariantId: Scalars['ID'];
};


/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroupAppliesToProductVariantsArgs = {
  productId: Scalars['ID'];
};


/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroupProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['ID']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroupProductVariantsCountArgs = {
  productId?: InputMaybe<Scalars['ID']>;
};


/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroupProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroupSellingPlansArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Represents a selling method (for example, "Subscribe and save" or "Pre-paid"). Selling plan groups
 * and associated records (selling plans and policies) are deleted 48 hours after a merchant
 * uninstalls their subscriptions app. We recommend backing up these records if you need to restore them later.
 */
export type SellingPlanGroupTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** Return type for `sellingPlanGroupAddProductVariants` mutation. */
export type SellingPlanGroupAddProductVariantsPayload = {
  /** The updated selling plan group. */
  readonly sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** Return type for `sellingPlanGroupAddProducts` mutation. */
export type SellingPlanGroupAddProductsPayload = {
  /** The updated selling plan group. */
  readonly sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** An auto-generated type for paginating through multiple SellingPlanGroups. */
export type SellingPlanGroupConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SellingPlanGroupEdge>;
  /** A list of nodes that are contained in SellingPlanGroupEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SellingPlanGroup>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `sellingPlanGroupCreate` mutation. */
export type SellingPlanGroupCreatePayload = {
  /** The created selling plan group object. */
  readonly sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** Return type for `sellingPlanGroupDelete` mutation. */
export type SellingPlanGroupDeletePayload = {
  /** The ID of the deleted selling plan group object. */
  readonly deletedSellingPlanGroupId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** An auto-generated type which holds one SellingPlanGroup and a cursor during pagination. */
export type SellingPlanGroupEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SellingPlanGroupEdge. */
  readonly node: SellingPlanGroup;
};

/** The input fields required to create or update a selling plan group. */
export type SellingPlanGroupInput = {
  /** ID for app, exposed in Liquid and product JSON. */
  readonly appId?: InputMaybe<Scalars['String']>;
  /** Merchant facing description of the selling plan group. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** Merchant facing label of the selling plan group. */
  readonly merchantCode?: InputMaybe<Scalars['String']>;
  /** Buyer facing label of the selling plan group. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The values of all options available on the selling plan group. Selling plans are grouped together in Liquid when they're created by the same app, and have the same `selling_plan_group.name` and `selling_plan_group.options` values. */
  readonly options?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** Relative value for display purposes of the selling plan group. A lower position will be displayed before a higher one. */
  readonly position?: InputMaybe<Scalars['Int']>;
  /** List of selling plans to create. */
  readonly sellingPlansToCreate?: InputMaybe<ReadonlyArray<SellingPlanInput>>;
  /** List of selling plans ids to delete. */
  readonly sellingPlansToDelete?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** List of selling plans to update. */
  readonly sellingPlansToUpdate?: InputMaybe<ReadonlyArray<SellingPlanInput>>;
};

/** Return type for `sellingPlanGroupRemoveProductVariants` mutation. */
export type SellingPlanGroupRemoveProductVariantsPayload = {
  /** The removed product variant ids. */
  readonly removedProductVariantIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** Return type for `sellingPlanGroupRemoveProducts` mutation. */
export type SellingPlanGroupRemoveProductsPayload = {
  /** The removed product ids. */
  readonly removedProductIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** The input fields for resource association with a Selling Plan Group. */
export type SellingPlanGroupResourceInput = {
  /** The IDs of the Products to add to the Selling Plan Group. */
  readonly productIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The IDs of the Variants to add to the Selling Plan Group. */
  readonly productVariantIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** The set of valid sort keys for the SellingPlanGroup query. */
export enum SellingPlanGroupSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `name` value. */
  NAME = 'NAME',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE',
  /** Sort by the `updated_at` value. */
  UPDATED_AT = 'UPDATED_AT'
}

/** Return type for `sellingPlanGroupUpdate` mutation. */
export type SellingPlanGroupUpdatePayload = {
  /** The IDs of the deleted Subscription Plans. */
  readonly deletedSellingPlanIds?: Maybe<ReadonlyArray<Scalars['ID']>>;
  /** The updated Selling Plan Group. */
  readonly sellingPlanGroup?: Maybe<SellingPlanGroup>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SellingPlanGroupUserError>;
};

/** Represents a selling plan group custom error. */
export type SellingPlanGroupUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<SellingPlanGroupUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `SellingPlanGroupUserError`. */
export enum SellingPlanGroupUserErrorCode {
  /** Billing and delivery policy types must be the same. */
  BILLING_AND_DELIVERY_POLICY_TYPES_MUST_BE_THE_SAME = 'BILLING_AND_DELIVERY_POLICY_TYPES_MUST_BE_THE_SAME',
  /** Billing policy's interval is too large. */
  BILLING_POLICY_INTERVAL_TOO_LARGE = 'BILLING_POLICY_INTERVAL_TOO_LARGE',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** A fixed billing policy's checkout charge value and type must match. */
  CHECKOUT_CHARGE_VALUE_AND_TYPE_MUST_MATCH = 'CHECKOUT_CHARGE_VALUE_AND_TYPE_MUST_MATCH',
  /** Delivery policy's interval is too large. */
  DELIVERY_POLICY_INTERVAL_TOO_LARGE = 'DELIVERY_POLICY_INTERVAL_TOO_LARGE',
  /** The input value should be equal to the value allowed. */
  EQUAL_TO = 'EQUAL_TO',
  /** Could not add the resource to the selling plan group. */
  ERROR_ADDING_RESOURCE_TO_GROUP = 'ERROR_ADDING_RESOURCE_TO_GROUP',
  /** A fixed billing policy's fulfillment_exact_time must not be present when the fulfillment_trigger isn't EXACT_TIME. */
  FULFILLMENT_EXACT_TIME_NOT_ALLOWED = 'FULFILLMENT_EXACT_TIME_NOT_ALLOWED',
  /** A fixed billing policy's fulfillment_exact_time can't be blank when the fulfillment_trigger is EXACT_TIME. */
  FULFILLMENT_EXACT_TIME_REQUIRED = 'FULFILLMENT_EXACT_TIME_REQUIRED',
  /** The input value should be greater than the minimum allowed value. */
  GREATER_THAN = 'GREATER_THAN',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  /** Selling plan group could not be deleted. */
  GROUP_COULD_NOT_BE_DELETED = 'GROUP_COULD_NOT_BE_DELETED',
  /** Selling plan group does not exist. */
  GROUP_DOES_NOT_EXIST = 'GROUP_DOES_NOT_EXIST',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The input submitted is invalid. */
  INVALID_INPUT = 'INVALID_INPUT',
  /** The input value should be less than the maximum value allowed. */
  LESS_THAN = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  /** The input value is not a number. */
  NOT_A_NUMBER = 'NOT_A_NUMBER',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** Only one billing policy type can be defined. */
  ONLY_NEED_ONE_BILLING_POLICY_TYPE = 'ONLY_NEED_ONE_BILLING_POLICY_TYPE',
  /** A fixed billing policy's checkout charge can have at most one value. */
  ONLY_NEED_ONE_CHECKOUT_CHARGE_VALUE = 'ONLY_NEED_ONE_CHECKOUT_CHARGE_VALUE',
  /** Only one delivery policy type can be defined. */
  ONLY_NEED_ONE_DELIVERY_POLICY_TYPE = 'ONLY_NEED_ONE_DELIVERY_POLICY_TYPE',
  /** Only one pricing policy type can be defined. */
  ONLY_NEED_ONE_PRICING_POLICY_TYPE = 'ONLY_NEED_ONE_PRICING_POLICY_TYPE',
  /** Only one pricing policy adjustment value type can be defined. */
  ONLY_NEED_ONE_PRICING_POLICY_VALUE = 'ONLY_NEED_ONE_PRICING_POLICY_VALUE',
  /** A selling plan can't have both fixed and recurring billing policies. */
  ONLY_ONE_OF_FIXED_OR_RECURRING_BILLING = 'ONLY_ONE_OF_FIXED_OR_RECURRING_BILLING',
  /** A selling plan can't have both fixed and recurring delivery policies. */
  ONLY_ONE_OF_FIXED_OR_RECURRING_DELIVERY = 'ONLY_ONE_OF_FIXED_OR_RECURRING_DELIVERY',
  /** Selling plan does not exist. */
  PLAN_DOES_NOT_EXIST = 'PLAN_DOES_NOT_EXIST',
  /** Selling plan ID must be specified to update. */
  PLAN_ID_MUST_BE_SPECIFIED_TO_UPDATE = 'PLAN_ID_MUST_BE_SPECIFIED_TO_UPDATE',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** Pricing policy's adjustment value and adjustment type must match. */
  PRICING_POLICY_ADJUSTMENT_VALUE_AND_TYPE_MUST_MATCH = 'PRICING_POLICY_ADJUSTMENT_VALUE_AND_TYPE_MUST_MATCH',
  /** Product does not exist. */
  PRODUCT_DOES_NOT_EXIST = 'PRODUCT_DOES_NOT_EXIST',
  /** Product variant does not exist. */
  PRODUCT_VARIANT_DOES_NOT_EXIST = 'PRODUCT_VARIANT_DOES_NOT_EXIST',
  /** A fixed billing policy's remaining_balance_charge_exact_time must not be present when the remaining_balance_charge_trigger isn't EXACT_TIME. */
  REMAINING_BALANCE_CHARGE_EXACT_TIME_NOT_ALLOWED = 'REMAINING_BALANCE_CHARGE_EXACT_TIME_NOT_ALLOWED',
  /** A fixed billing policy's remaining_balance_charge_exact_time can't be blank when the remaining_balance_charge_trigger is EXACT_TIME. */
  REMAINING_BALANCE_CHARGE_EXACT_TIME_REQUIRED = 'REMAINING_BALANCE_CHARGE_EXACT_TIME_REQUIRED',
  /** A fixed billing policy's remaining_balance_charge_time_after_checkout must be present and greater than zero when the remaining_balance_charge_trigger is TIME_AFTER_CHECKOUT. */
  REMAINING_BALANCE_CHARGE_TIME_AFTER_CHECKOUT_MUST_BE_GREATER_THAN_ZERO = 'REMAINING_BALANCE_CHARGE_TIME_AFTER_CHECKOUT_MUST_BE_GREATER_THAN_ZERO',
  /** A fixed billing policy's remaining_balance_charge_trigger can't be NO_REMAINING_BALANCE when the checkout_charge_type is PERCENTAGE and checkout_charge_value is less than 100. */
  REMAINING_BALANCE_CHARGE_TRIGGER_NO_REMAINING_BALANCE_ON_PARTIAL_PERCENTAGE_CHECKOUT_CHARGE = 'REMAINING_BALANCE_CHARGE_TRIGGER_NO_REMAINING_BALANCE_ON_PARTIAL_PERCENTAGE_CHECKOUT_CHARGE',
  /** A fixed billing policy's remaining_balance_charge_trigger can't be NO_REMAINING_BALANCE when the checkout_charge_type is PRICE. */
  REMAINING_BALANCE_CHARGE_TRIGGER_NO_REMAINING_BALANCE_ON_PRICE_CHECKOUT_CHARGE = 'REMAINING_BALANCE_CHARGE_TRIGGER_NO_REMAINING_BALANCE_ON_PRICE_CHECKOUT_CHARGE',
  /** A fixed billing policy's remaining_balance_charge_trigger must be NO_REMAINING_BALANCE when the checkout_charge_type is PERCENTAGE and checkout_charge_value is 100. */
  REMAINING_BALANCE_CHARGE_TRIGGER_ON_FULL_CHECKOUT = 'REMAINING_BALANCE_CHARGE_TRIGGER_ON_FULL_CHECKOUT',
  /** The selling plan list provided contains 1 or more invalid IDs. */
  RESOURCE_LIST_CONTAINS_INVALID_IDS = 'RESOURCE_LIST_CONTAINS_INVALID_IDS',
  /** A fixed delivery policy's anchors must not be present when the fulfillment_trigger isn't ANCHOR. */
  SELLING_PLAN_ANCHORS_NOT_ALLOWED = 'SELLING_PLAN_ANCHORS_NOT_ALLOWED',
  /** A fixed delivery policy's anchors must be present when the fulfillment_trigger is ANCHOR. */
  SELLING_PLAN_ANCHORS_REQUIRED = 'SELLING_PLAN_ANCHORS_REQUIRED',
  /** Selling plan's billing and delivery policies anchors must be equal. */
  SELLING_PLAN_BILLING_AND_DELIVERY_POLICY_ANCHORS_MUST_BE_EQUAL = 'SELLING_PLAN_BILLING_AND_DELIVERY_POLICY_ANCHORS_MUST_BE_EQUAL',
  /** Selling plan's billing cycle must be a multiple of delivery cycle. */
  SELLING_PLAN_BILLING_CYCLE_MUST_BE_A_MULTIPLE_OF_DELIVERY_CYCLE = 'SELLING_PLAN_BILLING_CYCLE_MUST_BE_A_MULTIPLE_OF_DELIVERY_CYCLE',
  /** Missing billing policy. */
  SELLING_PLAN_BILLING_POLICY_MISSING = 'SELLING_PLAN_BILLING_POLICY_MISSING',
  /** Must include at least one selling plan. */
  SELLING_PLAN_COUNT_LOWER_BOUND = 'SELLING_PLAN_COUNT_LOWER_BOUND',
  /** Exceeded the selling plan limit (31). */
  SELLING_PLAN_COUNT_UPPER_BOUND = 'SELLING_PLAN_COUNT_UPPER_BOUND',
  /** Missing delivery policy. */
  SELLING_PLAN_DELIVERY_POLICY_MISSING = 'SELLING_PLAN_DELIVERY_POLICY_MISSING',
  /** Cannot have multiple selling plans with the same name. */
  SELLING_PLAN_DUPLICATE_NAME = 'SELLING_PLAN_DUPLICATE_NAME',
  /** Cannot have multiple selling plans with the same options. */
  SELLING_PLAN_DUPLICATE_OPTIONS = 'SELLING_PLAN_DUPLICATE_OPTIONS',
  /** A fixed selling plan can have at most one pricing policy. */
  SELLING_PLAN_FIXED_PRICING_POLICIES_LIMIT = 'SELLING_PLAN_FIXED_PRICING_POLICIES_LIMIT',
  /** Selling plan's billing policy max cycles must be greater than min cycles. */
  SELLING_PLAN_MAX_CYCLES_MUST_BE_GREATER_THAN_MIN_CYCLES = 'SELLING_PLAN_MAX_CYCLES_MUST_BE_GREATER_THAN_MIN_CYCLES',
  /** Cannot define option2 on this selling plan as there's no label on the parent selling plan group. */
  SELLING_PLAN_MISSING_OPTION2_LABEL_ON_PARENT_GROUP = 'SELLING_PLAN_MISSING_OPTION2_LABEL_ON_PARENT_GROUP',
  /** Cannot define option3 on this selling plan as there's no label on the parent selling plan group. */
  SELLING_PLAN_MISSING_OPTION3_LABEL_ON_PARENT_GROUP = 'SELLING_PLAN_MISSING_OPTION3_LABEL_ON_PARENT_GROUP',
  /** Selling plan's option2 is required because option2 exists. */
  SELLING_PLAN_OPTION2_REQUIRED_AS_DEFINED_ON_PARENT_GROUP = 'SELLING_PLAN_OPTION2_REQUIRED_AS_DEFINED_ON_PARENT_GROUP',
  /** Selling plan's option3 is required because option3 exists. */
  SELLING_PLAN_OPTION3_REQUIRED_AS_DEFINED_ON_PARENT_GROUP = 'SELLING_PLAN_OPTION3_REQUIRED_AS_DEFINED_ON_PARENT_GROUP',
  /** Selling plans can't have more than 2 pricing policies. */
  SELLING_PLAN_PRICING_POLICIES_LIMIT = 'SELLING_PLAN_PRICING_POLICIES_LIMIT',
  /** Selling plan's pricing policies must contain one fixed pricing policy. */
  SELLING_PLAN_PRICING_POLICIES_MUST_CONTAIN_A_FIXED_PRICING_POLICY = 'SELLING_PLAN_PRICING_POLICIES_MUST_CONTAIN_A_FIXED_PRICING_POLICY',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too big. */
  TOO_BIG = 'TOO_BIG',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** The input value is the wrong length. */
  WRONG_LENGTH = 'WRONG_LENGTH'
}

/** The input fields to create or update a selling plan. */
export type SellingPlanInput = {
  /** Selling plan policy which describes the billing details. */
  readonly billingPolicy?: InputMaybe<SellingPlanBillingPolicyInput>;
  /** The category used to classify this selling plan for reporting purposes. */
  readonly category?: InputMaybe<SellingPlanCategory>;
  /** A selling plan policy which describes the delivery details. */
  readonly deliveryPolicy?: InputMaybe<SellingPlanDeliveryPolicyInput>;
  /** Buyer facing string which describes the selling plan commitment. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** ID of the selling plan. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** A selling plan policy which describes the inventory details. */
  readonly inventoryPolicy?: InputMaybe<SellingPlanInventoryPolicyInput>;
  /** Additional customizable information to associate with the SellingPlan. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** Buyer facing string which describes the selling plan content. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The values of all options available on the selling plan. Selling plans are grouped together in Liquid when they're created by the same app, and have the same `selling_plan_group.name` and `selling_plan_group.options` values. */
  readonly options?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** Relative value for display purposes of this plan. A lower position will be displayed before a higher one. */
  readonly position?: InputMaybe<Scalars['Int']>;
  /**
   * The pricing policies which describe the pricing details. Each selling plan
   * can only contain a maximum of 2 pricing policies.
   */
  readonly pricingPolicies?: InputMaybe<ReadonlyArray<SellingPlanPricingPolicyInput>>;
};

/** Represents valid selling plan interval. */
export enum SellingPlanInterval {
  /** Day interval. */
  DAY = 'DAY',
  /** Month interval. */
  MONTH = 'MONTH',
  /** Week interval. */
  WEEK = 'WEEK',
  /** Year interval. */
  YEAR = 'YEAR'
}

/** The selling plan inventory policy. */
export type SellingPlanInventoryPolicy = {
  /** When to reserve inventory for the order. */
  readonly reserve: SellingPlanReserve;
};

/** The input fields required to create or update an inventory policy. */
export type SellingPlanInventoryPolicyInput = {
  /** When to reserve inventory for the order. The value must be ON_FULFILLMENT or ON_SALE. */
  readonly reserve?: InputMaybe<SellingPlanReserve>;
};

/**
 * Represents the type of pricing associated to the selling plan (for example, a $10 or 20% discount that is set
 * for a limited period or that is fixed for the duration of the subscription). Selling plan pricing policies and
 * associated records (selling plan groups, selling plans, billing policy, and delivery policy) are deleted 48
 * hours after a merchant uninstalls their subscriptions app. We recommend backing up these records if you need
 * to restore them later.
 */
export type SellingPlanPricingPolicy = SellingPlanFixedPricingPolicy | SellingPlanRecurringPricingPolicy;

/** Represents a selling plan pricing policy adjustment type. */
export enum SellingPlanPricingPolicyAdjustmentType {
  /** Fixed amount off adjustment. */
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  /** Percentage off adjustment. */
  PERCENTAGE = 'PERCENTAGE',
  /** Price of the policy. */
  PRICE = 'PRICE'
}

/** Represents a selling plan pricing policy adjustment value type. */
export type SellingPlanPricingPolicyAdjustmentValue = MoneyV2 | SellingPlanPricingPolicyPercentageValue;

/** Represents selling plan pricing policy common fields. */
export type SellingPlanPricingPolicyBase = {
  /** The price adjustment type. */
  readonly adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** The price adjustment value. */
  readonly adjustmentValue: SellingPlanPricingPolicyAdjustmentValue;
};

/** The input fields required to create or update a selling plan pricing policy. */
export type SellingPlanPricingPolicyInput = {
  /** Fixed pricing policy details. */
  readonly fixed?: InputMaybe<SellingPlanFixedPricingPolicyInput>;
  /** Recurring pricing policy details. */
  readonly recurring?: InputMaybe<SellingPlanRecurringPricingPolicyInput>;
};

/** The percentage value of a selling plan pricing policy percentage type. */
export type SellingPlanPricingPolicyPercentageValue = {
  /** The percentage value. */
  readonly percentage: Scalars['Float'];
};

/** The input fields required to create or update a pricing policy adjustment value. */
export type SellingPlanPricingPolicyValueInput = {
  /** The fixed value for an fixed amount off or a new policy price. */
  readonly fixedValue?: InputMaybe<Scalars['Decimal']>;
  /** The percentage value. */
  readonly percentage?: InputMaybe<Scalars['Float']>;
};

/** Represents a recurring selling plan billing policy. */
export type SellingPlanRecurringBillingPolicy = {
  /** Specific anchor dates upon which the billing interval calculations should be made. */
  readonly anchors: ReadonlyArray<SellingPlanAnchor>;
  /** The date and time when the selling plan billing policy was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The billing frequency, it can be either: day, week, month or year. */
  readonly interval: SellingPlanInterval;
  /** The number of intervals between billings. */
  readonly intervalCount: Scalars['Int'];
  /** Maximum number of billing iterations. */
  readonly maxCycles?: Maybe<Scalars['Int']>;
  /** Minimum number of billing iterations. */
  readonly minCycles?: Maybe<Scalars['Int']>;
};

/** The input fields required to create or update a recurring billing policy. */
export type SellingPlanRecurringBillingPolicyInput = {
  /** Specific anchor dates upon which the billing interval calculations should be made. */
  readonly anchors?: InputMaybe<ReadonlyArray<SellingPlanAnchorInput>>;
  /** The billing frequency, it can be either: day, week, month or year. */
  readonly interval?: InputMaybe<SellingPlanInterval>;
  /** The number of intervals between billings. */
  readonly intervalCount?: InputMaybe<Scalars['Int']>;
  /** Maximum number of billing iterations. */
  readonly maxCycles?: InputMaybe<Scalars['Int']>;
  /** Minimum number of billing iterations. */
  readonly minCycles?: InputMaybe<Scalars['Int']>;
};

/** Represents a recurring selling plan delivery policy. */
export type SellingPlanRecurringDeliveryPolicy = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  readonly anchors: ReadonlyArray<SellingPlanAnchor>;
  /** The date and time when the selling plan delivery policy was created. */
  readonly createdAt: Scalars['DateTime'];
  /** Number of days which represent a buffer period for orders to be included in a cycle. */
  readonly cutoff?: Maybe<Scalars['Int']>;
  /**
   * Whether the delivery policy is merchant or buyer-centric.
   * Buyer-centric delivery policies state the time when the buyer will receive the goods.
   * Merchant-centric delivery policies state the time when the fulfillment should be started.
   * Currently, only merchant-centric delivery policies are supported.
   */
  readonly intent: SellingPlanRecurringDeliveryPolicyIntent;
  /** The delivery frequency, it can be either: day, week, month or year. */
  readonly interval: SellingPlanInterval;
  /** The number of intervals between deliveries. */
  readonly intervalCount: Scalars['Int'];
  /** The fulfillment or delivery behavior of the first fulfillment when the order is placed before the anchor. The default value for this field is `ASAP`. */
  readonly preAnchorBehavior: SellingPlanRecurringDeliveryPolicyPreAnchorBehavior;
};

/** The input fields to create or update a recurring delivery policy. */
export type SellingPlanRecurringDeliveryPolicyInput = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  readonly anchors?: InputMaybe<ReadonlyArray<SellingPlanAnchorInput>>;
  /** A buffer period for orders to be included in a cycle. */
  readonly cutoff?: InputMaybe<Scalars['Int']>;
  /** Intention of this delivery policy, it can be either: delivery or fulfillment. */
  readonly intent?: InputMaybe<SellingPlanRecurringDeliveryPolicyIntent>;
  /** The delivery frequency, it can be either: day, week, month or year. */
  readonly interval?: InputMaybe<SellingPlanInterval>;
  /** The number of intervals between deliveries. */
  readonly intervalCount?: InputMaybe<Scalars['Int']>;
  /** The pre-anchor behavior. It can be either: asap or next. */
  readonly preAnchorBehavior?: InputMaybe<SellingPlanRecurringDeliveryPolicyPreAnchorBehavior>;
};

/** Whether the delivery policy is merchant or buyer-centric. */
export enum SellingPlanRecurringDeliveryPolicyIntent {
  /** A merchant-centric delivery policy. Mark this delivery policy to define when the merchant should start fulfillment. */
  FULFILLMENT_BEGIN = 'FULFILLMENT_BEGIN'
}

/** The fulfillment or delivery behaviors of the first fulfillment when the orderis placed before the anchor. */
export enum SellingPlanRecurringDeliveryPolicyPreAnchorBehavior {
  /** The orders placed can be fulfilled or delivered immediately. The orders placed inside a cutoff can be fulfilled or delivered at the next anchor. */
  ASAP = 'ASAP',
  /**
   * The orders placed can be fulfilled or delivered at the next anchor date.
   * The orders placed inside a cutoff will skip the next anchor and can be fulfilled or
   * delivered at the following anchor.
   */
  NEXT = 'NEXT'
}

/** Represents a recurring selling plan pricing policy. It applies after the fixed pricing policy. By using the afterCycle parameter, you can specify the cycle when the recurring pricing policy comes into effect. Recurring pricing policies are not available for deferred purchase options. */
export type SellingPlanRecurringPricingPolicy = SellingPlanPricingPolicyBase & {
  /** The price adjustment type. */
  readonly adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** The price adjustment value. */
  readonly adjustmentValue: SellingPlanPricingPolicyAdjustmentValue;
  /** Cycle after which this pricing policy applies. */
  readonly afterCycle?: Maybe<Scalars['Int']>;
  /** The date and time when the recurring selling plan pricing policy was created. */
  readonly createdAt: Scalars['DateTime'];
};

/** The input fields required to create or update a recurring selling plan pricing policy. */
export type SellingPlanRecurringPricingPolicyInput = {
  /** Price adjustment type defined by the policy. */
  readonly adjustmentType?: InputMaybe<SellingPlanPricingPolicyAdjustmentType>;
  /** Price adjustment value defined by the policy. */
  readonly adjustmentValue?: InputMaybe<SellingPlanPricingPolicyValueInput>;
  /** Cycle after which the pricing policy applies. */
  readonly afterCycle: Scalars['Int'];
  /** ID of the pricing policy. */
  readonly id?: InputMaybe<Scalars['ID']>;
};

/** When to capture the payment for the remaining amount due. */
export enum SellingPlanRemainingBalanceChargeTrigger {
  /** At an exact time defined by the remaining_balance_charge_exact_time field. */
  EXACT_TIME = 'EXACT_TIME',
  /** When there's no remaining balance to be charged after checkout. */
  NO_REMAINING_BALANCE = 'NO_REMAINING_BALANCE',
  /** After the duration defined by the remaining_balance_charge_time_after_checkout field. */
  TIME_AFTER_CHECKOUT = 'TIME_AFTER_CHECKOUT'
}

/** When to reserve inventory for a selling plan. */
export enum SellingPlanReserve {
  /** Reserve inventory when order is fulfilled. */
  ON_FULFILLMENT = 'ON_FULFILLMENT',
  /** Reserve inventory at time of sale. */
  ON_SALE = 'ON_SALE'
}

/** A server pixel stores configuration for streaming customer interactions to an EventBridge or PubSub endpoint. */
export type ServerPixel = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The current state of this server pixel. */
  readonly status?: Maybe<ServerPixelStatus>;
  /** Address of the EventBridge or PubSub endpoint. */
  readonly webhookEndpointAddress?: Maybe<Scalars['String']>;
};

/** Return type for `serverPixelCreate` mutation. */
export type ServerPixelCreatePayload = {
  /** The new server pixel. */
  readonly serverPixel?: Maybe<ServerPixel>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ErrorsServerPixelUserError>;
};

/** Return type for `serverPixelDelete` mutation. */
export type ServerPixelDeletePayload = {
  /** The ID of the server pixel that was deleted, if one was deleted. */
  readonly deletedServerPixelId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ErrorsServerPixelUserError>;
};

/** The current state of a server pixel. */
export enum ServerPixelStatus {
  /** This server pixel is connected: it will stream customer events to the endpoint if it is configured properly. */
  CONNECTED = 'CONNECTED',
  /** This server pixel is disconnected: it does not stream events to the endpoint and an endpoint address has been added to the server pixel. */
  DISCONNECTED_CONFIGURED = 'DISCONNECTED_CONFIGURED',
  /** This server pixel is disconnected and unconfigured: it does not stream events to the endpoint and no endpoint address had been added to the server pixel. */
  DISCONNECTED_UNCONFIGURED = 'DISCONNECTED_UNCONFIGURED'
}

/**
 * The [discount class](https://help.shopify.com/manual/discounts/combining-discounts/discount-combinations)
 * that's used to control how discounts can be combined.
 */
export enum ShippingDiscountClass {
  /** Combined as a shipping discount. */
  SHIPPING = 'SHIPPING'
}

/** Represents the shipping details that the customer chose for their order. */
export type ShippingLine = {
  /**
   * A reference to the carrier service that provided the rate.
   * Present when the rate was computed by a third-party carrier service.
   */
  readonly carrierIdentifier?: Maybe<Scalars['String']>;
  /** A reference to the shipping method. */
  readonly code?: Maybe<Scalars['String']>;
  /** The current shipping price after applying refunds, after applying discounts. If the parent `order.taxesIncluded`` field is true, then this price includes taxes. Otherwise, this field is the pre-tax price. */
  readonly currentDiscountedPriceSet: MoneyBag;
  /** Whether the shipping line is custom or not. */
  readonly custom: Scalars['Boolean'];
  /** The general classification of the delivery method. */
  readonly deliveryCategory?: Maybe<Scalars['String']>;
  /** The discounts that have been allocated to the shipping line. */
  readonly discountAllocations: ReadonlyArray<DiscountAllocation>;
  /**
   * The pre-tax shipping price with discounts applied.
   * As of API version 2024-07, this will be calculated including cart level discounts, such as the free shipping discount.
   * @deprecated Use `discountedPriceSet` instead.
   */
  readonly discountedPrice: MoneyV2;
  /**
   * The shipping price after applying discounts. If the parent order.taxesIncluded field is true, then this price includes taxes. If not, it's the pre-tax price.
   * As of API version 2024-07, this will be calculated including cart level discounts, such as the free shipping discount.
   */
  readonly discountedPriceSet: MoneyBag;
  /** A globally-unique ID. */
  readonly id?: Maybe<Scalars['ID']>;
  /** Whether the shipping line has been removed. */
  readonly isRemoved: Scalars['Boolean'];
  /**
   * The pre-tax shipping price without any discounts applied.
   * @deprecated Use `originalPriceSet` instead.
   */
  readonly originalPrice: MoneyV2;
  /** The pre-tax shipping price without any discounts applied. */
  readonly originalPriceSet: MoneyBag;
  /** The phone number at the shipping address. */
  readonly phone?: Maybe<Scalars['String']>;
  /**
   * Returns the price of the shipping line.
   * @deprecated Use `originalPriceSet` instead.
   */
  readonly price: Scalars['Money'];
  /**
   * The fulfillment service requested for the shipping method.
   * Present if the shipping method requires processing by a third party fulfillment service.
   * @deprecated requestedFulfillmentService is no longer in use. Order routing does not use the requestedFulfillmentService during order and fulfillment order creation.
   */
  readonly requestedFulfillmentService?: Maybe<FulfillmentService>;
  /** A unique identifier for the shipping rate. The format can change without notice and isn't meant to be shown to users. */
  readonly shippingRateHandle?: Maybe<Scalars['String']>;
  /** Returns the rate source for the shipping line. */
  readonly source?: Maybe<Scalars['String']>;
  /** The TaxLine objects connected to this shipping line. */
  readonly taxLines: ReadonlyArray<TaxLine>;
  /** Returns the title of the shipping line. */
  readonly title: Scalars['String'];
};

/** An auto-generated type for paginating through multiple ShippingLines. */
export type ShippingLineConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ShippingLineEdge>;
  /** A list of nodes that are contained in ShippingLineEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ShippingLine>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShippingLine and a cursor during pagination. */
export type ShippingLineEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ShippingLineEdge. */
  readonly node: ShippingLine;
};

/**
 * The input fields for specifying the shipping details for the draft order.
 *
 * > Note:
 * > A custom shipping line includes a title and price with `shippingRateHandle` set to `nil`. A shipping line with a carrier-provided shipping rate (currently set via the Shopify admin) includes the shipping rate handle.
 */
export type ShippingLineInput = {
  /** Price of the shipping rate with currency. If provided, `price` will be ignored. */
  readonly priceWithCurrency?: InputMaybe<MoneyInput>;
  /** A unique identifier for the shipping rate. */
  readonly shippingRateHandle?: InputMaybe<Scalars['String']>;
  /** Title of the shipping rate. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** A sale associated with a shipping charge. */
export type ShippingLineSale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** The shipping line item for the associated sale. `shippingLine` is not available if the `SaleActionType` is a return. */
  readonly shippingLine?: Maybe<ShippingLine>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** Return type for `shippingPackageDelete` mutation. */
export type ShippingPackageDeletePayload = {
  /** The ID of the deleted shipping package. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `shippingPackageMakeDefault` mutation. */
export type ShippingPackageMakeDefaultPayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Type of a shipping package. */
export enum ShippingPackageType {
  /** A shipping box. */
  BOX = 'BOX',
  /** An envelope. */
  ENVELOPE = 'ENVELOPE',
  /** A flat rate packaging supplied by a carrier. */
  FLAT_RATE = 'FLAT_RATE',
  /** A soft-pack, bubble-wrap or vinyl envelope. */
  SOFT_PACK = 'SOFT_PACK'
}

/** Return type for `shippingPackageUpdate` mutation. */
export type ShippingPackageUpdatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** A shipping rate is an additional cost added to the cost of the products that were ordered. */
export type ShippingRate = {
  /** Human-readable unique identifier for this shipping rate. */
  readonly handle: Scalars['String'];
  /** The cost associated with the shipping rate. */
  readonly price: MoneyV2;
  /** The name of the shipping rate. */
  readonly title: Scalars['String'];
};

/** Represents the shipping costs refunded on the Refund. */
export type ShippingRefund = {
  /**
   * The monetary value of the shipping fees to be refunded.
   * @deprecated Use `amountSet` instead.
   */
  readonly amount: Scalars['Money'];
  /** The monetary value of the shipping fees to be refunded in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /**
   * The maximum amount of shipping fees currently refundable.
   * @deprecated Use `maximumRefundableSet` instead.
   */
  readonly maximumRefundable: Scalars['Money'];
  /** The maximum amount of shipping fees currently refundable in shop and presentment currencies. */
  readonly maximumRefundableSet: MoneyBag;
  /**
   * The monetary value of the tax allocated to shipping fees to be refunded.
   * @deprecated Use `taxSet` instead.
   */
  readonly tax: Scalars['Money'];
  /** The monetary value of the tax allocated to shipping fees to be refunded in shop and presentment currencies. */
  readonly taxSet: MoneyBag;
};

/** The input fields that are required to reimburse shipping costs. */
export type ShippingRefundInput = {
  /** The monetary value of the shipping fees to be reimbursed. */
  readonly amount?: InputMaybe<Scalars['Money']>;
  /** Whether a full refund is provided. */
  readonly fullRefund?: InputMaybe<Scalars['Boolean']>;
};

/** Represents a collection of general settings and information about the shop. */
export type Shop = HasMetafields & HasPublishedTranslations & Node & {
  /** Account owner information. */
  readonly accountOwner: StaffMember;
  /** A list of the shop's active alert messages that appear in the Shopify admin. */
  readonly alerts: ReadonlyArray<ShopAlert>;
  /**
   * A list of the shop's product categories. Limit: 1000 product categories.
   * @deprecated Deprecated in API version 2024-07. Use `allProductCategoriesList` instead.
   */
  readonly allProductCategories: ReadonlyArray<ProductCategory>;
  /** A list of the shop's product categories. Limit: 1000 product categories. */
  readonly allProductCategoriesList: ReadonlyArray<TaxonomyCategory>;
  /**
   * The token required to query the shop's reports or dashboards.
   * @deprecated Not supported anymore.
   */
  readonly analyticsToken: Scalars['String'];
  /**
   * The paginated list of fulfillment orders assigned to the shop locations owned by the app.
   *
   * Assigned fulfillment orders are fulfillment orders that are set to be fulfilled from locations
   * managed by
   * [fulfillment services](https://shopify.dev/api/admin-graphql/latest/objects/FulfillmentService)
   * that are registered by the app.
   * One app (api_client) can host multiple fulfillment services on a shop.
   * Each fulfillment service manages a dedicated location on a shop.
   * Assigned fulfillment orders can have associated
   * [fulfillment requests](https://shopify.dev/api/admin-graphql/latest/enums/FulfillmentOrderRequestStatus),
   * or might currently not be requested to be fulfilled.
   *
   * The app must have `read_assigned_fulfillment_orders`
   * [access scope](https://shopify.dev/docs/api/usage/access-scopes)
   * to be able to retrieve fulfillment orders assigned to its locations.
   *
   * All assigned fulfillment orders (except those with the `CLOSED` status) will be returned by default.
   * Perform filtering with the `assignmentStatus` argument
   * to receive only fulfillment orders that have been requested to be fulfilled.
   * @deprecated Use `QueryRoot.assignedFulfillmentOrders` instead. Details: https://shopify.dev/changelog/moving-the-shop-assignedfulfillmentorders-connection-to-queryroot
   */
  readonly assignedFulfillmentOrders: FulfillmentOrderConnection;
  /** The list of sales channels not currently installed on the shop. */
  readonly availableChannelApps: AppConnection;
  /** The shop's billing address information. */
  readonly billingAddress: ShopAddress;
  /** List of all channel definitions associated with a shop. */
  readonly channelDefinitionsForInstalledChannels: ReadonlyArray<AvailableChannelDefinitionsByChannel>;
  /**
   * List of the shop's active sales channels.
   * @deprecated Use `QueryRoot.channels` instead.
   */
  readonly channels: ChannelConnection;
  /** Specifies whether the shop supports checkouts via Checkout API. */
  readonly checkoutApiSupported: Scalars['Boolean'];
  /**
   * Return a collection by its handle.
   * @deprecated Use `QueryRoot.collectionByHandle` instead.
   */
  readonly collectionByHandle?: Maybe<Collection>;
  /**
   * List of the shop's collection saved searches.
   * @deprecated Use `QueryRoot.collectionSavedSearches` instead.
   */
  readonly collectionSavedSearches: SavedSearchConnection;
  /**
   * List of the shop's collections.
   * @deprecated Use `QueryRoot.collections` instead.
   */
  readonly collections: CollectionConnection;
  /**
   * The public-facing contact email address for the shop.
   * Customers will use this email to communicate with the shop owner.
   */
  readonly contactEmail: Scalars['String'];
  /** Countries that have been defined in shipping zones for the shop. */
  readonly countriesInShippingZones: CountriesInShippingZones;
  /** The date and time when the shop was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The three letter code for the currency that the shop sells in. */
  readonly currencyCode: CurrencyCode;
  /** How currencies are displayed on your store. */
  readonly currencyFormats: CurrencyFormats;
  /** The presentment currency settings for the shop excluding the shop's own currency. */
  readonly currencySettings: CurrencySettingConnection;
  /** Whether customer accounts are required, optional, or disabled for the shop. */
  readonly customerAccounts: ShopCustomerAccountsSetting;
  /** Information about the shop's customer accounts. */
  readonly customerAccountsV2: CustomerAccountsV2;
  /**
   * List of the shop's customer saved searches.
   * @deprecated Use `QueryRoot.customerSavedSearches` instead.
   */
  readonly customerSavedSearches: SavedSearchConnection;
  /** A list of tags that have been added to customer accounts. */
  readonly customerTags: StringConnection;
  /**
   * Customer accounts associated to the shop.
   * @deprecated Use `QueryRoot.customers` instead.
   */
  readonly customers: CustomerConnection;
  /** The shop's meta description used in search engine results. */
  readonly description?: Maybe<Scalars['String']>;
  /**
   * The domains configured for the shop.
   * @deprecated Use `domainsPaginated` instead.
   */
  readonly domains: ReadonlyArray<Domain>;
  /**
   * List of the shop's draft order saved searches.
   * @deprecated Use `QueryRoot.draftOrderSavedSearches` instead.
   */
  readonly draftOrderSavedSearches: SavedSearchConnection;
  /** A list of tags that have been added to draft orders. */
  readonly draftOrderTags: StringConnection;
  /**
   * List of saved draft orders on the shop.
   * @deprecated Use `QueryRoot.draftOrders` instead.
   */
  readonly draftOrders: DraftOrderConnection;
  /**
   * The shop owner's email address.
   * Shopify will use this email address to communicate with the shop owner.
   */
  readonly email: Scalars['String'];
  /** The presentment currencies enabled for the shop. */
  readonly enabledPresentmentCurrencies: ReadonlyArray<CurrencyCode>;
  /** The set of features enabled for the shop. */
  readonly features: ShopFeatures;
  /**
   * The paginated list of merchant-managed and third-party fulfillment orders.
   * @deprecated Use `QueryRoot.fulfillmentOrders` instead.
   */
  readonly fulfillmentOrders: FulfillmentOrderConnection;
  /** List of the shop's installed fulfillment services. */
  readonly fulfillmentServices: ReadonlyArray<FulfillmentService>;
  /** The shop's time zone as defined by the IANA. */
  readonly ianaTimezone: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * List of the shop's inventory items.
   * @deprecated Use `QueryRoot.inventoryItems` instead.
   */
  readonly inventoryItems: InventoryItemConnection;
  /**
   * The number of pendings orders on the shop.
   * Limited to a maximum of 10000.
   * @deprecated Use `QueryRoot.pendingOrdersCount` instead.
   */
  readonly limitedPendingOrderCount: LimitedPendingOrderCount;
  /**
   * List of active locations of the shop.
   * @deprecated Use `QueryRoot.locations` instead.
   */
  readonly locations: LocationConnection;
  /**
   * List of a shop's marketing events.
   * @deprecated Use `QueryRoot.marketingEvents` instead.
   */
  readonly marketingEvents: MarketingEventConnection;
  /** Whether SMS marketing has been enabled on the shop's checkout configuration settings. */
  readonly marketingSmsConsentEnabledAtCheckout: Scalars['Boolean'];
  /** The approval signals for a shop to support onboarding to channel apps. */
  readonly merchantApprovalSignals?: Maybe<MerchantApprovalSignals>;
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /** The shop's .myshopify.com domain name. */
  readonly myshopifyDomain: Scalars['String'];
  /** The shop's name. */
  readonly name: Scalars['String'];
  /** The shop's settings related to navigation. */
  readonly navigationSettings: ReadonlyArray<NavigationItem>;
  /** The prefix that appears before order numbers. */
  readonly orderNumberFormatPrefix: Scalars['String'];
  /** The suffix that appears after order numbers. */
  readonly orderNumberFormatSuffix: Scalars['String'];
  /**
   * List of the shop's order saved searches.
   * @deprecated Use `QueryRoot.orderSavedSearches` instead.
   */
  readonly orderSavedSearches: SavedSearchConnection;
  /** A list of tags that have been added to orders. */
  readonly orderTags: StringConnection;
  /**
   * A list of the shop's orders.
   * @deprecated Use `QueryRoot.orders` instead.
   */
  readonly orders: OrderConnection;
  /** The shop's settings related to payments. */
  readonly paymentSettings: PaymentSettings;
  /** The shop's billing plan. */
  readonly plan: ShopPlan;
  /** The primary domain of the shop's online store. */
  readonly primaryDomain: Domain;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /**
   * Return a product by its handle.
   * @deprecated Use `QueryRoot.productByHandle` instead.
   */
  readonly productByHandle?: Maybe<Product>;
  /**
   * The list of all images of all products for the shop.
   * @deprecated Use `files` instead. See [filesQuery](https://shopify.dev/docs/api/admin-graphql/latest/queries/files) and its [query](https://shopify.dev/docs/api/admin-graphql/2024-01/queries/files#argument-query) argument for more information.
   */
  readonly productImages: ImageConnection;
  /**
   * List of the shop's product saved searches.
   * @deprecated Use `QueryRoot.productSavedSearches` instead.
   */
  readonly productSavedSearches: SavedSearchConnection;
  /**
   * A list of tags that have been added to products.
   * @deprecated Use `QueryRoot.productTags` instead.
   */
  readonly productTags: StringConnection;
  /**
   * The list of types added to products.
   * @deprecated Use `QueryRoot.productTypes` instead.
   */
  readonly productTypes: StringConnection;
  /**
   * List of the shop's product variants.
   * @deprecated Use `QueryRoot.productVariants` instead.
   */
  readonly productVariants: ProductVariantConnection;
  /**
   * The list of vendors added to products.
   * @deprecated Use `QueryRoot.productVendors` instead.
   */
  readonly productVendors: StringConnection;
  /**
   * List of the shop's products.
   * @deprecated Use `QueryRoot.products`.
   */
  readonly products: ProductConnection;
  /**
   * The number of publications for the shop.
   * @deprecated Use `QueryRoot.publicationsCount` instead.
   */
  readonly publicationCount: Scalars['Int'];
  /** The shop's limits for specific resources. For example, the maximum number ofvariants allowed per product, or the maximum number of locations allowed. */
  readonly resourceLimits: ShopResourceLimits;
  /** The URL of the rich text editor that can be used for mobile devices. */
  readonly richTextEditorUrl: Scalars['URL'];
  /** Fetches a list of admin search results by a specified query. */
  readonly search: SearchResultConnection;
  /** The list of search filter options for the shop. These can be used to filter productvisibility for the shop. */
  readonly searchFilters: SearchFilterOptions;
  /** Whether the shop has outstanding setup steps. */
  readonly setupRequired: Scalars['Boolean'];
  /** The list of countries that the shop ships to. */
  readonly shipsToCountries: ReadonlyArray<CountryCode>;
  /** The name of the shop owner. */
  readonly shopOwnerName: Scalars['String'];
  /** The list of all legal policies associated with a shop. */
  readonly shopPolicies: ReadonlyArray<ShopPolicy>;
  /**
   * The paginated list of the shop's staff members.
   * @deprecated Use `QueryRoot.staffMembers` instead.
   */
  readonly staffMembers: StaffMemberConnection;
  /** The storefront access token of a private application. These are scoped per-application. */
  readonly storefrontAccessTokens: StorefrontAccessTokenConnection;
  /**
   * The URL of the shop's storefront.
   * @deprecated Use `url` instead.
   */
  readonly storefrontUrl: Scalars['URL'];
  /** Whether the shop charges taxes for shipping. */
  readonly taxShipping: Scalars['Boolean'];
  /** Whether applicable taxes are included in the shop's product prices. */
  readonly taxesIncluded: Scalars['Boolean'];
  /** The shop's time zone abbreviation. */
  readonly timezoneAbbreviation: Scalars['String'];
  /** The shop's time zone offset. */
  readonly timezoneOffset: Scalars['String'];
  /** The shop's time zone offset expressed as a number of minutes. */
  readonly timezoneOffsetMinutes: Scalars['Int'];
  /** Whether transactional SMS sent by Shopify have been disabled for a shop. */
  readonly transactionalSmsDisabled: Scalars['Boolean'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The shop's unit system for weights and measures. */
  readonly unitSystem: UnitSystem;
  /** The date and time when the shop was last updated. */
  readonly updatedAt: Scalars['DateTime'];
  /**
   * Fetches a list of images uploaded to the shop by their IDs.
   * @deprecated Use `files` instead. See [filesQuery](https://shopify.dev/docs/api/admin-graphql/latest/queries/files) and its [query](https://shopify.dev/docs/api/admin-graphql/2024-01/queries/files#argument-query) argument for more information.
   */
  readonly uploadedImagesByIds: ReadonlyArray<Image>;
  /** The URL of the shop's online store. */
  readonly url: Scalars['URL'];
  /** The shop's primary unit of weight for products and shipping. */
  readonly weightUnit: WeightUnit;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopAssignedFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  assignmentStatus?: InputMaybe<FulfillmentOrderAssignmentStatus>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<FulfillmentOrderSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopAvailableChannelAppsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopCollectionByHandleArgs = {
  handle: Scalars['String'];
};


/** Represents a collection of general settings and information about the shop. */
export type ShopCollectionSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<CollectionSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopCurrencySettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopCustomerSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CustomerSavedSearchSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopCustomerTagsArgs = {
  first: Scalars['Int'];
};


/** Represents a collection of general settings and information about the shop. */
export type ShopCustomersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<CustomerSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopDraftOrderSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopDraftOrderTagsArgs = {
  first: Scalars['Int'];
};


/** Represents a collection of general settings and information about the shop. */
export type ShopDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<DraftOrderSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopFulfillmentOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeClosed?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<FulfillmentOrderSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopInventoryItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  includeLegacy?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<LocationSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopMarketingEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MarketingEventSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopOrderSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopOrderTagsArgs = {
  first: Scalars['Int'];
  sort?: InputMaybe<ShopTagSort>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<OrderSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** Represents a collection of general settings and information about the shop. */
export type ShopPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopProductByHandleArgs = {
  handle: Scalars['String'];
};


/** Represents a collection of general settings and information about the shop. */
export type ShopProductImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductImageSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopProductSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopProductTagsArgs = {
  first: Scalars['Int'];
};


/** Represents a collection of general settings and information about the shop. */
export type ShopProductTypesArgs = {
  first: Scalars['Int'];
};


/** Represents a collection of general settings and information about the shop. */
export type ShopProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<ProductVariantSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopProductVendorsArgs = {
  first: Scalars['Int'];
};


/** Represents a collection of general settings and information about the shop. */
export type ShopProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  query: Scalars['String'];
  types?: InputMaybe<ReadonlyArray<SearchResultType>>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopStaffMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopStorefrontAccessTokensArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};


/** Represents a collection of general settings and information about the shop. */
export type ShopUploadedImagesByIdsArgs = {
  imageIds: ReadonlyArray<Scalars['ID']>;
};

/** An address for a shop. */
export type ShopAddress = Node & {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: Maybe<Scalars['String']>;
  /** The name of the company or organization. */
  readonly company?: Maybe<Scalars['String']>;
  /** Whether the address coordinates are valid. */
  readonly coordinatesValidated: Scalars['Boolean'];
  /** The name of the country. */
  readonly country?: Maybe<Scalars['String']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   * @deprecated Use `countryCodeV2` instead.
   */
  readonly countryCode?: Maybe<Scalars['String']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   */
  readonly countryCodeV2?: Maybe<CountryCode>;
  /**
   * The first name.
   * @deprecated Always null in this context.
   */
  readonly firstName?: Maybe<Scalars['String']>;
  /** A formatted version of the address, customized by the provided arguments. */
  readonly formatted: ReadonlyArray<Scalars['String']>;
  /** A comma-separated list of the values for city, province, and country. */
  readonly formattedArea?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The last name.
   * @deprecated Always null in this context.
   */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The latitude coordinate of the address. */
  readonly latitude?: Maybe<Scalars['Float']>;
  /** The longitude coordinate of the address. */
  readonly longitude?: Maybe<Scalars['Float']>;
  /**
   * The full name, based on firstName and lastName.
   * @deprecated Always null in this context.
   */
  readonly name?: Maybe<Scalars['String']>;
  /**
   * A phone number associated with the address.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   */
  readonly phone?: Maybe<Scalars['String']>;
  /** The region of the address, such as the province, state, or district. */
  readonly province?: Maybe<Scalars['String']>;
  /**
   * The alphanumeric code for the region.
   *
   * For example, ON.
   */
  readonly provinceCode?: Maybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  readonly zip?: Maybe<Scalars['String']>;
};


/** An address for a shop. */
export type ShopAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']>;
};

/** An alert message that appears in the Shopify admin about a problem with a store setting, with an action to take. For example, you could show an alert to ask the merchant to enter their billing information to activate Shopify Plus. */
export type ShopAlert = {
  /** The text for the button in the alert that links to related information. For example, _Add credit card_. */
  readonly action: ShopAlertAction;
  /** A description of the alert and further information, such as whether the merchant will be charged. */
  readonly description: Scalars['String'];
};

/** An action associated to a shop alert, such as adding a credit card. */
export type ShopAlertAction = {
  /** The text for the button in the alert. For example, _Add credit card_. */
  readonly title: Scalars['String'];
  /** The target URL that the button links to. */
  readonly url: Scalars['URL'];
};

/** Billing preferences for the shop. */
export type ShopBillingPreferences = {
  /** The currency the shop uses to pay for apps and services. */
  readonly currency: CurrencyCode;
};

/**
 * Possible branding of a shop.
 * Branding can be used to define the look of a shop including its styling and logo in the Shopify Admin.
 */
export enum ShopBranding {
  /** Shop has Rogers branding. */
  ROGERS = 'ROGERS',
  /** Shop has Shopify branding. */
  SHOPIFY = 'SHOPIFY',
  /** Shop has Shopify Gold branding. */
  SHOPIFY_GOLD = 'SHOPIFY_GOLD',
  /** Shop has Shopify Plus branding. */
  SHOPIFY_PLUS = 'SHOPIFY_PLUS'
}

/** Represents the shop's customer account requirement preference. */
export enum ShopCustomerAccountsSetting {
  DISABLED = 'DISABLED',
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED'
}

/**
 * Represents the feature set available to the shop.
 * Most fields specify whether a feature is enabled for a shop, and some fields return information
 * related to specific features.
 */
export type ShopFeatures = {
  /** Whether a shop has access to Avalara AvaTax. */
  readonly avalaraAvatax: Scalars['Boolean'];
  /** The branding of the shop, which influences its look and feel in the Shopify admin. */
  readonly branding: ShopBranding;
  /** Represents the Bundles feature configuration for the shop. */
  readonly bundles: BundlesFeature;
  /** Whether a shop's online store can have CAPTCHA protection. */
  readonly captcha: Scalars['Boolean'];
  /**
   * Whether a shop's online store can have CAPTCHA protection for domains not managed by Shopify.
   * @deprecated No longer required for external domains
   */
  readonly captchaExternalDomains: Scalars['Boolean'];
  /** Represents the cart transform feature configuration for the shop. */
  readonly cartTransform: CartTransformFeature;
  /**
   * Whether the delivery profiles functionality is enabled for this shop.
   * @deprecated Delivery profiles are now 100% enabled across Shopify.
   */
  readonly deliveryProfiles: Scalars['Boolean'];
  /** Whether a shop has access to the Google Analytics dynamic remarketing feature. */
  readonly dynamicRemarketing: Scalars['Boolean'];
  /** Whether a shop can be migrated to use Shopify subscriptions. */
  readonly eligibleForSubscriptionMigration: Scalars['Boolean'];
  /** Whether a shop is configured properly to sell subscriptions. */
  readonly eligibleForSubscriptions: Scalars['Boolean'];
  /** Whether a shop can create gift cards. */
  readonly giftCards: Scalars['Boolean'];
  /**
   * Whether a shop displays Harmonized System codes on products. This is used for customs when shipping
   * internationally.
   */
  readonly harmonizedSystemCode: Scalars['Boolean'];
  /**
   * Whether a shop can enable international domains.
   * @deprecated All shops have international domains through Shopify Markets.
   */
  readonly internationalDomains: Scalars['Boolean'];
  /** Whether a shop can enable international price overrides. */
  readonly internationalPriceOverrides: Scalars['Boolean'];
  /** Whether a shop can enable international price rules. */
  readonly internationalPriceRules: Scalars['Boolean'];
  /** Whether a shop has enabled a legacy subscription gateway to handle older subscriptions. */
  readonly legacySubscriptionGatewayEnabled: Scalars['Boolean'];
  /**
   * Whether to show the Live View metrics in the Shopify admin. Live view is hidden from merchants that are on a trial
   * or don't have a storefront.
   */
  readonly liveView: Scalars['Boolean'];
  /**
   * Whether a shop has multi-location functionality.
   * @deprecated All shops support multi-location inventory. Use `QueryRoot.locations` to determine whether shop has more than one location.
   *
   */
  readonly multiLocation: Scalars['Boolean'];
  /**
   * Whether a shop has access to the onboarding visual.
   * @deprecated No longer supported.
   */
  readonly onboardingVisual: Scalars['Boolean'];
  /** Whether a shop is configured to sell subscriptions with PayPal Express. */
  readonly paypalExpressSubscriptionGatewayStatus: PaypalExpressSubscriptionsGatewayStatus;
  /** Whether a shop has access to all reporting features. */
  readonly reports: Scalars['Boolean'];
  /** Whether a shop has ever had subscription products. */
  readonly sellsSubscriptions: Scalars['Boolean'];
  /**
   * Whether the shop has a Shopify Plus subscription.
   * @deprecated Use Shop.plan.shopifyPlus instead.
   */
  readonly shopifyPlus: Scalars['Boolean'];
  /** Whether to show metrics in the Shopify admin. Metrics are hidden for new merchants until they become meaningful. */
  readonly showMetrics: Scalars['Boolean'];
  /** Whether a shop has an online store. */
  readonly storefront: Scalars['Boolean'];
  /** Whether a shop is using Shopify Balance. */
  readonly usingShopifyBalance: Scalars['Boolean'];
};

/** A locale that's been enabled on a shop. */
export type ShopLocale = {
  /** The locale ISO code. */
  readonly locale: Scalars['String'];
  /** The market web presences that use the locale. */
  readonly marketWebPresences: ReadonlyArray<MarketWebPresence>;
  /** The human-readable locale name. */
  readonly name: Scalars['String'];
  /** Whether the locale is the default locale for the shop. */
  readonly primary: Scalars['Boolean'];
  /** Whether the locale is visible to buyers. */
  readonly published: Scalars['Boolean'];
};

/** Return type for `shopLocaleDisable` mutation. */
export type ShopLocaleDisablePayload = {
  /** ISO code of the locale that was deleted. */
  readonly locale?: Maybe<Scalars['String']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `shopLocaleEnable` mutation. */
export type ShopLocaleEnablePayload = {
  /** ISO code of the locale that was enabled. */
  readonly shopLocale?: Maybe<ShopLocale>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for a shop locale. */
export type ShopLocaleInput = {
  /** The market web presences on which the locale should be enabled. Pass in an empty array to remove the locale across all market web presences. */
  readonly marketWebPresenceIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** Whether the locale is published. Only published locales are visible to the buyer. */
  readonly published?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `shopLocaleUpdate` mutation. */
export type ShopLocaleUpdatePayload = {
  /** The locale that was updated. */
  readonly shopLocale?: Maybe<ShopLocale>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Shop Pay Installments payment details related to a transaction. */
export type ShopPayInstallmentsPaymentDetails = BasePaymentDetails & {
  /** The name of payment method used by the buyer. */
  readonly paymentMethodName?: Maybe<Scalars['String']>;
};

/** The billing plan of the shop. */
export type ShopPlan = {
  /**
   * The name of the shop's billing plan.
   * @deprecated Use `publicDisplayName` instead.
   */
  readonly displayName: Scalars['String'];
  /** Whether the shop is a partner development shop for testing purposes. */
  readonly partnerDevelopment: Scalars['Boolean'];
  /** Whether the shop has a Shopify Plus subscription. */
  readonly shopifyPlus: Scalars['Boolean'];
};

/** Policy that a merchant has configured for their store, such as their refund or privacy policy. */
export type ShopPolicy = HasPublishedTranslations & Node & {
  /** The text of the policy. The maximum size is 512kb. */
  readonly body: Scalars['HTML'];
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the policy was created. */
  readonly createdAt: Scalars['Date'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The translated title of the policy. For example, Refund Policy or Politique de remboursement. */
  readonly title: Scalars['String'];
  /** The published translations associated with the resource. */
  readonly translations: ReadonlyArray<Translation>;
  /** The shop policy type. */
  readonly type: ShopPolicyType;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the policy was last modified. */
  readonly updatedAt: Scalars['Date'];
  /** The public URL of the policy. */
  readonly url: Scalars['URL'];
};


/** Policy that a merchant has configured for their store, such as their refund or privacy policy. */
export type ShopPolicyTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
};

/** Possible error codes that can be returned by `ShopPolicyUserError`. */
export enum ShopPolicyErrorCode {
  /** The input value is too big. */
  TOO_BIG = 'TOO_BIG'
}

/** The input fields required to update a policy. */
export type ShopPolicyInput = {
  /** Policy text, maximum size of 512kb. */
  readonly body: Scalars['String'];
  /** The shop policy type. */
  readonly type: ShopPolicyType;
};

/** Available shop policy types. */
export enum ShopPolicyType {
  /** The contact information. */
  CONTACT_INFORMATION = 'CONTACT_INFORMATION',
  /** The legal notice. */
  LEGAL_NOTICE = 'LEGAL_NOTICE',
  /** The privacy policy. */
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  /** The refund policy. */
  REFUND_POLICY = 'REFUND_POLICY',
  /** The shipping policy. */
  SHIPPING_POLICY = 'SHIPPING_POLICY',
  /** The cancellation policy. */
  SUBSCRIPTION_POLICY = 'SUBSCRIPTION_POLICY',
  /** The terms of sale. */
  TERMS_OF_SALE = 'TERMS_OF_SALE',
  /** The terms of service. */
  TERMS_OF_SERVICE = 'TERMS_OF_SERVICE'
}

/** Return type for `shopPolicyUpdate` mutation. */
export type ShopPolicyUpdatePayload = {
  /** The shop policy that has been updated. */
  readonly shopPolicy?: Maybe<ShopPolicy>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ShopPolicyUserError>;
};

/** An error that occurs during the execution of a shop policy mutation. */
export type ShopPolicyUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ShopPolicyErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Return type for `shopResourceFeedbackCreate` mutation. */
export type ShopResourceFeedbackCreatePayload = {
  /** The shop feedback that's created. */
  readonly feedback?: Maybe<AppFeedback>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ShopResourceFeedbackCreateUserError>;
};

/** An error that occurs during the execution of `ShopResourceFeedbackCreate`. */
export type ShopResourceFeedbackCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ShopResourceFeedbackCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ShopResourceFeedbackCreateUserError`. */
export enum ShopResourceFeedbackCreateUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The feedback date cannot be set in the future. */
  FEEDBACK_DATE_IN_FUTURE = 'FEEDBACK_DATE_IN_FUTURE',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The feedback for a later version of the resource was already accepted. */
  OUTDATED_FEEDBACK = 'OUTDATED_FEEDBACK',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT'
}

/** Resource limits of a shop. */
export type ShopResourceLimits = {
  /** Maximum number of locations allowed. */
  readonly locationLimit: Scalars['Int'];
  /** Maximum number of product options allowed. */
  readonly maxProductOptions: Scalars['Int'];
  /** The maximum number of variants allowed per product. */
  readonly maxProductVariants: Scalars['Int'];
  /** Whether the shop has reached the limit of the number of URL redirects it can make for resources. */
  readonly redirectLimitReached: Scalars['Boolean'];
};

/** Possible sort of tags. */
export enum ShopTagSort {
  /** Alphabetical sort. */
  ALPHABETICAL = 'ALPHABETICAL',
  /** Popularity sort. */
  POPULAR = 'POPULAR'
}

/** A Shopify Function. */
export type ShopifyFunction = {
  /** The API type of the Shopify Function. */
  readonly apiType: Scalars['String'];
  /** The API version of the Shopify Function. */
  readonly apiVersion: Scalars['String'];
  /** The app that owns the Shopify Function. */
  readonly app: App;
  /** The App Bridge information for the Shopify Function. */
  readonly appBridge: FunctionsAppBridge;
  /** The client ID of the app that owns the Shopify Function. */
  readonly appKey: Scalars['String'];
  /** The description of the Shopify Function. */
  readonly description?: Maybe<Scalars['String']>;
  /** The ID of the Shopify Function. */
  readonly id: Scalars['String'];
  /** The input query of the Shopify Function. */
  readonly inputQuery?: Maybe<Scalars['String']>;
  /** The title of the Shopify Function. */
  readonly title: Scalars['String'];
  /** If the Shopify Function uses the creation UI in the Admin. */
  readonly useCreationUi: Scalars['Boolean'];
};

/** An auto-generated type for paginating through multiple ShopifyFunctions. */
export type ShopifyFunctionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ShopifyFunctionEdge>;
  /** A list of nodes that are contained in ShopifyFunctionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ShopifyFunction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyFunction and a cursor during pagination. */
export type ShopifyFunctionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ShopifyFunctionEdge. */
  readonly node: ShopifyFunction;
};

/**
 * Balance and payout information for a
 * [Shopify Payments](https://help.shopify.com/manual/payments/shopify-payments/getting-paid-with-shopify-payments)
 * account. Balance includes all balances for the currencies supported by the shop.
 * You can also query for a list of payouts, where each payout includes the corresponding currencyCode field.
 */
export type ShopifyPaymentsAccount = Node & {
  /** Whether the Shopify Payments setup is completed. */
  readonly activated: Scalars['Boolean'];
  /** Current balances in all currencies for the account. */
  readonly balance: ReadonlyArray<MoneyV2>;
  /** A list of balance transactions associated with the shop. */
  readonly balanceTransactions: ShopifyPaymentsBalanceTransactionConnection;
  /** All bank accounts configured for the Shopify Payments account. */
  readonly bankAccounts: ShopifyPaymentsBankAccountConnection;
  /**
   * The statement descriptor used for charges.
   *
   * The statement descriptor appears on a customer's credit card or bank statement when they make a purchase.
   * @deprecated Use `chargeStatementDescriptors` instead.
   */
  readonly chargeStatementDescriptor?: Maybe<Scalars['String']>;
  /**
   * The statement descriptors used for charges.
   *
   * These descriptors appear on a customer's credit card or bank statement when they make a purchase.
   */
  readonly chargeStatementDescriptors?: Maybe<ShopifyPaymentsChargeStatementDescriptor>;
  /** The Shopify Payments account country. */
  readonly country: Scalars['String'];
  /** The default payout currency for the Shopify Payments account. */
  readonly defaultCurrency: CurrencyCode;
  /** All disputes that originated from a transaction made with the Shopify Payments account. */
  readonly disputes: ShopifyPaymentsDisputeConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Whether the Shopify Payments account can be onboarded. */
  readonly onboardable: Scalars['Boolean'];
  /** The payout schedule for the account. */
  readonly payoutSchedule: ShopifyPaymentsPayoutSchedule;
  /**
   * The descriptor used for payouts.
   *
   * The descriptor appears on a merchant's bank statement when they receive a payout.
   */
  readonly payoutStatementDescriptor?: Maybe<Scalars['String']>;
  /** All current and previous payouts made between the account and the bank account. */
  readonly payouts: ShopifyPaymentsPayoutConnection;
};


/**
 * Balance and payout information for a
 * [Shopify Payments](https://help.shopify.com/manual/payments/shopify-payments/getting-paid-with-shopify-payments)
 * account. Balance includes all balances for the currencies supported by the shop.
 * You can also query for a list of payouts, where each payout includes the corresponding currencyCode field.
 */
export type ShopifyPaymentsAccountBalanceTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hideTransfers?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<BalanceTransactionSortKeys>;
};


/**
 * Balance and payout information for a
 * [Shopify Payments](https://help.shopify.com/manual/payments/shopify-payments/getting-paid-with-shopify-payments)
 * account. Balance includes all balances for the currencies supported by the shop.
 * You can also query for a list of payouts, where each payout includes the corresponding currencyCode field.
 */
export type ShopifyPaymentsAccountBankAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Balance and payout information for a
 * [Shopify Payments](https://help.shopify.com/manual/payments/shopify-payments/getting-paid-with-shopify-payments)
 * account. Balance includes all balances for the currencies supported by the shop.
 * You can also query for a list of payouts, where each payout includes the corresponding currencyCode field.
 */
export type ShopifyPaymentsAccountDisputesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/**
 * Balance and payout information for a
 * [Shopify Payments](https://help.shopify.com/manual/payments/shopify-payments/getting-paid-with-shopify-payments)
 * account. Balance includes all balances for the currencies supported by the shop.
 * You can also query for a list of payouts, where each payout includes the corresponding currencyCode field.
 */
export type ShopifyPaymentsAccountPayoutsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<PayoutSortKeys>;
  transactionType?: InputMaybe<ShopifyPaymentsPayoutTransactionType>;
};

/** The adjustment order object. */
export type ShopifyPaymentsAdjustmentOrder = {
  /** The amount of the adjustment order. */
  readonly amount: MoneyV2;
  /** The link to the adjustment order. */
  readonly link: Scalars['URL'];
  /** The name of the adjustment order. */
  readonly name: Scalars['String'];
  /** The ID of the order transaction. */
  readonly orderTransactionId: Scalars['BigInt'];
};

/** The order associated to the balance transaction. */
export type ShopifyPaymentsAssociatedOrder = {
  /** The ID of the associated order. */
  readonly id: Scalars['ID'];
  /** The name of the associated order. */
  readonly name: Scalars['String'];
};

/** A transaction that contributes to a Shopify Payments account balance. */
export type ShopifyPaymentsBalanceTransaction = Node & {
  /**
   * The reason for the adjustment that's associated with the transaction.
   *             If the source_type isn't an adjustment, the value will be null.
   */
  readonly adjustmentReason?: Maybe<Scalars['String']>;
  /** The adjustment orders associated to the transaction. */
  readonly adjustmentsOrders: ReadonlyArray<ShopifyPaymentsAdjustmentOrder>;
  /** The amount contributing to the balance transaction. */
  readonly amount: MoneyV2;
  /** The associated order for the balance transaction. */
  readonly associatedOrder?: Maybe<ShopifyPaymentsAssociatedOrder>;
  /** Payout assoicated with the transaction. */
  readonly associatedPayout: ShopifyPaymentsBalanceTransactionAssociatedPayout;
  /** The fee amount contributing to the balance transaction. */
  readonly fee: MoneyV2;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The net amount contributing to the merchant's balance. */
  readonly net: MoneyV2;
  /** The ID of the resource leading to the transaction. */
  readonly sourceId?: Maybe<Scalars['BigInt']>;
  /**
   * The id of the
   *             [Order Transaction](https://shopify.dev/docs/admin-api/rest/reference/orders/transaction)
   *
   *             that resulted in this balance transaction.
   */
  readonly sourceOrderTransactionId?: Maybe<Scalars['BigInt']>;
  /** The source type of the balance transaction. */
  readonly sourceType?: Maybe<ShopifyPaymentsSourceType>;
  /** Wether the tranaction was created in test mode. */
  readonly test: Scalars['Boolean'];
  /** The date and time when the balance transaction was processed. */
  readonly transactionDate: Scalars['DateTime'];
  /** The type of transaction. */
  readonly type: ShopifyPaymentsTransactionType;
};

/** The payout associated with a balance transaction. */
export type ShopifyPaymentsBalanceTransactionAssociatedPayout = {
  /** The ID of the payout associated with the balance transaction. */
  readonly id?: Maybe<Scalars['ID']>;
  /** The status of the payout associated with the balance transaction. */
  readonly status?: Maybe<ShopifyPaymentsBalanceTransactionPayoutStatus>;
};

/** An auto-generated type for paginating through multiple ShopifyPaymentsBalanceTransactions. */
export type ShopifyPaymentsBalanceTransactionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ShopifyPaymentsBalanceTransactionEdge>;
  /** A list of nodes that are contained in ShopifyPaymentsBalanceTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ShopifyPaymentsBalanceTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyPaymentsBalanceTransaction and a cursor during pagination. */
export type ShopifyPaymentsBalanceTransactionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ShopifyPaymentsBalanceTransactionEdge. */
  readonly node: ShopifyPaymentsBalanceTransaction;
};

/** The payout status of the balance transaction. */
export enum ShopifyPaymentsBalanceTransactionPayoutStatus {
  /** The transaction requires action before it can be paid out. */
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  /** The payout has been canceled by Shopify. */
  CANCELED = 'CANCELED',
  /** The payout has been declined by the bank. */
  FAILED = 'FAILED',
  /** The payout has been submitted to the bank. */
  IN_TRANSIT = 'IN_TRANSIT',
  /** The payout has been successfully deposited into the bank. */
  PAID = 'PAID',
  /** The transaction has not been assigned a payout yet. */
  PENDING = 'PENDING',
  /**
   * The payout has been created and had transactions assigned to it, but
   * it has not yet been submitted to the bank.
   */
  SCHEDULED = 'SCHEDULED'
}

/** A bank account that can receive payouts. */
export type ShopifyPaymentsBankAccount = Node & {
  /** The account number of the bank account. */
  readonly accountNumber: Scalars['String'];
  /** The last digits of the account number (the rest is redacted). */
  readonly accountNumberLastDigits: Scalars['String'];
  /** The name of the bank. */
  readonly bankName?: Maybe<Scalars['String']>;
  /** The country of the bank. */
  readonly country: CountryCode;
  /** The date that the bank account was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The currency of the bank account. */
  readonly currency: CurrencyCode;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** All current and previous payouts made between the account and the bank account. */
  readonly payouts: ShopifyPaymentsPayoutConnection;
  /** The routing number of the bank account. */
  readonly routingNumber: Scalars['String'];
  /** The status of the bank account. */
  readonly status: ShopifyPaymentsBankAccountStatus;
};


/** A bank account that can receive payouts. */
export type ShopifyPaymentsBankAccountPayoutsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  savedSearchId?: InputMaybe<Scalars['ID']>;
  sortKey?: InputMaybe<PayoutSortKeys>;
  transactionType?: InputMaybe<ShopifyPaymentsPayoutTransactionType>;
};

/** An auto-generated type for paginating through multiple ShopifyPaymentsBankAccounts. */
export type ShopifyPaymentsBankAccountConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ShopifyPaymentsBankAccountEdge>;
  /** A list of nodes that are contained in ShopifyPaymentsBankAccountEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ShopifyPaymentsBankAccount>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyPaymentsBankAccount and a cursor during pagination. */
export type ShopifyPaymentsBankAccountEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ShopifyPaymentsBankAccountEdge. */
  readonly node: ShopifyPaymentsBankAccount;
};

/** The bank account status. */
export enum ShopifyPaymentsBankAccountStatus {
  /** A payout to the bank account failed. */
  ERRORED = 'ERRORED',
  /** A bank account that hasn't had any activity and that's not validated. */
  NEW = 'NEW',
  /** It was determined that the bank account exists. */
  VALIDATED = 'VALIDATED',
  /** Bank account validation was successful. */
  VERIFIED = 'VERIFIED'
}

/** The charge descriptors for a payments account. */
export type ShopifyPaymentsChargeStatementDescriptor = {
  /** The default charge statement descriptor. */
  readonly default?: Maybe<Scalars['String']>;
  /** The prefix of the statement descriptor. */
  readonly prefix: Scalars['String'];
};

/** The charge descriptors for a payments account. */
export type ShopifyPaymentsDefaultChargeStatementDescriptor = ShopifyPaymentsChargeStatementDescriptor & {
  /** The default charge statement descriptor. */
  readonly default?: Maybe<Scalars['String']>;
  /** The prefix of the statement descriptor. */
  readonly prefix: Scalars['String'];
};

/** A dispute occurs when a buyer questions the legitimacy of a charge with their financial institution. */
export type ShopifyPaymentsDispute = LegacyInteroperability & Node & {
  /** The total amount disputed by the cardholder. */
  readonly amount: MoneyV2;
  /** The deadline for evidence submission. */
  readonly evidenceDueBy?: Maybe<Scalars['Date']>;
  /** The date when evidence was sent. Returns null if evidence hasn't yet been sent. */
  readonly evidenceSentOn?: Maybe<Scalars['Date']>;
  /** The date when this dispute was resolved. Returns null if the dispute isn't yet resolved. */
  readonly finalizedOn?: Maybe<Scalars['Date']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The date when this dispute was initiated. */
  readonly initiatedAt: Scalars['DateTime'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The order that contains the charge that's under dispute. */
  readonly order?: Maybe<Order>;
  /** The reason of the dispute. */
  readonly reasonDetails: ShopifyPaymentsDisputeReasonDetails;
  /** The current state of the dispute. */
  readonly status: DisputeStatus;
  /** Indicates if this dispute is still in the inquiry phase or has turned into a chargeback. */
  readonly type: DisputeType;
};

/** An auto-generated type for paginating through multiple ShopifyPaymentsDisputes. */
export type ShopifyPaymentsDisputeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ShopifyPaymentsDisputeEdge>;
  /** A list of nodes that are contained in ShopifyPaymentsDisputeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ShopifyPaymentsDispute>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyPaymentsDispute and a cursor during pagination. */
export type ShopifyPaymentsDisputeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ShopifyPaymentsDisputeEdge. */
  readonly node: ShopifyPaymentsDispute;
};

/** The evidence associated with the dispute. */
export type ShopifyPaymentsDisputeEvidence = Node & {
  /** The activity logs associated with the dispute evidence. */
  readonly accessActivityLog?: Maybe<Scalars['String']>;
  /** The billing address that's provided by the customer. */
  readonly billingAddress?: Maybe<MailingAddress>;
  /** The cancellation policy disclosure associated with the dispute evidence. */
  readonly cancellationPolicyDisclosure?: Maybe<Scalars['String']>;
  /** The cancellation policy file associated with the dispute evidence. */
  readonly cancellationPolicyFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The cancellation rebuttal associated with the dispute evidence. */
  readonly cancellationRebuttal?: Maybe<Scalars['String']>;
  /** The customer communication file associated with the dispute evidence. */
  readonly customerCommunicationFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The customer's email address. */
  readonly customerEmailAddress?: Maybe<Scalars['String']>;
  /** The customer's first name. */
  readonly customerFirstName?: Maybe<Scalars['String']>;
  /** The customer's last name. */
  readonly customerLastName?: Maybe<Scalars['String']>;
  /** The customer purchase ip for this dispute evidence. */
  readonly customerPurchaseIp?: Maybe<Scalars['String']>;
  /** The dispute associated with the evidence. */
  readonly dispute: ShopifyPaymentsDispute;
  /** The file uploads associated with the dispute evidence. */
  readonly disputeFileUploads: ReadonlyArray<ShopifyPaymentsDisputeFileUpload>;
  /** The fulfillments associated with the dispute evidence. */
  readonly fulfillments: ReadonlyArray<ShopifyPaymentsDisputeFulfillment>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The product description for this dispute evidence. */
  readonly productDescription?: Maybe<Scalars['String']>;
  /** The refund policy disclosure associated with the dispute evidence. */
  readonly refundPolicyDisclosure?: Maybe<Scalars['String']>;
  /** The refund policy file associated with the dispute evidence. */
  readonly refundPolicyFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The refund refusal explanation associated with dispute evidence. */
  readonly refundRefusalExplanation?: Maybe<Scalars['String']>;
  /** The service documentation file associated with the dispute evidence. */
  readonly serviceDocumentationFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The mailing address for shipping that's provided by the customer. */
  readonly shippingAddress?: Maybe<MailingAddress>;
  /** The shipping documentation file associated with the dispute evidence. */
  readonly shippingDocumentationFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** Whether the dispute evidence is submitted. */
  readonly submitted: Scalars['Boolean'];
  /** The uncategorized file associated with the dispute evidence. */
  readonly uncategorizedFile?: Maybe<ShopifyPaymentsDisputeFileUpload>;
  /** The uncategorized text for the dispute evidence. */
  readonly uncategorizedText?: Maybe<Scalars['String']>;
};

/** The possible dispute evidence file types. */
export enum ShopifyPaymentsDisputeEvidenceFileType {
  /** Cancellation Policy File. */
  CANCELLATION_POLICY_FILE = 'CANCELLATION_POLICY_FILE',
  /** Customer Communication File. */
  CUSTOMER_COMMUNICATION_FILE = 'CUSTOMER_COMMUNICATION_FILE',
  /** Refund Policy File. */
  REFUND_POLICY_FILE = 'REFUND_POLICY_FILE',
  /** Service Documentation File. */
  SERVICE_DOCUMENTATION_FILE = 'SERVICE_DOCUMENTATION_FILE',
  /** Shipping Documentation File. */
  SHIPPING_DOCUMENTATION_FILE = 'SHIPPING_DOCUMENTATION_FILE',
  /** Uncategorized File. */
  UNCATEGORIZED_FILE = 'UNCATEGORIZED_FILE'
}

/** The input fields required to update a dispute evidence object. */
export type ShopifyPaymentsDisputeEvidenceUpdateInput = {
  /** Activity logs. */
  readonly accessActivityLog?: InputMaybe<Scalars['String']>;
  /** Cancellation policy disclosure. */
  readonly cancellationPolicyDisclosure?: InputMaybe<Scalars['String']>;
  /** Cancellation policy file. */
  readonly cancellationPolicyFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Cancellation rebuttal. */
  readonly cancellationRebuttal?: InputMaybe<Scalars['String']>;
  /** Customer communication file. */
  readonly customerCommunicationFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Customer email address. */
  readonly customerEmailAddress?: InputMaybe<Scalars['String']>;
  /** Customer first name. */
  readonly customerFirstName?: InputMaybe<Scalars['String']>;
  /** Customer last name. */
  readonly customerLastName?: InputMaybe<Scalars['String']>;
  /** Refund policy disclosure. */
  readonly refundPolicyDisclosure?: InputMaybe<Scalars['String']>;
  /** Refund policy file. */
  readonly refundPolicyFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Refund refusal explanation. */
  readonly refundRefusalExplanation?: InputMaybe<Scalars['String']>;
  /** Service documentation file. */
  readonly serviceDocumentationFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** The shipping address associated with the dispute evidence. */
  readonly shippingAddress?: InputMaybe<MailingAddressInput>;
  /** Shipping documentation file. */
  readonly shippingDocumentationFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Whether to submit the evidence. */
  readonly submitEvidence?: InputMaybe<Scalars['Boolean']>;
  /** Uncategorized file. */
  readonly uncategorizedFile?: InputMaybe<ShopifyPaymentsDisputeFileUploadUpdateInput>;
  /** Uncategorized text. */
  readonly uncategorizedText?: InputMaybe<Scalars['String']>;
};

/** The file upload associated with the dispute evidence. */
export type ShopifyPaymentsDisputeFileUpload = Node & {
  /** The type of the file for the dispute evidence. */
  readonly disputeEvidenceType?: Maybe<ShopifyPaymentsDisputeEvidenceFileType>;
  /** The file size. */
  readonly fileSize: Scalars['Int'];
  /** The file type. */
  readonly fileType: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The original file name. */
  readonly originalFileName?: Maybe<Scalars['String']>;
  /** The URL for accessing the file. */
  readonly url: Scalars['URL'];
};

/** The input fields required to update a dispute file upload object. */
export type ShopifyPaymentsDisputeFileUploadUpdateInput = {
  /** Whether to delete this file upload. */
  readonly destroy?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the file upload to be updated. */
  readonly id: Scalars['ID'];
};

/** The fulfillment associated with dispute evidence. */
export type ShopifyPaymentsDisputeFulfillment = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The shipping carrier for this fulfillment. */
  readonly shippingCarrier?: Maybe<Scalars['String']>;
  /** The shipping date for this fulfillment. */
  readonly shippingDate?: Maybe<Scalars['Date']>;
  /** The shipping tracking number for this fulfillment. */
  readonly shippingTrackingNumber?: Maybe<Scalars['String']>;
};

/** The reason for the dispute provided by the cardholder's bank. */
export enum ShopifyPaymentsDisputeReason {
  /** The customer's bank can't process the charge. */
  BANK_CANNOT_PROCESS = 'BANK_CANNOT_PROCESS',
  /** The customer claims that the purchased product was returned or the transaction was otherwise canceled, but you haven't yet provided a refund or credit. */
  CREDIT_NOT_PROCESSED = 'CREDIT_NOT_PROCESSED',
  /** The customer initiated the dispute. Contact the customer for additional details on why the payment was disputed. */
  CUSTOMER_INITIATED = 'CUSTOMER_INITIATED',
  /** The customer's bank can't proceed with the debit since it hasn't been authorized. */
  DEBIT_NOT_AUTHORIZED = 'DEBIT_NOT_AUTHORIZED',
  /** The customer claims they were charged multiple times for the same product or service. */
  DUPLICATE = 'DUPLICATE',
  /** The cardholder claims that they didn’t authorize the payment. */
  FRAUDULENT = 'FRAUDULENT',
  /** The dispute is uncategorized, so you should contact the customer for additional details to find out why the payment was disputed. */
  GENERAL = 'GENERAL',
  /** The customer account associated with the purchase is incorrect. */
  INCORRECT_ACCOUNT_DETAILS = 'INCORRECT_ACCOUNT_DETAILS',
  /** The customer's bank account has insufficient funds. */
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  /** The customer claims they did not receive the products or services purchased. */
  PRODUCT_NOT_RECEIVED = 'PRODUCT_NOT_RECEIVED',
  /** The product or service was received but was defective, damaged, or not as described. */
  PRODUCT_UNACCEPTABLE = 'PRODUCT_UNACCEPTABLE',
  /** The customer claims that you continued to charge them after a subscription was canceled. */
  SUBSCRIPTION_CANCELLED = 'SUBSCRIPTION_CANCELLED',
  /** The customer doesn’t recognize the payment appearing on their card statement. */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** Details regarding a dispute reason. */
export type ShopifyPaymentsDisputeReasonDetails = {
  /** The raw code provided by the payment network. */
  readonly networkReasonCode?: Maybe<Scalars['String']>;
  /** The reason for the dispute provided by the cardholder's banks. */
  readonly reason: ShopifyPaymentsDisputeReason;
};

/** Presents all Shopify Payments information related to an extended authorization. */
export type ShopifyPaymentsExtendedAuthorization = {
  /** The time after which the extended authorization expires. After the expiry, the merchant is unable to capture the payment. */
  readonly extendedAuthorizationExpiresAt: Scalars['DateTime'];
  /** The time after which capture will incur an additional fee. */
  readonly standardAuthorizationExpiresAt: Scalars['DateTime'];
};

/** The charge descriptors for a Japanese payments account. */
export type ShopifyPaymentsJpChargeStatementDescriptor = ShopifyPaymentsChargeStatementDescriptor & {
  /** The default charge statement descriptor. */
  readonly default?: Maybe<Scalars['String']>;
  /** The charge statement descriptor in kana. */
  readonly kana?: Maybe<Scalars['String']>;
  /** The charge statement descriptor in kanji. */
  readonly kanji?: Maybe<Scalars['String']>;
  /** The prefix of the statement descriptor. */
  readonly prefix: Scalars['String'];
};

/**
 * Payouts represent the movement of money between a merchant's Shopify
 * Payments balance and their bank account.
 */
export type ShopifyPaymentsPayout = LegacyInteroperability & Node & {
  /**
   * The bank account for the payout.
   * @deprecated Use `destinationAccount` instead.
   */
  readonly bankAccount?: Maybe<ShopifyPaymentsBankAccount>;
  /** The business entity associated with the payout. */
  readonly businessEntity: BusinessEntity;
  /**
   * The total amount and currency of the payout.
   * @deprecated Use `net` instead.
   */
  readonly gross: MoneyV2;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The exact time when the payout was issued. The payout only contains
   * balance transactions that were available at this time.
   */
  readonly issuedAt: Scalars['DateTime'];
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The total amount and currency of the payout. */
  readonly net: MoneyV2;
  /** The transfer status of the payout. */
  readonly status: ShopifyPaymentsPayoutStatus;
  /** The summary of the payout. */
  readonly summary: ShopifyPaymentsPayoutSummary;
  /** The direction of the payout. */
  readonly transactionType: ShopifyPaymentsPayoutTransactionType;
};

/** Return type for `shopifyPaymentsPayoutAlternateCurrencyCreate` mutation. */
export type ShopifyPaymentsPayoutAlternateCurrencyCreatePayload = {
  /** The resulting alternate currency payout created. */
  readonly payout?: Maybe<ShopifyPaymentsToolingProviderPayout>;
  /** Whether the alternate currency payout was created successfully. */
  readonly success?: Maybe<Scalars['Boolean']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ShopifyPaymentsPayoutAlternateCurrencyCreateUserError>;
};

/** An error that occurs during the execution of `ShopifyPaymentsPayoutAlternateCurrencyCreate`. */
export type ShopifyPaymentsPayoutAlternateCurrencyCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ShopifyPaymentsPayoutAlternateCurrencyCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ShopifyPaymentsPayoutAlternateCurrencyCreateUserError`. */
export enum ShopifyPaymentsPayoutAlternateCurrencyCreateUserErrorCode {
  /** Failed to create payout, there is no eligible balance in this currency. */
  ALTERNATE_CURRENCY_PAYOUT_FAILED_NO_ELIGIBLE_BALANCE = 'ALTERNATE_CURRENCY_PAYOUT_FAILED_NO_ELIGIBLE_BALANCE',
  /** Failed to create payout due to an error from Stripe. */
  ALTERNATE_CURRENCY_PAYOUT_FAILED_STRIPE_ERROR = 'ALTERNATE_CURRENCY_PAYOUT_FAILED_STRIPE_ERROR',
  /** No Stripe provider account was found. */
  MISSING_PROVIDER_ACCOUNT = 'MISSING_PROVIDER_ACCOUNT',
  /** Failed to create payout due to an error from Shopify Core. */
  UNKNOWN_CORE_ERROR = 'UNKNOWN_CORE_ERROR'
}

/** An auto-generated type for paginating through multiple ShopifyPaymentsPayouts. */
export type ShopifyPaymentsPayoutConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ShopifyPaymentsPayoutEdge>;
  /** A list of nodes that are contained in ShopifyPaymentsPayoutEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<ShopifyPaymentsPayout>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one ShopifyPaymentsPayout and a cursor during pagination. */
export type ShopifyPaymentsPayoutEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ShopifyPaymentsPayoutEdge. */
  readonly node: ShopifyPaymentsPayout;
};

/** The interval at which payouts are sent to the connected bank account. */
export enum ShopifyPaymentsPayoutInterval {
  /** Each business day. */
  DAILY = 'DAILY',
  /** Payouts will not be automatically made. */
  MANUAL = 'MANUAL',
  /** Each month, on the day of month specified by monthlyAnchor. */
  MONTHLY = 'MONTHLY',
  /** Each week, on the day of week specified by weeklyAnchor. */
  WEEKLY = 'WEEKLY'
}

/** The payment schedule for a payments account. */
export type ShopifyPaymentsPayoutSchedule = {
  /** The interval at which payouts are sent to the connected bank account. */
  readonly interval: ShopifyPaymentsPayoutInterval;
  /**
   * The day of the month funds will be paid out.
   *
   * The value can be any day of the month from the 1st to the 31st.
   * If the payment interval is set to monthly, this value will be used.
   * Payouts scheduled between 29-31st of the month are sent on the last day of shorter months.
   */
  readonly monthlyAnchor?: Maybe<Scalars['Int']>;
  /**
   * The day of the week funds will be paid out.
   *
   * The value can be any weekday from Monday to Friday.
   * If the payment interval is set to weekly, this value will be used.
   */
  readonly weeklyAnchor?: Maybe<DayOfTheWeek>;
};

/** The transfer status of the payout. */
export enum ShopifyPaymentsPayoutStatus {
  /** The payout has been canceled by Shopify. */
  CANCELED = 'CANCELED',
  /** The payout has been declined by the bank. */
  FAILED = 'FAILED',
  /** The payout has been submitted to the bank. */
  IN_TRANSIT = 'IN_TRANSIT',
  /** The payout has been successfully deposited into the bank. */
  PAID = 'PAID',
  /**
   * The payout has been created and had transactions assigned to it, but
   * it has not yet been submitted to the bank.
   */
  SCHEDULED = 'SCHEDULED'
}

/**
 * Breakdown of the total fees and gross of each of the different types of transactions associated
 * with the payout.
 */
export type ShopifyPaymentsPayoutSummary = {
  /** Total fees for all adjustments including disputes. */
  readonly adjustmentsFee: MoneyV2;
  /** Total gross amount for all adjustments including disputes. */
  readonly adjustmentsGross: MoneyV2;
  /** Total fees for all advances. */
  readonly advanceFees: MoneyV2;
  /** Total gross amount for all advances. */
  readonly advanceGross: MoneyV2;
  /** Total fees for all charges. */
  readonly chargesFee: MoneyV2;
  /** Total gross amount for all charges. */
  readonly chargesGross: MoneyV2;
  /** Total fees for all refunds. */
  readonly refundsFee: MoneyV2;
  /** Total gross amount for all refunds. */
  readonly refundsFeeGross: MoneyV2;
  /** Total fees for all reserved funds. */
  readonly reservedFundsFee: MoneyV2;
  /** Total gross amount for all reserved funds. */
  readonly reservedFundsGross: MoneyV2;
  /** Total fees for all retried payouts. */
  readonly retriedPayoutsFee: MoneyV2;
  /** Total gross amount for all retried payouts. */
  readonly retriedPayoutsGross: MoneyV2;
};

/** The possible transaction types for a payout. */
export enum ShopifyPaymentsPayoutTransactionType {
  /** The payout is a deposit. */
  DEPOSIT = 'DEPOSIT',
  /** The payout is a withdrawal. */
  WITHDRAWAL = 'WITHDRAWAL'
}

/** Presents all Shopify Payments specific information related to an order refund. */
export type ShopifyPaymentsRefundSet = {
  /** The acquirer reference number (ARN) code generated for Visa/Mastercard transactions. */
  readonly acquirerReferenceNumber?: Maybe<Scalars['String']>;
};

/** The possible source types for a balance transaction. */
export enum ShopifyPaymentsSourceType {
  /** The adjustment source type. */
  ADJUSTMENT = 'ADJUSTMENT',
  /** The adjustment_reversal source type. */
  ADJUSTMENT_REVERSAL = 'ADJUSTMENT_REVERSAL',
  /** The charge source type. */
  CHARGE = 'CHARGE',
  /** The dispute source type. */
  DISPUTE = 'DISPUTE',
  /** The refund source type. */
  REFUND = 'REFUND',
  /** The system_adjustment source type. */
  SYSTEM_ADJUSTMENT = 'SYSTEM_ADJUSTMENT',
  /** The transfer source type. */
  TRANSFER = 'TRANSFER'
}

/** Relevant reference information for an alternate currency payout. */
export type ShopifyPaymentsToolingProviderPayout = {
  /** The balance amount the alternate currency payout was created for. */
  readonly amount: MoneyV2;
  /** A timestamp for the arrival of the alternate currency payout. */
  readonly arrivalDate?: Maybe<Scalars['DateTime']>;
  /** A timestamp for the creation of the alternate currency payout. */
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  /** The currency alternate currency payout was created in. */
  readonly currency: Scalars['String'];
  /** The remote ID for the alternate currency payout. */
  readonly remoteId: Scalars['String'];
};

/** Presents all Shopify Payments specific information related to an order transaction. */
export type ShopifyPaymentsTransactionSet = {
  /** Contains all fields related to an extended authorization. */
  readonly extendedAuthorizationSet?: Maybe<ShopifyPaymentsExtendedAuthorization>;
  /** Contains all fields related to a refund. */
  readonly refundSet?: Maybe<ShopifyPaymentsRefundSet>;
};

/** The possible types of transactions. */
export enum ShopifyPaymentsTransactionType {
  /** The adjustment transaction type. */
  ADJUSTMENT = 'ADJUSTMENT',
  /** The advance transaction type. */
  ADVANCE = 'ADVANCE',
  /** The advance funding transaction type. */
  ADVANCE_FUNDING = 'ADVANCE_FUNDING',
  /** The anomaly_credit transaction type. */
  ANOMALY_CREDIT = 'ANOMALY_CREDIT',
  /** The anomaly_credit_reversal transaction type. */
  ANOMALY_CREDIT_REVERSAL = 'ANOMALY_CREDIT_REVERSAL',
  /** The anomaly_debit transaction type. */
  ANOMALY_DEBIT = 'ANOMALY_DEBIT',
  /** The anomaly_debit_reversal transaction type. */
  ANOMALY_DEBIT_REVERSAL = 'ANOMALY_DEBIT_REVERSAL',
  /** The application_fee_refund transaction type. */
  APPLICATION_FEE_REFUND = 'APPLICATION_FEE_REFUND',
  /** The balance_transfer_inbound transaction type. */
  BALANCE_TRANSFER_INBOUND = 'BALANCE_TRANSFER_INBOUND',
  /** The billing_debit transaction type. */
  BILLING_DEBIT = 'BILLING_DEBIT',
  /** The billing_debit_reversal transaction type. */
  BILLING_DEBIT_REVERSAL = 'BILLING_DEBIT_REVERSAL',
  /** The channel_credit transaction type. */
  CHANNEL_CREDIT = 'CHANNEL_CREDIT',
  /** The channel_credit_reversal transaction type. */
  CHANNEL_CREDIT_REVERSAL = 'CHANNEL_CREDIT_REVERSAL',
  /** The channel_promotion_credit transaction type. */
  CHANNEL_PROMOTION_CREDIT = 'CHANNEL_PROMOTION_CREDIT',
  /** The channel_promotion_credit_reversal transaction type. */
  CHANNEL_PROMOTION_CREDIT_REVERSAL = 'CHANNEL_PROMOTION_CREDIT_REVERSAL',
  /** The channel_transfer_credit transaction type. */
  CHANNEL_TRANSFER_CREDIT = 'CHANNEL_TRANSFER_CREDIT',
  /** The channel_transfer_credit_reversal transaction type. */
  CHANNEL_TRANSFER_CREDIT_REVERSAL = 'CHANNEL_TRANSFER_CREDIT_REVERSAL',
  /** The channel_transfer_debit transaction type. */
  CHANNEL_TRANSFER_DEBIT = 'CHANNEL_TRANSFER_DEBIT',
  /** The channel_transfer_debit_reversal transaction type. */
  CHANNEL_TRANSFER_DEBIT_REVERSAL = 'CHANNEL_TRANSFER_DEBIT_REVERSAL',
  /** The charge transaction type. */
  CHARGE = 'CHARGE',
  /** The chargeback_fee transaction type. */
  CHARGEBACK_FEE = 'CHARGEBACK_FEE',
  /** The chargeback_fee_refund transaction type. */
  CHARGEBACK_FEE_REFUND = 'CHARGEBACK_FEE_REFUND',
  /** The chargeback_hold transaction type. */
  CHARGEBACK_HOLD = 'CHARGEBACK_HOLD',
  /** The chargeback_hold_release transaction type. */
  CHARGEBACK_HOLD_RELEASE = 'CHARGEBACK_HOLD_RELEASE',
  /** The chargeback_protection_credit transaction type. */
  CHARGEBACK_PROTECTION_CREDIT = 'CHARGEBACK_PROTECTION_CREDIT',
  /** The chargeback_protection_credit_reversal transaction type. */
  CHARGEBACK_PROTECTION_CREDIT_REVERSAL = 'CHARGEBACK_PROTECTION_CREDIT_REVERSAL',
  /** The chargeback_protection_debit transaction type. */
  CHARGEBACK_PROTECTION_DEBIT = 'CHARGEBACK_PROTECTION_DEBIT',
  /** The chargeback_protection_debit_reversal transaction type. */
  CHARGEBACK_PROTECTION_DEBIT_REVERSAL = 'CHARGEBACK_PROTECTION_DEBIT_REVERSAL',
  /** The charge_adjustment transaction type. */
  CHARGE_ADJUSTMENT = 'CHARGE_ADJUSTMENT',
  /** The collections_credit transaction type. */
  COLLECTIONS_CREDIT = 'COLLECTIONS_CREDIT',
  /** The collections_credit_reversal transaction type. */
  COLLECTIONS_CREDIT_REVERSAL = 'COLLECTIONS_CREDIT_REVERSAL',
  /** The customs_duty transaction type. */
  CUSTOMS_DUTY = 'CUSTOMS_DUTY',
  /** The customs_duty_adjustment transaction type. */
  CUSTOMS_DUTY_ADJUSTMENT = 'CUSTOMS_DUTY_ADJUSTMENT',
  /** The dispute_reversal transaction type. */
  DISPUTE_REVERSAL = 'DISPUTE_REVERSAL',
  /** The dispute_withdrawal transaction type. */
  DISPUTE_WITHDRAWAL = 'DISPUTE_WITHDRAWAL',
  /** The import_tax transaction type. */
  IMPORT_TAX = 'IMPORT_TAX',
  /** The import_tax_adjustment transaction type. */
  IMPORT_TAX_ADJUSTMENT = 'IMPORT_TAX_ADJUSTMENT',
  /** The tax refund transaction type. */
  IMPORT_TAX_REFUND = 'IMPORT_TAX_REFUND',
  /** The marketplace_fee_credit transaction type. */
  MARKETPLACE_FEE_CREDIT = 'MARKETPLACE_FEE_CREDIT',
  /** The marketplace_fee_credit_reversal transaction type. */
  MARKETPLACE_FEE_CREDIT_REVERSAL = 'MARKETPLACE_FEE_CREDIT_REVERSAL',
  /** The markets_pro_credit transaction type. */
  MARKETS_PRO_CREDIT = 'MARKETS_PRO_CREDIT',
  /** The merchant_goodwill_credit transaction type. */
  MERCHANT_GOODWILL_CREDIT = 'MERCHANT_GOODWILL_CREDIT',
  /** The merchant_goodwill_credit_reversal transaction type. */
  MERCHANT_GOODWILL_CREDIT_REVERSAL = 'MERCHANT_GOODWILL_CREDIT_REVERSAL',
  /** The merchant_to_merchant_credit transaction type. */
  MERCHANT_TO_MERCHANT_CREDIT = 'MERCHANT_TO_MERCHANT_CREDIT',
  /** The merchant_to_merchant_credit_reversal transaction type. */
  MERCHANT_TO_MERCHANT_CREDIT_REVERSAL = 'MERCHANT_TO_MERCHANT_CREDIT_REVERSAL',
  /** The merchant_to_merchant_debit transaction type. */
  MERCHANT_TO_MERCHANT_DEBIT = 'MERCHANT_TO_MERCHANT_DEBIT',
  /** The merchant_to_merchant_debit_reversal transaction type. */
  MERCHANT_TO_MERCHANT_DEBIT_REVERSAL = 'MERCHANT_TO_MERCHANT_DEBIT_REVERSAL',
  /** The promotion_credit transaction type. */
  PROMOTION_CREDIT = 'PROMOTION_CREDIT',
  /** The promotion_credit_reversal transaction type. */
  PROMOTION_CREDIT_REVERSAL = 'PROMOTION_CREDIT_REVERSAL',
  /** The refund transaction type. */
  REFUND = 'REFUND',
  /** The refund_adjustment transaction type. */
  REFUND_ADJUSTMENT = 'REFUND_ADJUSTMENT',
  /** The refund_failure transaction type. */
  REFUND_FAILURE = 'REFUND_FAILURE',
  /** The reserved_funds transaction type. */
  RESERVED_FUNDS = 'RESERVED_FUNDS',
  /** The reserved_funds_reversal transaction type. */
  RESERVED_FUNDS_REVERSAL = 'RESERVED_FUNDS_REVERSAL',
  /** The reserved_funds_withdrawal transaction type. */
  RESERVED_FUNDS_WITHDRAWAL = 'RESERVED_FUNDS_WITHDRAWAL',
  /** The risk_reversal transaction type. */
  RISK_REVERSAL = 'RISK_REVERSAL',
  /** The risk_withdrawal transaction type. */
  RISK_WITHDRAWAL = 'RISK_WITHDRAWAL',
  /** The seller_protection_credit transaction type. */
  SELLER_PROTECTION_CREDIT = 'SELLER_PROTECTION_CREDIT',
  /** The seller_protection_credit_reversal transaction type. */
  SELLER_PROTECTION_CREDIT_REVERSAL = 'SELLER_PROTECTION_CREDIT_REVERSAL',
  /** The shipping_label transaction type. */
  SHIPPING_LABEL = 'SHIPPING_LABEL',
  /** The shipping_label_adjustment transaction type. */
  SHIPPING_LABEL_ADJUSTMENT = 'SHIPPING_LABEL_ADJUSTMENT',
  /** The shipping_label_adjustment_base transaction type. */
  SHIPPING_LABEL_ADJUSTMENT_BASE = 'SHIPPING_LABEL_ADJUSTMENT_BASE',
  /** The shipping_label_adjustment_surcharge transaction type. */
  SHIPPING_LABEL_ADJUSTMENT_SURCHARGE = 'SHIPPING_LABEL_ADJUSTMENT_SURCHARGE',
  /** The shipping_other_carrier_charge_adjustment transaction type. */
  SHIPPING_OTHER_CARRIER_CHARGE_ADJUSTMENT = 'SHIPPING_OTHER_CARRIER_CHARGE_ADJUSTMENT',
  /** The shipping_return_to_origin_adjustment transaction type. */
  SHIPPING_RETURN_TO_ORIGIN_ADJUSTMENT = 'SHIPPING_RETURN_TO_ORIGIN_ADJUSTMENT',
  /** The shopify_collective_credit transaction type. */
  SHOPIFY_COLLECTIVE_CREDIT = 'SHOPIFY_COLLECTIVE_CREDIT',
  /** The shopify_collective_credit_reversal transaction type. */
  SHOPIFY_COLLECTIVE_CREDIT_REVERSAL = 'SHOPIFY_COLLECTIVE_CREDIT_REVERSAL',
  /** The shopify_collective_debit transaction type. */
  SHOPIFY_COLLECTIVE_DEBIT = 'SHOPIFY_COLLECTIVE_DEBIT',
  /** The shopify_collective_debit_reversal transaction type. */
  SHOPIFY_COLLECTIVE_DEBIT_REVERSAL = 'SHOPIFY_COLLECTIVE_DEBIT_REVERSAL',
  /** The shopify_source_credit transaction type. */
  SHOPIFY_SOURCE_CREDIT = 'SHOPIFY_SOURCE_CREDIT',
  /** The shopify_source_credit_reversal transaction type. */
  SHOPIFY_SOURCE_CREDIT_REVERSAL = 'SHOPIFY_SOURCE_CREDIT_REVERSAL',
  /** The shopify_source_debit transaction type. */
  SHOPIFY_SOURCE_DEBIT = 'SHOPIFY_SOURCE_DEBIT',
  /** The shopify_source_debit_reversal transaction type. */
  SHOPIFY_SOURCE_DEBIT_REVERSAL = 'SHOPIFY_SOURCE_DEBIT_REVERSAL',
  /** The shop_cash_billing_debit transaction type. */
  SHOP_CASH_BILLING_DEBIT = 'SHOP_CASH_BILLING_DEBIT',
  /** The shop_cash_billing_debit_reversal transaction type. */
  SHOP_CASH_BILLING_DEBIT_REVERSAL = 'SHOP_CASH_BILLING_DEBIT_REVERSAL',
  /** The shop_cash_campaign_billing_credit transaction type. */
  SHOP_CASH_CAMPAIGN_BILLING_CREDIT = 'SHOP_CASH_CAMPAIGN_BILLING_CREDIT',
  /** The shop_cash_campaign_billing_credit_reversal transaction type. */
  SHOP_CASH_CAMPAIGN_BILLING_CREDIT_REVERSAL = 'SHOP_CASH_CAMPAIGN_BILLING_CREDIT_REVERSAL',
  /** The shop_cash_campaign_billing_debit transaction type. */
  SHOP_CASH_CAMPAIGN_BILLING_DEBIT = 'SHOP_CASH_CAMPAIGN_BILLING_DEBIT',
  /** The shop_cash_campaign_billing_debit_reversal transaction type. */
  SHOP_CASH_CAMPAIGN_BILLING_DEBIT_REVERSAL = 'SHOP_CASH_CAMPAIGN_BILLING_DEBIT_REVERSAL',
  /** The shop_cash_credit transaction type. */
  SHOP_CASH_CREDIT = 'SHOP_CASH_CREDIT',
  /** The shop_cash_credit_reversal transaction type. */
  SHOP_CASH_CREDIT_REVERSAL = 'SHOP_CASH_CREDIT_REVERSAL',
  /** The shop_cash_refund_debit transaction type. */
  SHOP_CASH_REFUND_DEBIT = 'SHOP_CASH_REFUND_DEBIT',
  /** The shop_cash_refund_debit_reversal transaction type. */
  SHOP_CASH_REFUND_DEBIT_REVERSAL = 'SHOP_CASH_REFUND_DEBIT_REVERSAL',
  /** The stripe_fee transaction type. */
  STRIPE_FEE = 'STRIPE_FEE',
  /** The tax_adjustment_credit transaction type. */
  TAX_ADJUSTMENT_CREDIT = 'TAX_ADJUSTMENT_CREDIT',
  /** The tax_adjustment_credit_reversal transaction type. */
  TAX_ADJUSTMENT_CREDIT_REVERSAL = 'TAX_ADJUSTMENT_CREDIT_REVERSAL',
  /** The tax_adjustment_debit transaction type. */
  TAX_ADJUSTMENT_DEBIT = 'TAX_ADJUSTMENT_DEBIT',
  /** The tax_adjustment_debit_reversal transaction type. */
  TAX_ADJUSTMENT_DEBIT_REVERSAL = 'TAX_ADJUSTMENT_DEBIT_REVERSAL',
  /** The transfer transaction type. */
  TRANSFER = 'TRANSFER',
  /** The transfer_cancel transaction type. */
  TRANSFER_CANCEL = 'TRANSFER_CANCEL',
  /** The transfer_failure transaction type. */
  TRANSFER_FAILURE = 'TRANSFER_FAILURE',
  /** The transfer_refund transaction type. */
  TRANSFER_REFUND = 'TRANSFER_REFUND',
  /** The vat_refund_credit transaction type. */
  VAT_REFUND_CREDIT = 'VAT_REFUND_CREDIT',
  /** The vat_refund_credit_reversal transaction type. */
  VAT_REFUND_CREDIT_REVERSAL = 'VAT_REFUND_CREDIT_REVERSAL'
}

/**
 * Each subject (individual) of an account has a verification object giving
 *  information about the verification state.
 */
export type ShopifyPaymentsVerification = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The status of the verification. */
  readonly status: ShopifyPaymentsVerificationStatus;
  /** The subject/individual who has to be verified. */
  readonly subject: ShopifyPaymentsVerificationSubject;
};

/** The status of a verification. */
export enum ShopifyPaymentsVerificationStatus {
  /** The verification request has been submitted but a response has not yet been given. */
  PENDING = 'PENDING',
  /** The verification has not yet been verified. */
  UNVERIFIED = 'UNVERIFIED',
  /** The verification has been verified. */
  VERIFIED = 'VERIFIED'
}

/** The verification subject represents an individual that has to be verified. */
export type ShopifyPaymentsVerificationSubject = {
  /** The family name of the individual to verify. */
  readonly familyName: Scalars['String'];
  /** The given name of the individual to verify. */
  readonly givenName: Scalars['String'];
};

/** The status of an order's eligibility for protection against fraudulent chargebacks by Shopify Protect. */
export enum ShopifyProtectEligibilityStatus {
  /**
   * The order is eligible for protection against fraudulent chargebacks.
   * If an order is updated, the order's eligibility may change and protection could be removed.
   */
  ELIGIBLE = 'ELIGIBLE',
  /** The order isn't eligible for protection against fraudulent chargebacks. */
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  /** The eligibility of the order is pending and has not yet been determined. */
  PENDING = 'PENDING'
}

/** The eligibility details of an order's protection against fraudulent chargebacks by Shopify Protect. */
export type ShopifyProtectOrderEligibility = {
  /** The status of whether an order is eligible for protection against fraudulent chargebacks. */
  readonly status: ShopifyProtectEligibilityStatus;
};

/** A summary of Shopify Protect details for an order. */
export type ShopifyProtectOrderSummary = {
  /** The eligibility details of an order's protection against fraudulent chargebacks. */
  readonly eligibility: ShopifyProtectOrderEligibility;
  /** The status of the order's protection against fraudulent chargebacks. */
  readonly status: ShopifyProtectStatus;
};

/** The status of an order's protection with Shopify Protect. */
export enum ShopifyProtectStatus {
  /**
   * The protection for the order is active and eligible for reimbursement against fraudulent chargebacks.
   * If an order is updated, the order's eligibility may change and protection could become inactive.
   */
  ACTIVE = 'ACTIVE',
  /** The protection for an order isn't active because the order didn't meet eligibility requirements. */
  INACTIVE = 'INACTIVE',
  /** The order received a chargeback but the order wasn't protected because it didn't meet coverage requirements. */
  NOT_PROTECTED = 'NOT_PROTECTED',
  /** The protection for the order is pending and has not yet been determined. */
  PENDING = 'PENDING',
  /** The order received a fraudulent chargeback and it was protected. */
  PROTECTED = 'PROTECTED'
}

/** Represents the data about a staff member's Shopify account. Merchants can use staff member data to get more information about the staff members in their store. */
export type StaffMember = Node & {
  /** The type of account the staff member has. */
  readonly accountType?: Maybe<AccountType>;
  /** Whether the staff member is active. */
  readonly active: Scalars['Boolean'];
  /** The image used as the staff member's avatar in the Shopify admin. */
  readonly avatar: Image;
  /** The staff member's email address. */
  readonly email: Scalars['String'];
  /** Whether the staff member's account exists. */
  readonly exists: Scalars['Boolean'];
  /** The staff member's first name. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The staff member's initials, if available. */
  readonly initials?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** Whether the staff member is the shop owner. */
  readonly isShopOwner: Scalars['Boolean'];
  /** The staff member's last name. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The staff member's preferred locale. Locale values use the format `language` or `language-COUNTRY`, where `language` is a two-letter language code, and `COUNTRY` is a two-letter country code. For example: `en` or `en-US` */
  readonly locale: Scalars['String'];
  /** The staff member's full name. */
  readonly name: Scalars['String'];
  /** The staff member's phone number. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The data used to customize the Shopify admin experience for the staff member. */
  readonly privateData: StaffMemberPrivateData;
};


/** Represents the data about a staff member's Shopify account. Merchants can use staff member data to get more information about the staff members in their store. */
export type StaffMemberAvatarArgs = {
  fallback?: InputMaybe<StaffMemberDefaultImage>;
};

/** An auto-generated type for paginating through multiple StaffMembers. */
export type StaffMemberConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<StaffMemberEdge>;
  /** A list of nodes that are contained in StaffMemberEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<StaffMember>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Represents the fallback avatar image for a staff member. This is used only if the staff member has no avatar image. */
export enum StaffMemberDefaultImage {
  /** Returns a default avatar image for the staff member. */
  DEFAULT = 'DEFAULT',
  /** Returns a URL that returns a 404 error if the image is not present. */
  NOT_FOUND = 'NOT_FOUND',
  /** Returns a transparent avatar image for the staff member. */
  TRANSPARENT = 'TRANSPARENT'
}

/** An auto-generated type which holds one StaffMember and a cursor during pagination. */
export type StaffMemberEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of StaffMemberEdge. */
  readonly node: StaffMember;
};

/** Represents access permissions for a staff member. */
export enum StaffMemberPermission {
  /** The staff member can manage and install apps and channels. */
  APPLICATIONS = 'APPLICATIONS',
  /** The staff member can manage and install sales channels. */
  CHANNELS = 'CHANNELS',
  /** The staff member can create and edit customers. */
  CREATE_AND_EDIT_CUSTOMERS = 'CREATE_AND_EDIT_CUSTOMERS',
  /** The staff member can create and edit gift cards. */
  CREATE_AND_EDIT_GIFT_CARDS = 'CREATE_AND_EDIT_GIFT_CARDS',
  /** The staff member can view customers. */
  CUSTOMERS = 'CUSTOMERS',
  /** The staff member can view the Shopify Home page, which includes sales information and other shop data. */
  DASHBOARD = 'DASHBOARD',
  /** The staff member can deactivate gift cards. */
  DEACTIVATE_GIFT_CARDS = 'DEACTIVATE_GIFT_CARDS',
  /** The staff member can delete customers. */
  DELETE_CUSTOMERS = 'DELETE_CUSTOMERS',
  /** The staff member can view, buy, and manage domains. */
  DOMAINS = 'DOMAINS',
  /** The staff member can create, update, and delete draft orders. */
  DRAFT_ORDERS = 'DRAFT_ORDERS',
  /** The staff member can update orders. */
  EDIT_ORDERS = 'EDIT_ORDERS',
  /** The staff member can erase customer private data. */
  ERASE_CUSTOMER_DATA = 'ERASE_CUSTOMER_DATA',
  /** The staff member can export customers. */
  EXPORT_CUSTOMERS = 'EXPORT_CUSTOMERS',
  /** The staff member can export gift cards. */
  EXPORT_GIFT_CARDS = 'EXPORT_GIFT_CARDS',
  /** The staff has the same permissions as the [store owner](https://shopify.dev/en/manual/your-account/staff-accounts/staff-permissions#store-owner-permissions) with some exceptions, such as modifying the account billing or deleting staff accounts. */
  FULL = 'FULL',
  /** The staff member can view, create, issue, and export gift cards to a CSV file. */
  GIFT_CARDS = 'GIFT_CARDS',
  /** The staff member can view and modify links and navigation menus. */
  LINKS = 'LINKS',
  /** The staff member can create, update, and delete locations where inventory is stocked or managed. */
  LOCATIONS = 'LOCATIONS',
  /** The staff member can view and create discount codes and automatic discounts, and export discounts to a CSV file. */
  MARKETING = 'MARKETING',
  /** The staff member can view, create, and automate marketing campaigns. */
  MARKETING_SECTION = 'MARKETING_SECTION',
  /** The staff member can merge customers. */
  MERGE_CUSTOMERS = 'MERGE_CUSTOMERS',
  /** The staff member can view, create, update, delete, and cancel orders, and receive order notifications. The staff member can still create draft orders without this permission. */
  ORDERS = 'ORDERS',
  /** The staff member can view the Overview and Live view pages, which include sales information, and other shop and sales channels data. */
  OVERVIEWS = 'OVERVIEWS',
  /** The staff member can view, create, update, publish, and delete blog posts and pages. */
  PAGES = 'PAGES',
  /** The staff member can pay for an order by using a vaulted card. */
  PAY_ORDERS_BY_VAULTED_CARD = 'PAY_ORDERS_BY_VAULTED_CARD',
  /** The staff member can view the preferences and configuration of a shop. */
  PREFERENCES = 'PREFERENCES',
  /** The staff member can view, create, import, and update products, collections, and inventory. */
  PRODUCTS = 'PRODUCTS',
  /** The staff member can view and create all reports, which includes sales information and other shop data. */
  REPORTS = 'REPORTS',
  /** The staff member can request customer private data. */
  REQUEST_CUSTOMER_DATA = 'REQUEST_CUSTOMER_DATA',
  /** The staff member can view, update, and publish themes. */
  THEMES = 'THEMES',
  /** The staff member can view and create translations. */
  TRANSLATIONS = 'TRANSLATIONS'
}

/** Represents the data used to customize the Shopify admin experience for a logged-in staff member. */
export type StaffMemberPrivateData = {
  /** The URL to the staff member's account settings page. */
  readonly accountSettingsUrl: Scalars['URL'];
  /** The date and time when the staff member was created. */
  readonly createdAt: Scalars['DateTime'];
  /**
   * Access permissions for the staff member.
   * @deprecated There's no alternative field to use instead.
   */
  readonly permissions: ReadonlyArray<StaffMemberPermission>;
};

/** The set of valid sort keys for the StaffMembers query. */
export enum StaffMembersSortKeys {
  /** Sort by the `email` value. */
  EMAIL = 'EMAIL',
  /** Sort by the `first_name` value. */
  FIRST_NAME = 'FIRST_NAME',
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `last_name` value. */
  LAST_NAME = 'LAST_NAME'
}

/**
 * An image to be uploaded.
 *
 * Deprecated in favor of
 * [StagedUploadInput](https://shopify.dev/api/admin-graphql/latest/objects/StagedUploadInput),
 * which is used by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type StageImageInput = {
  /** The image filename. */
  readonly filename: Scalars['String'];
  /** HTTP method to be used by the staged upload. */
  readonly httpMethod?: InputMaybe<StagedUploadHttpMethodType>;
  /** The image MIME type. */
  readonly mimeType: Scalars['String'];
  /** The image resource. */
  readonly resource: StagedUploadTargetGenerateUploadResource;
};

/**
 * Information about a staged upload target, which should be used to send a request to upload
 * the file.
 *
 * For more information on the upload process, refer to
 * [Upload media to Shopify](https://shopify.dev/apps/online-store/media/products#step-1-upload-media-to-shopify).
 */
export type StagedMediaUploadTarget = {
  /** Parameters needed to authenticate a request to upload the file. */
  readonly parameters: ReadonlyArray<StagedUploadParameter>;
  /**
   * The URL to be passed as `originalSource` in
   * [CreateMediaInput](https://shopify.dev/api/admin-graphql/latest/input-objects/CreateMediaInput)
   * and [FileCreateInput](https://shopify.dev/api/admin-graphql/2022-04/input-objects/FileCreateInput)
   * for the [productCreateMedia](https://shopify.dev/api/admin-graphql/2022-04/mutations/productCreateMedia)
   * and [fileCreate](https://shopify.dev/api/admin-graphql/2022-04/mutations/fileCreate)
   * mutations.
   */
  readonly resourceUrl?: Maybe<Scalars['URL']>;
  /**
   * The URL to use when sending an request to upload the file. Should be used in conjunction with
   * the parameters field.
   */
  readonly url?: Maybe<Scalars['URL']>;
};

/**
 * The possible HTTP methods that can be used when sending a request to upload a file using information from a
 * [StagedMediaUploadTarget](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget).
 */
export enum StagedUploadHttpMethodType {
  /** The POST HTTP method. */
  POST = 'POST',
  /** The PUT HTTP method. */
  PUT = 'PUT'
}

/** The input fields for generating staged upload targets. */
export type StagedUploadInput = {
  /**
   * The size of the file to upload, in bytes. This is required when the request's resource property is set to
   * [VIDEO](https://shopify.dev/api/admin-graphql/latest/enums/StagedUploadTargetGenerateUploadResource#value-video)
   * or [MODEL_3D](https://shopify.dev/api/admin-graphql/latest/enums/StagedUploadTargetGenerateUploadResource#value-model3d).
   */
  readonly fileSize?: InputMaybe<Scalars['UnsignedInt64']>;
  /** The file's name and extension. */
  readonly filename: Scalars['String'];
  /**
   * The HTTP method to be used when sending a request to upload the file using the returned staged
   * upload target.
   */
  readonly httpMethod?: InputMaybe<StagedUploadHttpMethodType>;
  /** The file's MIME type. */
  readonly mimeType: Scalars['String'];
  /** The file's intended Shopify resource type. */
  readonly resource: StagedUploadTargetGenerateUploadResource;
};

/**
 * The parameters required to authenticate a file upload request using a
 * [StagedMediaUploadTarget's url field](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget#field-stagedmediauploadtarget-url).
 *
 * For more information on the upload process, refer to
 * [Upload media to Shopify](https://shopify.dev/apps/online-store/media/products#step-1-upload-media-to-shopify).
 */
export type StagedUploadParameter = {
  /** The parameter's name. */
  readonly name: Scalars['String'];
  /** The parameter's value. */
  readonly value: Scalars['String'];
};

/**
 * Information about the staged target.
 *
 * Deprecated in favor of
 * [StagedMediaUploadTarget](https://shopify.dev/api/admin-graphql/latest/objects/StagedMediaUploadTarget),
 * which is returned by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type StagedUploadTarget = {
  /** The parameters of an image to be uploaded. */
  readonly parameters: ReadonlyArray<ImageUploadParameter>;
  /** The image URL. */
  readonly url: Scalars['String'];
};

/**
 * The required fields and parameters to generate the URL upload an"
 * asset to Shopify.
 *
 * Deprecated in favor of
 * [StagedUploadInput](https://shopify.dev/api/admin-graphql/latest/objects/StagedUploadInput),
 * which is used by the
 * [stagedUploadsCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/stagedUploadsCreate).
 */
export type StagedUploadTargetGenerateInput = {
  /** The size of the file to upload, in bytes. */
  readonly fileSize?: InputMaybe<Scalars['UnsignedInt64']>;
  /** The filename of the asset being uploaded. */
  readonly filename: Scalars['String'];
  /** The HTTP method to be used by the staged upload. */
  readonly httpMethod?: InputMaybe<StagedUploadHttpMethodType>;
  /** The MIME type of the asset being uploaded. */
  readonly mimeType: Scalars['String'];
  /** The resource type being uploaded. */
  readonly resource: StagedUploadTargetGenerateUploadResource;
};

/** Return type for `stagedUploadTargetGenerate` mutation. */
export type StagedUploadTargetGeneratePayload = {
  /** The signed parameters that can be used to upload the asset. */
  readonly parameters: ReadonlyArray<MutationsStagedUploadTargetGenerateUploadParameter>;
  /** The signed URL where the asset can be uploaded. */
  readonly url: Scalars['String'];
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The resource type to receive. */
export enum StagedUploadTargetGenerateUploadResource {
  /**
   * Represents bulk mutation variables.
   *
   * For example, bulk mutation variables can be used for bulk operations using the
   * [bulkOperationRunMutation mutation](https://shopify.dev/api/admin-graphql/latest/mutations/bulkOperationRunMutation).
   */
  BULK_MUTATION_VARIABLES = 'BULK_MUTATION_VARIABLES',
  /**
   * An image associated with a collection.
   *
   * For example, after uploading an image, you can use the
   * [collectionUpdate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/collectionUpdate)
   * to add the image to a collection.
   */
  COLLECTION_IMAGE = 'COLLECTION_IMAGE',
  /**
   * Represents any file other than HTML.
   *
   * For example, after uploading the file, you can add the file to the
   * [Files page](https://shopify.com/admin/settings/files) in Shopify admin using the
   * [fileCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/fileCreate).
   */
  FILE = 'FILE',
  /**
   * An image.
   *
   * For example, after uploading an image, you can add the image to a product using the
   * [productCreateMedia mutation](https://shopify.dev/api/admin-graphql/latest/mutations/productCreateMedia)
   * or to the [Files page](https://shopify.com/admin/settings/files) in Shopify admin using the
   * [fileCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/fileCreate).
   */
  IMAGE = 'IMAGE',
  /**
   * A Shopify hosted 3d model.
   *
   * For example, after uploading the 3d model, you can add the 3d model to a product using the
   * [productCreateMedia mutation](https://shopify.dev/api/admin-graphql/latest/mutations/productCreateMedia).
   */
  MODEL_3D = 'MODEL_3D',
  /**
   * An image that's associated with a product.
   *
   * For example, after uploading the image, you can add the image to a product using the
   * [productCreateMedia mutation](https://shopify.dev/api/admin-graphql/latest/mutations/productCreateMedia).
   */
  PRODUCT_IMAGE = 'PRODUCT_IMAGE',
  /**
   * Represents a label associated with a return.
   *
   * For example, once uploaded, this resource can be used to [create a
   * ReverseDelivery](https://shopify.dev/api/admin-graphql/unstable/mutations/reverseDeliveryCreateWithShipping).
   */
  RETURN_LABEL = 'RETURN_LABEL',
  /**
   * An image.
   *
   * For example, after uploading the image, you can add the image to the
   * [Files page](https://shopify.com/admin/settings/files) in Shopify admin using the
   * [fileCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/fileCreate).
   */
  SHOP_IMAGE = 'SHOP_IMAGE',
  /**
   * Represents a redirect CSV file.
   *
   * Example usage: This resource can be used for creating a
   * [UrlRedirectImport](https://shopify.dev/api/admin-graphql/2022-04/objects/UrlRedirectImport)
   * object for use in the
   * [urlRedirectImportCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/urlRedirectImportCreate).
   */
  URL_REDIRECT_IMPORT = 'URL_REDIRECT_IMPORT',
  /**
   * A Shopify-hosted video.
   *
   * For example, after uploading the video, you can add the video to a product using the
   * [productCreateMedia mutation](https://shopify.dev/api/admin-graphql/latest/mutations/productCreateMedia)
   * or to the [Files page](https://shopify.com/admin/settings/files) in Shopify admin using the
   * [fileCreate mutation](https://shopify.dev/api/admin-graphql/latest/mutations/fileCreate).
   */
  VIDEO = 'VIDEO'
}

/** Return type for `stagedUploadTargetsGenerate` mutation. */
export type StagedUploadTargetsGeneratePayload = {
  /** The staged upload targets that were generated. */
  readonly urls?: Maybe<ReadonlyArray<StagedUploadTarget>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `stagedUploadsCreate` mutation. */
export type StagedUploadsCreatePayload = {
  /** The staged upload targets that were generated. */
  readonly stagedTargets?: Maybe<ReadonlyArray<StagedMediaUploadTarget>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields for the access settings for the metafields under the standard definition. */
export type StandardMetafieldDefinitionAccessInput = {
  /** The Admin API access setting to use for the metafields under this definition. */
  readonly admin: MetafieldAdminAccessInput;
  /** The Customer Account API access setting to use for the metafields under this definition. */
  readonly customerAccount?: InputMaybe<MetafieldCustomerAccountAccessInput>;
  /** The Storefront API access setting to use for the metafields under this definition. */
  readonly storefront?: InputMaybe<MetafieldStorefrontAccessInput>;
};

/** Return type for `standardMetafieldDefinitionEnable` mutation. */
export type StandardMetafieldDefinitionEnablePayload = {
  /** The metafield definition that was created. */
  readonly createdDefinition?: Maybe<MetafieldDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<StandardMetafieldDefinitionEnableUserError>;
};

/** An error that occurs during the execution of `StandardMetafieldDefinitionEnable`. */
export type StandardMetafieldDefinitionEnableUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<StandardMetafieldDefinitionEnableUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `StandardMetafieldDefinitionEnableUserError`. */
export enum StandardMetafieldDefinitionEnableUserErrorCode {
  /** Admin access can only be specified for app-owned metafield definitions. */
  ADMIN_ACCESS_INPUT_NOT_ALLOWED = 'ADMIN_ACCESS_INPUT_NOT_ALLOWED',
  /** The metafield definition capability cannot be disabled. */
  CAPABILITY_CANNOT_BE_DISABLED = 'CAPABILITY_CANNOT_BE_DISABLED',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The metafield definition capability is invalid. */
  INVALID_CAPABILITY = 'INVALID_CAPABILITY',
  /** The input combination is invalid. */
  INVALID_INPUT_COMBINATION = 'INVALID_INPUT_COMBINATION',
  /** The maximum number of definitions per owner type has been exceeded. */
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The standard metafield definition template was not found. */
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  /** The definition type is not eligible to be used as collection condition. */
  TYPE_NOT_ALLOWED_FOR_CONDITIONS = 'TYPE_NOT_ALLOWED_FOR_CONDITIONS',
  /** The namespace and key is already in use for a set of your metafields. */
  UNSTRUCTURED_ALREADY_EXISTS = 'UNSTRUCTURED_ALREADY_EXISTS',
  /** The metafield definition does not support pinning. */
  UNSUPPORTED_PINNING = 'UNSUPPORTED_PINNING'
}

/**
 * Standard metafield definition templates provide preset configurations to create metafield definitions.
 * Each template has a specific namespace and key that we've reserved to have specific meanings for common use cases.
 *
 * Refer to the [list of standard metafield definitions](https://shopify.dev/apps/metafields/definitions/standard-definitions).
 */
export type StandardMetafieldDefinitionTemplate = Node & {
  /** The description of the standard metafield definition. */
  readonly description?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The key owned by the definition after the definition has been activated. */
  readonly key: Scalars['String'];
  /** The human-readable name for the standard metafield definition. */
  readonly name: Scalars['String'];
  /** The namespace owned by the definition after the definition has been activated. */
  readonly namespace: Scalars['String'];
  /** The list of resource types that the standard metafield definition can be applied to. */
  readonly ownerTypes: ReadonlyArray<MetafieldOwnerType>;
  /** The associated [metafield definition type](https://shopify.dev/apps/metafields/definitions/types) that the metafield stores. */
  readonly type: MetafieldDefinitionType;
  /** The configured validations for the standard metafield definition. */
  readonly validations: ReadonlyArray<MetafieldDefinitionValidation>;
  /** Whether metafields for the definition are by default visible using the Storefront API. */
  readonly visibleToStorefrontApi: Scalars['Boolean'];
};

/** An auto-generated type for paginating through multiple StandardMetafieldDefinitionTemplates. */
export type StandardMetafieldDefinitionTemplateConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<StandardMetafieldDefinitionTemplateEdge>;
  /** A list of nodes that are contained in StandardMetafieldDefinitionTemplateEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<StandardMetafieldDefinitionTemplate>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one StandardMetafieldDefinitionTemplate and a cursor during pagination. */
export type StandardMetafieldDefinitionTemplateEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of StandardMetafieldDefinitionTemplateEdge. */
  readonly node: StandardMetafieldDefinitionTemplate;
};

/** Return type for `standardMetaobjectDefinitionEnable` mutation. */
export type StandardMetaobjectDefinitionEnablePayload = {
  /** The metaobject definition that was enabled using the standard template. */
  readonly metaobjectDefinition?: Maybe<MetaobjectDefinition>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<MetaobjectUserError>;
};

/** Represents the details of a specific type of product within the [Shopify product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). */
export type StandardizedProductType = {
  /** The product taxonomy node associated with the standardized product type. */
  readonly productTaxonomyNode?: Maybe<ProductTaxonomyNode>;
};

/**
 * A store credit account contains a monetary balance that can be redeemed at checkout for purchases in the shop.
 * The account is held in the specified currency and has an owner that cannot be transferred.
 *
 * The account balance is redeemable at checkout only when the owner is authenticated via [new customer accounts authentication](https://shopify.dev/docs/api/customer).
 */
export type StoreCreditAccount = Node & {
  /** The current balance of the store credit account. */
  readonly balance: MoneyV2;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The owner of the store credit account. */
  readonly owner: HasStoreCreditAccounts;
  /** The transaction history of the store credit account. */
  readonly transactions: StoreCreditAccountTransactionConnection;
};


/**
 * A store credit account contains a monetary balance that can be redeemed at checkout for purchases in the shop.
 * The account is held in the specified currency and has an owner that cannot be transferred.
 *
 * The account balance is redeemable at checkout only when the owner is authenticated via [new customer accounts authentication](https://shopify.dev/docs/api/customer).
 */
export type StoreCreditAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<TransactionSortKeys>;
};

/** An auto-generated type for paginating through multiple StoreCreditAccounts. */
export type StoreCreditAccountConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<StoreCreditAccountEdge>;
  /** A list of nodes that are contained in StoreCreditAccountEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<StoreCreditAccount>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields for a store credit account credit transaction. */
export type StoreCreditAccountCreditInput = {
  /** The amount to credit the store credit account. */
  readonly creditAmount: MoneyInput;
  /** The date and time when the credit expires. */
  readonly expiresAt?: InputMaybe<Scalars['DateTime']>;
};

/** Return type for `storeCreditAccountCredit` mutation. */
export type StoreCreditAccountCreditPayload = {
  /** The store credit account transaction that was created. */
  readonly storeCreditAccountTransaction?: Maybe<StoreCreditAccountCreditTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<StoreCreditAccountCreditUserError>;
};

/** A credit transaction which increases the store credit account balance. */
export type StoreCreditAccountCreditTransaction = Node & StoreCreditAccountTransaction & {
  /** The store credit account that the transaction belongs to. */
  readonly account: StoreCreditAccount;
  /** The amount of the transaction. */
  readonly amount: MoneyV2;
  /** The balance of the account after the transaction. */
  readonly balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  readonly createdAt: Scalars['DateTime'];
  /**
   * The time at which the transaction expires.
   * Debit transactions will always spend the soonest expiring credit first.
   */
  readonly expiresAt?: Maybe<Scalars['DateTime']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The remaining amount of the credit.
   * The remaining amount will decrease when a debit spends this credit. It may also increase if that debit is subsequently reverted.
   * In the event that the credit expires, the remaining amount will represent the amount that remained as the expiry ocurred.
   */
  readonly remainingAmount: MoneyV2;
};

/** An error that occurs during the execution of `StoreCreditAccountCredit`. */
export type StoreCreditAccountCreditUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<StoreCreditAccountCreditUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `StoreCreditAccountCreditUserError`. */
export enum StoreCreditAccountCreditUserErrorCode {
  /** The store credit account could not be found. */
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  /** The operation would cause the account's credit limit to be exceeded. */
  CREDIT_LIMIT_EXCEEDED = 'CREDIT_LIMIT_EXCEEDED',
  /** The expiry date must be in the future. */
  EXPIRES_AT_IN_PAST = 'EXPIRES_AT_IN_PAST',
  /** The currency provided does not match the currency of the store credit account. */
  MISMATCHING_CURRENCY = 'MISMATCHING_CURRENCY',
  /** A positive amount must be used to credit a store credit account. */
  NEGATIVE_OR_ZERO_AMOUNT = 'NEGATIVE_OR_ZERO_AMOUNT',
  /** Owner does not exist. */
  OWNER_NOT_FOUND = 'OWNER_NOT_FOUND',
  /** The currency provided is not currently supported. */
  UNSUPPORTED_CURRENCY = 'UNSUPPORTED_CURRENCY'
}

/** The input fields for a store credit account debit transaction. */
export type StoreCreditAccountDebitInput = {
  /** The amount to debit the store credit account. */
  readonly debitAmount: MoneyInput;
};

/** Return type for `storeCreditAccountDebit` mutation. */
export type StoreCreditAccountDebitPayload = {
  /** The store credit account transaction that was created. */
  readonly storeCreditAccountTransaction?: Maybe<StoreCreditAccountDebitTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<StoreCreditAccountDebitUserError>;
};

/**
 * A debit revert transaction which increases the store credit account balance.
 * Debit revert transactions are created automatically when a [store credit account debit transaction](https://shopify.dev/api/admin-graphql/latest/objects/StoreCreditAccountDebitTransaction) is reverted.
 *
 * Store credit account debit transactions are reverted when an order is cancelled, refunded or in the event of a payment failure at checkout.
 * The amount added to the balance is equal to the amount reverted on the original credit.
 */
export type StoreCreditAccountDebitRevertTransaction = Node & StoreCreditAccountTransaction & {
  /** The store credit account that the transaction belongs to. */
  readonly account: StoreCreditAccount;
  /** The amount of the transaction. */
  readonly amount: MoneyV2;
  /** The balance of the account after the transaction. */
  readonly balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The reverted debit transaction. */
  readonly debitTransaction: StoreCreditAccountDebitTransaction;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
};

/** A debit transaction which decreases the store credit account balance. */
export type StoreCreditAccountDebitTransaction = Node & StoreCreditAccountTransaction & {
  /** The store credit account that the transaction belongs to. */
  readonly account: StoreCreditAccount;
  /** The amount of the transaction. */
  readonly amount: MoneyV2;
  /** The balance of the account after the transaction. */
  readonly balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
};

/** An error that occurs during the execution of `StoreCreditAccountDebit`. */
export type StoreCreditAccountDebitUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<StoreCreditAccountDebitUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `StoreCreditAccountDebitUserError`. */
export enum StoreCreditAccountDebitUserErrorCode {
  /** The store credit account could not be found. */
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  /** The store credit account does not have sufficient funds to satisfy the request. */
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  /** The currency provided does not match the currency of the store credit account. */
  MISMATCHING_CURRENCY = 'MISMATCHING_CURRENCY',
  /** A positive amount must be used to debit a store credit account. */
  NEGATIVE_OR_ZERO_AMOUNT = 'NEGATIVE_OR_ZERO_AMOUNT'
}

/** An auto-generated type which holds one StoreCreditAccount and a cursor during pagination. */
export type StoreCreditAccountEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of StoreCreditAccountEdge. */
  readonly node: StoreCreditAccount;
};

/**
 * An expiration transaction which decreases the store credit account balance.
 * Expiration transactions are created automatically when a [store credit account credit transaction](https://shopify.dev/api/admin-graphql/latest/objects/StoreCreditAccountCreditTransaction) expires.
 *
 * The amount subtracted from the balance is equal to the remaining amount of the credit transaction.
 */
export type StoreCreditAccountExpirationTransaction = StoreCreditAccountTransaction & {
  /** The store credit account that the transaction belongs to. */
  readonly account: StoreCreditAccount;
  /** The amount of the transaction. */
  readonly amount: MoneyV2;
  /** The balance of the account after the transaction. */
  readonly balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The credit transaction which expired. */
  readonly creditTransaction: StoreCreditAccountCreditTransaction;
};

/** Interface for a store credit account transaction. */
export type StoreCreditAccountTransaction = {
  /** The store credit account that the transaction belongs to. */
  readonly account: StoreCreditAccount;
  /** The amount of the transaction. */
  readonly amount: MoneyV2;
  /** The balance of the account after the transaction. */
  readonly balanceAfterTransaction: MoneyV2;
  /** The date and time when the transaction was created. */
  readonly createdAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple StoreCreditAccountTransactions. */
export type StoreCreditAccountTransactionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<StoreCreditAccountTransactionEdge>;
  /** A list of nodes that are contained in StoreCreditAccountTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<StoreCreditAccountTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one StoreCreditAccountTransaction and a cursor during pagination. */
export type StoreCreditAccountTransactionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of StoreCreditAccountTransactionEdge. */
  readonly node: StoreCreditAccountTransaction;
};

/**
 * A token that's used to delegate unauthenticated access scopes to clients that need to access
 * the unauthenticated [Storefront API](https://shopify.dev/docs/api/storefront).
 *
 * An app can have a maximum of 100 active storefront access
 * tokens for each shop.
 *
 * [Get started with the Storefront API](https://shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/getting-started).
 */
export type StorefrontAccessToken = Node & {
  /** List of permissions associated with the token. */
  readonly accessScopes: ReadonlyArray<AccessScope>;
  /** The issued public access token. */
  readonly accessToken: Scalars['String'];
  /** The date and time when the public access token was created. */
  readonly createdAt: Scalars['DateTime'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** An arbitrary title for each token determined by the developer, used for reference         purposes. */
  readonly title: Scalars['String'];
  /** The date and time when the storefront access token was updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple StorefrontAccessTokens. */
export type StorefrontAccessTokenConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<StorefrontAccessTokenEdge>;
  /** A list of nodes that are contained in StorefrontAccessTokenEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<StorefrontAccessToken>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `storefrontAccessTokenCreate` mutation. */
export type StorefrontAccessTokenCreatePayload = {
  /** The user's shop. */
  readonly shop: Shop;
  /** The storefront access token. */
  readonly storefrontAccessToken?: Maybe<StorefrontAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** The input fields to delete a storefront access token. */
export type StorefrontAccessTokenDeleteInput = {
  /** The ID of the storefront access token to delete. */
  readonly id: Scalars['ID'];
};

/** Return type for `storefrontAccessTokenDelete` mutation. */
export type StorefrontAccessTokenDeletePayload = {
  /** The ID of the deleted storefront access token. */
  readonly deletedStorefrontAccessTokenId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one StorefrontAccessToken and a cursor during pagination. */
export type StorefrontAccessTokenEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of StorefrontAccessTokenEdge. */
  readonly node: StorefrontAccessToken;
};

/** The input fields for a storefront access token. */
export type StorefrontAccessTokenInput = {
  /** A title for the storefront access token. */
  readonly title: Scalars['String'];
};

/** An auto-generated type for paginating through multiple Strings. */
export type StringConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<StringEdge>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one String and a cursor during pagination. */
export type StringEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of StringEdge. */
  readonly node: Scalars['String'];
};

/** Represents an applied code discount. */
export type SubscriptionAppliedCodeDiscount = {
  /** The unique ID. */
  readonly id: Scalars['ID'];
  /** The redeem code of the discount that applies on the subscription. */
  readonly redeemCode: Scalars['String'];
  /** The reason that the discount on the subscription draft is rejected. */
  readonly rejectionReason?: Maybe<SubscriptionDiscountRejectionReason>;
};

/** The input fields for mapping a subscription line to a discount. */
export type SubscriptionAtomicLineInput = {
  /** The discount to be added to the subscription line. */
  readonly discounts?: InputMaybe<ReadonlyArray<SubscriptionAtomicManualDiscountInput>>;
  /** The new subscription line. */
  readonly line: SubscriptionLineInput;
};

/** The input fields for mapping a subscription line to a discount. */
export type SubscriptionAtomicManualDiscountInput = {
  /** The maximum number of times the subscription discount will be applied on orders. */
  readonly recurringCycleLimit?: InputMaybe<Scalars['Int']>;
  /** The title associated with the subscription discount. */
  readonly title?: InputMaybe<Scalars['String']>;
  /** Percentage or fixed amount value of the discount. */
  readonly value?: InputMaybe<SubscriptionManualDiscountValueInput>;
};

/**
 * A record of an execution of the subscription billing process. Billing attempts use
 * idempotency keys to avoid duplicate order creation. A successful billing attempt
 * will create an order.
 */
export type SubscriptionBillingAttempt = Node & {
  /** The date and time when the billing attempt was completed. */
  readonly completedAt?: Maybe<Scalars['DateTime']>;
  /** The date and time when the billing attempt was created. */
  readonly createdAt: Scalars['DateTime'];
  /**
   * A code corresponding to a payment error during processing.
   * @deprecated As of API version 2025-01, use `processingError.code` instead to get the errorCode
   */
  readonly errorCode?: Maybe<SubscriptionBillingAttemptErrorCode>;
  /**
   * A message describing a payment error during processing.
   * @deprecated As of API version 2025-01, use `processingError.message` instead to get the errorMessage
   */
  readonly errorMessage?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** A unique key generated by the client to avoid duplicate payments. */
  readonly idempotencyKey: Scalars['String'];
  /** The URL where the customer needs to be redirected so they can complete the 3D Secure payment flow. */
  readonly nextActionUrl?: Maybe<Scalars['URL']>;
  /** The result of this billing attempt if completed successfully. */
  readonly order?: Maybe<Order>;
  /**
   * The date and time used to calculate fulfillment intervals for a billing attempt that
   * successfully completed after the current anchor date. To prevent fulfillment from being
   * pushed to the next anchor date, this field can override the billing attempt date.
   */
  readonly originTime?: Maybe<Scalars['DateTime']>;
  /** The reference shared between retried payment attempts. */
  readonly paymentGroupId?: Maybe<Scalars['String']>;
  /** The reference shared between payment attempts with similar payment details. */
  readonly paymentSessionId?: Maybe<Scalars['String']>;
  /** Whether the billing attempt is still processing. */
  readonly ready: Scalars['Boolean'];
  /** The subscription contract. */
  readonly subscriptionContract: SubscriptionContract;
  /** The transactions created by the billing attempt. */
  readonly transactions: OrderTransactionConnection;
};


/**
 * A record of an execution of the subscription billing process. Billing attempts use
 * idempotency keys to avoid duplicate order creation. A successful billing attempt
 * will create an order.
 */
export type SubscriptionBillingAttemptTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple SubscriptionBillingAttempts. */
export type SubscriptionBillingAttemptConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SubscriptionBillingAttemptEdge>;
  /** A list of nodes that are contained in SubscriptionBillingAttemptEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SubscriptionBillingAttempt>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `subscriptionBillingAttemptCreate` mutation. */
export type SubscriptionBillingAttemptCreatePayload = {
  /** The subscription billing attempt. */
  readonly subscriptionBillingAttempt?: Maybe<SubscriptionBillingAttempt>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BillingAttemptUserError>;
};

/** An auto-generated type which holds one SubscriptionBillingAttempt and a cursor during pagination. */
export type SubscriptionBillingAttemptEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SubscriptionBillingAttemptEdge. */
  readonly node: SubscriptionBillingAttempt;
};

/**
 * The possible error codes associated with making billing attempts. The error codes supplement the
 * `error_message` to provide consistent results and help with dunning management.
 */
export enum SubscriptionBillingAttemptErrorCode {
  /** The amount is too small. */
  AMOUNT_TOO_SMALL = 'AMOUNT_TOO_SMALL',
  /** There was an error during the authentication. */
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  /** Payment method was canceled by buyer. */
  BUYER_CANCELED_PAYMENT_METHOD = 'BUYER_CANCELED_PAYMENT_METHOD',
  /** Card number was incorrect. */
  CARD_NUMBER_INCORRECT = 'CARD_NUMBER_INCORRECT',
  /** Customer is invalid. */
  CUSTOMER_INVALID = 'CUSTOMER_INVALID',
  /** Customer was not found. */
  CUSTOMER_NOT_FOUND = 'CUSTOMER_NOT_FOUND',
  /** Payment method is expired. */
  EXPIRED_PAYMENT_METHOD = 'EXPIRED_PAYMENT_METHOD',
  /** Fraud was suspected. */
  FRAUD_SUSPECTED = 'FRAUD_SUSPECTED',
  /** Insufficient funds. */
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  /** Not enough inventory found. */
  INSUFFICIENT_INVENTORY = 'INSUFFICIENT_INVENTORY',
  /** The billing agreement ID or the transaction ID for the customer's payment method is invalid. */
  INVALID_CUSTOMER_BILLING_AGREEMENT = 'INVALID_CUSTOMER_BILLING_AGREEMENT',
  /** Payment method is invalid. Please update or create a new payment method. */
  INVALID_PAYMENT_METHOD = 'INVALID_PAYMENT_METHOD',
  /** The shipping address is either missing or invalid. */
  INVALID_SHIPPING_ADDRESS = 'INVALID_SHIPPING_ADDRESS',
  /** No inventory location found or enabled. */
  INVENTORY_ALLOCATIONS_NOT_FOUND = 'INVENTORY_ALLOCATIONS_NOT_FOUND',
  /** A payment has already been made for this invoice. */
  INVOICE_ALREADY_PAID = 'INVOICE_ALREADY_PAID',
  /** Payment method was declined by processor. */
  PAYMENT_METHOD_DECLINED = 'PAYMENT_METHOD_DECLINED',
  /** Payment method cannot be used with the current payment gateway test mode configuration. */
  PAYMENT_METHOD_INCOMPATIBLE_WITH_GATEWAY_CONFIG = 'PAYMENT_METHOD_INCOMPATIBLE_WITH_GATEWAY_CONFIG',
  /** Payment method was not found. */
  PAYMENT_METHOD_NOT_FOUND = 'PAYMENT_METHOD_NOT_FOUND',
  /** Payment provider is not enabled. */
  PAYMENT_PROVIDER_IS_NOT_ENABLED = 'PAYMENT_PROVIDER_IS_NOT_ENABLED',
  /** Paypal Error General. */
  PAYPAL_ERROR_GENERAL = 'PAYPAL_ERROR_GENERAL',
  /** Purchase Type is not supported. */
  PURCHASE_TYPE_NOT_SUPPORTED = 'PURCHASE_TYPE_NOT_SUPPORTED',
  /** Gateway is in test mode and attempted to bill a live payment method. */
  TEST_MODE = 'TEST_MODE',
  /** Transient error, try again later. */
  TRANSIENT_ERROR = 'TRANSIENT_ERROR',
  /** There was an unexpected error during the billing attempt. */
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR'
}

/** The input fields required to complete a subscription billing attempt. */
export type SubscriptionBillingAttemptInput = {
  /**
   * Select the specific billing cycle to be billed.
   * Default to bill the current billing cycle if not specified.
   */
  readonly billingCycleSelector?: InputMaybe<SubscriptionBillingCycleSelector>;
  /** A unique key generated by the client to avoid duplicate payments. For more information, refer to [Idempotent requests](https://shopify.dev/api/usage/idempotent-requests). */
  readonly idempotencyKey: Scalars['String'];
  /**
   * The date and time used to calculate fulfillment intervals for a billing attempt that
   * successfully completed after the current anchor date. To prevent fulfillment from being
   * pushed to the next anchor date, this field can override the billing attempt date.
   */
  readonly originTime?: InputMaybe<Scalars['DateTime']>;
};

/** The set of valid sort keys for the SubscriptionBillingAttempts query. */
export enum SubscriptionBillingAttemptsSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** A subscription billing cycle. */
export type SubscriptionBillingCycle = {
  /** The date on which the billing attempt is expected to be made. */
  readonly billingAttemptExpectedDate: Scalars['DateTime'];
  /** The list of billing attempts associated with the billing cycle. */
  readonly billingAttempts: SubscriptionBillingAttemptConnection;
  /** The end date of the billing cycle. */
  readonly cycleEndAt: Scalars['DateTime'];
  /** The index of the billing cycle. */
  readonly cycleIndex: Scalars['Int'];
  /** The start date of the billing cycle. */
  readonly cycleStartAt: Scalars['DateTime'];
  /** Whether this billing cycle was edited. */
  readonly edited: Scalars['Boolean'];
  /** The active edited contract for the billing cycle. */
  readonly editedContract?: Maybe<SubscriptionBillingCycleEditedContract>;
  /** Whether this billing cycle was skipped. */
  readonly skipped: Scalars['Boolean'];
  /** The subscription contract that the billing cycle belongs to. */
  readonly sourceContract: SubscriptionContract;
  /** The status of the billing cycle. */
  readonly status: SubscriptionBillingCycleBillingCycleStatus;
};


/** A subscription billing cycle. */
export type SubscriptionBillingCycleBillingAttemptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The presence of billing attempts on Billing Cycles. */
export enum SubscriptionBillingCycleBillingAttemptStatus {
  /** Billing cycle has any number of billing attempts. */
  ANY = 'ANY',
  /** Billing cycle has at least one billing attempt. */
  HAS_ATTEMPT = 'HAS_ATTEMPT',
  /** Billing cycle has no billing attempts. */
  NO_ATTEMPT = 'NO_ATTEMPT'
}

/** The possible status values of a subscription billing cycle. */
export enum SubscriptionBillingCycleBillingCycleStatus {
  /** The billing cycle is billed. */
  BILLED = 'BILLED',
  /** The billing cycle hasn't been billed. */
  UNBILLED = 'UNBILLED'
}

/** Return type for `subscriptionBillingCycleBulkCharge` mutation. */
export type SubscriptionBillingCycleBulkChargePayload = {
  /** The asynchronous job that performs the action on the targeted billing cycles. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionBillingCycleBulkUserError>;
};

/** The input fields for filtering subscription billing cycles in bulk actions. */
export type SubscriptionBillingCycleBulkFilters = {
  /** Filters the billing cycles based on the presence of billing attempts. */
  readonly billingAttemptStatus?: InputMaybe<SubscriptionBillingCycleBillingAttemptStatus>;
  /** Filters the billing cycles based on their status. */
  readonly billingCycleStatus?: InputMaybe<ReadonlyArray<SubscriptionBillingCycleBillingCycleStatus>>;
  /** Filters the billing cycles based on the status of their associated subscription contracts. */
  readonly contractStatus?: InputMaybe<ReadonlyArray<SubscriptionContractSubscriptionStatus>>;
};

/** Return type for `subscriptionBillingCycleBulkSearch` mutation. */
export type SubscriptionBillingCycleBulkSearchPayload = {
  /** The asynchronous job that performs the action on the targeted billing cycles. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionBillingCycleBulkUserError>;
};

/** Represents an error that happens during the execution of subscriptionBillingCycles mutations. */
export type SubscriptionBillingCycleBulkUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<SubscriptionBillingCycleBulkUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `SubscriptionBillingCycleBulkUserError`. */
export enum SubscriptionBillingCycleBulkUserErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** End date can't be more than 24 hours in the future. */
  END_DATE_IN_THE_FUTURE = 'END_DATE_IN_THE_FUTURE',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The range between start date and end date shouldn't be more than 1 week. */
  INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
  /** Start date should be before end date. */
  START_DATE_BEFORE_END_DATE = 'START_DATE_BEFORE_END_DATE'
}

/** Return type for `subscriptionBillingCycleCharge` mutation. */
export type SubscriptionBillingCycleChargePayload = {
  /** The subscription billing attempt. */
  readonly subscriptionBillingAttempt?: Maybe<SubscriptionBillingAttempt>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<BillingAttemptUserError>;
};

/** An auto-generated type for paginating through multiple SubscriptionBillingCycles. */
export type SubscriptionBillingCycleConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SubscriptionBillingCycleEdge>;
  /** A list of nodes that are contained in SubscriptionBillingCycleEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SubscriptionBillingCycle>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `subscriptionBillingCycleContractDraftCommit` mutation. */
export type SubscriptionBillingCycleContractDraftCommitPayload = {
  /** The committed Subscription Billing Cycle Edited Contract object. */
  readonly contract?: Maybe<SubscriptionBillingCycleEditedContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionBillingCycleContractDraftConcatenate` mutation. */
export type SubscriptionBillingCycleContractDraftConcatenatePayload = {
  /** The Subscription Draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionBillingCycleContractEdit` mutation. */
export type SubscriptionBillingCycleContractEditPayload = {
  /** The draft subscription contract object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** An auto-generated type which holds one SubscriptionBillingCycle and a cursor during pagination. */
export type SubscriptionBillingCycleEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SubscriptionBillingCycleEdge. */
  readonly node: SubscriptionBillingCycle;
};

/** Return type for `subscriptionBillingCycleEditDelete` mutation. */
export type SubscriptionBillingCycleEditDeletePayload = {
  /** The list of updated billing cycles. */
  readonly billingCycles?: Maybe<ReadonlyArray<SubscriptionBillingCycle>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionBillingCycleUserError>;
};

/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContract = SubscriptionContractBase & {
  /** The subscription app that the subscription contract is registered to. */
  readonly app?: Maybe<App>;
  /** The URL of the subscription contract page on the subscription app. */
  readonly appAdminUrl?: Maybe<Scalars['URL']>;
  /** The billing cycles that the edited contract belongs to. */
  readonly billingCycles: SubscriptionBillingCycleConnection;
  /** The date and time when the subscription contract was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The currency that's used for the subscription contract. */
  readonly currencyCode: CurrencyCode;
  /** A list of the custom attributes to be added to the generated orders. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The customer to whom the subscription contract belongs. */
  readonly customer?: Maybe<Customer>;
  /** The customer payment method that's used for the subscription contract. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The delivery method for each billing of the subscription contract. */
  readonly deliveryMethod?: Maybe<SubscriptionDeliveryMethod>;
  /** The delivery price for each billing of the subscription contract. */
  readonly deliveryPrice: MoneyV2;
  /** The list of subscription discounts associated with the subscription contract. */
  readonly discounts: SubscriptionManualDiscountConnection;
  /**
   * The number of lines associated with the subscription contract.
   * @deprecated Use `linesCount` instead.
   */
  readonly lineCount: Scalars['Int'];
  /** The list of subscription lines associated with the subscription contract. */
  readonly lines: SubscriptionLineConnection;
  /** The number of lines associated with the subscription contract. */
  readonly linesCount?: Maybe<Count>;
  /** The note field that will be applied to the generated orders. */
  readonly note?: Maybe<Scalars['String']>;
  /** A list of the subscription contract's orders. */
  readonly orders: OrderConnection;
  /** The date and time when the subscription contract was updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractBillingCyclesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<SubscriptionBillingCyclesSortKeys>;
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractCustomerPaymentMethodArgs = {
  showRevoked?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a subscription contract with billing cycles. */
export type SubscriptionBillingCycleEditedContractOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `subscriptionBillingCycleEditsDelete` mutation. */
export type SubscriptionBillingCycleEditsDeletePayload = {
  /** The list of updated billing cycles. */
  readonly billingCycles?: Maybe<ReadonlyArray<SubscriptionBillingCycle>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionBillingCycleUserError>;
};

/** Possible error codes that can be returned by `SubscriptionBillingCycleUserError`. */
export enum SubscriptionBillingCycleErrorCode {
  /** Billing date cannot be set on skipped billing cycle. */
  BILLING_DATE_SET_ON_SKIPPED = 'BILLING_DATE_SET_ON_SKIPPED',
  /** Billing cycle selector cannot select billing cycle outside of index range. */
  CYCLE_INDEX_OUT_OF_RANGE = 'CYCLE_INDEX_OUT_OF_RANGE',
  /** Can't find the billing cycle. */
  CYCLE_NOT_FOUND = 'CYCLE_NOT_FOUND',
  /** Billing cycle selector cannot select billing cycle outside of start date range. */
  CYCLE_START_DATE_OUT_OF_RANGE = 'CYCLE_START_DATE_OUT_OF_RANGE',
  /** Billing cycle schedule edit input provided is empty. Must take in parameters to modify schedule. */
  EMPTY_BILLING_CYCLE_EDIT_SCHEDULE_INPUT = 'EMPTY_BILLING_CYCLE_EDIT_SCHEDULE_INPUT',
  /** Billing cycle has incomplete billing attempts in progress. */
  INCOMPLETE_BILLING_ATTEMPTS = 'INCOMPLETE_BILLING_ATTEMPTS',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The index selector is invalid. */
  INVALID_CYCLE_INDEX = 'INVALID_CYCLE_INDEX',
  /** The date selector is invalid. */
  INVALID_DATE = 'INVALID_DATE',
  /** There's no contract or schedule edit associated with the targeted billing cycle(s). */
  NO_CYCLE_EDITS = 'NO_CYCLE_EDITS',
  /** Billing date of a cycle cannot be set to a value outside of its billing date range. */
  OUT_OF_BOUNDS = 'OUT_OF_BOUNDS',
  /** Billing cycle selector cannot select upcoming billing cycle past limit. */
  UPCOMING_CYCLE_LIMIT_EXCEEDED = 'UPCOMING_CYCLE_LIMIT_EXCEEDED'
}

/** The input fields for specifying the subscription contract and selecting the associated billing cycle. */
export type SubscriptionBillingCycleInput = {
  /** The ID of the subscription contract associated with the billing cycle. */
  readonly contractId: Scalars['ID'];
  /** Selects the billing cycle by date or index. */
  readonly selector: SubscriptionBillingCycleSelector;
};

/** The input fields for parameters to modify the schedule of a specific billing cycle. */
export type SubscriptionBillingCycleScheduleEditInput = {
  /** Sets the expected billing date for the billing cycle. */
  readonly billingDate?: InputMaybe<Scalars['DateTime']>;
  /** The reason for editing. */
  readonly reason: SubscriptionBillingCycleScheduleEditInputScheduleEditReason;
  /** Sets the skip status for the billing cycle. */
  readonly skip?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields for possible reasons for editing the billing cycle's schedule. */
export enum SubscriptionBillingCycleScheduleEditInputScheduleEditReason {
  /** Buyer initiated the schedule edit. */
  BUYER_INITIATED = 'BUYER_INITIATED',
  /** Developer initiated the schedule edit. */
  DEV_INITIATED = 'DEV_INITIATED',
  /** Merchant initiated the schedule edit. */
  MERCHANT_INITIATED = 'MERCHANT_INITIATED'
}

/** Return type for `subscriptionBillingCycleScheduleEdit` mutation. */
export type SubscriptionBillingCycleScheduleEditPayload = {
  /** The updated billing cycle. */
  readonly billingCycle?: Maybe<SubscriptionBillingCycle>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionBillingCycleUserError>;
};

/** The input fields to select SubscriptionBillingCycle by either date or index. */
export type SubscriptionBillingCycleSelector = {
  /** Returns a billing cycle by date. */
  readonly date?: InputMaybe<Scalars['DateTime']>;
  /** Returns a billing cycle by index. */
  readonly index?: InputMaybe<Scalars['Int']>;
};

/** Return type for `subscriptionBillingCycleSkip` mutation. */
export type SubscriptionBillingCycleSkipPayload = {
  /** The updated billing cycle. */
  readonly billingCycle?: Maybe<SubscriptionBillingCycle>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionBillingCycleSkipUserError>;
};

/** An error that occurs during the execution of `SubscriptionBillingCycleSkip`. */
export type SubscriptionBillingCycleSkipUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<SubscriptionBillingCycleSkipUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `SubscriptionBillingCycleSkipUserError`. */
export enum SubscriptionBillingCycleSkipUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Return type for `subscriptionBillingCycleUnskip` mutation. */
export type SubscriptionBillingCycleUnskipPayload = {
  /** The updated billing cycle. */
  readonly billingCycle?: Maybe<SubscriptionBillingCycle>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionBillingCycleUnskipUserError>;
};

/** An error that occurs during the execution of `SubscriptionBillingCycleUnskip`. */
export type SubscriptionBillingCycleUnskipUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<SubscriptionBillingCycleUnskipUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `SubscriptionBillingCycleUnskipUserError`. */
export enum SubscriptionBillingCycleUnskipUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** The possible errors for a subscription billing cycle. */
export type SubscriptionBillingCycleUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<SubscriptionBillingCycleErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** The input fields to select a subset of subscription billing cycles within a date range. */
export type SubscriptionBillingCyclesDateRangeSelector = {
  /** The end date and time for the range. */
  readonly endDate: Scalars['DateTime'];
  /** The start date and time for the range. */
  readonly startDate: Scalars['DateTime'];
};

/** The input fields to select a subset of subscription billing cycles within an index range. */
export type SubscriptionBillingCyclesIndexRangeSelector = {
  /** The end index for the range. */
  readonly endIndex: Scalars['Int'];
  /** The start index for the range. */
  readonly startIndex: Scalars['Int'];
};

/** The set of valid sort keys for the SubscriptionBillingCycles query. */
export enum SubscriptionBillingCyclesSortKeys {
  /** Sort by the `cycle_index` value. */
  CYCLE_INDEX = 'CYCLE_INDEX',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** Select subscription billing cycles to be targeted. */
export enum SubscriptionBillingCyclesTargetSelection {
  /** Target all current and upcoming subscription billing cycles. */
  ALL = 'ALL'
}

/** Represents a Subscription Billing Policy. */
export type SubscriptionBillingPolicy = {
  /** Specific anchor dates upon which the billing interval calculations should be made. */
  readonly anchors: ReadonlyArray<SellingPlanAnchor>;
  /** The kind of interval that's associated with this schedule (e.g. Monthly, Weekly, etc). */
  readonly interval: SellingPlanInterval;
  /** The number of billing intervals between invoices. */
  readonly intervalCount: Scalars['Int'];
  /** Maximum amount of cycles after which the subscription ends. */
  readonly maxCycles?: Maybe<Scalars['Int']>;
  /** Minimum amount of cycles required in the subscription. */
  readonly minCycles?: Maybe<Scalars['Int']>;
};

/** The input fields for a Subscription Billing Policy. */
export type SubscriptionBillingPolicyInput = {
  /** Specific anchor dates upon which the billing interval calculations should be made. */
  readonly anchors?: InputMaybe<ReadonlyArray<SellingPlanAnchorInput>>;
  /** The kind of interval that's associated with this schedule (e.g. Monthly, Weekly, etc). */
  readonly interval: SellingPlanInterval;
  /** The number of billing intervals between invoices. */
  readonly intervalCount: Scalars['Int'];
  /** Maximum amount of cycles required in the subscription. */
  readonly maxCycles?: InputMaybe<Scalars['Int']>;
  /** Minimum amount of cycles required in the subscription. */
  readonly minCycles?: InputMaybe<Scalars['Int']>;
};

/** Represents a Subscription Contract. */
export type SubscriptionContract = Node & SubscriptionContractBase & {
  /** The subscription app that the subscription contract is registered to. */
  readonly app?: Maybe<App>;
  /** The URL of the subscription contract page on the subscription app. */
  readonly appAdminUrl?: Maybe<Scalars['URL']>;
  /** The list of billing attempts associated with the subscription contract. */
  readonly billingAttempts: SubscriptionBillingAttemptConnection;
  /** The billing policy associated with the subscription contract. */
  readonly billingPolicy: SubscriptionBillingPolicy;
  /** The date and time when the subscription contract was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The currency that's used for the subscription contract. */
  readonly currencyCode: CurrencyCode;
  /** A list of the custom attributes to be added to the generated orders. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The customer to whom the subscription contract belongs. */
  readonly customer?: Maybe<Customer>;
  /** The customer payment method that's used for the subscription contract. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The delivery method for each billing of the subscription contract. */
  readonly deliveryMethod?: Maybe<SubscriptionDeliveryMethod>;
  /** The delivery policy associated with the subscription contract. */
  readonly deliveryPolicy: SubscriptionDeliveryPolicy;
  /** The delivery price for each billing of the subscription contract. */
  readonly deliveryPrice: MoneyV2;
  /** The list of subscription discounts associated with the subscription contract. */
  readonly discounts: SubscriptionManualDiscountConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The last billing error type of the contract. */
  readonly lastBillingAttemptErrorType?: Maybe<SubscriptionContractLastBillingErrorType>;
  /** The current status of the last payment. */
  readonly lastPaymentStatus?: Maybe<SubscriptionContractLastPaymentStatus>;
  /**
   * The number of lines associated with the subscription contract.
   * @deprecated Use `linesCount` instead.
   */
  readonly lineCount: Scalars['Int'];
  /** The list of subscription lines associated with the subscription contract. */
  readonly lines: SubscriptionLineConnection;
  /** The number of lines associated with the subscription contract. */
  readonly linesCount?: Maybe<Count>;
  /**
   * The next billing date for the subscription contract. This field is managed by the apps.
   *         Alternatively you can utilize our
   *         [Billing Cycles APIs](https://shopify.dev/docs/apps/selling-strategies/subscriptions/billing-cycles),
   *         which provide auto-computed billing dates and additional functionalities.
   */
  readonly nextBillingDate?: Maybe<Scalars['DateTime']>;
  /** The note field that will be applied to the generated orders. */
  readonly note?: Maybe<Scalars['String']>;
  /** A list of the subscription contract's orders. */
  readonly orders: OrderConnection;
  /** The order from which this contract originated. */
  readonly originOrder?: Maybe<Order>;
  /** The revision id of the contract. */
  readonly revisionId: Scalars['UnsignedInt64'];
  /** The current status of the subscription contract. */
  readonly status: SubscriptionContractSubscriptionStatus;
  /** The date and time when the subscription contract was updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** Represents a Subscription Contract. */
export type SubscriptionContractBillingAttemptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Contract. */
export type SubscriptionContractCustomerPaymentMethodArgs = {
  showRevoked?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Contract. */
export type SubscriptionContractDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Contract. */
export type SubscriptionContractLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Contract. */
export type SubscriptionContractOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `subscriptionContractActivate` mutation. */
export type SubscriptionContractActivatePayload = {
  /** The new Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionContractStatusUpdateUserError>;
};

/** The input fields required to create a Subscription Contract. */
export type SubscriptionContractAtomicCreateInput = {
  /** The attributes used as input for the Subscription Draft. */
  readonly contract: SubscriptionDraftInput;
  /** The currency used for the subscription contract. */
  readonly currencyCode: CurrencyCode;
  /** The ID of the customer to associate with the subscription contract. */
  readonly customerId: Scalars['ID'];
  /** A list of discount redeem codes to apply to the subscription contract. */
  readonly discountCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** A list of new Subscription Lines. */
  readonly lines: ReadonlyArray<SubscriptionAtomicLineInput>;
  /** The next billing date for the subscription contract.This field is independent of billing cycles.It stores metadata set by the apps, and thus not managed by Shopify.It can be queried from subscriptionContract.nextBillingDate. */
  readonly nextBillingDate: Scalars['DateTime'];
};

/** Return type for `subscriptionContractAtomicCreate` mutation. */
export type SubscriptionContractAtomicCreatePayload = {
  /** The new Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Represents subscription contract common fields. */
export type SubscriptionContractBase = {
  /** The subscription app that the subscription contract is registered to. */
  readonly app?: Maybe<App>;
  /** The URL of the subscription contract page on the subscription app. */
  readonly appAdminUrl?: Maybe<Scalars['URL']>;
  /** The currency that's used for the subscription contract. */
  readonly currencyCode: CurrencyCode;
  /** A list of the custom attributes to be added to the generated orders. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The customer to whom the subscription contract belongs. */
  readonly customer?: Maybe<Customer>;
  /** The customer payment method that's used for the subscription contract. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The delivery method for each billing of the subscription contract. */
  readonly deliveryMethod?: Maybe<SubscriptionDeliveryMethod>;
  /** The delivery price for each billing of the subscription contract. */
  readonly deliveryPrice: MoneyV2;
  /** The list of subscription discounts associated with the subscription contract. */
  readonly discounts: SubscriptionManualDiscountConnection;
  /**
   * The number of lines associated with the subscription contract.
   * @deprecated Use `linesCount` instead.
   */
  readonly lineCount: Scalars['Int'];
  /** The list of subscription lines associated with the subscription contract. */
  readonly lines: SubscriptionLineConnection;
  /** The number of lines associated with the subscription contract. */
  readonly linesCount?: Maybe<Count>;
  /** The note field that will be applied to the generated orders. */
  readonly note?: Maybe<Scalars['String']>;
  /** A list of the subscription contract's orders. */
  readonly orders: OrderConnection;
  /** The date and time when the subscription contract was updated. */
  readonly updatedAt: Scalars['DateTime'];
};


/** Represents subscription contract common fields. */
export type SubscriptionContractBaseCustomerPaymentMethodArgs = {
  showRevoked?: InputMaybe<Scalars['Boolean']>;
};


/** Represents subscription contract common fields. */
export type SubscriptionContractBaseDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents subscription contract common fields. */
export type SubscriptionContractBaseLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents subscription contract common fields. */
export type SubscriptionContractBaseOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** Return type for `subscriptionContractCancel` mutation. */
export type SubscriptionContractCancelPayload = {
  /** The new Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionContractStatusUpdateUserError>;
};

/** An auto-generated type for paginating through multiple SubscriptionContracts. */
export type SubscriptionContractConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SubscriptionContractEdge>;
  /** A list of nodes that are contained in SubscriptionContractEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SubscriptionContract>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields required to create a Subscription Contract. */
export type SubscriptionContractCreateInput = {
  /** The attributes used as input for the Subscription Draft. */
  readonly contract: SubscriptionDraftInput;
  /** The currency used for the subscription contract. */
  readonly currencyCode: CurrencyCode;
  /** The ID of the customer to associate with the subscription contract. */
  readonly customerId: Scalars['ID'];
  /** The next billing date for the subscription contract. */
  readonly nextBillingDate: Scalars['DateTime'];
};

/** Return type for `subscriptionContractCreate` mutation. */
export type SubscriptionContractCreatePayload = {
  /** The Subscription Contract object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** An auto-generated type which holds one SubscriptionContract and a cursor during pagination. */
export type SubscriptionContractEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SubscriptionContractEdge. */
  readonly node: SubscriptionContract;
};

/** Possible error codes that can be returned by `SubscriptionContractUserError`. */
export enum SubscriptionContractErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Return type for `subscriptionContractExpire` mutation. */
export type SubscriptionContractExpirePayload = {
  /** The new Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionContractStatusUpdateUserError>;
};

/** Return type for `subscriptionContractFail` mutation. */
export type SubscriptionContractFailPayload = {
  /** The new Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionContractStatusUpdateUserError>;
};

/** The possible values of the last billing error on a subscription contract. */
export enum SubscriptionContractLastBillingErrorType {
  /** Subscription billing attempt error due to customer error. */
  CUSTOMER_ERROR = 'CUSTOMER_ERROR',
  /** Subscription billing attempt error due to inventory error. */
  INVENTORY_ERROR = 'INVENTORY_ERROR',
  /** All other billing attempt errors. */
  OTHER = 'OTHER',
  /** Subscription billing attempt error due to payment error. */
  PAYMENT_ERROR = 'PAYMENT_ERROR'
}

/** The possible status values of the last payment on a subscription contract. */
export enum SubscriptionContractLastPaymentStatus {
  /** Failed subscription billing attempt. */
  FAILED = 'FAILED',
  /** Successful subscription billing attempt. */
  SUCCEEDED = 'SUCCEEDED'
}

/** Return type for `subscriptionContractPause` mutation. */
export type SubscriptionContractPausePayload = {
  /** The new Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionContractStatusUpdateUserError>;
};

/** The input fields required to create a Subscription Contract. */
export type SubscriptionContractProductChangeInput = {
  /** The price of the product. */
  readonly currentPrice?: InputMaybe<Scalars['Decimal']>;
  /** The ID of the product variant the subscription line refers to. */
  readonly productVariantId?: InputMaybe<Scalars['ID']>;
};

/** Return type for `subscriptionContractProductChange` mutation. */
export type SubscriptionContractProductChangePayload = {
  /** The new Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The updated Subscription Line. */
  readonly lineUpdated?: Maybe<SubscriptionLine>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionContractSetNextBillingDate` mutation. */
export type SubscriptionContractSetNextBillingDatePayload = {
  /** The updated Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionContractUserError>;
};

/** Possible error codes that can be returned by `SubscriptionContractStatusUpdateUserError`. */
export enum SubscriptionContractStatusUpdateErrorCode {
  /** Subscription contract status cannot be changed once terminated. */
  CONTRACT_TERMINATED = 'CONTRACT_TERMINATED',
  /** The input value is invalid. */
  INVALID = 'INVALID'
}

/** Represents a subscription contract status update error. */
export type SubscriptionContractStatusUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<SubscriptionContractStatusUpdateErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** The possible status values of a subscription. */
export enum SubscriptionContractSubscriptionStatus {
  /** The contract is active and continuing per its policies. */
  ACTIVE = 'ACTIVE',
  /** The contract was ended by an unplanned customer action. */
  CANCELLED = 'CANCELLED',
  /** The contract has ended per the expected circumstances. All billing and deliverycycles of the subscriptions were executed. */
  EXPIRED = 'EXPIRED',
  /** The contract ended because billing failed and no further billing attempts are expected. */
  FAILED = 'FAILED',
  /** The contract is temporarily paused and is expected to resume in the future. */
  PAUSED = 'PAUSED'
}

/** Return type for `subscriptionContractUpdate` mutation. */
export type SubscriptionContractUpdatePayload = {
  /** The Subscription Contract object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Represents a Subscription Contract error. */
export type SubscriptionContractUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<SubscriptionContractErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Represents a Subscription Line Pricing Cycle Adjustment. */
export type SubscriptionCyclePriceAdjustment = {
  /** Price adjustment type. */
  readonly adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** Price adjustment value. */
  readonly adjustmentValue: SellingPlanPricingPolicyAdjustmentValue;
  /** The number of cycles required before this pricing policy applies. */
  readonly afterCycle: Scalars['Int'];
  /** The computed price after the adjustments applied. */
  readonly computedPrice: MoneyV2;
};

/** Describes the delivery method to use to get the physical goods to the customer. */
export type SubscriptionDeliveryMethod = SubscriptionDeliveryMethodLocalDelivery | SubscriptionDeliveryMethodPickup | SubscriptionDeliveryMethodShipping;

/**
 * Specifies delivery method fields for a subscription draft.
 * This is an input union: one, and only one, field can be provided.
 * The field provided will determine which delivery method is to be used.
 */
export type SubscriptionDeliveryMethodInput = {
  /** The input fields for the local delivery method. */
  readonly localDelivery?: InputMaybe<SubscriptionDeliveryMethodLocalDeliveryInput>;
  /** The input fields for the pickup delivery method. */
  readonly pickup?: InputMaybe<SubscriptionDeliveryMethodPickupInput>;
  /** The input fields for the shipping delivery method. */
  readonly shipping?: InputMaybe<SubscriptionDeliveryMethodShippingInput>;
};

/**
 * A subscription delivery method for local delivery.
 * The other subscription delivery methods can be found in the `SubscriptionDeliveryMethod` union type.
 */
export type SubscriptionDeliveryMethodLocalDelivery = {
  /** The address to deliver to. */
  readonly address: SubscriptionMailingAddress;
  /** The details of the local delivery method to use. */
  readonly localDeliveryOption: SubscriptionDeliveryMethodLocalDeliveryOption;
};

/**
 * The input fields for a local delivery method.
 *
 * This input accepts partial input. When a field is not provided,
 * its prior value is left unchanged.
 */
export type SubscriptionDeliveryMethodLocalDeliveryInput = {
  /** The address to deliver to. */
  readonly address?: InputMaybe<MailingAddressInput>;
  /** The details of the local delivery method to use. */
  readonly localDeliveryOption?: InputMaybe<SubscriptionDeliveryMethodLocalDeliveryOptionInput>;
};

/** The selected delivery option on a subscription contract. */
export type SubscriptionDeliveryMethodLocalDeliveryOption = {
  /** A custom reference to the delivery method for use with automations. */
  readonly code?: Maybe<Scalars['String']>;
  /** The details displayed to the customer to describe the local delivery option. */
  readonly description?: Maybe<Scalars['String']>;
  /** The delivery instructions that the customer can provide to the merchant. */
  readonly instructions?: Maybe<Scalars['String']>;
  /**
   * The phone number that the customer provided to the merchant.
   * Formatted using E.164 standard. For example, `+16135551111`.
   */
  readonly phone: Scalars['String'];
  /** The presentment title of the local delivery option. */
  readonly presentmentTitle?: Maybe<Scalars['String']>;
  /** The title of the local delivery option. */
  readonly title?: Maybe<Scalars['String']>;
};

/** The input fields for local delivery option. */
export type SubscriptionDeliveryMethodLocalDeliveryOptionInput = {
  /** A custom reference to the delivery method for use with automations. */
  readonly code?: InputMaybe<Scalars['String']>;
  /** The details displayed to the customer to describe the local delivery option. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** The delivery instructions that the customer can provide to the merchant. */
  readonly instructions?: InputMaybe<Scalars['String']>;
  /**
   * The phone number that the customer must provide to the merchant.
   * Formatted using E.164 standard. For example, `+16135551111`.
   */
  readonly phone: Scalars['String'];
  /** The presentment title of the local delivery option. */
  readonly presentmentTitle?: InputMaybe<Scalars['String']>;
  /** The title of the local delivery option. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** A delivery method with a pickup option. */
export type SubscriptionDeliveryMethodPickup = {
  /** The details of the pickup delivery method to use. */
  readonly pickupOption: SubscriptionDeliveryMethodPickupOption;
};

/**
 * The input fields for a pickup delivery method.
 *
 * This input accepts partial input. When a field is not provided,
 * its prior value is left unchanged.
 */
export type SubscriptionDeliveryMethodPickupInput = {
  /** The details of the pickup method to use. */
  readonly pickupOption?: InputMaybe<SubscriptionDeliveryMethodPickupOptionInput>;
};

/** Represents the selected pickup option on a subscription contract. */
export type SubscriptionDeliveryMethodPickupOption = {
  /** A custom reference to the delivery method for use with automations. */
  readonly code?: Maybe<Scalars['String']>;
  /** The details displayed to the customer to describe the pickup option. */
  readonly description?: Maybe<Scalars['String']>;
  /** The location where the customer will pick up the merchandise. */
  readonly location: Location;
  /** The presentment title of the pickup option. */
  readonly presentmentTitle?: Maybe<Scalars['String']>;
  /** The title of the pickup option. */
  readonly title?: Maybe<Scalars['String']>;
};

/** The input fields for pickup option. */
export type SubscriptionDeliveryMethodPickupOptionInput = {
  /** A custom reference to the delivery method for use with automations. */
  readonly code?: InputMaybe<Scalars['String']>;
  /** The details displayed to the customer to describe the pickup option. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** The ID of the pickup location. */
  readonly locationId: Scalars['ID'];
  /** The presentment title of the pickup option. */
  readonly presentmentTitle?: InputMaybe<Scalars['String']>;
  /** The title of the pickup option. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Represents a shipping delivery method: a mailing address and a shipping option. */
export type SubscriptionDeliveryMethodShipping = {
  /** The address to ship to. */
  readonly address: SubscriptionMailingAddress;
  /** The details of the shipping method to use. */
  readonly shippingOption: SubscriptionDeliveryMethodShippingOption;
};

/**
 * Specifies shipping delivery method fields.
 *
 * This input accepts partial input. When a field is not provided,
 * its prior value is left unchanged.
 */
export type SubscriptionDeliveryMethodShippingInput = {
  /** The address to ship to. */
  readonly address?: InputMaybe<MailingAddressInput>;
  /** The details of the shipping method to use. */
  readonly shippingOption?: InputMaybe<SubscriptionDeliveryMethodShippingOptionInput>;
};

/** Represents the selected shipping option on a subscription contract. */
export type SubscriptionDeliveryMethodShippingOption = {
  /**
   * The carrier service that's providing this shipping option.
   * This field isn't currently supported and returns null.
   * @deprecated This field has never been implemented.
   */
  readonly carrierService?: Maybe<DeliveryCarrierService>;
  /** The code of the shipping option. */
  readonly code?: Maybe<Scalars['String']>;
  /** The description of the shipping option. */
  readonly description?: Maybe<Scalars['String']>;
  /** The presentment title of the shipping option. */
  readonly presentmentTitle?: Maybe<Scalars['String']>;
  /** The title of the shipping option. */
  readonly title?: Maybe<Scalars['String']>;
};

/** The input fields for shipping option. */
export type SubscriptionDeliveryMethodShippingOptionInput = {
  /** The carrier service ID of the shipping option. */
  readonly carrierServiceId?: InputMaybe<Scalars['ID']>;
  /** The code of the shipping option. */
  readonly code?: InputMaybe<Scalars['String']>;
  /** The description of the shipping option. */
  readonly description?: InputMaybe<Scalars['String']>;
  /** The presentment title of the shipping option. */
  readonly presentmentTitle?: InputMaybe<Scalars['String']>;
  /** The title of the shipping option. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** The delivery option for a subscription contract. */
export type SubscriptionDeliveryOption = SubscriptionLocalDeliveryOption | SubscriptionPickupOption | SubscriptionShippingOption;

/** The result of the query to fetch delivery options for the subscription contract. */
export type SubscriptionDeliveryOptionResult = SubscriptionDeliveryOptionResultFailure | SubscriptionDeliveryOptionResultSuccess;

/** A failure to find the available delivery options for a subscription contract. */
export type SubscriptionDeliveryOptionResultFailure = {
  /** The reason for the failure. */
  readonly message?: Maybe<Scalars['String']>;
};

/** The delivery option for a subscription contract. */
export type SubscriptionDeliveryOptionResultSuccess = {
  /** The available delivery options. */
  readonly deliveryOptions: ReadonlyArray<SubscriptionDeliveryOption>;
};

/** Represents a Subscription Delivery Policy. */
export type SubscriptionDeliveryPolicy = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  readonly anchors: ReadonlyArray<SellingPlanAnchor>;
  /** The kind of interval that's associated with this schedule (e.g. Monthly, Weekly, etc). */
  readonly interval: SellingPlanInterval;
  /** The number of delivery intervals between deliveries. */
  readonly intervalCount: Scalars['Int'];
};

/** The input fields for a Subscription Delivery Policy. */
export type SubscriptionDeliveryPolicyInput = {
  /** The specific anchor dates upon which the delivery interval calculations should be made. */
  readonly anchors?: InputMaybe<ReadonlyArray<SellingPlanAnchorInput>>;
  /** The kind of interval that's associated with this schedule (e.g. Monthly, Weekly, etc). */
  readonly interval: SellingPlanInterval;
  /** The number of billing intervals between invoices. */
  readonly intervalCount: Scalars['Int'];
};

/** Subscription draft discount types. */
export type SubscriptionDiscount = SubscriptionAppliedCodeDiscount | SubscriptionManualDiscount;

/** Represents what a particular discount reduces from a line price. */
export type SubscriptionDiscountAllocation = {
  /** Allocation amount. */
  readonly amount: MoneyV2;
  /** Discount that created the allocation. */
  readonly discount: SubscriptionDiscount;
};

/** An auto-generated type for paginating through multiple SubscriptionDiscounts. */
export type SubscriptionDiscountConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SubscriptionDiscountEdge>;
  /** A list of nodes that are contained in SubscriptionDiscountEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SubscriptionDiscount>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one SubscriptionDiscount and a cursor during pagination. */
export type SubscriptionDiscountEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SubscriptionDiscountEdge. */
  readonly node: SubscriptionDiscount;
};

/** Represents the subscription lines the discount applies on. */
export type SubscriptionDiscountEntitledLines = {
  /** Specify whether the subscription discount will apply on all subscription lines. */
  readonly all: Scalars['Boolean'];
  /** The list of subscription lines associated with the subscription discount. */
  readonly lines: SubscriptionLineConnection;
};


/** Represents the subscription lines the discount applies on. */
export type SubscriptionDiscountEntitledLinesLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** The value of the discount and how it will be applied. */
export type SubscriptionDiscountFixedAmountValue = {
  /** The fixed amount value of the discount. */
  readonly amount: MoneyV2;
  /** Whether the amount is applied per item. */
  readonly appliesOnEachItem: Scalars['Boolean'];
};

/** The percentage value of the discount. */
export type SubscriptionDiscountPercentageValue = {
  /** The percentage value of the discount. */
  readonly percentage: Scalars['Int'];
};

/** The reason a discount on a subscription draft was rejected. */
export enum SubscriptionDiscountRejectionReason {
  /** Discount is inactive. */
  CURRENTLY_INACTIVE = 'CURRENTLY_INACTIVE',
  /** Given customer does not qualify for the discount. */
  CUSTOMER_NOT_ELIGIBLE = 'CUSTOMER_NOT_ELIGIBLE',
  /** Customer usage limit has been reached. */
  CUSTOMER_USAGE_LIMIT_REACHED = 'CUSTOMER_USAGE_LIMIT_REACHED',
  /** Purchase type does not qualify for the discount. */
  INCOMPATIBLE_PURCHASE_TYPE = 'INCOMPATIBLE_PURCHASE_TYPE',
  /** Internal error during discount code validation. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** Discount code is not found. */
  NOT_FOUND = 'NOT_FOUND',
  /** Discount does not apply to any of the given line items. */
  NO_ENTITLED_LINE_ITEMS = 'NO_ENTITLED_LINE_ITEMS',
  /** No applicable shipping lines. */
  NO_ENTITLED_SHIPPING_LINES = 'NO_ENTITLED_SHIPPING_LINES',
  /** Purchase amount of items does not qualify for the discount. */
  PURCHASE_NOT_IN_RANGE = 'PURCHASE_NOT_IN_RANGE',
  /** Quantity of items does not qualify for the discount. */
  QUANTITY_NOT_IN_RANGE = 'QUANTITY_NOT_IN_RANGE',
  /** Discount usage limit has been reached. */
  USAGE_LIMIT_REACHED = 'USAGE_LIMIT_REACHED'
}

/** The value of the discount and how it will be applied. */
export type SubscriptionDiscountValue = SubscriptionDiscountFixedAmountValue | SubscriptionDiscountPercentageValue;

/** Represents a Subscription Draft. */
export type SubscriptionDraft = Node & {
  /** The billing cycle that the subscription contract will be associated with. */
  readonly billingCycle?: Maybe<SubscriptionBillingCycle>;
  /** The billing policy for the subscription contract. */
  readonly billingPolicy: SubscriptionBillingPolicy;
  /** The billing cycles of the contracts that will be concatenated to the subscription contract. */
  readonly concatenatedBillingCycles: SubscriptionBillingCycleConnection;
  /** The currency used for the subscription contract. */
  readonly currencyCode: CurrencyCode;
  /** A list of the custom attributes to be added to the generated orders. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** The customer to whom the subscription contract belongs. */
  readonly customer: Customer;
  /** The customer payment method used for the subscription contract. */
  readonly customerPaymentMethod?: Maybe<CustomerPaymentMethod>;
  /** The delivery method for each billing of the subscription contract. */
  readonly deliveryMethod?: Maybe<SubscriptionDeliveryMethod>;
  /** The available delivery options for a given delivery address. Returns `null` for pending requests. */
  readonly deliveryOptions?: Maybe<SubscriptionDeliveryOptionResult>;
  /** The delivery policy for the subscription contract. */
  readonly deliveryPolicy: SubscriptionDeliveryPolicy;
  /** The delivery price for each billing the subscription contract. */
  readonly deliveryPrice?: Maybe<MoneyV2>;
  /** The list of subscription discounts which will be associated with the subscription contract. */
  readonly discounts: SubscriptionDiscountConnection;
  /** The list of subscription discounts to be added to the subscription contract. */
  readonly discountsAdded: SubscriptionDiscountConnection;
  /** The list of subscription discounts to be removed from the subscription contract. */
  readonly discountsRemoved: SubscriptionDiscountConnection;
  /** The list of subscription discounts to be updated on the subscription contract. */
  readonly discountsUpdated: SubscriptionDiscountConnection;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The list of subscription lines which will be associated with the subscription contract. */
  readonly lines: SubscriptionLineConnection;
  /** The list of subscription lines to be added to the subscription contract. */
  readonly linesAdded: SubscriptionLineConnection;
  /** The list of subscription lines to be removed from the subscription contract. */
  readonly linesRemoved: SubscriptionLineConnection;
  /** The next billing date for the subscription contract. */
  readonly nextBillingDate?: Maybe<Scalars['DateTime']>;
  /** The note field that will be applied to the generated orders. */
  readonly note?: Maybe<Scalars['String']>;
  /** The original subscription contract. */
  readonly originalContract?: Maybe<SubscriptionContract>;
  /**
   * Available Shipping Options for a given delivery address. Returns NULL for pending requests.
   * @deprecated Use `deliveryOptions` instead.
   */
  readonly shippingOptions?: Maybe<SubscriptionShippingOptionResult>;
  /** The current status of the subscription contract. */
  readonly status?: Maybe<SubscriptionContractSubscriptionStatus>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftConcatenatedBillingCyclesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<SubscriptionBillingCyclesSortKeys>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftCustomerPaymentMethodArgs = {
  showRevoked?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftDeliveryOptionsArgs = {
  deliveryAddress?: InputMaybe<MailingAddressInput>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftDiscountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftDiscountsAddedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftDiscountsRemovedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftDiscountsUpdatedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftLinesAddedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftLinesRemovedArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** Represents a Subscription Draft. */
export type SubscriptionDraftShippingOptionsArgs = {
  deliveryAddress?: InputMaybe<MailingAddressInput>;
};

/** Return type for `subscriptionDraftCommit` mutation. */
export type SubscriptionDraftCommitPayload = {
  /** The updated Subscription Contract object. */
  readonly contract?: Maybe<SubscriptionContract>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftDiscountAdd` mutation. */
export type SubscriptionDraftDiscountAddPayload = {
  /** The added Subscription Discount. */
  readonly discountAdded?: Maybe<SubscriptionManualDiscount>;
  /** The Subscription Contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftDiscountCodeApply` mutation. */
export type SubscriptionDraftDiscountCodeApplyPayload = {
  /** The added subscription discount. */
  readonly appliedDiscount?: Maybe<SubscriptionAppliedCodeDiscount>;
  /** The subscription contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftDiscountRemove` mutation. */
export type SubscriptionDraftDiscountRemovePayload = {
  /** The removed subscription draft discount. */
  readonly discountRemoved?: Maybe<SubscriptionDiscount>;
  /** The subscription contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftDiscountUpdate` mutation. */
export type SubscriptionDraftDiscountUpdatePayload = {
  /** The updated Subscription Discount. */
  readonly discountUpdated?: Maybe<SubscriptionManualDiscount>;
  /** The Subscription Contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Possible error codes that can be returned by `SubscriptionDraftUserError`. */
export enum SubscriptionDraftErrorCode {
  /** This line has already been removed. */
  ALREADY_REMOVED = 'ALREADY_REMOVED',
  /** Cannot commit a contract draft with this mutation. Please use SubscriptionDraftCommit. */
  BILLING_CYCLE_ABSENT = 'BILLING_CYCLE_ABSENT',
  /** Billing policy cannot be updated for billing cycle contract drafts. */
  BILLING_CYCLE_CONTRACT_DRAFT_BILLING_POLICY_INVALID = 'BILLING_CYCLE_CONTRACT_DRAFT_BILLING_POLICY_INVALID',
  /** Delivery policy cannot be updated for billing cycle contract drafts. */
  BILLING_CYCLE_CONTRACT_DRAFT_DELIVERY_POLICY_INVALID = 'BILLING_CYCLE_CONTRACT_DRAFT_DELIVERY_POLICY_INVALID',
  /** Cannot commit a billing cycle contract draft with this mutation. Please use SubscriptionBillingCycleContractDraftCommit. */
  BILLING_CYCLE_PRESENT = 'BILLING_CYCLE_PRESENT',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Subscription draft has been already committed. */
  COMMITTED = 'COMMITTED',
  /** Contract draft must be a billing cycle contract draft for contract concatenation. */
  CONCATENATION_BILLING_CYCLE_CONTRACT_DRAFT_REQUIRED = 'CONCATENATION_BILLING_CYCLE_CONTRACT_DRAFT_REQUIRED',
  /** Cannot concatenate a contract draft from subscriptionContractCreate mutation. */
  CONCATENATION_UNCOMMITTED_CONTRACT_DRAFT = 'CONCATENATION_UNCOMMITTED_CONTRACT_DRAFT',
  /** Currency is not enabled. */
  CURRENCY_NOT_ENABLED = 'CURRENCY_NOT_ENABLED',
  /** The customer doesn't exist. */
  CUSTOMER_DOES_NOT_EXIST = 'CUSTOMER_DOES_NOT_EXIST',
  /** The payment method customer must be the same as the contract customer. */
  CUSTOMER_MISMATCH = 'CUSTOMER_MISMATCH',
  /** Customer is scheduled for redaction or has been redacted. */
  CUSTOMER_REDACTED = 'CUSTOMER_REDACTED',
  /** The after cycle attribute must be unique between cycle discounts. */
  CYCLE_DISCOUNTS_UNIQUE_AFTER_CYCLE = 'CYCLE_DISCOUNTS_UNIQUE_AFTER_CYCLE',
  /** Billing cycle selector cannot select billing cycle outside of index range. */
  CYCLE_INDEX_OUT_OF_RANGE = 'CYCLE_INDEX_OUT_OF_RANGE',
  /** Billing cycle selector requires exactly one of index or date to be provided. */
  CYCLE_SELECTOR_VALIDATE_ONE_OF = 'CYCLE_SELECTOR_VALIDATE_ONE_OF',
  /** Billing cycle selector cannot select billing cycle outside of start date range. */
  CYCLE_START_DATE_OUT_OF_RANGE = 'CYCLE_START_DATE_OUT_OF_RANGE',
  /** The delivery method can't be blank if any lines require shipping. */
  DELIVERY_METHOD_REQUIRED = 'DELIVERY_METHOD_REQUIRED',
  /** The delivery policy interval must be a multiple of the billing policy interval. */
  DELIVERY_MUST_BE_MULTIPLE_OF_BILLING = 'DELIVERY_MUST_BE_MULTIPLE_OF_BILLING',
  /** Concatenated contracts cannot contain duplicate subscription contracts. */
  DUPLICATE_CONCATENATED_CONTRACTS = 'DUPLICATE_CONCATENATED_CONTRACTS',
  /** Maximum number of concatenated contracts on a billing cycle contract draft exceeded. */
  EXCEEDED_MAX_CONCATENATED_CONTRACTS = 'EXCEEDED_MAX_CONCATENATED_CONTRACTS',
  /** The input value should be greater than the minimum allowed value. */
  GREATER_THAN = 'GREATER_THAN',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  /** Cannot update a subscription contract with a current or upcoming billing cycle contract edit. */
  HAS_FUTURE_EDITS = 'HAS_FUTURE_EDITS',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The adjustment value must the same type as the adjustment type. */
  INVALID_ADJUSTMENT_TYPE = 'INVALID_ADJUSTMENT_TYPE',
  /** The adjustment value must be either fixed_value or percentage. */
  INVALID_ADJUSTMENT_VALUE = 'INVALID_ADJUSTMENT_VALUE',
  /** Next billing date is invalid. */
  INVALID_BILLING_DATE = 'INVALID_BILLING_DATE',
  /** Must have at least one line. */
  INVALID_LINES = 'INVALID_LINES',
  /** Note length is too long. */
  INVALID_NOTE_LENGTH = 'INVALID_NOTE_LENGTH',
  /** The input value should be less than the maximum value allowed. */
  LESS_THAN = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  /** Customer payment method is required. */
  MISSING_CUSTOMER_PAYMENT_METHOD = 'MISSING_CUSTOMER_PAYMENT_METHOD',
  /** The local delivery options must be set for local delivery. */
  MISSING_LOCAL_DELIVERY_OPTIONS = 'MISSING_LOCAL_DELIVERY_OPTIONS',
  /** The value is not an integer. */
  NOT_AN_INTEGER = 'NOT_AN_INTEGER',
  /** Value is not in range. */
  NOT_IN_RANGE = 'NOT_IN_RANGE',
  /** Discount must have at least one entitled line. */
  NO_ENTITLED_LINES = 'NO_ENTITLED_LINES',
  /** Input value is not present. */
  PRESENCE = 'PRESENCE',
  /** The maximum number of cycles must be greater than the minimum. */
  SELLING_PLAN_MAX_CYCLES_MUST_BE_GREATER_THAN_MIN_CYCLES = 'SELLING_PLAN_MAX_CYCLES_MUST_BE_GREATER_THAN_MIN_CYCLES',
  /** Another operation updated the contract concurrently as the commit was in progress. */
  STALE_CONTRACT = 'STALE_CONTRACT',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** Billing cycle selector cannot select upcoming billing cycle past limit. */
  UPCOMING_CYCLE_LIMIT_EXCEEDED = 'UPCOMING_CYCLE_LIMIT_EXCEEDED'
}

/** Return type for `subscriptionDraftFreeShippingDiscountAdd` mutation. */
export type SubscriptionDraftFreeShippingDiscountAddPayload = {
  /** The added subscription free shipping discount. */
  readonly discountAdded?: Maybe<SubscriptionManualDiscount>;
  /** The subscription contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftFreeShippingDiscountUpdate` mutation. */
export type SubscriptionDraftFreeShippingDiscountUpdatePayload = {
  /** The updated Subscription Discount. */
  readonly discountUpdated?: Maybe<SubscriptionManualDiscount>;
  /** The Subscription Contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** The input fields required to create a Subscription Draft. */
export type SubscriptionDraftInput = {
  /** The billing policy for the subscription contract. */
  readonly billingPolicy?: InputMaybe<SubscriptionBillingPolicyInput>;
  /** A list of the custom attributes added to the subscription contract. */
  readonly customAttributes?: InputMaybe<ReadonlyArray<AttributeInput>>;
  /** The delivery method for the subscription contract. */
  readonly deliveryMethod?: InputMaybe<SubscriptionDeliveryMethodInput>;
  /** The delivery policy for the subscription contract. */
  readonly deliveryPolicy?: InputMaybe<SubscriptionDeliveryPolicyInput>;
  /** The shipping price for each renewal the subscription contract. */
  readonly deliveryPrice?: InputMaybe<Scalars['Decimal']>;
  /** The next billing date for the subscription contract. */
  readonly nextBillingDate?: InputMaybe<Scalars['DateTime']>;
  /** The note field that will be applied to the generated orders. */
  readonly note?: InputMaybe<Scalars['String']>;
  /** The ID of the payment method to be used for the subscription contract. */
  readonly paymentMethodId?: InputMaybe<Scalars['ID']>;
  /** The current status of the subscription contract. */
  readonly status?: InputMaybe<SubscriptionContractSubscriptionStatus>;
};

/** Return type for `subscriptionDraftLineAdd` mutation. */
export type SubscriptionDraftLineAddPayload = {
  /** The Subscription Contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The added Subscription Line. */
  readonly lineAdded?: Maybe<SubscriptionLine>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftLineRemove` mutation. */
export type SubscriptionDraftLineRemovePayload = {
  /** The list of updated subscription discounts impacted by the removed line. */
  readonly discountsUpdated?: Maybe<ReadonlyArray<SubscriptionManualDiscount>>;
  /** The Subscription Contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The removed Subscription Line. */
  readonly lineRemoved?: Maybe<SubscriptionLine>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftLineUpdate` mutation. */
export type SubscriptionDraftLineUpdatePayload = {
  /** The Subscription Contract draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The updated Subscription Line. */
  readonly lineUpdated?: Maybe<SubscriptionLine>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Return type for `subscriptionDraftUpdate` mutation. */
export type SubscriptionDraftUpdatePayload = {
  /** The Subscription Draft object. */
  readonly draft?: Maybe<SubscriptionDraft>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<SubscriptionDraftUserError>;
};

/** Represents a Subscription Draft error. */
export type SubscriptionDraftUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<SubscriptionDraftErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** The input fields for a subscription free shipping discount on a contract. */
export type SubscriptionFreeShippingDiscountInput = {
  /** The maximum number of times the subscription free shipping discount will be applied on orders. */
  readonly recurringCycleLimit?: InputMaybe<Scalars['Int']>;
  /** The title associated with the subscription free shipping discount. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Represents a Subscription Line. */
export type SubscriptionLine = {
  /** The price per unit for the subscription line in the contract's currency. */
  readonly currentPrice: MoneyV2;
  /** List of custom attributes associated to the line item. */
  readonly customAttributes: ReadonlyArray<Attribute>;
  /** Discount allocations. */
  readonly discountAllocations: ReadonlyArray<SubscriptionDiscountAllocation>;
  /** The unique ID. */
  readonly id: Scalars['ID'];
  /** Total line price including all discounts. */
  readonly lineDiscountedPrice: MoneyV2;
  /** Describe the price changes of the line over time. */
  readonly pricingPolicy?: Maybe<SubscriptionPricingPolicy>;
  /** The product ID associated with the subscription line. */
  readonly productId?: Maybe<Scalars['ID']>;
  /** The quantity of the unit selected for the subscription line. */
  readonly quantity: Scalars['Int'];
  /** Whether physical shipping is required for the variant. */
  readonly requiresShipping: Scalars['Boolean'];
  /**
   * The selling plan ID associated to the line.
   *
   * Indicates which selling plan was used to create this
   * contract line initially. The selling plan ID is also used to
   * find the associated delivery profile.
   *
   * The subscription contract, subscription line, or selling plan might have
   * changed. As a result, the selling plan's attributes might not
   * match the information on the contract.
   */
  readonly sellingPlanId?: Maybe<Scalars['ID']>;
  /**
   * The selling plan name associated to the line. This name describes
   * the order line items created from this subscription line
   * for both merchants and customers.
   *
   * The value can be different from the selling plan's name, because both
   * the selling plan's name and the subscription line's selling_plan_name
   * attribute can be updated independently.
   */
  readonly sellingPlanName?: Maybe<Scalars['String']>;
  /** Variant SKU number of the item associated with the subscription line. */
  readonly sku?: Maybe<Scalars['String']>;
  /** Whether the variant is taxable. */
  readonly taxable: Scalars['Boolean'];
  /** Product title of the item associated with the subscription line. */
  readonly title: Scalars['String'];
  /** The product variant ID associated with the subscription line. */
  readonly variantId?: Maybe<Scalars['ID']>;
  /** The image associated with the line item's variant or product. */
  readonly variantImage?: Maybe<Image>;
  /** Product variant title of the item associated with the subscription line. */
  readonly variantTitle?: Maybe<Scalars['String']>;
};

/** An auto-generated type for paginating through multiple SubscriptionLines. */
export type SubscriptionLineConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SubscriptionLineEdge>;
  /** A list of nodes that are contained in SubscriptionLineEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SubscriptionLine>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one SubscriptionLine and a cursor during pagination. */
export type SubscriptionLineEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SubscriptionLineEdge. */
  readonly node: SubscriptionLine;
};

/** The input fields required to add a new subscription line to a contract. */
export type SubscriptionLineInput = {
  /** The price of the product. */
  readonly currentPrice: Scalars['Decimal'];
  /** The custom attributes for this subscription line. */
  readonly customAttributes?: InputMaybe<ReadonlyArray<AttributeInput>>;
  /** Describes expected price changes of the subscription line over time. */
  readonly pricingPolicy?: InputMaybe<SubscriptionPricingPolicyInput>;
  /** The ID of the product variant the subscription line refers to. */
  readonly productVariantId: Scalars['ID'];
  /** The quantity of the product. */
  readonly quantity: Scalars['Int'];
  /** The selling plan for the subscription line. */
  readonly sellingPlanId?: InputMaybe<Scalars['ID']>;
  /**
   * The selling plan name for the subscription line.
   *
   * Defaults to using the selling plan's current name when not specified.
   */
  readonly sellingPlanName?: InputMaybe<Scalars['String']>;
};

/** The input fields required to update a subscription line on a contract. */
export type SubscriptionLineUpdateInput = {
  /** The price of the product. */
  readonly currentPrice?: InputMaybe<Scalars['Decimal']>;
  /** The custom attributes for this subscription line. */
  readonly customAttributes?: InputMaybe<ReadonlyArray<AttributeInput>>;
  /** Describes expected price changes of the subscription line over time. */
  readonly pricingPolicy?: InputMaybe<SubscriptionPricingPolicyInput>;
  /** The ID of the product variant the subscription line refers to. */
  readonly productVariantId?: InputMaybe<Scalars['ID']>;
  /** The quantity of the product. */
  readonly quantity?: InputMaybe<Scalars['Int']>;
  /** The selling plan for the subscription line. */
  readonly sellingPlanId?: InputMaybe<Scalars['ID']>;
  /** The selling plan name for the subscription line. */
  readonly sellingPlanName?: InputMaybe<Scalars['String']>;
};

/** A local delivery option for a subscription contract. */
export type SubscriptionLocalDeliveryOption = {
  /** The code of the local delivery option. */
  readonly code: Scalars['String'];
  /** The description of the local delivery option. */
  readonly description?: Maybe<Scalars['String']>;
  /** Whether a phone number is required for the local delivery option. */
  readonly phoneRequired: Scalars['Boolean'];
  /** The presentment title of the local delivery option. */
  readonly presentmentTitle?: Maybe<Scalars['String']>;
  /** The price of the local delivery option. */
  readonly price?: Maybe<MoneyV2>;
  /** The title of the local delivery option. */
  readonly title: Scalars['String'];
};

/** Represents a Mailing Address on a Subscription. */
export type SubscriptionMailingAddress = {
  /** The first line of the address. Typically the street address or PO Box number. */
  readonly address1?: Maybe<Scalars['String']>;
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  readonly address2?: Maybe<Scalars['String']>;
  /** The name of the city, district, village, or town. */
  readonly city?: Maybe<Scalars['String']>;
  /** The name of the customer's company or organization. */
  readonly company?: Maybe<Scalars['String']>;
  /** The name of the country. */
  readonly country?: Maybe<Scalars['String']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   */
  readonly countryCode?: Maybe<CountryCode>;
  /** The first name of the customer. */
  readonly firstName?: Maybe<Scalars['String']>;
  /** The last name of the customer. */
  readonly lastName?: Maybe<Scalars['String']>;
  /** The full name of the customer, based on firstName and lastName. */
  readonly name?: Maybe<Scalars['String']>;
  /** A unique phone number for the customer. Formatted using E.164 standard. For example, _+16135551111_. */
  readonly phone?: Maybe<Scalars['String']>;
  /** The region of the address, such as the province, state, or district. */
  readonly province?: Maybe<Scalars['String']>;
  /**
   * The alphanumeric code for the region.
   *
   * For example, ON.
   */
  readonly provinceCode?: Maybe<Scalars['String']>;
  /** The zip or postal code of the address. */
  readonly zip?: Maybe<Scalars['String']>;
};

/** Custom subscription discount. */
export type SubscriptionManualDiscount = {
  /** Entitled line items used to apply the subscription discount on. */
  readonly entitledLines: SubscriptionDiscountEntitledLines;
  /** The unique ID. */
  readonly id: Scalars['ID'];
  /** The maximum number of times the subscription discount will be applied on orders. */
  readonly recurringCycleLimit?: Maybe<Scalars['Int']>;
  /** The reason that the discount on the subscription draft is rejected. */
  readonly rejectionReason?: Maybe<SubscriptionDiscountRejectionReason>;
  /** Type of line the discount applies on. */
  readonly targetType: DiscountTargetType;
  /** The title associated with the subscription discount. */
  readonly title?: Maybe<Scalars['String']>;
  /** The type of the subscription discount. */
  readonly type: DiscountType;
  /** The number of times the discount was applied. */
  readonly usageCount: Scalars['Int'];
  /** The value of the subscription discount. */
  readonly value: SubscriptionDiscountValue;
};

/** An auto-generated type for paginating through multiple SubscriptionManualDiscounts. */
export type SubscriptionManualDiscountConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<SubscriptionManualDiscountEdge>;
  /** A list of nodes that are contained in SubscriptionManualDiscountEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<SubscriptionManualDiscount>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one SubscriptionManualDiscount and a cursor during pagination. */
export type SubscriptionManualDiscountEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of SubscriptionManualDiscountEdge. */
  readonly node: SubscriptionManualDiscount;
};

/** The input fields for the subscription lines the discount applies on. */
export type SubscriptionManualDiscountEntitledLinesInput = {
  /** Specify whether the subscription discount will apply on all subscription lines. */
  readonly all?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the lines to add to or remove from the subscription discount. */
  readonly lines?: InputMaybe<SubscriptionManualDiscountLinesInput>;
};

/** The input fields for the fixed amount value of the discount and distribution on the lines. */
export type SubscriptionManualDiscountFixedAmountInput = {
  /** Fixed amount value. */
  readonly amount?: InputMaybe<Scalars['Float']>;
  /** Whether the amount is intended per line item or once per subscription. */
  readonly appliesOnEachItem?: InputMaybe<Scalars['Boolean']>;
};

/** The input fields for a subscription discount on a contract. */
export type SubscriptionManualDiscountInput = {
  /** Entitled line items used to apply the subscription discount on. */
  readonly entitledLines?: InputMaybe<SubscriptionManualDiscountEntitledLinesInput>;
  /** The maximum number of times the subscription discount will be applied on orders. */
  readonly recurringCycleLimit?: InputMaybe<Scalars['Int']>;
  /** The title associated with the subscription discount. */
  readonly title?: InputMaybe<Scalars['String']>;
  /** Percentage or fixed amount value of the discount. */
  readonly value?: InputMaybe<SubscriptionManualDiscountValueInput>;
};

/** The input fields for line items that the discount refers to. */
export type SubscriptionManualDiscountLinesInput = {
  /** The ID of the lines to add to the subscription discount. */
  readonly add?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /** The ID of the lines to remove from the subscription discount. */
  readonly remove?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

/** The input fields for the discount value and its distribution. */
export type SubscriptionManualDiscountValueInput = {
  /** Fixed amount input in the currency defined by the subscription. */
  readonly fixedAmount?: InputMaybe<SubscriptionManualDiscountFixedAmountInput>;
  /** The percentage value of the discount. Value must be between 0 - 100. */
  readonly percentage?: InputMaybe<Scalars['Int']>;
};

/** A pickup option to deliver a subscription contract. */
export type SubscriptionPickupOption = {
  /** The code of the pickup option. */
  readonly code: Scalars['String'];
  /** The description of the pickup option. */
  readonly description?: Maybe<Scalars['String']>;
  /** The pickup location. */
  readonly location: Location;
  /** Whether a phone number is required for the pickup option. */
  readonly phoneRequired: Scalars['Boolean'];
  /** The estimated amount of time it takes for the pickup to be ready. For example, "Usually ready in 24 hours".). */
  readonly pickupTime: Scalars['String'];
  /** The presentment title of the pickup option. */
  readonly presentmentTitle?: Maybe<Scalars['String']>;
  /** The price of the pickup option. */
  readonly price?: Maybe<MoneyV2>;
  /** The title of the pickup option. */
  readonly title: Scalars['String'];
};

/** Represents a Subscription Line Pricing Policy. */
export type SubscriptionPricingPolicy = {
  /** The base price per unit for the subscription line in the contract's currency. */
  readonly basePrice: MoneyV2;
  /** The adjustments per cycle for the subscription line. */
  readonly cycleDiscounts: ReadonlyArray<SubscriptionCyclePriceAdjustment>;
};

/** The input fields for an array containing all pricing changes for each billing cycle. */
export type SubscriptionPricingPolicyCycleDiscountsInput = {
  /** The price adjustment type. */
  readonly adjustmentType: SellingPlanPricingPolicyAdjustmentType;
  /** The price adjustment value. */
  readonly adjustmentValue: SellingPlanPricingPolicyValueInput;
  /** The cycle after which the pricing policy applies. */
  readonly afterCycle: Scalars['Int'];
  /** The computed price after the adjustments are applied. */
  readonly computedPrice: Scalars['Decimal'];
};

/** The input fields for expected price changes of the subscription line over time. */
export type SubscriptionPricingPolicyInput = {
  /** The base price per unit for the subscription line in the contract's currency. */
  readonly basePrice: Scalars['Decimal'];
  /** An array containing all pricing changes for each billing cycle. */
  readonly cycleDiscounts: ReadonlyArray<SubscriptionPricingPolicyCycleDiscountsInput>;
};

/** A shipping option to deliver a subscription contract. */
export type SubscriptionShippingOption = {
  /**
   * The carrier service that's providing this shipping option.
   * This field isn't currently supported and returns null.
   * @deprecated This field has never been implemented.
   */
  readonly carrierService?: Maybe<DeliveryCarrierService>;
  /** The code of the shipping option. */
  readonly code: Scalars['String'];
  /** The description of the shipping option. */
  readonly description?: Maybe<Scalars['String']>;
  /** If a phone number is required for the shipping option. */
  readonly phoneRequired?: Maybe<Scalars['Boolean']>;
  /** The presentment title of the shipping option. */
  readonly presentmentTitle?: Maybe<Scalars['String']>;
  /** The price of the shipping option. */
  readonly price?: Maybe<MoneyV2>;
  /** The title of the shipping option. */
  readonly title: Scalars['String'];
};

/** The result of the query to fetch shipping options for the subscription contract. */
export type SubscriptionShippingOptionResult = SubscriptionShippingOptionResultFailure | SubscriptionShippingOptionResultSuccess;

/** Failure determining available shipping options for delivery of a subscription contract. */
export type SubscriptionShippingOptionResultFailure = {
  /** Failure reason. */
  readonly message?: Maybe<Scalars['String']>;
};

/** A shipping option for delivery of a subscription contract. */
export type SubscriptionShippingOptionResultSuccess = {
  /** Available shipping options. */
  readonly shippingOptions: ReadonlyArray<SubscriptionShippingOption>;
};

/**
 * A suggested transaction. Suggested transaction are usually used in the context of refunds
 * and exchanges.
 */
export type SuggestedOrderTransaction = {
  /** The masked account number associated with the payment method. */
  readonly accountNumber?: Maybe<Scalars['String']>;
  /**
   * The amount of the transaction.
   * @deprecated Use `amountSet` instead.
   */
  readonly amount: Scalars['Money'];
  /** The amount and currency of the suggested order transaction in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** The human-readable payment gateway name suggested to process the transaction. */
  readonly formattedGateway?: Maybe<Scalars['String']>;
  /** The suggested payment gateway used to process the transaction. */
  readonly gateway?: Maybe<Scalars['String']>;
  /** Specifies the kind of the suggested order transaction. */
  readonly kind: SuggestedOrderTransactionKind;
  /**
   * Specifies the available amount to refund on the gateway. Only available within SuggestedRefund.
   * @deprecated Use `maximumRefundableSet` instead.
   */
  readonly maximumRefundable?: Maybe<Scalars['Money']>;
  /** Specifies the available amount to refund on the gateway in shop and presentment currencies. Only available within SuggestedRefund. */
  readonly maximumRefundableSet?: Maybe<MoneyBag>;
  /** The associated parent transaction, for example the authorization of a capture. */
  readonly parentTransaction?: Maybe<OrderTransaction>;
  /** The associated payment details related to the transaction. */
  readonly paymentDetails?: Maybe<PaymentDetails>;
};

/** Specifies the kind of the suggested order transaction. */
export enum SuggestedOrderTransactionKind {
  /** A suggested refund transaction for an order. */
  SUGGESTED_REFUND = 'SUGGESTED_REFUND'
}

/** Represents a refund suggested by Shopify based on the items being reimbursed. You can then use the suggested refund object to generate an actual refund. */
export type SuggestedRefund = {
  /**
   * The total monetary value to be refunded.
   * @deprecated Use `amountSet` instead.
   */
  readonly amount: Scalars['Money'];
  /** The total monetary value to be refunded in shop and presentment currencies. */
  readonly amountSet: MoneyBag;
  /** The sum of all the discounted prices of the line items being refunded. */
  readonly discountedSubtotalSet: MoneyBag;
  /**
   * The total monetary value available to refund.
   * @deprecated Use `maximumRefundableSet` instead.
   */
  readonly maximumRefundable: Scalars['Money'];
  /** The total monetary value available to refund in shop and presentment currencies. */
  readonly maximumRefundableSet: MoneyBag;
  /** A list of duties to be refunded from the order. */
  readonly refundDuties: ReadonlyArray<RefundDuty>;
  /** A list of line items to be refunded, along with restock instructions. */
  readonly refundLineItems: ReadonlyArray<RefundLineItem>;
  /** The shipping costs to be refunded from the order. */
  readonly shipping: ShippingRefund;
  /**
   * The sum of all the prices of the line items being refunded.
   * @deprecated Use `subtotalSet` instead.
   */
  readonly subtotal: Scalars['Money'];
  /** The sum of all the prices of the line items being refunded in shop and presentment currencies. */
  readonly subtotalSet: MoneyBag;
  /** A list of suggested order transactions. */
  readonly suggestedTransactions: ReadonlyArray<SuggestedOrderTransaction>;
  /** The total cart discount amount that was applied to all line items in this refund. */
  readonly totalCartDiscountAmountSet: MoneyBag;
  /** The sum of all the duties being refunded from the order in shop and presentment currencies. The value must be positive. */
  readonly totalDutiesSet: MoneyBag;
  /** The sum of the taxes being refunded from the order in shop and presentment currencies. The value must be positive. */
  readonly totalTaxSet: MoneyBag;
  /**
   * The sum of the taxes being refunded from the order. The value must be positive.
   * @deprecated Use `totalTaxSet` instead.
   */
  readonly totalTaxes: Scalars['Money'];
};

/** Represents a return refund suggested by Shopify based on the items being reimbursed. You can then use the suggested refund object to generate an actual refund for the return. */
export type SuggestedReturnRefund = {
  /** The total monetary value to be refunded in shop and presentment currencies. */
  readonly amount: MoneyBag;
  /** The sum of all the discounted prices of the line items being refunded. */
  readonly discountedSubtotal: MoneyBag;
  /** The total monetary value available to refund in shop and presentment currencies. */
  readonly maximumRefundable: MoneyBag;
  /** A list of duties to be refunded from the order. */
  readonly refundDuties: ReadonlyArray<RefundDuty>;
  /** The shipping costs to be refunded from the order. */
  readonly shipping: ShippingRefund;
  /** The sum of all the prices of the line items being refunded in shop and presentment currencies. */
  readonly subtotal: MoneyBag;
  /** A list of suggested order transactions. */
  readonly suggestedTransactions: ReadonlyArray<SuggestedOrderTransaction>;
  /** The total cart discount amount that was applied to all line items in this refund. */
  readonly totalCartDiscountAmount: MoneyBag;
  /** The sum of all the duties being refunded from the order in shop and presentment currencies. The value must be positive. */
  readonly totalDuties: MoneyBag;
  /** The sum of the taxes being refunded in shop and presentment currencies. The value must be positive. */
  readonly totalTax: MoneyBag;
};

/** Return type for `tagsAdd` mutation. */
export type TagsAddPayload = {
  /** The object that was updated. */
  readonly node?: Maybe<Node>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `tagsRemove` mutation. */
export type TagsRemovePayload = {
  /** The object that was updated. */
  readonly node?: Maybe<Node>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Tax app configuration of a merchant. */
export type TaxAppConfiguration = {
  /** State of the tax app configuration. */
  readonly state: TaxPartnerState;
};

/** Return type for `taxAppConfigure` mutation. */
export type TaxAppConfigurePayload = {
  /** The updated tax app configuration. */
  readonly taxAppConfiguration?: Maybe<TaxAppConfiguration>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<TaxAppConfigureUserError>;
};

/** An error that occurs during the execution of `TaxAppConfigure`. */
export type TaxAppConfigureUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<TaxAppConfigureUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `TaxAppConfigureUserError`. */
export enum TaxAppConfigureUserErrorCode {
  /** Unable to update already active tax partner. */
  TAX_PARTNER_ALREADY_ACTIVE = 'TAX_PARTNER_ALREADY_ACTIVE',
  /** Unable to find the tax partner record. */
  TAX_PARTNER_NOT_FOUND = 'TAX_PARTNER_NOT_FOUND',
  /** Unable to update tax partner state. */
  TAX_PARTNER_STATE_UPDATE_FAILED = 'TAX_PARTNER_STATE_UPDATE_FAILED'
}

/** Available customer tax exemptions. */
export enum TaxExemption {
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in British Columbia. */
  CA_BC_COMMERCIAL_FISHERY_EXEMPTION = 'CA_BC_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid CONTRACTOR_EXEMPTION in British Columbia. */
  CA_BC_CONTRACTOR_EXEMPTION = 'CA_BC_CONTRACTOR_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid PRODUCTION_AND_MACHINERY_EXEMPTION in British Columbia. */
  CA_BC_PRODUCTION_AND_MACHINERY_EXEMPTION = 'CA_BC_PRODUCTION_AND_MACHINERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in British Columbia. */
  CA_BC_RESELLER_EXEMPTION = 'CA_BC_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid SUB_CONTRACTOR_EXEMPTION in British Columbia. */
  CA_BC_SUB_CONTRACTOR_EXEMPTION = 'CA_BC_SUB_CONTRACTOR_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid DIPLOMAT_EXEMPTION in Canada. */
  CA_DIPLOMAT_EXEMPTION = 'CA_DIPLOMAT_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in Manitoba. */
  CA_MB_COMMERCIAL_FISHERY_EXEMPTION = 'CA_MB_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid FARMER_EXEMPTION in Manitoba. */
  CA_MB_FARMER_EXEMPTION = 'CA_MB_FARMER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Manitoba. */
  CA_MB_RESELLER_EXEMPTION = 'CA_MB_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in Nova Scotia. */
  CA_NS_COMMERCIAL_FISHERY_EXEMPTION = 'CA_NS_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid FARMER_EXEMPTION in Nova Scotia. */
  CA_NS_FARMER_EXEMPTION = 'CA_NS_FARMER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid PURCHASE_EXEMPTION in Ontario. */
  CA_ON_PURCHASE_EXEMPTION = 'CA_ON_PURCHASE_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in Prince Edward Island. */
  CA_PE_COMMERCIAL_FISHERY_EXEMPTION = 'CA_PE_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid COMMERCIAL_FISHERY_EXEMPTION in Saskatchewan. */
  CA_SK_COMMERCIAL_FISHERY_EXEMPTION = 'CA_SK_COMMERCIAL_FISHERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid CONTRACTOR_EXEMPTION in Saskatchewan. */
  CA_SK_CONTRACTOR_EXEMPTION = 'CA_SK_CONTRACTOR_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid FARMER_EXEMPTION in Saskatchewan. */
  CA_SK_FARMER_EXEMPTION = 'CA_SK_FARMER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid PRODUCTION_AND_MACHINERY_EXEMPTION in Saskatchewan. */
  CA_SK_PRODUCTION_AND_MACHINERY_EXEMPTION = 'CA_SK_PRODUCTION_AND_MACHINERY_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Saskatchewan. */
  CA_SK_RESELLER_EXEMPTION = 'CA_SK_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid SUB_CONTRACTOR_EXEMPTION in Saskatchewan. */
  CA_SK_SUB_CONTRACTOR_EXEMPTION = 'CA_SK_SUB_CONTRACTOR_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid STATUS_CARD_EXEMPTION in Canada. */
  CA_STATUS_CARD_EXEMPTION = 'CA_STATUS_CARD_EXEMPTION',
  /** This customer is exempt from VAT for purchases within the EU that is shipping from outside of customer's country, as well as purchases from the EU to the UK. */
  EU_REVERSE_CHARGE_EXEMPTION_RULE = 'EU_REVERSE_CHARGE_EXEMPTION_RULE',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Alaska. */
  US_AK_RESELLER_EXEMPTION = 'US_AK_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Alabama. */
  US_AL_RESELLER_EXEMPTION = 'US_AL_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Arkansas. */
  US_AR_RESELLER_EXEMPTION = 'US_AR_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Arizona. */
  US_AZ_RESELLER_EXEMPTION = 'US_AZ_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in California. */
  US_CA_RESELLER_EXEMPTION = 'US_CA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Colorado. */
  US_CO_RESELLER_EXEMPTION = 'US_CO_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Connecticut. */
  US_CT_RESELLER_EXEMPTION = 'US_CT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Washington DC. */
  US_DC_RESELLER_EXEMPTION = 'US_DC_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Delaware. */
  US_DE_RESELLER_EXEMPTION = 'US_DE_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Florida. */
  US_FL_RESELLER_EXEMPTION = 'US_FL_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Georgia. */
  US_GA_RESELLER_EXEMPTION = 'US_GA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Hawaii. */
  US_HI_RESELLER_EXEMPTION = 'US_HI_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Iowa. */
  US_IA_RESELLER_EXEMPTION = 'US_IA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Idaho. */
  US_ID_RESELLER_EXEMPTION = 'US_ID_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Illinois. */
  US_IL_RESELLER_EXEMPTION = 'US_IL_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Indiana. */
  US_IN_RESELLER_EXEMPTION = 'US_IN_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Kansas. */
  US_KS_RESELLER_EXEMPTION = 'US_KS_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Kentucky. */
  US_KY_RESELLER_EXEMPTION = 'US_KY_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Louisiana. */
  US_LA_RESELLER_EXEMPTION = 'US_LA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Massachusetts. */
  US_MA_RESELLER_EXEMPTION = 'US_MA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Maryland. */
  US_MD_RESELLER_EXEMPTION = 'US_MD_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Maine. */
  US_ME_RESELLER_EXEMPTION = 'US_ME_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Michigan. */
  US_MI_RESELLER_EXEMPTION = 'US_MI_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Minnesota. */
  US_MN_RESELLER_EXEMPTION = 'US_MN_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Missouri. */
  US_MO_RESELLER_EXEMPTION = 'US_MO_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Mississippi. */
  US_MS_RESELLER_EXEMPTION = 'US_MS_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Montana. */
  US_MT_RESELLER_EXEMPTION = 'US_MT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in North Carolina. */
  US_NC_RESELLER_EXEMPTION = 'US_NC_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in North Dakota. */
  US_ND_RESELLER_EXEMPTION = 'US_ND_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Nebraska. */
  US_NE_RESELLER_EXEMPTION = 'US_NE_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in New Hampshire. */
  US_NH_RESELLER_EXEMPTION = 'US_NH_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in New Jersey. */
  US_NJ_RESELLER_EXEMPTION = 'US_NJ_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in New Mexico. */
  US_NM_RESELLER_EXEMPTION = 'US_NM_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Nevada. */
  US_NV_RESELLER_EXEMPTION = 'US_NV_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in New York. */
  US_NY_RESELLER_EXEMPTION = 'US_NY_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Ohio. */
  US_OH_RESELLER_EXEMPTION = 'US_OH_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Oklahoma. */
  US_OK_RESELLER_EXEMPTION = 'US_OK_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Oregon. */
  US_OR_RESELLER_EXEMPTION = 'US_OR_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Pennsylvania. */
  US_PA_RESELLER_EXEMPTION = 'US_PA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Rhode Island. */
  US_RI_RESELLER_EXEMPTION = 'US_RI_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in South Carolina. */
  US_SC_RESELLER_EXEMPTION = 'US_SC_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in South Dakota. */
  US_SD_RESELLER_EXEMPTION = 'US_SD_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Tennessee. */
  US_TN_RESELLER_EXEMPTION = 'US_TN_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Texas. */
  US_TX_RESELLER_EXEMPTION = 'US_TX_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Utah. */
  US_UT_RESELLER_EXEMPTION = 'US_UT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Virginia. */
  US_VA_RESELLER_EXEMPTION = 'US_VA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Vermont. */
  US_VT_RESELLER_EXEMPTION = 'US_VT_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Washington. */
  US_WA_RESELLER_EXEMPTION = 'US_WA_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Wisconsin. */
  US_WI_RESELLER_EXEMPTION = 'US_WI_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in West Virginia. */
  US_WV_RESELLER_EXEMPTION = 'US_WV_RESELLER_EXEMPTION',
  /** This customer is exempt from specific taxes for holding a valid RESELLER_EXEMPTION in Wyoming. */
  US_WY_RESELLER_EXEMPTION = 'US_WY_RESELLER_EXEMPTION'
}

/** Represents a single tax applied to the associated line item. */
export type TaxLine = {
  /** Whether the channel that submitted the tax line is liable for remitting. A value of null indicates unknown liability for this tax line. */
  readonly channelLiable?: Maybe<Scalars['Boolean']>;
  /**
   * The amount of tax, in shop currency, after discounts and before returns.
   * @deprecated Use `priceSet` instead.
   */
  readonly price: Scalars['Money'];
  /** The amount of tax, in shop and presentment currencies, after discounts and before returns. */
  readonly priceSet: MoneyBag;
  /** The proportion of the line item price that the tax represents as a decimal. */
  readonly rate?: Maybe<Scalars['Float']>;
  /** The proportion of the line item price that the tax represents as a percentage. */
  readonly ratePercentage?: Maybe<Scalars['Float']>;
  /** The source of the tax. */
  readonly source?: Maybe<Scalars['String']>;
  /** The name of the tax. */
  readonly title: Scalars['String'];
};

/** State of the tax app configuration. */
export enum TaxPartnerState {
  /** App is configured and to be used for tax calculations. */
  ACTIVE = 'ACTIVE',
  /** App is not configured. */
  PENDING = 'PENDING',
  /** App is configured, but not used for tax calculations. */
  READY = 'READY'
}

/** The Taxonomy resource lets you access the categories, attributes and values of a taxonomy tree. */
export type Taxonomy = {
  /**
   * Returns the categories of the product taxonomy based on the arguments provided.
   * If a `search` argument is provided, then all categories that match the search query globally are returned.
   * If a `children_of` argument is provided, then all children of the specified category are returned.
   * If a `siblings_of` argument is provided, then all siblings of the specified category are returned.
   * If a `decendents_of` argument is provided, then all descendents of the specified category are returned.
   * If no arguments are provided, then all the top-level categories of the taxonomy are returned.
   */
  readonly categories: TaxonomyCategoryConnection;
};


/** The Taxonomy resource lets you access the categories, attributes and values of a taxonomy tree. */
export type TaxonomyCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  childrenOf?: InputMaybe<Scalars['ID']>;
  descendantsOf?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  siblingsOf?: InputMaybe<Scalars['ID']>;
};

/** A Shopify product taxonomy attribute. */
export type TaxonomyAttribute = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
};

/** The details of a specific product category within the [Shopify product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). */
export type TaxonomyCategory = Node & {
  /** The IDs of the category's ancestor categories. */
  readonly ancestorIds: ReadonlyArray<Scalars['ID']>;
  /** The attributes of the taxonomy category. */
  readonly attributes: TaxonomyCategoryAttributeConnection;
  /** The IDs of the category's child categories. */
  readonly childrenIds: ReadonlyArray<Scalars['ID']>;
  /** The full name of the taxonomy category. For example, Animals & Pet Supplies > Pet Supplies > Dog Supplies > Dog Beds. */
  readonly fullName: Scalars['String'];
  /** The globally-unique ID of the TaxonomyCategory. */
  readonly id: Scalars['ID'];
  /** Whether the category is archived. The default value is `false`. */
  readonly isArchived: Scalars['Boolean'];
  /** Whether the category is a leaf category. A leaf category doesn't have any subcategories beneath it. For example, in Animals & Pet Supplies > Pet Supplies > Dog Supplies > Dog Treadmills, Dog Treadmills is a leaf category. The value is `true` when there are no `childrenIds` specified. */
  readonly isLeaf: Scalars['Boolean'];
  /** Whether the category is a root category. A root category is at the top level of the category hierarchy and doesn't have a parent category. For example, Animals & Pet Supplies. The value is `true` when there's no `parentId` specified. */
  readonly isRoot: Scalars['Boolean'];
  /** The level of the category in the taxonomy tree. Levels indicate the depth of the category from the root. For example, in Animals & Pet Supplies > Pet Supplies > Dog Supplies, Animals & Pet Supplies is at level 1, Animals & Pet Supplies > Pet Supplies is at level 2, and Animals & Pet Supplies > Pet Supplies > Dog Supplies is at level 3. */
  readonly level: Scalars['Int'];
  /** The name of the taxonomy category. For example, Dog Beds. */
  readonly name: Scalars['String'];
  /** The ID of the category's parent category. */
  readonly parentId?: Maybe<Scalars['ID']>;
};


/** The details of a specific product category within the [Shopify product taxonomy](https://shopify.github.io/product-taxonomy/releases/unstable/?categoryId=sg-4-17-2-17). */
export type TaxonomyCategoryAttributesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A product taxonomy attribute interface. */
export type TaxonomyCategoryAttribute = TaxonomyAttribute | TaxonomyChoiceListAttribute | TaxonomyMeasurementAttribute;

/** An auto-generated type for paginating through multiple TaxonomyCategoryAttributes. */
export type TaxonomyCategoryAttributeConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<TaxonomyCategoryAttributeEdge>;
  /** A list of nodes that are contained in TaxonomyCategoryAttributeEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<TaxonomyCategoryAttribute>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one TaxonomyCategoryAttribute and a cursor during pagination. */
export type TaxonomyCategoryAttributeEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of TaxonomyCategoryAttributeEdge. */
  readonly node: TaxonomyCategoryAttribute;
};

/** An auto-generated type for paginating through multiple TaxonomyCategories. */
export type TaxonomyCategoryConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<TaxonomyCategoryEdge>;
  /** A list of nodes that are contained in TaxonomyCategoryEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<TaxonomyCategory>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one TaxonomyCategory and a cursor during pagination. */
export type TaxonomyCategoryEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of TaxonomyCategoryEdge. */
  readonly node: TaxonomyCategory;
};

/** A Shopify product taxonomy choice list attribute. */
export type TaxonomyChoiceListAttribute = Node & {
  /** The unique ID of the TaxonomyAttribute. */
  readonly id: Scalars['ID'];
  /** The name of the product taxonomy attribute. For example, Color. */
  readonly name: Scalars['String'];
  /** A list of values on the choice list attribute. */
  readonly values: TaxonomyValueConnection;
};


/** A Shopify product taxonomy choice list attribute. */
export type TaxonomyChoiceListAttributeValuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** A Shopify product taxonomy measurement attribute. */
export type TaxonomyMeasurementAttribute = Node & {
  /** The unique ID of the TaxonomyAttribute. */
  readonly id: Scalars['ID'];
  /** The name of the product taxonomy attribute. For example, Color. */
  readonly name: Scalars['String'];
  /** The product taxonomy attribute options. */
  readonly options: ReadonlyArray<Attribute>;
};

/** Represents a Shopify product taxonomy value. */
export type TaxonomyValue = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The name of the product taxonomy value. For example, Red. */
  readonly name: Scalars['String'];
};

/** An auto-generated type for paginating through multiple TaxonomyValues. */
export type TaxonomyValueConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<TaxonomyValueEdge>;
  /** A list of nodes that are contained in TaxonomyValueEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<TaxonomyValue>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one TaxonomyValue and a cursor during pagination. */
export type TaxonomyValueEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of TaxonomyValueEdge. */
  readonly node: TaxonomyValue;
};

/**
 * A TenderTransaction represents a transaction with financial impact on a shop's balance sheet. A tender transaction always
 * represents actual money movement between a buyer and a shop. TenderTransactions can be used instead of OrderTransactions
 * for reconciling a shop's cash flow. A TenderTransaction is immutable once created.
 */
export type TenderTransaction = Node & {
  /** The amount and currency of the tender transaction. */
  readonly amount: MoneyV2;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The order that's related to the tender transaction. This value is null if the order has been deleted. */
  readonly order?: Maybe<Order>;
  /** Information about the payment method used for the transaction. */
  readonly paymentMethod?: Maybe<Scalars['String']>;
  /** Date and time when the transaction was processed. */
  readonly processedAt?: Maybe<Scalars['DateTime']>;
  /** The remote gateway reference associated with the tender transaction. */
  readonly remoteReference?: Maybe<Scalars['String']>;
  /** Whether the transaction is a test transaction. */
  readonly test: Scalars['Boolean'];
  /** Information about the payment instrument used for the transaction. */
  readonly transactionDetails?: Maybe<TenderTransactionDetails>;
  /** The staff member who performed the transaction. */
  readonly user?: Maybe<StaffMember>;
};

/** An auto-generated type for paginating through multiple TenderTransactions. */
export type TenderTransactionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<TenderTransactionEdge>;
  /** A list of nodes that are contained in TenderTransactionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<TenderTransaction>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Information about the credit card used for this transaction. */
export type TenderTransactionCreditCardDetails = {
  /** The name of the company that issued the customer's credit card. Example: `Visa`. */
  readonly creditCardCompany?: Maybe<Scalars['String']>;
  /** The customer's credit card number, with all digits except the last 4 redacted. Example: `•••• •••• •••• 1234` */
  readonly creditCardNumber?: Maybe<Scalars['String']>;
};

/** Information about the payment instrument used for this transaction. */
export type TenderTransactionDetails = TenderTransactionCreditCardDetails;

/** An auto-generated type which holds one TenderTransaction and a cursor during pagination. */
export type TenderTransactionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of TenderTransactionEdge. */
  readonly node: TenderTransaction;
};

/** Return type for `themeCreate` mutation. */
export type ThemeCreatePayload = {
  /** The theme that was created. */
  readonly theme?: Maybe<OnlineStoreTheme>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ThemeCreateUserError>;
};

/** An error that occurs during the execution of `ThemeCreate`. */
export type ThemeCreateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ThemeCreateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ThemeCreateUserError`. */
export enum ThemeCreateUserErrorCode {
  /** Invalid theme role for theme creation. */
  INVALID_THEME_ROLE_FOR_THEME_CREATION = 'INVALID_THEME_ROLE_FOR_THEME_CREATION',
  /** Must be a zip file. */
  INVALID_ZIP = 'INVALID_ZIP',
  /** Theme creation is not allowed for your shop's plan. */
  THEME_CREATION_NOT_ALLOWED_FOR_THEME_LIMITED_PLAN = 'THEME_CREATION_NOT_ALLOWED_FOR_THEME_LIMITED_PLAN',
  /** Zip is empty. */
  ZIP_IS_EMPTY = 'ZIP_IS_EMPTY',
  /**
   * May not be used to fetch a file bigger
   *             than 50MB.
   */
  ZIP_TOO_LARGE = 'ZIP_TOO_LARGE'
}

/** Return type for `themeDelete` mutation. */
export type ThemeDeletePayload = {
  /** The ID of the deleted theme. */
  readonly deletedThemeId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ThemeDeleteUserError>;
};

/** An error that occurs during the execution of `ThemeDelete`. */
export type ThemeDeleteUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ThemeDeleteUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ThemeDeleteUserError`. */
export enum ThemeDeleteUserErrorCode {
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** The input fields for the file copy. */
export type ThemeFilesCopyFileInput = {
  /** The new file where the content is copied to. */
  readonly dstFilename: Scalars['String'];
  /** The source file to copy from. */
  readonly srcFilename: Scalars['String'];
};

/** Return type for `themeFilesCopy` mutation. */
export type ThemeFilesCopyPayload = {
  /** The resulting theme files. */
  readonly copiedThemeFiles?: Maybe<ReadonlyArray<OnlineStoreThemeFileOperationResult>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OnlineStoreThemeFilesUserErrors>;
};

/** Return type for `themeFilesDelete` mutation. */
export type ThemeFilesDeletePayload = {
  /** The resulting theme files. */
  readonly deletedThemeFiles?: Maybe<ReadonlyArray<OnlineStoreThemeFileOperationResult>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OnlineStoreThemeFilesUserErrors>;
};

/** Return type for `themeFilesUpsert` mutation. */
export type ThemeFilesUpsertPayload = {
  /** The theme files write job triggered by the mutation. */
  readonly job?: Maybe<Job>;
  /** The resulting theme files. */
  readonly upsertedThemeFiles?: Maybe<ReadonlyArray<OnlineStoreThemeFileOperationResult>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<OnlineStoreThemeFilesUserErrors>;
};

/** Return type for `themePublish` mutation. */
export type ThemePublishPayload = {
  /** The theme that was published. */
  readonly theme?: Maybe<OnlineStoreTheme>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ThemePublishUserError>;
};

/** An error that occurs during the execution of `ThemePublish`. */
export type ThemePublishUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ThemePublishUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ThemePublishUserError`. */
export enum ThemePublishUserErrorCode {
  /** Theme publishing is not available during install. */
  CANNOT_PUBLISH_THEME_DURING_INSTALL = 'CANNOT_PUBLISH_THEME_DURING_INSTALL',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** Theme publishing is not allowed on this plan. */
  THEME_PUBLISH_NOT_AVAILABLE_FOR_THEME_LIMITED_PLAN = 'THEME_PUBLISH_NOT_AVAILABLE_FOR_THEME_LIMITED_PLAN'
}

/** The role of the theme. */
export enum ThemeRole {
  /** The theme is archived if a merchant changes their plan and exceeds the maximum number of themes allowed. Archived themes can be downloaded by merchant, but can not be customized or published until the plan is upgraded. */
  ARCHIVED = 'ARCHIVED',
  /** The theme is installed as a trial from the Shopify Theme Store. It can be customized using the theme editor, but access to the code editor and the ability to publish the theme are restricted until it is purchased. */
  DEMO = 'DEMO',
  /** The theme is automatically created by the CLI for previewing purposes when in a development session. */
  DEVELOPMENT = 'DEVELOPMENT',
  /** The theme is locked if it is identified as unlicensed. Customization and publishing are restricted until the merchant resolves the licensing issue. */
  LOCKED = 'LOCKED',
  /** The currently published theme. There can only be one main theme at any time. */
  MAIN = 'MAIN',
  /** The currently published theme that is only accessible to a mobile client. */
  MOBILE = 'MOBILE',
  /** The theme is currently not published. It can be transitioned to the main role if it is published by the merchant. */
  UNPUBLISHED = 'UNPUBLISHED'
}

/** Return type for `themeUpdate` mutation. */
export type ThemeUpdatePayload = {
  /** The theme that was updated. */
  readonly theme?: Maybe<OnlineStoreTheme>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ThemeUpdateUserError>;
};

/** An error that occurs during the execution of `ThemeUpdate`. */
export type ThemeUpdateUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ThemeUpdateUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ThemeUpdateUserError`. */
export enum ThemeUpdateUserErrorCode {
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** The record with the ID used as the input value couldn't be found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG'
}

/** A sale associated with a tip. */
export type TipSale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line item for the associated sale. */
  readonly lineItem: LineItem;
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** Transaction fee related to an order transaction. */
export type TransactionFee = Node & {
  /** Amount of the fee. */
  readonly amount: MoneyV2;
  /** Flat rate charge for a transaction. */
  readonly flatFee: MoneyV2;
  /** Name of the credit card flat fee. */
  readonly flatFeeName?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** Percentage charge. */
  readonly rate: Scalars['Decimal'];
  /** Name of the credit card rate. */
  readonly rateName?: Maybe<Scalars['String']>;
  /** Tax amount charged on the fee. */
  readonly taxAmount: MoneyV2;
  /** Name of the type of fee. */
  readonly type: Scalars['String'];
};

/** The set of valid sort keys for the Transaction query. */
export enum TransactionSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `expires_at` value. */
  EXPIRES_AT = 'EXPIRES_AT'
}

/** Return type for `transactionVoid` mutation. */
export type TransactionVoidPayload = {
  /** The created void transaction. */
  readonly transaction?: Maybe<OrderTransaction>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<TransactionVoidUserError>;
};

/** An error that occurs during the execution of `TransactionVoid`. */
export type TransactionVoidUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<TransactionVoidUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `TransactionVoidUserError`. */
export enum TransactionVoidUserErrorCode {
  /** Transaction must be a successful authorization. */
  AUTH_NOT_SUCCESSFUL = 'AUTH_NOT_SUCCESSFUL',
  /** Transaction must be voidable. */
  AUTH_NOT_VOIDABLE = 'AUTH_NOT_VOIDABLE',
  /** A generic error occurred while attempting to void the transaction. */
  GENERIC_ERROR = 'GENERIC_ERROR',
  /** Transaction does not exist. */
  TRANSACTION_NOT_FOUND = 'TRANSACTION_NOT_FOUND'
}

/** Translatable content of a resource's field. */
export type TranslatableContent = {
  /** Hash digest representation of the content value. */
  readonly digest?: Maybe<Scalars['String']>;
  /** The resource field that's being translated. */
  readonly key: Scalars['String'];
  /** Locale of the content. */
  readonly locale: Scalars['String'];
  /** Type of the translatable content. */
  readonly type: LocalizableContentType;
  /** Content value. */
  readonly value?: Maybe<Scalars['String']>;
};

/** A resource that has translatable fields. */
export type TranslatableResource = {
  /** Nested translatable resources under the current resource. */
  readonly nestedTranslatableResources: TranslatableResourceConnection;
  /** GID of the resource. */
  readonly resourceId: Scalars['ID'];
  /** Translatable content. */
  readonly translatableContent: ReadonlyArray<TranslatableContent>;
  /** Translatable content translations (includes unpublished locales). */
  readonly translations: ReadonlyArray<Translation>;
};


/** A resource that has translatable fields. */
export type TranslatableResourceNestedTranslatableResourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  resourceType?: InputMaybe<TranslatableResourceType>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A resource that has translatable fields. */
export type TranslatableResourceTranslatableContentArgs = {
  marketId?: InputMaybe<Scalars['ID']>;
};


/** A resource that has translatable fields. */
export type TranslatableResourceTranslationsArgs = {
  locale: Scalars['String'];
  marketId?: InputMaybe<Scalars['ID']>;
  outdated?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple TranslatableResources. */
export type TranslatableResourceConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<TranslatableResourceEdge>;
  /** A list of nodes that are contained in TranslatableResourceEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<TranslatableResource>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** An auto-generated type which holds one TranslatableResource and a cursor during pagination. */
export type TranslatableResourceEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of TranslatableResourceEdge. */
  readonly node: TranslatableResource;
};

/** Specifies the type of resources that are translatable. */
export enum TranslatableResourceType {
  /** A blog post. Translatable fields: `title`, `body_html`, `summary_html`, `handle`, `meta_title`, `meta_description`. */
  ARTICLE = 'ARTICLE',
  /** A blog. Translatable fields: `title`, `handle`, `meta_title`, `meta_description`. */
  BLOG = 'BLOG',
  /** A product collection. Translatable fields: `title`, `body_html`, `handle`, `meta_title`, `meta_description`. */
  COLLECTION = 'COLLECTION',
  /** The delivery method definition. For example, "Standard", or "Expedited". Translatable fields: `name`. */
  DELIVERY_METHOD_DEFINITION = 'DELIVERY_METHOD_DEFINITION',
  /** An email template. Translatable fields: `title`, `body_html`. */
  EMAIL_TEMPLATE = 'EMAIL_TEMPLATE',
  /** A filter. Translatable fields: `label`. */
  FILTER = 'FILTER',
  /** A link to direct users. Translatable fields: `title`. */
  LINK = 'LINK',
  /** A category of links. Translatable fields: `title`. */
  MENU = 'MENU',
  /** A Metafield. Translatable fields: `value`. */
  METAFIELD = 'METAFIELD',
  /** A Metaobject. Translatable fields are determined by the Metaobject type. */
  METAOBJECT = 'METAOBJECT',
  /** An online store theme. Translatable fields: `dynamic keys based on theme data`. */
  ONLINE_STORE_THEME = 'ONLINE_STORE_THEME',
  /** A theme app embed. Translatable fields: `dynamic keys based on theme data`. */
  ONLINE_STORE_THEME_APP_EMBED = 'ONLINE_STORE_THEME_APP_EMBED',
  /** A theme json template. Translatable fields: `dynamic keys based on theme data`. */
  ONLINE_STORE_THEME_JSON_TEMPLATE = 'ONLINE_STORE_THEME_JSON_TEMPLATE',
  /** Locale file content of an online store theme. Translatable fields: `dynamic keys based on theme data`. */
  ONLINE_STORE_THEME_LOCALE_CONTENT = 'ONLINE_STORE_THEME_LOCALE_CONTENT',
  /** A theme json section group. Translatable fields: `dynamic keys based on theme data`. */
  ONLINE_STORE_THEME_SECTION_GROUP = 'ONLINE_STORE_THEME_SECTION_GROUP',
  /** A theme setting category. Translatable fields: `dynamic keys based on theme data`. */
  ONLINE_STORE_THEME_SETTINGS_CATEGORY = 'ONLINE_STORE_THEME_SETTINGS_CATEGORY',
  /** Shared static sections of an online store theme. Translatable fields: `dynamic keys based on theme data`. */
  ONLINE_STORE_THEME_SETTINGS_DATA_SECTIONS = 'ONLINE_STORE_THEME_SETTINGS_DATA_SECTIONS',
  /** A packing slip template. Translatable fields: `body`. */
  PACKING_SLIP_TEMPLATE = 'PACKING_SLIP_TEMPLATE',
  /** A page. Translatable fields: `title`, `body_html`, `handle`, `meta_title`, `meta_description`. */
  PAGE = 'PAGE',
  /** A payment gateway. Translatable fields: `name`, `message`, `before_payment_instructions`. */
  PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
  /** An online store product. Translatable fields: `title`, `body_html`, `handle`, `product_type`, `meta_title`, `meta_description`. */
  PRODUCT = 'PRODUCT',
  /**
   * An online store custom product property name. For example, "Size", "Color", or "Material".
   *         Translatable fields: `name`.
   */
  PRODUCT_OPTION = 'PRODUCT_OPTION',
  /** The product option value names. For example, "Red", "Blue", and "Green" for a "Color" option. Translatable fields: `name`. */
  PRODUCT_OPTION_VALUE = 'PRODUCT_OPTION_VALUE',
  /** A selling plan. Translatable fields:`name`, `option1`, `option2`, `option3`, `description`. */
  SELLING_PLAN = 'SELLING_PLAN',
  /** A selling plan group. Translatable fields: `name`, `option1`, `option2`, `option3`. */
  SELLING_PLAN_GROUP = 'SELLING_PLAN_GROUP',
  /** A shop. Translatable fields: `meta_title`, `meta_description`. */
  SHOP = 'SHOP',
  /** A shop policy. Translatable fields: `body`. */
  SHOP_POLICY = 'SHOP_POLICY'
}

/** Translation of a field of a resource. */
export type Translation = {
  /** On the resource that this translation belongs to, the reference to the value being translated. */
  readonly key: Scalars['String'];
  /** ISO code of the translation locale. */
  readonly locale: Scalars['String'];
  /** The market that the translation is specific to. Null value means the translation is available in all markets. */
  readonly market?: Maybe<Market>;
  /** Whether the original content has changed since this translation was updated. */
  readonly outdated: Scalars['Boolean'];
  /** The date and time when the translation was updated. */
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  /** Translation value. */
  readonly value?: Maybe<Scalars['String']>;
};

/** Possible error codes that can be returned by `TranslationUserError`. */
export enum TranslationErrorCode {
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** Translation value is invalid. */
  FAILS_RESOURCE_VALIDATION = 'FAILS_RESOURCE_VALIDATION',
  /** The input value is invalid. */
  INVALID = 'INVALID',
  /** Locale language code is invalid. */
  INVALID_CODE = 'INVALID_CODE',
  /** Locale code format is invalid. */
  INVALID_FORMAT = 'INVALID_FORMAT',
  /** Translation key is invalid. */
  INVALID_KEY_FOR_MODEL = 'INVALID_KEY_FOR_MODEL',
  /** The locale is missing on the market corresponding to the `marketId` argument. */
  INVALID_LOCALE_FOR_MARKET = 'INVALID_LOCALE_FOR_MARKET',
  /** Locale is invalid for the shop. */
  INVALID_LOCALE_FOR_SHOP = 'INVALID_LOCALE_FOR_SHOP',
  /** Market localizable content is invalid. */
  INVALID_MARKET_LOCALIZABLE_CONTENT = 'INVALID_MARKET_LOCALIZABLE_CONTENT',
  /** Translatable content is invalid. */
  INVALID_TRANSLATABLE_CONTENT = 'INVALID_TRANSLATABLE_CONTENT',
  /** The handle is already taken for this resource. */
  INVALID_VALUE_FOR_HANDLE_TRANSLATION = 'INVALID_VALUE_FOR_HANDLE_TRANSLATION',
  /** The shop isn't allowed to operate on market custom content. */
  MARKET_CUSTOM_CONTENT_NOT_ALLOWED = 'MARKET_CUSTOM_CONTENT_NOT_ALLOWED',
  /** The market corresponding to the `marketId` argument doesn't exist. */
  MARKET_DOES_NOT_EXIST = 'MARKET_DOES_NOT_EXIST',
  /** The market override locale creation failed. */
  MARKET_LOCALE_CREATION_FAILED = 'MARKET_LOCALE_CREATION_FAILED',
  /** Resource does not exist. */
  RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND',
  /** The specified resource can't be customized for a market. */
  RESOURCE_NOT_MARKET_CUSTOMIZABLE = 'RESOURCE_NOT_MARKET_CUSTOMIZABLE',
  /** Resource is not translatable. */
  RESOURCE_NOT_TRANSLATABLE = 'RESOURCE_NOT_TRANSLATABLE',
  /** Too many translation keys for the resource. */
  TOO_MANY_KEYS_FOR_RESOURCE = 'TOO_MANY_KEYS_FOR_RESOURCE'
}

/** The input fields and values for creating or updating a translation. */
export type TranslationInput = {
  /** On the resource that this translation belongs to, the reference to the value being translated. */
  readonly key: Scalars['String'];
  /** ISO code of the locale being translated into. Only locales returned in `shopLocales` are valid. */
  readonly locale: Scalars['String'];
  /** The ID of the market that the translation is specific to. Not specifying this field means that the translation will be available in all markets. */
  readonly marketId?: InputMaybe<Scalars['ID']>;
  /** Hash digest representation of the content being translated. */
  readonly translatableContentDigest: Scalars['String'];
  /** The value of the translation. */
  readonly value: Scalars['String'];
};

/** Represents an error that happens during the execution of a translation mutation. */
export type TranslationUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<TranslationErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Return type for `translationsRegister` mutation. */
export type TranslationsRegisterPayload = {
  /** The translations that were created or updated. */
  readonly translations?: Maybe<ReadonlyArray<Translation>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<TranslationUserError>;
};

/** Return type for `translationsRemove` mutation. */
export type TranslationsRemovePayload = {
  /** The translations that were deleted. */
  readonly translations?: Maybe<ReadonlyArray<Translation>>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<TranslationUserError>;
};

/** Represents a typed custom attribute. */
export type TypedAttribute = {
  /** Key or name of the attribute. */
  readonly key: Scalars['String'];
  /** Value of the attribute. */
  readonly value: Scalars['String'];
};

/**
 * Specifies the
 * [Urchin Traffic Module (UTM) parameters](https://en.wikipedia.org/wiki/UTM_parameters)
 * that are associated with a related marketing campaign.
 */
export type UtmInput = {
  /** The name of the UTM campaign. */
  readonly campaign: Scalars['String'];
  /** The UTM campaign medium. */
  readonly medium: Scalars['String'];
  /** The name of the website or application where the referral link exists. */
  readonly source: Scalars['String'];
};

/** Represents a set of UTM parameters. */
export type UtmParameters = {
  /** The name of a marketing campaign. */
  readonly campaign?: Maybe<Scalars['String']>;
  /** Identifies specific content in a marketing campaign. Used to differentiate between similar content or links in a marketing campaign to determine which is the most effective. */
  readonly content?: Maybe<Scalars['String']>;
  /** The medium of a marketing campaign, such as a banner or email newsletter. */
  readonly medium?: Maybe<Scalars['String']>;
  /** The source of traffic to the merchant's store, such as Google or an email newsletter. */
  readonly source?: Maybe<Scalars['String']>;
  /** Paid search terms used by a marketing campaign. */
  readonly term?: Maybe<Scalars['String']>;
};

/** The measurement used to calculate a unit price for a product variant (e.g. $9.99 / 100ml). */
export type UnitPriceMeasurement = {
  /** The type of unit of measurement for the unit price measurement. */
  readonly measuredType?: Maybe<UnitPriceMeasurementMeasuredType>;
  /** The quantity unit for the unit price measurement. */
  readonly quantityUnit?: Maybe<UnitPriceMeasurementMeasuredUnit>;
  /** The quantity value for the unit price measurement. */
  readonly quantityValue: Scalars['Float'];
  /** The reference unit for the unit price measurement. */
  readonly referenceUnit?: Maybe<UnitPriceMeasurementMeasuredUnit>;
  /** The reference value for the unit price measurement. */
  readonly referenceValue: Scalars['Int'];
};

/** The accepted types of unit of measurement. */
export enum UnitPriceMeasurementMeasuredType {
  /** Unit of measurements representing areas. */
  AREA = 'AREA',
  /** Unit of measurements representing lengths. */
  LENGTH = 'LENGTH',
  /** Unit of measurements representing volumes. */
  VOLUME = 'VOLUME',
  /** Unit of measurements representing weights. */
  WEIGHT = 'WEIGHT'
}

/** The valid units of measurement for a unit price measurement. */
export enum UnitPriceMeasurementMeasuredUnit {
  /** 100 centiliters equals 1 liter. */
  CL = 'CL',
  /** 100 centimeters equals 1 meter. */
  CM = 'CM',
  /** Metric system unit of weight. */
  G = 'G',
  /** 1 kilogram equals 1000 grams. */
  KG = 'KG',
  /** Metric system unit of volume. */
  L = 'L',
  /** Metric system unit of length. */
  M = 'M',
  /** Metric system unit of area. */
  M2 = 'M2',
  /** 1 cubic meter equals 1000 liters. */
  M3 = 'M3',
  /** 1000 milligrams equals 1 gram. */
  MG = 'MG',
  /** 1000 milliliters equals 1 liter. */
  ML = 'ML',
  /** 1000 millimeters equals 1 meter. */
  MM = 'MM'
}

/** Systems of weights and measures. */
export enum UnitSystem {
  /** Imperial system of weights and measures. */
  IMPERIAL_SYSTEM = 'IMPERIAL_SYSTEM',
  /** Metric system of weights and measures. */
  METRIC_SYSTEM = 'METRIC_SYSTEM'
}

/** This is represents new sale types that have been added in future API versions. You may update to a more recent API version to receive additional details about this sale. */
export type UnknownSale = Sale & {
  /** The type of order action that the sale represents. */
  readonly actionType: SaleActionType;
  /** The unique ID for the sale. */
  readonly id: Scalars['ID'];
  /** The line type assocated with the sale. */
  readonly lineType: SaleLineType;
  /** The number of units either ordered or intended to be returned. */
  readonly quantity?: Maybe<Scalars['Int']>;
  /** All individual taxes associated with the sale. */
  readonly taxes: ReadonlyArray<SaleTax>;
  /** The total sale amount after taxes and discounts. */
  readonly totalAmount: MoneyBag;
  /** The total discounts allocated to the sale after taxes. */
  readonly totalDiscountAmountAfterTaxes: MoneyBag;
  /** The total discounts allocated to the sale before taxes. */
  readonly totalDiscountAmountBeforeTaxes: MoneyBag;
  /** The total amount of taxes for the sale. */
  readonly totalTaxAmount: MoneyBag;
};

/** An unverified return line item. */
export type UnverifiedReturnLineItem = Node & ReturnLineItemType & {
  /** A note from the customer that describes the item to be returned. Maximum length: 300 characters. */
  readonly customerNote?: Maybe<Scalars['String']>;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The quantity being returned. */
  readonly quantity: Scalars['Int'];
  /** The quantity that can be refunded. */
  readonly refundableQuantity: Scalars['Int'];
  /** The quantity that was refunded. */
  readonly refundedQuantity: Scalars['Int'];
  /** The reason for returning the item. */
  readonly returnReason: ReturnReason;
  /** Additional information about the reason for the return. Maximum length: 255 characters. */
  readonly returnReasonNote: Scalars['String'];
  /** The unit price of the unverified return line item. */
  readonly unitPrice: MoneyV2;
};

/** The input fields required to update a media object. */
export type UpdateMediaInput = {
  /** The alt text associated to the media. */
  readonly alt?: InputMaybe<Scalars['String']>;
  /** Specifies the media to update. */
  readonly id: Scalars['ID'];
  /** The source from which to update the media preview image. May be an external URL or staged upload URL. */
  readonly previewImageSource?: InputMaybe<Scalars['String']>;
};

/** The URL redirect for the online store. */
export type UrlRedirect = Node & {
  /** The ID of the URL redirect. */
  readonly id: Scalars['ID'];
  /** The old path to be redirected from. When the user visits this path, they will be redirected to the target location. */
  readonly path: Scalars['String'];
  /** The target location where the user will be redirected to. */
  readonly target: Scalars['String'];
};

/** Return type for `urlRedirectBulkDeleteAll` mutation. */
export type UrlRedirectBulkDeleteAllPayload = {
  /** The asynchronous job removing the redirects. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** Return type for `urlRedirectBulkDeleteByIds` mutation. */
export type UrlRedirectBulkDeleteByIdsPayload = {
  /** The asynchronous job removing the redirects. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UrlRedirectBulkDeleteByIdsUserError>;
};

/** An error that occurs during the execution of `UrlRedirectBulkDeleteByIds`. */
export type UrlRedirectBulkDeleteByIdsUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<UrlRedirectBulkDeleteByIdsUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `UrlRedirectBulkDeleteByIdsUserError`. */
export enum UrlRedirectBulkDeleteByIdsUserErrorCode {
  /**
   * You must pass one or more [`URLRedirect`](
   *             https://help.shopify.com/en/manual/online-store/menus-and-links/url-redirect
   *           ) object IDs.
   */
  IDS_EMPTY = 'IDS_EMPTY'
}

/** Return type for `urlRedirectBulkDeleteBySavedSearch` mutation. */
export type UrlRedirectBulkDeleteBySavedSearchPayload = {
  /** The asynchronous job removing the redirects. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UrlRedirectBulkDeleteBySavedSearchUserError>;
};

/** An error that occurs during the execution of `UrlRedirectBulkDeleteBySavedSearch`. */
export type UrlRedirectBulkDeleteBySavedSearchUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<UrlRedirectBulkDeleteBySavedSearchUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `UrlRedirectBulkDeleteBySavedSearchUserError`. */
export enum UrlRedirectBulkDeleteBySavedSearchUserErrorCode {
  /** The saved search's query cannot match all entries or be empty. */
  INVALID_SAVED_SEARCH_QUERY = 'INVALID_SAVED_SEARCH_QUERY',
  /** Saved search not found. */
  SAVED_SEARCH_NOT_FOUND = 'SAVED_SEARCH_NOT_FOUND'
}

/** Return type for `urlRedirectBulkDeleteBySearch` mutation. */
export type UrlRedirectBulkDeleteBySearchPayload = {
  /** The asynchronous job removing the redirects. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UrlRedirectBulkDeleteBySearchUserError>;
};

/** An error that occurs during the execution of `UrlRedirectBulkDeleteBySearch`. */
export type UrlRedirectBulkDeleteBySearchUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<UrlRedirectBulkDeleteBySearchUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `UrlRedirectBulkDeleteBySearchUserError`. */
export enum UrlRedirectBulkDeleteBySearchUserErrorCode {
  /** Invalid search string. */
  INVALID_SEARCH_ARGUMENT = 'INVALID_SEARCH_ARGUMENT'
}

/** An auto-generated type for paginating through multiple UrlRedirects. */
export type UrlRedirectConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<UrlRedirectEdge>;
  /** A list of nodes that are contained in UrlRedirectEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<UrlRedirect>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `urlRedirectCreate` mutation. */
export type UrlRedirectCreatePayload = {
  /** The created redirect. */
  readonly urlRedirect?: Maybe<UrlRedirect>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UrlRedirectUserError>;
};

/** Return type for `urlRedirectDelete` mutation. */
export type UrlRedirectDeletePayload = {
  /** The ID of the deleted redirect. */
  readonly deletedUrlRedirectId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UrlRedirectUserError>;
};

/** An auto-generated type which holds one UrlRedirect and a cursor during pagination. */
export type UrlRedirectEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of UrlRedirectEdge. */
  readonly node: UrlRedirect;
};

/** Possible error codes that can be returned by `UrlRedirectUserError`. */
export enum UrlRedirectErrorCode {
  /** Redirect could not be created. */
  CREATE_FAILED = 'CREATE_FAILED',
  /** Redirect could not be deleted. */
  DELETE_FAILED = 'DELETE_FAILED',
  /** Redirect does not exist. */
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  /** Redirect could not be updated. */
  UPDATE_FAILED = 'UPDATE_FAILED'
}

/**
 * A request to import a [`URLRedirect`](https://shopify.dev/api/admin-graphql/latest/objects/UrlRedirect) object
 * into the Online Store channel. Apps can use this to query the state of an `UrlRedirectImport` request.
 *
 * For more information, see [`url-redirect`](https://help.shopify.com/en/manual/online-store/menus-and-links/url-redirect)s.
 */
export type UrlRedirectImport = Node & {
  /** The number of rows in the file. */
  readonly count?: Maybe<Scalars['Int']>;
  /** The number of redirects created from the import. */
  readonly createdCount?: Maybe<Scalars['Int']>;
  /** The number of redirects that failed to be imported. */
  readonly failedCount?: Maybe<Scalars['Int']>;
  /** Whether the import is finished. */
  readonly finished: Scalars['Boolean'];
  /** The date and time when the import finished. */
  readonly finishedAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the `UrlRedirectImport` object. */
  readonly id: Scalars['ID'];
  /** A list of up to three previews of the URL redirects to be imported. */
  readonly previewRedirects: ReadonlyArray<UrlRedirectImportPreview>;
  /** The number of redirects updated during the import. */
  readonly updatedCount?: Maybe<Scalars['Int']>;
};

/** Return type for `urlRedirectImportCreate` mutation. */
export type UrlRedirectImportCreatePayload = {
  /** The created `URLRedirectImport` object. */
  readonly urlRedirectImport?: Maybe<UrlRedirectImport>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UrlRedirectImportUserError>;
};

/** Possible error codes that can be returned by `UrlRedirectImportUserError`. */
export enum UrlRedirectImportErrorCode {
  /** The import has already completed. */
  ALREADY_IMPORTED = 'ALREADY_IMPORTED',
  /** CSV file does not exist at given URL. */
  FILE_DOES_NOT_EXIST = 'FILE_DOES_NOT_EXIST',
  /** The import is already in progress. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** URL redirect import not found. */
  NOT_FOUND = 'NOT_FOUND'
}

/** A preview of a URL redirect import row. */
export type UrlRedirectImportPreview = {
  /** The old path to be redirected from. When the user visits this path, they will be redirected to the target location. */
  readonly path: Scalars['String'];
  /** The target location where the user will be redirected to. */
  readonly target: Scalars['String'];
};

/** Return type for `urlRedirectImportSubmit` mutation. */
export type UrlRedirectImportSubmitPayload = {
  /** The asynchronous job importing the redirects. */
  readonly job?: Maybe<Job>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UrlRedirectImportUserError>;
};

/** Represents an error that happens during execution of a redirect import mutation. */
export type UrlRedirectImportUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<UrlRedirectImportErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** The input fields to create or update a URL redirect. */
export type UrlRedirectInput = {
  /** The old path to be redirected from. When the user visits this path, they will be redirected to the target location. */
  readonly path?: InputMaybe<Scalars['String']>;
  /** The target location where the user will be redirected to. */
  readonly target?: InputMaybe<Scalars['String']>;
};

/** The set of valid sort keys for the UrlRedirect query. */
export enum UrlRedirectSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /** Sort by the `path` value. */
  PATH = 'PATH',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** Return type for `urlRedirectUpdate` mutation. */
export type UrlRedirectUpdatePayload = {
  /** Returns the updated URL redirect. */
  readonly urlRedirect?: Maybe<UrlRedirect>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UrlRedirectUserError>;
};

/** Represents an error that happens during execution of a redirect mutation. */
export type UrlRedirectUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<UrlRedirectErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Represents an error in the input of a mutation. */
export type UserError = DisplayableError & {
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** A checkout server side validation installed on the shop. */
export type Validation = HasMetafieldDefinitions & HasMetafields & Node & {
  /** Whether the validation should block on failures other than expected violations. */
  readonly blockOnFailure: Scalars['Boolean'];
  /** Whether the validation is enabled on the merchant checkout. */
  readonly enabled: Scalars['Boolean'];
  /** The error history on the most recent version of the validation function. */
  readonly errorHistory?: Maybe<FunctionsErrorHistory>;
  /** Global ID for the validation. */
  readonly id: Scalars['ID'];
  /**
   * A [custom field](https://shopify.dev/docs/apps/build/custom-data),
   * including its `namespace` and `key`, that's associated with a Shopify resource
   * for the purposes of adding and storing additional information.
   */
  readonly metafield?: Maybe<Metafield>;
  /**
   * List of metafield definitions.
   * @deprecated This field will be removed in a future version. Use the root `metafieldDefinitions` field instead.
   */
  readonly metafieldDefinitions: MetafieldDefinitionConnection;
  /**
   * A list of [custom fields](https://shopify.dev/docs/apps/build/custom-data)
   * that a merchant associates with a Shopify resource.
   */
  readonly metafields: MetafieldConnection;
  /**
   * Returns a private metafield by namespace and key that belongs to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafield?: Maybe<PrivateMetafield>;
  /**
   * List of private metafields that belong to the resource.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafields: PrivateMetafieldConnection;
  /** The Shopify Function implementing the validation. */
  readonly shopifyFunction: ShopifyFunction;
  /** The merchant-facing validation name. */
  readonly title: Scalars['String'];
};


/** A checkout server side validation installed on the shop. */
export type ValidationMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};


/** A checkout server side validation installed on the shop. */
export type ValidationMetafieldDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  pinnedStatus?: InputMaybe<MetafieldDefinitionPinnedStatus>;
  query?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<MetafieldDefinitionSortKeys>;
};


/** A checkout server side validation installed on the shop. */
export type ValidationMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keys?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};


/** A checkout server side validation installed on the shop. */
export type ValidationPrivateMetafieldArgs = {
  key: Scalars['String'];
  namespace: Scalars['String'];
};


/** A checkout server side validation installed on the shop. */
export type ValidationPrivateMetafieldsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  namespace?: InputMaybe<Scalars['String']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

/** An auto-generated type for paginating through multiple Validations. */
export type ValidationConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<ValidationEdge>;
  /** A list of nodes that are contained in ValidationEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<Validation>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** The input fields required to install a validation. */
export type ValidationCreateInput = {
  /** Whether the validation should block on failures other than expected violations. */
  readonly blockOnFailure?: InputMaybe<Scalars['Boolean']>;
  /** Whether the validation should be live on the merchant checkout. */
  readonly enable?: InputMaybe<Scalars['Boolean']>;
  /** The function ID representing the extension to install. */
  readonly functionId: Scalars['String'];
  /** Additional metafields to associate to the validation. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The title of the validation. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `validationCreate` mutation. */
export type ValidationCreatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ValidationUserError>;
  /** The created validation. */
  readonly validation?: Maybe<Validation>;
};

/** Return type for `validationDelete` mutation. */
export type ValidationDeletePayload = {
  /** Returns the deleted validation ID. */
  readonly deletedId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ValidationUserError>;
};

/** An auto-generated type which holds one Validation and a cursor during pagination. */
export type ValidationEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of ValidationEdge. */
  readonly node: Validation;
};

/** The set of valid sort keys for the Validation query. */
export enum ValidationSortKeys {
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/** The input fields required to update a validation. */
export type ValidationUpdateInput = {
  /** Whether the validation should block on failures other than expected violations. */
  readonly blockOnFailure?: InputMaybe<Scalars['Boolean']>;
  /** Whether the validation should be live on the merchant checkout. */
  readonly enable?: InputMaybe<Scalars['Boolean']>;
  /** Additional metafields to associate to the validation. */
  readonly metafields?: InputMaybe<ReadonlyArray<MetafieldInput>>;
  /** The title of the validation. */
  readonly title?: InputMaybe<Scalars['String']>;
};

/** Return type for `validationUpdate` mutation. */
export type ValidationUpdatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ValidationUserError>;
  /** The updated validation. */
  readonly validation?: Maybe<Validation>;
};

/** An error that occurs during the execution of a validation mutation. */
export type ValidationUserError = DisplayableError & {
  /** The error code. */
  readonly code?: Maybe<ValidationUserErrorCode>;
  /** The path to the input field that caused the error. */
  readonly field?: Maybe<ReadonlyArray<Scalars['String']>>;
  /** The error message. */
  readonly message: Scalars['String'];
};

/** Possible error codes that can be returned by `ValidationUserError`. */
export enum ValidationUserErrorCode {
  /** ApiPermission metafields can only be created or updated by the app owner. */
  APP_NOT_AUTHORIZED = 'APP_NOT_AUTHORIZED',
  /** The input value is blank. */
  BLANK = 'BLANK',
  /** The metafield violates a capability restriction. */
  CAPABILITY_VIOLATION = 'CAPABILITY_VIOLATION',
  /** Shop must be on a Shopify Plus plan to activate functions from a custom app. */
  CUSTOM_APP_FUNCTION_NOT_ELIGIBLE = 'CUSTOM_APP_FUNCTION_NOT_ELIGIBLE',
  /** Owner type can't be used in this mutation. */
  DISALLOWED_OWNER_TYPE = 'DISALLOWED_OWNER_TYPE',
  /** Function does not implement the required interface for this cart & checkout validation. */
  FUNCTION_DOES_NOT_IMPLEMENT = 'FUNCTION_DOES_NOT_IMPLEMENT',
  /** Function not found. */
  FUNCTION_NOT_FOUND = 'FUNCTION_NOT_FOUND',
  /** Function is pending deletion. */
  FUNCTION_PENDING_DELETION = 'FUNCTION_PENDING_DELETION',
  /** The input value isn't included in the list. */
  INCLUSION = 'INCLUSION',
  /** An internal error occurred. */
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  /** The type is invalid. */
  INVALID_TYPE = 'INVALID_TYPE',
  /** The value is invalid for the metafield type or for the definition options. */
  INVALID_VALUE = 'INVALID_VALUE',
  /** Validation not found. */
  NOT_FOUND = 'NOT_FOUND',
  /** The input value needs to be blank. */
  PRESENT = 'PRESENT',
  /** Only unlisted apps can be used for this cart & checkout validation. */
  PUBLIC_APP_NOT_ALLOWED = 'PUBLIC_APP_NOT_ALLOWED',
  /** The input value is already taken. */
  TAKEN = 'TAKEN',
  /** The input value is too long. */
  TOO_LONG = 'TOO_LONG',
  /** The input value is too short. */
  TOO_SHORT = 'TOO_SHORT',
  /** Unstructured reserved namespace. */
  UNSTRUCTURED_RESERVED_NAMESPACE = 'UNSTRUCTURED_RESERVED_NAMESPACE'
}

/** The input fields required to create or modify a product variant's option value. */
export type VariantOptionValueInput = {
  /** Specifies the product option value by ID. */
  readonly id?: InputMaybe<Scalars['ID']>;
  /** Metafield value associated with an option. */
  readonly linkedMetafieldValue?: InputMaybe<Scalars['String']>;
  /** Specifies the product option value by name. */
  readonly name?: InputMaybe<Scalars['String']>;
  /** Specifies the product option by ID. */
  readonly optionId?: InputMaybe<Scalars['ID']>;
  /** Specifies the product option by name. */
  readonly optionName?: InputMaybe<Scalars['String']>;
};

/** Represents a credit card payment instrument. */
export type VaultCreditCard = {
  /** The billing address of the card. */
  readonly billingAddress?: Maybe<CustomerCreditCardBillingAddress>;
  /** The brand for the card. */
  readonly brand: Scalars['String'];
  /** Whether the card has been expired. */
  readonly expired: Scalars['Boolean'];
  /** The expiry month of the card. */
  readonly expiryMonth: Scalars['Int'];
  /** The expiry year of the card. */
  readonly expiryYear: Scalars['Int'];
  /** The last four digits for the card. */
  readonly lastDigits: Scalars['String'];
  /** The name of the card holder. */
  readonly name: Scalars['String'];
};

/** Represents a paypal billing agreement payment instrument. */
export type VaultPaypalBillingAgreement = {
  /** Whether the paypal billing agreement is inactive. */
  readonly inactive: Scalars['Boolean'];
  /** The paypal account name. */
  readonly name: Scalars['String'];
  /** The paypal account email address. */
  readonly paypalAccountEmail: Scalars['String'];
};

/**
 * Representation of 3d vectors and points. It can represent
 * either the coordinates of a point in space, a direction, or
 * size. Presented as an object with three floating-point values.
 */
export type Vector3 = {
  /** The x coordinate of Vector3. */
  readonly x: Scalars['Float'];
  /** The y coordinate of Vector3. */
  readonly y: Scalars['Float'];
  /** The z coordinate of Vector3. */
  readonly z: Scalars['Float'];
};

/** Represents a Shopify hosted video. */
export type Video = File & Media & Node & {
  /** A word or phrase to share the nature or contents of a media. */
  readonly alt?: Maybe<Scalars['String']>;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was created. */
  readonly createdAt: Scalars['DateTime'];
  /**
   * The video's duration in milliseconds. This value is `null` unless the video's status field is
   * [READY](https://shopify.dev/api/admin-graphql/latest/enums/MediaStatus#value-ready).
   */
  readonly duration?: Maybe<Scalars['Int']>;
  /** Any errors that have occurred on the file. */
  readonly fileErrors: ReadonlyArray<FileError>;
  /** The status of the file. */
  readonly fileStatus: FileStatus;
  /** The video's filename. */
  readonly filename: Scalars['String'];
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** The media content type. */
  readonly mediaContentType: MediaContentType;
  /** Any errors which have occurred on the media. */
  readonly mediaErrors: ReadonlyArray<MediaError>;
  /** The warnings attached to the media. */
  readonly mediaWarnings: ReadonlyArray<MediaWarning>;
  /**
   * The video's original source. This value is `null` unless the video's status field is
   * [READY](https://shopify.dev/api/admin-graphql/latest/enums/MediaStatus#value-ready).
   */
  readonly originalSource?: Maybe<VideoSource>;
  /** The preview image for the media. */
  readonly preview?: Maybe<MediaPreviewImage>;
  /**
   * The video's sources. This value is empty unless the video's status field is
   * [READY](https://shopify.dev/api/admin-graphql/latest/enums/MediaStatus#value-ready).
   */
  readonly sources: ReadonlyArray<VideoSource>;
  /** Current status of the media. */
  readonly status: MediaStatus;
  /** The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) when the file was last updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/**
 * Represents a source for a Shopify hosted video.
 *
 * Types of sources include the original video, lower resolution versions of the original video,
 * and an m3u8 playlist file.
 *
 * Only [videos](https://shopify.dev/api/admin-graphql/latest/objects/video) with a status field
 * of [READY](https://shopify.dev/api/admin-graphql/latest/enums/MediaStatus#value-ready) have sources.
 */
export type VideoSource = {
  /** The video source's file size in bytes. */
  readonly fileSize?: Maybe<Scalars['Int']>;
  /** The video source's file format extension. */
  readonly format: Scalars['String'];
  /** The video source's height. */
  readonly height: Scalars['Int'];
  /** The video source's MIME type. */
  readonly mimeType: Scalars['String'];
  /** The video source's URL. */
  readonly url: Scalars['String'];
  /** The video source's width. */
  readonly width: Scalars['Int'];
};

/**
 * The `WebPixel` object enables you to manage JavaScript code snippets
 * that run on an online store and collect
 * [behavioral data](https://shopify.dev/docs/api/web-pixels-api/standard-events)
 * for marketing campaign optimization and analytics.
 *
 * Learn how to create a
 * [web pixel extension](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels)
 * to subscribe your app to events that are emitted by Shopify.
 */
export type WebPixel = Node & {
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /**
   * The
   * [settings object](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels#step-2-define-your-web-pixel-settings)
   * for the web pixel. This object specifies configuration options that control the web pixel's functionality and behavior. You can find the settings for a web pixel in
   * `extensions/<your_extension_name>/shopify.extension.toml`.
   */
  readonly settings: Scalars['JSON'];
};

/** Return type for `webPixelCreate` mutation. */
export type WebPixelCreatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ErrorsWebPixelUserError>;
  /** The created web pixel settings. */
  readonly webPixel?: Maybe<WebPixel>;
};

/** Return type for `webPixelDelete` mutation. */
export type WebPixelDeletePayload = {
  /** The ID of the web pixel settings that was deleted. */
  readonly deletedWebPixelId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ErrorsWebPixelUserError>;
};

/** The input fields for creating or updating a web pixel. */
export type WebPixelInput = {
  /**
   * The
   * [settings object](https://shopify.dev/docs/apps/build/marketing-analytics/build-web-pixels#step-2-define-your-web-pixel-settings)
   * for the web pixel. This object specifies configuration options that control the web pixel's functionality and behavior.
   * You can find the settings for a web pixel in `extensions/<your_extension_name>/shopify.extension.toml`.
   */
  readonly settings: Scalars['JSON'];
};

/** Return type for `webPixelUpdate` mutation. */
export type WebPixelUpdatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<ErrorsWebPixelUserError>;
  /** The updated web pixel settings. */
  readonly webPixel?: Maybe<WebPixel>;
};

/** An Amazon EventBridge partner event source to which webhook subscriptions publish events. */
export type WebhookEventBridgeEndpoint = {
  /** The ARN of this EventBridge partner event source. */
  readonly arn: Scalars['ARN'];
};

/** An HTTPS endpoint to which webhook subscriptions send POST requests. */
export type WebhookHttpEndpoint = {
  /** The URL to which the webhooks events are sent. */
  readonly callbackUrl: Scalars['URL'];
};

/** A Google Cloud Pub/Sub topic to which webhook subscriptions publish events. */
export type WebhookPubSubEndpoint = {
  /** The Google Cloud Pub/Sub project ID. */
  readonly pubSubProject: Scalars['String'];
  /** The Google Cloud Pub/Sub topic ID. */
  readonly pubSubTopic: Scalars['String'];
};

/**
 * A webhook subscription is a persisted data object created by an app using the REST Admin API or GraphQL Admin API.
 * It describes the topic that the app wants to receive, and a destination where Shopify should send webhooks of the specified topic.
 * When an event for a given topic occurs, the webhook subscription sends a relevant payload to the destination.
 * Learn more about the [webhooks system](https://shopify.dev/apps/webhooks).
 */
export type WebhookSubscription = LegacyInteroperability & Node & {
  /** The Admin API version that Shopify uses to serialize webhook events. This value is inherited from the app that created the webhook subscription. */
  readonly apiVersion: ApiVersion;
  /**
   * The destination URI to which the webhook subscription will send a message when an event occurs.
   * @deprecated Use `endpoint` instead.
   */
  readonly callbackUrl: Scalars['URL'];
  /** The date and time when the webhook subscription was created. */
  readonly createdAt: Scalars['DateTime'];
  /** The endpoint to which the webhook subscription will send events. */
  readonly endpoint: WebhookSubscriptionEndpoint;
  /** A constraint specified using search syntax that ensures only webhooks that match the specified filter are emitted. See our [guide on filters](https://shopify.dev/docs/apps/build/webhooks/customize/filters) for more details. */
  readonly filter?: Maybe<Scalars['String']>;
  /** The format in which the webhook subscription should send the data. */
  readonly format: WebhookSubscriptionFormat;
  /** A globally-unique ID. */
  readonly id: Scalars['ID'];
  /** An optional array of top-level resource fields that should be serialized and sent in the webhook message. If null, then all fields will be sent. */
  readonly includeFields: ReadonlyArray<Scalars['String']>;
  /** The ID of the corresponding resource in the REST Admin API. */
  readonly legacyResourceId: Scalars['UnsignedInt64'];
  /** The list of namespaces for any metafields that should be included in the webhook subscription. */
  readonly metafieldNamespaces: ReadonlyArray<Scalars['String']>;
  /**
   * The list of namespaces for private metafields that should be included in the webhook subscription.
   * @deprecated Metafields created using a reserved namespace are private by default. See our guide for
   * [migrating private metafields](https://shopify.dev/docs/apps/custom-data/metafields/migrate-private-metafields).
   *
   */
  readonly privateMetafieldNamespaces: ReadonlyArray<Scalars['String']>;
  /** The type of event that triggers the webhook. The topic determines when the webhook subscription sends a webhook, as well as what class of data object that webhook contains. */
  readonly topic: WebhookSubscriptionTopic;
  /** The date and time when the webhook subscription was updated. */
  readonly updatedAt: Scalars['DateTime'];
};

/** An auto-generated type for paginating through multiple WebhookSubscriptions. */
export type WebhookSubscriptionConnection = {
  /** The connection between the node and its parent. Each edge contains a minimum of the edge's cursor and the node. */
  readonly edges: ReadonlyArray<WebhookSubscriptionEdge>;
  /** A list of nodes that are contained in WebhookSubscriptionEdge. You can fetch data about an individual node, or you can follow the edges to fetch data about a collection of related nodes. At each node, you specify the fields that you want to retrieve. */
  readonly nodes: ReadonlyArray<WebhookSubscription>;
  /** An object that’s used to retrieve [cursor information](https://shopify.dev/api/usage/pagination-graphql) about the current page. */
  readonly pageInfo: PageInfo;
};

/** Return type for `webhookSubscriptionCreate` mutation. */
export type WebhookSubscriptionCreatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
  /** The webhook subscription that was created. */
  readonly webhookSubscription?: Maybe<WebhookSubscription>;
};

/** Return type for `webhookSubscriptionDelete` mutation. */
export type WebhookSubscriptionDeletePayload = {
  /** The ID of the deleted webhook subscription. */
  readonly deletedWebhookSubscriptionId?: Maybe<Scalars['ID']>;
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
};

/** An auto-generated type which holds one WebhookSubscription and a cursor during pagination. */
export type WebhookSubscriptionEdge = {
  /** The position of each node in an array, used in [pagination](https://shopify.dev/api/usage/pagination-graphql). */
  readonly cursor: Scalars['String'];
  /** The item at the end of WebhookSubscriptionEdge. */
  readonly node: WebhookSubscription;
};

/** An endpoint to which webhook subscriptions send webhooks events. */
export type WebhookSubscriptionEndpoint = WebhookEventBridgeEndpoint | WebhookHttpEndpoint | WebhookPubSubEndpoint;

/** The supported formats for webhook subscriptions. */
export enum WebhookSubscriptionFormat {
  JSON = 'JSON',
  XML = 'XML'
}

/** The input fields for a webhook subscription. */
export type WebhookSubscriptionInput = {
  /** URL where the webhook subscription should send the POST request when the event occurs. */
  readonly callbackUrl?: InputMaybe<Scalars['URL']>;
  /** A constraint specified using search syntax that ensures only webhooks that match the specified filter are emitted. See our [guide on filters](https://shopify.dev/docs/apps/build/webhooks/customize/filters) for more details. */
  readonly filter?: InputMaybe<Scalars['String']>;
  /** The format in which the webhook subscription should send the data. */
  readonly format?: InputMaybe<WebhookSubscriptionFormat>;
  /** The list of fields to be included in the webhook subscription. */
  readonly includeFields?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  /** The list of namespaces for any metafields that should be included in the webhook subscription. */
  readonly metafieldNamespaces?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

/** The set of valid sort keys for the WebhookSubscription query. */
export enum WebhookSubscriptionSortKeys {
  /** Sort by the `created_at` value. */
  CREATED_AT = 'CREATED_AT',
  /** Sort by the `id` value. */
  ID = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   */
  RELEVANCE = 'RELEVANCE'
}

/**
 * The supported topics for webhook subscriptions. You can use webhook subscriptions to receive
 * notifications about particular events in a shop.
 *
 * You create [mandatory webhooks](https://shopify.dev/apps/webhooks/configuration/mandatory-webhooks#mandatory-compliance-webhooks) either via the
 * [Partner Dashboard](https://shopify.dev/apps/webhooks/configuration/mandatory-webhooks#subscribe-to-privacy-webhooks)
 * or by updating the [app configuration file](https://shopify.dev/apps/tools/cli/configuration#app-configuration-file-example).
 *
 * > Tip:
 * >To configure your subscription using the app configuration file, refer to the [full list of topic names](https://shopify.dev/docs/api/webhooks?reference=graphql).
 */
export enum WebhookSubscriptionTopic {
  /** The webhook topic for `app_purchases_one_time/update` events. Occurs whenever a one-time app charge is updated. */
  APP_PURCHASES_ONE_TIME_UPDATE = 'APP_PURCHASES_ONE_TIME_UPDATE',
  /** The webhook topic for `app/scopes_update` events. Occurs whenever the access scopes of any installation are modified. Allows apps to keep track of the granted access scopes of their installations. */
  APP_SCOPES_UPDATE = 'APP_SCOPES_UPDATE',
  /** The webhook topic for `app_subscriptions/approaching_capped_amount` events. Occurs when the balance used on an app subscription crosses 90% of the capped amount. */
  APP_SUBSCRIPTIONS_APPROACHING_CAPPED_AMOUNT = 'APP_SUBSCRIPTIONS_APPROACHING_CAPPED_AMOUNT',
  /** The webhook topic for `app_subscriptions/update` events. Occurs whenever an app subscription is updated. */
  APP_SUBSCRIPTIONS_UPDATE = 'APP_SUBSCRIPTIONS_UPDATE',
  /** The webhook topic for `app/uninstalled` events. Occurs whenever a shop has uninstalled the app. */
  APP_UNINSTALLED = 'APP_UNINSTALLED',
  /** The webhook topic for `attributed_sessions/first` events. Occurs whenever an order with a "first" attributed session is attributed. Requires the `read_marketing_events` scope. */
  ATTRIBUTED_SESSIONS_FIRST = 'ATTRIBUTED_SESSIONS_FIRST',
  /** The webhook topic for `attributed_sessions/last` events. Occurs whenever an order with a "last" attributed session is attributed. Requires the `read_marketing_events` scope. */
  ATTRIBUTED_SESSIONS_LAST = 'ATTRIBUTED_SESSIONS_LAST',
  /** The webhook topic for `audit_events/admin_api_activity` events. Triggers for each auditable Admin API request. This topic is limited to one active subscription per Plus store and requires the use of Google Cloud Pub/Sub or AWS EventBridge. Requires the `read_audit_events` scope. */
  AUDIT_EVENTS_ADMIN_API_ACTIVITY = 'AUDIT_EVENTS_ADMIN_API_ACTIVITY',
  /** The webhook topic for `bulk_operations/finish` events. Notifies when a Bulk Operation finishes. */
  BULK_OPERATIONS_FINISH = 'BULK_OPERATIONS_FINISH',
  /** The webhook topic for `carts/create` events. Occurs when a cart is created in the online store. Other types of carts aren't supported. For example, the webhook doesn't support carts that are created in a custom storefront. Requires the `read_orders` scope. */
  CARTS_CREATE = 'CARTS_CREATE',
  /** The webhook topic for `carts/update` events. Occurs when a cart is updated in the online store. Other types of carts aren't supported. For example, the webhook doesn't support carts that are updated in a custom storefront. Requires the `read_orders` scope. */
  CARTS_UPDATE = 'CARTS_UPDATE',
  /** The webhook topic for `channels/delete` events. Occurs whenever a channel is deleted. Requires the `read_publications` scope. */
  CHANNELS_DELETE = 'CHANNELS_DELETE',
  /** The webhook topic for `checkouts/create` events. Occurs whenever a checkout is created. Requires the `read_orders` scope. */
  CHECKOUTS_CREATE = 'CHECKOUTS_CREATE',
  /** The webhook topic for `checkouts/delete` events. Occurs whenever a checkout is deleted. Requires the `read_orders` scope. */
  CHECKOUTS_DELETE = 'CHECKOUTS_DELETE',
  /** The webhook topic for `checkouts/update` events. Occurs whenever a checkout is updated. Requires the `read_orders` scope. */
  CHECKOUTS_UPDATE = 'CHECKOUTS_UPDATE',
  /** The webhook topic for `collections/create` events. Occurs whenever a collection is created. Requires the `read_products` scope. */
  COLLECTIONS_CREATE = 'COLLECTIONS_CREATE',
  /** The webhook topic for `collections/delete` events. Occurs whenever a collection is deleted. Requires the `read_products` scope. */
  COLLECTIONS_DELETE = 'COLLECTIONS_DELETE',
  /** The webhook topic for `collections/update` events. Occurs whenever a collection is updated, including whenever products are added or removed from the collection. Occurs once if multiple products are added or removed from a collection at the same time. Requires the `read_products` scope. */
  COLLECTIONS_UPDATE = 'COLLECTIONS_UPDATE',
  /** The webhook topic for `collection_listings/add` events. Occurs whenever a collection listing is added. Requires the `read_product_listings` scope. */
  COLLECTION_LISTINGS_ADD = 'COLLECTION_LISTINGS_ADD',
  /** The webhook topic for `collection_listings/remove` events. Occurs whenever a collection listing is removed. Requires the `read_product_listings` scope. */
  COLLECTION_LISTINGS_REMOVE = 'COLLECTION_LISTINGS_REMOVE',
  /** The webhook topic for `collection_listings/update` events. Occurs whenever a collection listing is updated. Requires the `read_product_listings` scope. */
  COLLECTION_LISTINGS_UPDATE = 'COLLECTION_LISTINGS_UPDATE',
  /** The webhook topic for `collection_publications/create` events. Occurs whenever a collection publication listing is created. Requires the `read_publications` scope. */
  COLLECTION_PUBLICATIONS_CREATE = 'COLLECTION_PUBLICATIONS_CREATE',
  /** The webhook topic for `collection_publications/delete` events. Occurs whenever a collection publication listing is deleted. Requires the `read_publications` scope. */
  COLLECTION_PUBLICATIONS_DELETE = 'COLLECTION_PUBLICATIONS_DELETE',
  /** The webhook topic for `collection_publications/update` events. Occurs whenever a collection publication listing is updated. Requires the `read_publications` scope. */
  COLLECTION_PUBLICATIONS_UPDATE = 'COLLECTION_PUBLICATIONS_UPDATE',
  /** The webhook topic for `companies/create` events. Occurs whenever a company is created. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANIES_CREATE = 'COMPANIES_CREATE',
  /** The webhook topic for `companies/delete` events. Occurs whenever a company is deleted. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANIES_DELETE = 'COMPANIES_DELETE',
  /** The webhook topic for `companies/update` events. Occurs whenever a company is updated. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANIES_UPDATE = 'COMPANIES_UPDATE',
  /** The webhook topic for `company_contacts/create` events. Occurs whenever a company contact is created. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANY_CONTACTS_CREATE = 'COMPANY_CONTACTS_CREATE',
  /** The webhook topic for `company_contacts/delete` events. Occurs whenever a company contact is deleted. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANY_CONTACTS_DELETE = 'COMPANY_CONTACTS_DELETE',
  /** The webhook topic for `company_contacts/update` events. Occurs whenever a company contact is updated. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANY_CONTACTS_UPDATE = 'COMPANY_CONTACTS_UPDATE',
  /** The webhook topic for `company_contact_roles/assign` events. Occurs whenever a role is assigned to a contact at a location. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANY_CONTACT_ROLES_ASSIGN = 'COMPANY_CONTACT_ROLES_ASSIGN',
  /** The webhook topic for `company_contact_roles/revoke` events. Occurs whenever a role is revoked from a contact at a location. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANY_CONTACT_ROLES_REVOKE = 'COMPANY_CONTACT_ROLES_REVOKE',
  /** The webhook topic for `company_locations/create` events. Occurs whenever a company location is created. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANY_LOCATIONS_CREATE = 'COMPANY_LOCATIONS_CREATE',
  /** The webhook topic for `company_locations/delete` events. Occurs whenever a company location is deleted. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANY_LOCATIONS_DELETE = 'COMPANY_LOCATIONS_DELETE',
  /** The webhook topic for `company_locations/update` events. Occurs whenever a company location is updated. Requires at least one of the following scopes: read_customers, read_companies. */
  COMPANY_LOCATIONS_UPDATE = 'COMPANY_LOCATIONS_UPDATE',
  /** The webhook topic for `customers/create` events. Occurs whenever a customer is created. Requires the `read_customers` scope. */
  CUSTOMERS_CREATE = 'CUSTOMERS_CREATE',
  /** The webhook topic for `customers/delete` events. Occurs whenever a customer is deleted. Requires the `read_customers` scope. */
  CUSTOMERS_DELETE = 'CUSTOMERS_DELETE',
  /** The webhook topic for `customers/disable` events. Occurs whenever a customer account is disabled. Requires the `read_customers` scope. */
  CUSTOMERS_DISABLE = 'CUSTOMERS_DISABLE',
  /** The webhook topic for `customers_email_marketing_consent/update` events. Occurs whenever a customer's email marketing consent is updated. Requires the `read_customers` scope. */
  CUSTOMERS_EMAIL_MARKETING_CONSENT_UPDATE = 'CUSTOMERS_EMAIL_MARKETING_CONSENT_UPDATE',
  /** The webhook topic for `customers/enable` events. Occurs whenever a customer account is enabled. Requires the `read_customers` scope. */
  CUSTOMERS_ENABLE = 'CUSTOMERS_ENABLE',
  /** The webhook topic for `customers_marketing_consent/update` events. Occurs whenever a customer's SMS marketing consent is updated. Requires the `read_customers` scope. */
  CUSTOMERS_MARKETING_CONSENT_UPDATE = 'CUSTOMERS_MARKETING_CONSENT_UPDATE',
  /** The webhook topic for `customers/merge` events. Triggers when two customers are merged Requires the `read_customer_merge` scope. */
  CUSTOMERS_MERGE = 'CUSTOMERS_MERGE',
  /** The webhook topic for `customers/update` events. Occurs whenever a customer is updated. Requires the `read_customers` scope. */
  CUSTOMERS_UPDATE = 'CUSTOMERS_UPDATE',
  /** The webhook topic for `customer_account_settings/update` events. Triggers when merchants change customer account setting. */
  CUSTOMER_ACCOUNT_SETTINGS_UPDATE = 'CUSTOMER_ACCOUNT_SETTINGS_UPDATE',
  /** The webhook topic for `customer_groups/create` events. Occurs whenever a customer saved search is created. Requires the `read_customers` scope. */
  CUSTOMER_GROUPS_CREATE = 'CUSTOMER_GROUPS_CREATE',
  /** The webhook topic for `customer_groups/delete` events. Occurs whenever a customer saved search is deleted. Requires the `read_customers` scope. */
  CUSTOMER_GROUPS_DELETE = 'CUSTOMER_GROUPS_DELETE',
  /** The webhook topic for `customer_groups/update` events. Occurs whenever a customer saved search is updated. Requires the `read_customers` scope. */
  CUSTOMER_GROUPS_UPDATE = 'CUSTOMER_GROUPS_UPDATE',
  /** The webhook topic for `customer_payment_methods/create` events. Occurs whenever a customer payment method is created. Requires the `read_customer_payment_methods` scope. */
  CUSTOMER_PAYMENT_METHODS_CREATE = 'CUSTOMER_PAYMENT_METHODS_CREATE',
  /** The webhook topic for `customer_payment_methods/revoke` events. Occurs whenever a customer payment method is revoked. Requires the `read_customer_payment_methods` scope. */
  CUSTOMER_PAYMENT_METHODS_REVOKE = 'CUSTOMER_PAYMENT_METHODS_REVOKE',
  /** The webhook topic for `customer_payment_methods/update` events. Occurs whenever a customer payment method is updated. Requires the `read_customer_payment_methods` scope. */
  CUSTOMER_PAYMENT_METHODS_UPDATE = 'CUSTOMER_PAYMENT_METHODS_UPDATE',
  /** The webhook topic for `customer.tags_added` events. Triggers when tags are added to a customer. Requires the `read_customers` scope. */
  CUSTOMER_TAGS_ADDED = 'CUSTOMER_TAGS_ADDED',
  /** The webhook topic for `customer.tags_removed` events. Triggers when tags are removed from a customer. Requires the `read_customers` scope. */
  CUSTOMER_TAGS_REMOVED = 'CUSTOMER_TAGS_REMOVED',
  /** The webhook topic for `discounts/create` events. Occurs whenever a discount is created. Requires the `read_discounts` scope. */
  DISCOUNTS_CREATE = 'DISCOUNTS_CREATE',
  /** The webhook topic for `discounts/delete` events. Occurs whenever a discount is deleted. Requires the `read_discounts` scope. */
  DISCOUNTS_DELETE = 'DISCOUNTS_DELETE',
  /** The webhook topic for `discounts/redeemcode_added` events. Occurs whenever a redeem code is added to a code discount. Requires the `read_discounts` scope. */
  DISCOUNTS_REDEEMCODE_ADDED = 'DISCOUNTS_REDEEMCODE_ADDED',
  /** The webhook topic for `discounts/redeemcode_removed` events. Occurs whenever a redeem code on a code discount is deleted. Requires the `read_discounts` scope. */
  DISCOUNTS_REDEEMCODE_REMOVED = 'DISCOUNTS_REDEEMCODE_REMOVED',
  /** The webhook topic for `discounts/update` events. Occurs whenever a discount is updated. Requires the `read_discounts` scope. */
  DISCOUNTS_UPDATE = 'DISCOUNTS_UPDATE',
  /** The webhook topic for `disputes/create` events. Occurs whenever a dispute is created. Requires the `read_shopify_payments_disputes` scope. */
  DISPUTES_CREATE = 'DISPUTES_CREATE',
  /** The webhook topic for `disputes/update` events. Occurs whenever a dispute is updated. Requires the `read_shopify_payments_disputes` scope. */
  DISPUTES_UPDATE = 'DISPUTES_UPDATE',
  /** The webhook topic for `domains/create` events. Occurs whenever a domain is created. */
  DOMAINS_CREATE = 'DOMAINS_CREATE',
  /** The webhook topic for `domains/destroy` events. Occurs whenever a domain is destroyed. */
  DOMAINS_DESTROY = 'DOMAINS_DESTROY',
  /** The webhook topic for `domains/update` events. Occurs whenever a domain is updated. */
  DOMAINS_UPDATE = 'DOMAINS_UPDATE',
  /** The webhook topic for `draft_orders/create` events. Occurs whenever a draft order is created. Requires the `read_draft_orders` scope. */
  DRAFT_ORDERS_CREATE = 'DRAFT_ORDERS_CREATE',
  /** The webhook topic for `draft_orders/delete` events. Occurs whenever a draft order is deleted. Requires the `read_draft_orders` scope. */
  DRAFT_ORDERS_DELETE = 'DRAFT_ORDERS_DELETE',
  /** The webhook topic for `draft_orders/update` events. Occurs whenever a draft order is updated. Requires the `read_draft_orders` scope. */
  DRAFT_ORDERS_UPDATE = 'DRAFT_ORDERS_UPDATE',
  /** The webhook topic for `fulfillments/create` events. Occurs whenever a fulfillment is created. Requires at least one of the following scopes: read_fulfillments, read_marketplace_orders. */
  FULFILLMENTS_CREATE = 'FULFILLMENTS_CREATE',
  /** The webhook topic for `fulfillments/update` events. Occurs whenever a fulfillment is updated. Requires at least one of the following scopes: read_fulfillments, read_marketplace_orders. */
  FULFILLMENTS_UPDATE = 'FULFILLMENTS_UPDATE',
  /** The webhook topic for `fulfillment_events/create` events. Occurs whenever a fulfillment event is created. Requires the `read_fulfillments` scope. */
  FULFILLMENT_EVENTS_CREATE = 'FULFILLMENT_EVENTS_CREATE',
  /** The webhook topic for `fulfillment_events/delete` events. Occurs whenever a fulfillment event is deleted. Requires the `read_fulfillments` scope. */
  FULFILLMENT_EVENTS_DELETE = 'FULFILLMENT_EVENTS_DELETE',
  /** The webhook topic for `fulfillment_orders/cancellation_request_accepted` events. Occurs when a 3PL accepts a fulfillment cancellation request, received from a merchant. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_CANCELLATION_REQUEST_ACCEPTED = 'FULFILLMENT_ORDERS_CANCELLATION_REQUEST_ACCEPTED',
  /** The webhook topic for `fulfillment_orders/cancellation_request_rejected` events. Occurs when a 3PL rejects a fulfillment cancellation request, received from a merchant. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_CANCELLATION_REQUEST_REJECTED = 'FULFILLMENT_ORDERS_CANCELLATION_REQUEST_REJECTED',
  /** The webhook topic for `fulfillment_orders/cancellation_request_submitted` events. Occurs when a merchant requests a fulfillment request to be cancelled after that request was approved by a 3PL. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_CANCELLATION_REQUEST_SUBMITTED = 'FULFILLMENT_ORDERS_CANCELLATION_REQUEST_SUBMITTED',
  /** The webhook topic for `fulfillment_orders/cancelled` events. Occurs when a fulfillment order is cancelled. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_CANCELLED = 'FULFILLMENT_ORDERS_CANCELLED',
  /** The webhook topic for `fulfillment_orders/fulfillment_request_accepted` events. Occurs when a fulfillment service accepts a request to fulfill a fulfillment order. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_ACCEPTED = 'FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_ACCEPTED',
  /** The webhook topic for `fulfillment_orders/fulfillment_request_rejected` events. Occurs when a 3PL rejects a fulfillment request that was sent by a merchant. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_REJECTED = 'FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_REJECTED',
  /** The webhook topic for `fulfillment_orders/fulfillment_request_submitted` events. Occurs when a merchant submits a fulfillment request to a 3PL. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_SUBMITTED = 'FULFILLMENT_ORDERS_FULFILLMENT_REQUEST_SUBMITTED',
  /** The webhook topic for `fulfillment_orders/fulfillment_service_failed_to_complete` events. Occurs when a fulfillment service intends to close an in_progress fulfillment order. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_FULFILLMENT_SERVICE_FAILED_TO_COMPLETE = 'FULFILLMENT_ORDERS_FULFILLMENT_SERVICE_FAILED_TO_COMPLETE',
  /**
   * The webhook topic for `fulfillment_orders/hold_released` events. Occurs when a fulfillment order is released and is no longer on hold.
   *
   * If a fulfillment order has multiple holds then this webhook will only be triggered once when the last hold is released and the status of the fulfillment order is no longer `ON_HOLD`.
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FULFILLMENT_ORDERS_HOLD_RELEASED = 'FULFILLMENT_ORDERS_HOLD_RELEASED',
  /** The webhook topic for `fulfillment_orders/line_items_prepared_for_local_delivery` events. Occurs whenever a fulfillment order's line items are prepared for local delivery. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_LINE_ITEMS_PREPARED_FOR_LOCAL_DELIVERY = 'FULFILLMENT_ORDERS_LINE_ITEMS_PREPARED_FOR_LOCAL_DELIVERY',
  /** The webhook topic for `fulfillment_orders/line_items_prepared_for_pickup` events. Triggers when one or more of the line items for a fulfillment order are prepared for pickup Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_LINE_ITEMS_PREPARED_FOR_PICKUP = 'FULFILLMENT_ORDERS_LINE_ITEMS_PREPARED_FOR_PICKUP',
  /** The webhook topic for `fulfillment_orders/merged` events. Occurs when multiple fulfillment orders are merged into a single fulfillment order. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders. */
  FULFILLMENT_ORDERS_MERGED = 'FULFILLMENT_ORDERS_MERGED',
  /**
   * The webhook topic for `fulfillment_orders/moved` events. Occurs whenever the location which is assigned to fulfill one or more fulfillment order line items is changed.
   *
   * * `original_fulfillment_order` - The final state of the original fulfillment order.
   * * `moved_fulfillment_order` - The fulfillment order which now contains the re-assigned line items.
   * * `source_location` - The original location which was assigned to fulfill the line items (available as of the `2023-04` API version).
   * * `destination_location_id` - The ID of the location which is now responsible for fulfilling the line items.
   *
   * **Note:** The [assignedLocation](https://shopify.dev/docs/api/admin-graphql/latest/objects/fulfillmentorder#field-fulfillmentorder-assignedlocation)
   * of the `original_fulfillment_order` might be changed by the move operation.
   * If you need to determine the originally assigned location, then you should refer to the `source_location`.
   *
   * [Learn more about moving line items](https://shopify.dev/docs/api/admin-graphql/latest/mutations/fulfillmentOrderMove).
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FULFILLMENT_ORDERS_MOVED = 'FULFILLMENT_ORDERS_MOVED',
  /** The webhook topic for `fulfillment_orders/order_routing_complete` events. Occurs when an order has finished being routed and it's fulfillment orders assigned to a fulfillment service's location. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_buyer_membership_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_ORDER_ROUTING_COMPLETE = 'FULFILLMENT_ORDERS_ORDER_ROUTING_COMPLETE',
  /**
   * The webhook topic for `fulfillment_orders/placed_on_hold` events. Occurs when a fulfillment order transitions to the `ON_HOLD` status
   *
   * For cases where multiple holds are applied to a fulfillment order, this webhook will only trigger once when the first hold is applied and the fulfillment order status changes to `ON_HOLD`.
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FULFILLMENT_ORDERS_PLACED_ON_HOLD = 'FULFILLMENT_ORDERS_PLACED_ON_HOLD',
  /**
   * The webhook topic for `fulfillment_orders/rescheduled` events. Triggers when a fulfillment order is rescheduled.
   *
   * Fulfillment orders may be merged if they have the same `fulfillAt` datetime.
   * If the fulfillment order is merged then the resulting fulfillment order will be indicated in the webhook body.
   * Otherwise it will be the original fulfillment order with an updated `fulfill_at` datetime.
   *  Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders.
   */
  FULFILLMENT_ORDERS_RESCHEDULED = 'FULFILLMENT_ORDERS_RESCHEDULED',
  /** The webhook topic for `fulfillment_orders/scheduled_fulfillment_order_ready` events. Occurs whenever a fulfillment order which was scheduled becomes due. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders, read_marketplace_fulfillment_orders. */
  FULFILLMENT_ORDERS_SCHEDULED_FULFILLMENT_ORDER_READY = 'FULFILLMENT_ORDERS_SCHEDULED_FULFILLMENT_ORDER_READY',
  /** The webhook topic for `fulfillment_orders/split` events. Occurs when a fulfillment order is split into multiple fulfillment orders. Requires at least one of the following scopes: read_merchant_managed_fulfillment_orders, read_assigned_fulfillment_orders, read_third_party_fulfillment_orders. */
  FULFILLMENT_ORDERS_SPLIT = 'FULFILLMENT_ORDERS_SPLIT',
  /** The webhook topic for `inventory_items/create` events. Occurs whenever an inventory item is created. Requires at least one of the following scopes: read_inventory, read_products. */
  INVENTORY_ITEMS_CREATE = 'INVENTORY_ITEMS_CREATE',
  /** The webhook topic for `inventory_items/delete` events. Occurs whenever an inventory item is deleted. Requires at least one of the following scopes: read_inventory, read_products. */
  INVENTORY_ITEMS_DELETE = 'INVENTORY_ITEMS_DELETE',
  /** The webhook topic for `inventory_items/update` events. Occurs whenever an inventory item is updated. Requires at least one of the following scopes: read_inventory, read_products. */
  INVENTORY_ITEMS_UPDATE = 'INVENTORY_ITEMS_UPDATE',
  /** The webhook topic for `inventory_levels/connect` events. Occurs whenever an inventory level is connected. Requires the `read_inventory` scope. */
  INVENTORY_LEVELS_CONNECT = 'INVENTORY_LEVELS_CONNECT',
  /** The webhook topic for `inventory_levels/disconnect` events. Occurs whenever an inventory level is disconnected. Requires the `read_inventory` scope. */
  INVENTORY_LEVELS_DISCONNECT = 'INVENTORY_LEVELS_DISCONNECT',
  /** The webhook topic for `inventory_levels/update` events. Occurs whenever an inventory level is updated. Requires the `read_inventory` scope. */
  INVENTORY_LEVELS_UPDATE = 'INVENTORY_LEVELS_UPDATE',
  /** The webhook topic for `locales/create` events. Occurs whenever a shop locale is created Requires the `read_locales` scope. */
  LOCALES_CREATE = 'LOCALES_CREATE',
  /** The webhook topic for `locales/update` events. Occurs whenever a shop locale is updated, such as published or unpublished Requires the `read_locales` scope. */
  LOCALES_UPDATE = 'LOCALES_UPDATE',
  /** The webhook topic for `locations/activate` events. Occurs whenever a deactivated location is re-activated. Requires the `read_locations` scope. */
  LOCATIONS_ACTIVATE = 'LOCATIONS_ACTIVATE',
  /** The webhook topic for `locations/create` events. Occurs whenever a location is created. Requires the `read_locations` scope. */
  LOCATIONS_CREATE = 'LOCATIONS_CREATE',
  /** The webhook topic for `locations/deactivate` events. Occurs whenever a location is deactivated. Requires the `read_locations` scope. */
  LOCATIONS_DEACTIVATE = 'LOCATIONS_DEACTIVATE',
  /** The webhook topic for `locations/delete` events. Occurs whenever a location is deleted. Requires the `read_locations` scope. */
  LOCATIONS_DELETE = 'LOCATIONS_DELETE',
  /** The webhook topic for `locations/update` events. Occurs whenever a location is updated. Requires the `read_locations` scope. */
  LOCATIONS_UPDATE = 'LOCATIONS_UPDATE',
  /** The webhook topic for `markets/create` events. Occurs when a new market is created. Requires the `read_markets` scope. */
  MARKETS_CREATE = 'MARKETS_CREATE',
  /** The webhook topic for `markets/delete` events. Occurs when a market is deleted. Requires the `read_markets` scope. */
  MARKETS_DELETE = 'MARKETS_DELETE',
  /** The webhook topic for `markets/update` events. Occurs when a market is updated. Requires the `read_markets` scope. */
  MARKETS_UPDATE = 'MARKETS_UPDATE',
  /** The webhook topic for `metafield_definitions/create` events. Occurs when a metafield definition is created. Requires the `read_content` scope. */
  METAFIELD_DEFINITIONS_CREATE = 'METAFIELD_DEFINITIONS_CREATE',
  /** The webhook topic for `metafield_definitions/delete` events. Occurs when a metafield definition is deleted. Requires the `read_content` scope. */
  METAFIELD_DEFINITIONS_DELETE = 'METAFIELD_DEFINITIONS_DELETE',
  /** The webhook topic for `metafield_definitions/update` events. Occurs when a metafield definition is updated. Requires the `read_content` scope. */
  METAFIELD_DEFINITIONS_UPDATE = 'METAFIELD_DEFINITIONS_UPDATE',
  /** The webhook topic for `metaobjects/create` events. Occurs when a metaobject is created. Requires the `read_metaobjects` scope. */
  METAOBJECTS_CREATE = 'METAOBJECTS_CREATE',
  /** The webhook topic for `metaobjects/delete` events. Occurs when a metaobject is deleted. Requires the `read_metaobjects` scope. */
  METAOBJECTS_DELETE = 'METAOBJECTS_DELETE',
  /** The webhook topic for `metaobjects/update` events. Occurs when a metaobject is updated. Requires the `read_metaobjects` scope. */
  METAOBJECTS_UPDATE = 'METAOBJECTS_UPDATE',
  /** The webhook topic for `orders/cancelled` events. Occurs whenever an order is cancelled. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  ORDERS_CANCELLED = 'ORDERS_CANCELLED',
  /** The webhook topic for `orders/create` events. Occurs whenever an order is created. Requires at least one of the following scopes: read_orders, read_marketplace_orders. */
  ORDERS_CREATE = 'ORDERS_CREATE',
  /** The webhook topic for `orders/delete` events. Occurs whenever an order is deleted. Requires the `read_orders` scope. */
  ORDERS_DELETE = 'ORDERS_DELETE',
  /** The webhook topic for `orders/edited` events. Occurs whenever an order is edited. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  ORDERS_EDITED = 'ORDERS_EDITED',
  /** The webhook topic for `orders/fulfilled` events. Occurs whenever an order is fulfilled. Requires at least one of the following scopes: read_orders, read_marketplace_orders. */
  ORDERS_FULFILLED = 'ORDERS_FULFILLED',
  /** The webhook topic for `orders/paid` events. Occurs whenever an order is paid. Requires at least one of the following scopes: read_orders, read_marketplace_orders. */
  ORDERS_PAID = 'ORDERS_PAID',
  /** The webhook topic for `orders/partially_fulfilled` events. Occurs whenever an order is partially fulfilled. Requires at least one of the following scopes: read_orders, read_marketplace_orders. */
  ORDERS_PARTIALLY_FULFILLED = 'ORDERS_PARTIALLY_FULFILLED',
  /**
   * The webhook topic for `orders/risk_assessment_changed` events. Triggers when a new risk assessment is available on the order.
   * This can be the first or a subsequent risk assessment.
   * New risk assessments can be provided until the order is marked as fulfilled.
   * Includes the risk level, risk facts, the provider and the order ID.
   * When the provider is Shopify, that field is null.
   * Does not include the risk recommendation for the order.
   * The Shop ID is available in the headers.
   *  Requires the `read_orders` scope.
   */
  ORDERS_RISK_ASSESSMENT_CHANGED = 'ORDERS_RISK_ASSESSMENT_CHANGED',
  /** The webhook topic for `orders/shopify_protect_eligibility_changed` events. Occurs whenever Shopify Protect's eligibility for an order is changed. Requires the `read_orders` scope. */
  ORDERS_SHOPIFY_PROTECT_ELIGIBILITY_CHANGED = 'ORDERS_SHOPIFY_PROTECT_ELIGIBILITY_CHANGED',
  /** The webhook topic for `orders/updated` events. Occurs whenever an order is updated. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  ORDERS_UPDATED = 'ORDERS_UPDATED',
  /** The webhook topic for `order_transactions/create` events. Occurs when a order transaction is created or when it's status is updated. Only occurs for transactions with a status of success, failure or error. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  ORDER_TRANSACTIONS_CREATE = 'ORDER_TRANSACTIONS_CREATE',
  /** The webhook topic for `payment_schedules/due` events. Occurs whenever payment schedules are due. Requires the `read_payment_terms` scope. */
  PAYMENT_SCHEDULES_DUE = 'PAYMENT_SCHEDULES_DUE',
  /** The webhook topic for `payment_terms/create` events. Occurs whenever payment terms are created. Requires the `read_payment_terms` scope. */
  PAYMENT_TERMS_CREATE = 'PAYMENT_TERMS_CREATE',
  /** The webhook topic for `payment_terms/delete` events. Occurs whenever payment terms are deleted. Requires the `read_payment_terms` scope. */
  PAYMENT_TERMS_DELETE = 'PAYMENT_TERMS_DELETE',
  /** The webhook topic for `payment_terms/update` events. Occurs whenever payment terms are updated. Requires the `read_payment_terms` scope. */
  PAYMENT_TERMS_UPDATE = 'PAYMENT_TERMS_UPDATE',
  /** The webhook topic for `products/create` events. Occurs whenever a product is created. Requires the `read_products` scope. */
  PRODUCTS_CREATE = 'PRODUCTS_CREATE',
  /** The webhook topic for `products/delete` events. Occurs whenever a product is deleted. Requires the `read_products` scope. */
  PRODUCTS_DELETE = 'PRODUCTS_DELETE',
  /** The webhook topic for `products/update` events. Occurs whenever a product is updated, ordered, or variants are added, removed or updated. Requires the `read_products` scope. */
  PRODUCTS_UPDATE = 'PRODUCTS_UPDATE',
  /** The webhook topic for `product_feeds/create` events. Triggers when product feed is created Requires the `read_product_listings` scope. */
  PRODUCT_FEEDS_CREATE = 'PRODUCT_FEEDS_CREATE',
  /** The webhook topic for `product_feeds/full_sync` events. Triggers when a full sync for a product feed is performed Requires the `read_product_listings` scope. */
  PRODUCT_FEEDS_FULL_SYNC = 'PRODUCT_FEEDS_FULL_SYNC',
  /** The webhook topic for `product_feeds/full_sync_finish` events. Triggers when a full sync finishes Requires the `read_product_listings` scope. */
  PRODUCT_FEEDS_FULL_SYNC_FINISH = 'PRODUCT_FEEDS_FULL_SYNC_FINISH',
  /** The webhook topic for `product_feeds/incremental_sync` events. Occurs whenever a product publication is created, updated or removed for a product feed Requires the `read_product_listings` scope. */
  PRODUCT_FEEDS_INCREMENTAL_SYNC = 'PRODUCT_FEEDS_INCREMENTAL_SYNC',
  /** The webhook topic for `product_feeds/update` events. Triggers when product feed is updated Requires the `read_product_listings` scope. */
  PRODUCT_FEEDS_UPDATE = 'PRODUCT_FEEDS_UPDATE',
  /** The webhook topic for `product_listings/add` events. Occurs whenever an active product is listed on a channel. Requires the `read_product_listings` scope. */
  PRODUCT_LISTINGS_ADD = 'PRODUCT_LISTINGS_ADD',
  /** The webhook topic for `product_listings/remove` events. Occurs whenever a product listing is removed from the channel. Requires the `read_product_listings` scope. */
  PRODUCT_LISTINGS_REMOVE = 'PRODUCT_LISTINGS_REMOVE',
  /** The webhook topic for `product_listings/update` events. Occurs whenever a product publication is updated. Requires the `read_product_listings` scope. */
  PRODUCT_LISTINGS_UPDATE = 'PRODUCT_LISTINGS_UPDATE',
  /** The webhook topic for `product_publications/create` events. Occurs whenever a product publication for an active product is created, or whenever an existing product publication is published on the app that is subscribed to this webhook topic. Note that a webhook is only emitted when there are publishing changes to the app that is subscribed to the topic (ie. no webhook will be emitted if there is a publishing change to the online store and the webhook subscriber of the topic is a third-party app). Requires the `read_publications` scope. */
  PRODUCT_PUBLICATIONS_CREATE = 'PRODUCT_PUBLICATIONS_CREATE',
  /** The webhook topic for `product_publications/delete` events. Occurs whenever a product publication for an active product is removed, or whenever an existing product publication is unpublished from the app that is subscribed to this webhook topic. Note that a webhook is only emitted when there are publishing changes to the app that is subscribed to the topic (ie. no webhook will be emitted if there is a publishing change to the online store and the webhook subscriber of the topic is a third-party app). Requires the `read_publications` scope. */
  PRODUCT_PUBLICATIONS_DELETE = 'PRODUCT_PUBLICATIONS_DELETE',
  /** The webhook topic for `product_publications/update` events. Occurs whenever a product publication is updated from the app that is subscribed to this webhook topic. Note that a webhook is only emitted when there are publishing changes to the app that is subscribed to the topic (ie. no webhook will be emitted if there is a publishing change to the online store and the webhook subscriber of the topic is a third-party app). Requires the `read_publications` scope. */
  PRODUCT_PUBLICATIONS_UPDATE = 'PRODUCT_PUBLICATIONS_UPDATE',
  /** The webhook topic for `profiles/create` events. Occurs whenever a delivery profile is created Requires at least one of the following scopes: read_shipping, read_assigned_shipping. */
  PROFILES_CREATE = 'PROFILES_CREATE',
  /** The webhook topic for `profiles/delete` events. Occurs whenever a delivery profile is deleted Requires at least one of the following scopes: read_shipping, read_assigned_shipping. */
  PROFILES_DELETE = 'PROFILES_DELETE',
  /** The webhook topic for `profiles/update` events. Occurs whenever a delivery profile is updated Requires at least one of the following scopes: read_shipping, read_assigned_shipping. */
  PROFILES_UPDATE = 'PROFILES_UPDATE',
  /** The webhook topic for `publications/delete` events. Occurs whenever a publication is deleted. Requires the `read_publications` scope. */
  PUBLICATIONS_DELETE = 'PUBLICATIONS_DELETE',
  /** The webhook topic for `refunds/create` events. Occurs whenever a new refund is created without errors on an order, independent from the movement of money. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_buyer_membership_orders. */
  REFUNDS_CREATE = 'REFUNDS_CREATE',
  /** The webhook topic for `returns/approve` events. Occurs whenever a return is approved. This means `Return.status` is `OPEN`. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  RETURNS_APPROVE = 'RETURNS_APPROVE',
  /** The webhook topic for `returns/cancel` events. Occurs whenever a return is canceled. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  RETURNS_CANCEL = 'RETURNS_CANCEL',
  /** The webhook topic for `returns/close` events. Occurs whenever a return is closed. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  RETURNS_CLOSE = 'RETURNS_CLOSE',
  /** The webhook topic for `returns/decline` events. Occurs whenever a return is declined. This means `Return.status` is `DECLINED`. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  RETURNS_DECLINE = 'RETURNS_DECLINE',
  /** The webhook topic for `returns/reopen` events. Occurs whenever a closed return is reopened. Requires at least one of the following scopes: read_orders, read_marketplace_orders, read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  RETURNS_REOPEN = 'RETURNS_REOPEN',
  /** The webhook topic for `returns/request` events. Occurs whenever a return is requested. This means `Return.status` is `REQUESTED`. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  RETURNS_REQUEST = 'RETURNS_REQUEST',
  /** The webhook topic for `returns/update` events. Occurs whenever a return is updated. Requires at least one of the following scopes: read_returns, read_marketplace_returns, read_buyer_membership_orders. */
  RETURNS_UPDATE = 'RETURNS_UPDATE',
  /**
   * The webhook topic for `reverse_deliveries/attach_deliverable` events. Occurs whenever a deliverable is attached to a reverse delivery.
   * This occurs when a reverse delivery is created or updated with delivery metadata.
   * Metadata includes the delivery method, label, and tracking information associated with a reverse delivery.
   *  Requires at least one of the following scopes: read_returns, read_marketplace_returns.
   */
  REVERSE_DELIVERIES_ATTACH_DELIVERABLE = 'REVERSE_DELIVERIES_ATTACH_DELIVERABLE',
  /**
   * The webhook topic for `reverse_fulfillment_orders/dispose` events. Occurs whenever a disposition is made on a reverse fulfillment order.
   * This includes dispositions made on reverse deliveries that are associated with the reverse fulfillment order.
   *  Requires at least one of the following scopes: read_returns, read_marketplace_returns.
   */
  REVERSE_FULFILLMENT_ORDERS_DISPOSE = 'REVERSE_FULFILLMENT_ORDERS_DISPOSE',
  /** The webhook topic for `scheduled_product_listings/add` events. Occurs whenever a product is scheduled to be published. Requires the `read_product_listings` scope. */
  SCHEDULED_PRODUCT_LISTINGS_ADD = 'SCHEDULED_PRODUCT_LISTINGS_ADD',
  /** The webhook topic for `scheduled_product_listings/remove` events. Occurs whenever a product is no longer scheduled to be published. Requires the `read_product_listings` scope. */
  SCHEDULED_PRODUCT_LISTINGS_REMOVE = 'SCHEDULED_PRODUCT_LISTINGS_REMOVE',
  /** The webhook topic for `scheduled_product_listings/update` events. Occurs whenever a product's scheduled availability date changes. Requires the `read_product_listings` scope. */
  SCHEDULED_PRODUCT_LISTINGS_UPDATE = 'SCHEDULED_PRODUCT_LISTINGS_UPDATE',
  /** The webhook topic for `segments/create` events. Occurs whenever a segment is created. Requires the `read_customers` scope. */
  SEGMENTS_CREATE = 'SEGMENTS_CREATE',
  /** The webhook topic for `segments/delete` events. Occurs whenever a segment is deleted. Requires the `read_customers` scope. */
  SEGMENTS_DELETE = 'SEGMENTS_DELETE',
  /** The webhook topic for `segments/update` events. Occurs whenever a segment is updated. Requires the `read_customers` scope. */
  SEGMENTS_UPDATE = 'SEGMENTS_UPDATE',
  /** The webhook topic for `selling_plan_groups/create` events. Notifies when a SellingPlanGroup is created. Requires the `read_products` scope. */
  SELLING_PLAN_GROUPS_CREATE = 'SELLING_PLAN_GROUPS_CREATE',
  /** The webhook topic for `selling_plan_groups/delete` events. Notifies when a SellingPlanGroup is deleted. Requires the `read_products` scope. */
  SELLING_PLAN_GROUPS_DELETE = 'SELLING_PLAN_GROUPS_DELETE',
  /** The webhook topic for `selling_plan_groups/update` events. Notifies when a SellingPlanGroup is updated. Requires the `read_products` scope. */
  SELLING_PLAN_GROUPS_UPDATE = 'SELLING_PLAN_GROUPS_UPDATE',
  /** The webhook topic for `shipping_addresses/create` events. Occurs whenever a shipping address is created. Requires the `read_shipping` scope. */
  SHIPPING_ADDRESSES_CREATE = 'SHIPPING_ADDRESSES_CREATE',
  /** The webhook topic for `shipping_addresses/update` events. Occurs whenever a shipping address is updated. Requires the `read_shipping` scope. */
  SHIPPING_ADDRESSES_UPDATE = 'SHIPPING_ADDRESSES_UPDATE',
  /** The webhook topic for `shop/update` events. Occurs whenever a shop is updated. */
  SHOP_UPDATE = 'SHOP_UPDATE',
  /** The webhook topic for `subscription_billing_attempts/challenged` events. Occurs when the financial instutition challenges the subscripttion billing attempt charge as per 3D Secure. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_BILLING_ATTEMPTS_CHALLENGED = 'SUBSCRIPTION_BILLING_ATTEMPTS_CHALLENGED',
  /** The webhook topic for `subscription_billing_attempts/failure` events. Occurs whenever a subscription billing attempt fails. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_BILLING_ATTEMPTS_FAILURE = 'SUBSCRIPTION_BILLING_ATTEMPTS_FAILURE',
  /** The webhook topic for `subscription_billing_attempts/success` events. Occurs whenever a subscription billing attempt succeeds. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_BILLING_ATTEMPTS_SUCCESS = 'SUBSCRIPTION_BILLING_ATTEMPTS_SUCCESS',
  /** The webhook topic for `subscription_billing_cycles/skip` events. Occurs whenever a subscription contract billing cycle is skipped. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_BILLING_CYCLES_SKIP = 'SUBSCRIPTION_BILLING_CYCLES_SKIP',
  /** The webhook topic for `subscription_billing_cycles/unskip` events. Occurs whenever a subscription contract billing cycle is unskipped. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_BILLING_CYCLES_UNSKIP = 'SUBSCRIPTION_BILLING_CYCLES_UNSKIP',
  /** The webhook topic for `subscription_billing_cycle_edits/create` events. Occurs whenever a subscription contract billing cycle is edited. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_BILLING_CYCLE_EDITS_CREATE = 'SUBSCRIPTION_BILLING_CYCLE_EDITS_CREATE',
  /** The webhook topic for `subscription_billing_cycle_edits/delete` events. Occurs whenever a subscription contract billing cycle edit is deleted. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_BILLING_CYCLE_EDITS_DELETE = 'SUBSCRIPTION_BILLING_CYCLE_EDITS_DELETE',
  /** The webhook topic for `subscription_billing_cycle_edits/update` events. Occurs whenever a subscription contract billing cycle edit is updated. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_BILLING_CYCLE_EDITS_UPDATE = 'SUBSCRIPTION_BILLING_CYCLE_EDITS_UPDATE',
  /** The webhook topic for `subscription_contracts/activate` events. Occurs when a subscription contract is activated. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_CONTRACTS_ACTIVATE = 'SUBSCRIPTION_CONTRACTS_ACTIVATE',
  /** The webhook topic for `subscription_contracts/cancel` events. Occurs when a subscription contract is canceled. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_CONTRACTS_CANCEL = 'SUBSCRIPTION_CONTRACTS_CANCEL',
  /** The webhook topic for `subscription_contracts/create` events. Occurs whenever a subscription contract is created. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_CONTRACTS_CREATE = 'SUBSCRIPTION_CONTRACTS_CREATE',
  /** The webhook topic for `subscription_contracts/expire` events. Occurs when a subscription contract expires. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_CONTRACTS_EXPIRE = 'SUBSCRIPTION_CONTRACTS_EXPIRE',
  /** The webhook topic for `subscription_contracts/fail` events. Occurs when a subscription contract is failed. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_CONTRACTS_FAIL = 'SUBSCRIPTION_CONTRACTS_FAIL',
  /** The webhook topic for `subscription_contracts/pause` events. Occurs when a subscription contract is paused. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_CONTRACTS_PAUSE = 'SUBSCRIPTION_CONTRACTS_PAUSE',
  /** The webhook topic for `subscription_contracts/update` events. Occurs whenever a subscription contract is updated. Requires the `read_own_subscription_contracts` scope. */
  SUBSCRIPTION_CONTRACTS_UPDATE = 'SUBSCRIPTION_CONTRACTS_UPDATE',
  /** The webhook topic for `tax_partners/update` events. Occurs whenever a tax partner is created or updated. Requires the `read_taxes` scope. */
  TAX_PARTNERS_UPDATE = 'TAX_PARTNERS_UPDATE',
  /** The webhook topic for `tax_services/create` events. Occurs whenever a tax service is created. Requires the `read_taxes` scope. */
  TAX_SERVICES_CREATE = 'TAX_SERVICES_CREATE',
  /** The webhook topic for `tax_services/update` events. Occurs whenver a tax service is updated. Requires the `read_taxes` scope. */
  TAX_SERVICES_UPDATE = 'TAX_SERVICES_UPDATE',
  /** The webhook topic for `tender_transactions/create` events. Occurs when a tender transaction is created. Requires the `read_orders` scope. */
  TENDER_TRANSACTIONS_CREATE = 'TENDER_TRANSACTIONS_CREATE',
  /** The webhook topic for `themes/create` events. Occurs whenever a theme is created. Does not occur when theme files are created. Requires the `read_themes` scope. */
  THEMES_CREATE = 'THEMES_CREATE',
  /** The webhook topic for `themes/delete` events. Occurs whenever a theme is deleted. Does not occur when theme files are deleted. Requires the `read_themes` scope. */
  THEMES_DELETE = 'THEMES_DELETE',
  /** The webhook topic for `themes/publish` events. Occurs whenever a theme with the main or mobile (deprecated) role is published. Requires the `read_themes` scope. */
  THEMES_PUBLISH = 'THEMES_PUBLISH',
  /** The webhook topic for `themes/update` events. Occurs whenever a theme is updated. Does not occur when theme files are updated. Requires the `read_themes` scope. */
  THEMES_UPDATE = 'THEMES_UPDATE',
  /** The webhook topic for `variants/in_stock` events. Occurs whenever a variant becomes in stock. Online channels receive this webhook only when the variant becomes in stock online. Requires the `read_products` scope. */
  VARIANTS_IN_STOCK = 'VARIANTS_IN_STOCK',
  /** The webhook topic for `variants/out_of_stock` events. Occurs whenever a variant becomes out of stock. Online channels receive this webhook only when the variant becomes out of stock online. Requires the `read_products` scope. */
  VARIANTS_OUT_OF_STOCK = 'VARIANTS_OUT_OF_STOCK'
}

/** Return type for `webhookSubscriptionUpdate` mutation. */
export type WebhookSubscriptionUpdatePayload = {
  /** The list of errors that occurred from executing the mutation. */
  readonly userErrors: ReadonlyArray<UserError>;
  /** The webhook subscription that was updated. */
  readonly webhookSubscription?: Maybe<WebhookSubscription>;
};

/** A weight, which includes a numeric value and a unit of measurement. */
export type Weight = {
  /** The unit of measurement for `value`. */
  readonly unit: WeightUnit;
  /** The weight value using the unit system specified with `unit`. */
  readonly value: Scalars['Float'];
};

/** The input fields for the weight unit and value inputs. */
export type WeightInput = {
  /** Unit of measurement for `value`. */
  readonly unit: WeightUnit;
  /** The weight value using the unit system specified with `weight_unit`. */
  readonly value: Scalars['Float'];
};

/** Units of measurement for weight. */
export enum WeightUnit {
  /** Metric system unit of mass. */
  GRAMS = 'GRAMS',
  /** 1 kilogram equals 1000 grams. */
  KILOGRAMS = 'KILOGRAMS',
  /** Imperial system unit of mass. */
  OUNCES = 'OUNCES',
  /** 1 pound equals 16 ounces. */
  POUNDS = 'POUNDS'
}

export type LocationGroupZoneFragment = { readonly zone: { readonly countries: ReadonlyArray<{ readonly code: Pick<DeliveryCountryCodeOrRestOfWorld, 'countryCode' | 'restOfWorld'> }> }, readonly methodDefinitions: { readonly nodes: ReadonlyArray<(
      Pick<DeliveryMethodDefinition, 'active'>
      & { readonly rateProvider: { readonly __typename: 'DeliveryParticipant' } | (
        { readonly __typename: 'DeliveryRateDefinition' }
        & { readonly price: Pick<MoneyV2, 'amount' | 'currencyCode'> }
      ), readonly methodConditions: ReadonlyArray<(
        Pick<DeliveryCondition, 'field' | 'operator'>
        & { readonly conditionCriteria: (
          { readonly __typename: 'MoneyV2' }
          & Pick<MoneyV2, 'amount' | 'currencyCode'>
        ) | { readonly __typename: 'Weight' } }
      )> }
    )> } };

export type DeliveryProfileFragment = (
  Pick<DeliveryProfile, 'id' | 'name' | 'default'>
  & { readonly profileLocationGroups: ReadonlyArray<{ readonly locationGroupZones: { readonly nodes: ReadonlyArray<{ readonly zone: { readonly countries: ReadonlyArray<{ readonly code: Pick<DeliveryCountryCodeOrRestOfWorld, 'countryCode' | 'restOfWorld'> }> }, readonly methodDefinitions: { readonly nodes: ReadonlyArray<(
            Pick<DeliveryMethodDefinition, 'active'>
            & { readonly rateProvider: { readonly __typename: 'DeliveryParticipant' } | (
              { readonly __typename: 'DeliveryRateDefinition' }
              & { readonly price: Pick<MoneyV2, 'amount' | 'currencyCode'> }
            ), readonly methodConditions: ReadonlyArray<(
              Pick<DeliveryCondition, 'field' | 'operator'>
              & { readonly conditionCriteria: (
                { readonly __typename: 'MoneyV2' }
                & Pick<MoneyV2, 'amount' | 'currencyCode'>
              ) | { readonly __typename: 'Weight' } }
            )> }
          )> } }> } }> }
);

export type DeliveryProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type DeliveryProfilesQuery = { readonly deliveryProfiles: { readonly nodes: ReadonlyArray<(
      Pick<DeliveryProfile, 'id' | 'name' | 'default'>
      & { readonly profileLocationGroups: ReadonlyArray<{ readonly locationGroupZones: { readonly nodes: ReadonlyArray<{ readonly zone: { readonly countries: ReadonlyArray<{ readonly code: Pick<DeliveryCountryCodeOrRestOfWorld, 'countryCode' | 'restOfWorld'> }> }, readonly methodDefinitions: { readonly nodes: ReadonlyArray<(
                Pick<DeliveryMethodDefinition, 'active'>
                & { readonly rateProvider: { readonly __typename: 'DeliveryParticipant' } | (
                  { readonly __typename: 'DeliveryRateDefinition' }
                  & { readonly price: Pick<MoneyV2, 'amount' | 'currencyCode'> }
                ), readonly methodConditions: ReadonlyArray<(
                  Pick<DeliveryCondition, 'field' | 'operator'>
                  & { readonly conditionCriteria: (
                    { readonly __typename: 'MoneyV2' }
                    & Pick<MoneyV2, 'amount' | 'currencyCode'>
                  ) | { readonly __typename: 'Weight' } }
                )> }
              )> } }> } }> }
    )> } };

export type MarketRegionCountryFragment = (
  { readonly __typename: 'MarketRegionCountry' }
  & Pick<MarketRegionCountry, 'id' | 'code'>
);

export type MarketsCountriesQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']>;
}>;


export type MarketsCountriesQuery = { readonly nodes: ReadonlyArray<Maybe<(
    { readonly __typename: 'MarketRegionCountry' }
    & Pick<MarketRegionCountry, 'id' | 'code'>
  ) | {}>> };

export type MarketFragment = (
  Pick<Market, 'id' | 'enabled'>
  & { readonly currencySettings: { readonly baseCurrency: Pick<CurrencySetting, 'currencyCode' | 'enabled'> }, readonly webPresences: { readonly nodes: ReadonlyArray<{ readonly defaultLocale: Pick<ShopLocale, 'locale'>, readonly domain?: Maybe<Pick<Domain, 'host'>> }> }, readonly regions: { readonly nodes: ReadonlyArray<Pick<MarketRegionCountry, 'id' | 'name'>> } }
);

export type MarketsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketsQuery = { readonly markets: { readonly nodes: ReadonlyArray<(
      Pick<Market, 'id' | 'enabled'>
      & { readonly currencySettings: { readonly baseCurrency: Pick<CurrencySetting, 'currencyCode' | 'enabled'> }, readonly webPresences: { readonly nodes: ReadonlyArray<{ readonly defaultLocale: Pick<ShopLocale, 'locale'>, readonly domain?: Maybe<Pick<Domain, 'host'>> }> }, readonly regions: { readonly nodes: ReadonlyArray<Pick<MarketRegionCountry, 'id' | 'name'>> } }
    )> } };

export const LocationGroupZoneFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroupZone"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryLocationGroupZone"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"restOfWorld"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"rateProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryRateDefinition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"methodConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"conditionCriteria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MoneyV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LocationGroupZoneFragment, unknown>;
export const DeliveryProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeliveryProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"profileLocationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGroupZones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroupZone"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeliveryProfileFragment, unknown>;
export const MarketRegionCountryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketRegionCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketRegionCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<MarketRegionCountryFragment, unknown>;
export const MarketFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Market"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Market"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currencySettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"webPresences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultLocale"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"host"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MarketFragment, unknown>;
export const DeliveryProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeliveryProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeliveryProfile"}}]}}]}}]}},...DeliveryProfileFragmentDoc.definitions,...LocationGroupZoneFragmentDoc.definitions]} as unknown as DocumentNode<DeliveryProfilesQuery, DeliveryProfilesQueryVariables>;
export const MarketsCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MarketsCountries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketRegionCountry"}}]}}]}},...MarketRegionCountryFragmentDoc.definitions]} as unknown as DocumentNode<MarketsCountriesQuery, MarketsCountriesQueryVariables>;
export const MarketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Markets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Market"}}]}}]}}]}},...MarketFragmentDoc.definitions]} as unknown as DocumentNode<MarketsQuery, MarketsQueryVariables>;